// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tippy.js/dist/tippy.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tippy.js/animations/perspective.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/tippy.js/themes/light.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-form-builder2/dist/app.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2718%27 height=%2718%27 viewBox=%270 0 18 18%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.5607 2.67V1.5C12.5607 1.1925 12.3057 0.9375 11.9982 0.9375C11.6907 0.9375 11.4357 1.1925 11.4357 1.5V2.625H6.56072V1.5C6.56072 1.1925 6.30572 0.9375 5.99822 0.9375C5.69072 0.9375 5.43572 1.1925 5.43572 1.5V2.67C3.41072 2.8575 2.42822 4.065 2.27822 5.8575C2.26322 6.075 2.44322 6.255 2.65322 6.255H15.3432C15.5607 6.255 15.7407 6.0675 15.7182 5.8575C15.5682 4.065 14.5857 2.8575 12.5607 2.67Z%27 fill=%27%23C1CACE%27/%3E%3Cpath opacity=%270.32%27 d=%27M15 7.37988C15.4125 7.37988 15.75 7.71738 15.75 8.12988V12.7499C15.75 14.9999 14.625 16.4999 12 16.4999H6C3.375 16.4999 2.25 14.9999 2.25 12.7499V8.12988C2.25 7.71738 2.5875 7.37988 3 7.37988H15Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M6.375 11.2501C6.18 11.2501 5.985 11.1676 5.8425 11.0326C5.7075 10.8901 5.625 10.6951 5.625 10.5001C5.625 10.3051 5.7075 10.1102 5.8425 9.96766C6.0525 9.75766 6.3825 9.69014 6.66 9.81014C6.7575 9.84764 6.84 9.90016 6.9075 9.96766C7.0425 10.1102 7.125 10.3051 7.125 10.5001C7.125 10.6951 7.0425 10.8901 6.9075 11.0326C6.765 11.1676 6.57 11.2501 6.375 11.2501Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M9 11.2501C8.805 11.2501 8.61 11.1676 8.4675 11.0326C8.3325 10.8901 8.25 10.6951 8.25 10.5001C8.25 10.3051 8.3325 10.1102 8.4675 9.96766C8.535 9.90016 8.6175 9.84764 8.715 9.81014C8.9925 9.69014 9.3225 9.75766 9.5325 9.96766C9.6675 10.1102 9.75 10.3051 9.75 10.5001C9.75 10.6951 9.6675 10.8901 9.5325 11.0326C9.495 11.0626 9.4575 11.0926 9.42 11.1226C9.375 11.1526 9.33 11.1752 9.285 11.1902C9.24 11.2127 9.195 11.2277 9.15 11.2352C9.0975 11.2427 9.0525 11.2501 9 11.2501Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M11.625 11.25C11.43 11.25 11.235 11.1675 11.0925 11.0325C10.9575 10.89 10.875 10.695 10.875 10.5C10.875 10.305 10.9575 10.11 11.0925 9.96752C11.1675 9.90002 11.2425 9.8475 11.34 9.81C11.475 9.75 11.625 9.735 11.775 9.765C11.82 9.7725 11.865 9.7875 11.91 9.81C11.955 9.825 12 9.84752 12.045 9.87752C12.0825 9.90752 12.12 9.93752 12.1575 9.96752C12.2925 10.11 12.375 10.305 12.375 10.5C12.375 10.695 12.2925 10.89 12.1575 11.0325C12.12 11.0625 12.0825 11.0925 12.045 11.1225C12 11.1525 11.955 11.175 11.91 11.19C11.865 11.2125 11.82 11.2275 11.775 11.235C11.7225 11.2425 11.67 11.25 11.625 11.25Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M6.375 13.875C6.2775 13.875 6.18 13.8525 6.09 13.815C5.9925 13.7775 5.9175 13.725 5.8425 13.6575C5.7075 13.515 5.625 13.32 5.625 13.125C5.625 12.93 5.7075 12.735 5.8425 12.5925C5.9175 12.525 5.9925 12.4725 6.09 12.435C6.225 12.375 6.375 12.36 6.525 12.39C6.57 12.3975 6.615 12.4125 6.66 12.435C6.705 12.45 6.75 12.4725 6.795 12.5025C6.8325 12.5325 6.87 12.5625 6.9075 12.5925C7.0425 12.735 7.125 12.93 7.125 13.125C7.125 13.32 7.0425 13.515 6.9075 13.6575C6.87 13.6875 6.8325 13.725 6.795 13.7475C6.75 13.7775 6.705 13.8 6.66 13.815C6.615 13.8375 6.57 13.8525 6.525 13.86C6.4725 13.8675 6.4275 13.875 6.375 13.875Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M9 13.8754C8.805 13.8754 8.61 13.7929 8.4675 13.6579C8.3325 13.5154 8.25 13.3204 8.25 13.1254C8.25 12.9304 8.3325 12.7354 8.4675 12.5929C8.745 12.3154 9.255 12.3154 9.5325 12.5929C9.6675 12.7354 9.75 12.9304 9.75 13.1254C9.75 13.3204 9.6675 13.5154 9.5325 13.6579C9.39 13.7929 9.195 13.8754 9 13.8754Z%27 fill=%27%23C1CACE%27/%3E%3Cpath d=%27M11.625 13.8754C11.43 13.8754 11.235 13.7929 11.0925 13.6579C10.9575 13.5154 10.875 13.3204 10.875 13.1254C10.875 12.9304 10.9575 12.7354 11.0925 12.5929C11.37 12.3154 11.88 12.3154 12.1575 12.5929C12.2925 12.7354 12.375 12.9304 12.375 13.1254C12.375 13.3204 12.2925 13.5154 12.1575 13.6579C12.015 13.7929 11.82 13.8754 11.625 13.8754Z%27 fill=%27%23C1CACE%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/StarFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Spinner-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

.tippy-box.tippy-content {
  padding: 6px 12px;
}
.tippy-box.custom-tooltip .tippy-content {
  padding: 0 !important;
}
.tippy-box.arrow-small .tippy-arrow:before {
  border-width: 5px 5px 5px 0;
}
.tippy-box.arrow-small[data-placement^=top] .tippy-arrow {
  bottom: unset;
}
.tippy-box.arrow-small[data-placement^=top] .tippy-arrow:before {
  top: 0;
  border-width: 5px 5px 0px 5px;
}
.tippy-box.arrow-small[data-placement^=bottom] .tippy-arrow:before {
  top: -10px;
  border-width: 5px;
}
.tippy-box.arrow-small[data-placement^=right] .tippy-arrow {
  left: 0;
}
.tippy-box.arrow-small[data-placement^=right] .tippy-arrow:before {
  left: -4px;
}
.tippy-box.arrow-small[data-placement^=left] .tippy-arrow {
  left: 100%;
}
.tippy-box.arrow-small[data-placement^=left] .tippy-arrow:before {
  right: unset;
  left: 0;
  border-width: 5px 0px 5px 5px;
}
.tippy-box.arrow-small[data-placement^=right] .tippy-arrow:before, .tippy-box.arrow-small[data-placement^=left] .tippy-arrow:before {
  top: 50%;
  transform: translateY(-50%);
}

div[data-tippy-root] > div {
  color: #004f6b !important;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16) !important;
  font-size: 0.875rem;
  border-radius: 4px;
}
div[data-tippy-root] > div.tippy-border {
  box-shadow: none !important;
}

.tippy-arrow-primary-dark .tippy-arrow {
  color: #004f6b;
}
.tippy-arrow-primary-dark .tippy-arrow:before {
  left: -5px !important;
}

.tippy-dark div:first-child {
  color: white;
  background-color: #181d27;
  border-radius: 4px;
}
.tippy-dark[data-placement^=top] > .tippy-arrow:before {
  border-top-color: #181d27 !important;
}
.tippy-dark[data-placement^=bottom] > .tippy-arrow:before {
  border-bottom-color: #181d27 !important;
}
.tippy-dark[data-placement^=left] > .tippy-arrow:before {
  border-left-color: #181d27 !important;
}
.tippy-dark[data-placement^=right] > .tippy-arrow:before {
  border-right-color: #181d27 !important;
}
.tippy-dark.no-arrow .tippy-arrow:before {
  border: none !important;
}

.tippy-black div:first-child {
  color: white;
  background: #374145;
  border-radius: 3px;
}
.tippy-black[data-placement^=top] > .tippy-arrow:before {
  border-top-color: #374145 !important;
}
.tippy-black[data-placement^=bottom] > .tippy-arrow:before {
  border-bottom-color: #374145 !important;
}
.tippy-black[data-placement^=left] > .tippy-arrow:before {
  border-left-color: #374145 !important;
}
.tippy-black[data-placement^=right] > .tippy-arrow:before {
  border-right-color: #374145 !important;
}
.tippy-black.no-arrow .tippy-arrow:before {
  border: none !important;
}

.tippy-border {
  box-shadow: none !important;
  border: 1px solid #d5d7da;
}
.tippy-border div:first-child {
  color: #181d27;
  box-shadow: none !important;
}
.tippy-border[data-placement^=top] > .tippy-arrow:before {
  border-top-color: #d5d7da !important;
  transform: scale(0.65);
  transform-origin: center;
}
.tippy-border[data-placement^=bottom] > .tippy-arrow:before {
  border-bottom-color: #d5d7da !important;
  transform: scale(0.65);
  transform-origin: center;
}
.tippy-border[data-placement^=left] > .tippy-arrow:before {
  border-left-color: #d5d7da !important;
  transform: scale(0.65);
  transform-origin: center;
}
.tippy-border[data-placement^=right] > .tippy-arrow:before {
  border-right-color: #d5d7da !important;
  transform: scale(0.65);
  transform-origin: center;
}
.tippy-border.no-arrow .tippy-arrow:before {
  border: none !important;
}

.Tabnav {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #dcdcdc;
}
.Tabnav__item {
  margin-left: 30px;
  padding: 22px 0;
  position: relative;
  cursor: pointer;
}
.Tabnav__item:hover span {
  color: #737373;
}
.Tabnav__item.active:before {
  content: "";
  position: absolute;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background-color: var(--color-primary-500, #0ba5ec);
  z-index: 2;
}
.Tabnav__item.active:hover span {
  color: var(--color-primary-500, #0ba5ec);
}
.Tabnav__item.active span {
  color: var(--color-primary-500, #0ba5ec);
}
.Tabnav__item:hover span {
  color: #737373;
}
.Tabnav__item span {
  color: #8e8d8e;
  font-weight: 600;
  transition: 0.2s;
}

body,
p,
ul,
li,
a,
h1,
h2,
h3,
h4,
h5,
h6,
form {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  color: var(--color-primary-500, #0ba5ec);
}
a:hover {
  color: var(--color-primary-500, #0ba5ec);
}

button {
  outline: none !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

.react-confirm-alert-overlay {
  transition: 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.3);
}

.react-confirm-alert-body {
  min-width: 430px;
  line-height: 1.3;
  color: #afafaf;
}
.react-confirm-alert-body > h1 {
  color: #252b37;
  font-weight: 600;
  font-size: 1.25rem;
  padding-bottom: 20px;
}

.react-confirm-alert-button-group {
  margin-top: 30px;
  gap: 14px;
}
.react-confirm-alert-button-group > .Button {
  width: 50%;
  margin: 0;
  font-size: 1rem;
}
.react-confirm-alert-button-group > .Button--success {
  background-color: #16b364;
}
.react-confirm-alert-button-group > .Button--danger {
  background-color: #f04438;
}
.react-confirm-alert-button-group > .Button--transparent {
  background-color: transparent;
  border: 1px solid transparent;
  color: #aaaaaa;
}
.react-confirm-alert-button-group > .Button--transparent:hover {
  background-color: #efefef;
}

.print-only .rfb-item:not(:has(.CustomForms)) {
  max-width: 700px !important;
}
.print-only {
  background-color: #ffffff;
}
.print-only .Icon--trash {
  display: none !important;
}
.print-only div:has(> .Icon--trash:first-child) {
  display: none !important;
}

.new-forms .react-form-builder-form {
  max-width: 900px;
  margin: 0 auto;
}
@media screen and (max-width: 1024px) {
  .new-forms .react-form-builder-form {
    max-width: 100%;
  }
}
.new-forms .react-form-builder-form .rfb-item:not(:has(.CustomForms)) {
  width: auto;
  max-width: none;
  margin: 0;
}
@media screen and (max-width: 599px) {
  .new-forms .react-form-builder-form .rfb-item.SortableItem > :not(:first-child) {
    padding-left: 8px;
    padding-right: 8px;
  }
}
.new-forms .react-form-builder-form .rfb-item .form-label {
  display: flex !important;
  gap: 2px;
}
.new-forms .react-form-builder-form .rfb-item label:not(.static) {
  display: flex !important;
  gap: 2px;
  color: #374145;
  font-weight: 400;
}
.new-forms .react-form-builder-form .rfb-item label.static {
  display: block !important;
  color: #374145;
  font-weight: 400;
}
.new-forms .react-form-builder-form p {
  line-height: 150%;
  font-weight: 400;
}
.new-forms .react-form-builder-form .static {
  font-size: 1rem;
}
.new-forms .react-form-builder-form .rfb-item img {
  border-radius: 8px;
}
.new-forms .react-form-builder-form .react-datepicker__close-icon::after {
  cursor: pointer;
  color: #6d828b;
  background-color: transparent;
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 22px;
  padding-bottom: 8px;
  font-size: 20px;
  display: table-cell;
  content: "×";
}
.new-forms .react-form-builder-form .react-datepicker__input-container:not(:has(button))::after {
  content: "";
  right: 12px;
  display: block;
  position: absolute;
  bottom: 10px;
  height: 20px;
  width: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain; /* Adjust as needed */
  background-position: center; /* Adjust as needed */
}
.new-forms .react-form-builder-form .react-datepicker__input-container input {
  height: auto;
  font-size: 14px;
  padding: 9px 12px;
  width: 100%;
  max-width: 100%;
}
.new-forms .react-form-builder-form .range {
  margin-top: 12px;
}
.new-forms .react-form-builder-form .slider {
  margin-top: 5px;
}
.new-forms .react-form-builder-form .clear-signature {
  position: absolute;
  right: 12px;
  bottom: 38px;
}
.new-forms .react-form-builder-form .form-group canvas {
  width: 100% !important;
  max-width: 500px !important;
  aspect-ratio: 2 !important;
  margin-top: 4px;
  height: auto !important;
  touch-action: none;
}

.react-form-builder-form button span {
  white-space: nowrap;
}
.react-form-builder-form canvas {
  touch-action: none;
}
.react-form-builder-form .signature-missing canvas {
  outline: 2px solid #f04438;
  outline-offset: -1px;
}
.react-form-builder-form input,
.react-form-builder-form textarea {
  resize: none;
}
.react-form-builder-form hr {
  display: none;
}

@font-face {
  font-family: "StarFont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.rating-container:before,
.rating-container .rating-stars:before {
  font-family: "StarFont";
  letter-spacing: 3px;
}

.react-datepicker__year-read-view--down-arrow:before {
  border-top-color: transparent;
}

.react-tooltip {
  z-index: 2;
}

.Spinner-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}

button,
[type=button],
[type=reset],
[type=submit] {
  background-image: white !important;
}

input[type=date],
input[type=datetime-local],
input[type=month],
input[type=time] {
  display: flex;
}

#__filestack-picker {
  overflow: hidden;
  position: fixed !important;
  z-index: 9999999 !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.intercom-app [class*=intercom-with-namespace-] {
  background: none !important;
}

html.kiosk-touch,
html.kiosk-touch body,
html.touch-ux,
html.touch-ux body {
  font-size: 16px !important;
}

html.kiosk-touch,
html.kiosk-touch *,
html.touch-ux,
html.touch-ux * {
  touch-action: manipulation;
}
html.kiosk-touch .form-group canvas,
html.kiosk-touch .react-form-builder-form canvas,
html.touch-ux .form-group canvas,
html.touch-ux .react-form-builder-form canvas {
  touch-action: none;
}
html.kiosk-touch input,
html.kiosk-touch select,
html.kiosk-touch textarea,
html.kiosk-touch [contenteditable=true],
html.touch-ux input,
html.touch-ux select,
html.touch-ux textarea,
html.touch-ux [contenteditable=true] {
  font-size: 16px !important;
}
html.kiosk-touch input::placeholder,
html.kiosk-touch textarea::placeholder,
html.touch-ux input::placeholder,
html.touch-ux textarea::placeholder {
  font-size: 16px !important;
}
html.kiosk-touch label:has(> div > input),
html.touch-ux label:has(> div > input) {
  height: auto !important;
  min-height: 48px !important;
}
html.kiosk-touch .custom-picker .react-date-picker,
html.kiosk-touch .custom-picker .react-datetime-picker,
html.kiosk-touch .custom-picker .react-daterange-picker,
html.kiosk-touch .custom-picker .react-datetimerange-picker,
html.touch-ux .custom-picker .react-date-picker,
html.touch-ux .custom-picker .react-datetime-picker,
html.touch-ux .custom-picker .react-daterange-picker,
html.touch-ux .custom-picker .react-datetimerange-picker {
  height: auto !important;
  min-height: 48px !important;
  font-size: 16px !important;
}
html.kiosk-touch .custom-picker .react-date-picker__wrapper,
html.kiosk-touch .custom-picker .react-datetime-picker__wrapper,
html.kiosk-touch .custom-picker .react-daterange-picker__wrapper,
html.kiosk-touch .custom-picker .react-datetimerange-picker__wrapper,
html.touch-ux .custom-picker .react-date-picker__wrapper,
html.touch-ux .custom-picker .react-datetime-picker__wrapper,
html.touch-ux .custom-picker .react-daterange-picker__wrapper,
html.touch-ux .custom-picker .react-datetimerange-picker__wrapper {
  width: 100%;
  min-height: 48px;
}
html.kiosk-touch .custom-picker .react-date-picker__button,
html.kiosk-touch .custom-picker .react-datetime-picker__button,
html.kiosk-touch .custom-picker .react-daterange-picker__button,
html.kiosk-touch .custom-picker .react-datetimerange-picker__button,
html.touch-ux .custom-picker .react-date-picker__button,
html.touch-ux .custom-picker .react-datetime-picker__button,
html.touch-ux .custom-picker .react-daterange-picker__button,
html.touch-ux .custom-picker .react-datetimerange-picker__button {
  padding: 0 4px !important;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
html.kiosk-touch .custom-picker .react-date-picker__clear-button,
html.kiosk-touch .custom-picker .react-datetime-picker__clear-button,
html.kiosk-touch .custom-picker .react-daterange-picker__clear-button,
html.kiosk-touch .custom-picker .react-datetimerange-picker__clear-button,
html.touch-ux .custom-picker .react-date-picker__clear-button,
html.touch-ux .custom-picker .react-datetime-picker__clear-button,
html.touch-ux .custom-picker .react-daterange-picker__clear-button,
html.touch-ux .custom-picker .react-datetimerange-picker__clear-button {
  min-width: 44px;
  min-height: 44px;
}
html.kiosk-touch .react-form-builder-form,
html.touch-ux .react-form-builder-form {
  font-size: 16px;
}
html.kiosk-touch .react-form-builder-form .form-control.form-control,
html.touch-ux .react-form-builder-form .form-control.form-control {
  min-height: 48px !important;
  font-size: 16px !important;
}
html.kiosk-touch .react-form-builder-form input.form-control.form-control,
html.kiosk-touch .react-form-builder-form select.form-control.form-control,
html.touch-ux .react-form-builder-form input.form-control.form-control,
html.touch-ux .react-form-builder-form select.form-control.form-control {
  height: 48px !important;
}
html.kiosk-touch .react-form-builder-form textarea.form-control.form-control,
html.touch-ux .react-form-builder-form textarea.form-control.form-control {
  height: auto !important;
  min-height: 96px !important;
}
html.kiosk-touch .react-form-builder-form .rfb-item .form-group > label,
html.kiosk-touch .react-form-builder-form .rfb-item .form-group > .form-label,
html.touch-ux .react-form-builder-form .rfb-item .form-group > label,
html.touch-ux .react-form-builder-form .rfb-item .form-group > .form-label {
  font-size: 16px !important;
  margin-bottom: 8px !important;
}
html.kiosk-touch .react-form-builder-form .rfb-item .form-group input[type=date],
html.touch-ux .react-form-builder-form .rfb-item .form-group input[type=date] {
  height: 48px !important;
}
html.kiosk-touch .react-form-builder-form .react-datepicker__input-container input,
html.touch-ux .react-form-builder-form .react-datepicker__input-container input {
  min-height: 48px !important;
  padding: 12px !important;
}
html.kiosk-touch .react-form-builder-form .react-datepicker__input-container:not(:has(button))::after,
html.touch-ux .react-form-builder-form .react-datepicker__input-container:not(:has(button))::after {
  bottom: 14px !important;
}
html.kiosk-touch .react-form-builder-form .custom-control.custom-checkbox,
html.kiosk-touch .react-form-builder-form .custom-control.custom-radio,
html.touch-ux .react-form-builder-form .custom-control.custom-checkbox,
html.touch-ux .react-form-builder-form .custom-control.custom-radio {
  margin-bottom: 12px !important;
}
html.kiosk-touch .react-form-builder-form .custom-control .custom-control-label,
html.touch-ux .react-form-builder-form .custom-control .custom-control-label {
  display: flex !important;
  align-items: center !important;
  min-height: 40px !important;
  padding: 8px 0 8px 36px !important;
  font-size: 16px !important;
  line-height: 24px !important;
}
html.kiosk-touch .react-form-builder-form .custom-control .custom-control-label::before,
html.kiosk-touch .react-form-builder-form .custom-control .custom-control-label::after,
html.touch-ux .react-form-builder-form .custom-control .custom-control-label::before,
html.touch-ux .react-form-builder-form .custom-control .custom-control-label::after {
  top: 8px !important;
  left: 0 !important;
  width: 24px !important;
  height: 24px !important;
}
html.kiosk-touch .react-form-builder-form .custom-control.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after,
html.touch-ux .react-form-builder-form .custom-control.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  top: 12px !important;
  left: 8px !important;
  width: 8px !important;
  height: 13px !important;
  border-width: 0 3px 3px 0 !important;
}
html.kiosk-touch .react-form-builder-form .custom-control.custom-radio .custom-control-input:checked ~ .custom-control-label::after,
html.touch-ux .react-form-builder-form .custom-control.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  top: 13px !important;
  left: 5px !important;
  width: 13px !important;
  height: 13px !important;
}
html.kiosk-touch .react-form-builder-form .three-column,
html.kiosk-touch .react-form-builder-form .four-column,
html.touch-ux .react-form-builder-form .three-column,
html.touch-ux .react-form-builder-form .four-column {
  grid-template-columns: repeat(2, 1fr) !important;
}
html.kiosk-touch .react-form-builder-form .m-signature-pad--footer,
html.touch-ux .react-form-builder-form .m-signature-pad--footer {
  position: static !important;
}
html.kiosk-touch .react-form-builder-form .rfb-item .form-group:has(.clear-signature),
html.touch-ux .react-form-builder-form .rfb-item .form-group:has(.clear-signature) {
  position: relative;
}
html.kiosk-touch .react-form-builder-form .clear-signature,
html.touch-ux .react-form-builder-form .clear-signature {
  top: auto !important;
  right: 8px !important;
  bottom: 8px !important;
  left: auto !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  width: auto !important;
  height: 40px !important;
  padding: 0 14px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
  font-size: 14px;
  font-weight: 600;
  color: #374145;
}
html.kiosk-touch .react-form-builder-form .clear-signature::after,
html.touch-ux .react-form-builder-form .clear-signature::after {
  content: "Clear";
}
html.kiosk-touch .ReviewSystems__block__row .Input,
html.touch-ux .ReviewSystems__block__row .Input {
  height: 44px !important;
  font-size: 16px !important;
}
html.kiosk-touch .HipaaForm__notice .text-sm,
html.touch-ux .HipaaForm__notice .text-sm {
  font-size: 16px !important;
  line-height: 26px !important;
}
html.kiosk-touch [data-qa=hipaa-read-notice],
html.kiosk-touch [data-qa=hipaa-add-contact],
html.touch-ux [data-qa=hipaa-read-notice],
html.touch-ux [data-qa=hipaa-add-contact] {
  height: 44px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}
html.kiosk-touch .react-datepicker__day,
html.kiosk-touch .react-datepicker__day-name,
html.kiosk-touch .react-datepicker__time-name,
html.touch-ux .react-datepicker__day,
html.touch-ux .react-datepicker__day-name,
html.touch-ux .react-datepicker__time-name {
  width: 40px !important;
  line-height: 40px !important;
  margin: 2px !important;
  font-size: 16px !important;
}
html.kiosk-touch .validation-error,
html.touch-ux .validation-error {
  top: auto !important;
  bottom: 24px !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
  width: calc(100% - 48px) !important;
  max-width: 640px !important;
  padding: 0 !important;
  font-size: 16px !important;
}
html.kiosk-touch .validation-error .btn,
html.touch-ux .validation-error .btn {
  min-height: 44px !important;
  padding: 12px 24px !important;
  font-size: 16px !important;
  line-height: 20px !important;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

button{
  background-color: transparent;
  border-width: 0px;
}

ul{
  list-style-type: disc;
}

ol{
  list-style-type: decimal;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 1920px){
  .\\!container{
    max-width: 1920px !important;
  }
  .container{
    max-width: 1920px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.\\!collapse{
  visibility: collapse !important;
}
.collapse{
  visibility: collapse;
}
.\\!static{
  position: static !important;
}
.static{
  position: static;
}
.\\!fixed{
  position: fixed !important;
}
.fixed{
  position: fixed;
}
.\\!absolute{
  position: absolute !important;
}
.absolute{
  position: absolute;
}
.\\!relative{
  position: relative !important;
}
.relative{
  position: relative;
}
.\\!sticky{
  position: sticky !important;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-\\[2px\\]{
  inset: 2px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.\\!-top-\\[90px\\]{
  top: -90px !important;
}
.\\!bottom-16{
  bottom: 4rem !important;
}
.\\!bottom-24{
  bottom: 6rem !important;
}
.\\!bottom-32{
  bottom: 8rem !important;
}
.\\!left-1{
  left: 0.25rem !important;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-11{
  bottom: -2.75rem;
}
.-bottom-2{
  bottom: -0.5rem;
}
.-bottom-3{
  bottom: -0.75rem;
}
.-bottom-4{
  bottom: -1rem;
}
.-bottom-6{
  bottom: -1.5rem;
}
.-bottom-80{
  bottom: -20rem;
}
.-bottom-\\[120px\\]{
  bottom: -120px;
}
.-bottom-\\[170px\\]{
  bottom: -170px;
}
.-bottom-\\[220px\\]{
  bottom: -220px;
}
.-bottom-\\[250px\\]{
  bottom: -250px;
}
.-left-1{
  left: -0.25rem;
}
.-left-1\\.5{
  left: -0.375rem;
}
.-left-28{
  left: -7rem;
}
.-left-4{
  left: -1rem;
}
.-left-6{
  left: -1.5rem;
}
.-left-\\[12px\\]{
  left: -12px;
}
.-left-\\[2000px\\]{
  left: -2000px;
}
.-left-\\[21px\\]{
  left: -21px;
}
.-left-\\[5px\\]{
  left: -5px;
}
.-left-\\[9999px\\]{
  left: -9999px;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-12{
  right: -3rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-28{
  right: -7rem;
}
.-right-3{
  right: -0.75rem;
}
.-right-36{
  right: -9rem;
}
.-right-4{
  right: -1rem;
}
.-right-\\[14px\\]{
  right: -14px;
}
.-right-\\[170px\\]{
  right: -170px;
}
.-right-\\[1px\\]{
  right: -1px;
}
.-right-\\[24px\\]{
  right: -24px;
}
.-right-\\[2px\\]{
  right: -2px;
}
.-right-\\[5px\\]{
  right: -5px;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-12{
  top: -3rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-3{
  top: -0.75rem;
}
.-top-4{
  top: -1rem;
}
.-top-8{
  top: -2rem;
}
.-top-96{
  top: -24rem;
}
.-top-\\[16px\\]{
  top: -16px;
}
.-top-\\[2000px\\]{
  top: -2000px;
}
.-top-\\[2px\\]{
  top: -2px;
}
.-top-\\[4px\\]{
  top: -4px;
}
.-top-\\[8px\\]{
  top: -8px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-0\\.5{
  bottom: 0.125rem;
}
.bottom-1\\/2{
  bottom: 50%;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-12{
  bottom: 3rem;
}
.bottom-14{
  bottom: 3.5rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-\\[-20px\\]{
  bottom: -20px;
}
.bottom-\\[123px\\]{
  bottom: 123px;
}
.bottom-\\[14\\%\\]{
  bottom: 14%;
}
.bottom-\\[18px\\]{
  bottom: 18px;
}
.bottom-\\[2px\\]{
  bottom: 2px;
}
.bottom-\\[40px\\]{
  bottom: 40px;
}
.bottom-\\[50px\\]{
  bottom: 50px;
}
.bottom-\\[8\\%\\]{
  bottom: 8%;
}
.bottom-\\[calc\\(100\\%\\+10px\\)\\]{
  bottom: calc(100% + 10px);
}
.bottom-\\[calc\\(100\\%\\+4px\\)\\]{
  bottom: calc(100% + 4px);
}
.bottom-\\[calc\\(100\\%_\\+_10px\\)\\]{
  bottom: calc(100% + 10px);
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-24{
  left: 6rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-6{
  left: 1.5rem;
}
.left-8{
  left: 2rem;
}
.left-\\[-3px\\]{
  left: -3px;
}
.left-\\[-9999px\\]{
  left: -9999px;
}
.left-\\[10\\%\\]{
  left: 10%;
}
.left-\\[120px\\]{
  left: 120px;
}
.left-\\[127px\\]{
  left: 127px;
}
.left-\\[18px\\]{
  left: 18px;
}
.left-\\[2px\\]{
  left: 2px;
}
.left-\\[320px\\]{
  left: 320px;
}
.left-\\[38px\\]{
  left: 38px;
}
.left-\\[6px\\]{
  left: 6px;
}
.left-\\[calc\\(100\\%\\+8px\\)\\]{
  left: calc(100% + 8px);
}
.left-auto{
  left: auto;
}
.left-full{
  left: 100%;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-1\\/2{
  right: 50%;
}
.right-14{
  right: 3.5rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-8{
  right: 2rem;
}
.right-\\[-6px\\]{
  right: -6px;
}
.right-\\[-8\\.5px\\]{
  right: -8.5px;
}
.right-\\[10px\\]{
  right: 10px;
}
.right-\\[12\\%\\]{
  right: 12%;
}
.right-\\[127px\\]{
  right: 127px;
}
.right-\\[4\\%\\]{
  right: 4%;
}
.right-\\[6px\\]{
  right: 6px;
}
.right-\\[8\\%\\]{
  right: 8%;
}
.right-\\[calc\\(100\\%\\+8px\\)\\]{
  right: calc(100% + 8px);
}
.right-full{
  right: 100%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-2{
  top: 0.5rem;
}
.top-28{
  top: 7rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[-20px\\]{
  top: -20px;
}
.top-\\[-28px\\]{
  top: -28px;
}
.top-\\[-32px\\]{
  top: -32px;
}
.top-\\[-3px\\]{
  top: -3px;
}
.top-\\[-415px\\]{
  top: -415px;
}
.top-\\[-4px\\]{
  top: -4px;
}
.top-\\[-6px\\]{
  top: -6px;
}
.top-\\[-8px\\]{
  top: -8px;
}
.top-\\[10px\\]{
  top: 10px;
}
.top-\\[110px\\]{
  top: 110px;
}
.top-\\[12px\\]{
  top: 12px;
}
.top-\\[13px\\]{
  top: 13px;
}
.top-\\[14\\%\\]{
  top: 14%;
}
.top-\\[16px\\]{
  top: 16px;
}
.top-\\[18\\%\\]{
  top: 18%;
}
.top-\\[20px\\]{
  top: 20px;
}
.top-\\[24\\%\\]{
  top: 24%;
}
.top-\\[24rem\\]{
  top: 24rem;
}
.top-\\[2px\\]{
  top: 2px;
}
.top-\\[34px\\]{
  top: 34px;
}
.top-\\[38px\\]{
  top: 38px;
}
.top-\\[40px\\]{
  top: 40px;
}
.top-\\[5px\\]{
  top: 5px;
}
.top-\\[60px\\]{
  top: 60px;
}
.top-\\[76px\\]{
  top: 76px;
}
.top-\\[calc\\(100\\%\\+4px\\)\\]{
  top: calc(100% + 4px);
}
.top-\\[calc\\(100\\%\\+6px\\)\\]{
  top: calc(100% + 6px);
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.\\!z-50{
  z-index: 50 !important;
}
.\\!z-\\[100\\]{
  z-index: 100 !important;
}
.\\!z-\\[102\\]{
  z-index: 102 !important;
}
.\\!z-\\[103\\]{
  z-index: 103 !important;
}
.\\!z-\\[200\\]{
  z-index: 200 !important;
}
.\\!z-\\[9999\\]{
  z-index: 9999 !important;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[-1\\]{
  z-index: -1;
}
.z-\\[0\\]{
  z-index: 0;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[101\\]{
  z-index: 101;
}
.z-\\[102\\]{
  z-index: 102;
}
.z-\\[103\\]{
  z-index: 103;
}
.z-\\[105\\]{
  z-index: 105;
}
.z-\\[106\\]{
  z-index: 106;
}
.z-\\[110\\]{
  z-index: 110;
}
.z-\\[120\\]{
  z-index: 120;
}
.z-\\[150\\]{
  z-index: 150;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[200\\]{
  z-index: 200;
}
.z-\\[21\\]{
  z-index: 21;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[300\\]{
  z-index: 300;
}
.z-\\[30\\]{
  z-index: 30;
}
.z-\\[3\\]{
  z-index: 3;
}
.z-\\[40\\]{
  z-index: 40;
}
.z-\\[4\\]{
  z-index: 4;
}
.z-\\[50000\\]{
  z-index: 50000;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[90\\]{
  z-index: 90;
}
.z-\\[999999\\]{
  z-index: 999999;
}
.z-\\[99999\\]{
  z-index: 99999;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.z-\\[99\\]{
  z-index: 99;
}
.order-first{
  order: -9999;
}
.order-last{
  order: 9999;
}
.col-auto{
  grid-column: auto;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-full{
  grid-column: 1 / -1;
}
.col-start-1{
  grid-column-start: 1;
}
.col-start-2{
  grid-column-start: 2;
}
.col-end-3{
  grid-column-end: 3;
}
.col-end-4{
  grid-column-end: 4;
}
.row-span-8{
  grid-row: span 8 / span 8;
}
.row-start-1{
  grid-row-start: 1;
}
.row-start-2{
  grid-row-start: 2;
}
.row-start-4{
  grid-row-start: 4;
}
.row-end-2{
  grid-row-end: 2;
}
.float-right{
  float: right;
}
.float-left{
  float: left;
}
.\\!m-0{
  margin: 0px !important;
}
.\\!m-1{
  margin: 0.25rem !important;
}
.\\!m-2{
  margin: 0.5rem !important;
}
.\\!m-3{
  margin: 0.75rem !important;
}
.\\!m-5{
  margin: 1.25rem !important;
}
.\\!m-\\[10px\\]{
  margin: 10px !important;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.m-10{
  margin: 2.5rem;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-5{
  margin: 1.25rem;
}
.m-6{
  margin: 1.5rem;
}
.m-\\[10px\\]{
  margin: 10px;
}
.m-\\[16px_-16px_-16px_-16px\\]{
  margin: 16px -16px -16px -16px;
}
.m-auto{
  margin: auto;
}
.\\!mx-1{
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.\\!mx-10{
  margin-left: 2.5rem !important;
  margin-right: 2.5rem !important;
}
.\\!mx-2{
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}
.\\!my-0{
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.\\!my-12{
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.\\!my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.\\!my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.\\!my-5{
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}
.\\!my-\\[6px\\]{
  margin-top: 6px !important;
  margin-bottom: 6px !important;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5{
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5{
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-mx-\\[16px\\]{
  margin-left: -16px;
  margin-right: -16px;
}
.-my-2{
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.-my-3{
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-10{
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-\\[20px\\]{
  margin-left: 20px;
  margin-right: 20px;
}
.mx-\\[28px\\]{
  margin-left: 28px;
  margin-right: 28px;
}
.mx-\\[40px\\]{
  margin-left: 40px;
  margin-right: 40px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0{
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-9{
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}
.my-\\[1\\.5rem\\]{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[1rem\\]{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-\\[24px\\]{
  margin-top: 24px;
  margin-bottom: 24px;
}
.my-\\[3px\\]{
  margin-top: 3px;
  margin-bottom: 3px;
}
.my-\\[50px\\]{
  margin-top: 50px;
  margin-bottom: 50px;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.\\!-ml-px{
  margin-left: -1px !important;
}
.\\!-mt-4{
  margin-top: -1rem !important;
}
.\\!-mt-\\[2px\\]{
  margin-top: -2px !important;
}
.\\!mb-0{
  margin-bottom: 0px !important;
}
.\\!mb-1{
  margin-bottom: 0.25rem !important;
}
.\\!mb-2{
  margin-bottom: 0.5rem !important;
}
.\\!mb-3{
  margin-bottom: 0.75rem !important;
}
.\\!mb-4{
  margin-bottom: 1rem !important;
}
.\\!mb-5{
  margin-bottom: 1.25rem !important;
}
.\\!mb-6{
  margin-bottom: 1.5rem !important;
}
.\\!mb-8{
  margin-bottom: 2rem !important;
}
.\\!mb-\\[10\\%\\]{
  margin-bottom: 10% !important;
}
.\\!mb-\\[10px\\]{
  margin-bottom: 10px !important;
}
.\\!mb-\\[var\\(--keyboard-inset\\2c 0px\\)\\]{
  margin-bottom: var(--keyboard-inset,0px) !important;
}
.\\!me-6{
  margin-inline-end: 1.5rem !important;
}
.\\!ml-0{
  margin-left: 0px !important;
}
.\\!ml-1{
  margin-left: 0.25rem !important;
}
.\\!ml-2{
  margin-left: 0.5rem !important;
}
.\\!ml-3{
  margin-left: 0.75rem !important;
}
.\\!ml-4{
  margin-left: 1rem !important;
}
.\\!ml-5{
  margin-left: 1.25rem !important;
}
.\\!ml-9{
  margin-left: 2.25rem !important;
}
.\\!ml-auto{
  margin-left: auto !important;
}
.\\!mr-0{
  margin-right: 0px !important;
}
.\\!mr-1\\.5{
  margin-right: 0.375rem !important;
}
.\\!mr-2{
  margin-right: 0.5rem !important;
}
.\\!mr-3{
  margin-right: 0.75rem !important;
}
.\\!mr-4{
  margin-right: 1rem !important;
}
.\\!mr-5{
  margin-right: 1.25rem !important;
}
.\\!mr-auto{
  margin-right: auto !important;
}
.\\!mt-0{
  margin-top: 0px !important;
}
.\\!mt-1{
  margin-top: 0.25rem !important;
}
.\\!mt-12{
  margin-top: 3rem !important;
}
.\\!mt-2{
  margin-top: 0.5rem !important;
}
.\\!mt-2\\.5{
  margin-top: 0.625rem !important;
}
.\\!mt-3{
  margin-top: 0.75rem !important;
}
.\\!mt-4{
  margin-top: 1rem !important;
}
.\\!mt-5{
  margin-top: 1.25rem !important;
}
.\\!mt-6{
  margin-top: 1.5rem !important;
}
.\\!mt-7{
  margin-top: 1.75rem !important;
}
.\\!mt-8{
  margin-top: 2rem !important;
}
.\\!mt-9{
  margin-top: 2.25rem !important;
}
.\\!mt-\\[15px\\]{
  margin-top: 15px !important;
}
.\\!mt-\\[2px\\]{
  margin-top: 2px !important;
}
.\\!mt-\\[3px\\]{
  margin-top: 3px !important;
}
.\\!mt-\\[6px\\]{
  margin-top: 6px !important;
}
.\\!mt-auto{
  margin-top: auto !important;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.-mb-2{
  margin-bottom: -0.5rem;
}
.-mb-3{
  margin-bottom: -0.75rem;
}
.-mb-4{
  margin-bottom: -1rem;
}
.-mb-\\[0\\.1rem\\]{
  margin-bottom: -0.1rem;
}
.-mb-\\[0\\.3rem\\]{
  margin-bottom: -0.3rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-3{
  margin-left: -0.75rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-ml-5{
  margin-left: -1.25rem;
}
.-ml-\\[1px\\]{
  margin-left: -1px;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-2{
  margin-right: -0.5rem;
}
.-mr-3{
  margin-right: -0.75rem;
}
.-mr-5{
  margin-right: -1.25rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-10{
  margin-top: -2.5rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-2\\.5{
  margin-top: -0.625rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.-mt-\\[0\\.5px\\]{
  margin-top: -0.5px;
}
.-mt-\\[10px\\]{
  margin-top: -10px;
}
.-mt-\\[16px\\]{
  margin-top: -16px;
}
.-mt-\\[1px\\]{
  margin-top: -1px;
}
.-mt-\\[3px\\]{
  margin-top: -3px;
}
.-mt-\\[40px\\]{
  margin-top: -40px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[0\\.8rem\\]{
  margin-bottom: 0.8rem;
}
.mb-\\[100px\\]{
  margin-bottom: 100px;
}
.mb-\\[112px\\]{
  margin-bottom: 112px;
}
.mb-\\[120px\\]{
  margin-bottom: 120px;
}
.mb-\\[1px\\]{
  margin-bottom: 1px;
}
.mb-\\[1rem\\]{
  margin-bottom: 1rem;
}
.mb-\\[21px\\]{
  margin-bottom: 21px;
}
.mb-\\[2px\\]{
  margin-bottom: 2px;
}
.mb-\\[30px\\]{
  margin-bottom: 30px;
}
.mb-\\[6px\\]{
  margin-bottom: 6px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-12{
  margin-left: 3rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-\\[0\\.5rem\\]{
  margin-left: 0.5rem;
}
.ml-\\[0\\.6rem\\]{
  margin-left: 0.6rem;
}
.ml-\\[10px\\]{
  margin-left: 10px;
}
.ml-\\[14px\\]{
  margin-left: 14px;
}
.ml-\\[20px\\]{
  margin-left: 20px;
}
.ml-\\[25px\\]{
  margin-left: 25px;
}
.ml-\\[2px\\]{
  margin-left: 2px;
}
.ml-\\[32px\\]{
  margin-left: 32px;
}
.ml-\\[34px\\]{
  margin-left: 34px;
}
.ml-\\[38px\\]{
  margin-left: 38px;
}
.ml-\\[46px\\]{
  margin-left: 46px;
}
.ml-\\[4px\\]{
  margin-left: 4px;
}
.ml-\\[51px\\]{
  margin-left: 51px;
}
.ml-\\[52px\\]{
  margin-left: 52px;
}
.ml-\\[6px\\]{
  margin-left: 6px;
}
.ml-\\[8px\\]{
  margin-left: 8px;
}
.ml-\\[9px\\]{
  margin-left: 9px;
}
.ml-auto{
  margin-left: auto;
}
.mr-0{
  margin-right: 0px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-10{
  margin-right: 2.5rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.mr-8{
  margin-right: 2rem;
}
.mr-\\[10px\\]{
  margin-right: 10px;
}
.mr-\\[14px\\]{
  margin-right: 14px;
}
.mr-\\[1px\\]{
  margin-right: 1px;
}
.mr-\\[2px\\]{
  margin-right: 2px;
}
.mr-\\[6px\\]{
  margin-right: 6px;
}
.mr-auto{
  margin-right: auto;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-28{
  margin-top: 7rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-40{
  margin-top: 10rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[1\\.5rem\\]{
  margin-top: 1.5rem;
}
.mt-\\[10px\\]{
  margin-top: 10px;
}
.mt-\\[12px\\]{
  margin-top: 12px;
}
.mt-\\[14px\\]{
  margin-top: 14px;
}
.mt-\\[18px\\]{
  margin-top: 18px;
}
.mt-\\[1px\\]{
  margin-top: 1px;
}
.mt-\\[1rem\\]{
  margin-top: 1rem;
}
.mt-\\[21px\\]{
  margin-top: 21px;
}
.mt-\\[27px\\]{
  margin-top: 27px;
}
.mt-\\[2px\\]{
  margin-top: 2px;
}
.mt-\\[6px\\]{
  margin-top: 6px;
}
.mt-\\[7px\\]{
  margin-top: 7px;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.box-border{
  box-sizing: border-box;
}
.\\!box-content{
  box-sizing: content-box !important;
}
.box-content{
  box-sizing: content-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.\\!flex{
  display: flex !important;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.flow-root{
  display: flow-root;
}
.\\!grid{
  display: grid !important;
}
.grid{
  display: grid;
}
.\\!contents{
  display: contents !important;
}
.contents{
  display: contents;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.\\!aspect-square{
  aspect-ratio: 1 / 1 !important;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-\\[5\\/3\\]{
  aspect-ratio: 5/3;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.\\!size-6{
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.\\!size-\\[14px\\]{
  width: 14px !important;
  height: 14px !important;
}
.\\!size-\\[24px\\]{
  width: 24px !important;
  height: 24px !important;
}
.size-0\\.5{
  width: 0.125rem;
  height: 0.125rem;
}
.size-1{
  width: 0.25rem;
  height: 0.25rem;
}
.size-1\\.5{
  width: 0.375rem;
  height: 0.375rem;
}
.size-10{
  width: 2.5rem;
  height: 2.5rem;
}
.size-12{
  width: 3rem;
  height: 3rem;
}
.size-2{
  width: 0.5rem;
  height: 0.5rem;
}
.size-2\\.5{
  width: 0.625rem;
  height: 0.625rem;
}
.size-24{
  width: 6rem;
  height: 6rem;
}
.size-3{
  width: 0.75rem;
  height: 0.75rem;
}
.size-4{
  width: 1rem;
  height: 1rem;
}
.size-5{
  width: 1.25rem;
  height: 1.25rem;
}
.size-52{
  width: 13rem;
  height: 13rem;
}
.size-6{
  width: 1.5rem;
  height: 1.5rem;
}
.size-7{
  width: 1.75rem;
  height: 1.75rem;
}
.size-8{
  width: 2rem;
  height: 2rem;
}
.size-9{
  width: 2.25rem;
  height: 2.25rem;
}
.size-\\[128px\\]{
  width: 128px;
  height: 128px;
}
.size-\\[160px\\]{
  width: 160px;
  height: 160px;
}
.size-\\[17px\\]{
  width: 17px;
  height: 17px;
}
.size-\\[18px\\]{
  width: 18px;
  height: 18px;
}
.size-\\[20px\\]{
  width: 20px;
  height: 20px;
}
.size-\\[22px\\]{
  width: 22px;
  height: 22px;
}
.size-\\[24px\\]{
  width: 24px;
  height: 24px;
}
.size-\\[25px\\]{
  width: 25px;
  height: 25px;
}
.size-\\[26px\\]{
  width: 26px;
  height: 26px;
}
.size-\\[28px\\]{
  width: 28px;
  height: 28px;
}
.size-\\[2px\\]{
  width: 2px;
  height: 2px;
}
.size-\\[3px\\]{
  width: 3px;
  height: 3px;
}
.size-\\[4px\\]{
  width: 4px;
  height: 4px;
}
.size-\\[96px\\]{
  width: 96px;
  height: 96px;
}
.\\!h-0{
  height: 0px !important;
}
.\\!h-1\\.5{
  height: 0.375rem !important;
}
.\\!h-10{
  height: 2.5rem !important;
}
.\\!h-11{
  height: 2.75rem !important;
}
.\\!h-12{
  height: 3rem !important;
}
.\\!h-16{
  height: 4rem !important;
}
.\\!h-24{
  height: 6rem !important;
}
.\\!h-28{
  height: 7rem !important;
}
.\\!h-4{
  height: 1rem !important;
}
.\\!h-5{
  height: 1.25rem !important;
}
.\\!h-6{
  height: 1.5rem !important;
}
.\\!h-7{
  height: 1.75rem !important;
}
.\\!h-8{
  height: 2rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.\\!h-\\[18px\\]{
  height: 18px !important;
}
.\\!h-\\[200px\\]{
  height: 200px !important;
}
.\\!h-\\[210px\\]{
  height: 210px !important;
}
.\\!h-\\[22px\\]{
  height: 22px !important;
}
.\\!h-\\[24px\\]{
  height: 24px !important;
}
.\\!h-\\[28px\\]{
  height: 28px !important;
}
.\\!h-\\[30px\\]{
  height: 30px !important;
}
.\\!h-\\[32px\\]{
  height: 32px !important;
}
.\\!h-\\[38px\\]{
  height: 38px !important;
}
.\\!h-\\[40px\\]{
  height: 40px !important;
}
.\\!h-\\[42px\\]{
  height: 42px !important;
}
.\\!h-\\[45px\\]{
  height: 45px !important;
}
.\\!h-\\[46px\\]{
  height: 46px !important;
}
.\\!h-\\[472px\\]{
  height: 472px !important;
}
.\\!h-\\[48px\\]{
  height: 48px !important;
}
.\\!h-\\[54px\\]{
  height: 54px !important;
}
.\\!h-\\[600px\\]{
  height: 600px !important;
}
.\\!h-\\[62px\\]{
  height: 62px !important;
}
.\\!h-\\[67px\\]{
  height: 67px !important;
}
.\\!h-\\[68px\\]{
  height: 68px !important;
}
.\\!h-\\[80\\%\\]{
  height: 80% !important;
}
.\\!h-\\[80dvh\\]{
  height: 80dvh !important;
}
.\\!h-\\[90\\%\\]{
  height: 90% !important;
}
.\\!h-\\[calc\\(100\\%\\+40px\\)\\]{
  height: calc(100% + 40px) !important;
}
.\\!h-\\[calc\\(100vh-238px\\)\\]{
  height: calc(100vh - 238px) !important;
}
.\\!h-\\[calc\\(100vh-254px\\)\\]{
  height: calc(100vh - 254px) !important;
}
.\\!h-\\[calc\\(var\\(--app-height\\2c 100dvh\\)\\*0\\.7\\)\\]{
  height: calc(var(--app-height,100dvh) * 0.7) !important;
}
.\\!h-\\[calc\\(var\\(--app-height\\2c 100dvh\\)\\*0\\.9\\)\\]{
  height: calc(var(--app-height,100dvh) * 0.9) !important;
}
.\\!h-\\[min\\(683px\\2c calc\\(var\\(--app-height\\2c 100vh\\)_-_2rem\\)\\)\\]{
  height: min(683px, calc(var(--app-height,100vh) - 2rem)) !important;
}
.\\!h-\\[var\\(--app-height\\2c 100dvh\\)\\]{
  height: var(--app-height,100dvh) !important;
}
.\\!h-\\[var\\(--app-height\\2c 100vh\\)\\]{
  height: var(--app-height,100vh) !important;
}
.\\!h-auto{
  height: auto !important;
}
.\\!h-fit{
  height: fit-content !important;
}
.\\!h-full{
  height: 100% !important;
}
.\\!h-screen{
  height: 100vh !important;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-44{
  height: 11rem;
}
.h-5{
  height: 1.25rem;
}
.h-5\\/6{
  height: 83.333333%;
}
.h-52{
  height: 13rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[0px\\]{
  height: 0px;
}
.h-\\[1\\.75rem\\]{
  height: 1.75rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[100svh\\]{
  height: 100svh;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[105\\.70px\\]{
  height: 105.70px;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[12px\\]{
  height: 12px;
}
.h-\\[130px\\]{
  height: 130px;
}
.h-\\[139px\\]{
  height: 139px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[143\\.70px\\]{
  height: 143.70px;
}
.h-\\[143px\\]{
  height: 143px;
}
.h-\\[146px\\]{
  height: 146px;
}
.h-\\[14px\\]{
  height: 14px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[16px\\]{
  height: 16px;
}
.h-\\[174px\\]{
  height: 174px;
}
.h-\\[176px\\]{
  height: 176px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1lh\\]{
  height: 1lh;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[2\\.2rem\\]{
  height: 2.2rem;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[212px\\]{
  height: 212px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[225px\\]{
  height: 225px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[240px\\]{
  height: 240px;
}
.h-\\[24px\\]{
  height: 24px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[252px\\]{
  height: 252px;
}
.h-\\[256px\\]{
  height: 256px;
}
.h-\\[25px\\]{
  height: 25px;
}
.h-\\[266px\\]{
  height: 266px;
}
.h-\\[26px\\]{
  height: 26px;
}
.h-\\[270px\\]{
  height: 270px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[301px\\]{
  height: 301px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[32px\\]{
  height: 32px;
}
.h-\\[330px\\]{
  height: 330px;
}
.h-\\[340px\\]{
  height: 340px;
}
.h-\\[34px\\]{
  height: 34px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[35px\\]{
  height: 35px;
}
.h-\\[360px\\]{
  height: 360px;
}
.h-\\[365px\\]{
  height: 365px;
}
.h-\\[37px\\]{
  height: 37px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[39px\\]{
  height: 39px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[41px\\]{
  height: 41px;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[430px\\]{
  height: 430px;
}
.h-\\[436px\\]{
  height: 436px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[4rem\\]{
  height: 4rem;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[50vh\\]{
  height: 50vh;
}
.h-\\[520px\\]{
  height: 520px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[5px\\]{
  height: 5px;
}
.h-\\[60\\%\\]{
  height: 60%;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[60vh\\]{
  height: 60vh;
}
.h-\\[62px\\]{
  height: 62px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[664px\\]{
  height: 664px;
}
.h-\\[67px\\]{
  height: 67px;
}
.h-\\[680px\\]{
  height: 680px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-\\[6px\\]{
  height: 6px;
}
.h-\\[700px\\]{
  height: 700px;
}
.h-\\[70px\\]{
  height: 70px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[75vh\\]{
  height: 75vh;
}
.h-\\[80\\%\\]{
  height: 80%;
}
.h-\\[800px\\]{
  height: 800px;
}
.h-\\[80px\\]{
  height: 80px;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[82px\\]{
  height: 82px;
}
.h-\\[85\\%\\]{
  height: 85%;
}
.h-\\[85vh\\]{
  height: 85vh;
}
.h-\\[86px\\]{
  height: 86px;
}
.h-\\[90dvh\\]{
  height: 90dvh;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-\\[92px\\]{
  height: 92px;
}
.h-\\[95\\%\\]{
  height: 95%;
}
.h-\\[calc\\(100\\%\\+2px\\)\\]{
  height: calc(100% + 2px);
}
.h-\\[calc\\(100\\%\\+6px\\)\\]{
  height: calc(100% + 6px);
}
.h-\\[calc\\(100\\%-100px\\)\\]{
  height: calc(100% - 100px);
}
.h-\\[calc\\(100\\%-44px\\)\\]{
  height: calc(100% - 44px);
}
.h-\\[calc\\(100\\%-50px\\)\\]{
  height: calc(100% - 50px);
}
.h-\\[calc\\(100\\%-52px\\)\\]{
  height: calc(100% - 52px);
}
.h-\\[calc\\(100\\%-60px\\)\\]{
  height: calc(100% - 60px);
}
.h-\\[calc\\(100vh-100px\\)\\]{
  height: calc(100vh - 100px);
}
.h-\\[calc\\(100vh-140px\\)\\]{
  height: calc(100vh - 140px);
}
.h-\\[calc\\(100vh-205px\\)\\]{
  height: calc(100vh - 205px);
}
.h-\\[calc\\(100vh-211px\\)\\]{
  height: calc(100vh - 211px);
}
.h-\\[calc\\(100vh-240px\\)\\]{
  height: calc(100vh - 240px);
}
.h-\\[calc\\(100vh-250px\\)\\]{
  height: calc(100vh - 250px);
}
.h-\\[calc\\(100vh-254px\\)\\]{
  height: calc(100vh - 254px);
}
.h-\\[calc\\(100vh-285px\\)\\]{
  height: calc(100vh - 285px);
}
.h-\\[calc\\(100vh-322px\\)\\]{
  height: calc(100vh - 322px);
}
.h-\\[calc\\(100vh-52px\\)\\]{
  height: calc(100vh - 52px);
}
.h-\\[calc\\(100vh-5rem\\)\\]{
  height: calc(100vh - 5rem);
}
.h-\\[clamp\\(104px\\2c 11vw\\2c 164px\\)\\]{
  height: clamp(104px, 11vw, 164px);
}
.h-\\[clamp\\(16rem\\2c calc\\(var\\(--app-height\\2c 100vh\\)-36\\.5rem\\)\\2c 32\\.5rem\\)\\]{
  height: clamp(16rem, calc(var(--app-height,100vh) - 36.5rem), 32.5rem);
}
.h-\\[min\\(var\\(--modal-fixed-height\\2c 640px\\)\\2c calc\\(100dvh-96px\\)\\)\\]{
  height: min(var(--modal-fixed-height,640px), calc(100dvh - 96px));
}
.h-\\[var\\(--app-height\\)\\]{
  height: var(--app-height);
}
.h-\\[var\\(--app-height\\2c 100svh\\)\\]{
  height: var(--app-height,100svh);
}
.h-\\[var\\(--app-height\\2c 100vh\\)\\]{
  height: var(--app-height,100vh);
}
.h-\\[var\\(--loader-size\\)\\]{
  height: var(--loader-size);
}
.h-auto{
  height: auto;
}
.h-dvh{
  height: 100dvh;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-max{
  height: max-content;
}
.h-min{
  height: min-content;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.\\!max-h-\\[190px\\]{
  max-height: 190px !important;
}
.\\!max-h-\\[22px\\]{
  max-height: 22px !important;
}
.\\!max-h-\\[270px\\]{
  max-height: 270px !important;
}
.\\!max-h-\\[320px\\]{
  max-height: 320px !important;
}
.\\!max-h-\\[80\\%\\]{
  max-height: 80% !important;
}
.\\!max-h-\\[80dvh\\]{
  max-height: 80dvh !important;
}
.\\!max-h-\\[80vh\\]{
  max-height: 80vh !important;
}
.\\!max-h-\\[85\\%\\]{
  max-height: 85% !important;
}
.\\!max-h-\\[85dvh\\]{
  max-height: 85dvh !important;
}
.\\!max-h-\\[85vh\\]{
  max-height: 85vh !important;
}
.\\!max-h-\\[90dvh\\]{
  max-height: 90dvh !important;
}
.\\!max-h-\\[min\\(860px\\2c calc\\(var\\(--app-height\\2c 100vh\\)_-_2rem\\)\\)\\]{
  max-height: min(860px, calc(var(--app-height,100vh) - 2rem)) !important;
}
.\\!max-h-\\[unset\\]{
  max-height: unset !important;
}
.\\!max-h-\\[var\\(--app-height\\2c 100vh\\)\\]{
  max-height: var(--app-height,100vh) !important;
}
.\\!max-h-fit{
  max-height: fit-content !important;
}
.\\!max-h-full{
  max-height: 100% !important;
}
.max-h-0{
  max-height: 0px;
}
.max-h-10{
  max-height: 2.5rem;
}
.max-h-11{
  max-height: 2.75rem;
}
.max-h-12{
  max-height: 3rem;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-4{
  max-height: 1rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-5{
  max-height: 1.25rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-6{
  max-height: 1.5rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-8{
  max-height: 2rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[1000px\\]{
  max-height: 1000px;
}
.max-h-\\[100px\\]{
  max-height: 100px;
}
.max-h-\\[107px\\]{
  max-height: 107px;
}
.max-h-\\[108px\\]{
  max-height: 108px;
}
.max-h-\\[120px\\]{
  max-height: 120px;
}
.max-h-\\[150px\\]{
  max-height: 150px;
}
.max-h-\\[170px\\]{
  max-height: 170px;
}
.max-h-\\[192px\\]{
  max-height: 192px;
}
.max-h-\\[198px\\]{
  max-height: 198px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[20px\\]{
  max-height: 20px;
}
.max-h-\\[20vh\\]{
  max-height: 20vh;
}
.max-h-\\[220px\\]{
  max-height: 220px;
}
.max-h-\\[240px\\]{
  max-height: 240px;
}
.max-h-\\[248px\\]{
  max-height: 248px;
}
.max-h-\\[250px\\]{
  max-height: 250px;
}
.max-h-\\[252px\\]{
  max-height: 252px;
}
.max-h-\\[25px\\]{
  max-height: 25px;
}
.max-h-\\[260px\\]{
  max-height: 260px;
}
.max-h-\\[264px\\]{
  max-height: 264px;
}
.max-h-\\[280px\\]{
  max-height: 280px;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[30vh\\]{
  max-height: 30vh;
}
.max-h-\\[320px\\]{
  max-height: 320px;
}
.max-h-\\[326px\\]{
  max-height: 326px;
}
.max-h-\\[332px\\]{
  max-height: 332px;
}
.max-h-\\[350px\\]{
  max-height: 350px;
}
.max-h-\\[356px\\]{
  max-height: 356px;
}
.max-h-\\[360px\\]{
  max-height: 360px;
}
.max-h-\\[380px\\]{
  max-height: 380px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[407px\\]{
  max-height: 407px;
}
.max-h-\\[40px\\]{
  max-height: 40px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[436px\\]{
  max-height: 436px;
}
.max-h-\\[50\\%\\]{
  max-height: 50%;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-\\[512px\\]{
  max-height: 512px;
}
.max-h-\\[52px\\]{
  max-height: 52px;
}
.max-h-\\[55vh\\]{
  max-height: 55vh;
}
.max-h-\\[576px\\]{
  max-height: 576px;
}
.max-h-\\[5rem\\]{
  max-height: 5rem;
}
.max-h-\\[600px\\]{
  max-height: 600px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[666px\\]{
  max-height: 666px;
}
.max-h-\\[700px\\]{
  max-height: 700px;
}
.max-h-\\[70dvh\\]{
  max-height: 70dvh;
}
.max-h-\\[70px\\]{
  max-height: 70px;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[756px\\]{
  max-height: 756px;
}
.max-h-\\[80\\%\\]{
  max-height: 80%;
}
.max-h-\\[800px\\]{
  max-height: 800px;
}
.max-h-\\[80dvh\\]{
  max-height: 80dvh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90\\%\\]{
  max-height: 90%;
}
.max-h-\\[900px\\]{
  max-height: 900px;
}
.max-h-\\[90px\\]{
  max-height: 90px;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[96dvh\\]{
  max-height: 96dvh;
}
.max-h-\\[calc\\(100vh-195px\\)\\]{
  max-height: calc(100vh - 195px);
}
.max-h-\\[calc\\(100vh-230px\\)\\]{
  max-height: calc(100vh - 230px);
}
.max-h-\\[calc\\(100vh-290px\\)\\]{
  max-height: calc(100vh - 290px);
}
.max-h-\\[calc\\(100vh-352px\\)\\]{
  max-height: calc(100vh - 352px);
}
.max-h-\\[calc\\(100vh-48px\\)\\]{
  max-height: calc(100vh - 48px);
}
.max-h-\\[calc\\(50vh-80px\\)\\]{
  max-height: calc(50vh - 80px);
}
.max-h-\\[min\\(440px\\2c 60vh\\)\\]{
  max-height: min(440px, 60vh);
}
.max-h-\\[min\\(640px\\2c calc\\(100dvh-96px\\)\\)\\]{
  max-height: min(640px, calc(100dvh - 96px));
}
.max-h-fit{
  max-height: fit-content;
}
.max-h-full{
  max-height: 100%;
}
.max-h-max{
  max-height: max-content;
}
.max-h-none{
  max-height: none;
}
.\\!min-h-0{
  min-height: 0px !important;
}
.\\!min-h-10{
  min-height: 2.5rem !important;
}
.\\!min-h-3{
  min-height: 0.75rem !important;
}
.\\!min-h-4{
  min-height: 1rem !important;
}
.\\!min-h-5{
  min-height: 1.25rem !important;
}
.\\!min-h-6{
  min-height: 1.5rem !important;
}
.\\!min-h-7{
  min-height: 1.75rem !important;
}
.\\!min-h-\\[100px\\]{
  min-height: 100px !important;
}
.\\!min-h-\\[120px\\]{
  min-height: 120px !important;
}
.\\!min-h-\\[14px\\]{
  min-height: 14px !important;
}
.\\!min-h-\\[18px\\]{
  min-height: 18px !important;
}
.\\!min-h-\\[220px\\]{
  min-height: 220px !important;
}
.\\!min-h-\\[28px\\]{
  min-height: 28px !important;
}
.\\!min-h-\\[30\\%\\]{
  min-height: 30% !important;
}
.\\!min-h-\\[30px\\]{
  min-height: 30px !important;
}
.\\!min-h-\\[34px\\]{
  min-height: 34px !important;
}
.\\!min-h-\\[40\\%\\]{
  min-height: 40% !important;
}
.\\!min-h-\\[60\\%\\]{
  min-height: 60% !important;
}
.\\!min-h-\\[60px\\]{
  min-height: 60px !important;
}
.\\!min-h-\\[70\\%\\]{
  min-height: 70% !important;
}
.\\!min-h-\\[80\\%\\]{
  min-height: 80% !important;
}
.\\!min-h-\\[80px\\]{
  min-height: 80px !important;
}
.\\!min-h-\\[85\\%\\]{
  min-height: 85% !important;
}
.\\!min-h-\\[98px\\]{
  min-height: 98px !important;
}
.min-h-0{
  min-height: 0px;
}
.min-h-10{
  min-height: 2.5rem;
}
.min-h-11{
  min-height: 2.75rem;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-14{
  min-height: 3.5rem;
}
.min-h-16{
  min-height: 4rem;
}
.min-h-36{
  min-height: 9rem;
}
.min-h-4{
  min-height: 1rem;
}
.min-h-44{
  min-height: 11rem;
}
.min-h-48{
  min-height: 12rem;
}
.min-h-5{
  min-height: 1.25rem;
}
.min-h-6{
  min-height: 1.5rem;
}
.min-h-60{
  min-height: 15rem;
}
.min-h-7{
  min-height: 1.75rem;
}
.min-h-72{
  min-height: 18rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-9{
  min-height: 2.25rem;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[116px\\]{
  min-height: 116px;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[122px\\]{
  min-height: 122px;
}
.min-h-\\[128px\\]{
  min-height: 128px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[144px\\]{
  min-height: 144px;
}
.min-h-\\[148px\\]{
  min-height: 148px;
}
.min-h-\\[150px\\]{
  min-height: 150px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[18px\\]{
  min-height: 18px;
}
.min-h-\\[1px\\]{
  min-height: 1px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[232px\\]{
  min-height: 232px;
}
.min-h-\\[24px\\]{
  min-height: 24px;
}
.min-h-\\[250px\\]{
  min-height: 250px;
}
.min-h-\\[258px\\]{
  min-height: 258px;
}
.min-h-\\[260px\\]{
  min-height: 260px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[28px\\]{
  min-height: 28px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[30vh\\]{
  min-height: 30vh;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[32px\\]{
  min-height: 32px;
}
.min-h-\\[332px\\]{
  min-height: 332px;
}
.min-h-\\[34px\\]{
  min-height: 34px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[38px\\]{
  min-height: 38px;
}
.min-h-\\[3rem\\]{
  min-height: 3rem;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[420px\\]{
  min-height: 420px;
}
.min-h-\\[42px\\]{
  min-height: 42px;
}
.min-h-\\[436px\\]{
  min-height: 436px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[480px\\]{
  min-height: 480px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[52px\\]{
  min-height: 52px;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[64px\\]{
  min-height: 64px;
}
.min-h-\\[66px\\]{
  min-height: 66px;
}
.min-h-\\[68px\\]{
  min-height: 68px;
}
.min-h-\\[7\\.5rem\\]{
  min-height: 7.5rem;
}
.min-h-\\[70px\\]{
  min-height: 70px;
}
.min-h-\\[75px\\]{
  min-height: 75px;
}
.min-h-\\[76px\\]{
  min-height: 76px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[82px\\]{
  min-height: 82px;
}
.min-h-\\[calc\\(100vh-102px\\)\\]{
  min-height: calc(100vh - 102px);
}
.min-h-\\[inherit\\]{
  min-height: inherit;
}
.min-h-\\[var\\(--app-height\\2c 100vh\\)\\]{
  min-height: var(--app-height,100vh);
}
.min-h-\\[var\\(--loader-size\\)\\]{
  min-height: var(--loader-size);
}
.min-h-dvh{
  min-height: 100dvh;
}
.min-h-fit{
  min-height: fit-content;
}
.min-h-full{
  min-height: 100%;
}
.min-h-min{
  min-height: min-content;
}
.min-h-px{
  min-height: 1px;
}
.\\!w-1\\/4{
  width: 25% !important;
}
.\\!w-10{
  width: 2.5rem !important;
}
.\\!w-11{
  width: 2.75rem !important;
}
.\\!w-12{
  width: 3rem !important;
}
.\\!w-14{
  width: 3.5rem !important;
}
.\\!w-16{
  width: 4rem !important;
}
.\\!w-2\\/3{
  width: 66.666667% !important;
}
.\\!w-2\\/4{
  width: 50% !important;
}
.\\!w-3\\/4{
  width: 75% !important;
}
.\\!w-32{
  width: 8rem !important;
}
.\\!w-4{
  width: 1rem !important;
}
.\\!w-48{
  width: 12rem !important;
}
.\\!w-5{
  width: 1.25rem !important;
}
.\\!w-6{
  width: 1.5rem !important;
}
.\\!w-7{
  width: 1.75rem !important;
}
.\\!w-8{
  width: 2rem !important;
}
.\\!w-9{
  width: 2.25rem !important;
}
.\\!w-\\[100\\%\\]{
  width: 100% !important;
}
.\\!w-\\[1000px\\]{
  width: 1000px !important;
}
.\\!w-\\[1056px\\]{
  width: 1056px !important;
}
.\\!w-\\[110px\\]{
  width: 110px !important;
}
.\\!w-\\[1200px\\]{
  width: 1200px !important;
}
.\\!w-\\[130px\\]{
  width: 130px !important;
}
.\\!w-\\[160px\\]{
  width: 160px !important;
}
.\\!w-\\[182px\\]{
  width: 182px !important;
}
.\\!w-\\[186px\\]{
  width: 186px !important;
}
.\\!w-\\[18px\\]{
  width: 18px !important;
}
.\\!w-\\[200px\\]{
  width: 200px !important;
}
.\\!w-\\[24px\\]{
  width: 24px !important;
}
.\\!w-\\[26px\\]{
  width: 26px !important;
}
.\\!w-\\[272px\\]{
  width: 272px !important;
}
.\\!w-\\[28px\\]{
  width: 28px !important;
}
.\\!w-\\[34px\\]{
  width: 34px !important;
}
.\\!w-\\[360px\\]{
  width: 360px !important;
}
.\\!w-\\[380px\\]{
  width: 380px !important;
}
.\\!w-\\[38px\\]{
  width: 38px !important;
}
.\\!w-\\[400px\\]{
  width: 400px !important;
}
.\\!w-\\[450px\\]{
  width: 450px !important;
}
.\\!w-\\[460px\\]{
  width: 460px !important;
}
.\\!w-\\[576px\\]{
  width: 576px !important;
}
.\\!w-\\[60\\%\\]{
  width: 60% !important;
}
.\\!w-\\[640px\\]{
  width: 640px !important;
}
.\\!w-\\[650px\\]{
  width: 650px !important;
}
.\\!w-\\[70\\%\\]{
  width: 70% !important;
}
.\\!w-\\[720px\\]{
  width: 720px !important;
}
.\\!w-\\[72px\\]{
  width: 72px !important;
}
.\\!w-\\[75px\\]{
  width: 75px !important;
}
.\\!w-\\[800px\\]{
  width: 800px !important;
}
.\\!w-\\[min\\(576px\\2c calc\\(100vw_-_2rem\\)\\)\\]{
  width: min(576px, calc(100vw - 2rem)) !important;
}
.\\!w-auto{
  width: auto !important;
}
.\\!w-fit{
  width: fit-content !important;
}
.\\!w-full{
  width: 100% !important;
}
.\\!w-max{
  width: max-content !important;
}
.\\!w-screen{
  width: 100vw !important;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/4{
  width: 50%;
}
.w-2\\/5{
  width: 40%;
}
.w-2\\/6{
  width: 33.333333%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/12{
  width: 25%;
}
.w-3\\/4{
  width: 75%;
}
.w-3\\/5{
  width: 60%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/12{
  width: 33.333333%;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-8\\/12{
  width: 66.666667%;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[1\\.5rem\\]{
  width: 1.5rem;
}
.w-\\[1\\.75rem\\]{
  width: 1.75rem;
}
.w-\\[100dvw\\]{
  width: 100dvw;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[100vw\\]{
  width: 100vw;
}
.w-\\[100wh\\]{
  width: 100wh;
}
.w-\\[1020px\\]{
  width: 1020px;
}
.w-\\[104px\\]{
  width: 104px;
}
.w-\\[1056px\\]{
  width: 1056px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[10rem\\]{
  width: 10rem;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[111px\\]{
  width: 111px;
}
.w-\\[1160px\\]{
  width: 1160px;
}
.w-\\[117px\\]{
  width: 117px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[1240px\\]{
  width: 1240px;
}
.w-\\[126\\.50px\\]{
  width: 126.50px;
}
.w-\\[12px\\]{
  width: 12px;
}
.w-\\[136px\\]{
  width: 136px;
}
.w-\\[14\\%\\]{
  width: 14%;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[142px\\]{
  width: 142px;
}
.w-\\[14px\\]{
  width: 14px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[15rem\\]{
  width: 15rem;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[16px\\]{
  width: 16px;
}
.w-\\[172px\\]{
  width: 172px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[182px\\]{
  width: 182px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[196px\\]{
  width: 196px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[2\\.2rem\\]{
  width: 2.2rem;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[208px\\]{
  width: 208px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[224px\\]{
  width: 224px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[230px\\]{
  width: 230px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[24px\\]{
  width: 24px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[256px\\]{
  width: 256px;
}
.w-\\[25px\\]{
  width: 25px;
}
.w-\\[26\\%\\]{
  width: 26%;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[264px\\]{
  width: 264px;
}
.w-\\[26px\\]{
  width: 26px;
}
.w-\\[274px\\]{
  width: 274px;
}
.w-\\[27px\\]{
  width: 27px;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[284px\\]{
  width: 284px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[308px\\]{
  width: 308px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[312px\\]{
  width: 312px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[32px\\]{
  width: 32px;
}
.w-\\[330px\\]{
  width: 330px;
}
.w-\\[332px\\]{
  width: 332px;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[340px\\]{
  width: 340px;
}
.w-\\[348px\\]{
  width: 348px;
}
.w-\\[34px\\]{
  width: 34px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[354px\\]{
  width: 354px;
}
.w-\\[359px\\]{
  width: 359px;
}
.w-\\[35px\\]{
  width: 35px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[368px\\]{
  width: 368px;
}
.w-\\[376px\\]{
  width: 376px;
}
.w-\\[380px\\]{
  width: 380px;
}
.w-\\[38px\\]{
  width: 38px;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[410px\\]{
  width: 410px;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[440px\\]{
  width: 440px;
}
.w-\\[444px\\]{
  width: 444px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[460px\\]{
  width: 460px;
}
.w-\\[46px\\]{
  width: 46px;
}
.w-\\[480px\\]{
  width: 480px;
}
.w-\\[48px\\]{
  width: 48px;
}
.w-\\[498px\\]{
  width: 498px;
}
.w-\\[4rem\\]{
  width: 4rem;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[512px\\]{
  width: 512px;
}
.w-\\[52\\%\\]{
  width: 52%;
}
.w-\\[52px\\]{
  width: 52px;
}
.w-\\[536px\\]{
  width: 536px;
}
.w-\\[56px\\]{
  width: 56px;
}
.w-\\[576px\\]{
  width: 576px;
}
.w-\\[590px\\]{
  width: 590px;
}
.w-\\[5px\\]{
  width: 5px;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[620px\\]{
  width: 620px;
}
.w-\\[62px\\]{
  width: 62px;
}
.w-\\[640px\\]{
  width: 640px;
}
.w-\\[64px\\]{
  width: 64px;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[66\\%\\]{
  width: 66%;
}
.w-\\[678px\\]{
  width: 678px;
}
.w-\\[6px\\]{
  width: 6px;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[700px\\]{
  width: 700px;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[720px\\]{
  width: 720px;
}
.w-\\[729px\\]{
  width: 729px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[746px\\]{
  width: 746px;
}
.w-\\[768px\\]{
  width: 768px;
}
.w-\\[770px\\]{
  width: 770px;
}
.w-\\[780px\\]{
  width: 780px;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[800px\\]{
  width: 800px;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[80vw\\]{
  width: 80vw;
}
.w-\\[81\\%\\]{
  width: 81%;
}
.w-\\[82px\\]{
  width: 82px;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[900px\\]{
  width: 900px;
}
.w-\\[90vw\\]{
  width: 90vw;
}
.w-\\[91\\%\\]{
  width: 91%;
}
.w-\\[92px\\]{
  width: 92px;
}
.w-\\[93px\\]{
  width: 93px;
}
.w-\\[96px\\]{
  width: 96px;
}
.w-\\[984px\\]{
  width: 984px;
}
.w-\\[calc\\(100\\%\\+6px\\)\\]{
  width: calc(100% + 6px);
}
.w-\\[calc\\(100\\%\\+8px\\)\\]{
  width: calc(100% + 8px);
}
.w-\\[calc\\(100\\%-1\\.5rem\\)\\]{
  width: calc(100% - 1.5rem);
}
.w-\\[calc\\(100\\%-120px\\)\\]{
  width: calc(100% - 120px);
}
.w-\\[calc\\(100\\%-4px\\)\\]{
  width: calc(100% - 4px);
}
.w-\\[calc\\(100\\%-6px\\)\\]{
  width: calc(100% - 6px);
}
.w-\\[calc\\(50\\%-3px\\)\\]{
  width: calc(50% - 3px);
}
.w-\\[min\\(1020px\\2c calc\\(100vw_-_3rem\\)\\)\\]{
  width: min(1020px, calc(100vw - 3rem));
}
.w-\\[min\\(680px\\2c calc\\(100vw-32px\\)\\)\\]{
  width: min(680px, calc(100vw - 32px));
}
.w-\\[var\\(--loader-size\\)\\]{
  width: var(--loader-size);
}
.w-auto{
  width: auto;
}
.w-dvw{
  width: 100dvw;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-min{
  width: min-content;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.\\!min-w-0{
  min-width: 0px !important;
}
.\\!min-w-5{
  min-width: 1.25rem !important;
}
.\\!min-w-6{
  min-width: 1.5rem !important;
}
.\\!min-w-\\[112px\\]{
  min-width: 112px !important;
}
.\\!min-w-\\[140px\\]{
  min-width: 140px !important;
}
.\\!min-w-\\[14px\\]{
  min-width: 14px !important;
}
.\\!min-w-\\[16px\\]{
  min-width: 16px !important;
}
.\\!min-w-\\[180px\\]{
  min-width: 180px !important;
}
.\\!min-w-\\[18px\\]{
  min-width: 18px !important;
}
.\\!min-w-\\[200px\\]{
  min-width: 200px !important;
}
.\\!min-w-\\[22px\\]{
  min-width: 22px !important;
}
.\\!min-w-\\[24px\\]{
  min-width: 24px !important;
}
.\\!min-w-\\[256px\\]{
  min-width: 256px !important;
}
.\\!min-w-\\[28px\\]{
  min-width: 28px !important;
}
.\\!min-w-\\[300px\\]{
  min-width: 300px !important;
}
.\\!min-w-\\[520px\\]{
  min-width: 520px !important;
}
.\\!min-w-\\[90px\\]{
  min-width: 90px !important;
}
.\\!min-w-\\[unset\\]{
  min-width: unset !important;
}
.\\!min-w-full{
  min-width: 100% !important;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-12{
  min-width: 3rem;
}
.min-w-14{
  min-width: 3.5rem;
}
.min-w-20{
  min-width: 5rem;
}
.min-w-24{
  min-width: 6rem;
}
.min-w-28{
  min-width: 7rem;
}
.min-w-3{
  min-width: 0.75rem;
}
.min-w-32{
  min-width: 8rem;
}
.min-w-36{
  min-width: 9rem;
}
.min-w-4{
  min-width: 1rem;
}
.min-w-44{
  min-width: 11rem;
}
.min-w-5{
  min-width: 1.25rem;
}
.min-w-52{
  min-width: 13rem;
}
.min-w-6{
  min-width: 1.5rem;
}
.min-w-60{
  min-width: 15rem;
}
.min-w-7{
  min-width: 1.75rem;
}
.min-w-72{
  min-width: 18rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-80{
  min-width: 20rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-96{
  min-width: 24rem;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[1024px\\]{
  min-width: 1024px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[1240px\\]{
  min-width: 1240px;
}
.min-w-\\[125px\\]{
  min-width: 125px;
}
.min-w-\\[126px\\]{
  min-width: 126px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[144px\\]{
  min-width: 144px;
}
.min-w-\\[14px\\]{
  min-width: 14px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[1650px\\]{
  min-width: 1650px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[172px\\]{
  min-width: 172px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[182px\\]{
  min-width: 182px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[224px\\]{
  min-width: 224px;
}
.min-w-\\[230px\\]{
  min-width: 230px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[244px\\]{
  min-width: 244px;
}
.min-w-\\[24px\\]{
  min-width: 24px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[264px\\]{
  min-width: 264px;
}
.min-w-\\[26px\\]{
  min-width: 26px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[28px\\]{
  min-width: 28px;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[30px\\]{
  min-width: 30px;
}
.min-w-\\[320px\\]{
  min-width: 320px;
}
.min-w-\\[32px\\]{
  min-width: 32px;
}
.min-w-\\[350px\\]{
  min-width: 350px;
}
.min-w-\\[360px\\]{
  min-width: 360px;
}
.min-w-\\[36px\\]{
  min-width: 36px;
}
.min-w-\\[380px\\]{
  min-width: 380px;
}
.min-w-\\[38px\\]{
  min-width: 38px;
}
.min-w-\\[3px\\]{
  min-width: 3px;
}
.min-w-\\[400px\\]{
  min-width: 400px;
}
.min-w-\\[40px\\]{
  min-width: 40px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-\\[46px\\]{
  min-width: 46px;
}
.min-w-\\[480px\\]{
  min-width: 480px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-\\[500px\\]{
  min-width: 500px;
}
.min-w-\\[50dvw\\]{
  min-width: 50dvw;
}
.min-w-\\[55px\\]{
  min-width: 55px;
}
.min-w-\\[560px\\]{
  min-width: 560px;
}
.min-w-\\[600px\\]{
  min-width: 600px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[627px\\]{
  min-width: 627px;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[64px\\]{
  min-width: 64px;
}
.min-w-\\[6px\\]{
  min-width: 6px;
}
.min-w-\\[70\\%\\]{
  min-width: 70%;
}
.min-w-\\[70px\\]{
  min-width: 70px;
}
.min-w-\\[72px\\]{
  min-width: 72px;
}
.min-w-\\[75px\\]{
  min-width: 75px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-\\[82px\\]{
  min-width: 82px;
}
.min-w-\\[83px\\]{
  min-width: 83px;
}
.min-w-\\[88px\\]{
  min-width: 88px;
}
.min-w-\\[90px\\]{
  min-width: 90px;
}
.min-w-\\[min\\(480px\\2c calc\\(100vw_-_2rem\\)\\)\\]{
  min-width: min(480px, calc(100vw - 2rem));
}
.min-w-\\[var\\(--loader-size\\)\\]{
  min-width: var(--loader-size);
}
.min-w-\\[\\2026\\]{
  min-width: …;
}
.min-w-fit{
  min-width: fit-content;
}
.min-w-full{
  min-width: 100%;
}
.min-w-max{
  min-width: max-content;
}
.\\!max-w-\\[112px\\]{
  max-width: 112px !important;
}
.\\!max-w-\\[130px\\]{
  max-width: 130px !important;
}
.\\!max-w-\\[1400px\\]{
  max-width: 1400px !important;
}
.\\!max-w-\\[150px\\]{
  max-width: 150px !important;
}
.\\!max-w-\\[300px\\]{
  max-width: 300px !important;
}
.\\!max-w-\\[360px\\]{
  max-width: 360px !important;
}
.\\!max-w-\\[400px\\]{
  max-width: 400px !important;
}
.\\!max-w-\\[480px\\]{
  max-width: 480px !important;
}
.\\!max-w-\\[550px\\]{
  max-width: 550px !important;
}
.\\!max-w-\\[576px\\]{
  max-width: 576px !important;
}
.\\!max-w-\\[60\\%\\]{
  max-width: 60% !important;
}
.\\!max-w-\\[650px\\]{
  max-width: 650px !important;
}
.\\!max-w-full{
  max-width: 100% !important;
}
.\\!max-w-none{
  max-width: none !important;
}
.max-w-0{
  max-width: 0px;
}
.max-w-12{
  max-width: 3rem;
}
.max-w-20{
  max-width: 5rem;
}
.max-w-32{
  max-width: 8rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-44{
  max-width: 11rem;
}
.max-w-48{
  max-width: 12rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-\\[1000px\\]{
  max-width: 1000px;
}
.max-w-\\[100px\\]{
  max-width: 100px;
}
.max-w-\\[1080px\\]{
  max-width: 1080px;
}
.max-w-\\[108px\\]{
  max-width: 108px;
}
.max-w-\\[110px\\]{
  max-width: 110px;
}
.max-w-\\[1160px\\]{
  max-width: 1160px;
}
.max-w-\\[1180px\\]{
  max-width: 1180px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[124px\\]{
  max-width: 124px;
}
.max-w-\\[1280px\\]{
  max-width: 1280px;
}
.max-w-\\[130px\\]{
  max-width: 130px;
}
.max-w-\\[132px\\]{
  max-width: 132px;
}
.max-w-\\[1408px\\]{
  max-width: 1408px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[142px\\]{
  max-width: 142px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[164px\\]{
  max-width: 164px;
}
.max-w-\\[170px\\]{
  max-width: 170px;
}
.max-w-\\[175px\\]{
  max-width: 175px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[190px\\]{
  max-width: 190px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[20rem\\]{
  max-width: 20rem;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[224px\\]{
  max-width: 224px;
}
.max-w-\\[230px\\]{
  max-width: 230px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[24rem\\]{
  max-width: 24rem;
}
.max-w-\\[252px\\]{
  max-width: 252px;
}
.max-w-\\[255px\\]{
  max-width: 255px;
}
.max-w-\\[256px\\]{
  max-width: 256px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[272px\\]{
  max-width: 272px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[284px\\]{
  max-width: 284px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[330px\\]{
  max-width: 330px;
}
.max-w-\\[332px\\]{
  max-width: 332px;
}
.max-w-\\[340px\\]{
  max-width: 340px;
}
.max-w-\\[348px\\]{
  max-width: 348px;
}
.max-w-\\[360px\\]{
  max-width: 360px;
}
.max-w-\\[362px\\]{
  max-width: 362px;
}
.max-w-\\[366px\\]{
  max-width: 366px;
}
.max-w-\\[36px\\]{
  max-width: 36px;
}
.max-w-\\[380px\\]{
  max-width: 380px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[406px\\]{
  max-width: 406px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[422px\\]{
  max-width: 422px;
}
.max-w-\\[440px\\]{
  max-width: 440px;
}
.max-w-\\[448px\\]{
  max-width: 448px;
}
.max-w-\\[450px\\]{
  max-width: 450px;
}
.max-w-\\[456px\\]{
  max-width: 456px;
}
.max-w-\\[460px\\]{
  max-width: 460px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[48px\\]{
  max-width: 48px;
}
.max-w-\\[50\\%\\]{
  max-width: 50%;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[50px\\]{
  max-width: 50px;
}
.max-w-\\[50vw\\]{
  max-width: 50vw;
}
.max-w-\\[512px\\]{
  max-width: 512px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[552px\\]{
  max-width: 552px;
}
.max-w-\\[560px\\]{
  max-width: 560px;
}
.max-w-\\[56px\\]{
  max-width: 56px;
}
.max-w-\\[576px\\]{
  max-width: 576px;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[600px\\]{
  max-width: 600px;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[64px\\]{
  max-width: 64px;
}
.max-w-\\[65\\%\\]{
  max-width: 65%;
}
.max-w-\\[650px\\]{
  max-width: 650px;
}
.max-w-\\[654px\\]{
  max-width: 654px;
}
.max-w-\\[664px\\]{
  max-width: 664px;
}
.max-w-\\[688px\\]{
  max-width: 688px;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[700px\\]{
  max-width: 700px;
}
.max-w-\\[70px\\]{
  max-width: 70px;
}
.max-w-\\[711px\\]{
  max-width: 711px;
}
.max-w-\\[712px\\]{
  max-width: 712px;
}
.max-w-\\[720px\\]{
  max-width: 720px;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-\\[750px\\]{
  max-width: 750px;
}
.max-w-\\[754px\\]{
  max-width: 754px;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-\\[768px\\]{
  max-width: 768px;
}
.max-w-\\[770px\\]{
  max-width: 770px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[82px\\]{
  max-width: 82px;
}
.max-w-\\[840px\\]{
  max-width: 840px;
}
.max-w-\\[856px\\]{
  max-width: 856px;
}
.max-w-\\[860px\\]{
  max-width: 860px;
}
.max-w-\\[880px\\]{
  max-width: 880px;
}
.max-w-\\[900px\\]{
  max-width: 900px;
}
.max-w-\\[92vw\\]{
  max-width: 92vw;
}
.max-w-\\[94vw\\]{
  max-width: 94vw;
}
.max-w-\\[968px\\]{
  max-width: 968px;
}
.max-w-\\[976px\\]{
  max-width: 976px;
}
.max-w-\\[calc\\(100vw-32px\\)\\]{
  max-width: calc(100vw - 32px);
}
.max-w-\\[calc\\(100vw_-_2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-\\[min\\(576px\\2c calc\\(100vw_-_2rem\\)\\)\\]{
  max-width: min(576px, calc(100vw - 2rem));
}
.max-w-\\[min\\(620px\\2c calc\\(100vw_-_2rem\\)\\)\\]{
  max-width: min(620px, calc(100vw - 2rem));
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-\\[0_100_552px\\]{
  flex: 0 100 552px;
}
.flex-\\[1\\.3\\]{
  flex: 1.3;
}
.flex-\\[1_1_340px\\]{
  flex: 1 1 340px;
}
.flex-\\[1_1_640px\\]{
  flex: 1 1 640px;
}
.flex-\\[2\\]{
  flex: 2;
}
.flex-\\[2_1_460px\\]{
  flex: 2 1 460px;
}
.flex-\\[999_1_120px\\]{
  flex: 999 1 120px;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.flex-grow-0{
  flex-grow: 0;
}
.\\!grow-0{
  flex-grow: 0 !important;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.\\!basis-0{
  flex-basis: 0px !important;
}
.\\!basis-40{
  flex-basis: 10rem !important;
}
.basis-0{
  flex-basis: 0px;
}
.basis-1\\/2{
  flex-basis: 50%;
}
.basis-1\\/4{
  flex-basis: 25%;
}
.basis-32{
  flex-basis: 8rem;
}
.basis-\\[140px\\]{
  flex-basis: 140px;
}
.basis-\\[240px\\]{
  flex-basis: 240px;
}
.basis-\\[40\\%\\]{
  flex-basis: 40%;
}
.basis-\\[42\\%\\]{
  flex-basis: 42%;
}
.basis-full{
  flex-basis: 100%;
}
.table-auto{
  table-layout: auto;
}
.table-fixed{
  table-layout: fixed;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-0{
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-x-4{
  --tw-border-spacing-x: 1rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-y-4{
  --tw-border-spacing-y: 1rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-bottom{
  transform-origin: bottom;
}
.origin-center{
  transform-origin: center;
}
.origin-top{
  transform-origin: top;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2{
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-24{
  --tw-translate-x: -6rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-5{
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-32{
  --tw-translate-y: -8rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2{
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-24{
  --tw-translate-x: 6rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[calc\\(100\\%\\+2px\\)\\]{
  --tw-translate-x: calc(100% + 2px);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2{
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-32{
  --tw-translate-y: 8rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[110\\%\\]{
  --tw-translate-y: 110%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[200\\%\\]{
  --tw-translate-y: 200%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full{
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!-rotate-1{
  --tw-rotate: -1deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!rotate-180{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-rotate-1{
  --tw-rotate: -1deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-1{
  --tw-rotate: 1deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3{
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[33deg\\]{
  --tw-rotate: 33deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[43deg\\]{
  --tw-rotate: 43deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.8\\]{
  --tw-scale-x: 0.8;
  --tw-scale-y: 0.8;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.97\\]{
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.98\\]{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.15\\]{
  --tw-scale-x: 1.15;
  --tw-scale-y: 1.15;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.\\!animate-bounce{
  animation: bounce 1s infinite !important;
}
@keyframes shimmer{
  0%{
    transform: translateX(-100%);
  }
  100%{
    transform: translateX(340px);
  }
}
.animate-\\[shimmer_5s_ease-in-out_infinite\\]{
  animation: shimmer 5s ease-in-out infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-\\[spin_2s_linear_infinite\\]{
  animation: spin 2s linear infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-\\[spin_3s_linear_infinite\\]{
  animation: spin 3s linear infinite;
}
@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes breathe{
  0%, 100%{
    opacity: 0.1;
    transform: scale(1);
  }
  50%{
    opacity: 0.25;
    transform: scale(1.04);
  }
}
.animate-breathe{
  animation: breathe 2.5s ease-in-out infinite;
}
@keyframes check-bounce{
  0%{
    transform: scale(0);
  }
  60%{
    transform: scale(1.15);
  }
  100%{
    transform: scale(1);
  }
}
.animate-check-bounce{
  animation: check-bounce 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}
@keyframes enter-up{
  0%{
    opacity: 0;
    transform: translateY(16px);
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-enter-up{
  animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) backwards;
}
@keyframes enter-up{
  0%{
    opacity: 0;
    transform: translateY(16px);
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-enter-up-1{
  animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards;
}
@keyframes enter-up{
  0%{
    opacity: 0;
    transform: translateY(16px);
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-enter-up-2{
  animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.22s backwards;
}
@keyframes enter-up{
  0%{
    opacity: 0;
    transform: translateY(16px);
  }
  100%{
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-enter-up-3{
  animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.34s backwards;
}
@keyframes fade-in{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
.animate-fade-in{
  animation: fade-in 0.15s ease-out;
}
@keyframes fadeIn_pulse{
  0%{
    opacity: 0;
  }
  50%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-fade-in-pulse{
  animation: fadeIn_pulse 0.5s ease-in forwards, pulse 1.5s infinite 0.5s;
}
@keyframes float-in{
  0%{
    opacity: 0;
    scale: 0.97;
    translate: 0 -8px;
  }
  100%{
    opacity: 1;
    scale: 1;
    translate: 0 0;
  }
}
.animate-float-in{
  animation: float-in 0.15s cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pop-in{
  0%{
    opacity: 0;
    transform: scale(0.4);
  }
  60%{
    opacity: 1;
    transform: scale(1.08);
  }
  100%{
    opacity: 1;
    transform: scale(1);
  }
}
.animate-pop-in{
  animation: pop-in 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s backwards;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes ring-burst{
  0%{
    opacity: 0.55;
    transform: scale(0.55);
  }
  100%{
    opacity: 0;
    transform: scale(2.1);
  }
}
.animate-ring-burst{
  animation: ring-burst 0.9s ease-out 0.4s;
}
@keyframes scale_pulse{
  0%, 100%{
    transform: scale(0.85);
  }
  50%{
    transform: scale(1);
  }
}
.animate-scale-pulse{
  animation: scale_pulse 1.5s ease-in-out infinite;
}
@keyframes shake{
  0%, 50%, 100%{
    transform: translateX(0);
  }
  6%, 19%{
    transform: translateX(-2px);
  }
  12%{
    transform: translateX(2px);
  }
  31%, 44%{
    transform: translateX(-1px);
  }
  25%, 38%{
    transform: translateX(1px);
  }
}
.animate-shake{
  animation: shake 2s ease-in-out infinite;
}
@keyframes shimmer{
  0%{
    transform: translateX(-100%);
  }
  100%{
    transform: translateX(340px);
  }
}
.animate-shimmer{
  animation: shimmer 1.5s ease-in-out infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
@keyframes sweep{
  0%{
    transform: translateX(-100%);
  }
  100%{
    transform: translateX(100%);
  }
}
.animate-sweep{
  animation: sweep 1.8s ease-in-out infinite;
}
.\\!cursor-copy{
  cursor: copy !important;
}
.\\!cursor-default{
  cursor: default !important;
}
.\\!cursor-grab{
  cursor: grab !important;
}
.\\!cursor-not-allowed{
  cursor: not-allowed !important;
}
.\\!cursor-pointer{
  cursor: pointer !important;
}
.cursor-\\[inherit\\]{
  cursor: inherit;
}
.cursor-col-resize{
  cursor: col-resize;
}
.cursor-copy{
  cursor: copy;
}
.cursor-default{
  cursor: default;
}
.cursor-e-resize{
  cursor: e-resize;
}
.cursor-ew-resize{
  cursor: ew-resize;
}
.cursor-grab{
  cursor: grab;
}
.cursor-grabbing{
  cursor: grabbing;
}
.cursor-help{
  cursor: help;
}
.cursor-move{
  cursor: move;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-ns-resize{
  cursor: ns-resize;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.cursor-w-resize{
  cursor: w-resize;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.touch-none{
  touch-action: none;
}
.touch-manipulation{
  touch-action: manipulation;
}
.select-none{
  user-select: none;
}
.\\!select-text{
  user-select: text !important;
}
.select-text{
  user-select: text;
}
.select-all{
  user-select: all;
}
.\\!resize-none{
  resize: none !important;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.\\!list-inside{
  list-style-position: inside !important;
}
.list-inside{
  list-style-position: inside;
}
.\\!list-decimal{
  list-style-type: decimal !important;
}
.\\!list-disc{
  list-style-type: disc !important;
}
.list-\\[circle\\]{
  list-style-type: circle;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.columns-3{
  columns: 3;
}
.break-inside-avoid{
  break-inside: avoid;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.auto-rows-max{
  grid-auto-rows: max-content;
}
.auto-rows-min{
  grid-auto-rows: min-content;
}
.\\!grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.\\!grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-\\[1\\.5fr_0\\.8fr_1\\.5fr\\]{
  grid-template-columns: 1.5fr 0.8fr 1.5fr;
}
.grid-cols-\\[100px_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 100px minmax(0,1fr);
}
.grid-cols-\\[110px\\2c 1fr\\]{
  grid-template-columns: 110px 1fr;
}
.grid-cols-\\[120px_1fr_1fr\\]{
  grid-template-columns: 120px 1fr 1fr;
}
.grid-cols-\\[130px_1fr_1fr\\]{
  grid-template-columns: 130px 1fr 1fr;
}
.grid-cols-\\[1fr_1\\.4fr_1\\.4fr\\]{
  grid-template-columns: 1fr 1.4fr 1.4fr;
}
.grid-cols-\\[1fr_1fr_1fr_auto\\]{
  grid-template-columns: 1fr 1fr 1fr auto;
}
.grid-cols-\\[1fr_auto_auto\\]{
  grid-template-columns: 1fr auto auto;
}
.grid-cols-\\[2fr\\2c 2fr\\2c 1fr\\]{
  grid-template-columns: 2fr 2fr 1fr;
}
.grid-cols-\\[34px\\2c auto\\]{
  grid-template-columns: 34px auto;
}
.grid-cols-\\[63\\%\\2c 35\\%\\]{
  grid-template-columns: 63% 35%;
}
.grid-cols-\\[80px_1fr_1fr\\]{
  grid-template-columns: 80px 1fr 1fr;
}
.grid-cols-\\[auto\\2c 1fr\\]{
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_1fr\\]{
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: auto minmax(0,1fr);
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: auto minmax(0,1fr) auto;
}
.grid-cols-\\[max-content\\2c max-content\\]{
  grid-template-columns: max-content max-content;
}
.grid-cols-\\[max-content_1fr\\]{
  grid-template-columns: max-content 1fr;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_28px_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: minmax(0,1fr) 28px minmax(0,1fr);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_40px_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: minmax(0,1fr) 40px minmax(0,1fr);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c min\\(33\\%\\2c 80px\\)\\)_minmax\\(0\\2c min\\(45\\%\\2c 200px\\)\\)\\]{
  grid-template-columns: minmax(0,1fr) minmax(0,min(33%, 80px)) minmax(0,min(45%, 200px));
}
.grid-cols-\\[minmax\\(0\\2c 3fr\\)_minmax\\(0\\2c 5fr\\)\\]{
  grid-template-columns: minmax(0,3fr) minmax(0,5fr);
}
.grid-cols-\\[minmax\\(0\\2c 7fr\\)_minmax\\(0\\2c 3fr\\)\\]{
  grid-template-columns: minmax(0,7fr) minmax(0,3fr);
}
.grid-cols-\\[repeat\\(4\\2c 56px\\)\\]{
  grid-template-columns: repeat(4,56px);
}
.grid-cols-\\[repeat\\(7\\2c 56px\\)\\]{
  grid-template-columns: repeat(7,56px);
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(140px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(140px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(190px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(190px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(200px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(260px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(260px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(300px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(300px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(326px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(326px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(360px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(360px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(90px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(90px,1fr));
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(min\\(100\\%\\2c 15rem\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(min(100%, 15rem),1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(110px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(110px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(118px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(118px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(140px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(140px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(150px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(150px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(200px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(250px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(264px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(264px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(280px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(280px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(284px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(284px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(96px\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(96px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(max\\(240px\\2c calc\\(50\\%-12px\\)\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(max(240px, calc(50% - 12px)),1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(min\\(100\\%\\2c 16rem\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(min(100%, 16rem),1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(min\\(100\\%\\2c 320px\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(min(100%, 320px),1fr));
}
.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.grid-rows-\\[0fr\\]{
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\]{
  grid-template-rows: 1fr;
}
.grid-rows-\\[auto_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-rows: auto minmax(0,1fr);
}
.grid-rows-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-rows: minmax(0,1fr) auto;
}
.\\!flex-row{
  flex-direction: row !important;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.\\!flex-col{
  flex-direction: column !important;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-wrap-reverse{
  flex-wrap: wrap-reverse;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.place-content-center{
  place-content: center;
}
.place-content-end{
  place-content: end;
}
.place-items-center{
  place-items: center;
}
.content-center{
  align-content: center;
}
.content-start{
  align-content: flex-start;
}
.\\!items-start{
  align-items: flex-start !important;
}
.items-start{
  align-items: flex-start;
}
.\\!items-end{
  align-items: flex-end !important;
}
.items-end{
  align-items: flex-end;
}
.\\!items-center{
  align-items: center !important;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.\\!items-stretch{
  align-items: stretch !important;
}
.items-stretch{
  align-items: stretch;
}
.\\!justify-start{
  justify-content: flex-start !important;
}
.justify-start{
  justify-content: flex-start;
}
.\\!justify-end{
  justify-content: flex-end !important;
}
.justify-end{
  justify-content: flex-end;
}
.\\!justify-center{
  justify-content: center !important;
}
.justify-center{
  justify-content: center;
}
.\\!justify-between{
  justify-content: space-between !important;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.justify-items-center{
  justify-items: center;
}
.\\!gap-0{
  gap: 0px !important;
}
.\\!gap-1{
  gap: 0.25rem !important;
}
.\\!gap-2{
  gap: 0.5rem !important;
}
.\\!gap-3{
  gap: 0.75rem !important;
}
.\\!gap-4{
  gap: 1rem !important;
}
.\\!gap-5{
  gap: 1.25rem !important;
}
.\\!gap-6{
  gap: 1.5rem !important;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-11{
  gap: 2.75rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-20{
  gap: 5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-9{
  gap: 2.25rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[12px\\]{
  gap: 12px;
}
.gap-\\[12px_8px\\]{
  gap: 12px 8px;
}
.gap-\\[14px\\]{
  gap: 14px;
}
.gap-\\[15px\\]{
  gap: 15px;
}
.gap-\\[18px\\]{
  gap: 18px;
}
.gap-\\[21px\\]{
  gap: 21px;
}
.gap-\\[22px\\]{
  gap: 22px;
}
.gap-\\[24px\\]{
  gap: 24px;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[3px\\]{
  gap: 3px;
}
.gap-\\[4px\\]{
  gap: 4px;
}
.gap-\\[5px\\]{
  gap: 5px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-\\[7px\\]{
  gap: 7px;
}
.gap-\\[8px\\]{
  gap: 8px;
}
.gap-\\[98px\\]{
  gap: 98px;
}
.gap-px{
  gap: 1px;
}
.\\!gap-x-0{
  column-gap: 0px !important;
}
.\\!gap-x-2{
  column-gap: 0.5rem !important;
}
.\\!gap-x-3{
  column-gap: 0.75rem !important;
}
.\\!gap-x-6{
  column-gap: 1.5rem !important;
}
.\\!gap-y-0{
  row-gap: 0px !important;
}
.\\!gap-y-1{
  row-gap: 0.25rem !important;
}
.\\!gap-y-2{
  row-gap: 0.5rem !important;
}
.\\!gap-y-4{
  row-gap: 1rem !important;
}
.\\!gap-y-6{
  row-gap: 1.5rem !important;
}
.gap-x-0{
  column-gap: 0px;
}
.gap-x-0\\.5{
  column-gap: 0.125rem;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-1\\.5{
  column-gap: 0.375rem;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-12{
  column-gap: 3rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-2\\.5{
  column-gap: 0.625rem;
}
.gap-x-20{
  column-gap: 5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-x-\\[10px\\]{
  column-gap: 10px;
}
.gap-x-\\[14px\\]{
  column-gap: 14px;
}
.gap-x-\\[18px\\]{
  column-gap: 18px;
}
.gap-x-\\[2px\\]{
  column-gap: 2px;
}
.gap-x-\\[40px\\]{
  column-gap: 40px;
}
.gap-x-\\[6px\\]{
  column-gap: 6px;
}
.gap-x-\\[9px\\]{
  column-gap: 9px;
}
.gap-y-0{
  row-gap: 0px;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-12{
  row-gap: 3rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-2\\.5{
  row-gap: 0.625rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.gap-y-7{
  row-gap: 1.75rem;
}
.gap-y-\\[14px\\]{
  row-gap: 14px;
}
.gap-y-\\[1px\\]{
  row-gap: 1px;
}
.gap-y-\\[2px\\]{
  row-gap: 2px;
}
.gap-y-\\[6px\\]{
  row-gap: 6px;
}
.-space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-x-0 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(0px * var(--tw-divide-x-reverse));
  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(2px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(2px * var(--tw-divide-y-reverse));
}
.divide-solid > :not([hidden]) ~ :not([hidden]){
  border-style: solid;
}
.divide-neutral-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-divide-opacity, 1));
}
.divide-neutral-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-divide-opacity, 1));
}
.divide-neutral-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 250 / var(--tw-divide-opacity, 1));
}
.place-self-center{
  place-self: center;
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.self-stretch{
  align-self: stretch;
}
.justify-self-start{
  justify-self: start;
}
.justify-self-end{
  justify-self: end;
}
.\\!overflow-auto{
  overflow: auto !important;
}
.overflow-auto{
  overflow: auto;
}
.\\!overflow-hidden{
  overflow: hidden !important;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-clip{
  overflow: clip;
}
.overflow-visible{
  overflow: visible;
}
.overflow-scroll{
  overflow: scroll;
}
.overflow-x-auto{
  overflow-x: auto;
}
.\\!overflow-y-auto{
  overflow-y: auto !important;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.\\!overflow-y-hidden{
  overflow-y: hidden !important;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-x-clip{
  overflow-x: clip;
}
.overflow-y-visible{
  overflow-y: visible;
}
.\\!overflow-y-scroll{
  overflow-y: scroll !important;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.overscroll-contain{
  overscroll-behavior: contain;
}
.\\!truncate{
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.text-clip{
  text-overflow: clip;
}
.\\!whitespace-normal{
  white-space: normal !important;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.\\!whitespace-pre-wrap{
  white-space: pre-wrap !important;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-wrap{
  text-wrap: wrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-normal{
  overflow-wrap: normal;
  word-break: normal;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded{
  border-radius: 0.25rem !important;
}
.\\!rounded-2xl{
  border-radius: 1rem !important;
}
.\\!rounded-\\[27px\\]{
  border-radius: 27px !important;
}
.\\!rounded-\\[3px\\]{
  border-radius: 3px !important;
}
.\\!rounded-\\[4px\\]{
  border-radius: 4px !important;
}
.\\!rounded-\\[5px\\]{
  border-radius: 5px !important;
}
.\\!rounded-\\[6px\\]{
  border-radius: 6px !important;
}
.\\!rounded-full{
  border-radius: 9999px !important;
}
.\\!rounded-lg{
  border-radius: 0.5rem !important;
}
.\\!rounded-md{
  border-radius: 0.375rem !important;
}
.\\!rounded-none{
  border-radius: 0px !important;
}
.\\!rounded-xl{
  border-radius: 0.75rem !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[0\\.5rem\\]{
  border-radius: 0.5rem;
}
.rounded-\\[0px_0px_8px_8px\\]{
  border-radius: 0px 0px 8px 8px;
}
.rounded-\\[0px_25\\.5px_25\\.5px_0px\\]{
  border-radius: 0px 25.5px 25.5px 0px;
}
.rounded-\\[0px_25\\.5px_25\\.5px_25\\.5px\\]{
  border-radius: 0px 25.5px 25.5px 25.5px;
}
.rounded-\\[10\\.43px\\]{
  border-radius: 10.43px;
}
.rounded-\\[100px\\]{
  border-radius: 100px;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[14\\.34px\\]{
  border-radius: 14.34px;
}
.rounded-\\[15px\\]{
  border-radius: 15px;
}
.rounded-\\[16px\\]{
  border-radius: 16px;
}
.rounded-\\[17px\\]{
  border-radius: 17px;
}
.rounded-\\[1px\\]{
  border-radius: 1px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[25\\.5px_25\\.5px_25\\.5px_0px\\]{
  border-radius: 25.5px 25.5px 25.5px 0px;
}
.rounded-\\[26px_0px_0px_26px\\]{
  border-radius: 26px 0px 0px 26px;
}
.rounded-\\[26px_0px_26px_26px\\]{
  border-radius: 26px 0px 26px 26px;
}
.rounded-\\[26px_26px_0px_26px\\]{
  border-radius: 26px 26px 0px 26px;
}
.rounded-\\[27px\\]{
  border-radius: 27px;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[32px\\]{
  border-radius: 32px;
}
.rounded-\\[34px\\]{
  border-radius: 34px;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[40px\\]{
  border-radius: 40px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[7px\\]{
  border-radius: 7px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.\\!rounded-b-none{
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!rounded-l-none{
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.\\!rounded-r-md{
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
.\\!rounded-r-none{
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.\\!rounded-t-2xl{
  border-top-left-radius: 1rem !important;
  border-top-right-radius: 1rem !important;
}
.\\!rounded-t-\\[12px\\]{
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-\\[16px\\]{
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}
.rounded-b-\\[8px\\]{
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.rounded-b-lg{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l{
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-r-none{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[6px\\]{
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.rounded-t-\\[8px\\]{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md{
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-md{
  border-bottom-left-radius: 0.375rem;
}
.rounded-br-lg{
  border-bottom-right-radius: 0.5rem;
}
.rounded-tr-lg{
  border-top-right-radius: 0.5rem;
}
.\\!border{
  border-width: 1px !important;
}
.\\!border-0{
  border-width: 0px !important;
}
.\\!border-2{
  border-width: 2px !important;
}
.\\!border-4{
  border-width: 4px !important;
}
.\\!border-\\[5px\\]{
  border-width: 5px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-\\[0\\.25rem\\]{
  border-width: 0.25rem;
}
.border-\\[0\\.75px\\]{
  border-width: 0.75px;
}
.border-\\[0\\]{
  border-width: 0;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.\\!border-x-0{
  border-left-width: 0px !important;
  border-right-width: 0px !important;
}
.\\!border-y{
  border-top-width: 1px !important;
  border-bottom-width: 1px !important;
}
.\\!border-y-2{
  border-top-width: 2px !important;
  border-bottom-width: 2px !important;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-x-0{
  border-left-width: 0px;
  border-right-width: 0px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-0{
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.\\!border-b{
  border-bottom-width: 1px !important;
}
.\\!border-b-0{
  border-bottom-width: 0px !important;
}
.\\!border-b-2{
  border-bottom-width: 2px !important;
}
.\\!border-b-\\[1px\\]{
  border-bottom-width: 1px !important;
}
.\\!border-l{
  border-left-width: 1px !important;
}
.\\!border-l-0{
  border-left-width: 0px !important;
}
.\\!border-l-\\[4px\\]{
  border-left-width: 4px !important;
}
.\\!border-r{
  border-right-width: 1px !important;
}
.\\!border-r-\\[1px\\]{
  border-right-width: 1px !important;
}
.\\!border-t{
  border-top-width: 1px !important;
}
.\\!border-t-0{
  border-top-width: 0px !important;
}
.\\!border-t-\\[1px\\]{
  border-top-width: 1px !important;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[0\\.6px\\]{
  border-bottom-width: 0.6px;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[1px\\]{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-r-8{
  border-right-width: 8px;
}
.border-r-\\[1px\\]{
  border-right-width: 1px;
}
.border-r-\\[2px\\]{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-\\[1px\\]{
  border-top-width: 1px;
}
.border-t-\\[2px\\]{
  border-top-width: 2px;
}
.\\!border-solid{
  border-style: solid !important;
}
.border-solid{
  border-style: solid;
}
.\\!border-dashed{
  border-style: dashed !important;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.border-none{
  border-style: none;
}
.\\!border-\\[\\#8AE0FF\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(138 224 255 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#C1CACE\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(193 202 206 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#dadfe2\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(218 223 226 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#dcdcdc\\]{
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 220 220 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-black{
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-black\\/10{
  border-color: rgb(0 0 0 / 0.1) !important;
}
.\\!border-danger-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-danger-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 162 155 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-danger-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-danger-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-100{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-800{
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 43 55 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-neutral-dark-700{
  --tw-border-opacity: 1 !important;
  border-color: rgb(55 58 65 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-orange-dark-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 214 174 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-primary-100{
  border-color: var(--color-primary-100, #E0F2FE) !important;
}
.\\!border-primary-200{
  border-color: var(--color-primary-200, #B9E6FE) !important;
}
.\\!border-primary-300{
  border-color: var(--color-primary-300, #7CD4FD) !important;
}
.\\!border-primary-400{
  border-color: var(--color-primary-400, #36BFFA) !important;
}
.\\!border-primary-500{
  border-color: var(--color-primary-500, #0BA5EC) !important;
}
.\\!border-primary-600{
  border-color: var(--color-primary-600, #0086C9) !important;
}
.\\!border-success-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(115 226 163 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(22 179 100 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-success-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(9 146 80 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-transparent{
  border-color: transparent !important;
}
.\\!border-warning-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 200 75 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-warning-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-warning-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-white{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-white\\/30{
  border-color: rgb(255 255 255 / 0.3) !important;
}
.border-\\[\\#8191E8\\]\\/30{
  border-color: rgb(129 145 232 / 0.3);
}
.border-\\[\\#C1CACE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(193 202 206 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E9EAEB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ECEFF0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(236 239 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F3F4F6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cdd5d8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(205 213 216 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]{
  border-color: rgba(0,0,0,0.12);
}
.border-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.8\\)\\]{
  border-color: rgba(255,255,255,0.8);
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-black\\/10{
  border-color: rgb(0 0 0 / 0.1);
}
.border-black\\/\\[0\\.12\\]{
  border-color: rgb(0 0 0 / 0.12);
}
.border-blue-dark-300{
  --tw-border-opacity: 1;
  border-color: rgb(132 173 255 / var(--tw-border-opacity, 1));
}
.border-cyan-100{
  --tw-border-opacity: 1;
  border-color: rgb(207 249 254 / var(--tw-border-opacity, 1));
}
.border-cyan-300{
  --tw-border-opacity: 1;
  border-color: rgb(103 227 249 / var(--tw-border-opacity, 1));
}
.border-danger-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}
.border-danger-100\\/0{
  border-color: rgb(254 228 226 / 0);
}
.border-danger-100\\/10{
  border-color: rgb(254 228 226 / 0.1);
}
.border-danger-100\\/100{
  border-color: rgb(254 228 226 / 1);
}
.border-danger-100\\/15{
  border-color: rgb(254 228 226 / 0.15);
}
.border-danger-100\\/20{
  border-color: rgb(254 228 226 / 0.2);
}
.border-danger-100\\/25{
  border-color: rgb(254 228 226 / 0.25);
}
.border-danger-100\\/30{
  border-color: rgb(254 228 226 / 0.3);
}
.border-danger-100\\/35{
  border-color: rgb(254 228 226 / 0.35);
}
.border-danger-100\\/40{
  border-color: rgb(254 228 226 / 0.4);
}
.border-danger-100\\/45{
  border-color: rgb(254 228 226 / 0.45);
}
.border-danger-100\\/5{
  border-color: rgb(254 228 226 / 0.05);
}
.border-danger-100\\/50{
  border-color: rgb(254 228 226 / 0.5);
}
.border-danger-100\\/55{
  border-color: rgb(254 228 226 / 0.55);
}
.border-danger-100\\/60{
  border-color: rgb(254 228 226 / 0.6);
}
.border-danger-100\\/65{
  border-color: rgb(254 228 226 / 0.65);
}
.border-danger-100\\/70{
  border-color: rgb(254 228 226 / 0.7);
}
.border-danger-100\\/75{
  border-color: rgb(254 228 226 / 0.75);
}
.border-danger-100\\/80{
  border-color: rgb(254 228 226 / 0.8);
}
.border-danger-100\\/85{
  border-color: rgb(254 228 226 / 0.85);
}
.border-danger-100\\/90{
  border-color: rgb(254 228 226 / 0.9);
}
.border-danger-100\\/95{
  border-color: rgb(254 228 226 / 0.95);
}
.border-danger-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1));
}
.border-danger-200\\/0{
  border-color: rgb(254 205 202 / 0);
}
.border-danger-200\\/10{
  border-color: rgb(254 205 202 / 0.1);
}
.border-danger-200\\/100{
  border-color: rgb(254 205 202 / 1);
}
.border-danger-200\\/15{
  border-color: rgb(254 205 202 / 0.15);
}
.border-danger-200\\/20{
  border-color: rgb(254 205 202 / 0.2);
}
.border-danger-200\\/25{
  border-color: rgb(254 205 202 / 0.25);
}
.border-danger-200\\/30{
  border-color: rgb(254 205 202 / 0.3);
}
.border-danger-200\\/35{
  border-color: rgb(254 205 202 / 0.35);
}
.border-danger-200\\/40{
  border-color: rgb(254 205 202 / 0.4);
}
.border-danger-200\\/45{
  border-color: rgb(254 205 202 / 0.45);
}
.border-danger-200\\/5{
  border-color: rgb(254 205 202 / 0.05);
}
.border-danger-200\\/50{
  border-color: rgb(254 205 202 / 0.5);
}
.border-danger-200\\/55{
  border-color: rgb(254 205 202 / 0.55);
}
.border-danger-200\\/60{
  border-color: rgb(254 205 202 / 0.6);
}
.border-danger-200\\/65{
  border-color: rgb(254 205 202 / 0.65);
}
.border-danger-200\\/70{
  border-color: rgb(254 205 202 / 0.7);
}
.border-danger-200\\/75{
  border-color: rgb(254 205 202 / 0.75);
}
.border-danger-200\\/80{
  border-color: rgb(254 205 202 / 0.8);
}
.border-danger-200\\/85{
  border-color: rgb(254 205 202 / 0.85);
}
.border-danger-200\\/90{
  border-color: rgb(254 205 202 / 0.9);
}
.border-danger-200\\/95{
  border-color: rgb(254 205 202 / 0.95);
}
.border-danger-25{
  --tw-border-opacity: 1;
  border-color: rgb(255 251 250 / var(--tw-border-opacity, 1));
}
.border-danger-25\\/0{
  border-color: rgb(255 251 250 / 0);
}
.border-danger-25\\/10{
  border-color: rgb(255 251 250 / 0.1);
}
.border-danger-25\\/100{
  border-color: rgb(255 251 250 / 1);
}
.border-danger-25\\/15{
  border-color: rgb(255 251 250 / 0.15);
}
.border-danger-25\\/20{
  border-color: rgb(255 251 250 / 0.2);
}
.border-danger-25\\/25{
  border-color: rgb(255 251 250 / 0.25);
}
.border-danger-25\\/30{
  border-color: rgb(255 251 250 / 0.3);
}
.border-danger-25\\/35{
  border-color: rgb(255 251 250 / 0.35);
}
.border-danger-25\\/40{
  border-color: rgb(255 251 250 / 0.4);
}
.border-danger-25\\/45{
  border-color: rgb(255 251 250 / 0.45);
}
.border-danger-25\\/5{
  border-color: rgb(255 251 250 / 0.05);
}
.border-danger-25\\/50{
  border-color: rgb(255 251 250 / 0.5);
}
.border-danger-25\\/55{
  border-color: rgb(255 251 250 / 0.55);
}
.border-danger-25\\/60{
  border-color: rgb(255 251 250 / 0.6);
}
.border-danger-25\\/65{
  border-color: rgb(255 251 250 / 0.65);
}
.border-danger-25\\/70{
  border-color: rgb(255 251 250 / 0.7);
}
.border-danger-25\\/75{
  border-color: rgb(255 251 250 / 0.75);
}
.border-danger-25\\/80{
  border-color: rgb(255 251 250 / 0.8);
}
.border-danger-25\\/85{
  border-color: rgb(255 251 250 / 0.85);
}
.border-danger-25\\/90{
  border-color: rgb(255 251 250 / 0.9);
}
.border-danger-25\\/95{
  border-color: rgb(255 251 250 / 0.95);
}
.border-danger-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}
.border-danger-400{
  --tw-border-opacity: 1;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1));
}
.border-danger-400\\/0{
  border-color: rgb(249 112 102 / 0);
}
.border-danger-400\\/10{
  border-color: rgb(249 112 102 / 0.1);
}
.border-danger-400\\/100{
  border-color: rgb(249 112 102 / 1);
}
.border-danger-400\\/15{
  border-color: rgb(249 112 102 / 0.15);
}
.border-danger-400\\/20{
  border-color: rgb(249 112 102 / 0.2);
}
.border-danger-400\\/25{
  border-color: rgb(249 112 102 / 0.25);
}
.border-danger-400\\/30{
  border-color: rgb(249 112 102 / 0.3);
}
.border-danger-400\\/35{
  border-color: rgb(249 112 102 / 0.35);
}
.border-danger-400\\/40{
  border-color: rgb(249 112 102 / 0.4);
}
.border-danger-400\\/45{
  border-color: rgb(249 112 102 / 0.45);
}
.border-danger-400\\/5{
  border-color: rgb(249 112 102 / 0.05);
}
.border-danger-400\\/50{
  border-color: rgb(249 112 102 / 0.5);
}
.border-danger-400\\/55{
  border-color: rgb(249 112 102 / 0.55);
}
.border-danger-400\\/60{
  border-color: rgb(249 112 102 / 0.6);
}
.border-danger-400\\/65{
  border-color: rgb(249 112 102 / 0.65);
}
.border-danger-400\\/70{
  border-color: rgb(249 112 102 / 0.7);
}
.border-danger-400\\/75{
  border-color: rgb(249 112 102 / 0.75);
}
.border-danger-400\\/80{
  border-color: rgb(249 112 102 / 0.8);
}
.border-danger-400\\/85{
  border-color: rgb(249 112 102 / 0.85);
}
.border-danger-400\\/90{
  border-color: rgb(249 112 102 / 0.9);
}
.border-danger-400\\/95{
  border-color: rgb(249 112 102 / 0.95);
}
.border-danger-50{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
}
.border-danger-50\\/0{
  border-color: rgb(254 243 242 / 0);
}
.border-danger-50\\/10{
  border-color: rgb(254 243 242 / 0.1);
}
.border-danger-50\\/100{
  border-color: rgb(254 243 242 / 1);
}
.border-danger-50\\/15{
  border-color: rgb(254 243 242 / 0.15);
}
.border-danger-50\\/20{
  border-color: rgb(254 243 242 / 0.2);
}
.border-danger-50\\/25{
  border-color: rgb(254 243 242 / 0.25);
}
.border-danger-50\\/30{
  border-color: rgb(254 243 242 / 0.3);
}
.border-danger-50\\/35{
  border-color: rgb(254 243 242 / 0.35);
}
.border-danger-50\\/40{
  border-color: rgb(254 243 242 / 0.4);
}
.border-danger-50\\/45{
  border-color: rgb(254 243 242 / 0.45);
}
.border-danger-50\\/5{
  border-color: rgb(254 243 242 / 0.05);
}
.border-danger-50\\/50{
  border-color: rgb(254 243 242 / 0.5);
}
.border-danger-50\\/55{
  border-color: rgb(254 243 242 / 0.55);
}
.border-danger-50\\/60{
  border-color: rgb(254 243 242 / 0.6);
}
.border-danger-50\\/65{
  border-color: rgb(254 243 242 / 0.65);
}
.border-danger-50\\/70{
  border-color: rgb(254 243 242 / 0.7);
}
.border-danger-50\\/75{
  border-color: rgb(254 243 242 / 0.75);
}
.border-danger-50\\/80{
  border-color: rgb(254 243 242 / 0.8);
}
.border-danger-50\\/85{
  border-color: rgb(254 243 242 / 0.85);
}
.border-danger-50\\/90{
  border-color: rgb(254 243 242 / 0.9);
}
.border-danger-50\\/95{
  border-color: rgb(254 243 242 / 0.95);
}
.border-danger-500{
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}
.border-danger-500\\/0{
  border-color: rgb(240 68 56 / 0);
}
.border-danger-500\\/10{
  border-color: rgb(240 68 56 / 0.1);
}
.border-danger-500\\/100{
  border-color: rgb(240 68 56 / 1);
}
.border-danger-500\\/15{
  border-color: rgb(240 68 56 / 0.15);
}
.border-danger-500\\/20{
  border-color: rgb(240 68 56 / 0.2);
}
.border-danger-500\\/25{
  border-color: rgb(240 68 56 / 0.25);
}
.border-danger-500\\/30{
  border-color: rgb(240 68 56 / 0.3);
}
.border-danger-500\\/35{
  border-color: rgb(240 68 56 / 0.35);
}
.border-danger-500\\/40{
  border-color: rgb(240 68 56 / 0.4);
}
.border-danger-500\\/45{
  border-color: rgb(240 68 56 / 0.45);
}
.border-danger-500\\/5{
  border-color: rgb(240 68 56 / 0.05);
}
.border-danger-500\\/50{
  border-color: rgb(240 68 56 / 0.5);
}
.border-danger-500\\/55{
  border-color: rgb(240 68 56 / 0.55);
}
.border-danger-500\\/60{
  border-color: rgb(240 68 56 / 0.6);
}
.border-danger-500\\/65{
  border-color: rgb(240 68 56 / 0.65);
}
.border-danger-500\\/70{
  border-color: rgb(240 68 56 / 0.7);
}
.border-danger-500\\/75{
  border-color: rgb(240 68 56 / 0.75);
}
.border-danger-500\\/80{
  border-color: rgb(240 68 56 / 0.8);
}
.border-danger-500\\/85{
  border-color: rgb(240 68 56 / 0.85);
}
.border-danger-500\\/90{
  border-color: rgb(240 68 56 / 0.9);
}
.border-danger-500\\/95{
  border-color: rgb(240 68 56 / 0.95);
}
.border-danger-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}
.border-danger-600\\/0{
  border-color: rgb(217 45 32 / 0);
}
.border-danger-600\\/10{
  border-color: rgb(217 45 32 / 0.1);
}
.border-danger-600\\/100{
  border-color: rgb(217 45 32 / 1);
}
.border-danger-600\\/15{
  border-color: rgb(217 45 32 / 0.15);
}
.border-danger-600\\/20{
  border-color: rgb(217 45 32 / 0.2);
}
.border-danger-600\\/25{
  border-color: rgb(217 45 32 / 0.25);
}
.border-danger-600\\/30{
  border-color: rgb(217 45 32 / 0.3);
}
.border-danger-600\\/35{
  border-color: rgb(217 45 32 / 0.35);
}
.border-danger-600\\/40{
  border-color: rgb(217 45 32 / 0.4);
}
.border-danger-600\\/45{
  border-color: rgb(217 45 32 / 0.45);
}
.border-danger-600\\/5{
  border-color: rgb(217 45 32 / 0.05);
}
.border-danger-600\\/50{
  border-color: rgb(217 45 32 / 0.5);
}
.border-danger-600\\/55{
  border-color: rgb(217 45 32 / 0.55);
}
.border-danger-600\\/60{
  border-color: rgb(217 45 32 / 0.6);
}
.border-danger-600\\/65{
  border-color: rgb(217 45 32 / 0.65);
}
.border-danger-600\\/70{
  border-color: rgb(217 45 32 / 0.7);
}
.border-danger-600\\/75{
  border-color: rgb(217 45 32 / 0.75);
}
.border-danger-600\\/80{
  border-color: rgb(217 45 32 / 0.8);
}
.border-danger-600\\/85{
  border-color: rgb(217 45 32 / 0.85);
}
.border-danger-600\\/90{
  border-color: rgb(217 45 32 / 0.9);
}
.border-danger-600\\/95{
  border-color: rgb(217 45 32 / 0.95);
}
.border-danger-700{
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}
.border-danger-700\\/0{
  border-color: rgb(180 35 24 / 0);
}
.border-danger-700\\/10{
  border-color: rgb(180 35 24 / 0.1);
}
.border-danger-700\\/100{
  border-color: rgb(180 35 24 / 1);
}
.border-danger-700\\/15{
  border-color: rgb(180 35 24 / 0.15);
}
.border-danger-700\\/20{
  border-color: rgb(180 35 24 / 0.2);
}
.border-danger-700\\/25{
  border-color: rgb(180 35 24 / 0.25);
}
.border-danger-700\\/30{
  border-color: rgb(180 35 24 / 0.3);
}
.border-danger-700\\/35{
  border-color: rgb(180 35 24 / 0.35);
}
.border-danger-700\\/40{
  border-color: rgb(180 35 24 / 0.4);
}
.border-danger-700\\/45{
  border-color: rgb(180 35 24 / 0.45);
}
.border-danger-700\\/5{
  border-color: rgb(180 35 24 / 0.05);
}
.border-danger-700\\/50{
  border-color: rgb(180 35 24 / 0.5);
}
.border-danger-700\\/55{
  border-color: rgb(180 35 24 / 0.55);
}
.border-danger-700\\/60{
  border-color: rgb(180 35 24 / 0.6);
}
.border-danger-700\\/65{
  border-color: rgb(180 35 24 / 0.65);
}
.border-danger-700\\/70{
  border-color: rgb(180 35 24 / 0.7);
}
.border-danger-700\\/75{
  border-color: rgb(180 35 24 / 0.75);
}
.border-danger-700\\/80{
  border-color: rgb(180 35 24 / 0.8);
}
.border-danger-700\\/85{
  border-color: rgb(180 35 24 / 0.85);
}
.border-danger-700\\/90{
  border-color: rgb(180 35 24 / 0.9);
}
.border-danger-700\\/95{
  border-color: rgb(180 35 24 / 0.95);
}
.border-fuchsia-300{
  --tw-border-opacity: 1;
  border-color: rgb(238 170 253 / var(--tw-border-opacity, 1));
}
.border-green-light-300{
  --tw-border-opacity: 1;
  border-color: rgb(166 239 103 / var(--tw-border-opacity, 1));
}
.border-moss-100{
  --tw-border-opacity: 1;
  border-color: rgb(230 244 215 / var(--tw-border-opacity, 1));
}
.border-moss-100\\/0{
  border-color: rgb(230 244 215 / 0);
}
.border-moss-100\\/10{
  border-color: rgb(230 244 215 / 0.1);
}
.border-moss-100\\/100{
  border-color: rgb(230 244 215 / 1);
}
.border-moss-100\\/15{
  border-color: rgb(230 244 215 / 0.15);
}
.border-moss-100\\/20{
  border-color: rgb(230 244 215 / 0.2);
}
.border-moss-100\\/25{
  border-color: rgb(230 244 215 / 0.25);
}
.border-moss-100\\/30{
  border-color: rgb(230 244 215 / 0.3);
}
.border-moss-100\\/35{
  border-color: rgb(230 244 215 / 0.35);
}
.border-moss-100\\/40{
  border-color: rgb(230 244 215 / 0.4);
}
.border-moss-100\\/45{
  border-color: rgb(230 244 215 / 0.45);
}
.border-moss-100\\/5{
  border-color: rgb(230 244 215 / 0.05);
}
.border-moss-100\\/50{
  border-color: rgb(230 244 215 / 0.5);
}
.border-moss-100\\/55{
  border-color: rgb(230 244 215 / 0.55);
}
.border-moss-100\\/60{
  border-color: rgb(230 244 215 / 0.6);
}
.border-moss-100\\/65{
  border-color: rgb(230 244 215 / 0.65);
}
.border-moss-100\\/70{
  border-color: rgb(230 244 215 / 0.7);
}
.border-moss-100\\/75{
  border-color: rgb(230 244 215 / 0.75);
}
.border-moss-100\\/80{
  border-color: rgb(230 244 215 / 0.8);
}
.border-moss-100\\/85{
  border-color: rgb(230 244 215 / 0.85);
}
.border-moss-100\\/90{
  border-color: rgb(230 244 215 / 0.9);
}
.border-moss-100\\/95{
  border-color: rgb(230 244 215 / 0.95);
}
.border-moss-200{
  --tw-border-opacity: 1;
  border-color: rgb(206 234 176 / var(--tw-border-opacity, 1));
}
.border-moss-200\\/0{
  border-color: rgb(206 234 176 / 0);
}
.border-moss-200\\/10{
  border-color: rgb(206 234 176 / 0.1);
}
.border-moss-200\\/100{
  border-color: rgb(206 234 176 / 1);
}
.border-moss-200\\/15{
  border-color: rgb(206 234 176 / 0.15);
}
.border-moss-200\\/20{
  border-color: rgb(206 234 176 / 0.2);
}
.border-moss-200\\/25{
  border-color: rgb(206 234 176 / 0.25);
}
.border-moss-200\\/30{
  border-color: rgb(206 234 176 / 0.3);
}
.border-moss-200\\/35{
  border-color: rgb(206 234 176 / 0.35);
}
.border-moss-200\\/40{
  border-color: rgb(206 234 176 / 0.4);
}
.border-moss-200\\/45{
  border-color: rgb(206 234 176 / 0.45);
}
.border-moss-200\\/5{
  border-color: rgb(206 234 176 / 0.05);
}
.border-moss-200\\/50{
  border-color: rgb(206 234 176 / 0.5);
}
.border-moss-200\\/55{
  border-color: rgb(206 234 176 / 0.55);
}
.border-moss-200\\/60{
  border-color: rgb(206 234 176 / 0.6);
}
.border-moss-200\\/65{
  border-color: rgb(206 234 176 / 0.65);
}
.border-moss-200\\/70{
  border-color: rgb(206 234 176 / 0.7);
}
.border-moss-200\\/75{
  border-color: rgb(206 234 176 / 0.75);
}
.border-moss-200\\/80{
  border-color: rgb(206 234 176 / 0.8);
}
.border-moss-200\\/85{
  border-color: rgb(206 234 176 / 0.85);
}
.border-moss-200\\/90{
  border-color: rgb(206 234 176 / 0.9);
}
.border-moss-200\\/95{
  border-color: rgb(206 234 176 / 0.95);
}
.border-moss-25{
  --tw-border-opacity: 1;
  border-color: rgb(250 253 247 / var(--tw-border-opacity, 1));
}
.border-moss-25\\/0{
  border-color: rgb(250 253 247 / 0);
}
.border-moss-25\\/10{
  border-color: rgb(250 253 247 / 0.1);
}
.border-moss-25\\/100{
  border-color: rgb(250 253 247 / 1);
}
.border-moss-25\\/15{
  border-color: rgb(250 253 247 / 0.15);
}
.border-moss-25\\/20{
  border-color: rgb(250 253 247 / 0.2);
}
.border-moss-25\\/25{
  border-color: rgb(250 253 247 / 0.25);
}
.border-moss-25\\/30{
  border-color: rgb(250 253 247 / 0.3);
}
.border-moss-25\\/35{
  border-color: rgb(250 253 247 / 0.35);
}
.border-moss-25\\/40{
  border-color: rgb(250 253 247 / 0.4);
}
.border-moss-25\\/45{
  border-color: rgb(250 253 247 / 0.45);
}
.border-moss-25\\/5{
  border-color: rgb(250 253 247 / 0.05);
}
.border-moss-25\\/50{
  border-color: rgb(250 253 247 / 0.5);
}
.border-moss-25\\/55{
  border-color: rgb(250 253 247 / 0.55);
}
.border-moss-25\\/60{
  border-color: rgb(250 253 247 / 0.6);
}
.border-moss-25\\/65{
  border-color: rgb(250 253 247 / 0.65);
}
.border-moss-25\\/70{
  border-color: rgb(250 253 247 / 0.7);
}
.border-moss-25\\/75{
  border-color: rgb(250 253 247 / 0.75);
}
.border-moss-25\\/80{
  border-color: rgb(250 253 247 / 0.8);
}
.border-moss-25\\/85{
  border-color: rgb(250 253 247 / 0.85);
}
.border-moss-25\\/90{
  border-color: rgb(250 253 247 / 0.9);
}
.border-moss-25\\/95{
  border-color: rgb(250 253 247 / 0.95);
}
.border-moss-300{
  --tw-border-opacity: 1;
  border-color: rgb(172 220 121 / var(--tw-border-opacity, 1));
}
.border-moss-400{
  --tw-border-opacity: 1;
  border-color: rgb(134 203 60 / var(--tw-border-opacity, 1));
}
.border-moss-400\\/0{
  border-color: rgb(134 203 60 / 0);
}
.border-moss-400\\/10{
  border-color: rgb(134 203 60 / 0.1);
}
.border-moss-400\\/100{
  border-color: rgb(134 203 60 / 1);
}
.border-moss-400\\/15{
  border-color: rgb(134 203 60 / 0.15);
}
.border-moss-400\\/20{
  border-color: rgb(134 203 60 / 0.2);
}
.border-moss-400\\/25{
  border-color: rgb(134 203 60 / 0.25);
}
.border-moss-400\\/30{
  border-color: rgb(134 203 60 / 0.3);
}
.border-moss-400\\/35{
  border-color: rgb(134 203 60 / 0.35);
}
.border-moss-400\\/40{
  border-color: rgb(134 203 60 / 0.4);
}
.border-moss-400\\/45{
  border-color: rgb(134 203 60 / 0.45);
}
.border-moss-400\\/5{
  border-color: rgb(134 203 60 / 0.05);
}
.border-moss-400\\/50{
  border-color: rgb(134 203 60 / 0.5);
}
.border-moss-400\\/55{
  border-color: rgb(134 203 60 / 0.55);
}
.border-moss-400\\/60{
  border-color: rgb(134 203 60 / 0.6);
}
.border-moss-400\\/65{
  border-color: rgb(134 203 60 / 0.65);
}
.border-moss-400\\/70{
  border-color: rgb(134 203 60 / 0.7);
}
.border-moss-400\\/75{
  border-color: rgb(134 203 60 / 0.75);
}
.border-moss-400\\/80{
  border-color: rgb(134 203 60 / 0.8);
}
.border-moss-400\\/85{
  border-color: rgb(134 203 60 / 0.85);
}
.border-moss-400\\/90{
  border-color: rgb(134 203 60 / 0.9);
}
.border-moss-400\\/95{
  border-color: rgb(134 203 60 / 0.95);
}
.border-moss-50{
  --tw-border-opacity: 1;
  border-color: rgb(245 251 238 / var(--tw-border-opacity, 1));
}
.border-moss-50\\/0{
  border-color: rgb(245 251 238 / 0);
}
.border-moss-50\\/10{
  border-color: rgb(245 251 238 / 0.1);
}
.border-moss-50\\/100{
  border-color: rgb(245 251 238 / 1);
}
.border-moss-50\\/15{
  border-color: rgb(245 251 238 / 0.15);
}
.border-moss-50\\/20{
  border-color: rgb(245 251 238 / 0.2);
}
.border-moss-50\\/25{
  border-color: rgb(245 251 238 / 0.25);
}
.border-moss-50\\/30{
  border-color: rgb(245 251 238 / 0.3);
}
.border-moss-50\\/35{
  border-color: rgb(245 251 238 / 0.35);
}
.border-moss-50\\/40{
  border-color: rgb(245 251 238 / 0.4);
}
.border-moss-50\\/45{
  border-color: rgb(245 251 238 / 0.45);
}
.border-moss-50\\/5{
  border-color: rgb(245 251 238 / 0.05);
}
.border-moss-50\\/50{
  border-color: rgb(245 251 238 / 0.5);
}
.border-moss-50\\/55{
  border-color: rgb(245 251 238 / 0.55);
}
.border-moss-50\\/60{
  border-color: rgb(245 251 238 / 0.6);
}
.border-moss-50\\/65{
  border-color: rgb(245 251 238 / 0.65);
}
.border-moss-50\\/70{
  border-color: rgb(245 251 238 / 0.7);
}
.border-moss-50\\/75{
  border-color: rgb(245 251 238 / 0.75);
}
.border-moss-50\\/80{
  border-color: rgb(245 251 238 / 0.8);
}
.border-moss-50\\/85{
  border-color: rgb(245 251 238 / 0.85);
}
.border-moss-50\\/90{
  border-color: rgb(245 251 238 / 0.9);
}
.border-moss-50\\/95{
  border-color: rgb(245 251 238 / 0.95);
}
.border-moss-500{
  --tw-border-opacity: 1;
  border-color: rgb(102 159 42 / var(--tw-border-opacity, 1));
}
.border-moss-500\\/0{
  border-color: rgb(102 159 42 / 0);
}
.border-moss-500\\/10{
  border-color: rgb(102 159 42 / 0.1);
}
.border-moss-500\\/100{
  border-color: rgb(102 159 42 / 1);
}
.border-moss-500\\/15{
  border-color: rgb(102 159 42 / 0.15);
}
.border-moss-500\\/20{
  border-color: rgb(102 159 42 / 0.2);
}
.border-moss-500\\/25{
  border-color: rgb(102 159 42 / 0.25);
}
.border-moss-500\\/30{
  border-color: rgb(102 159 42 / 0.3);
}
.border-moss-500\\/35{
  border-color: rgb(102 159 42 / 0.35);
}
.border-moss-500\\/40{
  border-color: rgb(102 159 42 / 0.4);
}
.border-moss-500\\/45{
  border-color: rgb(102 159 42 / 0.45);
}
.border-moss-500\\/5{
  border-color: rgb(102 159 42 / 0.05);
}
.border-moss-500\\/50{
  border-color: rgb(102 159 42 / 0.5);
}
.border-moss-500\\/55{
  border-color: rgb(102 159 42 / 0.55);
}
.border-moss-500\\/60{
  border-color: rgb(102 159 42 / 0.6);
}
.border-moss-500\\/65{
  border-color: rgb(102 159 42 / 0.65);
}
.border-moss-500\\/70{
  border-color: rgb(102 159 42 / 0.7);
}
.border-moss-500\\/75{
  border-color: rgb(102 159 42 / 0.75);
}
.border-moss-500\\/80{
  border-color: rgb(102 159 42 / 0.8);
}
.border-moss-500\\/85{
  border-color: rgb(102 159 42 / 0.85);
}
.border-moss-500\\/90{
  border-color: rgb(102 159 42 / 0.9);
}
.border-moss-500\\/95{
  border-color: rgb(102 159 42 / 0.95);
}
.border-moss-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 122 33 / var(--tw-border-opacity, 1));
}
.border-moss-600\\/0{
  border-color: rgb(79 122 33 / 0);
}
.border-moss-600\\/10{
  border-color: rgb(79 122 33 / 0.1);
}
.border-moss-600\\/100{
  border-color: rgb(79 122 33 / 1);
}
.border-moss-600\\/15{
  border-color: rgb(79 122 33 / 0.15);
}
.border-moss-600\\/20{
  border-color: rgb(79 122 33 / 0.2);
}
.border-moss-600\\/25{
  border-color: rgb(79 122 33 / 0.25);
}
.border-moss-600\\/30{
  border-color: rgb(79 122 33 / 0.3);
}
.border-moss-600\\/35{
  border-color: rgb(79 122 33 / 0.35);
}
.border-moss-600\\/40{
  border-color: rgb(79 122 33 / 0.4);
}
.border-moss-600\\/45{
  border-color: rgb(79 122 33 / 0.45);
}
.border-moss-600\\/5{
  border-color: rgb(79 122 33 / 0.05);
}
.border-moss-600\\/50{
  border-color: rgb(79 122 33 / 0.5);
}
.border-moss-600\\/55{
  border-color: rgb(79 122 33 / 0.55);
}
.border-moss-600\\/60{
  border-color: rgb(79 122 33 / 0.6);
}
.border-moss-600\\/65{
  border-color: rgb(79 122 33 / 0.65);
}
.border-moss-600\\/70{
  border-color: rgb(79 122 33 / 0.7);
}
.border-moss-600\\/75{
  border-color: rgb(79 122 33 / 0.75);
}
.border-moss-600\\/80{
  border-color: rgb(79 122 33 / 0.8);
}
.border-moss-600\\/85{
  border-color: rgb(79 122 33 / 0.85);
}
.border-moss-600\\/90{
  border-color: rgb(79 122 33 / 0.9);
}
.border-moss-600\\/95{
  border-color: rgb(79 122 33 / 0.95);
}
.border-moss-700{
  --tw-border-opacity: 1;
  border-color: rgb(63 98 26 / var(--tw-border-opacity, 1));
}
.border-moss-700\\/0{
  border-color: rgb(63 98 26 / 0);
}
.border-moss-700\\/10{
  border-color: rgb(63 98 26 / 0.1);
}
.border-moss-700\\/100{
  border-color: rgb(63 98 26 / 1);
}
.border-moss-700\\/15{
  border-color: rgb(63 98 26 / 0.15);
}
.border-moss-700\\/20{
  border-color: rgb(63 98 26 / 0.2);
}
.border-moss-700\\/25{
  border-color: rgb(63 98 26 / 0.25);
}
.border-moss-700\\/30{
  border-color: rgb(63 98 26 / 0.3);
}
.border-moss-700\\/35{
  border-color: rgb(63 98 26 / 0.35);
}
.border-moss-700\\/40{
  border-color: rgb(63 98 26 / 0.4);
}
.border-moss-700\\/45{
  border-color: rgb(63 98 26 / 0.45);
}
.border-moss-700\\/5{
  border-color: rgb(63 98 26 / 0.05);
}
.border-moss-700\\/50{
  border-color: rgb(63 98 26 / 0.5);
}
.border-moss-700\\/55{
  border-color: rgb(63 98 26 / 0.55);
}
.border-moss-700\\/60{
  border-color: rgb(63 98 26 / 0.6);
}
.border-moss-700\\/65{
  border-color: rgb(63 98 26 / 0.65);
}
.border-moss-700\\/70{
  border-color: rgb(63 98 26 / 0.7);
}
.border-moss-700\\/75{
  border-color: rgb(63 98 26 / 0.75);
}
.border-moss-700\\/80{
  border-color: rgb(63 98 26 / 0.8);
}
.border-moss-700\\/85{
  border-color: rgb(63 98 26 / 0.85);
}
.border-moss-700\\/90{
  border-color: rgb(63 98 26 / 0.9);
}
.border-moss-700\\/95{
  border-color: rgb(63 98 26 / 0.95);
}
.border-neutral-100{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-neutral-100\\/0{
  border-color: rgb(245 245 245 / 0);
}
.border-neutral-100\\/10{
  border-color: rgb(245 245 245 / 0.1);
}
.border-neutral-100\\/100{
  border-color: rgb(245 245 245 / 1);
}
.border-neutral-100\\/15{
  border-color: rgb(245 245 245 / 0.15);
}
.border-neutral-100\\/20{
  border-color: rgb(245 245 245 / 0.2);
}
.border-neutral-100\\/25{
  border-color: rgb(245 245 245 / 0.25);
}
.border-neutral-100\\/30{
  border-color: rgb(245 245 245 / 0.3);
}
.border-neutral-100\\/35{
  border-color: rgb(245 245 245 / 0.35);
}
.border-neutral-100\\/40{
  border-color: rgb(245 245 245 / 0.4);
}
.border-neutral-100\\/45{
  border-color: rgb(245 245 245 / 0.45);
}
.border-neutral-100\\/5{
  border-color: rgb(245 245 245 / 0.05);
}
.border-neutral-100\\/50{
  border-color: rgb(245 245 245 / 0.5);
}
.border-neutral-100\\/55{
  border-color: rgb(245 245 245 / 0.55);
}
.border-neutral-100\\/60{
  border-color: rgb(245 245 245 / 0.6);
}
.border-neutral-100\\/65{
  border-color: rgb(245 245 245 / 0.65);
}
.border-neutral-100\\/70{
  border-color: rgb(245 245 245 / 0.7);
}
.border-neutral-100\\/75{
  border-color: rgb(245 245 245 / 0.75);
}
.border-neutral-100\\/80{
  border-color: rgb(245 245 245 / 0.8);
}
.border-neutral-100\\/85{
  border-color: rgb(245 245 245 / 0.85);
}
.border-neutral-100\\/90{
  border-color: rgb(245 245 245 / 0.9);
}
.border-neutral-100\\/95{
  border-color: rgb(245 245 245 / 0.95);
}
.border-neutral-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-neutral-200\\/0{
  border-color: rgb(233 234 235 / 0);
}
.border-neutral-200\\/10{
  border-color: rgb(233 234 235 / 0.1);
}
.border-neutral-200\\/100{
  border-color: rgb(233 234 235 / 1);
}
.border-neutral-200\\/15{
  border-color: rgb(233 234 235 / 0.15);
}
.border-neutral-200\\/20{
  border-color: rgb(233 234 235 / 0.2);
}
.border-neutral-200\\/25{
  border-color: rgb(233 234 235 / 0.25);
}
.border-neutral-200\\/30{
  border-color: rgb(233 234 235 / 0.3);
}
.border-neutral-200\\/35{
  border-color: rgb(233 234 235 / 0.35);
}
.border-neutral-200\\/40{
  border-color: rgb(233 234 235 / 0.4);
}
.border-neutral-200\\/45{
  border-color: rgb(233 234 235 / 0.45);
}
.border-neutral-200\\/5{
  border-color: rgb(233 234 235 / 0.05);
}
.border-neutral-200\\/50{
  border-color: rgb(233 234 235 / 0.5);
}
.border-neutral-200\\/55{
  border-color: rgb(233 234 235 / 0.55);
}
.border-neutral-200\\/60{
  border-color: rgb(233 234 235 / 0.6);
}
.border-neutral-200\\/65{
  border-color: rgb(233 234 235 / 0.65);
}
.border-neutral-200\\/70{
  border-color: rgb(233 234 235 / 0.7);
}
.border-neutral-200\\/75{
  border-color: rgb(233 234 235 / 0.75);
}
.border-neutral-200\\/80{
  border-color: rgb(233 234 235 / 0.8);
}
.border-neutral-200\\/85{
  border-color: rgb(233 234 235 / 0.85);
}
.border-neutral-200\\/90{
  border-color: rgb(233 234 235 / 0.9);
}
.border-neutral-200\\/95{
  border-color: rgb(233 234 235 / 0.95);
}
.border-neutral-25{
  --tw-border-opacity: 1;
  border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
}
.border-neutral-25\\/0{
  border-color: rgb(253 253 253 / 0);
}
.border-neutral-25\\/10{
  border-color: rgb(253 253 253 / 0.1);
}
.border-neutral-25\\/100{
  border-color: rgb(253 253 253 / 1);
}
.border-neutral-25\\/15{
  border-color: rgb(253 253 253 / 0.15);
}
.border-neutral-25\\/20{
  border-color: rgb(253 253 253 / 0.2);
}
.border-neutral-25\\/25{
  border-color: rgb(253 253 253 / 0.25);
}
.border-neutral-25\\/30{
  border-color: rgb(253 253 253 / 0.3);
}
.border-neutral-25\\/35{
  border-color: rgb(253 253 253 / 0.35);
}
.border-neutral-25\\/40{
  border-color: rgb(253 253 253 / 0.4);
}
.border-neutral-25\\/45{
  border-color: rgb(253 253 253 / 0.45);
}
.border-neutral-25\\/5{
  border-color: rgb(253 253 253 / 0.05);
}
.border-neutral-25\\/50{
  border-color: rgb(253 253 253 / 0.5);
}
.border-neutral-25\\/55{
  border-color: rgb(253 253 253 / 0.55);
}
.border-neutral-25\\/60{
  border-color: rgb(253 253 253 / 0.6);
}
.border-neutral-25\\/65{
  border-color: rgb(253 253 253 / 0.65);
}
.border-neutral-25\\/70{
  border-color: rgb(253 253 253 / 0.7);
}
.border-neutral-25\\/75{
  border-color: rgb(253 253 253 / 0.75);
}
.border-neutral-25\\/80{
  border-color: rgb(253 253 253 / 0.8);
}
.border-neutral-25\\/85{
  border-color: rgb(253 253 253 / 0.85);
}
.border-neutral-25\\/90{
  border-color: rgb(253 253 253 / 0.9);
}
.border-neutral-25\\/95{
  border-color: rgb(253 253 253 / 0.95);
}
.border-neutral-300{
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.border-neutral-400{
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}
.border-neutral-400\\/0{
  border-color: rgb(164 167 174 / 0);
}
.border-neutral-400\\/10{
  border-color: rgb(164 167 174 / 0.1);
}
.border-neutral-400\\/100{
  border-color: rgb(164 167 174 / 1);
}
.border-neutral-400\\/15{
  border-color: rgb(164 167 174 / 0.15);
}
.border-neutral-400\\/20{
  border-color: rgb(164 167 174 / 0.2);
}
.border-neutral-400\\/25{
  border-color: rgb(164 167 174 / 0.25);
}
.border-neutral-400\\/30{
  border-color: rgb(164 167 174 / 0.3);
}
.border-neutral-400\\/35{
  border-color: rgb(164 167 174 / 0.35);
}
.border-neutral-400\\/40{
  border-color: rgb(164 167 174 / 0.4);
}
.border-neutral-400\\/45{
  border-color: rgb(164 167 174 / 0.45);
}
.border-neutral-400\\/5{
  border-color: rgb(164 167 174 / 0.05);
}
.border-neutral-400\\/50{
  border-color: rgb(164 167 174 / 0.5);
}
.border-neutral-400\\/55{
  border-color: rgb(164 167 174 / 0.55);
}
.border-neutral-400\\/60{
  border-color: rgb(164 167 174 / 0.6);
}
.border-neutral-400\\/65{
  border-color: rgb(164 167 174 / 0.65);
}
.border-neutral-400\\/70{
  border-color: rgb(164 167 174 / 0.7);
}
.border-neutral-400\\/75{
  border-color: rgb(164 167 174 / 0.75);
}
.border-neutral-400\\/80{
  border-color: rgb(164 167 174 / 0.8);
}
.border-neutral-400\\/85{
  border-color: rgb(164 167 174 / 0.85);
}
.border-neutral-400\\/90{
  border-color: rgb(164 167 174 / 0.9);
}
.border-neutral-400\\/95{
  border-color: rgb(164 167 174 / 0.95);
}
.border-neutral-50{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 250 / var(--tw-border-opacity, 1));
}
.border-neutral-50\\/0{
  border-color: rgb(249 250 250 / 0);
}
.border-neutral-50\\/10{
  border-color: rgb(249 250 250 / 0.1);
}
.border-neutral-50\\/100{
  border-color: rgb(249 250 250 / 1);
}
.border-neutral-50\\/15{
  border-color: rgb(249 250 250 / 0.15);
}
.border-neutral-50\\/20{
  border-color: rgb(249 250 250 / 0.2);
}
.border-neutral-50\\/25{
  border-color: rgb(249 250 250 / 0.25);
}
.border-neutral-50\\/30{
  border-color: rgb(249 250 250 / 0.3);
}
.border-neutral-50\\/35{
  border-color: rgb(249 250 250 / 0.35);
}
.border-neutral-50\\/40{
  border-color: rgb(249 250 250 / 0.4);
}
.border-neutral-50\\/45{
  border-color: rgb(249 250 250 / 0.45);
}
.border-neutral-50\\/5{
  border-color: rgb(249 250 250 / 0.05);
}
.border-neutral-50\\/50{
  border-color: rgb(249 250 250 / 0.5);
}
.border-neutral-50\\/55{
  border-color: rgb(249 250 250 / 0.55);
}
.border-neutral-50\\/60{
  border-color: rgb(249 250 250 / 0.6);
}
.border-neutral-50\\/65{
  border-color: rgb(249 250 250 / 0.65);
}
.border-neutral-50\\/70{
  border-color: rgb(249 250 250 / 0.7);
}
.border-neutral-50\\/75{
  border-color: rgb(249 250 250 / 0.75);
}
.border-neutral-50\\/80{
  border-color: rgb(249 250 250 / 0.8);
}
.border-neutral-50\\/85{
  border-color: rgb(249 250 250 / 0.85);
}
.border-neutral-50\\/90{
  border-color: rgb(249 250 250 / 0.9);
}
.border-neutral-50\\/95{
  border-color: rgb(249 250 250 / 0.95);
}
.border-neutral-500{
  --tw-border-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1));
}
.border-neutral-500\\/0{
  border-color: rgb(113 118 128 / 0);
}
.border-neutral-500\\/10{
  border-color: rgb(113 118 128 / 0.1);
}
.border-neutral-500\\/100{
  border-color: rgb(113 118 128 / 1);
}
.border-neutral-500\\/15{
  border-color: rgb(113 118 128 / 0.15);
}
.border-neutral-500\\/20{
  border-color: rgb(113 118 128 / 0.2);
}
.border-neutral-500\\/25{
  border-color: rgb(113 118 128 / 0.25);
}
.border-neutral-500\\/30{
  border-color: rgb(113 118 128 / 0.3);
}
.border-neutral-500\\/35{
  border-color: rgb(113 118 128 / 0.35);
}
.border-neutral-500\\/40{
  border-color: rgb(113 118 128 / 0.4);
}
.border-neutral-500\\/45{
  border-color: rgb(113 118 128 / 0.45);
}
.border-neutral-500\\/5{
  border-color: rgb(113 118 128 / 0.05);
}
.border-neutral-500\\/50{
  border-color: rgb(113 118 128 / 0.5);
}
.border-neutral-500\\/55{
  border-color: rgb(113 118 128 / 0.55);
}
.border-neutral-500\\/60{
  border-color: rgb(113 118 128 / 0.6);
}
.border-neutral-500\\/65{
  border-color: rgb(113 118 128 / 0.65);
}
.border-neutral-500\\/70{
  border-color: rgb(113 118 128 / 0.7);
}
.border-neutral-500\\/75{
  border-color: rgb(113 118 128 / 0.75);
}
.border-neutral-500\\/80{
  border-color: rgb(113 118 128 / 0.8);
}
.border-neutral-500\\/85{
  border-color: rgb(113 118 128 / 0.85);
}
.border-neutral-500\\/90{
  border-color: rgb(113 118 128 / 0.9);
}
.border-neutral-500\\/95{
  border-color: rgb(113 118 128 / 0.95);
}
.border-neutral-600{
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}
.border-neutral-600\\/0{
  border-color: rgb(83 88 98 / 0);
}
.border-neutral-600\\/10{
  border-color: rgb(83 88 98 / 0.1);
}
.border-neutral-600\\/100{
  border-color: rgb(83 88 98 / 1);
}
.border-neutral-600\\/15{
  border-color: rgb(83 88 98 / 0.15);
}
.border-neutral-600\\/20{
  border-color: rgb(83 88 98 / 0.2);
}
.border-neutral-600\\/25{
  border-color: rgb(83 88 98 / 0.25);
}
.border-neutral-600\\/30{
  border-color: rgb(83 88 98 / 0.3);
}
.border-neutral-600\\/35{
  border-color: rgb(83 88 98 / 0.35);
}
.border-neutral-600\\/40{
  border-color: rgb(83 88 98 / 0.4);
}
.border-neutral-600\\/45{
  border-color: rgb(83 88 98 / 0.45);
}
.border-neutral-600\\/5{
  border-color: rgb(83 88 98 / 0.05);
}
.border-neutral-600\\/50{
  border-color: rgb(83 88 98 / 0.5);
}
.border-neutral-600\\/55{
  border-color: rgb(83 88 98 / 0.55);
}
.border-neutral-600\\/60{
  border-color: rgb(83 88 98 / 0.6);
}
.border-neutral-600\\/65{
  border-color: rgb(83 88 98 / 0.65);
}
.border-neutral-600\\/70{
  border-color: rgb(83 88 98 / 0.7);
}
.border-neutral-600\\/75{
  border-color: rgb(83 88 98 / 0.75);
}
.border-neutral-600\\/80{
  border-color: rgb(83 88 98 / 0.8);
}
.border-neutral-600\\/85{
  border-color: rgb(83 88 98 / 0.85);
}
.border-neutral-600\\/90{
  border-color: rgb(83 88 98 / 0.9);
}
.border-neutral-600\\/95{
  border-color: rgb(83 88 98 / 0.95);
}
.border-neutral-700{
  --tw-border-opacity: 1;
  border-color: rgb(65 70 81 / var(--tw-border-opacity, 1));
}
.border-neutral-700\\/0{
  border-color: rgb(65 70 81 / 0);
}
.border-neutral-700\\/10{
  border-color: rgb(65 70 81 / 0.1);
}
.border-neutral-700\\/100{
  border-color: rgb(65 70 81 / 1);
}
.border-neutral-700\\/15{
  border-color: rgb(65 70 81 / 0.15);
}
.border-neutral-700\\/20{
  border-color: rgb(65 70 81 / 0.2);
}
.border-neutral-700\\/25{
  border-color: rgb(65 70 81 / 0.25);
}
.border-neutral-700\\/30{
  border-color: rgb(65 70 81 / 0.3);
}
.border-neutral-700\\/35{
  border-color: rgb(65 70 81 / 0.35);
}
.border-neutral-700\\/40{
  border-color: rgb(65 70 81 / 0.4);
}
.border-neutral-700\\/45{
  border-color: rgb(65 70 81 / 0.45);
}
.border-neutral-700\\/5{
  border-color: rgb(65 70 81 / 0.05);
}
.border-neutral-700\\/50{
  border-color: rgb(65 70 81 / 0.5);
}
.border-neutral-700\\/55{
  border-color: rgb(65 70 81 / 0.55);
}
.border-neutral-700\\/60{
  border-color: rgb(65 70 81 / 0.6);
}
.border-neutral-700\\/65{
  border-color: rgb(65 70 81 / 0.65);
}
.border-neutral-700\\/70{
  border-color: rgb(65 70 81 / 0.7);
}
.border-neutral-700\\/75{
  border-color: rgb(65 70 81 / 0.75);
}
.border-neutral-700\\/80{
  border-color: rgb(65 70 81 / 0.8);
}
.border-neutral-700\\/85{
  border-color: rgb(65 70 81 / 0.85);
}
.border-neutral-700\\/90{
  border-color: rgb(65 70 81 / 0.9);
}
.border-neutral-700\\/95{
  border-color: rgb(65 70 81 / 0.95);
}
.border-neutral-75{
  --tw-border-opacity: 1;
  border-color: rgb(246 246 246 / var(--tw-border-opacity, 1));
}
.border-neutral-75\\/0{
  border-color: rgb(246 246 246 / 0);
}
.border-neutral-75\\/10{
  border-color: rgb(246 246 246 / 0.1);
}
.border-neutral-75\\/100{
  border-color: rgb(246 246 246 / 1);
}
.border-neutral-75\\/15{
  border-color: rgb(246 246 246 / 0.15);
}
.border-neutral-75\\/20{
  border-color: rgb(246 246 246 / 0.2);
}
.border-neutral-75\\/25{
  border-color: rgb(246 246 246 / 0.25);
}
.border-neutral-75\\/30{
  border-color: rgb(246 246 246 / 0.3);
}
.border-neutral-75\\/35{
  border-color: rgb(246 246 246 / 0.35);
}
.border-neutral-75\\/40{
  border-color: rgb(246 246 246 / 0.4);
}
.border-neutral-75\\/45{
  border-color: rgb(246 246 246 / 0.45);
}
.border-neutral-75\\/5{
  border-color: rgb(246 246 246 / 0.05);
}
.border-neutral-75\\/50{
  border-color: rgb(246 246 246 / 0.5);
}
.border-neutral-75\\/55{
  border-color: rgb(246 246 246 / 0.55);
}
.border-neutral-75\\/60{
  border-color: rgb(246 246 246 / 0.6);
}
.border-neutral-75\\/65{
  border-color: rgb(246 246 246 / 0.65);
}
.border-neutral-75\\/70{
  border-color: rgb(246 246 246 / 0.7);
}
.border-neutral-75\\/75{
  border-color: rgb(246 246 246 / 0.75);
}
.border-neutral-75\\/80{
  border-color: rgb(246 246 246 / 0.8);
}
.border-neutral-75\\/85{
  border-color: rgb(246 246 246 / 0.85);
}
.border-neutral-75\\/90{
  border-color: rgb(246 246 246 / 0.9);
}
.border-neutral-75\\/95{
  border-color: rgb(246 246 246 / 0.95);
}
.border-neutral-900{
  --tw-border-opacity: 1;
  border-color: rgb(24 29 39 / var(--tw-border-opacity, 1));
}
.border-neutral-dark-600{
  --tw-border-opacity: 1;
  border-color: rgb(97 101 108 / var(--tw-border-opacity, 1));
}
.border-neutral-dark-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 58 65 / var(--tw-border-opacity, 1));
}
.border-orange-dark-200{
  --tw-border-opacity: 1;
  border-color: rgb(255 214 174 / var(--tw-border-opacity, 1));
}
.border-orange-dark-300{
  --tw-border-opacity: 1;
  border-color: rgb(255 156 102 / var(--tw-border-opacity, 1));
}
.border-primary-100{
  border-color: var(--color-primary-100, #E0F2FE);
}
.border-primary-200{
  border-color: var(--color-primary-200, #B9E6FE);
}
.border-primary-25{
  border-color: var(--color-primary-25, #F5FBFF);
}
.border-primary-300{
  border-color: var(--color-primary-300, #7CD4FD);
}
.border-primary-400{
  border-color: var(--color-primary-400, #36BFFA);
}
.border-primary-50{
  border-color: var(--color-primary-50, #F0F9FF);
}
.border-primary-500{
  border-color: var(--color-primary-500, #0BA5EC);
}
.border-primary-600{
  border-color: var(--color-primary-600, #0086C9);
}
.border-primary-700{
  border-color: var(--color-primary-700, #026AA2);
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(235 233 254 / var(--tw-border-opacity, 1));
}
.border-purple-100\\/0{
  border-color: rgb(235 233 254 / 0);
}
.border-purple-100\\/10{
  border-color: rgb(235 233 254 / 0.1);
}
.border-purple-100\\/100{
  border-color: rgb(235 233 254 / 1);
}
.border-purple-100\\/15{
  border-color: rgb(235 233 254 / 0.15);
}
.border-purple-100\\/20{
  border-color: rgb(235 233 254 / 0.2);
}
.border-purple-100\\/25{
  border-color: rgb(235 233 254 / 0.25);
}
.border-purple-100\\/30{
  border-color: rgb(235 233 254 / 0.3);
}
.border-purple-100\\/35{
  border-color: rgb(235 233 254 / 0.35);
}
.border-purple-100\\/40{
  border-color: rgb(235 233 254 / 0.4);
}
.border-purple-100\\/45{
  border-color: rgb(235 233 254 / 0.45);
}
.border-purple-100\\/5{
  border-color: rgb(235 233 254 / 0.05);
}
.border-purple-100\\/50{
  border-color: rgb(235 233 254 / 0.5);
}
.border-purple-100\\/55{
  border-color: rgb(235 233 254 / 0.55);
}
.border-purple-100\\/60{
  border-color: rgb(235 233 254 / 0.6);
}
.border-purple-100\\/65{
  border-color: rgb(235 233 254 / 0.65);
}
.border-purple-100\\/70{
  border-color: rgb(235 233 254 / 0.7);
}
.border-purple-100\\/75{
  border-color: rgb(235 233 254 / 0.75);
}
.border-purple-100\\/80{
  border-color: rgb(235 233 254 / 0.8);
}
.border-purple-100\\/85{
  border-color: rgb(235 233 254 / 0.85);
}
.border-purple-100\\/90{
  border-color: rgb(235 233 254 / 0.9);
}
.border-purple-100\\/95{
  border-color: rgb(235 233 254 / 0.95);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(217 214 254 / var(--tw-border-opacity, 1));
}
.border-purple-200\\/0{
  border-color: rgb(217 214 254 / 0);
}
.border-purple-200\\/10{
  border-color: rgb(217 214 254 / 0.1);
}
.border-purple-200\\/100{
  border-color: rgb(217 214 254 / 1);
}
.border-purple-200\\/15{
  border-color: rgb(217 214 254 / 0.15);
}
.border-purple-200\\/20{
  border-color: rgb(217 214 254 / 0.2);
}
.border-purple-200\\/25{
  border-color: rgb(217 214 254 / 0.25);
}
.border-purple-200\\/30{
  border-color: rgb(217 214 254 / 0.3);
}
.border-purple-200\\/35{
  border-color: rgb(217 214 254 / 0.35);
}
.border-purple-200\\/40{
  border-color: rgb(217 214 254 / 0.4);
}
.border-purple-200\\/45{
  border-color: rgb(217 214 254 / 0.45);
}
.border-purple-200\\/5{
  border-color: rgb(217 214 254 / 0.05);
}
.border-purple-200\\/50{
  border-color: rgb(217 214 254 / 0.5);
}
.border-purple-200\\/55{
  border-color: rgb(217 214 254 / 0.55);
}
.border-purple-200\\/60{
  border-color: rgb(217 214 254 / 0.6);
}
.border-purple-200\\/65{
  border-color: rgb(217 214 254 / 0.65);
}
.border-purple-200\\/70{
  border-color: rgb(217 214 254 / 0.7);
}
.border-purple-200\\/75{
  border-color: rgb(217 214 254 / 0.75);
}
.border-purple-200\\/80{
  border-color: rgb(217 214 254 / 0.8);
}
.border-purple-200\\/85{
  border-color: rgb(217 214 254 / 0.85);
}
.border-purple-200\\/90{
  border-color: rgb(217 214 254 / 0.9);
}
.border-purple-200\\/95{
  border-color: rgb(217 214 254 / 0.95);
}
.border-purple-25{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 255 / var(--tw-border-opacity, 1));
}
.border-purple-25\\/0{
  border-color: rgb(250 250 255 / 0);
}
.border-purple-25\\/10{
  border-color: rgb(250 250 255 / 0.1);
}
.border-purple-25\\/100{
  border-color: rgb(250 250 255 / 1);
}
.border-purple-25\\/15{
  border-color: rgb(250 250 255 / 0.15);
}
.border-purple-25\\/20{
  border-color: rgb(250 250 255 / 0.2);
}
.border-purple-25\\/25{
  border-color: rgb(250 250 255 / 0.25);
}
.border-purple-25\\/30{
  border-color: rgb(250 250 255 / 0.3);
}
.border-purple-25\\/35{
  border-color: rgb(250 250 255 / 0.35);
}
.border-purple-25\\/40{
  border-color: rgb(250 250 255 / 0.4);
}
.border-purple-25\\/45{
  border-color: rgb(250 250 255 / 0.45);
}
.border-purple-25\\/5{
  border-color: rgb(250 250 255 / 0.05);
}
.border-purple-25\\/50{
  border-color: rgb(250 250 255 / 0.5);
}
.border-purple-25\\/55{
  border-color: rgb(250 250 255 / 0.55);
}
.border-purple-25\\/60{
  border-color: rgb(250 250 255 / 0.6);
}
.border-purple-25\\/65{
  border-color: rgb(250 250 255 / 0.65);
}
.border-purple-25\\/70{
  border-color: rgb(250 250 255 / 0.7);
}
.border-purple-25\\/75{
  border-color: rgb(250 250 255 / 0.75);
}
.border-purple-25\\/80{
  border-color: rgb(250 250 255 / 0.8);
}
.border-purple-25\\/85{
  border-color: rgb(250 250 255 / 0.85);
}
.border-purple-25\\/90{
  border-color: rgb(250 250 255 / 0.9);
}
.border-purple-25\\/95{
  border-color: rgb(250 250 255 / 0.95);
}
.border-purple-400{
  --tw-border-opacity: 1;
  border-color: rgb(155 138 251 / var(--tw-border-opacity, 1));
}
.border-purple-400\\/0{
  border-color: rgb(155 138 251 / 0);
}
.border-purple-400\\/10{
  border-color: rgb(155 138 251 / 0.1);
}
.border-purple-400\\/100{
  border-color: rgb(155 138 251 / 1);
}
.border-purple-400\\/15{
  border-color: rgb(155 138 251 / 0.15);
}
.border-purple-400\\/20{
  border-color: rgb(155 138 251 / 0.2);
}
.border-purple-400\\/25{
  border-color: rgb(155 138 251 / 0.25);
}
.border-purple-400\\/30{
  border-color: rgb(155 138 251 / 0.3);
}
.border-purple-400\\/35{
  border-color: rgb(155 138 251 / 0.35);
}
.border-purple-400\\/40{
  border-color: rgb(155 138 251 / 0.4);
}
.border-purple-400\\/45{
  border-color: rgb(155 138 251 / 0.45);
}
.border-purple-400\\/5{
  border-color: rgb(155 138 251 / 0.05);
}
.border-purple-400\\/50{
  border-color: rgb(155 138 251 / 0.5);
}
.border-purple-400\\/55{
  border-color: rgb(155 138 251 / 0.55);
}
.border-purple-400\\/60{
  border-color: rgb(155 138 251 / 0.6);
}
.border-purple-400\\/65{
  border-color: rgb(155 138 251 / 0.65);
}
.border-purple-400\\/70{
  border-color: rgb(155 138 251 / 0.7);
}
.border-purple-400\\/75{
  border-color: rgb(155 138 251 / 0.75);
}
.border-purple-400\\/80{
  border-color: rgb(155 138 251 / 0.8);
}
.border-purple-400\\/85{
  border-color: rgb(155 138 251 / 0.85);
}
.border-purple-400\\/90{
  border-color: rgb(155 138 251 / 0.9);
}
.border-purple-400\\/95{
  border-color: rgb(155 138 251 / 0.95);
}
.border-purple-50{
  --tw-border-opacity: 1;
  border-color: rgb(244 243 255 / var(--tw-border-opacity, 1));
}
.border-purple-50\\/0{
  border-color: rgb(244 243 255 / 0);
}
.border-purple-50\\/10{
  border-color: rgb(244 243 255 / 0.1);
}
.border-purple-50\\/100{
  border-color: rgb(244 243 255 / 1);
}
.border-purple-50\\/15{
  border-color: rgb(244 243 255 / 0.15);
}
.border-purple-50\\/20{
  border-color: rgb(244 243 255 / 0.2);
}
.border-purple-50\\/25{
  border-color: rgb(244 243 255 / 0.25);
}
.border-purple-50\\/30{
  border-color: rgb(244 243 255 / 0.3);
}
.border-purple-50\\/35{
  border-color: rgb(244 243 255 / 0.35);
}
.border-purple-50\\/40{
  border-color: rgb(244 243 255 / 0.4);
}
.border-purple-50\\/45{
  border-color: rgb(244 243 255 / 0.45);
}
.border-purple-50\\/5{
  border-color: rgb(244 243 255 / 0.05);
}
.border-purple-50\\/50{
  border-color: rgb(244 243 255 / 0.5);
}
.border-purple-50\\/55{
  border-color: rgb(244 243 255 / 0.55);
}
.border-purple-50\\/60{
  border-color: rgb(244 243 255 / 0.6);
}
.border-purple-50\\/65{
  border-color: rgb(244 243 255 / 0.65);
}
.border-purple-50\\/70{
  border-color: rgb(244 243 255 / 0.7);
}
.border-purple-50\\/75{
  border-color: rgb(244 243 255 / 0.75);
}
.border-purple-50\\/80{
  border-color: rgb(244 243 255 / 0.8);
}
.border-purple-50\\/85{
  border-color: rgb(244 243 255 / 0.85);
}
.border-purple-50\\/90{
  border-color: rgb(244 243 255 / 0.9);
}
.border-purple-50\\/95{
  border-color: rgb(244 243 255 / 0.95);
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(122 90 248 / var(--tw-border-opacity, 1));
}
.border-purple-500\\/0{
  border-color: rgb(122 90 248 / 0);
}
.border-purple-500\\/10{
  border-color: rgb(122 90 248 / 0.1);
}
.border-purple-500\\/100{
  border-color: rgb(122 90 248 / 1);
}
.border-purple-500\\/15{
  border-color: rgb(122 90 248 / 0.15);
}
.border-purple-500\\/20{
  border-color: rgb(122 90 248 / 0.2);
}
.border-purple-500\\/25{
  border-color: rgb(122 90 248 / 0.25);
}
.border-purple-500\\/30{
  border-color: rgb(122 90 248 / 0.3);
}
.border-purple-500\\/35{
  border-color: rgb(122 90 248 / 0.35);
}
.border-purple-500\\/40{
  border-color: rgb(122 90 248 / 0.4);
}
.border-purple-500\\/45{
  border-color: rgb(122 90 248 / 0.45);
}
.border-purple-500\\/5{
  border-color: rgb(122 90 248 / 0.05);
}
.border-purple-500\\/50{
  border-color: rgb(122 90 248 / 0.5);
}
.border-purple-500\\/55{
  border-color: rgb(122 90 248 / 0.55);
}
.border-purple-500\\/60{
  border-color: rgb(122 90 248 / 0.6);
}
.border-purple-500\\/65{
  border-color: rgb(122 90 248 / 0.65);
}
.border-purple-500\\/70{
  border-color: rgb(122 90 248 / 0.7);
}
.border-purple-500\\/75{
  border-color: rgb(122 90 248 / 0.75);
}
.border-purple-500\\/80{
  border-color: rgb(122 90 248 / 0.8);
}
.border-purple-500\\/85{
  border-color: rgb(122 90 248 / 0.85);
}
.border-purple-500\\/90{
  border-color: rgb(122 90 248 / 0.9);
}
.border-purple-500\\/95{
  border-color: rgb(122 90 248 / 0.95);
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(105 56 239 / var(--tw-border-opacity, 1));
}
.border-purple-600\\/0{
  border-color: rgb(105 56 239 / 0);
}
.border-purple-600\\/10{
  border-color: rgb(105 56 239 / 0.1);
}
.border-purple-600\\/100{
  border-color: rgb(105 56 239 / 1);
}
.border-purple-600\\/15{
  border-color: rgb(105 56 239 / 0.15);
}
.border-purple-600\\/20{
  border-color: rgb(105 56 239 / 0.2);
}
.border-purple-600\\/25{
  border-color: rgb(105 56 239 / 0.25);
}
.border-purple-600\\/30{
  border-color: rgb(105 56 239 / 0.3);
}
.border-purple-600\\/35{
  border-color: rgb(105 56 239 / 0.35);
}
.border-purple-600\\/40{
  border-color: rgb(105 56 239 / 0.4);
}
.border-purple-600\\/45{
  border-color: rgb(105 56 239 / 0.45);
}
.border-purple-600\\/5{
  border-color: rgb(105 56 239 / 0.05);
}
.border-purple-600\\/50{
  border-color: rgb(105 56 239 / 0.5);
}
.border-purple-600\\/55{
  border-color: rgb(105 56 239 / 0.55);
}
.border-purple-600\\/60{
  border-color: rgb(105 56 239 / 0.6);
}
.border-purple-600\\/65{
  border-color: rgb(105 56 239 / 0.65);
}
.border-purple-600\\/70{
  border-color: rgb(105 56 239 / 0.7);
}
.border-purple-600\\/75{
  border-color: rgb(105 56 239 / 0.75);
}
.border-purple-600\\/80{
  border-color: rgb(105 56 239 / 0.8);
}
.border-purple-600\\/85{
  border-color: rgb(105 56 239 / 0.85);
}
.border-purple-600\\/90{
  border-color: rgb(105 56 239 / 0.9);
}
.border-purple-600\\/95{
  border-color: rgb(105 56 239 / 0.95);
}
.border-purple-700{
  --tw-border-opacity: 1;
  border-color: rgb(89 37 220 / var(--tw-border-opacity, 1));
}
.border-purple-700\\/0{
  border-color: rgb(89 37 220 / 0);
}
.border-purple-700\\/10{
  border-color: rgb(89 37 220 / 0.1);
}
.border-purple-700\\/100{
  border-color: rgb(89 37 220 / 1);
}
.border-purple-700\\/15{
  border-color: rgb(89 37 220 / 0.15);
}
.border-purple-700\\/20{
  border-color: rgb(89 37 220 / 0.2);
}
.border-purple-700\\/25{
  border-color: rgb(89 37 220 / 0.25);
}
.border-purple-700\\/30{
  border-color: rgb(89 37 220 / 0.3);
}
.border-purple-700\\/35{
  border-color: rgb(89 37 220 / 0.35);
}
.border-purple-700\\/40{
  border-color: rgb(89 37 220 / 0.4);
}
.border-purple-700\\/45{
  border-color: rgb(89 37 220 / 0.45);
}
.border-purple-700\\/5{
  border-color: rgb(89 37 220 / 0.05);
}
.border-purple-700\\/50{
  border-color: rgb(89 37 220 / 0.5);
}
.border-purple-700\\/55{
  border-color: rgb(89 37 220 / 0.55);
}
.border-purple-700\\/60{
  border-color: rgb(89 37 220 / 0.6);
}
.border-purple-700\\/65{
  border-color: rgb(89 37 220 / 0.65);
}
.border-purple-700\\/70{
  border-color: rgb(89 37 220 / 0.7);
}
.border-purple-700\\/75{
  border-color: rgb(89 37 220 / 0.75);
}
.border-purple-700\\/80{
  border-color: rgb(89 37 220 / 0.8);
}
.border-purple-700\\/85{
  border-color: rgb(89 37 220 / 0.85);
}
.border-purple-700\\/90{
  border-color: rgb(89 37 220 / 0.9);
}
.border-purple-700\\/95{
  border-color: rgb(89 37 220 / 0.95);
}
.border-success-100{
  --tw-border-opacity: 1;
  border-color: rgb(211 248 223 / var(--tw-border-opacity, 1));
}
.border-success-100\\/0{
  border-color: rgb(211 248 223 / 0);
}
.border-success-100\\/10{
  border-color: rgb(211 248 223 / 0.1);
}
.border-success-100\\/100{
  border-color: rgb(211 248 223 / 1);
}
.border-success-100\\/15{
  border-color: rgb(211 248 223 / 0.15);
}
.border-success-100\\/20{
  border-color: rgb(211 248 223 / 0.2);
}
.border-success-100\\/25{
  border-color: rgb(211 248 223 / 0.25);
}
.border-success-100\\/30{
  border-color: rgb(211 248 223 / 0.3);
}
.border-success-100\\/35{
  border-color: rgb(211 248 223 / 0.35);
}
.border-success-100\\/40{
  border-color: rgb(211 248 223 / 0.4);
}
.border-success-100\\/45{
  border-color: rgb(211 248 223 / 0.45);
}
.border-success-100\\/5{
  border-color: rgb(211 248 223 / 0.05);
}
.border-success-100\\/50{
  border-color: rgb(211 248 223 / 0.5);
}
.border-success-100\\/55{
  border-color: rgb(211 248 223 / 0.55);
}
.border-success-100\\/60{
  border-color: rgb(211 248 223 / 0.6);
}
.border-success-100\\/65{
  border-color: rgb(211 248 223 / 0.65);
}
.border-success-100\\/70{
  border-color: rgb(211 248 223 / 0.7);
}
.border-success-100\\/75{
  border-color: rgb(211 248 223 / 0.75);
}
.border-success-100\\/80{
  border-color: rgb(211 248 223 / 0.8);
}
.border-success-100\\/85{
  border-color: rgb(211 248 223 / 0.85);
}
.border-success-100\\/90{
  border-color: rgb(211 248 223 / 0.9);
}
.border-success-100\\/95{
  border-color: rgb(211 248 223 / 0.95);
}
.border-success-200{
  --tw-border-opacity: 1;
  border-color: rgb(170 240 196 / var(--tw-border-opacity, 1));
}
.border-success-200\\/0{
  border-color: rgb(170 240 196 / 0);
}
.border-success-200\\/10{
  border-color: rgb(170 240 196 / 0.1);
}
.border-success-200\\/100{
  border-color: rgb(170 240 196 / 1);
}
.border-success-200\\/15{
  border-color: rgb(170 240 196 / 0.15);
}
.border-success-200\\/20{
  border-color: rgb(170 240 196 / 0.2);
}
.border-success-200\\/25{
  border-color: rgb(170 240 196 / 0.25);
}
.border-success-200\\/30{
  border-color: rgb(170 240 196 / 0.3);
}
.border-success-200\\/35{
  border-color: rgb(170 240 196 / 0.35);
}
.border-success-200\\/40{
  border-color: rgb(170 240 196 / 0.4);
}
.border-success-200\\/45{
  border-color: rgb(170 240 196 / 0.45);
}
.border-success-200\\/5{
  border-color: rgb(170 240 196 / 0.05);
}
.border-success-200\\/50{
  border-color: rgb(170 240 196 / 0.5);
}
.border-success-200\\/55{
  border-color: rgb(170 240 196 / 0.55);
}
.border-success-200\\/60{
  border-color: rgb(170 240 196 / 0.6);
}
.border-success-200\\/65{
  border-color: rgb(170 240 196 / 0.65);
}
.border-success-200\\/70{
  border-color: rgb(170 240 196 / 0.7);
}
.border-success-200\\/75{
  border-color: rgb(170 240 196 / 0.75);
}
.border-success-200\\/80{
  border-color: rgb(170 240 196 / 0.8);
}
.border-success-200\\/85{
  border-color: rgb(170 240 196 / 0.85);
}
.border-success-200\\/90{
  border-color: rgb(170 240 196 / 0.9);
}
.border-success-200\\/95{
  border-color: rgb(170 240 196 / 0.95);
}
.border-success-25{
  --tw-border-opacity: 1;
  border-color: rgb(246 254 249 / var(--tw-border-opacity, 1));
}
.border-success-25\\/0{
  border-color: rgb(246 254 249 / 0);
}
.border-success-25\\/10{
  border-color: rgb(246 254 249 / 0.1);
}
.border-success-25\\/100{
  border-color: rgb(246 254 249 / 1);
}
.border-success-25\\/15{
  border-color: rgb(246 254 249 / 0.15);
}
.border-success-25\\/20{
  border-color: rgb(246 254 249 / 0.2);
}
.border-success-25\\/25{
  border-color: rgb(246 254 249 / 0.25);
}
.border-success-25\\/30{
  border-color: rgb(246 254 249 / 0.3);
}
.border-success-25\\/35{
  border-color: rgb(246 254 249 / 0.35);
}
.border-success-25\\/40{
  border-color: rgb(246 254 249 / 0.4);
}
.border-success-25\\/45{
  border-color: rgb(246 254 249 / 0.45);
}
.border-success-25\\/5{
  border-color: rgb(246 254 249 / 0.05);
}
.border-success-25\\/50{
  border-color: rgb(246 254 249 / 0.5);
}
.border-success-25\\/55{
  border-color: rgb(246 254 249 / 0.55);
}
.border-success-25\\/60{
  border-color: rgb(246 254 249 / 0.6);
}
.border-success-25\\/65{
  border-color: rgb(246 254 249 / 0.65);
}
.border-success-25\\/70{
  border-color: rgb(246 254 249 / 0.7);
}
.border-success-25\\/75{
  border-color: rgb(246 254 249 / 0.75);
}
.border-success-25\\/80{
  border-color: rgb(246 254 249 / 0.8);
}
.border-success-25\\/85{
  border-color: rgb(246 254 249 / 0.85);
}
.border-success-25\\/90{
  border-color: rgb(246 254 249 / 0.9);
}
.border-success-25\\/95{
  border-color: rgb(246 254 249 / 0.95);
}
.border-success-300{
  --tw-border-opacity: 1;
  border-color: rgb(115 226 163 / var(--tw-border-opacity, 1));
}
.border-success-400{
  --tw-border-opacity: 1;
  border-color: rgb(60 203 127 / var(--tw-border-opacity, 1));
}
.border-success-400\\/0{
  border-color: rgb(60 203 127 / 0);
}
.border-success-400\\/10{
  border-color: rgb(60 203 127 / 0.1);
}
.border-success-400\\/100{
  border-color: rgb(60 203 127 / 1);
}
.border-success-400\\/15{
  border-color: rgb(60 203 127 / 0.15);
}
.border-success-400\\/20{
  border-color: rgb(60 203 127 / 0.2);
}
.border-success-400\\/25{
  border-color: rgb(60 203 127 / 0.25);
}
.border-success-400\\/30{
  border-color: rgb(60 203 127 / 0.3);
}
.border-success-400\\/35{
  border-color: rgb(60 203 127 / 0.35);
}
.border-success-400\\/40{
  border-color: rgb(60 203 127 / 0.4);
}
.border-success-400\\/45{
  border-color: rgb(60 203 127 / 0.45);
}
.border-success-400\\/5{
  border-color: rgb(60 203 127 / 0.05);
}
.border-success-400\\/50{
  border-color: rgb(60 203 127 / 0.5);
}
.border-success-400\\/55{
  border-color: rgb(60 203 127 / 0.55);
}
.border-success-400\\/60{
  border-color: rgb(60 203 127 / 0.6);
}
.border-success-400\\/65{
  border-color: rgb(60 203 127 / 0.65);
}
.border-success-400\\/70{
  border-color: rgb(60 203 127 / 0.7);
}
.border-success-400\\/75{
  border-color: rgb(60 203 127 / 0.75);
}
.border-success-400\\/80{
  border-color: rgb(60 203 127 / 0.8);
}
.border-success-400\\/85{
  border-color: rgb(60 203 127 / 0.85);
}
.border-success-400\\/90{
  border-color: rgb(60 203 127 / 0.9);
}
.border-success-400\\/95{
  border-color: rgb(60 203 127 / 0.95);
}
.border-success-50{
  --tw-border-opacity: 1;
  border-color: rgb(237 252 242 / var(--tw-border-opacity, 1));
}
.border-success-50\\/0{
  border-color: rgb(237 252 242 / 0);
}
.border-success-50\\/10{
  border-color: rgb(237 252 242 / 0.1);
}
.border-success-50\\/100{
  border-color: rgb(237 252 242 / 1);
}
.border-success-50\\/15{
  border-color: rgb(237 252 242 / 0.15);
}
.border-success-50\\/20{
  border-color: rgb(237 252 242 / 0.2);
}
.border-success-50\\/25{
  border-color: rgb(237 252 242 / 0.25);
}
.border-success-50\\/30{
  border-color: rgb(237 252 242 / 0.3);
}
.border-success-50\\/35{
  border-color: rgb(237 252 242 / 0.35);
}
.border-success-50\\/40{
  border-color: rgb(237 252 242 / 0.4);
}
.border-success-50\\/45{
  border-color: rgb(237 252 242 / 0.45);
}
.border-success-50\\/5{
  border-color: rgb(237 252 242 / 0.05);
}
.border-success-50\\/50{
  border-color: rgb(237 252 242 / 0.5);
}
.border-success-50\\/55{
  border-color: rgb(237 252 242 / 0.55);
}
.border-success-50\\/60{
  border-color: rgb(237 252 242 / 0.6);
}
.border-success-50\\/65{
  border-color: rgb(237 252 242 / 0.65);
}
.border-success-50\\/70{
  border-color: rgb(237 252 242 / 0.7);
}
.border-success-50\\/75{
  border-color: rgb(237 252 242 / 0.75);
}
.border-success-50\\/80{
  border-color: rgb(237 252 242 / 0.8);
}
.border-success-50\\/85{
  border-color: rgb(237 252 242 / 0.85);
}
.border-success-50\\/90{
  border-color: rgb(237 252 242 / 0.9);
}
.border-success-50\\/95{
  border-color: rgb(237 252 242 / 0.95);
}
.border-success-500{
  --tw-border-opacity: 1;
  border-color: rgb(22 179 100 / var(--tw-border-opacity, 1));
}
.border-success-500\\/0{
  border-color: rgb(22 179 100 / 0);
}
.border-success-500\\/10{
  border-color: rgb(22 179 100 / 0.1);
}
.border-success-500\\/100{
  border-color: rgb(22 179 100 / 1);
}
.border-success-500\\/15{
  border-color: rgb(22 179 100 / 0.15);
}
.border-success-500\\/20{
  border-color: rgb(22 179 100 / 0.2);
}
.border-success-500\\/25{
  border-color: rgb(22 179 100 / 0.25);
}
.border-success-500\\/30{
  border-color: rgb(22 179 100 / 0.3);
}
.border-success-500\\/35{
  border-color: rgb(22 179 100 / 0.35);
}
.border-success-500\\/40{
  border-color: rgb(22 179 100 / 0.4);
}
.border-success-500\\/45{
  border-color: rgb(22 179 100 / 0.45);
}
.border-success-500\\/5{
  border-color: rgb(22 179 100 / 0.05);
}
.border-success-500\\/50{
  border-color: rgb(22 179 100 / 0.5);
}
.border-success-500\\/55{
  border-color: rgb(22 179 100 / 0.55);
}
.border-success-500\\/60{
  border-color: rgb(22 179 100 / 0.6);
}
.border-success-500\\/65{
  border-color: rgb(22 179 100 / 0.65);
}
.border-success-500\\/70{
  border-color: rgb(22 179 100 / 0.7);
}
.border-success-500\\/75{
  border-color: rgb(22 179 100 / 0.75);
}
.border-success-500\\/80{
  border-color: rgb(22 179 100 / 0.8);
}
.border-success-500\\/85{
  border-color: rgb(22 179 100 / 0.85);
}
.border-success-500\\/90{
  border-color: rgb(22 179 100 / 0.9);
}
.border-success-500\\/95{
  border-color: rgb(22 179 100 / 0.95);
}
.border-success-600{
  --tw-border-opacity: 1;
  border-color: rgb(9 146 80 / var(--tw-border-opacity, 1));
}
.border-success-600\\/0{
  border-color: rgb(9 146 80 / 0);
}
.border-success-600\\/10{
  border-color: rgb(9 146 80 / 0.1);
}
.border-success-600\\/100{
  border-color: rgb(9 146 80 / 1);
}
.border-success-600\\/15{
  border-color: rgb(9 146 80 / 0.15);
}
.border-success-600\\/20{
  border-color: rgb(9 146 80 / 0.2);
}
.border-success-600\\/25{
  border-color: rgb(9 146 80 / 0.25);
}
.border-success-600\\/30{
  border-color: rgb(9 146 80 / 0.3);
}
.border-success-600\\/35{
  border-color: rgb(9 146 80 / 0.35);
}
.border-success-600\\/40{
  border-color: rgb(9 146 80 / 0.4);
}
.border-success-600\\/45{
  border-color: rgb(9 146 80 / 0.45);
}
.border-success-600\\/5{
  border-color: rgb(9 146 80 / 0.05);
}
.border-success-600\\/50{
  border-color: rgb(9 146 80 / 0.5);
}
.border-success-600\\/55{
  border-color: rgb(9 146 80 / 0.55);
}
.border-success-600\\/60{
  border-color: rgb(9 146 80 / 0.6);
}
.border-success-600\\/65{
  border-color: rgb(9 146 80 / 0.65);
}
.border-success-600\\/70{
  border-color: rgb(9 146 80 / 0.7);
}
.border-success-600\\/75{
  border-color: rgb(9 146 80 / 0.75);
}
.border-success-600\\/80{
  border-color: rgb(9 146 80 / 0.8);
}
.border-success-600\\/85{
  border-color: rgb(9 146 80 / 0.85);
}
.border-success-600\\/90{
  border-color: rgb(9 146 80 / 0.9);
}
.border-success-600\\/95{
  border-color: rgb(9 146 80 / 0.95);
}
.border-success-700{
  --tw-border-opacity: 1;
  border-color: rgb(8 116 67 / var(--tw-border-opacity, 1));
}
.border-success-700\\/0{
  border-color: rgb(8 116 67 / 0);
}
.border-success-700\\/10{
  border-color: rgb(8 116 67 / 0.1);
}
.border-success-700\\/100{
  border-color: rgb(8 116 67 / 1);
}
.border-success-700\\/15{
  border-color: rgb(8 116 67 / 0.15);
}
.border-success-700\\/20{
  border-color: rgb(8 116 67 / 0.2);
}
.border-success-700\\/25{
  border-color: rgb(8 116 67 / 0.25);
}
.border-success-700\\/30{
  border-color: rgb(8 116 67 / 0.3);
}
.border-success-700\\/35{
  border-color: rgb(8 116 67 / 0.35);
}
.border-success-700\\/40{
  border-color: rgb(8 116 67 / 0.4);
}
.border-success-700\\/45{
  border-color: rgb(8 116 67 / 0.45);
}
.border-success-700\\/5{
  border-color: rgb(8 116 67 / 0.05);
}
.border-success-700\\/50{
  border-color: rgb(8 116 67 / 0.5);
}
.border-success-700\\/55{
  border-color: rgb(8 116 67 / 0.55);
}
.border-success-700\\/60{
  border-color: rgb(8 116 67 / 0.6);
}
.border-success-700\\/65{
  border-color: rgb(8 116 67 / 0.65);
}
.border-success-700\\/70{
  border-color: rgb(8 116 67 / 0.7);
}
.border-success-700\\/75{
  border-color: rgb(8 116 67 / 0.75);
}
.border-success-700\\/80{
  border-color: rgb(8 116 67 / 0.8);
}
.border-success-700\\/85{
  border-color: rgb(8 116 67 / 0.85);
}
.border-success-700\\/90{
  border-color: rgb(8 116 67 / 0.9);
}
.border-success-700\\/95{
  border-color: rgb(8 116 67 / 0.95);
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(95 233 208 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(195 181 253 / var(--tw-border-opacity, 1));
}
.border-warning-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 199 / var(--tw-border-opacity, 1));
}
.border-warning-100\\/0{
  border-color: rgb(254 240 199 / 0);
}
.border-warning-100\\/10{
  border-color: rgb(254 240 199 / 0.1);
}
.border-warning-100\\/100{
  border-color: rgb(254 240 199 / 1);
}
.border-warning-100\\/15{
  border-color: rgb(254 240 199 / 0.15);
}
.border-warning-100\\/20{
  border-color: rgb(254 240 199 / 0.2);
}
.border-warning-100\\/25{
  border-color: rgb(254 240 199 / 0.25);
}
.border-warning-100\\/30{
  border-color: rgb(254 240 199 / 0.3);
}
.border-warning-100\\/35{
  border-color: rgb(254 240 199 / 0.35);
}
.border-warning-100\\/40{
  border-color: rgb(254 240 199 / 0.4);
}
.border-warning-100\\/45{
  border-color: rgb(254 240 199 / 0.45);
}
.border-warning-100\\/5{
  border-color: rgb(254 240 199 / 0.05);
}
.border-warning-100\\/50{
  border-color: rgb(254 240 199 / 0.5);
}
.border-warning-100\\/55{
  border-color: rgb(254 240 199 / 0.55);
}
.border-warning-100\\/60{
  border-color: rgb(254 240 199 / 0.6);
}
.border-warning-100\\/65{
  border-color: rgb(254 240 199 / 0.65);
}
.border-warning-100\\/70{
  border-color: rgb(254 240 199 / 0.7);
}
.border-warning-100\\/75{
  border-color: rgb(254 240 199 / 0.75);
}
.border-warning-100\\/80{
  border-color: rgb(254 240 199 / 0.8);
}
.border-warning-100\\/85{
  border-color: rgb(254 240 199 / 0.85);
}
.border-warning-100\\/90{
  border-color: rgb(254 240 199 / 0.9);
}
.border-warning-100\\/95{
  border-color: rgb(254 240 199 / 0.95);
}
.border-warning-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 223 137 / var(--tw-border-opacity, 1));
}
.border-warning-200\\/0{
  border-color: rgb(254 223 137 / 0);
}
.border-warning-200\\/10{
  border-color: rgb(254 223 137 / 0.1);
}
.border-warning-200\\/100{
  border-color: rgb(254 223 137 / 1);
}
.border-warning-200\\/15{
  border-color: rgb(254 223 137 / 0.15);
}
.border-warning-200\\/20{
  border-color: rgb(254 223 137 / 0.2);
}
.border-warning-200\\/25{
  border-color: rgb(254 223 137 / 0.25);
}
.border-warning-200\\/30{
  border-color: rgb(254 223 137 / 0.3);
}
.border-warning-200\\/35{
  border-color: rgb(254 223 137 / 0.35);
}
.border-warning-200\\/40{
  border-color: rgb(254 223 137 / 0.4);
}
.border-warning-200\\/45{
  border-color: rgb(254 223 137 / 0.45);
}
.border-warning-200\\/5{
  border-color: rgb(254 223 137 / 0.05);
}
.border-warning-200\\/50{
  border-color: rgb(254 223 137 / 0.5);
}
.border-warning-200\\/55{
  border-color: rgb(254 223 137 / 0.55);
}
.border-warning-200\\/60{
  border-color: rgb(254 223 137 / 0.6);
}
.border-warning-200\\/65{
  border-color: rgb(254 223 137 / 0.65);
}
.border-warning-200\\/70{
  border-color: rgb(254 223 137 / 0.7);
}
.border-warning-200\\/75{
  border-color: rgb(254 223 137 / 0.75);
}
.border-warning-200\\/80{
  border-color: rgb(254 223 137 / 0.8);
}
.border-warning-200\\/85{
  border-color: rgb(254 223 137 / 0.85);
}
.border-warning-200\\/90{
  border-color: rgb(254 223 137 / 0.9);
}
.border-warning-200\\/95{
  border-color: rgb(254 223 137 / 0.95);
}
.border-warning-25{
  --tw-border-opacity: 1;
  border-color: rgb(255 252 245 / var(--tw-border-opacity, 1));
}
.border-warning-25\\/0{
  border-color: rgb(255 252 245 / 0);
}
.border-warning-25\\/10{
  border-color: rgb(255 252 245 / 0.1);
}
.border-warning-25\\/100{
  border-color: rgb(255 252 245 / 1);
}
.border-warning-25\\/15{
  border-color: rgb(255 252 245 / 0.15);
}
.border-warning-25\\/20{
  border-color: rgb(255 252 245 / 0.2);
}
.border-warning-25\\/25{
  border-color: rgb(255 252 245 / 0.25);
}
.border-warning-25\\/30{
  border-color: rgb(255 252 245 / 0.3);
}
.border-warning-25\\/35{
  border-color: rgb(255 252 245 / 0.35);
}
.border-warning-25\\/40{
  border-color: rgb(255 252 245 / 0.4);
}
.border-warning-25\\/45{
  border-color: rgb(255 252 245 / 0.45);
}
.border-warning-25\\/5{
  border-color: rgb(255 252 245 / 0.05);
}
.border-warning-25\\/50{
  border-color: rgb(255 252 245 / 0.5);
}
.border-warning-25\\/55{
  border-color: rgb(255 252 245 / 0.55);
}
.border-warning-25\\/60{
  border-color: rgb(255 252 245 / 0.6);
}
.border-warning-25\\/65{
  border-color: rgb(255 252 245 / 0.65);
}
.border-warning-25\\/70{
  border-color: rgb(255 252 245 / 0.7);
}
.border-warning-25\\/75{
  border-color: rgb(255 252 245 / 0.75);
}
.border-warning-25\\/80{
  border-color: rgb(255 252 245 / 0.8);
}
.border-warning-25\\/85{
  border-color: rgb(255 252 245 / 0.85);
}
.border-warning-25\\/90{
  border-color: rgb(255 252 245 / 0.9);
}
.border-warning-25\\/95{
  border-color: rgb(255 252 245 / 0.95);
}
.border-warning-300{
  --tw-border-opacity: 1;
  border-color: rgb(254 200 75 / var(--tw-border-opacity, 1));
}
.border-warning-400{
  --tw-border-opacity: 1;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1));
}
.border-warning-400\\/0{
  border-color: rgb(253 176 34 / 0);
}
.border-warning-400\\/10{
  border-color: rgb(253 176 34 / 0.1);
}
.border-warning-400\\/100{
  border-color: rgb(253 176 34 / 1);
}
.border-warning-400\\/15{
  border-color: rgb(253 176 34 / 0.15);
}
.border-warning-400\\/20{
  border-color: rgb(253 176 34 / 0.2);
}
.border-warning-400\\/25{
  border-color: rgb(253 176 34 / 0.25);
}
.border-warning-400\\/30{
  border-color: rgb(253 176 34 / 0.3);
}
.border-warning-400\\/35{
  border-color: rgb(253 176 34 / 0.35);
}
.border-warning-400\\/40{
  border-color: rgb(253 176 34 / 0.4);
}
.border-warning-400\\/45{
  border-color: rgb(253 176 34 / 0.45);
}
.border-warning-400\\/5{
  border-color: rgb(253 176 34 / 0.05);
}
.border-warning-400\\/50{
  border-color: rgb(253 176 34 / 0.5);
}
.border-warning-400\\/55{
  border-color: rgb(253 176 34 / 0.55);
}
.border-warning-400\\/60{
  border-color: rgb(253 176 34 / 0.6);
}
.border-warning-400\\/65{
  border-color: rgb(253 176 34 / 0.65);
}
.border-warning-400\\/70{
  border-color: rgb(253 176 34 / 0.7);
}
.border-warning-400\\/75{
  border-color: rgb(253 176 34 / 0.75);
}
.border-warning-400\\/80{
  border-color: rgb(253 176 34 / 0.8);
}
.border-warning-400\\/85{
  border-color: rgb(253 176 34 / 0.85);
}
.border-warning-400\\/90{
  border-color: rgb(253 176 34 / 0.9);
}
.border-warning-400\\/95{
  border-color: rgb(253 176 34 / 0.95);
}
.border-warning-50{
  --tw-border-opacity: 1;
  border-color: rgb(255 250 235 / var(--tw-border-opacity, 1));
}
.border-warning-50\\/0{
  border-color: rgb(255 250 235 / 0);
}
.border-warning-50\\/10{
  border-color: rgb(255 250 235 / 0.1);
}
.border-warning-50\\/100{
  border-color: rgb(255 250 235 / 1);
}
.border-warning-50\\/15{
  border-color: rgb(255 250 235 / 0.15);
}
.border-warning-50\\/20{
  border-color: rgb(255 250 235 / 0.2);
}
.border-warning-50\\/25{
  border-color: rgb(255 250 235 / 0.25);
}
.border-warning-50\\/30{
  border-color: rgb(255 250 235 / 0.3);
}
.border-warning-50\\/35{
  border-color: rgb(255 250 235 / 0.35);
}
.border-warning-50\\/40{
  border-color: rgb(255 250 235 / 0.4);
}
.border-warning-50\\/45{
  border-color: rgb(255 250 235 / 0.45);
}
.border-warning-50\\/5{
  border-color: rgb(255 250 235 / 0.05);
}
.border-warning-50\\/50{
  border-color: rgb(255 250 235 / 0.5);
}
.border-warning-50\\/55{
  border-color: rgb(255 250 235 / 0.55);
}
.border-warning-50\\/60{
  border-color: rgb(255 250 235 / 0.6);
}
.border-warning-50\\/65{
  border-color: rgb(255 250 235 / 0.65);
}
.border-warning-50\\/70{
  border-color: rgb(255 250 235 / 0.7);
}
.border-warning-50\\/75{
  border-color: rgb(255 250 235 / 0.75);
}
.border-warning-50\\/80{
  border-color: rgb(255 250 235 / 0.8);
}
.border-warning-50\\/85{
  border-color: rgb(255 250 235 / 0.85);
}
.border-warning-50\\/90{
  border-color: rgb(255 250 235 / 0.9);
}
.border-warning-50\\/95{
  border-color: rgb(255 250 235 / 0.95);
}
.border-warning-500{
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}
.border-warning-500\\/0{
  border-color: rgb(247 144 9 / 0);
}
.border-warning-500\\/10{
  border-color: rgb(247 144 9 / 0.1);
}
.border-warning-500\\/100{
  border-color: rgb(247 144 9 / 1);
}
.border-warning-500\\/15{
  border-color: rgb(247 144 9 / 0.15);
}
.border-warning-500\\/20{
  border-color: rgb(247 144 9 / 0.2);
}
.border-warning-500\\/25{
  border-color: rgb(247 144 9 / 0.25);
}
.border-warning-500\\/30{
  border-color: rgb(247 144 9 / 0.3);
}
.border-warning-500\\/35{
  border-color: rgb(247 144 9 / 0.35);
}
.border-warning-500\\/40{
  border-color: rgb(247 144 9 / 0.4);
}
.border-warning-500\\/45{
  border-color: rgb(247 144 9 / 0.45);
}
.border-warning-500\\/5{
  border-color: rgb(247 144 9 / 0.05);
}
.border-warning-500\\/50{
  border-color: rgb(247 144 9 / 0.5);
}
.border-warning-500\\/55{
  border-color: rgb(247 144 9 / 0.55);
}
.border-warning-500\\/60{
  border-color: rgb(247 144 9 / 0.6);
}
.border-warning-500\\/65{
  border-color: rgb(247 144 9 / 0.65);
}
.border-warning-500\\/70{
  border-color: rgb(247 144 9 / 0.7);
}
.border-warning-500\\/75{
  border-color: rgb(247 144 9 / 0.75);
}
.border-warning-500\\/80{
  border-color: rgb(247 144 9 / 0.8);
}
.border-warning-500\\/85{
  border-color: rgb(247 144 9 / 0.85);
}
.border-warning-500\\/90{
  border-color: rgb(247 144 9 / 0.9);
}
.border-warning-500\\/95{
  border-color: rgb(247 144 9 / 0.95);
}
.border-warning-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}
.border-warning-600\\/0{
  border-color: rgb(220 104 3 / 0);
}
.border-warning-600\\/10{
  border-color: rgb(220 104 3 / 0.1);
}
.border-warning-600\\/100{
  border-color: rgb(220 104 3 / 1);
}
.border-warning-600\\/15{
  border-color: rgb(220 104 3 / 0.15);
}
.border-warning-600\\/20{
  border-color: rgb(220 104 3 / 0.2);
}
.border-warning-600\\/25{
  border-color: rgb(220 104 3 / 0.25);
}
.border-warning-600\\/30{
  border-color: rgb(220 104 3 / 0.3);
}
.border-warning-600\\/35{
  border-color: rgb(220 104 3 / 0.35);
}
.border-warning-600\\/40{
  border-color: rgb(220 104 3 / 0.4);
}
.border-warning-600\\/45{
  border-color: rgb(220 104 3 / 0.45);
}
.border-warning-600\\/5{
  border-color: rgb(220 104 3 / 0.05);
}
.border-warning-600\\/50{
  border-color: rgb(220 104 3 / 0.5);
}
.border-warning-600\\/55{
  border-color: rgb(220 104 3 / 0.55);
}
.border-warning-600\\/60{
  border-color: rgb(220 104 3 / 0.6);
}
.border-warning-600\\/65{
  border-color: rgb(220 104 3 / 0.65);
}
.border-warning-600\\/70{
  border-color: rgb(220 104 3 / 0.7);
}
.border-warning-600\\/75{
  border-color: rgb(220 104 3 / 0.75);
}
.border-warning-600\\/80{
  border-color: rgb(220 104 3 / 0.8);
}
.border-warning-600\\/85{
  border-color: rgb(220 104 3 / 0.85);
}
.border-warning-600\\/90{
  border-color: rgb(220 104 3 / 0.9);
}
.border-warning-600\\/95{
  border-color: rgb(220 104 3 / 0.95);
}
.border-warning-700{
  --tw-border-opacity: 1;
  border-color: rgb(181 71 8 / var(--tw-border-opacity, 1));
}
.border-warning-700\\/0{
  border-color: rgb(181 71 8 / 0);
}
.border-warning-700\\/10{
  border-color: rgb(181 71 8 / 0.1);
}
.border-warning-700\\/100{
  border-color: rgb(181 71 8 / 1);
}
.border-warning-700\\/15{
  border-color: rgb(181 71 8 / 0.15);
}
.border-warning-700\\/20{
  border-color: rgb(181 71 8 / 0.2);
}
.border-warning-700\\/25{
  border-color: rgb(181 71 8 / 0.25);
}
.border-warning-700\\/30{
  border-color: rgb(181 71 8 / 0.3);
}
.border-warning-700\\/35{
  border-color: rgb(181 71 8 / 0.35);
}
.border-warning-700\\/40{
  border-color: rgb(181 71 8 / 0.4);
}
.border-warning-700\\/45{
  border-color: rgb(181 71 8 / 0.45);
}
.border-warning-700\\/5{
  border-color: rgb(181 71 8 / 0.05);
}
.border-warning-700\\/50{
  border-color: rgb(181 71 8 / 0.5);
}
.border-warning-700\\/55{
  border-color: rgb(181 71 8 / 0.55);
}
.border-warning-700\\/60{
  border-color: rgb(181 71 8 / 0.6);
}
.border-warning-700\\/65{
  border-color: rgb(181 71 8 / 0.65);
}
.border-warning-700\\/70{
  border-color: rgb(181 71 8 / 0.7);
}
.border-warning-700\\/75{
  border-color: rgb(181 71 8 / 0.75);
}
.border-warning-700\\/80{
  border-color: rgb(181 71 8 / 0.8);
}
.border-warning-700\\/85{
  border-color: rgb(181 71 8 / 0.85);
}
.border-warning-700\\/90{
  border-color: rgb(181 71 8 / 0.9);
}
.border-warning-700\\/95{
  border-color: rgb(181 71 8 / 0.95);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/60{
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/80{
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 197 21 / var(--tw-border-opacity, 1));
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(234 170 8 / var(--tw-border-opacity, 1));
}
.border-b-danger-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}
.border-b-neutral-100{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-b-neutral-200{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-b-neutral-300{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.border-b-neutral-900{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(24 29 39 / var(--tw-border-opacity, 1));
}
.border-b-primary-500{
  border-bottom-color: var(--color-primary-500, #0BA5EC);
}
.border-b-transparent{
  border-bottom-color: transparent;
}
.border-l-neutral-200{
  --tw-border-opacity: 1;
  border-left-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-l-neutral-300{
  --tw-border-opacity: 1;
  border-left-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.border-l-primary-50{
  border-left-color: var(--color-primary-50, #F0F9FF);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-neutral-100{
  --tw-border-opacity: 1;
  border-right-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-r-neutral-200{
  --tw-border-opacity: 1;
  border-right-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-r-primary-100{
  border-right-color: var(--color-primary-100, #E0F2FE);
}
.border-r-transparent{
  border-right-color: transparent;
}
.border-t-neutral-100{
  --tw-border-opacity: 1;
  border-top-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}
.border-t-neutral-200{
  --tw-border-opacity: 1;
  border-top-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.border-t-neutral-300{
  --tw-border-opacity: 1;
  border-top-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}
.border-t-neutral-400{
  --tw-border-opacity: 1;
  border-top-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}
.border-t-primary-500{
  border-top-color: var(--color-primary-500, #0BA5EC);
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-warning-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}
.border-t-white\\/70{
  border-top-color: rgb(255 255 255 / 0.7);
}
.\\!border-opacity-10{
  --tw-border-opacity: 0.1 !important;
}
.\\!border-opacity-90{
  --tw-border-opacity: 0.9 !important;
}
.\\!border-opacity-\\[12\\%\\]{
  --tw-border-opacity: 12% !important;
}
.border-opacity-100{
  --tw-border-opacity: 1;
}
.border-opacity-15{
  --tw-border-opacity: 0.15;
}
.border-opacity-\\[12\\%\\]{
  --tw-border-opacity: 12%;
}
.\\!bg-\\[\\#F4F6F8\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 246 248 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-danger-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-danger-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(122 39 26 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-200{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-300{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-75{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-800{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(24 29 39 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-neutral-dark-800{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 38 47 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-orange-dark-200{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 214 174 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-primary-100{
  background-color: var(--color-primary-100, #E0F2FE) !important;
}
.\\!bg-primary-200{
  background-color: var(--color-primary-200, #B9E6FE) !important;
}
.\\!bg-primary-25{
  background-color: var(--color-primary-25, #F5FBFF) !important;
}
.\\!bg-primary-50{
  background-color: var(--color-primary-50, #F0F9FF) !important;
}
.\\!bg-primary-500{
  background-color: var(--color-primary-500, #0BA5EC) !important;
}
.\\!bg-primary-700{
  background-color: var(--color-primary-700, #026AA2) !important;
}
.\\!bg-primary-800{
  background-color: var(--color-primary-800, #065986) !important;
}
.\\!bg-success-25{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-success-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent{
  background-color: transparent !important;
}
.\\!bg-warning-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-warning-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-warning-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1) !important;
}
.bg-\\[\\#003A4B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 58 75 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#17B26A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(23 178 106 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2EA1D1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 161 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3298dc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(50 152 220 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8191E8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(129 145 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8191E8\\]\\/5{
  background-color: rgb(129 145 232 / 0.05);
}
.bg-\\[\\#B0EAFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(176 234 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D4D9DB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(212 217 219 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F6FC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 246 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E9EAEB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F04438\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0F0F0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F5F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 245 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F4F5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F6F6F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F79009\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFDFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 253 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff88\\]{
  background-color: #ffffff88;
}
.bg-\\[color\\:var\\(--color-secondary-200\\2c \\#E9EAEB\\)\\]{
  background-color: var(--color-secondary-200,#E9EAEB);
}
.bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.3\\)\\]{
  background-color: rgba(255,255,255,0.3);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/35{
  background-color: rgb(0 0 0 / 0.35);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-dark-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 224 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-dark-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 244 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-dark-600{
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 239 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 249 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50\\/50{
  background-color: rgb(236 253 255 / 0.5);
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 174 212 / var(--tw-bg-opacity, 1));
}
.bg-danger-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}
.bg-danger-100\\/0{
  background-color: rgb(254 228 226 / 0);
}
.bg-danger-100\\/10{
  background-color: rgb(254 228 226 / 0.1);
}
.bg-danger-100\\/100{
  background-color: rgb(254 228 226 / 1);
}
.bg-danger-100\\/15{
  background-color: rgb(254 228 226 / 0.15);
}
.bg-danger-100\\/20{
  background-color: rgb(254 228 226 / 0.2);
}
.bg-danger-100\\/25{
  background-color: rgb(254 228 226 / 0.25);
}
.bg-danger-100\\/30{
  background-color: rgb(254 228 226 / 0.3);
}
.bg-danger-100\\/35{
  background-color: rgb(254 228 226 / 0.35);
}
.bg-danger-100\\/40{
  background-color: rgb(254 228 226 / 0.4);
}
.bg-danger-100\\/45{
  background-color: rgb(254 228 226 / 0.45);
}
.bg-danger-100\\/5{
  background-color: rgb(254 228 226 / 0.05);
}
.bg-danger-100\\/50{
  background-color: rgb(254 228 226 / 0.5);
}
.bg-danger-100\\/55{
  background-color: rgb(254 228 226 / 0.55);
}
.bg-danger-100\\/60{
  background-color: rgb(254 228 226 / 0.6);
}
.bg-danger-100\\/65{
  background-color: rgb(254 228 226 / 0.65);
}
.bg-danger-100\\/70{
  background-color: rgb(254 228 226 / 0.7);
}
.bg-danger-100\\/75{
  background-color: rgb(254 228 226 / 0.75);
}
.bg-danger-100\\/80{
  background-color: rgb(254 228 226 / 0.8);
}
.bg-danger-100\\/85{
  background-color: rgb(254 228 226 / 0.85);
}
.bg-danger-100\\/90{
  background-color: rgb(254 228 226 / 0.9);
}
.bg-danger-100\\/95{
  background-color: rgb(254 228 226 / 0.95);
}
.bg-danger-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}
.bg-danger-200\\/0{
  background-color: rgb(254 205 202 / 0);
}
.bg-danger-200\\/10{
  background-color: rgb(254 205 202 / 0.1);
}
.bg-danger-200\\/100{
  background-color: rgb(254 205 202 / 1);
}
.bg-danger-200\\/15{
  background-color: rgb(254 205 202 / 0.15);
}
.bg-danger-200\\/20{
  background-color: rgb(254 205 202 / 0.2);
}
.bg-danger-200\\/25{
  background-color: rgb(254 205 202 / 0.25);
}
.bg-danger-200\\/30{
  background-color: rgb(254 205 202 / 0.3);
}
.bg-danger-200\\/35{
  background-color: rgb(254 205 202 / 0.35);
}
.bg-danger-200\\/40{
  background-color: rgb(254 205 202 / 0.4);
}
.bg-danger-200\\/45{
  background-color: rgb(254 205 202 / 0.45);
}
.bg-danger-200\\/5{
  background-color: rgb(254 205 202 / 0.05);
}
.bg-danger-200\\/50{
  background-color: rgb(254 205 202 / 0.5);
}
.bg-danger-200\\/55{
  background-color: rgb(254 205 202 / 0.55);
}
.bg-danger-200\\/60{
  background-color: rgb(254 205 202 / 0.6);
}
.bg-danger-200\\/65{
  background-color: rgb(254 205 202 / 0.65);
}
.bg-danger-200\\/70{
  background-color: rgb(254 205 202 / 0.7);
}
.bg-danger-200\\/75{
  background-color: rgb(254 205 202 / 0.75);
}
.bg-danger-200\\/80{
  background-color: rgb(254 205 202 / 0.8);
}
.bg-danger-200\\/85{
  background-color: rgb(254 205 202 / 0.85);
}
.bg-danger-200\\/90{
  background-color: rgb(254 205 202 / 0.9);
}
.bg-danger-200\\/95{
  background-color: rgb(254 205 202 / 0.95);
}
.bg-danger-25{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}
.bg-danger-25\\/0{
  background-color: rgb(255 251 250 / 0);
}
.bg-danger-25\\/10{
  background-color: rgb(255 251 250 / 0.1);
}
.bg-danger-25\\/100{
  background-color: rgb(255 251 250 / 1);
}
.bg-danger-25\\/15{
  background-color: rgb(255 251 250 / 0.15);
}
.bg-danger-25\\/20{
  background-color: rgb(255 251 250 / 0.2);
}
.bg-danger-25\\/25{
  background-color: rgb(255 251 250 / 0.25);
}
.bg-danger-25\\/30{
  background-color: rgb(255 251 250 / 0.3);
}
.bg-danger-25\\/35{
  background-color: rgb(255 251 250 / 0.35);
}
.bg-danger-25\\/40{
  background-color: rgb(255 251 250 / 0.4);
}
.bg-danger-25\\/45{
  background-color: rgb(255 251 250 / 0.45);
}
.bg-danger-25\\/5{
  background-color: rgb(255 251 250 / 0.05);
}
.bg-danger-25\\/50{
  background-color: rgb(255 251 250 / 0.5);
}
.bg-danger-25\\/55{
  background-color: rgb(255 251 250 / 0.55);
}
.bg-danger-25\\/60{
  background-color: rgb(255 251 250 / 0.6);
}
.bg-danger-25\\/65{
  background-color: rgb(255 251 250 / 0.65);
}
.bg-danger-25\\/70{
  background-color: rgb(255 251 250 / 0.7);
}
.bg-danger-25\\/75{
  background-color: rgb(255 251 250 / 0.75);
}
.bg-danger-25\\/80{
  background-color: rgb(255 251 250 / 0.8);
}
.bg-danger-25\\/85{
  background-color: rgb(255 251 250 / 0.85);
}
.bg-danger-25\\/90{
  background-color: rgb(255 251 250 / 0.9);
}
.bg-danger-25\\/95{
  background-color: rgb(255 251 250 / 0.95);
}
.bg-danger-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 162 155 / var(--tw-bg-opacity, 1));
}
.bg-danger-300\\/0{
  background-color: rgb(253 162 155 / 0);
}
.bg-danger-300\\/10{
  background-color: rgb(253 162 155 / 0.1);
}
.bg-danger-300\\/100{
  background-color: rgb(253 162 155 / 1);
}
.bg-danger-300\\/15{
  background-color: rgb(253 162 155 / 0.15);
}
.bg-danger-300\\/20{
  background-color: rgb(253 162 155 / 0.2);
}
.bg-danger-300\\/25{
  background-color: rgb(253 162 155 / 0.25);
}
.bg-danger-300\\/30{
  background-color: rgb(253 162 155 / 0.3);
}
.bg-danger-300\\/35{
  background-color: rgb(253 162 155 / 0.35);
}
.bg-danger-300\\/40{
  background-color: rgb(253 162 155 / 0.4);
}
.bg-danger-300\\/45{
  background-color: rgb(253 162 155 / 0.45);
}
.bg-danger-300\\/5{
  background-color: rgb(253 162 155 / 0.05);
}
.bg-danger-300\\/50{
  background-color: rgb(253 162 155 / 0.5);
}
.bg-danger-300\\/55{
  background-color: rgb(253 162 155 / 0.55);
}
.bg-danger-300\\/60{
  background-color: rgb(253 162 155 / 0.6);
}
.bg-danger-300\\/65{
  background-color: rgb(253 162 155 / 0.65);
}
.bg-danger-300\\/70{
  background-color: rgb(253 162 155 / 0.7);
}
.bg-danger-300\\/75{
  background-color: rgb(253 162 155 / 0.75);
}
.bg-danger-300\\/80{
  background-color: rgb(253 162 155 / 0.8);
}
.bg-danger-300\\/85{
  background-color: rgb(253 162 155 / 0.85);
}
.bg-danger-300\\/90{
  background-color: rgb(253 162 155 / 0.9);
}
.bg-danger-300\\/95{
  background-color: rgb(253 162 155 / 0.95);
}
.bg-danger-400{
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}
.bg-danger-400\\/0{
  background-color: rgb(249 112 102 / 0);
}
.bg-danger-400\\/10{
  background-color: rgb(249 112 102 / 0.1);
}
.bg-danger-400\\/100{
  background-color: rgb(249 112 102 / 1);
}
.bg-danger-400\\/15{
  background-color: rgb(249 112 102 / 0.15);
}
.bg-danger-400\\/20{
  background-color: rgb(249 112 102 / 0.2);
}
.bg-danger-400\\/25{
  background-color: rgb(249 112 102 / 0.25);
}
.bg-danger-400\\/30{
  background-color: rgb(249 112 102 / 0.3);
}
.bg-danger-400\\/35{
  background-color: rgb(249 112 102 / 0.35);
}
.bg-danger-400\\/40{
  background-color: rgb(249 112 102 / 0.4);
}
.bg-danger-400\\/45{
  background-color: rgb(249 112 102 / 0.45);
}
.bg-danger-400\\/5{
  background-color: rgb(249 112 102 / 0.05);
}
.bg-danger-400\\/50{
  background-color: rgb(249 112 102 / 0.5);
}
.bg-danger-400\\/55{
  background-color: rgb(249 112 102 / 0.55);
}
.bg-danger-400\\/60{
  background-color: rgb(249 112 102 / 0.6);
}
.bg-danger-400\\/65{
  background-color: rgb(249 112 102 / 0.65);
}
.bg-danger-400\\/70{
  background-color: rgb(249 112 102 / 0.7);
}
.bg-danger-400\\/75{
  background-color: rgb(249 112 102 / 0.75);
}
.bg-danger-400\\/80{
  background-color: rgb(249 112 102 / 0.8);
}
.bg-danger-400\\/85{
  background-color: rgb(249 112 102 / 0.85);
}
.bg-danger-400\\/90{
  background-color: rgb(249 112 102 / 0.9);
}
.bg-danger-400\\/95{
  background-color: rgb(249 112 102 / 0.95);
}
.bg-danger-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-danger-50\\/0{
  background-color: rgb(254 243 242 / 0);
}
.bg-danger-50\\/10{
  background-color: rgb(254 243 242 / 0.1);
}
.bg-danger-50\\/100{
  background-color: rgb(254 243 242 / 1);
}
.bg-danger-50\\/15{
  background-color: rgb(254 243 242 / 0.15);
}
.bg-danger-50\\/20{
  background-color: rgb(254 243 242 / 0.2);
}
.bg-danger-50\\/25{
  background-color: rgb(254 243 242 / 0.25);
}
.bg-danger-50\\/30{
  background-color: rgb(254 243 242 / 0.3);
}
.bg-danger-50\\/35{
  background-color: rgb(254 243 242 / 0.35);
}
.bg-danger-50\\/40{
  background-color: rgb(254 243 242 / 0.4);
}
.bg-danger-50\\/45{
  background-color: rgb(254 243 242 / 0.45);
}
.bg-danger-50\\/5{
  background-color: rgb(254 243 242 / 0.05);
}
.bg-danger-50\\/50{
  background-color: rgb(254 243 242 / 0.5);
}
.bg-danger-50\\/55{
  background-color: rgb(254 243 242 / 0.55);
}
.bg-danger-50\\/60{
  background-color: rgb(254 243 242 / 0.6);
}
.bg-danger-50\\/65{
  background-color: rgb(254 243 242 / 0.65);
}
.bg-danger-50\\/70{
  background-color: rgb(254 243 242 / 0.7);
}
.bg-danger-50\\/75{
  background-color: rgb(254 243 242 / 0.75);
}
.bg-danger-50\\/80{
  background-color: rgb(254 243 242 / 0.8);
}
.bg-danger-50\\/85{
  background-color: rgb(254 243 242 / 0.85);
}
.bg-danger-50\\/90{
  background-color: rgb(254 243 242 / 0.9);
}
.bg-danger-50\\/95{
  background-color: rgb(254 243 242 / 0.95);
}
.bg-danger-500{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-danger-500\\/0{
  background-color: rgb(240 68 56 / 0);
}
.bg-danger-500\\/10{
  background-color: rgb(240 68 56 / 0.1);
}
.bg-danger-500\\/100{
  background-color: rgb(240 68 56 / 1);
}
.bg-danger-500\\/15{
  background-color: rgb(240 68 56 / 0.15);
}
.bg-danger-500\\/20{
  background-color: rgb(240 68 56 / 0.2);
}
.bg-danger-500\\/25{
  background-color: rgb(240 68 56 / 0.25);
}
.bg-danger-500\\/30{
  background-color: rgb(240 68 56 / 0.3);
}
.bg-danger-500\\/35{
  background-color: rgb(240 68 56 / 0.35);
}
.bg-danger-500\\/40{
  background-color: rgb(240 68 56 / 0.4);
}
.bg-danger-500\\/45{
  background-color: rgb(240 68 56 / 0.45);
}
.bg-danger-500\\/5{
  background-color: rgb(240 68 56 / 0.05);
}
.bg-danger-500\\/50{
  background-color: rgb(240 68 56 / 0.5);
}
.bg-danger-500\\/55{
  background-color: rgb(240 68 56 / 0.55);
}
.bg-danger-500\\/60{
  background-color: rgb(240 68 56 / 0.6);
}
.bg-danger-500\\/65{
  background-color: rgb(240 68 56 / 0.65);
}
.bg-danger-500\\/70{
  background-color: rgb(240 68 56 / 0.7);
}
.bg-danger-500\\/75{
  background-color: rgb(240 68 56 / 0.75);
}
.bg-danger-500\\/80{
  background-color: rgb(240 68 56 / 0.8);
}
.bg-danger-500\\/85{
  background-color: rgb(240 68 56 / 0.85);
}
.bg-danger-500\\/90{
  background-color: rgb(240 68 56 / 0.9);
}
.bg-danger-500\\/95{
  background-color: rgb(240 68 56 / 0.95);
}
.bg-danger-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}
.bg-danger-600\\/0{
  background-color: rgb(217 45 32 / 0);
}
.bg-danger-600\\/10{
  background-color: rgb(217 45 32 / 0.1);
}
.bg-danger-600\\/100{
  background-color: rgb(217 45 32 / 1);
}
.bg-danger-600\\/15{
  background-color: rgb(217 45 32 / 0.15);
}
.bg-danger-600\\/20{
  background-color: rgb(217 45 32 / 0.2);
}
.bg-danger-600\\/25{
  background-color: rgb(217 45 32 / 0.25);
}
.bg-danger-600\\/30{
  background-color: rgb(217 45 32 / 0.3);
}
.bg-danger-600\\/35{
  background-color: rgb(217 45 32 / 0.35);
}
.bg-danger-600\\/40{
  background-color: rgb(217 45 32 / 0.4);
}
.bg-danger-600\\/45{
  background-color: rgb(217 45 32 / 0.45);
}
.bg-danger-600\\/5{
  background-color: rgb(217 45 32 / 0.05);
}
.bg-danger-600\\/50{
  background-color: rgb(217 45 32 / 0.5);
}
.bg-danger-600\\/55{
  background-color: rgb(217 45 32 / 0.55);
}
.bg-danger-600\\/60{
  background-color: rgb(217 45 32 / 0.6);
}
.bg-danger-600\\/65{
  background-color: rgb(217 45 32 / 0.65);
}
.bg-danger-600\\/70{
  background-color: rgb(217 45 32 / 0.7);
}
.bg-danger-600\\/75{
  background-color: rgb(217 45 32 / 0.75);
}
.bg-danger-600\\/80{
  background-color: rgb(217 45 32 / 0.8);
}
.bg-danger-600\\/85{
  background-color: rgb(217 45 32 / 0.85);
}
.bg-danger-600\\/90{
  background-color: rgb(217 45 32 / 0.9);
}
.bg-danger-600\\/95{
  background-color: rgb(217 45 32 / 0.95);
}
.bg-danger-700{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}
.bg-danger-700\\/0{
  background-color: rgb(180 35 24 / 0);
}
.bg-danger-700\\/10{
  background-color: rgb(180 35 24 / 0.1);
}
.bg-danger-700\\/100{
  background-color: rgb(180 35 24 / 1);
}
.bg-danger-700\\/15{
  background-color: rgb(180 35 24 / 0.15);
}
.bg-danger-700\\/20{
  background-color: rgb(180 35 24 / 0.2);
}
.bg-danger-700\\/25{
  background-color: rgb(180 35 24 / 0.25);
}
.bg-danger-700\\/30{
  background-color: rgb(180 35 24 / 0.3);
}
.bg-danger-700\\/35{
  background-color: rgb(180 35 24 / 0.35);
}
.bg-danger-700\\/40{
  background-color: rgb(180 35 24 / 0.4);
}
.bg-danger-700\\/45{
  background-color: rgb(180 35 24 / 0.45);
}
.bg-danger-700\\/5{
  background-color: rgb(180 35 24 / 0.05);
}
.bg-danger-700\\/50{
  background-color: rgb(180 35 24 / 0.5);
}
.bg-danger-700\\/55{
  background-color: rgb(180 35 24 / 0.55);
}
.bg-danger-700\\/60{
  background-color: rgb(180 35 24 / 0.6);
}
.bg-danger-700\\/65{
  background-color: rgb(180 35 24 / 0.65);
}
.bg-danger-700\\/70{
  background-color: rgb(180 35 24 / 0.7);
}
.bg-danger-700\\/75{
  background-color: rgb(180 35 24 / 0.75);
}
.bg-danger-700\\/80{
  background-color: rgb(180 35 24 / 0.8);
}
.bg-danger-700\\/85{
  background-color: rgb(180 35 24 / 0.85);
}
.bg-danger-700\\/90{
  background-color: rgb(180 35 24 / 0.9);
}
.bg-danger-700\\/95{
  background-color: rgb(180 35 24 / 0.95);
}
.bg-danger-800{
  --tw-bg-opacity: 1;
  background-color: rgb(145 32 24 / var(--tw-bg-opacity, 1));
}
.bg-danger-800\\/0{
  background-color: rgb(145 32 24 / 0);
}
.bg-danger-800\\/10{
  background-color: rgb(145 32 24 / 0.1);
}
.bg-danger-800\\/100{
  background-color: rgb(145 32 24 / 1);
}
.bg-danger-800\\/15{
  background-color: rgb(145 32 24 / 0.15);
}
.bg-danger-800\\/20{
  background-color: rgb(145 32 24 / 0.2);
}
.bg-danger-800\\/25{
  background-color: rgb(145 32 24 / 0.25);
}
.bg-danger-800\\/30{
  background-color: rgb(145 32 24 / 0.3);
}
.bg-danger-800\\/35{
  background-color: rgb(145 32 24 / 0.35);
}
.bg-danger-800\\/40{
  background-color: rgb(145 32 24 / 0.4);
}
.bg-danger-800\\/45{
  background-color: rgb(145 32 24 / 0.45);
}
.bg-danger-800\\/5{
  background-color: rgb(145 32 24 / 0.05);
}
.bg-danger-800\\/50{
  background-color: rgb(145 32 24 / 0.5);
}
.bg-danger-800\\/55{
  background-color: rgb(145 32 24 / 0.55);
}
.bg-danger-800\\/60{
  background-color: rgb(145 32 24 / 0.6);
}
.bg-danger-800\\/65{
  background-color: rgb(145 32 24 / 0.65);
}
.bg-danger-800\\/70{
  background-color: rgb(145 32 24 / 0.7);
}
.bg-danger-800\\/75{
  background-color: rgb(145 32 24 / 0.75);
}
.bg-danger-800\\/80{
  background-color: rgb(145 32 24 / 0.8);
}
.bg-danger-800\\/85{
  background-color: rgb(145 32 24 / 0.85);
}
.bg-danger-800\\/90{
  background-color: rgb(145 32 24 / 0.9);
}
.bg-danger-800\\/95{
  background-color: rgb(145 32 24 / 0.95);
}
.bg-danger-900{
  --tw-bg-opacity: 1;
  background-color: rgb(122 39 26 / var(--tw-bg-opacity, 1));
}
.bg-danger-900\\/0{
  background-color: rgb(122 39 26 / 0);
}
.bg-danger-900\\/10{
  background-color: rgb(122 39 26 / 0.1);
}
.bg-danger-900\\/100{
  background-color: rgb(122 39 26 / 1);
}
.bg-danger-900\\/15{
  background-color: rgb(122 39 26 / 0.15);
}
.bg-danger-900\\/20{
  background-color: rgb(122 39 26 / 0.2);
}
.bg-danger-900\\/25{
  background-color: rgb(122 39 26 / 0.25);
}
.bg-danger-900\\/30{
  background-color: rgb(122 39 26 / 0.3);
}
.bg-danger-900\\/35{
  background-color: rgb(122 39 26 / 0.35);
}
.bg-danger-900\\/40{
  background-color: rgb(122 39 26 / 0.4);
}
.bg-danger-900\\/45{
  background-color: rgb(122 39 26 / 0.45);
}
.bg-danger-900\\/5{
  background-color: rgb(122 39 26 / 0.05);
}
.bg-danger-900\\/50{
  background-color: rgb(122 39 26 / 0.5);
}
.bg-danger-900\\/55{
  background-color: rgb(122 39 26 / 0.55);
}
.bg-danger-900\\/60{
  background-color: rgb(122 39 26 / 0.6);
}
.bg-danger-900\\/65{
  background-color: rgb(122 39 26 / 0.65);
}
.bg-danger-900\\/70{
  background-color: rgb(122 39 26 / 0.7);
}
.bg-danger-900\\/75{
  background-color: rgb(122 39 26 / 0.75);
}
.bg-danger-900\\/80{
  background-color: rgb(122 39 26 / 0.8);
}
.bg-danger-900\\/85{
  background-color: rgb(122 39 26 / 0.85);
}
.bg-danger-900\\/90{
  background-color: rgb(122 39 26 / 0.9);
}
.bg-danger-900\\/95{
  background-color: rgb(122 39 26 / 0.95);
}
.bg-danger-950{
  --tw-bg-opacity: 1;
  background-color: rgb(85 22 12 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-100{
  --tw-bg-opacity: 1;
  background-color: rgb(251 232 255 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.bg-green-light-100{
  --tw-bg-opacity: 1;
  background-color: rgb(228 251 204 / var(--tw-bg-opacity, 1));
}
.bg-green-light-200{
  --tw-bg-opacity: 1;
  background-color: rgb(208 248 171 / var(--tw-bg-opacity, 1));
}
.bg-green-light-50{
  --tw-bg-opacity: 1;
  background-color: rgb(243 254 231 / var(--tw-bg-opacity, 1));
}
.bg-green-light-500{
  --tw-bg-opacity: 1;
  background-color: rgb(102 198 28 / var(--tw-bg-opacity, 1));
}
.bg-moss-100{
  --tw-bg-opacity: 1;
  background-color: rgb(230 244 215 / var(--tw-bg-opacity, 1));
}
.bg-moss-100\\/0{
  background-color: rgb(230 244 215 / 0);
}
.bg-moss-100\\/10{
  background-color: rgb(230 244 215 / 0.1);
}
.bg-moss-100\\/100{
  background-color: rgb(230 244 215 / 1);
}
.bg-moss-100\\/15{
  background-color: rgb(230 244 215 / 0.15);
}
.bg-moss-100\\/20{
  background-color: rgb(230 244 215 / 0.2);
}
.bg-moss-100\\/25{
  background-color: rgb(230 244 215 / 0.25);
}
.bg-moss-100\\/30{
  background-color: rgb(230 244 215 / 0.3);
}
.bg-moss-100\\/35{
  background-color: rgb(230 244 215 / 0.35);
}
.bg-moss-100\\/40{
  background-color: rgb(230 244 215 / 0.4);
}
.bg-moss-100\\/45{
  background-color: rgb(230 244 215 / 0.45);
}
.bg-moss-100\\/5{
  background-color: rgb(230 244 215 / 0.05);
}
.bg-moss-100\\/50{
  background-color: rgb(230 244 215 / 0.5);
}
.bg-moss-100\\/55{
  background-color: rgb(230 244 215 / 0.55);
}
.bg-moss-100\\/60{
  background-color: rgb(230 244 215 / 0.6);
}
.bg-moss-100\\/65{
  background-color: rgb(230 244 215 / 0.65);
}
.bg-moss-100\\/70{
  background-color: rgb(230 244 215 / 0.7);
}
.bg-moss-100\\/75{
  background-color: rgb(230 244 215 / 0.75);
}
.bg-moss-100\\/80{
  background-color: rgb(230 244 215 / 0.8);
}
.bg-moss-100\\/85{
  background-color: rgb(230 244 215 / 0.85);
}
.bg-moss-100\\/90{
  background-color: rgb(230 244 215 / 0.9);
}
.bg-moss-100\\/95{
  background-color: rgb(230 244 215 / 0.95);
}
.bg-moss-200{
  --tw-bg-opacity: 1;
  background-color: rgb(206 234 176 / var(--tw-bg-opacity, 1));
}
.bg-moss-200\\/0{
  background-color: rgb(206 234 176 / 0);
}
.bg-moss-200\\/10{
  background-color: rgb(206 234 176 / 0.1);
}
.bg-moss-200\\/100{
  background-color: rgb(206 234 176 / 1);
}
.bg-moss-200\\/15{
  background-color: rgb(206 234 176 / 0.15);
}
.bg-moss-200\\/20{
  background-color: rgb(206 234 176 / 0.2);
}
.bg-moss-200\\/25{
  background-color: rgb(206 234 176 / 0.25);
}
.bg-moss-200\\/30{
  background-color: rgb(206 234 176 / 0.3);
}
.bg-moss-200\\/35{
  background-color: rgb(206 234 176 / 0.35);
}
.bg-moss-200\\/40{
  background-color: rgb(206 234 176 / 0.4);
}
.bg-moss-200\\/45{
  background-color: rgb(206 234 176 / 0.45);
}
.bg-moss-200\\/5{
  background-color: rgb(206 234 176 / 0.05);
}
.bg-moss-200\\/50{
  background-color: rgb(206 234 176 / 0.5);
}
.bg-moss-200\\/55{
  background-color: rgb(206 234 176 / 0.55);
}
.bg-moss-200\\/60{
  background-color: rgb(206 234 176 / 0.6);
}
.bg-moss-200\\/65{
  background-color: rgb(206 234 176 / 0.65);
}
.bg-moss-200\\/70{
  background-color: rgb(206 234 176 / 0.7);
}
.bg-moss-200\\/75{
  background-color: rgb(206 234 176 / 0.75);
}
.bg-moss-200\\/80{
  background-color: rgb(206 234 176 / 0.8);
}
.bg-moss-200\\/85{
  background-color: rgb(206 234 176 / 0.85);
}
.bg-moss-200\\/90{
  background-color: rgb(206 234 176 / 0.9);
}
.bg-moss-200\\/95{
  background-color: rgb(206 234 176 / 0.95);
}
.bg-moss-25{
  --tw-bg-opacity: 1;
  background-color: rgb(250 253 247 / var(--tw-bg-opacity, 1));
}
.bg-moss-25\\/0{
  background-color: rgb(250 253 247 / 0);
}
.bg-moss-25\\/10{
  background-color: rgb(250 253 247 / 0.1);
}
.bg-moss-25\\/100{
  background-color: rgb(250 253 247 / 1);
}
.bg-moss-25\\/15{
  background-color: rgb(250 253 247 / 0.15);
}
.bg-moss-25\\/20{
  background-color: rgb(250 253 247 / 0.2);
}
.bg-moss-25\\/25{
  background-color: rgb(250 253 247 / 0.25);
}
.bg-moss-25\\/30{
  background-color: rgb(250 253 247 / 0.3);
}
.bg-moss-25\\/35{
  background-color: rgb(250 253 247 / 0.35);
}
.bg-moss-25\\/40{
  background-color: rgb(250 253 247 / 0.4);
}
.bg-moss-25\\/45{
  background-color: rgb(250 253 247 / 0.45);
}
.bg-moss-25\\/5{
  background-color: rgb(250 253 247 / 0.05);
}
.bg-moss-25\\/50{
  background-color: rgb(250 253 247 / 0.5);
}
.bg-moss-25\\/55{
  background-color: rgb(250 253 247 / 0.55);
}
.bg-moss-25\\/60{
  background-color: rgb(250 253 247 / 0.6);
}
.bg-moss-25\\/65{
  background-color: rgb(250 253 247 / 0.65);
}
.bg-moss-25\\/70{
  background-color: rgb(250 253 247 / 0.7);
}
.bg-moss-25\\/75{
  background-color: rgb(250 253 247 / 0.75);
}
.bg-moss-25\\/80{
  background-color: rgb(250 253 247 / 0.8);
}
.bg-moss-25\\/85{
  background-color: rgb(250 253 247 / 0.85);
}
.bg-moss-25\\/90{
  background-color: rgb(250 253 247 / 0.9);
}
.bg-moss-25\\/95{
  background-color: rgb(250 253 247 / 0.95);
}
.bg-moss-300{
  --tw-bg-opacity: 1;
  background-color: rgb(172 220 121 / var(--tw-bg-opacity, 1));
}
.bg-moss-300\\/0{
  background-color: rgb(172 220 121 / 0);
}
.bg-moss-300\\/10{
  background-color: rgb(172 220 121 / 0.1);
}
.bg-moss-300\\/100{
  background-color: rgb(172 220 121 / 1);
}
.bg-moss-300\\/15{
  background-color: rgb(172 220 121 / 0.15);
}
.bg-moss-300\\/20{
  background-color: rgb(172 220 121 / 0.2);
}
.bg-moss-300\\/25{
  background-color: rgb(172 220 121 / 0.25);
}
.bg-moss-300\\/30{
  background-color: rgb(172 220 121 / 0.3);
}
.bg-moss-300\\/35{
  background-color: rgb(172 220 121 / 0.35);
}
.bg-moss-300\\/40{
  background-color: rgb(172 220 121 / 0.4);
}
.bg-moss-300\\/45{
  background-color: rgb(172 220 121 / 0.45);
}
.bg-moss-300\\/5{
  background-color: rgb(172 220 121 / 0.05);
}
.bg-moss-300\\/50{
  background-color: rgb(172 220 121 / 0.5);
}
.bg-moss-300\\/55{
  background-color: rgb(172 220 121 / 0.55);
}
.bg-moss-300\\/60{
  background-color: rgb(172 220 121 / 0.6);
}
.bg-moss-300\\/65{
  background-color: rgb(172 220 121 / 0.65);
}
.bg-moss-300\\/70{
  background-color: rgb(172 220 121 / 0.7);
}
.bg-moss-300\\/75{
  background-color: rgb(172 220 121 / 0.75);
}
.bg-moss-300\\/80{
  background-color: rgb(172 220 121 / 0.8);
}
.bg-moss-300\\/85{
  background-color: rgb(172 220 121 / 0.85);
}
.bg-moss-300\\/90{
  background-color: rgb(172 220 121 / 0.9);
}
.bg-moss-300\\/95{
  background-color: rgb(172 220 121 / 0.95);
}
.bg-moss-400{
  --tw-bg-opacity: 1;
  background-color: rgb(134 203 60 / var(--tw-bg-opacity, 1));
}
.bg-moss-400\\/0{
  background-color: rgb(134 203 60 / 0);
}
.bg-moss-400\\/10{
  background-color: rgb(134 203 60 / 0.1);
}
.bg-moss-400\\/100{
  background-color: rgb(134 203 60 / 1);
}
.bg-moss-400\\/15{
  background-color: rgb(134 203 60 / 0.15);
}
.bg-moss-400\\/20{
  background-color: rgb(134 203 60 / 0.2);
}
.bg-moss-400\\/25{
  background-color: rgb(134 203 60 / 0.25);
}
.bg-moss-400\\/30{
  background-color: rgb(134 203 60 / 0.3);
}
.bg-moss-400\\/35{
  background-color: rgb(134 203 60 / 0.35);
}
.bg-moss-400\\/40{
  background-color: rgb(134 203 60 / 0.4);
}
.bg-moss-400\\/45{
  background-color: rgb(134 203 60 / 0.45);
}
.bg-moss-400\\/5{
  background-color: rgb(134 203 60 / 0.05);
}
.bg-moss-400\\/50{
  background-color: rgb(134 203 60 / 0.5);
}
.bg-moss-400\\/55{
  background-color: rgb(134 203 60 / 0.55);
}
.bg-moss-400\\/60{
  background-color: rgb(134 203 60 / 0.6);
}
.bg-moss-400\\/65{
  background-color: rgb(134 203 60 / 0.65);
}
.bg-moss-400\\/70{
  background-color: rgb(134 203 60 / 0.7);
}
.bg-moss-400\\/75{
  background-color: rgb(134 203 60 / 0.75);
}
.bg-moss-400\\/80{
  background-color: rgb(134 203 60 / 0.8);
}
.bg-moss-400\\/85{
  background-color: rgb(134 203 60 / 0.85);
}
.bg-moss-400\\/90{
  background-color: rgb(134 203 60 / 0.9);
}
.bg-moss-400\\/95{
  background-color: rgb(134 203 60 / 0.95);
}
.bg-moss-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 238 / var(--tw-bg-opacity, 1));
}
.bg-moss-50\\/0{
  background-color: rgb(245 251 238 / 0);
}
.bg-moss-50\\/10{
  background-color: rgb(245 251 238 / 0.1);
}
.bg-moss-50\\/100{
  background-color: rgb(245 251 238 / 1);
}
.bg-moss-50\\/15{
  background-color: rgb(245 251 238 / 0.15);
}
.bg-moss-50\\/20{
  background-color: rgb(245 251 238 / 0.2);
}
.bg-moss-50\\/25{
  background-color: rgb(245 251 238 / 0.25);
}
.bg-moss-50\\/30{
  background-color: rgb(245 251 238 / 0.3);
}
.bg-moss-50\\/35{
  background-color: rgb(245 251 238 / 0.35);
}
.bg-moss-50\\/40{
  background-color: rgb(245 251 238 / 0.4);
}
.bg-moss-50\\/45{
  background-color: rgb(245 251 238 / 0.45);
}
.bg-moss-50\\/5{
  background-color: rgb(245 251 238 / 0.05);
}
.bg-moss-50\\/50{
  background-color: rgb(245 251 238 / 0.5);
}
.bg-moss-50\\/55{
  background-color: rgb(245 251 238 / 0.55);
}
.bg-moss-50\\/60{
  background-color: rgb(245 251 238 / 0.6);
}
.bg-moss-50\\/65{
  background-color: rgb(245 251 238 / 0.65);
}
.bg-moss-50\\/70{
  background-color: rgb(245 251 238 / 0.7);
}
.bg-moss-50\\/75{
  background-color: rgb(245 251 238 / 0.75);
}
.bg-moss-50\\/80{
  background-color: rgb(245 251 238 / 0.8);
}
.bg-moss-50\\/85{
  background-color: rgb(245 251 238 / 0.85);
}
.bg-moss-50\\/90{
  background-color: rgb(245 251 238 / 0.9);
}
.bg-moss-50\\/95{
  background-color: rgb(245 251 238 / 0.95);
}
.bg-moss-500{
  --tw-bg-opacity: 1;
  background-color: rgb(102 159 42 / var(--tw-bg-opacity, 1));
}
.bg-moss-500\\/0{
  background-color: rgb(102 159 42 / 0);
}
.bg-moss-500\\/10{
  background-color: rgb(102 159 42 / 0.1);
}
.bg-moss-500\\/100{
  background-color: rgb(102 159 42 / 1);
}
.bg-moss-500\\/15{
  background-color: rgb(102 159 42 / 0.15);
}
.bg-moss-500\\/20{
  background-color: rgb(102 159 42 / 0.2);
}
.bg-moss-500\\/25{
  background-color: rgb(102 159 42 / 0.25);
}
.bg-moss-500\\/30{
  background-color: rgb(102 159 42 / 0.3);
}
.bg-moss-500\\/35{
  background-color: rgb(102 159 42 / 0.35);
}
.bg-moss-500\\/40{
  background-color: rgb(102 159 42 / 0.4);
}
.bg-moss-500\\/45{
  background-color: rgb(102 159 42 / 0.45);
}
.bg-moss-500\\/5{
  background-color: rgb(102 159 42 / 0.05);
}
.bg-moss-500\\/50{
  background-color: rgb(102 159 42 / 0.5);
}
.bg-moss-500\\/55{
  background-color: rgb(102 159 42 / 0.55);
}
.bg-moss-500\\/60{
  background-color: rgb(102 159 42 / 0.6);
}
.bg-moss-500\\/65{
  background-color: rgb(102 159 42 / 0.65);
}
.bg-moss-500\\/70{
  background-color: rgb(102 159 42 / 0.7);
}
.bg-moss-500\\/75{
  background-color: rgb(102 159 42 / 0.75);
}
.bg-moss-500\\/80{
  background-color: rgb(102 159 42 / 0.8);
}
.bg-moss-500\\/85{
  background-color: rgb(102 159 42 / 0.85);
}
.bg-moss-500\\/90{
  background-color: rgb(102 159 42 / 0.9);
}
.bg-moss-500\\/95{
  background-color: rgb(102 159 42 / 0.95);
}
.bg-moss-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 122 33 / var(--tw-bg-opacity, 1));
}
.bg-moss-600\\/0{
  background-color: rgb(79 122 33 / 0);
}
.bg-moss-600\\/10{
  background-color: rgb(79 122 33 / 0.1);
}
.bg-moss-600\\/100{
  background-color: rgb(79 122 33 / 1);
}
.bg-moss-600\\/15{
  background-color: rgb(79 122 33 / 0.15);
}
.bg-moss-600\\/20{
  background-color: rgb(79 122 33 / 0.2);
}
.bg-moss-600\\/25{
  background-color: rgb(79 122 33 / 0.25);
}
.bg-moss-600\\/30{
  background-color: rgb(79 122 33 / 0.3);
}
.bg-moss-600\\/35{
  background-color: rgb(79 122 33 / 0.35);
}
.bg-moss-600\\/40{
  background-color: rgb(79 122 33 / 0.4);
}
.bg-moss-600\\/45{
  background-color: rgb(79 122 33 / 0.45);
}
.bg-moss-600\\/5{
  background-color: rgb(79 122 33 / 0.05);
}
.bg-moss-600\\/50{
  background-color: rgb(79 122 33 / 0.5);
}
.bg-moss-600\\/55{
  background-color: rgb(79 122 33 / 0.55);
}
.bg-moss-600\\/60{
  background-color: rgb(79 122 33 / 0.6);
}
.bg-moss-600\\/65{
  background-color: rgb(79 122 33 / 0.65);
}
.bg-moss-600\\/70{
  background-color: rgb(79 122 33 / 0.7);
}
.bg-moss-600\\/75{
  background-color: rgb(79 122 33 / 0.75);
}
.bg-moss-600\\/80{
  background-color: rgb(79 122 33 / 0.8);
}
.bg-moss-600\\/85{
  background-color: rgb(79 122 33 / 0.85);
}
.bg-moss-600\\/90{
  background-color: rgb(79 122 33 / 0.9);
}
.bg-moss-600\\/95{
  background-color: rgb(79 122 33 / 0.95);
}
.bg-moss-700{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 26 / var(--tw-bg-opacity, 1));
}
.bg-moss-700\\/0{
  background-color: rgb(63 98 26 / 0);
}
.bg-moss-700\\/10{
  background-color: rgb(63 98 26 / 0.1);
}
.bg-moss-700\\/100{
  background-color: rgb(63 98 26 / 1);
}
.bg-moss-700\\/15{
  background-color: rgb(63 98 26 / 0.15);
}
.bg-moss-700\\/20{
  background-color: rgb(63 98 26 / 0.2);
}
.bg-moss-700\\/25{
  background-color: rgb(63 98 26 / 0.25);
}
.bg-moss-700\\/30{
  background-color: rgb(63 98 26 / 0.3);
}
.bg-moss-700\\/35{
  background-color: rgb(63 98 26 / 0.35);
}
.bg-moss-700\\/40{
  background-color: rgb(63 98 26 / 0.4);
}
.bg-moss-700\\/45{
  background-color: rgb(63 98 26 / 0.45);
}
.bg-moss-700\\/5{
  background-color: rgb(63 98 26 / 0.05);
}
.bg-moss-700\\/50{
  background-color: rgb(63 98 26 / 0.5);
}
.bg-moss-700\\/55{
  background-color: rgb(63 98 26 / 0.55);
}
.bg-moss-700\\/60{
  background-color: rgb(63 98 26 / 0.6);
}
.bg-moss-700\\/65{
  background-color: rgb(63 98 26 / 0.65);
}
.bg-moss-700\\/70{
  background-color: rgb(63 98 26 / 0.7);
}
.bg-moss-700\\/75{
  background-color: rgb(63 98 26 / 0.75);
}
.bg-moss-700\\/80{
  background-color: rgb(63 98 26 / 0.8);
}
.bg-moss-700\\/85{
  background-color: rgb(63 98 26 / 0.85);
}
.bg-moss-700\\/90{
  background-color: rgb(63 98 26 / 0.9);
}
.bg-moss-700\\/95{
  background-color: rgb(63 98 26 / 0.95);
}
.bg-moss-800{
  --tw-bg-opacity: 1;
  background-color: rgb(51 80 21 / var(--tw-bg-opacity, 1));
}
.bg-moss-800\\/0{
  background-color: rgb(51 80 21 / 0);
}
.bg-moss-800\\/10{
  background-color: rgb(51 80 21 / 0.1);
}
.bg-moss-800\\/100{
  background-color: rgb(51 80 21 / 1);
}
.bg-moss-800\\/15{
  background-color: rgb(51 80 21 / 0.15);
}
.bg-moss-800\\/20{
  background-color: rgb(51 80 21 / 0.2);
}
.bg-moss-800\\/25{
  background-color: rgb(51 80 21 / 0.25);
}
.bg-moss-800\\/30{
  background-color: rgb(51 80 21 / 0.3);
}
.bg-moss-800\\/35{
  background-color: rgb(51 80 21 / 0.35);
}
.bg-moss-800\\/40{
  background-color: rgb(51 80 21 / 0.4);
}
.bg-moss-800\\/45{
  background-color: rgb(51 80 21 / 0.45);
}
.bg-moss-800\\/5{
  background-color: rgb(51 80 21 / 0.05);
}
.bg-moss-800\\/50{
  background-color: rgb(51 80 21 / 0.5);
}
.bg-moss-800\\/55{
  background-color: rgb(51 80 21 / 0.55);
}
.bg-moss-800\\/60{
  background-color: rgb(51 80 21 / 0.6);
}
.bg-moss-800\\/65{
  background-color: rgb(51 80 21 / 0.65);
}
.bg-moss-800\\/70{
  background-color: rgb(51 80 21 / 0.7);
}
.bg-moss-800\\/75{
  background-color: rgb(51 80 21 / 0.75);
}
.bg-moss-800\\/80{
  background-color: rgb(51 80 21 / 0.8);
}
.bg-moss-800\\/85{
  background-color: rgb(51 80 21 / 0.85);
}
.bg-moss-800\\/90{
  background-color: rgb(51 80 21 / 0.9);
}
.bg-moss-800\\/95{
  background-color: rgb(51 80 21 / 0.95);
}
.bg-moss-900{
  --tw-bg-opacity: 1;
  background-color: rgb(43 66 18 / var(--tw-bg-opacity, 1));
}
.bg-moss-900\\/0{
  background-color: rgb(43 66 18 / 0);
}
.bg-moss-900\\/10{
  background-color: rgb(43 66 18 / 0.1);
}
.bg-moss-900\\/100{
  background-color: rgb(43 66 18 / 1);
}
.bg-moss-900\\/15{
  background-color: rgb(43 66 18 / 0.15);
}
.bg-moss-900\\/20{
  background-color: rgb(43 66 18 / 0.2);
}
.bg-moss-900\\/25{
  background-color: rgb(43 66 18 / 0.25);
}
.bg-moss-900\\/30{
  background-color: rgb(43 66 18 / 0.3);
}
.bg-moss-900\\/35{
  background-color: rgb(43 66 18 / 0.35);
}
.bg-moss-900\\/40{
  background-color: rgb(43 66 18 / 0.4);
}
.bg-moss-900\\/45{
  background-color: rgb(43 66 18 / 0.45);
}
.bg-moss-900\\/5{
  background-color: rgb(43 66 18 / 0.05);
}
.bg-moss-900\\/50{
  background-color: rgb(43 66 18 / 0.5);
}
.bg-moss-900\\/55{
  background-color: rgb(43 66 18 / 0.55);
}
.bg-moss-900\\/60{
  background-color: rgb(43 66 18 / 0.6);
}
.bg-moss-900\\/65{
  background-color: rgb(43 66 18 / 0.65);
}
.bg-moss-900\\/70{
  background-color: rgb(43 66 18 / 0.7);
}
.bg-moss-900\\/75{
  background-color: rgb(43 66 18 / 0.75);
}
.bg-moss-900\\/80{
  background-color: rgb(43 66 18 / 0.8);
}
.bg-moss-900\\/85{
  background-color: rgb(43 66 18 / 0.85);
}
.bg-moss-900\\/90{
  background-color: rgb(43 66 18 / 0.9);
}
.bg-moss-900\\/95{
  background-color: rgb(43 66 18 / 0.95);
}
.bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-neutral-100\\/0{
  background-color: rgb(245 245 245 / 0);
}
.bg-neutral-100\\/10{
  background-color: rgb(245 245 245 / 0.1);
}
.bg-neutral-100\\/100{
  background-color: rgb(245 245 245 / 1);
}
.bg-neutral-100\\/15{
  background-color: rgb(245 245 245 / 0.15);
}
.bg-neutral-100\\/20{
  background-color: rgb(245 245 245 / 0.2);
}
.bg-neutral-100\\/25{
  background-color: rgb(245 245 245 / 0.25);
}
.bg-neutral-100\\/30{
  background-color: rgb(245 245 245 / 0.3);
}
.bg-neutral-100\\/35{
  background-color: rgb(245 245 245 / 0.35);
}
.bg-neutral-100\\/40{
  background-color: rgb(245 245 245 / 0.4);
}
.bg-neutral-100\\/45{
  background-color: rgb(245 245 245 / 0.45);
}
.bg-neutral-100\\/5{
  background-color: rgb(245 245 245 / 0.05);
}
.bg-neutral-100\\/50{
  background-color: rgb(245 245 245 / 0.5);
}
.bg-neutral-100\\/55{
  background-color: rgb(245 245 245 / 0.55);
}
.bg-neutral-100\\/60{
  background-color: rgb(245 245 245 / 0.6);
}
.bg-neutral-100\\/65{
  background-color: rgb(245 245 245 / 0.65);
}
.bg-neutral-100\\/70{
  background-color: rgb(245 245 245 / 0.7);
}
.bg-neutral-100\\/75{
  background-color: rgb(245 245 245 / 0.75);
}
.bg-neutral-100\\/80{
  background-color: rgb(245 245 245 / 0.8);
}
.bg-neutral-100\\/85{
  background-color: rgb(245 245 245 / 0.85);
}
.bg-neutral-100\\/90{
  background-color: rgb(245 245 245 / 0.9);
}
.bg-neutral-100\\/95{
  background-color: rgb(245 245 245 / 0.95);
}
.bg-neutral-200{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}
.bg-neutral-200\\/0{
  background-color: rgb(233 234 235 / 0);
}
.bg-neutral-200\\/10{
  background-color: rgb(233 234 235 / 0.1);
}
.bg-neutral-200\\/100{
  background-color: rgb(233 234 235 / 1);
}
.bg-neutral-200\\/15{
  background-color: rgb(233 234 235 / 0.15);
}
.bg-neutral-200\\/20{
  background-color: rgb(233 234 235 / 0.2);
}
.bg-neutral-200\\/25{
  background-color: rgb(233 234 235 / 0.25);
}
.bg-neutral-200\\/30{
  background-color: rgb(233 234 235 / 0.3);
}
.bg-neutral-200\\/35{
  background-color: rgb(233 234 235 / 0.35);
}
.bg-neutral-200\\/40{
  background-color: rgb(233 234 235 / 0.4);
}
.bg-neutral-200\\/45{
  background-color: rgb(233 234 235 / 0.45);
}
.bg-neutral-200\\/5{
  background-color: rgb(233 234 235 / 0.05);
}
.bg-neutral-200\\/50{
  background-color: rgb(233 234 235 / 0.5);
}
.bg-neutral-200\\/55{
  background-color: rgb(233 234 235 / 0.55);
}
.bg-neutral-200\\/60{
  background-color: rgb(233 234 235 / 0.6);
}
.bg-neutral-200\\/65{
  background-color: rgb(233 234 235 / 0.65);
}
.bg-neutral-200\\/70{
  background-color: rgb(233 234 235 / 0.7);
}
.bg-neutral-200\\/75{
  background-color: rgb(233 234 235 / 0.75);
}
.bg-neutral-200\\/80{
  background-color: rgb(233 234 235 / 0.8);
}
.bg-neutral-200\\/85{
  background-color: rgb(233 234 235 / 0.85);
}
.bg-neutral-200\\/90{
  background-color: rgb(233 234 235 / 0.9);
}
.bg-neutral-200\\/95{
  background-color: rgb(233 234 235 / 0.95);
}
.bg-neutral-25{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.bg-neutral-25\\/0{
  background-color: rgb(253 253 253 / 0);
}
.bg-neutral-25\\/10{
  background-color: rgb(253 253 253 / 0.1);
}
.bg-neutral-25\\/100{
  background-color: rgb(253 253 253 / 1);
}
.bg-neutral-25\\/15{
  background-color: rgb(253 253 253 / 0.15);
}
.bg-neutral-25\\/20{
  background-color: rgb(253 253 253 / 0.2);
}
.bg-neutral-25\\/25{
  background-color: rgb(253 253 253 / 0.25);
}
.bg-neutral-25\\/30{
  background-color: rgb(253 253 253 / 0.3);
}
.bg-neutral-25\\/35{
  background-color: rgb(253 253 253 / 0.35);
}
.bg-neutral-25\\/40{
  background-color: rgb(253 253 253 / 0.4);
}
.bg-neutral-25\\/45{
  background-color: rgb(253 253 253 / 0.45);
}
.bg-neutral-25\\/5{
  background-color: rgb(253 253 253 / 0.05);
}
.bg-neutral-25\\/50{
  background-color: rgb(253 253 253 / 0.5);
}
.bg-neutral-25\\/55{
  background-color: rgb(253 253 253 / 0.55);
}
.bg-neutral-25\\/60{
  background-color: rgb(253 253 253 / 0.6);
}
.bg-neutral-25\\/65{
  background-color: rgb(253 253 253 / 0.65);
}
.bg-neutral-25\\/70{
  background-color: rgb(253 253 253 / 0.7);
}
.bg-neutral-25\\/75{
  background-color: rgb(253 253 253 / 0.75);
}
.bg-neutral-25\\/80{
  background-color: rgb(253 253 253 / 0.8);
}
.bg-neutral-25\\/85{
  background-color: rgb(253 253 253 / 0.85);
}
.bg-neutral-25\\/90{
  background-color: rgb(253 253 253 / 0.9);
}
.bg-neutral-25\\/95{
  background-color: rgb(253 253 253 / 0.95);
}
.bg-neutral-300{
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1));
}
.bg-neutral-300\\/0{
  background-color: rgb(213 215 218 / 0);
}
.bg-neutral-300\\/10{
  background-color: rgb(213 215 218 / 0.1);
}
.bg-neutral-300\\/100{
  background-color: rgb(213 215 218 / 1);
}
.bg-neutral-300\\/15{
  background-color: rgb(213 215 218 / 0.15);
}
.bg-neutral-300\\/20{
  background-color: rgb(213 215 218 / 0.2);
}
.bg-neutral-300\\/25{
  background-color: rgb(213 215 218 / 0.25);
}
.bg-neutral-300\\/30{
  background-color: rgb(213 215 218 / 0.3);
}
.bg-neutral-300\\/35{
  background-color: rgb(213 215 218 / 0.35);
}
.bg-neutral-300\\/40{
  background-color: rgb(213 215 218 / 0.4);
}
.bg-neutral-300\\/45{
  background-color: rgb(213 215 218 / 0.45);
}
.bg-neutral-300\\/5{
  background-color: rgb(213 215 218 / 0.05);
}
.bg-neutral-300\\/50{
  background-color: rgb(213 215 218 / 0.5);
}
.bg-neutral-300\\/55{
  background-color: rgb(213 215 218 / 0.55);
}
.bg-neutral-300\\/60{
  background-color: rgb(213 215 218 / 0.6);
}
.bg-neutral-300\\/65{
  background-color: rgb(213 215 218 / 0.65);
}
.bg-neutral-300\\/70{
  background-color: rgb(213 215 218 / 0.7);
}
.bg-neutral-300\\/75{
  background-color: rgb(213 215 218 / 0.75);
}
.bg-neutral-300\\/80{
  background-color: rgb(213 215 218 / 0.8);
}
.bg-neutral-300\\/85{
  background-color: rgb(213 215 218 / 0.85);
}
.bg-neutral-300\\/90{
  background-color: rgb(213 215 218 / 0.9);
}
.bg-neutral-300\\/95{
  background-color: rgb(213 215 218 / 0.95);
}
.bg-neutral-400{
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}
.bg-neutral-400\\/0{
  background-color: rgb(164 167 174 / 0);
}
.bg-neutral-400\\/10{
  background-color: rgb(164 167 174 / 0.1);
}
.bg-neutral-400\\/100{
  background-color: rgb(164 167 174 / 1);
}
.bg-neutral-400\\/15{
  background-color: rgb(164 167 174 / 0.15);
}
.bg-neutral-400\\/20{
  background-color: rgb(164 167 174 / 0.2);
}
.bg-neutral-400\\/25{
  background-color: rgb(164 167 174 / 0.25);
}
.bg-neutral-400\\/30{
  background-color: rgb(164 167 174 / 0.3);
}
.bg-neutral-400\\/35{
  background-color: rgb(164 167 174 / 0.35);
}
.bg-neutral-400\\/40{
  background-color: rgb(164 167 174 / 0.4);
}
.bg-neutral-400\\/45{
  background-color: rgb(164 167 174 / 0.45);
}
.bg-neutral-400\\/5{
  background-color: rgb(164 167 174 / 0.05);
}
.bg-neutral-400\\/50{
  background-color: rgb(164 167 174 / 0.5);
}
.bg-neutral-400\\/55{
  background-color: rgb(164 167 174 / 0.55);
}
.bg-neutral-400\\/60{
  background-color: rgb(164 167 174 / 0.6);
}
.bg-neutral-400\\/65{
  background-color: rgb(164 167 174 / 0.65);
}
.bg-neutral-400\\/70{
  background-color: rgb(164 167 174 / 0.7);
}
.bg-neutral-400\\/75{
  background-color: rgb(164 167 174 / 0.75);
}
.bg-neutral-400\\/80{
  background-color: rgb(164 167 174 / 0.8);
}
.bg-neutral-400\\/85{
  background-color: rgb(164 167 174 / 0.85);
}
.bg-neutral-400\\/90{
  background-color: rgb(164 167 174 / 0.9);
}
.bg-neutral-400\\/95{
  background-color: rgb(164 167 174 / 0.95);
}
.bg-neutral-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}
.bg-neutral-50\\/0{
  background-color: rgb(249 250 250 / 0);
}
.bg-neutral-50\\/10{
  background-color: rgb(249 250 250 / 0.1);
}
.bg-neutral-50\\/100{
  background-color: rgb(249 250 250 / 1);
}
.bg-neutral-50\\/15{
  background-color: rgb(249 250 250 / 0.15);
}
.bg-neutral-50\\/20{
  background-color: rgb(249 250 250 / 0.2);
}
.bg-neutral-50\\/25{
  background-color: rgb(249 250 250 / 0.25);
}
.bg-neutral-50\\/30{
  background-color: rgb(249 250 250 / 0.3);
}
.bg-neutral-50\\/35{
  background-color: rgb(249 250 250 / 0.35);
}
.bg-neutral-50\\/40{
  background-color: rgb(249 250 250 / 0.4);
}
.bg-neutral-50\\/45{
  background-color: rgb(249 250 250 / 0.45);
}
.bg-neutral-50\\/5{
  background-color: rgb(249 250 250 / 0.05);
}
.bg-neutral-50\\/50{
  background-color: rgb(249 250 250 / 0.5);
}
.bg-neutral-50\\/55{
  background-color: rgb(249 250 250 / 0.55);
}
.bg-neutral-50\\/60{
  background-color: rgb(249 250 250 / 0.6);
}
.bg-neutral-50\\/65{
  background-color: rgb(249 250 250 / 0.65);
}
.bg-neutral-50\\/70{
  background-color: rgb(249 250 250 / 0.7);
}
.bg-neutral-50\\/75{
  background-color: rgb(249 250 250 / 0.75);
}
.bg-neutral-50\\/80{
  background-color: rgb(249 250 250 / 0.8);
}
.bg-neutral-50\\/85{
  background-color: rgb(249 250 250 / 0.85);
}
.bg-neutral-50\\/90{
  background-color: rgb(249 250 250 / 0.9);
}
.bg-neutral-50\\/95{
  background-color: rgb(249 250 250 / 0.95);
}
.bg-neutral-500{
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}
.bg-neutral-500\\/0{
  background-color: rgb(113 118 128 / 0);
}
.bg-neutral-500\\/10{
  background-color: rgb(113 118 128 / 0.1);
}
.bg-neutral-500\\/100{
  background-color: rgb(113 118 128 / 1);
}
.bg-neutral-500\\/15{
  background-color: rgb(113 118 128 / 0.15);
}
.bg-neutral-500\\/20{
  background-color: rgb(113 118 128 / 0.2);
}
.bg-neutral-500\\/25{
  background-color: rgb(113 118 128 / 0.25);
}
.bg-neutral-500\\/30{
  background-color: rgb(113 118 128 / 0.3);
}
.bg-neutral-500\\/35{
  background-color: rgb(113 118 128 / 0.35);
}
.bg-neutral-500\\/40{
  background-color: rgb(113 118 128 / 0.4);
}
.bg-neutral-500\\/45{
  background-color: rgb(113 118 128 / 0.45);
}
.bg-neutral-500\\/5{
  background-color: rgb(113 118 128 / 0.05);
}
.bg-neutral-500\\/50{
  background-color: rgb(113 118 128 / 0.5);
}
.bg-neutral-500\\/55{
  background-color: rgb(113 118 128 / 0.55);
}
.bg-neutral-500\\/60{
  background-color: rgb(113 118 128 / 0.6);
}
.bg-neutral-500\\/65{
  background-color: rgb(113 118 128 / 0.65);
}
.bg-neutral-500\\/70{
  background-color: rgb(113 118 128 / 0.7);
}
.bg-neutral-500\\/75{
  background-color: rgb(113 118 128 / 0.75);
}
.bg-neutral-500\\/80{
  background-color: rgb(113 118 128 / 0.8);
}
.bg-neutral-500\\/85{
  background-color: rgb(113 118 128 / 0.85);
}
.bg-neutral-500\\/90{
  background-color: rgb(113 118 128 / 0.9);
}
.bg-neutral-500\\/95{
  background-color: rgb(113 118 128 / 0.95);
}
.bg-neutral-600{
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}
.bg-neutral-600\\/0{
  background-color: rgb(83 88 98 / 0);
}
.bg-neutral-600\\/10{
  background-color: rgb(83 88 98 / 0.1);
}
.bg-neutral-600\\/100{
  background-color: rgb(83 88 98 / 1);
}
.bg-neutral-600\\/15{
  background-color: rgb(83 88 98 / 0.15);
}
.bg-neutral-600\\/20{
  background-color: rgb(83 88 98 / 0.2);
}
.bg-neutral-600\\/25{
  background-color: rgb(83 88 98 / 0.25);
}
.bg-neutral-600\\/30{
  background-color: rgb(83 88 98 / 0.3);
}
.bg-neutral-600\\/35{
  background-color: rgb(83 88 98 / 0.35);
}
.bg-neutral-600\\/40{
  background-color: rgb(83 88 98 / 0.4);
}
.bg-neutral-600\\/45{
  background-color: rgb(83 88 98 / 0.45);
}
.bg-neutral-600\\/5{
  background-color: rgb(83 88 98 / 0.05);
}
.bg-neutral-600\\/50{
  background-color: rgb(83 88 98 / 0.5);
}
.bg-neutral-600\\/55{
  background-color: rgb(83 88 98 / 0.55);
}
.bg-neutral-600\\/60{
  background-color: rgb(83 88 98 / 0.6);
}
.bg-neutral-600\\/65{
  background-color: rgb(83 88 98 / 0.65);
}
.bg-neutral-600\\/70{
  background-color: rgb(83 88 98 / 0.7);
}
.bg-neutral-600\\/75{
  background-color: rgb(83 88 98 / 0.75);
}
.bg-neutral-600\\/80{
  background-color: rgb(83 88 98 / 0.8);
}
.bg-neutral-600\\/85{
  background-color: rgb(83 88 98 / 0.85);
}
.bg-neutral-600\\/90{
  background-color: rgb(83 88 98 / 0.9);
}
.bg-neutral-600\\/95{
  background-color: rgb(83 88 98 / 0.95);
}
.bg-neutral-700{
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}
.bg-neutral-700\\/0{
  background-color: rgb(65 70 81 / 0);
}
.bg-neutral-700\\/10{
  background-color: rgb(65 70 81 / 0.1);
}
.bg-neutral-700\\/100{
  background-color: rgb(65 70 81 / 1);
}
.bg-neutral-700\\/15{
  background-color: rgb(65 70 81 / 0.15);
}
.bg-neutral-700\\/20{
  background-color: rgb(65 70 81 / 0.2);
}
.bg-neutral-700\\/25{
  background-color: rgb(65 70 81 / 0.25);
}
.bg-neutral-700\\/30{
  background-color: rgb(65 70 81 / 0.3);
}
.bg-neutral-700\\/35{
  background-color: rgb(65 70 81 / 0.35);
}
.bg-neutral-700\\/40{
  background-color: rgb(65 70 81 / 0.4);
}
.bg-neutral-700\\/45{
  background-color: rgb(65 70 81 / 0.45);
}
.bg-neutral-700\\/5{
  background-color: rgb(65 70 81 / 0.05);
}
.bg-neutral-700\\/50{
  background-color: rgb(65 70 81 / 0.5);
}
.bg-neutral-700\\/55{
  background-color: rgb(65 70 81 / 0.55);
}
.bg-neutral-700\\/60{
  background-color: rgb(65 70 81 / 0.6);
}
.bg-neutral-700\\/65{
  background-color: rgb(65 70 81 / 0.65);
}
.bg-neutral-700\\/70{
  background-color: rgb(65 70 81 / 0.7);
}
.bg-neutral-700\\/75{
  background-color: rgb(65 70 81 / 0.75);
}
.bg-neutral-700\\/80{
  background-color: rgb(65 70 81 / 0.8);
}
.bg-neutral-700\\/85{
  background-color: rgb(65 70 81 / 0.85);
}
.bg-neutral-700\\/90{
  background-color: rgb(65 70 81 / 0.9);
}
.bg-neutral-700\\/95{
  background-color: rgb(65 70 81 / 0.95);
}
.bg-neutral-75{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}
.bg-neutral-75\\/0{
  background-color: rgb(246 246 246 / 0);
}
.bg-neutral-75\\/10{
  background-color: rgb(246 246 246 / 0.1);
}
.bg-neutral-75\\/100{
  background-color: rgb(246 246 246 / 1);
}
.bg-neutral-75\\/15{
  background-color: rgb(246 246 246 / 0.15);
}
.bg-neutral-75\\/20{
  background-color: rgb(246 246 246 / 0.2);
}
.bg-neutral-75\\/25{
  background-color: rgb(246 246 246 / 0.25);
}
.bg-neutral-75\\/30{
  background-color: rgb(246 246 246 / 0.3);
}
.bg-neutral-75\\/35{
  background-color: rgb(246 246 246 / 0.35);
}
.bg-neutral-75\\/40{
  background-color: rgb(246 246 246 / 0.4);
}
.bg-neutral-75\\/45{
  background-color: rgb(246 246 246 / 0.45);
}
.bg-neutral-75\\/5{
  background-color: rgb(246 246 246 / 0.05);
}
.bg-neutral-75\\/50{
  background-color: rgb(246 246 246 / 0.5);
}
.bg-neutral-75\\/55{
  background-color: rgb(246 246 246 / 0.55);
}
.bg-neutral-75\\/60{
  background-color: rgb(246 246 246 / 0.6);
}
.bg-neutral-75\\/65{
  background-color: rgb(246 246 246 / 0.65);
}
.bg-neutral-75\\/70{
  background-color: rgb(246 246 246 / 0.7);
}
.bg-neutral-75\\/75{
  background-color: rgb(246 246 246 / 0.75);
}
.bg-neutral-75\\/80{
  background-color: rgb(246 246 246 / 0.8);
}
.bg-neutral-75\\/85{
  background-color: rgb(246 246 246 / 0.85);
}
.bg-neutral-75\\/90{
  background-color: rgb(246 246 246 / 0.9);
}
.bg-neutral-75\\/95{
  background-color: rgb(246 246 246 / 0.95);
}
.bg-neutral-800{
  --tw-bg-opacity: 1;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1));
}
.bg-neutral-800\\/0{
  background-color: rgb(37 43 55 / 0);
}
.bg-neutral-800\\/10{
  background-color: rgb(37 43 55 / 0.1);
}
.bg-neutral-800\\/100{
  background-color: rgb(37 43 55 / 1);
}
.bg-neutral-800\\/15{
  background-color: rgb(37 43 55 / 0.15);
}
.bg-neutral-800\\/20{
  background-color: rgb(37 43 55 / 0.2);
}
.bg-neutral-800\\/25{
  background-color: rgb(37 43 55 / 0.25);
}
.bg-neutral-800\\/30{
  background-color: rgb(37 43 55 / 0.3);
}
.bg-neutral-800\\/35{
  background-color: rgb(37 43 55 / 0.35);
}
.bg-neutral-800\\/40{
  background-color: rgb(37 43 55 / 0.4);
}
.bg-neutral-800\\/45{
  background-color: rgb(37 43 55 / 0.45);
}
.bg-neutral-800\\/5{
  background-color: rgb(37 43 55 / 0.05);
}
.bg-neutral-800\\/50{
  background-color: rgb(37 43 55 / 0.5);
}
.bg-neutral-800\\/55{
  background-color: rgb(37 43 55 / 0.55);
}
.bg-neutral-800\\/60{
  background-color: rgb(37 43 55 / 0.6);
}
.bg-neutral-800\\/65{
  background-color: rgb(37 43 55 / 0.65);
}
.bg-neutral-800\\/70{
  background-color: rgb(37 43 55 / 0.7);
}
.bg-neutral-800\\/75{
  background-color: rgb(37 43 55 / 0.75);
}
.bg-neutral-800\\/80{
  background-color: rgb(37 43 55 / 0.8);
}
.bg-neutral-800\\/85{
  background-color: rgb(37 43 55 / 0.85);
}
.bg-neutral-800\\/90{
  background-color: rgb(37 43 55 / 0.9);
}
.bg-neutral-800\\/95{
  background-color: rgb(37 43 55 / 0.95);
}
.bg-neutral-900{
  --tw-bg-opacity: 1;
  background-color: rgb(24 29 39 / var(--tw-bg-opacity, 1));
}
.bg-neutral-900\\/0{
  background-color: rgb(24 29 39 / 0);
}
.bg-neutral-900\\/10{
  background-color: rgb(24 29 39 / 0.1);
}
.bg-neutral-900\\/100{
  background-color: rgb(24 29 39 / 1);
}
.bg-neutral-900\\/15{
  background-color: rgb(24 29 39 / 0.15);
}
.bg-neutral-900\\/20{
  background-color: rgb(24 29 39 / 0.2);
}
.bg-neutral-900\\/25{
  background-color: rgb(24 29 39 / 0.25);
}
.bg-neutral-900\\/30{
  background-color: rgb(24 29 39 / 0.3);
}
.bg-neutral-900\\/35{
  background-color: rgb(24 29 39 / 0.35);
}
.bg-neutral-900\\/40{
  background-color: rgb(24 29 39 / 0.4);
}
.bg-neutral-900\\/45{
  background-color: rgb(24 29 39 / 0.45);
}
.bg-neutral-900\\/5{
  background-color: rgb(24 29 39 / 0.05);
}
.bg-neutral-900\\/50{
  background-color: rgb(24 29 39 / 0.5);
}
.bg-neutral-900\\/55{
  background-color: rgb(24 29 39 / 0.55);
}
.bg-neutral-900\\/60{
  background-color: rgb(24 29 39 / 0.6);
}
.bg-neutral-900\\/65{
  background-color: rgb(24 29 39 / 0.65);
}
.bg-neutral-900\\/70{
  background-color: rgb(24 29 39 / 0.7);
}
.bg-neutral-900\\/75{
  background-color: rgb(24 29 39 / 0.75);
}
.bg-neutral-900\\/80{
  background-color: rgb(24 29 39 / 0.8);
}
.bg-neutral-900\\/85{
  background-color: rgb(24 29 39 / 0.85);
}
.bg-neutral-900\\/90{
  background-color: rgb(24 29 39 / 0.9);
}
.bg-neutral-900\\/95{
  background-color: rgb(24 29 39 / 0.95);
}
.bg-neutral-dark-25{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-neutral-dark-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 58 65 / var(--tw-bg-opacity, 1));
}
.bg-neutral-dark-800{
  --tw-bg-opacity: 1;
  background-color: rgb(34 38 47 / var(--tw-bg-opacity, 1));
}
.bg-neutral-dark-900{
  --tw-bg-opacity: 1;
  background-color: rgb(19 22 27 / var(--tw-bg-opacity, 1));
}
.bg-neutral-dark-950{
  --tw-bg-opacity: 1;
  background-color: rgb(12 14 18 / var(--tw-bg-opacity, 1));
}
.bg-orange-dark-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-dark-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 237 / var(--tw-bg-opacity, 1));
}
.bg-primary-10{
  background-color: var(--color-primary-10, #FAFDFF);
}
.bg-primary-100{
  background-color: var(--color-primary-100, #E0F2FE);
}
.bg-primary-200{
  background-color: var(--color-primary-200, #B9E6FE);
}
.bg-primary-25{
  background-color: var(--color-primary-25, #F5FBFF);
}
.bg-primary-300{
  background-color: var(--color-primary-300, #7CD4FD);
}
.bg-primary-400{
  background-color: var(--color-primary-400, #36BFFA);
}
.bg-primary-50{
  background-color: var(--color-primary-50, #F0F9FF);
}
.bg-primary-500{
  background-color: var(--color-primary-500, #0BA5EC);
}
.bg-primary-600{
  background-color: var(--color-primary-600, #0086C9);
}
.bg-primary-700{
  background-color: var(--color-primary-700, #026AA2);
}
.bg-primary-800{
  background-color: var(--color-primary-800, #065986);
}
.bg-primary-900{
  background-color: var(--color-primary-900, #0B4A6F);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-100\\/0{
  background-color: rgb(235 233 254 / 0);
}
.bg-purple-100\\/10{
  background-color: rgb(235 233 254 / 0.1);
}
.bg-purple-100\\/100{
  background-color: rgb(235 233 254 / 1);
}
.bg-purple-100\\/15{
  background-color: rgb(235 233 254 / 0.15);
}
.bg-purple-100\\/20{
  background-color: rgb(235 233 254 / 0.2);
}
.bg-purple-100\\/25{
  background-color: rgb(235 233 254 / 0.25);
}
.bg-purple-100\\/30{
  background-color: rgb(235 233 254 / 0.3);
}
.bg-purple-100\\/35{
  background-color: rgb(235 233 254 / 0.35);
}
.bg-purple-100\\/40{
  background-color: rgb(235 233 254 / 0.4);
}
.bg-purple-100\\/45{
  background-color: rgb(235 233 254 / 0.45);
}
.bg-purple-100\\/5{
  background-color: rgb(235 233 254 / 0.05);
}
.bg-purple-100\\/50{
  background-color: rgb(235 233 254 / 0.5);
}
.bg-purple-100\\/55{
  background-color: rgb(235 233 254 / 0.55);
}
.bg-purple-100\\/60{
  background-color: rgb(235 233 254 / 0.6);
}
.bg-purple-100\\/65{
  background-color: rgb(235 233 254 / 0.65);
}
.bg-purple-100\\/70{
  background-color: rgb(235 233 254 / 0.7);
}
.bg-purple-100\\/75{
  background-color: rgb(235 233 254 / 0.75);
}
.bg-purple-100\\/80{
  background-color: rgb(235 233 254 / 0.8);
}
.bg-purple-100\\/85{
  background-color: rgb(235 233 254 / 0.85);
}
.bg-purple-100\\/90{
  background-color: rgb(235 233 254 / 0.9);
}
.bg-purple-100\\/95{
  background-color: rgb(235 233 254 / 0.95);
}
.bg-purple-200{
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-200\\/0{
  background-color: rgb(217 214 254 / 0);
}
.bg-purple-200\\/10{
  background-color: rgb(217 214 254 / 0.1);
}
.bg-purple-200\\/100{
  background-color: rgb(217 214 254 / 1);
}
.bg-purple-200\\/15{
  background-color: rgb(217 214 254 / 0.15);
}
.bg-purple-200\\/20{
  background-color: rgb(217 214 254 / 0.2);
}
.bg-purple-200\\/25{
  background-color: rgb(217 214 254 / 0.25);
}
.bg-purple-200\\/30{
  background-color: rgb(217 214 254 / 0.3);
}
.bg-purple-200\\/35{
  background-color: rgb(217 214 254 / 0.35);
}
.bg-purple-200\\/40{
  background-color: rgb(217 214 254 / 0.4);
}
.bg-purple-200\\/45{
  background-color: rgb(217 214 254 / 0.45);
}
.bg-purple-200\\/5{
  background-color: rgb(217 214 254 / 0.05);
}
.bg-purple-200\\/50{
  background-color: rgb(217 214 254 / 0.5);
}
.bg-purple-200\\/55{
  background-color: rgb(217 214 254 / 0.55);
}
.bg-purple-200\\/60{
  background-color: rgb(217 214 254 / 0.6);
}
.bg-purple-200\\/65{
  background-color: rgb(217 214 254 / 0.65);
}
.bg-purple-200\\/70{
  background-color: rgb(217 214 254 / 0.7);
}
.bg-purple-200\\/75{
  background-color: rgb(217 214 254 / 0.75);
}
.bg-purple-200\\/80{
  background-color: rgb(217 214 254 / 0.8);
}
.bg-purple-200\\/85{
  background-color: rgb(217 214 254 / 0.85);
}
.bg-purple-200\\/90{
  background-color: rgb(217 214 254 / 0.9);
}
.bg-purple-200\\/95{
  background-color: rgb(217 214 254 / 0.95);
}
.bg-purple-25{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-25\\/0{
  background-color: rgb(250 250 255 / 0);
}
.bg-purple-25\\/10{
  background-color: rgb(250 250 255 / 0.1);
}
.bg-purple-25\\/100{
  background-color: rgb(250 250 255 / 1);
}
.bg-purple-25\\/15{
  background-color: rgb(250 250 255 / 0.15);
}
.bg-purple-25\\/20{
  background-color: rgb(250 250 255 / 0.2);
}
.bg-purple-25\\/25{
  background-color: rgb(250 250 255 / 0.25);
}
.bg-purple-25\\/30{
  background-color: rgb(250 250 255 / 0.3);
}
.bg-purple-25\\/35{
  background-color: rgb(250 250 255 / 0.35);
}
.bg-purple-25\\/40{
  background-color: rgb(250 250 255 / 0.4);
}
.bg-purple-25\\/45{
  background-color: rgb(250 250 255 / 0.45);
}
.bg-purple-25\\/5{
  background-color: rgb(250 250 255 / 0.05);
}
.bg-purple-25\\/50{
  background-color: rgb(250 250 255 / 0.5);
}
.bg-purple-25\\/55{
  background-color: rgb(250 250 255 / 0.55);
}
.bg-purple-25\\/60{
  background-color: rgb(250 250 255 / 0.6);
}
.bg-purple-25\\/65{
  background-color: rgb(250 250 255 / 0.65);
}
.bg-purple-25\\/70{
  background-color: rgb(250 250 255 / 0.7);
}
.bg-purple-25\\/75{
  background-color: rgb(250 250 255 / 0.75);
}
.bg-purple-25\\/80{
  background-color: rgb(250 250 255 / 0.8);
}
.bg-purple-25\\/85{
  background-color: rgb(250 250 255 / 0.85);
}
.bg-purple-25\\/90{
  background-color: rgb(250 250 255 / 0.9);
}
.bg-purple-25\\/95{
  background-color: rgb(250 250 255 / 0.95);
}
.bg-purple-300{
  --tw-bg-opacity: 1;
  background-color: rgb(189 180 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-300\\/0{
  background-color: rgb(189 180 254 / 0);
}
.bg-purple-300\\/10{
  background-color: rgb(189 180 254 / 0.1);
}
.bg-purple-300\\/100{
  background-color: rgb(189 180 254 / 1);
}
.bg-purple-300\\/15{
  background-color: rgb(189 180 254 / 0.15);
}
.bg-purple-300\\/20{
  background-color: rgb(189 180 254 / 0.2);
}
.bg-purple-300\\/25{
  background-color: rgb(189 180 254 / 0.25);
}
.bg-purple-300\\/30{
  background-color: rgb(189 180 254 / 0.3);
}
.bg-purple-300\\/35{
  background-color: rgb(189 180 254 / 0.35);
}
.bg-purple-300\\/40{
  background-color: rgb(189 180 254 / 0.4);
}
.bg-purple-300\\/45{
  background-color: rgb(189 180 254 / 0.45);
}
.bg-purple-300\\/5{
  background-color: rgb(189 180 254 / 0.05);
}
.bg-purple-300\\/50{
  background-color: rgb(189 180 254 / 0.5);
}
.bg-purple-300\\/55{
  background-color: rgb(189 180 254 / 0.55);
}
.bg-purple-300\\/60{
  background-color: rgb(189 180 254 / 0.6);
}
.bg-purple-300\\/65{
  background-color: rgb(189 180 254 / 0.65);
}
.bg-purple-300\\/70{
  background-color: rgb(189 180 254 / 0.7);
}
.bg-purple-300\\/75{
  background-color: rgb(189 180 254 / 0.75);
}
.bg-purple-300\\/80{
  background-color: rgb(189 180 254 / 0.8);
}
.bg-purple-300\\/85{
  background-color: rgb(189 180 254 / 0.85);
}
.bg-purple-300\\/90{
  background-color: rgb(189 180 254 / 0.9);
}
.bg-purple-300\\/95{
  background-color: rgb(189 180 254 / 0.95);
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}
.bg-purple-400\\/0{
  background-color: rgb(155 138 251 / 0);
}
.bg-purple-400\\/10{
  background-color: rgb(155 138 251 / 0.1);
}
.bg-purple-400\\/100{
  background-color: rgb(155 138 251 / 1);
}
.bg-purple-400\\/15{
  background-color: rgb(155 138 251 / 0.15);
}
.bg-purple-400\\/20{
  background-color: rgb(155 138 251 / 0.2);
}
.bg-purple-400\\/25{
  background-color: rgb(155 138 251 / 0.25);
}
.bg-purple-400\\/30{
  background-color: rgb(155 138 251 / 0.3);
}
.bg-purple-400\\/35{
  background-color: rgb(155 138 251 / 0.35);
}
.bg-purple-400\\/40{
  background-color: rgb(155 138 251 / 0.4);
}
.bg-purple-400\\/45{
  background-color: rgb(155 138 251 / 0.45);
}
.bg-purple-400\\/5{
  background-color: rgb(155 138 251 / 0.05);
}
.bg-purple-400\\/50{
  background-color: rgb(155 138 251 / 0.5);
}
.bg-purple-400\\/55{
  background-color: rgb(155 138 251 / 0.55);
}
.bg-purple-400\\/60{
  background-color: rgb(155 138 251 / 0.6);
}
.bg-purple-400\\/65{
  background-color: rgb(155 138 251 / 0.65);
}
.bg-purple-400\\/70{
  background-color: rgb(155 138 251 / 0.7);
}
.bg-purple-400\\/75{
  background-color: rgb(155 138 251 / 0.75);
}
.bg-purple-400\\/80{
  background-color: rgb(155 138 251 / 0.8);
}
.bg-purple-400\\/85{
  background-color: rgb(155 138 251 / 0.85);
}
.bg-purple-400\\/90{
  background-color: rgb(155 138 251 / 0.9);
}
.bg-purple-400\\/95{
  background-color: rgb(155 138 251 / 0.95);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/0{
  background-color: rgb(244 243 255 / 0);
}
.bg-purple-50\\/10{
  background-color: rgb(244 243 255 / 0.1);
}
.bg-purple-50\\/100{
  background-color: rgb(244 243 255 / 1);
}
.bg-purple-50\\/15{
  background-color: rgb(244 243 255 / 0.15);
}
.bg-purple-50\\/20{
  background-color: rgb(244 243 255 / 0.2);
}
.bg-purple-50\\/25{
  background-color: rgb(244 243 255 / 0.25);
}
.bg-purple-50\\/30{
  background-color: rgb(244 243 255 / 0.3);
}
.bg-purple-50\\/35{
  background-color: rgb(244 243 255 / 0.35);
}
.bg-purple-50\\/40{
  background-color: rgb(244 243 255 / 0.4);
}
.bg-purple-50\\/45{
  background-color: rgb(244 243 255 / 0.45);
}
.bg-purple-50\\/5{
  background-color: rgb(244 243 255 / 0.05);
}
.bg-purple-50\\/50{
  background-color: rgb(244 243 255 / 0.5);
}
.bg-purple-50\\/55{
  background-color: rgb(244 243 255 / 0.55);
}
.bg-purple-50\\/60{
  background-color: rgb(244 243 255 / 0.6);
}
.bg-purple-50\\/65{
  background-color: rgb(244 243 255 / 0.65);
}
.bg-purple-50\\/70{
  background-color: rgb(244 243 255 / 0.7);
}
.bg-purple-50\\/75{
  background-color: rgb(244 243 255 / 0.75);
}
.bg-purple-50\\/80{
  background-color: rgb(244 243 255 / 0.8);
}
.bg-purple-50\\/85{
  background-color: rgb(244 243 255 / 0.85);
}
.bg-purple-50\\/90{
  background-color: rgb(244 243 255 / 0.9);
}
.bg-purple-50\\/95{
  background-color: rgb(244 243 255 / 0.95);
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/0{
  background-color: rgb(122 90 248 / 0);
}
.bg-purple-500\\/10{
  background-color: rgb(122 90 248 / 0.1);
}
.bg-purple-500\\/100{
  background-color: rgb(122 90 248 / 1);
}
.bg-purple-500\\/15{
  background-color: rgb(122 90 248 / 0.15);
}
.bg-purple-500\\/20{
  background-color: rgb(122 90 248 / 0.2);
}
.bg-purple-500\\/25{
  background-color: rgb(122 90 248 / 0.25);
}
.bg-purple-500\\/30{
  background-color: rgb(122 90 248 / 0.3);
}
.bg-purple-500\\/35{
  background-color: rgb(122 90 248 / 0.35);
}
.bg-purple-500\\/40{
  background-color: rgb(122 90 248 / 0.4);
}
.bg-purple-500\\/45{
  background-color: rgb(122 90 248 / 0.45);
}
.bg-purple-500\\/5{
  background-color: rgb(122 90 248 / 0.05);
}
.bg-purple-500\\/50{
  background-color: rgb(122 90 248 / 0.5);
}
.bg-purple-500\\/55{
  background-color: rgb(122 90 248 / 0.55);
}
.bg-purple-500\\/60{
  background-color: rgb(122 90 248 / 0.6);
}
.bg-purple-500\\/65{
  background-color: rgb(122 90 248 / 0.65);
}
.bg-purple-500\\/70{
  background-color: rgb(122 90 248 / 0.7);
}
.bg-purple-500\\/75{
  background-color: rgb(122 90 248 / 0.75);
}
.bg-purple-500\\/80{
  background-color: rgb(122 90 248 / 0.8);
}
.bg-purple-500\\/85{
  background-color: rgb(122 90 248 / 0.85);
}
.bg-purple-500\\/90{
  background-color: rgb(122 90 248 / 0.9);
}
.bg-purple-500\\/95{
  background-color: rgb(122 90 248 / 0.95);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}
.bg-purple-600\\/0{
  background-color: rgb(105 56 239 / 0);
}
.bg-purple-600\\/10{
  background-color: rgb(105 56 239 / 0.1);
}
.bg-purple-600\\/100{
  background-color: rgb(105 56 239 / 1);
}
.bg-purple-600\\/15{
  background-color: rgb(105 56 239 / 0.15);
}
.bg-purple-600\\/20{
  background-color: rgb(105 56 239 / 0.2);
}
.bg-purple-600\\/25{
  background-color: rgb(105 56 239 / 0.25);
}
.bg-purple-600\\/30{
  background-color: rgb(105 56 239 / 0.3);
}
.bg-purple-600\\/35{
  background-color: rgb(105 56 239 / 0.35);
}
.bg-purple-600\\/40{
  background-color: rgb(105 56 239 / 0.4);
}
.bg-purple-600\\/45{
  background-color: rgb(105 56 239 / 0.45);
}
.bg-purple-600\\/5{
  background-color: rgb(105 56 239 / 0.05);
}
.bg-purple-600\\/50{
  background-color: rgb(105 56 239 / 0.5);
}
.bg-purple-600\\/55{
  background-color: rgb(105 56 239 / 0.55);
}
.bg-purple-600\\/60{
  background-color: rgb(105 56 239 / 0.6);
}
.bg-purple-600\\/65{
  background-color: rgb(105 56 239 / 0.65);
}
.bg-purple-600\\/70{
  background-color: rgb(105 56 239 / 0.7);
}
.bg-purple-600\\/75{
  background-color: rgb(105 56 239 / 0.75);
}
.bg-purple-600\\/80{
  background-color: rgb(105 56 239 / 0.8);
}
.bg-purple-600\\/85{
  background-color: rgb(105 56 239 / 0.85);
}
.bg-purple-600\\/90{
  background-color: rgb(105 56 239 / 0.9);
}
.bg-purple-600\\/95{
  background-color: rgb(105 56 239 / 0.95);
}
.bg-purple-700{
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}
.bg-purple-700\\/0{
  background-color: rgb(89 37 220 / 0);
}
.bg-purple-700\\/10{
  background-color: rgb(89 37 220 / 0.1);
}
.bg-purple-700\\/100{
  background-color: rgb(89 37 220 / 1);
}
.bg-purple-700\\/15{
  background-color: rgb(89 37 220 / 0.15);
}
.bg-purple-700\\/20{
  background-color: rgb(89 37 220 / 0.2);
}
.bg-purple-700\\/25{
  background-color: rgb(89 37 220 / 0.25);
}
.bg-purple-700\\/30{
  background-color: rgb(89 37 220 / 0.3);
}
.bg-purple-700\\/35{
  background-color: rgb(89 37 220 / 0.35);
}
.bg-purple-700\\/40{
  background-color: rgb(89 37 220 / 0.4);
}
.bg-purple-700\\/45{
  background-color: rgb(89 37 220 / 0.45);
}
.bg-purple-700\\/5{
  background-color: rgb(89 37 220 / 0.05);
}
.bg-purple-700\\/50{
  background-color: rgb(89 37 220 / 0.5);
}
.bg-purple-700\\/55{
  background-color: rgb(89 37 220 / 0.55);
}
.bg-purple-700\\/60{
  background-color: rgb(89 37 220 / 0.6);
}
.bg-purple-700\\/65{
  background-color: rgb(89 37 220 / 0.65);
}
.bg-purple-700\\/70{
  background-color: rgb(89 37 220 / 0.7);
}
.bg-purple-700\\/75{
  background-color: rgb(89 37 220 / 0.75);
}
.bg-purple-700\\/80{
  background-color: rgb(89 37 220 / 0.8);
}
.bg-purple-700\\/85{
  background-color: rgb(89 37 220 / 0.85);
}
.bg-purple-700\\/90{
  background-color: rgb(89 37 220 / 0.9);
}
.bg-purple-700\\/95{
  background-color: rgb(89 37 220 / 0.95);
}
.bg-purple-800{
  --tw-bg-opacity: 1;
  background-color: rgb(74 31 184 / var(--tw-bg-opacity, 1));
}
.bg-purple-800\\/0{
  background-color: rgb(74 31 184 / 0);
}
.bg-purple-800\\/10{
  background-color: rgb(74 31 184 / 0.1);
}
.bg-purple-800\\/100{
  background-color: rgb(74 31 184 / 1);
}
.bg-purple-800\\/15{
  background-color: rgb(74 31 184 / 0.15);
}
.bg-purple-800\\/20{
  background-color: rgb(74 31 184 / 0.2);
}
.bg-purple-800\\/25{
  background-color: rgb(74 31 184 / 0.25);
}
.bg-purple-800\\/30{
  background-color: rgb(74 31 184 / 0.3);
}
.bg-purple-800\\/35{
  background-color: rgb(74 31 184 / 0.35);
}
.bg-purple-800\\/40{
  background-color: rgb(74 31 184 / 0.4);
}
.bg-purple-800\\/45{
  background-color: rgb(74 31 184 / 0.45);
}
.bg-purple-800\\/5{
  background-color: rgb(74 31 184 / 0.05);
}
.bg-purple-800\\/50{
  background-color: rgb(74 31 184 / 0.5);
}
.bg-purple-800\\/55{
  background-color: rgb(74 31 184 / 0.55);
}
.bg-purple-800\\/60{
  background-color: rgb(74 31 184 / 0.6);
}
.bg-purple-800\\/65{
  background-color: rgb(74 31 184 / 0.65);
}
.bg-purple-800\\/70{
  background-color: rgb(74 31 184 / 0.7);
}
.bg-purple-800\\/75{
  background-color: rgb(74 31 184 / 0.75);
}
.bg-purple-800\\/80{
  background-color: rgb(74 31 184 / 0.8);
}
.bg-purple-800\\/85{
  background-color: rgb(74 31 184 / 0.85);
}
.bg-purple-800\\/90{
  background-color: rgb(74 31 184 / 0.9);
}
.bg-purple-800\\/95{
  background-color: rgb(74 31 184 / 0.95);
}
.bg-purple-900{
  --tw-bg-opacity: 1;
  background-color: rgb(62 28 150 / var(--tw-bg-opacity, 1));
}
.bg-purple-900\\/0{
  background-color: rgb(62 28 150 / 0);
}
.bg-purple-900\\/10{
  background-color: rgb(62 28 150 / 0.1);
}
.bg-purple-900\\/100{
  background-color: rgb(62 28 150 / 1);
}
.bg-purple-900\\/15{
  background-color: rgb(62 28 150 / 0.15);
}
.bg-purple-900\\/20{
  background-color: rgb(62 28 150 / 0.2);
}
.bg-purple-900\\/25{
  background-color: rgb(62 28 150 / 0.25);
}
.bg-purple-900\\/30{
  background-color: rgb(62 28 150 / 0.3);
}
.bg-purple-900\\/35{
  background-color: rgb(62 28 150 / 0.35);
}
.bg-purple-900\\/40{
  background-color: rgb(62 28 150 / 0.4);
}
.bg-purple-900\\/45{
  background-color: rgb(62 28 150 / 0.45);
}
.bg-purple-900\\/5{
  background-color: rgb(62 28 150 / 0.05);
}
.bg-purple-900\\/50{
  background-color: rgb(62 28 150 / 0.5);
}
.bg-purple-900\\/55{
  background-color: rgb(62 28 150 / 0.55);
}
.bg-purple-900\\/60{
  background-color: rgb(62 28 150 / 0.6);
}
.bg-purple-900\\/65{
  background-color: rgb(62 28 150 / 0.65);
}
.bg-purple-900\\/70{
  background-color: rgb(62 28 150 / 0.7);
}
.bg-purple-900\\/75{
  background-color: rgb(62 28 150 / 0.75);
}
.bg-purple-900\\/80{
  background-color: rgb(62 28 150 / 0.8);
}
.bg-purple-900\\/85{
  background-color: rgb(62 28 150 / 0.85);
}
.bg-purple-900\\/90{
  background-color: rgb(62 28 150 / 0.9);
}
.bg-purple-900\\/95{
  background-color: rgb(62 28 150 / 0.95);
}
.bg-success-100{
  --tw-bg-opacity: 1;
  background-color: rgb(211 248 223 / var(--tw-bg-opacity, 1));
}
.bg-success-100\\/0{
  background-color: rgb(211 248 223 / 0);
}
.bg-success-100\\/10{
  background-color: rgb(211 248 223 / 0.1);
}
.bg-success-100\\/100{
  background-color: rgb(211 248 223 / 1);
}
.bg-success-100\\/15{
  background-color: rgb(211 248 223 / 0.15);
}
.bg-success-100\\/20{
  background-color: rgb(211 248 223 / 0.2);
}
.bg-success-100\\/25{
  background-color: rgb(211 248 223 / 0.25);
}
.bg-success-100\\/30{
  background-color: rgb(211 248 223 / 0.3);
}
.bg-success-100\\/35{
  background-color: rgb(211 248 223 / 0.35);
}
.bg-success-100\\/40{
  background-color: rgb(211 248 223 / 0.4);
}
.bg-success-100\\/45{
  background-color: rgb(211 248 223 / 0.45);
}
.bg-success-100\\/5{
  background-color: rgb(211 248 223 / 0.05);
}
.bg-success-100\\/50{
  background-color: rgb(211 248 223 / 0.5);
}
.bg-success-100\\/55{
  background-color: rgb(211 248 223 / 0.55);
}
.bg-success-100\\/60{
  background-color: rgb(211 248 223 / 0.6);
}
.bg-success-100\\/65{
  background-color: rgb(211 248 223 / 0.65);
}
.bg-success-100\\/70{
  background-color: rgb(211 248 223 / 0.7);
}
.bg-success-100\\/75{
  background-color: rgb(211 248 223 / 0.75);
}
.bg-success-100\\/80{
  background-color: rgb(211 248 223 / 0.8);
}
.bg-success-100\\/85{
  background-color: rgb(211 248 223 / 0.85);
}
.bg-success-100\\/90{
  background-color: rgb(211 248 223 / 0.9);
}
.bg-success-100\\/95{
  background-color: rgb(211 248 223 / 0.95);
}
.bg-success-200{
  --tw-bg-opacity: 1;
  background-color: rgb(170 240 196 / var(--tw-bg-opacity, 1));
}
.bg-success-200\\/0{
  background-color: rgb(170 240 196 / 0);
}
.bg-success-200\\/10{
  background-color: rgb(170 240 196 / 0.1);
}
.bg-success-200\\/100{
  background-color: rgb(170 240 196 / 1);
}
.bg-success-200\\/15{
  background-color: rgb(170 240 196 / 0.15);
}
.bg-success-200\\/20{
  background-color: rgb(170 240 196 / 0.2);
}
.bg-success-200\\/25{
  background-color: rgb(170 240 196 / 0.25);
}
.bg-success-200\\/30{
  background-color: rgb(170 240 196 / 0.3);
}
.bg-success-200\\/35{
  background-color: rgb(170 240 196 / 0.35);
}
.bg-success-200\\/40{
  background-color: rgb(170 240 196 / 0.4);
}
.bg-success-200\\/45{
  background-color: rgb(170 240 196 / 0.45);
}
.bg-success-200\\/5{
  background-color: rgb(170 240 196 / 0.05);
}
.bg-success-200\\/50{
  background-color: rgb(170 240 196 / 0.5);
}
.bg-success-200\\/55{
  background-color: rgb(170 240 196 / 0.55);
}
.bg-success-200\\/60{
  background-color: rgb(170 240 196 / 0.6);
}
.bg-success-200\\/65{
  background-color: rgb(170 240 196 / 0.65);
}
.bg-success-200\\/70{
  background-color: rgb(170 240 196 / 0.7);
}
.bg-success-200\\/75{
  background-color: rgb(170 240 196 / 0.75);
}
.bg-success-200\\/80{
  background-color: rgb(170 240 196 / 0.8);
}
.bg-success-200\\/85{
  background-color: rgb(170 240 196 / 0.85);
}
.bg-success-200\\/90{
  background-color: rgb(170 240 196 / 0.9);
}
.bg-success-200\\/95{
  background-color: rgb(170 240 196 / 0.95);
}
.bg-success-25{
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}
.bg-success-25\\/0{
  background-color: rgb(246 254 249 / 0);
}
.bg-success-25\\/10{
  background-color: rgb(246 254 249 / 0.1);
}
.bg-success-25\\/100{
  background-color: rgb(246 254 249 / 1);
}
.bg-success-25\\/15{
  background-color: rgb(246 254 249 / 0.15);
}
.bg-success-25\\/20{
  background-color: rgb(246 254 249 / 0.2);
}
.bg-success-25\\/25{
  background-color: rgb(246 254 249 / 0.25);
}
.bg-success-25\\/30{
  background-color: rgb(246 254 249 / 0.3);
}
.bg-success-25\\/35{
  background-color: rgb(246 254 249 / 0.35);
}
.bg-success-25\\/40{
  background-color: rgb(246 254 249 / 0.4);
}
.bg-success-25\\/45{
  background-color: rgb(246 254 249 / 0.45);
}
.bg-success-25\\/5{
  background-color: rgb(246 254 249 / 0.05);
}
.bg-success-25\\/50{
  background-color: rgb(246 254 249 / 0.5);
}
.bg-success-25\\/55{
  background-color: rgb(246 254 249 / 0.55);
}
.bg-success-25\\/60{
  background-color: rgb(246 254 249 / 0.6);
}
.bg-success-25\\/65{
  background-color: rgb(246 254 249 / 0.65);
}
.bg-success-25\\/70{
  background-color: rgb(246 254 249 / 0.7);
}
.bg-success-25\\/75{
  background-color: rgb(246 254 249 / 0.75);
}
.bg-success-25\\/80{
  background-color: rgb(246 254 249 / 0.8);
}
.bg-success-25\\/85{
  background-color: rgb(246 254 249 / 0.85);
}
.bg-success-25\\/90{
  background-color: rgb(246 254 249 / 0.9);
}
.bg-success-25\\/95{
  background-color: rgb(246 254 249 / 0.95);
}
.bg-success-300{
  --tw-bg-opacity: 1;
  background-color: rgb(115 226 163 / var(--tw-bg-opacity, 1));
}
.bg-success-300\\/0{
  background-color: rgb(115 226 163 / 0);
}
.bg-success-300\\/10{
  background-color: rgb(115 226 163 / 0.1);
}
.bg-success-300\\/100{
  background-color: rgb(115 226 163 / 1);
}
.bg-success-300\\/15{
  background-color: rgb(115 226 163 / 0.15);
}
.bg-success-300\\/20{
  background-color: rgb(115 226 163 / 0.2);
}
.bg-success-300\\/25{
  background-color: rgb(115 226 163 / 0.25);
}
.bg-success-300\\/30{
  background-color: rgb(115 226 163 / 0.3);
}
.bg-success-300\\/35{
  background-color: rgb(115 226 163 / 0.35);
}
.bg-success-300\\/40{
  background-color: rgb(115 226 163 / 0.4);
}
.bg-success-300\\/45{
  background-color: rgb(115 226 163 / 0.45);
}
.bg-success-300\\/5{
  background-color: rgb(115 226 163 / 0.05);
}
.bg-success-300\\/50{
  background-color: rgb(115 226 163 / 0.5);
}
.bg-success-300\\/55{
  background-color: rgb(115 226 163 / 0.55);
}
.bg-success-300\\/60{
  background-color: rgb(115 226 163 / 0.6);
}
.bg-success-300\\/65{
  background-color: rgb(115 226 163 / 0.65);
}
.bg-success-300\\/70{
  background-color: rgb(115 226 163 / 0.7);
}
.bg-success-300\\/75{
  background-color: rgb(115 226 163 / 0.75);
}
.bg-success-300\\/80{
  background-color: rgb(115 226 163 / 0.8);
}
.bg-success-300\\/85{
  background-color: rgb(115 226 163 / 0.85);
}
.bg-success-300\\/90{
  background-color: rgb(115 226 163 / 0.9);
}
.bg-success-300\\/95{
  background-color: rgb(115 226 163 / 0.95);
}
.bg-success-400{
  --tw-bg-opacity: 1;
  background-color: rgb(60 203 127 / var(--tw-bg-opacity, 1));
}
.bg-success-400\\/0{
  background-color: rgb(60 203 127 / 0);
}
.bg-success-400\\/10{
  background-color: rgb(60 203 127 / 0.1);
}
.bg-success-400\\/100{
  background-color: rgb(60 203 127 / 1);
}
.bg-success-400\\/15{
  background-color: rgb(60 203 127 / 0.15);
}
.bg-success-400\\/20{
  background-color: rgb(60 203 127 / 0.2);
}
.bg-success-400\\/25{
  background-color: rgb(60 203 127 / 0.25);
}
.bg-success-400\\/30{
  background-color: rgb(60 203 127 / 0.3);
}
.bg-success-400\\/35{
  background-color: rgb(60 203 127 / 0.35);
}
.bg-success-400\\/40{
  background-color: rgb(60 203 127 / 0.4);
}
.bg-success-400\\/45{
  background-color: rgb(60 203 127 / 0.45);
}
.bg-success-400\\/5{
  background-color: rgb(60 203 127 / 0.05);
}
.bg-success-400\\/50{
  background-color: rgb(60 203 127 / 0.5);
}
.bg-success-400\\/55{
  background-color: rgb(60 203 127 / 0.55);
}
.bg-success-400\\/60{
  background-color: rgb(60 203 127 / 0.6);
}
.bg-success-400\\/65{
  background-color: rgb(60 203 127 / 0.65);
}
.bg-success-400\\/70{
  background-color: rgb(60 203 127 / 0.7);
}
.bg-success-400\\/75{
  background-color: rgb(60 203 127 / 0.75);
}
.bg-success-400\\/80{
  background-color: rgb(60 203 127 / 0.8);
}
.bg-success-400\\/85{
  background-color: rgb(60 203 127 / 0.85);
}
.bg-success-400\\/90{
  background-color: rgb(60 203 127 / 0.9);
}
.bg-success-400\\/95{
  background-color: rgb(60 203 127 / 0.95);
}
.bg-success-50{
  --tw-bg-opacity: 1;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1));
}
.bg-success-50\\/0{
  background-color: rgb(237 252 242 / 0);
}
.bg-success-50\\/10{
  background-color: rgb(237 252 242 / 0.1);
}
.bg-success-50\\/100{
  background-color: rgb(237 252 242 / 1);
}
.bg-success-50\\/15{
  background-color: rgb(237 252 242 / 0.15);
}
.bg-success-50\\/20{
  background-color: rgb(237 252 242 / 0.2);
}
.bg-success-50\\/25{
  background-color: rgb(237 252 242 / 0.25);
}
.bg-success-50\\/30{
  background-color: rgb(237 252 242 / 0.3);
}
.bg-success-50\\/35{
  background-color: rgb(237 252 242 / 0.35);
}
.bg-success-50\\/40{
  background-color: rgb(237 252 242 / 0.4);
}
.bg-success-50\\/45{
  background-color: rgb(237 252 242 / 0.45);
}
.bg-success-50\\/5{
  background-color: rgb(237 252 242 / 0.05);
}
.bg-success-50\\/50{
  background-color: rgb(237 252 242 / 0.5);
}
.bg-success-50\\/55{
  background-color: rgb(237 252 242 / 0.55);
}
.bg-success-50\\/60{
  background-color: rgb(237 252 242 / 0.6);
}
.bg-success-50\\/65{
  background-color: rgb(237 252 242 / 0.65);
}
.bg-success-50\\/70{
  background-color: rgb(237 252 242 / 0.7);
}
.bg-success-50\\/75{
  background-color: rgb(237 252 242 / 0.75);
}
.bg-success-50\\/80{
  background-color: rgb(237 252 242 / 0.8);
}
.bg-success-50\\/85{
  background-color: rgb(237 252 242 / 0.85);
}
.bg-success-50\\/90{
  background-color: rgb(237 252 242 / 0.9);
}
.bg-success-50\\/95{
  background-color: rgb(237 252 242 / 0.95);
}
.bg-success-500{
  --tw-bg-opacity: 1;
  background-color: rgb(22 179 100 / var(--tw-bg-opacity, 1));
}
.bg-success-500\\/0{
  background-color: rgb(22 179 100 / 0);
}
.bg-success-500\\/10{
  background-color: rgb(22 179 100 / 0.1);
}
.bg-success-500\\/100{
  background-color: rgb(22 179 100 / 1);
}
.bg-success-500\\/15{
  background-color: rgb(22 179 100 / 0.15);
}
.bg-success-500\\/20{
  background-color: rgb(22 179 100 / 0.2);
}
.bg-success-500\\/25{
  background-color: rgb(22 179 100 / 0.25);
}
.bg-success-500\\/30{
  background-color: rgb(22 179 100 / 0.3);
}
.bg-success-500\\/35{
  background-color: rgb(22 179 100 / 0.35);
}
.bg-success-500\\/40{
  background-color: rgb(22 179 100 / 0.4);
}
.bg-success-500\\/45{
  background-color: rgb(22 179 100 / 0.45);
}
.bg-success-500\\/5{
  background-color: rgb(22 179 100 / 0.05);
}
.bg-success-500\\/50{
  background-color: rgb(22 179 100 / 0.5);
}
.bg-success-500\\/55{
  background-color: rgb(22 179 100 / 0.55);
}
.bg-success-500\\/60{
  background-color: rgb(22 179 100 / 0.6);
}
.bg-success-500\\/65{
  background-color: rgb(22 179 100 / 0.65);
}
.bg-success-500\\/70{
  background-color: rgb(22 179 100 / 0.7);
}
.bg-success-500\\/75{
  background-color: rgb(22 179 100 / 0.75);
}
.bg-success-500\\/80{
  background-color: rgb(22 179 100 / 0.8);
}
.bg-success-500\\/85{
  background-color: rgb(22 179 100 / 0.85);
}
.bg-success-500\\/90{
  background-color: rgb(22 179 100 / 0.9);
}
.bg-success-500\\/95{
  background-color: rgb(22 179 100 / 0.95);
}
.bg-success-600{
  --tw-bg-opacity: 1;
  background-color: rgb(9 146 80 / var(--tw-bg-opacity, 1));
}
.bg-success-600\\/0{
  background-color: rgb(9 146 80 / 0);
}
.bg-success-600\\/10{
  background-color: rgb(9 146 80 / 0.1);
}
.bg-success-600\\/100{
  background-color: rgb(9 146 80 / 1);
}
.bg-success-600\\/15{
  background-color: rgb(9 146 80 / 0.15);
}
.bg-success-600\\/20{
  background-color: rgb(9 146 80 / 0.2);
}
.bg-success-600\\/25{
  background-color: rgb(9 146 80 / 0.25);
}
.bg-success-600\\/30{
  background-color: rgb(9 146 80 / 0.3);
}
.bg-success-600\\/35{
  background-color: rgb(9 146 80 / 0.35);
}
.bg-success-600\\/40{
  background-color: rgb(9 146 80 / 0.4);
}
.bg-success-600\\/45{
  background-color: rgb(9 146 80 / 0.45);
}
.bg-success-600\\/5{
  background-color: rgb(9 146 80 / 0.05);
}
.bg-success-600\\/50{
  background-color: rgb(9 146 80 / 0.5);
}
.bg-success-600\\/55{
  background-color: rgb(9 146 80 / 0.55);
}
.bg-success-600\\/60{
  background-color: rgb(9 146 80 / 0.6);
}
.bg-success-600\\/65{
  background-color: rgb(9 146 80 / 0.65);
}
.bg-success-600\\/70{
  background-color: rgb(9 146 80 / 0.7);
}
.bg-success-600\\/75{
  background-color: rgb(9 146 80 / 0.75);
}
.bg-success-600\\/80{
  background-color: rgb(9 146 80 / 0.8);
}
.bg-success-600\\/85{
  background-color: rgb(9 146 80 / 0.85);
}
.bg-success-600\\/90{
  background-color: rgb(9 146 80 / 0.9);
}
.bg-success-600\\/95{
  background-color: rgb(9 146 80 / 0.95);
}
.bg-success-700{
  --tw-bg-opacity: 1;
  background-color: rgb(8 116 67 / var(--tw-bg-opacity, 1));
}
.bg-success-700\\/0{
  background-color: rgb(8 116 67 / 0);
}
.bg-success-700\\/10{
  background-color: rgb(8 116 67 / 0.1);
}
.bg-success-700\\/100{
  background-color: rgb(8 116 67 / 1);
}
.bg-success-700\\/15{
  background-color: rgb(8 116 67 / 0.15);
}
.bg-success-700\\/20{
  background-color: rgb(8 116 67 / 0.2);
}
.bg-success-700\\/25{
  background-color: rgb(8 116 67 / 0.25);
}
.bg-success-700\\/30{
  background-color: rgb(8 116 67 / 0.3);
}
.bg-success-700\\/35{
  background-color: rgb(8 116 67 / 0.35);
}
.bg-success-700\\/40{
  background-color: rgb(8 116 67 / 0.4);
}
.bg-success-700\\/45{
  background-color: rgb(8 116 67 / 0.45);
}
.bg-success-700\\/5{
  background-color: rgb(8 116 67 / 0.05);
}
.bg-success-700\\/50{
  background-color: rgb(8 116 67 / 0.5);
}
.bg-success-700\\/55{
  background-color: rgb(8 116 67 / 0.55);
}
.bg-success-700\\/60{
  background-color: rgb(8 116 67 / 0.6);
}
.bg-success-700\\/65{
  background-color: rgb(8 116 67 / 0.65);
}
.bg-success-700\\/70{
  background-color: rgb(8 116 67 / 0.7);
}
.bg-success-700\\/75{
  background-color: rgb(8 116 67 / 0.75);
}
.bg-success-700\\/80{
  background-color: rgb(8 116 67 / 0.8);
}
.bg-success-700\\/85{
  background-color: rgb(8 116 67 / 0.85);
}
.bg-success-700\\/90{
  background-color: rgb(8 116 67 / 0.9);
}
.bg-success-700\\/95{
  background-color: rgb(8 116 67 / 0.95);
}
.bg-success-800{
  --tw-bg-opacity: 1;
  background-color: rgb(9 92 55 / var(--tw-bg-opacity, 1));
}
.bg-success-800\\/0{
  background-color: rgb(9 92 55 / 0);
}
.bg-success-800\\/10{
  background-color: rgb(9 92 55 / 0.1);
}
.bg-success-800\\/100{
  background-color: rgb(9 92 55 / 1);
}
.bg-success-800\\/15{
  background-color: rgb(9 92 55 / 0.15);
}
.bg-success-800\\/20{
  background-color: rgb(9 92 55 / 0.2);
}
.bg-success-800\\/25{
  background-color: rgb(9 92 55 / 0.25);
}
.bg-success-800\\/30{
  background-color: rgb(9 92 55 / 0.3);
}
.bg-success-800\\/35{
  background-color: rgb(9 92 55 / 0.35);
}
.bg-success-800\\/40{
  background-color: rgb(9 92 55 / 0.4);
}
.bg-success-800\\/45{
  background-color: rgb(9 92 55 / 0.45);
}
.bg-success-800\\/5{
  background-color: rgb(9 92 55 / 0.05);
}
.bg-success-800\\/50{
  background-color: rgb(9 92 55 / 0.5);
}
.bg-success-800\\/55{
  background-color: rgb(9 92 55 / 0.55);
}
.bg-success-800\\/60{
  background-color: rgb(9 92 55 / 0.6);
}
.bg-success-800\\/65{
  background-color: rgb(9 92 55 / 0.65);
}
.bg-success-800\\/70{
  background-color: rgb(9 92 55 / 0.7);
}
.bg-success-800\\/75{
  background-color: rgb(9 92 55 / 0.75);
}
.bg-success-800\\/80{
  background-color: rgb(9 92 55 / 0.8);
}
.bg-success-800\\/85{
  background-color: rgb(9 92 55 / 0.85);
}
.bg-success-800\\/90{
  background-color: rgb(9 92 55 / 0.9);
}
.bg-success-800\\/95{
  background-color: rgb(9 92 55 / 0.95);
}
.bg-success-900{
  --tw-bg-opacity: 1;
  background-color: rgb(8 76 46 / var(--tw-bg-opacity, 1));
}
.bg-success-900\\/0{
  background-color: rgb(8 76 46 / 0);
}
.bg-success-900\\/10{
  background-color: rgb(8 76 46 / 0.1);
}
.bg-success-900\\/100{
  background-color: rgb(8 76 46 / 1);
}
.bg-success-900\\/15{
  background-color: rgb(8 76 46 / 0.15);
}
.bg-success-900\\/20{
  background-color: rgb(8 76 46 / 0.2);
}
.bg-success-900\\/25{
  background-color: rgb(8 76 46 / 0.25);
}
.bg-success-900\\/30{
  background-color: rgb(8 76 46 / 0.3);
}
.bg-success-900\\/35{
  background-color: rgb(8 76 46 / 0.35);
}
.bg-success-900\\/40{
  background-color: rgb(8 76 46 / 0.4);
}
.bg-success-900\\/45{
  background-color: rgb(8 76 46 / 0.45);
}
.bg-success-900\\/5{
  background-color: rgb(8 76 46 / 0.05);
}
.bg-success-900\\/50{
  background-color: rgb(8 76 46 / 0.5);
}
.bg-success-900\\/55{
  background-color: rgb(8 76 46 / 0.55);
}
.bg-success-900\\/60{
  background-color: rgb(8 76 46 / 0.6);
}
.bg-success-900\\/65{
  background-color: rgb(8 76 46 / 0.65);
}
.bg-success-900\\/70{
  background-color: rgb(8 76 46 / 0.7);
}
.bg-success-900\\/75{
  background-color: rgb(8 76 46 / 0.75);
}
.bg-success-900\\/80{
  background-color: rgb(8 76 46 / 0.8);
}
.bg-success-900\\/85{
  background-color: rgb(8 76 46 / 0.85);
}
.bg-success-900\\/90{
  background-color: rgb(8 76 46 / 0.9);
}
.bg-success-900\\/95{
  background-color: rgb(8 76 46 / 0.95);
}
.bg-teal-200{
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 224 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 249 / var(--tw-bg-opacity, 1));
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(21 183 158 / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(14 147 132 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(236 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-200{
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-25{
  --tw-bg-opacity: 1;
  background-color: rgb(251 250 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(135 91 247 / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(120 57 238 / var(--tw-bg-opacity, 1));
}
.bg-warning-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}
.bg-warning-100\\/0{
  background-color: rgb(254 240 199 / 0);
}
.bg-warning-100\\/10{
  background-color: rgb(254 240 199 / 0.1);
}
.bg-warning-100\\/100{
  background-color: rgb(254 240 199 / 1);
}
.bg-warning-100\\/15{
  background-color: rgb(254 240 199 / 0.15);
}
.bg-warning-100\\/20{
  background-color: rgb(254 240 199 / 0.2);
}
.bg-warning-100\\/25{
  background-color: rgb(254 240 199 / 0.25);
}
.bg-warning-100\\/30{
  background-color: rgb(254 240 199 / 0.3);
}
.bg-warning-100\\/35{
  background-color: rgb(254 240 199 / 0.35);
}
.bg-warning-100\\/40{
  background-color: rgb(254 240 199 / 0.4);
}
.bg-warning-100\\/45{
  background-color: rgb(254 240 199 / 0.45);
}
.bg-warning-100\\/5{
  background-color: rgb(254 240 199 / 0.05);
}
.bg-warning-100\\/50{
  background-color: rgb(254 240 199 / 0.5);
}
.bg-warning-100\\/55{
  background-color: rgb(254 240 199 / 0.55);
}
.bg-warning-100\\/60{
  background-color: rgb(254 240 199 / 0.6);
}
.bg-warning-100\\/65{
  background-color: rgb(254 240 199 / 0.65);
}
.bg-warning-100\\/70{
  background-color: rgb(254 240 199 / 0.7);
}
.bg-warning-100\\/75{
  background-color: rgb(254 240 199 / 0.75);
}
.bg-warning-100\\/80{
  background-color: rgb(254 240 199 / 0.8);
}
.bg-warning-100\\/85{
  background-color: rgb(254 240 199 / 0.85);
}
.bg-warning-100\\/90{
  background-color: rgb(254 240 199 / 0.9);
}
.bg-warning-100\\/95{
  background-color: rgb(254 240 199 / 0.95);
}
.bg-warning-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}
.bg-warning-200\\/0{
  background-color: rgb(254 223 137 / 0);
}
.bg-warning-200\\/10{
  background-color: rgb(254 223 137 / 0.1);
}
.bg-warning-200\\/100{
  background-color: rgb(254 223 137 / 1);
}
.bg-warning-200\\/15{
  background-color: rgb(254 223 137 / 0.15);
}
.bg-warning-200\\/20{
  background-color: rgb(254 223 137 / 0.2);
}
.bg-warning-200\\/25{
  background-color: rgb(254 223 137 / 0.25);
}
.bg-warning-200\\/30{
  background-color: rgb(254 223 137 / 0.3);
}
.bg-warning-200\\/35{
  background-color: rgb(254 223 137 / 0.35);
}
.bg-warning-200\\/40{
  background-color: rgb(254 223 137 / 0.4);
}
.bg-warning-200\\/45{
  background-color: rgb(254 223 137 / 0.45);
}
.bg-warning-200\\/5{
  background-color: rgb(254 223 137 / 0.05);
}
.bg-warning-200\\/50{
  background-color: rgb(254 223 137 / 0.5);
}
.bg-warning-200\\/55{
  background-color: rgb(254 223 137 / 0.55);
}
.bg-warning-200\\/60{
  background-color: rgb(254 223 137 / 0.6);
}
.bg-warning-200\\/65{
  background-color: rgb(254 223 137 / 0.65);
}
.bg-warning-200\\/70{
  background-color: rgb(254 223 137 / 0.7);
}
.bg-warning-200\\/75{
  background-color: rgb(254 223 137 / 0.75);
}
.bg-warning-200\\/80{
  background-color: rgb(254 223 137 / 0.8);
}
.bg-warning-200\\/85{
  background-color: rgb(254 223 137 / 0.85);
}
.bg-warning-200\\/90{
  background-color: rgb(254 223 137 / 0.9);
}
.bg-warning-200\\/95{
  background-color: rgb(254 223 137 / 0.95);
}
.bg-warning-25{
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}
.bg-warning-25\\/0{
  background-color: rgb(255 252 245 / 0);
}
.bg-warning-25\\/10{
  background-color: rgb(255 252 245 / 0.1);
}
.bg-warning-25\\/100{
  background-color: rgb(255 252 245 / 1);
}
.bg-warning-25\\/15{
  background-color: rgb(255 252 245 / 0.15);
}
.bg-warning-25\\/20{
  background-color: rgb(255 252 245 / 0.2);
}
.bg-warning-25\\/25{
  background-color: rgb(255 252 245 / 0.25);
}
.bg-warning-25\\/30{
  background-color: rgb(255 252 245 / 0.3);
}
.bg-warning-25\\/35{
  background-color: rgb(255 252 245 / 0.35);
}
.bg-warning-25\\/40{
  background-color: rgb(255 252 245 / 0.4);
}
.bg-warning-25\\/45{
  background-color: rgb(255 252 245 / 0.45);
}
.bg-warning-25\\/5{
  background-color: rgb(255 252 245 / 0.05);
}
.bg-warning-25\\/50{
  background-color: rgb(255 252 245 / 0.5);
}
.bg-warning-25\\/55{
  background-color: rgb(255 252 245 / 0.55);
}
.bg-warning-25\\/60{
  background-color: rgb(255 252 245 / 0.6);
}
.bg-warning-25\\/65{
  background-color: rgb(255 252 245 / 0.65);
}
.bg-warning-25\\/70{
  background-color: rgb(255 252 245 / 0.7);
}
.bg-warning-25\\/75{
  background-color: rgb(255 252 245 / 0.75);
}
.bg-warning-25\\/80{
  background-color: rgb(255 252 245 / 0.8);
}
.bg-warning-25\\/85{
  background-color: rgb(255 252 245 / 0.85);
}
.bg-warning-25\\/90{
  background-color: rgb(255 252 245 / 0.9);
}
.bg-warning-25\\/95{
  background-color: rgb(255 252 245 / 0.95);
}
.bg-warning-300{
  --tw-bg-opacity: 1;
  background-color: rgb(254 200 75 / var(--tw-bg-opacity, 1));
}
.bg-warning-300\\/0{
  background-color: rgb(254 200 75 / 0);
}
.bg-warning-300\\/10{
  background-color: rgb(254 200 75 / 0.1);
}
.bg-warning-300\\/100{
  background-color: rgb(254 200 75 / 1);
}
.bg-warning-300\\/15{
  background-color: rgb(254 200 75 / 0.15);
}
.bg-warning-300\\/20{
  background-color: rgb(254 200 75 / 0.2);
}
.bg-warning-300\\/25{
  background-color: rgb(254 200 75 / 0.25);
}
.bg-warning-300\\/30{
  background-color: rgb(254 200 75 / 0.3);
}
.bg-warning-300\\/35{
  background-color: rgb(254 200 75 / 0.35);
}
.bg-warning-300\\/40{
  background-color: rgb(254 200 75 / 0.4);
}
.bg-warning-300\\/45{
  background-color: rgb(254 200 75 / 0.45);
}
.bg-warning-300\\/5{
  background-color: rgb(254 200 75 / 0.05);
}
.bg-warning-300\\/50{
  background-color: rgb(254 200 75 / 0.5);
}
.bg-warning-300\\/55{
  background-color: rgb(254 200 75 / 0.55);
}
.bg-warning-300\\/60{
  background-color: rgb(254 200 75 / 0.6);
}
.bg-warning-300\\/65{
  background-color: rgb(254 200 75 / 0.65);
}
.bg-warning-300\\/70{
  background-color: rgb(254 200 75 / 0.7);
}
.bg-warning-300\\/75{
  background-color: rgb(254 200 75 / 0.75);
}
.bg-warning-300\\/80{
  background-color: rgb(254 200 75 / 0.8);
}
.bg-warning-300\\/85{
  background-color: rgb(254 200 75 / 0.85);
}
.bg-warning-300\\/90{
  background-color: rgb(254 200 75 / 0.9);
}
.bg-warning-300\\/95{
  background-color: rgb(254 200 75 / 0.95);
}
.bg-warning-400{
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}
.bg-warning-400\\/0{
  background-color: rgb(253 176 34 / 0);
}
.bg-warning-400\\/10{
  background-color: rgb(253 176 34 / 0.1);
}
.bg-warning-400\\/100{
  background-color: rgb(253 176 34 / 1);
}
.bg-warning-400\\/15{
  background-color: rgb(253 176 34 / 0.15);
}
.bg-warning-400\\/20{
  background-color: rgb(253 176 34 / 0.2);
}
.bg-warning-400\\/25{
  background-color: rgb(253 176 34 / 0.25);
}
.bg-warning-400\\/30{
  background-color: rgb(253 176 34 / 0.3);
}
.bg-warning-400\\/35{
  background-color: rgb(253 176 34 / 0.35);
}
.bg-warning-400\\/40{
  background-color: rgb(253 176 34 / 0.4);
}
.bg-warning-400\\/45{
  background-color: rgb(253 176 34 / 0.45);
}
.bg-warning-400\\/5{
  background-color: rgb(253 176 34 / 0.05);
}
.bg-warning-400\\/50{
  background-color: rgb(253 176 34 / 0.5);
}
.bg-warning-400\\/55{
  background-color: rgb(253 176 34 / 0.55);
}
.bg-warning-400\\/60{
  background-color: rgb(253 176 34 / 0.6);
}
.bg-warning-400\\/65{
  background-color: rgb(253 176 34 / 0.65);
}
.bg-warning-400\\/70{
  background-color: rgb(253 176 34 / 0.7);
}
.bg-warning-400\\/75{
  background-color: rgb(253 176 34 / 0.75);
}
.bg-warning-400\\/80{
  background-color: rgb(253 176 34 / 0.8);
}
.bg-warning-400\\/85{
  background-color: rgb(253 176 34 / 0.85);
}
.bg-warning-400\\/90{
  background-color: rgb(253 176 34 / 0.9);
}
.bg-warning-400\\/95{
  background-color: rgb(253 176 34 / 0.95);
}
.bg-warning-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.bg-warning-50\\/0{
  background-color: rgb(255 250 235 / 0);
}
.bg-warning-50\\/10{
  background-color: rgb(255 250 235 / 0.1);
}
.bg-warning-50\\/100{
  background-color: rgb(255 250 235 / 1);
}
.bg-warning-50\\/15{
  background-color: rgb(255 250 235 / 0.15);
}
.bg-warning-50\\/20{
  background-color: rgb(255 250 235 / 0.2);
}
.bg-warning-50\\/25{
  background-color: rgb(255 250 235 / 0.25);
}
.bg-warning-50\\/30{
  background-color: rgb(255 250 235 / 0.3);
}
.bg-warning-50\\/35{
  background-color: rgb(255 250 235 / 0.35);
}
.bg-warning-50\\/40{
  background-color: rgb(255 250 235 / 0.4);
}
.bg-warning-50\\/45{
  background-color: rgb(255 250 235 / 0.45);
}
.bg-warning-50\\/5{
  background-color: rgb(255 250 235 / 0.05);
}
.bg-warning-50\\/50{
  background-color: rgb(255 250 235 / 0.5);
}
.bg-warning-50\\/55{
  background-color: rgb(255 250 235 / 0.55);
}
.bg-warning-50\\/60{
  background-color: rgb(255 250 235 / 0.6);
}
.bg-warning-50\\/65{
  background-color: rgb(255 250 235 / 0.65);
}
.bg-warning-50\\/70{
  background-color: rgb(255 250 235 / 0.7);
}
.bg-warning-50\\/75{
  background-color: rgb(255 250 235 / 0.75);
}
.bg-warning-50\\/80{
  background-color: rgb(255 250 235 / 0.8);
}
.bg-warning-50\\/85{
  background-color: rgb(255 250 235 / 0.85);
}
.bg-warning-50\\/90{
  background-color: rgb(255 250 235 / 0.9);
}
.bg-warning-50\\/95{
  background-color: rgb(255 250 235 / 0.95);
}
.bg-warning-500{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-warning-500\\/0{
  background-color: rgb(247 144 9 / 0);
}
.bg-warning-500\\/10{
  background-color: rgb(247 144 9 / 0.1);
}
.bg-warning-500\\/100{
  background-color: rgb(247 144 9 / 1);
}
.bg-warning-500\\/15{
  background-color: rgb(247 144 9 / 0.15);
}
.bg-warning-500\\/20{
  background-color: rgb(247 144 9 / 0.2);
}
.bg-warning-500\\/25{
  background-color: rgb(247 144 9 / 0.25);
}
.bg-warning-500\\/30{
  background-color: rgb(247 144 9 / 0.3);
}
.bg-warning-500\\/35{
  background-color: rgb(247 144 9 / 0.35);
}
.bg-warning-500\\/40{
  background-color: rgb(247 144 9 / 0.4);
}
.bg-warning-500\\/45{
  background-color: rgb(247 144 9 / 0.45);
}
.bg-warning-500\\/5{
  background-color: rgb(247 144 9 / 0.05);
}
.bg-warning-500\\/50{
  background-color: rgb(247 144 9 / 0.5);
}
.bg-warning-500\\/55{
  background-color: rgb(247 144 9 / 0.55);
}
.bg-warning-500\\/60{
  background-color: rgb(247 144 9 / 0.6);
}
.bg-warning-500\\/65{
  background-color: rgb(247 144 9 / 0.65);
}
.bg-warning-500\\/70{
  background-color: rgb(247 144 9 / 0.7);
}
.bg-warning-500\\/75{
  background-color: rgb(247 144 9 / 0.75);
}
.bg-warning-500\\/80{
  background-color: rgb(247 144 9 / 0.8);
}
.bg-warning-500\\/85{
  background-color: rgb(247 144 9 / 0.85);
}
.bg-warning-500\\/90{
  background-color: rgb(247 144 9 / 0.9);
}
.bg-warning-500\\/95{
  background-color: rgb(247 144 9 / 0.95);
}
.bg-warning-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}
.bg-warning-600\\/0{
  background-color: rgb(220 104 3 / 0);
}
.bg-warning-600\\/10{
  background-color: rgb(220 104 3 / 0.1);
}
.bg-warning-600\\/100{
  background-color: rgb(220 104 3 / 1);
}
.bg-warning-600\\/15{
  background-color: rgb(220 104 3 / 0.15);
}
.bg-warning-600\\/20{
  background-color: rgb(220 104 3 / 0.2);
}
.bg-warning-600\\/25{
  background-color: rgb(220 104 3 / 0.25);
}
.bg-warning-600\\/30{
  background-color: rgb(220 104 3 / 0.3);
}
.bg-warning-600\\/35{
  background-color: rgb(220 104 3 / 0.35);
}
.bg-warning-600\\/40{
  background-color: rgb(220 104 3 / 0.4);
}
.bg-warning-600\\/45{
  background-color: rgb(220 104 3 / 0.45);
}
.bg-warning-600\\/5{
  background-color: rgb(220 104 3 / 0.05);
}
.bg-warning-600\\/50{
  background-color: rgb(220 104 3 / 0.5);
}
.bg-warning-600\\/55{
  background-color: rgb(220 104 3 / 0.55);
}
.bg-warning-600\\/60{
  background-color: rgb(220 104 3 / 0.6);
}
.bg-warning-600\\/65{
  background-color: rgb(220 104 3 / 0.65);
}
.bg-warning-600\\/70{
  background-color: rgb(220 104 3 / 0.7);
}
.bg-warning-600\\/75{
  background-color: rgb(220 104 3 / 0.75);
}
.bg-warning-600\\/80{
  background-color: rgb(220 104 3 / 0.8);
}
.bg-warning-600\\/85{
  background-color: rgb(220 104 3 / 0.85);
}
.bg-warning-600\\/90{
  background-color: rgb(220 104 3 / 0.9);
}
.bg-warning-600\\/95{
  background-color: rgb(220 104 3 / 0.95);
}
.bg-warning-700{
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}
.bg-warning-700\\/0{
  background-color: rgb(181 71 8 / 0);
}
.bg-warning-700\\/10{
  background-color: rgb(181 71 8 / 0.1);
}
.bg-warning-700\\/100{
  background-color: rgb(181 71 8 / 1);
}
.bg-warning-700\\/15{
  background-color: rgb(181 71 8 / 0.15);
}
.bg-warning-700\\/20{
  background-color: rgb(181 71 8 / 0.2);
}
.bg-warning-700\\/25{
  background-color: rgb(181 71 8 / 0.25);
}
.bg-warning-700\\/30{
  background-color: rgb(181 71 8 / 0.3);
}
.bg-warning-700\\/35{
  background-color: rgb(181 71 8 / 0.35);
}
.bg-warning-700\\/40{
  background-color: rgb(181 71 8 / 0.4);
}
.bg-warning-700\\/45{
  background-color: rgb(181 71 8 / 0.45);
}
.bg-warning-700\\/5{
  background-color: rgb(181 71 8 / 0.05);
}
.bg-warning-700\\/50{
  background-color: rgb(181 71 8 / 0.5);
}
.bg-warning-700\\/55{
  background-color: rgb(181 71 8 / 0.55);
}
.bg-warning-700\\/60{
  background-color: rgb(181 71 8 / 0.6);
}
.bg-warning-700\\/65{
  background-color: rgb(181 71 8 / 0.65);
}
.bg-warning-700\\/70{
  background-color: rgb(181 71 8 / 0.7);
}
.bg-warning-700\\/75{
  background-color: rgb(181 71 8 / 0.75);
}
.bg-warning-700\\/80{
  background-color: rgb(181 71 8 / 0.8);
}
.bg-warning-700\\/85{
  background-color: rgb(181 71 8 / 0.85);
}
.bg-warning-700\\/90{
  background-color: rgb(181 71 8 / 0.9);
}
.bg-warning-700\\/95{
  background-color: rgb(181 71 8 / 0.95);
}
.bg-warning-800{
  --tw-bg-opacity: 1;
  background-color: rgb(147 55 13 / var(--tw-bg-opacity, 1));
}
.bg-warning-800\\/0{
  background-color: rgb(147 55 13 / 0);
}
.bg-warning-800\\/10{
  background-color: rgb(147 55 13 / 0.1);
}
.bg-warning-800\\/100{
  background-color: rgb(147 55 13 / 1);
}
.bg-warning-800\\/15{
  background-color: rgb(147 55 13 / 0.15);
}
.bg-warning-800\\/20{
  background-color: rgb(147 55 13 / 0.2);
}
.bg-warning-800\\/25{
  background-color: rgb(147 55 13 / 0.25);
}
.bg-warning-800\\/30{
  background-color: rgb(147 55 13 / 0.3);
}
.bg-warning-800\\/35{
  background-color: rgb(147 55 13 / 0.35);
}
.bg-warning-800\\/40{
  background-color: rgb(147 55 13 / 0.4);
}
.bg-warning-800\\/45{
  background-color: rgb(147 55 13 / 0.45);
}
.bg-warning-800\\/5{
  background-color: rgb(147 55 13 / 0.05);
}
.bg-warning-800\\/50{
  background-color: rgb(147 55 13 / 0.5);
}
.bg-warning-800\\/55{
  background-color: rgb(147 55 13 / 0.55);
}
.bg-warning-800\\/60{
  background-color: rgb(147 55 13 / 0.6);
}
.bg-warning-800\\/65{
  background-color: rgb(147 55 13 / 0.65);
}
.bg-warning-800\\/70{
  background-color: rgb(147 55 13 / 0.7);
}
.bg-warning-800\\/75{
  background-color: rgb(147 55 13 / 0.75);
}
.bg-warning-800\\/80{
  background-color: rgb(147 55 13 / 0.8);
}
.bg-warning-800\\/85{
  background-color: rgb(147 55 13 / 0.85);
}
.bg-warning-800\\/90{
  background-color: rgb(147 55 13 / 0.9);
}
.bg-warning-800\\/95{
  background-color: rgb(147 55 13 / 0.95);
}
.bg-warning-900{
  --tw-bg-opacity: 1;
  background-color: rgb(122 46 14 / var(--tw-bg-opacity, 1));
}
.bg-warning-900\\/0{
  background-color: rgb(122 46 14 / 0);
}
.bg-warning-900\\/10{
  background-color: rgb(122 46 14 / 0.1);
}
.bg-warning-900\\/100{
  background-color: rgb(122 46 14 / 1);
}
.bg-warning-900\\/15{
  background-color: rgb(122 46 14 / 0.15);
}
.bg-warning-900\\/20{
  background-color: rgb(122 46 14 / 0.2);
}
.bg-warning-900\\/25{
  background-color: rgb(122 46 14 / 0.25);
}
.bg-warning-900\\/30{
  background-color: rgb(122 46 14 / 0.3);
}
.bg-warning-900\\/35{
  background-color: rgb(122 46 14 / 0.35);
}
.bg-warning-900\\/40{
  background-color: rgb(122 46 14 / 0.4);
}
.bg-warning-900\\/45{
  background-color: rgb(122 46 14 / 0.45);
}
.bg-warning-900\\/5{
  background-color: rgb(122 46 14 / 0.05);
}
.bg-warning-900\\/50{
  background-color: rgb(122 46 14 / 0.5);
}
.bg-warning-900\\/55{
  background-color: rgb(122 46 14 / 0.55);
}
.bg-warning-900\\/60{
  background-color: rgb(122 46 14 / 0.6);
}
.bg-warning-900\\/65{
  background-color: rgb(122 46 14 / 0.65);
}
.bg-warning-900\\/70{
  background-color: rgb(122 46 14 / 0.7);
}
.bg-warning-900\\/75{
  background-color: rgb(122 46 14 / 0.75);
}
.bg-warning-900\\/80{
  background-color: rgb(122 46 14 / 0.8);
}
.bg-warning-900\\/85{
  background-color: rgb(122 46 14 / 0.85);
}
.bg-warning-900\\/90{
  background-color: rgb(122 46 14 / 0.9);
}
.bg-warning-900\\/95{
  background-color: rgb(122 46 14 / 0.95);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85{
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 238 149 / var(--tw-bg-opacity, 1));
}
.bg-opacity-0{
  --tw-bg-opacity: 0;
}
.bg-opacity-10{
  --tw-bg-opacity: 0.1;
}
.bg-opacity-100{
  --tw-bg-opacity: 1;
}
.bg-opacity-20{
  --tw-bg-opacity: 0.2;
}
.bg-opacity-25{
  --tw-bg-opacity: 0.25;
}
.bg-opacity-30{
  --tw-bg-opacity: 0.3;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70{
  --tw-bg-opacity: 0.7;
}
.\\!bg-none{
  background-image: none !important;
}
.bg-\\[conic-gradient\\(rgba\\(51\\2c 201\\2c 255\\2c 1\\)\\2c rgba\\(51\\2c 201\\2c 255\\2c 0\\.1\\)\\)\\]{
  background-image: conic-gradient(rgba(51,201,255,1),rgba(51,201,255,0.1));
}
.bg-\\[linear-gradient\\(90deg\\2c color-mix\\(in_srgb\\2c theme\\(colors\\.primary\\.950\\)_70\\%\\2c transparent\\)_0\\%\\2c color-mix\\(in_srgb\\2c theme\\(colors\\.primary\\.900\\)_70\\%\\2c transparent\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,color-mix(in srgb,var(--color-primary-950, #062C41) 70%,transparent) 0%,color-mix(in srgb,var(--color-primary-900, #0B4A6F) 70%,transparent) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgba\\(18\\2c 18\\2c 18\\2c 0\\.7\\)_0\\%\\2c rgba\\(35\\2c 35\\2c 35\\2c 0\\.7\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,rgba(18,18,18,0.7) 0%,rgba(35,35,35,0.7) 100%);
}
.bg-\\[radial-gradient\\(circle\\2c theme\\(colors\\.primary\\.600\\)_0\\%\\2c theme\\(colors\\.primary\\.600\\)_0\\%\\2c transparent_100\\%\\)\\]{
  background-image: radial-gradient(circle,var(--color-primary-600, #0086C9) 0%,var(--color-primary-600, #0086C9) 0%,transparent 100%);
}
.bg-\\[radial-gradient\\(ellipse_at_right\\2c \\#38bdf8_20\\%\\2c transparent_80\\%\\)\\2c radial-gradient\\(circle_at_20\\%_30\\%\\2c \\#ffffff80_0\\%\\2c transparent_25\\%\\)\\2c radial-gradient\\(circle_at_70\\%_65\\%\\2c \\#a5f3fc66_0\\%\\2c transparent_35\\%\\)\\2c radial-gradient\\(circle_at_85\\%_45\\%\\2c \\#c084fc55_0\\%\\2c transparent_30\\%\\)\\2c radial-gradient\\(circle_at_40\\%_90\\%\\2c \\#f472b655_0\\%\\2c transparent_40\\%\\)\\]{
  background-image: radial-gradient(ellipse at right,#38bdf8 20%,transparent 80%),radial-gradient(circle at 20% 30%,#ffffff80 0%,transparent 25%),radial-gradient(circle at 70% 65%,#a5f3fc66 0%,transparent 35%),radial-gradient(circle at 85% 45%,#c084fc55 0%,transparent 30%),radial-gradient(circle at 40% 90%,#f472b655 0%,transparent 40%);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-primary-to-white{
  background-image: linear-gradient(90.01deg, #f0f9ff 0%, rgba(240, 249, 255, 0.24) 56.77%, #ffffff 82.66%, #ffffff 103.58%);
}
.bg-success-to-white{
  background-image: linear-gradient(90.01deg, #edfcf2 0%, rgba(237, 252, 242, 0.24) 56.77%, #ffffff 82.66%, #ffffff 103.58%);
}
.from-\\[\\#004F6B3D\\]{
  --tw-gradient-from: #004F6B3D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 79 107 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0093C4\\]{
  --tw-gradient-from: #0093C4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 147 196 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#00ABE8\\]{
  --tw-gradient-from: #00ABE8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 171 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#00B8E8\\]{
  --tw-gradient-from: #00B8E8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 184 232 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0E85B8\\]{
  --tw-gradient-from: #0E85B8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 133 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#13B8FF\\]{
  --tw-gradient-from: #13B8FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 184 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#13B9FF\\]{
  --tw-gradient-from: #13B9FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 185 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#13b8ff\\]{
  --tw-gradient-from: #13b8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 184 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1788BF\\]{
  --tw-gradient-from: #1788BF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 136 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#4E1D09\\]{
  --tw-gradient-from: #4E1D09 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(78 29 9 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#C1EFFF\\]{
  --tw-gradient-from: #C1EFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(193 239 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#CCF1FF\\]{
  --tw-gradient-from: #CCF1FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(204 241 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#D6F0FB\\]{
  --tw-gradient-from: #D6F0FB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(214 240 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#DFF5FF\\]{
  --tw-gradient-from: #DFF5FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(223 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#E6F7FF\\]{
  --tw-gradient-from: #E6F7FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(230 247 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F59E0B\\]{
  --tw-gradient-from: #F59E0B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F75454\\]{
  --tw-gradient-from: #F75454 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(247 84 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[rgba\\(19\\2c 185\\2c 255\\2c 0\\.08\\)\\]{
  --tw-gradient-from: rgba(19,185,255,0.08) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(19, 185, 255, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400{
  --tw-gradient-from: #22CCEE var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 204 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-50{
  --tw-gradient-from: #F9FAFA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-800{
  --tw-gradient-from: #252B37 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 43 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-900\\/80{
  --tw-gradient-from: rgb(24 29 39 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(24 29 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-25{
  --tw-gradient-from: var(--color-primary-25, #F5FBFF) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-400{
  --tw-gradient-from: var(--color-primary-400, #36BFFA) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50{
  --tw-gradient-from: var(--color-primary-50, #F0F9FF) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-success-400{
  --tw-gradient-from: #3CCB7F var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(60 203 127 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-success-50{
  --tw-gradient-from: #EDFCF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 252 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-warning-400{
  --tw-gradient-from: #FDB022 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 176 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #FFFFFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/70{
  --tw-gradient-from: rgb(255 255 255 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#E2F4FC\\]{
  --tw-gradient-to: rgb(226 244 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E2F4FC var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500{
  --tw-gradient-to: rgb(6 174 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06AED4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-neutral-50{
  --tw-gradient-to: rgb(249 250 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F9FAFA var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary-200{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--color-primary-200, #B9E6FE) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FFFFFF var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/50{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/60{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#00437B\\]{
  --tw-gradient-to: #00437B var(--tw-gradient-to-position);
}
.to-\\[\\#004f6b0d\\]{
  --tw-gradient-to: #004f6b0d var(--tw-gradient-to-position);
}
.to-\\[\\#007BB0\\]{
  --tw-gradient-to: #007BB0 var(--tw-gradient-to-position);
}
.to-\\[\\#00B8E8\\]{
  --tw-gradient-to: #00B8E8 var(--tw-gradient-to-position);
}
.to-\\[\\#098cc1\\]{
  --tw-gradient-to: #098cc1 var(--tw-gradient-to-position);
}
.to-\\[\\#0B6F99\\]{
  --tw-gradient-to: #0B6F99 var(--tw-gradient-to-position);
}
.to-\\[\\#13B9FF\\]{
  --tw-gradient-to: #13B9FF var(--tw-gradient-to-position);
}
.to-\\[\\#33C9FF\\]{
  --tw-gradient-to: #33C9FF var(--tw-gradient-to-position);
}
.to-\\[\\#4DD4F0\\]{
  --tw-gradient-to: #4DD4F0 var(--tw-gradient-to-position);
}
.to-\\[\\#85310F\\]{
  --tw-gradient-to: #85310F var(--tw-gradient-to-position);
}
.to-\\[\\#B6E9FF\\]{
  --tw-gradient-to: #B6E9FF var(--tw-gradient-to-position);
}
.to-\\[\\#D4880A\\]{
  --tw-gradient-to: #D4880A var(--tw-gradient-to-position);
}
.to-\\[\\#E6F8FF\\]{
  --tw-gradient-to: #E6F8FF var(--tw-gradient-to-position);
}
.to-\\[\\#EAF7FD\\]{
  --tw-gradient-to: #EAF7FD var(--tw-gradient-to-position);
}
.to-\\[\\#EF4444\\]{
  --tw-gradient-to: #EF4444 var(--tw-gradient-to-position);
}
.to-\\[\\#F0FAFF\\]{
  --tw-gradient-to: #F0FAFF var(--tw-gradient-to-position);
}
.to-\\[rgba\\(19\\2c 185\\2c 255\\2c 0\\.22\\)\\]{
  --tw-gradient-to: rgba(19,185,255,0.22) var(--tw-gradient-to-position);
}
.to-neutral-50{
  --tw-gradient-to: #F9FAFA var(--tw-gradient-to-position);
}
.to-neutral-700{
  --tw-gradient-to: #414651 var(--tw-gradient-to-position);
}
.to-primary-10{
  --tw-gradient-to: var(--color-primary-10, #FAFDFF) var(--tw-gradient-to-position);
}
.to-primary-100{
  --tw-gradient-to: var(--color-primary-100, #E0F2FE) var(--tw-gradient-to-position);
}
.to-primary-200{
  --tw-gradient-to: var(--color-primary-200, #B9E6FE) var(--tw-gradient-to-position);
}
.to-primary-25{
  --tw-gradient-to: var(--color-primary-25, #F5FBFF) var(--tw-gradient-to-position);
}
.to-primary-50{
  --tw-gradient-to: var(--color-primary-50, #F0F9FF) var(--tw-gradient-to-position);
}
.to-primary-600{
  --tw-gradient-to: var(--color-primary-600, #0086C9) var(--tw-gradient-to-position);
}
.to-success-100{
  --tw-gradient-to: #D3F8DF var(--tw-gradient-to-position);
}
.to-success-50{
  --tw-gradient-to: #EDFCF2 var(--tw-gradient-to-position);
}
.to-success-600{
  --tw-gradient-to: #099250 var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #15B79E var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-warning-600{
  --tw-gradient-to: #DC6803 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #FFFFFF var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-text{
  background-clip: text;
}
.bg-center{
  background-position: center;
}
.stroke-primary-50{
  stroke: var(--color-primary-50, #F0F9FF);
}
.stroke-primary-500{
  stroke: var(--color-primary-500, #0BA5EC);
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-bottom{
  object-position: bottom;
}
.object-center{
  object-position: center;
}
.object-left{
  object-position: left;
}
.object-right{
  object-position: right;
}
.object-top{
  object-position: top;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-1{
  padding: 0.25rem !important;
}
.\\!p-10{
  padding: 2.5rem !important;
}
.\\!p-2{
  padding: 0.5rem !important;
}
.\\!p-2\\.5{
  padding: 0.625rem !important;
}
.\\!p-3{
  padding: 0.75rem !important;
}
.\\!p-4{
  padding: 1rem !important;
}
.\\!p-5{
  padding: 1.25rem !important;
}
.\\!p-6{
  padding: 1.5rem !important;
}
.\\!p-8{
  padding: 2rem !important;
}
.\\!p-9{
  padding: 2.25rem !important;
}
.\\!p-\\[0px\\]{
  padding: 0px !important;
}
.\\!p-\\[12px\\]{
  padding: 12px !important;
}
.\\!p-\\[2px\\]{
  padding: 2px !important;
}
.\\!p-\\[8px\\]{
  padding: 8px !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-14{
  padding: 3.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-20{
  padding: 5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1\\.25rem\\]{
  padding: 1.25rem;
}
.p-\\[1\\.2rem\\]{
  padding: 1.2rem;
}
.p-\\[16px\\]{
  padding: 16px;
}
.p-\\[18px\\]{
  padding: 18px;
}
.p-\\[1px\\]{
  padding: 1px;
}
.p-\\[1rem\\]{
  padding: 1rem;
}
.p-\\[2\\.5px\\]{
  padding: 2.5px;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[21px\\]{
  padding: 21px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-\\[2rem\\]{
  padding: 2rem;
}
.p-\\[3px\\]{
  padding: 3px;
}
.p-\\[4px\\]{
  padding: 4px;
}
.p-\\[54px\\]{
  padding: 54px;
}
.p-\\[6px\\]{
  padding: 6px;
}
.p-\\[8px\\]{
  padding: 8px;
}
.\\!px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.\\!px-10{
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}
.\\!px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-36{
  padding-left: 9rem !important;
  padding-right: 9rem !important;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.\\!px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!px-7{
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
}
.\\!px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.\\!px-\\[10px\\]{
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.\\!px-\\[12px\\]{
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.\\!px-\\[14px\\]{
  padding-left: 14px !important;
  padding-right: 14px !important;
}
.\\!px-\\[15px\\]{
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.\\!px-\\[26px\\]{
  padding-left: 26px !important;
  padding-right: 26px !important;
}
.\\!px-\\[2px\\]{
  padding-left: 2px !important;
  padding-right: 2px !important;
}
.\\!px-\\[3px\\]{
  padding-left: 3px !important;
  padding-right: 3px !important;
}
.\\!px-\\[6px\\]{
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.\\!px-\\[7px\\]{
  padding-left: 7px !important;
  padding-right: 7px !important;
}
.\\!px-\\[8px\\]{
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.\\!py-0{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-10{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.\\!py-16{
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.\\!py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-2\\.5{
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.\\!py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.\\!py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.\\!py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.\\!py-6{
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.\\!py-7{
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}
.\\!py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.\\!py-9{
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}
.\\!py-\\[10px\\]{
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.\\!py-\\[12px\\]{
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.\\!py-\\[13px\\]{
  padding-top: 13px !important;
  padding-bottom: 13px !important;
}
.\\!py-\\[14px\\]{
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
.\\!py-\\[15px\\]{
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.\\!py-\\[20px\\]{
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.\\!py-\\[2px\\]{
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.\\!py-\\[4px\\]{
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.\\!py-\\[5px\\]{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.\\!py-\\[6px\\]{
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.\\!py-\\[7\\.5px\\]{
  padding-top: 7.5px !important;
  padding-bottom: 7.5px !important;
}
.\\!py-\\[7px\\]{
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-24{
  padding-left: 6rem;
  padding-right: 6rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-36{
  padding-left: 9rem;
  padding-right: 9rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-48{
  padding-left: 12rem;
  padding-right: 12rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[10px\\]{
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[11px\\]{
  padding-left: 11px;
  padding-right: 11px;
}
.px-\\[12px\\]{
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[14px\\]{
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[16px\\]{
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[18px\\]{
  padding-left: 18px;
  padding-right: 18px;
}
.px-\\[1px\\]{
  padding-left: 1px;
  padding-right: 1px;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[21px\\]{
  padding-left: 21px;
  padding-right: 21px;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[230px\\]{
  padding-left: 230px;
  padding-right: 230px;
}
.px-\\[24px\\]{
  padding-left: 24px;
  padding-right: 24px;
}
.px-\\[26px\\]{
  padding-left: 26px;
  padding-right: 26px;
}
.px-\\[3px\\]{
  padding-left: 3px;
  padding-right: 3px;
}
.px-\\[3rem\\]{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-\\[5px\\]{
  padding-left: 5px;
  padding-right: 5px;
}
.px-\\[60px\\]{
  padding-left: 60px;
  padding-right: 60px;
}
.px-\\[6px\\]{
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[72px\\]{
  padding-left: 72px;
  padding-right: 72px;
}
.px-\\[80px\\]{
  padding-left: 80px;
  padding-right: 80px;
}
.px-\\[8px\\]{
  padding-left: 8px;
  padding-right: 8px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-11{
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9{
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.py-\\[1\\.5rem\\]{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[13px\\]{
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[15px\\]{
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[18px\\]{
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[1px\\]{
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[1rem\\]{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-\\[2px\\]{
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\]{
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[40px\\]{
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[4px\\]{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[9px\\]{
  padding-top: 9px;
  padding-bottom: 9px;
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.\\!pb-0{
  padding-bottom: 0px !important;
}
.\\!pb-1{
  padding-bottom: 0.25rem !important;
}
.\\!pb-16{
  padding-bottom: 4rem !important;
}
.\\!pb-2{
  padding-bottom: 0.5rem !important;
}
.\\!pb-24{
  padding-bottom: 6rem !important;
}
.\\!pb-3{
  padding-bottom: 0.75rem !important;
}
.\\!pb-4{
  padding-bottom: 1rem !important;
}
.\\!pb-5{
  padding-bottom: 1.25rem !important;
}
.\\!pb-6{
  padding-bottom: 1.5rem !important;
}
.\\!pb-8{
  padding-bottom: 2rem !important;
}
.\\!pb-9{
  padding-bottom: 2.25rem !important;
}
.\\!pb-\\[2px\\]{
  padding-bottom: 2px !important;
}
.\\!pb-\\[6px\\]{
  padding-bottom: 6px !important;
}
.\\!pl-0{
  padding-left: 0px !important;
}
.\\!pl-12{
  padding-left: 3rem !important;
}
.\\!pl-16{
  padding-left: 4rem !important;
}
.\\!pl-2{
  padding-left: 0.5rem !important;
}
.\\!pl-3{
  padding-left: 0.75rem !important;
}
.\\!pl-4{
  padding-left: 1rem !important;
}
.\\!pl-5{
  padding-left: 1.25rem !important;
}
.\\!pl-6{
  padding-left: 1.5rem !important;
}
.\\!pl-7{
  padding-left: 1.75rem !important;
}
.\\!pl-8{
  padding-left: 2rem !important;
}
.\\!pl-9{
  padding-left: 2.25rem !important;
}
.\\!pl-\\[0px\\]{
  padding-left: 0px !important;
}
.\\!pl-\\[38px\\]{
  padding-left: 38px !important;
}
.\\!pr-0{
  padding-right: 0px !important;
}
.\\!pr-1{
  padding-right: 0.25rem !important;
}
.\\!pr-12{
  padding-right: 3rem !important;
}
.\\!pr-16{
  padding-right: 4rem !important;
}
.\\!pr-2{
  padding-right: 0.5rem !important;
}
.\\!pr-3{
  padding-right: 0.75rem !important;
}
.\\!pr-4{
  padding-right: 1rem !important;
}
.\\!pr-5{
  padding-right: 1.25rem !important;
}
.\\!pr-6{
  padding-right: 1.5rem !important;
}
.\\!pr-\\[0\\]{
  padding-right: 0 !important;
}
.\\!pr-\\[10px\\]{
  padding-right: 10px !important;
}
.\\!pt-0{
  padding-top: 0px !important;
}
.\\!pt-0\\.5{
  padding-top: 0.125rem !important;
}
.\\!pt-1{
  padding-top: 0.25rem !important;
}
.\\!pt-12{
  padding-top: 3rem !important;
}
.\\!pt-2{
  padding-top: 0.5rem !important;
}
.\\!pt-3{
  padding-top: 0.75rem !important;
}
.\\!pt-32{
  padding-top: 8rem !important;
}
.\\!pt-4{
  padding-top: 1rem !important;
}
.\\!pt-5{
  padding-top: 1.25rem !important;
}
.\\!pt-6{
  padding-top: 1.5rem !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-11{
  padding-bottom: 2.75rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-32{
  padding-bottom: 8rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-9{
  padding-bottom: 2.25rem;
}
.pb-\\[10px\\]{
  padding-bottom: 10px;
}
.pb-\\[112px\\]{
  padding-bottom: 112px;
}
.pb-\\[11px\\]{
  padding-bottom: 11px;
}
.pb-\\[124px\\]{
  padding-bottom: 124px;
}
.pb-\\[12px\\]{
  padding-bottom: 12px;
}
.pb-\\[150px\\]{
  padding-bottom: 150px;
}
.pb-\\[16px\\]{
  padding-bottom: 16px;
}
.pb-\\[200px\\]{
  padding-bottom: 200px;
}
.pb-\\[21px\\]{
  padding-bottom: 21px;
}
.pb-\\[2px\\]{
  padding-bottom: 2px;
}
.pb-\\[34px\\]{
  padding-bottom: 34px;
}
.pb-\\[4px\\]{
  padding-bottom: 4px;
}
.pb-\\[5px\\]{
  padding-bottom: 5px;
}
.pb-\\[6px\\]{
  padding-bottom: 6px;
}
.pb-\\[70px\\]{
  padding-bottom: 70px;
}
.pb-\\[80px\\]{
  padding-bottom: 80px;
}
.pb-\\[calc\\(var\\(--keyboard-inset\\2c 0px\\)\\+1\\.25rem\\)\\]{
  padding-bottom: calc(var(--keyboard-inset,0px) + 1.25rem);
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-0\\.5{
  padding-left: 0.125rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-1\\.5{
  padding-left: 0.375rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-16{
  padding-left: 4rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[105px\\]{
  padding-left: 105px;
}
.pl-\\[10px\\]{
  padding-left: 10px;
}
.pl-\\[13px\\]{
  padding-left: 13px;
}
.pl-\\[14px\\]{
  padding-left: 14px;
}
.pl-\\[17px\\]{
  padding-left: 17px;
}
.pl-\\[24px\\]{
  padding-left: 24px;
}
.pl-\\[264px\\]{
  padding-left: 264px;
}
.pl-\\[26px\\]{
  padding-left: 26px;
}
.pl-\\[42px\\]{
  padding-left: 42px;
}
.pl-\\[46px\\]{
  padding-left: 46px;
}
.pl-\\[4px\\]{
  padding-left: 4px;
}
.pl-\\[60px\\]{
  padding-left: 60px;
}
.pl-\\[70px\\]{
  padding-left: 70px;
}
.pl-\\[9px\\]{
  padding-left: 9px;
}
.pr-0{
  padding-right: 0px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[10px\\]{
  padding-right: 10px;
}
.pr-\\[14px\\]{
  padding-right: 14px;
}
.pr-\\[15px\\]{
  padding-right: 15px;
}
.pr-\\[20px\\]{
  padding-right: 20px;
}
.pr-\\[38px\\]{
  padding-right: 38px;
}
.pr-\\[60px\\]{
  padding-right: 60px;
}
.pr-\\[70px\\]{
  padding-right: 70px;
}
.pr-\\[84px\\]{
  padding-right: 84px;
}
.pr-\\[8px\\]{
  padding-right: 8px;
}
.ps-4{
  padding-inline-start: 1rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-20{
  padding-top: 5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[10px\\]{
  padding-top: 10px;
}
.pt-\\[12px\\]{
  padding-top: 12px;
}
.pt-\\[12vh\\]{
  padding-top: 12vh;
}
.pt-\\[150px\\]{
  padding-top: 150px;
}
.pt-\\[16px\\]{
  padding-top: 16px;
}
.pt-\\[22px\\]{
  padding-top: 22px;
}
.pt-\\[2px\\]{
  padding-top: 2px;
}
.pt-\\[39px\\]{
  padding-top: 39px;
}
.pt-\\[6px\\]{
  padding-top: 6px;
}
.pt-\\[8px\\]{
  padding-top: 8px;
}
.\\!text-left{
  text-align: left !important;
}
.text-left{
  text-align: left;
}
.\\!text-center{
  text-align: center !important;
}
.text-center{
  text-align: center;
}
.\\!text-right{
  text-align: right !important;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.\\!align-top{
  vertical-align: top !important;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.font-apple{
  font-family: Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.\\!text-3xl{
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.\\!text-\\[12px\\]{
  font-size: 12px !important;
}
.\\!text-\\[26px\\]{
  font-size: 26px !important;
}
.\\!text-\\[32px\\]{
  font-size: 32px !important;
}
.\\!text-\\[44px\\]{
  font-size: 44px !important;
}
.\\!text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-lg{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.\\!text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-7xl{
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[0\\.625rem\\]{
  font-size: 0.625rem;
}
.text-\\[0\\.875rem\\]{
  font-size: 0.875rem;
}
.text-\\[0\\.87rem\\]{
  font-size: 0.87rem;
}
.text-\\[1\\.75rem\\]{
  font-size: 1.75rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[2\\.5rem\\]{
  font-size: 2.5rem;
}
.text-\\[2\\.75rem\\]{
  font-size: 2.75rem;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[2rem\\]{
  font-size: 2rem;
}
.text-\\[3\\.25rem\\]{
  font-size: 3.25rem;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[clamp\\(17px\\2c 1\\.5vw\\2c 22px\\)\\]{
  font-size: clamp(17px, 1.5vw, 22px);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-xxs{
  font-size: 0.625rem;
}
.\\!font-400{
  font-weight: 400 !important;
}
.\\!font-500{
  font-weight: 500 !important;
}
.\\!font-600{
  font-weight: 600 !important;
}
.\\!font-medium{
  font-weight: 500 !important;
}
.font-400{
  font-weight: 400;
}
.font-500{
  font-weight: 500;
}
.font-600{
  font-weight: 600;
}
.font-700{
  font-weight: 700;
}
.font-800{
  font-weight: 800;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.font-thin{
  font-weight: 100;
}
.uppercase{
  text-transform: uppercase;
}
.\\!lowercase{
  text-transform: lowercase !important;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.\\!normal-case{
  text-transform: none !important;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.\\!leading-10{
  line-height: 2.5rem !important;
}
.\\!leading-4{
  line-height: 1rem !important;
}
.\\!leading-5{
  line-height: 1.25rem !important;
}
.\\!leading-6{
  line-height: 1.5rem !important;
}
.\\!leading-7{
  line-height: 1.75rem !important;
}
.\\!leading-8{
  line-height: 2rem !important;
}
.\\!leading-\\[114\\%\\]{
  line-height: 114% !important;
}
.\\!leading-\\[14px\\]{
  line-height: 14px !important;
}
.\\!leading-\\[55px\\]{
  line-height: 55px !important;
}
.\\!leading-none{
  line-height: 1 !important;
}
.\\!leading-tight{
  line-height: 1.25 !important;
}
.leading-3{
  line-height: .75rem;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-\\[1\\.7\\]{
  line-height: 1.7;
}
.leading-\\[1\\.8\\]{
  line-height: 1.8;
}
.leading-\\[112\\%\\]{
  line-height: 112%;
}
.leading-\\[114\\%\\]{
  line-height: 114%;
}
.leading-\\[117\\%\\]{
  line-height: 117%;
}
.leading-\\[120\\%\\]{
  line-height: 120%;
}
.leading-\\[125\\%\\]{
  line-height: 125%;
}
.leading-\\[129\\%\\]{
  line-height: 129%;
}
.leading-\\[130\\%\\]{
  line-height: 130%;
}
.leading-\\[133\\%\\]{
  line-height: 133%;
}
.leading-\\[13px\\]{
  line-height: 13px;
}
.leading-\\[140\\%\\]{
  line-height: 140%;
}
.leading-\\[143\\%\\]{
  line-height: 143%;
}
.leading-\\[14px\\]{
  line-height: 14px;
}
.leading-\\[150\\%\\]{
  line-height: 150%;
}
.leading-\\[156\\%\\]{
  line-height: 156%;
}
.leading-\\[157\\%\\]{
  line-height: 157%;
}
.leading-\\[15px\\]{
  line-height: 15px;
}
.leading-\\[167\\%\\]{
  line-height: 167%;
}
.leading-\\[16px\\]{
  line-height: 16px;
}
.leading-\\[17px\\]{
  line-height: 17px;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.leading-\\[19px\\]{
  line-height: 19px;
}
.leading-\\[20px\\]{
  line-height: 20px;
}
.leading-\\[22px\\]{
  line-height: 22px;
}
.leading-\\[24px\\]{
  line-height: 24px;
}
.leading-\\[26px\\]{
  line-height: 26px;
}
.leading-\\[28px\\]{
  line-height: 28px;
}
.leading-\\[30px\\]{
  line-height: 30px;
}
.leading-\\[44px\\]{
  line-height: 44px;
}
.leading-loose{
  line-height: 2;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\]{
  letter-spacing: -0.02em;
}
.tracking-\\[0\\.06em\\]{
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.1em\\]{
  letter-spacing: 0.1em;
}
.tracking-\\[1px\\]{
  letter-spacing: 1px;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.\\!text-\\[\\#13b8ff\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(19 184 255 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-\\[\\#8191E8\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(129 145 232 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-danger-500{
  --tw-text-opacity: 1 !important;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-danger-600{
  --tw-text-opacity: 1 !important;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-danger-700{
  --tw-text-opacity: 1 !important;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-400{
  --tw-text-opacity: 1 !important;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-500{
  --tw-text-opacity: 1 !important;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-600{
  --tw-text-opacity: 1 !important;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-700{
  --tw-text-opacity: 1 !important;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-800{
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-neutral-900{
  --tw-text-opacity: 1 !important;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-primary-50{
  color: var(--color-primary-50, #F0F9FF) !important;
}
.\\!text-primary-500{
  color: var(--color-primary-500, #0BA5EC) !important;
}
.\\!text-primary-600{
  color: var(--color-primary-600, #0086C9) !important;
}
.\\!text-primary-700{
  color: var(--color-primary-700, #026AA2) !important;
}
.\\!text-primary-800{
  color: var(--color-primary-800, #065986) !important;
}
.\\!text-primary-900{
  color: var(--color-primary-900, #0B4A6F) !important;
}
.\\!text-success-500{
  --tw-text-opacity: 1 !important;
  color: rgb(22 179 100 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-success-900{
  --tw-text-opacity: 1 !important;
  color: rgb(8 76 46 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-warning-500{
  --tw-text-opacity: 1 !important;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#003A4B\\]{
  --tw-text-opacity: 1;
  color: rgb(0 58 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#004F6B\\]{
  --tw-text-opacity: 1;
  color: rgb(0 79 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0086c9\\]{
  --tw-text-opacity: 1;
  color: rgb(0 134 201 / var(--tw-text-opacity, 1));
}
.text-\\[\\#13b8ff\\]{
  --tw-text-opacity: 1;
  color: rgb(19 184 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#171717\\]{
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.text-\\[\\#17B26A\\]{
  --tw-text-opacity: 1;
  color: rgb(23 178 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#374145\\]{
  --tw-text-opacity: 1;
  color: rgb(55 65 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8191E8\\]{
  --tw-text-opacity: 1;
  color: rgb(129 145 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8fa0a7\\]{
  --tw-text-opacity: 1;
  color: rgb(143 160 167 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F04438\\]{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F79009\\]{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}
.text-\\[color\\:var\\(--color-on-primary\\2c \\#fff\\)\\]{
  color: var(--color-on-primary,#fff);
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 138 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 112 144 / var(--tw-text-opacity, 1));
}
.text-danger-100{
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}
.text-danger-100\\/0{
  color: rgb(254 228 226 / 0);
}
.text-danger-100\\/10{
  color: rgb(254 228 226 / 0.1);
}
.text-danger-100\\/100{
  color: rgb(254 228 226 / 1);
}
.text-danger-100\\/15{
  color: rgb(254 228 226 / 0.15);
}
.text-danger-100\\/20{
  color: rgb(254 228 226 / 0.2);
}
.text-danger-100\\/25{
  color: rgb(254 228 226 / 0.25);
}
.text-danger-100\\/30{
  color: rgb(254 228 226 / 0.3);
}
.text-danger-100\\/35{
  color: rgb(254 228 226 / 0.35);
}
.text-danger-100\\/40{
  color: rgb(254 228 226 / 0.4);
}
.text-danger-100\\/45{
  color: rgb(254 228 226 / 0.45);
}
.text-danger-100\\/5{
  color: rgb(254 228 226 / 0.05);
}
.text-danger-100\\/50{
  color: rgb(254 228 226 / 0.5);
}
.text-danger-100\\/55{
  color: rgb(254 228 226 / 0.55);
}
.text-danger-100\\/60{
  color: rgb(254 228 226 / 0.6);
}
.text-danger-100\\/65{
  color: rgb(254 228 226 / 0.65);
}
.text-danger-100\\/70{
  color: rgb(254 228 226 / 0.7);
}
.text-danger-100\\/75{
  color: rgb(254 228 226 / 0.75);
}
.text-danger-100\\/80{
  color: rgb(254 228 226 / 0.8);
}
.text-danger-100\\/85{
  color: rgb(254 228 226 / 0.85);
}
.text-danger-100\\/90{
  color: rgb(254 228 226 / 0.9);
}
.text-danger-100\\/95{
  color: rgb(254 228 226 / 0.95);
}
.text-danger-200{
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}
.text-danger-200\\/0{
  color: rgb(254 205 202 / 0);
}
.text-danger-200\\/10{
  color: rgb(254 205 202 / 0.1);
}
.text-danger-200\\/100{
  color: rgb(254 205 202 / 1);
}
.text-danger-200\\/15{
  color: rgb(254 205 202 / 0.15);
}
.text-danger-200\\/20{
  color: rgb(254 205 202 / 0.2);
}
.text-danger-200\\/25{
  color: rgb(254 205 202 / 0.25);
}
.text-danger-200\\/30{
  color: rgb(254 205 202 / 0.3);
}
.text-danger-200\\/35{
  color: rgb(254 205 202 / 0.35);
}
.text-danger-200\\/40{
  color: rgb(254 205 202 / 0.4);
}
.text-danger-200\\/45{
  color: rgb(254 205 202 / 0.45);
}
.text-danger-200\\/5{
  color: rgb(254 205 202 / 0.05);
}
.text-danger-200\\/50{
  color: rgb(254 205 202 / 0.5);
}
.text-danger-200\\/55{
  color: rgb(254 205 202 / 0.55);
}
.text-danger-200\\/60{
  color: rgb(254 205 202 / 0.6);
}
.text-danger-200\\/65{
  color: rgb(254 205 202 / 0.65);
}
.text-danger-200\\/70{
  color: rgb(254 205 202 / 0.7);
}
.text-danger-200\\/75{
  color: rgb(254 205 202 / 0.75);
}
.text-danger-200\\/80{
  color: rgb(254 205 202 / 0.8);
}
.text-danger-200\\/85{
  color: rgb(254 205 202 / 0.85);
}
.text-danger-200\\/90{
  color: rgb(254 205 202 / 0.9);
}
.text-danger-200\\/95{
  color: rgb(254 205 202 / 0.95);
}
.text-danger-25{
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}
.text-danger-25\\/0{
  color: rgb(255 251 250 / 0);
}
.text-danger-25\\/10{
  color: rgb(255 251 250 / 0.1);
}
.text-danger-25\\/100{
  color: rgb(255 251 250 / 1);
}
.text-danger-25\\/15{
  color: rgb(255 251 250 / 0.15);
}
.text-danger-25\\/20{
  color: rgb(255 251 250 / 0.2);
}
.text-danger-25\\/25{
  color: rgb(255 251 250 / 0.25);
}
.text-danger-25\\/30{
  color: rgb(255 251 250 / 0.3);
}
.text-danger-25\\/35{
  color: rgb(255 251 250 / 0.35);
}
.text-danger-25\\/40{
  color: rgb(255 251 250 / 0.4);
}
.text-danger-25\\/45{
  color: rgb(255 251 250 / 0.45);
}
.text-danger-25\\/5{
  color: rgb(255 251 250 / 0.05);
}
.text-danger-25\\/50{
  color: rgb(255 251 250 / 0.5);
}
.text-danger-25\\/55{
  color: rgb(255 251 250 / 0.55);
}
.text-danger-25\\/60{
  color: rgb(255 251 250 / 0.6);
}
.text-danger-25\\/65{
  color: rgb(255 251 250 / 0.65);
}
.text-danger-25\\/70{
  color: rgb(255 251 250 / 0.7);
}
.text-danger-25\\/75{
  color: rgb(255 251 250 / 0.75);
}
.text-danger-25\\/80{
  color: rgb(255 251 250 / 0.8);
}
.text-danger-25\\/85{
  color: rgb(255 251 250 / 0.85);
}
.text-danger-25\\/90{
  color: rgb(255 251 250 / 0.9);
}
.text-danger-25\\/95{
  color: rgb(255 251 250 / 0.95);
}
.text-danger-400{
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}
.text-danger-400\\/0{
  color: rgb(249 112 102 / 0);
}
.text-danger-400\\/10{
  color: rgb(249 112 102 / 0.1);
}
.text-danger-400\\/100{
  color: rgb(249 112 102 / 1);
}
.text-danger-400\\/15{
  color: rgb(249 112 102 / 0.15);
}
.text-danger-400\\/20{
  color: rgb(249 112 102 / 0.2);
}
.text-danger-400\\/25{
  color: rgb(249 112 102 / 0.25);
}
.text-danger-400\\/30{
  color: rgb(249 112 102 / 0.3);
}
.text-danger-400\\/35{
  color: rgb(249 112 102 / 0.35);
}
.text-danger-400\\/40{
  color: rgb(249 112 102 / 0.4);
}
.text-danger-400\\/45{
  color: rgb(249 112 102 / 0.45);
}
.text-danger-400\\/5{
  color: rgb(249 112 102 / 0.05);
}
.text-danger-400\\/50{
  color: rgb(249 112 102 / 0.5);
}
.text-danger-400\\/55{
  color: rgb(249 112 102 / 0.55);
}
.text-danger-400\\/60{
  color: rgb(249 112 102 / 0.6);
}
.text-danger-400\\/65{
  color: rgb(249 112 102 / 0.65);
}
.text-danger-400\\/70{
  color: rgb(249 112 102 / 0.7);
}
.text-danger-400\\/75{
  color: rgb(249 112 102 / 0.75);
}
.text-danger-400\\/80{
  color: rgb(249 112 102 / 0.8);
}
.text-danger-400\\/85{
  color: rgb(249 112 102 / 0.85);
}
.text-danger-400\\/90{
  color: rgb(249 112 102 / 0.9);
}
.text-danger-400\\/95{
  color: rgb(249 112 102 / 0.95);
}
.text-danger-50{
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}
.text-danger-50\\/0{
  color: rgb(254 243 242 / 0);
}
.text-danger-50\\/10{
  color: rgb(254 243 242 / 0.1);
}
.text-danger-50\\/100{
  color: rgb(254 243 242 / 1);
}
.text-danger-50\\/15{
  color: rgb(254 243 242 / 0.15);
}
.text-danger-50\\/20{
  color: rgb(254 243 242 / 0.2);
}
.text-danger-50\\/25{
  color: rgb(254 243 242 / 0.25);
}
.text-danger-50\\/30{
  color: rgb(254 243 242 / 0.3);
}
.text-danger-50\\/35{
  color: rgb(254 243 242 / 0.35);
}
.text-danger-50\\/40{
  color: rgb(254 243 242 / 0.4);
}
.text-danger-50\\/45{
  color: rgb(254 243 242 / 0.45);
}
.text-danger-50\\/5{
  color: rgb(254 243 242 / 0.05);
}
.text-danger-50\\/50{
  color: rgb(254 243 242 / 0.5);
}
.text-danger-50\\/55{
  color: rgb(254 243 242 / 0.55);
}
.text-danger-50\\/60{
  color: rgb(254 243 242 / 0.6);
}
.text-danger-50\\/65{
  color: rgb(254 243 242 / 0.65);
}
.text-danger-50\\/70{
  color: rgb(254 243 242 / 0.7);
}
.text-danger-50\\/75{
  color: rgb(254 243 242 / 0.75);
}
.text-danger-50\\/80{
  color: rgb(254 243 242 / 0.8);
}
.text-danger-50\\/85{
  color: rgb(254 243 242 / 0.85);
}
.text-danger-50\\/90{
  color: rgb(254 243 242 / 0.9);
}
.text-danger-50\\/95{
  color: rgb(254 243 242 / 0.95);
}
.text-danger-500{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}
.text-danger-500\\/0{
  color: rgb(240 68 56 / 0);
}
.text-danger-500\\/10{
  color: rgb(240 68 56 / 0.1);
}
.text-danger-500\\/100{
  color: rgb(240 68 56 / 1);
}
.text-danger-500\\/15{
  color: rgb(240 68 56 / 0.15);
}
.text-danger-500\\/20{
  color: rgb(240 68 56 / 0.2);
}
.text-danger-500\\/25{
  color: rgb(240 68 56 / 0.25);
}
.text-danger-500\\/30{
  color: rgb(240 68 56 / 0.3);
}
.text-danger-500\\/35{
  color: rgb(240 68 56 / 0.35);
}
.text-danger-500\\/40{
  color: rgb(240 68 56 / 0.4);
}
.text-danger-500\\/45{
  color: rgb(240 68 56 / 0.45);
}
.text-danger-500\\/5{
  color: rgb(240 68 56 / 0.05);
}
.text-danger-500\\/50{
  color: rgb(240 68 56 / 0.5);
}
.text-danger-500\\/55{
  color: rgb(240 68 56 / 0.55);
}
.text-danger-500\\/60{
  color: rgb(240 68 56 / 0.6);
}
.text-danger-500\\/65{
  color: rgb(240 68 56 / 0.65);
}
.text-danger-500\\/70{
  color: rgb(240 68 56 / 0.7);
}
.text-danger-500\\/75{
  color: rgb(240 68 56 / 0.75);
}
.text-danger-500\\/80{
  color: rgb(240 68 56 / 0.8);
}
.text-danger-500\\/85{
  color: rgb(240 68 56 / 0.85);
}
.text-danger-500\\/90{
  color: rgb(240 68 56 / 0.9);
}
.text-danger-500\\/95{
  color: rgb(240 68 56 / 0.95);
}
.text-danger-600{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.text-danger-600\\/0{
  color: rgb(217 45 32 / 0);
}
.text-danger-600\\/10{
  color: rgb(217 45 32 / 0.1);
}
.text-danger-600\\/100{
  color: rgb(217 45 32 / 1);
}
.text-danger-600\\/15{
  color: rgb(217 45 32 / 0.15);
}
.text-danger-600\\/20{
  color: rgb(217 45 32 / 0.2);
}
.text-danger-600\\/25{
  color: rgb(217 45 32 / 0.25);
}
.text-danger-600\\/30{
  color: rgb(217 45 32 / 0.3);
}
.text-danger-600\\/35{
  color: rgb(217 45 32 / 0.35);
}
.text-danger-600\\/40{
  color: rgb(217 45 32 / 0.4);
}
.text-danger-600\\/45{
  color: rgb(217 45 32 / 0.45);
}
.text-danger-600\\/5{
  color: rgb(217 45 32 / 0.05);
}
.text-danger-600\\/50{
  color: rgb(217 45 32 / 0.5);
}
.text-danger-600\\/55{
  color: rgb(217 45 32 / 0.55);
}
.text-danger-600\\/60{
  color: rgb(217 45 32 / 0.6);
}
.text-danger-600\\/65{
  color: rgb(217 45 32 / 0.65);
}
.text-danger-600\\/70{
  color: rgb(217 45 32 / 0.7);
}
.text-danger-600\\/75{
  color: rgb(217 45 32 / 0.75);
}
.text-danger-600\\/80{
  color: rgb(217 45 32 / 0.8);
}
.text-danger-600\\/85{
  color: rgb(217 45 32 / 0.85);
}
.text-danger-600\\/90{
  color: rgb(217 45 32 / 0.9);
}
.text-danger-600\\/95{
  color: rgb(217 45 32 / 0.95);
}
.text-danger-700{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-danger-700\\/0{
  color: rgb(180 35 24 / 0);
}
.text-danger-700\\/10{
  color: rgb(180 35 24 / 0.1);
}
.text-danger-700\\/100{
  color: rgb(180 35 24 / 1);
}
.text-danger-700\\/15{
  color: rgb(180 35 24 / 0.15);
}
.text-danger-700\\/20{
  color: rgb(180 35 24 / 0.2);
}
.text-danger-700\\/25{
  color: rgb(180 35 24 / 0.25);
}
.text-danger-700\\/30{
  color: rgb(180 35 24 / 0.3);
}
.text-danger-700\\/35{
  color: rgb(180 35 24 / 0.35);
}
.text-danger-700\\/40{
  color: rgb(180 35 24 / 0.4);
}
.text-danger-700\\/45{
  color: rgb(180 35 24 / 0.45);
}
.text-danger-700\\/5{
  color: rgb(180 35 24 / 0.05);
}
.text-danger-700\\/50{
  color: rgb(180 35 24 / 0.5);
}
.text-danger-700\\/55{
  color: rgb(180 35 24 / 0.55);
}
.text-danger-700\\/60{
  color: rgb(180 35 24 / 0.6);
}
.text-danger-700\\/65{
  color: rgb(180 35 24 / 0.65);
}
.text-danger-700\\/70{
  color: rgb(180 35 24 / 0.7);
}
.text-danger-700\\/75{
  color: rgb(180 35 24 / 0.75);
}
.text-danger-700\\/80{
  color: rgb(180 35 24 / 0.8);
}
.text-danger-700\\/85{
  color: rgb(180 35 24 / 0.85);
}
.text-danger-700\\/90{
  color: rgb(180 35 24 / 0.9);
}
.text-danger-700\\/95{
  color: rgb(180 35 24 / 0.95);
}
.text-danger-800{
  --tw-text-opacity: 1;
  color: rgb(145 32 24 / var(--tw-text-opacity, 1));
}
.text-danger-900{
  --tw-text-opacity: 1;
  color: rgb(122 39 26 / var(--tw-text-opacity, 1));
}
.text-moss-100{
  --tw-text-opacity: 1;
  color: rgb(230 244 215 / var(--tw-text-opacity, 1));
}
.text-moss-100\\/0{
  color: rgb(230 244 215 / 0);
}
.text-moss-100\\/10{
  color: rgb(230 244 215 / 0.1);
}
.text-moss-100\\/100{
  color: rgb(230 244 215 / 1);
}
.text-moss-100\\/15{
  color: rgb(230 244 215 / 0.15);
}
.text-moss-100\\/20{
  color: rgb(230 244 215 / 0.2);
}
.text-moss-100\\/25{
  color: rgb(230 244 215 / 0.25);
}
.text-moss-100\\/30{
  color: rgb(230 244 215 / 0.3);
}
.text-moss-100\\/35{
  color: rgb(230 244 215 / 0.35);
}
.text-moss-100\\/40{
  color: rgb(230 244 215 / 0.4);
}
.text-moss-100\\/45{
  color: rgb(230 244 215 / 0.45);
}
.text-moss-100\\/5{
  color: rgb(230 244 215 / 0.05);
}
.text-moss-100\\/50{
  color: rgb(230 244 215 / 0.5);
}
.text-moss-100\\/55{
  color: rgb(230 244 215 / 0.55);
}
.text-moss-100\\/60{
  color: rgb(230 244 215 / 0.6);
}
.text-moss-100\\/65{
  color: rgb(230 244 215 / 0.65);
}
.text-moss-100\\/70{
  color: rgb(230 244 215 / 0.7);
}
.text-moss-100\\/75{
  color: rgb(230 244 215 / 0.75);
}
.text-moss-100\\/80{
  color: rgb(230 244 215 / 0.8);
}
.text-moss-100\\/85{
  color: rgb(230 244 215 / 0.85);
}
.text-moss-100\\/90{
  color: rgb(230 244 215 / 0.9);
}
.text-moss-100\\/95{
  color: rgb(230 244 215 / 0.95);
}
.text-moss-200{
  --tw-text-opacity: 1;
  color: rgb(206 234 176 / var(--tw-text-opacity, 1));
}
.text-moss-200\\/0{
  color: rgb(206 234 176 / 0);
}
.text-moss-200\\/10{
  color: rgb(206 234 176 / 0.1);
}
.text-moss-200\\/100{
  color: rgb(206 234 176 / 1);
}
.text-moss-200\\/15{
  color: rgb(206 234 176 / 0.15);
}
.text-moss-200\\/20{
  color: rgb(206 234 176 / 0.2);
}
.text-moss-200\\/25{
  color: rgb(206 234 176 / 0.25);
}
.text-moss-200\\/30{
  color: rgb(206 234 176 / 0.3);
}
.text-moss-200\\/35{
  color: rgb(206 234 176 / 0.35);
}
.text-moss-200\\/40{
  color: rgb(206 234 176 / 0.4);
}
.text-moss-200\\/45{
  color: rgb(206 234 176 / 0.45);
}
.text-moss-200\\/5{
  color: rgb(206 234 176 / 0.05);
}
.text-moss-200\\/50{
  color: rgb(206 234 176 / 0.5);
}
.text-moss-200\\/55{
  color: rgb(206 234 176 / 0.55);
}
.text-moss-200\\/60{
  color: rgb(206 234 176 / 0.6);
}
.text-moss-200\\/65{
  color: rgb(206 234 176 / 0.65);
}
.text-moss-200\\/70{
  color: rgb(206 234 176 / 0.7);
}
.text-moss-200\\/75{
  color: rgb(206 234 176 / 0.75);
}
.text-moss-200\\/80{
  color: rgb(206 234 176 / 0.8);
}
.text-moss-200\\/85{
  color: rgb(206 234 176 / 0.85);
}
.text-moss-200\\/90{
  color: rgb(206 234 176 / 0.9);
}
.text-moss-200\\/95{
  color: rgb(206 234 176 / 0.95);
}
.text-moss-25{
  --tw-text-opacity: 1;
  color: rgb(250 253 247 / var(--tw-text-opacity, 1));
}
.text-moss-25\\/0{
  color: rgb(250 253 247 / 0);
}
.text-moss-25\\/10{
  color: rgb(250 253 247 / 0.1);
}
.text-moss-25\\/100{
  color: rgb(250 253 247 / 1);
}
.text-moss-25\\/15{
  color: rgb(250 253 247 / 0.15);
}
.text-moss-25\\/20{
  color: rgb(250 253 247 / 0.2);
}
.text-moss-25\\/25{
  color: rgb(250 253 247 / 0.25);
}
.text-moss-25\\/30{
  color: rgb(250 253 247 / 0.3);
}
.text-moss-25\\/35{
  color: rgb(250 253 247 / 0.35);
}
.text-moss-25\\/40{
  color: rgb(250 253 247 / 0.4);
}
.text-moss-25\\/45{
  color: rgb(250 253 247 / 0.45);
}
.text-moss-25\\/5{
  color: rgb(250 253 247 / 0.05);
}
.text-moss-25\\/50{
  color: rgb(250 253 247 / 0.5);
}
.text-moss-25\\/55{
  color: rgb(250 253 247 / 0.55);
}
.text-moss-25\\/60{
  color: rgb(250 253 247 / 0.6);
}
.text-moss-25\\/65{
  color: rgb(250 253 247 / 0.65);
}
.text-moss-25\\/70{
  color: rgb(250 253 247 / 0.7);
}
.text-moss-25\\/75{
  color: rgb(250 253 247 / 0.75);
}
.text-moss-25\\/80{
  color: rgb(250 253 247 / 0.8);
}
.text-moss-25\\/85{
  color: rgb(250 253 247 / 0.85);
}
.text-moss-25\\/90{
  color: rgb(250 253 247 / 0.9);
}
.text-moss-25\\/95{
  color: rgb(250 253 247 / 0.95);
}
.text-moss-400{
  --tw-text-opacity: 1;
  color: rgb(134 203 60 / var(--tw-text-opacity, 1));
}
.text-moss-400\\/0{
  color: rgb(134 203 60 / 0);
}
.text-moss-400\\/10{
  color: rgb(134 203 60 / 0.1);
}
.text-moss-400\\/100{
  color: rgb(134 203 60 / 1);
}
.text-moss-400\\/15{
  color: rgb(134 203 60 / 0.15);
}
.text-moss-400\\/20{
  color: rgb(134 203 60 / 0.2);
}
.text-moss-400\\/25{
  color: rgb(134 203 60 / 0.25);
}
.text-moss-400\\/30{
  color: rgb(134 203 60 / 0.3);
}
.text-moss-400\\/35{
  color: rgb(134 203 60 / 0.35);
}
.text-moss-400\\/40{
  color: rgb(134 203 60 / 0.4);
}
.text-moss-400\\/45{
  color: rgb(134 203 60 / 0.45);
}
.text-moss-400\\/5{
  color: rgb(134 203 60 / 0.05);
}
.text-moss-400\\/50{
  color: rgb(134 203 60 / 0.5);
}
.text-moss-400\\/55{
  color: rgb(134 203 60 / 0.55);
}
.text-moss-400\\/60{
  color: rgb(134 203 60 / 0.6);
}
.text-moss-400\\/65{
  color: rgb(134 203 60 / 0.65);
}
.text-moss-400\\/70{
  color: rgb(134 203 60 / 0.7);
}
.text-moss-400\\/75{
  color: rgb(134 203 60 / 0.75);
}
.text-moss-400\\/80{
  color: rgb(134 203 60 / 0.8);
}
.text-moss-400\\/85{
  color: rgb(134 203 60 / 0.85);
}
.text-moss-400\\/90{
  color: rgb(134 203 60 / 0.9);
}
.text-moss-400\\/95{
  color: rgb(134 203 60 / 0.95);
}
.text-moss-50{
  --tw-text-opacity: 1;
  color: rgb(245 251 238 / var(--tw-text-opacity, 1));
}
.text-moss-50\\/0{
  color: rgb(245 251 238 / 0);
}
.text-moss-50\\/10{
  color: rgb(245 251 238 / 0.1);
}
.text-moss-50\\/100{
  color: rgb(245 251 238 / 1);
}
.text-moss-50\\/15{
  color: rgb(245 251 238 / 0.15);
}
.text-moss-50\\/20{
  color: rgb(245 251 238 / 0.2);
}
.text-moss-50\\/25{
  color: rgb(245 251 238 / 0.25);
}
.text-moss-50\\/30{
  color: rgb(245 251 238 / 0.3);
}
.text-moss-50\\/35{
  color: rgb(245 251 238 / 0.35);
}
.text-moss-50\\/40{
  color: rgb(245 251 238 / 0.4);
}
.text-moss-50\\/45{
  color: rgb(245 251 238 / 0.45);
}
.text-moss-50\\/5{
  color: rgb(245 251 238 / 0.05);
}
.text-moss-50\\/50{
  color: rgb(245 251 238 / 0.5);
}
.text-moss-50\\/55{
  color: rgb(245 251 238 / 0.55);
}
.text-moss-50\\/60{
  color: rgb(245 251 238 / 0.6);
}
.text-moss-50\\/65{
  color: rgb(245 251 238 / 0.65);
}
.text-moss-50\\/70{
  color: rgb(245 251 238 / 0.7);
}
.text-moss-50\\/75{
  color: rgb(245 251 238 / 0.75);
}
.text-moss-50\\/80{
  color: rgb(245 251 238 / 0.8);
}
.text-moss-50\\/85{
  color: rgb(245 251 238 / 0.85);
}
.text-moss-50\\/90{
  color: rgb(245 251 238 / 0.9);
}
.text-moss-50\\/95{
  color: rgb(245 251 238 / 0.95);
}
.text-moss-500{
  --tw-text-opacity: 1;
  color: rgb(102 159 42 / var(--tw-text-opacity, 1));
}
.text-moss-500\\/0{
  color: rgb(102 159 42 / 0);
}
.text-moss-500\\/10{
  color: rgb(102 159 42 / 0.1);
}
.text-moss-500\\/100{
  color: rgb(102 159 42 / 1);
}
.text-moss-500\\/15{
  color: rgb(102 159 42 / 0.15);
}
.text-moss-500\\/20{
  color: rgb(102 159 42 / 0.2);
}
.text-moss-500\\/25{
  color: rgb(102 159 42 / 0.25);
}
.text-moss-500\\/30{
  color: rgb(102 159 42 / 0.3);
}
.text-moss-500\\/35{
  color: rgb(102 159 42 / 0.35);
}
.text-moss-500\\/40{
  color: rgb(102 159 42 / 0.4);
}
.text-moss-500\\/45{
  color: rgb(102 159 42 / 0.45);
}
.text-moss-500\\/5{
  color: rgb(102 159 42 / 0.05);
}
.text-moss-500\\/50{
  color: rgb(102 159 42 / 0.5);
}
.text-moss-500\\/55{
  color: rgb(102 159 42 / 0.55);
}
.text-moss-500\\/60{
  color: rgb(102 159 42 / 0.6);
}
.text-moss-500\\/65{
  color: rgb(102 159 42 / 0.65);
}
.text-moss-500\\/70{
  color: rgb(102 159 42 / 0.7);
}
.text-moss-500\\/75{
  color: rgb(102 159 42 / 0.75);
}
.text-moss-500\\/80{
  color: rgb(102 159 42 / 0.8);
}
.text-moss-500\\/85{
  color: rgb(102 159 42 / 0.85);
}
.text-moss-500\\/90{
  color: rgb(102 159 42 / 0.9);
}
.text-moss-500\\/95{
  color: rgb(102 159 42 / 0.95);
}
.text-moss-600{
  --tw-text-opacity: 1;
  color: rgb(79 122 33 / var(--tw-text-opacity, 1));
}
.text-moss-600\\/0{
  color: rgb(79 122 33 / 0);
}
.text-moss-600\\/10{
  color: rgb(79 122 33 / 0.1);
}
.text-moss-600\\/100{
  color: rgb(79 122 33 / 1);
}
.text-moss-600\\/15{
  color: rgb(79 122 33 / 0.15);
}
.text-moss-600\\/20{
  color: rgb(79 122 33 / 0.2);
}
.text-moss-600\\/25{
  color: rgb(79 122 33 / 0.25);
}
.text-moss-600\\/30{
  color: rgb(79 122 33 / 0.3);
}
.text-moss-600\\/35{
  color: rgb(79 122 33 / 0.35);
}
.text-moss-600\\/40{
  color: rgb(79 122 33 / 0.4);
}
.text-moss-600\\/45{
  color: rgb(79 122 33 / 0.45);
}
.text-moss-600\\/5{
  color: rgb(79 122 33 / 0.05);
}
.text-moss-600\\/50{
  color: rgb(79 122 33 / 0.5);
}
.text-moss-600\\/55{
  color: rgb(79 122 33 / 0.55);
}
.text-moss-600\\/60{
  color: rgb(79 122 33 / 0.6);
}
.text-moss-600\\/65{
  color: rgb(79 122 33 / 0.65);
}
.text-moss-600\\/70{
  color: rgb(79 122 33 / 0.7);
}
.text-moss-600\\/75{
  color: rgb(79 122 33 / 0.75);
}
.text-moss-600\\/80{
  color: rgb(79 122 33 / 0.8);
}
.text-moss-600\\/85{
  color: rgb(79 122 33 / 0.85);
}
.text-moss-600\\/90{
  color: rgb(79 122 33 / 0.9);
}
.text-moss-600\\/95{
  color: rgb(79 122 33 / 0.95);
}
.text-moss-700{
  --tw-text-opacity: 1;
  color: rgb(63 98 26 / var(--tw-text-opacity, 1));
}
.text-moss-700\\/0{
  color: rgb(63 98 26 / 0);
}
.text-moss-700\\/10{
  color: rgb(63 98 26 / 0.1);
}
.text-moss-700\\/100{
  color: rgb(63 98 26 / 1);
}
.text-moss-700\\/15{
  color: rgb(63 98 26 / 0.15);
}
.text-moss-700\\/20{
  color: rgb(63 98 26 / 0.2);
}
.text-moss-700\\/25{
  color: rgb(63 98 26 / 0.25);
}
.text-moss-700\\/30{
  color: rgb(63 98 26 / 0.3);
}
.text-moss-700\\/35{
  color: rgb(63 98 26 / 0.35);
}
.text-moss-700\\/40{
  color: rgb(63 98 26 / 0.4);
}
.text-moss-700\\/45{
  color: rgb(63 98 26 / 0.45);
}
.text-moss-700\\/5{
  color: rgb(63 98 26 / 0.05);
}
.text-moss-700\\/50{
  color: rgb(63 98 26 / 0.5);
}
.text-moss-700\\/55{
  color: rgb(63 98 26 / 0.55);
}
.text-moss-700\\/60{
  color: rgb(63 98 26 / 0.6);
}
.text-moss-700\\/65{
  color: rgb(63 98 26 / 0.65);
}
.text-moss-700\\/70{
  color: rgb(63 98 26 / 0.7);
}
.text-moss-700\\/75{
  color: rgb(63 98 26 / 0.75);
}
.text-moss-700\\/80{
  color: rgb(63 98 26 / 0.8);
}
.text-moss-700\\/85{
  color: rgb(63 98 26 / 0.85);
}
.text-moss-700\\/90{
  color: rgb(63 98 26 / 0.9);
}
.text-moss-700\\/95{
  color: rgb(63 98 26 / 0.95);
}
.text-neutral-100{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.text-neutral-100\\/0{
  color: rgb(245 245 245 / 0);
}
.text-neutral-100\\/10{
  color: rgb(245 245 245 / 0.1);
}
.text-neutral-100\\/100{
  color: rgb(245 245 245 / 1);
}
.text-neutral-100\\/15{
  color: rgb(245 245 245 / 0.15);
}
.text-neutral-100\\/20{
  color: rgb(245 245 245 / 0.2);
}
.text-neutral-100\\/25{
  color: rgb(245 245 245 / 0.25);
}
.text-neutral-100\\/30{
  color: rgb(245 245 245 / 0.3);
}
.text-neutral-100\\/35{
  color: rgb(245 245 245 / 0.35);
}
.text-neutral-100\\/40{
  color: rgb(245 245 245 / 0.4);
}
.text-neutral-100\\/45{
  color: rgb(245 245 245 / 0.45);
}
.text-neutral-100\\/5{
  color: rgb(245 245 245 / 0.05);
}
.text-neutral-100\\/50{
  color: rgb(245 245 245 / 0.5);
}
.text-neutral-100\\/55{
  color: rgb(245 245 245 / 0.55);
}
.text-neutral-100\\/60{
  color: rgb(245 245 245 / 0.6);
}
.text-neutral-100\\/65{
  color: rgb(245 245 245 / 0.65);
}
.text-neutral-100\\/70{
  color: rgb(245 245 245 / 0.7);
}
.text-neutral-100\\/75{
  color: rgb(245 245 245 / 0.75);
}
.text-neutral-100\\/80{
  color: rgb(245 245 245 / 0.8);
}
.text-neutral-100\\/85{
  color: rgb(245 245 245 / 0.85);
}
.text-neutral-100\\/90{
  color: rgb(245 245 245 / 0.9);
}
.text-neutral-100\\/95{
  color: rgb(245 245 245 / 0.95);
}
.text-neutral-200{
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}
.text-neutral-200\\/0{
  color: rgb(233 234 235 / 0);
}
.text-neutral-200\\/10{
  color: rgb(233 234 235 / 0.1);
}
.text-neutral-200\\/100{
  color: rgb(233 234 235 / 1);
}
.text-neutral-200\\/15{
  color: rgb(233 234 235 / 0.15);
}
.text-neutral-200\\/20{
  color: rgb(233 234 235 / 0.2);
}
.text-neutral-200\\/25{
  color: rgb(233 234 235 / 0.25);
}
.text-neutral-200\\/30{
  color: rgb(233 234 235 / 0.3);
}
.text-neutral-200\\/35{
  color: rgb(233 234 235 / 0.35);
}
.text-neutral-200\\/40{
  color: rgb(233 234 235 / 0.4);
}
.text-neutral-200\\/45{
  color: rgb(233 234 235 / 0.45);
}
.text-neutral-200\\/5{
  color: rgb(233 234 235 / 0.05);
}
.text-neutral-200\\/50{
  color: rgb(233 234 235 / 0.5);
}
.text-neutral-200\\/55{
  color: rgb(233 234 235 / 0.55);
}
.text-neutral-200\\/60{
  color: rgb(233 234 235 / 0.6);
}
.text-neutral-200\\/65{
  color: rgb(233 234 235 / 0.65);
}
.text-neutral-200\\/70{
  color: rgb(233 234 235 / 0.7);
}
.text-neutral-200\\/75{
  color: rgb(233 234 235 / 0.75);
}
.text-neutral-200\\/80{
  color: rgb(233 234 235 / 0.8);
}
.text-neutral-200\\/85{
  color: rgb(233 234 235 / 0.85);
}
.text-neutral-200\\/90{
  color: rgb(233 234 235 / 0.9);
}
.text-neutral-200\\/95{
  color: rgb(233 234 235 / 0.95);
}
.text-neutral-25{
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}
.text-neutral-25\\/0{
  color: rgb(253 253 253 / 0);
}
.text-neutral-25\\/10{
  color: rgb(253 253 253 / 0.1);
}
.text-neutral-25\\/100{
  color: rgb(253 253 253 / 1);
}
.text-neutral-25\\/15{
  color: rgb(253 253 253 / 0.15);
}
.text-neutral-25\\/20{
  color: rgb(253 253 253 / 0.2);
}
.text-neutral-25\\/25{
  color: rgb(253 253 253 / 0.25);
}
.text-neutral-25\\/30{
  color: rgb(253 253 253 / 0.3);
}
.text-neutral-25\\/35{
  color: rgb(253 253 253 / 0.35);
}
.text-neutral-25\\/40{
  color: rgb(253 253 253 / 0.4);
}
.text-neutral-25\\/45{
  color: rgb(253 253 253 / 0.45);
}
.text-neutral-25\\/5{
  color: rgb(253 253 253 / 0.05);
}
.text-neutral-25\\/50{
  color: rgb(253 253 253 / 0.5);
}
.text-neutral-25\\/55{
  color: rgb(253 253 253 / 0.55);
}
.text-neutral-25\\/60{
  color: rgb(253 253 253 / 0.6);
}
.text-neutral-25\\/65{
  color: rgb(253 253 253 / 0.65);
}
.text-neutral-25\\/70{
  color: rgb(253 253 253 / 0.7);
}
.text-neutral-25\\/75{
  color: rgb(253 253 253 / 0.75);
}
.text-neutral-25\\/80{
  color: rgb(253 253 253 / 0.8);
}
.text-neutral-25\\/85{
  color: rgb(253 253 253 / 0.85);
}
.text-neutral-25\\/90{
  color: rgb(253 253 253 / 0.9);
}
.text-neutral-25\\/95{
  color: rgb(253 253 253 / 0.95);
}
.text-neutral-300{
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}
.text-neutral-400{
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}
.text-neutral-400\\/0{
  color: rgb(164 167 174 / 0);
}
.text-neutral-400\\/10{
  color: rgb(164 167 174 / 0.1);
}
.text-neutral-400\\/100{
  color: rgb(164 167 174 / 1);
}
.text-neutral-400\\/15{
  color: rgb(164 167 174 / 0.15);
}
.text-neutral-400\\/20{
  color: rgb(164 167 174 / 0.2);
}
.text-neutral-400\\/25{
  color: rgb(164 167 174 / 0.25);
}
.text-neutral-400\\/30{
  color: rgb(164 167 174 / 0.3);
}
.text-neutral-400\\/35{
  color: rgb(164 167 174 / 0.35);
}
.text-neutral-400\\/40{
  color: rgb(164 167 174 / 0.4);
}
.text-neutral-400\\/45{
  color: rgb(164 167 174 / 0.45);
}
.text-neutral-400\\/5{
  color: rgb(164 167 174 / 0.05);
}
.text-neutral-400\\/50{
  color: rgb(164 167 174 / 0.5);
}
.text-neutral-400\\/55{
  color: rgb(164 167 174 / 0.55);
}
.text-neutral-400\\/60{
  color: rgb(164 167 174 / 0.6);
}
.text-neutral-400\\/65{
  color: rgb(164 167 174 / 0.65);
}
.text-neutral-400\\/70{
  color: rgb(164 167 174 / 0.7);
}
.text-neutral-400\\/75{
  color: rgb(164 167 174 / 0.75);
}
.text-neutral-400\\/80{
  color: rgb(164 167 174 / 0.8);
}
.text-neutral-400\\/85{
  color: rgb(164 167 174 / 0.85);
}
.text-neutral-400\\/90{
  color: rgb(164 167 174 / 0.9);
}
.text-neutral-400\\/95{
  color: rgb(164 167 174 / 0.95);
}
.text-neutral-50{
  --tw-text-opacity: 1;
  color: rgb(249 250 250 / var(--tw-text-opacity, 1));
}
.text-neutral-50\\/0{
  color: rgb(249 250 250 / 0);
}
.text-neutral-50\\/10{
  color: rgb(249 250 250 / 0.1);
}
.text-neutral-50\\/100{
  color: rgb(249 250 250 / 1);
}
.text-neutral-50\\/15{
  color: rgb(249 250 250 / 0.15);
}
.text-neutral-50\\/20{
  color: rgb(249 250 250 / 0.2);
}
.text-neutral-50\\/25{
  color: rgb(249 250 250 / 0.25);
}
.text-neutral-50\\/30{
  color: rgb(249 250 250 / 0.3);
}
.text-neutral-50\\/35{
  color: rgb(249 250 250 / 0.35);
}
.text-neutral-50\\/40{
  color: rgb(249 250 250 / 0.4);
}
.text-neutral-50\\/45{
  color: rgb(249 250 250 / 0.45);
}
.text-neutral-50\\/5{
  color: rgb(249 250 250 / 0.05);
}
.text-neutral-50\\/50{
  color: rgb(249 250 250 / 0.5);
}
.text-neutral-50\\/55{
  color: rgb(249 250 250 / 0.55);
}
.text-neutral-50\\/60{
  color: rgb(249 250 250 / 0.6);
}
.text-neutral-50\\/65{
  color: rgb(249 250 250 / 0.65);
}
.text-neutral-50\\/70{
  color: rgb(249 250 250 / 0.7);
}
.text-neutral-50\\/75{
  color: rgb(249 250 250 / 0.75);
}
.text-neutral-50\\/80{
  color: rgb(249 250 250 / 0.8);
}
.text-neutral-50\\/85{
  color: rgb(249 250 250 / 0.85);
}
.text-neutral-50\\/90{
  color: rgb(249 250 250 / 0.9);
}
.text-neutral-50\\/95{
  color: rgb(249 250 250 / 0.95);
}
.text-neutral-500{
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.text-neutral-500\\/0{
  color: rgb(113 118 128 / 0);
}
.text-neutral-500\\/10{
  color: rgb(113 118 128 / 0.1);
}
.text-neutral-500\\/100{
  color: rgb(113 118 128 / 1);
}
.text-neutral-500\\/15{
  color: rgb(113 118 128 / 0.15);
}
.text-neutral-500\\/20{
  color: rgb(113 118 128 / 0.2);
}
.text-neutral-500\\/25{
  color: rgb(113 118 128 / 0.25);
}
.text-neutral-500\\/30{
  color: rgb(113 118 128 / 0.3);
}
.text-neutral-500\\/35{
  color: rgb(113 118 128 / 0.35);
}
.text-neutral-500\\/40{
  color: rgb(113 118 128 / 0.4);
}
.text-neutral-500\\/45{
  color: rgb(113 118 128 / 0.45);
}
.text-neutral-500\\/5{
  color: rgb(113 118 128 / 0.05);
}
.text-neutral-500\\/50{
  color: rgb(113 118 128 / 0.5);
}
.text-neutral-500\\/55{
  color: rgb(113 118 128 / 0.55);
}
.text-neutral-500\\/60{
  color: rgb(113 118 128 / 0.6);
}
.text-neutral-500\\/65{
  color: rgb(113 118 128 / 0.65);
}
.text-neutral-500\\/70{
  color: rgb(113 118 128 / 0.7);
}
.text-neutral-500\\/75{
  color: rgb(113 118 128 / 0.75);
}
.text-neutral-500\\/80{
  color: rgb(113 118 128 / 0.8);
}
.text-neutral-500\\/85{
  color: rgb(113 118 128 / 0.85);
}
.text-neutral-500\\/90{
  color: rgb(113 118 128 / 0.9);
}
.text-neutral-500\\/95{
  color: rgb(113 118 128 / 0.95);
}
.text-neutral-600{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}
.text-neutral-600\\/0{
  color: rgb(83 88 98 / 0);
}
.text-neutral-600\\/10{
  color: rgb(83 88 98 / 0.1);
}
.text-neutral-600\\/100{
  color: rgb(83 88 98 / 1);
}
.text-neutral-600\\/15{
  color: rgb(83 88 98 / 0.15);
}
.text-neutral-600\\/20{
  color: rgb(83 88 98 / 0.2);
}
.text-neutral-600\\/25{
  color: rgb(83 88 98 / 0.25);
}
.text-neutral-600\\/30{
  color: rgb(83 88 98 / 0.3);
}
.text-neutral-600\\/35{
  color: rgb(83 88 98 / 0.35);
}
.text-neutral-600\\/40{
  color: rgb(83 88 98 / 0.4);
}
.text-neutral-600\\/45{
  color: rgb(83 88 98 / 0.45);
}
.text-neutral-600\\/5{
  color: rgb(83 88 98 / 0.05);
}
.text-neutral-600\\/50{
  color: rgb(83 88 98 / 0.5);
}
.text-neutral-600\\/55{
  color: rgb(83 88 98 / 0.55);
}
.text-neutral-600\\/60{
  color: rgb(83 88 98 / 0.6);
}
.text-neutral-600\\/65{
  color: rgb(83 88 98 / 0.65);
}
.text-neutral-600\\/70{
  color: rgb(83 88 98 / 0.7);
}
.text-neutral-600\\/75{
  color: rgb(83 88 98 / 0.75);
}
.text-neutral-600\\/80{
  color: rgb(83 88 98 / 0.8);
}
.text-neutral-600\\/85{
  color: rgb(83 88 98 / 0.85);
}
.text-neutral-600\\/90{
  color: rgb(83 88 98 / 0.9);
}
.text-neutral-600\\/95{
  color: rgb(83 88 98 / 0.95);
}
.text-neutral-700{
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.text-neutral-700\\/0{
  color: rgb(65 70 81 / 0);
}
.text-neutral-700\\/10{
  color: rgb(65 70 81 / 0.1);
}
.text-neutral-700\\/100{
  color: rgb(65 70 81 / 1);
}
.text-neutral-700\\/15{
  color: rgb(65 70 81 / 0.15);
}
.text-neutral-700\\/20{
  color: rgb(65 70 81 / 0.2);
}
.text-neutral-700\\/25{
  color: rgb(65 70 81 / 0.25);
}
.text-neutral-700\\/30{
  color: rgb(65 70 81 / 0.3);
}
.text-neutral-700\\/35{
  color: rgb(65 70 81 / 0.35);
}
.text-neutral-700\\/40{
  color: rgb(65 70 81 / 0.4);
}
.text-neutral-700\\/45{
  color: rgb(65 70 81 / 0.45);
}
.text-neutral-700\\/5{
  color: rgb(65 70 81 / 0.05);
}
.text-neutral-700\\/50{
  color: rgb(65 70 81 / 0.5);
}
.text-neutral-700\\/55{
  color: rgb(65 70 81 / 0.55);
}
.text-neutral-700\\/60{
  color: rgb(65 70 81 / 0.6);
}
.text-neutral-700\\/65{
  color: rgb(65 70 81 / 0.65);
}
.text-neutral-700\\/70{
  color: rgb(65 70 81 / 0.7);
}
.text-neutral-700\\/75{
  color: rgb(65 70 81 / 0.75);
}
.text-neutral-700\\/80{
  color: rgb(65 70 81 / 0.8);
}
.text-neutral-700\\/85{
  color: rgb(65 70 81 / 0.85);
}
.text-neutral-700\\/90{
  color: rgb(65 70 81 / 0.9);
}
.text-neutral-700\\/95{
  color: rgb(65 70 81 / 0.95);
}
.text-neutral-75{
  --tw-text-opacity: 1;
  color: rgb(246 246 246 / var(--tw-text-opacity, 1));
}
.text-neutral-75\\/0{
  color: rgb(246 246 246 / 0);
}
.text-neutral-75\\/10{
  color: rgb(246 246 246 / 0.1);
}
.text-neutral-75\\/100{
  color: rgb(246 246 246 / 1);
}
.text-neutral-75\\/15{
  color: rgb(246 246 246 / 0.15);
}
.text-neutral-75\\/20{
  color: rgb(246 246 246 / 0.2);
}
.text-neutral-75\\/25{
  color: rgb(246 246 246 / 0.25);
}
.text-neutral-75\\/30{
  color: rgb(246 246 246 / 0.3);
}
.text-neutral-75\\/35{
  color: rgb(246 246 246 / 0.35);
}
.text-neutral-75\\/40{
  color: rgb(246 246 246 / 0.4);
}
.text-neutral-75\\/45{
  color: rgb(246 246 246 / 0.45);
}
.text-neutral-75\\/5{
  color: rgb(246 246 246 / 0.05);
}
.text-neutral-75\\/50{
  color: rgb(246 246 246 / 0.5);
}
.text-neutral-75\\/55{
  color: rgb(246 246 246 / 0.55);
}
.text-neutral-75\\/60{
  color: rgb(246 246 246 / 0.6);
}
.text-neutral-75\\/65{
  color: rgb(246 246 246 / 0.65);
}
.text-neutral-75\\/70{
  color: rgb(246 246 246 / 0.7);
}
.text-neutral-75\\/75{
  color: rgb(246 246 246 / 0.75);
}
.text-neutral-75\\/80{
  color: rgb(246 246 246 / 0.8);
}
.text-neutral-75\\/85{
  color: rgb(246 246 246 / 0.85);
}
.text-neutral-75\\/90{
  color: rgb(246 246 246 / 0.9);
}
.text-neutral-75\\/95{
  color: rgb(246 246 246 / 0.95);
}
.text-neutral-800{
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}
.text-neutral-900{
  --tw-text-opacity: 1;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1));
}
.text-neutral-dark-300{
  --tw-text-opacity: 1;
  color: rgb(206 207 210 / var(--tw-text-opacity, 1));
}
.text-neutral-dark-400{
  --tw-text-opacity: 1;
  color: rgb(148 151 156 / var(--tw-text-opacity, 1));
}
.text-orange-dark-400{
  --tw-text-opacity: 1;
  color: rgb(255 105 45 / var(--tw-text-opacity, 1));
}
.text-primary-100{
  color: var(--color-primary-100, #E0F2FE);
}
.text-primary-200{
  color: var(--color-primary-200, #B9E6FE);
}
.text-primary-25{
  color: var(--color-primary-25, #F5FBFF);
}
.text-primary-300{
  color: var(--color-primary-300, #7CD4FD);
}
.text-primary-400{
  color: var(--color-primary-400, #36BFFA);
}
.text-primary-50{
  color: var(--color-primary-50, #F0F9FF);
}
.text-primary-500{
  color: var(--color-primary-500, #0BA5EC);
}
.text-primary-600{
  color: var(--color-primary-600, #0086C9);
}
.text-primary-700{
  color: var(--color-primary-700, #026AA2);
}
.text-primary-800{
  color: var(--color-primary-800, #065986);
}
.text-primary-900{
  color: var(--color-primary-900, #0B4A6F);
}
.text-purple-100{
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}
.text-purple-100\\/0{
  color: rgb(235 233 254 / 0);
}
.text-purple-100\\/10{
  color: rgb(235 233 254 / 0.1);
}
.text-purple-100\\/100{
  color: rgb(235 233 254 / 1);
}
.text-purple-100\\/15{
  color: rgb(235 233 254 / 0.15);
}
.text-purple-100\\/20{
  color: rgb(235 233 254 / 0.2);
}
.text-purple-100\\/25{
  color: rgb(235 233 254 / 0.25);
}
.text-purple-100\\/30{
  color: rgb(235 233 254 / 0.3);
}
.text-purple-100\\/35{
  color: rgb(235 233 254 / 0.35);
}
.text-purple-100\\/40{
  color: rgb(235 233 254 / 0.4);
}
.text-purple-100\\/45{
  color: rgb(235 233 254 / 0.45);
}
.text-purple-100\\/5{
  color: rgb(235 233 254 / 0.05);
}
.text-purple-100\\/50{
  color: rgb(235 233 254 / 0.5);
}
.text-purple-100\\/55{
  color: rgb(235 233 254 / 0.55);
}
.text-purple-100\\/60{
  color: rgb(235 233 254 / 0.6);
}
.text-purple-100\\/65{
  color: rgb(235 233 254 / 0.65);
}
.text-purple-100\\/70{
  color: rgb(235 233 254 / 0.7);
}
.text-purple-100\\/75{
  color: rgb(235 233 254 / 0.75);
}
.text-purple-100\\/80{
  color: rgb(235 233 254 / 0.8);
}
.text-purple-100\\/85{
  color: rgb(235 233 254 / 0.85);
}
.text-purple-100\\/90{
  color: rgb(235 233 254 / 0.9);
}
.text-purple-100\\/95{
  color: rgb(235 233 254 / 0.95);
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}
.text-purple-200\\/0{
  color: rgb(217 214 254 / 0);
}
.text-purple-200\\/10{
  color: rgb(217 214 254 / 0.1);
}
.text-purple-200\\/100{
  color: rgb(217 214 254 / 1);
}
.text-purple-200\\/15{
  color: rgb(217 214 254 / 0.15);
}
.text-purple-200\\/20{
  color: rgb(217 214 254 / 0.2);
}
.text-purple-200\\/25{
  color: rgb(217 214 254 / 0.25);
}
.text-purple-200\\/30{
  color: rgb(217 214 254 / 0.3);
}
.text-purple-200\\/35{
  color: rgb(217 214 254 / 0.35);
}
.text-purple-200\\/40{
  color: rgb(217 214 254 / 0.4);
}
.text-purple-200\\/45{
  color: rgb(217 214 254 / 0.45);
}
.text-purple-200\\/5{
  color: rgb(217 214 254 / 0.05);
}
.text-purple-200\\/50{
  color: rgb(217 214 254 / 0.5);
}
.text-purple-200\\/55{
  color: rgb(217 214 254 / 0.55);
}
.text-purple-200\\/60{
  color: rgb(217 214 254 / 0.6);
}
.text-purple-200\\/65{
  color: rgb(217 214 254 / 0.65);
}
.text-purple-200\\/70{
  color: rgb(217 214 254 / 0.7);
}
.text-purple-200\\/75{
  color: rgb(217 214 254 / 0.75);
}
.text-purple-200\\/80{
  color: rgb(217 214 254 / 0.8);
}
.text-purple-200\\/85{
  color: rgb(217 214 254 / 0.85);
}
.text-purple-200\\/90{
  color: rgb(217 214 254 / 0.9);
}
.text-purple-200\\/95{
  color: rgb(217 214 254 / 0.95);
}
.text-purple-25{
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}
.text-purple-25\\/0{
  color: rgb(250 250 255 / 0);
}
.text-purple-25\\/10{
  color: rgb(250 250 255 / 0.1);
}
.text-purple-25\\/100{
  color: rgb(250 250 255 / 1);
}
.text-purple-25\\/15{
  color: rgb(250 250 255 / 0.15);
}
.text-purple-25\\/20{
  color: rgb(250 250 255 / 0.2);
}
.text-purple-25\\/25{
  color: rgb(250 250 255 / 0.25);
}
.text-purple-25\\/30{
  color: rgb(250 250 255 / 0.3);
}
.text-purple-25\\/35{
  color: rgb(250 250 255 / 0.35);
}
.text-purple-25\\/40{
  color: rgb(250 250 255 / 0.4);
}
.text-purple-25\\/45{
  color: rgb(250 250 255 / 0.45);
}
.text-purple-25\\/5{
  color: rgb(250 250 255 / 0.05);
}
.text-purple-25\\/50{
  color: rgb(250 250 255 / 0.5);
}
.text-purple-25\\/55{
  color: rgb(250 250 255 / 0.55);
}
.text-purple-25\\/60{
  color: rgb(250 250 255 / 0.6);
}
.text-purple-25\\/65{
  color: rgb(250 250 255 / 0.65);
}
.text-purple-25\\/70{
  color: rgb(250 250 255 / 0.7);
}
.text-purple-25\\/75{
  color: rgb(250 250 255 / 0.75);
}
.text-purple-25\\/80{
  color: rgb(250 250 255 / 0.8);
}
.text-purple-25\\/85{
  color: rgb(250 250 255 / 0.85);
}
.text-purple-25\\/90{
  color: rgb(250 250 255 / 0.9);
}
.text-purple-25\\/95{
  color: rgb(250 250 255 / 0.95);
}
.text-purple-400{
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}
.text-purple-400\\/0{
  color: rgb(155 138 251 / 0);
}
.text-purple-400\\/10{
  color: rgb(155 138 251 / 0.1);
}
.text-purple-400\\/100{
  color: rgb(155 138 251 / 1);
}
.text-purple-400\\/15{
  color: rgb(155 138 251 / 0.15);
}
.text-purple-400\\/20{
  color: rgb(155 138 251 / 0.2);
}
.text-purple-400\\/25{
  color: rgb(155 138 251 / 0.25);
}
.text-purple-400\\/30{
  color: rgb(155 138 251 / 0.3);
}
.text-purple-400\\/35{
  color: rgb(155 138 251 / 0.35);
}
.text-purple-400\\/40{
  color: rgb(155 138 251 / 0.4);
}
.text-purple-400\\/45{
  color: rgb(155 138 251 / 0.45);
}
.text-purple-400\\/5{
  color: rgb(155 138 251 / 0.05);
}
.text-purple-400\\/50{
  color: rgb(155 138 251 / 0.5);
}
.text-purple-400\\/55{
  color: rgb(155 138 251 / 0.55);
}
.text-purple-400\\/60{
  color: rgb(155 138 251 / 0.6);
}
.text-purple-400\\/65{
  color: rgb(155 138 251 / 0.65);
}
.text-purple-400\\/70{
  color: rgb(155 138 251 / 0.7);
}
.text-purple-400\\/75{
  color: rgb(155 138 251 / 0.75);
}
.text-purple-400\\/80{
  color: rgb(155 138 251 / 0.8);
}
.text-purple-400\\/85{
  color: rgb(155 138 251 / 0.85);
}
.text-purple-400\\/90{
  color: rgb(155 138 251 / 0.9);
}
.text-purple-400\\/95{
  color: rgb(155 138 251 / 0.95);
}
.text-purple-50{
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}
.text-purple-50\\/0{
  color: rgb(244 243 255 / 0);
}
.text-purple-50\\/10{
  color: rgb(244 243 255 / 0.1);
}
.text-purple-50\\/100{
  color: rgb(244 243 255 / 1);
}
.text-purple-50\\/15{
  color: rgb(244 243 255 / 0.15);
}
.text-purple-50\\/20{
  color: rgb(244 243 255 / 0.2);
}
.text-purple-50\\/25{
  color: rgb(244 243 255 / 0.25);
}
.text-purple-50\\/30{
  color: rgb(244 243 255 / 0.3);
}
.text-purple-50\\/35{
  color: rgb(244 243 255 / 0.35);
}
.text-purple-50\\/40{
  color: rgb(244 243 255 / 0.4);
}
.text-purple-50\\/45{
  color: rgb(244 243 255 / 0.45);
}
.text-purple-50\\/5{
  color: rgb(244 243 255 / 0.05);
}
.text-purple-50\\/50{
  color: rgb(244 243 255 / 0.5);
}
.text-purple-50\\/55{
  color: rgb(244 243 255 / 0.55);
}
.text-purple-50\\/60{
  color: rgb(244 243 255 / 0.6);
}
.text-purple-50\\/65{
  color: rgb(244 243 255 / 0.65);
}
.text-purple-50\\/70{
  color: rgb(244 243 255 / 0.7);
}
.text-purple-50\\/75{
  color: rgb(244 243 255 / 0.75);
}
.text-purple-50\\/80{
  color: rgb(244 243 255 / 0.8);
}
.text-purple-50\\/85{
  color: rgb(244 243 255 / 0.85);
}
.text-purple-50\\/90{
  color: rgb(244 243 255 / 0.9);
}
.text-purple-50\\/95{
  color: rgb(244 243 255 / 0.95);
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}
.text-purple-500\\/0{
  color: rgb(122 90 248 / 0);
}
.text-purple-500\\/10{
  color: rgb(122 90 248 / 0.1);
}
.text-purple-500\\/100{
  color: rgb(122 90 248 / 1);
}
.text-purple-500\\/15{
  color: rgb(122 90 248 / 0.15);
}
.text-purple-500\\/20{
  color: rgb(122 90 248 / 0.2);
}
.text-purple-500\\/25{
  color: rgb(122 90 248 / 0.25);
}
.text-purple-500\\/30{
  color: rgb(122 90 248 / 0.3);
}
.text-purple-500\\/35{
  color: rgb(122 90 248 / 0.35);
}
.text-purple-500\\/40{
  color: rgb(122 90 248 / 0.4);
}
.text-purple-500\\/45{
  color: rgb(122 90 248 / 0.45);
}
.text-purple-500\\/5{
  color: rgb(122 90 248 / 0.05);
}
.text-purple-500\\/50{
  color: rgb(122 90 248 / 0.5);
}
.text-purple-500\\/55{
  color: rgb(122 90 248 / 0.55);
}
.text-purple-500\\/60{
  color: rgb(122 90 248 / 0.6);
}
.text-purple-500\\/65{
  color: rgb(122 90 248 / 0.65);
}
.text-purple-500\\/70{
  color: rgb(122 90 248 / 0.7);
}
.text-purple-500\\/75{
  color: rgb(122 90 248 / 0.75);
}
.text-purple-500\\/80{
  color: rgb(122 90 248 / 0.8);
}
.text-purple-500\\/85{
  color: rgb(122 90 248 / 0.85);
}
.text-purple-500\\/90{
  color: rgb(122 90 248 / 0.9);
}
.text-purple-500\\/95{
  color: rgb(122 90 248 / 0.95);
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}
.text-purple-600\\/0{
  color: rgb(105 56 239 / 0);
}
.text-purple-600\\/10{
  color: rgb(105 56 239 / 0.1);
}
.text-purple-600\\/100{
  color: rgb(105 56 239 / 1);
}
.text-purple-600\\/15{
  color: rgb(105 56 239 / 0.15);
}
.text-purple-600\\/20{
  color: rgb(105 56 239 / 0.2);
}
.text-purple-600\\/25{
  color: rgb(105 56 239 / 0.25);
}
.text-purple-600\\/30{
  color: rgb(105 56 239 / 0.3);
}
.text-purple-600\\/35{
  color: rgb(105 56 239 / 0.35);
}
.text-purple-600\\/40{
  color: rgb(105 56 239 / 0.4);
}
.text-purple-600\\/45{
  color: rgb(105 56 239 / 0.45);
}
.text-purple-600\\/5{
  color: rgb(105 56 239 / 0.05);
}
.text-purple-600\\/50{
  color: rgb(105 56 239 / 0.5);
}
.text-purple-600\\/55{
  color: rgb(105 56 239 / 0.55);
}
.text-purple-600\\/60{
  color: rgb(105 56 239 / 0.6);
}
.text-purple-600\\/65{
  color: rgb(105 56 239 / 0.65);
}
.text-purple-600\\/70{
  color: rgb(105 56 239 / 0.7);
}
.text-purple-600\\/75{
  color: rgb(105 56 239 / 0.75);
}
.text-purple-600\\/80{
  color: rgb(105 56 239 / 0.8);
}
.text-purple-600\\/85{
  color: rgb(105 56 239 / 0.85);
}
.text-purple-600\\/90{
  color: rgb(105 56 239 / 0.9);
}
.text-purple-600\\/95{
  color: rgb(105 56 239 / 0.95);
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}
.text-purple-700\\/0{
  color: rgb(89 37 220 / 0);
}
.text-purple-700\\/10{
  color: rgb(89 37 220 / 0.1);
}
.text-purple-700\\/100{
  color: rgb(89 37 220 / 1);
}
.text-purple-700\\/15{
  color: rgb(89 37 220 / 0.15);
}
.text-purple-700\\/20{
  color: rgb(89 37 220 / 0.2);
}
.text-purple-700\\/25{
  color: rgb(89 37 220 / 0.25);
}
.text-purple-700\\/30{
  color: rgb(89 37 220 / 0.3);
}
.text-purple-700\\/35{
  color: rgb(89 37 220 / 0.35);
}
.text-purple-700\\/40{
  color: rgb(89 37 220 / 0.4);
}
.text-purple-700\\/45{
  color: rgb(89 37 220 / 0.45);
}
.text-purple-700\\/5{
  color: rgb(89 37 220 / 0.05);
}
.text-purple-700\\/50{
  color: rgb(89 37 220 / 0.5);
}
.text-purple-700\\/55{
  color: rgb(89 37 220 / 0.55);
}
.text-purple-700\\/60{
  color: rgb(89 37 220 / 0.6);
}
.text-purple-700\\/65{
  color: rgb(89 37 220 / 0.65);
}
.text-purple-700\\/70{
  color: rgb(89 37 220 / 0.7);
}
.text-purple-700\\/75{
  color: rgb(89 37 220 / 0.75);
}
.text-purple-700\\/80{
  color: rgb(89 37 220 / 0.8);
}
.text-purple-700\\/85{
  color: rgb(89 37 220 / 0.85);
}
.text-purple-700\\/90{
  color: rgb(89 37 220 / 0.9);
}
.text-purple-700\\/95{
  color: rgb(89 37 220 / 0.95);
}
.text-success-100{
  --tw-text-opacity: 1;
  color: rgb(211 248 223 / var(--tw-text-opacity, 1));
}
.text-success-100\\/0{
  color: rgb(211 248 223 / 0);
}
.text-success-100\\/10{
  color: rgb(211 248 223 / 0.1);
}
.text-success-100\\/100{
  color: rgb(211 248 223 / 1);
}
.text-success-100\\/15{
  color: rgb(211 248 223 / 0.15);
}
.text-success-100\\/20{
  color: rgb(211 248 223 / 0.2);
}
.text-success-100\\/25{
  color: rgb(211 248 223 / 0.25);
}
.text-success-100\\/30{
  color: rgb(211 248 223 / 0.3);
}
.text-success-100\\/35{
  color: rgb(211 248 223 / 0.35);
}
.text-success-100\\/40{
  color: rgb(211 248 223 / 0.4);
}
.text-success-100\\/45{
  color: rgb(211 248 223 / 0.45);
}
.text-success-100\\/5{
  color: rgb(211 248 223 / 0.05);
}
.text-success-100\\/50{
  color: rgb(211 248 223 / 0.5);
}
.text-success-100\\/55{
  color: rgb(211 248 223 / 0.55);
}
.text-success-100\\/60{
  color: rgb(211 248 223 / 0.6);
}
.text-success-100\\/65{
  color: rgb(211 248 223 / 0.65);
}
.text-success-100\\/70{
  color: rgb(211 248 223 / 0.7);
}
.text-success-100\\/75{
  color: rgb(211 248 223 / 0.75);
}
.text-success-100\\/80{
  color: rgb(211 248 223 / 0.8);
}
.text-success-100\\/85{
  color: rgb(211 248 223 / 0.85);
}
.text-success-100\\/90{
  color: rgb(211 248 223 / 0.9);
}
.text-success-100\\/95{
  color: rgb(211 248 223 / 0.95);
}
.text-success-200{
  --tw-text-opacity: 1;
  color: rgb(170 240 196 / var(--tw-text-opacity, 1));
}
.text-success-200\\/0{
  color: rgb(170 240 196 / 0);
}
.text-success-200\\/10{
  color: rgb(170 240 196 / 0.1);
}
.text-success-200\\/100{
  color: rgb(170 240 196 / 1);
}
.text-success-200\\/15{
  color: rgb(170 240 196 / 0.15);
}
.text-success-200\\/20{
  color: rgb(170 240 196 / 0.2);
}
.text-success-200\\/25{
  color: rgb(170 240 196 / 0.25);
}
.text-success-200\\/30{
  color: rgb(170 240 196 / 0.3);
}
.text-success-200\\/35{
  color: rgb(170 240 196 / 0.35);
}
.text-success-200\\/40{
  color: rgb(170 240 196 / 0.4);
}
.text-success-200\\/45{
  color: rgb(170 240 196 / 0.45);
}
.text-success-200\\/5{
  color: rgb(170 240 196 / 0.05);
}
.text-success-200\\/50{
  color: rgb(170 240 196 / 0.5);
}
.text-success-200\\/55{
  color: rgb(170 240 196 / 0.55);
}
.text-success-200\\/60{
  color: rgb(170 240 196 / 0.6);
}
.text-success-200\\/65{
  color: rgb(170 240 196 / 0.65);
}
.text-success-200\\/70{
  color: rgb(170 240 196 / 0.7);
}
.text-success-200\\/75{
  color: rgb(170 240 196 / 0.75);
}
.text-success-200\\/80{
  color: rgb(170 240 196 / 0.8);
}
.text-success-200\\/85{
  color: rgb(170 240 196 / 0.85);
}
.text-success-200\\/90{
  color: rgb(170 240 196 / 0.9);
}
.text-success-200\\/95{
  color: rgb(170 240 196 / 0.95);
}
.text-success-25{
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}
.text-success-25\\/0{
  color: rgb(246 254 249 / 0);
}
.text-success-25\\/10{
  color: rgb(246 254 249 / 0.1);
}
.text-success-25\\/100{
  color: rgb(246 254 249 / 1);
}
.text-success-25\\/15{
  color: rgb(246 254 249 / 0.15);
}
.text-success-25\\/20{
  color: rgb(246 254 249 / 0.2);
}
.text-success-25\\/25{
  color: rgb(246 254 249 / 0.25);
}
.text-success-25\\/30{
  color: rgb(246 254 249 / 0.3);
}
.text-success-25\\/35{
  color: rgb(246 254 249 / 0.35);
}
.text-success-25\\/40{
  color: rgb(246 254 249 / 0.4);
}
.text-success-25\\/45{
  color: rgb(246 254 249 / 0.45);
}
.text-success-25\\/5{
  color: rgb(246 254 249 / 0.05);
}
.text-success-25\\/50{
  color: rgb(246 254 249 / 0.5);
}
.text-success-25\\/55{
  color: rgb(246 254 249 / 0.55);
}
.text-success-25\\/60{
  color: rgb(246 254 249 / 0.6);
}
.text-success-25\\/65{
  color: rgb(246 254 249 / 0.65);
}
.text-success-25\\/70{
  color: rgb(246 254 249 / 0.7);
}
.text-success-25\\/75{
  color: rgb(246 254 249 / 0.75);
}
.text-success-25\\/80{
  color: rgb(246 254 249 / 0.8);
}
.text-success-25\\/85{
  color: rgb(246 254 249 / 0.85);
}
.text-success-25\\/90{
  color: rgb(246 254 249 / 0.9);
}
.text-success-25\\/95{
  color: rgb(246 254 249 / 0.95);
}
.text-success-400{
  --tw-text-opacity: 1;
  color: rgb(60 203 127 / var(--tw-text-opacity, 1));
}
.text-success-400\\/0{
  color: rgb(60 203 127 / 0);
}
.text-success-400\\/10{
  color: rgb(60 203 127 / 0.1);
}
.text-success-400\\/100{
  color: rgb(60 203 127 / 1);
}
.text-success-400\\/15{
  color: rgb(60 203 127 / 0.15);
}
.text-success-400\\/20{
  color: rgb(60 203 127 / 0.2);
}
.text-success-400\\/25{
  color: rgb(60 203 127 / 0.25);
}
.text-success-400\\/30{
  color: rgb(60 203 127 / 0.3);
}
.text-success-400\\/35{
  color: rgb(60 203 127 / 0.35);
}
.text-success-400\\/40{
  color: rgb(60 203 127 / 0.4);
}
.text-success-400\\/45{
  color: rgb(60 203 127 / 0.45);
}
.text-success-400\\/5{
  color: rgb(60 203 127 / 0.05);
}
.text-success-400\\/50{
  color: rgb(60 203 127 / 0.5);
}
.text-success-400\\/55{
  color: rgb(60 203 127 / 0.55);
}
.text-success-400\\/60{
  color: rgb(60 203 127 / 0.6);
}
.text-success-400\\/65{
  color: rgb(60 203 127 / 0.65);
}
.text-success-400\\/70{
  color: rgb(60 203 127 / 0.7);
}
.text-success-400\\/75{
  color: rgb(60 203 127 / 0.75);
}
.text-success-400\\/80{
  color: rgb(60 203 127 / 0.8);
}
.text-success-400\\/85{
  color: rgb(60 203 127 / 0.85);
}
.text-success-400\\/90{
  color: rgb(60 203 127 / 0.9);
}
.text-success-400\\/95{
  color: rgb(60 203 127 / 0.95);
}
.text-success-50{
  --tw-text-opacity: 1;
  color: rgb(237 252 242 / var(--tw-text-opacity, 1));
}
.text-success-50\\/0{
  color: rgb(237 252 242 / 0);
}
.text-success-50\\/10{
  color: rgb(237 252 242 / 0.1);
}
.text-success-50\\/100{
  color: rgb(237 252 242 / 1);
}
.text-success-50\\/15{
  color: rgb(237 252 242 / 0.15);
}
.text-success-50\\/20{
  color: rgb(237 252 242 / 0.2);
}
.text-success-50\\/25{
  color: rgb(237 252 242 / 0.25);
}
.text-success-50\\/30{
  color: rgb(237 252 242 / 0.3);
}
.text-success-50\\/35{
  color: rgb(237 252 242 / 0.35);
}
.text-success-50\\/40{
  color: rgb(237 252 242 / 0.4);
}
.text-success-50\\/45{
  color: rgb(237 252 242 / 0.45);
}
.text-success-50\\/5{
  color: rgb(237 252 242 / 0.05);
}
.text-success-50\\/50{
  color: rgb(237 252 242 / 0.5);
}
.text-success-50\\/55{
  color: rgb(237 252 242 / 0.55);
}
.text-success-50\\/60{
  color: rgb(237 252 242 / 0.6);
}
.text-success-50\\/65{
  color: rgb(237 252 242 / 0.65);
}
.text-success-50\\/70{
  color: rgb(237 252 242 / 0.7);
}
.text-success-50\\/75{
  color: rgb(237 252 242 / 0.75);
}
.text-success-50\\/80{
  color: rgb(237 252 242 / 0.8);
}
.text-success-50\\/85{
  color: rgb(237 252 242 / 0.85);
}
.text-success-50\\/90{
  color: rgb(237 252 242 / 0.9);
}
.text-success-50\\/95{
  color: rgb(237 252 242 / 0.95);
}
.text-success-500{
  --tw-text-opacity: 1;
  color: rgb(22 179 100 / var(--tw-text-opacity, 1));
}
.text-success-500\\/0{
  color: rgb(22 179 100 / 0);
}
.text-success-500\\/10{
  color: rgb(22 179 100 / 0.1);
}
.text-success-500\\/100{
  color: rgb(22 179 100 / 1);
}
.text-success-500\\/15{
  color: rgb(22 179 100 / 0.15);
}
.text-success-500\\/20{
  color: rgb(22 179 100 / 0.2);
}
.text-success-500\\/25{
  color: rgb(22 179 100 / 0.25);
}
.text-success-500\\/30{
  color: rgb(22 179 100 / 0.3);
}
.text-success-500\\/35{
  color: rgb(22 179 100 / 0.35);
}
.text-success-500\\/40{
  color: rgb(22 179 100 / 0.4);
}
.text-success-500\\/45{
  color: rgb(22 179 100 / 0.45);
}
.text-success-500\\/5{
  color: rgb(22 179 100 / 0.05);
}
.text-success-500\\/50{
  color: rgb(22 179 100 / 0.5);
}
.text-success-500\\/55{
  color: rgb(22 179 100 / 0.55);
}
.text-success-500\\/60{
  color: rgb(22 179 100 / 0.6);
}
.text-success-500\\/65{
  color: rgb(22 179 100 / 0.65);
}
.text-success-500\\/70{
  color: rgb(22 179 100 / 0.7);
}
.text-success-500\\/75{
  color: rgb(22 179 100 / 0.75);
}
.text-success-500\\/80{
  color: rgb(22 179 100 / 0.8);
}
.text-success-500\\/85{
  color: rgb(22 179 100 / 0.85);
}
.text-success-500\\/90{
  color: rgb(22 179 100 / 0.9);
}
.text-success-500\\/95{
  color: rgb(22 179 100 / 0.95);
}
.text-success-600{
  --tw-text-opacity: 1;
  color: rgb(9 146 80 / var(--tw-text-opacity, 1));
}
.text-success-600\\/0{
  color: rgb(9 146 80 / 0);
}
.text-success-600\\/10{
  color: rgb(9 146 80 / 0.1);
}
.text-success-600\\/100{
  color: rgb(9 146 80 / 1);
}
.text-success-600\\/15{
  color: rgb(9 146 80 / 0.15);
}
.text-success-600\\/20{
  color: rgb(9 146 80 / 0.2);
}
.text-success-600\\/25{
  color: rgb(9 146 80 / 0.25);
}
.text-success-600\\/30{
  color: rgb(9 146 80 / 0.3);
}
.text-success-600\\/35{
  color: rgb(9 146 80 / 0.35);
}
.text-success-600\\/40{
  color: rgb(9 146 80 / 0.4);
}
.text-success-600\\/45{
  color: rgb(9 146 80 / 0.45);
}
.text-success-600\\/5{
  color: rgb(9 146 80 / 0.05);
}
.text-success-600\\/50{
  color: rgb(9 146 80 / 0.5);
}
.text-success-600\\/55{
  color: rgb(9 146 80 / 0.55);
}
.text-success-600\\/60{
  color: rgb(9 146 80 / 0.6);
}
.text-success-600\\/65{
  color: rgb(9 146 80 / 0.65);
}
.text-success-600\\/70{
  color: rgb(9 146 80 / 0.7);
}
.text-success-600\\/75{
  color: rgb(9 146 80 / 0.75);
}
.text-success-600\\/80{
  color: rgb(9 146 80 / 0.8);
}
.text-success-600\\/85{
  color: rgb(9 146 80 / 0.85);
}
.text-success-600\\/90{
  color: rgb(9 146 80 / 0.9);
}
.text-success-600\\/95{
  color: rgb(9 146 80 / 0.95);
}
.text-success-700{
  --tw-text-opacity: 1;
  color: rgb(8 116 67 / var(--tw-text-opacity, 1));
}
.text-success-700\\/0{
  color: rgb(8 116 67 / 0);
}
.text-success-700\\/10{
  color: rgb(8 116 67 / 0.1);
}
.text-success-700\\/100{
  color: rgb(8 116 67 / 1);
}
.text-success-700\\/15{
  color: rgb(8 116 67 / 0.15);
}
.text-success-700\\/20{
  color: rgb(8 116 67 / 0.2);
}
.text-success-700\\/25{
  color: rgb(8 116 67 / 0.25);
}
.text-success-700\\/30{
  color: rgb(8 116 67 / 0.3);
}
.text-success-700\\/35{
  color: rgb(8 116 67 / 0.35);
}
.text-success-700\\/40{
  color: rgb(8 116 67 / 0.4);
}
.text-success-700\\/45{
  color: rgb(8 116 67 / 0.45);
}
.text-success-700\\/5{
  color: rgb(8 116 67 / 0.05);
}
.text-success-700\\/50{
  color: rgb(8 116 67 / 0.5);
}
.text-success-700\\/55{
  color: rgb(8 116 67 / 0.55);
}
.text-success-700\\/60{
  color: rgb(8 116 67 / 0.6);
}
.text-success-700\\/65{
  color: rgb(8 116 67 / 0.65);
}
.text-success-700\\/70{
  color: rgb(8 116 67 / 0.7);
}
.text-success-700\\/75{
  color: rgb(8 116 67 / 0.75);
}
.text-success-700\\/80{
  color: rgb(8 116 67 / 0.8);
}
.text-success-700\\/85{
  color: rgb(8 116 67 / 0.85);
}
.text-success-700\\/90{
  color: rgb(8 116 67 / 0.9);
}
.text-success-700\\/95{
  color: rgb(8 116 67 / 0.95);
}
.text-transparent{
  color: transparent;
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(105 39 218 / var(--tw-text-opacity, 1));
}
.text-warning-100{
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}
.text-warning-100\\/0{
  color: rgb(254 240 199 / 0);
}
.text-warning-100\\/10{
  color: rgb(254 240 199 / 0.1);
}
.text-warning-100\\/100{
  color: rgb(254 240 199 / 1);
}
.text-warning-100\\/15{
  color: rgb(254 240 199 / 0.15);
}
.text-warning-100\\/20{
  color: rgb(254 240 199 / 0.2);
}
.text-warning-100\\/25{
  color: rgb(254 240 199 / 0.25);
}
.text-warning-100\\/30{
  color: rgb(254 240 199 / 0.3);
}
.text-warning-100\\/35{
  color: rgb(254 240 199 / 0.35);
}
.text-warning-100\\/40{
  color: rgb(254 240 199 / 0.4);
}
.text-warning-100\\/45{
  color: rgb(254 240 199 / 0.45);
}
.text-warning-100\\/5{
  color: rgb(254 240 199 / 0.05);
}
.text-warning-100\\/50{
  color: rgb(254 240 199 / 0.5);
}
.text-warning-100\\/55{
  color: rgb(254 240 199 / 0.55);
}
.text-warning-100\\/60{
  color: rgb(254 240 199 / 0.6);
}
.text-warning-100\\/65{
  color: rgb(254 240 199 / 0.65);
}
.text-warning-100\\/70{
  color: rgb(254 240 199 / 0.7);
}
.text-warning-100\\/75{
  color: rgb(254 240 199 / 0.75);
}
.text-warning-100\\/80{
  color: rgb(254 240 199 / 0.8);
}
.text-warning-100\\/85{
  color: rgb(254 240 199 / 0.85);
}
.text-warning-100\\/90{
  color: rgb(254 240 199 / 0.9);
}
.text-warning-100\\/95{
  color: rgb(254 240 199 / 0.95);
}
.text-warning-200{
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}
.text-warning-200\\/0{
  color: rgb(254 223 137 / 0);
}
.text-warning-200\\/10{
  color: rgb(254 223 137 / 0.1);
}
.text-warning-200\\/100{
  color: rgb(254 223 137 / 1);
}
.text-warning-200\\/15{
  color: rgb(254 223 137 / 0.15);
}
.text-warning-200\\/20{
  color: rgb(254 223 137 / 0.2);
}
.text-warning-200\\/25{
  color: rgb(254 223 137 / 0.25);
}
.text-warning-200\\/30{
  color: rgb(254 223 137 / 0.3);
}
.text-warning-200\\/35{
  color: rgb(254 223 137 / 0.35);
}
.text-warning-200\\/40{
  color: rgb(254 223 137 / 0.4);
}
.text-warning-200\\/45{
  color: rgb(254 223 137 / 0.45);
}
.text-warning-200\\/5{
  color: rgb(254 223 137 / 0.05);
}
.text-warning-200\\/50{
  color: rgb(254 223 137 / 0.5);
}
.text-warning-200\\/55{
  color: rgb(254 223 137 / 0.55);
}
.text-warning-200\\/60{
  color: rgb(254 223 137 / 0.6);
}
.text-warning-200\\/65{
  color: rgb(254 223 137 / 0.65);
}
.text-warning-200\\/70{
  color: rgb(254 223 137 / 0.7);
}
.text-warning-200\\/75{
  color: rgb(254 223 137 / 0.75);
}
.text-warning-200\\/80{
  color: rgb(254 223 137 / 0.8);
}
.text-warning-200\\/85{
  color: rgb(254 223 137 / 0.85);
}
.text-warning-200\\/90{
  color: rgb(254 223 137 / 0.9);
}
.text-warning-200\\/95{
  color: rgb(254 223 137 / 0.95);
}
.text-warning-25{
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}
.text-warning-25\\/0{
  color: rgb(255 252 245 / 0);
}
.text-warning-25\\/10{
  color: rgb(255 252 245 / 0.1);
}
.text-warning-25\\/100{
  color: rgb(255 252 245 / 1);
}
.text-warning-25\\/15{
  color: rgb(255 252 245 / 0.15);
}
.text-warning-25\\/20{
  color: rgb(255 252 245 / 0.2);
}
.text-warning-25\\/25{
  color: rgb(255 252 245 / 0.25);
}
.text-warning-25\\/30{
  color: rgb(255 252 245 / 0.3);
}
.text-warning-25\\/35{
  color: rgb(255 252 245 / 0.35);
}
.text-warning-25\\/40{
  color: rgb(255 252 245 / 0.4);
}
.text-warning-25\\/45{
  color: rgb(255 252 245 / 0.45);
}
.text-warning-25\\/5{
  color: rgb(255 252 245 / 0.05);
}
.text-warning-25\\/50{
  color: rgb(255 252 245 / 0.5);
}
.text-warning-25\\/55{
  color: rgb(255 252 245 / 0.55);
}
.text-warning-25\\/60{
  color: rgb(255 252 245 / 0.6);
}
.text-warning-25\\/65{
  color: rgb(255 252 245 / 0.65);
}
.text-warning-25\\/70{
  color: rgb(255 252 245 / 0.7);
}
.text-warning-25\\/75{
  color: rgb(255 252 245 / 0.75);
}
.text-warning-25\\/80{
  color: rgb(255 252 245 / 0.8);
}
.text-warning-25\\/85{
  color: rgb(255 252 245 / 0.85);
}
.text-warning-25\\/90{
  color: rgb(255 252 245 / 0.9);
}
.text-warning-25\\/95{
  color: rgb(255 252 245 / 0.95);
}
.text-warning-300{
  --tw-text-opacity: 1;
  color: rgb(254 200 75 / var(--tw-text-opacity, 1));
}
.text-warning-400{
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}
.text-warning-400\\/0{
  color: rgb(253 176 34 / 0);
}
.text-warning-400\\/10{
  color: rgb(253 176 34 / 0.1);
}
.text-warning-400\\/100{
  color: rgb(253 176 34 / 1);
}
.text-warning-400\\/15{
  color: rgb(253 176 34 / 0.15);
}
.text-warning-400\\/20{
  color: rgb(253 176 34 / 0.2);
}
.text-warning-400\\/25{
  color: rgb(253 176 34 / 0.25);
}
.text-warning-400\\/30{
  color: rgb(253 176 34 / 0.3);
}
.text-warning-400\\/35{
  color: rgb(253 176 34 / 0.35);
}
.text-warning-400\\/40{
  color: rgb(253 176 34 / 0.4);
}
.text-warning-400\\/45{
  color: rgb(253 176 34 / 0.45);
}
.text-warning-400\\/5{
  color: rgb(253 176 34 / 0.05);
}
.text-warning-400\\/50{
  color: rgb(253 176 34 / 0.5);
}
.text-warning-400\\/55{
  color: rgb(253 176 34 / 0.55);
}
.text-warning-400\\/60{
  color: rgb(253 176 34 / 0.6);
}
.text-warning-400\\/65{
  color: rgb(253 176 34 / 0.65);
}
.text-warning-400\\/70{
  color: rgb(253 176 34 / 0.7);
}
.text-warning-400\\/75{
  color: rgb(253 176 34 / 0.75);
}
.text-warning-400\\/80{
  color: rgb(253 176 34 / 0.8);
}
.text-warning-400\\/85{
  color: rgb(253 176 34 / 0.85);
}
.text-warning-400\\/90{
  color: rgb(253 176 34 / 0.9);
}
.text-warning-400\\/95{
  color: rgb(253 176 34 / 0.95);
}
.text-warning-50{
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}
.text-warning-50\\/0{
  color: rgb(255 250 235 / 0);
}
.text-warning-50\\/10{
  color: rgb(255 250 235 / 0.1);
}
.text-warning-50\\/100{
  color: rgb(255 250 235 / 1);
}
.text-warning-50\\/15{
  color: rgb(255 250 235 / 0.15);
}
.text-warning-50\\/20{
  color: rgb(255 250 235 / 0.2);
}
.text-warning-50\\/25{
  color: rgb(255 250 235 / 0.25);
}
.text-warning-50\\/30{
  color: rgb(255 250 235 / 0.3);
}
.text-warning-50\\/35{
  color: rgb(255 250 235 / 0.35);
}
.text-warning-50\\/40{
  color: rgb(255 250 235 / 0.4);
}
.text-warning-50\\/45{
  color: rgb(255 250 235 / 0.45);
}
.text-warning-50\\/5{
  color: rgb(255 250 235 / 0.05);
}
.text-warning-50\\/50{
  color: rgb(255 250 235 / 0.5);
}
.text-warning-50\\/55{
  color: rgb(255 250 235 / 0.55);
}
.text-warning-50\\/60{
  color: rgb(255 250 235 / 0.6);
}
.text-warning-50\\/65{
  color: rgb(255 250 235 / 0.65);
}
.text-warning-50\\/70{
  color: rgb(255 250 235 / 0.7);
}
.text-warning-50\\/75{
  color: rgb(255 250 235 / 0.75);
}
.text-warning-50\\/80{
  color: rgb(255 250 235 / 0.8);
}
.text-warning-50\\/85{
  color: rgb(255 250 235 / 0.85);
}
.text-warning-50\\/90{
  color: rgb(255 250 235 / 0.9);
}
.text-warning-50\\/95{
  color: rgb(255 250 235 / 0.95);
}
.text-warning-500{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}
.text-warning-500\\/0{
  color: rgb(247 144 9 / 0);
}
.text-warning-500\\/10{
  color: rgb(247 144 9 / 0.1);
}
.text-warning-500\\/100{
  color: rgb(247 144 9 / 1);
}
.text-warning-500\\/15{
  color: rgb(247 144 9 / 0.15);
}
.text-warning-500\\/20{
  color: rgb(247 144 9 / 0.2);
}
.text-warning-500\\/25{
  color: rgb(247 144 9 / 0.25);
}
.text-warning-500\\/30{
  color: rgb(247 144 9 / 0.3);
}
.text-warning-500\\/35{
  color: rgb(247 144 9 / 0.35);
}
.text-warning-500\\/40{
  color: rgb(247 144 9 / 0.4);
}
.text-warning-500\\/45{
  color: rgb(247 144 9 / 0.45);
}
.text-warning-500\\/5{
  color: rgb(247 144 9 / 0.05);
}
.text-warning-500\\/50{
  color: rgb(247 144 9 / 0.5);
}
.text-warning-500\\/55{
  color: rgb(247 144 9 / 0.55);
}
.text-warning-500\\/60{
  color: rgb(247 144 9 / 0.6);
}
.text-warning-500\\/65{
  color: rgb(247 144 9 / 0.65);
}
.text-warning-500\\/70{
  color: rgb(247 144 9 / 0.7);
}
.text-warning-500\\/75{
  color: rgb(247 144 9 / 0.75);
}
.text-warning-500\\/80{
  color: rgb(247 144 9 / 0.8);
}
.text-warning-500\\/85{
  color: rgb(247 144 9 / 0.85);
}
.text-warning-500\\/90{
  color: rgb(247 144 9 / 0.9);
}
.text-warning-500\\/95{
  color: rgb(247 144 9 / 0.95);
}
.text-warning-600{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}
.text-warning-600\\/0{
  color: rgb(220 104 3 / 0);
}
.text-warning-600\\/10{
  color: rgb(220 104 3 / 0.1);
}
.text-warning-600\\/100{
  color: rgb(220 104 3 / 1);
}
.text-warning-600\\/15{
  color: rgb(220 104 3 / 0.15);
}
.text-warning-600\\/20{
  color: rgb(220 104 3 / 0.2);
}
.text-warning-600\\/25{
  color: rgb(220 104 3 / 0.25);
}
.text-warning-600\\/30{
  color: rgb(220 104 3 / 0.3);
}
.text-warning-600\\/35{
  color: rgb(220 104 3 / 0.35);
}
.text-warning-600\\/40{
  color: rgb(220 104 3 / 0.4);
}
.text-warning-600\\/45{
  color: rgb(220 104 3 / 0.45);
}
.text-warning-600\\/5{
  color: rgb(220 104 3 / 0.05);
}
.text-warning-600\\/50{
  color: rgb(220 104 3 / 0.5);
}
.text-warning-600\\/55{
  color: rgb(220 104 3 / 0.55);
}
.text-warning-600\\/60{
  color: rgb(220 104 3 / 0.6);
}
.text-warning-600\\/65{
  color: rgb(220 104 3 / 0.65);
}
.text-warning-600\\/70{
  color: rgb(220 104 3 / 0.7);
}
.text-warning-600\\/75{
  color: rgb(220 104 3 / 0.75);
}
.text-warning-600\\/80{
  color: rgb(220 104 3 / 0.8);
}
.text-warning-600\\/85{
  color: rgb(220 104 3 / 0.85);
}
.text-warning-600\\/90{
  color: rgb(220 104 3 / 0.9);
}
.text-warning-600\\/95{
  color: rgb(220 104 3 / 0.95);
}
.text-warning-700{
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}
.text-warning-700\\/0{
  color: rgb(181 71 8 / 0);
}
.text-warning-700\\/10{
  color: rgb(181 71 8 / 0.1);
}
.text-warning-700\\/100{
  color: rgb(181 71 8 / 1);
}
.text-warning-700\\/15{
  color: rgb(181 71 8 / 0.15);
}
.text-warning-700\\/20{
  color: rgb(181 71 8 / 0.2);
}
.text-warning-700\\/25{
  color: rgb(181 71 8 / 0.25);
}
.text-warning-700\\/30{
  color: rgb(181 71 8 / 0.3);
}
.text-warning-700\\/35{
  color: rgb(181 71 8 / 0.35);
}
.text-warning-700\\/40{
  color: rgb(181 71 8 / 0.4);
}
.text-warning-700\\/45{
  color: rgb(181 71 8 / 0.45);
}
.text-warning-700\\/5{
  color: rgb(181 71 8 / 0.05);
}
.text-warning-700\\/50{
  color: rgb(181 71 8 / 0.5);
}
.text-warning-700\\/55{
  color: rgb(181 71 8 / 0.55);
}
.text-warning-700\\/60{
  color: rgb(181 71 8 / 0.6);
}
.text-warning-700\\/65{
  color: rgb(181 71 8 / 0.65);
}
.text-warning-700\\/70{
  color: rgb(181 71 8 / 0.7);
}
.text-warning-700\\/75{
  color: rgb(181 71 8 / 0.75);
}
.text-warning-700\\/80{
  color: rgb(181 71 8 / 0.8);
}
.text-warning-700\\/85{
  color: rgb(181 71 8 / 0.85);
}
.text-warning-700\\/90{
  color: rgb(181 71 8 / 0.9);
}
.text-warning-700\\/95{
  color: rgb(181 71 8 / 0.95);
}
.text-warning-800{
  --tw-text-opacity: 1;
  color: rgb(147 55 13 / var(--tw-text-opacity, 1));
}
.text-warning-900{
  --tw-text-opacity: 1;
  color: rgb(122 46 14 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 197 21 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 133 4 / var(--tw-text-opacity, 1));
}
.\\!underline{
  text-decoration-line: underline !important;
}
.underline{
  text-decoration-line: underline;
}
.overline{
  text-decoration-line: overline;
}
.line-through{
  text-decoration-line: line-through;
}
.\\!no-underline{
  text-decoration-line: none !important;
}
.no-underline{
  text-decoration-line: none;
}
.decoration-solid{
  text-decoration-style: solid;
}
.decoration-dotted{
  text-decoration-style: dotted;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.caret-danger-500{
  caret-color: #F04438;
}
.caret-primary-500{
  caret-color: var(--color-primary-500, #0BA5EC);
}
.\\!opacity-100{
  opacity: 1 !important;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-15{
  opacity: 0.15;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.07\\]{
  opacity: 0.07;
}
.opacity-\\[0\\.8\\]{
  opacity: 0.8;
}
.bg-blend-screen{
  background-blend-mode: screen;
}
.\\!shadow-\\[0_4px_12px_0_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 4px 12px 0 rgba(65,70,81,0.08) !important;
  --tw-shadow-colored: 0 4px 12px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-\\[0_6px_16px_0_rgba\\(37\\2c 49\\2c 60\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 6px 16px 0 rgba(37,49,60,0.06) !important;
  --tw-shadow-colored: 0 6px 16px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-\\[0px_0px_16px_0px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 16px 0px rgba(65,70,81,0.08) !important;
  --tw-shadow-colored: 0px 0px 16px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-none{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-12px_0_32px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.12\\)\\]{
  --tw-shadow: -12px 0 32px rgba(16,24,40,0.12);
  --tw-shadow-colored: -12px 0 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-2px_0px_4px_0px_\\#2A5C8A1A\\]{
  --tw-shadow: -2px 0px 4px 0px #2A5C8A1A;
  --tw-shadow-colored: -2px 0px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-2px_0px_4px_rgba\\(42\\2c 92\\2c 138\\2c 0\\.1\\)\\]{
  --tw-shadow: -2px 0px 4px rgba(42,92,138,0.1);
  --tw-shadow-colored: -2px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-2px_0px_7px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\2c 2px_4px_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\]{
  --tw-shadow: -2px 0px 7px rgba(0,0,0,0.05),2px 4px 15px rgba(0,0,0,0.07);
  --tw-shadow-colored: -2px 0px 7px var(--tw-shadow-color), 2px 4px 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-2px_0px_8px_0px_\\#2A5C8A1A\\]{
  --tw-shadow: -2px 0px 8px 0px #2A5C8A1A;
  --tw-shadow-colored: -2px 0px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-4px_0px_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: -4px 0px 16px 0 rgba(0,79,107,0.06);
  --tw-shadow-colored: -4px 0px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-2px_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 -2px 16px 0 rgba(0,79,107,0.06);
  --tw-shadow-colored: 0 -2px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-2px_16px_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 -2px 16px rgba(0,79,107,0.06);
  --tw-shadow-colored: 0 -2px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-2px_5px_-5px_\\#333\\]{
  --tw-shadow: 0 -2px 5px -5px #333;
  --tw-shadow-colored: 0 -2px 5px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_2px_\\#CBF0FD\\]{
  --tw-shadow: 0 0 0 2px #CBF0FD;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(22\\2c 179\\2c 100\\2c 0\\.16\\)\\]{
  --tw-shadow: 0 0 0 4px rgba(22,179,100,0.16);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_16px_0_\\#37414514\\]{
  --tw-shadow: 0 0 16px 0 #37414514;
  --tw-shadow-colored: 0 0 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_16px_0_rgba\\(55\\2c 65\\2c 69\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 0 16px 0 rgba(55,65,69,0.08);
  --tw-shadow-colored: 0 0 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 0 8px 0 rgba(0,79,107,0.08);
  --tw-shadow-colored: 0 0 8px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_24px_-8px_color-mix\\(in_srgb\\2c var\\(--color-primary-600\\2c \\#0B85C9\\)_50\\%\\2c transparent\\)\\]{
  --tw-shadow: 0 10px 24px -8px color-mix(in srgb,var(--color-primary-600,#0B85C9) 50%,transparent);
  --tw-shadow-colored: 0 10px 24px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_14px_30px_-10px_color-mix\\(in_srgb\\2c var\\(--color-primary-600\\2c \\#0B85C9\\)_50\\%\\2c transparent\\)\\]{
  --tw-shadow: 0 14px 30px -10px color-mix(in srgb,var(--color-primary-600,#0B85C9) 50%,transparent);
  --tw-shadow-colored: 0 14px 30px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_36px_-10px_rgba\\(2\\2c 28\\2c 44\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 16px 36px -10px rgba(2,28,44,0.5);
  --tw-shadow-colored: 0 16px 36px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_40px_-12px_rgba\\(9\\2c 146\\2c 80\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 18px 40px -12px rgba(9,146,80,0.6);
  --tw-shadow-colored: 0 18px 40px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(27\\2c 33\\2c 35\\2c 0\\.03\\)\\]{
  --tw-shadow: 0 1px 2px rgba(27,33,35,0.03);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-12px_rgba\\(2\\2c 28\\2c 44\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 20px 50px -12px rgba(2,28,44,0.4);
  --tw-shadow-colored: 0 20px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(0\\2c 79\\2c 107\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 2px 12px rgba(0,79,107,0.12);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_6px_rgba\\(11\\2c 165\\2c 236\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 2px 6px rgba(11,165,236,0.3);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_6px_rgba\\(129\\2c 145\\2c 232\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 2px 6px rgba(129,145,232,0.3);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_6px_rgba\\(22\\2c 179\\2c 100\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 2px 6px rgba(22,179,100,0.3);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_6px_rgba\\(247\\2c 144\\2c 9\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 2px 6px rgba(247,144,9,0.3);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_6px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 2px 6px rgba(65,70,81,0.08);
  --tw-shadow-colored: 0 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 2px 8px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(0\\2c 171\\2c 232\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 2px 8px rgba(0,171,232,0.1);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(245\\2c 158\\2c 11\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 2px 8px rgba(245,158,11,0.1);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(129\\2c 145\\2c 232\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 4px 16px rgba(129,145,232,0.3);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_16px_rgba\\(22\\2c 179\\2c 100\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 4px 16px rgba(22,179,100,0.3);
  --tw-shadow-colored: 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_16px_0_\\#25313c0a\\]{
  --tw-shadow: 0 6px 16px 0 #25313c0a;
  --tw-shadow-colored: 0 6px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_18px_-6px_color-mix\\(in_srgb\\2c var\\(--color-primary-600\\2c \\#0B85C9\\)_55\\%\\2c transparent\\)\\]{
  --tw-shadow: 0 8px 18px -6px color-mix(in srgb,var(--color-primary-600,#0B85C9) 55%,transparent);
  --tw-shadow-colored: 0 8px 18px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(22\\2c 179\\2c 100\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 8px 24px rgba(22,179,100,0.25);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(234\\2c 142\\2c 34\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 8px 24px rgba(234,142,34,0.25);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_28px_-12px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 8px 28px -12px rgba(16,24,40,0.18);
  --tw-shadow-colored: 0 8px 28px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_-1px_4px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.1\\)\\]{
  --tw-shadow: 0px -1px 4px rgba(65,70,81,0.1);
  --tw-shadow-colored: 0px -1px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_-2px_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: 0px -2px 16px 0 rgba(0,79,107,0.06);
  --tw-shadow-colored: 0px -2px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_-2px_16px_0px_\\#0000000F\\]{
  --tw-shadow: 0px -2px 16px 0px #0000000F;
  --tw-shadow-colored: 0px -2px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_-2px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: 0px -2px 16px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0px -2px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_-2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.16\\)\\]{
  --tw-shadow: 0px -2px 8px rgba(0,0,0,0.16);
  --tw-shadow-colored: 0px -2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_12px_rgba\\(0\\2c 79\\2c 107\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 0px 12px rgba(0,79,107,0.04);
  --tw-shadow-colored: 0px 0px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_0px_rgba\\(55\\2c 65\\2c 69\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 16px 0px rgba(55,65,69,0.08);
  --tw-shadow-colored: 0px 0px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_0px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 16px 0px rgba(65,70,81,0.08);
  --tw-shadow-colored: 0px 0px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0px 0px 16px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0px 0px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\]{
  --tw-shadow: 0px 0px 16px rgba(0,0,0,0.07);
  --tw-shadow-colored: 0px 0px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_rgba\\(0\\2c 79\\2c 107\\2c 0\\.24\\)\\]{
  --tw-shadow: 0px 0px 16px rgba(0,79,107,0.24);
  --tw-shadow-colored: 0px 0px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_16px_rgba\\(55\\2c 65\\2c 69\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 16px rgba(55,65,69,0.08);
  --tw-shadow-colored: 0px 0px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_20px_0px_rgba\\(55\\2c 65\\2c 69\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 20px 0px rgba(55,65,69,0.08);
  --tw-shadow-colored: 0px 0px 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_4px_0px_\\#0000001F\\]{
  --tw-shadow: 0px 0px 4px 0px #0000001F;
  --tw-shadow-colored: 0px 0px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]{
  --tw-shadow: 0px 0px 4px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_8px_0px_\\#1032540A\\]{
  --tw-shadow: 0px 0px 8px 0px #1032540A;
  --tw-shadow-colored: 0px 0px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_8px_0px__rgba\\(0\\2c 79\\2c 107\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 8px 0px  rgba(0,79,107,0.08);
  --tw-shadow-colored: 0px 0px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_8px_0px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 0px 8px 0px rgba(65,70,81,0.08);
  --tw-shadow-colored: 0px 0px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_8px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.1\\)\\]{
  --tw-shadow: 0px 0px 8px rgba(65,70,81,0.1);
  --tw-shadow-colored: 0px 0px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_12px_32px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.14\\)\\]{
  --tw-shadow: 0px 12px 32px rgba(16,24,40,0.14);
  --tw-shadow-colored: 0px 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_12px_32px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.16\\)\\]{
  --tw-shadow: 0px 12px 32px rgba(16,24,40,0.16);
  --tw-shadow-colored: 0px 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_1px_2px_0px__rgba\\(16\\2c 24\\2c 40\\2c 0\\.05\\)\\]{
  --tw-shadow: 0px 1px 2px 0px  rgba(16,24,40,0.05);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_1px_2px_0px_rgba\\(27\\2c 33\\2c 35\\2c 0\\.03\\)\\]{
  --tw-shadow: 0px 1px 2px 0px rgba(27,33,35,0.03);
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_16px_0px_\\#0000000F\\]{
  --tw-shadow: 0px 2px 16px 0px #0000000F;
  --tw-shadow-colored: 0px 2px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_16px_0px_rgba\\(0\\2c 79\\2c 107\\2c 0\\.2\\)\\]{
  --tw-shadow: 0px 2px 16px 0px rgba(0,79,107,0.2);
  --tw-shadow-colored: 0px 2px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_4px_0px_rgba\\(0\\2c 171\\2c 232\\2c 0\\.05\\)\\]{
  --tw-shadow: 0px 2px 4px 0px rgba(0,171,232,0.05);
  --tw-shadow-colored: 0px 2px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_4px_0px_rgba\\(27\\2c 33\\2c 35\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 2px 4px 0px rgba(27,33,35,0.04);
  --tw-shadow-colored: 0px 2px 4px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_4px_rgba\\(27\\2c 33\\2c 35\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 2px 4px rgba(27,33,35,0.04);
  --tw-shadow-colored: 0px 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]{
  --tw-shadow: 0px 2px 8px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0px 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_2px_8px_rgba\\(10\\2c 18\\2c 57\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 2px 8px rgba(10,18,57,0.04);
  --tw-shadow-colored: 0px 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_12px_0px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 4px 12px 0px rgba(65,70,81,0.08);
  --tw-shadow-colored: 0px 4px 12px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_12px_rgba\\(65\\2c 70\\2c 81\\2c 0\\.08\\)\\]{
  --tw-shadow: 0px 4px 12px rgba(65,70,81,0.08);
  --tw-shadow-colored: 0px 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_16px_0px_\\#0085B514\\]{
  --tw-shadow: 0px 4px 16px 0px #0085B514;
  --tw-shadow-colored: 0px 4px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 4px 16px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_16px_rgba\\(0\\2c 171\\2c 232\\2c 0\\.24\\)\\]{
  --tw-shadow: 0px 4px 16px rgba(0,171,232,0.24);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_16px_rgba\\(10\\2c 18\\2c 57\\2c 0\\.03\\)\\]{
  --tw-shadow: 0px 4px 16px rgba(10,18,57,0.03);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_24px_rgba\\(10\\2c 18\\2c 57\\2c 0\\.06\\)\\]{
  --tw-shadow: 0px 4px 24px rgba(10,18,57,0.06);
  --tw-shadow-colored: 0px 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_40px_rgba\\(55\\2c 65\\2c 69\\2c 0\\.32\\)\\]{
  --tw-shadow: 0px 4px 40px rgba(55,65,69,0.32);
  --tw-shadow-colored: 0px 4px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0px 4px 8px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0px 4px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_0px_8px_0px_\\#2A5C8A1A\\]{
  --tw-shadow: 2px 0px 8px 0px #2A5C8A1A;
  --tw-shadow-colored: 2px 0px 8px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[2px_5px_60px_0px_rgba\\(0\\2c 79\\2c 109\\2c 0\\.1\\)\\]{
  --tw-shadow: 2px 5px 60px 0px rgba(0,79,109,0.1);
  --tw-shadow-colored: 2px 5px 60px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.04\\)\\]{
  --tw-shadow: 4px 0 16px 0 rgba(0,79,107,0.04);
  --tw-shadow-colored: 4px 0 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0px_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: 4px 0px 16px 0 rgba(0,79,107,0.06);
  --tw-shadow-colored: 4px 0px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_0px_16px_0px_\\#004F6B0A\\]{
  --tw-shadow: 4px 0px 16px 0px #004F6B0A;
  --tw-shadow-colored: 4px 0px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_4px_12px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\2c 0px_0px_0px_2\\.5px_\\#CBF0FD\\]{
  --tw-shadow: 4px 4px 12px 0px rgba(0,0,0,0.08),0px 0px 0px 2.5px #CBF0FD;
  --tw-shadow-colored: 4px 4px 12px 0px var(--tw-shadow-color), 0px 0px 0px 2.5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0px_0px_4px_rgba\\(55\\2c 65\\2c 69\\2c 0\\.08\\)\\]{
  --tw-shadow: inset 0px 0px 4px rgba(55,65,69,0.08);
  --tw-shadow-colored: inset 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[px_-2px_16px_0_rgba\\(0\\2c 79\\2c 107\\2c 0\\.06\\)\\]{
  --tw-shadow: px -2px 16px 0 rgba(0,79,107,0.06);
  --tw-shadow-colored: -2px 16px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card-selected{
  --tw-shadow: 0px 0px 0px 2px rgba(203, 240, 253, 1);
  --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-medium{
  --tw-shadow: 0 0px 24px 0px rgba(0,79,107,0.16);
  --tw-shadow-colored: 0 0px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-small{
  --tw-shadow: 0 4px 16px 0px rgba(10,18,57,0.03);
  --tw-shadow-colored: 0 4px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-spread-medium{
  --tw-shadow: 0px 0px 16px 2px rgba(65, 70, 81, 0.12);
  --tw-shadow-colored: 0px 0px 16px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xs{
  --tw-shadow: 0px 2px 16px rgba(0,79,107,0.2);
  --tw-shadow-colored: 0px 2px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xxs{
  --tw-shadow: 0px -2px 24px rgba(42, 92, 138, 0.08);
  --tw-shadow-colored: 0px -2px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-neutral-200{
  --tw-shadow-color: #E9EAEB;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-neutral-400{
  --tw-shadow-color: #A4A7AE;
  --tw-shadow: var(--tw-shadow-colored);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.\\!outline{
  outline-style: solid !important;
}
.outline{
  outline-style: solid;
}
.\\!outline-0{
  outline-width: 0px !important;
}
.\\!outline-2{
  outline-width: 2px !important;
}
.outline-1{
  outline-width: 1px;
}
.outline-2{
  outline-width: 2px;
}
.outline-offset-\\[-1px\\]{
  outline-offset: -1px;
}
.\\!outline-neutral-100{
  outline-color: #F5F5F5 !important;
}
.\\!outline-primary-100{
  outline-color: var(--color-primary-100, #E0F2FE) !important;
}
.\\!outline-transparent{
  outline-color: transparent !important;
}
.outline-neutral-200{
  outline-color: #E9EAEB;
}
.outline-neutral-300{
  outline-color: #D5D7DA;
}
.outline-primary-100{
  outline-color: var(--color-primary-100, #E0F2FE);
}
.outline-primary-50{
  outline-color: var(--color-primary-50, #F0F9FF);
}
.outline-white{
  outline-color: #FFFFFF;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-danger-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 202 / var(--tw-ring-opacity, 1));
}
.ring-primary-100{
  --tw-ring-color: var(--color-primary-100, #E0F2FE);
}
.ring-primary-200{
  --tw-ring-color: var(--color-primary-200, #B9E6FE);
}
.ring-primary-50{
  --tw-ring-color: var(--color-primary-50, #F0F9FF);
}
.ring-primary-500{
  --tw-ring-color: var(--color-primary-500, #0BA5EC);
}
.ring-success-50{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(237 252 242 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.ring-offset-1{
  --tw-ring-offset-width: 1px;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[20px\\]{
  --tw-blur: blur(20px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0px_0px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\]{
  --tw-drop-shadow: drop-shadow(0px 0px 2px rgba(0,0,0,0.12));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter-none{
  filter: none;
}
.\\!backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[30px\\]{
  --tw-backdrop-blur: blur(30px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[80px\\]{
  --tw-backdrop-blur: blur(80px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg{
  --tw-backdrop-blur: blur(16px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-none{
  transition-property: none !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c box-shadow\\]{
  transition-property: background-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c border-color\\]{
  transition-property: box-shadow,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c box-shadow\\2c transform\\]{
  transition-property: color,background-color,border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\2c visibility\\]{
  transition-property: grid-template-rows,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\]{
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[margin\\]{
  transition-property: margin;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-height\\]{
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-width\\2c opacity\\]{
  transition-property: max-width,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-width\\]{
  transition-property: max-width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[min-height\\]{
  transition-property: min-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c background-color\\]{
  transition-property: opacity,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\2c visibility\\]{
  transition-property: opacity,transform,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\]{
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[stroke-dashoffset\\]{
  transition-property: stroke-dashoffset;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c border-color\\]{
  transition-property: transform,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c opacity\\]{
  transition-property: transform,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[transform\\2c visibility\\]{
  transition-property: transform,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c box-shadow\\]{
  transition-property: width,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0{
  transition-delay: 0s;
}
.delay-200{
  transition-delay: 200ms;
}
.delay-300{
  transition-delay: 300ms;
}
.delay-\\[80ms\\]{
  transition-delay: 80ms;
}
.duration-0{
  transition-duration: 0s;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.duration-\\[1200ms\\]{
  transition-duration: 1200ms;
}
.duration-\\[400ms\\]{
  transition-duration: 400ms;
}
.duration-fast{
  transition-duration: 120ms;
}
.duration-standard{
  transition-duration: 200ms;
}
.ease-\\[cubic-bezier\\(0\\.32\\2c 0\\.72\\2c 0\\2c 1\\)\\]{
  transition-timing-function: cubic-bezier(0.32,0.72,0,1);
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear{
  transition-timing-function: linear;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.ease-standard{
  transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
}
.will-change-transform{
  will-change: transform;
}
.content-\\[\\'\\'\\]{
  --tw-content: '';
  content: var(--tw-content);
}
.content-none{
  --tw-content: none;
  content: var(--tw-content);
}
.\\[--ag-background-color\\:\\#FFFFFF\\]{
  --ag-background-color: #FFFFFF;
}
.\\[--ag-borders\\:none\\]{
  --ag-borders: none;
}
.\\[--ag-header-background-color\\:\\#FFFFFF\\]{
  --ag-header-background-color: #FFFFFF;
}
.\\[--ag-range-selection-border-color\\:transparent\\]{
  --ag-range-selection-border-color: transparent;
}
.\\[--ag-row-border-color\\:\\#E9EAEB\\]{
  --ag-row-border-color: #E9EAEB;
}
.\\[--ag-row-hover-color\\:theme\\(colors\\.neutral\\.75\\)\\]{
  --ag-row-hover-color: #F6F6F6;
}
.\\[--ag-row-hover-color\\:theme\\(colors\\.primary\\.50\\)\\]{
  --ag-row-hover-color: var(--color-primary-50, #F0F9FF);
}
.\\[--anchor-gap\\:4px\\]{
  --anchor-gap: 4px;
}
.\\[-ms-overflow-style\\:none\\]{
  -ms-overflow-style: none;
}
.\\[appearance\\:textfield\\]{
  appearance: textfield;
}
.\\[border-bottom-color\\:transparent\\]{
  border-bottom-color: transparent;
}
.\\[border-bottom-style\\:solid\\]{
  border-bottom-style: solid;
}
.\\[color\\:var\\(--color-on-primary\\2c \\#fff\\)\\]{
  color: var(--color-on-primary,#fff);
}
.\\[container-type\\:inline-size\\]{
  container-type: inline-size;
}
.\\[gap\\:inherit\\]{
  gap: inherit;
}
.\\[grid-template-columns\\:minmax\\(0\\2c 1fr\\)_372px\\]{
  grid-template-columns: minmax(0,1fr) 372px;
}
.\\[grid-template-columns\\:repeat\\(auto-fit\\2c minmax\\(max\\(252px\\2c 45\\%\\)\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fit,minmax(max(252px, 45%),1fr));
}
.\\[mask-image\\:radial-gradient\\(ellipse_90\\%_60\\%_at_60\\%_10\\%\\2c \\#000_65\\%\\2c transparent_120\\%\\)\\]{
  mask-image: radial-gradient(ellipse 90% 60% at 60% 10%,#000 65%,transparent 120%);
}
.\\[overflow-anchor\\:none\\]{
  overflow-anchor: none;
}
.\\[overflow-wrap\\:anywhere\\]{
  overflow-wrap: anywhere;
}
.\\[scrollbar-color\\:\\#D3D3D3_transparent\\]{
  scrollbar-color: #D3D3D3 transparent;
}
.\\[scrollbar-gutter\\:stable\\]{
  scrollbar-gutter: stable;
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}
.\\[scrollbar-width\\:thin\\]{
  scrollbar-width: thin;
}
.\\[zoom\\:1\\.3\\]{
  zoom: 1.3;
}
* {
  box-sizing: border-box;
  font-family: "Geist", sans-serif;
}

html.portal,
html.admin {
  overflow: hidden;
}

html,
body {
  font-weight: 400;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  font-size: 1rem;
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}
@media (max-width: 768px) {
  html,
  body {
    font-size: 0.875rem;
  }
}

p {
  font-family: "Geist", sans-serif;
  word-break: break-word;
}

li {
  list-style: none;
}

.rfb-item .static ul,
.rfb-item .static ol,
.rfb-item label > span ul,
.rfb-item label > span ol {
  margin: 4px 0;
  padding-left: 1.5em;
}
.rfb-item .static ul > li,
.rfb-item label > span ul > li {
  list-style: disc;
}
.rfb-item .static ul ul > li,
.rfb-item label > span ul ul > li {
  list-style: circle;
}
.rfb-item .static ul ul ul > li,
.rfb-item label > span ul ul ul > li {
  list-style: square;
}
.rfb-item .static ol > li,
.rfb-item label > span ol > li {
  list-style: decimal;
}
.rfb-item .static ol ol > li,
.rfb-item label > span ol ol > li {
  list-style: lower-alpha;
}
.rfb-item .static ol ol ol > li,
.rfb-item label > span ol ol ol > li {
  list-style: lower-roman;
}

body :not(.ag-theme-quartz) *::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background: transparent;
}
body :not(.ag-theme-quartz) *::-webkit-scrollbar-thumb {
  background: #8fa0a7;
  border-radius: 24px;
  border: 2px solid transparent;
  background-clip: content-box;
}
body :not(.ag-theme-quartz) *::-webkit-scrollbar-thumb:hover {
  border-width: 0px;
}

.ag-visible-x-scroll .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar {
  opacity: 1;
  visibility: visible;
}
.ag-visible-x-scroll .ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background: transparent;
}
.ag-visible-x-scroll .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
  background: #8fa0a7;
  border-radius: 24px;
  border: 2px solid transparent;
  background-clip: content-box;
}
.ag-visible-x-scroll .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover {
  border-width: 0px;
}

.dynamic-scrollbar {
  scrollbar-gutter: stable;
  scrollbar-color: transparent transparent;
}
.dynamic-scrollbar::-webkit-scrollbar {
  width: 12px;
  height: 12px;
  background: transparent;
}
.dynamic-scrollbar::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 24px;
  border: 2px solid transparent;
  background-clip: content-box;
}
.dynamic-scrollbar:hover, .dynamic-scrollbar:focus-within {
  scrollbar-color: #8fa0a7 transparent;
}
.dynamic-scrollbar:hover::-webkit-scrollbar-thumb, .dynamic-scrollbar:focus-within::-webkit-scrollbar-thumb {
  background: #8fa0a7;
}
.dynamic-scrollbar:hover::-webkit-scrollbar-thumb:hover, .dynamic-scrollbar:focus-within::-webkit-scrollbar-thumb:hover {
  border-width: 0px;
}

::selection {
  background: #b0eaff;
}

.rounded-smooth {
  clip-path: polygon(100% 50%, 100% 56.6%, 100% 59.3%, 100% 61.4%, 99.9% 63.2%, 99.9% 64.8%, 99.9% 66.2%, 99.8% 67.5%, 99.8% 68.7%, 99.7% 69.8%, 99.6% 70.8%, 99.5% 71.8%, 99.5% 72.8%, 99.4% 73.7%, 99.3% 74.6%, 99.1% 75.4%, 99% 76.3%, 98.9% 77%, 98.8% 77.8%, 98.6% 78.5%, 98.5% 79.2%, 98.3% 79.9%, 98.1% 80.6%, 98% 81.3%, 97.8% 81.9%, 97.6% 82.5%, 97.4% 83.1%, 97.2% 83.7%, 97% 84.3%, 96.8% 84.8%, 96.5% 85.4%, 96.3% 85.9%, 96% 86.4%, 95.8% 86.9%, 95.5% 87.4%, 95.3% 87.9%, 95% 88.3%, 94.7% 88.8%, 94.4% 89.2%, 94.1% 89.7%, 93.8% 90.1%, 93.4% 90.5%, 93.1% 90.9%, 92.8% 91.3%, 92.4% 91.7%, 92% 92%, 91.7% 92.4%, 91.3% 92.8%, 90.9% 93.1%, 90.5% 93.4%, 90.1% 93.8%, 89.7% 94.1%, 89.2% 94.4%, 88.8% 94.7%, 88.3% 95%, 87.9% 95.3%, 87.4% 95.5%, 86.9% 95.8%, 86.4% 96%, 85.9% 96.3%, 85.4% 96.5%, 84.8% 96.8%, 84.3% 97%, 83.7% 97.2%, 83.1% 97.4%, 82.5% 97.6%, 81.9% 97.8%, 81.3% 98%, 80.6% 98.1%, 79.9% 98.3%, 79.2% 98.5%, 78.5% 98.6%, 77.8% 98.8%, 77% 98.9%, 76.3% 99%, 75.4% 99.1%, 74.6% 99.3%, 73.7% 99.4%, 72.8% 99.5%, 71.8% 99.5%, 70.8% 99.6%, 69.8% 99.7%, 68.7% 99.8%, 67.5% 99.8%, 66.2% 99.9%, 64.8% 99.9%, 63.2% 99.9%, 61.4% 100%, 59.3% 100%, 56.6% 100%, 50% 100%, 43.4% 100%, 40.7% 100%, 38.6% 100%, 36.8% 99.9%, 35.2% 99.9%, 33.8% 99.9%, 32.5% 99.8%, 31.3% 99.8%, 30.2% 99.7%, 29.2% 99.6%, 28.2% 99.5%, 27.2% 99.5%, 26.3% 99.4%, 25.4% 99.3%, 24.6% 99.1%, 23.7% 99%, 23% 98.9%, 22.2% 98.8%, 21.5% 98.6%, 20.8% 98.5%, 20.1% 98.3%, 19.4% 98.1%, 18.7% 98%, 18.1% 97.8%, 17.5% 97.6%, 16.9% 97.4%, 16.3% 97.2%, 15.7% 97%, 15.2% 96.8%, 14.6% 96.5%, 14.1% 96.3%, 13.6% 96%, 13.1% 95.8%, 12.6% 95.5%, 12.1% 95.3%, 11.7% 95%, 11.2% 94.7%, 10.8% 94.4%, 10.3% 94.1%, 9.9% 93.8%, 9.5% 93.4%, 9.1% 93.1%, 8.7% 92.8%, 8.3% 92.4%, 8% 92%, 7.6% 91.7%, 7.2% 91.3%, 6.9% 90.9%, 6.6% 90.5%, 6.2% 90.1%, 5.9% 89.7%, 5.6% 89.2%, 5.3% 88.8%, 5% 88.3%, 4.7% 87.9%, 4.5% 87.4%, 4.2% 86.9%, 4% 86.4%, 3.7% 85.9%, 3.5% 85.4%, 3.2% 84.8%, 3% 84.3%, 2.8% 83.7%, 2.6% 83.1%, 2.4% 82.5%, 2.2% 81.9%, 2% 81.3%, 1.9% 80.6%, 1.7% 79.9%, 1.5% 79.2%, 1.4% 78.5%, 1.2% 77.8%, 1.1% 77%, 1% 76.3%, 0.9% 75.4%, 0.7% 74.6%, 0.6% 73.7%, 0.5% 72.8%, 0.5% 71.8%, 0.4% 70.8%, 0.3% 69.8%, 0.2% 68.7%, 0.2% 67.5%, 0.1% 66.2%, 0.1% 64.8%, 0.1% 63.2%, 0% 61.4%, 0% 59.3%, 0% 56.6%, 0% 50%, 0% 43.4%, 0% 40.7%, 0% 38.6%, 0.1% 36.8%, 0.1% 35.2%, 0.1% 33.8%, 0.2% 32.5%, 0.2% 31.3%, 0.3% 30.2%, 0.4% 29.2%, 0.5% 28.2%, 0.5% 27.2%, 0.6% 26.3%, 0.7% 25.4%, 0.9% 24.6%, 1% 23.7%, 1.1% 23%, 1.2% 22.2%, 1.4% 21.5%, 1.5% 20.8%, 1.7% 20.1%, 1.9% 19.4%, 2% 18.7%, 2.2% 18.1%, 2.4% 17.5%, 2.6% 16.9%, 2.8% 16.3%, 3% 15.7%, 3.2% 15.2%, 3.5% 14.6%, 3.7% 14.1%, 4% 13.6%, 4.2% 13.1%, 4.5% 12.6%, 4.7% 12.1%, 5% 11.7%, 5.3% 11.2%, 5.6% 10.8%, 5.9% 10.3%, 6.2% 9.9%, 6.6% 9.5%, 6.9% 9.1%, 7.2% 8.7%, 7.6% 8.3%, 8% 8%, 8.3% 7.6%, 8.7% 7.2%, 9.1% 6.9%, 9.5% 6.6%, 9.9% 6.2%, 10.3% 5.9%, 10.8% 5.6%, 11.2% 5.3%, 11.7% 5%, 12.1% 4.7%, 12.6% 4.5%, 13.1% 4.2%, 13.6% 4%, 14.1% 3.7%, 14.6% 3.5%, 15.2% 3.2%, 15.7% 3%, 16.3% 2.8%, 16.9% 2.6%, 17.5% 2.4%, 18.1% 2.2%, 18.7% 2%, 19.4% 1.9%, 20.1% 1.7%, 20.8% 1.5%, 21.5% 1.4%, 22.2% 1.2%, 23% 1.1%, 23.7% 1%, 24.6% 0.9%, 25.4% 0.7%, 26.3% 0.6%, 27.2% 0.5%, 28.2% 0.5%, 29.2% 0.4%, 30.2% 0.3%, 31.3% 0.2%, 32.5% 0.2%, 33.8% 0.1%, 35.2% 0.1%, 36.8% 0.1%, 38.6% 0%, 40.7% 0%, 43.4% 0%, 50% 0%, 56.6% 0%, 59.3% 0%, 61.4% 0%, 63.2% 0.1%, 64.8% 0.1%, 66.2% 0.1%, 67.5% 0.2%, 68.7% 0.2%, 69.8% 0.3%, 70.8% 0.4%, 71.8% 0.5%, 72.8% 0.5%, 73.7% 0.6%, 74.6% 0.7%, 75.4% 0.9%, 76.3% 1%, 77% 1.1%, 77.8% 1.2%, 78.5% 1.4%, 79.2% 1.5%, 79.9% 1.7%, 80.6% 1.9%, 81.3% 2%, 81.9% 2.2%, 82.5% 2.4%, 83.1% 2.6%, 83.7% 2.8%, 84.3% 3%, 84.8% 3.2%, 85.4% 3.5%, 85.9% 3.7%, 86.4% 4%, 86.9% 4.2%, 87.4% 4.5%, 87.9% 4.7%, 88.3% 5%, 88.8% 5.3%, 89.2% 5.6%, 89.7% 5.9%, 90.1% 6.2%, 90.5% 6.6%, 90.9% 6.9%, 91.3% 7.2%, 91.7% 7.6%, 92% 8%, 92.4% 8.3%, 92.8% 8.7%, 93.1% 9.1%, 93.4% 9.5%, 93.8% 9.9%, 94.1% 10.3%, 94.4% 10.8%, 94.7% 11.2%, 95% 11.7%, 95.3% 12.1%, 95.5% 12.6%, 95.8% 13.1%, 96% 13.6%, 96.3% 14.1%, 96.5% 14.6%, 96.8% 15.2%, 97% 15.7%, 97.2% 16.3%, 97.4% 16.9%, 97.6% 17.5%, 97.8% 18.1%, 98% 18.7%, 98.1% 19.4%, 98.3% 20.1%, 98.5% 20.8%, 98.6% 21.5%, 98.8% 22.2%, 98.9% 23%, 99% 23.7%, 99.1% 24.6%, 99.3% 25.4%, 99.4% 26.3%, 99.5% 27.2%, 99.5% 28.2%, 99.6% 29.2%, 99.7% 30.2%, 99.8% 31.3%, 99.8% 32.5%, 99.9% 33.8%, 99.9% 35.2%, 99.9% 36.8%, 100% 38.6%, 100% 40.7%, 100% 43.4%);
}

a {
  text-decoration: none !important;
}

label {
  font-size: 0.875rem;
}
label:first-letter {
  text-transform: capitalize;
}

@media (max-width: 768px) {
  input::placeholder {
    font-size: 0.875rem;
  }
}

.invoice-table-container .ag-details-row {
  padding: 0 !important;
  margin: 0 !important;
}
.invoice-table-container .ag-layout-auto-height .ag-center-cols-container,
.invoice-table-container .ag-layout-auto-height .ag-center-cols-viewport,
.invoice-table-container .ag-layout-print .ag-center-cols-container,
.invoice-table-container .ag-layout-print .ag-center-cols-viewport {
  min-height: unset !important;
}

.era-table-container .ag-row .ag-cell-value {
  flex-direction: column;
}

.disabled-wrapper {
  position: relative;
}
.disabled-wrapper:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 2;
  opacity: 0.3;
  cursor: not-allowed;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.eye-left,
.eye-right {
  animation: rotate 1s infinite;
  transform-origin: center;
  transform-box: border-box;
}

h1 {
  font-size: 2.5rem;
  line-height: 50px;
  font-weight: 500;
}

h2 {
  font-size: 2.25rem;
  line-height: 45px;
  font-weight: 500;
}

h3 {
  font-size: 2rem;
  line-height: 40px;
  font-weight: 500;
}

h4 {
  font-size: 1.75rem;
  line-height: 36px;
  font-weight: 500;
}

h5 {
  font-size: 1.5rem;
  line-height: 32px;
  font-weight: 500;
}

h6 {
  font-size: 1.25rem;
  line-height: 28px;
  font-weight: 500;
}

.primary-table {
  width: 100%;
  text-align: left;
  box-shadow: 0 4px 16px 0px rgba(10, 18, 57, 0.03);
  overflow: auto;
  min-height: 104px;
}
.primary-table thead {
  position: sticky;
  top: 0px;
  background-color: #fff;
  z-index: 1;
}
.primary-table thead tr {
  height: 52px;
  position: relative;
  box-shadow: 0 4px 16px 0px rgba(10, 18, 57, 0.03);
}
.primary-table thead tr th {
  color: #004f6b;
  font-weight: 400 !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
  vertical-align: middle;
  padding: 0 8px;
}
.primary-table tbody tr {
  height: 52px;
}
.primary-table tbody tr:nth-child(odd) {
  background-color: #f8fdff;
}
.primary-table tbody tr:nth-child(even) {
  background-color: #fff;
}
.primary-table tbody tr th {
  color: #004f6b;
  font-weight: inherit;
  font-size: 0.875rem;
  line-height: 1.25rem;
  vertical-align: middle;
}
.primary-table tbody tr td {
  color: #004f6b;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0 8px;
}
.primary-table .has-subtable tr {
  background-color: #e6f8ff !important;
}
.primary-table .has-subtable tr th {
  font-weight: 600;
  text-align: left;
}
.primary-table .has-subtable tr td {
  text-align: left;
}
.primary-table .has-subtable.danger tr {
  background-color: #fef2f2 !important;
}
.primary-table .has-subtable.success tr {
  background-color: #f0fdf4 !important;
}
.primary-table.selectable-children {
  border-collapse: unset;
}
.primary-table.selectable-children tr {
  border-radius: 8px;
}
.primary-table.selectable-children tr.selected td {
  background-color: #e6f8ff;
  border-color: #13b9ff;
}
.primary-table.selectable-children tr td {
  border-width: 1px;
  border-top-style: solid;
  border-bottom-style: solid;
  border-color: transparent;
}
.primary-table.selectable-children tr td:first-child {
  border-left-style: solid;
}
.primary-table.selectable-children tr td:last-child {
  border-right-style: solid;
}
.primary-table.responsive-table {
  position: relative;
  overflow: auto;
  display: block;
  table-layout: fixed;
  width: 100%;
}
.primary-table.responsive-table tbody {
  position: relative;
  z-index: 2;
  display: block;
  overflow: auto;
  margin-right: 6px;
  margin-left: 6px;
  margin-top: 6px;
  margin-bottom: 10px;
}
.primary-table.responsive-table tbody tr {
  display: table;
  table-layout: fixed;
  width: 100%;
  margin-top: 2px;
}
.primary-table.responsive-table thead {
  display: table;
  table-layout: fixed;
  width: 100%;
}
.primary-table .empty {
  position: absolute;
  left: 0;
  font-size: 0.875rem;
  color: #004f6b;
  width: 100%;
  background: white;
  height: 52px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashed-top {
  border-top: 1px dashed #8ae0ff;
}

.dashed-bottom {
  border-bottom: 1px dashed #8ae0ff !important;
}

.dashed-left {
  border-left: 1px dashed #8ae0ff;
}

.dashed-right {
  border-right: 1px dashed #8ae0ff;
}

.ag-row-error {
  background-color: rgba(255, 0, 0, 0.2);
}

.ag-row-command-highlight {
  background-color: #f5fbff;
  box-shadow: inset 2px 0 0 #0ba5ec;
}

::highlight(command-bar-match) {
  background-color: #fedf89;
  color: inherit;
}

.ag-cell-wrapper.ag-row-group {
  align-items: center;
}

.selected-group-row {
  background-color: #e6f8ff;
}

.ag-hover-group-row {
  background-color: #d3edfe;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

button .Icon,
.select .Icon {
  cursor: pointer;
}

.ag-status-bar {
  padding: 16px 18px;
  height: 48px;
  min-height: 35px;
}

.debug {
  border: 1px solid #f56565;
  border-style: solid;
}

@keyframes ellipsis {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
  100% {
    content: ".";
  }
}
.animate-ellipsis::after {
  content: ".";
  animation: ellipsis 1s infinite steps(1);
}

/* Blink effect */
@keyframes blink {
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
}
.blink {
  animation: blink 2s linear infinite;
}

.animate-shine {
  position: relative;
  border: none !important;
}
.animate-shine:after {
  content: "";
  position: absolute;
  top: -4px;
  width: 30px;
  height: calc(100% + 8px);
  transform: rotate(0deg);
  background: linear-gradient(109.17deg, rgba(255, 255, 255, 0) 27.03%, rgba(255, 255, 255, 0.3) 43.82%, rgba(255, 255, 255, 0.254412) 58.83%, rgba(255, 255, 255, 0) 77.63%);
  animation: shine 1.5s linear infinite;
}

@keyframes shine {
  0% {
    left: -30px;
    opacity: 1;
  }
  70% {
    left: 70%;
    opacity: 0.5;
  }
  100% {
    left: calc(100% - 16px);
    opacity: 0;
  }
}
@keyframes pulse-bg {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@media print {
  input,
  textarea,
  select {
    background-color: transparent !important;
    color: #252b37;
  }
  p,
  span,
  strong,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  label,
  input {
    color: #252b37 !important;
  }
  input,
  select {
    border-color: #a4a7ae !important;
  }
  svg {
    transform: scale(0.8);
  }
  svg path {
    fill: #252b37;
  }
  .SortableItem {
    break-inside: avoid;
  }
  .row {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
  }
  .row .SortableItem {
    break-inside: unset;
    flex: unset !important;
  }
  .row .col-md-3 {
    flex: 1 1 20%;
    max-width: unset;
    padding: 0;
  }
  .row .col-md-4 {
    flex: 1 1 30%;
    max-width: unset;
    padding: 0;
  }
}
.ag-chart-tooltip {
  z-index: 99999 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(233, 234, 235, 0.9) !important;
  background: rgba(255, 255, 255, 0.94) !important;
  backdrop-filter: saturate(180%) blur(8px);
  -webkit-backdrop-filter: saturate(180%) blur(8px);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 16px -6px rgba(16, 24, 40, 0.12), 0 20px 32px -12px rgba(10, 18, 57, 0.18) !important;
  font-family: "Geist", sans-serif !important;
  font-size: 12px !important;
  color: #181d27 !important;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
}

.ag-chart-tooltip-title {
  background: transparent !important;
  color: #717680 !important;
  font-weight: 600;
  font-size: 10.5px;
  letter-spacing: 0.02em;
  padding: 8px 12px 2px !important;
}

.ag-chart-tooltip-content {
  color: #181d27;
  font-weight: 600;
  padding: 2px 12px 9px !important;
}

.first-letter\\:uppercase::first-letter{
  text-transform: uppercase;
}

.first-letter\\:lowercase::first-letter{
  text-transform: lowercase;
}

.first-letter\\:\\!capitalize::first-letter{
  text-transform: capitalize !important;
}

.first-letter\\:capitalize::first-letter{
  text-transform: capitalize;
}

.marker\\:text-warning-800 *::marker{
  color: rgb(147 55 13 );
}

.marker\\:text-warning-800::marker{
  color: rgb(147 55 13 );
}

.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}

.file\\:cursor-pointer::file-selector-button{
  cursor: pointer;
}

.file\\:rounded-md::file-selector-button{
  border-radius: 0.375rem;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-primary-500::file-selector-button{
  background-color: var(--color-primary-500, #0BA5EC);
}

.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.file\\:py-1\\.5::file-selector-button{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-500::file-selector-button{
  font-weight: 500;
}

.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-base::placeholder{
  font-size: 1rem;
  line-height: 1.5rem;
}

.placeholder\\:text-sm::placeholder{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.placeholder\\:text-neutral-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-neutral-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-neutral-600::placeholder{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}

.before\\:pointer-events-none::before{
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before{
  content: var(--tw-content);
  inset: 0px;
}

.before\\:-left-2\\.5::before{
  content: var(--tw-content);
  left: -0.625rem;
}

.before\\:-right-2\\.5::before{
  content: var(--tw-content);
  right: -0.625rem;
}

.before\\:bottom-0::before{
  content: var(--tw-content);
  bottom: 0px;
}

.before\\:left-0::before{
  content: var(--tw-content);
  left: 0px;
}

.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}

.before\\:z-10::before{
  content: var(--tw-content);
  z-index: 10;
}

.before\\:mr-0\\.5::before{
  content: var(--tw-content);
  margin-right: 0.125rem;
}

.before\\:\\!h-5::before{
  content: var(--tw-content);
  height: 1.25rem !important;
}

.before\\:h-0::before{
  content: var(--tw-content);
  height: 0px;
}

.before\\:h-\\[1px\\]::before{
  content: var(--tw-content);
  height: 1px;
}

.before\\:h-\\[2px\\]::before{
  content: var(--tw-content);
  height: 2px;
}

.before\\:h-full::before{
  content: var(--tw-content);
  height: 100%;
}

.before\\:\\!w-5::before{
  content: var(--tw-content);
  width: 1.25rem !important;
}

.before\\:\\!w-6::before{
  content: var(--tw-content);
  width: 1.5rem !important;
}

.before\\:w-1::before{
  content: var(--tw-content);
  width: 0.25rem;
}

.before\\:w-2\\.5::before{
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:w-\\[4px\\]::before{
  content: var(--tw-content);
  width: 4px;
}

.before\\:w-full::before{
  content: var(--tw-content);
  width: 100%;
}

.before\\:\\!rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px !important;
}

.before\\:rounded-\\[6px\\]::before{
  content: var(--tw-content);
  border-radius: 6px;
}

.before\\:rounded-l-md::before{
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.before\\:\\!bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.before\\:bg-danger-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}

.before\\:bg-neutral-100::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.before\\:bg-neutral-200::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.before\\:bg-neutral-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}

.before\\:bg-neutral-800::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1));
}

.before\\:bg-primary-500::before{
  content: var(--tw-content);
  background-color: var(--color-primary-500, #0BA5EC);
}

.before\\:bg-success-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(22 179 100 / var(--tw-bg-opacity, 1));
}

.before\\:bg-warning-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}

.before\\:bg-\\[linear-gradient\\(to_right\\2c transparent_85\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.6\\)_100\\%\\)\\]::before{
  content: var(--tw-content);
  background-image: linear-gradient(to right,transparent 85%,rgba(255,255,255,0.6) 100%);
}

.before\\:opacity-0::before{
  content: var(--tw-content);
  opacity: 0;
}

.before\\:opacity-30::before{
  content: var(--tw-content);
  opacity: 0.3;
}

.before\\:duration-150::before{
  content: var(--tw-content);
  transition-duration: 150ms;
}

.before\\:duration-200::before{
  content: var(--tw-content);
  transition-duration: 200ms;
}

.before\\:ease-linear::before{
  content: var(--tw-content);
  transition-timing-function: linear;
}

.before\\:content-\\[\\"\\"\\]::before{
  --tw-content: "";
  content: var(--tw-content);
}

.before\\:content-\\[\\'\\'\\]::before{
  --tw-content: '';
  content: var(--tw-content);
}

.before\\:content-\\[\\'\\2022\\'\\]::before{
  --tw-content: '•';
  content: var(--tw-content);
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:-inset-1::after{
  content: var(--tw-content);
  inset: -0.25rem;
}

.after\\:-inset-1\\.5::after{
  content: var(--tw-content);
  inset: -0.375rem;
}

.after\\:inset-0::after{
  content: var(--tw-content);
  inset: 0px;
}

.after\\:\\!left-\\[7\\.5px\\]::after{
  content: var(--tw-content);
  left: 7.5px !important;
}

.after\\:\\!top-\\[4px\\]::after{
  content: var(--tw-content);
  top: 4px !important;
}

.after\\:bottom-0::after{
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:left-0::after{
  content: var(--tw-content);
  left: 0px;
}

.after\\:\\!h-\\[10px\\]::after{
  content: var(--tw-content);
  height: 10px !important;
}

.after\\:h-0\\.5::after{
  content: var(--tw-content);
  height: 0.125rem;
}

.after\\:\\!w-\\[5px\\]::after{
  content: var(--tw-content);
  width: 5px !important;
}

.after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}

.after\\:rounded-lg::after{
  content: var(--tw-content);
  border-radius: 0.5rem;
}

.after\\:bg-primary-500::after{
  content: var(--tw-content);
  background-color: var(--color-primary-500, #0BA5EC);
}

.after\\:content-\\[\\"\\"\\]::after{
  --tw-content: "";
  content: var(--tw-content);
}

.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}

.first\\:\\!mt-0:first-child{
  margin-top: 0px !important;
}

.first\\:mt-0:first-child{
  margin-top: 0px;
}

.first\\:\\!w-full:first-child{
  width: 100% !important;
}

.first\\:rounded-t-md:first-child{
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.first\\:\\!border-l-0:first-child{
  border-left-width: 0px !important;
}

.first\\:border-l-0:first-child{
  border-left-width: 0px;
}

.first\\:border-t-0:first-child{
  border-top-width: 0px;
}

.first\\:pt-0:first-child{
  padding-top: 0px;
}

.last\\:rounded-b-md:last-child{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:\\!border-b-0:last-child{
  border-bottom-width: 0px !important;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.last\\:border-r-0:last-child{
  border-right-width: 0px;
}

.last\\:border-none:last-child{
  border-style: none;
}

.last\\:pb-0:last-child{
  padding-bottom: 0px;
}

.only\\:hidden:only-child{
  display: none;
}

.odd\\:\\!bg-\\[\\#F8FDFF\\]:nth-child(odd){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 253 255 / var(--tw-bg-opacity, 1)) !important;
}

.odd\\:bg-neutral-50:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.odd\\:bg-white:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.odd\\:pl-0:nth-child(odd){
  padding-left: 0px;
}

.even\\:border-r-0:nth-child(even){
  border-right-width: 0px;
}

.even\\:\\!bg-white:nth-child(even){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.even\\:pr-0:nth-child(even){
  padding-right: 0px;
}

.first-of-type\\:\\!mt-0:first-of-type{
  margin-top: 0px !important;
}

.first-of-type\\:-mb-\\[1px\\]:first-of-type{
  margin-bottom: -1px;
}

.first-of-type\\:ml-0:first-of-type{
  margin-left: 0px;
}

.first-of-type\\:mt-0:first-of-type{
  margin-top: 0px;
}

.first-of-type\\:hidden:first-of-type{
  display: none;
}

.first-of-type\\:rounded-l-md:first-of-type{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.first-of-type\\:\\!border-t-0:first-of-type{
  border-top-width: 0px !important;
}

.first-of-type\\:border-b:first-of-type{
  border-bottom-width: 1px;
}

.first-of-type\\:\\!pt-0:first-of-type{
  padding-top: 0px !important;
}

.first-of-type\\:pl-0:first-of-type{
  padding-left: 0px;
}

.last-of-type\\:z-10:last-of-type{
  z-index: 10;
}

.last-of-type\\:mr-0:last-of-type{
  margin-right: 0px;
}

.last-of-type\\:rounded-r-md:last-of-type{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.last-of-type\\:border-0:last-of-type{
  border-width: 0px;
}

.last-of-type\\:border-t:last-of-type{
  border-top-width: 1px;
}

.last-of-type\\:border-none:last-of-type{
  border-style: none;
}

.last-of-type\\:\\!pb-0:last-of-type{
  padding-bottom: 0px !important;
}

.last-of-type\\:pr-0:last-of-type{
  padding-right: 0px;
}

.visited\\:\\!text-neutral-800:visited{
  color: rgb(37 43 55 ) !important;
}

.empty\\:hidden:empty{
  display: none;
}

.empty\\:before\\:text-neutral-500:empty::before{
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}

.empty\\:before\\:content-\\[attr\\(data-placeholder\\)\\]:empty::before{
  --tw-content: attr(data-placeholder);
  content: var(--tw-content);
}

.focus-within\\:\\!border-0:focus-within{
  border-width: 0px !important;
}

.focus-within\\:\\!border-b-2:focus-within{
  border-bottom-width: 2px !important;
}

.focus-within\\:\\!border-b-\\[1px\\]:focus-within{
  border-bottom-width: 1px !important;
}

.focus-within\\:\\!border-none:focus-within{
  border-style: none !important;
}

.focus-within\\:\\!border-\\[\\#dadfe2\\]:focus-within{
  --tw-border-opacity: 1 !important;
  border-color: rgb(218 223 226 / var(--tw-border-opacity, 1)) !important;
}

.focus-within\\:\\!border-neutral-200:focus-within{
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1)) !important;
}

.focus-within\\:\\!border-primary-300:focus-within{
  border-color: var(--color-primary-300, #7CD4FD) !important;
}

.focus-within\\:border-\\[\\#7CD4FD\\]:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(124 212 253 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-primary-300:focus-within{
  border-color: var(--color-primary-300, #7CD4FD);
}

.focus-within\\:border-b-primary-300:focus-within{
  border-bottom-color: var(--color-primary-300, #7CD4FD);
}

.focus-within\\:\\!bg-primary-100:focus-within{
  background-color: var(--color-primary-100, #E0F2FE) !important;
}

.focus-within\\:bg-neutral-200:focus-within{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.focus-within\\:opacity-100:focus-within{
  opacity: 1;
}

.focus-within\\:shadow-medium:focus-within{
  --tw-shadow: 0 0px 24px 0px rgba(0,79,107,0.16);
  --tw-shadow-colored: 0 0px 24px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus-within\\:\\!outline-none:focus-within{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus-within\\:\\!outline:focus-within{
  outline-style: solid !important;
}

.focus-within\\:outline:focus-within{
  outline-style: solid;
}

.focus-within\\:\\!outline-0:focus-within{
  outline-width: 0px !important;
}

.focus-within\\:\\!outline-2:focus-within{
  outline-width: 2px !important;
}

.focus-within\\:\\!outline-\\[0px\\]:focus-within{
  outline-width: 0px !important;
}

.focus-within\\:outline-2:focus-within{
  outline-width: 2px;
}

.focus-within\\:outline-offset-1:focus-within{
  outline-offset: 1px;
}

.focus-within\\:\\!outline-\\[\\#CBF0FD\\]:focus-within{
  outline-color: #CBF0FD !important;
}

.focus-within\\:\\!outline-\\[\\#FFFFFF\\]:focus-within{
  outline-color: #FFFFFF !important;
}

.focus-within\\:\\!outline-danger-100:focus-within{
  outline-color: #FEE4E2 !important;
}

.focus-within\\:\\!outline-transparent:focus-within{
  outline-color: transparent !important;
}

.focus-within\\:outline-\\[\\#CBF0FD\\]:focus-within{
  outline-color: #CBF0FD;
}

.focus-within\\:outline-\\[\\#E0E3F9\\]:focus-within{
  outline-color: #E0E3F9;
}

.focus-within\\:outline-danger-100:focus-within{
  outline-color: #FEE4E2;
}

.focus-within\\:outline-primary-300:focus-within{
  outline-color: var(--color-primary-300, #7CD4FD);
}

.hover\\:-bottom-2:hover{
  bottom: -0.5rem;
}

.hover\\:-left-2:hover{
  left: -0.5rem;
}

.hover\\:-right-2:hover{
  right: -0.5rem;
}

.hover\\:-top-2:hover{
  top: -0.5rem;
}

.hover\\:-translate-x-1:hover{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-\\[1px\\]:hover{
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:translate-x-1:hover{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover{
  cursor: pointer;
}

.hover\\:rounded-\\[1px\\]:hover{
  border-radius: 1px;
}

.hover\\:rounded-lg:hover{
  border-radius: 0.5rem;
}

.hover\\:rounded-sm:hover{
  border-radius: 0.125rem;
}

.hover\\:border:hover{
  border-width: 1px;
}

.hover\\:border-2:hover{
  border-width: 2px;
}

.hover\\:\\!border-danger-500:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:\\!border-neutral-200:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:\\!border-neutral-50:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 250 250 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:\\!border-neutral-800:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 43 55 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:\\!border-primary-100:hover{
  border-color: var(--color-primary-100, #E0F2FE) !important;
}

.hover\\:\\!border-primary-200:hover{
  border-color: var(--color-primary-200, #B9E6FE) !important;
}

.hover\\:\\!border-primary-500:hover{
  border-color: var(--color-primary-500, #0BA5EC) !important;
}

.hover\\:border-blue-dark-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(132 173 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-cyan-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(103 227 249 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-100\\/0:hover{
  border-color: rgb(254 228 226 / 0);
}

.hover\\:border-danger-100\\/10:hover{
  border-color: rgb(254 228 226 / 0.1);
}

.hover\\:border-danger-100\\/100:hover{
  border-color: rgb(254 228 226 / 1);
}

.hover\\:border-danger-100\\/15:hover{
  border-color: rgb(254 228 226 / 0.15);
}

.hover\\:border-danger-100\\/20:hover{
  border-color: rgb(254 228 226 / 0.2);
}

.hover\\:border-danger-100\\/25:hover{
  border-color: rgb(254 228 226 / 0.25);
}

.hover\\:border-danger-100\\/30:hover{
  border-color: rgb(254 228 226 / 0.3);
}

.hover\\:border-danger-100\\/35:hover{
  border-color: rgb(254 228 226 / 0.35);
}

.hover\\:border-danger-100\\/40:hover{
  border-color: rgb(254 228 226 / 0.4);
}

.hover\\:border-danger-100\\/45:hover{
  border-color: rgb(254 228 226 / 0.45);
}

.hover\\:border-danger-100\\/5:hover{
  border-color: rgb(254 228 226 / 0.05);
}

.hover\\:border-danger-100\\/50:hover{
  border-color: rgb(254 228 226 / 0.5);
}

.hover\\:border-danger-100\\/55:hover{
  border-color: rgb(254 228 226 / 0.55);
}

.hover\\:border-danger-100\\/60:hover{
  border-color: rgb(254 228 226 / 0.6);
}

.hover\\:border-danger-100\\/65:hover{
  border-color: rgb(254 228 226 / 0.65);
}

.hover\\:border-danger-100\\/70:hover{
  border-color: rgb(254 228 226 / 0.7);
}

.hover\\:border-danger-100\\/75:hover{
  border-color: rgb(254 228 226 / 0.75);
}

.hover\\:border-danger-100\\/80:hover{
  border-color: rgb(254 228 226 / 0.8);
}

.hover\\:border-danger-100\\/85:hover{
  border-color: rgb(254 228 226 / 0.85);
}

.hover\\:border-danger-100\\/90:hover{
  border-color: rgb(254 228 226 / 0.9);
}

.hover\\:border-danger-100\\/95:hover{
  border-color: rgb(254 228 226 / 0.95);
}

.hover\\:border-danger-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-200\\/0:hover{
  border-color: rgb(254 205 202 / 0);
}

.hover\\:border-danger-200\\/10:hover{
  border-color: rgb(254 205 202 / 0.1);
}

.hover\\:border-danger-200\\/100:hover{
  border-color: rgb(254 205 202 / 1);
}

.hover\\:border-danger-200\\/15:hover{
  border-color: rgb(254 205 202 / 0.15);
}

.hover\\:border-danger-200\\/20:hover{
  border-color: rgb(254 205 202 / 0.2);
}

.hover\\:border-danger-200\\/25:hover{
  border-color: rgb(254 205 202 / 0.25);
}

.hover\\:border-danger-200\\/30:hover{
  border-color: rgb(254 205 202 / 0.3);
}

.hover\\:border-danger-200\\/35:hover{
  border-color: rgb(254 205 202 / 0.35);
}

.hover\\:border-danger-200\\/40:hover{
  border-color: rgb(254 205 202 / 0.4);
}

.hover\\:border-danger-200\\/45:hover{
  border-color: rgb(254 205 202 / 0.45);
}

.hover\\:border-danger-200\\/5:hover{
  border-color: rgb(254 205 202 / 0.05);
}

.hover\\:border-danger-200\\/50:hover{
  border-color: rgb(254 205 202 / 0.5);
}

.hover\\:border-danger-200\\/55:hover{
  border-color: rgb(254 205 202 / 0.55);
}

.hover\\:border-danger-200\\/60:hover{
  border-color: rgb(254 205 202 / 0.6);
}

.hover\\:border-danger-200\\/65:hover{
  border-color: rgb(254 205 202 / 0.65);
}

.hover\\:border-danger-200\\/70:hover{
  border-color: rgb(254 205 202 / 0.7);
}

.hover\\:border-danger-200\\/75:hover{
  border-color: rgb(254 205 202 / 0.75);
}

.hover\\:border-danger-200\\/80:hover{
  border-color: rgb(254 205 202 / 0.8);
}

.hover\\:border-danger-200\\/85:hover{
  border-color: rgb(254 205 202 / 0.85);
}

.hover\\:border-danger-200\\/90:hover{
  border-color: rgb(254 205 202 / 0.9);
}

.hover\\:border-danger-200\\/95:hover{
  border-color: rgb(254 205 202 / 0.95);
}

.hover\\:border-danger-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 251 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-25\\/0:hover{
  border-color: rgb(255 251 250 / 0);
}

.hover\\:border-danger-25\\/10:hover{
  border-color: rgb(255 251 250 / 0.1);
}

.hover\\:border-danger-25\\/100:hover{
  border-color: rgb(255 251 250 / 1);
}

.hover\\:border-danger-25\\/15:hover{
  border-color: rgb(255 251 250 / 0.15);
}

.hover\\:border-danger-25\\/20:hover{
  border-color: rgb(255 251 250 / 0.2);
}

.hover\\:border-danger-25\\/25:hover{
  border-color: rgb(255 251 250 / 0.25);
}

.hover\\:border-danger-25\\/30:hover{
  border-color: rgb(255 251 250 / 0.3);
}

.hover\\:border-danger-25\\/35:hover{
  border-color: rgb(255 251 250 / 0.35);
}

.hover\\:border-danger-25\\/40:hover{
  border-color: rgb(255 251 250 / 0.4);
}

.hover\\:border-danger-25\\/45:hover{
  border-color: rgb(255 251 250 / 0.45);
}

.hover\\:border-danger-25\\/5:hover{
  border-color: rgb(255 251 250 / 0.05);
}

.hover\\:border-danger-25\\/50:hover{
  border-color: rgb(255 251 250 / 0.5);
}

.hover\\:border-danger-25\\/55:hover{
  border-color: rgb(255 251 250 / 0.55);
}

.hover\\:border-danger-25\\/60:hover{
  border-color: rgb(255 251 250 / 0.6);
}

.hover\\:border-danger-25\\/65:hover{
  border-color: rgb(255 251 250 / 0.65);
}

.hover\\:border-danger-25\\/70:hover{
  border-color: rgb(255 251 250 / 0.7);
}

.hover\\:border-danger-25\\/75:hover{
  border-color: rgb(255 251 250 / 0.75);
}

.hover\\:border-danger-25\\/80:hover{
  border-color: rgb(255 251 250 / 0.8);
}

.hover\\:border-danger-25\\/85:hover{
  border-color: rgb(255 251 250 / 0.85);
}

.hover\\:border-danger-25\\/90:hover{
  border-color: rgb(255 251 250 / 0.9);
}

.hover\\:border-danger-25\\/95:hover{
  border-color: rgb(255 251 250 / 0.95);
}

.hover\\:border-danger-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 162 155 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-400\\/0:hover{
  border-color: rgb(249 112 102 / 0);
}

.hover\\:border-danger-400\\/10:hover{
  border-color: rgb(249 112 102 / 0.1);
}

.hover\\:border-danger-400\\/100:hover{
  border-color: rgb(249 112 102 / 1);
}

.hover\\:border-danger-400\\/15:hover{
  border-color: rgb(249 112 102 / 0.15);
}

.hover\\:border-danger-400\\/20:hover{
  border-color: rgb(249 112 102 / 0.2);
}

.hover\\:border-danger-400\\/25:hover{
  border-color: rgb(249 112 102 / 0.25);
}

.hover\\:border-danger-400\\/30:hover{
  border-color: rgb(249 112 102 / 0.3);
}

.hover\\:border-danger-400\\/35:hover{
  border-color: rgb(249 112 102 / 0.35);
}

.hover\\:border-danger-400\\/40:hover{
  border-color: rgb(249 112 102 / 0.4);
}

.hover\\:border-danger-400\\/45:hover{
  border-color: rgb(249 112 102 / 0.45);
}

.hover\\:border-danger-400\\/5:hover{
  border-color: rgb(249 112 102 / 0.05);
}

.hover\\:border-danger-400\\/50:hover{
  border-color: rgb(249 112 102 / 0.5);
}

.hover\\:border-danger-400\\/55:hover{
  border-color: rgb(249 112 102 / 0.55);
}

.hover\\:border-danger-400\\/60:hover{
  border-color: rgb(249 112 102 / 0.6);
}

.hover\\:border-danger-400\\/65:hover{
  border-color: rgb(249 112 102 / 0.65);
}

.hover\\:border-danger-400\\/70:hover{
  border-color: rgb(249 112 102 / 0.7);
}

.hover\\:border-danger-400\\/75:hover{
  border-color: rgb(249 112 102 / 0.75);
}

.hover\\:border-danger-400\\/80:hover{
  border-color: rgb(249 112 102 / 0.8);
}

.hover\\:border-danger-400\\/85:hover{
  border-color: rgb(249 112 102 / 0.85);
}

.hover\\:border-danger-400\\/90:hover{
  border-color: rgb(249 112 102 / 0.9);
}

.hover\\:border-danger-400\\/95:hover{
  border-color: rgb(249 112 102 / 0.95);
}

.hover\\:border-danger-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-50\\/0:hover{
  border-color: rgb(254 243 242 / 0);
}

.hover\\:border-danger-50\\/10:hover{
  border-color: rgb(254 243 242 / 0.1);
}

.hover\\:border-danger-50\\/100:hover{
  border-color: rgb(254 243 242 / 1);
}

.hover\\:border-danger-50\\/15:hover{
  border-color: rgb(254 243 242 / 0.15);
}

.hover\\:border-danger-50\\/20:hover{
  border-color: rgb(254 243 242 / 0.2);
}

.hover\\:border-danger-50\\/25:hover{
  border-color: rgb(254 243 242 / 0.25);
}

.hover\\:border-danger-50\\/30:hover{
  border-color: rgb(254 243 242 / 0.3);
}

.hover\\:border-danger-50\\/35:hover{
  border-color: rgb(254 243 242 / 0.35);
}

.hover\\:border-danger-50\\/40:hover{
  border-color: rgb(254 243 242 / 0.4);
}

.hover\\:border-danger-50\\/45:hover{
  border-color: rgb(254 243 242 / 0.45);
}

.hover\\:border-danger-50\\/5:hover{
  border-color: rgb(254 243 242 / 0.05);
}

.hover\\:border-danger-50\\/50:hover{
  border-color: rgb(254 243 242 / 0.5);
}

.hover\\:border-danger-50\\/55:hover{
  border-color: rgb(254 243 242 / 0.55);
}

.hover\\:border-danger-50\\/60:hover{
  border-color: rgb(254 243 242 / 0.6);
}

.hover\\:border-danger-50\\/65:hover{
  border-color: rgb(254 243 242 / 0.65);
}

.hover\\:border-danger-50\\/70:hover{
  border-color: rgb(254 243 242 / 0.7);
}

.hover\\:border-danger-50\\/75:hover{
  border-color: rgb(254 243 242 / 0.75);
}

.hover\\:border-danger-50\\/80:hover{
  border-color: rgb(254 243 242 / 0.8);
}

.hover\\:border-danger-50\\/85:hover{
  border-color: rgb(254 243 242 / 0.85);
}

.hover\\:border-danger-50\\/90:hover{
  border-color: rgb(254 243 242 / 0.9);
}

.hover\\:border-danger-50\\/95:hover{
  border-color: rgb(254 243 242 / 0.95);
}

.hover\\:border-danger-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-500\\/0:hover{
  border-color: rgb(240 68 56 / 0);
}

.hover\\:border-danger-500\\/10:hover{
  border-color: rgb(240 68 56 / 0.1);
}

.hover\\:border-danger-500\\/100:hover{
  border-color: rgb(240 68 56 / 1);
}

.hover\\:border-danger-500\\/15:hover{
  border-color: rgb(240 68 56 / 0.15);
}

.hover\\:border-danger-500\\/20:hover{
  border-color: rgb(240 68 56 / 0.2);
}

.hover\\:border-danger-500\\/25:hover{
  border-color: rgb(240 68 56 / 0.25);
}

.hover\\:border-danger-500\\/30:hover{
  border-color: rgb(240 68 56 / 0.3);
}

.hover\\:border-danger-500\\/35:hover{
  border-color: rgb(240 68 56 / 0.35);
}

.hover\\:border-danger-500\\/40:hover{
  border-color: rgb(240 68 56 / 0.4);
}

.hover\\:border-danger-500\\/45:hover{
  border-color: rgb(240 68 56 / 0.45);
}

.hover\\:border-danger-500\\/5:hover{
  border-color: rgb(240 68 56 / 0.05);
}

.hover\\:border-danger-500\\/50:hover{
  border-color: rgb(240 68 56 / 0.5);
}

.hover\\:border-danger-500\\/55:hover{
  border-color: rgb(240 68 56 / 0.55);
}

.hover\\:border-danger-500\\/60:hover{
  border-color: rgb(240 68 56 / 0.6);
}

.hover\\:border-danger-500\\/65:hover{
  border-color: rgb(240 68 56 / 0.65);
}

.hover\\:border-danger-500\\/70:hover{
  border-color: rgb(240 68 56 / 0.7);
}

.hover\\:border-danger-500\\/75:hover{
  border-color: rgb(240 68 56 / 0.75);
}

.hover\\:border-danger-500\\/80:hover{
  border-color: rgb(240 68 56 / 0.8);
}

.hover\\:border-danger-500\\/85:hover{
  border-color: rgb(240 68 56 / 0.85);
}

.hover\\:border-danger-500\\/90:hover{
  border-color: rgb(240 68 56 / 0.9);
}

.hover\\:border-danger-500\\/95:hover{
  border-color: rgb(240 68 56 / 0.95);
}

.hover\\:border-danger-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-600\\/0:hover{
  border-color: rgb(217 45 32 / 0);
}

.hover\\:border-danger-600\\/10:hover{
  border-color: rgb(217 45 32 / 0.1);
}

.hover\\:border-danger-600\\/100:hover{
  border-color: rgb(217 45 32 / 1);
}

.hover\\:border-danger-600\\/15:hover{
  border-color: rgb(217 45 32 / 0.15);
}

.hover\\:border-danger-600\\/20:hover{
  border-color: rgb(217 45 32 / 0.2);
}

.hover\\:border-danger-600\\/25:hover{
  border-color: rgb(217 45 32 / 0.25);
}

.hover\\:border-danger-600\\/30:hover{
  border-color: rgb(217 45 32 / 0.3);
}

.hover\\:border-danger-600\\/35:hover{
  border-color: rgb(217 45 32 / 0.35);
}

.hover\\:border-danger-600\\/40:hover{
  border-color: rgb(217 45 32 / 0.4);
}

.hover\\:border-danger-600\\/45:hover{
  border-color: rgb(217 45 32 / 0.45);
}

.hover\\:border-danger-600\\/5:hover{
  border-color: rgb(217 45 32 / 0.05);
}

.hover\\:border-danger-600\\/50:hover{
  border-color: rgb(217 45 32 / 0.5);
}

.hover\\:border-danger-600\\/55:hover{
  border-color: rgb(217 45 32 / 0.55);
}

.hover\\:border-danger-600\\/60:hover{
  border-color: rgb(217 45 32 / 0.6);
}

.hover\\:border-danger-600\\/65:hover{
  border-color: rgb(217 45 32 / 0.65);
}

.hover\\:border-danger-600\\/70:hover{
  border-color: rgb(217 45 32 / 0.7);
}

.hover\\:border-danger-600\\/75:hover{
  border-color: rgb(217 45 32 / 0.75);
}

.hover\\:border-danger-600\\/80:hover{
  border-color: rgb(217 45 32 / 0.8);
}

.hover\\:border-danger-600\\/85:hover{
  border-color: rgb(217 45 32 / 0.85);
}

.hover\\:border-danger-600\\/90:hover{
  border-color: rgb(217 45 32 / 0.9);
}

.hover\\:border-danger-600\\/95:hover{
  border-color: rgb(217 45 32 / 0.95);
}

.hover\\:border-danger-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}

.hover\\:border-danger-700\\/0:hover{
  border-color: rgb(180 35 24 / 0);
}

.hover\\:border-danger-700\\/10:hover{
  border-color: rgb(180 35 24 / 0.1);
}

.hover\\:border-danger-700\\/100:hover{
  border-color: rgb(180 35 24 / 1);
}

.hover\\:border-danger-700\\/15:hover{
  border-color: rgb(180 35 24 / 0.15);
}

.hover\\:border-danger-700\\/20:hover{
  border-color: rgb(180 35 24 / 0.2);
}

.hover\\:border-danger-700\\/25:hover{
  border-color: rgb(180 35 24 / 0.25);
}

.hover\\:border-danger-700\\/30:hover{
  border-color: rgb(180 35 24 / 0.3);
}

.hover\\:border-danger-700\\/35:hover{
  border-color: rgb(180 35 24 / 0.35);
}

.hover\\:border-danger-700\\/40:hover{
  border-color: rgb(180 35 24 / 0.4);
}

.hover\\:border-danger-700\\/45:hover{
  border-color: rgb(180 35 24 / 0.45);
}

.hover\\:border-danger-700\\/5:hover{
  border-color: rgb(180 35 24 / 0.05);
}

.hover\\:border-danger-700\\/50:hover{
  border-color: rgb(180 35 24 / 0.5);
}

.hover\\:border-danger-700\\/55:hover{
  border-color: rgb(180 35 24 / 0.55);
}

.hover\\:border-danger-700\\/60:hover{
  border-color: rgb(180 35 24 / 0.6);
}

.hover\\:border-danger-700\\/65:hover{
  border-color: rgb(180 35 24 / 0.65);
}

.hover\\:border-danger-700\\/70:hover{
  border-color: rgb(180 35 24 / 0.7);
}

.hover\\:border-danger-700\\/75:hover{
  border-color: rgb(180 35 24 / 0.75);
}

.hover\\:border-danger-700\\/80:hover{
  border-color: rgb(180 35 24 / 0.8);
}

.hover\\:border-danger-700\\/85:hover{
  border-color: rgb(180 35 24 / 0.85);
}

.hover\\:border-danger-700\\/90:hover{
  border-color: rgb(180 35 24 / 0.9);
}

.hover\\:border-danger-700\\/95:hover{
  border-color: rgb(180 35 24 / 0.95);
}

.hover\\:border-fuchsia-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(238 170 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-green-light-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(166 239 103 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(230 244 215 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-100\\/0:hover{
  border-color: rgb(230 244 215 / 0);
}

.hover\\:border-moss-100\\/10:hover{
  border-color: rgb(230 244 215 / 0.1);
}

.hover\\:border-moss-100\\/100:hover{
  border-color: rgb(230 244 215 / 1);
}

.hover\\:border-moss-100\\/15:hover{
  border-color: rgb(230 244 215 / 0.15);
}

.hover\\:border-moss-100\\/20:hover{
  border-color: rgb(230 244 215 / 0.2);
}

.hover\\:border-moss-100\\/25:hover{
  border-color: rgb(230 244 215 / 0.25);
}

.hover\\:border-moss-100\\/30:hover{
  border-color: rgb(230 244 215 / 0.3);
}

.hover\\:border-moss-100\\/35:hover{
  border-color: rgb(230 244 215 / 0.35);
}

.hover\\:border-moss-100\\/40:hover{
  border-color: rgb(230 244 215 / 0.4);
}

.hover\\:border-moss-100\\/45:hover{
  border-color: rgb(230 244 215 / 0.45);
}

.hover\\:border-moss-100\\/5:hover{
  border-color: rgb(230 244 215 / 0.05);
}

.hover\\:border-moss-100\\/50:hover{
  border-color: rgb(230 244 215 / 0.5);
}

.hover\\:border-moss-100\\/55:hover{
  border-color: rgb(230 244 215 / 0.55);
}

.hover\\:border-moss-100\\/60:hover{
  border-color: rgb(230 244 215 / 0.6);
}

.hover\\:border-moss-100\\/65:hover{
  border-color: rgb(230 244 215 / 0.65);
}

.hover\\:border-moss-100\\/70:hover{
  border-color: rgb(230 244 215 / 0.7);
}

.hover\\:border-moss-100\\/75:hover{
  border-color: rgb(230 244 215 / 0.75);
}

.hover\\:border-moss-100\\/80:hover{
  border-color: rgb(230 244 215 / 0.8);
}

.hover\\:border-moss-100\\/85:hover{
  border-color: rgb(230 244 215 / 0.85);
}

.hover\\:border-moss-100\\/90:hover{
  border-color: rgb(230 244 215 / 0.9);
}

.hover\\:border-moss-100\\/95:hover{
  border-color: rgb(230 244 215 / 0.95);
}

.hover\\:border-moss-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(206 234 176 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-200\\/0:hover{
  border-color: rgb(206 234 176 / 0);
}

.hover\\:border-moss-200\\/10:hover{
  border-color: rgb(206 234 176 / 0.1);
}

.hover\\:border-moss-200\\/100:hover{
  border-color: rgb(206 234 176 / 1);
}

.hover\\:border-moss-200\\/15:hover{
  border-color: rgb(206 234 176 / 0.15);
}

.hover\\:border-moss-200\\/20:hover{
  border-color: rgb(206 234 176 / 0.2);
}

.hover\\:border-moss-200\\/25:hover{
  border-color: rgb(206 234 176 / 0.25);
}

.hover\\:border-moss-200\\/30:hover{
  border-color: rgb(206 234 176 / 0.3);
}

.hover\\:border-moss-200\\/35:hover{
  border-color: rgb(206 234 176 / 0.35);
}

.hover\\:border-moss-200\\/40:hover{
  border-color: rgb(206 234 176 / 0.4);
}

.hover\\:border-moss-200\\/45:hover{
  border-color: rgb(206 234 176 / 0.45);
}

.hover\\:border-moss-200\\/5:hover{
  border-color: rgb(206 234 176 / 0.05);
}

.hover\\:border-moss-200\\/50:hover{
  border-color: rgb(206 234 176 / 0.5);
}

.hover\\:border-moss-200\\/55:hover{
  border-color: rgb(206 234 176 / 0.55);
}

.hover\\:border-moss-200\\/60:hover{
  border-color: rgb(206 234 176 / 0.6);
}

.hover\\:border-moss-200\\/65:hover{
  border-color: rgb(206 234 176 / 0.65);
}

.hover\\:border-moss-200\\/70:hover{
  border-color: rgb(206 234 176 / 0.7);
}

.hover\\:border-moss-200\\/75:hover{
  border-color: rgb(206 234 176 / 0.75);
}

.hover\\:border-moss-200\\/80:hover{
  border-color: rgb(206 234 176 / 0.8);
}

.hover\\:border-moss-200\\/85:hover{
  border-color: rgb(206 234 176 / 0.85);
}

.hover\\:border-moss-200\\/90:hover{
  border-color: rgb(206 234 176 / 0.9);
}

.hover\\:border-moss-200\\/95:hover{
  border-color: rgb(206 234 176 / 0.95);
}

.hover\\:border-moss-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(250 253 247 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-25\\/0:hover{
  border-color: rgb(250 253 247 / 0);
}

.hover\\:border-moss-25\\/10:hover{
  border-color: rgb(250 253 247 / 0.1);
}

.hover\\:border-moss-25\\/100:hover{
  border-color: rgb(250 253 247 / 1);
}

.hover\\:border-moss-25\\/15:hover{
  border-color: rgb(250 253 247 / 0.15);
}

.hover\\:border-moss-25\\/20:hover{
  border-color: rgb(250 253 247 / 0.2);
}

.hover\\:border-moss-25\\/25:hover{
  border-color: rgb(250 253 247 / 0.25);
}

.hover\\:border-moss-25\\/30:hover{
  border-color: rgb(250 253 247 / 0.3);
}

.hover\\:border-moss-25\\/35:hover{
  border-color: rgb(250 253 247 / 0.35);
}

.hover\\:border-moss-25\\/40:hover{
  border-color: rgb(250 253 247 / 0.4);
}

.hover\\:border-moss-25\\/45:hover{
  border-color: rgb(250 253 247 / 0.45);
}

.hover\\:border-moss-25\\/5:hover{
  border-color: rgb(250 253 247 / 0.05);
}

.hover\\:border-moss-25\\/50:hover{
  border-color: rgb(250 253 247 / 0.5);
}

.hover\\:border-moss-25\\/55:hover{
  border-color: rgb(250 253 247 / 0.55);
}

.hover\\:border-moss-25\\/60:hover{
  border-color: rgb(250 253 247 / 0.6);
}

.hover\\:border-moss-25\\/65:hover{
  border-color: rgb(250 253 247 / 0.65);
}

.hover\\:border-moss-25\\/70:hover{
  border-color: rgb(250 253 247 / 0.7);
}

.hover\\:border-moss-25\\/75:hover{
  border-color: rgb(250 253 247 / 0.75);
}

.hover\\:border-moss-25\\/80:hover{
  border-color: rgb(250 253 247 / 0.8);
}

.hover\\:border-moss-25\\/85:hover{
  border-color: rgb(250 253 247 / 0.85);
}

.hover\\:border-moss-25\\/90:hover{
  border-color: rgb(250 253 247 / 0.9);
}

.hover\\:border-moss-25\\/95:hover{
  border-color: rgb(250 253 247 / 0.95);
}

.hover\\:border-moss-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(172 220 121 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(134 203 60 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-400\\/0:hover{
  border-color: rgb(134 203 60 / 0);
}

.hover\\:border-moss-400\\/10:hover{
  border-color: rgb(134 203 60 / 0.1);
}

.hover\\:border-moss-400\\/100:hover{
  border-color: rgb(134 203 60 / 1);
}

.hover\\:border-moss-400\\/15:hover{
  border-color: rgb(134 203 60 / 0.15);
}

.hover\\:border-moss-400\\/20:hover{
  border-color: rgb(134 203 60 / 0.2);
}

.hover\\:border-moss-400\\/25:hover{
  border-color: rgb(134 203 60 / 0.25);
}

.hover\\:border-moss-400\\/30:hover{
  border-color: rgb(134 203 60 / 0.3);
}

.hover\\:border-moss-400\\/35:hover{
  border-color: rgb(134 203 60 / 0.35);
}

.hover\\:border-moss-400\\/40:hover{
  border-color: rgb(134 203 60 / 0.4);
}

.hover\\:border-moss-400\\/45:hover{
  border-color: rgb(134 203 60 / 0.45);
}

.hover\\:border-moss-400\\/5:hover{
  border-color: rgb(134 203 60 / 0.05);
}

.hover\\:border-moss-400\\/50:hover{
  border-color: rgb(134 203 60 / 0.5);
}

.hover\\:border-moss-400\\/55:hover{
  border-color: rgb(134 203 60 / 0.55);
}

.hover\\:border-moss-400\\/60:hover{
  border-color: rgb(134 203 60 / 0.6);
}

.hover\\:border-moss-400\\/65:hover{
  border-color: rgb(134 203 60 / 0.65);
}

.hover\\:border-moss-400\\/70:hover{
  border-color: rgb(134 203 60 / 0.7);
}

.hover\\:border-moss-400\\/75:hover{
  border-color: rgb(134 203 60 / 0.75);
}

.hover\\:border-moss-400\\/80:hover{
  border-color: rgb(134 203 60 / 0.8);
}

.hover\\:border-moss-400\\/85:hover{
  border-color: rgb(134 203 60 / 0.85);
}

.hover\\:border-moss-400\\/90:hover{
  border-color: rgb(134 203 60 / 0.9);
}

.hover\\:border-moss-400\\/95:hover{
  border-color: rgb(134 203 60 / 0.95);
}

.hover\\:border-moss-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(245 251 238 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-50\\/0:hover{
  border-color: rgb(245 251 238 / 0);
}

.hover\\:border-moss-50\\/10:hover{
  border-color: rgb(245 251 238 / 0.1);
}

.hover\\:border-moss-50\\/100:hover{
  border-color: rgb(245 251 238 / 1);
}

.hover\\:border-moss-50\\/15:hover{
  border-color: rgb(245 251 238 / 0.15);
}

.hover\\:border-moss-50\\/20:hover{
  border-color: rgb(245 251 238 / 0.2);
}

.hover\\:border-moss-50\\/25:hover{
  border-color: rgb(245 251 238 / 0.25);
}

.hover\\:border-moss-50\\/30:hover{
  border-color: rgb(245 251 238 / 0.3);
}

.hover\\:border-moss-50\\/35:hover{
  border-color: rgb(245 251 238 / 0.35);
}

.hover\\:border-moss-50\\/40:hover{
  border-color: rgb(245 251 238 / 0.4);
}

.hover\\:border-moss-50\\/45:hover{
  border-color: rgb(245 251 238 / 0.45);
}

.hover\\:border-moss-50\\/5:hover{
  border-color: rgb(245 251 238 / 0.05);
}

.hover\\:border-moss-50\\/50:hover{
  border-color: rgb(245 251 238 / 0.5);
}

.hover\\:border-moss-50\\/55:hover{
  border-color: rgb(245 251 238 / 0.55);
}

.hover\\:border-moss-50\\/60:hover{
  border-color: rgb(245 251 238 / 0.6);
}

.hover\\:border-moss-50\\/65:hover{
  border-color: rgb(245 251 238 / 0.65);
}

.hover\\:border-moss-50\\/70:hover{
  border-color: rgb(245 251 238 / 0.7);
}

.hover\\:border-moss-50\\/75:hover{
  border-color: rgb(245 251 238 / 0.75);
}

.hover\\:border-moss-50\\/80:hover{
  border-color: rgb(245 251 238 / 0.8);
}

.hover\\:border-moss-50\\/85:hover{
  border-color: rgb(245 251 238 / 0.85);
}

.hover\\:border-moss-50\\/90:hover{
  border-color: rgb(245 251 238 / 0.9);
}

.hover\\:border-moss-50\\/95:hover{
  border-color: rgb(245 251 238 / 0.95);
}

.hover\\:border-moss-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(102 159 42 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-500\\/0:hover{
  border-color: rgb(102 159 42 / 0);
}

.hover\\:border-moss-500\\/10:hover{
  border-color: rgb(102 159 42 / 0.1);
}

.hover\\:border-moss-500\\/100:hover{
  border-color: rgb(102 159 42 / 1);
}

.hover\\:border-moss-500\\/15:hover{
  border-color: rgb(102 159 42 / 0.15);
}

.hover\\:border-moss-500\\/20:hover{
  border-color: rgb(102 159 42 / 0.2);
}

.hover\\:border-moss-500\\/25:hover{
  border-color: rgb(102 159 42 / 0.25);
}

.hover\\:border-moss-500\\/30:hover{
  border-color: rgb(102 159 42 / 0.3);
}

.hover\\:border-moss-500\\/35:hover{
  border-color: rgb(102 159 42 / 0.35);
}

.hover\\:border-moss-500\\/40:hover{
  border-color: rgb(102 159 42 / 0.4);
}

.hover\\:border-moss-500\\/45:hover{
  border-color: rgb(102 159 42 / 0.45);
}

.hover\\:border-moss-500\\/5:hover{
  border-color: rgb(102 159 42 / 0.05);
}

.hover\\:border-moss-500\\/50:hover{
  border-color: rgb(102 159 42 / 0.5);
}

.hover\\:border-moss-500\\/55:hover{
  border-color: rgb(102 159 42 / 0.55);
}

.hover\\:border-moss-500\\/60:hover{
  border-color: rgb(102 159 42 / 0.6);
}

.hover\\:border-moss-500\\/65:hover{
  border-color: rgb(102 159 42 / 0.65);
}

.hover\\:border-moss-500\\/70:hover{
  border-color: rgb(102 159 42 / 0.7);
}

.hover\\:border-moss-500\\/75:hover{
  border-color: rgb(102 159 42 / 0.75);
}

.hover\\:border-moss-500\\/80:hover{
  border-color: rgb(102 159 42 / 0.8);
}

.hover\\:border-moss-500\\/85:hover{
  border-color: rgb(102 159 42 / 0.85);
}

.hover\\:border-moss-500\\/90:hover{
  border-color: rgb(102 159 42 / 0.9);
}

.hover\\:border-moss-500\\/95:hover{
  border-color: rgb(102 159 42 / 0.95);
}

.hover\\:border-moss-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(79 122 33 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-600\\/0:hover{
  border-color: rgb(79 122 33 / 0);
}

.hover\\:border-moss-600\\/10:hover{
  border-color: rgb(79 122 33 / 0.1);
}

.hover\\:border-moss-600\\/100:hover{
  border-color: rgb(79 122 33 / 1);
}

.hover\\:border-moss-600\\/15:hover{
  border-color: rgb(79 122 33 / 0.15);
}

.hover\\:border-moss-600\\/20:hover{
  border-color: rgb(79 122 33 / 0.2);
}

.hover\\:border-moss-600\\/25:hover{
  border-color: rgb(79 122 33 / 0.25);
}

.hover\\:border-moss-600\\/30:hover{
  border-color: rgb(79 122 33 / 0.3);
}

.hover\\:border-moss-600\\/35:hover{
  border-color: rgb(79 122 33 / 0.35);
}

.hover\\:border-moss-600\\/40:hover{
  border-color: rgb(79 122 33 / 0.4);
}

.hover\\:border-moss-600\\/45:hover{
  border-color: rgb(79 122 33 / 0.45);
}

.hover\\:border-moss-600\\/5:hover{
  border-color: rgb(79 122 33 / 0.05);
}

.hover\\:border-moss-600\\/50:hover{
  border-color: rgb(79 122 33 / 0.5);
}

.hover\\:border-moss-600\\/55:hover{
  border-color: rgb(79 122 33 / 0.55);
}

.hover\\:border-moss-600\\/60:hover{
  border-color: rgb(79 122 33 / 0.6);
}

.hover\\:border-moss-600\\/65:hover{
  border-color: rgb(79 122 33 / 0.65);
}

.hover\\:border-moss-600\\/70:hover{
  border-color: rgb(79 122 33 / 0.7);
}

.hover\\:border-moss-600\\/75:hover{
  border-color: rgb(79 122 33 / 0.75);
}

.hover\\:border-moss-600\\/80:hover{
  border-color: rgb(79 122 33 / 0.8);
}

.hover\\:border-moss-600\\/85:hover{
  border-color: rgb(79 122 33 / 0.85);
}

.hover\\:border-moss-600\\/90:hover{
  border-color: rgb(79 122 33 / 0.9);
}

.hover\\:border-moss-600\\/95:hover{
  border-color: rgb(79 122 33 / 0.95);
}

.hover\\:border-moss-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(63 98 26 / var(--tw-border-opacity, 1));
}

.hover\\:border-moss-700\\/0:hover{
  border-color: rgb(63 98 26 / 0);
}

.hover\\:border-moss-700\\/10:hover{
  border-color: rgb(63 98 26 / 0.1);
}

.hover\\:border-moss-700\\/100:hover{
  border-color: rgb(63 98 26 / 1);
}

.hover\\:border-moss-700\\/15:hover{
  border-color: rgb(63 98 26 / 0.15);
}

.hover\\:border-moss-700\\/20:hover{
  border-color: rgb(63 98 26 / 0.2);
}

.hover\\:border-moss-700\\/25:hover{
  border-color: rgb(63 98 26 / 0.25);
}

.hover\\:border-moss-700\\/30:hover{
  border-color: rgb(63 98 26 / 0.3);
}

.hover\\:border-moss-700\\/35:hover{
  border-color: rgb(63 98 26 / 0.35);
}

.hover\\:border-moss-700\\/40:hover{
  border-color: rgb(63 98 26 / 0.4);
}

.hover\\:border-moss-700\\/45:hover{
  border-color: rgb(63 98 26 / 0.45);
}

.hover\\:border-moss-700\\/5:hover{
  border-color: rgb(63 98 26 / 0.05);
}

.hover\\:border-moss-700\\/50:hover{
  border-color: rgb(63 98 26 / 0.5);
}

.hover\\:border-moss-700\\/55:hover{
  border-color: rgb(63 98 26 / 0.55);
}

.hover\\:border-moss-700\\/60:hover{
  border-color: rgb(63 98 26 / 0.6);
}

.hover\\:border-moss-700\\/65:hover{
  border-color: rgb(63 98 26 / 0.65);
}

.hover\\:border-moss-700\\/70:hover{
  border-color: rgb(63 98 26 / 0.7);
}

.hover\\:border-moss-700\\/75:hover{
  border-color: rgb(63 98 26 / 0.75);
}

.hover\\:border-moss-700\\/80:hover{
  border-color: rgb(63 98 26 / 0.8);
}

.hover\\:border-moss-700\\/85:hover{
  border-color: rgb(63 98 26 / 0.85);
}

.hover\\:border-moss-700\\/90:hover{
  border-color: rgb(63 98 26 / 0.9);
}

.hover\\:border-moss-700\\/95:hover{
  border-color: rgb(63 98 26 / 0.95);
}

.hover\\:border-neutral-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-100\\/0:hover{
  border-color: rgb(245 245 245 / 0);
}

.hover\\:border-neutral-100\\/10:hover{
  border-color: rgb(245 245 245 / 0.1);
}

.hover\\:border-neutral-100\\/100:hover{
  border-color: rgb(245 245 245 / 1);
}

.hover\\:border-neutral-100\\/15:hover{
  border-color: rgb(245 245 245 / 0.15);
}

.hover\\:border-neutral-100\\/20:hover{
  border-color: rgb(245 245 245 / 0.2);
}

.hover\\:border-neutral-100\\/25:hover{
  border-color: rgb(245 245 245 / 0.25);
}

.hover\\:border-neutral-100\\/30:hover{
  border-color: rgb(245 245 245 / 0.3);
}

.hover\\:border-neutral-100\\/35:hover{
  border-color: rgb(245 245 245 / 0.35);
}

.hover\\:border-neutral-100\\/40:hover{
  border-color: rgb(245 245 245 / 0.4);
}

.hover\\:border-neutral-100\\/45:hover{
  border-color: rgb(245 245 245 / 0.45);
}

.hover\\:border-neutral-100\\/5:hover{
  border-color: rgb(245 245 245 / 0.05);
}

.hover\\:border-neutral-100\\/50:hover{
  border-color: rgb(245 245 245 / 0.5);
}

.hover\\:border-neutral-100\\/55:hover{
  border-color: rgb(245 245 245 / 0.55);
}

.hover\\:border-neutral-100\\/60:hover{
  border-color: rgb(245 245 245 / 0.6);
}

.hover\\:border-neutral-100\\/65:hover{
  border-color: rgb(245 245 245 / 0.65);
}

.hover\\:border-neutral-100\\/70:hover{
  border-color: rgb(245 245 245 / 0.7);
}

.hover\\:border-neutral-100\\/75:hover{
  border-color: rgb(245 245 245 / 0.75);
}

.hover\\:border-neutral-100\\/80:hover{
  border-color: rgb(245 245 245 / 0.8);
}

.hover\\:border-neutral-100\\/85:hover{
  border-color: rgb(245 245 245 / 0.85);
}

.hover\\:border-neutral-100\\/90:hover{
  border-color: rgb(245 245 245 / 0.9);
}

.hover\\:border-neutral-100\\/95:hover{
  border-color: rgb(245 245 245 / 0.95);
}

.hover\\:border-neutral-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-200\\/0:hover{
  border-color: rgb(233 234 235 / 0);
}

.hover\\:border-neutral-200\\/10:hover{
  border-color: rgb(233 234 235 / 0.1);
}

.hover\\:border-neutral-200\\/100:hover{
  border-color: rgb(233 234 235 / 1);
}

.hover\\:border-neutral-200\\/15:hover{
  border-color: rgb(233 234 235 / 0.15);
}

.hover\\:border-neutral-200\\/20:hover{
  border-color: rgb(233 234 235 / 0.2);
}

.hover\\:border-neutral-200\\/25:hover{
  border-color: rgb(233 234 235 / 0.25);
}

.hover\\:border-neutral-200\\/30:hover{
  border-color: rgb(233 234 235 / 0.3);
}

.hover\\:border-neutral-200\\/35:hover{
  border-color: rgb(233 234 235 / 0.35);
}

.hover\\:border-neutral-200\\/40:hover{
  border-color: rgb(233 234 235 / 0.4);
}

.hover\\:border-neutral-200\\/45:hover{
  border-color: rgb(233 234 235 / 0.45);
}

.hover\\:border-neutral-200\\/5:hover{
  border-color: rgb(233 234 235 / 0.05);
}

.hover\\:border-neutral-200\\/50:hover{
  border-color: rgb(233 234 235 / 0.5);
}

.hover\\:border-neutral-200\\/55:hover{
  border-color: rgb(233 234 235 / 0.55);
}

.hover\\:border-neutral-200\\/60:hover{
  border-color: rgb(233 234 235 / 0.6);
}

.hover\\:border-neutral-200\\/65:hover{
  border-color: rgb(233 234 235 / 0.65);
}

.hover\\:border-neutral-200\\/70:hover{
  border-color: rgb(233 234 235 / 0.7);
}

.hover\\:border-neutral-200\\/75:hover{
  border-color: rgb(233 234 235 / 0.75);
}

.hover\\:border-neutral-200\\/80:hover{
  border-color: rgb(233 234 235 / 0.8);
}

.hover\\:border-neutral-200\\/85:hover{
  border-color: rgb(233 234 235 / 0.85);
}

.hover\\:border-neutral-200\\/90:hover{
  border-color: rgb(233 234 235 / 0.9);
}

.hover\\:border-neutral-200\\/95:hover{
  border-color: rgb(233 234 235 / 0.95);
}

.hover\\:border-neutral-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-25\\/0:hover{
  border-color: rgb(253 253 253 / 0);
}

.hover\\:border-neutral-25\\/10:hover{
  border-color: rgb(253 253 253 / 0.1);
}

.hover\\:border-neutral-25\\/100:hover{
  border-color: rgb(253 253 253 / 1);
}

.hover\\:border-neutral-25\\/15:hover{
  border-color: rgb(253 253 253 / 0.15);
}

.hover\\:border-neutral-25\\/20:hover{
  border-color: rgb(253 253 253 / 0.2);
}

.hover\\:border-neutral-25\\/25:hover{
  border-color: rgb(253 253 253 / 0.25);
}

.hover\\:border-neutral-25\\/30:hover{
  border-color: rgb(253 253 253 / 0.3);
}

.hover\\:border-neutral-25\\/35:hover{
  border-color: rgb(253 253 253 / 0.35);
}

.hover\\:border-neutral-25\\/40:hover{
  border-color: rgb(253 253 253 / 0.4);
}

.hover\\:border-neutral-25\\/45:hover{
  border-color: rgb(253 253 253 / 0.45);
}

.hover\\:border-neutral-25\\/5:hover{
  border-color: rgb(253 253 253 / 0.05);
}

.hover\\:border-neutral-25\\/50:hover{
  border-color: rgb(253 253 253 / 0.5);
}

.hover\\:border-neutral-25\\/55:hover{
  border-color: rgb(253 253 253 / 0.55);
}

.hover\\:border-neutral-25\\/60:hover{
  border-color: rgb(253 253 253 / 0.6);
}

.hover\\:border-neutral-25\\/65:hover{
  border-color: rgb(253 253 253 / 0.65);
}

.hover\\:border-neutral-25\\/70:hover{
  border-color: rgb(253 253 253 / 0.7);
}

.hover\\:border-neutral-25\\/75:hover{
  border-color: rgb(253 253 253 / 0.75);
}

.hover\\:border-neutral-25\\/80:hover{
  border-color: rgb(253 253 253 / 0.8);
}

.hover\\:border-neutral-25\\/85:hover{
  border-color: rgb(253 253 253 / 0.85);
}

.hover\\:border-neutral-25\\/90:hover{
  border-color: rgb(253 253 253 / 0.9);
}

.hover\\:border-neutral-25\\/95:hover{
  border-color: rgb(253 253 253 / 0.95);
}

.hover\\:border-neutral-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(213 215 218 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-400\\/0:hover{
  border-color: rgb(164 167 174 / 0);
}

.hover\\:border-neutral-400\\/10:hover{
  border-color: rgb(164 167 174 / 0.1);
}

.hover\\:border-neutral-400\\/100:hover{
  border-color: rgb(164 167 174 / 1);
}

.hover\\:border-neutral-400\\/15:hover{
  border-color: rgb(164 167 174 / 0.15);
}

.hover\\:border-neutral-400\\/20:hover{
  border-color: rgb(164 167 174 / 0.2);
}

.hover\\:border-neutral-400\\/25:hover{
  border-color: rgb(164 167 174 / 0.25);
}

.hover\\:border-neutral-400\\/30:hover{
  border-color: rgb(164 167 174 / 0.3);
}

.hover\\:border-neutral-400\\/35:hover{
  border-color: rgb(164 167 174 / 0.35);
}

.hover\\:border-neutral-400\\/40:hover{
  border-color: rgb(164 167 174 / 0.4);
}

.hover\\:border-neutral-400\\/45:hover{
  border-color: rgb(164 167 174 / 0.45);
}

.hover\\:border-neutral-400\\/5:hover{
  border-color: rgb(164 167 174 / 0.05);
}

.hover\\:border-neutral-400\\/50:hover{
  border-color: rgb(164 167 174 / 0.5);
}

.hover\\:border-neutral-400\\/55:hover{
  border-color: rgb(164 167 174 / 0.55);
}

.hover\\:border-neutral-400\\/60:hover{
  border-color: rgb(164 167 174 / 0.6);
}

.hover\\:border-neutral-400\\/65:hover{
  border-color: rgb(164 167 174 / 0.65);
}

.hover\\:border-neutral-400\\/70:hover{
  border-color: rgb(164 167 174 / 0.7);
}

.hover\\:border-neutral-400\\/75:hover{
  border-color: rgb(164 167 174 / 0.75);
}

.hover\\:border-neutral-400\\/80:hover{
  border-color: rgb(164 167 174 / 0.8);
}

.hover\\:border-neutral-400\\/85:hover{
  border-color: rgb(164 167 174 / 0.85);
}

.hover\\:border-neutral-400\\/90:hover{
  border-color: rgb(164 167 174 / 0.9);
}

.hover\\:border-neutral-400\\/95:hover{
  border-color: rgb(164 167 174 / 0.95);
}

.hover\\:border-neutral-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-50\\/0:hover{
  border-color: rgb(249 250 250 / 0);
}

.hover\\:border-neutral-50\\/10:hover{
  border-color: rgb(249 250 250 / 0.1);
}

.hover\\:border-neutral-50\\/100:hover{
  border-color: rgb(249 250 250 / 1);
}

.hover\\:border-neutral-50\\/15:hover{
  border-color: rgb(249 250 250 / 0.15);
}

.hover\\:border-neutral-50\\/20:hover{
  border-color: rgb(249 250 250 / 0.2);
}

.hover\\:border-neutral-50\\/25:hover{
  border-color: rgb(249 250 250 / 0.25);
}

.hover\\:border-neutral-50\\/30:hover{
  border-color: rgb(249 250 250 / 0.3);
}

.hover\\:border-neutral-50\\/35:hover{
  border-color: rgb(249 250 250 / 0.35);
}

.hover\\:border-neutral-50\\/40:hover{
  border-color: rgb(249 250 250 / 0.4);
}

.hover\\:border-neutral-50\\/45:hover{
  border-color: rgb(249 250 250 / 0.45);
}

.hover\\:border-neutral-50\\/5:hover{
  border-color: rgb(249 250 250 / 0.05);
}

.hover\\:border-neutral-50\\/50:hover{
  border-color: rgb(249 250 250 / 0.5);
}

.hover\\:border-neutral-50\\/55:hover{
  border-color: rgb(249 250 250 / 0.55);
}

.hover\\:border-neutral-50\\/60:hover{
  border-color: rgb(249 250 250 / 0.6);
}

.hover\\:border-neutral-50\\/65:hover{
  border-color: rgb(249 250 250 / 0.65);
}

.hover\\:border-neutral-50\\/70:hover{
  border-color: rgb(249 250 250 / 0.7);
}

.hover\\:border-neutral-50\\/75:hover{
  border-color: rgb(249 250 250 / 0.75);
}

.hover\\:border-neutral-50\\/80:hover{
  border-color: rgb(249 250 250 / 0.8);
}

.hover\\:border-neutral-50\\/85:hover{
  border-color: rgb(249 250 250 / 0.85);
}

.hover\\:border-neutral-50\\/90:hover{
  border-color: rgb(249 250 250 / 0.9);
}

.hover\\:border-neutral-50\\/95:hover{
  border-color: rgb(249 250 250 / 0.95);
}

.hover\\:border-neutral-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-500\\/0:hover{
  border-color: rgb(113 118 128 / 0);
}

.hover\\:border-neutral-500\\/10:hover{
  border-color: rgb(113 118 128 / 0.1);
}

.hover\\:border-neutral-500\\/100:hover{
  border-color: rgb(113 118 128 / 1);
}

.hover\\:border-neutral-500\\/15:hover{
  border-color: rgb(113 118 128 / 0.15);
}

.hover\\:border-neutral-500\\/20:hover{
  border-color: rgb(113 118 128 / 0.2);
}

.hover\\:border-neutral-500\\/25:hover{
  border-color: rgb(113 118 128 / 0.25);
}

.hover\\:border-neutral-500\\/30:hover{
  border-color: rgb(113 118 128 / 0.3);
}

.hover\\:border-neutral-500\\/35:hover{
  border-color: rgb(113 118 128 / 0.35);
}

.hover\\:border-neutral-500\\/40:hover{
  border-color: rgb(113 118 128 / 0.4);
}

.hover\\:border-neutral-500\\/45:hover{
  border-color: rgb(113 118 128 / 0.45);
}

.hover\\:border-neutral-500\\/5:hover{
  border-color: rgb(113 118 128 / 0.05);
}

.hover\\:border-neutral-500\\/50:hover{
  border-color: rgb(113 118 128 / 0.5);
}

.hover\\:border-neutral-500\\/55:hover{
  border-color: rgb(113 118 128 / 0.55);
}

.hover\\:border-neutral-500\\/60:hover{
  border-color: rgb(113 118 128 / 0.6);
}

.hover\\:border-neutral-500\\/65:hover{
  border-color: rgb(113 118 128 / 0.65);
}

.hover\\:border-neutral-500\\/70:hover{
  border-color: rgb(113 118 128 / 0.7);
}

.hover\\:border-neutral-500\\/75:hover{
  border-color: rgb(113 118 128 / 0.75);
}

.hover\\:border-neutral-500\\/80:hover{
  border-color: rgb(113 118 128 / 0.8);
}

.hover\\:border-neutral-500\\/85:hover{
  border-color: rgb(113 118 128 / 0.85);
}

.hover\\:border-neutral-500\\/90:hover{
  border-color: rgb(113 118 128 / 0.9);
}

.hover\\:border-neutral-500\\/95:hover{
  border-color: rgb(113 118 128 / 0.95);
}

.hover\\:border-neutral-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-600\\/0:hover{
  border-color: rgb(83 88 98 / 0);
}

.hover\\:border-neutral-600\\/10:hover{
  border-color: rgb(83 88 98 / 0.1);
}

.hover\\:border-neutral-600\\/100:hover{
  border-color: rgb(83 88 98 / 1);
}

.hover\\:border-neutral-600\\/15:hover{
  border-color: rgb(83 88 98 / 0.15);
}

.hover\\:border-neutral-600\\/20:hover{
  border-color: rgb(83 88 98 / 0.2);
}

.hover\\:border-neutral-600\\/25:hover{
  border-color: rgb(83 88 98 / 0.25);
}

.hover\\:border-neutral-600\\/30:hover{
  border-color: rgb(83 88 98 / 0.3);
}

.hover\\:border-neutral-600\\/35:hover{
  border-color: rgb(83 88 98 / 0.35);
}

.hover\\:border-neutral-600\\/40:hover{
  border-color: rgb(83 88 98 / 0.4);
}

.hover\\:border-neutral-600\\/45:hover{
  border-color: rgb(83 88 98 / 0.45);
}

.hover\\:border-neutral-600\\/5:hover{
  border-color: rgb(83 88 98 / 0.05);
}

.hover\\:border-neutral-600\\/50:hover{
  border-color: rgb(83 88 98 / 0.5);
}

.hover\\:border-neutral-600\\/55:hover{
  border-color: rgb(83 88 98 / 0.55);
}

.hover\\:border-neutral-600\\/60:hover{
  border-color: rgb(83 88 98 / 0.6);
}

.hover\\:border-neutral-600\\/65:hover{
  border-color: rgb(83 88 98 / 0.65);
}

.hover\\:border-neutral-600\\/70:hover{
  border-color: rgb(83 88 98 / 0.7);
}

.hover\\:border-neutral-600\\/75:hover{
  border-color: rgb(83 88 98 / 0.75);
}

.hover\\:border-neutral-600\\/80:hover{
  border-color: rgb(83 88 98 / 0.8);
}

.hover\\:border-neutral-600\\/85:hover{
  border-color: rgb(83 88 98 / 0.85);
}

.hover\\:border-neutral-600\\/90:hover{
  border-color: rgb(83 88 98 / 0.9);
}

.hover\\:border-neutral-600\\/95:hover{
  border-color: rgb(83 88 98 / 0.95);
}

.hover\\:border-neutral-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(65 70 81 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-700\\/0:hover{
  border-color: rgb(65 70 81 / 0);
}

.hover\\:border-neutral-700\\/10:hover{
  border-color: rgb(65 70 81 / 0.1);
}

.hover\\:border-neutral-700\\/100:hover{
  border-color: rgb(65 70 81 / 1);
}

.hover\\:border-neutral-700\\/15:hover{
  border-color: rgb(65 70 81 / 0.15);
}

.hover\\:border-neutral-700\\/20:hover{
  border-color: rgb(65 70 81 / 0.2);
}

.hover\\:border-neutral-700\\/25:hover{
  border-color: rgb(65 70 81 / 0.25);
}

.hover\\:border-neutral-700\\/30:hover{
  border-color: rgb(65 70 81 / 0.3);
}

.hover\\:border-neutral-700\\/35:hover{
  border-color: rgb(65 70 81 / 0.35);
}

.hover\\:border-neutral-700\\/40:hover{
  border-color: rgb(65 70 81 / 0.4);
}

.hover\\:border-neutral-700\\/45:hover{
  border-color: rgb(65 70 81 / 0.45);
}

.hover\\:border-neutral-700\\/5:hover{
  border-color: rgb(65 70 81 / 0.05);
}

.hover\\:border-neutral-700\\/50:hover{
  border-color: rgb(65 70 81 / 0.5);
}

.hover\\:border-neutral-700\\/55:hover{
  border-color: rgb(65 70 81 / 0.55);
}

.hover\\:border-neutral-700\\/60:hover{
  border-color: rgb(65 70 81 / 0.6);
}

.hover\\:border-neutral-700\\/65:hover{
  border-color: rgb(65 70 81 / 0.65);
}

.hover\\:border-neutral-700\\/70:hover{
  border-color: rgb(65 70 81 / 0.7);
}

.hover\\:border-neutral-700\\/75:hover{
  border-color: rgb(65 70 81 / 0.75);
}

.hover\\:border-neutral-700\\/80:hover{
  border-color: rgb(65 70 81 / 0.8);
}

.hover\\:border-neutral-700\\/85:hover{
  border-color: rgb(65 70 81 / 0.85);
}

.hover\\:border-neutral-700\\/90:hover{
  border-color: rgb(65 70 81 / 0.9);
}

.hover\\:border-neutral-700\\/95:hover{
  border-color: rgb(65 70 81 / 0.95);
}

.hover\\:border-neutral-75:hover{
  --tw-border-opacity: 1;
  border-color: rgb(246 246 246 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-75\\/0:hover{
  border-color: rgb(246 246 246 / 0);
}

.hover\\:border-neutral-75\\/10:hover{
  border-color: rgb(246 246 246 / 0.1);
}

.hover\\:border-neutral-75\\/100:hover{
  border-color: rgb(246 246 246 / 1);
}

.hover\\:border-neutral-75\\/15:hover{
  border-color: rgb(246 246 246 / 0.15);
}

.hover\\:border-neutral-75\\/20:hover{
  border-color: rgb(246 246 246 / 0.2);
}

.hover\\:border-neutral-75\\/25:hover{
  border-color: rgb(246 246 246 / 0.25);
}

.hover\\:border-neutral-75\\/30:hover{
  border-color: rgb(246 246 246 / 0.3);
}

.hover\\:border-neutral-75\\/35:hover{
  border-color: rgb(246 246 246 / 0.35);
}

.hover\\:border-neutral-75\\/40:hover{
  border-color: rgb(246 246 246 / 0.4);
}

.hover\\:border-neutral-75\\/45:hover{
  border-color: rgb(246 246 246 / 0.45);
}

.hover\\:border-neutral-75\\/5:hover{
  border-color: rgb(246 246 246 / 0.05);
}

.hover\\:border-neutral-75\\/50:hover{
  border-color: rgb(246 246 246 / 0.5);
}

.hover\\:border-neutral-75\\/55:hover{
  border-color: rgb(246 246 246 / 0.55);
}

.hover\\:border-neutral-75\\/60:hover{
  border-color: rgb(246 246 246 / 0.6);
}

.hover\\:border-neutral-75\\/65:hover{
  border-color: rgb(246 246 246 / 0.65);
}

.hover\\:border-neutral-75\\/70:hover{
  border-color: rgb(246 246 246 / 0.7);
}

.hover\\:border-neutral-75\\/75:hover{
  border-color: rgb(246 246 246 / 0.75);
}

.hover\\:border-neutral-75\\/80:hover{
  border-color: rgb(246 246 246 / 0.8);
}

.hover\\:border-neutral-75\\/85:hover{
  border-color: rgb(246 246 246 / 0.85);
}

.hover\\:border-neutral-75\\/90:hover{
  border-color: rgb(246 246 246 / 0.9);
}

.hover\\:border-neutral-75\\/95:hover{
  border-color: rgb(246 246 246 / 0.95);
}

.hover\\:border-orange-dark-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 156 102 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-100:hover{
  border-color: var(--color-primary-100, #E0F2FE);
}

.hover\\:border-primary-200:hover{
  border-color: var(--color-primary-200, #B9E6FE);
}

.hover\\:border-primary-25:hover{
  border-color: var(--color-primary-25, #F5FBFF);
}

.hover\\:border-primary-300:hover{
  border-color: var(--color-primary-300, #7CD4FD);
}

.hover\\:border-primary-400:hover{
  border-color: var(--color-primary-400, #36BFFA);
}

.hover\\:border-primary-50:hover{
  border-color: var(--color-primary-50, #F0F9FF);
}

.hover\\:border-primary-500:hover{
  border-color: var(--color-primary-500, #0BA5EC);
}

.hover\\:border-primary-600:hover{
  border-color: var(--color-primary-600, #0086C9);
}

.hover\\:border-primary-700:hover{
  border-color: var(--color-primary-700, #026AA2);
}

.hover\\:border-purple-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(235 233 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-100\\/0:hover{
  border-color: rgb(235 233 254 / 0);
}

.hover\\:border-purple-100\\/10:hover{
  border-color: rgb(235 233 254 / 0.1);
}

.hover\\:border-purple-100\\/100:hover{
  border-color: rgb(235 233 254 / 1);
}

.hover\\:border-purple-100\\/15:hover{
  border-color: rgb(235 233 254 / 0.15);
}

.hover\\:border-purple-100\\/20:hover{
  border-color: rgb(235 233 254 / 0.2);
}

.hover\\:border-purple-100\\/25:hover{
  border-color: rgb(235 233 254 / 0.25);
}

.hover\\:border-purple-100\\/30:hover{
  border-color: rgb(235 233 254 / 0.3);
}

.hover\\:border-purple-100\\/35:hover{
  border-color: rgb(235 233 254 / 0.35);
}

.hover\\:border-purple-100\\/40:hover{
  border-color: rgb(235 233 254 / 0.4);
}

.hover\\:border-purple-100\\/45:hover{
  border-color: rgb(235 233 254 / 0.45);
}

.hover\\:border-purple-100\\/5:hover{
  border-color: rgb(235 233 254 / 0.05);
}

.hover\\:border-purple-100\\/50:hover{
  border-color: rgb(235 233 254 / 0.5);
}

.hover\\:border-purple-100\\/55:hover{
  border-color: rgb(235 233 254 / 0.55);
}

.hover\\:border-purple-100\\/60:hover{
  border-color: rgb(235 233 254 / 0.6);
}

.hover\\:border-purple-100\\/65:hover{
  border-color: rgb(235 233 254 / 0.65);
}

.hover\\:border-purple-100\\/70:hover{
  border-color: rgb(235 233 254 / 0.7);
}

.hover\\:border-purple-100\\/75:hover{
  border-color: rgb(235 233 254 / 0.75);
}

.hover\\:border-purple-100\\/80:hover{
  border-color: rgb(235 233 254 / 0.8);
}

.hover\\:border-purple-100\\/85:hover{
  border-color: rgb(235 233 254 / 0.85);
}

.hover\\:border-purple-100\\/90:hover{
  border-color: rgb(235 233 254 / 0.9);
}

.hover\\:border-purple-100\\/95:hover{
  border-color: rgb(235 233 254 / 0.95);
}

.hover\\:border-purple-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(217 214 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-200\\/0:hover{
  border-color: rgb(217 214 254 / 0);
}

.hover\\:border-purple-200\\/10:hover{
  border-color: rgb(217 214 254 / 0.1);
}

.hover\\:border-purple-200\\/100:hover{
  border-color: rgb(217 214 254 / 1);
}

.hover\\:border-purple-200\\/15:hover{
  border-color: rgb(217 214 254 / 0.15);
}

.hover\\:border-purple-200\\/20:hover{
  border-color: rgb(217 214 254 / 0.2);
}

.hover\\:border-purple-200\\/25:hover{
  border-color: rgb(217 214 254 / 0.25);
}

.hover\\:border-purple-200\\/30:hover{
  border-color: rgb(217 214 254 / 0.3);
}

.hover\\:border-purple-200\\/35:hover{
  border-color: rgb(217 214 254 / 0.35);
}

.hover\\:border-purple-200\\/40:hover{
  border-color: rgb(217 214 254 / 0.4);
}

.hover\\:border-purple-200\\/45:hover{
  border-color: rgb(217 214 254 / 0.45);
}

.hover\\:border-purple-200\\/5:hover{
  border-color: rgb(217 214 254 / 0.05);
}

.hover\\:border-purple-200\\/50:hover{
  border-color: rgb(217 214 254 / 0.5);
}

.hover\\:border-purple-200\\/55:hover{
  border-color: rgb(217 214 254 / 0.55);
}

.hover\\:border-purple-200\\/60:hover{
  border-color: rgb(217 214 254 / 0.6);
}

.hover\\:border-purple-200\\/65:hover{
  border-color: rgb(217 214 254 / 0.65);
}

.hover\\:border-purple-200\\/70:hover{
  border-color: rgb(217 214 254 / 0.7);
}

.hover\\:border-purple-200\\/75:hover{
  border-color: rgb(217 214 254 / 0.75);
}

.hover\\:border-purple-200\\/80:hover{
  border-color: rgb(217 214 254 / 0.8);
}

.hover\\:border-purple-200\\/85:hover{
  border-color: rgb(217 214 254 / 0.85);
}

.hover\\:border-purple-200\\/90:hover{
  border-color: rgb(217 214 254 / 0.9);
}

.hover\\:border-purple-200\\/95:hover{
  border-color: rgb(217 214 254 / 0.95);
}

.hover\\:border-purple-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-25\\/0:hover{
  border-color: rgb(250 250 255 / 0);
}

.hover\\:border-purple-25\\/10:hover{
  border-color: rgb(250 250 255 / 0.1);
}

.hover\\:border-purple-25\\/100:hover{
  border-color: rgb(250 250 255 / 1);
}

.hover\\:border-purple-25\\/15:hover{
  border-color: rgb(250 250 255 / 0.15);
}

.hover\\:border-purple-25\\/20:hover{
  border-color: rgb(250 250 255 / 0.2);
}

.hover\\:border-purple-25\\/25:hover{
  border-color: rgb(250 250 255 / 0.25);
}

.hover\\:border-purple-25\\/30:hover{
  border-color: rgb(250 250 255 / 0.3);
}

.hover\\:border-purple-25\\/35:hover{
  border-color: rgb(250 250 255 / 0.35);
}

.hover\\:border-purple-25\\/40:hover{
  border-color: rgb(250 250 255 / 0.4);
}

.hover\\:border-purple-25\\/45:hover{
  border-color: rgb(250 250 255 / 0.45);
}

.hover\\:border-purple-25\\/5:hover{
  border-color: rgb(250 250 255 / 0.05);
}

.hover\\:border-purple-25\\/50:hover{
  border-color: rgb(250 250 255 / 0.5);
}

.hover\\:border-purple-25\\/55:hover{
  border-color: rgb(250 250 255 / 0.55);
}

.hover\\:border-purple-25\\/60:hover{
  border-color: rgb(250 250 255 / 0.6);
}

.hover\\:border-purple-25\\/65:hover{
  border-color: rgb(250 250 255 / 0.65);
}

.hover\\:border-purple-25\\/70:hover{
  border-color: rgb(250 250 255 / 0.7);
}

.hover\\:border-purple-25\\/75:hover{
  border-color: rgb(250 250 255 / 0.75);
}

.hover\\:border-purple-25\\/80:hover{
  border-color: rgb(250 250 255 / 0.8);
}

.hover\\:border-purple-25\\/85:hover{
  border-color: rgb(250 250 255 / 0.85);
}

.hover\\:border-purple-25\\/90:hover{
  border-color: rgb(250 250 255 / 0.9);
}

.hover\\:border-purple-25\\/95:hover{
  border-color: rgb(250 250 255 / 0.95);
}

.hover\\:border-purple-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(155 138 251 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-400\\/0:hover{
  border-color: rgb(155 138 251 / 0);
}

.hover\\:border-purple-400\\/10:hover{
  border-color: rgb(155 138 251 / 0.1);
}

.hover\\:border-purple-400\\/100:hover{
  border-color: rgb(155 138 251 / 1);
}

.hover\\:border-purple-400\\/15:hover{
  border-color: rgb(155 138 251 / 0.15);
}

.hover\\:border-purple-400\\/20:hover{
  border-color: rgb(155 138 251 / 0.2);
}

.hover\\:border-purple-400\\/25:hover{
  border-color: rgb(155 138 251 / 0.25);
}

.hover\\:border-purple-400\\/30:hover{
  border-color: rgb(155 138 251 / 0.3);
}

.hover\\:border-purple-400\\/35:hover{
  border-color: rgb(155 138 251 / 0.35);
}

.hover\\:border-purple-400\\/40:hover{
  border-color: rgb(155 138 251 / 0.4);
}

.hover\\:border-purple-400\\/45:hover{
  border-color: rgb(155 138 251 / 0.45);
}

.hover\\:border-purple-400\\/5:hover{
  border-color: rgb(155 138 251 / 0.05);
}

.hover\\:border-purple-400\\/50:hover{
  border-color: rgb(155 138 251 / 0.5);
}

.hover\\:border-purple-400\\/55:hover{
  border-color: rgb(155 138 251 / 0.55);
}

.hover\\:border-purple-400\\/60:hover{
  border-color: rgb(155 138 251 / 0.6);
}

.hover\\:border-purple-400\\/65:hover{
  border-color: rgb(155 138 251 / 0.65);
}

.hover\\:border-purple-400\\/70:hover{
  border-color: rgb(155 138 251 / 0.7);
}

.hover\\:border-purple-400\\/75:hover{
  border-color: rgb(155 138 251 / 0.75);
}

.hover\\:border-purple-400\\/80:hover{
  border-color: rgb(155 138 251 / 0.8);
}

.hover\\:border-purple-400\\/85:hover{
  border-color: rgb(155 138 251 / 0.85);
}

.hover\\:border-purple-400\\/90:hover{
  border-color: rgb(155 138 251 / 0.9);
}

.hover\\:border-purple-400\\/95:hover{
  border-color: rgb(155 138 251 / 0.95);
}

.hover\\:border-purple-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(244 243 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-50\\/0:hover{
  border-color: rgb(244 243 255 / 0);
}

.hover\\:border-purple-50\\/10:hover{
  border-color: rgb(244 243 255 / 0.1);
}

.hover\\:border-purple-50\\/100:hover{
  border-color: rgb(244 243 255 / 1);
}

.hover\\:border-purple-50\\/15:hover{
  border-color: rgb(244 243 255 / 0.15);
}

.hover\\:border-purple-50\\/20:hover{
  border-color: rgb(244 243 255 / 0.2);
}

.hover\\:border-purple-50\\/25:hover{
  border-color: rgb(244 243 255 / 0.25);
}

.hover\\:border-purple-50\\/30:hover{
  border-color: rgb(244 243 255 / 0.3);
}

.hover\\:border-purple-50\\/35:hover{
  border-color: rgb(244 243 255 / 0.35);
}

.hover\\:border-purple-50\\/40:hover{
  border-color: rgb(244 243 255 / 0.4);
}

.hover\\:border-purple-50\\/45:hover{
  border-color: rgb(244 243 255 / 0.45);
}

.hover\\:border-purple-50\\/5:hover{
  border-color: rgb(244 243 255 / 0.05);
}

.hover\\:border-purple-50\\/50:hover{
  border-color: rgb(244 243 255 / 0.5);
}

.hover\\:border-purple-50\\/55:hover{
  border-color: rgb(244 243 255 / 0.55);
}

.hover\\:border-purple-50\\/60:hover{
  border-color: rgb(244 243 255 / 0.6);
}

.hover\\:border-purple-50\\/65:hover{
  border-color: rgb(244 243 255 / 0.65);
}

.hover\\:border-purple-50\\/70:hover{
  border-color: rgb(244 243 255 / 0.7);
}

.hover\\:border-purple-50\\/75:hover{
  border-color: rgb(244 243 255 / 0.75);
}

.hover\\:border-purple-50\\/80:hover{
  border-color: rgb(244 243 255 / 0.8);
}

.hover\\:border-purple-50\\/85:hover{
  border-color: rgb(244 243 255 / 0.85);
}

.hover\\:border-purple-50\\/90:hover{
  border-color: rgb(244 243 255 / 0.9);
}

.hover\\:border-purple-50\\/95:hover{
  border-color: rgb(244 243 255 / 0.95);
}

.hover\\:border-purple-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(122 90 248 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-500\\/0:hover{
  border-color: rgb(122 90 248 / 0);
}

.hover\\:border-purple-500\\/10:hover{
  border-color: rgb(122 90 248 / 0.1);
}

.hover\\:border-purple-500\\/100:hover{
  border-color: rgb(122 90 248 / 1);
}

.hover\\:border-purple-500\\/15:hover{
  border-color: rgb(122 90 248 / 0.15);
}

.hover\\:border-purple-500\\/20:hover{
  border-color: rgb(122 90 248 / 0.2);
}

.hover\\:border-purple-500\\/25:hover{
  border-color: rgb(122 90 248 / 0.25);
}

.hover\\:border-purple-500\\/30:hover{
  border-color: rgb(122 90 248 / 0.3);
}

.hover\\:border-purple-500\\/35:hover{
  border-color: rgb(122 90 248 / 0.35);
}

.hover\\:border-purple-500\\/40:hover{
  border-color: rgb(122 90 248 / 0.4);
}

.hover\\:border-purple-500\\/45:hover{
  border-color: rgb(122 90 248 / 0.45);
}

.hover\\:border-purple-500\\/5:hover{
  border-color: rgb(122 90 248 / 0.05);
}

.hover\\:border-purple-500\\/50:hover{
  border-color: rgb(122 90 248 / 0.5);
}

.hover\\:border-purple-500\\/55:hover{
  border-color: rgb(122 90 248 / 0.55);
}

.hover\\:border-purple-500\\/60:hover{
  border-color: rgb(122 90 248 / 0.6);
}

.hover\\:border-purple-500\\/65:hover{
  border-color: rgb(122 90 248 / 0.65);
}

.hover\\:border-purple-500\\/70:hover{
  border-color: rgb(122 90 248 / 0.7);
}

.hover\\:border-purple-500\\/75:hover{
  border-color: rgb(122 90 248 / 0.75);
}

.hover\\:border-purple-500\\/80:hover{
  border-color: rgb(122 90 248 / 0.8);
}

.hover\\:border-purple-500\\/85:hover{
  border-color: rgb(122 90 248 / 0.85);
}

.hover\\:border-purple-500\\/90:hover{
  border-color: rgb(122 90 248 / 0.9);
}

.hover\\:border-purple-500\\/95:hover{
  border-color: rgb(122 90 248 / 0.95);
}

.hover\\:border-purple-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(105 56 239 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-600\\/0:hover{
  border-color: rgb(105 56 239 / 0);
}

.hover\\:border-purple-600\\/10:hover{
  border-color: rgb(105 56 239 / 0.1);
}

.hover\\:border-purple-600\\/100:hover{
  border-color: rgb(105 56 239 / 1);
}

.hover\\:border-purple-600\\/15:hover{
  border-color: rgb(105 56 239 / 0.15);
}

.hover\\:border-purple-600\\/20:hover{
  border-color: rgb(105 56 239 / 0.2);
}

.hover\\:border-purple-600\\/25:hover{
  border-color: rgb(105 56 239 / 0.25);
}

.hover\\:border-purple-600\\/30:hover{
  border-color: rgb(105 56 239 / 0.3);
}

.hover\\:border-purple-600\\/35:hover{
  border-color: rgb(105 56 239 / 0.35);
}

.hover\\:border-purple-600\\/40:hover{
  border-color: rgb(105 56 239 / 0.4);
}

.hover\\:border-purple-600\\/45:hover{
  border-color: rgb(105 56 239 / 0.45);
}

.hover\\:border-purple-600\\/5:hover{
  border-color: rgb(105 56 239 / 0.05);
}

.hover\\:border-purple-600\\/50:hover{
  border-color: rgb(105 56 239 / 0.5);
}

.hover\\:border-purple-600\\/55:hover{
  border-color: rgb(105 56 239 / 0.55);
}

.hover\\:border-purple-600\\/60:hover{
  border-color: rgb(105 56 239 / 0.6);
}

.hover\\:border-purple-600\\/65:hover{
  border-color: rgb(105 56 239 / 0.65);
}

.hover\\:border-purple-600\\/70:hover{
  border-color: rgb(105 56 239 / 0.7);
}

.hover\\:border-purple-600\\/75:hover{
  border-color: rgb(105 56 239 / 0.75);
}

.hover\\:border-purple-600\\/80:hover{
  border-color: rgb(105 56 239 / 0.8);
}

.hover\\:border-purple-600\\/85:hover{
  border-color: rgb(105 56 239 / 0.85);
}

.hover\\:border-purple-600\\/90:hover{
  border-color: rgb(105 56 239 / 0.9);
}

.hover\\:border-purple-600\\/95:hover{
  border-color: rgb(105 56 239 / 0.95);
}

.hover\\:border-purple-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(89 37 220 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-700\\/0:hover{
  border-color: rgb(89 37 220 / 0);
}

.hover\\:border-purple-700\\/10:hover{
  border-color: rgb(89 37 220 / 0.1);
}

.hover\\:border-purple-700\\/100:hover{
  border-color: rgb(89 37 220 / 1);
}

.hover\\:border-purple-700\\/15:hover{
  border-color: rgb(89 37 220 / 0.15);
}

.hover\\:border-purple-700\\/20:hover{
  border-color: rgb(89 37 220 / 0.2);
}

.hover\\:border-purple-700\\/25:hover{
  border-color: rgb(89 37 220 / 0.25);
}

.hover\\:border-purple-700\\/30:hover{
  border-color: rgb(89 37 220 / 0.3);
}

.hover\\:border-purple-700\\/35:hover{
  border-color: rgb(89 37 220 / 0.35);
}

.hover\\:border-purple-700\\/40:hover{
  border-color: rgb(89 37 220 / 0.4);
}

.hover\\:border-purple-700\\/45:hover{
  border-color: rgb(89 37 220 / 0.45);
}

.hover\\:border-purple-700\\/5:hover{
  border-color: rgb(89 37 220 / 0.05);
}

.hover\\:border-purple-700\\/50:hover{
  border-color: rgb(89 37 220 / 0.5);
}

.hover\\:border-purple-700\\/55:hover{
  border-color: rgb(89 37 220 / 0.55);
}

.hover\\:border-purple-700\\/60:hover{
  border-color: rgb(89 37 220 / 0.6);
}

.hover\\:border-purple-700\\/65:hover{
  border-color: rgb(89 37 220 / 0.65);
}

.hover\\:border-purple-700\\/70:hover{
  border-color: rgb(89 37 220 / 0.7);
}

.hover\\:border-purple-700\\/75:hover{
  border-color: rgb(89 37 220 / 0.75);
}

.hover\\:border-purple-700\\/80:hover{
  border-color: rgb(89 37 220 / 0.8);
}

.hover\\:border-purple-700\\/85:hover{
  border-color: rgb(89 37 220 / 0.85);
}

.hover\\:border-purple-700\\/90:hover{
  border-color: rgb(89 37 220 / 0.9);
}

.hover\\:border-purple-700\\/95:hover{
  border-color: rgb(89 37 220 / 0.95);
}

.hover\\:border-success-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(211 248 223 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-100\\/0:hover{
  border-color: rgb(211 248 223 / 0);
}

.hover\\:border-success-100\\/10:hover{
  border-color: rgb(211 248 223 / 0.1);
}

.hover\\:border-success-100\\/100:hover{
  border-color: rgb(211 248 223 / 1);
}

.hover\\:border-success-100\\/15:hover{
  border-color: rgb(211 248 223 / 0.15);
}

.hover\\:border-success-100\\/20:hover{
  border-color: rgb(211 248 223 / 0.2);
}

.hover\\:border-success-100\\/25:hover{
  border-color: rgb(211 248 223 / 0.25);
}

.hover\\:border-success-100\\/30:hover{
  border-color: rgb(211 248 223 / 0.3);
}

.hover\\:border-success-100\\/35:hover{
  border-color: rgb(211 248 223 / 0.35);
}

.hover\\:border-success-100\\/40:hover{
  border-color: rgb(211 248 223 / 0.4);
}

.hover\\:border-success-100\\/45:hover{
  border-color: rgb(211 248 223 / 0.45);
}

.hover\\:border-success-100\\/5:hover{
  border-color: rgb(211 248 223 / 0.05);
}

.hover\\:border-success-100\\/50:hover{
  border-color: rgb(211 248 223 / 0.5);
}

.hover\\:border-success-100\\/55:hover{
  border-color: rgb(211 248 223 / 0.55);
}

.hover\\:border-success-100\\/60:hover{
  border-color: rgb(211 248 223 / 0.6);
}

.hover\\:border-success-100\\/65:hover{
  border-color: rgb(211 248 223 / 0.65);
}

.hover\\:border-success-100\\/70:hover{
  border-color: rgb(211 248 223 / 0.7);
}

.hover\\:border-success-100\\/75:hover{
  border-color: rgb(211 248 223 / 0.75);
}

.hover\\:border-success-100\\/80:hover{
  border-color: rgb(211 248 223 / 0.8);
}

.hover\\:border-success-100\\/85:hover{
  border-color: rgb(211 248 223 / 0.85);
}

.hover\\:border-success-100\\/90:hover{
  border-color: rgb(211 248 223 / 0.9);
}

.hover\\:border-success-100\\/95:hover{
  border-color: rgb(211 248 223 / 0.95);
}

.hover\\:border-success-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(170 240 196 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-200\\/0:hover{
  border-color: rgb(170 240 196 / 0);
}

.hover\\:border-success-200\\/10:hover{
  border-color: rgb(170 240 196 / 0.1);
}

.hover\\:border-success-200\\/100:hover{
  border-color: rgb(170 240 196 / 1);
}

.hover\\:border-success-200\\/15:hover{
  border-color: rgb(170 240 196 / 0.15);
}

.hover\\:border-success-200\\/20:hover{
  border-color: rgb(170 240 196 / 0.2);
}

.hover\\:border-success-200\\/25:hover{
  border-color: rgb(170 240 196 / 0.25);
}

.hover\\:border-success-200\\/30:hover{
  border-color: rgb(170 240 196 / 0.3);
}

.hover\\:border-success-200\\/35:hover{
  border-color: rgb(170 240 196 / 0.35);
}

.hover\\:border-success-200\\/40:hover{
  border-color: rgb(170 240 196 / 0.4);
}

.hover\\:border-success-200\\/45:hover{
  border-color: rgb(170 240 196 / 0.45);
}

.hover\\:border-success-200\\/5:hover{
  border-color: rgb(170 240 196 / 0.05);
}

.hover\\:border-success-200\\/50:hover{
  border-color: rgb(170 240 196 / 0.5);
}

.hover\\:border-success-200\\/55:hover{
  border-color: rgb(170 240 196 / 0.55);
}

.hover\\:border-success-200\\/60:hover{
  border-color: rgb(170 240 196 / 0.6);
}

.hover\\:border-success-200\\/65:hover{
  border-color: rgb(170 240 196 / 0.65);
}

.hover\\:border-success-200\\/70:hover{
  border-color: rgb(170 240 196 / 0.7);
}

.hover\\:border-success-200\\/75:hover{
  border-color: rgb(170 240 196 / 0.75);
}

.hover\\:border-success-200\\/80:hover{
  border-color: rgb(170 240 196 / 0.8);
}

.hover\\:border-success-200\\/85:hover{
  border-color: rgb(170 240 196 / 0.85);
}

.hover\\:border-success-200\\/90:hover{
  border-color: rgb(170 240 196 / 0.9);
}

.hover\\:border-success-200\\/95:hover{
  border-color: rgb(170 240 196 / 0.95);
}

.hover\\:border-success-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(246 254 249 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-25\\/0:hover{
  border-color: rgb(246 254 249 / 0);
}

.hover\\:border-success-25\\/10:hover{
  border-color: rgb(246 254 249 / 0.1);
}

.hover\\:border-success-25\\/100:hover{
  border-color: rgb(246 254 249 / 1);
}

.hover\\:border-success-25\\/15:hover{
  border-color: rgb(246 254 249 / 0.15);
}

.hover\\:border-success-25\\/20:hover{
  border-color: rgb(246 254 249 / 0.2);
}

.hover\\:border-success-25\\/25:hover{
  border-color: rgb(246 254 249 / 0.25);
}

.hover\\:border-success-25\\/30:hover{
  border-color: rgb(246 254 249 / 0.3);
}

.hover\\:border-success-25\\/35:hover{
  border-color: rgb(246 254 249 / 0.35);
}

.hover\\:border-success-25\\/40:hover{
  border-color: rgb(246 254 249 / 0.4);
}

.hover\\:border-success-25\\/45:hover{
  border-color: rgb(246 254 249 / 0.45);
}

.hover\\:border-success-25\\/5:hover{
  border-color: rgb(246 254 249 / 0.05);
}

.hover\\:border-success-25\\/50:hover{
  border-color: rgb(246 254 249 / 0.5);
}

.hover\\:border-success-25\\/55:hover{
  border-color: rgb(246 254 249 / 0.55);
}

.hover\\:border-success-25\\/60:hover{
  border-color: rgb(246 254 249 / 0.6);
}

.hover\\:border-success-25\\/65:hover{
  border-color: rgb(246 254 249 / 0.65);
}

.hover\\:border-success-25\\/70:hover{
  border-color: rgb(246 254 249 / 0.7);
}

.hover\\:border-success-25\\/75:hover{
  border-color: rgb(246 254 249 / 0.75);
}

.hover\\:border-success-25\\/80:hover{
  border-color: rgb(246 254 249 / 0.8);
}

.hover\\:border-success-25\\/85:hover{
  border-color: rgb(246 254 249 / 0.85);
}

.hover\\:border-success-25\\/90:hover{
  border-color: rgb(246 254 249 / 0.9);
}

.hover\\:border-success-25\\/95:hover{
  border-color: rgb(246 254 249 / 0.95);
}

.hover\\:border-success-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(115 226 163 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(60 203 127 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-400\\/0:hover{
  border-color: rgb(60 203 127 / 0);
}

.hover\\:border-success-400\\/10:hover{
  border-color: rgb(60 203 127 / 0.1);
}

.hover\\:border-success-400\\/100:hover{
  border-color: rgb(60 203 127 / 1);
}

.hover\\:border-success-400\\/15:hover{
  border-color: rgb(60 203 127 / 0.15);
}

.hover\\:border-success-400\\/20:hover{
  border-color: rgb(60 203 127 / 0.2);
}

.hover\\:border-success-400\\/25:hover{
  border-color: rgb(60 203 127 / 0.25);
}

.hover\\:border-success-400\\/30:hover{
  border-color: rgb(60 203 127 / 0.3);
}

.hover\\:border-success-400\\/35:hover{
  border-color: rgb(60 203 127 / 0.35);
}

.hover\\:border-success-400\\/40:hover{
  border-color: rgb(60 203 127 / 0.4);
}

.hover\\:border-success-400\\/45:hover{
  border-color: rgb(60 203 127 / 0.45);
}

.hover\\:border-success-400\\/5:hover{
  border-color: rgb(60 203 127 / 0.05);
}

.hover\\:border-success-400\\/50:hover{
  border-color: rgb(60 203 127 / 0.5);
}

.hover\\:border-success-400\\/55:hover{
  border-color: rgb(60 203 127 / 0.55);
}

.hover\\:border-success-400\\/60:hover{
  border-color: rgb(60 203 127 / 0.6);
}

.hover\\:border-success-400\\/65:hover{
  border-color: rgb(60 203 127 / 0.65);
}

.hover\\:border-success-400\\/70:hover{
  border-color: rgb(60 203 127 / 0.7);
}

.hover\\:border-success-400\\/75:hover{
  border-color: rgb(60 203 127 / 0.75);
}

.hover\\:border-success-400\\/80:hover{
  border-color: rgb(60 203 127 / 0.8);
}

.hover\\:border-success-400\\/85:hover{
  border-color: rgb(60 203 127 / 0.85);
}

.hover\\:border-success-400\\/90:hover{
  border-color: rgb(60 203 127 / 0.9);
}

.hover\\:border-success-400\\/95:hover{
  border-color: rgb(60 203 127 / 0.95);
}

.hover\\:border-success-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(237 252 242 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-50\\/0:hover{
  border-color: rgb(237 252 242 / 0);
}

.hover\\:border-success-50\\/10:hover{
  border-color: rgb(237 252 242 / 0.1);
}

.hover\\:border-success-50\\/100:hover{
  border-color: rgb(237 252 242 / 1);
}

.hover\\:border-success-50\\/15:hover{
  border-color: rgb(237 252 242 / 0.15);
}

.hover\\:border-success-50\\/20:hover{
  border-color: rgb(237 252 242 / 0.2);
}

.hover\\:border-success-50\\/25:hover{
  border-color: rgb(237 252 242 / 0.25);
}

.hover\\:border-success-50\\/30:hover{
  border-color: rgb(237 252 242 / 0.3);
}

.hover\\:border-success-50\\/35:hover{
  border-color: rgb(237 252 242 / 0.35);
}

.hover\\:border-success-50\\/40:hover{
  border-color: rgb(237 252 242 / 0.4);
}

.hover\\:border-success-50\\/45:hover{
  border-color: rgb(237 252 242 / 0.45);
}

.hover\\:border-success-50\\/5:hover{
  border-color: rgb(237 252 242 / 0.05);
}

.hover\\:border-success-50\\/50:hover{
  border-color: rgb(237 252 242 / 0.5);
}

.hover\\:border-success-50\\/55:hover{
  border-color: rgb(237 252 242 / 0.55);
}

.hover\\:border-success-50\\/60:hover{
  border-color: rgb(237 252 242 / 0.6);
}

.hover\\:border-success-50\\/65:hover{
  border-color: rgb(237 252 242 / 0.65);
}

.hover\\:border-success-50\\/70:hover{
  border-color: rgb(237 252 242 / 0.7);
}

.hover\\:border-success-50\\/75:hover{
  border-color: rgb(237 252 242 / 0.75);
}

.hover\\:border-success-50\\/80:hover{
  border-color: rgb(237 252 242 / 0.8);
}

.hover\\:border-success-50\\/85:hover{
  border-color: rgb(237 252 242 / 0.85);
}

.hover\\:border-success-50\\/90:hover{
  border-color: rgb(237 252 242 / 0.9);
}

.hover\\:border-success-50\\/95:hover{
  border-color: rgb(237 252 242 / 0.95);
}

.hover\\:border-success-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(22 179 100 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-500\\/0:hover{
  border-color: rgb(22 179 100 / 0);
}

.hover\\:border-success-500\\/10:hover{
  border-color: rgb(22 179 100 / 0.1);
}

.hover\\:border-success-500\\/100:hover{
  border-color: rgb(22 179 100 / 1);
}

.hover\\:border-success-500\\/15:hover{
  border-color: rgb(22 179 100 / 0.15);
}

.hover\\:border-success-500\\/20:hover{
  border-color: rgb(22 179 100 / 0.2);
}

.hover\\:border-success-500\\/25:hover{
  border-color: rgb(22 179 100 / 0.25);
}

.hover\\:border-success-500\\/30:hover{
  border-color: rgb(22 179 100 / 0.3);
}

.hover\\:border-success-500\\/35:hover{
  border-color: rgb(22 179 100 / 0.35);
}

.hover\\:border-success-500\\/40:hover{
  border-color: rgb(22 179 100 / 0.4);
}

.hover\\:border-success-500\\/45:hover{
  border-color: rgb(22 179 100 / 0.45);
}

.hover\\:border-success-500\\/5:hover{
  border-color: rgb(22 179 100 / 0.05);
}

.hover\\:border-success-500\\/50:hover{
  border-color: rgb(22 179 100 / 0.5);
}

.hover\\:border-success-500\\/55:hover{
  border-color: rgb(22 179 100 / 0.55);
}

.hover\\:border-success-500\\/60:hover{
  border-color: rgb(22 179 100 / 0.6);
}

.hover\\:border-success-500\\/65:hover{
  border-color: rgb(22 179 100 / 0.65);
}

.hover\\:border-success-500\\/70:hover{
  border-color: rgb(22 179 100 / 0.7);
}

.hover\\:border-success-500\\/75:hover{
  border-color: rgb(22 179 100 / 0.75);
}

.hover\\:border-success-500\\/80:hover{
  border-color: rgb(22 179 100 / 0.8);
}

.hover\\:border-success-500\\/85:hover{
  border-color: rgb(22 179 100 / 0.85);
}

.hover\\:border-success-500\\/90:hover{
  border-color: rgb(22 179 100 / 0.9);
}

.hover\\:border-success-500\\/95:hover{
  border-color: rgb(22 179 100 / 0.95);
}

.hover\\:border-success-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(9 146 80 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-600\\/0:hover{
  border-color: rgb(9 146 80 / 0);
}

.hover\\:border-success-600\\/10:hover{
  border-color: rgb(9 146 80 / 0.1);
}

.hover\\:border-success-600\\/100:hover{
  border-color: rgb(9 146 80 / 1);
}

.hover\\:border-success-600\\/15:hover{
  border-color: rgb(9 146 80 / 0.15);
}

.hover\\:border-success-600\\/20:hover{
  border-color: rgb(9 146 80 / 0.2);
}

.hover\\:border-success-600\\/25:hover{
  border-color: rgb(9 146 80 / 0.25);
}

.hover\\:border-success-600\\/30:hover{
  border-color: rgb(9 146 80 / 0.3);
}

.hover\\:border-success-600\\/35:hover{
  border-color: rgb(9 146 80 / 0.35);
}

.hover\\:border-success-600\\/40:hover{
  border-color: rgb(9 146 80 / 0.4);
}

.hover\\:border-success-600\\/45:hover{
  border-color: rgb(9 146 80 / 0.45);
}

.hover\\:border-success-600\\/5:hover{
  border-color: rgb(9 146 80 / 0.05);
}

.hover\\:border-success-600\\/50:hover{
  border-color: rgb(9 146 80 / 0.5);
}

.hover\\:border-success-600\\/55:hover{
  border-color: rgb(9 146 80 / 0.55);
}

.hover\\:border-success-600\\/60:hover{
  border-color: rgb(9 146 80 / 0.6);
}

.hover\\:border-success-600\\/65:hover{
  border-color: rgb(9 146 80 / 0.65);
}

.hover\\:border-success-600\\/70:hover{
  border-color: rgb(9 146 80 / 0.7);
}

.hover\\:border-success-600\\/75:hover{
  border-color: rgb(9 146 80 / 0.75);
}

.hover\\:border-success-600\\/80:hover{
  border-color: rgb(9 146 80 / 0.8);
}

.hover\\:border-success-600\\/85:hover{
  border-color: rgb(9 146 80 / 0.85);
}

.hover\\:border-success-600\\/90:hover{
  border-color: rgb(9 146 80 / 0.9);
}

.hover\\:border-success-600\\/95:hover{
  border-color: rgb(9 146 80 / 0.95);
}

.hover\\:border-success-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(8 116 67 / var(--tw-border-opacity, 1));
}

.hover\\:border-success-700\\/0:hover{
  border-color: rgb(8 116 67 / 0);
}

.hover\\:border-success-700\\/10:hover{
  border-color: rgb(8 116 67 / 0.1);
}

.hover\\:border-success-700\\/100:hover{
  border-color: rgb(8 116 67 / 1);
}

.hover\\:border-success-700\\/15:hover{
  border-color: rgb(8 116 67 / 0.15);
}

.hover\\:border-success-700\\/20:hover{
  border-color: rgb(8 116 67 / 0.2);
}

.hover\\:border-success-700\\/25:hover{
  border-color: rgb(8 116 67 / 0.25);
}

.hover\\:border-success-700\\/30:hover{
  border-color: rgb(8 116 67 / 0.3);
}

.hover\\:border-success-700\\/35:hover{
  border-color: rgb(8 116 67 / 0.35);
}

.hover\\:border-success-700\\/40:hover{
  border-color: rgb(8 116 67 / 0.4);
}

.hover\\:border-success-700\\/45:hover{
  border-color: rgb(8 116 67 / 0.45);
}

.hover\\:border-success-700\\/5:hover{
  border-color: rgb(8 116 67 / 0.05);
}

.hover\\:border-success-700\\/50:hover{
  border-color: rgb(8 116 67 / 0.5);
}

.hover\\:border-success-700\\/55:hover{
  border-color: rgb(8 116 67 / 0.55);
}

.hover\\:border-success-700\\/60:hover{
  border-color: rgb(8 116 67 / 0.6);
}

.hover\\:border-success-700\\/65:hover{
  border-color: rgb(8 116 67 / 0.65);
}

.hover\\:border-success-700\\/70:hover{
  border-color: rgb(8 116 67 / 0.7);
}

.hover\\:border-success-700\\/75:hover{
  border-color: rgb(8 116 67 / 0.75);
}

.hover\\:border-success-700\\/80:hover{
  border-color: rgb(8 116 67 / 0.8);
}

.hover\\:border-success-700\\/85:hover{
  border-color: rgb(8 116 67 / 0.85);
}

.hover\\:border-success-700\\/90:hover{
  border-color: rgb(8 116 67 / 0.9);
}

.hover\\:border-success-700\\/95:hover{
  border-color: rgb(8 116 67 / 0.95);
}

.hover\\:border-teal-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(95 233 208 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(195 181 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 199 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-100\\/0:hover{
  border-color: rgb(254 240 199 / 0);
}

.hover\\:border-warning-100\\/10:hover{
  border-color: rgb(254 240 199 / 0.1);
}

.hover\\:border-warning-100\\/100:hover{
  border-color: rgb(254 240 199 / 1);
}

.hover\\:border-warning-100\\/15:hover{
  border-color: rgb(254 240 199 / 0.15);
}

.hover\\:border-warning-100\\/20:hover{
  border-color: rgb(254 240 199 / 0.2);
}

.hover\\:border-warning-100\\/25:hover{
  border-color: rgb(254 240 199 / 0.25);
}

.hover\\:border-warning-100\\/30:hover{
  border-color: rgb(254 240 199 / 0.3);
}

.hover\\:border-warning-100\\/35:hover{
  border-color: rgb(254 240 199 / 0.35);
}

.hover\\:border-warning-100\\/40:hover{
  border-color: rgb(254 240 199 / 0.4);
}

.hover\\:border-warning-100\\/45:hover{
  border-color: rgb(254 240 199 / 0.45);
}

.hover\\:border-warning-100\\/5:hover{
  border-color: rgb(254 240 199 / 0.05);
}

.hover\\:border-warning-100\\/50:hover{
  border-color: rgb(254 240 199 / 0.5);
}

.hover\\:border-warning-100\\/55:hover{
  border-color: rgb(254 240 199 / 0.55);
}

.hover\\:border-warning-100\\/60:hover{
  border-color: rgb(254 240 199 / 0.6);
}

.hover\\:border-warning-100\\/65:hover{
  border-color: rgb(254 240 199 / 0.65);
}

.hover\\:border-warning-100\\/70:hover{
  border-color: rgb(254 240 199 / 0.7);
}

.hover\\:border-warning-100\\/75:hover{
  border-color: rgb(254 240 199 / 0.75);
}

.hover\\:border-warning-100\\/80:hover{
  border-color: rgb(254 240 199 / 0.8);
}

.hover\\:border-warning-100\\/85:hover{
  border-color: rgb(254 240 199 / 0.85);
}

.hover\\:border-warning-100\\/90:hover{
  border-color: rgb(254 240 199 / 0.9);
}

.hover\\:border-warning-100\\/95:hover{
  border-color: rgb(254 240 199 / 0.95);
}

.hover\\:border-warning-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 223 137 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-200\\/0:hover{
  border-color: rgb(254 223 137 / 0);
}

.hover\\:border-warning-200\\/10:hover{
  border-color: rgb(254 223 137 / 0.1);
}

.hover\\:border-warning-200\\/100:hover{
  border-color: rgb(254 223 137 / 1);
}

.hover\\:border-warning-200\\/15:hover{
  border-color: rgb(254 223 137 / 0.15);
}

.hover\\:border-warning-200\\/20:hover{
  border-color: rgb(254 223 137 / 0.2);
}

.hover\\:border-warning-200\\/25:hover{
  border-color: rgb(254 223 137 / 0.25);
}

.hover\\:border-warning-200\\/30:hover{
  border-color: rgb(254 223 137 / 0.3);
}

.hover\\:border-warning-200\\/35:hover{
  border-color: rgb(254 223 137 / 0.35);
}

.hover\\:border-warning-200\\/40:hover{
  border-color: rgb(254 223 137 / 0.4);
}

.hover\\:border-warning-200\\/45:hover{
  border-color: rgb(254 223 137 / 0.45);
}

.hover\\:border-warning-200\\/5:hover{
  border-color: rgb(254 223 137 / 0.05);
}

.hover\\:border-warning-200\\/50:hover{
  border-color: rgb(254 223 137 / 0.5);
}

.hover\\:border-warning-200\\/55:hover{
  border-color: rgb(254 223 137 / 0.55);
}

.hover\\:border-warning-200\\/60:hover{
  border-color: rgb(254 223 137 / 0.6);
}

.hover\\:border-warning-200\\/65:hover{
  border-color: rgb(254 223 137 / 0.65);
}

.hover\\:border-warning-200\\/70:hover{
  border-color: rgb(254 223 137 / 0.7);
}

.hover\\:border-warning-200\\/75:hover{
  border-color: rgb(254 223 137 / 0.75);
}

.hover\\:border-warning-200\\/80:hover{
  border-color: rgb(254 223 137 / 0.8);
}

.hover\\:border-warning-200\\/85:hover{
  border-color: rgb(254 223 137 / 0.85);
}

.hover\\:border-warning-200\\/90:hover{
  border-color: rgb(254 223 137 / 0.9);
}

.hover\\:border-warning-200\\/95:hover{
  border-color: rgb(254 223 137 / 0.95);
}

.hover\\:border-warning-25:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 252 245 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-25\\/0:hover{
  border-color: rgb(255 252 245 / 0);
}

.hover\\:border-warning-25\\/10:hover{
  border-color: rgb(255 252 245 / 0.1);
}

.hover\\:border-warning-25\\/100:hover{
  border-color: rgb(255 252 245 / 1);
}

.hover\\:border-warning-25\\/15:hover{
  border-color: rgb(255 252 245 / 0.15);
}

.hover\\:border-warning-25\\/20:hover{
  border-color: rgb(255 252 245 / 0.2);
}

.hover\\:border-warning-25\\/25:hover{
  border-color: rgb(255 252 245 / 0.25);
}

.hover\\:border-warning-25\\/30:hover{
  border-color: rgb(255 252 245 / 0.3);
}

.hover\\:border-warning-25\\/35:hover{
  border-color: rgb(255 252 245 / 0.35);
}

.hover\\:border-warning-25\\/40:hover{
  border-color: rgb(255 252 245 / 0.4);
}

.hover\\:border-warning-25\\/45:hover{
  border-color: rgb(255 252 245 / 0.45);
}

.hover\\:border-warning-25\\/5:hover{
  border-color: rgb(255 252 245 / 0.05);
}

.hover\\:border-warning-25\\/50:hover{
  border-color: rgb(255 252 245 / 0.5);
}

.hover\\:border-warning-25\\/55:hover{
  border-color: rgb(255 252 245 / 0.55);
}

.hover\\:border-warning-25\\/60:hover{
  border-color: rgb(255 252 245 / 0.6);
}

.hover\\:border-warning-25\\/65:hover{
  border-color: rgb(255 252 245 / 0.65);
}

.hover\\:border-warning-25\\/70:hover{
  border-color: rgb(255 252 245 / 0.7);
}

.hover\\:border-warning-25\\/75:hover{
  border-color: rgb(255 252 245 / 0.75);
}

.hover\\:border-warning-25\\/80:hover{
  border-color: rgb(255 252 245 / 0.8);
}

.hover\\:border-warning-25\\/85:hover{
  border-color: rgb(255 252 245 / 0.85);
}

.hover\\:border-warning-25\\/90:hover{
  border-color: rgb(255 252 245 / 0.9);
}

.hover\\:border-warning-25\\/95:hover{
  border-color: rgb(255 252 245 / 0.95);
}

.hover\\:border-warning-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 200 75 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-400\\/0:hover{
  border-color: rgb(253 176 34 / 0);
}

.hover\\:border-warning-400\\/10:hover{
  border-color: rgb(253 176 34 / 0.1);
}

.hover\\:border-warning-400\\/100:hover{
  border-color: rgb(253 176 34 / 1);
}

.hover\\:border-warning-400\\/15:hover{
  border-color: rgb(253 176 34 / 0.15);
}

.hover\\:border-warning-400\\/20:hover{
  border-color: rgb(253 176 34 / 0.2);
}

.hover\\:border-warning-400\\/25:hover{
  border-color: rgb(253 176 34 / 0.25);
}

.hover\\:border-warning-400\\/30:hover{
  border-color: rgb(253 176 34 / 0.3);
}

.hover\\:border-warning-400\\/35:hover{
  border-color: rgb(253 176 34 / 0.35);
}

.hover\\:border-warning-400\\/40:hover{
  border-color: rgb(253 176 34 / 0.4);
}

.hover\\:border-warning-400\\/45:hover{
  border-color: rgb(253 176 34 / 0.45);
}

.hover\\:border-warning-400\\/5:hover{
  border-color: rgb(253 176 34 / 0.05);
}

.hover\\:border-warning-400\\/50:hover{
  border-color: rgb(253 176 34 / 0.5);
}

.hover\\:border-warning-400\\/55:hover{
  border-color: rgb(253 176 34 / 0.55);
}

.hover\\:border-warning-400\\/60:hover{
  border-color: rgb(253 176 34 / 0.6);
}

.hover\\:border-warning-400\\/65:hover{
  border-color: rgb(253 176 34 / 0.65);
}

.hover\\:border-warning-400\\/70:hover{
  border-color: rgb(253 176 34 / 0.7);
}

.hover\\:border-warning-400\\/75:hover{
  border-color: rgb(253 176 34 / 0.75);
}

.hover\\:border-warning-400\\/80:hover{
  border-color: rgb(253 176 34 / 0.8);
}

.hover\\:border-warning-400\\/85:hover{
  border-color: rgb(253 176 34 / 0.85);
}

.hover\\:border-warning-400\\/90:hover{
  border-color: rgb(253 176 34 / 0.9);
}

.hover\\:border-warning-400\\/95:hover{
  border-color: rgb(253 176 34 / 0.95);
}

.hover\\:border-warning-50:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 250 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-50\\/0:hover{
  border-color: rgb(255 250 235 / 0);
}

.hover\\:border-warning-50\\/10:hover{
  border-color: rgb(255 250 235 / 0.1);
}

.hover\\:border-warning-50\\/100:hover{
  border-color: rgb(255 250 235 / 1);
}

.hover\\:border-warning-50\\/15:hover{
  border-color: rgb(255 250 235 / 0.15);
}

.hover\\:border-warning-50\\/20:hover{
  border-color: rgb(255 250 235 / 0.2);
}

.hover\\:border-warning-50\\/25:hover{
  border-color: rgb(255 250 235 / 0.25);
}

.hover\\:border-warning-50\\/30:hover{
  border-color: rgb(255 250 235 / 0.3);
}

.hover\\:border-warning-50\\/35:hover{
  border-color: rgb(255 250 235 / 0.35);
}

.hover\\:border-warning-50\\/40:hover{
  border-color: rgb(255 250 235 / 0.4);
}

.hover\\:border-warning-50\\/45:hover{
  border-color: rgb(255 250 235 / 0.45);
}

.hover\\:border-warning-50\\/5:hover{
  border-color: rgb(255 250 235 / 0.05);
}

.hover\\:border-warning-50\\/50:hover{
  border-color: rgb(255 250 235 / 0.5);
}

.hover\\:border-warning-50\\/55:hover{
  border-color: rgb(255 250 235 / 0.55);
}

.hover\\:border-warning-50\\/60:hover{
  border-color: rgb(255 250 235 / 0.6);
}

.hover\\:border-warning-50\\/65:hover{
  border-color: rgb(255 250 235 / 0.65);
}

.hover\\:border-warning-50\\/70:hover{
  border-color: rgb(255 250 235 / 0.7);
}

.hover\\:border-warning-50\\/75:hover{
  border-color: rgb(255 250 235 / 0.75);
}

.hover\\:border-warning-50\\/80:hover{
  border-color: rgb(255 250 235 / 0.8);
}

.hover\\:border-warning-50\\/85:hover{
  border-color: rgb(255 250 235 / 0.85);
}

.hover\\:border-warning-50\\/90:hover{
  border-color: rgb(255 250 235 / 0.9);
}

.hover\\:border-warning-50\\/95:hover{
  border-color: rgb(255 250 235 / 0.95);
}

.hover\\:border-warning-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-500\\/0:hover{
  border-color: rgb(247 144 9 / 0);
}

.hover\\:border-warning-500\\/10:hover{
  border-color: rgb(247 144 9 / 0.1);
}

.hover\\:border-warning-500\\/100:hover{
  border-color: rgb(247 144 9 / 1);
}

.hover\\:border-warning-500\\/15:hover{
  border-color: rgb(247 144 9 / 0.15);
}

.hover\\:border-warning-500\\/20:hover{
  border-color: rgb(247 144 9 / 0.2);
}

.hover\\:border-warning-500\\/25:hover{
  border-color: rgb(247 144 9 / 0.25);
}

.hover\\:border-warning-500\\/30:hover{
  border-color: rgb(247 144 9 / 0.3);
}

.hover\\:border-warning-500\\/35:hover{
  border-color: rgb(247 144 9 / 0.35);
}

.hover\\:border-warning-500\\/40:hover{
  border-color: rgb(247 144 9 / 0.4);
}

.hover\\:border-warning-500\\/45:hover{
  border-color: rgb(247 144 9 / 0.45);
}

.hover\\:border-warning-500\\/5:hover{
  border-color: rgb(247 144 9 / 0.05);
}

.hover\\:border-warning-500\\/50:hover{
  border-color: rgb(247 144 9 / 0.5);
}

.hover\\:border-warning-500\\/55:hover{
  border-color: rgb(247 144 9 / 0.55);
}

.hover\\:border-warning-500\\/60:hover{
  border-color: rgb(247 144 9 / 0.6);
}

.hover\\:border-warning-500\\/65:hover{
  border-color: rgb(247 144 9 / 0.65);
}

.hover\\:border-warning-500\\/70:hover{
  border-color: rgb(247 144 9 / 0.7);
}

.hover\\:border-warning-500\\/75:hover{
  border-color: rgb(247 144 9 / 0.75);
}

.hover\\:border-warning-500\\/80:hover{
  border-color: rgb(247 144 9 / 0.8);
}

.hover\\:border-warning-500\\/85:hover{
  border-color: rgb(247 144 9 / 0.85);
}

.hover\\:border-warning-500\\/90:hover{
  border-color: rgb(247 144 9 / 0.9);
}

.hover\\:border-warning-500\\/95:hover{
  border-color: rgb(247 144 9 / 0.95);
}

.hover\\:border-warning-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-600\\/0:hover{
  border-color: rgb(220 104 3 / 0);
}

.hover\\:border-warning-600\\/10:hover{
  border-color: rgb(220 104 3 / 0.1);
}

.hover\\:border-warning-600\\/100:hover{
  border-color: rgb(220 104 3 / 1);
}

.hover\\:border-warning-600\\/15:hover{
  border-color: rgb(220 104 3 / 0.15);
}

.hover\\:border-warning-600\\/20:hover{
  border-color: rgb(220 104 3 / 0.2);
}

.hover\\:border-warning-600\\/25:hover{
  border-color: rgb(220 104 3 / 0.25);
}

.hover\\:border-warning-600\\/30:hover{
  border-color: rgb(220 104 3 / 0.3);
}

.hover\\:border-warning-600\\/35:hover{
  border-color: rgb(220 104 3 / 0.35);
}

.hover\\:border-warning-600\\/40:hover{
  border-color: rgb(220 104 3 / 0.4);
}

.hover\\:border-warning-600\\/45:hover{
  border-color: rgb(220 104 3 / 0.45);
}

.hover\\:border-warning-600\\/5:hover{
  border-color: rgb(220 104 3 / 0.05);
}

.hover\\:border-warning-600\\/50:hover{
  border-color: rgb(220 104 3 / 0.5);
}

.hover\\:border-warning-600\\/55:hover{
  border-color: rgb(220 104 3 / 0.55);
}

.hover\\:border-warning-600\\/60:hover{
  border-color: rgb(220 104 3 / 0.6);
}

.hover\\:border-warning-600\\/65:hover{
  border-color: rgb(220 104 3 / 0.65);
}

.hover\\:border-warning-600\\/70:hover{
  border-color: rgb(220 104 3 / 0.7);
}

.hover\\:border-warning-600\\/75:hover{
  border-color: rgb(220 104 3 / 0.75);
}

.hover\\:border-warning-600\\/80:hover{
  border-color: rgb(220 104 3 / 0.8);
}

.hover\\:border-warning-600\\/85:hover{
  border-color: rgb(220 104 3 / 0.85);
}

.hover\\:border-warning-600\\/90:hover{
  border-color: rgb(220 104 3 / 0.9);
}

.hover\\:border-warning-600\\/95:hover{
  border-color: rgb(220 104 3 / 0.95);
}

.hover\\:border-warning-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(181 71 8 / var(--tw-border-opacity, 1));
}

.hover\\:border-warning-700\\/0:hover{
  border-color: rgb(181 71 8 / 0);
}

.hover\\:border-warning-700\\/10:hover{
  border-color: rgb(181 71 8 / 0.1);
}

.hover\\:border-warning-700\\/100:hover{
  border-color: rgb(181 71 8 / 1);
}

.hover\\:border-warning-700\\/15:hover{
  border-color: rgb(181 71 8 / 0.15);
}

.hover\\:border-warning-700\\/20:hover{
  border-color: rgb(181 71 8 / 0.2);
}

.hover\\:border-warning-700\\/25:hover{
  border-color: rgb(181 71 8 / 0.25);
}

.hover\\:border-warning-700\\/30:hover{
  border-color: rgb(181 71 8 / 0.3);
}

.hover\\:border-warning-700\\/35:hover{
  border-color: rgb(181 71 8 / 0.35);
}

.hover\\:border-warning-700\\/40:hover{
  border-color: rgb(181 71 8 / 0.4);
}

.hover\\:border-warning-700\\/45:hover{
  border-color: rgb(181 71 8 / 0.45);
}

.hover\\:border-warning-700\\/5:hover{
  border-color: rgb(181 71 8 / 0.05);
}

.hover\\:border-warning-700\\/50:hover{
  border-color: rgb(181 71 8 / 0.5);
}

.hover\\:border-warning-700\\/55:hover{
  border-color: rgb(181 71 8 / 0.55);
}

.hover\\:border-warning-700\\/60:hover{
  border-color: rgb(181 71 8 / 0.6);
}

.hover\\:border-warning-700\\/65:hover{
  border-color: rgb(181 71 8 / 0.65);
}

.hover\\:border-warning-700\\/70:hover{
  border-color: rgb(181 71 8 / 0.7);
}

.hover\\:border-warning-700\\/75:hover{
  border-color: rgb(181 71 8 / 0.75);
}

.hover\\:border-warning-700\\/80:hover{
  border-color: rgb(181 71 8 / 0.8);
}

.hover\\:border-warning-700\\/85:hover{
  border-color: rgb(181 71 8 / 0.85);
}

.hover\\:border-warning-700\\/90:hover{
  border-color: rgb(181 71 8 / 0.9);
}

.hover\\:border-warning-700\\/95:hover{
  border-color: rgb(181 71 8 / 0.95);
}

.hover\\:\\!bg-danger-900:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(122 39 26 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-neutral-100:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-neutral-50:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-neutral-75:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-neutral-dark-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 58 65 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-primary-100:hover{
  background-color: var(--color-primary-100, #E0F2FE) !important;
}

.hover\\:\\!bg-primary-50:hover{
  background-color: var(--color-primary-50, #F0F9FF) !important;
}

.hover\\:\\!bg-primary-500:hover{
  background-color: var(--color-primary-500, #0BA5EC) !important;
}

.hover\\:\\!bg-primary-700:hover{
  background-color: var(--color-primary-700, #026AA2) !important;
}

.hover\\:\\!bg-primary-800:hover{
  background-color: var(--color-primary-800, #065986) !important;
}

.hover\\:\\!bg-transparent:hover{
  background-color: transparent !important;
}

.hover\\:\\!bg-warning-100:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-white:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2) !important;
}

.hover\\:bg-\\[\\#E6F8FF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(230 248 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F0F9FF\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-100\\/0:hover{
  background-color: rgb(254 228 226 / 0);
}

.hover\\:bg-danger-100\\/10:hover{
  background-color: rgb(254 228 226 / 0.1);
}

.hover\\:bg-danger-100\\/100:hover{
  background-color: rgb(254 228 226 / 1);
}

.hover\\:bg-danger-100\\/15:hover{
  background-color: rgb(254 228 226 / 0.15);
}

.hover\\:bg-danger-100\\/20:hover{
  background-color: rgb(254 228 226 / 0.2);
}

.hover\\:bg-danger-100\\/25:hover{
  background-color: rgb(254 228 226 / 0.25);
}

.hover\\:bg-danger-100\\/30:hover{
  background-color: rgb(254 228 226 / 0.3);
}

.hover\\:bg-danger-100\\/35:hover{
  background-color: rgb(254 228 226 / 0.35);
}

.hover\\:bg-danger-100\\/40:hover{
  background-color: rgb(254 228 226 / 0.4);
}

.hover\\:bg-danger-100\\/45:hover{
  background-color: rgb(254 228 226 / 0.45);
}

.hover\\:bg-danger-100\\/5:hover{
  background-color: rgb(254 228 226 / 0.05);
}

.hover\\:bg-danger-100\\/50:hover{
  background-color: rgb(254 228 226 / 0.5);
}

.hover\\:bg-danger-100\\/55:hover{
  background-color: rgb(254 228 226 / 0.55);
}

.hover\\:bg-danger-100\\/60:hover{
  background-color: rgb(254 228 226 / 0.6);
}

.hover\\:bg-danger-100\\/65:hover{
  background-color: rgb(254 228 226 / 0.65);
}

.hover\\:bg-danger-100\\/70:hover{
  background-color: rgb(254 228 226 / 0.7);
}

.hover\\:bg-danger-100\\/75:hover{
  background-color: rgb(254 228 226 / 0.75);
}

.hover\\:bg-danger-100\\/80:hover{
  background-color: rgb(254 228 226 / 0.8);
}

.hover\\:bg-danger-100\\/85:hover{
  background-color: rgb(254 228 226 / 0.85);
}

.hover\\:bg-danger-100\\/90:hover{
  background-color: rgb(254 228 226 / 0.9);
}

.hover\\:bg-danger-100\\/95:hover{
  background-color: rgb(254 228 226 / 0.95);
}

.hover\\:bg-danger-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-200\\/0:hover{
  background-color: rgb(254 205 202 / 0);
}

.hover\\:bg-danger-200\\/10:hover{
  background-color: rgb(254 205 202 / 0.1);
}

.hover\\:bg-danger-200\\/100:hover{
  background-color: rgb(254 205 202 / 1);
}

.hover\\:bg-danger-200\\/15:hover{
  background-color: rgb(254 205 202 / 0.15);
}

.hover\\:bg-danger-200\\/20:hover{
  background-color: rgb(254 205 202 / 0.2);
}

.hover\\:bg-danger-200\\/25:hover{
  background-color: rgb(254 205 202 / 0.25);
}

.hover\\:bg-danger-200\\/30:hover{
  background-color: rgb(254 205 202 / 0.3);
}

.hover\\:bg-danger-200\\/35:hover{
  background-color: rgb(254 205 202 / 0.35);
}

.hover\\:bg-danger-200\\/40:hover{
  background-color: rgb(254 205 202 / 0.4);
}

.hover\\:bg-danger-200\\/45:hover{
  background-color: rgb(254 205 202 / 0.45);
}

.hover\\:bg-danger-200\\/5:hover{
  background-color: rgb(254 205 202 / 0.05);
}

.hover\\:bg-danger-200\\/50:hover{
  background-color: rgb(254 205 202 / 0.5);
}

.hover\\:bg-danger-200\\/55:hover{
  background-color: rgb(254 205 202 / 0.55);
}

.hover\\:bg-danger-200\\/60:hover{
  background-color: rgb(254 205 202 / 0.6);
}

.hover\\:bg-danger-200\\/65:hover{
  background-color: rgb(254 205 202 / 0.65);
}

.hover\\:bg-danger-200\\/70:hover{
  background-color: rgb(254 205 202 / 0.7);
}

.hover\\:bg-danger-200\\/75:hover{
  background-color: rgb(254 205 202 / 0.75);
}

.hover\\:bg-danger-200\\/80:hover{
  background-color: rgb(254 205 202 / 0.8);
}

.hover\\:bg-danger-200\\/85:hover{
  background-color: rgb(254 205 202 / 0.85);
}

.hover\\:bg-danger-200\\/90:hover{
  background-color: rgb(254 205 202 / 0.9);
}

.hover\\:bg-danger-200\\/95:hover{
  background-color: rgb(254 205 202 / 0.95);
}

.hover\\:bg-danger-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-25\\/0:hover{
  background-color: rgb(255 251 250 / 0);
}

.hover\\:bg-danger-25\\/10:hover{
  background-color: rgb(255 251 250 / 0.1);
}

.hover\\:bg-danger-25\\/100:hover{
  background-color: rgb(255 251 250 / 1);
}

.hover\\:bg-danger-25\\/15:hover{
  background-color: rgb(255 251 250 / 0.15);
}

.hover\\:bg-danger-25\\/20:hover{
  background-color: rgb(255 251 250 / 0.2);
}

.hover\\:bg-danger-25\\/25:hover{
  background-color: rgb(255 251 250 / 0.25);
}

.hover\\:bg-danger-25\\/30:hover{
  background-color: rgb(255 251 250 / 0.3);
}

.hover\\:bg-danger-25\\/35:hover{
  background-color: rgb(255 251 250 / 0.35);
}

.hover\\:bg-danger-25\\/40:hover{
  background-color: rgb(255 251 250 / 0.4);
}

.hover\\:bg-danger-25\\/45:hover{
  background-color: rgb(255 251 250 / 0.45);
}

.hover\\:bg-danger-25\\/5:hover{
  background-color: rgb(255 251 250 / 0.05);
}

.hover\\:bg-danger-25\\/50:hover{
  background-color: rgb(255 251 250 / 0.5);
}

.hover\\:bg-danger-25\\/55:hover{
  background-color: rgb(255 251 250 / 0.55);
}

.hover\\:bg-danger-25\\/60:hover{
  background-color: rgb(255 251 250 / 0.6);
}

.hover\\:bg-danger-25\\/65:hover{
  background-color: rgb(255 251 250 / 0.65);
}

.hover\\:bg-danger-25\\/70:hover{
  background-color: rgb(255 251 250 / 0.7);
}

.hover\\:bg-danger-25\\/75:hover{
  background-color: rgb(255 251 250 / 0.75);
}

.hover\\:bg-danger-25\\/80:hover{
  background-color: rgb(255 251 250 / 0.8);
}

.hover\\:bg-danger-25\\/85:hover{
  background-color: rgb(255 251 250 / 0.85);
}

.hover\\:bg-danger-25\\/90:hover{
  background-color: rgb(255 251 250 / 0.9);
}

.hover\\:bg-danger-25\\/95:hover{
  background-color: rgb(255 251 250 / 0.95);
}

.hover\\:bg-danger-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-400\\/0:hover{
  background-color: rgb(249 112 102 / 0);
}

.hover\\:bg-danger-400\\/10:hover{
  background-color: rgb(249 112 102 / 0.1);
}

.hover\\:bg-danger-400\\/100:hover{
  background-color: rgb(249 112 102 / 1);
}

.hover\\:bg-danger-400\\/15:hover{
  background-color: rgb(249 112 102 / 0.15);
}

.hover\\:bg-danger-400\\/20:hover{
  background-color: rgb(249 112 102 / 0.2);
}

.hover\\:bg-danger-400\\/25:hover{
  background-color: rgb(249 112 102 / 0.25);
}

.hover\\:bg-danger-400\\/30:hover{
  background-color: rgb(249 112 102 / 0.3);
}

.hover\\:bg-danger-400\\/35:hover{
  background-color: rgb(249 112 102 / 0.35);
}

.hover\\:bg-danger-400\\/40:hover{
  background-color: rgb(249 112 102 / 0.4);
}

.hover\\:bg-danger-400\\/45:hover{
  background-color: rgb(249 112 102 / 0.45);
}

.hover\\:bg-danger-400\\/5:hover{
  background-color: rgb(249 112 102 / 0.05);
}

.hover\\:bg-danger-400\\/50:hover{
  background-color: rgb(249 112 102 / 0.5);
}

.hover\\:bg-danger-400\\/55:hover{
  background-color: rgb(249 112 102 / 0.55);
}

.hover\\:bg-danger-400\\/60:hover{
  background-color: rgb(249 112 102 / 0.6);
}

.hover\\:bg-danger-400\\/65:hover{
  background-color: rgb(249 112 102 / 0.65);
}

.hover\\:bg-danger-400\\/70:hover{
  background-color: rgb(249 112 102 / 0.7);
}

.hover\\:bg-danger-400\\/75:hover{
  background-color: rgb(249 112 102 / 0.75);
}

.hover\\:bg-danger-400\\/80:hover{
  background-color: rgb(249 112 102 / 0.8);
}

.hover\\:bg-danger-400\\/85:hover{
  background-color: rgb(249 112 102 / 0.85);
}

.hover\\:bg-danger-400\\/90:hover{
  background-color: rgb(249 112 102 / 0.9);
}

.hover\\:bg-danger-400\\/95:hover{
  background-color: rgb(249 112 102 / 0.95);
}

.hover\\:bg-danger-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-50\\/0:hover{
  background-color: rgb(254 243 242 / 0);
}

.hover\\:bg-danger-50\\/10:hover{
  background-color: rgb(254 243 242 / 0.1);
}

.hover\\:bg-danger-50\\/100:hover{
  background-color: rgb(254 243 242 / 1);
}

.hover\\:bg-danger-50\\/15:hover{
  background-color: rgb(254 243 242 / 0.15);
}

.hover\\:bg-danger-50\\/20:hover{
  background-color: rgb(254 243 242 / 0.2);
}

.hover\\:bg-danger-50\\/25:hover{
  background-color: rgb(254 243 242 / 0.25);
}

.hover\\:bg-danger-50\\/30:hover{
  background-color: rgb(254 243 242 / 0.3);
}

.hover\\:bg-danger-50\\/35:hover{
  background-color: rgb(254 243 242 / 0.35);
}

.hover\\:bg-danger-50\\/40:hover{
  background-color: rgb(254 243 242 / 0.4);
}

.hover\\:bg-danger-50\\/45:hover{
  background-color: rgb(254 243 242 / 0.45);
}

.hover\\:bg-danger-50\\/5:hover{
  background-color: rgb(254 243 242 / 0.05);
}

.hover\\:bg-danger-50\\/50:hover{
  background-color: rgb(254 243 242 / 0.5);
}

.hover\\:bg-danger-50\\/55:hover{
  background-color: rgb(254 243 242 / 0.55);
}

.hover\\:bg-danger-50\\/60:hover{
  background-color: rgb(254 243 242 / 0.6);
}

.hover\\:bg-danger-50\\/65:hover{
  background-color: rgb(254 243 242 / 0.65);
}

.hover\\:bg-danger-50\\/70:hover{
  background-color: rgb(254 243 242 / 0.7);
}

.hover\\:bg-danger-50\\/75:hover{
  background-color: rgb(254 243 242 / 0.75);
}

.hover\\:bg-danger-50\\/80:hover{
  background-color: rgb(254 243 242 / 0.8);
}

.hover\\:bg-danger-50\\/85:hover{
  background-color: rgb(254 243 242 / 0.85);
}

.hover\\:bg-danger-50\\/90:hover{
  background-color: rgb(254 243 242 / 0.9);
}

.hover\\:bg-danger-50\\/95:hover{
  background-color: rgb(254 243 242 / 0.95);
}

.hover\\:bg-danger-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-500\\/0:hover{
  background-color: rgb(240 68 56 / 0);
}

.hover\\:bg-danger-500\\/10:hover{
  background-color: rgb(240 68 56 / 0.1);
}

.hover\\:bg-danger-500\\/100:hover{
  background-color: rgb(240 68 56 / 1);
}

.hover\\:bg-danger-500\\/15:hover{
  background-color: rgb(240 68 56 / 0.15);
}

.hover\\:bg-danger-500\\/20:hover{
  background-color: rgb(240 68 56 / 0.2);
}

.hover\\:bg-danger-500\\/25:hover{
  background-color: rgb(240 68 56 / 0.25);
}

.hover\\:bg-danger-500\\/30:hover{
  background-color: rgb(240 68 56 / 0.3);
}

.hover\\:bg-danger-500\\/35:hover{
  background-color: rgb(240 68 56 / 0.35);
}

.hover\\:bg-danger-500\\/40:hover{
  background-color: rgb(240 68 56 / 0.4);
}

.hover\\:bg-danger-500\\/45:hover{
  background-color: rgb(240 68 56 / 0.45);
}

.hover\\:bg-danger-500\\/5:hover{
  background-color: rgb(240 68 56 / 0.05);
}

.hover\\:bg-danger-500\\/50:hover{
  background-color: rgb(240 68 56 / 0.5);
}

.hover\\:bg-danger-500\\/55:hover{
  background-color: rgb(240 68 56 / 0.55);
}

.hover\\:bg-danger-500\\/60:hover{
  background-color: rgb(240 68 56 / 0.6);
}

.hover\\:bg-danger-500\\/65:hover{
  background-color: rgb(240 68 56 / 0.65);
}

.hover\\:bg-danger-500\\/70:hover{
  background-color: rgb(240 68 56 / 0.7);
}

.hover\\:bg-danger-500\\/75:hover{
  background-color: rgb(240 68 56 / 0.75);
}

.hover\\:bg-danger-500\\/80:hover{
  background-color: rgb(240 68 56 / 0.8);
}

.hover\\:bg-danger-500\\/85:hover{
  background-color: rgb(240 68 56 / 0.85);
}

.hover\\:bg-danger-500\\/90:hover{
  background-color: rgb(240 68 56 / 0.9);
}

.hover\\:bg-danger-500\\/95:hover{
  background-color: rgb(240 68 56 / 0.95);
}

.hover\\:bg-danger-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-600\\/0:hover{
  background-color: rgb(217 45 32 / 0);
}

.hover\\:bg-danger-600\\/10:hover{
  background-color: rgb(217 45 32 / 0.1);
}

.hover\\:bg-danger-600\\/100:hover{
  background-color: rgb(217 45 32 / 1);
}

.hover\\:bg-danger-600\\/15:hover{
  background-color: rgb(217 45 32 / 0.15);
}

.hover\\:bg-danger-600\\/20:hover{
  background-color: rgb(217 45 32 / 0.2);
}

.hover\\:bg-danger-600\\/25:hover{
  background-color: rgb(217 45 32 / 0.25);
}

.hover\\:bg-danger-600\\/30:hover{
  background-color: rgb(217 45 32 / 0.3);
}

.hover\\:bg-danger-600\\/35:hover{
  background-color: rgb(217 45 32 / 0.35);
}

.hover\\:bg-danger-600\\/40:hover{
  background-color: rgb(217 45 32 / 0.4);
}

.hover\\:bg-danger-600\\/45:hover{
  background-color: rgb(217 45 32 / 0.45);
}

.hover\\:bg-danger-600\\/5:hover{
  background-color: rgb(217 45 32 / 0.05);
}

.hover\\:bg-danger-600\\/50:hover{
  background-color: rgb(217 45 32 / 0.5);
}

.hover\\:bg-danger-600\\/55:hover{
  background-color: rgb(217 45 32 / 0.55);
}

.hover\\:bg-danger-600\\/60:hover{
  background-color: rgb(217 45 32 / 0.6);
}

.hover\\:bg-danger-600\\/65:hover{
  background-color: rgb(217 45 32 / 0.65);
}

.hover\\:bg-danger-600\\/70:hover{
  background-color: rgb(217 45 32 / 0.7);
}

.hover\\:bg-danger-600\\/75:hover{
  background-color: rgb(217 45 32 / 0.75);
}

.hover\\:bg-danger-600\\/80:hover{
  background-color: rgb(217 45 32 / 0.8);
}

.hover\\:bg-danger-600\\/85:hover{
  background-color: rgb(217 45 32 / 0.85);
}

.hover\\:bg-danger-600\\/90:hover{
  background-color: rgb(217 45 32 / 0.9);
}

.hover\\:bg-danger-600\\/95:hover{
  background-color: rgb(217 45 32 / 0.95);
}

.hover\\:bg-danger-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-danger-700\\/0:hover{
  background-color: rgb(180 35 24 / 0);
}

.hover\\:bg-danger-700\\/10:hover{
  background-color: rgb(180 35 24 / 0.1);
}

.hover\\:bg-danger-700\\/100:hover{
  background-color: rgb(180 35 24 / 1);
}

.hover\\:bg-danger-700\\/15:hover{
  background-color: rgb(180 35 24 / 0.15);
}

.hover\\:bg-danger-700\\/20:hover{
  background-color: rgb(180 35 24 / 0.2);
}

.hover\\:bg-danger-700\\/25:hover{
  background-color: rgb(180 35 24 / 0.25);
}

.hover\\:bg-danger-700\\/30:hover{
  background-color: rgb(180 35 24 / 0.3);
}

.hover\\:bg-danger-700\\/35:hover{
  background-color: rgb(180 35 24 / 0.35);
}

.hover\\:bg-danger-700\\/40:hover{
  background-color: rgb(180 35 24 / 0.4);
}

.hover\\:bg-danger-700\\/45:hover{
  background-color: rgb(180 35 24 / 0.45);
}

.hover\\:bg-danger-700\\/5:hover{
  background-color: rgb(180 35 24 / 0.05);
}

.hover\\:bg-danger-700\\/50:hover{
  background-color: rgb(180 35 24 / 0.5);
}

.hover\\:bg-danger-700\\/55:hover{
  background-color: rgb(180 35 24 / 0.55);
}

.hover\\:bg-danger-700\\/60:hover{
  background-color: rgb(180 35 24 / 0.6);
}

.hover\\:bg-danger-700\\/65:hover{
  background-color: rgb(180 35 24 / 0.65);
}

.hover\\:bg-danger-700\\/70:hover{
  background-color: rgb(180 35 24 / 0.7);
}

.hover\\:bg-danger-700\\/75:hover{
  background-color: rgb(180 35 24 / 0.75);
}

.hover\\:bg-danger-700\\/80:hover{
  background-color: rgb(180 35 24 / 0.8);
}

.hover\\:bg-danger-700\\/85:hover{
  background-color: rgb(180 35 24 / 0.85);
}

.hover\\:bg-danger-700\\/90:hover{
  background-color: rgb(180 35 24 / 0.9);
}

.hover\\:bg-danger-700\\/95:hover{
  background-color: rgb(180 35 24 / 0.95);
}

.hover\\:bg-moss-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(230 244 215 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-100\\/0:hover{
  background-color: rgb(230 244 215 / 0);
}

.hover\\:bg-moss-100\\/10:hover{
  background-color: rgb(230 244 215 / 0.1);
}

.hover\\:bg-moss-100\\/100:hover{
  background-color: rgb(230 244 215 / 1);
}

.hover\\:bg-moss-100\\/15:hover{
  background-color: rgb(230 244 215 / 0.15);
}

.hover\\:bg-moss-100\\/20:hover{
  background-color: rgb(230 244 215 / 0.2);
}

.hover\\:bg-moss-100\\/25:hover{
  background-color: rgb(230 244 215 / 0.25);
}

.hover\\:bg-moss-100\\/30:hover{
  background-color: rgb(230 244 215 / 0.3);
}

.hover\\:bg-moss-100\\/35:hover{
  background-color: rgb(230 244 215 / 0.35);
}

.hover\\:bg-moss-100\\/40:hover{
  background-color: rgb(230 244 215 / 0.4);
}

.hover\\:bg-moss-100\\/45:hover{
  background-color: rgb(230 244 215 / 0.45);
}

.hover\\:bg-moss-100\\/5:hover{
  background-color: rgb(230 244 215 / 0.05);
}

.hover\\:bg-moss-100\\/50:hover{
  background-color: rgb(230 244 215 / 0.5);
}

.hover\\:bg-moss-100\\/55:hover{
  background-color: rgb(230 244 215 / 0.55);
}

.hover\\:bg-moss-100\\/60:hover{
  background-color: rgb(230 244 215 / 0.6);
}

.hover\\:bg-moss-100\\/65:hover{
  background-color: rgb(230 244 215 / 0.65);
}

.hover\\:bg-moss-100\\/70:hover{
  background-color: rgb(230 244 215 / 0.7);
}

.hover\\:bg-moss-100\\/75:hover{
  background-color: rgb(230 244 215 / 0.75);
}

.hover\\:bg-moss-100\\/80:hover{
  background-color: rgb(230 244 215 / 0.8);
}

.hover\\:bg-moss-100\\/85:hover{
  background-color: rgb(230 244 215 / 0.85);
}

.hover\\:bg-moss-100\\/90:hover{
  background-color: rgb(230 244 215 / 0.9);
}

.hover\\:bg-moss-100\\/95:hover{
  background-color: rgb(230 244 215 / 0.95);
}

.hover\\:bg-moss-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(206 234 176 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-200\\/0:hover{
  background-color: rgb(206 234 176 / 0);
}

.hover\\:bg-moss-200\\/10:hover{
  background-color: rgb(206 234 176 / 0.1);
}

.hover\\:bg-moss-200\\/100:hover{
  background-color: rgb(206 234 176 / 1);
}

.hover\\:bg-moss-200\\/15:hover{
  background-color: rgb(206 234 176 / 0.15);
}

.hover\\:bg-moss-200\\/20:hover{
  background-color: rgb(206 234 176 / 0.2);
}

.hover\\:bg-moss-200\\/25:hover{
  background-color: rgb(206 234 176 / 0.25);
}

.hover\\:bg-moss-200\\/30:hover{
  background-color: rgb(206 234 176 / 0.3);
}

.hover\\:bg-moss-200\\/35:hover{
  background-color: rgb(206 234 176 / 0.35);
}

.hover\\:bg-moss-200\\/40:hover{
  background-color: rgb(206 234 176 / 0.4);
}

.hover\\:bg-moss-200\\/45:hover{
  background-color: rgb(206 234 176 / 0.45);
}

.hover\\:bg-moss-200\\/5:hover{
  background-color: rgb(206 234 176 / 0.05);
}

.hover\\:bg-moss-200\\/50:hover{
  background-color: rgb(206 234 176 / 0.5);
}

.hover\\:bg-moss-200\\/55:hover{
  background-color: rgb(206 234 176 / 0.55);
}

.hover\\:bg-moss-200\\/60:hover{
  background-color: rgb(206 234 176 / 0.6);
}

.hover\\:bg-moss-200\\/65:hover{
  background-color: rgb(206 234 176 / 0.65);
}

.hover\\:bg-moss-200\\/70:hover{
  background-color: rgb(206 234 176 / 0.7);
}

.hover\\:bg-moss-200\\/75:hover{
  background-color: rgb(206 234 176 / 0.75);
}

.hover\\:bg-moss-200\\/80:hover{
  background-color: rgb(206 234 176 / 0.8);
}

.hover\\:bg-moss-200\\/85:hover{
  background-color: rgb(206 234 176 / 0.85);
}

.hover\\:bg-moss-200\\/90:hover{
  background-color: rgb(206 234 176 / 0.9);
}

.hover\\:bg-moss-200\\/95:hover{
  background-color: rgb(206 234 176 / 0.95);
}

.hover\\:bg-moss-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 253 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-25\\/0:hover{
  background-color: rgb(250 253 247 / 0);
}

.hover\\:bg-moss-25\\/10:hover{
  background-color: rgb(250 253 247 / 0.1);
}

.hover\\:bg-moss-25\\/100:hover{
  background-color: rgb(250 253 247 / 1);
}

.hover\\:bg-moss-25\\/15:hover{
  background-color: rgb(250 253 247 / 0.15);
}

.hover\\:bg-moss-25\\/20:hover{
  background-color: rgb(250 253 247 / 0.2);
}

.hover\\:bg-moss-25\\/25:hover{
  background-color: rgb(250 253 247 / 0.25);
}

.hover\\:bg-moss-25\\/30:hover{
  background-color: rgb(250 253 247 / 0.3);
}

.hover\\:bg-moss-25\\/35:hover{
  background-color: rgb(250 253 247 / 0.35);
}

.hover\\:bg-moss-25\\/40:hover{
  background-color: rgb(250 253 247 / 0.4);
}

.hover\\:bg-moss-25\\/45:hover{
  background-color: rgb(250 253 247 / 0.45);
}

.hover\\:bg-moss-25\\/5:hover{
  background-color: rgb(250 253 247 / 0.05);
}

.hover\\:bg-moss-25\\/50:hover{
  background-color: rgb(250 253 247 / 0.5);
}

.hover\\:bg-moss-25\\/55:hover{
  background-color: rgb(250 253 247 / 0.55);
}

.hover\\:bg-moss-25\\/60:hover{
  background-color: rgb(250 253 247 / 0.6);
}

.hover\\:bg-moss-25\\/65:hover{
  background-color: rgb(250 253 247 / 0.65);
}

.hover\\:bg-moss-25\\/70:hover{
  background-color: rgb(250 253 247 / 0.7);
}

.hover\\:bg-moss-25\\/75:hover{
  background-color: rgb(250 253 247 / 0.75);
}

.hover\\:bg-moss-25\\/80:hover{
  background-color: rgb(250 253 247 / 0.8);
}

.hover\\:bg-moss-25\\/85:hover{
  background-color: rgb(250 253 247 / 0.85);
}

.hover\\:bg-moss-25\\/90:hover{
  background-color: rgb(250 253 247 / 0.9);
}

.hover\\:bg-moss-25\\/95:hover{
  background-color: rgb(250 253 247 / 0.95);
}

.hover\\:bg-moss-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(134 203 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-400\\/0:hover{
  background-color: rgb(134 203 60 / 0);
}

.hover\\:bg-moss-400\\/10:hover{
  background-color: rgb(134 203 60 / 0.1);
}

.hover\\:bg-moss-400\\/100:hover{
  background-color: rgb(134 203 60 / 1);
}

.hover\\:bg-moss-400\\/15:hover{
  background-color: rgb(134 203 60 / 0.15);
}

.hover\\:bg-moss-400\\/20:hover{
  background-color: rgb(134 203 60 / 0.2);
}

.hover\\:bg-moss-400\\/25:hover{
  background-color: rgb(134 203 60 / 0.25);
}

.hover\\:bg-moss-400\\/30:hover{
  background-color: rgb(134 203 60 / 0.3);
}

.hover\\:bg-moss-400\\/35:hover{
  background-color: rgb(134 203 60 / 0.35);
}

.hover\\:bg-moss-400\\/40:hover{
  background-color: rgb(134 203 60 / 0.4);
}

.hover\\:bg-moss-400\\/45:hover{
  background-color: rgb(134 203 60 / 0.45);
}

.hover\\:bg-moss-400\\/5:hover{
  background-color: rgb(134 203 60 / 0.05);
}

.hover\\:bg-moss-400\\/50:hover{
  background-color: rgb(134 203 60 / 0.5);
}

.hover\\:bg-moss-400\\/55:hover{
  background-color: rgb(134 203 60 / 0.55);
}

.hover\\:bg-moss-400\\/60:hover{
  background-color: rgb(134 203 60 / 0.6);
}

.hover\\:bg-moss-400\\/65:hover{
  background-color: rgb(134 203 60 / 0.65);
}

.hover\\:bg-moss-400\\/70:hover{
  background-color: rgb(134 203 60 / 0.7);
}

.hover\\:bg-moss-400\\/75:hover{
  background-color: rgb(134 203 60 / 0.75);
}

.hover\\:bg-moss-400\\/80:hover{
  background-color: rgb(134 203 60 / 0.8);
}

.hover\\:bg-moss-400\\/85:hover{
  background-color: rgb(134 203 60 / 0.85);
}

.hover\\:bg-moss-400\\/90:hover{
  background-color: rgb(134 203 60 / 0.9);
}

.hover\\:bg-moss-400\\/95:hover{
  background-color: rgb(134 203 60 / 0.95);
}

.hover\\:bg-moss-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 238 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-50\\/0:hover{
  background-color: rgb(245 251 238 / 0);
}

.hover\\:bg-moss-50\\/10:hover{
  background-color: rgb(245 251 238 / 0.1);
}

.hover\\:bg-moss-50\\/100:hover{
  background-color: rgb(245 251 238 / 1);
}

.hover\\:bg-moss-50\\/15:hover{
  background-color: rgb(245 251 238 / 0.15);
}

.hover\\:bg-moss-50\\/20:hover{
  background-color: rgb(245 251 238 / 0.2);
}

.hover\\:bg-moss-50\\/25:hover{
  background-color: rgb(245 251 238 / 0.25);
}

.hover\\:bg-moss-50\\/30:hover{
  background-color: rgb(245 251 238 / 0.3);
}

.hover\\:bg-moss-50\\/35:hover{
  background-color: rgb(245 251 238 / 0.35);
}

.hover\\:bg-moss-50\\/40:hover{
  background-color: rgb(245 251 238 / 0.4);
}

.hover\\:bg-moss-50\\/45:hover{
  background-color: rgb(245 251 238 / 0.45);
}

.hover\\:bg-moss-50\\/5:hover{
  background-color: rgb(245 251 238 / 0.05);
}

.hover\\:bg-moss-50\\/50:hover{
  background-color: rgb(245 251 238 / 0.5);
}

.hover\\:bg-moss-50\\/55:hover{
  background-color: rgb(245 251 238 / 0.55);
}

.hover\\:bg-moss-50\\/60:hover{
  background-color: rgb(245 251 238 / 0.6);
}

.hover\\:bg-moss-50\\/65:hover{
  background-color: rgb(245 251 238 / 0.65);
}

.hover\\:bg-moss-50\\/70:hover{
  background-color: rgb(245 251 238 / 0.7);
}

.hover\\:bg-moss-50\\/75:hover{
  background-color: rgb(245 251 238 / 0.75);
}

.hover\\:bg-moss-50\\/80:hover{
  background-color: rgb(245 251 238 / 0.8);
}

.hover\\:bg-moss-50\\/85:hover{
  background-color: rgb(245 251 238 / 0.85);
}

.hover\\:bg-moss-50\\/90:hover{
  background-color: rgb(245 251 238 / 0.9);
}

.hover\\:bg-moss-50\\/95:hover{
  background-color: rgb(245 251 238 / 0.95);
}

.hover\\:bg-moss-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(102 159 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-500\\/0:hover{
  background-color: rgb(102 159 42 / 0);
}

.hover\\:bg-moss-500\\/10:hover{
  background-color: rgb(102 159 42 / 0.1);
}

.hover\\:bg-moss-500\\/100:hover{
  background-color: rgb(102 159 42 / 1);
}

.hover\\:bg-moss-500\\/15:hover{
  background-color: rgb(102 159 42 / 0.15);
}

.hover\\:bg-moss-500\\/20:hover{
  background-color: rgb(102 159 42 / 0.2);
}

.hover\\:bg-moss-500\\/25:hover{
  background-color: rgb(102 159 42 / 0.25);
}

.hover\\:bg-moss-500\\/30:hover{
  background-color: rgb(102 159 42 / 0.3);
}

.hover\\:bg-moss-500\\/35:hover{
  background-color: rgb(102 159 42 / 0.35);
}

.hover\\:bg-moss-500\\/40:hover{
  background-color: rgb(102 159 42 / 0.4);
}

.hover\\:bg-moss-500\\/45:hover{
  background-color: rgb(102 159 42 / 0.45);
}

.hover\\:bg-moss-500\\/5:hover{
  background-color: rgb(102 159 42 / 0.05);
}

.hover\\:bg-moss-500\\/50:hover{
  background-color: rgb(102 159 42 / 0.5);
}

.hover\\:bg-moss-500\\/55:hover{
  background-color: rgb(102 159 42 / 0.55);
}

.hover\\:bg-moss-500\\/60:hover{
  background-color: rgb(102 159 42 / 0.6);
}

.hover\\:bg-moss-500\\/65:hover{
  background-color: rgb(102 159 42 / 0.65);
}

.hover\\:bg-moss-500\\/70:hover{
  background-color: rgb(102 159 42 / 0.7);
}

.hover\\:bg-moss-500\\/75:hover{
  background-color: rgb(102 159 42 / 0.75);
}

.hover\\:bg-moss-500\\/80:hover{
  background-color: rgb(102 159 42 / 0.8);
}

.hover\\:bg-moss-500\\/85:hover{
  background-color: rgb(102 159 42 / 0.85);
}

.hover\\:bg-moss-500\\/90:hover{
  background-color: rgb(102 159 42 / 0.9);
}

.hover\\:bg-moss-500\\/95:hover{
  background-color: rgb(102 159 42 / 0.95);
}

.hover\\:bg-moss-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(79 122 33 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-600\\/0:hover{
  background-color: rgb(79 122 33 / 0);
}

.hover\\:bg-moss-600\\/10:hover{
  background-color: rgb(79 122 33 / 0.1);
}

.hover\\:bg-moss-600\\/100:hover{
  background-color: rgb(79 122 33 / 1);
}

.hover\\:bg-moss-600\\/15:hover{
  background-color: rgb(79 122 33 / 0.15);
}

.hover\\:bg-moss-600\\/20:hover{
  background-color: rgb(79 122 33 / 0.2);
}

.hover\\:bg-moss-600\\/25:hover{
  background-color: rgb(79 122 33 / 0.25);
}

.hover\\:bg-moss-600\\/30:hover{
  background-color: rgb(79 122 33 / 0.3);
}

.hover\\:bg-moss-600\\/35:hover{
  background-color: rgb(79 122 33 / 0.35);
}

.hover\\:bg-moss-600\\/40:hover{
  background-color: rgb(79 122 33 / 0.4);
}

.hover\\:bg-moss-600\\/45:hover{
  background-color: rgb(79 122 33 / 0.45);
}

.hover\\:bg-moss-600\\/5:hover{
  background-color: rgb(79 122 33 / 0.05);
}

.hover\\:bg-moss-600\\/50:hover{
  background-color: rgb(79 122 33 / 0.5);
}

.hover\\:bg-moss-600\\/55:hover{
  background-color: rgb(79 122 33 / 0.55);
}

.hover\\:bg-moss-600\\/60:hover{
  background-color: rgb(79 122 33 / 0.6);
}

.hover\\:bg-moss-600\\/65:hover{
  background-color: rgb(79 122 33 / 0.65);
}

.hover\\:bg-moss-600\\/70:hover{
  background-color: rgb(79 122 33 / 0.7);
}

.hover\\:bg-moss-600\\/75:hover{
  background-color: rgb(79 122 33 / 0.75);
}

.hover\\:bg-moss-600\\/80:hover{
  background-color: rgb(79 122 33 / 0.8);
}

.hover\\:bg-moss-600\\/85:hover{
  background-color: rgb(79 122 33 / 0.85);
}

.hover\\:bg-moss-600\\/90:hover{
  background-color: rgb(79 122 33 / 0.9);
}

.hover\\:bg-moss-600\\/95:hover{
  background-color: rgb(79 122 33 / 0.95);
}

.hover\\:bg-moss-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 26 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-moss-700\\/0:hover{
  background-color: rgb(63 98 26 / 0);
}

.hover\\:bg-moss-700\\/10:hover{
  background-color: rgb(63 98 26 / 0.1);
}

.hover\\:bg-moss-700\\/100:hover{
  background-color: rgb(63 98 26 / 1);
}

.hover\\:bg-moss-700\\/15:hover{
  background-color: rgb(63 98 26 / 0.15);
}

.hover\\:bg-moss-700\\/20:hover{
  background-color: rgb(63 98 26 / 0.2);
}

.hover\\:bg-moss-700\\/25:hover{
  background-color: rgb(63 98 26 / 0.25);
}

.hover\\:bg-moss-700\\/30:hover{
  background-color: rgb(63 98 26 / 0.3);
}

.hover\\:bg-moss-700\\/35:hover{
  background-color: rgb(63 98 26 / 0.35);
}

.hover\\:bg-moss-700\\/40:hover{
  background-color: rgb(63 98 26 / 0.4);
}

.hover\\:bg-moss-700\\/45:hover{
  background-color: rgb(63 98 26 / 0.45);
}

.hover\\:bg-moss-700\\/5:hover{
  background-color: rgb(63 98 26 / 0.05);
}

.hover\\:bg-moss-700\\/50:hover{
  background-color: rgb(63 98 26 / 0.5);
}

.hover\\:bg-moss-700\\/55:hover{
  background-color: rgb(63 98 26 / 0.55);
}

.hover\\:bg-moss-700\\/60:hover{
  background-color: rgb(63 98 26 / 0.6);
}

.hover\\:bg-moss-700\\/65:hover{
  background-color: rgb(63 98 26 / 0.65);
}

.hover\\:bg-moss-700\\/70:hover{
  background-color: rgb(63 98 26 / 0.7);
}

.hover\\:bg-moss-700\\/75:hover{
  background-color: rgb(63 98 26 / 0.75);
}

.hover\\:bg-moss-700\\/80:hover{
  background-color: rgb(63 98 26 / 0.8);
}

.hover\\:bg-moss-700\\/85:hover{
  background-color: rgb(63 98 26 / 0.85);
}

.hover\\:bg-moss-700\\/90:hover{
  background-color: rgb(63 98 26 / 0.9);
}

.hover\\:bg-moss-700\\/95:hover{
  background-color: rgb(63 98 26 / 0.95);
}

.hover\\:bg-neutral-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-100\\/0:hover{
  background-color: rgb(245 245 245 / 0);
}

.hover\\:bg-neutral-100\\/10:hover{
  background-color: rgb(245 245 245 / 0.1);
}

.hover\\:bg-neutral-100\\/100:hover{
  background-color: rgb(245 245 245 / 1);
}

.hover\\:bg-neutral-100\\/15:hover{
  background-color: rgb(245 245 245 / 0.15);
}

.hover\\:bg-neutral-100\\/20:hover{
  background-color: rgb(245 245 245 / 0.2);
}

.hover\\:bg-neutral-100\\/25:hover{
  background-color: rgb(245 245 245 / 0.25);
}

.hover\\:bg-neutral-100\\/30:hover{
  background-color: rgb(245 245 245 / 0.3);
}

.hover\\:bg-neutral-100\\/35:hover{
  background-color: rgb(245 245 245 / 0.35);
}

.hover\\:bg-neutral-100\\/40:hover{
  background-color: rgb(245 245 245 / 0.4);
}

.hover\\:bg-neutral-100\\/45:hover{
  background-color: rgb(245 245 245 / 0.45);
}

.hover\\:bg-neutral-100\\/5:hover{
  background-color: rgb(245 245 245 / 0.05);
}

.hover\\:bg-neutral-100\\/50:hover{
  background-color: rgb(245 245 245 / 0.5);
}

.hover\\:bg-neutral-100\\/55:hover{
  background-color: rgb(245 245 245 / 0.55);
}

.hover\\:bg-neutral-100\\/60:hover{
  background-color: rgb(245 245 245 / 0.6);
}

.hover\\:bg-neutral-100\\/65:hover{
  background-color: rgb(245 245 245 / 0.65);
}

.hover\\:bg-neutral-100\\/70:hover{
  background-color: rgb(245 245 245 / 0.7);
}

.hover\\:bg-neutral-100\\/75:hover{
  background-color: rgb(245 245 245 / 0.75);
}

.hover\\:bg-neutral-100\\/80:hover{
  background-color: rgb(245 245 245 / 0.8);
}

.hover\\:bg-neutral-100\\/85:hover{
  background-color: rgb(245 245 245 / 0.85);
}

.hover\\:bg-neutral-100\\/90:hover{
  background-color: rgb(245 245 245 / 0.9);
}

.hover\\:bg-neutral-100\\/95:hover{
  background-color: rgb(245 245 245 / 0.95);
}

.hover\\:bg-neutral-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-200\\/0:hover{
  background-color: rgb(233 234 235 / 0);
}

.hover\\:bg-neutral-200\\/10:hover{
  background-color: rgb(233 234 235 / 0.1);
}

.hover\\:bg-neutral-200\\/100:hover{
  background-color: rgb(233 234 235 / 1);
}

.hover\\:bg-neutral-200\\/15:hover{
  background-color: rgb(233 234 235 / 0.15);
}

.hover\\:bg-neutral-200\\/20:hover{
  background-color: rgb(233 234 235 / 0.2);
}

.hover\\:bg-neutral-200\\/25:hover{
  background-color: rgb(233 234 235 / 0.25);
}

.hover\\:bg-neutral-200\\/30:hover{
  background-color: rgb(233 234 235 / 0.3);
}

.hover\\:bg-neutral-200\\/35:hover{
  background-color: rgb(233 234 235 / 0.35);
}

.hover\\:bg-neutral-200\\/40:hover{
  background-color: rgb(233 234 235 / 0.4);
}

.hover\\:bg-neutral-200\\/45:hover{
  background-color: rgb(233 234 235 / 0.45);
}

.hover\\:bg-neutral-200\\/5:hover{
  background-color: rgb(233 234 235 / 0.05);
}

.hover\\:bg-neutral-200\\/50:hover{
  background-color: rgb(233 234 235 / 0.5);
}

.hover\\:bg-neutral-200\\/55:hover{
  background-color: rgb(233 234 235 / 0.55);
}

.hover\\:bg-neutral-200\\/60:hover{
  background-color: rgb(233 234 235 / 0.6);
}

.hover\\:bg-neutral-200\\/65:hover{
  background-color: rgb(233 234 235 / 0.65);
}

.hover\\:bg-neutral-200\\/70:hover{
  background-color: rgb(233 234 235 / 0.7);
}

.hover\\:bg-neutral-200\\/75:hover{
  background-color: rgb(233 234 235 / 0.75);
}

.hover\\:bg-neutral-200\\/80:hover{
  background-color: rgb(233 234 235 / 0.8);
}

.hover\\:bg-neutral-200\\/85:hover{
  background-color: rgb(233 234 235 / 0.85);
}

.hover\\:bg-neutral-200\\/90:hover{
  background-color: rgb(233 234 235 / 0.9);
}

.hover\\:bg-neutral-200\\/95:hover{
  background-color: rgb(233 234 235 / 0.95);
}

.hover\\:bg-neutral-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-25\\/0:hover{
  background-color: rgb(253 253 253 / 0);
}

.hover\\:bg-neutral-25\\/10:hover{
  background-color: rgb(253 253 253 / 0.1);
}

.hover\\:bg-neutral-25\\/100:hover{
  background-color: rgb(253 253 253 / 1);
}

.hover\\:bg-neutral-25\\/15:hover{
  background-color: rgb(253 253 253 / 0.15);
}

.hover\\:bg-neutral-25\\/20:hover{
  background-color: rgb(253 253 253 / 0.2);
}

.hover\\:bg-neutral-25\\/25:hover{
  background-color: rgb(253 253 253 / 0.25);
}

.hover\\:bg-neutral-25\\/30:hover{
  background-color: rgb(253 253 253 / 0.3);
}

.hover\\:bg-neutral-25\\/35:hover{
  background-color: rgb(253 253 253 / 0.35);
}

.hover\\:bg-neutral-25\\/40:hover{
  background-color: rgb(253 253 253 / 0.4);
}

.hover\\:bg-neutral-25\\/45:hover{
  background-color: rgb(253 253 253 / 0.45);
}

.hover\\:bg-neutral-25\\/5:hover{
  background-color: rgb(253 253 253 / 0.05);
}

.hover\\:bg-neutral-25\\/50:hover{
  background-color: rgb(253 253 253 / 0.5);
}

.hover\\:bg-neutral-25\\/55:hover{
  background-color: rgb(253 253 253 / 0.55);
}

.hover\\:bg-neutral-25\\/60:hover{
  background-color: rgb(253 253 253 / 0.6);
}

.hover\\:bg-neutral-25\\/65:hover{
  background-color: rgb(253 253 253 / 0.65);
}

.hover\\:bg-neutral-25\\/70:hover{
  background-color: rgb(253 253 253 / 0.7);
}

.hover\\:bg-neutral-25\\/75:hover{
  background-color: rgb(253 253 253 / 0.75);
}

.hover\\:bg-neutral-25\\/80:hover{
  background-color: rgb(253 253 253 / 0.8);
}

.hover\\:bg-neutral-25\\/85:hover{
  background-color: rgb(253 253 253 / 0.85);
}

.hover\\:bg-neutral-25\\/90:hover{
  background-color: rgb(253 253 253 / 0.9);
}

.hover\\:bg-neutral-25\\/95:hover{
  background-color: rgb(253 253 253 / 0.95);
}

.hover\\:bg-neutral-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-400\\/0:hover{
  background-color: rgb(164 167 174 / 0);
}

.hover\\:bg-neutral-400\\/10:hover{
  background-color: rgb(164 167 174 / 0.1);
}

.hover\\:bg-neutral-400\\/100:hover{
  background-color: rgb(164 167 174 / 1);
}

.hover\\:bg-neutral-400\\/15:hover{
  background-color: rgb(164 167 174 / 0.15);
}

.hover\\:bg-neutral-400\\/20:hover{
  background-color: rgb(164 167 174 / 0.2);
}

.hover\\:bg-neutral-400\\/25:hover{
  background-color: rgb(164 167 174 / 0.25);
}

.hover\\:bg-neutral-400\\/30:hover{
  background-color: rgb(164 167 174 / 0.3);
}

.hover\\:bg-neutral-400\\/35:hover{
  background-color: rgb(164 167 174 / 0.35);
}

.hover\\:bg-neutral-400\\/40:hover{
  background-color: rgb(164 167 174 / 0.4);
}

.hover\\:bg-neutral-400\\/45:hover{
  background-color: rgb(164 167 174 / 0.45);
}

.hover\\:bg-neutral-400\\/5:hover{
  background-color: rgb(164 167 174 / 0.05);
}

.hover\\:bg-neutral-400\\/50:hover{
  background-color: rgb(164 167 174 / 0.5);
}

.hover\\:bg-neutral-400\\/55:hover{
  background-color: rgb(164 167 174 / 0.55);
}

.hover\\:bg-neutral-400\\/60:hover{
  background-color: rgb(164 167 174 / 0.6);
}

.hover\\:bg-neutral-400\\/65:hover{
  background-color: rgb(164 167 174 / 0.65);
}

.hover\\:bg-neutral-400\\/70:hover{
  background-color: rgb(164 167 174 / 0.7);
}

.hover\\:bg-neutral-400\\/75:hover{
  background-color: rgb(164 167 174 / 0.75);
}

.hover\\:bg-neutral-400\\/80:hover{
  background-color: rgb(164 167 174 / 0.8);
}

.hover\\:bg-neutral-400\\/85:hover{
  background-color: rgb(164 167 174 / 0.85);
}

.hover\\:bg-neutral-400\\/90:hover{
  background-color: rgb(164 167 174 / 0.9);
}

.hover\\:bg-neutral-400\\/95:hover{
  background-color: rgb(164 167 174 / 0.95);
}

.hover\\:bg-neutral-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-50\\/0:hover{
  background-color: rgb(249 250 250 / 0);
}

.hover\\:bg-neutral-50\\/10:hover{
  background-color: rgb(249 250 250 / 0.1);
}

.hover\\:bg-neutral-50\\/100:hover{
  background-color: rgb(249 250 250 / 1);
}

.hover\\:bg-neutral-50\\/15:hover{
  background-color: rgb(249 250 250 / 0.15);
}

.hover\\:bg-neutral-50\\/20:hover{
  background-color: rgb(249 250 250 / 0.2);
}

.hover\\:bg-neutral-50\\/25:hover{
  background-color: rgb(249 250 250 / 0.25);
}

.hover\\:bg-neutral-50\\/30:hover{
  background-color: rgb(249 250 250 / 0.3);
}

.hover\\:bg-neutral-50\\/35:hover{
  background-color: rgb(249 250 250 / 0.35);
}

.hover\\:bg-neutral-50\\/40:hover{
  background-color: rgb(249 250 250 / 0.4);
}

.hover\\:bg-neutral-50\\/45:hover{
  background-color: rgb(249 250 250 / 0.45);
}

.hover\\:bg-neutral-50\\/5:hover{
  background-color: rgb(249 250 250 / 0.05);
}

.hover\\:bg-neutral-50\\/50:hover{
  background-color: rgb(249 250 250 / 0.5);
}

.hover\\:bg-neutral-50\\/55:hover{
  background-color: rgb(249 250 250 / 0.55);
}

.hover\\:bg-neutral-50\\/60:hover{
  background-color: rgb(249 250 250 / 0.6);
}

.hover\\:bg-neutral-50\\/65:hover{
  background-color: rgb(249 250 250 / 0.65);
}

.hover\\:bg-neutral-50\\/70:hover{
  background-color: rgb(249 250 250 / 0.7);
}

.hover\\:bg-neutral-50\\/75:hover{
  background-color: rgb(249 250 250 / 0.75);
}

.hover\\:bg-neutral-50\\/80:hover{
  background-color: rgb(249 250 250 / 0.8);
}

.hover\\:bg-neutral-50\\/85:hover{
  background-color: rgb(249 250 250 / 0.85);
}

.hover\\:bg-neutral-50\\/90:hover{
  background-color: rgb(249 250 250 / 0.9);
}

.hover\\:bg-neutral-50\\/95:hover{
  background-color: rgb(249 250 250 / 0.95);
}

.hover\\:bg-neutral-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-500\\/0:hover{
  background-color: rgb(113 118 128 / 0);
}

.hover\\:bg-neutral-500\\/10:hover{
  background-color: rgb(113 118 128 / 0.1);
}

.hover\\:bg-neutral-500\\/100:hover{
  background-color: rgb(113 118 128 / 1);
}

.hover\\:bg-neutral-500\\/15:hover{
  background-color: rgb(113 118 128 / 0.15);
}

.hover\\:bg-neutral-500\\/20:hover{
  background-color: rgb(113 118 128 / 0.2);
}

.hover\\:bg-neutral-500\\/25:hover{
  background-color: rgb(113 118 128 / 0.25);
}

.hover\\:bg-neutral-500\\/30:hover{
  background-color: rgb(113 118 128 / 0.3);
}

.hover\\:bg-neutral-500\\/35:hover{
  background-color: rgb(113 118 128 / 0.35);
}

.hover\\:bg-neutral-500\\/40:hover{
  background-color: rgb(113 118 128 / 0.4);
}

.hover\\:bg-neutral-500\\/45:hover{
  background-color: rgb(113 118 128 / 0.45);
}

.hover\\:bg-neutral-500\\/5:hover{
  background-color: rgb(113 118 128 / 0.05);
}

.hover\\:bg-neutral-500\\/50:hover{
  background-color: rgb(113 118 128 / 0.5);
}

.hover\\:bg-neutral-500\\/55:hover{
  background-color: rgb(113 118 128 / 0.55);
}

.hover\\:bg-neutral-500\\/60:hover{
  background-color: rgb(113 118 128 / 0.6);
}

.hover\\:bg-neutral-500\\/65:hover{
  background-color: rgb(113 118 128 / 0.65);
}

.hover\\:bg-neutral-500\\/70:hover{
  background-color: rgb(113 118 128 / 0.7);
}

.hover\\:bg-neutral-500\\/75:hover{
  background-color: rgb(113 118 128 / 0.75);
}

.hover\\:bg-neutral-500\\/80:hover{
  background-color: rgb(113 118 128 / 0.8);
}

.hover\\:bg-neutral-500\\/85:hover{
  background-color: rgb(113 118 128 / 0.85);
}

.hover\\:bg-neutral-500\\/90:hover{
  background-color: rgb(113 118 128 / 0.9);
}

.hover\\:bg-neutral-500\\/95:hover{
  background-color: rgb(113 118 128 / 0.95);
}

.hover\\:bg-neutral-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-600\\/0:hover{
  background-color: rgb(83 88 98 / 0);
}

.hover\\:bg-neutral-600\\/10:hover{
  background-color: rgb(83 88 98 / 0.1);
}

.hover\\:bg-neutral-600\\/100:hover{
  background-color: rgb(83 88 98 / 1);
}

.hover\\:bg-neutral-600\\/15:hover{
  background-color: rgb(83 88 98 / 0.15);
}

.hover\\:bg-neutral-600\\/20:hover{
  background-color: rgb(83 88 98 / 0.2);
}

.hover\\:bg-neutral-600\\/25:hover{
  background-color: rgb(83 88 98 / 0.25);
}

.hover\\:bg-neutral-600\\/30:hover{
  background-color: rgb(83 88 98 / 0.3);
}

.hover\\:bg-neutral-600\\/35:hover{
  background-color: rgb(83 88 98 / 0.35);
}

.hover\\:bg-neutral-600\\/40:hover{
  background-color: rgb(83 88 98 / 0.4);
}

.hover\\:bg-neutral-600\\/45:hover{
  background-color: rgb(83 88 98 / 0.45);
}

.hover\\:bg-neutral-600\\/5:hover{
  background-color: rgb(83 88 98 / 0.05);
}

.hover\\:bg-neutral-600\\/50:hover{
  background-color: rgb(83 88 98 / 0.5);
}

.hover\\:bg-neutral-600\\/55:hover{
  background-color: rgb(83 88 98 / 0.55);
}

.hover\\:bg-neutral-600\\/60:hover{
  background-color: rgb(83 88 98 / 0.6);
}

.hover\\:bg-neutral-600\\/65:hover{
  background-color: rgb(83 88 98 / 0.65);
}

.hover\\:bg-neutral-600\\/70:hover{
  background-color: rgb(83 88 98 / 0.7);
}

.hover\\:bg-neutral-600\\/75:hover{
  background-color: rgb(83 88 98 / 0.75);
}

.hover\\:bg-neutral-600\\/80:hover{
  background-color: rgb(83 88 98 / 0.8);
}

.hover\\:bg-neutral-600\\/85:hover{
  background-color: rgb(83 88 98 / 0.85);
}

.hover\\:bg-neutral-600\\/90:hover{
  background-color: rgb(83 88 98 / 0.9);
}

.hover\\:bg-neutral-600\\/95:hover{
  background-color: rgb(83 88 98 / 0.95);
}

.hover\\:bg-neutral-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-700\\/0:hover{
  background-color: rgb(65 70 81 / 0);
}

.hover\\:bg-neutral-700\\/10:hover{
  background-color: rgb(65 70 81 / 0.1);
}

.hover\\:bg-neutral-700\\/100:hover{
  background-color: rgb(65 70 81 / 1);
}

.hover\\:bg-neutral-700\\/15:hover{
  background-color: rgb(65 70 81 / 0.15);
}

.hover\\:bg-neutral-700\\/20:hover{
  background-color: rgb(65 70 81 / 0.2);
}

.hover\\:bg-neutral-700\\/25:hover{
  background-color: rgb(65 70 81 / 0.25);
}

.hover\\:bg-neutral-700\\/30:hover{
  background-color: rgb(65 70 81 / 0.3);
}

.hover\\:bg-neutral-700\\/35:hover{
  background-color: rgb(65 70 81 / 0.35);
}

.hover\\:bg-neutral-700\\/40:hover{
  background-color: rgb(65 70 81 / 0.4);
}

.hover\\:bg-neutral-700\\/45:hover{
  background-color: rgb(65 70 81 / 0.45);
}

.hover\\:bg-neutral-700\\/5:hover{
  background-color: rgb(65 70 81 / 0.05);
}

.hover\\:bg-neutral-700\\/50:hover{
  background-color: rgb(65 70 81 / 0.5);
}

.hover\\:bg-neutral-700\\/55:hover{
  background-color: rgb(65 70 81 / 0.55);
}

.hover\\:bg-neutral-700\\/60:hover{
  background-color: rgb(65 70 81 / 0.6);
}

.hover\\:bg-neutral-700\\/65:hover{
  background-color: rgb(65 70 81 / 0.65);
}

.hover\\:bg-neutral-700\\/70:hover{
  background-color: rgb(65 70 81 / 0.7);
}

.hover\\:bg-neutral-700\\/75:hover{
  background-color: rgb(65 70 81 / 0.75);
}

.hover\\:bg-neutral-700\\/80:hover{
  background-color: rgb(65 70 81 / 0.8);
}

.hover\\:bg-neutral-700\\/85:hover{
  background-color: rgb(65 70 81 / 0.85);
}

.hover\\:bg-neutral-700\\/90:hover{
  background-color: rgb(65 70 81 / 0.9);
}

.hover\\:bg-neutral-700\\/95:hover{
  background-color: rgb(65 70 81 / 0.95);
}

.hover\\:bg-neutral-75:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-75\\/0:hover{
  background-color: rgb(246 246 246 / 0);
}

.hover\\:bg-neutral-75\\/10:hover{
  background-color: rgb(246 246 246 / 0.1);
}

.hover\\:bg-neutral-75\\/100:hover{
  background-color: rgb(246 246 246 / 1);
}

.hover\\:bg-neutral-75\\/15:hover{
  background-color: rgb(246 246 246 / 0.15);
}

.hover\\:bg-neutral-75\\/20:hover{
  background-color: rgb(246 246 246 / 0.2);
}

.hover\\:bg-neutral-75\\/25:hover{
  background-color: rgb(246 246 246 / 0.25);
}

.hover\\:bg-neutral-75\\/30:hover{
  background-color: rgb(246 246 246 / 0.3);
}

.hover\\:bg-neutral-75\\/35:hover{
  background-color: rgb(246 246 246 / 0.35);
}

.hover\\:bg-neutral-75\\/40:hover{
  background-color: rgb(246 246 246 / 0.4);
}

.hover\\:bg-neutral-75\\/45:hover{
  background-color: rgb(246 246 246 / 0.45);
}

.hover\\:bg-neutral-75\\/5:hover{
  background-color: rgb(246 246 246 / 0.05);
}

.hover\\:bg-neutral-75\\/50:hover{
  background-color: rgb(246 246 246 / 0.5);
}

.hover\\:bg-neutral-75\\/55:hover{
  background-color: rgb(246 246 246 / 0.55);
}

.hover\\:bg-neutral-75\\/60:hover{
  background-color: rgb(246 246 246 / 0.6);
}

.hover\\:bg-neutral-75\\/65:hover{
  background-color: rgb(246 246 246 / 0.65);
}

.hover\\:bg-neutral-75\\/70:hover{
  background-color: rgb(246 246 246 / 0.7);
}

.hover\\:bg-neutral-75\\/75:hover{
  background-color: rgb(246 246 246 / 0.75);
}

.hover\\:bg-neutral-75\\/80:hover{
  background-color: rgb(246 246 246 / 0.8);
}

.hover\\:bg-neutral-75\\/85:hover{
  background-color: rgb(246 246 246 / 0.85);
}

.hover\\:bg-neutral-75\\/90:hover{
  background-color: rgb(246 246 246 / 0.9);
}

.hover\\:bg-neutral-75\\/95:hover{
  background-color: rgb(246 246 246 / 0.95);
}

.hover\\:bg-neutral-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-dark-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 58 65 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-dark-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(34 38 47 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-100:hover{
  background-color: var(--color-primary-100, #E0F2FE);
}

.hover\\:bg-primary-200:hover{
  background-color: var(--color-primary-200, #B9E6FE);
}

.hover\\:bg-primary-25:hover{
  background-color: var(--color-primary-25, #F5FBFF);
}

.hover\\:bg-primary-400:hover{
  background-color: var(--color-primary-400, #36BFFA);
}

.hover\\:bg-primary-50:hover{
  background-color: var(--color-primary-50, #F0F9FF);
}

.hover\\:bg-primary-500:hover{
  background-color: var(--color-primary-500, #0BA5EC);
}

.hover\\:bg-primary-600:hover{
  background-color: var(--color-primary-600, #0086C9);
}

.hover\\:bg-primary-700:hover{
  background-color: var(--color-primary-700, #026AA2);
}

.hover\\:bg-primary-800:hover{
  background-color: var(--color-primary-800, #065986);
}

.hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-100\\/0:hover{
  background-color: rgb(235 233 254 / 0);
}

.hover\\:bg-purple-100\\/10:hover{
  background-color: rgb(235 233 254 / 0.1);
}

.hover\\:bg-purple-100\\/100:hover{
  background-color: rgb(235 233 254 / 1);
}

.hover\\:bg-purple-100\\/15:hover{
  background-color: rgb(235 233 254 / 0.15);
}

.hover\\:bg-purple-100\\/20:hover{
  background-color: rgb(235 233 254 / 0.2);
}

.hover\\:bg-purple-100\\/25:hover{
  background-color: rgb(235 233 254 / 0.25);
}

.hover\\:bg-purple-100\\/30:hover{
  background-color: rgb(235 233 254 / 0.3);
}

.hover\\:bg-purple-100\\/35:hover{
  background-color: rgb(235 233 254 / 0.35);
}

.hover\\:bg-purple-100\\/40:hover{
  background-color: rgb(235 233 254 / 0.4);
}

.hover\\:bg-purple-100\\/45:hover{
  background-color: rgb(235 233 254 / 0.45);
}

.hover\\:bg-purple-100\\/5:hover{
  background-color: rgb(235 233 254 / 0.05);
}

.hover\\:bg-purple-100\\/50:hover{
  background-color: rgb(235 233 254 / 0.5);
}

.hover\\:bg-purple-100\\/55:hover{
  background-color: rgb(235 233 254 / 0.55);
}

.hover\\:bg-purple-100\\/60:hover{
  background-color: rgb(235 233 254 / 0.6);
}

.hover\\:bg-purple-100\\/65:hover{
  background-color: rgb(235 233 254 / 0.65);
}

.hover\\:bg-purple-100\\/70:hover{
  background-color: rgb(235 233 254 / 0.7);
}

.hover\\:bg-purple-100\\/75:hover{
  background-color: rgb(235 233 254 / 0.75);
}

.hover\\:bg-purple-100\\/80:hover{
  background-color: rgb(235 233 254 / 0.8);
}

.hover\\:bg-purple-100\\/85:hover{
  background-color: rgb(235 233 254 / 0.85);
}

.hover\\:bg-purple-100\\/90:hover{
  background-color: rgb(235 233 254 / 0.9);
}

.hover\\:bg-purple-100\\/95:hover{
  background-color: rgb(235 233 254 / 0.95);
}

.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-200\\/0:hover{
  background-color: rgb(217 214 254 / 0);
}

.hover\\:bg-purple-200\\/10:hover{
  background-color: rgb(217 214 254 / 0.1);
}

.hover\\:bg-purple-200\\/100:hover{
  background-color: rgb(217 214 254 / 1);
}

.hover\\:bg-purple-200\\/15:hover{
  background-color: rgb(217 214 254 / 0.15);
}

.hover\\:bg-purple-200\\/20:hover{
  background-color: rgb(217 214 254 / 0.2);
}

.hover\\:bg-purple-200\\/25:hover{
  background-color: rgb(217 214 254 / 0.25);
}

.hover\\:bg-purple-200\\/30:hover{
  background-color: rgb(217 214 254 / 0.3);
}

.hover\\:bg-purple-200\\/35:hover{
  background-color: rgb(217 214 254 / 0.35);
}

.hover\\:bg-purple-200\\/40:hover{
  background-color: rgb(217 214 254 / 0.4);
}

.hover\\:bg-purple-200\\/45:hover{
  background-color: rgb(217 214 254 / 0.45);
}

.hover\\:bg-purple-200\\/5:hover{
  background-color: rgb(217 214 254 / 0.05);
}

.hover\\:bg-purple-200\\/50:hover{
  background-color: rgb(217 214 254 / 0.5);
}

.hover\\:bg-purple-200\\/55:hover{
  background-color: rgb(217 214 254 / 0.55);
}

.hover\\:bg-purple-200\\/60:hover{
  background-color: rgb(217 214 254 / 0.6);
}

.hover\\:bg-purple-200\\/65:hover{
  background-color: rgb(217 214 254 / 0.65);
}

.hover\\:bg-purple-200\\/70:hover{
  background-color: rgb(217 214 254 / 0.7);
}

.hover\\:bg-purple-200\\/75:hover{
  background-color: rgb(217 214 254 / 0.75);
}

.hover\\:bg-purple-200\\/80:hover{
  background-color: rgb(217 214 254 / 0.8);
}

.hover\\:bg-purple-200\\/85:hover{
  background-color: rgb(217 214 254 / 0.85);
}

.hover\\:bg-purple-200\\/90:hover{
  background-color: rgb(217 214 254 / 0.9);
}

.hover\\:bg-purple-200\\/95:hover{
  background-color: rgb(217 214 254 / 0.95);
}

.hover\\:bg-purple-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-25\\/0:hover{
  background-color: rgb(250 250 255 / 0);
}

.hover\\:bg-purple-25\\/10:hover{
  background-color: rgb(250 250 255 / 0.1);
}

.hover\\:bg-purple-25\\/100:hover{
  background-color: rgb(250 250 255 / 1);
}

.hover\\:bg-purple-25\\/15:hover{
  background-color: rgb(250 250 255 / 0.15);
}

.hover\\:bg-purple-25\\/20:hover{
  background-color: rgb(250 250 255 / 0.2);
}

.hover\\:bg-purple-25\\/25:hover{
  background-color: rgb(250 250 255 / 0.25);
}

.hover\\:bg-purple-25\\/30:hover{
  background-color: rgb(250 250 255 / 0.3);
}

.hover\\:bg-purple-25\\/35:hover{
  background-color: rgb(250 250 255 / 0.35);
}

.hover\\:bg-purple-25\\/40:hover{
  background-color: rgb(250 250 255 / 0.4);
}

.hover\\:bg-purple-25\\/45:hover{
  background-color: rgb(250 250 255 / 0.45);
}

.hover\\:bg-purple-25\\/5:hover{
  background-color: rgb(250 250 255 / 0.05);
}

.hover\\:bg-purple-25\\/50:hover{
  background-color: rgb(250 250 255 / 0.5);
}

.hover\\:bg-purple-25\\/55:hover{
  background-color: rgb(250 250 255 / 0.55);
}

.hover\\:bg-purple-25\\/60:hover{
  background-color: rgb(250 250 255 / 0.6);
}

.hover\\:bg-purple-25\\/65:hover{
  background-color: rgb(250 250 255 / 0.65);
}

.hover\\:bg-purple-25\\/70:hover{
  background-color: rgb(250 250 255 / 0.7);
}

.hover\\:bg-purple-25\\/75:hover{
  background-color: rgb(250 250 255 / 0.75);
}

.hover\\:bg-purple-25\\/80:hover{
  background-color: rgb(250 250 255 / 0.8);
}

.hover\\:bg-purple-25\\/85:hover{
  background-color: rgb(250 250 255 / 0.85);
}

.hover\\:bg-purple-25\\/90:hover{
  background-color: rgb(250 250 255 / 0.9);
}

.hover\\:bg-purple-25\\/95:hover{
  background-color: rgb(250 250 255 / 0.95);
}

.hover\\:bg-purple-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-400\\/0:hover{
  background-color: rgb(155 138 251 / 0);
}

.hover\\:bg-purple-400\\/10:hover{
  background-color: rgb(155 138 251 / 0.1);
}

.hover\\:bg-purple-400\\/100:hover{
  background-color: rgb(155 138 251 / 1);
}

.hover\\:bg-purple-400\\/15:hover{
  background-color: rgb(155 138 251 / 0.15);
}

.hover\\:bg-purple-400\\/20:hover{
  background-color: rgb(155 138 251 / 0.2);
}

.hover\\:bg-purple-400\\/25:hover{
  background-color: rgb(155 138 251 / 0.25);
}

.hover\\:bg-purple-400\\/30:hover{
  background-color: rgb(155 138 251 / 0.3);
}

.hover\\:bg-purple-400\\/35:hover{
  background-color: rgb(155 138 251 / 0.35);
}

.hover\\:bg-purple-400\\/40:hover{
  background-color: rgb(155 138 251 / 0.4);
}

.hover\\:bg-purple-400\\/45:hover{
  background-color: rgb(155 138 251 / 0.45);
}

.hover\\:bg-purple-400\\/5:hover{
  background-color: rgb(155 138 251 / 0.05);
}

.hover\\:bg-purple-400\\/50:hover{
  background-color: rgb(155 138 251 / 0.5);
}

.hover\\:bg-purple-400\\/55:hover{
  background-color: rgb(155 138 251 / 0.55);
}

.hover\\:bg-purple-400\\/60:hover{
  background-color: rgb(155 138 251 / 0.6);
}

.hover\\:bg-purple-400\\/65:hover{
  background-color: rgb(155 138 251 / 0.65);
}

.hover\\:bg-purple-400\\/70:hover{
  background-color: rgb(155 138 251 / 0.7);
}

.hover\\:bg-purple-400\\/75:hover{
  background-color: rgb(155 138 251 / 0.75);
}

.hover\\:bg-purple-400\\/80:hover{
  background-color: rgb(155 138 251 / 0.8);
}

.hover\\:bg-purple-400\\/85:hover{
  background-color: rgb(155 138 251 / 0.85);
}

.hover\\:bg-purple-400\\/90:hover{
  background-color: rgb(155 138 251 / 0.9);
}

.hover\\:bg-purple-400\\/95:hover{
  background-color: rgb(155 138 251 / 0.95);
}

.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50\\/0:hover{
  background-color: rgb(244 243 255 / 0);
}

.hover\\:bg-purple-50\\/10:hover{
  background-color: rgb(244 243 255 / 0.1);
}

.hover\\:bg-purple-50\\/100:hover{
  background-color: rgb(244 243 255 / 1);
}

.hover\\:bg-purple-50\\/15:hover{
  background-color: rgb(244 243 255 / 0.15);
}

.hover\\:bg-purple-50\\/20:hover{
  background-color: rgb(244 243 255 / 0.2);
}

.hover\\:bg-purple-50\\/25:hover{
  background-color: rgb(244 243 255 / 0.25);
}

.hover\\:bg-purple-50\\/30:hover{
  background-color: rgb(244 243 255 / 0.3);
}

.hover\\:bg-purple-50\\/35:hover{
  background-color: rgb(244 243 255 / 0.35);
}

.hover\\:bg-purple-50\\/40:hover{
  background-color: rgb(244 243 255 / 0.4);
}

.hover\\:bg-purple-50\\/45:hover{
  background-color: rgb(244 243 255 / 0.45);
}

.hover\\:bg-purple-50\\/5:hover{
  background-color: rgb(244 243 255 / 0.05);
}

.hover\\:bg-purple-50\\/50:hover{
  background-color: rgb(244 243 255 / 0.5);
}

.hover\\:bg-purple-50\\/55:hover{
  background-color: rgb(244 243 255 / 0.55);
}

.hover\\:bg-purple-50\\/60:hover{
  background-color: rgb(244 243 255 / 0.6);
}

.hover\\:bg-purple-50\\/65:hover{
  background-color: rgb(244 243 255 / 0.65);
}

.hover\\:bg-purple-50\\/70:hover{
  background-color: rgb(244 243 255 / 0.7);
}

.hover\\:bg-purple-50\\/75:hover{
  background-color: rgb(244 243 255 / 0.75);
}

.hover\\:bg-purple-50\\/80:hover{
  background-color: rgb(244 243 255 / 0.8);
}

.hover\\:bg-purple-50\\/85:hover{
  background-color: rgb(244 243 255 / 0.85);
}

.hover\\:bg-purple-50\\/90:hover{
  background-color: rgb(244 243 255 / 0.9);
}

.hover\\:bg-purple-50\\/95:hover{
  background-color: rgb(244 243 255 / 0.95);
}

.hover\\:bg-purple-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-500\\/0:hover{
  background-color: rgb(122 90 248 / 0);
}

.hover\\:bg-purple-500\\/10:hover{
  background-color: rgb(122 90 248 / 0.1);
}

.hover\\:bg-purple-500\\/100:hover{
  background-color: rgb(122 90 248 / 1);
}

.hover\\:bg-purple-500\\/15:hover{
  background-color: rgb(122 90 248 / 0.15);
}

.hover\\:bg-purple-500\\/20:hover{
  background-color: rgb(122 90 248 / 0.2);
}

.hover\\:bg-purple-500\\/25:hover{
  background-color: rgb(122 90 248 / 0.25);
}

.hover\\:bg-purple-500\\/30:hover{
  background-color: rgb(122 90 248 / 0.3);
}

.hover\\:bg-purple-500\\/35:hover{
  background-color: rgb(122 90 248 / 0.35);
}

.hover\\:bg-purple-500\\/40:hover{
  background-color: rgb(122 90 248 / 0.4);
}

.hover\\:bg-purple-500\\/45:hover{
  background-color: rgb(122 90 248 / 0.45);
}

.hover\\:bg-purple-500\\/5:hover{
  background-color: rgb(122 90 248 / 0.05);
}

.hover\\:bg-purple-500\\/50:hover{
  background-color: rgb(122 90 248 / 0.5);
}

.hover\\:bg-purple-500\\/55:hover{
  background-color: rgb(122 90 248 / 0.55);
}

.hover\\:bg-purple-500\\/60:hover{
  background-color: rgb(122 90 248 / 0.6);
}

.hover\\:bg-purple-500\\/65:hover{
  background-color: rgb(122 90 248 / 0.65);
}

.hover\\:bg-purple-500\\/70:hover{
  background-color: rgb(122 90 248 / 0.7);
}

.hover\\:bg-purple-500\\/75:hover{
  background-color: rgb(122 90 248 / 0.75);
}

.hover\\:bg-purple-500\\/80:hover{
  background-color: rgb(122 90 248 / 0.8);
}

.hover\\:bg-purple-500\\/85:hover{
  background-color: rgb(122 90 248 / 0.85);
}

.hover\\:bg-purple-500\\/90:hover{
  background-color: rgb(122 90 248 / 0.9);
}

.hover\\:bg-purple-500\\/95:hover{
  background-color: rgb(122 90 248 / 0.95);
}

.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-600\\/0:hover{
  background-color: rgb(105 56 239 / 0);
}

.hover\\:bg-purple-600\\/10:hover{
  background-color: rgb(105 56 239 / 0.1);
}

.hover\\:bg-purple-600\\/100:hover{
  background-color: rgb(105 56 239 / 1);
}

.hover\\:bg-purple-600\\/15:hover{
  background-color: rgb(105 56 239 / 0.15);
}

.hover\\:bg-purple-600\\/20:hover{
  background-color: rgb(105 56 239 / 0.2);
}

.hover\\:bg-purple-600\\/25:hover{
  background-color: rgb(105 56 239 / 0.25);
}

.hover\\:bg-purple-600\\/30:hover{
  background-color: rgb(105 56 239 / 0.3);
}

.hover\\:bg-purple-600\\/35:hover{
  background-color: rgb(105 56 239 / 0.35);
}

.hover\\:bg-purple-600\\/40:hover{
  background-color: rgb(105 56 239 / 0.4);
}

.hover\\:bg-purple-600\\/45:hover{
  background-color: rgb(105 56 239 / 0.45);
}

.hover\\:bg-purple-600\\/5:hover{
  background-color: rgb(105 56 239 / 0.05);
}

.hover\\:bg-purple-600\\/50:hover{
  background-color: rgb(105 56 239 / 0.5);
}

.hover\\:bg-purple-600\\/55:hover{
  background-color: rgb(105 56 239 / 0.55);
}

.hover\\:bg-purple-600\\/60:hover{
  background-color: rgb(105 56 239 / 0.6);
}

.hover\\:bg-purple-600\\/65:hover{
  background-color: rgb(105 56 239 / 0.65);
}

.hover\\:bg-purple-600\\/70:hover{
  background-color: rgb(105 56 239 / 0.7);
}

.hover\\:bg-purple-600\\/75:hover{
  background-color: rgb(105 56 239 / 0.75);
}

.hover\\:bg-purple-600\\/80:hover{
  background-color: rgb(105 56 239 / 0.8);
}

.hover\\:bg-purple-600\\/85:hover{
  background-color: rgb(105 56 239 / 0.85);
}

.hover\\:bg-purple-600\\/90:hover{
  background-color: rgb(105 56 239 / 0.9);
}

.hover\\:bg-purple-600\\/95:hover{
  background-color: rgb(105 56 239 / 0.95);
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700\\/0:hover{
  background-color: rgb(89 37 220 / 0);
}

.hover\\:bg-purple-700\\/10:hover{
  background-color: rgb(89 37 220 / 0.1);
}

.hover\\:bg-purple-700\\/100:hover{
  background-color: rgb(89 37 220 / 1);
}

.hover\\:bg-purple-700\\/15:hover{
  background-color: rgb(89 37 220 / 0.15);
}

.hover\\:bg-purple-700\\/20:hover{
  background-color: rgb(89 37 220 / 0.2);
}

.hover\\:bg-purple-700\\/25:hover{
  background-color: rgb(89 37 220 / 0.25);
}

.hover\\:bg-purple-700\\/30:hover{
  background-color: rgb(89 37 220 / 0.3);
}

.hover\\:bg-purple-700\\/35:hover{
  background-color: rgb(89 37 220 / 0.35);
}

.hover\\:bg-purple-700\\/40:hover{
  background-color: rgb(89 37 220 / 0.4);
}

.hover\\:bg-purple-700\\/45:hover{
  background-color: rgb(89 37 220 / 0.45);
}

.hover\\:bg-purple-700\\/5:hover{
  background-color: rgb(89 37 220 / 0.05);
}

.hover\\:bg-purple-700\\/50:hover{
  background-color: rgb(89 37 220 / 0.5);
}

.hover\\:bg-purple-700\\/55:hover{
  background-color: rgb(89 37 220 / 0.55);
}

.hover\\:bg-purple-700\\/60:hover{
  background-color: rgb(89 37 220 / 0.6);
}

.hover\\:bg-purple-700\\/65:hover{
  background-color: rgb(89 37 220 / 0.65);
}

.hover\\:bg-purple-700\\/70:hover{
  background-color: rgb(89 37 220 / 0.7);
}

.hover\\:bg-purple-700\\/75:hover{
  background-color: rgb(89 37 220 / 0.75);
}

.hover\\:bg-purple-700\\/80:hover{
  background-color: rgb(89 37 220 / 0.8);
}

.hover\\:bg-purple-700\\/85:hover{
  background-color: rgb(89 37 220 / 0.85);
}

.hover\\:bg-purple-700\\/90:hover{
  background-color: rgb(89 37 220 / 0.9);
}

.hover\\:bg-purple-700\\/95:hover{
  background-color: rgb(89 37 220 / 0.95);
}

.hover\\:bg-success-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(211 248 223 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-100\\/0:hover{
  background-color: rgb(211 248 223 / 0);
}

.hover\\:bg-success-100\\/10:hover{
  background-color: rgb(211 248 223 / 0.1);
}

.hover\\:bg-success-100\\/100:hover{
  background-color: rgb(211 248 223 / 1);
}

.hover\\:bg-success-100\\/15:hover{
  background-color: rgb(211 248 223 / 0.15);
}

.hover\\:bg-success-100\\/20:hover{
  background-color: rgb(211 248 223 / 0.2);
}

.hover\\:bg-success-100\\/25:hover{
  background-color: rgb(211 248 223 / 0.25);
}

.hover\\:bg-success-100\\/30:hover{
  background-color: rgb(211 248 223 / 0.3);
}

.hover\\:bg-success-100\\/35:hover{
  background-color: rgb(211 248 223 / 0.35);
}

.hover\\:bg-success-100\\/40:hover{
  background-color: rgb(211 248 223 / 0.4);
}

.hover\\:bg-success-100\\/45:hover{
  background-color: rgb(211 248 223 / 0.45);
}

.hover\\:bg-success-100\\/5:hover{
  background-color: rgb(211 248 223 / 0.05);
}

.hover\\:bg-success-100\\/50:hover{
  background-color: rgb(211 248 223 / 0.5);
}

.hover\\:bg-success-100\\/55:hover{
  background-color: rgb(211 248 223 / 0.55);
}

.hover\\:bg-success-100\\/60:hover{
  background-color: rgb(211 248 223 / 0.6);
}

.hover\\:bg-success-100\\/65:hover{
  background-color: rgb(211 248 223 / 0.65);
}

.hover\\:bg-success-100\\/70:hover{
  background-color: rgb(211 248 223 / 0.7);
}

.hover\\:bg-success-100\\/75:hover{
  background-color: rgb(211 248 223 / 0.75);
}

.hover\\:bg-success-100\\/80:hover{
  background-color: rgb(211 248 223 / 0.8);
}

.hover\\:bg-success-100\\/85:hover{
  background-color: rgb(211 248 223 / 0.85);
}

.hover\\:bg-success-100\\/90:hover{
  background-color: rgb(211 248 223 / 0.9);
}

.hover\\:bg-success-100\\/95:hover{
  background-color: rgb(211 248 223 / 0.95);
}

.hover\\:bg-success-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(170 240 196 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-200\\/0:hover{
  background-color: rgb(170 240 196 / 0);
}

.hover\\:bg-success-200\\/10:hover{
  background-color: rgb(170 240 196 / 0.1);
}

.hover\\:bg-success-200\\/100:hover{
  background-color: rgb(170 240 196 / 1);
}

.hover\\:bg-success-200\\/15:hover{
  background-color: rgb(170 240 196 / 0.15);
}

.hover\\:bg-success-200\\/20:hover{
  background-color: rgb(170 240 196 / 0.2);
}

.hover\\:bg-success-200\\/25:hover{
  background-color: rgb(170 240 196 / 0.25);
}

.hover\\:bg-success-200\\/30:hover{
  background-color: rgb(170 240 196 / 0.3);
}

.hover\\:bg-success-200\\/35:hover{
  background-color: rgb(170 240 196 / 0.35);
}

.hover\\:bg-success-200\\/40:hover{
  background-color: rgb(170 240 196 / 0.4);
}

.hover\\:bg-success-200\\/45:hover{
  background-color: rgb(170 240 196 / 0.45);
}

.hover\\:bg-success-200\\/5:hover{
  background-color: rgb(170 240 196 / 0.05);
}

.hover\\:bg-success-200\\/50:hover{
  background-color: rgb(170 240 196 / 0.5);
}

.hover\\:bg-success-200\\/55:hover{
  background-color: rgb(170 240 196 / 0.55);
}

.hover\\:bg-success-200\\/60:hover{
  background-color: rgb(170 240 196 / 0.6);
}

.hover\\:bg-success-200\\/65:hover{
  background-color: rgb(170 240 196 / 0.65);
}

.hover\\:bg-success-200\\/70:hover{
  background-color: rgb(170 240 196 / 0.7);
}

.hover\\:bg-success-200\\/75:hover{
  background-color: rgb(170 240 196 / 0.75);
}

.hover\\:bg-success-200\\/80:hover{
  background-color: rgb(170 240 196 / 0.8);
}

.hover\\:bg-success-200\\/85:hover{
  background-color: rgb(170 240 196 / 0.85);
}

.hover\\:bg-success-200\\/90:hover{
  background-color: rgb(170 240 196 / 0.9);
}

.hover\\:bg-success-200\\/95:hover{
  background-color: rgb(170 240 196 / 0.95);
}

.hover\\:bg-success-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-25\\/0:hover{
  background-color: rgb(246 254 249 / 0);
}

.hover\\:bg-success-25\\/10:hover{
  background-color: rgb(246 254 249 / 0.1);
}

.hover\\:bg-success-25\\/100:hover{
  background-color: rgb(246 254 249 / 1);
}

.hover\\:bg-success-25\\/15:hover{
  background-color: rgb(246 254 249 / 0.15);
}

.hover\\:bg-success-25\\/20:hover{
  background-color: rgb(246 254 249 / 0.2);
}

.hover\\:bg-success-25\\/25:hover{
  background-color: rgb(246 254 249 / 0.25);
}

.hover\\:bg-success-25\\/30:hover{
  background-color: rgb(246 254 249 / 0.3);
}

.hover\\:bg-success-25\\/35:hover{
  background-color: rgb(246 254 249 / 0.35);
}

.hover\\:bg-success-25\\/40:hover{
  background-color: rgb(246 254 249 / 0.4);
}

.hover\\:bg-success-25\\/45:hover{
  background-color: rgb(246 254 249 / 0.45);
}

.hover\\:bg-success-25\\/5:hover{
  background-color: rgb(246 254 249 / 0.05);
}

.hover\\:bg-success-25\\/50:hover{
  background-color: rgb(246 254 249 / 0.5);
}

.hover\\:bg-success-25\\/55:hover{
  background-color: rgb(246 254 249 / 0.55);
}

.hover\\:bg-success-25\\/60:hover{
  background-color: rgb(246 254 249 / 0.6);
}

.hover\\:bg-success-25\\/65:hover{
  background-color: rgb(246 254 249 / 0.65);
}

.hover\\:bg-success-25\\/70:hover{
  background-color: rgb(246 254 249 / 0.7);
}

.hover\\:bg-success-25\\/75:hover{
  background-color: rgb(246 254 249 / 0.75);
}

.hover\\:bg-success-25\\/80:hover{
  background-color: rgb(246 254 249 / 0.8);
}

.hover\\:bg-success-25\\/85:hover{
  background-color: rgb(246 254 249 / 0.85);
}

.hover\\:bg-success-25\\/90:hover{
  background-color: rgb(246 254 249 / 0.9);
}

.hover\\:bg-success-25\\/95:hover{
  background-color: rgb(246 254 249 / 0.95);
}

.hover\\:bg-success-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(60 203 127 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-400\\/0:hover{
  background-color: rgb(60 203 127 / 0);
}

.hover\\:bg-success-400\\/10:hover{
  background-color: rgb(60 203 127 / 0.1);
}

.hover\\:bg-success-400\\/100:hover{
  background-color: rgb(60 203 127 / 1);
}

.hover\\:bg-success-400\\/15:hover{
  background-color: rgb(60 203 127 / 0.15);
}

.hover\\:bg-success-400\\/20:hover{
  background-color: rgb(60 203 127 / 0.2);
}

.hover\\:bg-success-400\\/25:hover{
  background-color: rgb(60 203 127 / 0.25);
}

.hover\\:bg-success-400\\/30:hover{
  background-color: rgb(60 203 127 / 0.3);
}

.hover\\:bg-success-400\\/35:hover{
  background-color: rgb(60 203 127 / 0.35);
}

.hover\\:bg-success-400\\/40:hover{
  background-color: rgb(60 203 127 / 0.4);
}

.hover\\:bg-success-400\\/45:hover{
  background-color: rgb(60 203 127 / 0.45);
}

.hover\\:bg-success-400\\/5:hover{
  background-color: rgb(60 203 127 / 0.05);
}

.hover\\:bg-success-400\\/50:hover{
  background-color: rgb(60 203 127 / 0.5);
}

.hover\\:bg-success-400\\/55:hover{
  background-color: rgb(60 203 127 / 0.55);
}

.hover\\:bg-success-400\\/60:hover{
  background-color: rgb(60 203 127 / 0.6);
}

.hover\\:bg-success-400\\/65:hover{
  background-color: rgb(60 203 127 / 0.65);
}

.hover\\:bg-success-400\\/70:hover{
  background-color: rgb(60 203 127 / 0.7);
}

.hover\\:bg-success-400\\/75:hover{
  background-color: rgb(60 203 127 / 0.75);
}

.hover\\:bg-success-400\\/80:hover{
  background-color: rgb(60 203 127 / 0.8);
}

.hover\\:bg-success-400\\/85:hover{
  background-color: rgb(60 203 127 / 0.85);
}

.hover\\:bg-success-400\\/90:hover{
  background-color: rgb(60 203 127 / 0.9);
}

.hover\\:bg-success-400\\/95:hover{
  background-color: rgb(60 203 127 / 0.95);
}

.hover\\:bg-success-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-50\\/0:hover{
  background-color: rgb(237 252 242 / 0);
}

.hover\\:bg-success-50\\/10:hover{
  background-color: rgb(237 252 242 / 0.1);
}

.hover\\:bg-success-50\\/100:hover{
  background-color: rgb(237 252 242 / 1);
}

.hover\\:bg-success-50\\/15:hover{
  background-color: rgb(237 252 242 / 0.15);
}

.hover\\:bg-success-50\\/20:hover{
  background-color: rgb(237 252 242 / 0.2);
}

.hover\\:bg-success-50\\/25:hover{
  background-color: rgb(237 252 242 / 0.25);
}

.hover\\:bg-success-50\\/30:hover{
  background-color: rgb(237 252 242 / 0.3);
}

.hover\\:bg-success-50\\/35:hover{
  background-color: rgb(237 252 242 / 0.35);
}

.hover\\:bg-success-50\\/40:hover{
  background-color: rgb(237 252 242 / 0.4);
}

.hover\\:bg-success-50\\/45:hover{
  background-color: rgb(237 252 242 / 0.45);
}

.hover\\:bg-success-50\\/5:hover{
  background-color: rgb(237 252 242 / 0.05);
}

.hover\\:bg-success-50\\/50:hover{
  background-color: rgb(237 252 242 / 0.5);
}

.hover\\:bg-success-50\\/55:hover{
  background-color: rgb(237 252 242 / 0.55);
}

.hover\\:bg-success-50\\/60:hover{
  background-color: rgb(237 252 242 / 0.6);
}

.hover\\:bg-success-50\\/65:hover{
  background-color: rgb(237 252 242 / 0.65);
}

.hover\\:bg-success-50\\/70:hover{
  background-color: rgb(237 252 242 / 0.7);
}

.hover\\:bg-success-50\\/75:hover{
  background-color: rgb(237 252 242 / 0.75);
}

.hover\\:bg-success-50\\/80:hover{
  background-color: rgb(237 252 242 / 0.8);
}

.hover\\:bg-success-50\\/85:hover{
  background-color: rgb(237 252 242 / 0.85);
}

.hover\\:bg-success-50\\/90:hover{
  background-color: rgb(237 252 242 / 0.9);
}

.hover\\:bg-success-50\\/95:hover{
  background-color: rgb(237 252 242 / 0.95);
}

.hover\\:bg-success-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 179 100 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-500\\/0:hover{
  background-color: rgb(22 179 100 / 0);
}

.hover\\:bg-success-500\\/10:hover{
  background-color: rgb(22 179 100 / 0.1);
}

.hover\\:bg-success-500\\/100:hover{
  background-color: rgb(22 179 100 / 1);
}

.hover\\:bg-success-500\\/15:hover{
  background-color: rgb(22 179 100 / 0.15);
}

.hover\\:bg-success-500\\/20:hover{
  background-color: rgb(22 179 100 / 0.2);
}

.hover\\:bg-success-500\\/25:hover{
  background-color: rgb(22 179 100 / 0.25);
}

.hover\\:bg-success-500\\/30:hover{
  background-color: rgb(22 179 100 / 0.3);
}

.hover\\:bg-success-500\\/35:hover{
  background-color: rgb(22 179 100 / 0.35);
}

.hover\\:bg-success-500\\/40:hover{
  background-color: rgb(22 179 100 / 0.4);
}

.hover\\:bg-success-500\\/45:hover{
  background-color: rgb(22 179 100 / 0.45);
}

.hover\\:bg-success-500\\/5:hover{
  background-color: rgb(22 179 100 / 0.05);
}

.hover\\:bg-success-500\\/50:hover{
  background-color: rgb(22 179 100 / 0.5);
}

.hover\\:bg-success-500\\/55:hover{
  background-color: rgb(22 179 100 / 0.55);
}

.hover\\:bg-success-500\\/60:hover{
  background-color: rgb(22 179 100 / 0.6);
}

.hover\\:bg-success-500\\/65:hover{
  background-color: rgb(22 179 100 / 0.65);
}

.hover\\:bg-success-500\\/70:hover{
  background-color: rgb(22 179 100 / 0.7);
}

.hover\\:bg-success-500\\/75:hover{
  background-color: rgb(22 179 100 / 0.75);
}

.hover\\:bg-success-500\\/80:hover{
  background-color: rgb(22 179 100 / 0.8);
}

.hover\\:bg-success-500\\/85:hover{
  background-color: rgb(22 179 100 / 0.85);
}

.hover\\:bg-success-500\\/90:hover{
  background-color: rgb(22 179 100 / 0.9);
}

.hover\\:bg-success-500\\/95:hover{
  background-color: rgb(22 179 100 / 0.95);
}

.hover\\:bg-success-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(9 146 80 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-600\\/0:hover{
  background-color: rgb(9 146 80 / 0);
}

.hover\\:bg-success-600\\/10:hover{
  background-color: rgb(9 146 80 / 0.1);
}

.hover\\:bg-success-600\\/100:hover{
  background-color: rgb(9 146 80 / 1);
}

.hover\\:bg-success-600\\/15:hover{
  background-color: rgb(9 146 80 / 0.15);
}

.hover\\:bg-success-600\\/20:hover{
  background-color: rgb(9 146 80 / 0.2);
}

.hover\\:bg-success-600\\/25:hover{
  background-color: rgb(9 146 80 / 0.25);
}

.hover\\:bg-success-600\\/30:hover{
  background-color: rgb(9 146 80 / 0.3);
}

.hover\\:bg-success-600\\/35:hover{
  background-color: rgb(9 146 80 / 0.35);
}

.hover\\:bg-success-600\\/40:hover{
  background-color: rgb(9 146 80 / 0.4);
}

.hover\\:bg-success-600\\/45:hover{
  background-color: rgb(9 146 80 / 0.45);
}

.hover\\:bg-success-600\\/5:hover{
  background-color: rgb(9 146 80 / 0.05);
}

.hover\\:bg-success-600\\/50:hover{
  background-color: rgb(9 146 80 / 0.5);
}

.hover\\:bg-success-600\\/55:hover{
  background-color: rgb(9 146 80 / 0.55);
}

.hover\\:bg-success-600\\/60:hover{
  background-color: rgb(9 146 80 / 0.6);
}

.hover\\:bg-success-600\\/65:hover{
  background-color: rgb(9 146 80 / 0.65);
}

.hover\\:bg-success-600\\/70:hover{
  background-color: rgb(9 146 80 / 0.7);
}

.hover\\:bg-success-600\\/75:hover{
  background-color: rgb(9 146 80 / 0.75);
}

.hover\\:bg-success-600\\/80:hover{
  background-color: rgb(9 146 80 / 0.8);
}

.hover\\:bg-success-600\\/85:hover{
  background-color: rgb(9 146 80 / 0.85);
}

.hover\\:bg-success-600\\/90:hover{
  background-color: rgb(9 146 80 / 0.9);
}

.hover\\:bg-success-600\\/95:hover{
  background-color: rgb(9 146 80 / 0.95);
}

.hover\\:bg-success-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(8 116 67 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-700\\/0:hover{
  background-color: rgb(8 116 67 / 0);
}

.hover\\:bg-success-700\\/10:hover{
  background-color: rgb(8 116 67 / 0.1);
}

.hover\\:bg-success-700\\/100:hover{
  background-color: rgb(8 116 67 / 1);
}

.hover\\:bg-success-700\\/15:hover{
  background-color: rgb(8 116 67 / 0.15);
}

.hover\\:bg-success-700\\/20:hover{
  background-color: rgb(8 116 67 / 0.2);
}

.hover\\:bg-success-700\\/25:hover{
  background-color: rgb(8 116 67 / 0.25);
}

.hover\\:bg-success-700\\/30:hover{
  background-color: rgb(8 116 67 / 0.3);
}

.hover\\:bg-success-700\\/35:hover{
  background-color: rgb(8 116 67 / 0.35);
}

.hover\\:bg-success-700\\/40:hover{
  background-color: rgb(8 116 67 / 0.4);
}

.hover\\:bg-success-700\\/45:hover{
  background-color: rgb(8 116 67 / 0.45);
}

.hover\\:bg-success-700\\/5:hover{
  background-color: rgb(8 116 67 / 0.05);
}

.hover\\:bg-success-700\\/50:hover{
  background-color: rgb(8 116 67 / 0.5);
}

.hover\\:bg-success-700\\/55:hover{
  background-color: rgb(8 116 67 / 0.55);
}

.hover\\:bg-success-700\\/60:hover{
  background-color: rgb(8 116 67 / 0.6);
}

.hover\\:bg-success-700\\/65:hover{
  background-color: rgb(8 116 67 / 0.65);
}

.hover\\:bg-success-700\\/70:hover{
  background-color: rgb(8 116 67 / 0.7);
}

.hover\\:bg-success-700\\/75:hover{
  background-color: rgb(8 116 67 / 0.75);
}

.hover\\:bg-success-700\\/80:hover{
  background-color: rgb(8 116 67 / 0.8);
}

.hover\\:bg-success-700\\/85:hover{
  background-color: rgb(8 116 67 / 0.85);
}

.hover\\:bg-success-700\\/90:hover{
  background-color: rgb(8 116 67 / 0.9);
}

.hover\\:bg-success-700\\/95:hover{
  background-color: rgb(8 116 67 / 0.95);
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-warning-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-100\\/0:hover{
  background-color: rgb(254 240 199 / 0);
}

.hover\\:bg-warning-100\\/10:hover{
  background-color: rgb(254 240 199 / 0.1);
}

.hover\\:bg-warning-100\\/100:hover{
  background-color: rgb(254 240 199 / 1);
}

.hover\\:bg-warning-100\\/15:hover{
  background-color: rgb(254 240 199 / 0.15);
}

.hover\\:bg-warning-100\\/20:hover{
  background-color: rgb(254 240 199 / 0.2);
}

.hover\\:bg-warning-100\\/25:hover{
  background-color: rgb(254 240 199 / 0.25);
}

.hover\\:bg-warning-100\\/30:hover{
  background-color: rgb(254 240 199 / 0.3);
}

.hover\\:bg-warning-100\\/35:hover{
  background-color: rgb(254 240 199 / 0.35);
}

.hover\\:bg-warning-100\\/40:hover{
  background-color: rgb(254 240 199 / 0.4);
}

.hover\\:bg-warning-100\\/45:hover{
  background-color: rgb(254 240 199 / 0.45);
}

.hover\\:bg-warning-100\\/5:hover{
  background-color: rgb(254 240 199 / 0.05);
}

.hover\\:bg-warning-100\\/50:hover{
  background-color: rgb(254 240 199 / 0.5);
}

.hover\\:bg-warning-100\\/55:hover{
  background-color: rgb(254 240 199 / 0.55);
}

.hover\\:bg-warning-100\\/60:hover{
  background-color: rgb(254 240 199 / 0.6);
}

.hover\\:bg-warning-100\\/65:hover{
  background-color: rgb(254 240 199 / 0.65);
}

.hover\\:bg-warning-100\\/70:hover{
  background-color: rgb(254 240 199 / 0.7);
}

.hover\\:bg-warning-100\\/75:hover{
  background-color: rgb(254 240 199 / 0.75);
}

.hover\\:bg-warning-100\\/80:hover{
  background-color: rgb(254 240 199 / 0.8);
}

.hover\\:bg-warning-100\\/85:hover{
  background-color: rgb(254 240 199 / 0.85);
}

.hover\\:bg-warning-100\\/90:hover{
  background-color: rgb(254 240 199 / 0.9);
}

.hover\\:bg-warning-100\\/95:hover{
  background-color: rgb(254 240 199 / 0.95);
}

.hover\\:bg-warning-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-200\\/0:hover{
  background-color: rgb(254 223 137 / 0);
}

.hover\\:bg-warning-200\\/10:hover{
  background-color: rgb(254 223 137 / 0.1);
}

.hover\\:bg-warning-200\\/100:hover{
  background-color: rgb(254 223 137 / 1);
}

.hover\\:bg-warning-200\\/15:hover{
  background-color: rgb(254 223 137 / 0.15);
}

.hover\\:bg-warning-200\\/20:hover{
  background-color: rgb(254 223 137 / 0.2);
}

.hover\\:bg-warning-200\\/25:hover{
  background-color: rgb(254 223 137 / 0.25);
}

.hover\\:bg-warning-200\\/30:hover{
  background-color: rgb(254 223 137 / 0.3);
}

.hover\\:bg-warning-200\\/35:hover{
  background-color: rgb(254 223 137 / 0.35);
}

.hover\\:bg-warning-200\\/40:hover{
  background-color: rgb(254 223 137 / 0.4);
}

.hover\\:bg-warning-200\\/45:hover{
  background-color: rgb(254 223 137 / 0.45);
}

.hover\\:bg-warning-200\\/5:hover{
  background-color: rgb(254 223 137 / 0.05);
}

.hover\\:bg-warning-200\\/50:hover{
  background-color: rgb(254 223 137 / 0.5);
}

.hover\\:bg-warning-200\\/55:hover{
  background-color: rgb(254 223 137 / 0.55);
}

.hover\\:bg-warning-200\\/60:hover{
  background-color: rgb(254 223 137 / 0.6);
}

.hover\\:bg-warning-200\\/65:hover{
  background-color: rgb(254 223 137 / 0.65);
}

.hover\\:bg-warning-200\\/70:hover{
  background-color: rgb(254 223 137 / 0.7);
}

.hover\\:bg-warning-200\\/75:hover{
  background-color: rgb(254 223 137 / 0.75);
}

.hover\\:bg-warning-200\\/80:hover{
  background-color: rgb(254 223 137 / 0.8);
}

.hover\\:bg-warning-200\\/85:hover{
  background-color: rgb(254 223 137 / 0.85);
}

.hover\\:bg-warning-200\\/90:hover{
  background-color: rgb(254 223 137 / 0.9);
}

.hover\\:bg-warning-200\\/95:hover{
  background-color: rgb(254 223 137 / 0.95);
}

.hover\\:bg-warning-25:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-25\\/0:hover{
  background-color: rgb(255 252 245 / 0);
}

.hover\\:bg-warning-25\\/10:hover{
  background-color: rgb(255 252 245 / 0.1);
}

.hover\\:bg-warning-25\\/100:hover{
  background-color: rgb(255 252 245 / 1);
}

.hover\\:bg-warning-25\\/15:hover{
  background-color: rgb(255 252 245 / 0.15);
}

.hover\\:bg-warning-25\\/20:hover{
  background-color: rgb(255 252 245 / 0.2);
}

.hover\\:bg-warning-25\\/25:hover{
  background-color: rgb(255 252 245 / 0.25);
}

.hover\\:bg-warning-25\\/30:hover{
  background-color: rgb(255 252 245 / 0.3);
}

.hover\\:bg-warning-25\\/35:hover{
  background-color: rgb(255 252 245 / 0.35);
}

.hover\\:bg-warning-25\\/40:hover{
  background-color: rgb(255 252 245 / 0.4);
}

.hover\\:bg-warning-25\\/45:hover{
  background-color: rgb(255 252 245 / 0.45);
}

.hover\\:bg-warning-25\\/5:hover{
  background-color: rgb(255 252 245 / 0.05);
}

.hover\\:bg-warning-25\\/50:hover{
  background-color: rgb(255 252 245 / 0.5);
}

.hover\\:bg-warning-25\\/55:hover{
  background-color: rgb(255 252 245 / 0.55);
}

.hover\\:bg-warning-25\\/60:hover{
  background-color: rgb(255 252 245 / 0.6);
}

.hover\\:bg-warning-25\\/65:hover{
  background-color: rgb(255 252 245 / 0.65);
}

.hover\\:bg-warning-25\\/70:hover{
  background-color: rgb(255 252 245 / 0.7);
}

.hover\\:bg-warning-25\\/75:hover{
  background-color: rgb(255 252 245 / 0.75);
}

.hover\\:bg-warning-25\\/80:hover{
  background-color: rgb(255 252 245 / 0.8);
}

.hover\\:bg-warning-25\\/85:hover{
  background-color: rgb(255 252 245 / 0.85);
}

.hover\\:bg-warning-25\\/90:hover{
  background-color: rgb(255 252 245 / 0.9);
}

.hover\\:bg-warning-25\\/95:hover{
  background-color: rgb(255 252 245 / 0.95);
}

.hover\\:bg-warning-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-400\\/0:hover{
  background-color: rgb(253 176 34 / 0);
}

.hover\\:bg-warning-400\\/10:hover{
  background-color: rgb(253 176 34 / 0.1);
}

.hover\\:bg-warning-400\\/100:hover{
  background-color: rgb(253 176 34 / 1);
}

.hover\\:bg-warning-400\\/15:hover{
  background-color: rgb(253 176 34 / 0.15);
}

.hover\\:bg-warning-400\\/20:hover{
  background-color: rgb(253 176 34 / 0.2);
}

.hover\\:bg-warning-400\\/25:hover{
  background-color: rgb(253 176 34 / 0.25);
}

.hover\\:bg-warning-400\\/30:hover{
  background-color: rgb(253 176 34 / 0.3);
}

.hover\\:bg-warning-400\\/35:hover{
  background-color: rgb(253 176 34 / 0.35);
}

.hover\\:bg-warning-400\\/40:hover{
  background-color: rgb(253 176 34 / 0.4);
}

.hover\\:bg-warning-400\\/45:hover{
  background-color: rgb(253 176 34 / 0.45);
}

.hover\\:bg-warning-400\\/5:hover{
  background-color: rgb(253 176 34 / 0.05);
}

.hover\\:bg-warning-400\\/50:hover{
  background-color: rgb(253 176 34 / 0.5);
}

.hover\\:bg-warning-400\\/55:hover{
  background-color: rgb(253 176 34 / 0.55);
}

.hover\\:bg-warning-400\\/60:hover{
  background-color: rgb(253 176 34 / 0.6);
}

.hover\\:bg-warning-400\\/65:hover{
  background-color: rgb(253 176 34 / 0.65);
}

.hover\\:bg-warning-400\\/70:hover{
  background-color: rgb(253 176 34 / 0.7);
}

.hover\\:bg-warning-400\\/75:hover{
  background-color: rgb(253 176 34 / 0.75);
}

.hover\\:bg-warning-400\\/80:hover{
  background-color: rgb(253 176 34 / 0.8);
}

.hover\\:bg-warning-400\\/85:hover{
  background-color: rgb(253 176 34 / 0.85);
}

.hover\\:bg-warning-400\\/90:hover{
  background-color: rgb(253 176 34 / 0.9);
}

.hover\\:bg-warning-400\\/95:hover{
  background-color: rgb(253 176 34 / 0.95);
}

.hover\\:bg-warning-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-50\\/0:hover{
  background-color: rgb(255 250 235 / 0);
}

.hover\\:bg-warning-50\\/10:hover{
  background-color: rgb(255 250 235 / 0.1);
}

.hover\\:bg-warning-50\\/100:hover{
  background-color: rgb(255 250 235 / 1);
}

.hover\\:bg-warning-50\\/15:hover{
  background-color: rgb(255 250 235 / 0.15);
}

.hover\\:bg-warning-50\\/20:hover{
  background-color: rgb(255 250 235 / 0.2);
}

.hover\\:bg-warning-50\\/25:hover{
  background-color: rgb(255 250 235 / 0.25);
}

.hover\\:bg-warning-50\\/30:hover{
  background-color: rgb(255 250 235 / 0.3);
}

.hover\\:bg-warning-50\\/35:hover{
  background-color: rgb(255 250 235 / 0.35);
}

.hover\\:bg-warning-50\\/40:hover{
  background-color: rgb(255 250 235 / 0.4);
}

.hover\\:bg-warning-50\\/45:hover{
  background-color: rgb(255 250 235 / 0.45);
}

.hover\\:bg-warning-50\\/5:hover{
  background-color: rgb(255 250 235 / 0.05);
}

.hover\\:bg-warning-50\\/50:hover{
  background-color: rgb(255 250 235 / 0.5);
}

.hover\\:bg-warning-50\\/55:hover{
  background-color: rgb(255 250 235 / 0.55);
}

.hover\\:bg-warning-50\\/60:hover{
  background-color: rgb(255 250 235 / 0.6);
}

.hover\\:bg-warning-50\\/65:hover{
  background-color: rgb(255 250 235 / 0.65);
}

.hover\\:bg-warning-50\\/70:hover{
  background-color: rgb(255 250 235 / 0.7);
}

.hover\\:bg-warning-50\\/75:hover{
  background-color: rgb(255 250 235 / 0.75);
}

.hover\\:bg-warning-50\\/80:hover{
  background-color: rgb(255 250 235 / 0.8);
}

.hover\\:bg-warning-50\\/85:hover{
  background-color: rgb(255 250 235 / 0.85);
}

.hover\\:bg-warning-50\\/90:hover{
  background-color: rgb(255 250 235 / 0.9);
}

.hover\\:bg-warning-50\\/95:hover{
  background-color: rgb(255 250 235 / 0.95);
}

.hover\\:bg-warning-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-500\\/0:hover{
  background-color: rgb(247 144 9 / 0);
}

.hover\\:bg-warning-500\\/10:hover{
  background-color: rgb(247 144 9 / 0.1);
}

.hover\\:bg-warning-500\\/100:hover{
  background-color: rgb(247 144 9 / 1);
}

.hover\\:bg-warning-500\\/15:hover{
  background-color: rgb(247 144 9 / 0.15);
}

.hover\\:bg-warning-500\\/20:hover{
  background-color: rgb(247 144 9 / 0.2);
}

.hover\\:bg-warning-500\\/25:hover{
  background-color: rgb(247 144 9 / 0.25);
}

.hover\\:bg-warning-500\\/30:hover{
  background-color: rgb(247 144 9 / 0.3);
}

.hover\\:bg-warning-500\\/35:hover{
  background-color: rgb(247 144 9 / 0.35);
}

.hover\\:bg-warning-500\\/40:hover{
  background-color: rgb(247 144 9 / 0.4);
}

.hover\\:bg-warning-500\\/45:hover{
  background-color: rgb(247 144 9 / 0.45);
}

.hover\\:bg-warning-500\\/5:hover{
  background-color: rgb(247 144 9 / 0.05);
}

.hover\\:bg-warning-500\\/50:hover{
  background-color: rgb(247 144 9 / 0.5);
}

.hover\\:bg-warning-500\\/55:hover{
  background-color: rgb(247 144 9 / 0.55);
}

.hover\\:bg-warning-500\\/60:hover{
  background-color: rgb(247 144 9 / 0.6);
}

.hover\\:bg-warning-500\\/65:hover{
  background-color: rgb(247 144 9 / 0.65);
}

.hover\\:bg-warning-500\\/70:hover{
  background-color: rgb(247 144 9 / 0.7);
}

.hover\\:bg-warning-500\\/75:hover{
  background-color: rgb(247 144 9 / 0.75);
}

.hover\\:bg-warning-500\\/80:hover{
  background-color: rgb(247 144 9 / 0.8);
}

.hover\\:bg-warning-500\\/85:hover{
  background-color: rgb(247 144 9 / 0.85);
}

.hover\\:bg-warning-500\\/90:hover{
  background-color: rgb(247 144 9 / 0.9);
}

.hover\\:bg-warning-500\\/95:hover{
  background-color: rgb(247 144 9 / 0.95);
}

.hover\\:bg-warning-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-600\\/0:hover{
  background-color: rgb(220 104 3 / 0);
}

.hover\\:bg-warning-600\\/10:hover{
  background-color: rgb(220 104 3 / 0.1);
}

.hover\\:bg-warning-600\\/100:hover{
  background-color: rgb(220 104 3 / 1);
}

.hover\\:bg-warning-600\\/15:hover{
  background-color: rgb(220 104 3 / 0.15);
}

.hover\\:bg-warning-600\\/20:hover{
  background-color: rgb(220 104 3 / 0.2);
}

.hover\\:bg-warning-600\\/25:hover{
  background-color: rgb(220 104 3 / 0.25);
}

.hover\\:bg-warning-600\\/30:hover{
  background-color: rgb(220 104 3 / 0.3);
}

.hover\\:bg-warning-600\\/35:hover{
  background-color: rgb(220 104 3 / 0.35);
}

.hover\\:bg-warning-600\\/40:hover{
  background-color: rgb(220 104 3 / 0.4);
}

.hover\\:bg-warning-600\\/45:hover{
  background-color: rgb(220 104 3 / 0.45);
}

.hover\\:bg-warning-600\\/5:hover{
  background-color: rgb(220 104 3 / 0.05);
}

.hover\\:bg-warning-600\\/50:hover{
  background-color: rgb(220 104 3 / 0.5);
}

.hover\\:bg-warning-600\\/55:hover{
  background-color: rgb(220 104 3 / 0.55);
}

.hover\\:bg-warning-600\\/60:hover{
  background-color: rgb(220 104 3 / 0.6);
}

.hover\\:bg-warning-600\\/65:hover{
  background-color: rgb(220 104 3 / 0.65);
}

.hover\\:bg-warning-600\\/70:hover{
  background-color: rgb(220 104 3 / 0.7);
}

.hover\\:bg-warning-600\\/75:hover{
  background-color: rgb(220 104 3 / 0.75);
}

.hover\\:bg-warning-600\\/80:hover{
  background-color: rgb(220 104 3 / 0.8);
}

.hover\\:bg-warning-600\\/85:hover{
  background-color: rgb(220 104 3 / 0.85);
}

.hover\\:bg-warning-600\\/90:hover{
  background-color: rgb(220 104 3 / 0.9);
}

.hover\\:bg-warning-600\\/95:hover{
  background-color: rgb(220 104 3 / 0.95);
}

.hover\\:bg-warning-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-warning-700\\/0:hover{
  background-color: rgb(181 71 8 / 0);
}

.hover\\:bg-warning-700\\/10:hover{
  background-color: rgb(181 71 8 / 0.1);
}

.hover\\:bg-warning-700\\/100:hover{
  background-color: rgb(181 71 8 / 1);
}

.hover\\:bg-warning-700\\/15:hover{
  background-color: rgb(181 71 8 / 0.15);
}

.hover\\:bg-warning-700\\/20:hover{
  background-color: rgb(181 71 8 / 0.2);
}

.hover\\:bg-warning-700\\/25:hover{
  background-color: rgb(181 71 8 / 0.25);
}

.hover\\:bg-warning-700\\/30:hover{
  background-color: rgb(181 71 8 / 0.3);
}

.hover\\:bg-warning-700\\/35:hover{
  background-color: rgb(181 71 8 / 0.35);
}

.hover\\:bg-warning-700\\/40:hover{
  background-color: rgb(181 71 8 / 0.4);
}

.hover\\:bg-warning-700\\/45:hover{
  background-color: rgb(181 71 8 / 0.45);
}

.hover\\:bg-warning-700\\/5:hover{
  background-color: rgb(181 71 8 / 0.05);
}

.hover\\:bg-warning-700\\/50:hover{
  background-color: rgb(181 71 8 / 0.5);
}

.hover\\:bg-warning-700\\/55:hover{
  background-color: rgb(181 71 8 / 0.55);
}

.hover\\:bg-warning-700\\/60:hover{
  background-color: rgb(181 71 8 / 0.6);
}

.hover\\:bg-warning-700\\/65:hover{
  background-color: rgb(181 71 8 / 0.65);
}

.hover\\:bg-warning-700\\/70:hover{
  background-color: rgb(181 71 8 / 0.7);
}

.hover\\:bg-warning-700\\/75:hover{
  background-color: rgb(181 71 8 / 0.75);
}

.hover\\:bg-warning-700\\/80:hover{
  background-color: rgb(181 71 8 / 0.8);
}

.hover\\:bg-warning-700\\/85:hover{
  background-color: rgb(181 71 8 / 0.85);
}

.hover\\:bg-warning-700\\/90:hover{
  background-color: rgb(181 71 8 / 0.9);
}

.hover\\:bg-warning-700\\/95:hover{
  background-color: rgb(181 71 8 / 0.95);
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-none:hover{
  background-image: none;
}

.hover\\:\\!text-danger-500:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:\\!text-neutral-800:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:\\!text-neutral-900:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:\\!text-white:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#002A3B\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(0 42 59 / var(--tw-text-opacity, 1));
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-700:hover{
  --tw-text-opacity: 1;
  color: rgb(14 112 144 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-100:hover{
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-100\\/0:hover{
  color: rgb(254 228 226 / 0);
}

.hover\\:text-danger-100\\/10:hover{
  color: rgb(254 228 226 / 0.1);
}

.hover\\:text-danger-100\\/100:hover{
  color: rgb(254 228 226 / 1);
}

.hover\\:text-danger-100\\/15:hover{
  color: rgb(254 228 226 / 0.15);
}

.hover\\:text-danger-100\\/20:hover{
  color: rgb(254 228 226 / 0.2);
}

.hover\\:text-danger-100\\/25:hover{
  color: rgb(254 228 226 / 0.25);
}

.hover\\:text-danger-100\\/30:hover{
  color: rgb(254 228 226 / 0.3);
}

.hover\\:text-danger-100\\/35:hover{
  color: rgb(254 228 226 / 0.35);
}

.hover\\:text-danger-100\\/40:hover{
  color: rgb(254 228 226 / 0.4);
}

.hover\\:text-danger-100\\/45:hover{
  color: rgb(254 228 226 / 0.45);
}

.hover\\:text-danger-100\\/5:hover{
  color: rgb(254 228 226 / 0.05);
}

.hover\\:text-danger-100\\/50:hover{
  color: rgb(254 228 226 / 0.5);
}

.hover\\:text-danger-100\\/55:hover{
  color: rgb(254 228 226 / 0.55);
}

.hover\\:text-danger-100\\/60:hover{
  color: rgb(254 228 226 / 0.6);
}

.hover\\:text-danger-100\\/65:hover{
  color: rgb(254 228 226 / 0.65);
}

.hover\\:text-danger-100\\/70:hover{
  color: rgb(254 228 226 / 0.7);
}

.hover\\:text-danger-100\\/75:hover{
  color: rgb(254 228 226 / 0.75);
}

.hover\\:text-danger-100\\/80:hover{
  color: rgb(254 228 226 / 0.8);
}

.hover\\:text-danger-100\\/85:hover{
  color: rgb(254 228 226 / 0.85);
}

.hover\\:text-danger-100\\/90:hover{
  color: rgb(254 228 226 / 0.9);
}

.hover\\:text-danger-100\\/95:hover{
  color: rgb(254 228 226 / 0.95);
}

.hover\\:text-danger-200:hover{
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-200\\/0:hover{
  color: rgb(254 205 202 / 0);
}

.hover\\:text-danger-200\\/10:hover{
  color: rgb(254 205 202 / 0.1);
}

.hover\\:text-danger-200\\/100:hover{
  color: rgb(254 205 202 / 1);
}

.hover\\:text-danger-200\\/15:hover{
  color: rgb(254 205 202 / 0.15);
}

.hover\\:text-danger-200\\/20:hover{
  color: rgb(254 205 202 / 0.2);
}

.hover\\:text-danger-200\\/25:hover{
  color: rgb(254 205 202 / 0.25);
}

.hover\\:text-danger-200\\/30:hover{
  color: rgb(254 205 202 / 0.3);
}

.hover\\:text-danger-200\\/35:hover{
  color: rgb(254 205 202 / 0.35);
}

.hover\\:text-danger-200\\/40:hover{
  color: rgb(254 205 202 / 0.4);
}

.hover\\:text-danger-200\\/45:hover{
  color: rgb(254 205 202 / 0.45);
}

.hover\\:text-danger-200\\/5:hover{
  color: rgb(254 205 202 / 0.05);
}

.hover\\:text-danger-200\\/50:hover{
  color: rgb(254 205 202 / 0.5);
}

.hover\\:text-danger-200\\/55:hover{
  color: rgb(254 205 202 / 0.55);
}

.hover\\:text-danger-200\\/60:hover{
  color: rgb(254 205 202 / 0.6);
}

.hover\\:text-danger-200\\/65:hover{
  color: rgb(254 205 202 / 0.65);
}

.hover\\:text-danger-200\\/70:hover{
  color: rgb(254 205 202 / 0.7);
}

.hover\\:text-danger-200\\/75:hover{
  color: rgb(254 205 202 / 0.75);
}

.hover\\:text-danger-200\\/80:hover{
  color: rgb(254 205 202 / 0.8);
}

.hover\\:text-danger-200\\/85:hover{
  color: rgb(254 205 202 / 0.85);
}

.hover\\:text-danger-200\\/90:hover{
  color: rgb(254 205 202 / 0.9);
}

.hover\\:text-danger-200\\/95:hover{
  color: rgb(254 205 202 / 0.95);
}

.hover\\:text-danger-25:hover{
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-25\\/0:hover{
  color: rgb(255 251 250 / 0);
}

.hover\\:text-danger-25\\/10:hover{
  color: rgb(255 251 250 / 0.1);
}

.hover\\:text-danger-25\\/100:hover{
  color: rgb(255 251 250 / 1);
}

.hover\\:text-danger-25\\/15:hover{
  color: rgb(255 251 250 / 0.15);
}

.hover\\:text-danger-25\\/20:hover{
  color: rgb(255 251 250 / 0.2);
}

.hover\\:text-danger-25\\/25:hover{
  color: rgb(255 251 250 / 0.25);
}

.hover\\:text-danger-25\\/30:hover{
  color: rgb(255 251 250 / 0.3);
}

.hover\\:text-danger-25\\/35:hover{
  color: rgb(255 251 250 / 0.35);
}

.hover\\:text-danger-25\\/40:hover{
  color: rgb(255 251 250 / 0.4);
}

.hover\\:text-danger-25\\/45:hover{
  color: rgb(255 251 250 / 0.45);
}

.hover\\:text-danger-25\\/5:hover{
  color: rgb(255 251 250 / 0.05);
}

.hover\\:text-danger-25\\/50:hover{
  color: rgb(255 251 250 / 0.5);
}

.hover\\:text-danger-25\\/55:hover{
  color: rgb(255 251 250 / 0.55);
}

.hover\\:text-danger-25\\/60:hover{
  color: rgb(255 251 250 / 0.6);
}

.hover\\:text-danger-25\\/65:hover{
  color: rgb(255 251 250 / 0.65);
}

.hover\\:text-danger-25\\/70:hover{
  color: rgb(255 251 250 / 0.7);
}

.hover\\:text-danger-25\\/75:hover{
  color: rgb(255 251 250 / 0.75);
}

.hover\\:text-danger-25\\/80:hover{
  color: rgb(255 251 250 / 0.8);
}

.hover\\:text-danger-25\\/85:hover{
  color: rgb(255 251 250 / 0.85);
}

.hover\\:text-danger-25\\/90:hover{
  color: rgb(255 251 250 / 0.9);
}

.hover\\:text-danger-25\\/95:hover{
  color: rgb(255 251 250 / 0.95);
}

.hover\\:text-danger-400:hover{
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-400\\/0:hover{
  color: rgb(249 112 102 / 0);
}

.hover\\:text-danger-400\\/10:hover{
  color: rgb(249 112 102 / 0.1);
}

.hover\\:text-danger-400\\/100:hover{
  color: rgb(249 112 102 / 1);
}

.hover\\:text-danger-400\\/15:hover{
  color: rgb(249 112 102 / 0.15);
}

.hover\\:text-danger-400\\/20:hover{
  color: rgb(249 112 102 / 0.2);
}

.hover\\:text-danger-400\\/25:hover{
  color: rgb(249 112 102 / 0.25);
}

.hover\\:text-danger-400\\/30:hover{
  color: rgb(249 112 102 / 0.3);
}

.hover\\:text-danger-400\\/35:hover{
  color: rgb(249 112 102 / 0.35);
}

.hover\\:text-danger-400\\/40:hover{
  color: rgb(249 112 102 / 0.4);
}

.hover\\:text-danger-400\\/45:hover{
  color: rgb(249 112 102 / 0.45);
}

.hover\\:text-danger-400\\/5:hover{
  color: rgb(249 112 102 / 0.05);
}

.hover\\:text-danger-400\\/50:hover{
  color: rgb(249 112 102 / 0.5);
}

.hover\\:text-danger-400\\/55:hover{
  color: rgb(249 112 102 / 0.55);
}

.hover\\:text-danger-400\\/60:hover{
  color: rgb(249 112 102 / 0.6);
}

.hover\\:text-danger-400\\/65:hover{
  color: rgb(249 112 102 / 0.65);
}

.hover\\:text-danger-400\\/70:hover{
  color: rgb(249 112 102 / 0.7);
}

.hover\\:text-danger-400\\/75:hover{
  color: rgb(249 112 102 / 0.75);
}

.hover\\:text-danger-400\\/80:hover{
  color: rgb(249 112 102 / 0.8);
}

.hover\\:text-danger-400\\/85:hover{
  color: rgb(249 112 102 / 0.85);
}

.hover\\:text-danger-400\\/90:hover{
  color: rgb(249 112 102 / 0.9);
}

.hover\\:text-danger-400\\/95:hover{
  color: rgb(249 112 102 / 0.95);
}

.hover\\:text-danger-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-50\\/0:hover{
  color: rgb(254 243 242 / 0);
}

.hover\\:text-danger-50\\/10:hover{
  color: rgb(254 243 242 / 0.1);
}

.hover\\:text-danger-50\\/100:hover{
  color: rgb(254 243 242 / 1);
}

.hover\\:text-danger-50\\/15:hover{
  color: rgb(254 243 242 / 0.15);
}

.hover\\:text-danger-50\\/20:hover{
  color: rgb(254 243 242 / 0.2);
}

.hover\\:text-danger-50\\/25:hover{
  color: rgb(254 243 242 / 0.25);
}

.hover\\:text-danger-50\\/30:hover{
  color: rgb(254 243 242 / 0.3);
}

.hover\\:text-danger-50\\/35:hover{
  color: rgb(254 243 242 / 0.35);
}

.hover\\:text-danger-50\\/40:hover{
  color: rgb(254 243 242 / 0.4);
}

.hover\\:text-danger-50\\/45:hover{
  color: rgb(254 243 242 / 0.45);
}

.hover\\:text-danger-50\\/5:hover{
  color: rgb(254 243 242 / 0.05);
}

.hover\\:text-danger-50\\/50:hover{
  color: rgb(254 243 242 / 0.5);
}

.hover\\:text-danger-50\\/55:hover{
  color: rgb(254 243 242 / 0.55);
}

.hover\\:text-danger-50\\/60:hover{
  color: rgb(254 243 242 / 0.6);
}

.hover\\:text-danger-50\\/65:hover{
  color: rgb(254 243 242 / 0.65);
}

.hover\\:text-danger-50\\/70:hover{
  color: rgb(254 243 242 / 0.7);
}

.hover\\:text-danger-50\\/75:hover{
  color: rgb(254 243 242 / 0.75);
}

.hover\\:text-danger-50\\/80:hover{
  color: rgb(254 243 242 / 0.8);
}

.hover\\:text-danger-50\\/85:hover{
  color: rgb(254 243 242 / 0.85);
}

.hover\\:text-danger-50\\/90:hover{
  color: rgb(254 243 242 / 0.9);
}

.hover\\:text-danger-50\\/95:hover{
  color: rgb(254 243 242 / 0.95);
}

.hover\\:text-danger-500:hover{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-500\\/0:hover{
  color: rgb(240 68 56 / 0);
}

.hover\\:text-danger-500\\/10:hover{
  color: rgb(240 68 56 / 0.1);
}

.hover\\:text-danger-500\\/100:hover{
  color: rgb(240 68 56 / 1);
}

.hover\\:text-danger-500\\/15:hover{
  color: rgb(240 68 56 / 0.15);
}

.hover\\:text-danger-500\\/20:hover{
  color: rgb(240 68 56 / 0.2);
}

.hover\\:text-danger-500\\/25:hover{
  color: rgb(240 68 56 / 0.25);
}

.hover\\:text-danger-500\\/30:hover{
  color: rgb(240 68 56 / 0.3);
}

.hover\\:text-danger-500\\/35:hover{
  color: rgb(240 68 56 / 0.35);
}

.hover\\:text-danger-500\\/40:hover{
  color: rgb(240 68 56 / 0.4);
}

.hover\\:text-danger-500\\/45:hover{
  color: rgb(240 68 56 / 0.45);
}

.hover\\:text-danger-500\\/5:hover{
  color: rgb(240 68 56 / 0.05);
}

.hover\\:text-danger-500\\/50:hover{
  color: rgb(240 68 56 / 0.5);
}

.hover\\:text-danger-500\\/55:hover{
  color: rgb(240 68 56 / 0.55);
}

.hover\\:text-danger-500\\/60:hover{
  color: rgb(240 68 56 / 0.6);
}

.hover\\:text-danger-500\\/65:hover{
  color: rgb(240 68 56 / 0.65);
}

.hover\\:text-danger-500\\/70:hover{
  color: rgb(240 68 56 / 0.7);
}

.hover\\:text-danger-500\\/75:hover{
  color: rgb(240 68 56 / 0.75);
}

.hover\\:text-danger-500\\/80:hover{
  color: rgb(240 68 56 / 0.8);
}

.hover\\:text-danger-500\\/85:hover{
  color: rgb(240 68 56 / 0.85);
}

.hover\\:text-danger-500\\/90:hover{
  color: rgb(240 68 56 / 0.9);
}

.hover\\:text-danger-500\\/95:hover{
  color: rgb(240 68 56 / 0.95);
}

.hover\\:text-danger-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-600\\/0:hover{
  color: rgb(217 45 32 / 0);
}

.hover\\:text-danger-600\\/10:hover{
  color: rgb(217 45 32 / 0.1);
}

.hover\\:text-danger-600\\/100:hover{
  color: rgb(217 45 32 / 1);
}

.hover\\:text-danger-600\\/15:hover{
  color: rgb(217 45 32 / 0.15);
}

.hover\\:text-danger-600\\/20:hover{
  color: rgb(217 45 32 / 0.2);
}

.hover\\:text-danger-600\\/25:hover{
  color: rgb(217 45 32 / 0.25);
}

.hover\\:text-danger-600\\/30:hover{
  color: rgb(217 45 32 / 0.3);
}

.hover\\:text-danger-600\\/35:hover{
  color: rgb(217 45 32 / 0.35);
}

.hover\\:text-danger-600\\/40:hover{
  color: rgb(217 45 32 / 0.4);
}

.hover\\:text-danger-600\\/45:hover{
  color: rgb(217 45 32 / 0.45);
}

.hover\\:text-danger-600\\/5:hover{
  color: rgb(217 45 32 / 0.05);
}

.hover\\:text-danger-600\\/50:hover{
  color: rgb(217 45 32 / 0.5);
}

.hover\\:text-danger-600\\/55:hover{
  color: rgb(217 45 32 / 0.55);
}

.hover\\:text-danger-600\\/60:hover{
  color: rgb(217 45 32 / 0.6);
}

.hover\\:text-danger-600\\/65:hover{
  color: rgb(217 45 32 / 0.65);
}

.hover\\:text-danger-600\\/70:hover{
  color: rgb(217 45 32 / 0.7);
}

.hover\\:text-danger-600\\/75:hover{
  color: rgb(217 45 32 / 0.75);
}

.hover\\:text-danger-600\\/80:hover{
  color: rgb(217 45 32 / 0.8);
}

.hover\\:text-danger-600\\/85:hover{
  color: rgb(217 45 32 / 0.85);
}

.hover\\:text-danger-600\\/90:hover{
  color: rgb(217 45 32 / 0.9);
}

.hover\\:text-danger-600\\/95:hover{
  color: rgb(217 45 32 / 0.95);
}

.hover\\:text-danger-700:hover{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger-700\\/0:hover{
  color: rgb(180 35 24 / 0);
}

.hover\\:text-danger-700\\/10:hover{
  color: rgb(180 35 24 / 0.1);
}

.hover\\:text-danger-700\\/100:hover{
  color: rgb(180 35 24 / 1);
}

.hover\\:text-danger-700\\/15:hover{
  color: rgb(180 35 24 / 0.15);
}

.hover\\:text-danger-700\\/20:hover{
  color: rgb(180 35 24 / 0.2);
}

.hover\\:text-danger-700\\/25:hover{
  color: rgb(180 35 24 / 0.25);
}

.hover\\:text-danger-700\\/30:hover{
  color: rgb(180 35 24 / 0.3);
}

.hover\\:text-danger-700\\/35:hover{
  color: rgb(180 35 24 / 0.35);
}

.hover\\:text-danger-700\\/40:hover{
  color: rgb(180 35 24 / 0.4);
}

.hover\\:text-danger-700\\/45:hover{
  color: rgb(180 35 24 / 0.45);
}

.hover\\:text-danger-700\\/5:hover{
  color: rgb(180 35 24 / 0.05);
}

.hover\\:text-danger-700\\/50:hover{
  color: rgb(180 35 24 / 0.5);
}

.hover\\:text-danger-700\\/55:hover{
  color: rgb(180 35 24 / 0.55);
}

.hover\\:text-danger-700\\/60:hover{
  color: rgb(180 35 24 / 0.6);
}

.hover\\:text-danger-700\\/65:hover{
  color: rgb(180 35 24 / 0.65);
}

.hover\\:text-danger-700\\/70:hover{
  color: rgb(180 35 24 / 0.7);
}

.hover\\:text-danger-700\\/75:hover{
  color: rgb(180 35 24 / 0.75);
}

.hover\\:text-danger-700\\/80:hover{
  color: rgb(180 35 24 / 0.8);
}

.hover\\:text-danger-700\\/85:hover{
  color: rgb(180 35 24 / 0.85);
}

.hover\\:text-danger-700\\/90:hover{
  color: rgb(180 35 24 / 0.9);
}

.hover\\:text-danger-700\\/95:hover{
  color: rgb(180 35 24 / 0.95);
}

.hover\\:text-danger-800:hover{
  --tw-text-opacity: 1;
  color: rgb(145 32 24 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-100:hover{
  --tw-text-opacity: 1;
  color: rgb(230 244 215 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-100\\/0:hover{
  color: rgb(230 244 215 / 0);
}

.hover\\:text-moss-100\\/10:hover{
  color: rgb(230 244 215 / 0.1);
}

.hover\\:text-moss-100\\/100:hover{
  color: rgb(230 244 215 / 1);
}

.hover\\:text-moss-100\\/15:hover{
  color: rgb(230 244 215 / 0.15);
}

.hover\\:text-moss-100\\/20:hover{
  color: rgb(230 244 215 / 0.2);
}

.hover\\:text-moss-100\\/25:hover{
  color: rgb(230 244 215 / 0.25);
}

.hover\\:text-moss-100\\/30:hover{
  color: rgb(230 244 215 / 0.3);
}

.hover\\:text-moss-100\\/35:hover{
  color: rgb(230 244 215 / 0.35);
}

.hover\\:text-moss-100\\/40:hover{
  color: rgb(230 244 215 / 0.4);
}

.hover\\:text-moss-100\\/45:hover{
  color: rgb(230 244 215 / 0.45);
}

.hover\\:text-moss-100\\/5:hover{
  color: rgb(230 244 215 / 0.05);
}

.hover\\:text-moss-100\\/50:hover{
  color: rgb(230 244 215 / 0.5);
}

.hover\\:text-moss-100\\/55:hover{
  color: rgb(230 244 215 / 0.55);
}

.hover\\:text-moss-100\\/60:hover{
  color: rgb(230 244 215 / 0.6);
}

.hover\\:text-moss-100\\/65:hover{
  color: rgb(230 244 215 / 0.65);
}

.hover\\:text-moss-100\\/70:hover{
  color: rgb(230 244 215 / 0.7);
}

.hover\\:text-moss-100\\/75:hover{
  color: rgb(230 244 215 / 0.75);
}

.hover\\:text-moss-100\\/80:hover{
  color: rgb(230 244 215 / 0.8);
}

.hover\\:text-moss-100\\/85:hover{
  color: rgb(230 244 215 / 0.85);
}

.hover\\:text-moss-100\\/90:hover{
  color: rgb(230 244 215 / 0.9);
}

.hover\\:text-moss-100\\/95:hover{
  color: rgb(230 244 215 / 0.95);
}

.hover\\:text-moss-200:hover{
  --tw-text-opacity: 1;
  color: rgb(206 234 176 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-200\\/0:hover{
  color: rgb(206 234 176 / 0);
}

.hover\\:text-moss-200\\/10:hover{
  color: rgb(206 234 176 / 0.1);
}

.hover\\:text-moss-200\\/100:hover{
  color: rgb(206 234 176 / 1);
}

.hover\\:text-moss-200\\/15:hover{
  color: rgb(206 234 176 / 0.15);
}

.hover\\:text-moss-200\\/20:hover{
  color: rgb(206 234 176 / 0.2);
}

.hover\\:text-moss-200\\/25:hover{
  color: rgb(206 234 176 / 0.25);
}

.hover\\:text-moss-200\\/30:hover{
  color: rgb(206 234 176 / 0.3);
}

.hover\\:text-moss-200\\/35:hover{
  color: rgb(206 234 176 / 0.35);
}

.hover\\:text-moss-200\\/40:hover{
  color: rgb(206 234 176 / 0.4);
}

.hover\\:text-moss-200\\/45:hover{
  color: rgb(206 234 176 / 0.45);
}

.hover\\:text-moss-200\\/5:hover{
  color: rgb(206 234 176 / 0.05);
}

.hover\\:text-moss-200\\/50:hover{
  color: rgb(206 234 176 / 0.5);
}

.hover\\:text-moss-200\\/55:hover{
  color: rgb(206 234 176 / 0.55);
}

.hover\\:text-moss-200\\/60:hover{
  color: rgb(206 234 176 / 0.6);
}

.hover\\:text-moss-200\\/65:hover{
  color: rgb(206 234 176 / 0.65);
}

.hover\\:text-moss-200\\/70:hover{
  color: rgb(206 234 176 / 0.7);
}

.hover\\:text-moss-200\\/75:hover{
  color: rgb(206 234 176 / 0.75);
}

.hover\\:text-moss-200\\/80:hover{
  color: rgb(206 234 176 / 0.8);
}

.hover\\:text-moss-200\\/85:hover{
  color: rgb(206 234 176 / 0.85);
}

.hover\\:text-moss-200\\/90:hover{
  color: rgb(206 234 176 / 0.9);
}

.hover\\:text-moss-200\\/95:hover{
  color: rgb(206 234 176 / 0.95);
}

.hover\\:text-moss-25:hover{
  --tw-text-opacity: 1;
  color: rgb(250 253 247 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-25\\/0:hover{
  color: rgb(250 253 247 / 0);
}

.hover\\:text-moss-25\\/10:hover{
  color: rgb(250 253 247 / 0.1);
}

.hover\\:text-moss-25\\/100:hover{
  color: rgb(250 253 247 / 1);
}

.hover\\:text-moss-25\\/15:hover{
  color: rgb(250 253 247 / 0.15);
}

.hover\\:text-moss-25\\/20:hover{
  color: rgb(250 253 247 / 0.2);
}

.hover\\:text-moss-25\\/25:hover{
  color: rgb(250 253 247 / 0.25);
}

.hover\\:text-moss-25\\/30:hover{
  color: rgb(250 253 247 / 0.3);
}

.hover\\:text-moss-25\\/35:hover{
  color: rgb(250 253 247 / 0.35);
}

.hover\\:text-moss-25\\/40:hover{
  color: rgb(250 253 247 / 0.4);
}

.hover\\:text-moss-25\\/45:hover{
  color: rgb(250 253 247 / 0.45);
}

.hover\\:text-moss-25\\/5:hover{
  color: rgb(250 253 247 / 0.05);
}

.hover\\:text-moss-25\\/50:hover{
  color: rgb(250 253 247 / 0.5);
}

.hover\\:text-moss-25\\/55:hover{
  color: rgb(250 253 247 / 0.55);
}

.hover\\:text-moss-25\\/60:hover{
  color: rgb(250 253 247 / 0.6);
}

.hover\\:text-moss-25\\/65:hover{
  color: rgb(250 253 247 / 0.65);
}

.hover\\:text-moss-25\\/70:hover{
  color: rgb(250 253 247 / 0.7);
}

.hover\\:text-moss-25\\/75:hover{
  color: rgb(250 253 247 / 0.75);
}

.hover\\:text-moss-25\\/80:hover{
  color: rgb(250 253 247 / 0.8);
}

.hover\\:text-moss-25\\/85:hover{
  color: rgb(250 253 247 / 0.85);
}

.hover\\:text-moss-25\\/90:hover{
  color: rgb(250 253 247 / 0.9);
}

.hover\\:text-moss-25\\/95:hover{
  color: rgb(250 253 247 / 0.95);
}

.hover\\:text-moss-400:hover{
  --tw-text-opacity: 1;
  color: rgb(134 203 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-400\\/0:hover{
  color: rgb(134 203 60 / 0);
}

.hover\\:text-moss-400\\/10:hover{
  color: rgb(134 203 60 / 0.1);
}

.hover\\:text-moss-400\\/100:hover{
  color: rgb(134 203 60 / 1);
}

.hover\\:text-moss-400\\/15:hover{
  color: rgb(134 203 60 / 0.15);
}

.hover\\:text-moss-400\\/20:hover{
  color: rgb(134 203 60 / 0.2);
}

.hover\\:text-moss-400\\/25:hover{
  color: rgb(134 203 60 / 0.25);
}

.hover\\:text-moss-400\\/30:hover{
  color: rgb(134 203 60 / 0.3);
}

.hover\\:text-moss-400\\/35:hover{
  color: rgb(134 203 60 / 0.35);
}

.hover\\:text-moss-400\\/40:hover{
  color: rgb(134 203 60 / 0.4);
}

.hover\\:text-moss-400\\/45:hover{
  color: rgb(134 203 60 / 0.45);
}

.hover\\:text-moss-400\\/5:hover{
  color: rgb(134 203 60 / 0.05);
}

.hover\\:text-moss-400\\/50:hover{
  color: rgb(134 203 60 / 0.5);
}

.hover\\:text-moss-400\\/55:hover{
  color: rgb(134 203 60 / 0.55);
}

.hover\\:text-moss-400\\/60:hover{
  color: rgb(134 203 60 / 0.6);
}

.hover\\:text-moss-400\\/65:hover{
  color: rgb(134 203 60 / 0.65);
}

.hover\\:text-moss-400\\/70:hover{
  color: rgb(134 203 60 / 0.7);
}

.hover\\:text-moss-400\\/75:hover{
  color: rgb(134 203 60 / 0.75);
}

.hover\\:text-moss-400\\/80:hover{
  color: rgb(134 203 60 / 0.8);
}

.hover\\:text-moss-400\\/85:hover{
  color: rgb(134 203 60 / 0.85);
}

.hover\\:text-moss-400\\/90:hover{
  color: rgb(134 203 60 / 0.9);
}

.hover\\:text-moss-400\\/95:hover{
  color: rgb(134 203 60 / 0.95);
}

.hover\\:text-moss-50:hover{
  --tw-text-opacity: 1;
  color: rgb(245 251 238 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-50\\/0:hover{
  color: rgb(245 251 238 / 0);
}

.hover\\:text-moss-50\\/10:hover{
  color: rgb(245 251 238 / 0.1);
}

.hover\\:text-moss-50\\/100:hover{
  color: rgb(245 251 238 / 1);
}

.hover\\:text-moss-50\\/15:hover{
  color: rgb(245 251 238 / 0.15);
}

.hover\\:text-moss-50\\/20:hover{
  color: rgb(245 251 238 / 0.2);
}

.hover\\:text-moss-50\\/25:hover{
  color: rgb(245 251 238 / 0.25);
}

.hover\\:text-moss-50\\/30:hover{
  color: rgb(245 251 238 / 0.3);
}

.hover\\:text-moss-50\\/35:hover{
  color: rgb(245 251 238 / 0.35);
}

.hover\\:text-moss-50\\/40:hover{
  color: rgb(245 251 238 / 0.4);
}

.hover\\:text-moss-50\\/45:hover{
  color: rgb(245 251 238 / 0.45);
}

.hover\\:text-moss-50\\/5:hover{
  color: rgb(245 251 238 / 0.05);
}

.hover\\:text-moss-50\\/50:hover{
  color: rgb(245 251 238 / 0.5);
}

.hover\\:text-moss-50\\/55:hover{
  color: rgb(245 251 238 / 0.55);
}

.hover\\:text-moss-50\\/60:hover{
  color: rgb(245 251 238 / 0.6);
}

.hover\\:text-moss-50\\/65:hover{
  color: rgb(245 251 238 / 0.65);
}

.hover\\:text-moss-50\\/70:hover{
  color: rgb(245 251 238 / 0.7);
}

.hover\\:text-moss-50\\/75:hover{
  color: rgb(245 251 238 / 0.75);
}

.hover\\:text-moss-50\\/80:hover{
  color: rgb(245 251 238 / 0.8);
}

.hover\\:text-moss-50\\/85:hover{
  color: rgb(245 251 238 / 0.85);
}

.hover\\:text-moss-50\\/90:hover{
  color: rgb(245 251 238 / 0.9);
}

.hover\\:text-moss-50\\/95:hover{
  color: rgb(245 251 238 / 0.95);
}

.hover\\:text-moss-500:hover{
  --tw-text-opacity: 1;
  color: rgb(102 159 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-500\\/0:hover{
  color: rgb(102 159 42 / 0);
}

.hover\\:text-moss-500\\/10:hover{
  color: rgb(102 159 42 / 0.1);
}

.hover\\:text-moss-500\\/100:hover{
  color: rgb(102 159 42 / 1);
}

.hover\\:text-moss-500\\/15:hover{
  color: rgb(102 159 42 / 0.15);
}

.hover\\:text-moss-500\\/20:hover{
  color: rgb(102 159 42 / 0.2);
}

.hover\\:text-moss-500\\/25:hover{
  color: rgb(102 159 42 / 0.25);
}

.hover\\:text-moss-500\\/30:hover{
  color: rgb(102 159 42 / 0.3);
}

.hover\\:text-moss-500\\/35:hover{
  color: rgb(102 159 42 / 0.35);
}

.hover\\:text-moss-500\\/40:hover{
  color: rgb(102 159 42 / 0.4);
}

.hover\\:text-moss-500\\/45:hover{
  color: rgb(102 159 42 / 0.45);
}

.hover\\:text-moss-500\\/5:hover{
  color: rgb(102 159 42 / 0.05);
}

.hover\\:text-moss-500\\/50:hover{
  color: rgb(102 159 42 / 0.5);
}

.hover\\:text-moss-500\\/55:hover{
  color: rgb(102 159 42 / 0.55);
}

.hover\\:text-moss-500\\/60:hover{
  color: rgb(102 159 42 / 0.6);
}

.hover\\:text-moss-500\\/65:hover{
  color: rgb(102 159 42 / 0.65);
}

.hover\\:text-moss-500\\/70:hover{
  color: rgb(102 159 42 / 0.7);
}

.hover\\:text-moss-500\\/75:hover{
  color: rgb(102 159 42 / 0.75);
}

.hover\\:text-moss-500\\/80:hover{
  color: rgb(102 159 42 / 0.8);
}

.hover\\:text-moss-500\\/85:hover{
  color: rgb(102 159 42 / 0.85);
}

.hover\\:text-moss-500\\/90:hover{
  color: rgb(102 159 42 / 0.9);
}

.hover\\:text-moss-500\\/95:hover{
  color: rgb(102 159 42 / 0.95);
}

.hover\\:text-moss-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 122 33 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-600\\/0:hover{
  color: rgb(79 122 33 / 0);
}

.hover\\:text-moss-600\\/10:hover{
  color: rgb(79 122 33 / 0.1);
}

.hover\\:text-moss-600\\/100:hover{
  color: rgb(79 122 33 / 1);
}

.hover\\:text-moss-600\\/15:hover{
  color: rgb(79 122 33 / 0.15);
}

.hover\\:text-moss-600\\/20:hover{
  color: rgb(79 122 33 / 0.2);
}

.hover\\:text-moss-600\\/25:hover{
  color: rgb(79 122 33 / 0.25);
}

.hover\\:text-moss-600\\/30:hover{
  color: rgb(79 122 33 / 0.3);
}

.hover\\:text-moss-600\\/35:hover{
  color: rgb(79 122 33 / 0.35);
}

.hover\\:text-moss-600\\/40:hover{
  color: rgb(79 122 33 / 0.4);
}

.hover\\:text-moss-600\\/45:hover{
  color: rgb(79 122 33 / 0.45);
}

.hover\\:text-moss-600\\/5:hover{
  color: rgb(79 122 33 / 0.05);
}

.hover\\:text-moss-600\\/50:hover{
  color: rgb(79 122 33 / 0.5);
}

.hover\\:text-moss-600\\/55:hover{
  color: rgb(79 122 33 / 0.55);
}

.hover\\:text-moss-600\\/60:hover{
  color: rgb(79 122 33 / 0.6);
}

.hover\\:text-moss-600\\/65:hover{
  color: rgb(79 122 33 / 0.65);
}

.hover\\:text-moss-600\\/70:hover{
  color: rgb(79 122 33 / 0.7);
}

.hover\\:text-moss-600\\/75:hover{
  color: rgb(79 122 33 / 0.75);
}

.hover\\:text-moss-600\\/80:hover{
  color: rgb(79 122 33 / 0.8);
}

.hover\\:text-moss-600\\/85:hover{
  color: rgb(79 122 33 / 0.85);
}

.hover\\:text-moss-600\\/90:hover{
  color: rgb(79 122 33 / 0.9);
}

.hover\\:text-moss-600\\/95:hover{
  color: rgb(79 122 33 / 0.95);
}

.hover\\:text-moss-700:hover{
  --tw-text-opacity: 1;
  color: rgb(63 98 26 / var(--tw-text-opacity, 1));
}

.hover\\:text-moss-700\\/0:hover{
  color: rgb(63 98 26 / 0);
}

.hover\\:text-moss-700\\/10:hover{
  color: rgb(63 98 26 / 0.1);
}

.hover\\:text-moss-700\\/100:hover{
  color: rgb(63 98 26 / 1);
}

.hover\\:text-moss-700\\/15:hover{
  color: rgb(63 98 26 / 0.15);
}

.hover\\:text-moss-700\\/20:hover{
  color: rgb(63 98 26 / 0.2);
}

.hover\\:text-moss-700\\/25:hover{
  color: rgb(63 98 26 / 0.25);
}

.hover\\:text-moss-700\\/30:hover{
  color: rgb(63 98 26 / 0.3);
}

.hover\\:text-moss-700\\/35:hover{
  color: rgb(63 98 26 / 0.35);
}

.hover\\:text-moss-700\\/40:hover{
  color: rgb(63 98 26 / 0.4);
}

.hover\\:text-moss-700\\/45:hover{
  color: rgb(63 98 26 / 0.45);
}

.hover\\:text-moss-700\\/5:hover{
  color: rgb(63 98 26 / 0.05);
}

.hover\\:text-moss-700\\/50:hover{
  color: rgb(63 98 26 / 0.5);
}

.hover\\:text-moss-700\\/55:hover{
  color: rgb(63 98 26 / 0.55);
}

.hover\\:text-moss-700\\/60:hover{
  color: rgb(63 98 26 / 0.6);
}

.hover\\:text-moss-700\\/65:hover{
  color: rgb(63 98 26 / 0.65);
}

.hover\\:text-moss-700\\/70:hover{
  color: rgb(63 98 26 / 0.7);
}

.hover\\:text-moss-700\\/75:hover{
  color: rgb(63 98 26 / 0.75);
}

.hover\\:text-moss-700\\/80:hover{
  color: rgb(63 98 26 / 0.8);
}

.hover\\:text-moss-700\\/85:hover{
  color: rgb(63 98 26 / 0.85);
}

.hover\\:text-moss-700\\/90:hover{
  color: rgb(63 98 26 / 0.9);
}

.hover\\:text-moss-700\\/95:hover{
  color: rgb(63 98 26 / 0.95);
}

.hover\\:text-neutral-100:hover{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-100\\/0:hover{
  color: rgb(245 245 245 / 0);
}

.hover\\:text-neutral-100\\/10:hover{
  color: rgb(245 245 245 / 0.1);
}

.hover\\:text-neutral-100\\/100:hover{
  color: rgb(245 245 245 / 1);
}

.hover\\:text-neutral-100\\/15:hover{
  color: rgb(245 245 245 / 0.15);
}

.hover\\:text-neutral-100\\/20:hover{
  color: rgb(245 245 245 / 0.2);
}

.hover\\:text-neutral-100\\/25:hover{
  color: rgb(245 245 245 / 0.25);
}

.hover\\:text-neutral-100\\/30:hover{
  color: rgb(245 245 245 / 0.3);
}

.hover\\:text-neutral-100\\/35:hover{
  color: rgb(245 245 245 / 0.35);
}

.hover\\:text-neutral-100\\/40:hover{
  color: rgb(245 245 245 / 0.4);
}

.hover\\:text-neutral-100\\/45:hover{
  color: rgb(245 245 245 / 0.45);
}

.hover\\:text-neutral-100\\/5:hover{
  color: rgb(245 245 245 / 0.05);
}

.hover\\:text-neutral-100\\/50:hover{
  color: rgb(245 245 245 / 0.5);
}

.hover\\:text-neutral-100\\/55:hover{
  color: rgb(245 245 245 / 0.55);
}

.hover\\:text-neutral-100\\/60:hover{
  color: rgb(245 245 245 / 0.6);
}

.hover\\:text-neutral-100\\/65:hover{
  color: rgb(245 245 245 / 0.65);
}

.hover\\:text-neutral-100\\/70:hover{
  color: rgb(245 245 245 / 0.7);
}

.hover\\:text-neutral-100\\/75:hover{
  color: rgb(245 245 245 / 0.75);
}

.hover\\:text-neutral-100\\/80:hover{
  color: rgb(245 245 245 / 0.8);
}

.hover\\:text-neutral-100\\/85:hover{
  color: rgb(245 245 245 / 0.85);
}

.hover\\:text-neutral-100\\/90:hover{
  color: rgb(245 245 245 / 0.9);
}

.hover\\:text-neutral-100\\/95:hover{
  color: rgb(245 245 245 / 0.95);
}

.hover\\:text-neutral-200:hover{
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-200\\/0:hover{
  color: rgb(233 234 235 / 0);
}

.hover\\:text-neutral-200\\/10:hover{
  color: rgb(233 234 235 / 0.1);
}

.hover\\:text-neutral-200\\/100:hover{
  color: rgb(233 234 235 / 1);
}

.hover\\:text-neutral-200\\/15:hover{
  color: rgb(233 234 235 / 0.15);
}

.hover\\:text-neutral-200\\/20:hover{
  color: rgb(233 234 235 / 0.2);
}

.hover\\:text-neutral-200\\/25:hover{
  color: rgb(233 234 235 / 0.25);
}

.hover\\:text-neutral-200\\/30:hover{
  color: rgb(233 234 235 / 0.3);
}

.hover\\:text-neutral-200\\/35:hover{
  color: rgb(233 234 235 / 0.35);
}

.hover\\:text-neutral-200\\/40:hover{
  color: rgb(233 234 235 / 0.4);
}

.hover\\:text-neutral-200\\/45:hover{
  color: rgb(233 234 235 / 0.45);
}

.hover\\:text-neutral-200\\/5:hover{
  color: rgb(233 234 235 / 0.05);
}

.hover\\:text-neutral-200\\/50:hover{
  color: rgb(233 234 235 / 0.5);
}

.hover\\:text-neutral-200\\/55:hover{
  color: rgb(233 234 235 / 0.55);
}

.hover\\:text-neutral-200\\/60:hover{
  color: rgb(233 234 235 / 0.6);
}

.hover\\:text-neutral-200\\/65:hover{
  color: rgb(233 234 235 / 0.65);
}

.hover\\:text-neutral-200\\/70:hover{
  color: rgb(233 234 235 / 0.7);
}

.hover\\:text-neutral-200\\/75:hover{
  color: rgb(233 234 235 / 0.75);
}

.hover\\:text-neutral-200\\/80:hover{
  color: rgb(233 234 235 / 0.8);
}

.hover\\:text-neutral-200\\/85:hover{
  color: rgb(233 234 235 / 0.85);
}

.hover\\:text-neutral-200\\/90:hover{
  color: rgb(233 234 235 / 0.9);
}

.hover\\:text-neutral-200\\/95:hover{
  color: rgb(233 234 235 / 0.95);
}

.hover\\:text-neutral-25:hover{
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-25\\/0:hover{
  color: rgb(253 253 253 / 0);
}

.hover\\:text-neutral-25\\/10:hover{
  color: rgb(253 253 253 / 0.1);
}

.hover\\:text-neutral-25\\/100:hover{
  color: rgb(253 253 253 / 1);
}

.hover\\:text-neutral-25\\/15:hover{
  color: rgb(253 253 253 / 0.15);
}

.hover\\:text-neutral-25\\/20:hover{
  color: rgb(253 253 253 / 0.2);
}

.hover\\:text-neutral-25\\/25:hover{
  color: rgb(253 253 253 / 0.25);
}

.hover\\:text-neutral-25\\/30:hover{
  color: rgb(253 253 253 / 0.3);
}

.hover\\:text-neutral-25\\/35:hover{
  color: rgb(253 253 253 / 0.35);
}

.hover\\:text-neutral-25\\/40:hover{
  color: rgb(253 253 253 / 0.4);
}

.hover\\:text-neutral-25\\/45:hover{
  color: rgb(253 253 253 / 0.45);
}

.hover\\:text-neutral-25\\/5:hover{
  color: rgb(253 253 253 / 0.05);
}

.hover\\:text-neutral-25\\/50:hover{
  color: rgb(253 253 253 / 0.5);
}

.hover\\:text-neutral-25\\/55:hover{
  color: rgb(253 253 253 / 0.55);
}

.hover\\:text-neutral-25\\/60:hover{
  color: rgb(253 253 253 / 0.6);
}

.hover\\:text-neutral-25\\/65:hover{
  color: rgb(253 253 253 / 0.65);
}

.hover\\:text-neutral-25\\/70:hover{
  color: rgb(253 253 253 / 0.7);
}

.hover\\:text-neutral-25\\/75:hover{
  color: rgb(253 253 253 / 0.75);
}

.hover\\:text-neutral-25\\/80:hover{
  color: rgb(253 253 253 / 0.8);
}

.hover\\:text-neutral-25\\/85:hover{
  color: rgb(253 253 253 / 0.85);
}

.hover\\:text-neutral-25\\/90:hover{
  color: rgb(253 253 253 / 0.9);
}

.hover\\:text-neutral-25\\/95:hover{
  color: rgb(253 253 253 / 0.95);
}

.hover\\:text-neutral-400:hover{
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-400\\/0:hover{
  color: rgb(164 167 174 / 0);
}

.hover\\:text-neutral-400\\/10:hover{
  color: rgb(164 167 174 / 0.1);
}

.hover\\:text-neutral-400\\/100:hover{
  color: rgb(164 167 174 / 1);
}

.hover\\:text-neutral-400\\/15:hover{
  color: rgb(164 167 174 / 0.15);
}

.hover\\:text-neutral-400\\/20:hover{
  color: rgb(164 167 174 / 0.2);
}

.hover\\:text-neutral-400\\/25:hover{
  color: rgb(164 167 174 / 0.25);
}

.hover\\:text-neutral-400\\/30:hover{
  color: rgb(164 167 174 / 0.3);
}

.hover\\:text-neutral-400\\/35:hover{
  color: rgb(164 167 174 / 0.35);
}

.hover\\:text-neutral-400\\/40:hover{
  color: rgb(164 167 174 / 0.4);
}

.hover\\:text-neutral-400\\/45:hover{
  color: rgb(164 167 174 / 0.45);
}

.hover\\:text-neutral-400\\/5:hover{
  color: rgb(164 167 174 / 0.05);
}

.hover\\:text-neutral-400\\/50:hover{
  color: rgb(164 167 174 / 0.5);
}

.hover\\:text-neutral-400\\/55:hover{
  color: rgb(164 167 174 / 0.55);
}

.hover\\:text-neutral-400\\/60:hover{
  color: rgb(164 167 174 / 0.6);
}

.hover\\:text-neutral-400\\/65:hover{
  color: rgb(164 167 174 / 0.65);
}

.hover\\:text-neutral-400\\/70:hover{
  color: rgb(164 167 174 / 0.7);
}

.hover\\:text-neutral-400\\/75:hover{
  color: rgb(164 167 174 / 0.75);
}

.hover\\:text-neutral-400\\/80:hover{
  color: rgb(164 167 174 / 0.8);
}

.hover\\:text-neutral-400\\/85:hover{
  color: rgb(164 167 174 / 0.85);
}

.hover\\:text-neutral-400\\/90:hover{
  color: rgb(164 167 174 / 0.9);
}

.hover\\:text-neutral-400\\/95:hover{
  color: rgb(164 167 174 / 0.95);
}

.hover\\:text-neutral-50:hover{
  --tw-text-opacity: 1;
  color: rgb(249 250 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-50\\/0:hover{
  color: rgb(249 250 250 / 0);
}

.hover\\:text-neutral-50\\/10:hover{
  color: rgb(249 250 250 / 0.1);
}

.hover\\:text-neutral-50\\/100:hover{
  color: rgb(249 250 250 / 1);
}

.hover\\:text-neutral-50\\/15:hover{
  color: rgb(249 250 250 / 0.15);
}

.hover\\:text-neutral-50\\/20:hover{
  color: rgb(249 250 250 / 0.2);
}

.hover\\:text-neutral-50\\/25:hover{
  color: rgb(249 250 250 / 0.25);
}

.hover\\:text-neutral-50\\/30:hover{
  color: rgb(249 250 250 / 0.3);
}

.hover\\:text-neutral-50\\/35:hover{
  color: rgb(249 250 250 / 0.35);
}

.hover\\:text-neutral-50\\/40:hover{
  color: rgb(249 250 250 / 0.4);
}

.hover\\:text-neutral-50\\/45:hover{
  color: rgb(249 250 250 / 0.45);
}

.hover\\:text-neutral-50\\/5:hover{
  color: rgb(249 250 250 / 0.05);
}

.hover\\:text-neutral-50\\/50:hover{
  color: rgb(249 250 250 / 0.5);
}

.hover\\:text-neutral-50\\/55:hover{
  color: rgb(249 250 250 / 0.55);
}

.hover\\:text-neutral-50\\/60:hover{
  color: rgb(249 250 250 / 0.6);
}

.hover\\:text-neutral-50\\/65:hover{
  color: rgb(249 250 250 / 0.65);
}

.hover\\:text-neutral-50\\/70:hover{
  color: rgb(249 250 250 / 0.7);
}

.hover\\:text-neutral-50\\/75:hover{
  color: rgb(249 250 250 / 0.75);
}

.hover\\:text-neutral-50\\/80:hover{
  color: rgb(249 250 250 / 0.8);
}

.hover\\:text-neutral-50\\/85:hover{
  color: rgb(249 250 250 / 0.85);
}

.hover\\:text-neutral-50\\/90:hover{
  color: rgb(249 250 250 / 0.9);
}

.hover\\:text-neutral-50\\/95:hover{
  color: rgb(249 250 250 / 0.95);
}

.hover\\:text-neutral-500:hover{
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-500\\/0:hover{
  color: rgb(113 118 128 / 0);
}

.hover\\:text-neutral-500\\/10:hover{
  color: rgb(113 118 128 / 0.1);
}

.hover\\:text-neutral-500\\/100:hover{
  color: rgb(113 118 128 / 1);
}

.hover\\:text-neutral-500\\/15:hover{
  color: rgb(113 118 128 / 0.15);
}

.hover\\:text-neutral-500\\/20:hover{
  color: rgb(113 118 128 / 0.2);
}

.hover\\:text-neutral-500\\/25:hover{
  color: rgb(113 118 128 / 0.25);
}

.hover\\:text-neutral-500\\/30:hover{
  color: rgb(113 118 128 / 0.3);
}

.hover\\:text-neutral-500\\/35:hover{
  color: rgb(113 118 128 / 0.35);
}

.hover\\:text-neutral-500\\/40:hover{
  color: rgb(113 118 128 / 0.4);
}

.hover\\:text-neutral-500\\/45:hover{
  color: rgb(113 118 128 / 0.45);
}

.hover\\:text-neutral-500\\/5:hover{
  color: rgb(113 118 128 / 0.05);
}

.hover\\:text-neutral-500\\/50:hover{
  color: rgb(113 118 128 / 0.5);
}

.hover\\:text-neutral-500\\/55:hover{
  color: rgb(113 118 128 / 0.55);
}

.hover\\:text-neutral-500\\/60:hover{
  color: rgb(113 118 128 / 0.6);
}

.hover\\:text-neutral-500\\/65:hover{
  color: rgb(113 118 128 / 0.65);
}

.hover\\:text-neutral-500\\/70:hover{
  color: rgb(113 118 128 / 0.7);
}

.hover\\:text-neutral-500\\/75:hover{
  color: rgb(113 118 128 / 0.75);
}

.hover\\:text-neutral-500\\/80:hover{
  color: rgb(113 118 128 / 0.8);
}

.hover\\:text-neutral-500\\/85:hover{
  color: rgb(113 118 128 / 0.85);
}

.hover\\:text-neutral-500\\/90:hover{
  color: rgb(113 118 128 / 0.9);
}

.hover\\:text-neutral-500\\/95:hover{
  color: rgb(113 118 128 / 0.95);
}

.hover\\:text-neutral-600:hover{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-600\\/0:hover{
  color: rgb(83 88 98 / 0);
}

.hover\\:text-neutral-600\\/10:hover{
  color: rgb(83 88 98 / 0.1);
}

.hover\\:text-neutral-600\\/100:hover{
  color: rgb(83 88 98 / 1);
}

.hover\\:text-neutral-600\\/15:hover{
  color: rgb(83 88 98 / 0.15);
}

.hover\\:text-neutral-600\\/20:hover{
  color: rgb(83 88 98 / 0.2);
}

.hover\\:text-neutral-600\\/25:hover{
  color: rgb(83 88 98 / 0.25);
}

.hover\\:text-neutral-600\\/30:hover{
  color: rgb(83 88 98 / 0.3);
}

.hover\\:text-neutral-600\\/35:hover{
  color: rgb(83 88 98 / 0.35);
}

.hover\\:text-neutral-600\\/40:hover{
  color: rgb(83 88 98 / 0.4);
}

.hover\\:text-neutral-600\\/45:hover{
  color: rgb(83 88 98 / 0.45);
}

.hover\\:text-neutral-600\\/5:hover{
  color: rgb(83 88 98 / 0.05);
}

.hover\\:text-neutral-600\\/50:hover{
  color: rgb(83 88 98 / 0.5);
}

.hover\\:text-neutral-600\\/55:hover{
  color: rgb(83 88 98 / 0.55);
}

.hover\\:text-neutral-600\\/60:hover{
  color: rgb(83 88 98 / 0.6);
}

.hover\\:text-neutral-600\\/65:hover{
  color: rgb(83 88 98 / 0.65);
}

.hover\\:text-neutral-600\\/70:hover{
  color: rgb(83 88 98 / 0.7);
}

.hover\\:text-neutral-600\\/75:hover{
  color: rgb(83 88 98 / 0.75);
}

.hover\\:text-neutral-600\\/80:hover{
  color: rgb(83 88 98 / 0.8);
}

.hover\\:text-neutral-600\\/85:hover{
  color: rgb(83 88 98 / 0.85);
}

.hover\\:text-neutral-600\\/90:hover{
  color: rgb(83 88 98 / 0.9);
}

.hover\\:text-neutral-600\\/95:hover{
  color: rgb(83 88 98 / 0.95);
}

.hover\\:text-neutral-700:hover{
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-700\\/0:hover{
  color: rgb(65 70 81 / 0);
}

.hover\\:text-neutral-700\\/10:hover{
  color: rgb(65 70 81 / 0.1);
}

.hover\\:text-neutral-700\\/100:hover{
  color: rgb(65 70 81 / 1);
}

.hover\\:text-neutral-700\\/15:hover{
  color: rgb(65 70 81 / 0.15);
}

.hover\\:text-neutral-700\\/20:hover{
  color: rgb(65 70 81 / 0.2);
}

.hover\\:text-neutral-700\\/25:hover{
  color: rgb(65 70 81 / 0.25);
}

.hover\\:text-neutral-700\\/30:hover{
  color: rgb(65 70 81 / 0.3);
}

.hover\\:text-neutral-700\\/35:hover{
  color: rgb(65 70 81 / 0.35);
}

.hover\\:text-neutral-700\\/40:hover{
  color: rgb(65 70 81 / 0.4);
}

.hover\\:text-neutral-700\\/45:hover{
  color: rgb(65 70 81 / 0.45);
}

.hover\\:text-neutral-700\\/5:hover{
  color: rgb(65 70 81 / 0.05);
}

.hover\\:text-neutral-700\\/50:hover{
  color: rgb(65 70 81 / 0.5);
}

.hover\\:text-neutral-700\\/55:hover{
  color: rgb(65 70 81 / 0.55);
}

.hover\\:text-neutral-700\\/60:hover{
  color: rgb(65 70 81 / 0.6);
}

.hover\\:text-neutral-700\\/65:hover{
  color: rgb(65 70 81 / 0.65);
}

.hover\\:text-neutral-700\\/70:hover{
  color: rgb(65 70 81 / 0.7);
}

.hover\\:text-neutral-700\\/75:hover{
  color: rgb(65 70 81 / 0.75);
}

.hover\\:text-neutral-700\\/80:hover{
  color: rgb(65 70 81 / 0.8);
}

.hover\\:text-neutral-700\\/85:hover{
  color: rgb(65 70 81 / 0.85);
}

.hover\\:text-neutral-700\\/90:hover{
  color: rgb(65 70 81 / 0.9);
}

.hover\\:text-neutral-700\\/95:hover{
  color: rgb(65 70 81 / 0.95);
}

.hover\\:text-neutral-75:hover{
  --tw-text-opacity: 1;
  color: rgb(246 246 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-75\\/0:hover{
  color: rgb(246 246 246 / 0);
}

.hover\\:text-neutral-75\\/10:hover{
  color: rgb(246 246 246 / 0.1);
}

.hover\\:text-neutral-75\\/100:hover{
  color: rgb(246 246 246 / 1);
}

.hover\\:text-neutral-75\\/15:hover{
  color: rgb(246 246 246 / 0.15);
}

.hover\\:text-neutral-75\\/20:hover{
  color: rgb(246 246 246 / 0.2);
}

.hover\\:text-neutral-75\\/25:hover{
  color: rgb(246 246 246 / 0.25);
}

.hover\\:text-neutral-75\\/30:hover{
  color: rgb(246 246 246 / 0.3);
}

.hover\\:text-neutral-75\\/35:hover{
  color: rgb(246 246 246 / 0.35);
}

.hover\\:text-neutral-75\\/40:hover{
  color: rgb(246 246 246 / 0.4);
}

.hover\\:text-neutral-75\\/45:hover{
  color: rgb(246 246 246 / 0.45);
}

.hover\\:text-neutral-75\\/5:hover{
  color: rgb(246 246 246 / 0.05);
}

.hover\\:text-neutral-75\\/50:hover{
  color: rgb(246 246 246 / 0.5);
}

.hover\\:text-neutral-75\\/55:hover{
  color: rgb(246 246 246 / 0.55);
}

.hover\\:text-neutral-75\\/60:hover{
  color: rgb(246 246 246 / 0.6);
}

.hover\\:text-neutral-75\\/65:hover{
  color: rgb(246 246 246 / 0.65);
}

.hover\\:text-neutral-75\\/70:hover{
  color: rgb(246 246 246 / 0.7);
}

.hover\\:text-neutral-75\\/75:hover{
  color: rgb(246 246 246 / 0.75);
}

.hover\\:text-neutral-75\\/80:hover{
  color: rgb(246 246 246 / 0.8);
}

.hover\\:text-neutral-75\\/85:hover{
  color: rgb(246 246 246 / 0.85);
}

.hover\\:text-neutral-75\\/90:hover{
  color: rgb(246 246 246 / 0.9);
}

.hover\\:text-neutral-75\\/95:hover{
  color: rgb(246 246 246 / 0.95);
}

.hover\\:text-neutral-800:hover{
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-900:hover{
  --tw-text-opacity: 1;
  color: rgb(24 29 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-100:hover{
  color: var(--color-primary-100, #E0F2FE);
}

.hover\\:text-primary-200:hover{
  color: var(--color-primary-200, #B9E6FE);
}

.hover\\:text-primary-25:hover{
  color: var(--color-primary-25, #F5FBFF);
}

.hover\\:text-primary-400:hover{
  color: var(--color-primary-400, #36BFFA);
}

.hover\\:text-primary-50:hover{
  color: var(--color-primary-50, #F0F9FF);
}

.hover\\:text-primary-500:hover{
  color: var(--color-primary-500, #0BA5EC);
}

.hover\\:text-primary-600:hover{
  color: var(--color-primary-600, #0086C9);
}

.hover\\:text-primary-700:hover{
  color: var(--color-primary-700, #026AA2);
}

.hover\\:text-primary-800:hover{
  color: var(--color-primary-800, #065986);
}

.hover\\:text-primary-900:hover{
  color: var(--color-primary-900, #0B4A6F);
}

.hover\\:text-purple-100:hover{
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-100\\/0:hover{
  color: rgb(235 233 254 / 0);
}

.hover\\:text-purple-100\\/10:hover{
  color: rgb(235 233 254 / 0.1);
}

.hover\\:text-purple-100\\/100:hover{
  color: rgb(235 233 254 / 1);
}

.hover\\:text-purple-100\\/15:hover{
  color: rgb(235 233 254 / 0.15);
}

.hover\\:text-purple-100\\/20:hover{
  color: rgb(235 233 254 / 0.2);
}

.hover\\:text-purple-100\\/25:hover{
  color: rgb(235 233 254 / 0.25);
}

.hover\\:text-purple-100\\/30:hover{
  color: rgb(235 233 254 / 0.3);
}

.hover\\:text-purple-100\\/35:hover{
  color: rgb(235 233 254 / 0.35);
}

.hover\\:text-purple-100\\/40:hover{
  color: rgb(235 233 254 / 0.4);
}

.hover\\:text-purple-100\\/45:hover{
  color: rgb(235 233 254 / 0.45);
}

.hover\\:text-purple-100\\/5:hover{
  color: rgb(235 233 254 / 0.05);
}

.hover\\:text-purple-100\\/50:hover{
  color: rgb(235 233 254 / 0.5);
}

.hover\\:text-purple-100\\/55:hover{
  color: rgb(235 233 254 / 0.55);
}

.hover\\:text-purple-100\\/60:hover{
  color: rgb(235 233 254 / 0.6);
}

.hover\\:text-purple-100\\/65:hover{
  color: rgb(235 233 254 / 0.65);
}

.hover\\:text-purple-100\\/70:hover{
  color: rgb(235 233 254 / 0.7);
}

.hover\\:text-purple-100\\/75:hover{
  color: rgb(235 233 254 / 0.75);
}

.hover\\:text-purple-100\\/80:hover{
  color: rgb(235 233 254 / 0.8);
}

.hover\\:text-purple-100\\/85:hover{
  color: rgb(235 233 254 / 0.85);
}

.hover\\:text-purple-100\\/90:hover{
  color: rgb(235 233 254 / 0.9);
}

.hover\\:text-purple-100\\/95:hover{
  color: rgb(235 233 254 / 0.95);
}

.hover\\:text-purple-200:hover{
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-200\\/0:hover{
  color: rgb(217 214 254 / 0);
}

.hover\\:text-purple-200\\/10:hover{
  color: rgb(217 214 254 / 0.1);
}

.hover\\:text-purple-200\\/100:hover{
  color: rgb(217 214 254 / 1);
}

.hover\\:text-purple-200\\/15:hover{
  color: rgb(217 214 254 / 0.15);
}

.hover\\:text-purple-200\\/20:hover{
  color: rgb(217 214 254 / 0.2);
}

.hover\\:text-purple-200\\/25:hover{
  color: rgb(217 214 254 / 0.25);
}

.hover\\:text-purple-200\\/30:hover{
  color: rgb(217 214 254 / 0.3);
}

.hover\\:text-purple-200\\/35:hover{
  color: rgb(217 214 254 / 0.35);
}

.hover\\:text-purple-200\\/40:hover{
  color: rgb(217 214 254 / 0.4);
}

.hover\\:text-purple-200\\/45:hover{
  color: rgb(217 214 254 / 0.45);
}

.hover\\:text-purple-200\\/5:hover{
  color: rgb(217 214 254 / 0.05);
}

.hover\\:text-purple-200\\/50:hover{
  color: rgb(217 214 254 / 0.5);
}

.hover\\:text-purple-200\\/55:hover{
  color: rgb(217 214 254 / 0.55);
}

.hover\\:text-purple-200\\/60:hover{
  color: rgb(217 214 254 / 0.6);
}

.hover\\:text-purple-200\\/65:hover{
  color: rgb(217 214 254 / 0.65);
}

.hover\\:text-purple-200\\/70:hover{
  color: rgb(217 214 254 / 0.7);
}

.hover\\:text-purple-200\\/75:hover{
  color: rgb(217 214 254 / 0.75);
}

.hover\\:text-purple-200\\/80:hover{
  color: rgb(217 214 254 / 0.8);
}

.hover\\:text-purple-200\\/85:hover{
  color: rgb(217 214 254 / 0.85);
}

.hover\\:text-purple-200\\/90:hover{
  color: rgb(217 214 254 / 0.9);
}

.hover\\:text-purple-200\\/95:hover{
  color: rgb(217 214 254 / 0.95);
}

.hover\\:text-purple-25:hover{
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-25\\/0:hover{
  color: rgb(250 250 255 / 0);
}

.hover\\:text-purple-25\\/10:hover{
  color: rgb(250 250 255 / 0.1);
}

.hover\\:text-purple-25\\/100:hover{
  color: rgb(250 250 255 / 1);
}

.hover\\:text-purple-25\\/15:hover{
  color: rgb(250 250 255 / 0.15);
}

.hover\\:text-purple-25\\/20:hover{
  color: rgb(250 250 255 / 0.2);
}

.hover\\:text-purple-25\\/25:hover{
  color: rgb(250 250 255 / 0.25);
}

.hover\\:text-purple-25\\/30:hover{
  color: rgb(250 250 255 / 0.3);
}

.hover\\:text-purple-25\\/35:hover{
  color: rgb(250 250 255 / 0.35);
}

.hover\\:text-purple-25\\/40:hover{
  color: rgb(250 250 255 / 0.4);
}

.hover\\:text-purple-25\\/45:hover{
  color: rgb(250 250 255 / 0.45);
}

.hover\\:text-purple-25\\/5:hover{
  color: rgb(250 250 255 / 0.05);
}

.hover\\:text-purple-25\\/50:hover{
  color: rgb(250 250 255 / 0.5);
}

.hover\\:text-purple-25\\/55:hover{
  color: rgb(250 250 255 / 0.55);
}

.hover\\:text-purple-25\\/60:hover{
  color: rgb(250 250 255 / 0.6);
}

.hover\\:text-purple-25\\/65:hover{
  color: rgb(250 250 255 / 0.65);
}

.hover\\:text-purple-25\\/70:hover{
  color: rgb(250 250 255 / 0.7);
}

.hover\\:text-purple-25\\/75:hover{
  color: rgb(250 250 255 / 0.75);
}

.hover\\:text-purple-25\\/80:hover{
  color: rgb(250 250 255 / 0.8);
}

.hover\\:text-purple-25\\/85:hover{
  color: rgb(250 250 255 / 0.85);
}

.hover\\:text-purple-25\\/90:hover{
  color: rgb(250 250 255 / 0.9);
}

.hover\\:text-purple-25\\/95:hover{
  color: rgb(250 250 255 / 0.95);
}

.hover\\:text-purple-400:hover{
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-400\\/0:hover{
  color: rgb(155 138 251 / 0);
}

.hover\\:text-purple-400\\/10:hover{
  color: rgb(155 138 251 / 0.1);
}

.hover\\:text-purple-400\\/100:hover{
  color: rgb(155 138 251 / 1);
}

.hover\\:text-purple-400\\/15:hover{
  color: rgb(155 138 251 / 0.15);
}

.hover\\:text-purple-400\\/20:hover{
  color: rgb(155 138 251 / 0.2);
}

.hover\\:text-purple-400\\/25:hover{
  color: rgb(155 138 251 / 0.25);
}

.hover\\:text-purple-400\\/30:hover{
  color: rgb(155 138 251 / 0.3);
}

.hover\\:text-purple-400\\/35:hover{
  color: rgb(155 138 251 / 0.35);
}

.hover\\:text-purple-400\\/40:hover{
  color: rgb(155 138 251 / 0.4);
}

.hover\\:text-purple-400\\/45:hover{
  color: rgb(155 138 251 / 0.45);
}

.hover\\:text-purple-400\\/5:hover{
  color: rgb(155 138 251 / 0.05);
}

.hover\\:text-purple-400\\/50:hover{
  color: rgb(155 138 251 / 0.5);
}

.hover\\:text-purple-400\\/55:hover{
  color: rgb(155 138 251 / 0.55);
}

.hover\\:text-purple-400\\/60:hover{
  color: rgb(155 138 251 / 0.6);
}

.hover\\:text-purple-400\\/65:hover{
  color: rgb(155 138 251 / 0.65);
}

.hover\\:text-purple-400\\/70:hover{
  color: rgb(155 138 251 / 0.7);
}

.hover\\:text-purple-400\\/75:hover{
  color: rgb(155 138 251 / 0.75);
}

.hover\\:text-purple-400\\/80:hover{
  color: rgb(155 138 251 / 0.8);
}

.hover\\:text-purple-400\\/85:hover{
  color: rgb(155 138 251 / 0.85);
}

.hover\\:text-purple-400\\/90:hover{
  color: rgb(155 138 251 / 0.9);
}

.hover\\:text-purple-400\\/95:hover{
  color: rgb(155 138 251 / 0.95);
}

.hover\\:text-purple-50:hover{
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-50\\/0:hover{
  color: rgb(244 243 255 / 0);
}

.hover\\:text-purple-50\\/10:hover{
  color: rgb(244 243 255 / 0.1);
}

.hover\\:text-purple-50\\/100:hover{
  color: rgb(244 243 255 / 1);
}

.hover\\:text-purple-50\\/15:hover{
  color: rgb(244 243 255 / 0.15);
}

.hover\\:text-purple-50\\/20:hover{
  color: rgb(244 243 255 / 0.2);
}

.hover\\:text-purple-50\\/25:hover{
  color: rgb(244 243 255 / 0.25);
}

.hover\\:text-purple-50\\/30:hover{
  color: rgb(244 243 255 / 0.3);
}

.hover\\:text-purple-50\\/35:hover{
  color: rgb(244 243 255 / 0.35);
}

.hover\\:text-purple-50\\/40:hover{
  color: rgb(244 243 255 / 0.4);
}

.hover\\:text-purple-50\\/45:hover{
  color: rgb(244 243 255 / 0.45);
}

.hover\\:text-purple-50\\/5:hover{
  color: rgb(244 243 255 / 0.05);
}

.hover\\:text-purple-50\\/50:hover{
  color: rgb(244 243 255 / 0.5);
}

.hover\\:text-purple-50\\/55:hover{
  color: rgb(244 243 255 / 0.55);
}

.hover\\:text-purple-50\\/60:hover{
  color: rgb(244 243 255 / 0.6);
}

.hover\\:text-purple-50\\/65:hover{
  color: rgb(244 243 255 / 0.65);
}

.hover\\:text-purple-50\\/70:hover{
  color: rgb(244 243 255 / 0.7);
}

.hover\\:text-purple-50\\/75:hover{
  color: rgb(244 243 255 / 0.75);
}

.hover\\:text-purple-50\\/80:hover{
  color: rgb(244 243 255 / 0.8);
}

.hover\\:text-purple-50\\/85:hover{
  color: rgb(244 243 255 / 0.85);
}

.hover\\:text-purple-50\\/90:hover{
  color: rgb(244 243 255 / 0.9);
}

.hover\\:text-purple-50\\/95:hover{
  color: rgb(244 243 255 / 0.95);
}

.hover\\:text-purple-500:hover{
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-500\\/0:hover{
  color: rgb(122 90 248 / 0);
}

.hover\\:text-purple-500\\/10:hover{
  color: rgb(122 90 248 / 0.1);
}

.hover\\:text-purple-500\\/100:hover{
  color: rgb(122 90 248 / 1);
}

.hover\\:text-purple-500\\/15:hover{
  color: rgb(122 90 248 / 0.15);
}

.hover\\:text-purple-500\\/20:hover{
  color: rgb(122 90 248 / 0.2);
}

.hover\\:text-purple-500\\/25:hover{
  color: rgb(122 90 248 / 0.25);
}

.hover\\:text-purple-500\\/30:hover{
  color: rgb(122 90 248 / 0.3);
}

.hover\\:text-purple-500\\/35:hover{
  color: rgb(122 90 248 / 0.35);
}

.hover\\:text-purple-500\\/40:hover{
  color: rgb(122 90 248 / 0.4);
}

.hover\\:text-purple-500\\/45:hover{
  color: rgb(122 90 248 / 0.45);
}

.hover\\:text-purple-500\\/5:hover{
  color: rgb(122 90 248 / 0.05);
}

.hover\\:text-purple-500\\/50:hover{
  color: rgb(122 90 248 / 0.5);
}

.hover\\:text-purple-500\\/55:hover{
  color: rgb(122 90 248 / 0.55);
}

.hover\\:text-purple-500\\/60:hover{
  color: rgb(122 90 248 / 0.6);
}

.hover\\:text-purple-500\\/65:hover{
  color: rgb(122 90 248 / 0.65);
}

.hover\\:text-purple-500\\/70:hover{
  color: rgb(122 90 248 / 0.7);
}

.hover\\:text-purple-500\\/75:hover{
  color: rgb(122 90 248 / 0.75);
}

.hover\\:text-purple-500\\/80:hover{
  color: rgb(122 90 248 / 0.8);
}

.hover\\:text-purple-500\\/85:hover{
  color: rgb(122 90 248 / 0.85);
}

.hover\\:text-purple-500\\/90:hover{
  color: rgb(122 90 248 / 0.9);
}

.hover\\:text-purple-500\\/95:hover{
  color: rgb(122 90 248 / 0.95);
}

.hover\\:text-purple-600:hover{
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-600\\/0:hover{
  color: rgb(105 56 239 / 0);
}

.hover\\:text-purple-600\\/10:hover{
  color: rgb(105 56 239 / 0.1);
}

.hover\\:text-purple-600\\/100:hover{
  color: rgb(105 56 239 / 1);
}

.hover\\:text-purple-600\\/15:hover{
  color: rgb(105 56 239 / 0.15);
}

.hover\\:text-purple-600\\/20:hover{
  color: rgb(105 56 239 / 0.2);
}

.hover\\:text-purple-600\\/25:hover{
  color: rgb(105 56 239 / 0.25);
}

.hover\\:text-purple-600\\/30:hover{
  color: rgb(105 56 239 / 0.3);
}

.hover\\:text-purple-600\\/35:hover{
  color: rgb(105 56 239 / 0.35);
}

.hover\\:text-purple-600\\/40:hover{
  color: rgb(105 56 239 / 0.4);
}

.hover\\:text-purple-600\\/45:hover{
  color: rgb(105 56 239 / 0.45);
}

.hover\\:text-purple-600\\/5:hover{
  color: rgb(105 56 239 / 0.05);
}

.hover\\:text-purple-600\\/50:hover{
  color: rgb(105 56 239 / 0.5);
}

.hover\\:text-purple-600\\/55:hover{
  color: rgb(105 56 239 / 0.55);
}

.hover\\:text-purple-600\\/60:hover{
  color: rgb(105 56 239 / 0.6);
}

.hover\\:text-purple-600\\/65:hover{
  color: rgb(105 56 239 / 0.65);
}

.hover\\:text-purple-600\\/70:hover{
  color: rgb(105 56 239 / 0.7);
}

.hover\\:text-purple-600\\/75:hover{
  color: rgb(105 56 239 / 0.75);
}

.hover\\:text-purple-600\\/80:hover{
  color: rgb(105 56 239 / 0.8);
}

.hover\\:text-purple-600\\/85:hover{
  color: rgb(105 56 239 / 0.85);
}

.hover\\:text-purple-600\\/90:hover{
  color: rgb(105 56 239 / 0.9);
}

.hover\\:text-purple-600\\/95:hover{
  color: rgb(105 56 239 / 0.95);
}

.hover\\:text-purple-700:hover{
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-700\\/0:hover{
  color: rgb(89 37 220 / 0);
}

.hover\\:text-purple-700\\/10:hover{
  color: rgb(89 37 220 / 0.1);
}

.hover\\:text-purple-700\\/100:hover{
  color: rgb(89 37 220 / 1);
}

.hover\\:text-purple-700\\/15:hover{
  color: rgb(89 37 220 / 0.15);
}

.hover\\:text-purple-700\\/20:hover{
  color: rgb(89 37 220 / 0.2);
}

.hover\\:text-purple-700\\/25:hover{
  color: rgb(89 37 220 / 0.25);
}

.hover\\:text-purple-700\\/30:hover{
  color: rgb(89 37 220 / 0.3);
}

.hover\\:text-purple-700\\/35:hover{
  color: rgb(89 37 220 / 0.35);
}

.hover\\:text-purple-700\\/40:hover{
  color: rgb(89 37 220 / 0.4);
}

.hover\\:text-purple-700\\/45:hover{
  color: rgb(89 37 220 / 0.45);
}

.hover\\:text-purple-700\\/5:hover{
  color: rgb(89 37 220 / 0.05);
}

.hover\\:text-purple-700\\/50:hover{
  color: rgb(89 37 220 / 0.5);
}

.hover\\:text-purple-700\\/55:hover{
  color: rgb(89 37 220 / 0.55);
}

.hover\\:text-purple-700\\/60:hover{
  color: rgb(89 37 220 / 0.6);
}

.hover\\:text-purple-700\\/65:hover{
  color: rgb(89 37 220 / 0.65);
}

.hover\\:text-purple-700\\/70:hover{
  color: rgb(89 37 220 / 0.7);
}

.hover\\:text-purple-700\\/75:hover{
  color: rgb(89 37 220 / 0.75);
}

.hover\\:text-purple-700\\/80:hover{
  color: rgb(89 37 220 / 0.8);
}

.hover\\:text-purple-700\\/85:hover{
  color: rgb(89 37 220 / 0.85);
}

.hover\\:text-purple-700\\/90:hover{
  color: rgb(89 37 220 / 0.9);
}

.hover\\:text-purple-700\\/95:hover{
  color: rgb(89 37 220 / 0.95);
}

.hover\\:text-success-100:hover{
  --tw-text-opacity: 1;
  color: rgb(211 248 223 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-100\\/0:hover{
  color: rgb(211 248 223 / 0);
}

.hover\\:text-success-100\\/10:hover{
  color: rgb(211 248 223 / 0.1);
}

.hover\\:text-success-100\\/100:hover{
  color: rgb(211 248 223 / 1);
}

.hover\\:text-success-100\\/15:hover{
  color: rgb(211 248 223 / 0.15);
}

.hover\\:text-success-100\\/20:hover{
  color: rgb(211 248 223 / 0.2);
}

.hover\\:text-success-100\\/25:hover{
  color: rgb(211 248 223 / 0.25);
}

.hover\\:text-success-100\\/30:hover{
  color: rgb(211 248 223 / 0.3);
}

.hover\\:text-success-100\\/35:hover{
  color: rgb(211 248 223 / 0.35);
}

.hover\\:text-success-100\\/40:hover{
  color: rgb(211 248 223 / 0.4);
}

.hover\\:text-success-100\\/45:hover{
  color: rgb(211 248 223 / 0.45);
}

.hover\\:text-success-100\\/5:hover{
  color: rgb(211 248 223 / 0.05);
}

.hover\\:text-success-100\\/50:hover{
  color: rgb(211 248 223 / 0.5);
}

.hover\\:text-success-100\\/55:hover{
  color: rgb(211 248 223 / 0.55);
}

.hover\\:text-success-100\\/60:hover{
  color: rgb(211 248 223 / 0.6);
}

.hover\\:text-success-100\\/65:hover{
  color: rgb(211 248 223 / 0.65);
}

.hover\\:text-success-100\\/70:hover{
  color: rgb(211 248 223 / 0.7);
}

.hover\\:text-success-100\\/75:hover{
  color: rgb(211 248 223 / 0.75);
}

.hover\\:text-success-100\\/80:hover{
  color: rgb(211 248 223 / 0.8);
}

.hover\\:text-success-100\\/85:hover{
  color: rgb(211 248 223 / 0.85);
}

.hover\\:text-success-100\\/90:hover{
  color: rgb(211 248 223 / 0.9);
}

.hover\\:text-success-100\\/95:hover{
  color: rgb(211 248 223 / 0.95);
}

.hover\\:text-success-200:hover{
  --tw-text-opacity: 1;
  color: rgb(170 240 196 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-200\\/0:hover{
  color: rgb(170 240 196 / 0);
}

.hover\\:text-success-200\\/10:hover{
  color: rgb(170 240 196 / 0.1);
}

.hover\\:text-success-200\\/100:hover{
  color: rgb(170 240 196 / 1);
}

.hover\\:text-success-200\\/15:hover{
  color: rgb(170 240 196 / 0.15);
}

.hover\\:text-success-200\\/20:hover{
  color: rgb(170 240 196 / 0.2);
}

.hover\\:text-success-200\\/25:hover{
  color: rgb(170 240 196 / 0.25);
}

.hover\\:text-success-200\\/30:hover{
  color: rgb(170 240 196 / 0.3);
}

.hover\\:text-success-200\\/35:hover{
  color: rgb(170 240 196 / 0.35);
}

.hover\\:text-success-200\\/40:hover{
  color: rgb(170 240 196 / 0.4);
}

.hover\\:text-success-200\\/45:hover{
  color: rgb(170 240 196 / 0.45);
}

.hover\\:text-success-200\\/5:hover{
  color: rgb(170 240 196 / 0.05);
}

.hover\\:text-success-200\\/50:hover{
  color: rgb(170 240 196 / 0.5);
}

.hover\\:text-success-200\\/55:hover{
  color: rgb(170 240 196 / 0.55);
}

.hover\\:text-success-200\\/60:hover{
  color: rgb(170 240 196 / 0.6);
}

.hover\\:text-success-200\\/65:hover{
  color: rgb(170 240 196 / 0.65);
}

.hover\\:text-success-200\\/70:hover{
  color: rgb(170 240 196 / 0.7);
}

.hover\\:text-success-200\\/75:hover{
  color: rgb(170 240 196 / 0.75);
}

.hover\\:text-success-200\\/80:hover{
  color: rgb(170 240 196 / 0.8);
}

.hover\\:text-success-200\\/85:hover{
  color: rgb(170 240 196 / 0.85);
}

.hover\\:text-success-200\\/90:hover{
  color: rgb(170 240 196 / 0.9);
}

.hover\\:text-success-200\\/95:hover{
  color: rgb(170 240 196 / 0.95);
}

.hover\\:text-success-25:hover{
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-25\\/0:hover{
  color: rgb(246 254 249 / 0);
}

.hover\\:text-success-25\\/10:hover{
  color: rgb(246 254 249 / 0.1);
}

.hover\\:text-success-25\\/100:hover{
  color: rgb(246 254 249 / 1);
}

.hover\\:text-success-25\\/15:hover{
  color: rgb(246 254 249 / 0.15);
}

.hover\\:text-success-25\\/20:hover{
  color: rgb(246 254 249 / 0.2);
}

.hover\\:text-success-25\\/25:hover{
  color: rgb(246 254 249 / 0.25);
}

.hover\\:text-success-25\\/30:hover{
  color: rgb(246 254 249 / 0.3);
}

.hover\\:text-success-25\\/35:hover{
  color: rgb(246 254 249 / 0.35);
}

.hover\\:text-success-25\\/40:hover{
  color: rgb(246 254 249 / 0.4);
}

.hover\\:text-success-25\\/45:hover{
  color: rgb(246 254 249 / 0.45);
}

.hover\\:text-success-25\\/5:hover{
  color: rgb(246 254 249 / 0.05);
}

.hover\\:text-success-25\\/50:hover{
  color: rgb(246 254 249 / 0.5);
}

.hover\\:text-success-25\\/55:hover{
  color: rgb(246 254 249 / 0.55);
}

.hover\\:text-success-25\\/60:hover{
  color: rgb(246 254 249 / 0.6);
}

.hover\\:text-success-25\\/65:hover{
  color: rgb(246 254 249 / 0.65);
}

.hover\\:text-success-25\\/70:hover{
  color: rgb(246 254 249 / 0.7);
}

.hover\\:text-success-25\\/75:hover{
  color: rgb(246 254 249 / 0.75);
}

.hover\\:text-success-25\\/80:hover{
  color: rgb(246 254 249 / 0.8);
}

.hover\\:text-success-25\\/85:hover{
  color: rgb(246 254 249 / 0.85);
}

.hover\\:text-success-25\\/90:hover{
  color: rgb(246 254 249 / 0.9);
}

.hover\\:text-success-25\\/95:hover{
  color: rgb(246 254 249 / 0.95);
}

.hover\\:text-success-400:hover{
  --tw-text-opacity: 1;
  color: rgb(60 203 127 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-400\\/0:hover{
  color: rgb(60 203 127 / 0);
}

.hover\\:text-success-400\\/10:hover{
  color: rgb(60 203 127 / 0.1);
}

.hover\\:text-success-400\\/100:hover{
  color: rgb(60 203 127 / 1);
}

.hover\\:text-success-400\\/15:hover{
  color: rgb(60 203 127 / 0.15);
}

.hover\\:text-success-400\\/20:hover{
  color: rgb(60 203 127 / 0.2);
}

.hover\\:text-success-400\\/25:hover{
  color: rgb(60 203 127 / 0.25);
}

.hover\\:text-success-400\\/30:hover{
  color: rgb(60 203 127 / 0.3);
}

.hover\\:text-success-400\\/35:hover{
  color: rgb(60 203 127 / 0.35);
}

.hover\\:text-success-400\\/40:hover{
  color: rgb(60 203 127 / 0.4);
}

.hover\\:text-success-400\\/45:hover{
  color: rgb(60 203 127 / 0.45);
}

.hover\\:text-success-400\\/5:hover{
  color: rgb(60 203 127 / 0.05);
}

.hover\\:text-success-400\\/50:hover{
  color: rgb(60 203 127 / 0.5);
}

.hover\\:text-success-400\\/55:hover{
  color: rgb(60 203 127 / 0.55);
}

.hover\\:text-success-400\\/60:hover{
  color: rgb(60 203 127 / 0.6);
}

.hover\\:text-success-400\\/65:hover{
  color: rgb(60 203 127 / 0.65);
}

.hover\\:text-success-400\\/70:hover{
  color: rgb(60 203 127 / 0.7);
}

.hover\\:text-success-400\\/75:hover{
  color: rgb(60 203 127 / 0.75);
}

.hover\\:text-success-400\\/80:hover{
  color: rgb(60 203 127 / 0.8);
}

.hover\\:text-success-400\\/85:hover{
  color: rgb(60 203 127 / 0.85);
}

.hover\\:text-success-400\\/90:hover{
  color: rgb(60 203 127 / 0.9);
}

.hover\\:text-success-400\\/95:hover{
  color: rgb(60 203 127 / 0.95);
}

.hover\\:text-success-50:hover{
  --tw-text-opacity: 1;
  color: rgb(237 252 242 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-50\\/0:hover{
  color: rgb(237 252 242 / 0);
}

.hover\\:text-success-50\\/10:hover{
  color: rgb(237 252 242 / 0.1);
}

.hover\\:text-success-50\\/100:hover{
  color: rgb(237 252 242 / 1);
}

.hover\\:text-success-50\\/15:hover{
  color: rgb(237 252 242 / 0.15);
}

.hover\\:text-success-50\\/20:hover{
  color: rgb(237 252 242 / 0.2);
}

.hover\\:text-success-50\\/25:hover{
  color: rgb(237 252 242 / 0.25);
}

.hover\\:text-success-50\\/30:hover{
  color: rgb(237 252 242 / 0.3);
}

.hover\\:text-success-50\\/35:hover{
  color: rgb(237 252 242 / 0.35);
}

.hover\\:text-success-50\\/40:hover{
  color: rgb(237 252 242 / 0.4);
}

.hover\\:text-success-50\\/45:hover{
  color: rgb(237 252 242 / 0.45);
}

.hover\\:text-success-50\\/5:hover{
  color: rgb(237 252 242 / 0.05);
}

.hover\\:text-success-50\\/50:hover{
  color: rgb(237 252 242 / 0.5);
}

.hover\\:text-success-50\\/55:hover{
  color: rgb(237 252 242 / 0.55);
}

.hover\\:text-success-50\\/60:hover{
  color: rgb(237 252 242 / 0.6);
}

.hover\\:text-success-50\\/65:hover{
  color: rgb(237 252 242 / 0.65);
}

.hover\\:text-success-50\\/70:hover{
  color: rgb(237 252 242 / 0.7);
}

.hover\\:text-success-50\\/75:hover{
  color: rgb(237 252 242 / 0.75);
}

.hover\\:text-success-50\\/80:hover{
  color: rgb(237 252 242 / 0.8);
}

.hover\\:text-success-50\\/85:hover{
  color: rgb(237 252 242 / 0.85);
}

.hover\\:text-success-50\\/90:hover{
  color: rgb(237 252 242 / 0.9);
}

.hover\\:text-success-50\\/95:hover{
  color: rgb(237 252 242 / 0.95);
}

.hover\\:text-success-500:hover{
  --tw-text-opacity: 1;
  color: rgb(22 179 100 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-500\\/0:hover{
  color: rgb(22 179 100 / 0);
}

.hover\\:text-success-500\\/10:hover{
  color: rgb(22 179 100 / 0.1);
}

.hover\\:text-success-500\\/100:hover{
  color: rgb(22 179 100 / 1);
}

.hover\\:text-success-500\\/15:hover{
  color: rgb(22 179 100 / 0.15);
}

.hover\\:text-success-500\\/20:hover{
  color: rgb(22 179 100 / 0.2);
}

.hover\\:text-success-500\\/25:hover{
  color: rgb(22 179 100 / 0.25);
}

.hover\\:text-success-500\\/30:hover{
  color: rgb(22 179 100 / 0.3);
}

.hover\\:text-success-500\\/35:hover{
  color: rgb(22 179 100 / 0.35);
}

.hover\\:text-success-500\\/40:hover{
  color: rgb(22 179 100 / 0.4);
}

.hover\\:text-success-500\\/45:hover{
  color: rgb(22 179 100 / 0.45);
}

.hover\\:text-success-500\\/5:hover{
  color: rgb(22 179 100 / 0.05);
}

.hover\\:text-success-500\\/50:hover{
  color: rgb(22 179 100 / 0.5);
}

.hover\\:text-success-500\\/55:hover{
  color: rgb(22 179 100 / 0.55);
}

.hover\\:text-success-500\\/60:hover{
  color: rgb(22 179 100 / 0.6);
}

.hover\\:text-success-500\\/65:hover{
  color: rgb(22 179 100 / 0.65);
}

.hover\\:text-success-500\\/70:hover{
  color: rgb(22 179 100 / 0.7);
}

.hover\\:text-success-500\\/75:hover{
  color: rgb(22 179 100 / 0.75);
}

.hover\\:text-success-500\\/80:hover{
  color: rgb(22 179 100 / 0.8);
}

.hover\\:text-success-500\\/85:hover{
  color: rgb(22 179 100 / 0.85);
}

.hover\\:text-success-500\\/90:hover{
  color: rgb(22 179 100 / 0.9);
}

.hover\\:text-success-500\\/95:hover{
  color: rgb(22 179 100 / 0.95);
}

.hover\\:text-success-600:hover{
  --tw-text-opacity: 1;
  color: rgb(9 146 80 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-600\\/0:hover{
  color: rgb(9 146 80 / 0);
}

.hover\\:text-success-600\\/10:hover{
  color: rgb(9 146 80 / 0.1);
}

.hover\\:text-success-600\\/100:hover{
  color: rgb(9 146 80 / 1);
}

.hover\\:text-success-600\\/15:hover{
  color: rgb(9 146 80 / 0.15);
}

.hover\\:text-success-600\\/20:hover{
  color: rgb(9 146 80 / 0.2);
}

.hover\\:text-success-600\\/25:hover{
  color: rgb(9 146 80 / 0.25);
}

.hover\\:text-success-600\\/30:hover{
  color: rgb(9 146 80 / 0.3);
}

.hover\\:text-success-600\\/35:hover{
  color: rgb(9 146 80 / 0.35);
}

.hover\\:text-success-600\\/40:hover{
  color: rgb(9 146 80 / 0.4);
}

.hover\\:text-success-600\\/45:hover{
  color: rgb(9 146 80 / 0.45);
}

.hover\\:text-success-600\\/5:hover{
  color: rgb(9 146 80 / 0.05);
}

.hover\\:text-success-600\\/50:hover{
  color: rgb(9 146 80 / 0.5);
}

.hover\\:text-success-600\\/55:hover{
  color: rgb(9 146 80 / 0.55);
}

.hover\\:text-success-600\\/60:hover{
  color: rgb(9 146 80 / 0.6);
}

.hover\\:text-success-600\\/65:hover{
  color: rgb(9 146 80 / 0.65);
}

.hover\\:text-success-600\\/70:hover{
  color: rgb(9 146 80 / 0.7);
}

.hover\\:text-success-600\\/75:hover{
  color: rgb(9 146 80 / 0.75);
}

.hover\\:text-success-600\\/80:hover{
  color: rgb(9 146 80 / 0.8);
}

.hover\\:text-success-600\\/85:hover{
  color: rgb(9 146 80 / 0.85);
}

.hover\\:text-success-600\\/90:hover{
  color: rgb(9 146 80 / 0.9);
}

.hover\\:text-success-600\\/95:hover{
  color: rgb(9 146 80 / 0.95);
}

.hover\\:text-success-700:hover{
  --tw-text-opacity: 1;
  color: rgb(8 116 67 / var(--tw-text-opacity, 1));
}

.hover\\:text-success-700\\/0:hover{
  color: rgb(8 116 67 / 0);
}

.hover\\:text-success-700\\/10:hover{
  color: rgb(8 116 67 / 0.1);
}

.hover\\:text-success-700\\/100:hover{
  color: rgb(8 116 67 / 1);
}

.hover\\:text-success-700\\/15:hover{
  color: rgb(8 116 67 / 0.15);
}

.hover\\:text-success-700\\/20:hover{
  color: rgb(8 116 67 / 0.2);
}

.hover\\:text-success-700\\/25:hover{
  color: rgb(8 116 67 / 0.25);
}

.hover\\:text-success-700\\/30:hover{
  color: rgb(8 116 67 / 0.3);
}

.hover\\:text-success-700\\/35:hover{
  color: rgb(8 116 67 / 0.35);
}

.hover\\:text-success-700\\/40:hover{
  color: rgb(8 116 67 / 0.4);
}

.hover\\:text-success-700\\/45:hover{
  color: rgb(8 116 67 / 0.45);
}

.hover\\:text-success-700\\/5:hover{
  color: rgb(8 116 67 / 0.05);
}

.hover\\:text-success-700\\/50:hover{
  color: rgb(8 116 67 / 0.5);
}

.hover\\:text-success-700\\/55:hover{
  color: rgb(8 116 67 / 0.55);
}

.hover\\:text-success-700\\/60:hover{
  color: rgb(8 116 67 / 0.6);
}

.hover\\:text-success-700\\/65:hover{
  color: rgb(8 116 67 / 0.65);
}

.hover\\:text-success-700\\/70:hover{
  color: rgb(8 116 67 / 0.7);
}

.hover\\:text-success-700\\/75:hover{
  color: rgb(8 116 67 / 0.75);
}

.hover\\:text-success-700\\/80:hover{
  color: rgb(8 116 67 / 0.8);
}

.hover\\:text-success-700\\/85:hover{
  color: rgb(8 116 67 / 0.85);
}

.hover\\:text-success-700\\/90:hover{
  color: rgb(8 116 67 / 0.9);
}

.hover\\:text-success-700\\/95:hover{
  color: rgb(8 116 67 / 0.95);
}

.hover\\:text-warning-100:hover{
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-100\\/0:hover{
  color: rgb(254 240 199 / 0);
}

.hover\\:text-warning-100\\/10:hover{
  color: rgb(254 240 199 / 0.1);
}

.hover\\:text-warning-100\\/100:hover{
  color: rgb(254 240 199 / 1);
}

.hover\\:text-warning-100\\/15:hover{
  color: rgb(254 240 199 / 0.15);
}

.hover\\:text-warning-100\\/20:hover{
  color: rgb(254 240 199 / 0.2);
}

.hover\\:text-warning-100\\/25:hover{
  color: rgb(254 240 199 / 0.25);
}

.hover\\:text-warning-100\\/30:hover{
  color: rgb(254 240 199 / 0.3);
}

.hover\\:text-warning-100\\/35:hover{
  color: rgb(254 240 199 / 0.35);
}

.hover\\:text-warning-100\\/40:hover{
  color: rgb(254 240 199 / 0.4);
}

.hover\\:text-warning-100\\/45:hover{
  color: rgb(254 240 199 / 0.45);
}

.hover\\:text-warning-100\\/5:hover{
  color: rgb(254 240 199 / 0.05);
}

.hover\\:text-warning-100\\/50:hover{
  color: rgb(254 240 199 / 0.5);
}

.hover\\:text-warning-100\\/55:hover{
  color: rgb(254 240 199 / 0.55);
}

.hover\\:text-warning-100\\/60:hover{
  color: rgb(254 240 199 / 0.6);
}

.hover\\:text-warning-100\\/65:hover{
  color: rgb(254 240 199 / 0.65);
}

.hover\\:text-warning-100\\/70:hover{
  color: rgb(254 240 199 / 0.7);
}

.hover\\:text-warning-100\\/75:hover{
  color: rgb(254 240 199 / 0.75);
}

.hover\\:text-warning-100\\/80:hover{
  color: rgb(254 240 199 / 0.8);
}

.hover\\:text-warning-100\\/85:hover{
  color: rgb(254 240 199 / 0.85);
}

.hover\\:text-warning-100\\/90:hover{
  color: rgb(254 240 199 / 0.9);
}

.hover\\:text-warning-100\\/95:hover{
  color: rgb(254 240 199 / 0.95);
}

.hover\\:text-warning-200:hover{
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-200\\/0:hover{
  color: rgb(254 223 137 / 0);
}

.hover\\:text-warning-200\\/10:hover{
  color: rgb(254 223 137 / 0.1);
}

.hover\\:text-warning-200\\/100:hover{
  color: rgb(254 223 137 / 1);
}

.hover\\:text-warning-200\\/15:hover{
  color: rgb(254 223 137 / 0.15);
}

.hover\\:text-warning-200\\/20:hover{
  color: rgb(254 223 137 / 0.2);
}

.hover\\:text-warning-200\\/25:hover{
  color: rgb(254 223 137 / 0.25);
}

.hover\\:text-warning-200\\/30:hover{
  color: rgb(254 223 137 / 0.3);
}

.hover\\:text-warning-200\\/35:hover{
  color: rgb(254 223 137 / 0.35);
}

.hover\\:text-warning-200\\/40:hover{
  color: rgb(254 223 137 / 0.4);
}

.hover\\:text-warning-200\\/45:hover{
  color: rgb(254 223 137 / 0.45);
}

.hover\\:text-warning-200\\/5:hover{
  color: rgb(254 223 137 / 0.05);
}

.hover\\:text-warning-200\\/50:hover{
  color: rgb(254 223 137 / 0.5);
}

.hover\\:text-warning-200\\/55:hover{
  color: rgb(254 223 137 / 0.55);
}

.hover\\:text-warning-200\\/60:hover{
  color: rgb(254 223 137 / 0.6);
}

.hover\\:text-warning-200\\/65:hover{
  color: rgb(254 223 137 / 0.65);
}

.hover\\:text-warning-200\\/70:hover{
  color: rgb(254 223 137 / 0.7);
}

.hover\\:text-warning-200\\/75:hover{
  color: rgb(254 223 137 / 0.75);
}

.hover\\:text-warning-200\\/80:hover{
  color: rgb(254 223 137 / 0.8);
}

.hover\\:text-warning-200\\/85:hover{
  color: rgb(254 223 137 / 0.85);
}

.hover\\:text-warning-200\\/90:hover{
  color: rgb(254 223 137 / 0.9);
}

.hover\\:text-warning-200\\/95:hover{
  color: rgb(254 223 137 / 0.95);
}

.hover\\:text-warning-25:hover{
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-25\\/0:hover{
  color: rgb(255 252 245 / 0);
}

.hover\\:text-warning-25\\/10:hover{
  color: rgb(255 252 245 / 0.1);
}

.hover\\:text-warning-25\\/100:hover{
  color: rgb(255 252 245 / 1);
}

.hover\\:text-warning-25\\/15:hover{
  color: rgb(255 252 245 / 0.15);
}

.hover\\:text-warning-25\\/20:hover{
  color: rgb(255 252 245 / 0.2);
}

.hover\\:text-warning-25\\/25:hover{
  color: rgb(255 252 245 / 0.25);
}

.hover\\:text-warning-25\\/30:hover{
  color: rgb(255 252 245 / 0.3);
}

.hover\\:text-warning-25\\/35:hover{
  color: rgb(255 252 245 / 0.35);
}

.hover\\:text-warning-25\\/40:hover{
  color: rgb(255 252 245 / 0.4);
}

.hover\\:text-warning-25\\/45:hover{
  color: rgb(255 252 245 / 0.45);
}

.hover\\:text-warning-25\\/5:hover{
  color: rgb(255 252 245 / 0.05);
}

.hover\\:text-warning-25\\/50:hover{
  color: rgb(255 252 245 / 0.5);
}

.hover\\:text-warning-25\\/55:hover{
  color: rgb(255 252 245 / 0.55);
}

.hover\\:text-warning-25\\/60:hover{
  color: rgb(255 252 245 / 0.6);
}

.hover\\:text-warning-25\\/65:hover{
  color: rgb(255 252 245 / 0.65);
}

.hover\\:text-warning-25\\/70:hover{
  color: rgb(255 252 245 / 0.7);
}

.hover\\:text-warning-25\\/75:hover{
  color: rgb(255 252 245 / 0.75);
}

.hover\\:text-warning-25\\/80:hover{
  color: rgb(255 252 245 / 0.8);
}

.hover\\:text-warning-25\\/85:hover{
  color: rgb(255 252 245 / 0.85);
}

.hover\\:text-warning-25\\/90:hover{
  color: rgb(255 252 245 / 0.9);
}

.hover\\:text-warning-25\\/95:hover{
  color: rgb(255 252 245 / 0.95);
}

.hover\\:text-warning-400:hover{
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-400\\/0:hover{
  color: rgb(253 176 34 / 0);
}

.hover\\:text-warning-400\\/10:hover{
  color: rgb(253 176 34 / 0.1);
}

.hover\\:text-warning-400\\/100:hover{
  color: rgb(253 176 34 / 1);
}

.hover\\:text-warning-400\\/15:hover{
  color: rgb(253 176 34 / 0.15);
}

.hover\\:text-warning-400\\/20:hover{
  color: rgb(253 176 34 / 0.2);
}

.hover\\:text-warning-400\\/25:hover{
  color: rgb(253 176 34 / 0.25);
}

.hover\\:text-warning-400\\/30:hover{
  color: rgb(253 176 34 / 0.3);
}

.hover\\:text-warning-400\\/35:hover{
  color: rgb(253 176 34 / 0.35);
}

.hover\\:text-warning-400\\/40:hover{
  color: rgb(253 176 34 / 0.4);
}

.hover\\:text-warning-400\\/45:hover{
  color: rgb(253 176 34 / 0.45);
}

.hover\\:text-warning-400\\/5:hover{
  color: rgb(253 176 34 / 0.05);
}

.hover\\:text-warning-400\\/50:hover{
  color: rgb(253 176 34 / 0.5);
}

.hover\\:text-warning-400\\/55:hover{
  color: rgb(253 176 34 / 0.55);
}

.hover\\:text-warning-400\\/60:hover{
  color: rgb(253 176 34 / 0.6);
}

.hover\\:text-warning-400\\/65:hover{
  color: rgb(253 176 34 / 0.65);
}

.hover\\:text-warning-400\\/70:hover{
  color: rgb(253 176 34 / 0.7);
}

.hover\\:text-warning-400\\/75:hover{
  color: rgb(253 176 34 / 0.75);
}

.hover\\:text-warning-400\\/80:hover{
  color: rgb(253 176 34 / 0.8);
}

.hover\\:text-warning-400\\/85:hover{
  color: rgb(253 176 34 / 0.85);
}

.hover\\:text-warning-400\\/90:hover{
  color: rgb(253 176 34 / 0.9);
}

.hover\\:text-warning-400\\/95:hover{
  color: rgb(253 176 34 / 0.95);
}

.hover\\:text-warning-50:hover{
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-50\\/0:hover{
  color: rgb(255 250 235 / 0);
}

.hover\\:text-warning-50\\/10:hover{
  color: rgb(255 250 235 / 0.1);
}

.hover\\:text-warning-50\\/100:hover{
  color: rgb(255 250 235 / 1);
}

.hover\\:text-warning-50\\/15:hover{
  color: rgb(255 250 235 / 0.15);
}

.hover\\:text-warning-50\\/20:hover{
  color: rgb(255 250 235 / 0.2);
}

.hover\\:text-warning-50\\/25:hover{
  color: rgb(255 250 235 / 0.25);
}

.hover\\:text-warning-50\\/30:hover{
  color: rgb(255 250 235 / 0.3);
}

.hover\\:text-warning-50\\/35:hover{
  color: rgb(255 250 235 / 0.35);
}

.hover\\:text-warning-50\\/40:hover{
  color: rgb(255 250 235 / 0.4);
}

.hover\\:text-warning-50\\/45:hover{
  color: rgb(255 250 235 / 0.45);
}

.hover\\:text-warning-50\\/5:hover{
  color: rgb(255 250 235 / 0.05);
}

.hover\\:text-warning-50\\/50:hover{
  color: rgb(255 250 235 / 0.5);
}

.hover\\:text-warning-50\\/55:hover{
  color: rgb(255 250 235 / 0.55);
}

.hover\\:text-warning-50\\/60:hover{
  color: rgb(255 250 235 / 0.6);
}

.hover\\:text-warning-50\\/65:hover{
  color: rgb(255 250 235 / 0.65);
}

.hover\\:text-warning-50\\/70:hover{
  color: rgb(255 250 235 / 0.7);
}

.hover\\:text-warning-50\\/75:hover{
  color: rgb(255 250 235 / 0.75);
}

.hover\\:text-warning-50\\/80:hover{
  color: rgb(255 250 235 / 0.8);
}

.hover\\:text-warning-50\\/85:hover{
  color: rgb(255 250 235 / 0.85);
}

.hover\\:text-warning-50\\/90:hover{
  color: rgb(255 250 235 / 0.9);
}

.hover\\:text-warning-50\\/95:hover{
  color: rgb(255 250 235 / 0.95);
}

.hover\\:text-warning-500:hover{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-500\\/0:hover{
  color: rgb(247 144 9 / 0);
}

.hover\\:text-warning-500\\/10:hover{
  color: rgb(247 144 9 / 0.1);
}

.hover\\:text-warning-500\\/100:hover{
  color: rgb(247 144 9 / 1);
}

.hover\\:text-warning-500\\/15:hover{
  color: rgb(247 144 9 / 0.15);
}

.hover\\:text-warning-500\\/20:hover{
  color: rgb(247 144 9 / 0.2);
}

.hover\\:text-warning-500\\/25:hover{
  color: rgb(247 144 9 / 0.25);
}

.hover\\:text-warning-500\\/30:hover{
  color: rgb(247 144 9 / 0.3);
}

.hover\\:text-warning-500\\/35:hover{
  color: rgb(247 144 9 / 0.35);
}

.hover\\:text-warning-500\\/40:hover{
  color: rgb(247 144 9 / 0.4);
}

.hover\\:text-warning-500\\/45:hover{
  color: rgb(247 144 9 / 0.45);
}

.hover\\:text-warning-500\\/5:hover{
  color: rgb(247 144 9 / 0.05);
}

.hover\\:text-warning-500\\/50:hover{
  color: rgb(247 144 9 / 0.5);
}

.hover\\:text-warning-500\\/55:hover{
  color: rgb(247 144 9 / 0.55);
}

.hover\\:text-warning-500\\/60:hover{
  color: rgb(247 144 9 / 0.6);
}

.hover\\:text-warning-500\\/65:hover{
  color: rgb(247 144 9 / 0.65);
}

.hover\\:text-warning-500\\/70:hover{
  color: rgb(247 144 9 / 0.7);
}

.hover\\:text-warning-500\\/75:hover{
  color: rgb(247 144 9 / 0.75);
}

.hover\\:text-warning-500\\/80:hover{
  color: rgb(247 144 9 / 0.8);
}

.hover\\:text-warning-500\\/85:hover{
  color: rgb(247 144 9 / 0.85);
}

.hover\\:text-warning-500\\/90:hover{
  color: rgb(247 144 9 / 0.9);
}

.hover\\:text-warning-500\\/95:hover{
  color: rgb(247 144 9 / 0.95);
}

.hover\\:text-warning-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-600\\/0:hover{
  color: rgb(220 104 3 / 0);
}

.hover\\:text-warning-600\\/10:hover{
  color: rgb(220 104 3 / 0.1);
}

.hover\\:text-warning-600\\/100:hover{
  color: rgb(220 104 3 / 1);
}

.hover\\:text-warning-600\\/15:hover{
  color: rgb(220 104 3 / 0.15);
}

.hover\\:text-warning-600\\/20:hover{
  color: rgb(220 104 3 / 0.2);
}

.hover\\:text-warning-600\\/25:hover{
  color: rgb(220 104 3 / 0.25);
}

.hover\\:text-warning-600\\/30:hover{
  color: rgb(220 104 3 / 0.3);
}

.hover\\:text-warning-600\\/35:hover{
  color: rgb(220 104 3 / 0.35);
}

.hover\\:text-warning-600\\/40:hover{
  color: rgb(220 104 3 / 0.4);
}

.hover\\:text-warning-600\\/45:hover{
  color: rgb(220 104 3 / 0.45);
}

.hover\\:text-warning-600\\/5:hover{
  color: rgb(220 104 3 / 0.05);
}

.hover\\:text-warning-600\\/50:hover{
  color: rgb(220 104 3 / 0.5);
}

.hover\\:text-warning-600\\/55:hover{
  color: rgb(220 104 3 / 0.55);
}

.hover\\:text-warning-600\\/60:hover{
  color: rgb(220 104 3 / 0.6);
}

.hover\\:text-warning-600\\/65:hover{
  color: rgb(220 104 3 / 0.65);
}

.hover\\:text-warning-600\\/70:hover{
  color: rgb(220 104 3 / 0.7);
}

.hover\\:text-warning-600\\/75:hover{
  color: rgb(220 104 3 / 0.75);
}

.hover\\:text-warning-600\\/80:hover{
  color: rgb(220 104 3 / 0.8);
}

.hover\\:text-warning-600\\/85:hover{
  color: rgb(220 104 3 / 0.85);
}

.hover\\:text-warning-600\\/90:hover{
  color: rgb(220 104 3 / 0.9);
}

.hover\\:text-warning-600\\/95:hover{
  color: rgb(220 104 3 / 0.95);
}

.hover\\:text-warning-700:hover{
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}

.hover\\:text-warning-700\\/0:hover{
  color: rgb(181 71 8 / 0);
}

.hover\\:text-warning-700\\/10:hover{
  color: rgb(181 71 8 / 0.1);
}

.hover\\:text-warning-700\\/100:hover{
  color: rgb(181 71 8 / 1);
}

.hover\\:text-warning-700\\/15:hover{
  color: rgb(181 71 8 / 0.15);
}

.hover\\:text-warning-700\\/20:hover{
  color: rgb(181 71 8 / 0.2);
}

.hover\\:text-warning-700\\/25:hover{
  color: rgb(181 71 8 / 0.25);
}

.hover\\:text-warning-700\\/30:hover{
  color: rgb(181 71 8 / 0.3);
}

.hover\\:text-warning-700\\/35:hover{
  color: rgb(181 71 8 / 0.35);
}

.hover\\:text-warning-700\\/40:hover{
  color: rgb(181 71 8 / 0.4);
}

.hover\\:text-warning-700\\/45:hover{
  color: rgb(181 71 8 / 0.45);
}

.hover\\:text-warning-700\\/5:hover{
  color: rgb(181 71 8 / 0.05);
}

.hover\\:text-warning-700\\/50:hover{
  color: rgb(181 71 8 / 0.5);
}

.hover\\:text-warning-700\\/55:hover{
  color: rgb(181 71 8 / 0.55);
}

.hover\\:text-warning-700\\/60:hover{
  color: rgb(181 71 8 / 0.6);
}

.hover\\:text-warning-700\\/65:hover{
  color: rgb(181 71 8 / 0.65);
}

.hover\\:text-warning-700\\/70:hover{
  color: rgb(181 71 8 / 0.7);
}

.hover\\:text-warning-700\\/75:hover{
  color: rgb(181 71 8 / 0.75);
}

.hover\\:text-warning-700\\/80:hover{
  color: rgb(181 71 8 / 0.8);
}

.hover\\:text-warning-700\\/85:hover{
  color: rgb(181 71 8 / 0.85);
}

.hover\\:text-warning-700\\/90:hover{
  color: rgb(181 71 8 / 0.9);
}

.hover\\:text-warning-700\\/95:hover{
  color: rgb(181 71 8 / 0.95);
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-800:hover{
  --tw-text-opacity: 1;
  color: rgb(133 74 14 / var(--tw-text-opacity, 1));
}

.hover\\:\\!underline:hover{
  text-decoration-line: underline !important;
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:shadow-\\[0_0_0_2px_\\#CBF0FD\\]:hover{
  --tw-shadow: 0 0 0 2px #CBF0FD;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0px_6px_18px_rgba\\(10\\2c 18\\2c 57\\2c 0\\.08\\)\\]:hover{
  --tw-shadow: 0px 6px 18px rgba(10,18,57,0.08);
  --tw-shadow-colored: 0px 6px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-spread-medium:hover{
  --tw-shadow: 0px 0px 16px 2px rgba(65, 70, 81, 0.12);
  --tw-shadow-colored: 0px 0px 16px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:file\\:bg-primary-600::file-selector-button:hover{
  background-color: var(--color-primary-600, #0086C9);
}

.hover\\:before\\:h-\\[2px\\]:hover::before{
  content: var(--tw-content);
  height: 2px;
}

.hover\\:before\\:\\!bg-neutral-200:hover::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:before\\:opacity-100:hover::before{
  content: var(--tw-content);
  opacity: 1;
}

.focus\\:border-none:focus{
  border-style: none;
}

.focus\\:\\!border-danger-400:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:\\!border-neutral-400:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:\\!border-success-400:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(60 203 127 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:\\!border-warning-400:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-neutral-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-300:focus{
  border-color: var(--color-primary-300, #7CD4FD);
}

.focus\\:border-primary-500:focus{
  border-color: var(--color-primary-500, #0BA5EC);
}

.focus\\:bg-danger-200:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-neutral-200:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-neutral-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-primary-200:focus{
  background-color: var(--color-primary-200, #B9E6FE);
}

.focus\\:bg-primary-400:focus{
  background-color: var(--color-primary-400, #36BFFA);
}

.focus\\:bg-success-200:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(170 240 196 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-warning-200:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:\\!shadow-none:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:\\!outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:\\!outline:focus{
  outline-style: solid !important;
}

.focus\\:\\!outline-2:focus{
  outline-width: 2px !important;
}

.focus\\:\\!outline-\\[\\#CBF0FD\\]:focus{
  outline-color: #CBF0FD !important;
}

.focus\\:\\!outline-danger-100:focus{
  outline-color: #FEE4E2 !important;
}

.focus\\:\\!outline-neutral-100:focus{
  outline-color: #F5F5F5 !important;
}

.focus\\:\\!outline-success-100:focus{
  outline-color: #D3F8DF !important;
}

.focus\\:\\!outline-warning-100:focus{
  outline-color: #FEF0C7 !important;
}

.focus\\:\\!ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-primary-100:focus{
  --tw-ring-color: var(--color-primary-100, #E0F2FE);
}

.focus\\:ring-primary-500:focus{
  --tw-ring-color: var(--color-primary-500, #0BA5EC);
}

.focus-visible\\:bg-neutral-75:focus-visible{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.focus-visible\\:bg-primary-25:focus-visible{
  background-color: var(--color-primary-25, #F5FBFF);
}

.focus-visible\\:opacity-100:focus-visible{
  opacity: 1;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}

.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}

.focus-visible\\:outline-offset-2:focus-visible{
  outline-offset: 2px;
}

.focus-visible\\:outline-primary-200:focus-visible{
  outline-color: var(--color-primary-200, #B9E6FE);
}

.focus-visible\\:outline-primary-500:focus-visible{
  outline-color: var(--color-primary-500, #0BA5EC);
}

.focus-visible\\:outline-primary-600:focus-visible{
  outline-color: var(--color-primary-600, #0086C9);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-primary-300:focus-visible{
  --tw-ring-color: var(--color-primary-300, #7CD4FD);
}

.focus-visible\\:ring-primary-400:focus-visible{
  --tw-ring-color: var(--color-primary-400, #36BFFA);
}

.focus-visible\\:ring-primary-500:focus-visible{
  --tw-ring-color: var(--color-primary-500, #0BA5EC);
}

.active\\:scale-90:active{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.active\\:border-none:active{
  border-style: none;
}

.active\\:border-danger-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-100\\/0:active{
  border-color: rgb(254 228 226 / 0);
}

.active\\:border-danger-100\\/10:active{
  border-color: rgb(254 228 226 / 0.1);
}

.active\\:border-danger-100\\/100:active{
  border-color: rgb(254 228 226 / 1);
}

.active\\:border-danger-100\\/15:active{
  border-color: rgb(254 228 226 / 0.15);
}

.active\\:border-danger-100\\/20:active{
  border-color: rgb(254 228 226 / 0.2);
}

.active\\:border-danger-100\\/25:active{
  border-color: rgb(254 228 226 / 0.25);
}

.active\\:border-danger-100\\/30:active{
  border-color: rgb(254 228 226 / 0.3);
}

.active\\:border-danger-100\\/35:active{
  border-color: rgb(254 228 226 / 0.35);
}

.active\\:border-danger-100\\/40:active{
  border-color: rgb(254 228 226 / 0.4);
}

.active\\:border-danger-100\\/45:active{
  border-color: rgb(254 228 226 / 0.45);
}

.active\\:border-danger-100\\/5:active{
  border-color: rgb(254 228 226 / 0.05);
}

.active\\:border-danger-100\\/50:active{
  border-color: rgb(254 228 226 / 0.5);
}

.active\\:border-danger-100\\/55:active{
  border-color: rgb(254 228 226 / 0.55);
}

.active\\:border-danger-100\\/60:active{
  border-color: rgb(254 228 226 / 0.6);
}

.active\\:border-danger-100\\/65:active{
  border-color: rgb(254 228 226 / 0.65);
}

.active\\:border-danger-100\\/70:active{
  border-color: rgb(254 228 226 / 0.7);
}

.active\\:border-danger-100\\/75:active{
  border-color: rgb(254 228 226 / 0.75);
}

.active\\:border-danger-100\\/80:active{
  border-color: rgb(254 228 226 / 0.8);
}

.active\\:border-danger-100\\/85:active{
  border-color: rgb(254 228 226 / 0.85);
}

.active\\:border-danger-100\\/90:active{
  border-color: rgb(254 228 226 / 0.9);
}

.active\\:border-danger-100\\/95:active{
  border-color: rgb(254 228 226 / 0.95);
}

.active\\:border-danger-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-200\\/0:active{
  border-color: rgb(254 205 202 / 0);
}

.active\\:border-danger-200\\/10:active{
  border-color: rgb(254 205 202 / 0.1);
}

.active\\:border-danger-200\\/100:active{
  border-color: rgb(254 205 202 / 1);
}

.active\\:border-danger-200\\/15:active{
  border-color: rgb(254 205 202 / 0.15);
}

.active\\:border-danger-200\\/20:active{
  border-color: rgb(254 205 202 / 0.2);
}

.active\\:border-danger-200\\/25:active{
  border-color: rgb(254 205 202 / 0.25);
}

.active\\:border-danger-200\\/30:active{
  border-color: rgb(254 205 202 / 0.3);
}

.active\\:border-danger-200\\/35:active{
  border-color: rgb(254 205 202 / 0.35);
}

.active\\:border-danger-200\\/40:active{
  border-color: rgb(254 205 202 / 0.4);
}

.active\\:border-danger-200\\/45:active{
  border-color: rgb(254 205 202 / 0.45);
}

.active\\:border-danger-200\\/5:active{
  border-color: rgb(254 205 202 / 0.05);
}

.active\\:border-danger-200\\/50:active{
  border-color: rgb(254 205 202 / 0.5);
}

.active\\:border-danger-200\\/55:active{
  border-color: rgb(254 205 202 / 0.55);
}

.active\\:border-danger-200\\/60:active{
  border-color: rgb(254 205 202 / 0.6);
}

.active\\:border-danger-200\\/65:active{
  border-color: rgb(254 205 202 / 0.65);
}

.active\\:border-danger-200\\/70:active{
  border-color: rgb(254 205 202 / 0.7);
}

.active\\:border-danger-200\\/75:active{
  border-color: rgb(254 205 202 / 0.75);
}

.active\\:border-danger-200\\/80:active{
  border-color: rgb(254 205 202 / 0.8);
}

.active\\:border-danger-200\\/85:active{
  border-color: rgb(254 205 202 / 0.85);
}

.active\\:border-danger-200\\/90:active{
  border-color: rgb(254 205 202 / 0.9);
}

.active\\:border-danger-200\\/95:active{
  border-color: rgb(254 205 202 / 0.95);
}

.active\\:border-danger-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(255 251 250 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-25\\/0:active{
  border-color: rgb(255 251 250 / 0);
}

.active\\:border-danger-25\\/10:active{
  border-color: rgb(255 251 250 / 0.1);
}

.active\\:border-danger-25\\/100:active{
  border-color: rgb(255 251 250 / 1);
}

.active\\:border-danger-25\\/15:active{
  border-color: rgb(255 251 250 / 0.15);
}

.active\\:border-danger-25\\/20:active{
  border-color: rgb(255 251 250 / 0.2);
}

.active\\:border-danger-25\\/25:active{
  border-color: rgb(255 251 250 / 0.25);
}

.active\\:border-danger-25\\/30:active{
  border-color: rgb(255 251 250 / 0.3);
}

.active\\:border-danger-25\\/35:active{
  border-color: rgb(255 251 250 / 0.35);
}

.active\\:border-danger-25\\/40:active{
  border-color: rgb(255 251 250 / 0.4);
}

.active\\:border-danger-25\\/45:active{
  border-color: rgb(255 251 250 / 0.45);
}

.active\\:border-danger-25\\/5:active{
  border-color: rgb(255 251 250 / 0.05);
}

.active\\:border-danger-25\\/50:active{
  border-color: rgb(255 251 250 / 0.5);
}

.active\\:border-danger-25\\/55:active{
  border-color: rgb(255 251 250 / 0.55);
}

.active\\:border-danger-25\\/60:active{
  border-color: rgb(255 251 250 / 0.6);
}

.active\\:border-danger-25\\/65:active{
  border-color: rgb(255 251 250 / 0.65);
}

.active\\:border-danger-25\\/70:active{
  border-color: rgb(255 251 250 / 0.7);
}

.active\\:border-danger-25\\/75:active{
  border-color: rgb(255 251 250 / 0.75);
}

.active\\:border-danger-25\\/80:active{
  border-color: rgb(255 251 250 / 0.8);
}

.active\\:border-danger-25\\/85:active{
  border-color: rgb(255 251 250 / 0.85);
}

.active\\:border-danger-25\\/90:active{
  border-color: rgb(255 251 250 / 0.9);
}

.active\\:border-danger-25\\/95:active{
  border-color: rgb(255 251 250 / 0.95);
}

.active\\:border-danger-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-400\\/0:active{
  border-color: rgb(249 112 102 / 0);
}

.active\\:border-danger-400\\/10:active{
  border-color: rgb(249 112 102 / 0.1);
}

.active\\:border-danger-400\\/100:active{
  border-color: rgb(249 112 102 / 1);
}

.active\\:border-danger-400\\/15:active{
  border-color: rgb(249 112 102 / 0.15);
}

.active\\:border-danger-400\\/20:active{
  border-color: rgb(249 112 102 / 0.2);
}

.active\\:border-danger-400\\/25:active{
  border-color: rgb(249 112 102 / 0.25);
}

.active\\:border-danger-400\\/30:active{
  border-color: rgb(249 112 102 / 0.3);
}

.active\\:border-danger-400\\/35:active{
  border-color: rgb(249 112 102 / 0.35);
}

.active\\:border-danger-400\\/40:active{
  border-color: rgb(249 112 102 / 0.4);
}

.active\\:border-danger-400\\/45:active{
  border-color: rgb(249 112 102 / 0.45);
}

.active\\:border-danger-400\\/5:active{
  border-color: rgb(249 112 102 / 0.05);
}

.active\\:border-danger-400\\/50:active{
  border-color: rgb(249 112 102 / 0.5);
}

.active\\:border-danger-400\\/55:active{
  border-color: rgb(249 112 102 / 0.55);
}

.active\\:border-danger-400\\/60:active{
  border-color: rgb(249 112 102 / 0.6);
}

.active\\:border-danger-400\\/65:active{
  border-color: rgb(249 112 102 / 0.65);
}

.active\\:border-danger-400\\/70:active{
  border-color: rgb(249 112 102 / 0.7);
}

.active\\:border-danger-400\\/75:active{
  border-color: rgb(249 112 102 / 0.75);
}

.active\\:border-danger-400\\/80:active{
  border-color: rgb(249 112 102 / 0.8);
}

.active\\:border-danger-400\\/85:active{
  border-color: rgb(249 112 102 / 0.85);
}

.active\\:border-danger-400\\/90:active{
  border-color: rgb(249 112 102 / 0.9);
}

.active\\:border-danger-400\\/95:active{
  border-color: rgb(249 112 102 / 0.95);
}

.active\\:border-danger-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-50\\/0:active{
  border-color: rgb(254 243 242 / 0);
}

.active\\:border-danger-50\\/10:active{
  border-color: rgb(254 243 242 / 0.1);
}

.active\\:border-danger-50\\/100:active{
  border-color: rgb(254 243 242 / 1);
}

.active\\:border-danger-50\\/15:active{
  border-color: rgb(254 243 242 / 0.15);
}

.active\\:border-danger-50\\/20:active{
  border-color: rgb(254 243 242 / 0.2);
}

.active\\:border-danger-50\\/25:active{
  border-color: rgb(254 243 242 / 0.25);
}

.active\\:border-danger-50\\/30:active{
  border-color: rgb(254 243 242 / 0.3);
}

.active\\:border-danger-50\\/35:active{
  border-color: rgb(254 243 242 / 0.35);
}

.active\\:border-danger-50\\/40:active{
  border-color: rgb(254 243 242 / 0.4);
}

.active\\:border-danger-50\\/45:active{
  border-color: rgb(254 243 242 / 0.45);
}

.active\\:border-danger-50\\/5:active{
  border-color: rgb(254 243 242 / 0.05);
}

.active\\:border-danger-50\\/50:active{
  border-color: rgb(254 243 242 / 0.5);
}

.active\\:border-danger-50\\/55:active{
  border-color: rgb(254 243 242 / 0.55);
}

.active\\:border-danger-50\\/60:active{
  border-color: rgb(254 243 242 / 0.6);
}

.active\\:border-danger-50\\/65:active{
  border-color: rgb(254 243 242 / 0.65);
}

.active\\:border-danger-50\\/70:active{
  border-color: rgb(254 243 242 / 0.7);
}

.active\\:border-danger-50\\/75:active{
  border-color: rgb(254 243 242 / 0.75);
}

.active\\:border-danger-50\\/80:active{
  border-color: rgb(254 243 242 / 0.8);
}

.active\\:border-danger-50\\/85:active{
  border-color: rgb(254 243 242 / 0.85);
}

.active\\:border-danger-50\\/90:active{
  border-color: rgb(254 243 242 / 0.9);
}

.active\\:border-danger-50\\/95:active{
  border-color: rgb(254 243 242 / 0.95);
}

.active\\:border-danger-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-500\\/0:active{
  border-color: rgb(240 68 56 / 0);
}

.active\\:border-danger-500\\/10:active{
  border-color: rgb(240 68 56 / 0.1);
}

.active\\:border-danger-500\\/100:active{
  border-color: rgb(240 68 56 / 1);
}

.active\\:border-danger-500\\/15:active{
  border-color: rgb(240 68 56 / 0.15);
}

.active\\:border-danger-500\\/20:active{
  border-color: rgb(240 68 56 / 0.2);
}

.active\\:border-danger-500\\/25:active{
  border-color: rgb(240 68 56 / 0.25);
}

.active\\:border-danger-500\\/30:active{
  border-color: rgb(240 68 56 / 0.3);
}

.active\\:border-danger-500\\/35:active{
  border-color: rgb(240 68 56 / 0.35);
}

.active\\:border-danger-500\\/40:active{
  border-color: rgb(240 68 56 / 0.4);
}

.active\\:border-danger-500\\/45:active{
  border-color: rgb(240 68 56 / 0.45);
}

.active\\:border-danger-500\\/5:active{
  border-color: rgb(240 68 56 / 0.05);
}

.active\\:border-danger-500\\/50:active{
  border-color: rgb(240 68 56 / 0.5);
}

.active\\:border-danger-500\\/55:active{
  border-color: rgb(240 68 56 / 0.55);
}

.active\\:border-danger-500\\/60:active{
  border-color: rgb(240 68 56 / 0.6);
}

.active\\:border-danger-500\\/65:active{
  border-color: rgb(240 68 56 / 0.65);
}

.active\\:border-danger-500\\/70:active{
  border-color: rgb(240 68 56 / 0.7);
}

.active\\:border-danger-500\\/75:active{
  border-color: rgb(240 68 56 / 0.75);
}

.active\\:border-danger-500\\/80:active{
  border-color: rgb(240 68 56 / 0.8);
}

.active\\:border-danger-500\\/85:active{
  border-color: rgb(240 68 56 / 0.85);
}

.active\\:border-danger-500\\/90:active{
  border-color: rgb(240 68 56 / 0.9);
}

.active\\:border-danger-500\\/95:active{
  border-color: rgb(240 68 56 / 0.95);
}

.active\\:border-danger-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-600\\/0:active{
  border-color: rgb(217 45 32 / 0);
}

.active\\:border-danger-600\\/10:active{
  border-color: rgb(217 45 32 / 0.1);
}

.active\\:border-danger-600\\/100:active{
  border-color: rgb(217 45 32 / 1);
}

.active\\:border-danger-600\\/15:active{
  border-color: rgb(217 45 32 / 0.15);
}

.active\\:border-danger-600\\/20:active{
  border-color: rgb(217 45 32 / 0.2);
}

.active\\:border-danger-600\\/25:active{
  border-color: rgb(217 45 32 / 0.25);
}

.active\\:border-danger-600\\/30:active{
  border-color: rgb(217 45 32 / 0.3);
}

.active\\:border-danger-600\\/35:active{
  border-color: rgb(217 45 32 / 0.35);
}

.active\\:border-danger-600\\/40:active{
  border-color: rgb(217 45 32 / 0.4);
}

.active\\:border-danger-600\\/45:active{
  border-color: rgb(217 45 32 / 0.45);
}

.active\\:border-danger-600\\/5:active{
  border-color: rgb(217 45 32 / 0.05);
}

.active\\:border-danger-600\\/50:active{
  border-color: rgb(217 45 32 / 0.5);
}

.active\\:border-danger-600\\/55:active{
  border-color: rgb(217 45 32 / 0.55);
}

.active\\:border-danger-600\\/60:active{
  border-color: rgb(217 45 32 / 0.6);
}

.active\\:border-danger-600\\/65:active{
  border-color: rgb(217 45 32 / 0.65);
}

.active\\:border-danger-600\\/70:active{
  border-color: rgb(217 45 32 / 0.7);
}

.active\\:border-danger-600\\/75:active{
  border-color: rgb(217 45 32 / 0.75);
}

.active\\:border-danger-600\\/80:active{
  border-color: rgb(217 45 32 / 0.8);
}

.active\\:border-danger-600\\/85:active{
  border-color: rgb(217 45 32 / 0.85);
}

.active\\:border-danger-600\\/90:active{
  border-color: rgb(217 45 32 / 0.9);
}

.active\\:border-danger-600\\/95:active{
  border-color: rgb(217 45 32 / 0.95);
}

.active\\:border-danger-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}

.active\\:border-danger-700\\/0:active{
  border-color: rgb(180 35 24 / 0);
}

.active\\:border-danger-700\\/10:active{
  border-color: rgb(180 35 24 / 0.1);
}

.active\\:border-danger-700\\/100:active{
  border-color: rgb(180 35 24 / 1);
}

.active\\:border-danger-700\\/15:active{
  border-color: rgb(180 35 24 / 0.15);
}

.active\\:border-danger-700\\/20:active{
  border-color: rgb(180 35 24 / 0.2);
}

.active\\:border-danger-700\\/25:active{
  border-color: rgb(180 35 24 / 0.25);
}

.active\\:border-danger-700\\/30:active{
  border-color: rgb(180 35 24 / 0.3);
}

.active\\:border-danger-700\\/35:active{
  border-color: rgb(180 35 24 / 0.35);
}

.active\\:border-danger-700\\/40:active{
  border-color: rgb(180 35 24 / 0.4);
}

.active\\:border-danger-700\\/45:active{
  border-color: rgb(180 35 24 / 0.45);
}

.active\\:border-danger-700\\/5:active{
  border-color: rgb(180 35 24 / 0.05);
}

.active\\:border-danger-700\\/50:active{
  border-color: rgb(180 35 24 / 0.5);
}

.active\\:border-danger-700\\/55:active{
  border-color: rgb(180 35 24 / 0.55);
}

.active\\:border-danger-700\\/60:active{
  border-color: rgb(180 35 24 / 0.6);
}

.active\\:border-danger-700\\/65:active{
  border-color: rgb(180 35 24 / 0.65);
}

.active\\:border-danger-700\\/70:active{
  border-color: rgb(180 35 24 / 0.7);
}

.active\\:border-danger-700\\/75:active{
  border-color: rgb(180 35 24 / 0.75);
}

.active\\:border-danger-700\\/80:active{
  border-color: rgb(180 35 24 / 0.8);
}

.active\\:border-danger-700\\/85:active{
  border-color: rgb(180 35 24 / 0.85);
}

.active\\:border-danger-700\\/90:active{
  border-color: rgb(180 35 24 / 0.9);
}

.active\\:border-danger-700\\/95:active{
  border-color: rgb(180 35 24 / 0.95);
}

.active\\:border-moss-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(230 244 215 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-100\\/0:active{
  border-color: rgb(230 244 215 / 0);
}

.active\\:border-moss-100\\/10:active{
  border-color: rgb(230 244 215 / 0.1);
}

.active\\:border-moss-100\\/100:active{
  border-color: rgb(230 244 215 / 1);
}

.active\\:border-moss-100\\/15:active{
  border-color: rgb(230 244 215 / 0.15);
}

.active\\:border-moss-100\\/20:active{
  border-color: rgb(230 244 215 / 0.2);
}

.active\\:border-moss-100\\/25:active{
  border-color: rgb(230 244 215 / 0.25);
}

.active\\:border-moss-100\\/30:active{
  border-color: rgb(230 244 215 / 0.3);
}

.active\\:border-moss-100\\/35:active{
  border-color: rgb(230 244 215 / 0.35);
}

.active\\:border-moss-100\\/40:active{
  border-color: rgb(230 244 215 / 0.4);
}

.active\\:border-moss-100\\/45:active{
  border-color: rgb(230 244 215 / 0.45);
}

.active\\:border-moss-100\\/5:active{
  border-color: rgb(230 244 215 / 0.05);
}

.active\\:border-moss-100\\/50:active{
  border-color: rgb(230 244 215 / 0.5);
}

.active\\:border-moss-100\\/55:active{
  border-color: rgb(230 244 215 / 0.55);
}

.active\\:border-moss-100\\/60:active{
  border-color: rgb(230 244 215 / 0.6);
}

.active\\:border-moss-100\\/65:active{
  border-color: rgb(230 244 215 / 0.65);
}

.active\\:border-moss-100\\/70:active{
  border-color: rgb(230 244 215 / 0.7);
}

.active\\:border-moss-100\\/75:active{
  border-color: rgb(230 244 215 / 0.75);
}

.active\\:border-moss-100\\/80:active{
  border-color: rgb(230 244 215 / 0.8);
}

.active\\:border-moss-100\\/85:active{
  border-color: rgb(230 244 215 / 0.85);
}

.active\\:border-moss-100\\/90:active{
  border-color: rgb(230 244 215 / 0.9);
}

.active\\:border-moss-100\\/95:active{
  border-color: rgb(230 244 215 / 0.95);
}

.active\\:border-moss-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(206 234 176 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-200\\/0:active{
  border-color: rgb(206 234 176 / 0);
}

.active\\:border-moss-200\\/10:active{
  border-color: rgb(206 234 176 / 0.1);
}

.active\\:border-moss-200\\/100:active{
  border-color: rgb(206 234 176 / 1);
}

.active\\:border-moss-200\\/15:active{
  border-color: rgb(206 234 176 / 0.15);
}

.active\\:border-moss-200\\/20:active{
  border-color: rgb(206 234 176 / 0.2);
}

.active\\:border-moss-200\\/25:active{
  border-color: rgb(206 234 176 / 0.25);
}

.active\\:border-moss-200\\/30:active{
  border-color: rgb(206 234 176 / 0.3);
}

.active\\:border-moss-200\\/35:active{
  border-color: rgb(206 234 176 / 0.35);
}

.active\\:border-moss-200\\/40:active{
  border-color: rgb(206 234 176 / 0.4);
}

.active\\:border-moss-200\\/45:active{
  border-color: rgb(206 234 176 / 0.45);
}

.active\\:border-moss-200\\/5:active{
  border-color: rgb(206 234 176 / 0.05);
}

.active\\:border-moss-200\\/50:active{
  border-color: rgb(206 234 176 / 0.5);
}

.active\\:border-moss-200\\/55:active{
  border-color: rgb(206 234 176 / 0.55);
}

.active\\:border-moss-200\\/60:active{
  border-color: rgb(206 234 176 / 0.6);
}

.active\\:border-moss-200\\/65:active{
  border-color: rgb(206 234 176 / 0.65);
}

.active\\:border-moss-200\\/70:active{
  border-color: rgb(206 234 176 / 0.7);
}

.active\\:border-moss-200\\/75:active{
  border-color: rgb(206 234 176 / 0.75);
}

.active\\:border-moss-200\\/80:active{
  border-color: rgb(206 234 176 / 0.8);
}

.active\\:border-moss-200\\/85:active{
  border-color: rgb(206 234 176 / 0.85);
}

.active\\:border-moss-200\\/90:active{
  border-color: rgb(206 234 176 / 0.9);
}

.active\\:border-moss-200\\/95:active{
  border-color: rgb(206 234 176 / 0.95);
}

.active\\:border-moss-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(250 253 247 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-25\\/0:active{
  border-color: rgb(250 253 247 / 0);
}

.active\\:border-moss-25\\/10:active{
  border-color: rgb(250 253 247 / 0.1);
}

.active\\:border-moss-25\\/100:active{
  border-color: rgb(250 253 247 / 1);
}

.active\\:border-moss-25\\/15:active{
  border-color: rgb(250 253 247 / 0.15);
}

.active\\:border-moss-25\\/20:active{
  border-color: rgb(250 253 247 / 0.2);
}

.active\\:border-moss-25\\/25:active{
  border-color: rgb(250 253 247 / 0.25);
}

.active\\:border-moss-25\\/30:active{
  border-color: rgb(250 253 247 / 0.3);
}

.active\\:border-moss-25\\/35:active{
  border-color: rgb(250 253 247 / 0.35);
}

.active\\:border-moss-25\\/40:active{
  border-color: rgb(250 253 247 / 0.4);
}

.active\\:border-moss-25\\/45:active{
  border-color: rgb(250 253 247 / 0.45);
}

.active\\:border-moss-25\\/5:active{
  border-color: rgb(250 253 247 / 0.05);
}

.active\\:border-moss-25\\/50:active{
  border-color: rgb(250 253 247 / 0.5);
}

.active\\:border-moss-25\\/55:active{
  border-color: rgb(250 253 247 / 0.55);
}

.active\\:border-moss-25\\/60:active{
  border-color: rgb(250 253 247 / 0.6);
}

.active\\:border-moss-25\\/65:active{
  border-color: rgb(250 253 247 / 0.65);
}

.active\\:border-moss-25\\/70:active{
  border-color: rgb(250 253 247 / 0.7);
}

.active\\:border-moss-25\\/75:active{
  border-color: rgb(250 253 247 / 0.75);
}

.active\\:border-moss-25\\/80:active{
  border-color: rgb(250 253 247 / 0.8);
}

.active\\:border-moss-25\\/85:active{
  border-color: rgb(250 253 247 / 0.85);
}

.active\\:border-moss-25\\/90:active{
  border-color: rgb(250 253 247 / 0.9);
}

.active\\:border-moss-25\\/95:active{
  border-color: rgb(250 253 247 / 0.95);
}

.active\\:border-moss-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(134 203 60 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-400\\/0:active{
  border-color: rgb(134 203 60 / 0);
}

.active\\:border-moss-400\\/10:active{
  border-color: rgb(134 203 60 / 0.1);
}

.active\\:border-moss-400\\/100:active{
  border-color: rgb(134 203 60 / 1);
}

.active\\:border-moss-400\\/15:active{
  border-color: rgb(134 203 60 / 0.15);
}

.active\\:border-moss-400\\/20:active{
  border-color: rgb(134 203 60 / 0.2);
}

.active\\:border-moss-400\\/25:active{
  border-color: rgb(134 203 60 / 0.25);
}

.active\\:border-moss-400\\/30:active{
  border-color: rgb(134 203 60 / 0.3);
}

.active\\:border-moss-400\\/35:active{
  border-color: rgb(134 203 60 / 0.35);
}

.active\\:border-moss-400\\/40:active{
  border-color: rgb(134 203 60 / 0.4);
}

.active\\:border-moss-400\\/45:active{
  border-color: rgb(134 203 60 / 0.45);
}

.active\\:border-moss-400\\/5:active{
  border-color: rgb(134 203 60 / 0.05);
}

.active\\:border-moss-400\\/50:active{
  border-color: rgb(134 203 60 / 0.5);
}

.active\\:border-moss-400\\/55:active{
  border-color: rgb(134 203 60 / 0.55);
}

.active\\:border-moss-400\\/60:active{
  border-color: rgb(134 203 60 / 0.6);
}

.active\\:border-moss-400\\/65:active{
  border-color: rgb(134 203 60 / 0.65);
}

.active\\:border-moss-400\\/70:active{
  border-color: rgb(134 203 60 / 0.7);
}

.active\\:border-moss-400\\/75:active{
  border-color: rgb(134 203 60 / 0.75);
}

.active\\:border-moss-400\\/80:active{
  border-color: rgb(134 203 60 / 0.8);
}

.active\\:border-moss-400\\/85:active{
  border-color: rgb(134 203 60 / 0.85);
}

.active\\:border-moss-400\\/90:active{
  border-color: rgb(134 203 60 / 0.9);
}

.active\\:border-moss-400\\/95:active{
  border-color: rgb(134 203 60 / 0.95);
}

.active\\:border-moss-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(245 251 238 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-50\\/0:active{
  border-color: rgb(245 251 238 / 0);
}

.active\\:border-moss-50\\/10:active{
  border-color: rgb(245 251 238 / 0.1);
}

.active\\:border-moss-50\\/100:active{
  border-color: rgb(245 251 238 / 1);
}

.active\\:border-moss-50\\/15:active{
  border-color: rgb(245 251 238 / 0.15);
}

.active\\:border-moss-50\\/20:active{
  border-color: rgb(245 251 238 / 0.2);
}

.active\\:border-moss-50\\/25:active{
  border-color: rgb(245 251 238 / 0.25);
}

.active\\:border-moss-50\\/30:active{
  border-color: rgb(245 251 238 / 0.3);
}

.active\\:border-moss-50\\/35:active{
  border-color: rgb(245 251 238 / 0.35);
}

.active\\:border-moss-50\\/40:active{
  border-color: rgb(245 251 238 / 0.4);
}

.active\\:border-moss-50\\/45:active{
  border-color: rgb(245 251 238 / 0.45);
}

.active\\:border-moss-50\\/5:active{
  border-color: rgb(245 251 238 / 0.05);
}

.active\\:border-moss-50\\/50:active{
  border-color: rgb(245 251 238 / 0.5);
}

.active\\:border-moss-50\\/55:active{
  border-color: rgb(245 251 238 / 0.55);
}

.active\\:border-moss-50\\/60:active{
  border-color: rgb(245 251 238 / 0.6);
}

.active\\:border-moss-50\\/65:active{
  border-color: rgb(245 251 238 / 0.65);
}

.active\\:border-moss-50\\/70:active{
  border-color: rgb(245 251 238 / 0.7);
}

.active\\:border-moss-50\\/75:active{
  border-color: rgb(245 251 238 / 0.75);
}

.active\\:border-moss-50\\/80:active{
  border-color: rgb(245 251 238 / 0.8);
}

.active\\:border-moss-50\\/85:active{
  border-color: rgb(245 251 238 / 0.85);
}

.active\\:border-moss-50\\/90:active{
  border-color: rgb(245 251 238 / 0.9);
}

.active\\:border-moss-50\\/95:active{
  border-color: rgb(245 251 238 / 0.95);
}

.active\\:border-moss-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(102 159 42 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-500\\/0:active{
  border-color: rgb(102 159 42 / 0);
}

.active\\:border-moss-500\\/10:active{
  border-color: rgb(102 159 42 / 0.1);
}

.active\\:border-moss-500\\/100:active{
  border-color: rgb(102 159 42 / 1);
}

.active\\:border-moss-500\\/15:active{
  border-color: rgb(102 159 42 / 0.15);
}

.active\\:border-moss-500\\/20:active{
  border-color: rgb(102 159 42 / 0.2);
}

.active\\:border-moss-500\\/25:active{
  border-color: rgb(102 159 42 / 0.25);
}

.active\\:border-moss-500\\/30:active{
  border-color: rgb(102 159 42 / 0.3);
}

.active\\:border-moss-500\\/35:active{
  border-color: rgb(102 159 42 / 0.35);
}

.active\\:border-moss-500\\/40:active{
  border-color: rgb(102 159 42 / 0.4);
}

.active\\:border-moss-500\\/45:active{
  border-color: rgb(102 159 42 / 0.45);
}

.active\\:border-moss-500\\/5:active{
  border-color: rgb(102 159 42 / 0.05);
}

.active\\:border-moss-500\\/50:active{
  border-color: rgb(102 159 42 / 0.5);
}

.active\\:border-moss-500\\/55:active{
  border-color: rgb(102 159 42 / 0.55);
}

.active\\:border-moss-500\\/60:active{
  border-color: rgb(102 159 42 / 0.6);
}

.active\\:border-moss-500\\/65:active{
  border-color: rgb(102 159 42 / 0.65);
}

.active\\:border-moss-500\\/70:active{
  border-color: rgb(102 159 42 / 0.7);
}

.active\\:border-moss-500\\/75:active{
  border-color: rgb(102 159 42 / 0.75);
}

.active\\:border-moss-500\\/80:active{
  border-color: rgb(102 159 42 / 0.8);
}

.active\\:border-moss-500\\/85:active{
  border-color: rgb(102 159 42 / 0.85);
}

.active\\:border-moss-500\\/90:active{
  border-color: rgb(102 159 42 / 0.9);
}

.active\\:border-moss-500\\/95:active{
  border-color: rgb(102 159 42 / 0.95);
}

.active\\:border-moss-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(79 122 33 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-600\\/0:active{
  border-color: rgb(79 122 33 / 0);
}

.active\\:border-moss-600\\/10:active{
  border-color: rgb(79 122 33 / 0.1);
}

.active\\:border-moss-600\\/100:active{
  border-color: rgb(79 122 33 / 1);
}

.active\\:border-moss-600\\/15:active{
  border-color: rgb(79 122 33 / 0.15);
}

.active\\:border-moss-600\\/20:active{
  border-color: rgb(79 122 33 / 0.2);
}

.active\\:border-moss-600\\/25:active{
  border-color: rgb(79 122 33 / 0.25);
}

.active\\:border-moss-600\\/30:active{
  border-color: rgb(79 122 33 / 0.3);
}

.active\\:border-moss-600\\/35:active{
  border-color: rgb(79 122 33 / 0.35);
}

.active\\:border-moss-600\\/40:active{
  border-color: rgb(79 122 33 / 0.4);
}

.active\\:border-moss-600\\/45:active{
  border-color: rgb(79 122 33 / 0.45);
}

.active\\:border-moss-600\\/5:active{
  border-color: rgb(79 122 33 / 0.05);
}

.active\\:border-moss-600\\/50:active{
  border-color: rgb(79 122 33 / 0.5);
}

.active\\:border-moss-600\\/55:active{
  border-color: rgb(79 122 33 / 0.55);
}

.active\\:border-moss-600\\/60:active{
  border-color: rgb(79 122 33 / 0.6);
}

.active\\:border-moss-600\\/65:active{
  border-color: rgb(79 122 33 / 0.65);
}

.active\\:border-moss-600\\/70:active{
  border-color: rgb(79 122 33 / 0.7);
}

.active\\:border-moss-600\\/75:active{
  border-color: rgb(79 122 33 / 0.75);
}

.active\\:border-moss-600\\/80:active{
  border-color: rgb(79 122 33 / 0.8);
}

.active\\:border-moss-600\\/85:active{
  border-color: rgb(79 122 33 / 0.85);
}

.active\\:border-moss-600\\/90:active{
  border-color: rgb(79 122 33 / 0.9);
}

.active\\:border-moss-600\\/95:active{
  border-color: rgb(79 122 33 / 0.95);
}

.active\\:border-moss-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(63 98 26 / var(--tw-border-opacity, 1));
}

.active\\:border-moss-700\\/0:active{
  border-color: rgb(63 98 26 / 0);
}

.active\\:border-moss-700\\/10:active{
  border-color: rgb(63 98 26 / 0.1);
}

.active\\:border-moss-700\\/100:active{
  border-color: rgb(63 98 26 / 1);
}

.active\\:border-moss-700\\/15:active{
  border-color: rgb(63 98 26 / 0.15);
}

.active\\:border-moss-700\\/20:active{
  border-color: rgb(63 98 26 / 0.2);
}

.active\\:border-moss-700\\/25:active{
  border-color: rgb(63 98 26 / 0.25);
}

.active\\:border-moss-700\\/30:active{
  border-color: rgb(63 98 26 / 0.3);
}

.active\\:border-moss-700\\/35:active{
  border-color: rgb(63 98 26 / 0.35);
}

.active\\:border-moss-700\\/40:active{
  border-color: rgb(63 98 26 / 0.4);
}

.active\\:border-moss-700\\/45:active{
  border-color: rgb(63 98 26 / 0.45);
}

.active\\:border-moss-700\\/5:active{
  border-color: rgb(63 98 26 / 0.05);
}

.active\\:border-moss-700\\/50:active{
  border-color: rgb(63 98 26 / 0.5);
}

.active\\:border-moss-700\\/55:active{
  border-color: rgb(63 98 26 / 0.55);
}

.active\\:border-moss-700\\/60:active{
  border-color: rgb(63 98 26 / 0.6);
}

.active\\:border-moss-700\\/65:active{
  border-color: rgb(63 98 26 / 0.65);
}

.active\\:border-moss-700\\/70:active{
  border-color: rgb(63 98 26 / 0.7);
}

.active\\:border-moss-700\\/75:active{
  border-color: rgb(63 98 26 / 0.75);
}

.active\\:border-moss-700\\/80:active{
  border-color: rgb(63 98 26 / 0.8);
}

.active\\:border-moss-700\\/85:active{
  border-color: rgb(63 98 26 / 0.85);
}

.active\\:border-moss-700\\/90:active{
  border-color: rgb(63 98 26 / 0.9);
}

.active\\:border-moss-700\\/95:active{
  border-color: rgb(63 98 26 / 0.95);
}

.active\\:border-neutral-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-100\\/0:active{
  border-color: rgb(245 245 245 / 0);
}

.active\\:border-neutral-100\\/10:active{
  border-color: rgb(245 245 245 / 0.1);
}

.active\\:border-neutral-100\\/100:active{
  border-color: rgb(245 245 245 / 1);
}

.active\\:border-neutral-100\\/15:active{
  border-color: rgb(245 245 245 / 0.15);
}

.active\\:border-neutral-100\\/20:active{
  border-color: rgb(245 245 245 / 0.2);
}

.active\\:border-neutral-100\\/25:active{
  border-color: rgb(245 245 245 / 0.25);
}

.active\\:border-neutral-100\\/30:active{
  border-color: rgb(245 245 245 / 0.3);
}

.active\\:border-neutral-100\\/35:active{
  border-color: rgb(245 245 245 / 0.35);
}

.active\\:border-neutral-100\\/40:active{
  border-color: rgb(245 245 245 / 0.4);
}

.active\\:border-neutral-100\\/45:active{
  border-color: rgb(245 245 245 / 0.45);
}

.active\\:border-neutral-100\\/5:active{
  border-color: rgb(245 245 245 / 0.05);
}

.active\\:border-neutral-100\\/50:active{
  border-color: rgb(245 245 245 / 0.5);
}

.active\\:border-neutral-100\\/55:active{
  border-color: rgb(245 245 245 / 0.55);
}

.active\\:border-neutral-100\\/60:active{
  border-color: rgb(245 245 245 / 0.6);
}

.active\\:border-neutral-100\\/65:active{
  border-color: rgb(245 245 245 / 0.65);
}

.active\\:border-neutral-100\\/70:active{
  border-color: rgb(245 245 245 / 0.7);
}

.active\\:border-neutral-100\\/75:active{
  border-color: rgb(245 245 245 / 0.75);
}

.active\\:border-neutral-100\\/80:active{
  border-color: rgb(245 245 245 / 0.8);
}

.active\\:border-neutral-100\\/85:active{
  border-color: rgb(245 245 245 / 0.85);
}

.active\\:border-neutral-100\\/90:active{
  border-color: rgb(245 245 245 / 0.9);
}

.active\\:border-neutral-100\\/95:active{
  border-color: rgb(245 245 245 / 0.95);
}

.active\\:border-neutral-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-200\\/0:active{
  border-color: rgb(233 234 235 / 0);
}

.active\\:border-neutral-200\\/10:active{
  border-color: rgb(233 234 235 / 0.1);
}

.active\\:border-neutral-200\\/100:active{
  border-color: rgb(233 234 235 / 1);
}

.active\\:border-neutral-200\\/15:active{
  border-color: rgb(233 234 235 / 0.15);
}

.active\\:border-neutral-200\\/20:active{
  border-color: rgb(233 234 235 / 0.2);
}

.active\\:border-neutral-200\\/25:active{
  border-color: rgb(233 234 235 / 0.25);
}

.active\\:border-neutral-200\\/30:active{
  border-color: rgb(233 234 235 / 0.3);
}

.active\\:border-neutral-200\\/35:active{
  border-color: rgb(233 234 235 / 0.35);
}

.active\\:border-neutral-200\\/40:active{
  border-color: rgb(233 234 235 / 0.4);
}

.active\\:border-neutral-200\\/45:active{
  border-color: rgb(233 234 235 / 0.45);
}

.active\\:border-neutral-200\\/5:active{
  border-color: rgb(233 234 235 / 0.05);
}

.active\\:border-neutral-200\\/50:active{
  border-color: rgb(233 234 235 / 0.5);
}

.active\\:border-neutral-200\\/55:active{
  border-color: rgb(233 234 235 / 0.55);
}

.active\\:border-neutral-200\\/60:active{
  border-color: rgb(233 234 235 / 0.6);
}

.active\\:border-neutral-200\\/65:active{
  border-color: rgb(233 234 235 / 0.65);
}

.active\\:border-neutral-200\\/70:active{
  border-color: rgb(233 234 235 / 0.7);
}

.active\\:border-neutral-200\\/75:active{
  border-color: rgb(233 234 235 / 0.75);
}

.active\\:border-neutral-200\\/80:active{
  border-color: rgb(233 234 235 / 0.8);
}

.active\\:border-neutral-200\\/85:active{
  border-color: rgb(233 234 235 / 0.85);
}

.active\\:border-neutral-200\\/90:active{
  border-color: rgb(233 234 235 / 0.9);
}

.active\\:border-neutral-200\\/95:active{
  border-color: rgb(233 234 235 / 0.95);
}

.active\\:border-neutral-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-25\\/0:active{
  border-color: rgb(253 253 253 / 0);
}

.active\\:border-neutral-25\\/10:active{
  border-color: rgb(253 253 253 / 0.1);
}

.active\\:border-neutral-25\\/100:active{
  border-color: rgb(253 253 253 / 1);
}

.active\\:border-neutral-25\\/15:active{
  border-color: rgb(253 253 253 / 0.15);
}

.active\\:border-neutral-25\\/20:active{
  border-color: rgb(253 253 253 / 0.2);
}

.active\\:border-neutral-25\\/25:active{
  border-color: rgb(253 253 253 / 0.25);
}

.active\\:border-neutral-25\\/30:active{
  border-color: rgb(253 253 253 / 0.3);
}

.active\\:border-neutral-25\\/35:active{
  border-color: rgb(253 253 253 / 0.35);
}

.active\\:border-neutral-25\\/40:active{
  border-color: rgb(253 253 253 / 0.4);
}

.active\\:border-neutral-25\\/45:active{
  border-color: rgb(253 253 253 / 0.45);
}

.active\\:border-neutral-25\\/5:active{
  border-color: rgb(253 253 253 / 0.05);
}

.active\\:border-neutral-25\\/50:active{
  border-color: rgb(253 253 253 / 0.5);
}

.active\\:border-neutral-25\\/55:active{
  border-color: rgb(253 253 253 / 0.55);
}

.active\\:border-neutral-25\\/60:active{
  border-color: rgb(253 253 253 / 0.6);
}

.active\\:border-neutral-25\\/65:active{
  border-color: rgb(253 253 253 / 0.65);
}

.active\\:border-neutral-25\\/70:active{
  border-color: rgb(253 253 253 / 0.7);
}

.active\\:border-neutral-25\\/75:active{
  border-color: rgb(253 253 253 / 0.75);
}

.active\\:border-neutral-25\\/80:active{
  border-color: rgb(253 253 253 / 0.8);
}

.active\\:border-neutral-25\\/85:active{
  border-color: rgb(253 253 253 / 0.85);
}

.active\\:border-neutral-25\\/90:active{
  border-color: rgb(253 253 253 / 0.9);
}

.active\\:border-neutral-25\\/95:active{
  border-color: rgb(253 253 253 / 0.95);
}

.active\\:border-neutral-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-400\\/0:active{
  border-color: rgb(164 167 174 / 0);
}

.active\\:border-neutral-400\\/10:active{
  border-color: rgb(164 167 174 / 0.1);
}

.active\\:border-neutral-400\\/100:active{
  border-color: rgb(164 167 174 / 1);
}

.active\\:border-neutral-400\\/15:active{
  border-color: rgb(164 167 174 / 0.15);
}

.active\\:border-neutral-400\\/20:active{
  border-color: rgb(164 167 174 / 0.2);
}

.active\\:border-neutral-400\\/25:active{
  border-color: rgb(164 167 174 / 0.25);
}

.active\\:border-neutral-400\\/30:active{
  border-color: rgb(164 167 174 / 0.3);
}

.active\\:border-neutral-400\\/35:active{
  border-color: rgb(164 167 174 / 0.35);
}

.active\\:border-neutral-400\\/40:active{
  border-color: rgb(164 167 174 / 0.4);
}

.active\\:border-neutral-400\\/45:active{
  border-color: rgb(164 167 174 / 0.45);
}

.active\\:border-neutral-400\\/5:active{
  border-color: rgb(164 167 174 / 0.05);
}

.active\\:border-neutral-400\\/50:active{
  border-color: rgb(164 167 174 / 0.5);
}

.active\\:border-neutral-400\\/55:active{
  border-color: rgb(164 167 174 / 0.55);
}

.active\\:border-neutral-400\\/60:active{
  border-color: rgb(164 167 174 / 0.6);
}

.active\\:border-neutral-400\\/65:active{
  border-color: rgb(164 167 174 / 0.65);
}

.active\\:border-neutral-400\\/70:active{
  border-color: rgb(164 167 174 / 0.7);
}

.active\\:border-neutral-400\\/75:active{
  border-color: rgb(164 167 174 / 0.75);
}

.active\\:border-neutral-400\\/80:active{
  border-color: rgb(164 167 174 / 0.8);
}

.active\\:border-neutral-400\\/85:active{
  border-color: rgb(164 167 174 / 0.85);
}

.active\\:border-neutral-400\\/90:active{
  border-color: rgb(164 167 174 / 0.9);
}

.active\\:border-neutral-400\\/95:active{
  border-color: rgb(164 167 174 / 0.95);
}

.active\\:border-neutral-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 250 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-50\\/0:active{
  border-color: rgb(249 250 250 / 0);
}

.active\\:border-neutral-50\\/10:active{
  border-color: rgb(249 250 250 / 0.1);
}

.active\\:border-neutral-50\\/100:active{
  border-color: rgb(249 250 250 / 1);
}

.active\\:border-neutral-50\\/15:active{
  border-color: rgb(249 250 250 / 0.15);
}

.active\\:border-neutral-50\\/20:active{
  border-color: rgb(249 250 250 / 0.2);
}

.active\\:border-neutral-50\\/25:active{
  border-color: rgb(249 250 250 / 0.25);
}

.active\\:border-neutral-50\\/30:active{
  border-color: rgb(249 250 250 / 0.3);
}

.active\\:border-neutral-50\\/35:active{
  border-color: rgb(249 250 250 / 0.35);
}

.active\\:border-neutral-50\\/40:active{
  border-color: rgb(249 250 250 / 0.4);
}

.active\\:border-neutral-50\\/45:active{
  border-color: rgb(249 250 250 / 0.45);
}

.active\\:border-neutral-50\\/5:active{
  border-color: rgb(249 250 250 / 0.05);
}

.active\\:border-neutral-50\\/50:active{
  border-color: rgb(249 250 250 / 0.5);
}

.active\\:border-neutral-50\\/55:active{
  border-color: rgb(249 250 250 / 0.55);
}

.active\\:border-neutral-50\\/60:active{
  border-color: rgb(249 250 250 / 0.6);
}

.active\\:border-neutral-50\\/65:active{
  border-color: rgb(249 250 250 / 0.65);
}

.active\\:border-neutral-50\\/70:active{
  border-color: rgb(249 250 250 / 0.7);
}

.active\\:border-neutral-50\\/75:active{
  border-color: rgb(249 250 250 / 0.75);
}

.active\\:border-neutral-50\\/80:active{
  border-color: rgb(249 250 250 / 0.8);
}

.active\\:border-neutral-50\\/85:active{
  border-color: rgb(249 250 250 / 0.85);
}

.active\\:border-neutral-50\\/90:active{
  border-color: rgb(249 250 250 / 0.9);
}

.active\\:border-neutral-50\\/95:active{
  border-color: rgb(249 250 250 / 0.95);
}

.active\\:border-neutral-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-500\\/0:active{
  border-color: rgb(113 118 128 / 0);
}

.active\\:border-neutral-500\\/10:active{
  border-color: rgb(113 118 128 / 0.1);
}

.active\\:border-neutral-500\\/100:active{
  border-color: rgb(113 118 128 / 1);
}

.active\\:border-neutral-500\\/15:active{
  border-color: rgb(113 118 128 / 0.15);
}

.active\\:border-neutral-500\\/20:active{
  border-color: rgb(113 118 128 / 0.2);
}

.active\\:border-neutral-500\\/25:active{
  border-color: rgb(113 118 128 / 0.25);
}

.active\\:border-neutral-500\\/30:active{
  border-color: rgb(113 118 128 / 0.3);
}

.active\\:border-neutral-500\\/35:active{
  border-color: rgb(113 118 128 / 0.35);
}

.active\\:border-neutral-500\\/40:active{
  border-color: rgb(113 118 128 / 0.4);
}

.active\\:border-neutral-500\\/45:active{
  border-color: rgb(113 118 128 / 0.45);
}

.active\\:border-neutral-500\\/5:active{
  border-color: rgb(113 118 128 / 0.05);
}

.active\\:border-neutral-500\\/50:active{
  border-color: rgb(113 118 128 / 0.5);
}

.active\\:border-neutral-500\\/55:active{
  border-color: rgb(113 118 128 / 0.55);
}

.active\\:border-neutral-500\\/60:active{
  border-color: rgb(113 118 128 / 0.6);
}

.active\\:border-neutral-500\\/65:active{
  border-color: rgb(113 118 128 / 0.65);
}

.active\\:border-neutral-500\\/70:active{
  border-color: rgb(113 118 128 / 0.7);
}

.active\\:border-neutral-500\\/75:active{
  border-color: rgb(113 118 128 / 0.75);
}

.active\\:border-neutral-500\\/80:active{
  border-color: rgb(113 118 128 / 0.8);
}

.active\\:border-neutral-500\\/85:active{
  border-color: rgb(113 118 128 / 0.85);
}

.active\\:border-neutral-500\\/90:active{
  border-color: rgb(113 118 128 / 0.9);
}

.active\\:border-neutral-500\\/95:active{
  border-color: rgb(113 118 128 / 0.95);
}

.active\\:border-neutral-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-600\\/0:active{
  border-color: rgb(83 88 98 / 0);
}

.active\\:border-neutral-600\\/10:active{
  border-color: rgb(83 88 98 / 0.1);
}

.active\\:border-neutral-600\\/100:active{
  border-color: rgb(83 88 98 / 1);
}

.active\\:border-neutral-600\\/15:active{
  border-color: rgb(83 88 98 / 0.15);
}

.active\\:border-neutral-600\\/20:active{
  border-color: rgb(83 88 98 / 0.2);
}

.active\\:border-neutral-600\\/25:active{
  border-color: rgb(83 88 98 / 0.25);
}

.active\\:border-neutral-600\\/30:active{
  border-color: rgb(83 88 98 / 0.3);
}

.active\\:border-neutral-600\\/35:active{
  border-color: rgb(83 88 98 / 0.35);
}

.active\\:border-neutral-600\\/40:active{
  border-color: rgb(83 88 98 / 0.4);
}

.active\\:border-neutral-600\\/45:active{
  border-color: rgb(83 88 98 / 0.45);
}

.active\\:border-neutral-600\\/5:active{
  border-color: rgb(83 88 98 / 0.05);
}

.active\\:border-neutral-600\\/50:active{
  border-color: rgb(83 88 98 / 0.5);
}

.active\\:border-neutral-600\\/55:active{
  border-color: rgb(83 88 98 / 0.55);
}

.active\\:border-neutral-600\\/60:active{
  border-color: rgb(83 88 98 / 0.6);
}

.active\\:border-neutral-600\\/65:active{
  border-color: rgb(83 88 98 / 0.65);
}

.active\\:border-neutral-600\\/70:active{
  border-color: rgb(83 88 98 / 0.7);
}

.active\\:border-neutral-600\\/75:active{
  border-color: rgb(83 88 98 / 0.75);
}

.active\\:border-neutral-600\\/80:active{
  border-color: rgb(83 88 98 / 0.8);
}

.active\\:border-neutral-600\\/85:active{
  border-color: rgb(83 88 98 / 0.85);
}

.active\\:border-neutral-600\\/90:active{
  border-color: rgb(83 88 98 / 0.9);
}

.active\\:border-neutral-600\\/95:active{
  border-color: rgb(83 88 98 / 0.95);
}

.active\\:border-neutral-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(65 70 81 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-700\\/0:active{
  border-color: rgb(65 70 81 / 0);
}

.active\\:border-neutral-700\\/10:active{
  border-color: rgb(65 70 81 / 0.1);
}

.active\\:border-neutral-700\\/100:active{
  border-color: rgb(65 70 81 / 1);
}

.active\\:border-neutral-700\\/15:active{
  border-color: rgb(65 70 81 / 0.15);
}

.active\\:border-neutral-700\\/20:active{
  border-color: rgb(65 70 81 / 0.2);
}

.active\\:border-neutral-700\\/25:active{
  border-color: rgb(65 70 81 / 0.25);
}

.active\\:border-neutral-700\\/30:active{
  border-color: rgb(65 70 81 / 0.3);
}

.active\\:border-neutral-700\\/35:active{
  border-color: rgb(65 70 81 / 0.35);
}

.active\\:border-neutral-700\\/40:active{
  border-color: rgb(65 70 81 / 0.4);
}

.active\\:border-neutral-700\\/45:active{
  border-color: rgb(65 70 81 / 0.45);
}

.active\\:border-neutral-700\\/5:active{
  border-color: rgb(65 70 81 / 0.05);
}

.active\\:border-neutral-700\\/50:active{
  border-color: rgb(65 70 81 / 0.5);
}

.active\\:border-neutral-700\\/55:active{
  border-color: rgb(65 70 81 / 0.55);
}

.active\\:border-neutral-700\\/60:active{
  border-color: rgb(65 70 81 / 0.6);
}

.active\\:border-neutral-700\\/65:active{
  border-color: rgb(65 70 81 / 0.65);
}

.active\\:border-neutral-700\\/70:active{
  border-color: rgb(65 70 81 / 0.7);
}

.active\\:border-neutral-700\\/75:active{
  border-color: rgb(65 70 81 / 0.75);
}

.active\\:border-neutral-700\\/80:active{
  border-color: rgb(65 70 81 / 0.8);
}

.active\\:border-neutral-700\\/85:active{
  border-color: rgb(65 70 81 / 0.85);
}

.active\\:border-neutral-700\\/90:active{
  border-color: rgb(65 70 81 / 0.9);
}

.active\\:border-neutral-700\\/95:active{
  border-color: rgb(65 70 81 / 0.95);
}

.active\\:border-neutral-75:active{
  --tw-border-opacity: 1;
  border-color: rgb(246 246 246 / var(--tw-border-opacity, 1));
}

.active\\:border-neutral-75\\/0:active{
  border-color: rgb(246 246 246 / 0);
}

.active\\:border-neutral-75\\/10:active{
  border-color: rgb(246 246 246 / 0.1);
}

.active\\:border-neutral-75\\/100:active{
  border-color: rgb(246 246 246 / 1);
}

.active\\:border-neutral-75\\/15:active{
  border-color: rgb(246 246 246 / 0.15);
}

.active\\:border-neutral-75\\/20:active{
  border-color: rgb(246 246 246 / 0.2);
}

.active\\:border-neutral-75\\/25:active{
  border-color: rgb(246 246 246 / 0.25);
}

.active\\:border-neutral-75\\/30:active{
  border-color: rgb(246 246 246 / 0.3);
}

.active\\:border-neutral-75\\/35:active{
  border-color: rgb(246 246 246 / 0.35);
}

.active\\:border-neutral-75\\/40:active{
  border-color: rgb(246 246 246 / 0.4);
}

.active\\:border-neutral-75\\/45:active{
  border-color: rgb(246 246 246 / 0.45);
}

.active\\:border-neutral-75\\/5:active{
  border-color: rgb(246 246 246 / 0.05);
}

.active\\:border-neutral-75\\/50:active{
  border-color: rgb(246 246 246 / 0.5);
}

.active\\:border-neutral-75\\/55:active{
  border-color: rgb(246 246 246 / 0.55);
}

.active\\:border-neutral-75\\/60:active{
  border-color: rgb(246 246 246 / 0.6);
}

.active\\:border-neutral-75\\/65:active{
  border-color: rgb(246 246 246 / 0.65);
}

.active\\:border-neutral-75\\/70:active{
  border-color: rgb(246 246 246 / 0.7);
}

.active\\:border-neutral-75\\/75:active{
  border-color: rgb(246 246 246 / 0.75);
}

.active\\:border-neutral-75\\/80:active{
  border-color: rgb(246 246 246 / 0.8);
}

.active\\:border-neutral-75\\/85:active{
  border-color: rgb(246 246 246 / 0.85);
}

.active\\:border-neutral-75\\/90:active{
  border-color: rgb(246 246 246 / 0.9);
}

.active\\:border-neutral-75\\/95:active{
  border-color: rgb(246 246 246 / 0.95);
}

.active\\:border-primary-100:active{
  border-color: var(--color-primary-100, #E0F2FE);
}

.active\\:border-primary-200:active{
  border-color: var(--color-primary-200, #B9E6FE);
}

.active\\:border-primary-25:active{
  border-color: var(--color-primary-25, #F5FBFF);
}

.active\\:border-primary-400:active{
  border-color: var(--color-primary-400, #36BFFA);
}

.active\\:border-primary-50:active{
  border-color: var(--color-primary-50, #F0F9FF);
}

.active\\:border-primary-500:active{
  border-color: var(--color-primary-500, #0BA5EC);
}

.active\\:border-primary-600:active{
  border-color: var(--color-primary-600, #0086C9);
}

.active\\:border-primary-700:active{
  border-color: var(--color-primary-700, #026AA2);
}

.active\\:border-purple-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(235 233 254 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-100\\/0:active{
  border-color: rgb(235 233 254 / 0);
}

.active\\:border-purple-100\\/10:active{
  border-color: rgb(235 233 254 / 0.1);
}

.active\\:border-purple-100\\/100:active{
  border-color: rgb(235 233 254 / 1);
}

.active\\:border-purple-100\\/15:active{
  border-color: rgb(235 233 254 / 0.15);
}

.active\\:border-purple-100\\/20:active{
  border-color: rgb(235 233 254 / 0.2);
}

.active\\:border-purple-100\\/25:active{
  border-color: rgb(235 233 254 / 0.25);
}

.active\\:border-purple-100\\/30:active{
  border-color: rgb(235 233 254 / 0.3);
}

.active\\:border-purple-100\\/35:active{
  border-color: rgb(235 233 254 / 0.35);
}

.active\\:border-purple-100\\/40:active{
  border-color: rgb(235 233 254 / 0.4);
}

.active\\:border-purple-100\\/45:active{
  border-color: rgb(235 233 254 / 0.45);
}

.active\\:border-purple-100\\/5:active{
  border-color: rgb(235 233 254 / 0.05);
}

.active\\:border-purple-100\\/50:active{
  border-color: rgb(235 233 254 / 0.5);
}

.active\\:border-purple-100\\/55:active{
  border-color: rgb(235 233 254 / 0.55);
}

.active\\:border-purple-100\\/60:active{
  border-color: rgb(235 233 254 / 0.6);
}

.active\\:border-purple-100\\/65:active{
  border-color: rgb(235 233 254 / 0.65);
}

.active\\:border-purple-100\\/70:active{
  border-color: rgb(235 233 254 / 0.7);
}

.active\\:border-purple-100\\/75:active{
  border-color: rgb(235 233 254 / 0.75);
}

.active\\:border-purple-100\\/80:active{
  border-color: rgb(235 233 254 / 0.8);
}

.active\\:border-purple-100\\/85:active{
  border-color: rgb(235 233 254 / 0.85);
}

.active\\:border-purple-100\\/90:active{
  border-color: rgb(235 233 254 / 0.9);
}

.active\\:border-purple-100\\/95:active{
  border-color: rgb(235 233 254 / 0.95);
}

.active\\:border-purple-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(217 214 254 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-200\\/0:active{
  border-color: rgb(217 214 254 / 0);
}

.active\\:border-purple-200\\/10:active{
  border-color: rgb(217 214 254 / 0.1);
}

.active\\:border-purple-200\\/100:active{
  border-color: rgb(217 214 254 / 1);
}

.active\\:border-purple-200\\/15:active{
  border-color: rgb(217 214 254 / 0.15);
}

.active\\:border-purple-200\\/20:active{
  border-color: rgb(217 214 254 / 0.2);
}

.active\\:border-purple-200\\/25:active{
  border-color: rgb(217 214 254 / 0.25);
}

.active\\:border-purple-200\\/30:active{
  border-color: rgb(217 214 254 / 0.3);
}

.active\\:border-purple-200\\/35:active{
  border-color: rgb(217 214 254 / 0.35);
}

.active\\:border-purple-200\\/40:active{
  border-color: rgb(217 214 254 / 0.4);
}

.active\\:border-purple-200\\/45:active{
  border-color: rgb(217 214 254 / 0.45);
}

.active\\:border-purple-200\\/5:active{
  border-color: rgb(217 214 254 / 0.05);
}

.active\\:border-purple-200\\/50:active{
  border-color: rgb(217 214 254 / 0.5);
}

.active\\:border-purple-200\\/55:active{
  border-color: rgb(217 214 254 / 0.55);
}

.active\\:border-purple-200\\/60:active{
  border-color: rgb(217 214 254 / 0.6);
}

.active\\:border-purple-200\\/65:active{
  border-color: rgb(217 214 254 / 0.65);
}

.active\\:border-purple-200\\/70:active{
  border-color: rgb(217 214 254 / 0.7);
}

.active\\:border-purple-200\\/75:active{
  border-color: rgb(217 214 254 / 0.75);
}

.active\\:border-purple-200\\/80:active{
  border-color: rgb(217 214 254 / 0.8);
}

.active\\:border-purple-200\\/85:active{
  border-color: rgb(217 214 254 / 0.85);
}

.active\\:border-purple-200\\/90:active{
  border-color: rgb(217 214 254 / 0.9);
}

.active\\:border-purple-200\\/95:active{
  border-color: rgb(217 214 254 / 0.95);
}

.active\\:border-purple-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 255 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-25\\/0:active{
  border-color: rgb(250 250 255 / 0);
}

.active\\:border-purple-25\\/10:active{
  border-color: rgb(250 250 255 / 0.1);
}

.active\\:border-purple-25\\/100:active{
  border-color: rgb(250 250 255 / 1);
}

.active\\:border-purple-25\\/15:active{
  border-color: rgb(250 250 255 / 0.15);
}

.active\\:border-purple-25\\/20:active{
  border-color: rgb(250 250 255 / 0.2);
}

.active\\:border-purple-25\\/25:active{
  border-color: rgb(250 250 255 / 0.25);
}

.active\\:border-purple-25\\/30:active{
  border-color: rgb(250 250 255 / 0.3);
}

.active\\:border-purple-25\\/35:active{
  border-color: rgb(250 250 255 / 0.35);
}

.active\\:border-purple-25\\/40:active{
  border-color: rgb(250 250 255 / 0.4);
}

.active\\:border-purple-25\\/45:active{
  border-color: rgb(250 250 255 / 0.45);
}

.active\\:border-purple-25\\/5:active{
  border-color: rgb(250 250 255 / 0.05);
}

.active\\:border-purple-25\\/50:active{
  border-color: rgb(250 250 255 / 0.5);
}

.active\\:border-purple-25\\/55:active{
  border-color: rgb(250 250 255 / 0.55);
}

.active\\:border-purple-25\\/60:active{
  border-color: rgb(250 250 255 / 0.6);
}

.active\\:border-purple-25\\/65:active{
  border-color: rgb(250 250 255 / 0.65);
}

.active\\:border-purple-25\\/70:active{
  border-color: rgb(250 250 255 / 0.7);
}

.active\\:border-purple-25\\/75:active{
  border-color: rgb(250 250 255 / 0.75);
}

.active\\:border-purple-25\\/80:active{
  border-color: rgb(250 250 255 / 0.8);
}

.active\\:border-purple-25\\/85:active{
  border-color: rgb(250 250 255 / 0.85);
}

.active\\:border-purple-25\\/90:active{
  border-color: rgb(250 250 255 / 0.9);
}

.active\\:border-purple-25\\/95:active{
  border-color: rgb(250 250 255 / 0.95);
}

.active\\:border-purple-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(155 138 251 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-400\\/0:active{
  border-color: rgb(155 138 251 / 0);
}

.active\\:border-purple-400\\/10:active{
  border-color: rgb(155 138 251 / 0.1);
}

.active\\:border-purple-400\\/100:active{
  border-color: rgb(155 138 251 / 1);
}

.active\\:border-purple-400\\/15:active{
  border-color: rgb(155 138 251 / 0.15);
}

.active\\:border-purple-400\\/20:active{
  border-color: rgb(155 138 251 / 0.2);
}

.active\\:border-purple-400\\/25:active{
  border-color: rgb(155 138 251 / 0.25);
}

.active\\:border-purple-400\\/30:active{
  border-color: rgb(155 138 251 / 0.3);
}

.active\\:border-purple-400\\/35:active{
  border-color: rgb(155 138 251 / 0.35);
}

.active\\:border-purple-400\\/40:active{
  border-color: rgb(155 138 251 / 0.4);
}

.active\\:border-purple-400\\/45:active{
  border-color: rgb(155 138 251 / 0.45);
}

.active\\:border-purple-400\\/5:active{
  border-color: rgb(155 138 251 / 0.05);
}

.active\\:border-purple-400\\/50:active{
  border-color: rgb(155 138 251 / 0.5);
}

.active\\:border-purple-400\\/55:active{
  border-color: rgb(155 138 251 / 0.55);
}

.active\\:border-purple-400\\/60:active{
  border-color: rgb(155 138 251 / 0.6);
}

.active\\:border-purple-400\\/65:active{
  border-color: rgb(155 138 251 / 0.65);
}

.active\\:border-purple-400\\/70:active{
  border-color: rgb(155 138 251 / 0.7);
}

.active\\:border-purple-400\\/75:active{
  border-color: rgb(155 138 251 / 0.75);
}

.active\\:border-purple-400\\/80:active{
  border-color: rgb(155 138 251 / 0.8);
}

.active\\:border-purple-400\\/85:active{
  border-color: rgb(155 138 251 / 0.85);
}

.active\\:border-purple-400\\/90:active{
  border-color: rgb(155 138 251 / 0.9);
}

.active\\:border-purple-400\\/95:active{
  border-color: rgb(155 138 251 / 0.95);
}

.active\\:border-purple-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(244 243 255 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-50\\/0:active{
  border-color: rgb(244 243 255 / 0);
}

.active\\:border-purple-50\\/10:active{
  border-color: rgb(244 243 255 / 0.1);
}

.active\\:border-purple-50\\/100:active{
  border-color: rgb(244 243 255 / 1);
}

.active\\:border-purple-50\\/15:active{
  border-color: rgb(244 243 255 / 0.15);
}

.active\\:border-purple-50\\/20:active{
  border-color: rgb(244 243 255 / 0.2);
}

.active\\:border-purple-50\\/25:active{
  border-color: rgb(244 243 255 / 0.25);
}

.active\\:border-purple-50\\/30:active{
  border-color: rgb(244 243 255 / 0.3);
}

.active\\:border-purple-50\\/35:active{
  border-color: rgb(244 243 255 / 0.35);
}

.active\\:border-purple-50\\/40:active{
  border-color: rgb(244 243 255 / 0.4);
}

.active\\:border-purple-50\\/45:active{
  border-color: rgb(244 243 255 / 0.45);
}

.active\\:border-purple-50\\/5:active{
  border-color: rgb(244 243 255 / 0.05);
}

.active\\:border-purple-50\\/50:active{
  border-color: rgb(244 243 255 / 0.5);
}

.active\\:border-purple-50\\/55:active{
  border-color: rgb(244 243 255 / 0.55);
}

.active\\:border-purple-50\\/60:active{
  border-color: rgb(244 243 255 / 0.6);
}

.active\\:border-purple-50\\/65:active{
  border-color: rgb(244 243 255 / 0.65);
}

.active\\:border-purple-50\\/70:active{
  border-color: rgb(244 243 255 / 0.7);
}

.active\\:border-purple-50\\/75:active{
  border-color: rgb(244 243 255 / 0.75);
}

.active\\:border-purple-50\\/80:active{
  border-color: rgb(244 243 255 / 0.8);
}

.active\\:border-purple-50\\/85:active{
  border-color: rgb(244 243 255 / 0.85);
}

.active\\:border-purple-50\\/90:active{
  border-color: rgb(244 243 255 / 0.9);
}

.active\\:border-purple-50\\/95:active{
  border-color: rgb(244 243 255 / 0.95);
}

.active\\:border-purple-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(122 90 248 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-500\\/0:active{
  border-color: rgb(122 90 248 / 0);
}

.active\\:border-purple-500\\/10:active{
  border-color: rgb(122 90 248 / 0.1);
}

.active\\:border-purple-500\\/100:active{
  border-color: rgb(122 90 248 / 1);
}

.active\\:border-purple-500\\/15:active{
  border-color: rgb(122 90 248 / 0.15);
}

.active\\:border-purple-500\\/20:active{
  border-color: rgb(122 90 248 / 0.2);
}

.active\\:border-purple-500\\/25:active{
  border-color: rgb(122 90 248 / 0.25);
}

.active\\:border-purple-500\\/30:active{
  border-color: rgb(122 90 248 / 0.3);
}

.active\\:border-purple-500\\/35:active{
  border-color: rgb(122 90 248 / 0.35);
}

.active\\:border-purple-500\\/40:active{
  border-color: rgb(122 90 248 / 0.4);
}

.active\\:border-purple-500\\/45:active{
  border-color: rgb(122 90 248 / 0.45);
}

.active\\:border-purple-500\\/5:active{
  border-color: rgb(122 90 248 / 0.05);
}

.active\\:border-purple-500\\/50:active{
  border-color: rgb(122 90 248 / 0.5);
}

.active\\:border-purple-500\\/55:active{
  border-color: rgb(122 90 248 / 0.55);
}

.active\\:border-purple-500\\/60:active{
  border-color: rgb(122 90 248 / 0.6);
}

.active\\:border-purple-500\\/65:active{
  border-color: rgb(122 90 248 / 0.65);
}

.active\\:border-purple-500\\/70:active{
  border-color: rgb(122 90 248 / 0.7);
}

.active\\:border-purple-500\\/75:active{
  border-color: rgb(122 90 248 / 0.75);
}

.active\\:border-purple-500\\/80:active{
  border-color: rgb(122 90 248 / 0.8);
}

.active\\:border-purple-500\\/85:active{
  border-color: rgb(122 90 248 / 0.85);
}

.active\\:border-purple-500\\/90:active{
  border-color: rgb(122 90 248 / 0.9);
}

.active\\:border-purple-500\\/95:active{
  border-color: rgb(122 90 248 / 0.95);
}

.active\\:border-purple-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(105 56 239 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-600\\/0:active{
  border-color: rgb(105 56 239 / 0);
}

.active\\:border-purple-600\\/10:active{
  border-color: rgb(105 56 239 / 0.1);
}

.active\\:border-purple-600\\/100:active{
  border-color: rgb(105 56 239 / 1);
}

.active\\:border-purple-600\\/15:active{
  border-color: rgb(105 56 239 / 0.15);
}

.active\\:border-purple-600\\/20:active{
  border-color: rgb(105 56 239 / 0.2);
}

.active\\:border-purple-600\\/25:active{
  border-color: rgb(105 56 239 / 0.25);
}

.active\\:border-purple-600\\/30:active{
  border-color: rgb(105 56 239 / 0.3);
}

.active\\:border-purple-600\\/35:active{
  border-color: rgb(105 56 239 / 0.35);
}

.active\\:border-purple-600\\/40:active{
  border-color: rgb(105 56 239 / 0.4);
}

.active\\:border-purple-600\\/45:active{
  border-color: rgb(105 56 239 / 0.45);
}

.active\\:border-purple-600\\/5:active{
  border-color: rgb(105 56 239 / 0.05);
}

.active\\:border-purple-600\\/50:active{
  border-color: rgb(105 56 239 / 0.5);
}

.active\\:border-purple-600\\/55:active{
  border-color: rgb(105 56 239 / 0.55);
}

.active\\:border-purple-600\\/60:active{
  border-color: rgb(105 56 239 / 0.6);
}

.active\\:border-purple-600\\/65:active{
  border-color: rgb(105 56 239 / 0.65);
}

.active\\:border-purple-600\\/70:active{
  border-color: rgb(105 56 239 / 0.7);
}

.active\\:border-purple-600\\/75:active{
  border-color: rgb(105 56 239 / 0.75);
}

.active\\:border-purple-600\\/80:active{
  border-color: rgb(105 56 239 / 0.8);
}

.active\\:border-purple-600\\/85:active{
  border-color: rgb(105 56 239 / 0.85);
}

.active\\:border-purple-600\\/90:active{
  border-color: rgb(105 56 239 / 0.9);
}

.active\\:border-purple-600\\/95:active{
  border-color: rgb(105 56 239 / 0.95);
}

.active\\:border-purple-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(89 37 220 / var(--tw-border-opacity, 1));
}

.active\\:border-purple-700\\/0:active{
  border-color: rgb(89 37 220 / 0);
}

.active\\:border-purple-700\\/10:active{
  border-color: rgb(89 37 220 / 0.1);
}

.active\\:border-purple-700\\/100:active{
  border-color: rgb(89 37 220 / 1);
}

.active\\:border-purple-700\\/15:active{
  border-color: rgb(89 37 220 / 0.15);
}

.active\\:border-purple-700\\/20:active{
  border-color: rgb(89 37 220 / 0.2);
}

.active\\:border-purple-700\\/25:active{
  border-color: rgb(89 37 220 / 0.25);
}

.active\\:border-purple-700\\/30:active{
  border-color: rgb(89 37 220 / 0.3);
}

.active\\:border-purple-700\\/35:active{
  border-color: rgb(89 37 220 / 0.35);
}

.active\\:border-purple-700\\/40:active{
  border-color: rgb(89 37 220 / 0.4);
}

.active\\:border-purple-700\\/45:active{
  border-color: rgb(89 37 220 / 0.45);
}

.active\\:border-purple-700\\/5:active{
  border-color: rgb(89 37 220 / 0.05);
}

.active\\:border-purple-700\\/50:active{
  border-color: rgb(89 37 220 / 0.5);
}

.active\\:border-purple-700\\/55:active{
  border-color: rgb(89 37 220 / 0.55);
}

.active\\:border-purple-700\\/60:active{
  border-color: rgb(89 37 220 / 0.6);
}

.active\\:border-purple-700\\/65:active{
  border-color: rgb(89 37 220 / 0.65);
}

.active\\:border-purple-700\\/70:active{
  border-color: rgb(89 37 220 / 0.7);
}

.active\\:border-purple-700\\/75:active{
  border-color: rgb(89 37 220 / 0.75);
}

.active\\:border-purple-700\\/80:active{
  border-color: rgb(89 37 220 / 0.8);
}

.active\\:border-purple-700\\/85:active{
  border-color: rgb(89 37 220 / 0.85);
}

.active\\:border-purple-700\\/90:active{
  border-color: rgb(89 37 220 / 0.9);
}

.active\\:border-purple-700\\/95:active{
  border-color: rgb(89 37 220 / 0.95);
}

.active\\:border-success-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(211 248 223 / var(--tw-border-opacity, 1));
}

.active\\:border-success-100\\/0:active{
  border-color: rgb(211 248 223 / 0);
}

.active\\:border-success-100\\/10:active{
  border-color: rgb(211 248 223 / 0.1);
}

.active\\:border-success-100\\/100:active{
  border-color: rgb(211 248 223 / 1);
}

.active\\:border-success-100\\/15:active{
  border-color: rgb(211 248 223 / 0.15);
}

.active\\:border-success-100\\/20:active{
  border-color: rgb(211 248 223 / 0.2);
}

.active\\:border-success-100\\/25:active{
  border-color: rgb(211 248 223 / 0.25);
}

.active\\:border-success-100\\/30:active{
  border-color: rgb(211 248 223 / 0.3);
}

.active\\:border-success-100\\/35:active{
  border-color: rgb(211 248 223 / 0.35);
}

.active\\:border-success-100\\/40:active{
  border-color: rgb(211 248 223 / 0.4);
}

.active\\:border-success-100\\/45:active{
  border-color: rgb(211 248 223 / 0.45);
}

.active\\:border-success-100\\/5:active{
  border-color: rgb(211 248 223 / 0.05);
}

.active\\:border-success-100\\/50:active{
  border-color: rgb(211 248 223 / 0.5);
}

.active\\:border-success-100\\/55:active{
  border-color: rgb(211 248 223 / 0.55);
}

.active\\:border-success-100\\/60:active{
  border-color: rgb(211 248 223 / 0.6);
}

.active\\:border-success-100\\/65:active{
  border-color: rgb(211 248 223 / 0.65);
}

.active\\:border-success-100\\/70:active{
  border-color: rgb(211 248 223 / 0.7);
}

.active\\:border-success-100\\/75:active{
  border-color: rgb(211 248 223 / 0.75);
}

.active\\:border-success-100\\/80:active{
  border-color: rgb(211 248 223 / 0.8);
}

.active\\:border-success-100\\/85:active{
  border-color: rgb(211 248 223 / 0.85);
}

.active\\:border-success-100\\/90:active{
  border-color: rgb(211 248 223 / 0.9);
}

.active\\:border-success-100\\/95:active{
  border-color: rgb(211 248 223 / 0.95);
}

.active\\:border-success-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(170 240 196 / var(--tw-border-opacity, 1));
}

.active\\:border-success-200\\/0:active{
  border-color: rgb(170 240 196 / 0);
}

.active\\:border-success-200\\/10:active{
  border-color: rgb(170 240 196 / 0.1);
}

.active\\:border-success-200\\/100:active{
  border-color: rgb(170 240 196 / 1);
}

.active\\:border-success-200\\/15:active{
  border-color: rgb(170 240 196 / 0.15);
}

.active\\:border-success-200\\/20:active{
  border-color: rgb(170 240 196 / 0.2);
}

.active\\:border-success-200\\/25:active{
  border-color: rgb(170 240 196 / 0.25);
}

.active\\:border-success-200\\/30:active{
  border-color: rgb(170 240 196 / 0.3);
}

.active\\:border-success-200\\/35:active{
  border-color: rgb(170 240 196 / 0.35);
}

.active\\:border-success-200\\/40:active{
  border-color: rgb(170 240 196 / 0.4);
}

.active\\:border-success-200\\/45:active{
  border-color: rgb(170 240 196 / 0.45);
}

.active\\:border-success-200\\/5:active{
  border-color: rgb(170 240 196 / 0.05);
}

.active\\:border-success-200\\/50:active{
  border-color: rgb(170 240 196 / 0.5);
}

.active\\:border-success-200\\/55:active{
  border-color: rgb(170 240 196 / 0.55);
}

.active\\:border-success-200\\/60:active{
  border-color: rgb(170 240 196 / 0.6);
}

.active\\:border-success-200\\/65:active{
  border-color: rgb(170 240 196 / 0.65);
}

.active\\:border-success-200\\/70:active{
  border-color: rgb(170 240 196 / 0.7);
}

.active\\:border-success-200\\/75:active{
  border-color: rgb(170 240 196 / 0.75);
}

.active\\:border-success-200\\/80:active{
  border-color: rgb(170 240 196 / 0.8);
}

.active\\:border-success-200\\/85:active{
  border-color: rgb(170 240 196 / 0.85);
}

.active\\:border-success-200\\/90:active{
  border-color: rgb(170 240 196 / 0.9);
}

.active\\:border-success-200\\/95:active{
  border-color: rgb(170 240 196 / 0.95);
}

.active\\:border-success-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(246 254 249 / var(--tw-border-opacity, 1));
}

.active\\:border-success-25\\/0:active{
  border-color: rgb(246 254 249 / 0);
}

.active\\:border-success-25\\/10:active{
  border-color: rgb(246 254 249 / 0.1);
}

.active\\:border-success-25\\/100:active{
  border-color: rgb(246 254 249 / 1);
}

.active\\:border-success-25\\/15:active{
  border-color: rgb(246 254 249 / 0.15);
}

.active\\:border-success-25\\/20:active{
  border-color: rgb(246 254 249 / 0.2);
}

.active\\:border-success-25\\/25:active{
  border-color: rgb(246 254 249 / 0.25);
}

.active\\:border-success-25\\/30:active{
  border-color: rgb(246 254 249 / 0.3);
}

.active\\:border-success-25\\/35:active{
  border-color: rgb(246 254 249 / 0.35);
}

.active\\:border-success-25\\/40:active{
  border-color: rgb(246 254 249 / 0.4);
}

.active\\:border-success-25\\/45:active{
  border-color: rgb(246 254 249 / 0.45);
}

.active\\:border-success-25\\/5:active{
  border-color: rgb(246 254 249 / 0.05);
}

.active\\:border-success-25\\/50:active{
  border-color: rgb(246 254 249 / 0.5);
}

.active\\:border-success-25\\/55:active{
  border-color: rgb(246 254 249 / 0.55);
}

.active\\:border-success-25\\/60:active{
  border-color: rgb(246 254 249 / 0.6);
}

.active\\:border-success-25\\/65:active{
  border-color: rgb(246 254 249 / 0.65);
}

.active\\:border-success-25\\/70:active{
  border-color: rgb(246 254 249 / 0.7);
}

.active\\:border-success-25\\/75:active{
  border-color: rgb(246 254 249 / 0.75);
}

.active\\:border-success-25\\/80:active{
  border-color: rgb(246 254 249 / 0.8);
}

.active\\:border-success-25\\/85:active{
  border-color: rgb(246 254 249 / 0.85);
}

.active\\:border-success-25\\/90:active{
  border-color: rgb(246 254 249 / 0.9);
}

.active\\:border-success-25\\/95:active{
  border-color: rgb(246 254 249 / 0.95);
}

.active\\:border-success-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(60 203 127 / var(--tw-border-opacity, 1));
}

.active\\:border-success-400\\/0:active{
  border-color: rgb(60 203 127 / 0);
}

.active\\:border-success-400\\/10:active{
  border-color: rgb(60 203 127 / 0.1);
}

.active\\:border-success-400\\/100:active{
  border-color: rgb(60 203 127 / 1);
}

.active\\:border-success-400\\/15:active{
  border-color: rgb(60 203 127 / 0.15);
}

.active\\:border-success-400\\/20:active{
  border-color: rgb(60 203 127 / 0.2);
}

.active\\:border-success-400\\/25:active{
  border-color: rgb(60 203 127 / 0.25);
}

.active\\:border-success-400\\/30:active{
  border-color: rgb(60 203 127 / 0.3);
}

.active\\:border-success-400\\/35:active{
  border-color: rgb(60 203 127 / 0.35);
}

.active\\:border-success-400\\/40:active{
  border-color: rgb(60 203 127 / 0.4);
}

.active\\:border-success-400\\/45:active{
  border-color: rgb(60 203 127 / 0.45);
}

.active\\:border-success-400\\/5:active{
  border-color: rgb(60 203 127 / 0.05);
}

.active\\:border-success-400\\/50:active{
  border-color: rgb(60 203 127 / 0.5);
}

.active\\:border-success-400\\/55:active{
  border-color: rgb(60 203 127 / 0.55);
}

.active\\:border-success-400\\/60:active{
  border-color: rgb(60 203 127 / 0.6);
}

.active\\:border-success-400\\/65:active{
  border-color: rgb(60 203 127 / 0.65);
}

.active\\:border-success-400\\/70:active{
  border-color: rgb(60 203 127 / 0.7);
}

.active\\:border-success-400\\/75:active{
  border-color: rgb(60 203 127 / 0.75);
}

.active\\:border-success-400\\/80:active{
  border-color: rgb(60 203 127 / 0.8);
}

.active\\:border-success-400\\/85:active{
  border-color: rgb(60 203 127 / 0.85);
}

.active\\:border-success-400\\/90:active{
  border-color: rgb(60 203 127 / 0.9);
}

.active\\:border-success-400\\/95:active{
  border-color: rgb(60 203 127 / 0.95);
}

.active\\:border-success-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(237 252 242 / var(--tw-border-opacity, 1));
}

.active\\:border-success-50\\/0:active{
  border-color: rgb(237 252 242 / 0);
}

.active\\:border-success-50\\/10:active{
  border-color: rgb(237 252 242 / 0.1);
}

.active\\:border-success-50\\/100:active{
  border-color: rgb(237 252 242 / 1);
}

.active\\:border-success-50\\/15:active{
  border-color: rgb(237 252 242 / 0.15);
}

.active\\:border-success-50\\/20:active{
  border-color: rgb(237 252 242 / 0.2);
}

.active\\:border-success-50\\/25:active{
  border-color: rgb(237 252 242 / 0.25);
}

.active\\:border-success-50\\/30:active{
  border-color: rgb(237 252 242 / 0.3);
}

.active\\:border-success-50\\/35:active{
  border-color: rgb(237 252 242 / 0.35);
}

.active\\:border-success-50\\/40:active{
  border-color: rgb(237 252 242 / 0.4);
}

.active\\:border-success-50\\/45:active{
  border-color: rgb(237 252 242 / 0.45);
}

.active\\:border-success-50\\/5:active{
  border-color: rgb(237 252 242 / 0.05);
}

.active\\:border-success-50\\/50:active{
  border-color: rgb(237 252 242 / 0.5);
}

.active\\:border-success-50\\/55:active{
  border-color: rgb(237 252 242 / 0.55);
}

.active\\:border-success-50\\/60:active{
  border-color: rgb(237 252 242 / 0.6);
}

.active\\:border-success-50\\/65:active{
  border-color: rgb(237 252 242 / 0.65);
}

.active\\:border-success-50\\/70:active{
  border-color: rgb(237 252 242 / 0.7);
}

.active\\:border-success-50\\/75:active{
  border-color: rgb(237 252 242 / 0.75);
}

.active\\:border-success-50\\/80:active{
  border-color: rgb(237 252 242 / 0.8);
}

.active\\:border-success-50\\/85:active{
  border-color: rgb(237 252 242 / 0.85);
}

.active\\:border-success-50\\/90:active{
  border-color: rgb(237 252 242 / 0.9);
}

.active\\:border-success-50\\/95:active{
  border-color: rgb(237 252 242 / 0.95);
}

.active\\:border-success-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(22 179 100 / var(--tw-border-opacity, 1));
}

.active\\:border-success-500\\/0:active{
  border-color: rgb(22 179 100 / 0);
}

.active\\:border-success-500\\/10:active{
  border-color: rgb(22 179 100 / 0.1);
}

.active\\:border-success-500\\/100:active{
  border-color: rgb(22 179 100 / 1);
}

.active\\:border-success-500\\/15:active{
  border-color: rgb(22 179 100 / 0.15);
}

.active\\:border-success-500\\/20:active{
  border-color: rgb(22 179 100 / 0.2);
}

.active\\:border-success-500\\/25:active{
  border-color: rgb(22 179 100 / 0.25);
}

.active\\:border-success-500\\/30:active{
  border-color: rgb(22 179 100 / 0.3);
}

.active\\:border-success-500\\/35:active{
  border-color: rgb(22 179 100 / 0.35);
}

.active\\:border-success-500\\/40:active{
  border-color: rgb(22 179 100 / 0.4);
}

.active\\:border-success-500\\/45:active{
  border-color: rgb(22 179 100 / 0.45);
}

.active\\:border-success-500\\/5:active{
  border-color: rgb(22 179 100 / 0.05);
}

.active\\:border-success-500\\/50:active{
  border-color: rgb(22 179 100 / 0.5);
}

.active\\:border-success-500\\/55:active{
  border-color: rgb(22 179 100 / 0.55);
}

.active\\:border-success-500\\/60:active{
  border-color: rgb(22 179 100 / 0.6);
}

.active\\:border-success-500\\/65:active{
  border-color: rgb(22 179 100 / 0.65);
}

.active\\:border-success-500\\/70:active{
  border-color: rgb(22 179 100 / 0.7);
}

.active\\:border-success-500\\/75:active{
  border-color: rgb(22 179 100 / 0.75);
}

.active\\:border-success-500\\/80:active{
  border-color: rgb(22 179 100 / 0.8);
}

.active\\:border-success-500\\/85:active{
  border-color: rgb(22 179 100 / 0.85);
}

.active\\:border-success-500\\/90:active{
  border-color: rgb(22 179 100 / 0.9);
}

.active\\:border-success-500\\/95:active{
  border-color: rgb(22 179 100 / 0.95);
}

.active\\:border-success-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(9 146 80 / var(--tw-border-opacity, 1));
}

.active\\:border-success-600\\/0:active{
  border-color: rgb(9 146 80 / 0);
}

.active\\:border-success-600\\/10:active{
  border-color: rgb(9 146 80 / 0.1);
}

.active\\:border-success-600\\/100:active{
  border-color: rgb(9 146 80 / 1);
}

.active\\:border-success-600\\/15:active{
  border-color: rgb(9 146 80 / 0.15);
}

.active\\:border-success-600\\/20:active{
  border-color: rgb(9 146 80 / 0.2);
}

.active\\:border-success-600\\/25:active{
  border-color: rgb(9 146 80 / 0.25);
}

.active\\:border-success-600\\/30:active{
  border-color: rgb(9 146 80 / 0.3);
}

.active\\:border-success-600\\/35:active{
  border-color: rgb(9 146 80 / 0.35);
}

.active\\:border-success-600\\/40:active{
  border-color: rgb(9 146 80 / 0.4);
}

.active\\:border-success-600\\/45:active{
  border-color: rgb(9 146 80 / 0.45);
}

.active\\:border-success-600\\/5:active{
  border-color: rgb(9 146 80 / 0.05);
}

.active\\:border-success-600\\/50:active{
  border-color: rgb(9 146 80 / 0.5);
}

.active\\:border-success-600\\/55:active{
  border-color: rgb(9 146 80 / 0.55);
}

.active\\:border-success-600\\/60:active{
  border-color: rgb(9 146 80 / 0.6);
}

.active\\:border-success-600\\/65:active{
  border-color: rgb(9 146 80 / 0.65);
}

.active\\:border-success-600\\/70:active{
  border-color: rgb(9 146 80 / 0.7);
}

.active\\:border-success-600\\/75:active{
  border-color: rgb(9 146 80 / 0.75);
}

.active\\:border-success-600\\/80:active{
  border-color: rgb(9 146 80 / 0.8);
}

.active\\:border-success-600\\/85:active{
  border-color: rgb(9 146 80 / 0.85);
}

.active\\:border-success-600\\/90:active{
  border-color: rgb(9 146 80 / 0.9);
}

.active\\:border-success-600\\/95:active{
  border-color: rgb(9 146 80 / 0.95);
}

.active\\:border-success-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(8 116 67 / var(--tw-border-opacity, 1));
}

.active\\:border-success-700\\/0:active{
  border-color: rgb(8 116 67 / 0);
}

.active\\:border-success-700\\/10:active{
  border-color: rgb(8 116 67 / 0.1);
}

.active\\:border-success-700\\/100:active{
  border-color: rgb(8 116 67 / 1);
}

.active\\:border-success-700\\/15:active{
  border-color: rgb(8 116 67 / 0.15);
}

.active\\:border-success-700\\/20:active{
  border-color: rgb(8 116 67 / 0.2);
}

.active\\:border-success-700\\/25:active{
  border-color: rgb(8 116 67 / 0.25);
}

.active\\:border-success-700\\/30:active{
  border-color: rgb(8 116 67 / 0.3);
}

.active\\:border-success-700\\/35:active{
  border-color: rgb(8 116 67 / 0.35);
}

.active\\:border-success-700\\/40:active{
  border-color: rgb(8 116 67 / 0.4);
}

.active\\:border-success-700\\/45:active{
  border-color: rgb(8 116 67 / 0.45);
}

.active\\:border-success-700\\/5:active{
  border-color: rgb(8 116 67 / 0.05);
}

.active\\:border-success-700\\/50:active{
  border-color: rgb(8 116 67 / 0.5);
}

.active\\:border-success-700\\/55:active{
  border-color: rgb(8 116 67 / 0.55);
}

.active\\:border-success-700\\/60:active{
  border-color: rgb(8 116 67 / 0.6);
}

.active\\:border-success-700\\/65:active{
  border-color: rgb(8 116 67 / 0.65);
}

.active\\:border-success-700\\/70:active{
  border-color: rgb(8 116 67 / 0.7);
}

.active\\:border-success-700\\/75:active{
  border-color: rgb(8 116 67 / 0.75);
}

.active\\:border-success-700\\/80:active{
  border-color: rgb(8 116 67 / 0.8);
}

.active\\:border-success-700\\/85:active{
  border-color: rgb(8 116 67 / 0.85);
}

.active\\:border-success-700\\/90:active{
  border-color: rgb(8 116 67 / 0.9);
}

.active\\:border-success-700\\/95:active{
  border-color: rgb(8 116 67 / 0.95);
}

.active\\:border-warning-100:active{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 199 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-100\\/0:active{
  border-color: rgb(254 240 199 / 0);
}

.active\\:border-warning-100\\/10:active{
  border-color: rgb(254 240 199 / 0.1);
}

.active\\:border-warning-100\\/100:active{
  border-color: rgb(254 240 199 / 1);
}

.active\\:border-warning-100\\/15:active{
  border-color: rgb(254 240 199 / 0.15);
}

.active\\:border-warning-100\\/20:active{
  border-color: rgb(254 240 199 / 0.2);
}

.active\\:border-warning-100\\/25:active{
  border-color: rgb(254 240 199 / 0.25);
}

.active\\:border-warning-100\\/30:active{
  border-color: rgb(254 240 199 / 0.3);
}

.active\\:border-warning-100\\/35:active{
  border-color: rgb(254 240 199 / 0.35);
}

.active\\:border-warning-100\\/40:active{
  border-color: rgb(254 240 199 / 0.4);
}

.active\\:border-warning-100\\/45:active{
  border-color: rgb(254 240 199 / 0.45);
}

.active\\:border-warning-100\\/5:active{
  border-color: rgb(254 240 199 / 0.05);
}

.active\\:border-warning-100\\/50:active{
  border-color: rgb(254 240 199 / 0.5);
}

.active\\:border-warning-100\\/55:active{
  border-color: rgb(254 240 199 / 0.55);
}

.active\\:border-warning-100\\/60:active{
  border-color: rgb(254 240 199 / 0.6);
}

.active\\:border-warning-100\\/65:active{
  border-color: rgb(254 240 199 / 0.65);
}

.active\\:border-warning-100\\/70:active{
  border-color: rgb(254 240 199 / 0.7);
}

.active\\:border-warning-100\\/75:active{
  border-color: rgb(254 240 199 / 0.75);
}

.active\\:border-warning-100\\/80:active{
  border-color: rgb(254 240 199 / 0.8);
}

.active\\:border-warning-100\\/85:active{
  border-color: rgb(254 240 199 / 0.85);
}

.active\\:border-warning-100\\/90:active{
  border-color: rgb(254 240 199 / 0.9);
}

.active\\:border-warning-100\\/95:active{
  border-color: rgb(254 240 199 / 0.95);
}

.active\\:border-warning-200:active{
  --tw-border-opacity: 1;
  border-color: rgb(254 223 137 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-200\\/0:active{
  border-color: rgb(254 223 137 / 0);
}

.active\\:border-warning-200\\/10:active{
  border-color: rgb(254 223 137 / 0.1);
}

.active\\:border-warning-200\\/100:active{
  border-color: rgb(254 223 137 / 1);
}

.active\\:border-warning-200\\/15:active{
  border-color: rgb(254 223 137 / 0.15);
}

.active\\:border-warning-200\\/20:active{
  border-color: rgb(254 223 137 / 0.2);
}

.active\\:border-warning-200\\/25:active{
  border-color: rgb(254 223 137 / 0.25);
}

.active\\:border-warning-200\\/30:active{
  border-color: rgb(254 223 137 / 0.3);
}

.active\\:border-warning-200\\/35:active{
  border-color: rgb(254 223 137 / 0.35);
}

.active\\:border-warning-200\\/40:active{
  border-color: rgb(254 223 137 / 0.4);
}

.active\\:border-warning-200\\/45:active{
  border-color: rgb(254 223 137 / 0.45);
}

.active\\:border-warning-200\\/5:active{
  border-color: rgb(254 223 137 / 0.05);
}

.active\\:border-warning-200\\/50:active{
  border-color: rgb(254 223 137 / 0.5);
}

.active\\:border-warning-200\\/55:active{
  border-color: rgb(254 223 137 / 0.55);
}

.active\\:border-warning-200\\/60:active{
  border-color: rgb(254 223 137 / 0.6);
}

.active\\:border-warning-200\\/65:active{
  border-color: rgb(254 223 137 / 0.65);
}

.active\\:border-warning-200\\/70:active{
  border-color: rgb(254 223 137 / 0.7);
}

.active\\:border-warning-200\\/75:active{
  border-color: rgb(254 223 137 / 0.75);
}

.active\\:border-warning-200\\/80:active{
  border-color: rgb(254 223 137 / 0.8);
}

.active\\:border-warning-200\\/85:active{
  border-color: rgb(254 223 137 / 0.85);
}

.active\\:border-warning-200\\/90:active{
  border-color: rgb(254 223 137 / 0.9);
}

.active\\:border-warning-200\\/95:active{
  border-color: rgb(254 223 137 / 0.95);
}

.active\\:border-warning-25:active{
  --tw-border-opacity: 1;
  border-color: rgb(255 252 245 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-25\\/0:active{
  border-color: rgb(255 252 245 / 0);
}

.active\\:border-warning-25\\/10:active{
  border-color: rgb(255 252 245 / 0.1);
}

.active\\:border-warning-25\\/100:active{
  border-color: rgb(255 252 245 / 1);
}

.active\\:border-warning-25\\/15:active{
  border-color: rgb(255 252 245 / 0.15);
}

.active\\:border-warning-25\\/20:active{
  border-color: rgb(255 252 245 / 0.2);
}

.active\\:border-warning-25\\/25:active{
  border-color: rgb(255 252 245 / 0.25);
}

.active\\:border-warning-25\\/30:active{
  border-color: rgb(255 252 245 / 0.3);
}

.active\\:border-warning-25\\/35:active{
  border-color: rgb(255 252 245 / 0.35);
}

.active\\:border-warning-25\\/40:active{
  border-color: rgb(255 252 245 / 0.4);
}

.active\\:border-warning-25\\/45:active{
  border-color: rgb(255 252 245 / 0.45);
}

.active\\:border-warning-25\\/5:active{
  border-color: rgb(255 252 245 / 0.05);
}

.active\\:border-warning-25\\/50:active{
  border-color: rgb(255 252 245 / 0.5);
}

.active\\:border-warning-25\\/55:active{
  border-color: rgb(255 252 245 / 0.55);
}

.active\\:border-warning-25\\/60:active{
  border-color: rgb(255 252 245 / 0.6);
}

.active\\:border-warning-25\\/65:active{
  border-color: rgb(255 252 245 / 0.65);
}

.active\\:border-warning-25\\/70:active{
  border-color: rgb(255 252 245 / 0.7);
}

.active\\:border-warning-25\\/75:active{
  border-color: rgb(255 252 245 / 0.75);
}

.active\\:border-warning-25\\/80:active{
  border-color: rgb(255 252 245 / 0.8);
}

.active\\:border-warning-25\\/85:active{
  border-color: rgb(255 252 245 / 0.85);
}

.active\\:border-warning-25\\/90:active{
  border-color: rgb(255 252 245 / 0.9);
}

.active\\:border-warning-25\\/95:active{
  border-color: rgb(255 252 245 / 0.95);
}

.active\\:border-warning-400:active{
  --tw-border-opacity: 1;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-400\\/0:active{
  border-color: rgb(253 176 34 / 0);
}

.active\\:border-warning-400\\/10:active{
  border-color: rgb(253 176 34 / 0.1);
}

.active\\:border-warning-400\\/100:active{
  border-color: rgb(253 176 34 / 1);
}

.active\\:border-warning-400\\/15:active{
  border-color: rgb(253 176 34 / 0.15);
}

.active\\:border-warning-400\\/20:active{
  border-color: rgb(253 176 34 / 0.2);
}

.active\\:border-warning-400\\/25:active{
  border-color: rgb(253 176 34 / 0.25);
}

.active\\:border-warning-400\\/30:active{
  border-color: rgb(253 176 34 / 0.3);
}

.active\\:border-warning-400\\/35:active{
  border-color: rgb(253 176 34 / 0.35);
}

.active\\:border-warning-400\\/40:active{
  border-color: rgb(253 176 34 / 0.4);
}

.active\\:border-warning-400\\/45:active{
  border-color: rgb(253 176 34 / 0.45);
}

.active\\:border-warning-400\\/5:active{
  border-color: rgb(253 176 34 / 0.05);
}

.active\\:border-warning-400\\/50:active{
  border-color: rgb(253 176 34 / 0.5);
}

.active\\:border-warning-400\\/55:active{
  border-color: rgb(253 176 34 / 0.55);
}

.active\\:border-warning-400\\/60:active{
  border-color: rgb(253 176 34 / 0.6);
}

.active\\:border-warning-400\\/65:active{
  border-color: rgb(253 176 34 / 0.65);
}

.active\\:border-warning-400\\/70:active{
  border-color: rgb(253 176 34 / 0.7);
}

.active\\:border-warning-400\\/75:active{
  border-color: rgb(253 176 34 / 0.75);
}

.active\\:border-warning-400\\/80:active{
  border-color: rgb(253 176 34 / 0.8);
}

.active\\:border-warning-400\\/85:active{
  border-color: rgb(253 176 34 / 0.85);
}

.active\\:border-warning-400\\/90:active{
  border-color: rgb(253 176 34 / 0.9);
}

.active\\:border-warning-400\\/95:active{
  border-color: rgb(253 176 34 / 0.95);
}

.active\\:border-warning-50:active{
  --tw-border-opacity: 1;
  border-color: rgb(255 250 235 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-50\\/0:active{
  border-color: rgb(255 250 235 / 0);
}

.active\\:border-warning-50\\/10:active{
  border-color: rgb(255 250 235 / 0.1);
}

.active\\:border-warning-50\\/100:active{
  border-color: rgb(255 250 235 / 1);
}

.active\\:border-warning-50\\/15:active{
  border-color: rgb(255 250 235 / 0.15);
}

.active\\:border-warning-50\\/20:active{
  border-color: rgb(255 250 235 / 0.2);
}

.active\\:border-warning-50\\/25:active{
  border-color: rgb(255 250 235 / 0.25);
}

.active\\:border-warning-50\\/30:active{
  border-color: rgb(255 250 235 / 0.3);
}

.active\\:border-warning-50\\/35:active{
  border-color: rgb(255 250 235 / 0.35);
}

.active\\:border-warning-50\\/40:active{
  border-color: rgb(255 250 235 / 0.4);
}

.active\\:border-warning-50\\/45:active{
  border-color: rgb(255 250 235 / 0.45);
}

.active\\:border-warning-50\\/5:active{
  border-color: rgb(255 250 235 / 0.05);
}

.active\\:border-warning-50\\/50:active{
  border-color: rgb(255 250 235 / 0.5);
}

.active\\:border-warning-50\\/55:active{
  border-color: rgb(255 250 235 / 0.55);
}

.active\\:border-warning-50\\/60:active{
  border-color: rgb(255 250 235 / 0.6);
}

.active\\:border-warning-50\\/65:active{
  border-color: rgb(255 250 235 / 0.65);
}

.active\\:border-warning-50\\/70:active{
  border-color: rgb(255 250 235 / 0.7);
}

.active\\:border-warning-50\\/75:active{
  border-color: rgb(255 250 235 / 0.75);
}

.active\\:border-warning-50\\/80:active{
  border-color: rgb(255 250 235 / 0.8);
}

.active\\:border-warning-50\\/85:active{
  border-color: rgb(255 250 235 / 0.85);
}

.active\\:border-warning-50\\/90:active{
  border-color: rgb(255 250 235 / 0.9);
}

.active\\:border-warning-50\\/95:active{
  border-color: rgb(255 250 235 / 0.95);
}

.active\\:border-warning-500:active{
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-500\\/0:active{
  border-color: rgb(247 144 9 / 0);
}

.active\\:border-warning-500\\/10:active{
  border-color: rgb(247 144 9 / 0.1);
}

.active\\:border-warning-500\\/100:active{
  border-color: rgb(247 144 9 / 1);
}

.active\\:border-warning-500\\/15:active{
  border-color: rgb(247 144 9 / 0.15);
}

.active\\:border-warning-500\\/20:active{
  border-color: rgb(247 144 9 / 0.2);
}

.active\\:border-warning-500\\/25:active{
  border-color: rgb(247 144 9 / 0.25);
}

.active\\:border-warning-500\\/30:active{
  border-color: rgb(247 144 9 / 0.3);
}

.active\\:border-warning-500\\/35:active{
  border-color: rgb(247 144 9 / 0.35);
}

.active\\:border-warning-500\\/40:active{
  border-color: rgb(247 144 9 / 0.4);
}

.active\\:border-warning-500\\/45:active{
  border-color: rgb(247 144 9 / 0.45);
}

.active\\:border-warning-500\\/5:active{
  border-color: rgb(247 144 9 / 0.05);
}

.active\\:border-warning-500\\/50:active{
  border-color: rgb(247 144 9 / 0.5);
}

.active\\:border-warning-500\\/55:active{
  border-color: rgb(247 144 9 / 0.55);
}

.active\\:border-warning-500\\/60:active{
  border-color: rgb(247 144 9 / 0.6);
}

.active\\:border-warning-500\\/65:active{
  border-color: rgb(247 144 9 / 0.65);
}

.active\\:border-warning-500\\/70:active{
  border-color: rgb(247 144 9 / 0.7);
}

.active\\:border-warning-500\\/75:active{
  border-color: rgb(247 144 9 / 0.75);
}

.active\\:border-warning-500\\/80:active{
  border-color: rgb(247 144 9 / 0.8);
}

.active\\:border-warning-500\\/85:active{
  border-color: rgb(247 144 9 / 0.85);
}

.active\\:border-warning-500\\/90:active{
  border-color: rgb(247 144 9 / 0.9);
}

.active\\:border-warning-500\\/95:active{
  border-color: rgb(247 144 9 / 0.95);
}

.active\\:border-warning-600:active{
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-600\\/0:active{
  border-color: rgb(220 104 3 / 0);
}

.active\\:border-warning-600\\/10:active{
  border-color: rgb(220 104 3 / 0.1);
}

.active\\:border-warning-600\\/100:active{
  border-color: rgb(220 104 3 / 1);
}

.active\\:border-warning-600\\/15:active{
  border-color: rgb(220 104 3 / 0.15);
}

.active\\:border-warning-600\\/20:active{
  border-color: rgb(220 104 3 / 0.2);
}

.active\\:border-warning-600\\/25:active{
  border-color: rgb(220 104 3 / 0.25);
}

.active\\:border-warning-600\\/30:active{
  border-color: rgb(220 104 3 / 0.3);
}

.active\\:border-warning-600\\/35:active{
  border-color: rgb(220 104 3 / 0.35);
}

.active\\:border-warning-600\\/40:active{
  border-color: rgb(220 104 3 / 0.4);
}

.active\\:border-warning-600\\/45:active{
  border-color: rgb(220 104 3 / 0.45);
}

.active\\:border-warning-600\\/5:active{
  border-color: rgb(220 104 3 / 0.05);
}

.active\\:border-warning-600\\/50:active{
  border-color: rgb(220 104 3 / 0.5);
}

.active\\:border-warning-600\\/55:active{
  border-color: rgb(220 104 3 / 0.55);
}

.active\\:border-warning-600\\/60:active{
  border-color: rgb(220 104 3 / 0.6);
}

.active\\:border-warning-600\\/65:active{
  border-color: rgb(220 104 3 / 0.65);
}

.active\\:border-warning-600\\/70:active{
  border-color: rgb(220 104 3 / 0.7);
}

.active\\:border-warning-600\\/75:active{
  border-color: rgb(220 104 3 / 0.75);
}

.active\\:border-warning-600\\/80:active{
  border-color: rgb(220 104 3 / 0.8);
}

.active\\:border-warning-600\\/85:active{
  border-color: rgb(220 104 3 / 0.85);
}

.active\\:border-warning-600\\/90:active{
  border-color: rgb(220 104 3 / 0.9);
}

.active\\:border-warning-600\\/95:active{
  border-color: rgb(220 104 3 / 0.95);
}

.active\\:border-warning-700:active{
  --tw-border-opacity: 1;
  border-color: rgb(181 71 8 / var(--tw-border-opacity, 1));
}

.active\\:border-warning-700\\/0:active{
  border-color: rgb(181 71 8 / 0);
}

.active\\:border-warning-700\\/10:active{
  border-color: rgb(181 71 8 / 0.1);
}

.active\\:border-warning-700\\/100:active{
  border-color: rgb(181 71 8 / 1);
}

.active\\:border-warning-700\\/15:active{
  border-color: rgb(181 71 8 / 0.15);
}

.active\\:border-warning-700\\/20:active{
  border-color: rgb(181 71 8 / 0.2);
}

.active\\:border-warning-700\\/25:active{
  border-color: rgb(181 71 8 / 0.25);
}

.active\\:border-warning-700\\/30:active{
  border-color: rgb(181 71 8 / 0.3);
}

.active\\:border-warning-700\\/35:active{
  border-color: rgb(181 71 8 / 0.35);
}

.active\\:border-warning-700\\/40:active{
  border-color: rgb(181 71 8 / 0.4);
}

.active\\:border-warning-700\\/45:active{
  border-color: rgb(181 71 8 / 0.45);
}

.active\\:border-warning-700\\/5:active{
  border-color: rgb(181 71 8 / 0.05);
}

.active\\:border-warning-700\\/50:active{
  border-color: rgb(181 71 8 / 0.5);
}

.active\\:border-warning-700\\/55:active{
  border-color: rgb(181 71 8 / 0.55);
}

.active\\:border-warning-700\\/60:active{
  border-color: rgb(181 71 8 / 0.6);
}

.active\\:border-warning-700\\/65:active{
  border-color: rgb(181 71 8 / 0.65);
}

.active\\:border-warning-700\\/70:active{
  border-color: rgb(181 71 8 / 0.7);
}

.active\\:border-warning-700\\/75:active{
  border-color: rgb(181 71 8 / 0.75);
}

.active\\:border-warning-700\\/80:active{
  border-color: rgb(181 71 8 / 0.8);
}

.active\\:border-warning-700\\/85:active{
  border-color: rgb(181 71 8 / 0.85);
}

.active\\:border-warning-700\\/90:active{
  border-color: rgb(181 71 8 / 0.9);
}

.active\\:border-warning-700\\/95:active{
  border-color: rgb(181 71 8 / 0.95);
}

.active\\:bg-danger-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-100\\/0:active{
  background-color: rgb(254 228 226 / 0);
}

.active\\:bg-danger-100\\/10:active{
  background-color: rgb(254 228 226 / 0.1);
}

.active\\:bg-danger-100\\/100:active{
  background-color: rgb(254 228 226 / 1);
}

.active\\:bg-danger-100\\/15:active{
  background-color: rgb(254 228 226 / 0.15);
}

.active\\:bg-danger-100\\/20:active{
  background-color: rgb(254 228 226 / 0.2);
}

.active\\:bg-danger-100\\/25:active{
  background-color: rgb(254 228 226 / 0.25);
}

.active\\:bg-danger-100\\/30:active{
  background-color: rgb(254 228 226 / 0.3);
}

.active\\:bg-danger-100\\/35:active{
  background-color: rgb(254 228 226 / 0.35);
}

.active\\:bg-danger-100\\/40:active{
  background-color: rgb(254 228 226 / 0.4);
}

.active\\:bg-danger-100\\/45:active{
  background-color: rgb(254 228 226 / 0.45);
}

.active\\:bg-danger-100\\/5:active{
  background-color: rgb(254 228 226 / 0.05);
}

.active\\:bg-danger-100\\/50:active{
  background-color: rgb(254 228 226 / 0.5);
}

.active\\:bg-danger-100\\/55:active{
  background-color: rgb(254 228 226 / 0.55);
}

.active\\:bg-danger-100\\/60:active{
  background-color: rgb(254 228 226 / 0.6);
}

.active\\:bg-danger-100\\/65:active{
  background-color: rgb(254 228 226 / 0.65);
}

.active\\:bg-danger-100\\/70:active{
  background-color: rgb(254 228 226 / 0.7);
}

.active\\:bg-danger-100\\/75:active{
  background-color: rgb(254 228 226 / 0.75);
}

.active\\:bg-danger-100\\/80:active{
  background-color: rgb(254 228 226 / 0.8);
}

.active\\:bg-danger-100\\/85:active{
  background-color: rgb(254 228 226 / 0.85);
}

.active\\:bg-danger-100\\/90:active{
  background-color: rgb(254 228 226 / 0.9);
}

.active\\:bg-danger-100\\/95:active{
  background-color: rgb(254 228 226 / 0.95);
}

.active\\:bg-danger-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-200\\/0:active{
  background-color: rgb(254 205 202 / 0);
}

.active\\:bg-danger-200\\/10:active{
  background-color: rgb(254 205 202 / 0.1);
}

.active\\:bg-danger-200\\/100:active{
  background-color: rgb(254 205 202 / 1);
}

.active\\:bg-danger-200\\/15:active{
  background-color: rgb(254 205 202 / 0.15);
}

.active\\:bg-danger-200\\/20:active{
  background-color: rgb(254 205 202 / 0.2);
}

.active\\:bg-danger-200\\/25:active{
  background-color: rgb(254 205 202 / 0.25);
}

.active\\:bg-danger-200\\/30:active{
  background-color: rgb(254 205 202 / 0.3);
}

.active\\:bg-danger-200\\/35:active{
  background-color: rgb(254 205 202 / 0.35);
}

.active\\:bg-danger-200\\/40:active{
  background-color: rgb(254 205 202 / 0.4);
}

.active\\:bg-danger-200\\/45:active{
  background-color: rgb(254 205 202 / 0.45);
}

.active\\:bg-danger-200\\/5:active{
  background-color: rgb(254 205 202 / 0.05);
}

.active\\:bg-danger-200\\/50:active{
  background-color: rgb(254 205 202 / 0.5);
}

.active\\:bg-danger-200\\/55:active{
  background-color: rgb(254 205 202 / 0.55);
}

.active\\:bg-danger-200\\/60:active{
  background-color: rgb(254 205 202 / 0.6);
}

.active\\:bg-danger-200\\/65:active{
  background-color: rgb(254 205 202 / 0.65);
}

.active\\:bg-danger-200\\/70:active{
  background-color: rgb(254 205 202 / 0.7);
}

.active\\:bg-danger-200\\/75:active{
  background-color: rgb(254 205 202 / 0.75);
}

.active\\:bg-danger-200\\/80:active{
  background-color: rgb(254 205 202 / 0.8);
}

.active\\:bg-danger-200\\/85:active{
  background-color: rgb(254 205 202 / 0.85);
}

.active\\:bg-danger-200\\/90:active{
  background-color: rgb(254 205 202 / 0.9);
}

.active\\:bg-danger-200\\/95:active{
  background-color: rgb(254 205 202 / 0.95);
}

.active\\:bg-danger-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-25\\/0:active{
  background-color: rgb(255 251 250 / 0);
}

.active\\:bg-danger-25\\/10:active{
  background-color: rgb(255 251 250 / 0.1);
}

.active\\:bg-danger-25\\/100:active{
  background-color: rgb(255 251 250 / 1);
}

.active\\:bg-danger-25\\/15:active{
  background-color: rgb(255 251 250 / 0.15);
}

.active\\:bg-danger-25\\/20:active{
  background-color: rgb(255 251 250 / 0.2);
}

.active\\:bg-danger-25\\/25:active{
  background-color: rgb(255 251 250 / 0.25);
}

.active\\:bg-danger-25\\/30:active{
  background-color: rgb(255 251 250 / 0.3);
}

.active\\:bg-danger-25\\/35:active{
  background-color: rgb(255 251 250 / 0.35);
}

.active\\:bg-danger-25\\/40:active{
  background-color: rgb(255 251 250 / 0.4);
}

.active\\:bg-danger-25\\/45:active{
  background-color: rgb(255 251 250 / 0.45);
}

.active\\:bg-danger-25\\/5:active{
  background-color: rgb(255 251 250 / 0.05);
}

.active\\:bg-danger-25\\/50:active{
  background-color: rgb(255 251 250 / 0.5);
}

.active\\:bg-danger-25\\/55:active{
  background-color: rgb(255 251 250 / 0.55);
}

.active\\:bg-danger-25\\/60:active{
  background-color: rgb(255 251 250 / 0.6);
}

.active\\:bg-danger-25\\/65:active{
  background-color: rgb(255 251 250 / 0.65);
}

.active\\:bg-danger-25\\/70:active{
  background-color: rgb(255 251 250 / 0.7);
}

.active\\:bg-danger-25\\/75:active{
  background-color: rgb(255 251 250 / 0.75);
}

.active\\:bg-danger-25\\/80:active{
  background-color: rgb(255 251 250 / 0.8);
}

.active\\:bg-danger-25\\/85:active{
  background-color: rgb(255 251 250 / 0.85);
}

.active\\:bg-danger-25\\/90:active{
  background-color: rgb(255 251 250 / 0.9);
}

.active\\:bg-danger-25\\/95:active{
  background-color: rgb(255 251 250 / 0.95);
}

.active\\:bg-danger-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-400\\/0:active{
  background-color: rgb(249 112 102 / 0);
}

.active\\:bg-danger-400\\/10:active{
  background-color: rgb(249 112 102 / 0.1);
}

.active\\:bg-danger-400\\/100:active{
  background-color: rgb(249 112 102 / 1);
}

.active\\:bg-danger-400\\/15:active{
  background-color: rgb(249 112 102 / 0.15);
}

.active\\:bg-danger-400\\/20:active{
  background-color: rgb(249 112 102 / 0.2);
}

.active\\:bg-danger-400\\/25:active{
  background-color: rgb(249 112 102 / 0.25);
}

.active\\:bg-danger-400\\/30:active{
  background-color: rgb(249 112 102 / 0.3);
}

.active\\:bg-danger-400\\/35:active{
  background-color: rgb(249 112 102 / 0.35);
}

.active\\:bg-danger-400\\/40:active{
  background-color: rgb(249 112 102 / 0.4);
}

.active\\:bg-danger-400\\/45:active{
  background-color: rgb(249 112 102 / 0.45);
}

.active\\:bg-danger-400\\/5:active{
  background-color: rgb(249 112 102 / 0.05);
}

.active\\:bg-danger-400\\/50:active{
  background-color: rgb(249 112 102 / 0.5);
}

.active\\:bg-danger-400\\/55:active{
  background-color: rgb(249 112 102 / 0.55);
}

.active\\:bg-danger-400\\/60:active{
  background-color: rgb(249 112 102 / 0.6);
}

.active\\:bg-danger-400\\/65:active{
  background-color: rgb(249 112 102 / 0.65);
}

.active\\:bg-danger-400\\/70:active{
  background-color: rgb(249 112 102 / 0.7);
}

.active\\:bg-danger-400\\/75:active{
  background-color: rgb(249 112 102 / 0.75);
}

.active\\:bg-danger-400\\/80:active{
  background-color: rgb(249 112 102 / 0.8);
}

.active\\:bg-danger-400\\/85:active{
  background-color: rgb(249 112 102 / 0.85);
}

.active\\:bg-danger-400\\/90:active{
  background-color: rgb(249 112 102 / 0.9);
}

.active\\:bg-danger-400\\/95:active{
  background-color: rgb(249 112 102 / 0.95);
}

.active\\:bg-danger-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-50\\/0:active{
  background-color: rgb(254 243 242 / 0);
}

.active\\:bg-danger-50\\/10:active{
  background-color: rgb(254 243 242 / 0.1);
}

.active\\:bg-danger-50\\/100:active{
  background-color: rgb(254 243 242 / 1);
}

.active\\:bg-danger-50\\/15:active{
  background-color: rgb(254 243 242 / 0.15);
}

.active\\:bg-danger-50\\/20:active{
  background-color: rgb(254 243 242 / 0.2);
}

.active\\:bg-danger-50\\/25:active{
  background-color: rgb(254 243 242 / 0.25);
}

.active\\:bg-danger-50\\/30:active{
  background-color: rgb(254 243 242 / 0.3);
}

.active\\:bg-danger-50\\/35:active{
  background-color: rgb(254 243 242 / 0.35);
}

.active\\:bg-danger-50\\/40:active{
  background-color: rgb(254 243 242 / 0.4);
}

.active\\:bg-danger-50\\/45:active{
  background-color: rgb(254 243 242 / 0.45);
}

.active\\:bg-danger-50\\/5:active{
  background-color: rgb(254 243 242 / 0.05);
}

.active\\:bg-danger-50\\/50:active{
  background-color: rgb(254 243 242 / 0.5);
}

.active\\:bg-danger-50\\/55:active{
  background-color: rgb(254 243 242 / 0.55);
}

.active\\:bg-danger-50\\/60:active{
  background-color: rgb(254 243 242 / 0.6);
}

.active\\:bg-danger-50\\/65:active{
  background-color: rgb(254 243 242 / 0.65);
}

.active\\:bg-danger-50\\/70:active{
  background-color: rgb(254 243 242 / 0.7);
}

.active\\:bg-danger-50\\/75:active{
  background-color: rgb(254 243 242 / 0.75);
}

.active\\:bg-danger-50\\/80:active{
  background-color: rgb(254 243 242 / 0.8);
}

.active\\:bg-danger-50\\/85:active{
  background-color: rgb(254 243 242 / 0.85);
}

.active\\:bg-danger-50\\/90:active{
  background-color: rgb(254 243 242 / 0.9);
}

.active\\:bg-danger-50\\/95:active{
  background-color: rgb(254 243 242 / 0.95);
}

.active\\:bg-danger-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-500\\/0:active{
  background-color: rgb(240 68 56 / 0);
}

.active\\:bg-danger-500\\/10:active{
  background-color: rgb(240 68 56 / 0.1);
}

.active\\:bg-danger-500\\/100:active{
  background-color: rgb(240 68 56 / 1);
}

.active\\:bg-danger-500\\/15:active{
  background-color: rgb(240 68 56 / 0.15);
}

.active\\:bg-danger-500\\/20:active{
  background-color: rgb(240 68 56 / 0.2);
}

.active\\:bg-danger-500\\/25:active{
  background-color: rgb(240 68 56 / 0.25);
}

.active\\:bg-danger-500\\/30:active{
  background-color: rgb(240 68 56 / 0.3);
}

.active\\:bg-danger-500\\/35:active{
  background-color: rgb(240 68 56 / 0.35);
}

.active\\:bg-danger-500\\/40:active{
  background-color: rgb(240 68 56 / 0.4);
}

.active\\:bg-danger-500\\/45:active{
  background-color: rgb(240 68 56 / 0.45);
}

.active\\:bg-danger-500\\/5:active{
  background-color: rgb(240 68 56 / 0.05);
}

.active\\:bg-danger-500\\/50:active{
  background-color: rgb(240 68 56 / 0.5);
}

.active\\:bg-danger-500\\/55:active{
  background-color: rgb(240 68 56 / 0.55);
}

.active\\:bg-danger-500\\/60:active{
  background-color: rgb(240 68 56 / 0.6);
}

.active\\:bg-danger-500\\/65:active{
  background-color: rgb(240 68 56 / 0.65);
}

.active\\:bg-danger-500\\/70:active{
  background-color: rgb(240 68 56 / 0.7);
}

.active\\:bg-danger-500\\/75:active{
  background-color: rgb(240 68 56 / 0.75);
}

.active\\:bg-danger-500\\/80:active{
  background-color: rgb(240 68 56 / 0.8);
}

.active\\:bg-danger-500\\/85:active{
  background-color: rgb(240 68 56 / 0.85);
}

.active\\:bg-danger-500\\/90:active{
  background-color: rgb(240 68 56 / 0.9);
}

.active\\:bg-danger-500\\/95:active{
  background-color: rgb(240 68 56 / 0.95);
}

.active\\:bg-danger-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-600\\/0:active{
  background-color: rgb(217 45 32 / 0);
}

.active\\:bg-danger-600\\/10:active{
  background-color: rgb(217 45 32 / 0.1);
}

.active\\:bg-danger-600\\/100:active{
  background-color: rgb(217 45 32 / 1);
}

.active\\:bg-danger-600\\/15:active{
  background-color: rgb(217 45 32 / 0.15);
}

.active\\:bg-danger-600\\/20:active{
  background-color: rgb(217 45 32 / 0.2);
}

.active\\:bg-danger-600\\/25:active{
  background-color: rgb(217 45 32 / 0.25);
}

.active\\:bg-danger-600\\/30:active{
  background-color: rgb(217 45 32 / 0.3);
}

.active\\:bg-danger-600\\/35:active{
  background-color: rgb(217 45 32 / 0.35);
}

.active\\:bg-danger-600\\/40:active{
  background-color: rgb(217 45 32 / 0.4);
}

.active\\:bg-danger-600\\/45:active{
  background-color: rgb(217 45 32 / 0.45);
}

.active\\:bg-danger-600\\/5:active{
  background-color: rgb(217 45 32 / 0.05);
}

.active\\:bg-danger-600\\/50:active{
  background-color: rgb(217 45 32 / 0.5);
}

.active\\:bg-danger-600\\/55:active{
  background-color: rgb(217 45 32 / 0.55);
}

.active\\:bg-danger-600\\/60:active{
  background-color: rgb(217 45 32 / 0.6);
}

.active\\:bg-danger-600\\/65:active{
  background-color: rgb(217 45 32 / 0.65);
}

.active\\:bg-danger-600\\/70:active{
  background-color: rgb(217 45 32 / 0.7);
}

.active\\:bg-danger-600\\/75:active{
  background-color: rgb(217 45 32 / 0.75);
}

.active\\:bg-danger-600\\/80:active{
  background-color: rgb(217 45 32 / 0.8);
}

.active\\:bg-danger-600\\/85:active{
  background-color: rgb(217 45 32 / 0.85);
}

.active\\:bg-danger-600\\/90:active{
  background-color: rgb(217 45 32 / 0.9);
}

.active\\:bg-danger-600\\/95:active{
  background-color: rgb(217 45 32 / 0.95);
}

.active\\:bg-danger-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}

.active\\:bg-danger-700\\/0:active{
  background-color: rgb(180 35 24 / 0);
}

.active\\:bg-danger-700\\/10:active{
  background-color: rgb(180 35 24 / 0.1);
}

.active\\:bg-danger-700\\/100:active{
  background-color: rgb(180 35 24 / 1);
}

.active\\:bg-danger-700\\/15:active{
  background-color: rgb(180 35 24 / 0.15);
}

.active\\:bg-danger-700\\/20:active{
  background-color: rgb(180 35 24 / 0.2);
}

.active\\:bg-danger-700\\/25:active{
  background-color: rgb(180 35 24 / 0.25);
}

.active\\:bg-danger-700\\/30:active{
  background-color: rgb(180 35 24 / 0.3);
}

.active\\:bg-danger-700\\/35:active{
  background-color: rgb(180 35 24 / 0.35);
}

.active\\:bg-danger-700\\/40:active{
  background-color: rgb(180 35 24 / 0.4);
}

.active\\:bg-danger-700\\/45:active{
  background-color: rgb(180 35 24 / 0.45);
}

.active\\:bg-danger-700\\/5:active{
  background-color: rgb(180 35 24 / 0.05);
}

.active\\:bg-danger-700\\/50:active{
  background-color: rgb(180 35 24 / 0.5);
}

.active\\:bg-danger-700\\/55:active{
  background-color: rgb(180 35 24 / 0.55);
}

.active\\:bg-danger-700\\/60:active{
  background-color: rgb(180 35 24 / 0.6);
}

.active\\:bg-danger-700\\/65:active{
  background-color: rgb(180 35 24 / 0.65);
}

.active\\:bg-danger-700\\/70:active{
  background-color: rgb(180 35 24 / 0.7);
}

.active\\:bg-danger-700\\/75:active{
  background-color: rgb(180 35 24 / 0.75);
}

.active\\:bg-danger-700\\/80:active{
  background-color: rgb(180 35 24 / 0.8);
}

.active\\:bg-danger-700\\/85:active{
  background-color: rgb(180 35 24 / 0.85);
}

.active\\:bg-danger-700\\/90:active{
  background-color: rgb(180 35 24 / 0.9);
}

.active\\:bg-danger-700\\/95:active{
  background-color: rgb(180 35 24 / 0.95);
}

.active\\:bg-moss-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(230 244 215 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-100\\/0:active{
  background-color: rgb(230 244 215 / 0);
}

.active\\:bg-moss-100\\/10:active{
  background-color: rgb(230 244 215 / 0.1);
}

.active\\:bg-moss-100\\/100:active{
  background-color: rgb(230 244 215 / 1);
}

.active\\:bg-moss-100\\/15:active{
  background-color: rgb(230 244 215 / 0.15);
}

.active\\:bg-moss-100\\/20:active{
  background-color: rgb(230 244 215 / 0.2);
}

.active\\:bg-moss-100\\/25:active{
  background-color: rgb(230 244 215 / 0.25);
}

.active\\:bg-moss-100\\/30:active{
  background-color: rgb(230 244 215 / 0.3);
}

.active\\:bg-moss-100\\/35:active{
  background-color: rgb(230 244 215 / 0.35);
}

.active\\:bg-moss-100\\/40:active{
  background-color: rgb(230 244 215 / 0.4);
}

.active\\:bg-moss-100\\/45:active{
  background-color: rgb(230 244 215 / 0.45);
}

.active\\:bg-moss-100\\/5:active{
  background-color: rgb(230 244 215 / 0.05);
}

.active\\:bg-moss-100\\/50:active{
  background-color: rgb(230 244 215 / 0.5);
}

.active\\:bg-moss-100\\/55:active{
  background-color: rgb(230 244 215 / 0.55);
}

.active\\:bg-moss-100\\/60:active{
  background-color: rgb(230 244 215 / 0.6);
}

.active\\:bg-moss-100\\/65:active{
  background-color: rgb(230 244 215 / 0.65);
}

.active\\:bg-moss-100\\/70:active{
  background-color: rgb(230 244 215 / 0.7);
}

.active\\:bg-moss-100\\/75:active{
  background-color: rgb(230 244 215 / 0.75);
}

.active\\:bg-moss-100\\/80:active{
  background-color: rgb(230 244 215 / 0.8);
}

.active\\:bg-moss-100\\/85:active{
  background-color: rgb(230 244 215 / 0.85);
}

.active\\:bg-moss-100\\/90:active{
  background-color: rgb(230 244 215 / 0.9);
}

.active\\:bg-moss-100\\/95:active{
  background-color: rgb(230 244 215 / 0.95);
}

.active\\:bg-moss-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(206 234 176 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-200\\/0:active{
  background-color: rgb(206 234 176 / 0);
}

.active\\:bg-moss-200\\/10:active{
  background-color: rgb(206 234 176 / 0.1);
}

.active\\:bg-moss-200\\/100:active{
  background-color: rgb(206 234 176 / 1);
}

.active\\:bg-moss-200\\/15:active{
  background-color: rgb(206 234 176 / 0.15);
}

.active\\:bg-moss-200\\/20:active{
  background-color: rgb(206 234 176 / 0.2);
}

.active\\:bg-moss-200\\/25:active{
  background-color: rgb(206 234 176 / 0.25);
}

.active\\:bg-moss-200\\/30:active{
  background-color: rgb(206 234 176 / 0.3);
}

.active\\:bg-moss-200\\/35:active{
  background-color: rgb(206 234 176 / 0.35);
}

.active\\:bg-moss-200\\/40:active{
  background-color: rgb(206 234 176 / 0.4);
}

.active\\:bg-moss-200\\/45:active{
  background-color: rgb(206 234 176 / 0.45);
}

.active\\:bg-moss-200\\/5:active{
  background-color: rgb(206 234 176 / 0.05);
}

.active\\:bg-moss-200\\/50:active{
  background-color: rgb(206 234 176 / 0.5);
}

.active\\:bg-moss-200\\/55:active{
  background-color: rgb(206 234 176 / 0.55);
}

.active\\:bg-moss-200\\/60:active{
  background-color: rgb(206 234 176 / 0.6);
}

.active\\:bg-moss-200\\/65:active{
  background-color: rgb(206 234 176 / 0.65);
}

.active\\:bg-moss-200\\/70:active{
  background-color: rgb(206 234 176 / 0.7);
}

.active\\:bg-moss-200\\/75:active{
  background-color: rgb(206 234 176 / 0.75);
}

.active\\:bg-moss-200\\/80:active{
  background-color: rgb(206 234 176 / 0.8);
}

.active\\:bg-moss-200\\/85:active{
  background-color: rgb(206 234 176 / 0.85);
}

.active\\:bg-moss-200\\/90:active{
  background-color: rgb(206 234 176 / 0.9);
}

.active\\:bg-moss-200\\/95:active{
  background-color: rgb(206 234 176 / 0.95);
}

.active\\:bg-moss-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(250 253 247 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-25\\/0:active{
  background-color: rgb(250 253 247 / 0);
}

.active\\:bg-moss-25\\/10:active{
  background-color: rgb(250 253 247 / 0.1);
}

.active\\:bg-moss-25\\/100:active{
  background-color: rgb(250 253 247 / 1);
}

.active\\:bg-moss-25\\/15:active{
  background-color: rgb(250 253 247 / 0.15);
}

.active\\:bg-moss-25\\/20:active{
  background-color: rgb(250 253 247 / 0.2);
}

.active\\:bg-moss-25\\/25:active{
  background-color: rgb(250 253 247 / 0.25);
}

.active\\:bg-moss-25\\/30:active{
  background-color: rgb(250 253 247 / 0.3);
}

.active\\:bg-moss-25\\/35:active{
  background-color: rgb(250 253 247 / 0.35);
}

.active\\:bg-moss-25\\/40:active{
  background-color: rgb(250 253 247 / 0.4);
}

.active\\:bg-moss-25\\/45:active{
  background-color: rgb(250 253 247 / 0.45);
}

.active\\:bg-moss-25\\/5:active{
  background-color: rgb(250 253 247 / 0.05);
}

.active\\:bg-moss-25\\/50:active{
  background-color: rgb(250 253 247 / 0.5);
}

.active\\:bg-moss-25\\/55:active{
  background-color: rgb(250 253 247 / 0.55);
}

.active\\:bg-moss-25\\/60:active{
  background-color: rgb(250 253 247 / 0.6);
}

.active\\:bg-moss-25\\/65:active{
  background-color: rgb(250 253 247 / 0.65);
}

.active\\:bg-moss-25\\/70:active{
  background-color: rgb(250 253 247 / 0.7);
}

.active\\:bg-moss-25\\/75:active{
  background-color: rgb(250 253 247 / 0.75);
}

.active\\:bg-moss-25\\/80:active{
  background-color: rgb(250 253 247 / 0.8);
}

.active\\:bg-moss-25\\/85:active{
  background-color: rgb(250 253 247 / 0.85);
}

.active\\:bg-moss-25\\/90:active{
  background-color: rgb(250 253 247 / 0.9);
}

.active\\:bg-moss-25\\/95:active{
  background-color: rgb(250 253 247 / 0.95);
}

.active\\:bg-moss-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(134 203 60 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-400\\/0:active{
  background-color: rgb(134 203 60 / 0);
}

.active\\:bg-moss-400\\/10:active{
  background-color: rgb(134 203 60 / 0.1);
}

.active\\:bg-moss-400\\/100:active{
  background-color: rgb(134 203 60 / 1);
}

.active\\:bg-moss-400\\/15:active{
  background-color: rgb(134 203 60 / 0.15);
}

.active\\:bg-moss-400\\/20:active{
  background-color: rgb(134 203 60 / 0.2);
}

.active\\:bg-moss-400\\/25:active{
  background-color: rgb(134 203 60 / 0.25);
}

.active\\:bg-moss-400\\/30:active{
  background-color: rgb(134 203 60 / 0.3);
}

.active\\:bg-moss-400\\/35:active{
  background-color: rgb(134 203 60 / 0.35);
}

.active\\:bg-moss-400\\/40:active{
  background-color: rgb(134 203 60 / 0.4);
}

.active\\:bg-moss-400\\/45:active{
  background-color: rgb(134 203 60 / 0.45);
}

.active\\:bg-moss-400\\/5:active{
  background-color: rgb(134 203 60 / 0.05);
}

.active\\:bg-moss-400\\/50:active{
  background-color: rgb(134 203 60 / 0.5);
}

.active\\:bg-moss-400\\/55:active{
  background-color: rgb(134 203 60 / 0.55);
}

.active\\:bg-moss-400\\/60:active{
  background-color: rgb(134 203 60 / 0.6);
}

.active\\:bg-moss-400\\/65:active{
  background-color: rgb(134 203 60 / 0.65);
}

.active\\:bg-moss-400\\/70:active{
  background-color: rgb(134 203 60 / 0.7);
}

.active\\:bg-moss-400\\/75:active{
  background-color: rgb(134 203 60 / 0.75);
}

.active\\:bg-moss-400\\/80:active{
  background-color: rgb(134 203 60 / 0.8);
}

.active\\:bg-moss-400\\/85:active{
  background-color: rgb(134 203 60 / 0.85);
}

.active\\:bg-moss-400\\/90:active{
  background-color: rgb(134 203 60 / 0.9);
}

.active\\:bg-moss-400\\/95:active{
  background-color: rgb(134 203 60 / 0.95);
}

.active\\:bg-moss-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 238 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-50\\/0:active{
  background-color: rgb(245 251 238 / 0);
}

.active\\:bg-moss-50\\/10:active{
  background-color: rgb(245 251 238 / 0.1);
}

.active\\:bg-moss-50\\/100:active{
  background-color: rgb(245 251 238 / 1);
}

.active\\:bg-moss-50\\/15:active{
  background-color: rgb(245 251 238 / 0.15);
}

.active\\:bg-moss-50\\/20:active{
  background-color: rgb(245 251 238 / 0.2);
}

.active\\:bg-moss-50\\/25:active{
  background-color: rgb(245 251 238 / 0.25);
}

.active\\:bg-moss-50\\/30:active{
  background-color: rgb(245 251 238 / 0.3);
}

.active\\:bg-moss-50\\/35:active{
  background-color: rgb(245 251 238 / 0.35);
}

.active\\:bg-moss-50\\/40:active{
  background-color: rgb(245 251 238 / 0.4);
}

.active\\:bg-moss-50\\/45:active{
  background-color: rgb(245 251 238 / 0.45);
}

.active\\:bg-moss-50\\/5:active{
  background-color: rgb(245 251 238 / 0.05);
}

.active\\:bg-moss-50\\/50:active{
  background-color: rgb(245 251 238 / 0.5);
}

.active\\:bg-moss-50\\/55:active{
  background-color: rgb(245 251 238 / 0.55);
}

.active\\:bg-moss-50\\/60:active{
  background-color: rgb(245 251 238 / 0.6);
}

.active\\:bg-moss-50\\/65:active{
  background-color: rgb(245 251 238 / 0.65);
}

.active\\:bg-moss-50\\/70:active{
  background-color: rgb(245 251 238 / 0.7);
}

.active\\:bg-moss-50\\/75:active{
  background-color: rgb(245 251 238 / 0.75);
}

.active\\:bg-moss-50\\/80:active{
  background-color: rgb(245 251 238 / 0.8);
}

.active\\:bg-moss-50\\/85:active{
  background-color: rgb(245 251 238 / 0.85);
}

.active\\:bg-moss-50\\/90:active{
  background-color: rgb(245 251 238 / 0.9);
}

.active\\:bg-moss-50\\/95:active{
  background-color: rgb(245 251 238 / 0.95);
}

.active\\:bg-moss-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(102 159 42 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-500\\/0:active{
  background-color: rgb(102 159 42 / 0);
}

.active\\:bg-moss-500\\/10:active{
  background-color: rgb(102 159 42 / 0.1);
}

.active\\:bg-moss-500\\/100:active{
  background-color: rgb(102 159 42 / 1);
}

.active\\:bg-moss-500\\/15:active{
  background-color: rgb(102 159 42 / 0.15);
}

.active\\:bg-moss-500\\/20:active{
  background-color: rgb(102 159 42 / 0.2);
}

.active\\:bg-moss-500\\/25:active{
  background-color: rgb(102 159 42 / 0.25);
}

.active\\:bg-moss-500\\/30:active{
  background-color: rgb(102 159 42 / 0.3);
}

.active\\:bg-moss-500\\/35:active{
  background-color: rgb(102 159 42 / 0.35);
}

.active\\:bg-moss-500\\/40:active{
  background-color: rgb(102 159 42 / 0.4);
}

.active\\:bg-moss-500\\/45:active{
  background-color: rgb(102 159 42 / 0.45);
}

.active\\:bg-moss-500\\/5:active{
  background-color: rgb(102 159 42 / 0.05);
}

.active\\:bg-moss-500\\/50:active{
  background-color: rgb(102 159 42 / 0.5);
}

.active\\:bg-moss-500\\/55:active{
  background-color: rgb(102 159 42 / 0.55);
}

.active\\:bg-moss-500\\/60:active{
  background-color: rgb(102 159 42 / 0.6);
}

.active\\:bg-moss-500\\/65:active{
  background-color: rgb(102 159 42 / 0.65);
}

.active\\:bg-moss-500\\/70:active{
  background-color: rgb(102 159 42 / 0.7);
}

.active\\:bg-moss-500\\/75:active{
  background-color: rgb(102 159 42 / 0.75);
}

.active\\:bg-moss-500\\/80:active{
  background-color: rgb(102 159 42 / 0.8);
}

.active\\:bg-moss-500\\/85:active{
  background-color: rgb(102 159 42 / 0.85);
}

.active\\:bg-moss-500\\/90:active{
  background-color: rgb(102 159 42 / 0.9);
}

.active\\:bg-moss-500\\/95:active{
  background-color: rgb(102 159 42 / 0.95);
}

.active\\:bg-moss-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(79 122 33 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-600\\/0:active{
  background-color: rgb(79 122 33 / 0);
}

.active\\:bg-moss-600\\/10:active{
  background-color: rgb(79 122 33 / 0.1);
}

.active\\:bg-moss-600\\/100:active{
  background-color: rgb(79 122 33 / 1);
}

.active\\:bg-moss-600\\/15:active{
  background-color: rgb(79 122 33 / 0.15);
}

.active\\:bg-moss-600\\/20:active{
  background-color: rgb(79 122 33 / 0.2);
}

.active\\:bg-moss-600\\/25:active{
  background-color: rgb(79 122 33 / 0.25);
}

.active\\:bg-moss-600\\/30:active{
  background-color: rgb(79 122 33 / 0.3);
}

.active\\:bg-moss-600\\/35:active{
  background-color: rgb(79 122 33 / 0.35);
}

.active\\:bg-moss-600\\/40:active{
  background-color: rgb(79 122 33 / 0.4);
}

.active\\:bg-moss-600\\/45:active{
  background-color: rgb(79 122 33 / 0.45);
}

.active\\:bg-moss-600\\/5:active{
  background-color: rgb(79 122 33 / 0.05);
}

.active\\:bg-moss-600\\/50:active{
  background-color: rgb(79 122 33 / 0.5);
}

.active\\:bg-moss-600\\/55:active{
  background-color: rgb(79 122 33 / 0.55);
}

.active\\:bg-moss-600\\/60:active{
  background-color: rgb(79 122 33 / 0.6);
}

.active\\:bg-moss-600\\/65:active{
  background-color: rgb(79 122 33 / 0.65);
}

.active\\:bg-moss-600\\/70:active{
  background-color: rgb(79 122 33 / 0.7);
}

.active\\:bg-moss-600\\/75:active{
  background-color: rgb(79 122 33 / 0.75);
}

.active\\:bg-moss-600\\/80:active{
  background-color: rgb(79 122 33 / 0.8);
}

.active\\:bg-moss-600\\/85:active{
  background-color: rgb(79 122 33 / 0.85);
}

.active\\:bg-moss-600\\/90:active{
  background-color: rgb(79 122 33 / 0.9);
}

.active\\:bg-moss-600\\/95:active{
  background-color: rgb(79 122 33 / 0.95);
}

.active\\:bg-moss-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 26 / var(--tw-bg-opacity, 1));
}

.active\\:bg-moss-700\\/0:active{
  background-color: rgb(63 98 26 / 0);
}

.active\\:bg-moss-700\\/10:active{
  background-color: rgb(63 98 26 / 0.1);
}

.active\\:bg-moss-700\\/100:active{
  background-color: rgb(63 98 26 / 1);
}

.active\\:bg-moss-700\\/15:active{
  background-color: rgb(63 98 26 / 0.15);
}

.active\\:bg-moss-700\\/20:active{
  background-color: rgb(63 98 26 / 0.2);
}

.active\\:bg-moss-700\\/25:active{
  background-color: rgb(63 98 26 / 0.25);
}

.active\\:bg-moss-700\\/30:active{
  background-color: rgb(63 98 26 / 0.3);
}

.active\\:bg-moss-700\\/35:active{
  background-color: rgb(63 98 26 / 0.35);
}

.active\\:bg-moss-700\\/40:active{
  background-color: rgb(63 98 26 / 0.4);
}

.active\\:bg-moss-700\\/45:active{
  background-color: rgb(63 98 26 / 0.45);
}

.active\\:bg-moss-700\\/5:active{
  background-color: rgb(63 98 26 / 0.05);
}

.active\\:bg-moss-700\\/50:active{
  background-color: rgb(63 98 26 / 0.5);
}

.active\\:bg-moss-700\\/55:active{
  background-color: rgb(63 98 26 / 0.55);
}

.active\\:bg-moss-700\\/60:active{
  background-color: rgb(63 98 26 / 0.6);
}

.active\\:bg-moss-700\\/65:active{
  background-color: rgb(63 98 26 / 0.65);
}

.active\\:bg-moss-700\\/70:active{
  background-color: rgb(63 98 26 / 0.7);
}

.active\\:bg-moss-700\\/75:active{
  background-color: rgb(63 98 26 / 0.75);
}

.active\\:bg-moss-700\\/80:active{
  background-color: rgb(63 98 26 / 0.8);
}

.active\\:bg-moss-700\\/85:active{
  background-color: rgb(63 98 26 / 0.85);
}

.active\\:bg-moss-700\\/90:active{
  background-color: rgb(63 98 26 / 0.9);
}

.active\\:bg-moss-700\\/95:active{
  background-color: rgb(63 98 26 / 0.95);
}

.active\\:bg-neutral-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-100\\/0:active{
  background-color: rgb(245 245 245 / 0);
}

.active\\:bg-neutral-100\\/10:active{
  background-color: rgb(245 245 245 / 0.1);
}

.active\\:bg-neutral-100\\/100:active{
  background-color: rgb(245 245 245 / 1);
}

.active\\:bg-neutral-100\\/15:active{
  background-color: rgb(245 245 245 / 0.15);
}

.active\\:bg-neutral-100\\/20:active{
  background-color: rgb(245 245 245 / 0.2);
}

.active\\:bg-neutral-100\\/25:active{
  background-color: rgb(245 245 245 / 0.25);
}

.active\\:bg-neutral-100\\/30:active{
  background-color: rgb(245 245 245 / 0.3);
}

.active\\:bg-neutral-100\\/35:active{
  background-color: rgb(245 245 245 / 0.35);
}

.active\\:bg-neutral-100\\/40:active{
  background-color: rgb(245 245 245 / 0.4);
}

.active\\:bg-neutral-100\\/45:active{
  background-color: rgb(245 245 245 / 0.45);
}

.active\\:bg-neutral-100\\/5:active{
  background-color: rgb(245 245 245 / 0.05);
}

.active\\:bg-neutral-100\\/50:active{
  background-color: rgb(245 245 245 / 0.5);
}

.active\\:bg-neutral-100\\/55:active{
  background-color: rgb(245 245 245 / 0.55);
}

.active\\:bg-neutral-100\\/60:active{
  background-color: rgb(245 245 245 / 0.6);
}

.active\\:bg-neutral-100\\/65:active{
  background-color: rgb(245 245 245 / 0.65);
}

.active\\:bg-neutral-100\\/70:active{
  background-color: rgb(245 245 245 / 0.7);
}

.active\\:bg-neutral-100\\/75:active{
  background-color: rgb(245 245 245 / 0.75);
}

.active\\:bg-neutral-100\\/80:active{
  background-color: rgb(245 245 245 / 0.8);
}

.active\\:bg-neutral-100\\/85:active{
  background-color: rgb(245 245 245 / 0.85);
}

.active\\:bg-neutral-100\\/90:active{
  background-color: rgb(245 245 245 / 0.9);
}

.active\\:bg-neutral-100\\/95:active{
  background-color: rgb(245 245 245 / 0.95);
}

.active\\:bg-neutral-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-200\\/0:active{
  background-color: rgb(233 234 235 / 0);
}

.active\\:bg-neutral-200\\/10:active{
  background-color: rgb(233 234 235 / 0.1);
}

.active\\:bg-neutral-200\\/100:active{
  background-color: rgb(233 234 235 / 1);
}

.active\\:bg-neutral-200\\/15:active{
  background-color: rgb(233 234 235 / 0.15);
}

.active\\:bg-neutral-200\\/20:active{
  background-color: rgb(233 234 235 / 0.2);
}

.active\\:bg-neutral-200\\/25:active{
  background-color: rgb(233 234 235 / 0.25);
}

.active\\:bg-neutral-200\\/30:active{
  background-color: rgb(233 234 235 / 0.3);
}

.active\\:bg-neutral-200\\/35:active{
  background-color: rgb(233 234 235 / 0.35);
}

.active\\:bg-neutral-200\\/40:active{
  background-color: rgb(233 234 235 / 0.4);
}

.active\\:bg-neutral-200\\/45:active{
  background-color: rgb(233 234 235 / 0.45);
}

.active\\:bg-neutral-200\\/5:active{
  background-color: rgb(233 234 235 / 0.05);
}

.active\\:bg-neutral-200\\/50:active{
  background-color: rgb(233 234 235 / 0.5);
}

.active\\:bg-neutral-200\\/55:active{
  background-color: rgb(233 234 235 / 0.55);
}

.active\\:bg-neutral-200\\/60:active{
  background-color: rgb(233 234 235 / 0.6);
}

.active\\:bg-neutral-200\\/65:active{
  background-color: rgb(233 234 235 / 0.65);
}

.active\\:bg-neutral-200\\/70:active{
  background-color: rgb(233 234 235 / 0.7);
}

.active\\:bg-neutral-200\\/75:active{
  background-color: rgb(233 234 235 / 0.75);
}

.active\\:bg-neutral-200\\/80:active{
  background-color: rgb(233 234 235 / 0.8);
}

.active\\:bg-neutral-200\\/85:active{
  background-color: rgb(233 234 235 / 0.85);
}

.active\\:bg-neutral-200\\/90:active{
  background-color: rgb(233 234 235 / 0.9);
}

.active\\:bg-neutral-200\\/95:active{
  background-color: rgb(233 234 235 / 0.95);
}

.active\\:bg-neutral-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-25\\/0:active{
  background-color: rgb(253 253 253 / 0);
}

.active\\:bg-neutral-25\\/10:active{
  background-color: rgb(253 253 253 / 0.1);
}

.active\\:bg-neutral-25\\/100:active{
  background-color: rgb(253 253 253 / 1);
}

.active\\:bg-neutral-25\\/15:active{
  background-color: rgb(253 253 253 / 0.15);
}

.active\\:bg-neutral-25\\/20:active{
  background-color: rgb(253 253 253 / 0.2);
}

.active\\:bg-neutral-25\\/25:active{
  background-color: rgb(253 253 253 / 0.25);
}

.active\\:bg-neutral-25\\/30:active{
  background-color: rgb(253 253 253 / 0.3);
}

.active\\:bg-neutral-25\\/35:active{
  background-color: rgb(253 253 253 / 0.35);
}

.active\\:bg-neutral-25\\/40:active{
  background-color: rgb(253 253 253 / 0.4);
}

.active\\:bg-neutral-25\\/45:active{
  background-color: rgb(253 253 253 / 0.45);
}

.active\\:bg-neutral-25\\/5:active{
  background-color: rgb(253 253 253 / 0.05);
}

.active\\:bg-neutral-25\\/50:active{
  background-color: rgb(253 253 253 / 0.5);
}

.active\\:bg-neutral-25\\/55:active{
  background-color: rgb(253 253 253 / 0.55);
}

.active\\:bg-neutral-25\\/60:active{
  background-color: rgb(253 253 253 / 0.6);
}

.active\\:bg-neutral-25\\/65:active{
  background-color: rgb(253 253 253 / 0.65);
}

.active\\:bg-neutral-25\\/70:active{
  background-color: rgb(253 253 253 / 0.7);
}

.active\\:bg-neutral-25\\/75:active{
  background-color: rgb(253 253 253 / 0.75);
}

.active\\:bg-neutral-25\\/80:active{
  background-color: rgb(253 253 253 / 0.8);
}

.active\\:bg-neutral-25\\/85:active{
  background-color: rgb(253 253 253 / 0.85);
}

.active\\:bg-neutral-25\\/90:active{
  background-color: rgb(253 253 253 / 0.9);
}

.active\\:bg-neutral-25\\/95:active{
  background-color: rgb(253 253 253 / 0.95);
}

.active\\:bg-neutral-300:active{
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-400\\/0:active{
  background-color: rgb(164 167 174 / 0);
}

.active\\:bg-neutral-400\\/10:active{
  background-color: rgb(164 167 174 / 0.1);
}

.active\\:bg-neutral-400\\/100:active{
  background-color: rgb(164 167 174 / 1);
}

.active\\:bg-neutral-400\\/15:active{
  background-color: rgb(164 167 174 / 0.15);
}

.active\\:bg-neutral-400\\/20:active{
  background-color: rgb(164 167 174 / 0.2);
}

.active\\:bg-neutral-400\\/25:active{
  background-color: rgb(164 167 174 / 0.25);
}

.active\\:bg-neutral-400\\/30:active{
  background-color: rgb(164 167 174 / 0.3);
}

.active\\:bg-neutral-400\\/35:active{
  background-color: rgb(164 167 174 / 0.35);
}

.active\\:bg-neutral-400\\/40:active{
  background-color: rgb(164 167 174 / 0.4);
}

.active\\:bg-neutral-400\\/45:active{
  background-color: rgb(164 167 174 / 0.45);
}

.active\\:bg-neutral-400\\/5:active{
  background-color: rgb(164 167 174 / 0.05);
}

.active\\:bg-neutral-400\\/50:active{
  background-color: rgb(164 167 174 / 0.5);
}

.active\\:bg-neutral-400\\/55:active{
  background-color: rgb(164 167 174 / 0.55);
}

.active\\:bg-neutral-400\\/60:active{
  background-color: rgb(164 167 174 / 0.6);
}

.active\\:bg-neutral-400\\/65:active{
  background-color: rgb(164 167 174 / 0.65);
}

.active\\:bg-neutral-400\\/70:active{
  background-color: rgb(164 167 174 / 0.7);
}

.active\\:bg-neutral-400\\/75:active{
  background-color: rgb(164 167 174 / 0.75);
}

.active\\:bg-neutral-400\\/80:active{
  background-color: rgb(164 167 174 / 0.8);
}

.active\\:bg-neutral-400\\/85:active{
  background-color: rgb(164 167 174 / 0.85);
}

.active\\:bg-neutral-400\\/90:active{
  background-color: rgb(164 167 174 / 0.9);
}

.active\\:bg-neutral-400\\/95:active{
  background-color: rgb(164 167 174 / 0.95);
}

.active\\:bg-neutral-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-50\\/0:active{
  background-color: rgb(249 250 250 / 0);
}

.active\\:bg-neutral-50\\/10:active{
  background-color: rgb(249 250 250 / 0.1);
}

.active\\:bg-neutral-50\\/100:active{
  background-color: rgb(249 250 250 / 1);
}

.active\\:bg-neutral-50\\/15:active{
  background-color: rgb(249 250 250 / 0.15);
}

.active\\:bg-neutral-50\\/20:active{
  background-color: rgb(249 250 250 / 0.2);
}

.active\\:bg-neutral-50\\/25:active{
  background-color: rgb(249 250 250 / 0.25);
}

.active\\:bg-neutral-50\\/30:active{
  background-color: rgb(249 250 250 / 0.3);
}

.active\\:bg-neutral-50\\/35:active{
  background-color: rgb(249 250 250 / 0.35);
}

.active\\:bg-neutral-50\\/40:active{
  background-color: rgb(249 250 250 / 0.4);
}

.active\\:bg-neutral-50\\/45:active{
  background-color: rgb(249 250 250 / 0.45);
}

.active\\:bg-neutral-50\\/5:active{
  background-color: rgb(249 250 250 / 0.05);
}

.active\\:bg-neutral-50\\/50:active{
  background-color: rgb(249 250 250 / 0.5);
}

.active\\:bg-neutral-50\\/55:active{
  background-color: rgb(249 250 250 / 0.55);
}

.active\\:bg-neutral-50\\/60:active{
  background-color: rgb(249 250 250 / 0.6);
}

.active\\:bg-neutral-50\\/65:active{
  background-color: rgb(249 250 250 / 0.65);
}

.active\\:bg-neutral-50\\/70:active{
  background-color: rgb(249 250 250 / 0.7);
}

.active\\:bg-neutral-50\\/75:active{
  background-color: rgb(249 250 250 / 0.75);
}

.active\\:bg-neutral-50\\/80:active{
  background-color: rgb(249 250 250 / 0.8);
}

.active\\:bg-neutral-50\\/85:active{
  background-color: rgb(249 250 250 / 0.85);
}

.active\\:bg-neutral-50\\/90:active{
  background-color: rgb(249 250 250 / 0.9);
}

.active\\:bg-neutral-50\\/95:active{
  background-color: rgb(249 250 250 / 0.95);
}

.active\\:bg-neutral-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-500\\/0:active{
  background-color: rgb(113 118 128 / 0);
}

.active\\:bg-neutral-500\\/10:active{
  background-color: rgb(113 118 128 / 0.1);
}

.active\\:bg-neutral-500\\/100:active{
  background-color: rgb(113 118 128 / 1);
}

.active\\:bg-neutral-500\\/15:active{
  background-color: rgb(113 118 128 / 0.15);
}

.active\\:bg-neutral-500\\/20:active{
  background-color: rgb(113 118 128 / 0.2);
}

.active\\:bg-neutral-500\\/25:active{
  background-color: rgb(113 118 128 / 0.25);
}

.active\\:bg-neutral-500\\/30:active{
  background-color: rgb(113 118 128 / 0.3);
}

.active\\:bg-neutral-500\\/35:active{
  background-color: rgb(113 118 128 / 0.35);
}

.active\\:bg-neutral-500\\/40:active{
  background-color: rgb(113 118 128 / 0.4);
}

.active\\:bg-neutral-500\\/45:active{
  background-color: rgb(113 118 128 / 0.45);
}

.active\\:bg-neutral-500\\/5:active{
  background-color: rgb(113 118 128 / 0.05);
}

.active\\:bg-neutral-500\\/50:active{
  background-color: rgb(113 118 128 / 0.5);
}

.active\\:bg-neutral-500\\/55:active{
  background-color: rgb(113 118 128 / 0.55);
}

.active\\:bg-neutral-500\\/60:active{
  background-color: rgb(113 118 128 / 0.6);
}

.active\\:bg-neutral-500\\/65:active{
  background-color: rgb(113 118 128 / 0.65);
}

.active\\:bg-neutral-500\\/70:active{
  background-color: rgb(113 118 128 / 0.7);
}

.active\\:bg-neutral-500\\/75:active{
  background-color: rgb(113 118 128 / 0.75);
}

.active\\:bg-neutral-500\\/80:active{
  background-color: rgb(113 118 128 / 0.8);
}

.active\\:bg-neutral-500\\/85:active{
  background-color: rgb(113 118 128 / 0.85);
}

.active\\:bg-neutral-500\\/90:active{
  background-color: rgb(113 118 128 / 0.9);
}

.active\\:bg-neutral-500\\/95:active{
  background-color: rgb(113 118 128 / 0.95);
}

.active\\:bg-neutral-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-600\\/0:active{
  background-color: rgb(83 88 98 / 0);
}

.active\\:bg-neutral-600\\/10:active{
  background-color: rgb(83 88 98 / 0.1);
}

.active\\:bg-neutral-600\\/100:active{
  background-color: rgb(83 88 98 / 1);
}

.active\\:bg-neutral-600\\/15:active{
  background-color: rgb(83 88 98 / 0.15);
}

.active\\:bg-neutral-600\\/20:active{
  background-color: rgb(83 88 98 / 0.2);
}

.active\\:bg-neutral-600\\/25:active{
  background-color: rgb(83 88 98 / 0.25);
}

.active\\:bg-neutral-600\\/30:active{
  background-color: rgb(83 88 98 / 0.3);
}

.active\\:bg-neutral-600\\/35:active{
  background-color: rgb(83 88 98 / 0.35);
}

.active\\:bg-neutral-600\\/40:active{
  background-color: rgb(83 88 98 / 0.4);
}

.active\\:bg-neutral-600\\/45:active{
  background-color: rgb(83 88 98 / 0.45);
}

.active\\:bg-neutral-600\\/5:active{
  background-color: rgb(83 88 98 / 0.05);
}

.active\\:bg-neutral-600\\/50:active{
  background-color: rgb(83 88 98 / 0.5);
}

.active\\:bg-neutral-600\\/55:active{
  background-color: rgb(83 88 98 / 0.55);
}

.active\\:bg-neutral-600\\/60:active{
  background-color: rgb(83 88 98 / 0.6);
}

.active\\:bg-neutral-600\\/65:active{
  background-color: rgb(83 88 98 / 0.65);
}

.active\\:bg-neutral-600\\/70:active{
  background-color: rgb(83 88 98 / 0.7);
}

.active\\:bg-neutral-600\\/75:active{
  background-color: rgb(83 88 98 / 0.75);
}

.active\\:bg-neutral-600\\/80:active{
  background-color: rgb(83 88 98 / 0.8);
}

.active\\:bg-neutral-600\\/85:active{
  background-color: rgb(83 88 98 / 0.85);
}

.active\\:bg-neutral-600\\/90:active{
  background-color: rgb(83 88 98 / 0.9);
}

.active\\:bg-neutral-600\\/95:active{
  background-color: rgb(83 88 98 / 0.95);
}

.active\\:bg-neutral-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-700\\/0:active{
  background-color: rgb(65 70 81 / 0);
}

.active\\:bg-neutral-700\\/10:active{
  background-color: rgb(65 70 81 / 0.1);
}

.active\\:bg-neutral-700\\/100:active{
  background-color: rgb(65 70 81 / 1);
}

.active\\:bg-neutral-700\\/15:active{
  background-color: rgb(65 70 81 / 0.15);
}

.active\\:bg-neutral-700\\/20:active{
  background-color: rgb(65 70 81 / 0.2);
}

.active\\:bg-neutral-700\\/25:active{
  background-color: rgb(65 70 81 / 0.25);
}

.active\\:bg-neutral-700\\/30:active{
  background-color: rgb(65 70 81 / 0.3);
}

.active\\:bg-neutral-700\\/35:active{
  background-color: rgb(65 70 81 / 0.35);
}

.active\\:bg-neutral-700\\/40:active{
  background-color: rgb(65 70 81 / 0.4);
}

.active\\:bg-neutral-700\\/45:active{
  background-color: rgb(65 70 81 / 0.45);
}

.active\\:bg-neutral-700\\/5:active{
  background-color: rgb(65 70 81 / 0.05);
}

.active\\:bg-neutral-700\\/50:active{
  background-color: rgb(65 70 81 / 0.5);
}

.active\\:bg-neutral-700\\/55:active{
  background-color: rgb(65 70 81 / 0.55);
}

.active\\:bg-neutral-700\\/60:active{
  background-color: rgb(65 70 81 / 0.6);
}

.active\\:bg-neutral-700\\/65:active{
  background-color: rgb(65 70 81 / 0.65);
}

.active\\:bg-neutral-700\\/70:active{
  background-color: rgb(65 70 81 / 0.7);
}

.active\\:bg-neutral-700\\/75:active{
  background-color: rgb(65 70 81 / 0.75);
}

.active\\:bg-neutral-700\\/80:active{
  background-color: rgb(65 70 81 / 0.8);
}

.active\\:bg-neutral-700\\/85:active{
  background-color: rgb(65 70 81 / 0.85);
}

.active\\:bg-neutral-700\\/90:active{
  background-color: rgb(65 70 81 / 0.9);
}

.active\\:bg-neutral-700\\/95:active{
  background-color: rgb(65 70 81 / 0.95);
}

.active\\:bg-neutral-75:active{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-75\\/0:active{
  background-color: rgb(246 246 246 / 0);
}

.active\\:bg-neutral-75\\/10:active{
  background-color: rgb(246 246 246 / 0.1);
}

.active\\:bg-neutral-75\\/100:active{
  background-color: rgb(246 246 246 / 1);
}

.active\\:bg-neutral-75\\/15:active{
  background-color: rgb(246 246 246 / 0.15);
}

.active\\:bg-neutral-75\\/20:active{
  background-color: rgb(246 246 246 / 0.2);
}

.active\\:bg-neutral-75\\/25:active{
  background-color: rgb(246 246 246 / 0.25);
}

.active\\:bg-neutral-75\\/30:active{
  background-color: rgb(246 246 246 / 0.3);
}

.active\\:bg-neutral-75\\/35:active{
  background-color: rgb(246 246 246 / 0.35);
}

.active\\:bg-neutral-75\\/40:active{
  background-color: rgb(246 246 246 / 0.4);
}

.active\\:bg-neutral-75\\/45:active{
  background-color: rgb(246 246 246 / 0.45);
}

.active\\:bg-neutral-75\\/5:active{
  background-color: rgb(246 246 246 / 0.05);
}

.active\\:bg-neutral-75\\/50:active{
  background-color: rgb(246 246 246 / 0.5);
}

.active\\:bg-neutral-75\\/55:active{
  background-color: rgb(246 246 246 / 0.55);
}

.active\\:bg-neutral-75\\/60:active{
  background-color: rgb(246 246 246 / 0.6);
}

.active\\:bg-neutral-75\\/65:active{
  background-color: rgb(246 246 246 / 0.65);
}

.active\\:bg-neutral-75\\/70:active{
  background-color: rgb(246 246 246 / 0.7);
}

.active\\:bg-neutral-75\\/75:active{
  background-color: rgb(246 246 246 / 0.75);
}

.active\\:bg-neutral-75\\/80:active{
  background-color: rgb(246 246 246 / 0.8);
}

.active\\:bg-neutral-75\\/85:active{
  background-color: rgb(246 246 246 / 0.85);
}

.active\\:bg-neutral-75\\/90:active{
  background-color: rgb(246 246 246 / 0.9);
}

.active\\:bg-neutral-75\\/95:active{
  background-color: rgb(246 246 246 / 0.95);
}

.active\\:bg-primary-100:active{
  background-color: var(--color-primary-100, #E0F2FE);
}

.active\\:bg-primary-200:active{
  background-color: var(--color-primary-200, #B9E6FE);
}

.active\\:bg-primary-25:active{
  background-color: var(--color-primary-25, #F5FBFF);
}

.active\\:bg-primary-400:active{
  background-color: var(--color-primary-400, #36BFFA);
}

.active\\:bg-primary-50:active{
  background-color: var(--color-primary-50, #F0F9FF);
}

.active\\:bg-primary-500:active{
  background-color: var(--color-primary-500, #0BA5EC);
}

.active\\:bg-primary-600:active{
  background-color: var(--color-primary-600, #0086C9);
}

.active\\:bg-primary-700:active{
  background-color: var(--color-primary-700, #026AA2);
}

.active\\:bg-purple-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-100\\/0:active{
  background-color: rgb(235 233 254 / 0);
}

.active\\:bg-purple-100\\/10:active{
  background-color: rgb(235 233 254 / 0.1);
}

.active\\:bg-purple-100\\/100:active{
  background-color: rgb(235 233 254 / 1);
}

.active\\:bg-purple-100\\/15:active{
  background-color: rgb(235 233 254 / 0.15);
}

.active\\:bg-purple-100\\/20:active{
  background-color: rgb(235 233 254 / 0.2);
}

.active\\:bg-purple-100\\/25:active{
  background-color: rgb(235 233 254 / 0.25);
}

.active\\:bg-purple-100\\/30:active{
  background-color: rgb(235 233 254 / 0.3);
}

.active\\:bg-purple-100\\/35:active{
  background-color: rgb(235 233 254 / 0.35);
}

.active\\:bg-purple-100\\/40:active{
  background-color: rgb(235 233 254 / 0.4);
}

.active\\:bg-purple-100\\/45:active{
  background-color: rgb(235 233 254 / 0.45);
}

.active\\:bg-purple-100\\/5:active{
  background-color: rgb(235 233 254 / 0.05);
}

.active\\:bg-purple-100\\/50:active{
  background-color: rgb(235 233 254 / 0.5);
}

.active\\:bg-purple-100\\/55:active{
  background-color: rgb(235 233 254 / 0.55);
}

.active\\:bg-purple-100\\/60:active{
  background-color: rgb(235 233 254 / 0.6);
}

.active\\:bg-purple-100\\/65:active{
  background-color: rgb(235 233 254 / 0.65);
}

.active\\:bg-purple-100\\/70:active{
  background-color: rgb(235 233 254 / 0.7);
}

.active\\:bg-purple-100\\/75:active{
  background-color: rgb(235 233 254 / 0.75);
}

.active\\:bg-purple-100\\/80:active{
  background-color: rgb(235 233 254 / 0.8);
}

.active\\:bg-purple-100\\/85:active{
  background-color: rgb(235 233 254 / 0.85);
}

.active\\:bg-purple-100\\/90:active{
  background-color: rgb(235 233 254 / 0.9);
}

.active\\:bg-purple-100\\/95:active{
  background-color: rgb(235 233 254 / 0.95);
}

.active\\:bg-purple-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-200\\/0:active{
  background-color: rgb(217 214 254 / 0);
}

.active\\:bg-purple-200\\/10:active{
  background-color: rgb(217 214 254 / 0.1);
}

.active\\:bg-purple-200\\/100:active{
  background-color: rgb(217 214 254 / 1);
}

.active\\:bg-purple-200\\/15:active{
  background-color: rgb(217 214 254 / 0.15);
}

.active\\:bg-purple-200\\/20:active{
  background-color: rgb(217 214 254 / 0.2);
}

.active\\:bg-purple-200\\/25:active{
  background-color: rgb(217 214 254 / 0.25);
}

.active\\:bg-purple-200\\/30:active{
  background-color: rgb(217 214 254 / 0.3);
}

.active\\:bg-purple-200\\/35:active{
  background-color: rgb(217 214 254 / 0.35);
}

.active\\:bg-purple-200\\/40:active{
  background-color: rgb(217 214 254 / 0.4);
}

.active\\:bg-purple-200\\/45:active{
  background-color: rgb(217 214 254 / 0.45);
}

.active\\:bg-purple-200\\/5:active{
  background-color: rgb(217 214 254 / 0.05);
}

.active\\:bg-purple-200\\/50:active{
  background-color: rgb(217 214 254 / 0.5);
}

.active\\:bg-purple-200\\/55:active{
  background-color: rgb(217 214 254 / 0.55);
}

.active\\:bg-purple-200\\/60:active{
  background-color: rgb(217 214 254 / 0.6);
}

.active\\:bg-purple-200\\/65:active{
  background-color: rgb(217 214 254 / 0.65);
}

.active\\:bg-purple-200\\/70:active{
  background-color: rgb(217 214 254 / 0.7);
}

.active\\:bg-purple-200\\/75:active{
  background-color: rgb(217 214 254 / 0.75);
}

.active\\:bg-purple-200\\/80:active{
  background-color: rgb(217 214 254 / 0.8);
}

.active\\:bg-purple-200\\/85:active{
  background-color: rgb(217 214 254 / 0.85);
}

.active\\:bg-purple-200\\/90:active{
  background-color: rgb(217 214 254 / 0.9);
}

.active\\:bg-purple-200\\/95:active{
  background-color: rgb(217 214 254 / 0.95);
}

.active\\:bg-purple-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-25\\/0:active{
  background-color: rgb(250 250 255 / 0);
}

.active\\:bg-purple-25\\/10:active{
  background-color: rgb(250 250 255 / 0.1);
}

.active\\:bg-purple-25\\/100:active{
  background-color: rgb(250 250 255 / 1);
}

.active\\:bg-purple-25\\/15:active{
  background-color: rgb(250 250 255 / 0.15);
}

.active\\:bg-purple-25\\/20:active{
  background-color: rgb(250 250 255 / 0.2);
}

.active\\:bg-purple-25\\/25:active{
  background-color: rgb(250 250 255 / 0.25);
}

.active\\:bg-purple-25\\/30:active{
  background-color: rgb(250 250 255 / 0.3);
}

.active\\:bg-purple-25\\/35:active{
  background-color: rgb(250 250 255 / 0.35);
}

.active\\:bg-purple-25\\/40:active{
  background-color: rgb(250 250 255 / 0.4);
}

.active\\:bg-purple-25\\/45:active{
  background-color: rgb(250 250 255 / 0.45);
}

.active\\:bg-purple-25\\/5:active{
  background-color: rgb(250 250 255 / 0.05);
}

.active\\:bg-purple-25\\/50:active{
  background-color: rgb(250 250 255 / 0.5);
}

.active\\:bg-purple-25\\/55:active{
  background-color: rgb(250 250 255 / 0.55);
}

.active\\:bg-purple-25\\/60:active{
  background-color: rgb(250 250 255 / 0.6);
}

.active\\:bg-purple-25\\/65:active{
  background-color: rgb(250 250 255 / 0.65);
}

.active\\:bg-purple-25\\/70:active{
  background-color: rgb(250 250 255 / 0.7);
}

.active\\:bg-purple-25\\/75:active{
  background-color: rgb(250 250 255 / 0.75);
}

.active\\:bg-purple-25\\/80:active{
  background-color: rgb(250 250 255 / 0.8);
}

.active\\:bg-purple-25\\/85:active{
  background-color: rgb(250 250 255 / 0.85);
}

.active\\:bg-purple-25\\/90:active{
  background-color: rgb(250 250 255 / 0.9);
}

.active\\:bg-purple-25\\/95:active{
  background-color: rgb(250 250 255 / 0.95);
}

.active\\:bg-purple-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-400\\/0:active{
  background-color: rgb(155 138 251 / 0);
}

.active\\:bg-purple-400\\/10:active{
  background-color: rgb(155 138 251 / 0.1);
}

.active\\:bg-purple-400\\/100:active{
  background-color: rgb(155 138 251 / 1);
}

.active\\:bg-purple-400\\/15:active{
  background-color: rgb(155 138 251 / 0.15);
}

.active\\:bg-purple-400\\/20:active{
  background-color: rgb(155 138 251 / 0.2);
}

.active\\:bg-purple-400\\/25:active{
  background-color: rgb(155 138 251 / 0.25);
}

.active\\:bg-purple-400\\/30:active{
  background-color: rgb(155 138 251 / 0.3);
}

.active\\:bg-purple-400\\/35:active{
  background-color: rgb(155 138 251 / 0.35);
}

.active\\:bg-purple-400\\/40:active{
  background-color: rgb(155 138 251 / 0.4);
}

.active\\:bg-purple-400\\/45:active{
  background-color: rgb(155 138 251 / 0.45);
}

.active\\:bg-purple-400\\/5:active{
  background-color: rgb(155 138 251 / 0.05);
}

.active\\:bg-purple-400\\/50:active{
  background-color: rgb(155 138 251 / 0.5);
}

.active\\:bg-purple-400\\/55:active{
  background-color: rgb(155 138 251 / 0.55);
}

.active\\:bg-purple-400\\/60:active{
  background-color: rgb(155 138 251 / 0.6);
}

.active\\:bg-purple-400\\/65:active{
  background-color: rgb(155 138 251 / 0.65);
}

.active\\:bg-purple-400\\/70:active{
  background-color: rgb(155 138 251 / 0.7);
}

.active\\:bg-purple-400\\/75:active{
  background-color: rgb(155 138 251 / 0.75);
}

.active\\:bg-purple-400\\/80:active{
  background-color: rgb(155 138 251 / 0.8);
}

.active\\:bg-purple-400\\/85:active{
  background-color: rgb(155 138 251 / 0.85);
}

.active\\:bg-purple-400\\/90:active{
  background-color: rgb(155 138 251 / 0.9);
}

.active\\:bg-purple-400\\/95:active{
  background-color: rgb(155 138 251 / 0.95);
}

.active\\:bg-purple-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-50\\/0:active{
  background-color: rgb(244 243 255 / 0);
}

.active\\:bg-purple-50\\/10:active{
  background-color: rgb(244 243 255 / 0.1);
}

.active\\:bg-purple-50\\/100:active{
  background-color: rgb(244 243 255 / 1);
}

.active\\:bg-purple-50\\/15:active{
  background-color: rgb(244 243 255 / 0.15);
}

.active\\:bg-purple-50\\/20:active{
  background-color: rgb(244 243 255 / 0.2);
}

.active\\:bg-purple-50\\/25:active{
  background-color: rgb(244 243 255 / 0.25);
}

.active\\:bg-purple-50\\/30:active{
  background-color: rgb(244 243 255 / 0.3);
}

.active\\:bg-purple-50\\/35:active{
  background-color: rgb(244 243 255 / 0.35);
}

.active\\:bg-purple-50\\/40:active{
  background-color: rgb(244 243 255 / 0.4);
}

.active\\:bg-purple-50\\/45:active{
  background-color: rgb(244 243 255 / 0.45);
}

.active\\:bg-purple-50\\/5:active{
  background-color: rgb(244 243 255 / 0.05);
}

.active\\:bg-purple-50\\/50:active{
  background-color: rgb(244 243 255 / 0.5);
}

.active\\:bg-purple-50\\/55:active{
  background-color: rgb(244 243 255 / 0.55);
}

.active\\:bg-purple-50\\/60:active{
  background-color: rgb(244 243 255 / 0.6);
}

.active\\:bg-purple-50\\/65:active{
  background-color: rgb(244 243 255 / 0.65);
}

.active\\:bg-purple-50\\/70:active{
  background-color: rgb(244 243 255 / 0.7);
}

.active\\:bg-purple-50\\/75:active{
  background-color: rgb(244 243 255 / 0.75);
}

.active\\:bg-purple-50\\/80:active{
  background-color: rgb(244 243 255 / 0.8);
}

.active\\:bg-purple-50\\/85:active{
  background-color: rgb(244 243 255 / 0.85);
}

.active\\:bg-purple-50\\/90:active{
  background-color: rgb(244 243 255 / 0.9);
}

.active\\:bg-purple-50\\/95:active{
  background-color: rgb(244 243 255 / 0.95);
}

.active\\:bg-purple-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-500\\/0:active{
  background-color: rgb(122 90 248 / 0);
}

.active\\:bg-purple-500\\/10:active{
  background-color: rgb(122 90 248 / 0.1);
}

.active\\:bg-purple-500\\/100:active{
  background-color: rgb(122 90 248 / 1);
}

.active\\:bg-purple-500\\/15:active{
  background-color: rgb(122 90 248 / 0.15);
}

.active\\:bg-purple-500\\/20:active{
  background-color: rgb(122 90 248 / 0.2);
}

.active\\:bg-purple-500\\/25:active{
  background-color: rgb(122 90 248 / 0.25);
}

.active\\:bg-purple-500\\/30:active{
  background-color: rgb(122 90 248 / 0.3);
}

.active\\:bg-purple-500\\/35:active{
  background-color: rgb(122 90 248 / 0.35);
}

.active\\:bg-purple-500\\/40:active{
  background-color: rgb(122 90 248 / 0.4);
}

.active\\:bg-purple-500\\/45:active{
  background-color: rgb(122 90 248 / 0.45);
}

.active\\:bg-purple-500\\/5:active{
  background-color: rgb(122 90 248 / 0.05);
}

.active\\:bg-purple-500\\/50:active{
  background-color: rgb(122 90 248 / 0.5);
}

.active\\:bg-purple-500\\/55:active{
  background-color: rgb(122 90 248 / 0.55);
}

.active\\:bg-purple-500\\/60:active{
  background-color: rgb(122 90 248 / 0.6);
}

.active\\:bg-purple-500\\/65:active{
  background-color: rgb(122 90 248 / 0.65);
}

.active\\:bg-purple-500\\/70:active{
  background-color: rgb(122 90 248 / 0.7);
}

.active\\:bg-purple-500\\/75:active{
  background-color: rgb(122 90 248 / 0.75);
}

.active\\:bg-purple-500\\/80:active{
  background-color: rgb(122 90 248 / 0.8);
}

.active\\:bg-purple-500\\/85:active{
  background-color: rgb(122 90 248 / 0.85);
}

.active\\:bg-purple-500\\/90:active{
  background-color: rgb(122 90 248 / 0.9);
}

.active\\:bg-purple-500\\/95:active{
  background-color: rgb(122 90 248 / 0.95);
}

.active\\:bg-purple-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-600\\/0:active{
  background-color: rgb(105 56 239 / 0);
}

.active\\:bg-purple-600\\/10:active{
  background-color: rgb(105 56 239 / 0.1);
}

.active\\:bg-purple-600\\/100:active{
  background-color: rgb(105 56 239 / 1);
}

.active\\:bg-purple-600\\/15:active{
  background-color: rgb(105 56 239 / 0.15);
}

.active\\:bg-purple-600\\/20:active{
  background-color: rgb(105 56 239 / 0.2);
}

.active\\:bg-purple-600\\/25:active{
  background-color: rgb(105 56 239 / 0.25);
}

.active\\:bg-purple-600\\/30:active{
  background-color: rgb(105 56 239 / 0.3);
}

.active\\:bg-purple-600\\/35:active{
  background-color: rgb(105 56 239 / 0.35);
}

.active\\:bg-purple-600\\/40:active{
  background-color: rgb(105 56 239 / 0.4);
}

.active\\:bg-purple-600\\/45:active{
  background-color: rgb(105 56 239 / 0.45);
}

.active\\:bg-purple-600\\/5:active{
  background-color: rgb(105 56 239 / 0.05);
}

.active\\:bg-purple-600\\/50:active{
  background-color: rgb(105 56 239 / 0.5);
}

.active\\:bg-purple-600\\/55:active{
  background-color: rgb(105 56 239 / 0.55);
}

.active\\:bg-purple-600\\/60:active{
  background-color: rgb(105 56 239 / 0.6);
}

.active\\:bg-purple-600\\/65:active{
  background-color: rgb(105 56 239 / 0.65);
}

.active\\:bg-purple-600\\/70:active{
  background-color: rgb(105 56 239 / 0.7);
}

.active\\:bg-purple-600\\/75:active{
  background-color: rgb(105 56 239 / 0.75);
}

.active\\:bg-purple-600\\/80:active{
  background-color: rgb(105 56 239 / 0.8);
}

.active\\:bg-purple-600\\/85:active{
  background-color: rgb(105 56 239 / 0.85);
}

.active\\:bg-purple-600\\/90:active{
  background-color: rgb(105 56 239 / 0.9);
}

.active\\:bg-purple-600\\/95:active{
  background-color: rgb(105 56 239 / 0.95);
}

.active\\:bg-purple-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}

.active\\:bg-purple-700\\/0:active{
  background-color: rgb(89 37 220 / 0);
}

.active\\:bg-purple-700\\/10:active{
  background-color: rgb(89 37 220 / 0.1);
}

.active\\:bg-purple-700\\/100:active{
  background-color: rgb(89 37 220 / 1);
}

.active\\:bg-purple-700\\/15:active{
  background-color: rgb(89 37 220 / 0.15);
}

.active\\:bg-purple-700\\/20:active{
  background-color: rgb(89 37 220 / 0.2);
}

.active\\:bg-purple-700\\/25:active{
  background-color: rgb(89 37 220 / 0.25);
}

.active\\:bg-purple-700\\/30:active{
  background-color: rgb(89 37 220 / 0.3);
}

.active\\:bg-purple-700\\/35:active{
  background-color: rgb(89 37 220 / 0.35);
}

.active\\:bg-purple-700\\/40:active{
  background-color: rgb(89 37 220 / 0.4);
}

.active\\:bg-purple-700\\/45:active{
  background-color: rgb(89 37 220 / 0.45);
}

.active\\:bg-purple-700\\/5:active{
  background-color: rgb(89 37 220 / 0.05);
}

.active\\:bg-purple-700\\/50:active{
  background-color: rgb(89 37 220 / 0.5);
}

.active\\:bg-purple-700\\/55:active{
  background-color: rgb(89 37 220 / 0.55);
}

.active\\:bg-purple-700\\/60:active{
  background-color: rgb(89 37 220 / 0.6);
}

.active\\:bg-purple-700\\/65:active{
  background-color: rgb(89 37 220 / 0.65);
}

.active\\:bg-purple-700\\/70:active{
  background-color: rgb(89 37 220 / 0.7);
}

.active\\:bg-purple-700\\/75:active{
  background-color: rgb(89 37 220 / 0.75);
}

.active\\:bg-purple-700\\/80:active{
  background-color: rgb(89 37 220 / 0.8);
}

.active\\:bg-purple-700\\/85:active{
  background-color: rgb(89 37 220 / 0.85);
}

.active\\:bg-purple-700\\/90:active{
  background-color: rgb(89 37 220 / 0.9);
}

.active\\:bg-purple-700\\/95:active{
  background-color: rgb(89 37 220 / 0.95);
}

.active\\:bg-success-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(211 248 223 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-100\\/0:active{
  background-color: rgb(211 248 223 / 0);
}

.active\\:bg-success-100\\/10:active{
  background-color: rgb(211 248 223 / 0.1);
}

.active\\:bg-success-100\\/100:active{
  background-color: rgb(211 248 223 / 1);
}

.active\\:bg-success-100\\/15:active{
  background-color: rgb(211 248 223 / 0.15);
}

.active\\:bg-success-100\\/20:active{
  background-color: rgb(211 248 223 / 0.2);
}

.active\\:bg-success-100\\/25:active{
  background-color: rgb(211 248 223 / 0.25);
}

.active\\:bg-success-100\\/30:active{
  background-color: rgb(211 248 223 / 0.3);
}

.active\\:bg-success-100\\/35:active{
  background-color: rgb(211 248 223 / 0.35);
}

.active\\:bg-success-100\\/40:active{
  background-color: rgb(211 248 223 / 0.4);
}

.active\\:bg-success-100\\/45:active{
  background-color: rgb(211 248 223 / 0.45);
}

.active\\:bg-success-100\\/5:active{
  background-color: rgb(211 248 223 / 0.05);
}

.active\\:bg-success-100\\/50:active{
  background-color: rgb(211 248 223 / 0.5);
}

.active\\:bg-success-100\\/55:active{
  background-color: rgb(211 248 223 / 0.55);
}

.active\\:bg-success-100\\/60:active{
  background-color: rgb(211 248 223 / 0.6);
}

.active\\:bg-success-100\\/65:active{
  background-color: rgb(211 248 223 / 0.65);
}

.active\\:bg-success-100\\/70:active{
  background-color: rgb(211 248 223 / 0.7);
}

.active\\:bg-success-100\\/75:active{
  background-color: rgb(211 248 223 / 0.75);
}

.active\\:bg-success-100\\/80:active{
  background-color: rgb(211 248 223 / 0.8);
}

.active\\:bg-success-100\\/85:active{
  background-color: rgb(211 248 223 / 0.85);
}

.active\\:bg-success-100\\/90:active{
  background-color: rgb(211 248 223 / 0.9);
}

.active\\:bg-success-100\\/95:active{
  background-color: rgb(211 248 223 / 0.95);
}

.active\\:bg-success-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(170 240 196 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-200\\/0:active{
  background-color: rgb(170 240 196 / 0);
}

.active\\:bg-success-200\\/10:active{
  background-color: rgb(170 240 196 / 0.1);
}

.active\\:bg-success-200\\/100:active{
  background-color: rgb(170 240 196 / 1);
}

.active\\:bg-success-200\\/15:active{
  background-color: rgb(170 240 196 / 0.15);
}

.active\\:bg-success-200\\/20:active{
  background-color: rgb(170 240 196 / 0.2);
}

.active\\:bg-success-200\\/25:active{
  background-color: rgb(170 240 196 / 0.25);
}

.active\\:bg-success-200\\/30:active{
  background-color: rgb(170 240 196 / 0.3);
}

.active\\:bg-success-200\\/35:active{
  background-color: rgb(170 240 196 / 0.35);
}

.active\\:bg-success-200\\/40:active{
  background-color: rgb(170 240 196 / 0.4);
}

.active\\:bg-success-200\\/45:active{
  background-color: rgb(170 240 196 / 0.45);
}

.active\\:bg-success-200\\/5:active{
  background-color: rgb(170 240 196 / 0.05);
}

.active\\:bg-success-200\\/50:active{
  background-color: rgb(170 240 196 / 0.5);
}

.active\\:bg-success-200\\/55:active{
  background-color: rgb(170 240 196 / 0.55);
}

.active\\:bg-success-200\\/60:active{
  background-color: rgb(170 240 196 / 0.6);
}

.active\\:bg-success-200\\/65:active{
  background-color: rgb(170 240 196 / 0.65);
}

.active\\:bg-success-200\\/70:active{
  background-color: rgb(170 240 196 / 0.7);
}

.active\\:bg-success-200\\/75:active{
  background-color: rgb(170 240 196 / 0.75);
}

.active\\:bg-success-200\\/80:active{
  background-color: rgb(170 240 196 / 0.8);
}

.active\\:bg-success-200\\/85:active{
  background-color: rgb(170 240 196 / 0.85);
}

.active\\:bg-success-200\\/90:active{
  background-color: rgb(170 240 196 / 0.9);
}

.active\\:bg-success-200\\/95:active{
  background-color: rgb(170 240 196 / 0.95);
}

.active\\:bg-success-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-25\\/0:active{
  background-color: rgb(246 254 249 / 0);
}

.active\\:bg-success-25\\/10:active{
  background-color: rgb(246 254 249 / 0.1);
}

.active\\:bg-success-25\\/100:active{
  background-color: rgb(246 254 249 / 1);
}

.active\\:bg-success-25\\/15:active{
  background-color: rgb(246 254 249 / 0.15);
}

.active\\:bg-success-25\\/20:active{
  background-color: rgb(246 254 249 / 0.2);
}

.active\\:bg-success-25\\/25:active{
  background-color: rgb(246 254 249 / 0.25);
}

.active\\:bg-success-25\\/30:active{
  background-color: rgb(246 254 249 / 0.3);
}

.active\\:bg-success-25\\/35:active{
  background-color: rgb(246 254 249 / 0.35);
}

.active\\:bg-success-25\\/40:active{
  background-color: rgb(246 254 249 / 0.4);
}

.active\\:bg-success-25\\/45:active{
  background-color: rgb(246 254 249 / 0.45);
}

.active\\:bg-success-25\\/5:active{
  background-color: rgb(246 254 249 / 0.05);
}

.active\\:bg-success-25\\/50:active{
  background-color: rgb(246 254 249 / 0.5);
}

.active\\:bg-success-25\\/55:active{
  background-color: rgb(246 254 249 / 0.55);
}

.active\\:bg-success-25\\/60:active{
  background-color: rgb(246 254 249 / 0.6);
}

.active\\:bg-success-25\\/65:active{
  background-color: rgb(246 254 249 / 0.65);
}

.active\\:bg-success-25\\/70:active{
  background-color: rgb(246 254 249 / 0.7);
}

.active\\:bg-success-25\\/75:active{
  background-color: rgb(246 254 249 / 0.75);
}

.active\\:bg-success-25\\/80:active{
  background-color: rgb(246 254 249 / 0.8);
}

.active\\:bg-success-25\\/85:active{
  background-color: rgb(246 254 249 / 0.85);
}

.active\\:bg-success-25\\/90:active{
  background-color: rgb(246 254 249 / 0.9);
}

.active\\:bg-success-25\\/95:active{
  background-color: rgb(246 254 249 / 0.95);
}

.active\\:bg-success-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(60 203 127 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-400\\/0:active{
  background-color: rgb(60 203 127 / 0);
}

.active\\:bg-success-400\\/10:active{
  background-color: rgb(60 203 127 / 0.1);
}

.active\\:bg-success-400\\/100:active{
  background-color: rgb(60 203 127 / 1);
}

.active\\:bg-success-400\\/15:active{
  background-color: rgb(60 203 127 / 0.15);
}

.active\\:bg-success-400\\/20:active{
  background-color: rgb(60 203 127 / 0.2);
}

.active\\:bg-success-400\\/25:active{
  background-color: rgb(60 203 127 / 0.25);
}

.active\\:bg-success-400\\/30:active{
  background-color: rgb(60 203 127 / 0.3);
}

.active\\:bg-success-400\\/35:active{
  background-color: rgb(60 203 127 / 0.35);
}

.active\\:bg-success-400\\/40:active{
  background-color: rgb(60 203 127 / 0.4);
}

.active\\:bg-success-400\\/45:active{
  background-color: rgb(60 203 127 / 0.45);
}

.active\\:bg-success-400\\/5:active{
  background-color: rgb(60 203 127 / 0.05);
}

.active\\:bg-success-400\\/50:active{
  background-color: rgb(60 203 127 / 0.5);
}

.active\\:bg-success-400\\/55:active{
  background-color: rgb(60 203 127 / 0.55);
}

.active\\:bg-success-400\\/60:active{
  background-color: rgb(60 203 127 / 0.6);
}

.active\\:bg-success-400\\/65:active{
  background-color: rgb(60 203 127 / 0.65);
}

.active\\:bg-success-400\\/70:active{
  background-color: rgb(60 203 127 / 0.7);
}

.active\\:bg-success-400\\/75:active{
  background-color: rgb(60 203 127 / 0.75);
}

.active\\:bg-success-400\\/80:active{
  background-color: rgb(60 203 127 / 0.8);
}

.active\\:bg-success-400\\/85:active{
  background-color: rgb(60 203 127 / 0.85);
}

.active\\:bg-success-400\\/90:active{
  background-color: rgb(60 203 127 / 0.9);
}

.active\\:bg-success-400\\/95:active{
  background-color: rgb(60 203 127 / 0.95);
}

.active\\:bg-success-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-50\\/0:active{
  background-color: rgb(237 252 242 / 0);
}

.active\\:bg-success-50\\/10:active{
  background-color: rgb(237 252 242 / 0.1);
}

.active\\:bg-success-50\\/100:active{
  background-color: rgb(237 252 242 / 1);
}

.active\\:bg-success-50\\/15:active{
  background-color: rgb(237 252 242 / 0.15);
}

.active\\:bg-success-50\\/20:active{
  background-color: rgb(237 252 242 / 0.2);
}

.active\\:bg-success-50\\/25:active{
  background-color: rgb(237 252 242 / 0.25);
}

.active\\:bg-success-50\\/30:active{
  background-color: rgb(237 252 242 / 0.3);
}

.active\\:bg-success-50\\/35:active{
  background-color: rgb(237 252 242 / 0.35);
}

.active\\:bg-success-50\\/40:active{
  background-color: rgb(237 252 242 / 0.4);
}

.active\\:bg-success-50\\/45:active{
  background-color: rgb(237 252 242 / 0.45);
}

.active\\:bg-success-50\\/5:active{
  background-color: rgb(237 252 242 / 0.05);
}

.active\\:bg-success-50\\/50:active{
  background-color: rgb(237 252 242 / 0.5);
}

.active\\:bg-success-50\\/55:active{
  background-color: rgb(237 252 242 / 0.55);
}

.active\\:bg-success-50\\/60:active{
  background-color: rgb(237 252 242 / 0.6);
}

.active\\:bg-success-50\\/65:active{
  background-color: rgb(237 252 242 / 0.65);
}

.active\\:bg-success-50\\/70:active{
  background-color: rgb(237 252 242 / 0.7);
}

.active\\:bg-success-50\\/75:active{
  background-color: rgb(237 252 242 / 0.75);
}

.active\\:bg-success-50\\/80:active{
  background-color: rgb(237 252 242 / 0.8);
}

.active\\:bg-success-50\\/85:active{
  background-color: rgb(237 252 242 / 0.85);
}

.active\\:bg-success-50\\/90:active{
  background-color: rgb(237 252 242 / 0.9);
}

.active\\:bg-success-50\\/95:active{
  background-color: rgb(237 252 242 / 0.95);
}

.active\\:bg-success-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(22 179 100 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-500\\/0:active{
  background-color: rgb(22 179 100 / 0);
}

.active\\:bg-success-500\\/10:active{
  background-color: rgb(22 179 100 / 0.1);
}

.active\\:bg-success-500\\/100:active{
  background-color: rgb(22 179 100 / 1);
}

.active\\:bg-success-500\\/15:active{
  background-color: rgb(22 179 100 / 0.15);
}

.active\\:bg-success-500\\/20:active{
  background-color: rgb(22 179 100 / 0.2);
}

.active\\:bg-success-500\\/25:active{
  background-color: rgb(22 179 100 / 0.25);
}

.active\\:bg-success-500\\/30:active{
  background-color: rgb(22 179 100 / 0.3);
}

.active\\:bg-success-500\\/35:active{
  background-color: rgb(22 179 100 / 0.35);
}

.active\\:bg-success-500\\/40:active{
  background-color: rgb(22 179 100 / 0.4);
}

.active\\:bg-success-500\\/45:active{
  background-color: rgb(22 179 100 / 0.45);
}

.active\\:bg-success-500\\/5:active{
  background-color: rgb(22 179 100 / 0.05);
}

.active\\:bg-success-500\\/50:active{
  background-color: rgb(22 179 100 / 0.5);
}

.active\\:bg-success-500\\/55:active{
  background-color: rgb(22 179 100 / 0.55);
}

.active\\:bg-success-500\\/60:active{
  background-color: rgb(22 179 100 / 0.6);
}

.active\\:bg-success-500\\/65:active{
  background-color: rgb(22 179 100 / 0.65);
}

.active\\:bg-success-500\\/70:active{
  background-color: rgb(22 179 100 / 0.7);
}

.active\\:bg-success-500\\/75:active{
  background-color: rgb(22 179 100 / 0.75);
}

.active\\:bg-success-500\\/80:active{
  background-color: rgb(22 179 100 / 0.8);
}

.active\\:bg-success-500\\/85:active{
  background-color: rgb(22 179 100 / 0.85);
}

.active\\:bg-success-500\\/90:active{
  background-color: rgb(22 179 100 / 0.9);
}

.active\\:bg-success-500\\/95:active{
  background-color: rgb(22 179 100 / 0.95);
}

.active\\:bg-success-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(9 146 80 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-600\\/0:active{
  background-color: rgb(9 146 80 / 0);
}

.active\\:bg-success-600\\/10:active{
  background-color: rgb(9 146 80 / 0.1);
}

.active\\:bg-success-600\\/100:active{
  background-color: rgb(9 146 80 / 1);
}

.active\\:bg-success-600\\/15:active{
  background-color: rgb(9 146 80 / 0.15);
}

.active\\:bg-success-600\\/20:active{
  background-color: rgb(9 146 80 / 0.2);
}

.active\\:bg-success-600\\/25:active{
  background-color: rgb(9 146 80 / 0.25);
}

.active\\:bg-success-600\\/30:active{
  background-color: rgb(9 146 80 / 0.3);
}

.active\\:bg-success-600\\/35:active{
  background-color: rgb(9 146 80 / 0.35);
}

.active\\:bg-success-600\\/40:active{
  background-color: rgb(9 146 80 / 0.4);
}

.active\\:bg-success-600\\/45:active{
  background-color: rgb(9 146 80 / 0.45);
}

.active\\:bg-success-600\\/5:active{
  background-color: rgb(9 146 80 / 0.05);
}

.active\\:bg-success-600\\/50:active{
  background-color: rgb(9 146 80 / 0.5);
}

.active\\:bg-success-600\\/55:active{
  background-color: rgb(9 146 80 / 0.55);
}

.active\\:bg-success-600\\/60:active{
  background-color: rgb(9 146 80 / 0.6);
}

.active\\:bg-success-600\\/65:active{
  background-color: rgb(9 146 80 / 0.65);
}

.active\\:bg-success-600\\/70:active{
  background-color: rgb(9 146 80 / 0.7);
}

.active\\:bg-success-600\\/75:active{
  background-color: rgb(9 146 80 / 0.75);
}

.active\\:bg-success-600\\/80:active{
  background-color: rgb(9 146 80 / 0.8);
}

.active\\:bg-success-600\\/85:active{
  background-color: rgb(9 146 80 / 0.85);
}

.active\\:bg-success-600\\/90:active{
  background-color: rgb(9 146 80 / 0.9);
}

.active\\:bg-success-600\\/95:active{
  background-color: rgb(9 146 80 / 0.95);
}

.active\\:bg-success-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(8 116 67 / var(--tw-bg-opacity, 1));
}

.active\\:bg-success-700\\/0:active{
  background-color: rgb(8 116 67 / 0);
}

.active\\:bg-success-700\\/10:active{
  background-color: rgb(8 116 67 / 0.1);
}

.active\\:bg-success-700\\/100:active{
  background-color: rgb(8 116 67 / 1);
}

.active\\:bg-success-700\\/15:active{
  background-color: rgb(8 116 67 / 0.15);
}

.active\\:bg-success-700\\/20:active{
  background-color: rgb(8 116 67 / 0.2);
}

.active\\:bg-success-700\\/25:active{
  background-color: rgb(8 116 67 / 0.25);
}

.active\\:bg-success-700\\/30:active{
  background-color: rgb(8 116 67 / 0.3);
}

.active\\:bg-success-700\\/35:active{
  background-color: rgb(8 116 67 / 0.35);
}

.active\\:bg-success-700\\/40:active{
  background-color: rgb(8 116 67 / 0.4);
}

.active\\:bg-success-700\\/45:active{
  background-color: rgb(8 116 67 / 0.45);
}

.active\\:bg-success-700\\/5:active{
  background-color: rgb(8 116 67 / 0.05);
}

.active\\:bg-success-700\\/50:active{
  background-color: rgb(8 116 67 / 0.5);
}

.active\\:bg-success-700\\/55:active{
  background-color: rgb(8 116 67 / 0.55);
}

.active\\:bg-success-700\\/60:active{
  background-color: rgb(8 116 67 / 0.6);
}

.active\\:bg-success-700\\/65:active{
  background-color: rgb(8 116 67 / 0.65);
}

.active\\:bg-success-700\\/70:active{
  background-color: rgb(8 116 67 / 0.7);
}

.active\\:bg-success-700\\/75:active{
  background-color: rgb(8 116 67 / 0.75);
}

.active\\:bg-success-700\\/80:active{
  background-color: rgb(8 116 67 / 0.8);
}

.active\\:bg-success-700\\/85:active{
  background-color: rgb(8 116 67 / 0.85);
}

.active\\:bg-success-700\\/90:active{
  background-color: rgb(8 116 67 / 0.9);
}

.active\\:bg-success-700\\/95:active{
  background-color: rgb(8 116 67 / 0.95);
}

.active\\:bg-transparent:active{
  background-color: transparent;
}

.active\\:bg-warning-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-100\\/0:active{
  background-color: rgb(254 240 199 / 0);
}

.active\\:bg-warning-100\\/10:active{
  background-color: rgb(254 240 199 / 0.1);
}

.active\\:bg-warning-100\\/100:active{
  background-color: rgb(254 240 199 / 1);
}

.active\\:bg-warning-100\\/15:active{
  background-color: rgb(254 240 199 / 0.15);
}

.active\\:bg-warning-100\\/20:active{
  background-color: rgb(254 240 199 / 0.2);
}

.active\\:bg-warning-100\\/25:active{
  background-color: rgb(254 240 199 / 0.25);
}

.active\\:bg-warning-100\\/30:active{
  background-color: rgb(254 240 199 / 0.3);
}

.active\\:bg-warning-100\\/35:active{
  background-color: rgb(254 240 199 / 0.35);
}

.active\\:bg-warning-100\\/40:active{
  background-color: rgb(254 240 199 / 0.4);
}

.active\\:bg-warning-100\\/45:active{
  background-color: rgb(254 240 199 / 0.45);
}

.active\\:bg-warning-100\\/5:active{
  background-color: rgb(254 240 199 / 0.05);
}

.active\\:bg-warning-100\\/50:active{
  background-color: rgb(254 240 199 / 0.5);
}

.active\\:bg-warning-100\\/55:active{
  background-color: rgb(254 240 199 / 0.55);
}

.active\\:bg-warning-100\\/60:active{
  background-color: rgb(254 240 199 / 0.6);
}

.active\\:bg-warning-100\\/65:active{
  background-color: rgb(254 240 199 / 0.65);
}

.active\\:bg-warning-100\\/70:active{
  background-color: rgb(254 240 199 / 0.7);
}

.active\\:bg-warning-100\\/75:active{
  background-color: rgb(254 240 199 / 0.75);
}

.active\\:bg-warning-100\\/80:active{
  background-color: rgb(254 240 199 / 0.8);
}

.active\\:bg-warning-100\\/85:active{
  background-color: rgb(254 240 199 / 0.85);
}

.active\\:bg-warning-100\\/90:active{
  background-color: rgb(254 240 199 / 0.9);
}

.active\\:bg-warning-100\\/95:active{
  background-color: rgb(254 240 199 / 0.95);
}

.active\\:bg-warning-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-200\\/0:active{
  background-color: rgb(254 223 137 / 0);
}

.active\\:bg-warning-200\\/10:active{
  background-color: rgb(254 223 137 / 0.1);
}

.active\\:bg-warning-200\\/100:active{
  background-color: rgb(254 223 137 / 1);
}

.active\\:bg-warning-200\\/15:active{
  background-color: rgb(254 223 137 / 0.15);
}

.active\\:bg-warning-200\\/20:active{
  background-color: rgb(254 223 137 / 0.2);
}

.active\\:bg-warning-200\\/25:active{
  background-color: rgb(254 223 137 / 0.25);
}

.active\\:bg-warning-200\\/30:active{
  background-color: rgb(254 223 137 / 0.3);
}

.active\\:bg-warning-200\\/35:active{
  background-color: rgb(254 223 137 / 0.35);
}

.active\\:bg-warning-200\\/40:active{
  background-color: rgb(254 223 137 / 0.4);
}

.active\\:bg-warning-200\\/45:active{
  background-color: rgb(254 223 137 / 0.45);
}

.active\\:bg-warning-200\\/5:active{
  background-color: rgb(254 223 137 / 0.05);
}

.active\\:bg-warning-200\\/50:active{
  background-color: rgb(254 223 137 / 0.5);
}

.active\\:bg-warning-200\\/55:active{
  background-color: rgb(254 223 137 / 0.55);
}

.active\\:bg-warning-200\\/60:active{
  background-color: rgb(254 223 137 / 0.6);
}

.active\\:bg-warning-200\\/65:active{
  background-color: rgb(254 223 137 / 0.65);
}

.active\\:bg-warning-200\\/70:active{
  background-color: rgb(254 223 137 / 0.7);
}

.active\\:bg-warning-200\\/75:active{
  background-color: rgb(254 223 137 / 0.75);
}

.active\\:bg-warning-200\\/80:active{
  background-color: rgb(254 223 137 / 0.8);
}

.active\\:bg-warning-200\\/85:active{
  background-color: rgb(254 223 137 / 0.85);
}

.active\\:bg-warning-200\\/90:active{
  background-color: rgb(254 223 137 / 0.9);
}

.active\\:bg-warning-200\\/95:active{
  background-color: rgb(254 223 137 / 0.95);
}

.active\\:bg-warning-25:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-25\\/0:active{
  background-color: rgb(255 252 245 / 0);
}

.active\\:bg-warning-25\\/10:active{
  background-color: rgb(255 252 245 / 0.1);
}

.active\\:bg-warning-25\\/100:active{
  background-color: rgb(255 252 245 / 1);
}

.active\\:bg-warning-25\\/15:active{
  background-color: rgb(255 252 245 / 0.15);
}

.active\\:bg-warning-25\\/20:active{
  background-color: rgb(255 252 245 / 0.2);
}

.active\\:bg-warning-25\\/25:active{
  background-color: rgb(255 252 245 / 0.25);
}

.active\\:bg-warning-25\\/30:active{
  background-color: rgb(255 252 245 / 0.3);
}

.active\\:bg-warning-25\\/35:active{
  background-color: rgb(255 252 245 / 0.35);
}

.active\\:bg-warning-25\\/40:active{
  background-color: rgb(255 252 245 / 0.4);
}

.active\\:bg-warning-25\\/45:active{
  background-color: rgb(255 252 245 / 0.45);
}

.active\\:bg-warning-25\\/5:active{
  background-color: rgb(255 252 245 / 0.05);
}

.active\\:bg-warning-25\\/50:active{
  background-color: rgb(255 252 245 / 0.5);
}

.active\\:bg-warning-25\\/55:active{
  background-color: rgb(255 252 245 / 0.55);
}

.active\\:bg-warning-25\\/60:active{
  background-color: rgb(255 252 245 / 0.6);
}

.active\\:bg-warning-25\\/65:active{
  background-color: rgb(255 252 245 / 0.65);
}

.active\\:bg-warning-25\\/70:active{
  background-color: rgb(255 252 245 / 0.7);
}

.active\\:bg-warning-25\\/75:active{
  background-color: rgb(255 252 245 / 0.75);
}

.active\\:bg-warning-25\\/80:active{
  background-color: rgb(255 252 245 / 0.8);
}

.active\\:bg-warning-25\\/85:active{
  background-color: rgb(255 252 245 / 0.85);
}

.active\\:bg-warning-25\\/90:active{
  background-color: rgb(255 252 245 / 0.9);
}

.active\\:bg-warning-25\\/95:active{
  background-color: rgb(255 252 245 / 0.95);
}

.active\\:bg-warning-400:active{
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-400\\/0:active{
  background-color: rgb(253 176 34 / 0);
}

.active\\:bg-warning-400\\/10:active{
  background-color: rgb(253 176 34 / 0.1);
}

.active\\:bg-warning-400\\/100:active{
  background-color: rgb(253 176 34 / 1);
}

.active\\:bg-warning-400\\/15:active{
  background-color: rgb(253 176 34 / 0.15);
}

.active\\:bg-warning-400\\/20:active{
  background-color: rgb(253 176 34 / 0.2);
}

.active\\:bg-warning-400\\/25:active{
  background-color: rgb(253 176 34 / 0.25);
}

.active\\:bg-warning-400\\/30:active{
  background-color: rgb(253 176 34 / 0.3);
}

.active\\:bg-warning-400\\/35:active{
  background-color: rgb(253 176 34 / 0.35);
}

.active\\:bg-warning-400\\/40:active{
  background-color: rgb(253 176 34 / 0.4);
}

.active\\:bg-warning-400\\/45:active{
  background-color: rgb(253 176 34 / 0.45);
}

.active\\:bg-warning-400\\/5:active{
  background-color: rgb(253 176 34 / 0.05);
}

.active\\:bg-warning-400\\/50:active{
  background-color: rgb(253 176 34 / 0.5);
}

.active\\:bg-warning-400\\/55:active{
  background-color: rgb(253 176 34 / 0.55);
}

.active\\:bg-warning-400\\/60:active{
  background-color: rgb(253 176 34 / 0.6);
}

.active\\:bg-warning-400\\/65:active{
  background-color: rgb(253 176 34 / 0.65);
}

.active\\:bg-warning-400\\/70:active{
  background-color: rgb(253 176 34 / 0.7);
}

.active\\:bg-warning-400\\/75:active{
  background-color: rgb(253 176 34 / 0.75);
}

.active\\:bg-warning-400\\/80:active{
  background-color: rgb(253 176 34 / 0.8);
}

.active\\:bg-warning-400\\/85:active{
  background-color: rgb(253 176 34 / 0.85);
}

.active\\:bg-warning-400\\/90:active{
  background-color: rgb(253 176 34 / 0.9);
}

.active\\:bg-warning-400\\/95:active{
  background-color: rgb(253 176 34 / 0.95);
}

.active\\:bg-warning-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-50\\/0:active{
  background-color: rgb(255 250 235 / 0);
}

.active\\:bg-warning-50\\/10:active{
  background-color: rgb(255 250 235 / 0.1);
}

.active\\:bg-warning-50\\/100:active{
  background-color: rgb(255 250 235 / 1);
}

.active\\:bg-warning-50\\/15:active{
  background-color: rgb(255 250 235 / 0.15);
}

.active\\:bg-warning-50\\/20:active{
  background-color: rgb(255 250 235 / 0.2);
}

.active\\:bg-warning-50\\/25:active{
  background-color: rgb(255 250 235 / 0.25);
}

.active\\:bg-warning-50\\/30:active{
  background-color: rgb(255 250 235 / 0.3);
}

.active\\:bg-warning-50\\/35:active{
  background-color: rgb(255 250 235 / 0.35);
}

.active\\:bg-warning-50\\/40:active{
  background-color: rgb(255 250 235 / 0.4);
}

.active\\:bg-warning-50\\/45:active{
  background-color: rgb(255 250 235 / 0.45);
}

.active\\:bg-warning-50\\/5:active{
  background-color: rgb(255 250 235 / 0.05);
}

.active\\:bg-warning-50\\/50:active{
  background-color: rgb(255 250 235 / 0.5);
}

.active\\:bg-warning-50\\/55:active{
  background-color: rgb(255 250 235 / 0.55);
}

.active\\:bg-warning-50\\/60:active{
  background-color: rgb(255 250 235 / 0.6);
}

.active\\:bg-warning-50\\/65:active{
  background-color: rgb(255 250 235 / 0.65);
}

.active\\:bg-warning-50\\/70:active{
  background-color: rgb(255 250 235 / 0.7);
}

.active\\:bg-warning-50\\/75:active{
  background-color: rgb(255 250 235 / 0.75);
}

.active\\:bg-warning-50\\/80:active{
  background-color: rgb(255 250 235 / 0.8);
}

.active\\:bg-warning-50\\/85:active{
  background-color: rgb(255 250 235 / 0.85);
}

.active\\:bg-warning-50\\/90:active{
  background-color: rgb(255 250 235 / 0.9);
}

.active\\:bg-warning-50\\/95:active{
  background-color: rgb(255 250 235 / 0.95);
}

.active\\:bg-warning-500:active{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-500\\/0:active{
  background-color: rgb(247 144 9 / 0);
}

.active\\:bg-warning-500\\/10:active{
  background-color: rgb(247 144 9 / 0.1);
}

.active\\:bg-warning-500\\/100:active{
  background-color: rgb(247 144 9 / 1);
}

.active\\:bg-warning-500\\/15:active{
  background-color: rgb(247 144 9 / 0.15);
}

.active\\:bg-warning-500\\/20:active{
  background-color: rgb(247 144 9 / 0.2);
}

.active\\:bg-warning-500\\/25:active{
  background-color: rgb(247 144 9 / 0.25);
}

.active\\:bg-warning-500\\/30:active{
  background-color: rgb(247 144 9 / 0.3);
}

.active\\:bg-warning-500\\/35:active{
  background-color: rgb(247 144 9 / 0.35);
}

.active\\:bg-warning-500\\/40:active{
  background-color: rgb(247 144 9 / 0.4);
}

.active\\:bg-warning-500\\/45:active{
  background-color: rgb(247 144 9 / 0.45);
}

.active\\:bg-warning-500\\/5:active{
  background-color: rgb(247 144 9 / 0.05);
}

.active\\:bg-warning-500\\/50:active{
  background-color: rgb(247 144 9 / 0.5);
}

.active\\:bg-warning-500\\/55:active{
  background-color: rgb(247 144 9 / 0.55);
}

.active\\:bg-warning-500\\/60:active{
  background-color: rgb(247 144 9 / 0.6);
}

.active\\:bg-warning-500\\/65:active{
  background-color: rgb(247 144 9 / 0.65);
}

.active\\:bg-warning-500\\/70:active{
  background-color: rgb(247 144 9 / 0.7);
}

.active\\:bg-warning-500\\/75:active{
  background-color: rgb(247 144 9 / 0.75);
}

.active\\:bg-warning-500\\/80:active{
  background-color: rgb(247 144 9 / 0.8);
}

.active\\:bg-warning-500\\/85:active{
  background-color: rgb(247 144 9 / 0.85);
}

.active\\:bg-warning-500\\/90:active{
  background-color: rgb(247 144 9 / 0.9);
}

.active\\:bg-warning-500\\/95:active{
  background-color: rgb(247 144 9 / 0.95);
}

.active\\:bg-warning-600:active{
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-600\\/0:active{
  background-color: rgb(220 104 3 / 0);
}

.active\\:bg-warning-600\\/10:active{
  background-color: rgb(220 104 3 / 0.1);
}

.active\\:bg-warning-600\\/100:active{
  background-color: rgb(220 104 3 / 1);
}

.active\\:bg-warning-600\\/15:active{
  background-color: rgb(220 104 3 / 0.15);
}

.active\\:bg-warning-600\\/20:active{
  background-color: rgb(220 104 3 / 0.2);
}

.active\\:bg-warning-600\\/25:active{
  background-color: rgb(220 104 3 / 0.25);
}

.active\\:bg-warning-600\\/30:active{
  background-color: rgb(220 104 3 / 0.3);
}

.active\\:bg-warning-600\\/35:active{
  background-color: rgb(220 104 3 / 0.35);
}

.active\\:bg-warning-600\\/40:active{
  background-color: rgb(220 104 3 / 0.4);
}

.active\\:bg-warning-600\\/45:active{
  background-color: rgb(220 104 3 / 0.45);
}

.active\\:bg-warning-600\\/5:active{
  background-color: rgb(220 104 3 / 0.05);
}

.active\\:bg-warning-600\\/50:active{
  background-color: rgb(220 104 3 / 0.5);
}

.active\\:bg-warning-600\\/55:active{
  background-color: rgb(220 104 3 / 0.55);
}

.active\\:bg-warning-600\\/60:active{
  background-color: rgb(220 104 3 / 0.6);
}

.active\\:bg-warning-600\\/65:active{
  background-color: rgb(220 104 3 / 0.65);
}

.active\\:bg-warning-600\\/70:active{
  background-color: rgb(220 104 3 / 0.7);
}

.active\\:bg-warning-600\\/75:active{
  background-color: rgb(220 104 3 / 0.75);
}

.active\\:bg-warning-600\\/80:active{
  background-color: rgb(220 104 3 / 0.8);
}

.active\\:bg-warning-600\\/85:active{
  background-color: rgb(220 104 3 / 0.85);
}

.active\\:bg-warning-600\\/90:active{
  background-color: rgb(220 104 3 / 0.9);
}

.active\\:bg-warning-600\\/95:active{
  background-color: rgb(220 104 3 / 0.95);
}

.active\\:bg-warning-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}

.active\\:bg-warning-700\\/0:active{
  background-color: rgb(181 71 8 / 0);
}

.active\\:bg-warning-700\\/10:active{
  background-color: rgb(181 71 8 / 0.1);
}

.active\\:bg-warning-700\\/100:active{
  background-color: rgb(181 71 8 / 1);
}

.active\\:bg-warning-700\\/15:active{
  background-color: rgb(181 71 8 / 0.15);
}

.active\\:bg-warning-700\\/20:active{
  background-color: rgb(181 71 8 / 0.2);
}

.active\\:bg-warning-700\\/25:active{
  background-color: rgb(181 71 8 / 0.25);
}

.active\\:bg-warning-700\\/30:active{
  background-color: rgb(181 71 8 / 0.3);
}

.active\\:bg-warning-700\\/35:active{
  background-color: rgb(181 71 8 / 0.35);
}

.active\\:bg-warning-700\\/40:active{
  background-color: rgb(181 71 8 / 0.4);
}

.active\\:bg-warning-700\\/45:active{
  background-color: rgb(181 71 8 / 0.45);
}

.active\\:bg-warning-700\\/5:active{
  background-color: rgb(181 71 8 / 0.05);
}

.active\\:bg-warning-700\\/50:active{
  background-color: rgb(181 71 8 / 0.5);
}

.active\\:bg-warning-700\\/55:active{
  background-color: rgb(181 71 8 / 0.55);
}

.active\\:bg-warning-700\\/60:active{
  background-color: rgb(181 71 8 / 0.6);
}

.active\\:bg-warning-700\\/65:active{
  background-color: rgb(181 71 8 / 0.65);
}

.active\\:bg-warning-700\\/70:active{
  background-color: rgb(181 71 8 / 0.7);
}

.active\\:bg-warning-700\\/75:active{
  background-color: rgb(181 71 8 / 0.75);
}

.active\\:bg-warning-700\\/80:active{
  background-color: rgb(181 71 8 / 0.8);
}

.active\\:bg-warning-700\\/85:active{
  background-color: rgb(181 71 8 / 0.85);
}

.active\\:bg-warning-700\\/90:active{
  background-color: rgb(181 71 8 / 0.9);
}

.active\\:bg-warning-700\\/95:active{
  background-color: rgb(181 71 8 / 0.95);
}

.active\\:text-danger-100:active{
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-100\\/0:active{
  color: rgb(254 228 226 / 0);
}

.active\\:text-danger-100\\/10:active{
  color: rgb(254 228 226 / 0.1);
}

.active\\:text-danger-100\\/100:active{
  color: rgb(254 228 226 / 1);
}

.active\\:text-danger-100\\/15:active{
  color: rgb(254 228 226 / 0.15);
}

.active\\:text-danger-100\\/20:active{
  color: rgb(254 228 226 / 0.2);
}

.active\\:text-danger-100\\/25:active{
  color: rgb(254 228 226 / 0.25);
}

.active\\:text-danger-100\\/30:active{
  color: rgb(254 228 226 / 0.3);
}

.active\\:text-danger-100\\/35:active{
  color: rgb(254 228 226 / 0.35);
}

.active\\:text-danger-100\\/40:active{
  color: rgb(254 228 226 / 0.4);
}

.active\\:text-danger-100\\/45:active{
  color: rgb(254 228 226 / 0.45);
}

.active\\:text-danger-100\\/5:active{
  color: rgb(254 228 226 / 0.05);
}

.active\\:text-danger-100\\/50:active{
  color: rgb(254 228 226 / 0.5);
}

.active\\:text-danger-100\\/55:active{
  color: rgb(254 228 226 / 0.55);
}

.active\\:text-danger-100\\/60:active{
  color: rgb(254 228 226 / 0.6);
}

.active\\:text-danger-100\\/65:active{
  color: rgb(254 228 226 / 0.65);
}

.active\\:text-danger-100\\/70:active{
  color: rgb(254 228 226 / 0.7);
}

.active\\:text-danger-100\\/75:active{
  color: rgb(254 228 226 / 0.75);
}

.active\\:text-danger-100\\/80:active{
  color: rgb(254 228 226 / 0.8);
}

.active\\:text-danger-100\\/85:active{
  color: rgb(254 228 226 / 0.85);
}

.active\\:text-danger-100\\/90:active{
  color: rgb(254 228 226 / 0.9);
}

.active\\:text-danger-100\\/95:active{
  color: rgb(254 228 226 / 0.95);
}

.active\\:text-danger-200:active{
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-200\\/0:active{
  color: rgb(254 205 202 / 0);
}

.active\\:text-danger-200\\/10:active{
  color: rgb(254 205 202 / 0.1);
}

.active\\:text-danger-200\\/100:active{
  color: rgb(254 205 202 / 1);
}

.active\\:text-danger-200\\/15:active{
  color: rgb(254 205 202 / 0.15);
}

.active\\:text-danger-200\\/20:active{
  color: rgb(254 205 202 / 0.2);
}

.active\\:text-danger-200\\/25:active{
  color: rgb(254 205 202 / 0.25);
}

.active\\:text-danger-200\\/30:active{
  color: rgb(254 205 202 / 0.3);
}

.active\\:text-danger-200\\/35:active{
  color: rgb(254 205 202 / 0.35);
}

.active\\:text-danger-200\\/40:active{
  color: rgb(254 205 202 / 0.4);
}

.active\\:text-danger-200\\/45:active{
  color: rgb(254 205 202 / 0.45);
}

.active\\:text-danger-200\\/5:active{
  color: rgb(254 205 202 / 0.05);
}

.active\\:text-danger-200\\/50:active{
  color: rgb(254 205 202 / 0.5);
}

.active\\:text-danger-200\\/55:active{
  color: rgb(254 205 202 / 0.55);
}

.active\\:text-danger-200\\/60:active{
  color: rgb(254 205 202 / 0.6);
}

.active\\:text-danger-200\\/65:active{
  color: rgb(254 205 202 / 0.65);
}

.active\\:text-danger-200\\/70:active{
  color: rgb(254 205 202 / 0.7);
}

.active\\:text-danger-200\\/75:active{
  color: rgb(254 205 202 / 0.75);
}

.active\\:text-danger-200\\/80:active{
  color: rgb(254 205 202 / 0.8);
}

.active\\:text-danger-200\\/85:active{
  color: rgb(254 205 202 / 0.85);
}

.active\\:text-danger-200\\/90:active{
  color: rgb(254 205 202 / 0.9);
}

.active\\:text-danger-200\\/95:active{
  color: rgb(254 205 202 / 0.95);
}

.active\\:text-danger-25:active{
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-25\\/0:active{
  color: rgb(255 251 250 / 0);
}

.active\\:text-danger-25\\/10:active{
  color: rgb(255 251 250 / 0.1);
}

.active\\:text-danger-25\\/100:active{
  color: rgb(255 251 250 / 1);
}

.active\\:text-danger-25\\/15:active{
  color: rgb(255 251 250 / 0.15);
}

.active\\:text-danger-25\\/20:active{
  color: rgb(255 251 250 / 0.2);
}

.active\\:text-danger-25\\/25:active{
  color: rgb(255 251 250 / 0.25);
}

.active\\:text-danger-25\\/30:active{
  color: rgb(255 251 250 / 0.3);
}

.active\\:text-danger-25\\/35:active{
  color: rgb(255 251 250 / 0.35);
}

.active\\:text-danger-25\\/40:active{
  color: rgb(255 251 250 / 0.4);
}

.active\\:text-danger-25\\/45:active{
  color: rgb(255 251 250 / 0.45);
}

.active\\:text-danger-25\\/5:active{
  color: rgb(255 251 250 / 0.05);
}

.active\\:text-danger-25\\/50:active{
  color: rgb(255 251 250 / 0.5);
}

.active\\:text-danger-25\\/55:active{
  color: rgb(255 251 250 / 0.55);
}

.active\\:text-danger-25\\/60:active{
  color: rgb(255 251 250 / 0.6);
}

.active\\:text-danger-25\\/65:active{
  color: rgb(255 251 250 / 0.65);
}

.active\\:text-danger-25\\/70:active{
  color: rgb(255 251 250 / 0.7);
}

.active\\:text-danger-25\\/75:active{
  color: rgb(255 251 250 / 0.75);
}

.active\\:text-danger-25\\/80:active{
  color: rgb(255 251 250 / 0.8);
}

.active\\:text-danger-25\\/85:active{
  color: rgb(255 251 250 / 0.85);
}

.active\\:text-danger-25\\/90:active{
  color: rgb(255 251 250 / 0.9);
}

.active\\:text-danger-25\\/95:active{
  color: rgb(255 251 250 / 0.95);
}

.active\\:text-danger-400:active{
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-400\\/0:active{
  color: rgb(249 112 102 / 0);
}

.active\\:text-danger-400\\/10:active{
  color: rgb(249 112 102 / 0.1);
}

.active\\:text-danger-400\\/100:active{
  color: rgb(249 112 102 / 1);
}

.active\\:text-danger-400\\/15:active{
  color: rgb(249 112 102 / 0.15);
}

.active\\:text-danger-400\\/20:active{
  color: rgb(249 112 102 / 0.2);
}

.active\\:text-danger-400\\/25:active{
  color: rgb(249 112 102 / 0.25);
}

.active\\:text-danger-400\\/30:active{
  color: rgb(249 112 102 / 0.3);
}

.active\\:text-danger-400\\/35:active{
  color: rgb(249 112 102 / 0.35);
}

.active\\:text-danger-400\\/40:active{
  color: rgb(249 112 102 / 0.4);
}

.active\\:text-danger-400\\/45:active{
  color: rgb(249 112 102 / 0.45);
}

.active\\:text-danger-400\\/5:active{
  color: rgb(249 112 102 / 0.05);
}

.active\\:text-danger-400\\/50:active{
  color: rgb(249 112 102 / 0.5);
}

.active\\:text-danger-400\\/55:active{
  color: rgb(249 112 102 / 0.55);
}

.active\\:text-danger-400\\/60:active{
  color: rgb(249 112 102 / 0.6);
}

.active\\:text-danger-400\\/65:active{
  color: rgb(249 112 102 / 0.65);
}

.active\\:text-danger-400\\/70:active{
  color: rgb(249 112 102 / 0.7);
}

.active\\:text-danger-400\\/75:active{
  color: rgb(249 112 102 / 0.75);
}

.active\\:text-danger-400\\/80:active{
  color: rgb(249 112 102 / 0.8);
}

.active\\:text-danger-400\\/85:active{
  color: rgb(249 112 102 / 0.85);
}

.active\\:text-danger-400\\/90:active{
  color: rgb(249 112 102 / 0.9);
}

.active\\:text-danger-400\\/95:active{
  color: rgb(249 112 102 / 0.95);
}

.active\\:text-danger-50:active{
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-50\\/0:active{
  color: rgb(254 243 242 / 0);
}

.active\\:text-danger-50\\/10:active{
  color: rgb(254 243 242 / 0.1);
}

.active\\:text-danger-50\\/100:active{
  color: rgb(254 243 242 / 1);
}

.active\\:text-danger-50\\/15:active{
  color: rgb(254 243 242 / 0.15);
}

.active\\:text-danger-50\\/20:active{
  color: rgb(254 243 242 / 0.2);
}

.active\\:text-danger-50\\/25:active{
  color: rgb(254 243 242 / 0.25);
}

.active\\:text-danger-50\\/30:active{
  color: rgb(254 243 242 / 0.3);
}

.active\\:text-danger-50\\/35:active{
  color: rgb(254 243 242 / 0.35);
}

.active\\:text-danger-50\\/40:active{
  color: rgb(254 243 242 / 0.4);
}

.active\\:text-danger-50\\/45:active{
  color: rgb(254 243 242 / 0.45);
}

.active\\:text-danger-50\\/5:active{
  color: rgb(254 243 242 / 0.05);
}

.active\\:text-danger-50\\/50:active{
  color: rgb(254 243 242 / 0.5);
}

.active\\:text-danger-50\\/55:active{
  color: rgb(254 243 242 / 0.55);
}

.active\\:text-danger-50\\/60:active{
  color: rgb(254 243 242 / 0.6);
}

.active\\:text-danger-50\\/65:active{
  color: rgb(254 243 242 / 0.65);
}

.active\\:text-danger-50\\/70:active{
  color: rgb(254 243 242 / 0.7);
}

.active\\:text-danger-50\\/75:active{
  color: rgb(254 243 242 / 0.75);
}

.active\\:text-danger-50\\/80:active{
  color: rgb(254 243 242 / 0.8);
}

.active\\:text-danger-50\\/85:active{
  color: rgb(254 243 242 / 0.85);
}

.active\\:text-danger-50\\/90:active{
  color: rgb(254 243 242 / 0.9);
}

.active\\:text-danger-50\\/95:active{
  color: rgb(254 243 242 / 0.95);
}

.active\\:text-danger-500:active{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-500\\/0:active{
  color: rgb(240 68 56 / 0);
}

.active\\:text-danger-500\\/10:active{
  color: rgb(240 68 56 / 0.1);
}

.active\\:text-danger-500\\/100:active{
  color: rgb(240 68 56 / 1);
}

.active\\:text-danger-500\\/15:active{
  color: rgb(240 68 56 / 0.15);
}

.active\\:text-danger-500\\/20:active{
  color: rgb(240 68 56 / 0.2);
}

.active\\:text-danger-500\\/25:active{
  color: rgb(240 68 56 / 0.25);
}

.active\\:text-danger-500\\/30:active{
  color: rgb(240 68 56 / 0.3);
}

.active\\:text-danger-500\\/35:active{
  color: rgb(240 68 56 / 0.35);
}

.active\\:text-danger-500\\/40:active{
  color: rgb(240 68 56 / 0.4);
}

.active\\:text-danger-500\\/45:active{
  color: rgb(240 68 56 / 0.45);
}

.active\\:text-danger-500\\/5:active{
  color: rgb(240 68 56 / 0.05);
}

.active\\:text-danger-500\\/50:active{
  color: rgb(240 68 56 / 0.5);
}

.active\\:text-danger-500\\/55:active{
  color: rgb(240 68 56 / 0.55);
}

.active\\:text-danger-500\\/60:active{
  color: rgb(240 68 56 / 0.6);
}

.active\\:text-danger-500\\/65:active{
  color: rgb(240 68 56 / 0.65);
}

.active\\:text-danger-500\\/70:active{
  color: rgb(240 68 56 / 0.7);
}

.active\\:text-danger-500\\/75:active{
  color: rgb(240 68 56 / 0.75);
}

.active\\:text-danger-500\\/80:active{
  color: rgb(240 68 56 / 0.8);
}

.active\\:text-danger-500\\/85:active{
  color: rgb(240 68 56 / 0.85);
}

.active\\:text-danger-500\\/90:active{
  color: rgb(240 68 56 / 0.9);
}

.active\\:text-danger-500\\/95:active{
  color: rgb(240 68 56 / 0.95);
}

.active\\:text-danger-600:active{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-600\\/0:active{
  color: rgb(217 45 32 / 0);
}

.active\\:text-danger-600\\/10:active{
  color: rgb(217 45 32 / 0.1);
}

.active\\:text-danger-600\\/100:active{
  color: rgb(217 45 32 / 1);
}

.active\\:text-danger-600\\/15:active{
  color: rgb(217 45 32 / 0.15);
}

.active\\:text-danger-600\\/20:active{
  color: rgb(217 45 32 / 0.2);
}

.active\\:text-danger-600\\/25:active{
  color: rgb(217 45 32 / 0.25);
}

.active\\:text-danger-600\\/30:active{
  color: rgb(217 45 32 / 0.3);
}

.active\\:text-danger-600\\/35:active{
  color: rgb(217 45 32 / 0.35);
}

.active\\:text-danger-600\\/40:active{
  color: rgb(217 45 32 / 0.4);
}

.active\\:text-danger-600\\/45:active{
  color: rgb(217 45 32 / 0.45);
}

.active\\:text-danger-600\\/5:active{
  color: rgb(217 45 32 / 0.05);
}

.active\\:text-danger-600\\/50:active{
  color: rgb(217 45 32 / 0.5);
}

.active\\:text-danger-600\\/55:active{
  color: rgb(217 45 32 / 0.55);
}

.active\\:text-danger-600\\/60:active{
  color: rgb(217 45 32 / 0.6);
}

.active\\:text-danger-600\\/65:active{
  color: rgb(217 45 32 / 0.65);
}

.active\\:text-danger-600\\/70:active{
  color: rgb(217 45 32 / 0.7);
}

.active\\:text-danger-600\\/75:active{
  color: rgb(217 45 32 / 0.75);
}

.active\\:text-danger-600\\/80:active{
  color: rgb(217 45 32 / 0.8);
}

.active\\:text-danger-600\\/85:active{
  color: rgb(217 45 32 / 0.85);
}

.active\\:text-danger-600\\/90:active{
  color: rgb(217 45 32 / 0.9);
}

.active\\:text-danger-600\\/95:active{
  color: rgb(217 45 32 / 0.95);
}

.active\\:text-danger-700:active{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}

.active\\:text-danger-700\\/0:active{
  color: rgb(180 35 24 / 0);
}

.active\\:text-danger-700\\/10:active{
  color: rgb(180 35 24 / 0.1);
}

.active\\:text-danger-700\\/100:active{
  color: rgb(180 35 24 / 1);
}

.active\\:text-danger-700\\/15:active{
  color: rgb(180 35 24 / 0.15);
}

.active\\:text-danger-700\\/20:active{
  color: rgb(180 35 24 / 0.2);
}

.active\\:text-danger-700\\/25:active{
  color: rgb(180 35 24 / 0.25);
}

.active\\:text-danger-700\\/30:active{
  color: rgb(180 35 24 / 0.3);
}

.active\\:text-danger-700\\/35:active{
  color: rgb(180 35 24 / 0.35);
}

.active\\:text-danger-700\\/40:active{
  color: rgb(180 35 24 / 0.4);
}

.active\\:text-danger-700\\/45:active{
  color: rgb(180 35 24 / 0.45);
}

.active\\:text-danger-700\\/5:active{
  color: rgb(180 35 24 / 0.05);
}

.active\\:text-danger-700\\/50:active{
  color: rgb(180 35 24 / 0.5);
}

.active\\:text-danger-700\\/55:active{
  color: rgb(180 35 24 / 0.55);
}

.active\\:text-danger-700\\/60:active{
  color: rgb(180 35 24 / 0.6);
}

.active\\:text-danger-700\\/65:active{
  color: rgb(180 35 24 / 0.65);
}

.active\\:text-danger-700\\/70:active{
  color: rgb(180 35 24 / 0.7);
}

.active\\:text-danger-700\\/75:active{
  color: rgb(180 35 24 / 0.75);
}

.active\\:text-danger-700\\/80:active{
  color: rgb(180 35 24 / 0.8);
}

.active\\:text-danger-700\\/85:active{
  color: rgb(180 35 24 / 0.85);
}

.active\\:text-danger-700\\/90:active{
  color: rgb(180 35 24 / 0.9);
}

.active\\:text-danger-700\\/95:active{
  color: rgb(180 35 24 / 0.95);
}

.active\\:text-moss-100:active{
  --tw-text-opacity: 1;
  color: rgb(230 244 215 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-100\\/0:active{
  color: rgb(230 244 215 / 0);
}

.active\\:text-moss-100\\/10:active{
  color: rgb(230 244 215 / 0.1);
}

.active\\:text-moss-100\\/100:active{
  color: rgb(230 244 215 / 1);
}

.active\\:text-moss-100\\/15:active{
  color: rgb(230 244 215 / 0.15);
}

.active\\:text-moss-100\\/20:active{
  color: rgb(230 244 215 / 0.2);
}

.active\\:text-moss-100\\/25:active{
  color: rgb(230 244 215 / 0.25);
}

.active\\:text-moss-100\\/30:active{
  color: rgb(230 244 215 / 0.3);
}

.active\\:text-moss-100\\/35:active{
  color: rgb(230 244 215 / 0.35);
}

.active\\:text-moss-100\\/40:active{
  color: rgb(230 244 215 / 0.4);
}

.active\\:text-moss-100\\/45:active{
  color: rgb(230 244 215 / 0.45);
}

.active\\:text-moss-100\\/5:active{
  color: rgb(230 244 215 / 0.05);
}

.active\\:text-moss-100\\/50:active{
  color: rgb(230 244 215 / 0.5);
}

.active\\:text-moss-100\\/55:active{
  color: rgb(230 244 215 / 0.55);
}

.active\\:text-moss-100\\/60:active{
  color: rgb(230 244 215 / 0.6);
}

.active\\:text-moss-100\\/65:active{
  color: rgb(230 244 215 / 0.65);
}

.active\\:text-moss-100\\/70:active{
  color: rgb(230 244 215 / 0.7);
}

.active\\:text-moss-100\\/75:active{
  color: rgb(230 244 215 / 0.75);
}

.active\\:text-moss-100\\/80:active{
  color: rgb(230 244 215 / 0.8);
}

.active\\:text-moss-100\\/85:active{
  color: rgb(230 244 215 / 0.85);
}

.active\\:text-moss-100\\/90:active{
  color: rgb(230 244 215 / 0.9);
}

.active\\:text-moss-100\\/95:active{
  color: rgb(230 244 215 / 0.95);
}

.active\\:text-moss-200:active{
  --tw-text-opacity: 1;
  color: rgb(206 234 176 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-200\\/0:active{
  color: rgb(206 234 176 / 0);
}

.active\\:text-moss-200\\/10:active{
  color: rgb(206 234 176 / 0.1);
}

.active\\:text-moss-200\\/100:active{
  color: rgb(206 234 176 / 1);
}

.active\\:text-moss-200\\/15:active{
  color: rgb(206 234 176 / 0.15);
}

.active\\:text-moss-200\\/20:active{
  color: rgb(206 234 176 / 0.2);
}

.active\\:text-moss-200\\/25:active{
  color: rgb(206 234 176 / 0.25);
}

.active\\:text-moss-200\\/30:active{
  color: rgb(206 234 176 / 0.3);
}

.active\\:text-moss-200\\/35:active{
  color: rgb(206 234 176 / 0.35);
}

.active\\:text-moss-200\\/40:active{
  color: rgb(206 234 176 / 0.4);
}

.active\\:text-moss-200\\/45:active{
  color: rgb(206 234 176 / 0.45);
}

.active\\:text-moss-200\\/5:active{
  color: rgb(206 234 176 / 0.05);
}

.active\\:text-moss-200\\/50:active{
  color: rgb(206 234 176 / 0.5);
}

.active\\:text-moss-200\\/55:active{
  color: rgb(206 234 176 / 0.55);
}

.active\\:text-moss-200\\/60:active{
  color: rgb(206 234 176 / 0.6);
}

.active\\:text-moss-200\\/65:active{
  color: rgb(206 234 176 / 0.65);
}

.active\\:text-moss-200\\/70:active{
  color: rgb(206 234 176 / 0.7);
}

.active\\:text-moss-200\\/75:active{
  color: rgb(206 234 176 / 0.75);
}

.active\\:text-moss-200\\/80:active{
  color: rgb(206 234 176 / 0.8);
}

.active\\:text-moss-200\\/85:active{
  color: rgb(206 234 176 / 0.85);
}

.active\\:text-moss-200\\/90:active{
  color: rgb(206 234 176 / 0.9);
}

.active\\:text-moss-200\\/95:active{
  color: rgb(206 234 176 / 0.95);
}

.active\\:text-moss-25:active{
  --tw-text-opacity: 1;
  color: rgb(250 253 247 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-25\\/0:active{
  color: rgb(250 253 247 / 0);
}

.active\\:text-moss-25\\/10:active{
  color: rgb(250 253 247 / 0.1);
}

.active\\:text-moss-25\\/100:active{
  color: rgb(250 253 247 / 1);
}

.active\\:text-moss-25\\/15:active{
  color: rgb(250 253 247 / 0.15);
}

.active\\:text-moss-25\\/20:active{
  color: rgb(250 253 247 / 0.2);
}

.active\\:text-moss-25\\/25:active{
  color: rgb(250 253 247 / 0.25);
}

.active\\:text-moss-25\\/30:active{
  color: rgb(250 253 247 / 0.3);
}

.active\\:text-moss-25\\/35:active{
  color: rgb(250 253 247 / 0.35);
}

.active\\:text-moss-25\\/40:active{
  color: rgb(250 253 247 / 0.4);
}

.active\\:text-moss-25\\/45:active{
  color: rgb(250 253 247 / 0.45);
}

.active\\:text-moss-25\\/5:active{
  color: rgb(250 253 247 / 0.05);
}

.active\\:text-moss-25\\/50:active{
  color: rgb(250 253 247 / 0.5);
}

.active\\:text-moss-25\\/55:active{
  color: rgb(250 253 247 / 0.55);
}

.active\\:text-moss-25\\/60:active{
  color: rgb(250 253 247 / 0.6);
}

.active\\:text-moss-25\\/65:active{
  color: rgb(250 253 247 / 0.65);
}

.active\\:text-moss-25\\/70:active{
  color: rgb(250 253 247 / 0.7);
}

.active\\:text-moss-25\\/75:active{
  color: rgb(250 253 247 / 0.75);
}

.active\\:text-moss-25\\/80:active{
  color: rgb(250 253 247 / 0.8);
}

.active\\:text-moss-25\\/85:active{
  color: rgb(250 253 247 / 0.85);
}

.active\\:text-moss-25\\/90:active{
  color: rgb(250 253 247 / 0.9);
}

.active\\:text-moss-25\\/95:active{
  color: rgb(250 253 247 / 0.95);
}

.active\\:text-moss-400:active{
  --tw-text-opacity: 1;
  color: rgb(134 203 60 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-400\\/0:active{
  color: rgb(134 203 60 / 0);
}

.active\\:text-moss-400\\/10:active{
  color: rgb(134 203 60 / 0.1);
}

.active\\:text-moss-400\\/100:active{
  color: rgb(134 203 60 / 1);
}

.active\\:text-moss-400\\/15:active{
  color: rgb(134 203 60 / 0.15);
}

.active\\:text-moss-400\\/20:active{
  color: rgb(134 203 60 / 0.2);
}

.active\\:text-moss-400\\/25:active{
  color: rgb(134 203 60 / 0.25);
}

.active\\:text-moss-400\\/30:active{
  color: rgb(134 203 60 / 0.3);
}

.active\\:text-moss-400\\/35:active{
  color: rgb(134 203 60 / 0.35);
}

.active\\:text-moss-400\\/40:active{
  color: rgb(134 203 60 / 0.4);
}

.active\\:text-moss-400\\/45:active{
  color: rgb(134 203 60 / 0.45);
}

.active\\:text-moss-400\\/5:active{
  color: rgb(134 203 60 / 0.05);
}

.active\\:text-moss-400\\/50:active{
  color: rgb(134 203 60 / 0.5);
}

.active\\:text-moss-400\\/55:active{
  color: rgb(134 203 60 / 0.55);
}

.active\\:text-moss-400\\/60:active{
  color: rgb(134 203 60 / 0.6);
}

.active\\:text-moss-400\\/65:active{
  color: rgb(134 203 60 / 0.65);
}

.active\\:text-moss-400\\/70:active{
  color: rgb(134 203 60 / 0.7);
}

.active\\:text-moss-400\\/75:active{
  color: rgb(134 203 60 / 0.75);
}

.active\\:text-moss-400\\/80:active{
  color: rgb(134 203 60 / 0.8);
}

.active\\:text-moss-400\\/85:active{
  color: rgb(134 203 60 / 0.85);
}

.active\\:text-moss-400\\/90:active{
  color: rgb(134 203 60 / 0.9);
}

.active\\:text-moss-400\\/95:active{
  color: rgb(134 203 60 / 0.95);
}

.active\\:text-moss-50:active{
  --tw-text-opacity: 1;
  color: rgb(245 251 238 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-50\\/0:active{
  color: rgb(245 251 238 / 0);
}

.active\\:text-moss-50\\/10:active{
  color: rgb(245 251 238 / 0.1);
}

.active\\:text-moss-50\\/100:active{
  color: rgb(245 251 238 / 1);
}

.active\\:text-moss-50\\/15:active{
  color: rgb(245 251 238 / 0.15);
}

.active\\:text-moss-50\\/20:active{
  color: rgb(245 251 238 / 0.2);
}

.active\\:text-moss-50\\/25:active{
  color: rgb(245 251 238 / 0.25);
}

.active\\:text-moss-50\\/30:active{
  color: rgb(245 251 238 / 0.3);
}

.active\\:text-moss-50\\/35:active{
  color: rgb(245 251 238 / 0.35);
}

.active\\:text-moss-50\\/40:active{
  color: rgb(245 251 238 / 0.4);
}

.active\\:text-moss-50\\/45:active{
  color: rgb(245 251 238 / 0.45);
}

.active\\:text-moss-50\\/5:active{
  color: rgb(245 251 238 / 0.05);
}

.active\\:text-moss-50\\/50:active{
  color: rgb(245 251 238 / 0.5);
}

.active\\:text-moss-50\\/55:active{
  color: rgb(245 251 238 / 0.55);
}

.active\\:text-moss-50\\/60:active{
  color: rgb(245 251 238 / 0.6);
}

.active\\:text-moss-50\\/65:active{
  color: rgb(245 251 238 / 0.65);
}

.active\\:text-moss-50\\/70:active{
  color: rgb(245 251 238 / 0.7);
}

.active\\:text-moss-50\\/75:active{
  color: rgb(245 251 238 / 0.75);
}

.active\\:text-moss-50\\/80:active{
  color: rgb(245 251 238 / 0.8);
}

.active\\:text-moss-50\\/85:active{
  color: rgb(245 251 238 / 0.85);
}

.active\\:text-moss-50\\/90:active{
  color: rgb(245 251 238 / 0.9);
}

.active\\:text-moss-50\\/95:active{
  color: rgb(245 251 238 / 0.95);
}

.active\\:text-moss-500:active{
  --tw-text-opacity: 1;
  color: rgb(102 159 42 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-500\\/0:active{
  color: rgb(102 159 42 / 0);
}

.active\\:text-moss-500\\/10:active{
  color: rgb(102 159 42 / 0.1);
}

.active\\:text-moss-500\\/100:active{
  color: rgb(102 159 42 / 1);
}

.active\\:text-moss-500\\/15:active{
  color: rgb(102 159 42 / 0.15);
}

.active\\:text-moss-500\\/20:active{
  color: rgb(102 159 42 / 0.2);
}

.active\\:text-moss-500\\/25:active{
  color: rgb(102 159 42 / 0.25);
}

.active\\:text-moss-500\\/30:active{
  color: rgb(102 159 42 / 0.3);
}

.active\\:text-moss-500\\/35:active{
  color: rgb(102 159 42 / 0.35);
}

.active\\:text-moss-500\\/40:active{
  color: rgb(102 159 42 / 0.4);
}

.active\\:text-moss-500\\/45:active{
  color: rgb(102 159 42 / 0.45);
}

.active\\:text-moss-500\\/5:active{
  color: rgb(102 159 42 / 0.05);
}

.active\\:text-moss-500\\/50:active{
  color: rgb(102 159 42 / 0.5);
}

.active\\:text-moss-500\\/55:active{
  color: rgb(102 159 42 / 0.55);
}

.active\\:text-moss-500\\/60:active{
  color: rgb(102 159 42 / 0.6);
}

.active\\:text-moss-500\\/65:active{
  color: rgb(102 159 42 / 0.65);
}

.active\\:text-moss-500\\/70:active{
  color: rgb(102 159 42 / 0.7);
}

.active\\:text-moss-500\\/75:active{
  color: rgb(102 159 42 / 0.75);
}

.active\\:text-moss-500\\/80:active{
  color: rgb(102 159 42 / 0.8);
}

.active\\:text-moss-500\\/85:active{
  color: rgb(102 159 42 / 0.85);
}

.active\\:text-moss-500\\/90:active{
  color: rgb(102 159 42 / 0.9);
}

.active\\:text-moss-500\\/95:active{
  color: rgb(102 159 42 / 0.95);
}

.active\\:text-moss-600:active{
  --tw-text-opacity: 1;
  color: rgb(79 122 33 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-600\\/0:active{
  color: rgb(79 122 33 / 0);
}

.active\\:text-moss-600\\/10:active{
  color: rgb(79 122 33 / 0.1);
}

.active\\:text-moss-600\\/100:active{
  color: rgb(79 122 33 / 1);
}

.active\\:text-moss-600\\/15:active{
  color: rgb(79 122 33 / 0.15);
}

.active\\:text-moss-600\\/20:active{
  color: rgb(79 122 33 / 0.2);
}

.active\\:text-moss-600\\/25:active{
  color: rgb(79 122 33 / 0.25);
}

.active\\:text-moss-600\\/30:active{
  color: rgb(79 122 33 / 0.3);
}

.active\\:text-moss-600\\/35:active{
  color: rgb(79 122 33 / 0.35);
}

.active\\:text-moss-600\\/40:active{
  color: rgb(79 122 33 / 0.4);
}

.active\\:text-moss-600\\/45:active{
  color: rgb(79 122 33 / 0.45);
}

.active\\:text-moss-600\\/5:active{
  color: rgb(79 122 33 / 0.05);
}

.active\\:text-moss-600\\/50:active{
  color: rgb(79 122 33 / 0.5);
}

.active\\:text-moss-600\\/55:active{
  color: rgb(79 122 33 / 0.55);
}

.active\\:text-moss-600\\/60:active{
  color: rgb(79 122 33 / 0.6);
}

.active\\:text-moss-600\\/65:active{
  color: rgb(79 122 33 / 0.65);
}

.active\\:text-moss-600\\/70:active{
  color: rgb(79 122 33 / 0.7);
}

.active\\:text-moss-600\\/75:active{
  color: rgb(79 122 33 / 0.75);
}

.active\\:text-moss-600\\/80:active{
  color: rgb(79 122 33 / 0.8);
}

.active\\:text-moss-600\\/85:active{
  color: rgb(79 122 33 / 0.85);
}

.active\\:text-moss-600\\/90:active{
  color: rgb(79 122 33 / 0.9);
}

.active\\:text-moss-600\\/95:active{
  color: rgb(79 122 33 / 0.95);
}

.active\\:text-moss-700:active{
  --tw-text-opacity: 1;
  color: rgb(63 98 26 / var(--tw-text-opacity, 1));
}

.active\\:text-moss-700\\/0:active{
  color: rgb(63 98 26 / 0);
}

.active\\:text-moss-700\\/10:active{
  color: rgb(63 98 26 / 0.1);
}

.active\\:text-moss-700\\/100:active{
  color: rgb(63 98 26 / 1);
}

.active\\:text-moss-700\\/15:active{
  color: rgb(63 98 26 / 0.15);
}

.active\\:text-moss-700\\/20:active{
  color: rgb(63 98 26 / 0.2);
}

.active\\:text-moss-700\\/25:active{
  color: rgb(63 98 26 / 0.25);
}

.active\\:text-moss-700\\/30:active{
  color: rgb(63 98 26 / 0.3);
}

.active\\:text-moss-700\\/35:active{
  color: rgb(63 98 26 / 0.35);
}

.active\\:text-moss-700\\/40:active{
  color: rgb(63 98 26 / 0.4);
}

.active\\:text-moss-700\\/45:active{
  color: rgb(63 98 26 / 0.45);
}

.active\\:text-moss-700\\/5:active{
  color: rgb(63 98 26 / 0.05);
}

.active\\:text-moss-700\\/50:active{
  color: rgb(63 98 26 / 0.5);
}

.active\\:text-moss-700\\/55:active{
  color: rgb(63 98 26 / 0.55);
}

.active\\:text-moss-700\\/60:active{
  color: rgb(63 98 26 / 0.6);
}

.active\\:text-moss-700\\/65:active{
  color: rgb(63 98 26 / 0.65);
}

.active\\:text-moss-700\\/70:active{
  color: rgb(63 98 26 / 0.7);
}

.active\\:text-moss-700\\/75:active{
  color: rgb(63 98 26 / 0.75);
}

.active\\:text-moss-700\\/80:active{
  color: rgb(63 98 26 / 0.8);
}

.active\\:text-moss-700\\/85:active{
  color: rgb(63 98 26 / 0.85);
}

.active\\:text-moss-700\\/90:active{
  color: rgb(63 98 26 / 0.9);
}

.active\\:text-moss-700\\/95:active{
  color: rgb(63 98 26 / 0.95);
}

.active\\:text-neutral-100:active{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-100\\/0:active{
  color: rgb(245 245 245 / 0);
}

.active\\:text-neutral-100\\/10:active{
  color: rgb(245 245 245 / 0.1);
}

.active\\:text-neutral-100\\/100:active{
  color: rgb(245 245 245 / 1);
}

.active\\:text-neutral-100\\/15:active{
  color: rgb(245 245 245 / 0.15);
}

.active\\:text-neutral-100\\/20:active{
  color: rgb(245 245 245 / 0.2);
}

.active\\:text-neutral-100\\/25:active{
  color: rgb(245 245 245 / 0.25);
}

.active\\:text-neutral-100\\/30:active{
  color: rgb(245 245 245 / 0.3);
}

.active\\:text-neutral-100\\/35:active{
  color: rgb(245 245 245 / 0.35);
}

.active\\:text-neutral-100\\/40:active{
  color: rgb(245 245 245 / 0.4);
}

.active\\:text-neutral-100\\/45:active{
  color: rgb(245 245 245 / 0.45);
}

.active\\:text-neutral-100\\/5:active{
  color: rgb(245 245 245 / 0.05);
}

.active\\:text-neutral-100\\/50:active{
  color: rgb(245 245 245 / 0.5);
}

.active\\:text-neutral-100\\/55:active{
  color: rgb(245 245 245 / 0.55);
}

.active\\:text-neutral-100\\/60:active{
  color: rgb(245 245 245 / 0.6);
}

.active\\:text-neutral-100\\/65:active{
  color: rgb(245 245 245 / 0.65);
}

.active\\:text-neutral-100\\/70:active{
  color: rgb(245 245 245 / 0.7);
}

.active\\:text-neutral-100\\/75:active{
  color: rgb(245 245 245 / 0.75);
}

.active\\:text-neutral-100\\/80:active{
  color: rgb(245 245 245 / 0.8);
}

.active\\:text-neutral-100\\/85:active{
  color: rgb(245 245 245 / 0.85);
}

.active\\:text-neutral-100\\/90:active{
  color: rgb(245 245 245 / 0.9);
}

.active\\:text-neutral-100\\/95:active{
  color: rgb(245 245 245 / 0.95);
}

.active\\:text-neutral-200:active{
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-200\\/0:active{
  color: rgb(233 234 235 / 0);
}

.active\\:text-neutral-200\\/10:active{
  color: rgb(233 234 235 / 0.1);
}

.active\\:text-neutral-200\\/100:active{
  color: rgb(233 234 235 / 1);
}

.active\\:text-neutral-200\\/15:active{
  color: rgb(233 234 235 / 0.15);
}

.active\\:text-neutral-200\\/20:active{
  color: rgb(233 234 235 / 0.2);
}

.active\\:text-neutral-200\\/25:active{
  color: rgb(233 234 235 / 0.25);
}

.active\\:text-neutral-200\\/30:active{
  color: rgb(233 234 235 / 0.3);
}

.active\\:text-neutral-200\\/35:active{
  color: rgb(233 234 235 / 0.35);
}

.active\\:text-neutral-200\\/40:active{
  color: rgb(233 234 235 / 0.4);
}

.active\\:text-neutral-200\\/45:active{
  color: rgb(233 234 235 / 0.45);
}

.active\\:text-neutral-200\\/5:active{
  color: rgb(233 234 235 / 0.05);
}

.active\\:text-neutral-200\\/50:active{
  color: rgb(233 234 235 / 0.5);
}

.active\\:text-neutral-200\\/55:active{
  color: rgb(233 234 235 / 0.55);
}

.active\\:text-neutral-200\\/60:active{
  color: rgb(233 234 235 / 0.6);
}

.active\\:text-neutral-200\\/65:active{
  color: rgb(233 234 235 / 0.65);
}

.active\\:text-neutral-200\\/70:active{
  color: rgb(233 234 235 / 0.7);
}

.active\\:text-neutral-200\\/75:active{
  color: rgb(233 234 235 / 0.75);
}

.active\\:text-neutral-200\\/80:active{
  color: rgb(233 234 235 / 0.8);
}

.active\\:text-neutral-200\\/85:active{
  color: rgb(233 234 235 / 0.85);
}

.active\\:text-neutral-200\\/90:active{
  color: rgb(233 234 235 / 0.9);
}

.active\\:text-neutral-200\\/95:active{
  color: rgb(233 234 235 / 0.95);
}

.active\\:text-neutral-25:active{
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-25\\/0:active{
  color: rgb(253 253 253 / 0);
}

.active\\:text-neutral-25\\/10:active{
  color: rgb(253 253 253 / 0.1);
}

.active\\:text-neutral-25\\/100:active{
  color: rgb(253 253 253 / 1);
}

.active\\:text-neutral-25\\/15:active{
  color: rgb(253 253 253 / 0.15);
}

.active\\:text-neutral-25\\/20:active{
  color: rgb(253 253 253 / 0.2);
}

.active\\:text-neutral-25\\/25:active{
  color: rgb(253 253 253 / 0.25);
}

.active\\:text-neutral-25\\/30:active{
  color: rgb(253 253 253 / 0.3);
}

.active\\:text-neutral-25\\/35:active{
  color: rgb(253 253 253 / 0.35);
}

.active\\:text-neutral-25\\/40:active{
  color: rgb(253 253 253 / 0.4);
}

.active\\:text-neutral-25\\/45:active{
  color: rgb(253 253 253 / 0.45);
}

.active\\:text-neutral-25\\/5:active{
  color: rgb(253 253 253 / 0.05);
}

.active\\:text-neutral-25\\/50:active{
  color: rgb(253 253 253 / 0.5);
}

.active\\:text-neutral-25\\/55:active{
  color: rgb(253 253 253 / 0.55);
}

.active\\:text-neutral-25\\/60:active{
  color: rgb(253 253 253 / 0.6);
}

.active\\:text-neutral-25\\/65:active{
  color: rgb(253 253 253 / 0.65);
}

.active\\:text-neutral-25\\/70:active{
  color: rgb(253 253 253 / 0.7);
}

.active\\:text-neutral-25\\/75:active{
  color: rgb(253 253 253 / 0.75);
}

.active\\:text-neutral-25\\/80:active{
  color: rgb(253 253 253 / 0.8);
}

.active\\:text-neutral-25\\/85:active{
  color: rgb(253 253 253 / 0.85);
}

.active\\:text-neutral-25\\/90:active{
  color: rgb(253 253 253 / 0.9);
}

.active\\:text-neutral-25\\/95:active{
  color: rgb(253 253 253 / 0.95);
}

.active\\:text-neutral-400:active{
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-400\\/0:active{
  color: rgb(164 167 174 / 0);
}

.active\\:text-neutral-400\\/10:active{
  color: rgb(164 167 174 / 0.1);
}

.active\\:text-neutral-400\\/100:active{
  color: rgb(164 167 174 / 1);
}

.active\\:text-neutral-400\\/15:active{
  color: rgb(164 167 174 / 0.15);
}

.active\\:text-neutral-400\\/20:active{
  color: rgb(164 167 174 / 0.2);
}

.active\\:text-neutral-400\\/25:active{
  color: rgb(164 167 174 / 0.25);
}

.active\\:text-neutral-400\\/30:active{
  color: rgb(164 167 174 / 0.3);
}

.active\\:text-neutral-400\\/35:active{
  color: rgb(164 167 174 / 0.35);
}

.active\\:text-neutral-400\\/40:active{
  color: rgb(164 167 174 / 0.4);
}

.active\\:text-neutral-400\\/45:active{
  color: rgb(164 167 174 / 0.45);
}

.active\\:text-neutral-400\\/5:active{
  color: rgb(164 167 174 / 0.05);
}

.active\\:text-neutral-400\\/50:active{
  color: rgb(164 167 174 / 0.5);
}

.active\\:text-neutral-400\\/55:active{
  color: rgb(164 167 174 / 0.55);
}

.active\\:text-neutral-400\\/60:active{
  color: rgb(164 167 174 / 0.6);
}

.active\\:text-neutral-400\\/65:active{
  color: rgb(164 167 174 / 0.65);
}

.active\\:text-neutral-400\\/70:active{
  color: rgb(164 167 174 / 0.7);
}

.active\\:text-neutral-400\\/75:active{
  color: rgb(164 167 174 / 0.75);
}

.active\\:text-neutral-400\\/80:active{
  color: rgb(164 167 174 / 0.8);
}

.active\\:text-neutral-400\\/85:active{
  color: rgb(164 167 174 / 0.85);
}

.active\\:text-neutral-400\\/90:active{
  color: rgb(164 167 174 / 0.9);
}

.active\\:text-neutral-400\\/95:active{
  color: rgb(164 167 174 / 0.95);
}

.active\\:text-neutral-50:active{
  --tw-text-opacity: 1;
  color: rgb(249 250 250 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-50\\/0:active{
  color: rgb(249 250 250 / 0);
}

.active\\:text-neutral-50\\/10:active{
  color: rgb(249 250 250 / 0.1);
}

.active\\:text-neutral-50\\/100:active{
  color: rgb(249 250 250 / 1);
}

.active\\:text-neutral-50\\/15:active{
  color: rgb(249 250 250 / 0.15);
}

.active\\:text-neutral-50\\/20:active{
  color: rgb(249 250 250 / 0.2);
}

.active\\:text-neutral-50\\/25:active{
  color: rgb(249 250 250 / 0.25);
}

.active\\:text-neutral-50\\/30:active{
  color: rgb(249 250 250 / 0.3);
}

.active\\:text-neutral-50\\/35:active{
  color: rgb(249 250 250 / 0.35);
}

.active\\:text-neutral-50\\/40:active{
  color: rgb(249 250 250 / 0.4);
}

.active\\:text-neutral-50\\/45:active{
  color: rgb(249 250 250 / 0.45);
}

.active\\:text-neutral-50\\/5:active{
  color: rgb(249 250 250 / 0.05);
}

.active\\:text-neutral-50\\/50:active{
  color: rgb(249 250 250 / 0.5);
}

.active\\:text-neutral-50\\/55:active{
  color: rgb(249 250 250 / 0.55);
}

.active\\:text-neutral-50\\/60:active{
  color: rgb(249 250 250 / 0.6);
}

.active\\:text-neutral-50\\/65:active{
  color: rgb(249 250 250 / 0.65);
}

.active\\:text-neutral-50\\/70:active{
  color: rgb(249 250 250 / 0.7);
}

.active\\:text-neutral-50\\/75:active{
  color: rgb(249 250 250 / 0.75);
}

.active\\:text-neutral-50\\/80:active{
  color: rgb(249 250 250 / 0.8);
}

.active\\:text-neutral-50\\/85:active{
  color: rgb(249 250 250 / 0.85);
}

.active\\:text-neutral-50\\/90:active{
  color: rgb(249 250 250 / 0.9);
}

.active\\:text-neutral-50\\/95:active{
  color: rgb(249 250 250 / 0.95);
}

.active\\:text-neutral-500:active{
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-500\\/0:active{
  color: rgb(113 118 128 / 0);
}

.active\\:text-neutral-500\\/10:active{
  color: rgb(113 118 128 / 0.1);
}

.active\\:text-neutral-500\\/100:active{
  color: rgb(113 118 128 / 1);
}

.active\\:text-neutral-500\\/15:active{
  color: rgb(113 118 128 / 0.15);
}

.active\\:text-neutral-500\\/20:active{
  color: rgb(113 118 128 / 0.2);
}

.active\\:text-neutral-500\\/25:active{
  color: rgb(113 118 128 / 0.25);
}

.active\\:text-neutral-500\\/30:active{
  color: rgb(113 118 128 / 0.3);
}

.active\\:text-neutral-500\\/35:active{
  color: rgb(113 118 128 / 0.35);
}

.active\\:text-neutral-500\\/40:active{
  color: rgb(113 118 128 / 0.4);
}

.active\\:text-neutral-500\\/45:active{
  color: rgb(113 118 128 / 0.45);
}

.active\\:text-neutral-500\\/5:active{
  color: rgb(113 118 128 / 0.05);
}

.active\\:text-neutral-500\\/50:active{
  color: rgb(113 118 128 / 0.5);
}

.active\\:text-neutral-500\\/55:active{
  color: rgb(113 118 128 / 0.55);
}

.active\\:text-neutral-500\\/60:active{
  color: rgb(113 118 128 / 0.6);
}

.active\\:text-neutral-500\\/65:active{
  color: rgb(113 118 128 / 0.65);
}

.active\\:text-neutral-500\\/70:active{
  color: rgb(113 118 128 / 0.7);
}

.active\\:text-neutral-500\\/75:active{
  color: rgb(113 118 128 / 0.75);
}

.active\\:text-neutral-500\\/80:active{
  color: rgb(113 118 128 / 0.8);
}

.active\\:text-neutral-500\\/85:active{
  color: rgb(113 118 128 / 0.85);
}

.active\\:text-neutral-500\\/90:active{
  color: rgb(113 118 128 / 0.9);
}

.active\\:text-neutral-500\\/95:active{
  color: rgb(113 118 128 / 0.95);
}

.active\\:text-neutral-600:active{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-600\\/0:active{
  color: rgb(83 88 98 / 0);
}

.active\\:text-neutral-600\\/10:active{
  color: rgb(83 88 98 / 0.1);
}

.active\\:text-neutral-600\\/100:active{
  color: rgb(83 88 98 / 1);
}

.active\\:text-neutral-600\\/15:active{
  color: rgb(83 88 98 / 0.15);
}

.active\\:text-neutral-600\\/20:active{
  color: rgb(83 88 98 / 0.2);
}

.active\\:text-neutral-600\\/25:active{
  color: rgb(83 88 98 / 0.25);
}

.active\\:text-neutral-600\\/30:active{
  color: rgb(83 88 98 / 0.3);
}

.active\\:text-neutral-600\\/35:active{
  color: rgb(83 88 98 / 0.35);
}

.active\\:text-neutral-600\\/40:active{
  color: rgb(83 88 98 / 0.4);
}

.active\\:text-neutral-600\\/45:active{
  color: rgb(83 88 98 / 0.45);
}

.active\\:text-neutral-600\\/5:active{
  color: rgb(83 88 98 / 0.05);
}

.active\\:text-neutral-600\\/50:active{
  color: rgb(83 88 98 / 0.5);
}

.active\\:text-neutral-600\\/55:active{
  color: rgb(83 88 98 / 0.55);
}

.active\\:text-neutral-600\\/60:active{
  color: rgb(83 88 98 / 0.6);
}

.active\\:text-neutral-600\\/65:active{
  color: rgb(83 88 98 / 0.65);
}

.active\\:text-neutral-600\\/70:active{
  color: rgb(83 88 98 / 0.7);
}

.active\\:text-neutral-600\\/75:active{
  color: rgb(83 88 98 / 0.75);
}

.active\\:text-neutral-600\\/80:active{
  color: rgb(83 88 98 / 0.8);
}

.active\\:text-neutral-600\\/85:active{
  color: rgb(83 88 98 / 0.85);
}

.active\\:text-neutral-600\\/90:active{
  color: rgb(83 88 98 / 0.9);
}

.active\\:text-neutral-600\\/95:active{
  color: rgb(83 88 98 / 0.95);
}

.active\\:text-neutral-700:active{
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-700\\/0:active{
  color: rgb(65 70 81 / 0);
}

.active\\:text-neutral-700\\/10:active{
  color: rgb(65 70 81 / 0.1);
}

.active\\:text-neutral-700\\/100:active{
  color: rgb(65 70 81 / 1);
}

.active\\:text-neutral-700\\/15:active{
  color: rgb(65 70 81 / 0.15);
}

.active\\:text-neutral-700\\/20:active{
  color: rgb(65 70 81 / 0.2);
}

.active\\:text-neutral-700\\/25:active{
  color: rgb(65 70 81 / 0.25);
}

.active\\:text-neutral-700\\/30:active{
  color: rgb(65 70 81 / 0.3);
}

.active\\:text-neutral-700\\/35:active{
  color: rgb(65 70 81 / 0.35);
}

.active\\:text-neutral-700\\/40:active{
  color: rgb(65 70 81 / 0.4);
}

.active\\:text-neutral-700\\/45:active{
  color: rgb(65 70 81 / 0.45);
}

.active\\:text-neutral-700\\/5:active{
  color: rgb(65 70 81 / 0.05);
}

.active\\:text-neutral-700\\/50:active{
  color: rgb(65 70 81 / 0.5);
}

.active\\:text-neutral-700\\/55:active{
  color: rgb(65 70 81 / 0.55);
}

.active\\:text-neutral-700\\/60:active{
  color: rgb(65 70 81 / 0.6);
}

.active\\:text-neutral-700\\/65:active{
  color: rgb(65 70 81 / 0.65);
}

.active\\:text-neutral-700\\/70:active{
  color: rgb(65 70 81 / 0.7);
}

.active\\:text-neutral-700\\/75:active{
  color: rgb(65 70 81 / 0.75);
}

.active\\:text-neutral-700\\/80:active{
  color: rgb(65 70 81 / 0.8);
}

.active\\:text-neutral-700\\/85:active{
  color: rgb(65 70 81 / 0.85);
}

.active\\:text-neutral-700\\/90:active{
  color: rgb(65 70 81 / 0.9);
}

.active\\:text-neutral-700\\/95:active{
  color: rgb(65 70 81 / 0.95);
}

.active\\:text-neutral-75:active{
  --tw-text-opacity: 1;
  color: rgb(246 246 246 / var(--tw-text-opacity, 1));
}

.active\\:text-neutral-75\\/0:active{
  color: rgb(246 246 246 / 0);
}

.active\\:text-neutral-75\\/10:active{
  color: rgb(246 246 246 / 0.1);
}

.active\\:text-neutral-75\\/100:active{
  color: rgb(246 246 246 / 1);
}

.active\\:text-neutral-75\\/15:active{
  color: rgb(246 246 246 / 0.15);
}

.active\\:text-neutral-75\\/20:active{
  color: rgb(246 246 246 / 0.2);
}

.active\\:text-neutral-75\\/25:active{
  color: rgb(246 246 246 / 0.25);
}

.active\\:text-neutral-75\\/30:active{
  color: rgb(246 246 246 / 0.3);
}

.active\\:text-neutral-75\\/35:active{
  color: rgb(246 246 246 / 0.35);
}

.active\\:text-neutral-75\\/40:active{
  color: rgb(246 246 246 / 0.4);
}

.active\\:text-neutral-75\\/45:active{
  color: rgb(246 246 246 / 0.45);
}

.active\\:text-neutral-75\\/5:active{
  color: rgb(246 246 246 / 0.05);
}

.active\\:text-neutral-75\\/50:active{
  color: rgb(246 246 246 / 0.5);
}

.active\\:text-neutral-75\\/55:active{
  color: rgb(246 246 246 / 0.55);
}

.active\\:text-neutral-75\\/60:active{
  color: rgb(246 246 246 / 0.6);
}

.active\\:text-neutral-75\\/65:active{
  color: rgb(246 246 246 / 0.65);
}

.active\\:text-neutral-75\\/70:active{
  color: rgb(246 246 246 / 0.7);
}

.active\\:text-neutral-75\\/75:active{
  color: rgb(246 246 246 / 0.75);
}

.active\\:text-neutral-75\\/80:active{
  color: rgb(246 246 246 / 0.8);
}

.active\\:text-neutral-75\\/85:active{
  color: rgb(246 246 246 / 0.85);
}

.active\\:text-neutral-75\\/90:active{
  color: rgb(246 246 246 / 0.9);
}

.active\\:text-neutral-75\\/95:active{
  color: rgb(246 246 246 / 0.95);
}

.active\\:text-primary-100:active{
  color: var(--color-primary-100, #E0F2FE);
}

.active\\:text-primary-200:active{
  color: var(--color-primary-200, #B9E6FE);
}

.active\\:text-primary-25:active{
  color: var(--color-primary-25, #F5FBFF);
}

.active\\:text-primary-400:active{
  color: var(--color-primary-400, #36BFFA);
}

.active\\:text-primary-50:active{
  color: var(--color-primary-50, #F0F9FF);
}

.active\\:text-primary-500:active{
  color: var(--color-primary-500, #0BA5EC);
}

.active\\:text-primary-600:active{
  color: var(--color-primary-600, #0086C9);
}

.active\\:text-primary-700:active{
  color: var(--color-primary-700, #026AA2);
}

.active\\:text-purple-100:active{
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-100\\/0:active{
  color: rgb(235 233 254 / 0);
}

.active\\:text-purple-100\\/10:active{
  color: rgb(235 233 254 / 0.1);
}

.active\\:text-purple-100\\/100:active{
  color: rgb(235 233 254 / 1);
}

.active\\:text-purple-100\\/15:active{
  color: rgb(235 233 254 / 0.15);
}

.active\\:text-purple-100\\/20:active{
  color: rgb(235 233 254 / 0.2);
}

.active\\:text-purple-100\\/25:active{
  color: rgb(235 233 254 / 0.25);
}

.active\\:text-purple-100\\/30:active{
  color: rgb(235 233 254 / 0.3);
}

.active\\:text-purple-100\\/35:active{
  color: rgb(235 233 254 / 0.35);
}

.active\\:text-purple-100\\/40:active{
  color: rgb(235 233 254 / 0.4);
}

.active\\:text-purple-100\\/45:active{
  color: rgb(235 233 254 / 0.45);
}

.active\\:text-purple-100\\/5:active{
  color: rgb(235 233 254 / 0.05);
}

.active\\:text-purple-100\\/50:active{
  color: rgb(235 233 254 / 0.5);
}

.active\\:text-purple-100\\/55:active{
  color: rgb(235 233 254 / 0.55);
}

.active\\:text-purple-100\\/60:active{
  color: rgb(235 233 254 / 0.6);
}

.active\\:text-purple-100\\/65:active{
  color: rgb(235 233 254 / 0.65);
}

.active\\:text-purple-100\\/70:active{
  color: rgb(235 233 254 / 0.7);
}

.active\\:text-purple-100\\/75:active{
  color: rgb(235 233 254 / 0.75);
}

.active\\:text-purple-100\\/80:active{
  color: rgb(235 233 254 / 0.8);
}

.active\\:text-purple-100\\/85:active{
  color: rgb(235 233 254 / 0.85);
}

.active\\:text-purple-100\\/90:active{
  color: rgb(235 233 254 / 0.9);
}

.active\\:text-purple-100\\/95:active{
  color: rgb(235 233 254 / 0.95);
}

.active\\:text-purple-200:active{
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-200\\/0:active{
  color: rgb(217 214 254 / 0);
}

.active\\:text-purple-200\\/10:active{
  color: rgb(217 214 254 / 0.1);
}

.active\\:text-purple-200\\/100:active{
  color: rgb(217 214 254 / 1);
}

.active\\:text-purple-200\\/15:active{
  color: rgb(217 214 254 / 0.15);
}

.active\\:text-purple-200\\/20:active{
  color: rgb(217 214 254 / 0.2);
}

.active\\:text-purple-200\\/25:active{
  color: rgb(217 214 254 / 0.25);
}

.active\\:text-purple-200\\/30:active{
  color: rgb(217 214 254 / 0.3);
}

.active\\:text-purple-200\\/35:active{
  color: rgb(217 214 254 / 0.35);
}

.active\\:text-purple-200\\/40:active{
  color: rgb(217 214 254 / 0.4);
}

.active\\:text-purple-200\\/45:active{
  color: rgb(217 214 254 / 0.45);
}

.active\\:text-purple-200\\/5:active{
  color: rgb(217 214 254 / 0.05);
}

.active\\:text-purple-200\\/50:active{
  color: rgb(217 214 254 / 0.5);
}

.active\\:text-purple-200\\/55:active{
  color: rgb(217 214 254 / 0.55);
}

.active\\:text-purple-200\\/60:active{
  color: rgb(217 214 254 / 0.6);
}

.active\\:text-purple-200\\/65:active{
  color: rgb(217 214 254 / 0.65);
}

.active\\:text-purple-200\\/70:active{
  color: rgb(217 214 254 / 0.7);
}

.active\\:text-purple-200\\/75:active{
  color: rgb(217 214 254 / 0.75);
}

.active\\:text-purple-200\\/80:active{
  color: rgb(217 214 254 / 0.8);
}

.active\\:text-purple-200\\/85:active{
  color: rgb(217 214 254 / 0.85);
}

.active\\:text-purple-200\\/90:active{
  color: rgb(217 214 254 / 0.9);
}

.active\\:text-purple-200\\/95:active{
  color: rgb(217 214 254 / 0.95);
}

.active\\:text-purple-25:active{
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-25\\/0:active{
  color: rgb(250 250 255 / 0);
}

.active\\:text-purple-25\\/10:active{
  color: rgb(250 250 255 / 0.1);
}

.active\\:text-purple-25\\/100:active{
  color: rgb(250 250 255 / 1);
}

.active\\:text-purple-25\\/15:active{
  color: rgb(250 250 255 / 0.15);
}

.active\\:text-purple-25\\/20:active{
  color: rgb(250 250 255 / 0.2);
}

.active\\:text-purple-25\\/25:active{
  color: rgb(250 250 255 / 0.25);
}

.active\\:text-purple-25\\/30:active{
  color: rgb(250 250 255 / 0.3);
}

.active\\:text-purple-25\\/35:active{
  color: rgb(250 250 255 / 0.35);
}

.active\\:text-purple-25\\/40:active{
  color: rgb(250 250 255 / 0.4);
}

.active\\:text-purple-25\\/45:active{
  color: rgb(250 250 255 / 0.45);
}

.active\\:text-purple-25\\/5:active{
  color: rgb(250 250 255 / 0.05);
}

.active\\:text-purple-25\\/50:active{
  color: rgb(250 250 255 / 0.5);
}

.active\\:text-purple-25\\/55:active{
  color: rgb(250 250 255 / 0.55);
}

.active\\:text-purple-25\\/60:active{
  color: rgb(250 250 255 / 0.6);
}

.active\\:text-purple-25\\/65:active{
  color: rgb(250 250 255 / 0.65);
}

.active\\:text-purple-25\\/70:active{
  color: rgb(250 250 255 / 0.7);
}

.active\\:text-purple-25\\/75:active{
  color: rgb(250 250 255 / 0.75);
}

.active\\:text-purple-25\\/80:active{
  color: rgb(250 250 255 / 0.8);
}

.active\\:text-purple-25\\/85:active{
  color: rgb(250 250 255 / 0.85);
}

.active\\:text-purple-25\\/90:active{
  color: rgb(250 250 255 / 0.9);
}

.active\\:text-purple-25\\/95:active{
  color: rgb(250 250 255 / 0.95);
}

.active\\:text-purple-400:active{
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-400\\/0:active{
  color: rgb(155 138 251 / 0);
}

.active\\:text-purple-400\\/10:active{
  color: rgb(155 138 251 / 0.1);
}

.active\\:text-purple-400\\/100:active{
  color: rgb(155 138 251 / 1);
}

.active\\:text-purple-400\\/15:active{
  color: rgb(155 138 251 / 0.15);
}

.active\\:text-purple-400\\/20:active{
  color: rgb(155 138 251 / 0.2);
}

.active\\:text-purple-400\\/25:active{
  color: rgb(155 138 251 / 0.25);
}

.active\\:text-purple-400\\/30:active{
  color: rgb(155 138 251 / 0.3);
}

.active\\:text-purple-400\\/35:active{
  color: rgb(155 138 251 / 0.35);
}

.active\\:text-purple-400\\/40:active{
  color: rgb(155 138 251 / 0.4);
}

.active\\:text-purple-400\\/45:active{
  color: rgb(155 138 251 / 0.45);
}

.active\\:text-purple-400\\/5:active{
  color: rgb(155 138 251 / 0.05);
}

.active\\:text-purple-400\\/50:active{
  color: rgb(155 138 251 / 0.5);
}

.active\\:text-purple-400\\/55:active{
  color: rgb(155 138 251 / 0.55);
}

.active\\:text-purple-400\\/60:active{
  color: rgb(155 138 251 / 0.6);
}

.active\\:text-purple-400\\/65:active{
  color: rgb(155 138 251 / 0.65);
}

.active\\:text-purple-400\\/70:active{
  color: rgb(155 138 251 / 0.7);
}

.active\\:text-purple-400\\/75:active{
  color: rgb(155 138 251 / 0.75);
}

.active\\:text-purple-400\\/80:active{
  color: rgb(155 138 251 / 0.8);
}

.active\\:text-purple-400\\/85:active{
  color: rgb(155 138 251 / 0.85);
}

.active\\:text-purple-400\\/90:active{
  color: rgb(155 138 251 / 0.9);
}

.active\\:text-purple-400\\/95:active{
  color: rgb(155 138 251 / 0.95);
}

.active\\:text-purple-50:active{
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-50\\/0:active{
  color: rgb(244 243 255 / 0);
}

.active\\:text-purple-50\\/10:active{
  color: rgb(244 243 255 / 0.1);
}

.active\\:text-purple-50\\/100:active{
  color: rgb(244 243 255 / 1);
}

.active\\:text-purple-50\\/15:active{
  color: rgb(244 243 255 / 0.15);
}

.active\\:text-purple-50\\/20:active{
  color: rgb(244 243 255 / 0.2);
}

.active\\:text-purple-50\\/25:active{
  color: rgb(244 243 255 / 0.25);
}

.active\\:text-purple-50\\/30:active{
  color: rgb(244 243 255 / 0.3);
}

.active\\:text-purple-50\\/35:active{
  color: rgb(244 243 255 / 0.35);
}

.active\\:text-purple-50\\/40:active{
  color: rgb(244 243 255 / 0.4);
}

.active\\:text-purple-50\\/45:active{
  color: rgb(244 243 255 / 0.45);
}

.active\\:text-purple-50\\/5:active{
  color: rgb(244 243 255 / 0.05);
}

.active\\:text-purple-50\\/50:active{
  color: rgb(244 243 255 / 0.5);
}

.active\\:text-purple-50\\/55:active{
  color: rgb(244 243 255 / 0.55);
}

.active\\:text-purple-50\\/60:active{
  color: rgb(244 243 255 / 0.6);
}

.active\\:text-purple-50\\/65:active{
  color: rgb(244 243 255 / 0.65);
}

.active\\:text-purple-50\\/70:active{
  color: rgb(244 243 255 / 0.7);
}

.active\\:text-purple-50\\/75:active{
  color: rgb(244 243 255 / 0.75);
}

.active\\:text-purple-50\\/80:active{
  color: rgb(244 243 255 / 0.8);
}

.active\\:text-purple-50\\/85:active{
  color: rgb(244 243 255 / 0.85);
}

.active\\:text-purple-50\\/90:active{
  color: rgb(244 243 255 / 0.9);
}

.active\\:text-purple-50\\/95:active{
  color: rgb(244 243 255 / 0.95);
}

.active\\:text-purple-500:active{
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-500\\/0:active{
  color: rgb(122 90 248 / 0);
}

.active\\:text-purple-500\\/10:active{
  color: rgb(122 90 248 / 0.1);
}

.active\\:text-purple-500\\/100:active{
  color: rgb(122 90 248 / 1);
}

.active\\:text-purple-500\\/15:active{
  color: rgb(122 90 248 / 0.15);
}

.active\\:text-purple-500\\/20:active{
  color: rgb(122 90 248 / 0.2);
}

.active\\:text-purple-500\\/25:active{
  color: rgb(122 90 248 / 0.25);
}

.active\\:text-purple-500\\/30:active{
  color: rgb(122 90 248 / 0.3);
}

.active\\:text-purple-500\\/35:active{
  color: rgb(122 90 248 / 0.35);
}

.active\\:text-purple-500\\/40:active{
  color: rgb(122 90 248 / 0.4);
}

.active\\:text-purple-500\\/45:active{
  color: rgb(122 90 248 / 0.45);
}

.active\\:text-purple-500\\/5:active{
  color: rgb(122 90 248 / 0.05);
}

.active\\:text-purple-500\\/50:active{
  color: rgb(122 90 248 / 0.5);
}

.active\\:text-purple-500\\/55:active{
  color: rgb(122 90 248 / 0.55);
}

.active\\:text-purple-500\\/60:active{
  color: rgb(122 90 248 / 0.6);
}

.active\\:text-purple-500\\/65:active{
  color: rgb(122 90 248 / 0.65);
}

.active\\:text-purple-500\\/70:active{
  color: rgb(122 90 248 / 0.7);
}

.active\\:text-purple-500\\/75:active{
  color: rgb(122 90 248 / 0.75);
}

.active\\:text-purple-500\\/80:active{
  color: rgb(122 90 248 / 0.8);
}

.active\\:text-purple-500\\/85:active{
  color: rgb(122 90 248 / 0.85);
}

.active\\:text-purple-500\\/90:active{
  color: rgb(122 90 248 / 0.9);
}

.active\\:text-purple-500\\/95:active{
  color: rgb(122 90 248 / 0.95);
}

.active\\:text-purple-600:active{
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-600\\/0:active{
  color: rgb(105 56 239 / 0);
}

.active\\:text-purple-600\\/10:active{
  color: rgb(105 56 239 / 0.1);
}

.active\\:text-purple-600\\/100:active{
  color: rgb(105 56 239 / 1);
}

.active\\:text-purple-600\\/15:active{
  color: rgb(105 56 239 / 0.15);
}

.active\\:text-purple-600\\/20:active{
  color: rgb(105 56 239 / 0.2);
}

.active\\:text-purple-600\\/25:active{
  color: rgb(105 56 239 / 0.25);
}

.active\\:text-purple-600\\/30:active{
  color: rgb(105 56 239 / 0.3);
}

.active\\:text-purple-600\\/35:active{
  color: rgb(105 56 239 / 0.35);
}

.active\\:text-purple-600\\/40:active{
  color: rgb(105 56 239 / 0.4);
}

.active\\:text-purple-600\\/45:active{
  color: rgb(105 56 239 / 0.45);
}

.active\\:text-purple-600\\/5:active{
  color: rgb(105 56 239 / 0.05);
}

.active\\:text-purple-600\\/50:active{
  color: rgb(105 56 239 / 0.5);
}

.active\\:text-purple-600\\/55:active{
  color: rgb(105 56 239 / 0.55);
}

.active\\:text-purple-600\\/60:active{
  color: rgb(105 56 239 / 0.6);
}

.active\\:text-purple-600\\/65:active{
  color: rgb(105 56 239 / 0.65);
}

.active\\:text-purple-600\\/70:active{
  color: rgb(105 56 239 / 0.7);
}

.active\\:text-purple-600\\/75:active{
  color: rgb(105 56 239 / 0.75);
}

.active\\:text-purple-600\\/80:active{
  color: rgb(105 56 239 / 0.8);
}

.active\\:text-purple-600\\/85:active{
  color: rgb(105 56 239 / 0.85);
}

.active\\:text-purple-600\\/90:active{
  color: rgb(105 56 239 / 0.9);
}

.active\\:text-purple-600\\/95:active{
  color: rgb(105 56 239 / 0.95);
}

.active\\:text-purple-700:active{
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}

.active\\:text-purple-700\\/0:active{
  color: rgb(89 37 220 / 0);
}

.active\\:text-purple-700\\/10:active{
  color: rgb(89 37 220 / 0.1);
}

.active\\:text-purple-700\\/100:active{
  color: rgb(89 37 220 / 1);
}

.active\\:text-purple-700\\/15:active{
  color: rgb(89 37 220 / 0.15);
}

.active\\:text-purple-700\\/20:active{
  color: rgb(89 37 220 / 0.2);
}

.active\\:text-purple-700\\/25:active{
  color: rgb(89 37 220 / 0.25);
}

.active\\:text-purple-700\\/30:active{
  color: rgb(89 37 220 / 0.3);
}

.active\\:text-purple-700\\/35:active{
  color: rgb(89 37 220 / 0.35);
}

.active\\:text-purple-700\\/40:active{
  color: rgb(89 37 220 / 0.4);
}

.active\\:text-purple-700\\/45:active{
  color: rgb(89 37 220 / 0.45);
}

.active\\:text-purple-700\\/5:active{
  color: rgb(89 37 220 / 0.05);
}

.active\\:text-purple-700\\/50:active{
  color: rgb(89 37 220 / 0.5);
}

.active\\:text-purple-700\\/55:active{
  color: rgb(89 37 220 / 0.55);
}

.active\\:text-purple-700\\/60:active{
  color: rgb(89 37 220 / 0.6);
}

.active\\:text-purple-700\\/65:active{
  color: rgb(89 37 220 / 0.65);
}

.active\\:text-purple-700\\/70:active{
  color: rgb(89 37 220 / 0.7);
}

.active\\:text-purple-700\\/75:active{
  color: rgb(89 37 220 / 0.75);
}

.active\\:text-purple-700\\/80:active{
  color: rgb(89 37 220 / 0.8);
}

.active\\:text-purple-700\\/85:active{
  color: rgb(89 37 220 / 0.85);
}

.active\\:text-purple-700\\/90:active{
  color: rgb(89 37 220 / 0.9);
}

.active\\:text-purple-700\\/95:active{
  color: rgb(89 37 220 / 0.95);
}

.active\\:text-success-100:active{
  --tw-text-opacity: 1;
  color: rgb(211 248 223 / var(--tw-text-opacity, 1));
}

.active\\:text-success-100\\/0:active{
  color: rgb(211 248 223 / 0);
}

.active\\:text-success-100\\/10:active{
  color: rgb(211 248 223 / 0.1);
}

.active\\:text-success-100\\/100:active{
  color: rgb(211 248 223 / 1);
}

.active\\:text-success-100\\/15:active{
  color: rgb(211 248 223 / 0.15);
}

.active\\:text-success-100\\/20:active{
  color: rgb(211 248 223 / 0.2);
}

.active\\:text-success-100\\/25:active{
  color: rgb(211 248 223 / 0.25);
}

.active\\:text-success-100\\/30:active{
  color: rgb(211 248 223 / 0.3);
}

.active\\:text-success-100\\/35:active{
  color: rgb(211 248 223 / 0.35);
}

.active\\:text-success-100\\/40:active{
  color: rgb(211 248 223 / 0.4);
}

.active\\:text-success-100\\/45:active{
  color: rgb(211 248 223 / 0.45);
}

.active\\:text-success-100\\/5:active{
  color: rgb(211 248 223 / 0.05);
}

.active\\:text-success-100\\/50:active{
  color: rgb(211 248 223 / 0.5);
}

.active\\:text-success-100\\/55:active{
  color: rgb(211 248 223 / 0.55);
}

.active\\:text-success-100\\/60:active{
  color: rgb(211 248 223 / 0.6);
}

.active\\:text-success-100\\/65:active{
  color: rgb(211 248 223 / 0.65);
}

.active\\:text-success-100\\/70:active{
  color: rgb(211 248 223 / 0.7);
}

.active\\:text-success-100\\/75:active{
  color: rgb(211 248 223 / 0.75);
}

.active\\:text-success-100\\/80:active{
  color: rgb(211 248 223 / 0.8);
}

.active\\:text-success-100\\/85:active{
  color: rgb(211 248 223 / 0.85);
}

.active\\:text-success-100\\/90:active{
  color: rgb(211 248 223 / 0.9);
}

.active\\:text-success-100\\/95:active{
  color: rgb(211 248 223 / 0.95);
}

.active\\:text-success-200:active{
  --tw-text-opacity: 1;
  color: rgb(170 240 196 / var(--tw-text-opacity, 1));
}

.active\\:text-success-200\\/0:active{
  color: rgb(170 240 196 / 0);
}

.active\\:text-success-200\\/10:active{
  color: rgb(170 240 196 / 0.1);
}

.active\\:text-success-200\\/100:active{
  color: rgb(170 240 196 / 1);
}

.active\\:text-success-200\\/15:active{
  color: rgb(170 240 196 / 0.15);
}

.active\\:text-success-200\\/20:active{
  color: rgb(170 240 196 / 0.2);
}

.active\\:text-success-200\\/25:active{
  color: rgb(170 240 196 / 0.25);
}

.active\\:text-success-200\\/30:active{
  color: rgb(170 240 196 / 0.3);
}

.active\\:text-success-200\\/35:active{
  color: rgb(170 240 196 / 0.35);
}

.active\\:text-success-200\\/40:active{
  color: rgb(170 240 196 / 0.4);
}

.active\\:text-success-200\\/45:active{
  color: rgb(170 240 196 / 0.45);
}

.active\\:text-success-200\\/5:active{
  color: rgb(170 240 196 / 0.05);
}

.active\\:text-success-200\\/50:active{
  color: rgb(170 240 196 / 0.5);
}

.active\\:text-success-200\\/55:active{
  color: rgb(170 240 196 / 0.55);
}

.active\\:text-success-200\\/60:active{
  color: rgb(170 240 196 / 0.6);
}

.active\\:text-success-200\\/65:active{
  color: rgb(170 240 196 / 0.65);
}

.active\\:text-success-200\\/70:active{
  color: rgb(170 240 196 / 0.7);
}

.active\\:text-success-200\\/75:active{
  color: rgb(170 240 196 / 0.75);
}

.active\\:text-success-200\\/80:active{
  color: rgb(170 240 196 / 0.8);
}

.active\\:text-success-200\\/85:active{
  color: rgb(170 240 196 / 0.85);
}

.active\\:text-success-200\\/90:active{
  color: rgb(170 240 196 / 0.9);
}

.active\\:text-success-200\\/95:active{
  color: rgb(170 240 196 / 0.95);
}

.active\\:text-success-25:active{
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}

.active\\:text-success-25\\/0:active{
  color: rgb(246 254 249 / 0);
}

.active\\:text-success-25\\/10:active{
  color: rgb(246 254 249 / 0.1);
}

.active\\:text-success-25\\/100:active{
  color: rgb(246 254 249 / 1);
}

.active\\:text-success-25\\/15:active{
  color: rgb(246 254 249 / 0.15);
}

.active\\:text-success-25\\/20:active{
  color: rgb(246 254 249 / 0.2);
}

.active\\:text-success-25\\/25:active{
  color: rgb(246 254 249 / 0.25);
}

.active\\:text-success-25\\/30:active{
  color: rgb(246 254 249 / 0.3);
}

.active\\:text-success-25\\/35:active{
  color: rgb(246 254 249 / 0.35);
}

.active\\:text-success-25\\/40:active{
  color: rgb(246 254 249 / 0.4);
}

.active\\:text-success-25\\/45:active{
  color: rgb(246 254 249 / 0.45);
}

.active\\:text-success-25\\/5:active{
  color: rgb(246 254 249 / 0.05);
}

.active\\:text-success-25\\/50:active{
  color: rgb(246 254 249 / 0.5);
}

.active\\:text-success-25\\/55:active{
  color: rgb(246 254 249 / 0.55);
}

.active\\:text-success-25\\/60:active{
  color: rgb(246 254 249 / 0.6);
}

.active\\:text-success-25\\/65:active{
  color: rgb(246 254 249 / 0.65);
}

.active\\:text-success-25\\/70:active{
  color: rgb(246 254 249 / 0.7);
}

.active\\:text-success-25\\/75:active{
  color: rgb(246 254 249 / 0.75);
}

.active\\:text-success-25\\/80:active{
  color: rgb(246 254 249 / 0.8);
}

.active\\:text-success-25\\/85:active{
  color: rgb(246 254 249 / 0.85);
}

.active\\:text-success-25\\/90:active{
  color: rgb(246 254 249 / 0.9);
}

.active\\:text-success-25\\/95:active{
  color: rgb(246 254 249 / 0.95);
}

.active\\:text-success-400:active{
  --tw-text-opacity: 1;
  color: rgb(60 203 127 / var(--tw-text-opacity, 1));
}

.active\\:text-success-400\\/0:active{
  color: rgb(60 203 127 / 0);
}

.active\\:text-success-400\\/10:active{
  color: rgb(60 203 127 / 0.1);
}

.active\\:text-success-400\\/100:active{
  color: rgb(60 203 127 / 1);
}

.active\\:text-success-400\\/15:active{
  color: rgb(60 203 127 / 0.15);
}

.active\\:text-success-400\\/20:active{
  color: rgb(60 203 127 / 0.2);
}

.active\\:text-success-400\\/25:active{
  color: rgb(60 203 127 / 0.25);
}

.active\\:text-success-400\\/30:active{
  color: rgb(60 203 127 / 0.3);
}

.active\\:text-success-400\\/35:active{
  color: rgb(60 203 127 / 0.35);
}

.active\\:text-success-400\\/40:active{
  color: rgb(60 203 127 / 0.4);
}

.active\\:text-success-400\\/45:active{
  color: rgb(60 203 127 / 0.45);
}

.active\\:text-success-400\\/5:active{
  color: rgb(60 203 127 / 0.05);
}

.active\\:text-success-400\\/50:active{
  color: rgb(60 203 127 / 0.5);
}

.active\\:text-success-400\\/55:active{
  color: rgb(60 203 127 / 0.55);
}

.active\\:text-success-400\\/60:active{
  color: rgb(60 203 127 / 0.6);
}

.active\\:text-success-400\\/65:active{
  color: rgb(60 203 127 / 0.65);
}

.active\\:text-success-400\\/70:active{
  color: rgb(60 203 127 / 0.7);
}

.active\\:text-success-400\\/75:active{
  color: rgb(60 203 127 / 0.75);
}

.active\\:text-success-400\\/80:active{
  color: rgb(60 203 127 / 0.8);
}

.active\\:text-success-400\\/85:active{
  color: rgb(60 203 127 / 0.85);
}

.active\\:text-success-400\\/90:active{
  color: rgb(60 203 127 / 0.9);
}

.active\\:text-success-400\\/95:active{
  color: rgb(60 203 127 / 0.95);
}

.active\\:text-success-50:active{
  --tw-text-opacity: 1;
  color: rgb(237 252 242 / var(--tw-text-opacity, 1));
}

.active\\:text-success-50\\/0:active{
  color: rgb(237 252 242 / 0);
}

.active\\:text-success-50\\/10:active{
  color: rgb(237 252 242 / 0.1);
}

.active\\:text-success-50\\/100:active{
  color: rgb(237 252 242 / 1);
}

.active\\:text-success-50\\/15:active{
  color: rgb(237 252 242 / 0.15);
}

.active\\:text-success-50\\/20:active{
  color: rgb(237 252 242 / 0.2);
}

.active\\:text-success-50\\/25:active{
  color: rgb(237 252 242 / 0.25);
}

.active\\:text-success-50\\/30:active{
  color: rgb(237 252 242 / 0.3);
}

.active\\:text-success-50\\/35:active{
  color: rgb(237 252 242 / 0.35);
}

.active\\:text-success-50\\/40:active{
  color: rgb(237 252 242 / 0.4);
}

.active\\:text-success-50\\/45:active{
  color: rgb(237 252 242 / 0.45);
}

.active\\:text-success-50\\/5:active{
  color: rgb(237 252 242 / 0.05);
}

.active\\:text-success-50\\/50:active{
  color: rgb(237 252 242 / 0.5);
}

.active\\:text-success-50\\/55:active{
  color: rgb(237 252 242 / 0.55);
}

.active\\:text-success-50\\/60:active{
  color: rgb(237 252 242 / 0.6);
}

.active\\:text-success-50\\/65:active{
  color: rgb(237 252 242 / 0.65);
}

.active\\:text-success-50\\/70:active{
  color: rgb(237 252 242 / 0.7);
}

.active\\:text-success-50\\/75:active{
  color: rgb(237 252 242 / 0.75);
}

.active\\:text-success-50\\/80:active{
  color: rgb(237 252 242 / 0.8);
}

.active\\:text-success-50\\/85:active{
  color: rgb(237 252 242 / 0.85);
}

.active\\:text-success-50\\/90:active{
  color: rgb(237 252 242 / 0.9);
}

.active\\:text-success-50\\/95:active{
  color: rgb(237 252 242 / 0.95);
}

.active\\:text-success-500:active{
  --tw-text-opacity: 1;
  color: rgb(22 179 100 / var(--tw-text-opacity, 1));
}

.active\\:text-success-500\\/0:active{
  color: rgb(22 179 100 / 0);
}

.active\\:text-success-500\\/10:active{
  color: rgb(22 179 100 / 0.1);
}

.active\\:text-success-500\\/100:active{
  color: rgb(22 179 100 / 1);
}

.active\\:text-success-500\\/15:active{
  color: rgb(22 179 100 / 0.15);
}

.active\\:text-success-500\\/20:active{
  color: rgb(22 179 100 / 0.2);
}

.active\\:text-success-500\\/25:active{
  color: rgb(22 179 100 / 0.25);
}

.active\\:text-success-500\\/30:active{
  color: rgb(22 179 100 / 0.3);
}

.active\\:text-success-500\\/35:active{
  color: rgb(22 179 100 / 0.35);
}

.active\\:text-success-500\\/40:active{
  color: rgb(22 179 100 / 0.4);
}

.active\\:text-success-500\\/45:active{
  color: rgb(22 179 100 / 0.45);
}

.active\\:text-success-500\\/5:active{
  color: rgb(22 179 100 / 0.05);
}

.active\\:text-success-500\\/50:active{
  color: rgb(22 179 100 / 0.5);
}

.active\\:text-success-500\\/55:active{
  color: rgb(22 179 100 / 0.55);
}

.active\\:text-success-500\\/60:active{
  color: rgb(22 179 100 / 0.6);
}

.active\\:text-success-500\\/65:active{
  color: rgb(22 179 100 / 0.65);
}

.active\\:text-success-500\\/70:active{
  color: rgb(22 179 100 / 0.7);
}

.active\\:text-success-500\\/75:active{
  color: rgb(22 179 100 / 0.75);
}

.active\\:text-success-500\\/80:active{
  color: rgb(22 179 100 / 0.8);
}

.active\\:text-success-500\\/85:active{
  color: rgb(22 179 100 / 0.85);
}

.active\\:text-success-500\\/90:active{
  color: rgb(22 179 100 / 0.9);
}

.active\\:text-success-500\\/95:active{
  color: rgb(22 179 100 / 0.95);
}

.active\\:text-success-600:active{
  --tw-text-opacity: 1;
  color: rgb(9 146 80 / var(--tw-text-opacity, 1));
}

.active\\:text-success-600\\/0:active{
  color: rgb(9 146 80 / 0);
}

.active\\:text-success-600\\/10:active{
  color: rgb(9 146 80 / 0.1);
}

.active\\:text-success-600\\/100:active{
  color: rgb(9 146 80 / 1);
}

.active\\:text-success-600\\/15:active{
  color: rgb(9 146 80 / 0.15);
}

.active\\:text-success-600\\/20:active{
  color: rgb(9 146 80 / 0.2);
}

.active\\:text-success-600\\/25:active{
  color: rgb(9 146 80 / 0.25);
}

.active\\:text-success-600\\/30:active{
  color: rgb(9 146 80 / 0.3);
}

.active\\:text-success-600\\/35:active{
  color: rgb(9 146 80 / 0.35);
}

.active\\:text-success-600\\/40:active{
  color: rgb(9 146 80 / 0.4);
}

.active\\:text-success-600\\/45:active{
  color: rgb(9 146 80 / 0.45);
}

.active\\:text-success-600\\/5:active{
  color: rgb(9 146 80 / 0.05);
}

.active\\:text-success-600\\/50:active{
  color: rgb(9 146 80 / 0.5);
}

.active\\:text-success-600\\/55:active{
  color: rgb(9 146 80 / 0.55);
}

.active\\:text-success-600\\/60:active{
  color: rgb(9 146 80 / 0.6);
}

.active\\:text-success-600\\/65:active{
  color: rgb(9 146 80 / 0.65);
}

.active\\:text-success-600\\/70:active{
  color: rgb(9 146 80 / 0.7);
}

.active\\:text-success-600\\/75:active{
  color: rgb(9 146 80 / 0.75);
}

.active\\:text-success-600\\/80:active{
  color: rgb(9 146 80 / 0.8);
}

.active\\:text-success-600\\/85:active{
  color: rgb(9 146 80 / 0.85);
}

.active\\:text-success-600\\/90:active{
  color: rgb(9 146 80 / 0.9);
}

.active\\:text-success-600\\/95:active{
  color: rgb(9 146 80 / 0.95);
}

.active\\:text-success-700:active{
  --tw-text-opacity: 1;
  color: rgb(8 116 67 / var(--tw-text-opacity, 1));
}

.active\\:text-success-700\\/0:active{
  color: rgb(8 116 67 / 0);
}

.active\\:text-success-700\\/10:active{
  color: rgb(8 116 67 / 0.1);
}

.active\\:text-success-700\\/100:active{
  color: rgb(8 116 67 / 1);
}

.active\\:text-success-700\\/15:active{
  color: rgb(8 116 67 / 0.15);
}

.active\\:text-success-700\\/20:active{
  color: rgb(8 116 67 / 0.2);
}

.active\\:text-success-700\\/25:active{
  color: rgb(8 116 67 / 0.25);
}

.active\\:text-success-700\\/30:active{
  color: rgb(8 116 67 / 0.3);
}

.active\\:text-success-700\\/35:active{
  color: rgb(8 116 67 / 0.35);
}

.active\\:text-success-700\\/40:active{
  color: rgb(8 116 67 / 0.4);
}

.active\\:text-success-700\\/45:active{
  color: rgb(8 116 67 / 0.45);
}

.active\\:text-success-700\\/5:active{
  color: rgb(8 116 67 / 0.05);
}

.active\\:text-success-700\\/50:active{
  color: rgb(8 116 67 / 0.5);
}

.active\\:text-success-700\\/55:active{
  color: rgb(8 116 67 / 0.55);
}

.active\\:text-success-700\\/60:active{
  color: rgb(8 116 67 / 0.6);
}

.active\\:text-success-700\\/65:active{
  color: rgb(8 116 67 / 0.65);
}

.active\\:text-success-700\\/70:active{
  color: rgb(8 116 67 / 0.7);
}

.active\\:text-success-700\\/75:active{
  color: rgb(8 116 67 / 0.75);
}

.active\\:text-success-700\\/80:active{
  color: rgb(8 116 67 / 0.8);
}

.active\\:text-success-700\\/85:active{
  color: rgb(8 116 67 / 0.85);
}

.active\\:text-success-700\\/90:active{
  color: rgb(8 116 67 / 0.9);
}

.active\\:text-success-700\\/95:active{
  color: rgb(8 116 67 / 0.95);
}

.active\\:text-warning-100:active{
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-100\\/0:active{
  color: rgb(254 240 199 / 0);
}

.active\\:text-warning-100\\/10:active{
  color: rgb(254 240 199 / 0.1);
}

.active\\:text-warning-100\\/100:active{
  color: rgb(254 240 199 / 1);
}

.active\\:text-warning-100\\/15:active{
  color: rgb(254 240 199 / 0.15);
}

.active\\:text-warning-100\\/20:active{
  color: rgb(254 240 199 / 0.2);
}

.active\\:text-warning-100\\/25:active{
  color: rgb(254 240 199 / 0.25);
}

.active\\:text-warning-100\\/30:active{
  color: rgb(254 240 199 / 0.3);
}

.active\\:text-warning-100\\/35:active{
  color: rgb(254 240 199 / 0.35);
}

.active\\:text-warning-100\\/40:active{
  color: rgb(254 240 199 / 0.4);
}

.active\\:text-warning-100\\/45:active{
  color: rgb(254 240 199 / 0.45);
}

.active\\:text-warning-100\\/5:active{
  color: rgb(254 240 199 / 0.05);
}

.active\\:text-warning-100\\/50:active{
  color: rgb(254 240 199 / 0.5);
}

.active\\:text-warning-100\\/55:active{
  color: rgb(254 240 199 / 0.55);
}

.active\\:text-warning-100\\/60:active{
  color: rgb(254 240 199 / 0.6);
}

.active\\:text-warning-100\\/65:active{
  color: rgb(254 240 199 / 0.65);
}

.active\\:text-warning-100\\/70:active{
  color: rgb(254 240 199 / 0.7);
}

.active\\:text-warning-100\\/75:active{
  color: rgb(254 240 199 / 0.75);
}

.active\\:text-warning-100\\/80:active{
  color: rgb(254 240 199 / 0.8);
}

.active\\:text-warning-100\\/85:active{
  color: rgb(254 240 199 / 0.85);
}

.active\\:text-warning-100\\/90:active{
  color: rgb(254 240 199 / 0.9);
}

.active\\:text-warning-100\\/95:active{
  color: rgb(254 240 199 / 0.95);
}

.active\\:text-warning-200:active{
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-200\\/0:active{
  color: rgb(254 223 137 / 0);
}

.active\\:text-warning-200\\/10:active{
  color: rgb(254 223 137 / 0.1);
}

.active\\:text-warning-200\\/100:active{
  color: rgb(254 223 137 / 1);
}

.active\\:text-warning-200\\/15:active{
  color: rgb(254 223 137 / 0.15);
}

.active\\:text-warning-200\\/20:active{
  color: rgb(254 223 137 / 0.2);
}

.active\\:text-warning-200\\/25:active{
  color: rgb(254 223 137 / 0.25);
}

.active\\:text-warning-200\\/30:active{
  color: rgb(254 223 137 / 0.3);
}

.active\\:text-warning-200\\/35:active{
  color: rgb(254 223 137 / 0.35);
}

.active\\:text-warning-200\\/40:active{
  color: rgb(254 223 137 / 0.4);
}

.active\\:text-warning-200\\/45:active{
  color: rgb(254 223 137 / 0.45);
}

.active\\:text-warning-200\\/5:active{
  color: rgb(254 223 137 / 0.05);
}

.active\\:text-warning-200\\/50:active{
  color: rgb(254 223 137 / 0.5);
}

.active\\:text-warning-200\\/55:active{
  color: rgb(254 223 137 / 0.55);
}

.active\\:text-warning-200\\/60:active{
  color: rgb(254 223 137 / 0.6);
}

.active\\:text-warning-200\\/65:active{
  color: rgb(254 223 137 / 0.65);
}

.active\\:text-warning-200\\/70:active{
  color: rgb(254 223 137 / 0.7);
}

.active\\:text-warning-200\\/75:active{
  color: rgb(254 223 137 / 0.75);
}

.active\\:text-warning-200\\/80:active{
  color: rgb(254 223 137 / 0.8);
}

.active\\:text-warning-200\\/85:active{
  color: rgb(254 223 137 / 0.85);
}

.active\\:text-warning-200\\/90:active{
  color: rgb(254 223 137 / 0.9);
}

.active\\:text-warning-200\\/95:active{
  color: rgb(254 223 137 / 0.95);
}

.active\\:text-warning-25:active{
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-25\\/0:active{
  color: rgb(255 252 245 / 0);
}

.active\\:text-warning-25\\/10:active{
  color: rgb(255 252 245 / 0.1);
}

.active\\:text-warning-25\\/100:active{
  color: rgb(255 252 245 / 1);
}

.active\\:text-warning-25\\/15:active{
  color: rgb(255 252 245 / 0.15);
}

.active\\:text-warning-25\\/20:active{
  color: rgb(255 252 245 / 0.2);
}

.active\\:text-warning-25\\/25:active{
  color: rgb(255 252 245 / 0.25);
}

.active\\:text-warning-25\\/30:active{
  color: rgb(255 252 245 / 0.3);
}

.active\\:text-warning-25\\/35:active{
  color: rgb(255 252 245 / 0.35);
}

.active\\:text-warning-25\\/40:active{
  color: rgb(255 252 245 / 0.4);
}

.active\\:text-warning-25\\/45:active{
  color: rgb(255 252 245 / 0.45);
}

.active\\:text-warning-25\\/5:active{
  color: rgb(255 252 245 / 0.05);
}

.active\\:text-warning-25\\/50:active{
  color: rgb(255 252 245 / 0.5);
}

.active\\:text-warning-25\\/55:active{
  color: rgb(255 252 245 / 0.55);
}

.active\\:text-warning-25\\/60:active{
  color: rgb(255 252 245 / 0.6);
}

.active\\:text-warning-25\\/65:active{
  color: rgb(255 252 245 / 0.65);
}

.active\\:text-warning-25\\/70:active{
  color: rgb(255 252 245 / 0.7);
}

.active\\:text-warning-25\\/75:active{
  color: rgb(255 252 245 / 0.75);
}

.active\\:text-warning-25\\/80:active{
  color: rgb(255 252 245 / 0.8);
}

.active\\:text-warning-25\\/85:active{
  color: rgb(255 252 245 / 0.85);
}

.active\\:text-warning-25\\/90:active{
  color: rgb(255 252 245 / 0.9);
}

.active\\:text-warning-25\\/95:active{
  color: rgb(255 252 245 / 0.95);
}

.active\\:text-warning-400:active{
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-400\\/0:active{
  color: rgb(253 176 34 / 0);
}

.active\\:text-warning-400\\/10:active{
  color: rgb(253 176 34 / 0.1);
}

.active\\:text-warning-400\\/100:active{
  color: rgb(253 176 34 / 1);
}

.active\\:text-warning-400\\/15:active{
  color: rgb(253 176 34 / 0.15);
}

.active\\:text-warning-400\\/20:active{
  color: rgb(253 176 34 / 0.2);
}

.active\\:text-warning-400\\/25:active{
  color: rgb(253 176 34 / 0.25);
}

.active\\:text-warning-400\\/30:active{
  color: rgb(253 176 34 / 0.3);
}

.active\\:text-warning-400\\/35:active{
  color: rgb(253 176 34 / 0.35);
}

.active\\:text-warning-400\\/40:active{
  color: rgb(253 176 34 / 0.4);
}

.active\\:text-warning-400\\/45:active{
  color: rgb(253 176 34 / 0.45);
}

.active\\:text-warning-400\\/5:active{
  color: rgb(253 176 34 / 0.05);
}

.active\\:text-warning-400\\/50:active{
  color: rgb(253 176 34 / 0.5);
}

.active\\:text-warning-400\\/55:active{
  color: rgb(253 176 34 / 0.55);
}

.active\\:text-warning-400\\/60:active{
  color: rgb(253 176 34 / 0.6);
}

.active\\:text-warning-400\\/65:active{
  color: rgb(253 176 34 / 0.65);
}

.active\\:text-warning-400\\/70:active{
  color: rgb(253 176 34 / 0.7);
}

.active\\:text-warning-400\\/75:active{
  color: rgb(253 176 34 / 0.75);
}

.active\\:text-warning-400\\/80:active{
  color: rgb(253 176 34 / 0.8);
}

.active\\:text-warning-400\\/85:active{
  color: rgb(253 176 34 / 0.85);
}

.active\\:text-warning-400\\/90:active{
  color: rgb(253 176 34 / 0.9);
}

.active\\:text-warning-400\\/95:active{
  color: rgb(253 176 34 / 0.95);
}

.active\\:text-warning-50:active{
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-50\\/0:active{
  color: rgb(255 250 235 / 0);
}

.active\\:text-warning-50\\/10:active{
  color: rgb(255 250 235 / 0.1);
}

.active\\:text-warning-50\\/100:active{
  color: rgb(255 250 235 / 1);
}

.active\\:text-warning-50\\/15:active{
  color: rgb(255 250 235 / 0.15);
}

.active\\:text-warning-50\\/20:active{
  color: rgb(255 250 235 / 0.2);
}

.active\\:text-warning-50\\/25:active{
  color: rgb(255 250 235 / 0.25);
}

.active\\:text-warning-50\\/30:active{
  color: rgb(255 250 235 / 0.3);
}

.active\\:text-warning-50\\/35:active{
  color: rgb(255 250 235 / 0.35);
}

.active\\:text-warning-50\\/40:active{
  color: rgb(255 250 235 / 0.4);
}

.active\\:text-warning-50\\/45:active{
  color: rgb(255 250 235 / 0.45);
}

.active\\:text-warning-50\\/5:active{
  color: rgb(255 250 235 / 0.05);
}

.active\\:text-warning-50\\/50:active{
  color: rgb(255 250 235 / 0.5);
}

.active\\:text-warning-50\\/55:active{
  color: rgb(255 250 235 / 0.55);
}

.active\\:text-warning-50\\/60:active{
  color: rgb(255 250 235 / 0.6);
}

.active\\:text-warning-50\\/65:active{
  color: rgb(255 250 235 / 0.65);
}

.active\\:text-warning-50\\/70:active{
  color: rgb(255 250 235 / 0.7);
}

.active\\:text-warning-50\\/75:active{
  color: rgb(255 250 235 / 0.75);
}

.active\\:text-warning-50\\/80:active{
  color: rgb(255 250 235 / 0.8);
}

.active\\:text-warning-50\\/85:active{
  color: rgb(255 250 235 / 0.85);
}

.active\\:text-warning-50\\/90:active{
  color: rgb(255 250 235 / 0.9);
}

.active\\:text-warning-50\\/95:active{
  color: rgb(255 250 235 / 0.95);
}

.active\\:text-warning-500:active{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-500\\/0:active{
  color: rgb(247 144 9 / 0);
}

.active\\:text-warning-500\\/10:active{
  color: rgb(247 144 9 / 0.1);
}

.active\\:text-warning-500\\/100:active{
  color: rgb(247 144 9 / 1);
}

.active\\:text-warning-500\\/15:active{
  color: rgb(247 144 9 / 0.15);
}

.active\\:text-warning-500\\/20:active{
  color: rgb(247 144 9 / 0.2);
}

.active\\:text-warning-500\\/25:active{
  color: rgb(247 144 9 / 0.25);
}

.active\\:text-warning-500\\/30:active{
  color: rgb(247 144 9 / 0.3);
}

.active\\:text-warning-500\\/35:active{
  color: rgb(247 144 9 / 0.35);
}

.active\\:text-warning-500\\/40:active{
  color: rgb(247 144 9 / 0.4);
}

.active\\:text-warning-500\\/45:active{
  color: rgb(247 144 9 / 0.45);
}

.active\\:text-warning-500\\/5:active{
  color: rgb(247 144 9 / 0.05);
}

.active\\:text-warning-500\\/50:active{
  color: rgb(247 144 9 / 0.5);
}

.active\\:text-warning-500\\/55:active{
  color: rgb(247 144 9 / 0.55);
}

.active\\:text-warning-500\\/60:active{
  color: rgb(247 144 9 / 0.6);
}

.active\\:text-warning-500\\/65:active{
  color: rgb(247 144 9 / 0.65);
}

.active\\:text-warning-500\\/70:active{
  color: rgb(247 144 9 / 0.7);
}

.active\\:text-warning-500\\/75:active{
  color: rgb(247 144 9 / 0.75);
}

.active\\:text-warning-500\\/80:active{
  color: rgb(247 144 9 / 0.8);
}

.active\\:text-warning-500\\/85:active{
  color: rgb(247 144 9 / 0.85);
}

.active\\:text-warning-500\\/90:active{
  color: rgb(247 144 9 / 0.9);
}

.active\\:text-warning-500\\/95:active{
  color: rgb(247 144 9 / 0.95);
}

.active\\:text-warning-600:active{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-600\\/0:active{
  color: rgb(220 104 3 / 0);
}

.active\\:text-warning-600\\/10:active{
  color: rgb(220 104 3 / 0.1);
}

.active\\:text-warning-600\\/100:active{
  color: rgb(220 104 3 / 1);
}

.active\\:text-warning-600\\/15:active{
  color: rgb(220 104 3 / 0.15);
}

.active\\:text-warning-600\\/20:active{
  color: rgb(220 104 3 / 0.2);
}

.active\\:text-warning-600\\/25:active{
  color: rgb(220 104 3 / 0.25);
}

.active\\:text-warning-600\\/30:active{
  color: rgb(220 104 3 / 0.3);
}

.active\\:text-warning-600\\/35:active{
  color: rgb(220 104 3 / 0.35);
}

.active\\:text-warning-600\\/40:active{
  color: rgb(220 104 3 / 0.4);
}

.active\\:text-warning-600\\/45:active{
  color: rgb(220 104 3 / 0.45);
}

.active\\:text-warning-600\\/5:active{
  color: rgb(220 104 3 / 0.05);
}

.active\\:text-warning-600\\/50:active{
  color: rgb(220 104 3 / 0.5);
}

.active\\:text-warning-600\\/55:active{
  color: rgb(220 104 3 / 0.55);
}

.active\\:text-warning-600\\/60:active{
  color: rgb(220 104 3 / 0.6);
}

.active\\:text-warning-600\\/65:active{
  color: rgb(220 104 3 / 0.65);
}

.active\\:text-warning-600\\/70:active{
  color: rgb(220 104 3 / 0.7);
}

.active\\:text-warning-600\\/75:active{
  color: rgb(220 104 3 / 0.75);
}

.active\\:text-warning-600\\/80:active{
  color: rgb(220 104 3 / 0.8);
}

.active\\:text-warning-600\\/85:active{
  color: rgb(220 104 3 / 0.85);
}

.active\\:text-warning-600\\/90:active{
  color: rgb(220 104 3 / 0.9);
}

.active\\:text-warning-600\\/95:active{
  color: rgb(220 104 3 / 0.95);
}

.active\\:text-warning-700:active{
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}

.active\\:text-warning-700\\/0:active{
  color: rgb(181 71 8 / 0);
}

.active\\:text-warning-700\\/10:active{
  color: rgb(181 71 8 / 0.1);
}

.active\\:text-warning-700\\/100:active{
  color: rgb(181 71 8 / 1);
}

.active\\:text-warning-700\\/15:active{
  color: rgb(181 71 8 / 0.15);
}

.active\\:text-warning-700\\/20:active{
  color: rgb(181 71 8 / 0.2);
}

.active\\:text-warning-700\\/25:active{
  color: rgb(181 71 8 / 0.25);
}

.active\\:text-warning-700\\/30:active{
  color: rgb(181 71 8 / 0.3);
}

.active\\:text-warning-700\\/35:active{
  color: rgb(181 71 8 / 0.35);
}

.active\\:text-warning-700\\/40:active{
  color: rgb(181 71 8 / 0.4);
}

.active\\:text-warning-700\\/45:active{
  color: rgb(181 71 8 / 0.45);
}

.active\\:text-warning-700\\/5:active{
  color: rgb(181 71 8 / 0.05);
}

.active\\:text-warning-700\\/50:active{
  color: rgb(181 71 8 / 0.5);
}

.active\\:text-warning-700\\/55:active{
  color: rgb(181 71 8 / 0.55);
}

.active\\:text-warning-700\\/60:active{
  color: rgb(181 71 8 / 0.6);
}

.active\\:text-warning-700\\/65:active{
  color: rgb(181 71 8 / 0.65);
}

.active\\:text-warning-700\\/70:active{
  color: rgb(181 71 8 / 0.7);
}

.active\\:text-warning-700\\/75:active{
  color: rgb(181 71 8 / 0.75);
}

.active\\:text-warning-700\\/80:active{
  color: rgb(181 71 8 / 0.8);
}

.active\\:text-warning-700\\/85:active{
  color: rgb(181 71 8 / 0.85);
}

.active\\:text-warning-700\\/90:active{
  color: rgb(181 71 8 / 0.9);
}

.active\\:text-warning-700\\/95:active{
  color: rgb(181 71 8 / 0.95);
}

.active\\:text-white:active{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.active\\:\\!shadow-none:active{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.disabled\\:cursor-default:disabled{
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:cursor-wait:disabled{
  cursor: wait;
}

.disabled\\:border-danger-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(254 228 226 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-100\\/0:disabled{
  border-color: rgb(254 228 226 / 0);
}

.disabled\\:border-danger-100\\/10:disabled{
  border-color: rgb(254 228 226 / 0.1);
}

.disabled\\:border-danger-100\\/100:disabled{
  border-color: rgb(254 228 226 / 1);
}

.disabled\\:border-danger-100\\/15:disabled{
  border-color: rgb(254 228 226 / 0.15);
}

.disabled\\:border-danger-100\\/20:disabled{
  border-color: rgb(254 228 226 / 0.2);
}

.disabled\\:border-danger-100\\/25:disabled{
  border-color: rgb(254 228 226 / 0.25);
}

.disabled\\:border-danger-100\\/30:disabled{
  border-color: rgb(254 228 226 / 0.3);
}

.disabled\\:border-danger-100\\/35:disabled{
  border-color: rgb(254 228 226 / 0.35);
}

.disabled\\:border-danger-100\\/40:disabled{
  border-color: rgb(254 228 226 / 0.4);
}

.disabled\\:border-danger-100\\/45:disabled{
  border-color: rgb(254 228 226 / 0.45);
}

.disabled\\:border-danger-100\\/5:disabled{
  border-color: rgb(254 228 226 / 0.05);
}

.disabled\\:border-danger-100\\/50:disabled{
  border-color: rgb(254 228 226 / 0.5);
}

.disabled\\:border-danger-100\\/55:disabled{
  border-color: rgb(254 228 226 / 0.55);
}

.disabled\\:border-danger-100\\/60:disabled{
  border-color: rgb(254 228 226 / 0.6);
}

.disabled\\:border-danger-100\\/65:disabled{
  border-color: rgb(254 228 226 / 0.65);
}

.disabled\\:border-danger-100\\/70:disabled{
  border-color: rgb(254 228 226 / 0.7);
}

.disabled\\:border-danger-100\\/75:disabled{
  border-color: rgb(254 228 226 / 0.75);
}

.disabled\\:border-danger-100\\/80:disabled{
  border-color: rgb(254 228 226 / 0.8);
}

.disabled\\:border-danger-100\\/85:disabled{
  border-color: rgb(254 228 226 / 0.85);
}

.disabled\\:border-danger-100\\/90:disabled{
  border-color: rgb(254 228 226 / 0.9);
}

.disabled\\:border-danger-100\\/95:disabled{
  border-color: rgb(254 228 226 / 0.95);
}

.disabled\\:border-danger-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 202 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-200\\/0:disabled{
  border-color: rgb(254 205 202 / 0);
}

.disabled\\:border-danger-200\\/10:disabled{
  border-color: rgb(254 205 202 / 0.1);
}

.disabled\\:border-danger-200\\/100:disabled{
  border-color: rgb(254 205 202 / 1);
}

.disabled\\:border-danger-200\\/15:disabled{
  border-color: rgb(254 205 202 / 0.15);
}

.disabled\\:border-danger-200\\/20:disabled{
  border-color: rgb(254 205 202 / 0.2);
}

.disabled\\:border-danger-200\\/25:disabled{
  border-color: rgb(254 205 202 / 0.25);
}

.disabled\\:border-danger-200\\/30:disabled{
  border-color: rgb(254 205 202 / 0.3);
}

.disabled\\:border-danger-200\\/35:disabled{
  border-color: rgb(254 205 202 / 0.35);
}

.disabled\\:border-danger-200\\/40:disabled{
  border-color: rgb(254 205 202 / 0.4);
}

.disabled\\:border-danger-200\\/45:disabled{
  border-color: rgb(254 205 202 / 0.45);
}

.disabled\\:border-danger-200\\/5:disabled{
  border-color: rgb(254 205 202 / 0.05);
}

.disabled\\:border-danger-200\\/50:disabled{
  border-color: rgb(254 205 202 / 0.5);
}

.disabled\\:border-danger-200\\/55:disabled{
  border-color: rgb(254 205 202 / 0.55);
}

.disabled\\:border-danger-200\\/60:disabled{
  border-color: rgb(254 205 202 / 0.6);
}

.disabled\\:border-danger-200\\/65:disabled{
  border-color: rgb(254 205 202 / 0.65);
}

.disabled\\:border-danger-200\\/70:disabled{
  border-color: rgb(254 205 202 / 0.7);
}

.disabled\\:border-danger-200\\/75:disabled{
  border-color: rgb(254 205 202 / 0.75);
}

.disabled\\:border-danger-200\\/80:disabled{
  border-color: rgb(254 205 202 / 0.8);
}

.disabled\\:border-danger-200\\/85:disabled{
  border-color: rgb(254 205 202 / 0.85);
}

.disabled\\:border-danger-200\\/90:disabled{
  border-color: rgb(254 205 202 / 0.9);
}

.disabled\\:border-danger-200\\/95:disabled{
  border-color: rgb(254 205 202 / 0.95);
}

.disabled\\:border-danger-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(255 251 250 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-25\\/0:disabled{
  border-color: rgb(255 251 250 / 0);
}

.disabled\\:border-danger-25\\/10:disabled{
  border-color: rgb(255 251 250 / 0.1);
}

.disabled\\:border-danger-25\\/100:disabled{
  border-color: rgb(255 251 250 / 1);
}

.disabled\\:border-danger-25\\/15:disabled{
  border-color: rgb(255 251 250 / 0.15);
}

.disabled\\:border-danger-25\\/20:disabled{
  border-color: rgb(255 251 250 / 0.2);
}

.disabled\\:border-danger-25\\/25:disabled{
  border-color: rgb(255 251 250 / 0.25);
}

.disabled\\:border-danger-25\\/30:disabled{
  border-color: rgb(255 251 250 / 0.3);
}

.disabled\\:border-danger-25\\/35:disabled{
  border-color: rgb(255 251 250 / 0.35);
}

.disabled\\:border-danger-25\\/40:disabled{
  border-color: rgb(255 251 250 / 0.4);
}

.disabled\\:border-danger-25\\/45:disabled{
  border-color: rgb(255 251 250 / 0.45);
}

.disabled\\:border-danger-25\\/5:disabled{
  border-color: rgb(255 251 250 / 0.05);
}

.disabled\\:border-danger-25\\/50:disabled{
  border-color: rgb(255 251 250 / 0.5);
}

.disabled\\:border-danger-25\\/55:disabled{
  border-color: rgb(255 251 250 / 0.55);
}

.disabled\\:border-danger-25\\/60:disabled{
  border-color: rgb(255 251 250 / 0.6);
}

.disabled\\:border-danger-25\\/65:disabled{
  border-color: rgb(255 251 250 / 0.65);
}

.disabled\\:border-danger-25\\/70:disabled{
  border-color: rgb(255 251 250 / 0.7);
}

.disabled\\:border-danger-25\\/75:disabled{
  border-color: rgb(255 251 250 / 0.75);
}

.disabled\\:border-danger-25\\/80:disabled{
  border-color: rgb(255 251 250 / 0.8);
}

.disabled\\:border-danger-25\\/85:disabled{
  border-color: rgb(255 251 250 / 0.85);
}

.disabled\\:border-danger-25\\/90:disabled{
  border-color: rgb(255 251 250 / 0.9);
}

.disabled\\:border-danger-25\\/95:disabled{
  border-color: rgb(255 251 250 / 0.95);
}

.disabled\\:border-danger-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(249 112 102 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-400\\/0:disabled{
  border-color: rgb(249 112 102 / 0);
}

.disabled\\:border-danger-400\\/10:disabled{
  border-color: rgb(249 112 102 / 0.1);
}

.disabled\\:border-danger-400\\/100:disabled{
  border-color: rgb(249 112 102 / 1);
}

.disabled\\:border-danger-400\\/15:disabled{
  border-color: rgb(249 112 102 / 0.15);
}

.disabled\\:border-danger-400\\/20:disabled{
  border-color: rgb(249 112 102 / 0.2);
}

.disabled\\:border-danger-400\\/25:disabled{
  border-color: rgb(249 112 102 / 0.25);
}

.disabled\\:border-danger-400\\/30:disabled{
  border-color: rgb(249 112 102 / 0.3);
}

.disabled\\:border-danger-400\\/35:disabled{
  border-color: rgb(249 112 102 / 0.35);
}

.disabled\\:border-danger-400\\/40:disabled{
  border-color: rgb(249 112 102 / 0.4);
}

.disabled\\:border-danger-400\\/45:disabled{
  border-color: rgb(249 112 102 / 0.45);
}

.disabled\\:border-danger-400\\/5:disabled{
  border-color: rgb(249 112 102 / 0.05);
}

.disabled\\:border-danger-400\\/50:disabled{
  border-color: rgb(249 112 102 / 0.5);
}

.disabled\\:border-danger-400\\/55:disabled{
  border-color: rgb(249 112 102 / 0.55);
}

.disabled\\:border-danger-400\\/60:disabled{
  border-color: rgb(249 112 102 / 0.6);
}

.disabled\\:border-danger-400\\/65:disabled{
  border-color: rgb(249 112 102 / 0.65);
}

.disabled\\:border-danger-400\\/70:disabled{
  border-color: rgb(249 112 102 / 0.7);
}

.disabled\\:border-danger-400\\/75:disabled{
  border-color: rgb(249 112 102 / 0.75);
}

.disabled\\:border-danger-400\\/80:disabled{
  border-color: rgb(249 112 102 / 0.8);
}

.disabled\\:border-danger-400\\/85:disabled{
  border-color: rgb(249 112 102 / 0.85);
}

.disabled\\:border-danger-400\\/90:disabled{
  border-color: rgb(249 112 102 / 0.9);
}

.disabled\\:border-danger-400\\/95:disabled{
  border-color: rgb(249 112 102 / 0.95);
}

.disabled\\:border-danger-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 242 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-50\\/0:disabled{
  border-color: rgb(254 243 242 / 0);
}

.disabled\\:border-danger-50\\/10:disabled{
  border-color: rgb(254 243 242 / 0.1);
}

.disabled\\:border-danger-50\\/100:disabled{
  border-color: rgb(254 243 242 / 1);
}

.disabled\\:border-danger-50\\/15:disabled{
  border-color: rgb(254 243 242 / 0.15);
}

.disabled\\:border-danger-50\\/20:disabled{
  border-color: rgb(254 243 242 / 0.2);
}

.disabled\\:border-danger-50\\/25:disabled{
  border-color: rgb(254 243 242 / 0.25);
}

.disabled\\:border-danger-50\\/30:disabled{
  border-color: rgb(254 243 242 / 0.3);
}

.disabled\\:border-danger-50\\/35:disabled{
  border-color: rgb(254 243 242 / 0.35);
}

.disabled\\:border-danger-50\\/40:disabled{
  border-color: rgb(254 243 242 / 0.4);
}

.disabled\\:border-danger-50\\/45:disabled{
  border-color: rgb(254 243 242 / 0.45);
}

.disabled\\:border-danger-50\\/5:disabled{
  border-color: rgb(254 243 242 / 0.05);
}

.disabled\\:border-danger-50\\/50:disabled{
  border-color: rgb(254 243 242 / 0.5);
}

.disabled\\:border-danger-50\\/55:disabled{
  border-color: rgb(254 243 242 / 0.55);
}

.disabled\\:border-danger-50\\/60:disabled{
  border-color: rgb(254 243 242 / 0.6);
}

.disabled\\:border-danger-50\\/65:disabled{
  border-color: rgb(254 243 242 / 0.65);
}

.disabled\\:border-danger-50\\/70:disabled{
  border-color: rgb(254 243 242 / 0.7);
}

.disabled\\:border-danger-50\\/75:disabled{
  border-color: rgb(254 243 242 / 0.75);
}

.disabled\\:border-danger-50\\/80:disabled{
  border-color: rgb(254 243 242 / 0.8);
}

.disabled\\:border-danger-50\\/85:disabled{
  border-color: rgb(254 243 242 / 0.85);
}

.disabled\\:border-danger-50\\/90:disabled{
  border-color: rgb(254 243 242 / 0.9);
}

.disabled\\:border-danger-50\\/95:disabled{
  border-color: rgb(254 243 242 / 0.95);
}

.disabled\\:border-danger-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(240 68 56 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-500\\/0:disabled{
  border-color: rgb(240 68 56 / 0);
}

.disabled\\:border-danger-500\\/10:disabled{
  border-color: rgb(240 68 56 / 0.1);
}

.disabled\\:border-danger-500\\/100:disabled{
  border-color: rgb(240 68 56 / 1);
}

.disabled\\:border-danger-500\\/15:disabled{
  border-color: rgb(240 68 56 / 0.15);
}

.disabled\\:border-danger-500\\/20:disabled{
  border-color: rgb(240 68 56 / 0.2);
}

.disabled\\:border-danger-500\\/25:disabled{
  border-color: rgb(240 68 56 / 0.25);
}

.disabled\\:border-danger-500\\/30:disabled{
  border-color: rgb(240 68 56 / 0.3);
}

.disabled\\:border-danger-500\\/35:disabled{
  border-color: rgb(240 68 56 / 0.35);
}

.disabled\\:border-danger-500\\/40:disabled{
  border-color: rgb(240 68 56 / 0.4);
}

.disabled\\:border-danger-500\\/45:disabled{
  border-color: rgb(240 68 56 / 0.45);
}

.disabled\\:border-danger-500\\/5:disabled{
  border-color: rgb(240 68 56 / 0.05);
}

.disabled\\:border-danger-500\\/50:disabled{
  border-color: rgb(240 68 56 / 0.5);
}

.disabled\\:border-danger-500\\/55:disabled{
  border-color: rgb(240 68 56 / 0.55);
}

.disabled\\:border-danger-500\\/60:disabled{
  border-color: rgb(240 68 56 / 0.6);
}

.disabled\\:border-danger-500\\/65:disabled{
  border-color: rgb(240 68 56 / 0.65);
}

.disabled\\:border-danger-500\\/70:disabled{
  border-color: rgb(240 68 56 / 0.7);
}

.disabled\\:border-danger-500\\/75:disabled{
  border-color: rgb(240 68 56 / 0.75);
}

.disabled\\:border-danger-500\\/80:disabled{
  border-color: rgb(240 68 56 / 0.8);
}

.disabled\\:border-danger-500\\/85:disabled{
  border-color: rgb(240 68 56 / 0.85);
}

.disabled\\:border-danger-500\\/90:disabled{
  border-color: rgb(240 68 56 / 0.9);
}

.disabled\\:border-danger-500\\/95:disabled{
  border-color: rgb(240 68 56 / 0.95);
}

.disabled\\:border-danger-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(217 45 32 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-600\\/0:disabled{
  border-color: rgb(217 45 32 / 0);
}

.disabled\\:border-danger-600\\/10:disabled{
  border-color: rgb(217 45 32 / 0.1);
}

.disabled\\:border-danger-600\\/100:disabled{
  border-color: rgb(217 45 32 / 1);
}

.disabled\\:border-danger-600\\/15:disabled{
  border-color: rgb(217 45 32 / 0.15);
}

.disabled\\:border-danger-600\\/20:disabled{
  border-color: rgb(217 45 32 / 0.2);
}

.disabled\\:border-danger-600\\/25:disabled{
  border-color: rgb(217 45 32 / 0.25);
}

.disabled\\:border-danger-600\\/30:disabled{
  border-color: rgb(217 45 32 / 0.3);
}

.disabled\\:border-danger-600\\/35:disabled{
  border-color: rgb(217 45 32 / 0.35);
}

.disabled\\:border-danger-600\\/40:disabled{
  border-color: rgb(217 45 32 / 0.4);
}

.disabled\\:border-danger-600\\/45:disabled{
  border-color: rgb(217 45 32 / 0.45);
}

.disabled\\:border-danger-600\\/5:disabled{
  border-color: rgb(217 45 32 / 0.05);
}

.disabled\\:border-danger-600\\/50:disabled{
  border-color: rgb(217 45 32 / 0.5);
}

.disabled\\:border-danger-600\\/55:disabled{
  border-color: rgb(217 45 32 / 0.55);
}

.disabled\\:border-danger-600\\/60:disabled{
  border-color: rgb(217 45 32 / 0.6);
}

.disabled\\:border-danger-600\\/65:disabled{
  border-color: rgb(217 45 32 / 0.65);
}

.disabled\\:border-danger-600\\/70:disabled{
  border-color: rgb(217 45 32 / 0.7);
}

.disabled\\:border-danger-600\\/75:disabled{
  border-color: rgb(217 45 32 / 0.75);
}

.disabled\\:border-danger-600\\/80:disabled{
  border-color: rgb(217 45 32 / 0.8);
}

.disabled\\:border-danger-600\\/85:disabled{
  border-color: rgb(217 45 32 / 0.85);
}

.disabled\\:border-danger-600\\/90:disabled{
  border-color: rgb(217 45 32 / 0.9);
}

.disabled\\:border-danger-600\\/95:disabled{
  border-color: rgb(217 45 32 / 0.95);
}

.disabled\\:border-danger-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(180 35 24 / var(--tw-border-opacity, 1));
}

.disabled\\:border-danger-700\\/0:disabled{
  border-color: rgb(180 35 24 / 0);
}

.disabled\\:border-danger-700\\/10:disabled{
  border-color: rgb(180 35 24 / 0.1);
}

.disabled\\:border-danger-700\\/100:disabled{
  border-color: rgb(180 35 24 / 1);
}

.disabled\\:border-danger-700\\/15:disabled{
  border-color: rgb(180 35 24 / 0.15);
}

.disabled\\:border-danger-700\\/20:disabled{
  border-color: rgb(180 35 24 / 0.2);
}

.disabled\\:border-danger-700\\/25:disabled{
  border-color: rgb(180 35 24 / 0.25);
}

.disabled\\:border-danger-700\\/30:disabled{
  border-color: rgb(180 35 24 / 0.3);
}

.disabled\\:border-danger-700\\/35:disabled{
  border-color: rgb(180 35 24 / 0.35);
}

.disabled\\:border-danger-700\\/40:disabled{
  border-color: rgb(180 35 24 / 0.4);
}

.disabled\\:border-danger-700\\/45:disabled{
  border-color: rgb(180 35 24 / 0.45);
}

.disabled\\:border-danger-700\\/5:disabled{
  border-color: rgb(180 35 24 / 0.05);
}

.disabled\\:border-danger-700\\/50:disabled{
  border-color: rgb(180 35 24 / 0.5);
}

.disabled\\:border-danger-700\\/55:disabled{
  border-color: rgb(180 35 24 / 0.55);
}

.disabled\\:border-danger-700\\/60:disabled{
  border-color: rgb(180 35 24 / 0.6);
}

.disabled\\:border-danger-700\\/65:disabled{
  border-color: rgb(180 35 24 / 0.65);
}

.disabled\\:border-danger-700\\/70:disabled{
  border-color: rgb(180 35 24 / 0.7);
}

.disabled\\:border-danger-700\\/75:disabled{
  border-color: rgb(180 35 24 / 0.75);
}

.disabled\\:border-danger-700\\/80:disabled{
  border-color: rgb(180 35 24 / 0.8);
}

.disabled\\:border-danger-700\\/85:disabled{
  border-color: rgb(180 35 24 / 0.85);
}

.disabled\\:border-danger-700\\/90:disabled{
  border-color: rgb(180 35 24 / 0.9);
}

.disabled\\:border-danger-700\\/95:disabled{
  border-color: rgb(180 35 24 / 0.95);
}

.disabled\\:border-moss-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(230 244 215 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-100\\/0:disabled{
  border-color: rgb(230 244 215 / 0);
}

.disabled\\:border-moss-100\\/10:disabled{
  border-color: rgb(230 244 215 / 0.1);
}

.disabled\\:border-moss-100\\/100:disabled{
  border-color: rgb(230 244 215 / 1);
}

.disabled\\:border-moss-100\\/15:disabled{
  border-color: rgb(230 244 215 / 0.15);
}

.disabled\\:border-moss-100\\/20:disabled{
  border-color: rgb(230 244 215 / 0.2);
}

.disabled\\:border-moss-100\\/25:disabled{
  border-color: rgb(230 244 215 / 0.25);
}

.disabled\\:border-moss-100\\/30:disabled{
  border-color: rgb(230 244 215 / 0.3);
}

.disabled\\:border-moss-100\\/35:disabled{
  border-color: rgb(230 244 215 / 0.35);
}

.disabled\\:border-moss-100\\/40:disabled{
  border-color: rgb(230 244 215 / 0.4);
}

.disabled\\:border-moss-100\\/45:disabled{
  border-color: rgb(230 244 215 / 0.45);
}

.disabled\\:border-moss-100\\/5:disabled{
  border-color: rgb(230 244 215 / 0.05);
}

.disabled\\:border-moss-100\\/50:disabled{
  border-color: rgb(230 244 215 / 0.5);
}

.disabled\\:border-moss-100\\/55:disabled{
  border-color: rgb(230 244 215 / 0.55);
}

.disabled\\:border-moss-100\\/60:disabled{
  border-color: rgb(230 244 215 / 0.6);
}

.disabled\\:border-moss-100\\/65:disabled{
  border-color: rgb(230 244 215 / 0.65);
}

.disabled\\:border-moss-100\\/70:disabled{
  border-color: rgb(230 244 215 / 0.7);
}

.disabled\\:border-moss-100\\/75:disabled{
  border-color: rgb(230 244 215 / 0.75);
}

.disabled\\:border-moss-100\\/80:disabled{
  border-color: rgb(230 244 215 / 0.8);
}

.disabled\\:border-moss-100\\/85:disabled{
  border-color: rgb(230 244 215 / 0.85);
}

.disabled\\:border-moss-100\\/90:disabled{
  border-color: rgb(230 244 215 / 0.9);
}

.disabled\\:border-moss-100\\/95:disabled{
  border-color: rgb(230 244 215 / 0.95);
}

.disabled\\:border-moss-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(206 234 176 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-200\\/0:disabled{
  border-color: rgb(206 234 176 / 0);
}

.disabled\\:border-moss-200\\/10:disabled{
  border-color: rgb(206 234 176 / 0.1);
}

.disabled\\:border-moss-200\\/100:disabled{
  border-color: rgb(206 234 176 / 1);
}

.disabled\\:border-moss-200\\/15:disabled{
  border-color: rgb(206 234 176 / 0.15);
}

.disabled\\:border-moss-200\\/20:disabled{
  border-color: rgb(206 234 176 / 0.2);
}

.disabled\\:border-moss-200\\/25:disabled{
  border-color: rgb(206 234 176 / 0.25);
}

.disabled\\:border-moss-200\\/30:disabled{
  border-color: rgb(206 234 176 / 0.3);
}

.disabled\\:border-moss-200\\/35:disabled{
  border-color: rgb(206 234 176 / 0.35);
}

.disabled\\:border-moss-200\\/40:disabled{
  border-color: rgb(206 234 176 / 0.4);
}

.disabled\\:border-moss-200\\/45:disabled{
  border-color: rgb(206 234 176 / 0.45);
}

.disabled\\:border-moss-200\\/5:disabled{
  border-color: rgb(206 234 176 / 0.05);
}

.disabled\\:border-moss-200\\/50:disabled{
  border-color: rgb(206 234 176 / 0.5);
}

.disabled\\:border-moss-200\\/55:disabled{
  border-color: rgb(206 234 176 / 0.55);
}

.disabled\\:border-moss-200\\/60:disabled{
  border-color: rgb(206 234 176 / 0.6);
}

.disabled\\:border-moss-200\\/65:disabled{
  border-color: rgb(206 234 176 / 0.65);
}

.disabled\\:border-moss-200\\/70:disabled{
  border-color: rgb(206 234 176 / 0.7);
}

.disabled\\:border-moss-200\\/75:disabled{
  border-color: rgb(206 234 176 / 0.75);
}

.disabled\\:border-moss-200\\/80:disabled{
  border-color: rgb(206 234 176 / 0.8);
}

.disabled\\:border-moss-200\\/85:disabled{
  border-color: rgb(206 234 176 / 0.85);
}

.disabled\\:border-moss-200\\/90:disabled{
  border-color: rgb(206 234 176 / 0.9);
}

.disabled\\:border-moss-200\\/95:disabled{
  border-color: rgb(206 234 176 / 0.95);
}

.disabled\\:border-moss-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(250 253 247 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-25\\/0:disabled{
  border-color: rgb(250 253 247 / 0);
}

.disabled\\:border-moss-25\\/10:disabled{
  border-color: rgb(250 253 247 / 0.1);
}

.disabled\\:border-moss-25\\/100:disabled{
  border-color: rgb(250 253 247 / 1);
}

.disabled\\:border-moss-25\\/15:disabled{
  border-color: rgb(250 253 247 / 0.15);
}

.disabled\\:border-moss-25\\/20:disabled{
  border-color: rgb(250 253 247 / 0.2);
}

.disabled\\:border-moss-25\\/25:disabled{
  border-color: rgb(250 253 247 / 0.25);
}

.disabled\\:border-moss-25\\/30:disabled{
  border-color: rgb(250 253 247 / 0.3);
}

.disabled\\:border-moss-25\\/35:disabled{
  border-color: rgb(250 253 247 / 0.35);
}

.disabled\\:border-moss-25\\/40:disabled{
  border-color: rgb(250 253 247 / 0.4);
}

.disabled\\:border-moss-25\\/45:disabled{
  border-color: rgb(250 253 247 / 0.45);
}

.disabled\\:border-moss-25\\/5:disabled{
  border-color: rgb(250 253 247 / 0.05);
}

.disabled\\:border-moss-25\\/50:disabled{
  border-color: rgb(250 253 247 / 0.5);
}

.disabled\\:border-moss-25\\/55:disabled{
  border-color: rgb(250 253 247 / 0.55);
}

.disabled\\:border-moss-25\\/60:disabled{
  border-color: rgb(250 253 247 / 0.6);
}

.disabled\\:border-moss-25\\/65:disabled{
  border-color: rgb(250 253 247 / 0.65);
}

.disabled\\:border-moss-25\\/70:disabled{
  border-color: rgb(250 253 247 / 0.7);
}

.disabled\\:border-moss-25\\/75:disabled{
  border-color: rgb(250 253 247 / 0.75);
}

.disabled\\:border-moss-25\\/80:disabled{
  border-color: rgb(250 253 247 / 0.8);
}

.disabled\\:border-moss-25\\/85:disabled{
  border-color: rgb(250 253 247 / 0.85);
}

.disabled\\:border-moss-25\\/90:disabled{
  border-color: rgb(250 253 247 / 0.9);
}

.disabled\\:border-moss-25\\/95:disabled{
  border-color: rgb(250 253 247 / 0.95);
}

.disabled\\:border-moss-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(134 203 60 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-400\\/0:disabled{
  border-color: rgb(134 203 60 / 0);
}

.disabled\\:border-moss-400\\/10:disabled{
  border-color: rgb(134 203 60 / 0.1);
}

.disabled\\:border-moss-400\\/100:disabled{
  border-color: rgb(134 203 60 / 1);
}

.disabled\\:border-moss-400\\/15:disabled{
  border-color: rgb(134 203 60 / 0.15);
}

.disabled\\:border-moss-400\\/20:disabled{
  border-color: rgb(134 203 60 / 0.2);
}

.disabled\\:border-moss-400\\/25:disabled{
  border-color: rgb(134 203 60 / 0.25);
}

.disabled\\:border-moss-400\\/30:disabled{
  border-color: rgb(134 203 60 / 0.3);
}

.disabled\\:border-moss-400\\/35:disabled{
  border-color: rgb(134 203 60 / 0.35);
}

.disabled\\:border-moss-400\\/40:disabled{
  border-color: rgb(134 203 60 / 0.4);
}

.disabled\\:border-moss-400\\/45:disabled{
  border-color: rgb(134 203 60 / 0.45);
}

.disabled\\:border-moss-400\\/5:disabled{
  border-color: rgb(134 203 60 / 0.05);
}

.disabled\\:border-moss-400\\/50:disabled{
  border-color: rgb(134 203 60 / 0.5);
}

.disabled\\:border-moss-400\\/55:disabled{
  border-color: rgb(134 203 60 / 0.55);
}

.disabled\\:border-moss-400\\/60:disabled{
  border-color: rgb(134 203 60 / 0.6);
}

.disabled\\:border-moss-400\\/65:disabled{
  border-color: rgb(134 203 60 / 0.65);
}

.disabled\\:border-moss-400\\/70:disabled{
  border-color: rgb(134 203 60 / 0.7);
}

.disabled\\:border-moss-400\\/75:disabled{
  border-color: rgb(134 203 60 / 0.75);
}

.disabled\\:border-moss-400\\/80:disabled{
  border-color: rgb(134 203 60 / 0.8);
}

.disabled\\:border-moss-400\\/85:disabled{
  border-color: rgb(134 203 60 / 0.85);
}

.disabled\\:border-moss-400\\/90:disabled{
  border-color: rgb(134 203 60 / 0.9);
}

.disabled\\:border-moss-400\\/95:disabled{
  border-color: rgb(134 203 60 / 0.95);
}

.disabled\\:border-moss-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(245 251 238 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-50\\/0:disabled{
  border-color: rgb(245 251 238 / 0);
}

.disabled\\:border-moss-50\\/10:disabled{
  border-color: rgb(245 251 238 / 0.1);
}

.disabled\\:border-moss-50\\/100:disabled{
  border-color: rgb(245 251 238 / 1);
}

.disabled\\:border-moss-50\\/15:disabled{
  border-color: rgb(245 251 238 / 0.15);
}

.disabled\\:border-moss-50\\/20:disabled{
  border-color: rgb(245 251 238 / 0.2);
}

.disabled\\:border-moss-50\\/25:disabled{
  border-color: rgb(245 251 238 / 0.25);
}

.disabled\\:border-moss-50\\/30:disabled{
  border-color: rgb(245 251 238 / 0.3);
}

.disabled\\:border-moss-50\\/35:disabled{
  border-color: rgb(245 251 238 / 0.35);
}

.disabled\\:border-moss-50\\/40:disabled{
  border-color: rgb(245 251 238 / 0.4);
}

.disabled\\:border-moss-50\\/45:disabled{
  border-color: rgb(245 251 238 / 0.45);
}

.disabled\\:border-moss-50\\/5:disabled{
  border-color: rgb(245 251 238 / 0.05);
}

.disabled\\:border-moss-50\\/50:disabled{
  border-color: rgb(245 251 238 / 0.5);
}

.disabled\\:border-moss-50\\/55:disabled{
  border-color: rgb(245 251 238 / 0.55);
}

.disabled\\:border-moss-50\\/60:disabled{
  border-color: rgb(245 251 238 / 0.6);
}

.disabled\\:border-moss-50\\/65:disabled{
  border-color: rgb(245 251 238 / 0.65);
}

.disabled\\:border-moss-50\\/70:disabled{
  border-color: rgb(245 251 238 / 0.7);
}

.disabled\\:border-moss-50\\/75:disabled{
  border-color: rgb(245 251 238 / 0.75);
}

.disabled\\:border-moss-50\\/80:disabled{
  border-color: rgb(245 251 238 / 0.8);
}

.disabled\\:border-moss-50\\/85:disabled{
  border-color: rgb(245 251 238 / 0.85);
}

.disabled\\:border-moss-50\\/90:disabled{
  border-color: rgb(245 251 238 / 0.9);
}

.disabled\\:border-moss-50\\/95:disabled{
  border-color: rgb(245 251 238 / 0.95);
}

.disabled\\:border-moss-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(102 159 42 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-500\\/0:disabled{
  border-color: rgb(102 159 42 / 0);
}

.disabled\\:border-moss-500\\/10:disabled{
  border-color: rgb(102 159 42 / 0.1);
}

.disabled\\:border-moss-500\\/100:disabled{
  border-color: rgb(102 159 42 / 1);
}

.disabled\\:border-moss-500\\/15:disabled{
  border-color: rgb(102 159 42 / 0.15);
}

.disabled\\:border-moss-500\\/20:disabled{
  border-color: rgb(102 159 42 / 0.2);
}

.disabled\\:border-moss-500\\/25:disabled{
  border-color: rgb(102 159 42 / 0.25);
}

.disabled\\:border-moss-500\\/30:disabled{
  border-color: rgb(102 159 42 / 0.3);
}

.disabled\\:border-moss-500\\/35:disabled{
  border-color: rgb(102 159 42 / 0.35);
}

.disabled\\:border-moss-500\\/40:disabled{
  border-color: rgb(102 159 42 / 0.4);
}

.disabled\\:border-moss-500\\/45:disabled{
  border-color: rgb(102 159 42 / 0.45);
}

.disabled\\:border-moss-500\\/5:disabled{
  border-color: rgb(102 159 42 / 0.05);
}

.disabled\\:border-moss-500\\/50:disabled{
  border-color: rgb(102 159 42 / 0.5);
}

.disabled\\:border-moss-500\\/55:disabled{
  border-color: rgb(102 159 42 / 0.55);
}

.disabled\\:border-moss-500\\/60:disabled{
  border-color: rgb(102 159 42 / 0.6);
}

.disabled\\:border-moss-500\\/65:disabled{
  border-color: rgb(102 159 42 / 0.65);
}

.disabled\\:border-moss-500\\/70:disabled{
  border-color: rgb(102 159 42 / 0.7);
}

.disabled\\:border-moss-500\\/75:disabled{
  border-color: rgb(102 159 42 / 0.75);
}

.disabled\\:border-moss-500\\/80:disabled{
  border-color: rgb(102 159 42 / 0.8);
}

.disabled\\:border-moss-500\\/85:disabled{
  border-color: rgb(102 159 42 / 0.85);
}

.disabled\\:border-moss-500\\/90:disabled{
  border-color: rgb(102 159 42 / 0.9);
}

.disabled\\:border-moss-500\\/95:disabled{
  border-color: rgb(102 159 42 / 0.95);
}

.disabled\\:border-moss-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(79 122 33 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-600\\/0:disabled{
  border-color: rgb(79 122 33 / 0);
}

.disabled\\:border-moss-600\\/10:disabled{
  border-color: rgb(79 122 33 / 0.1);
}

.disabled\\:border-moss-600\\/100:disabled{
  border-color: rgb(79 122 33 / 1);
}

.disabled\\:border-moss-600\\/15:disabled{
  border-color: rgb(79 122 33 / 0.15);
}

.disabled\\:border-moss-600\\/20:disabled{
  border-color: rgb(79 122 33 / 0.2);
}

.disabled\\:border-moss-600\\/25:disabled{
  border-color: rgb(79 122 33 / 0.25);
}

.disabled\\:border-moss-600\\/30:disabled{
  border-color: rgb(79 122 33 / 0.3);
}

.disabled\\:border-moss-600\\/35:disabled{
  border-color: rgb(79 122 33 / 0.35);
}

.disabled\\:border-moss-600\\/40:disabled{
  border-color: rgb(79 122 33 / 0.4);
}

.disabled\\:border-moss-600\\/45:disabled{
  border-color: rgb(79 122 33 / 0.45);
}

.disabled\\:border-moss-600\\/5:disabled{
  border-color: rgb(79 122 33 / 0.05);
}

.disabled\\:border-moss-600\\/50:disabled{
  border-color: rgb(79 122 33 / 0.5);
}

.disabled\\:border-moss-600\\/55:disabled{
  border-color: rgb(79 122 33 / 0.55);
}

.disabled\\:border-moss-600\\/60:disabled{
  border-color: rgb(79 122 33 / 0.6);
}

.disabled\\:border-moss-600\\/65:disabled{
  border-color: rgb(79 122 33 / 0.65);
}

.disabled\\:border-moss-600\\/70:disabled{
  border-color: rgb(79 122 33 / 0.7);
}

.disabled\\:border-moss-600\\/75:disabled{
  border-color: rgb(79 122 33 / 0.75);
}

.disabled\\:border-moss-600\\/80:disabled{
  border-color: rgb(79 122 33 / 0.8);
}

.disabled\\:border-moss-600\\/85:disabled{
  border-color: rgb(79 122 33 / 0.85);
}

.disabled\\:border-moss-600\\/90:disabled{
  border-color: rgb(79 122 33 / 0.9);
}

.disabled\\:border-moss-600\\/95:disabled{
  border-color: rgb(79 122 33 / 0.95);
}

.disabled\\:border-moss-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(63 98 26 / var(--tw-border-opacity, 1));
}

.disabled\\:border-moss-700\\/0:disabled{
  border-color: rgb(63 98 26 / 0);
}

.disabled\\:border-moss-700\\/10:disabled{
  border-color: rgb(63 98 26 / 0.1);
}

.disabled\\:border-moss-700\\/100:disabled{
  border-color: rgb(63 98 26 / 1);
}

.disabled\\:border-moss-700\\/15:disabled{
  border-color: rgb(63 98 26 / 0.15);
}

.disabled\\:border-moss-700\\/20:disabled{
  border-color: rgb(63 98 26 / 0.2);
}

.disabled\\:border-moss-700\\/25:disabled{
  border-color: rgb(63 98 26 / 0.25);
}

.disabled\\:border-moss-700\\/30:disabled{
  border-color: rgb(63 98 26 / 0.3);
}

.disabled\\:border-moss-700\\/35:disabled{
  border-color: rgb(63 98 26 / 0.35);
}

.disabled\\:border-moss-700\\/40:disabled{
  border-color: rgb(63 98 26 / 0.4);
}

.disabled\\:border-moss-700\\/45:disabled{
  border-color: rgb(63 98 26 / 0.45);
}

.disabled\\:border-moss-700\\/5:disabled{
  border-color: rgb(63 98 26 / 0.05);
}

.disabled\\:border-moss-700\\/50:disabled{
  border-color: rgb(63 98 26 / 0.5);
}

.disabled\\:border-moss-700\\/55:disabled{
  border-color: rgb(63 98 26 / 0.55);
}

.disabled\\:border-moss-700\\/60:disabled{
  border-color: rgb(63 98 26 / 0.6);
}

.disabled\\:border-moss-700\\/65:disabled{
  border-color: rgb(63 98 26 / 0.65);
}

.disabled\\:border-moss-700\\/70:disabled{
  border-color: rgb(63 98 26 / 0.7);
}

.disabled\\:border-moss-700\\/75:disabled{
  border-color: rgb(63 98 26 / 0.75);
}

.disabled\\:border-moss-700\\/80:disabled{
  border-color: rgb(63 98 26 / 0.8);
}

.disabled\\:border-moss-700\\/85:disabled{
  border-color: rgb(63 98 26 / 0.85);
}

.disabled\\:border-moss-700\\/90:disabled{
  border-color: rgb(63 98 26 / 0.9);
}

.disabled\\:border-moss-700\\/95:disabled{
  border-color: rgb(63 98 26 / 0.95);
}

.disabled\\:border-neutral-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-100\\/0:disabled{
  border-color: rgb(245 245 245 / 0);
}

.disabled\\:border-neutral-100\\/10:disabled{
  border-color: rgb(245 245 245 / 0.1);
}

.disabled\\:border-neutral-100\\/100:disabled{
  border-color: rgb(245 245 245 / 1);
}

.disabled\\:border-neutral-100\\/15:disabled{
  border-color: rgb(245 245 245 / 0.15);
}

.disabled\\:border-neutral-100\\/20:disabled{
  border-color: rgb(245 245 245 / 0.2);
}

.disabled\\:border-neutral-100\\/25:disabled{
  border-color: rgb(245 245 245 / 0.25);
}

.disabled\\:border-neutral-100\\/30:disabled{
  border-color: rgb(245 245 245 / 0.3);
}

.disabled\\:border-neutral-100\\/35:disabled{
  border-color: rgb(245 245 245 / 0.35);
}

.disabled\\:border-neutral-100\\/40:disabled{
  border-color: rgb(245 245 245 / 0.4);
}

.disabled\\:border-neutral-100\\/45:disabled{
  border-color: rgb(245 245 245 / 0.45);
}

.disabled\\:border-neutral-100\\/5:disabled{
  border-color: rgb(245 245 245 / 0.05);
}

.disabled\\:border-neutral-100\\/50:disabled{
  border-color: rgb(245 245 245 / 0.5);
}

.disabled\\:border-neutral-100\\/55:disabled{
  border-color: rgb(245 245 245 / 0.55);
}

.disabled\\:border-neutral-100\\/60:disabled{
  border-color: rgb(245 245 245 / 0.6);
}

.disabled\\:border-neutral-100\\/65:disabled{
  border-color: rgb(245 245 245 / 0.65);
}

.disabled\\:border-neutral-100\\/70:disabled{
  border-color: rgb(245 245 245 / 0.7);
}

.disabled\\:border-neutral-100\\/75:disabled{
  border-color: rgb(245 245 245 / 0.75);
}

.disabled\\:border-neutral-100\\/80:disabled{
  border-color: rgb(245 245 245 / 0.8);
}

.disabled\\:border-neutral-100\\/85:disabled{
  border-color: rgb(245 245 245 / 0.85);
}

.disabled\\:border-neutral-100\\/90:disabled{
  border-color: rgb(245 245 245 / 0.9);
}

.disabled\\:border-neutral-100\\/95:disabled{
  border-color: rgb(245 245 245 / 0.95);
}

.disabled\\:border-neutral-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-200\\/0:disabled{
  border-color: rgb(233 234 235 / 0);
}

.disabled\\:border-neutral-200\\/10:disabled{
  border-color: rgb(233 234 235 / 0.1);
}

.disabled\\:border-neutral-200\\/100:disabled{
  border-color: rgb(233 234 235 / 1);
}

.disabled\\:border-neutral-200\\/15:disabled{
  border-color: rgb(233 234 235 / 0.15);
}

.disabled\\:border-neutral-200\\/20:disabled{
  border-color: rgb(233 234 235 / 0.2);
}

.disabled\\:border-neutral-200\\/25:disabled{
  border-color: rgb(233 234 235 / 0.25);
}

.disabled\\:border-neutral-200\\/30:disabled{
  border-color: rgb(233 234 235 / 0.3);
}

.disabled\\:border-neutral-200\\/35:disabled{
  border-color: rgb(233 234 235 / 0.35);
}

.disabled\\:border-neutral-200\\/40:disabled{
  border-color: rgb(233 234 235 / 0.4);
}

.disabled\\:border-neutral-200\\/45:disabled{
  border-color: rgb(233 234 235 / 0.45);
}

.disabled\\:border-neutral-200\\/5:disabled{
  border-color: rgb(233 234 235 / 0.05);
}

.disabled\\:border-neutral-200\\/50:disabled{
  border-color: rgb(233 234 235 / 0.5);
}

.disabled\\:border-neutral-200\\/55:disabled{
  border-color: rgb(233 234 235 / 0.55);
}

.disabled\\:border-neutral-200\\/60:disabled{
  border-color: rgb(233 234 235 / 0.6);
}

.disabled\\:border-neutral-200\\/65:disabled{
  border-color: rgb(233 234 235 / 0.65);
}

.disabled\\:border-neutral-200\\/70:disabled{
  border-color: rgb(233 234 235 / 0.7);
}

.disabled\\:border-neutral-200\\/75:disabled{
  border-color: rgb(233 234 235 / 0.75);
}

.disabled\\:border-neutral-200\\/80:disabled{
  border-color: rgb(233 234 235 / 0.8);
}

.disabled\\:border-neutral-200\\/85:disabled{
  border-color: rgb(233 234 235 / 0.85);
}

.disabled\\:border-neutral-200\\/90:disabled{
  border-color: rgb(233 234 235 / 0.9);
}

.disabled\\:border-neutral-200\\/95:disabled{
  border-color: rgb(233 234 235 / 0.95);
}

.disabled\\:border-neutral-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(253 253 253 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-25\\/0:disabled{
  border-color: rgb(253 253 253 / 0);
}

.disabled\\:border-neutral-25\\/10:disabled{
  border-color: rgb(253 253 253 / 0.1);
}

.disabled\\:border-neutral-25\\/100:disabled{
  border-color: rgb(253 253 253 / 1);
}

.disabled\\:border-neutral-25\\/15:disabled{
  border-color: rgb(253 253 253 / 0.15);
}

.disabled\\:border-neutral-25\\/20:disabled{
  border-color: rgb(253 253 253 / 0.2);
}

.disabled\\:border-neutral-25\\/25:disabled{
  border-color: rgb(253 253 253 / 0.25);
}

.disabled\\:border-neutral-25\\/30:disabled{
  border-color: rgb(253 253 253 / 0.3);
}

.disabled\\:border-neutral-25\\/35:disabled{
  border-color: rgb(253 253 253 / 0.35);
}

.disabled\\:border-neutral-25\\/40:disabled{
  border-color: rgb(253 253 253 / 0.4);
}

.disabled\\:border-neutral-25\\/45:disabled{
  border-color: rgb(253 253 253 / 0.45);
}

.disabled\\:border-neutral-25\\/5:disabled{
  border-color: rgb(253 253 253 / 0.05);
}

.disabled\\:border-neutral-25\\/50:disabled{
  border-color: rgb(253 253 253 / 0.5);
}

.disabled\\:border-neutral-25\\/55:disabled{
  border-color: rgb(253 253 253 / 0.55);
}

.disabled\\:border-neutral-25\\/60:disabled{
  border-color: rgb(253 253 253 / 0.6);
}

.disabled\\:border-neutral-25\\/65:disabled{
  border-color: rgb(253 253 253 / 0.65);
}

.disabled\\:border-neutral-25\\/70:disabled{
  border-color: rgb(253 253 253 / 0.7);
}

.disabled\\:border-neutral-25\\/75:disabled{
  border-color: rgb(253 253 253 / 0.75);
}

.disabled\\:border-neutral-25\\/80:disabled{
  border-color: rgb(253 253 253 / 0.8);
}

.disabled\\:border-neutral-25\\/85:disabled{
  border-color: rgb(253 253 253 / 0.85);
}

.disabled\\:border-neutral-25\\/90:disabled{
  border-color: rgb(253 253 253 / 0.9);
}

.disabled\\:border-neutral-25\\/95:disabled{
  border-color: rgb(253 253 253 / 0.95);
}

.disabled\\:border-neutral-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(164 167 174 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-400\\/0:disabled{
  border-color: rgb(164 167 174 / 0);
}

.disabled\\:border-neutral-400\\/10:disabled{
  border-color: rgb(164 167 174 / 0.1);
}

.disabled\\:border-neutral-400\\/100:disabled{
  border-color: rgb(164 167 174 / 1);
}

.disabled\\:border-neutral-400\\/15:disabled{
  border-color: rgb(164 167 174 / 0.15);
}

.disabled\\:border-neutral-400\\/20:disabled{
  border-color: rgb(164 167 174 / 0.2);
}

.disabled\\:border-neutral-400\\/25:disabled{
  border-color: rgb(164 167 174 / 0.25);
}

.disabled\\:border-neutral-400\\/30:disabled{
  border-color: rgb(164 167 174 / 0.3);
}

.disabled\\:border-neutral-400\\/35:disabled{
  border-color: rgb(164 167 174 / 0.35);
}

.disabled\\:border-neutral-400\\/40:disabled{
  border-color: rgb(164 167 174 / 0.4);
}

.disabled\\:border-neutral-400\\/45:disabled{
  border-color: rgb(164 167 174 / 0.45);
}

.disabled\\:border-neutral-400\\/5:disabled{
  border-color: rgb(164 167 174 / 0.05);
}

.disabled\\:border-neutral-400\\/50:disabled{
  border-color: rgb(164 167 174 / 0.5);
}

.disabled\\:border-neutral-400\\/55:disabled{
  border-color: rgb(164 167 174 / 0.55);
}

.disabled\\:border-neutral-400\\/60:disabled{
  border-color: rgb(164 167 174 / 0.6);
}

.disabled\\:border-neutral-400\\/65:disabled{
  border-color: rgb(164 167 174 / 0.65);
}

.disabled\\:border-neutral-400\\/70:disabled{
  border-color: rgb(164 167 174 / 0.7);
}

.disabled\\:border-neutral-400\\/75:disabled{
  border-color: rgb(164 167 174 / 0.75);
}

.disabled\\:border-neutral-400\\/80:disabled{
  border-color: rgb(164 167 174 / 0.8);
}

.disabled\\:border-neutral-400\\/85:disabled{
  border-color: rgb(164 167 174 / 0.85);
}

.disabled\\:border-neutral-400\\/90:disabled{
  border-color: rgb(164 167 174 / 0.9);
}

.disabled\\:border-neutral-400\\/95:disabled{
  border-color: rgb(164 167 174 / 0.95);
}

.disabled\\:border-neutral-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 250 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-50\\/0:disabled{
  border-color: rgb(249 250 250 / 0);
}

.disabled\\:border-neutral-50\\/10:disabled{
  border-color: rgb(249 250 250 / 0.1);
}

.disabled\\:border-neutral-50\\/100:disabled{
  border-color: rgb(249 250 250 / 1);
}

.disabled\\:border-neutral-50\\/15:disabled{
  border-color: rgb(249 250 250 / 0.15);
}

.disabled\\:border-neutral-50\\/20:disabled{
  border-color: rgb(249 250 250 / 0.2);
}

.disabled\\:border-neutral-50\\/25:disabled{
  border-color: rgb(249 250 250 / 0.25);
}

.disabled\\:border-neutral-50\\/30:disabled{
  border-color: rgb(249 250 250 / 0.3);
}

.disabled\\:border-neutral-50\\/35:disabled{
  border-color: rgb(249 250 250 / 0.35);
}

.disabled\\:border-neutral-50\\/40:disabled{
  border-color: rgb(249 250 250 / 0.4);
}

.disabled\\:border-neutral-50\\/45:disabled{
  border-color: rgb(249 250 250 / 0.45);
}

.disabled\\:border-neutral-50\\/5:disabled{
  border-color: rgb(249 250 250 / 0.05);
}

.disabled\\:border-neutral-50\\/50:disabled{
  border-color: rgb(249 250 250 / 0.5);
}

.disabled\\:border-neutral-50\\/55:disabled{
  border-color: rgb(249 250 250 / 0.55);
}

.disabled\\:border-neutral-50\\/60:disabled{
  border-color: rgb(249 250 250 / 0.6);
}

.disabled\\:border-neutral-50\\/65:disabled{
  border-color: rgb(249 250 250 / 0.65);
}

.disabled\\:border-neutral-50\\/70:disabled{
  border-color: rgb(249 250 250 / 0.7);
}

.disabled\\:border-neutral-50\\/75:disabled{
  border-color: rgb(249 250 250 / 0.75);
}

.disabled\\:border-neutral-50\\/80:disabled{
  border-color: rgb(249 250 250 / 0.8);
}

.disabled\\:border-neutral-50\\/85:disabled{
  border-color: rgb(249 250 250 / 0.85);
}

.disabled\\:border-neutral-50\\/90:disabled{
  border-color: rgb(249 250 250 / 0.9);
}

.disabled\\:border-neutral-50\\/95:disabled{
  border-color: rgb(249 250 250 / 0.95);
}

.disabled\\:border-neutral-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(113 118 128 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-500\\/0:disabled{
  border-color: rgb(113 118 128 / 0);
}

.disabled\\:border-neutral-500\\/10:disabled{
  border-color: rgb(113 118 128 / 0.1);
}

.disabled\\:border-neutral-500\\/100:disabled{
  border-color: rgb(113 118 128 / 1);
}

.disabled\\:border-neutral-500\\/15:disabled{
  border-color: rgb(113 118 128 / 0.15);
}

.disabled\\:border-neutral-500\\/20:disabled{
  border-color: rgb(113 118 128 / 0.2);
}

.disabled\\:border-neutral-500\\/25:disabled{
  border-color: rgb(113 118 128 / 0.25);
}

.disabled\\:border-neutral-500\\/30:disabled{
  border-color: rgb(113 118 128 / 0.3);
}

.disabled\\:border-neutral-500\\/35:disabled{
  border-color: rgb(113 118 128 / 0.35);
}

.disabled\\:border-neutral-500\\/40:disabled{
  border-color: rgb(113 118 128 / 0.4);
}

.disabled\\:border-neutral-500\\/45:disabled{
  border-color: rgb(113 118 128 / 0.45);
}

.disabled\\:border-neutral-500\\/5:disabled{
  border-color: rgb(113 118 128 / 0.05);
}

.disabled\\:border-neutral-500\\/50:disabled{
  border-color: rgb(113 118 128 / 0.5);
}

.disabled\\:border-neutral-500\\/55:disabled{
  border-color: rgb(113 118 128 / 0.55);
}

.disabled\\:border-neutral-500\\/60:disabled{
  border-color: rgb(113 118 128 / 0.6);
}

.disabled\\:border-neutral-500\\/65:disabled{
  border-color: rgb(113 118 128 / 0.65);
}

.disabled\\:border-neutral-500\\/70:disabled{
  border-color: rgb(113 118 128 / 0.7);
}

.disabled\\:border-neutral-500\\/75:disabled{
  border-color: rgb(113 118 128 / 0.75);
}

.disabled\\:border-neutral-500\\/80:disabled{
  border-color: rgb(113 118 128 / 0.8);
}

.disabled\\:border-neutral-500\\/85:disabled{
  border-color: rgb(113 118 128 / 0.85);
}

.disabled\\:border-neutral-500\\/90:disabled{
  border-color: rgb(113 118 128 / 0.9);
}

.disabled\\:border-neutral-500\\/95:disabled{
  border-color: rgb(113 118 128 / 0.95);
}

.disabled\\:border-neutral-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(83 88 98 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-600\\/0:disabled{
  border-color: rgb(83 88 98 / 0);
}

.disabled\\:border-neutral-600\\/10:disabled{
  border-color: rgb(83 88 98 / 0.1);
}

.disabled\\:border-neutral-600\\/100:disabled{
  border-color: rgb(83 88 98 / 1);
}

.disabled\\:border-neutral-600\\/15:disabled{
  border-color: rgb(83 88 98 / 0.15);
}

.disabled\\:border-neutral-600\\/20:disabled{
  border-color: rgb(83 88 98 / 0.2);
}

.disabled\\:border-neutral-600\\/25:disabled{
  border-color: rgb(83 88 98 / 0.25);
}

.disabled\\:border-neutral-600\\/30:disabled{
  border-color: rgb(83 88 98 / 0.3);
}

.disabled\\:border-neutral-600\\/35:disabled{
  border-color: rgb(83 88 98 / 0.35);
}

.disabled\\:border-neutral-600\\/40:disabled{
  border-color: rgb(83 88 98 / 0.4);
}

.disabled\\:border-neutral-600\\/45:disabled{
  border-color: rgb(83 88 98 / 0.45);
}

.disabled\\:border-neutral-600\\/5:disabled{
  border-color: rgb(83 88 98 / 0.05);
}

.disabled\\:border-neutral-600\\/50:disabled{
  border-color: rgb(83 88 98 / 0.5);
}

.disabled\\:border-neutral-600\\/55:disabled{
  border-color: rgb(83 88 98 / 0.55);
}

.disabled\\:border-neutral-600\\/60:disabled{
  border-color: rgb(83 88 98 / 0.6);
}

.disabled\\:border-neutral-600\\/65:disabled{
  border-color: rgb(83 88 98 / 0.65);
}

.disabled\\:border-neutral-600\\/70:disabled{
  border-color: rgb(83 88 98 / 0.7);
}

.disabled\\:border-neutral-600\\/75:disabled{
  border-color: rgb(83 88 98 / 0.75);
}

.disabled\\:border-neutral-600\\/80:disabled{
  border-color: rgb(83 88 98 / 0.8);
}

.disabled\\:border-neutral-600\\/85:disabled{
  border-color: rgb(83 88 98 / 0.85);
}

.disabled\\:border-neutral-600\\/90:disabled{
  border-color: rgb(83 88 98 / 0.9);
}

.disabled\\:border-neutral-600\\/95:disabled{
  border-color: rgb(83 88 98 / 0.95);
}

.disabled\\:border-neutral-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(65 70 81 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-700\\/0:disabled{
  border-color: rgb(65 70 81 / 0);
}

.disabled\\:border-neutral-700\\/10:disabled{
  border-color: rgb(65 70 81 / 0.1);
}

.disabled\\:border-neutral-700\\/100:disabled{
  border-color: rgb(65 70 81 / 1);
}

.disabled\\:border-neutral-700\\/15:disabled{
  border-color: rgb(65 70 81 / 0.15);
}

.disabled\\:border-neutral-700\\/20:disabled{
  border-color: rgb(65 70 81 / 0.2);
}

.disabled\\:border-neutral-700\\/25:disabled{
  border-color: rgb(65 70 81 / 0.25);
}

.disabled\\:border-neutral-700\\/30:disabled{
  border-color: rgb(65 70 81 / 0.3);
}

.disabled\\:border-neutral-700\\/35:disabled{
  border-color: rgb(65 70 81 / 0.35);
}

.disabled\\:border-neutral-700\\/40:disabled{
  border-color: rgb(65 70 81 / 0.4);
}

.disabled\\:border-neutral-700\\/45:disabled{
  border-color: rgb(65 70 81 / 0.45);
}

.disabled\\:border-neutral-700\\/5:disabled{
  border-color: rgb(65 70 81 / 0.05);
}

.disabled\\:border-neutral-700\\/50:disabled{
  border-color: rgb(65 70 81 / 0.5);
}

.disabled\\:border-neutral-700\\/55:disabled{
  border-color: rgb(65 70 81 / 0.55);
}

.disabled\\:border-neutral-700\\/60:disabled{
  border-color: rgb(65 70 81 / 0.6);
}

.disabled\\:border-neutral-700\\/65:disabled{
  border-color: rgb(65 70 81 / 0.65);
}

.disabled\\:border-neutral-700\\/70:disabled{
  border-color: rgb(65 70 81 / 0.7);
}

.disabled\\:border-neutral-700\\/75:disabled{
  border-color: rgb(65 70 81 / 0.75);
}

.disabled\\:border-neutral-700\\/80:disabled{
  border-color: rgb(65 70 81 / 0.8);
}

.disabled\\:border-neutral-700\\/85:disabled{
  border-color: rgb(65 70 81 / 0.85);
}

.disabled\\:border-neutral-700\\/90:disabled{
  border-color: rgb(65 70 81 / 0.9);
}

.disabled\\:border-neutral-700\\/95:disabled{
  border-color: rgb(65 70 81 / 0.95);
}

.disabled\\:border-neutral-75:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(246 246 246 / var(--tw-border-opacity, 1));
}

.disabled\\:border-neutral-75\\/0:disabled{
  border-color: rgb(246 246 246 / 0);
}

.disabled\\:border-neutral-75\\/10:disabled{
  border-color: rgb(246 246 246 / 0.1);
}

.disabled\\:border-neutral-75\\/100:disabled{
  border-color: rgb(246 246 246 / 1);
}

.disabled\\:border-neutral-75\\/15:disabled{
  border-color: rgb(246 246 246 / 0.15);
}

.disabled\\:border-neutral-75\\/20:disabled{
  border-color: rgb(246 246 246 / 0.2);
}

.disabled\\:border-neutral-75\\/25:disabled{
  border-color: rgb(246 246 246 / 0.25);
}

.disabled\\:border-neutral-75\\/30:disabled{
  border-color: rgb(246 246 246 / 0.3);
}

.disabled\\:border-neutral-75\\/35:disabled{
  border-color: rgb(246 246 246 / 0.35);
}

.disabled\\:border-neutral-75\\/40:disabled{
  border-color: rgb(246 246 246 / 0.4);
}

.disabled\\:border-neutral-75\\/45:disabled{
  border-color: rgb(246 246 246 / 0.45);
}

.disabled\\:border-neutral-75\\/5:disabled{
  border-color: rgb(246 246 246 / 0.05);
}

.disabled\\:border-neutral-75\\/50:disabled{
  border-color: rgb(246 246 246 / 0.5);
}

.disabled\\:border-neutral-75\\/55:disabled{
  border-color: rgb(246 246 246 / 0.55);
}

.disabled\\:border-neutral-75\\/60:disabled{
  border-color: rgb(246 246 246 / 0.6);
}

.disabled\\:border-neutral-75\\/65:disabled{
  border-color: rgb(246 246 246 / 0.65);
}

.disabled\\:border-neutral-75\\/70:disabled{
  border-color: rgb(246 246 246 / 0.7);
}

.disabled\\:border-neutral-75\\/75:disabled{
  border-color: rgb(246 246 246 / 0.75);
}

.disabled\\:border-neutral-75\\/80:disabled{
  border-color: rgb(246 246 246 / 0.8);
}

.disabled\\:border-neutral-75\\/85:disabled{
  border-color: rgb(246 246 246 / 0.85);
}

.disabled\\:border-neutral-75\\/90:disabled{
  border-color: rgb(246 246 246 / 0.9);
}

.disabled\\:border-neutral-75\\/95:disabled{
  border-color: rgb(246 246 246 / 0.95);
}

.disabled\\:border-primary-100:disabled{
  border-color: var(--color-primary-100, #E0F2FE);
}

.disabled\\:border-primary-200:disabled{
  border-color: var(--color-primary-200, #B9E6FE);
}

.disabled\\:border-primary-25:disabled{
  border-color: var(--color-primary-25, #F5FBFF);
}

.disabled\\:border-primary-400:disabled{
  border-color: var(--color-primary-400, #36BFFA);
}

.disabled\\:border-primary-50:disabled{
  border-color: var(--color-primary-50, #F0F9FF);
}

.disabled\\:border-primary-500:disabled{
  border-color: var(--color-primary-500, #0BA5EC);
}

.disabled\\:border-primary-600:disabled{
  border-color: var(--color-primary-600, #0086C9);
}

.disabled\\:border-primary-700:disabled{
  border-color: var(--color-primary-700, #026AA2);
}

.disabled\\:border-purple-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(235 233 254 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-100\\/0:disabled{
  border-color: rgb(235 233 254 / 0);
}

.disabled\\:border-purple-100\\/10:disabled{
  border-color: rgb(235 233 254 / 0.1);
}

.disabled\\:border-purple-100\\/100:disabled{
  border-color: rgb(235 233 254 / 1);
}

.disabled\\:border-purple-100\\/15:disabled{
  border-color: rgb(235 233 254 / 0.15);
}

.disabled\\:border-purple-100\\/20:disabled{
  border-color: rgb(235 233 254 / 0.2);
}

.disabled\\:border-purple-100\\/25:disabled{
  border-color: rgb(235 233 254 / 0.25);
}

.disabled\\:border-purple-100\\/30:disabled{
  border-color: rgb(235 233 254 / 0.3);
}

.disabled\\:border-purple-100\\/35:disabled{
  border-color: rgb(235 233 254 / 0.35);
}

.disabled\\:border-purple-100\\/40:disabled{
  border-color: rgb(235 233 254 / 0.4);
}

.disabled\\:border-purple-100\\/45:disabled{
  border-color: rgb(235 233 254 / 0.45);
}

.disabled\\:border-purple-100\\/5:disabled{
  border-color: rgb(235 233 254 / 0.05);
}

.disabled\\:border-purple-100\\/50:disabled{
  border-color: rgb(235 233 254 / 0.5);
}

.disabled\\:border-purple-100\\/55:disabled{
  border-color: rgb(235 233 254 / 0.55);
}

.disabled\\:border-purple-100\\/60:disabled{
  border-color: rgb(235 233 254 / 0.6);
}

.disabled\\:border-purple-100\\/65:disabled{
  border-color: rgb(235 233 254 / 0.65);
}

.disabled\\:border-purple-100\\/70:disabled{
  border-color: rgb(235 233 254 / 0.7);
}

.disabled\\:border-purple-100\\/75:disabled{
  border-color: rgb(235 233 254 / 0.75);
}

.disabled\\:border-purple-100\\/80:disabled{
  border-color: rgb(235 233 254 / 0.8);
}

.disabled\\:border-purple-100\\/85:disabled{
  border-color: rgb(235 233 254 / 0.85);
}

.disabled\\:border-purple-100\\/90:disabled{
  border-color: rgb(235 233 254 / 0.9);
}

.disabled\\:border-purple-100\\/95:disabled{
  border-color: rgb(235 233 254 / 0.95);
}

.disabled\\:border-purple-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(217 214 254 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-200\\/0:disabled{
  border-color: rgb(217 214 254 / 0);
}

.disabled\\:border-purple-200\\/10:disabled{
  border-color: rgb(217 214 254 / 0.1);
}

.disabled\\:border-purple-200\\/100:disabled{
  border-color: rgb(217 214 254 / 1);
}

.disabled\\:border-purple-200\\/15:disabled{
  border-color: rgb(217 214 254 / 0.15);
}

.disabled\\:border-purple-200\\/20:disabled{
  border-color: rgb(217 214 254 / 0.2);
}

.disabled\\:border-purple-200\\/25:disabled{
  border-color: rgb(217 214 254 / 0.25);
}

.disabled\\:border-purple-200\\/30:disabled{
  border-color: rgb(217 214 254 / 0.3);
}

.disabled\\:border-purple-200\\/35:disabled{
  border-color: rgb(217 214 254 / 0.35);
}

.disabled\\:border-purple-200\\/40:disabled{
  border-color: rgb(217 214 254 / 0.4);
}

.disabled\\:border-purple-200\\/45:disabled{
  border-color: rgb(217 214 254 / 0.45);
}

.disabled\\:border-purple-200\\/5:disabled{
  border-color: rgb(217 214 254 / 0.05);
}

.disabled\\:border-purple-200\\/50:disabled{
  border-color: rgb(217 214 254 / 0.5);
}

.disabled\\:border-purple-200\\/55:disabled{
  border-color: rgb(217 214 254 / 0.55);
}

.disabled\\:border-purple-200\\/60:disabled{
  border-color: rgb(217 214 254 / 0.6);
}

.disabled\\:border-purple-200\\/65:disabled{
  border-color: rgb(217 214 254 / 0.65);
}

.disabled\\:border-purple-200\\/70:disabled{
  border-color: rgb(217 214 254 / 0.7);
}

.disabled\\:border-purple-200\\/75:disabled{
  border-color: rgb(217 214 254 / 0.75);
}

.disabled\\:border-purple-200\\/80:disabled{
  border-color: rgb(217 214 254 / 0.8);
}

.disabled\\:border-purple-200\\/85:disabled{
  border-color: rgb(217 214 254 / 0.85);
}

.disabled\\:border-purple-200\\/90:disabled{
  border-color: rgb(217 214 254 / 0.9);
}

.disabled\\:border-purple-200\\/95:disabled{
  border-color: rgb(217 214 254 / 0.95);
}

.disabled\\:border-purple-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(250 250 255 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-25\\/0:disabled{
  border-color: rgb(250 250 255 / 0);
}

.disabled\\:border-purple-25\\/10:disabled{
  border-color: rgb(250 250 255 / 0.1);
}

.disabled\\:border-purple-25\\/100:disabled{
  border-color: rgb(250 250 255 / 1);
}

.disabled\\:border-purple-25\\/15:disabled{
  border-color: rgb(250 250 255 / 0.15);
}

.disabled\\:border-purple-25\\/20:disabled{
  border-color: rgb(250 250 255 / 0.2);
}

.disabled\\:border-purple-25\\/25:disabled{
  border-color: rgb(250 250 255 / 0.25);
}

.disabled\\:border-purple-25\\/30:disabled{
  border-color: rgb(250 250 255 / 0.3);
}

.disabled\\:border-purple-25\\/35:disabled{
  border-color: rgb(250 250 255 / 0.35);
}

.disabled\\:border-purple-25\\/40:disabled{
  border-color: rgb(250 250 255 / 0.4);
}

.disabled\\:border-purple-25\\/45:disabled{
  border-color: rgb(250 250 255 / 0.45);
}

.disabled\\:border-purple-25\\/5:disabled{
  border-color: rgb(250 250 255 / 0.05);
}

.disabled\\:border-purple-25\\/50:disabled{
  border-color: rgb(250 250 255 / 0.5);
}

.disabled\\:border-purple-25\\/55:disabled{
  border-color: rgb(250 250 255 / 0.55);
}

.disabled\\:border-purple-25\\/60:disabled{
  border-color: rgb(250 250 255 / 0.6);
}

.disabled\\:border-purple-25\\/65:disabled{
  border-color: rgb(250 250 255 / 0.65);
}

.disabled\\:border-purple-25\\/70:disabled{
  border-color: rgb(250 250 255 / 0.7);
}

.disabled\\:border-purple-25\\/75:disabled{
  border-color: rgb(250 250 255 / 0.75);
}

.disabled\\:border-purple-25\\/80:disabled{
  border-color: rgb(250 250 255 / 0.8);
}

.disabled\\:border-purple-25\\/85:disabled{
  border-color: rgb(250 250 255 / 0.85);
}

.disabled\\:border-purple-25\\/90:disabled{
  border-color: rgb(250 250 255 / 0.9);
}

.disabled\\:border-purple-25\\/95:disabled{
  border-color: rgb(250 250 255 / 0.95);
}

.disabled\\:border-purple-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(155 138 251 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-400\\/0:disabled{
  border-color: rgb(155 138 251 / 0);
}

.disabled\\:border-purple-400\\/10:disabled{
  border-color: rgb(155 138 251 / 0.1);
}

.disabled\\:border-purple-400\\/100:disabled{
  border-color: rgb(155 138 251 / 1);
}

.disabled\\:border-purple-400\\/15:disabled{
  border-color: rgb(155 138 251 / 0.15);
}

.disabled\\:border-purple-400\\/20:disabled{
  border-color: rgb(155 138 251 / 0.2);
}

.disabled\\:border-purple-400\\/25:disabled{
  border-color: rgb(155 138 251 / 0.25);
}

.disabled\\:border-purple-400\\/30:disabled{
  border-color: rgb(155 138 251 / 0.3);
}

.disabled\\:border-purple-400\\/35:disabled{
  border-color: rgb(155 138 251 / 0.35);
}

.disabled\\:border-purple-400\\/40:disabled{
  border-color: rgb(155 138 251 / 0.4);
}

.disabled\\:border-purple-400\\/45:disabled{
  border-color: rgb(155 138 251 / 0.45);
}

.disabled\\:border-purple-400\\/5:disabled{
  border-color: rgb(155 138 251 / 0.05);
}

.disabled\\:border-purple-400\\/50:disabled{
  border-color: rgb(155 138 251 / 0.5);
}

.disabled\\:border-purple-400\\/55:disabled{
  border-color: rgb(155 138 251 / 0.55);
}

.disabled\\:border-purple-400\\/60:disabled{
  border-color: rgb(155 138 251 / 0.6);
}

.disabled\\:border-purple-400\\/65:disabled{
  border-color: rgb(155 138 251 / 0.65);
}

.disabled\\:border-purple-400\\/70:disabled{
  border-color: rgb(155 138 251 / 0.7);
}

.disabled\\:border-purple-400\\/75:disabled{
  border-color: rgb(155 138 251 / 0.75);
}

.disabled\\:border-purple-400\\/80:disabled{
  border-color: rgb(155 138 251 / 0.8);
}

.disabled\\:border-purple-400\\/85:disabled{
  border-color: rgb(155 138 251 / 0.85);
}

.disabled\\:border-purple-400\\/90:disabled{
  border-color: rgb(155 138 251 / 0.9);
}

.disabled\\:border-purple-400\\/95:disabled{
  border-color: rgb(155 138 251 / 0.95);
}

.disabled\\:border-purple-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(244 243 255 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-50\\/0:disabled{
  border-color: rgb(244 243 255 / 0);
}

.disabled\\:border-purple-50\\/10:disabled{
  border-color: rgb(244 243 255 / 0.1);
}

.disabled\\:border-purple-50\\/100:disabled{
  border-color: rgb(244 243 255 / 1);
}

.disabled\\:border-purple-50\\/15:disabled{
  border-color: rgb(244 243 255 / 0.15);
}

.disabled\\:border-purple-50\\/20:disabled{
  border-color: rgb(244 243 255 / 0.2);
}

.disabled\\:border-purple-50\\/25:disabled{
  border-color: rgb(244 243 255 / 0.25);
}

.disabled\\:border-purple-50\\/30:disabled{
  border-color: rgb(244 243 255 / 0.3);
}

.disabled\\:border-purple-50\\/35:disabled{
  border-color: rgb(244 243 255 / 0.35);
}

.disabled\\:border-purple-50\\/40:disabled{
  border-color: rgb(244 243 255 / 0.4);
}

.disabled\\:border-purple-50\\/45:disabled{
  border-color: rgb(244 243 255 / 0.45);
}

.disabled\\:border-purple-50\\/5:disabled{
  border-color: rgb(244 243 255 / 0.05);
}

.disabled\\:border-purple-50\\/50:disabled{
  border-color: rgb(244 243 255 / 0.5);
}

.disabled\\:border-purple-50\\/55:disabled{
  border-color: rgb(244 243 255 / 0.55);
}

.disabled\\:border-purple-50\\/60:disabled{
  border-color: rgb(244 243 255 / 0.6);
}

.disabled\\:border-purple-50\\/65:disabled{
  border-color: rgb(244 243 255 / 0.65);
}

.disabled\\:border-purple-50\\/70:disabled{
  border-color: rgb(244 243 255 / 0.7);
}

.disabled\\:border-purple-50\\/75:disabled{
  border-color: rgb(244 243 255 / 0.75);
}

.disabled\\:border-purple-50\\/80:disabled{
  border-color: rgb(244 243 255 / 0.8);
}

.disabled\\:border-purple-50\\/85:disabled{
  border-color: rgb(244 243 255 / 0.85);
}

.disabled\\:border-purple-50\\/90:disabled{
  border-color: rgb(244 243 255 / 0.9);
}

.disabled\\:border-purple-50\\/95:disabled{
  border-color: rgb(244 243 255 / 0.95);
}

.disabled\\:border-purple-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(122 90 248 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-500\\/0:disabled{
  border-color: rgb(122 90 248 / 0);
}

.disabled\\:border-purple-500\\/10:disabled{
  border-color: rgb(122 90 248 / 0.1);
}

.disabled\\:border-purple-500\\/100:disabled{
  border-color: rgb(122 90 248 / 1);
}

.disabled\\:border-purple-500\\/15:disabled{
  border-color: rgb(122 90 248 / 0.15);
}

.disabled\\:border-purple-500\\/20:disabled{
  border-color: rgb(122 90 248 / 0.2);
}

.disabled\\:border-purple-500\\/25:disabled{
  border-color: rgb(122 90 248 / 0.25);
}

.disabled\\:border-purple-500\\/30:disabled{
  border-color: rgb(122 90 248 / 0.3);
}

.disabled\\:border-purple-500\\/35:disabled{
  border-color: rgb(122 90 248 / 0.35);
}

.disabled\\:border-purple-500\\/40:disabled{
  border-color: rgb(122 90 248 / 0.4);
}

.disabled\\:border-purple-500\\/45:disabled{
  border-color: rgb(122 90 248 / 0.45);
}

.disabled\\:border-purple-500\\/5:disabled{
  border-color: rgb(122 90 248 / 0.05);
}

.disabled\\:border-purple-500\\/50:disabled{
  border-color: rgb(122 90 248 / 0.5);
}

.disabled\\:border-purple-500\\/55:disabled{
  border-color: rgb(122 90 248 / 0.55);
}

.disabled\\:border-purple-500\\/60:disabled{
  border-color: rgb(122 90 248 / 0.6);
}

.disabled\\:border-purple-500\\/65:disabled{
  border-color: rgb(122 90 248 / 0.65);
}

.disabled\\:border-purple-500\\/70:disabled{
  border-color: rgb(122 90 248 / 0.7);
}

.disabled\\:border-purple-500\\/75:disabled{
  border-color: rgb(122 90 248 / 0.75);
}

.disabled\\:border-purple-500\\/80:disabled{
  border-color: rgb(122 90 248 / 0.8);
}

.disabled\\:border-purple-500\\/85:disabled{
  border-color: rgb(122 90 248 / 0.85);
}

.disabled\\:border-purple-500\\/90:disabled{
  border-color: rgb(122 90 248 / 0.9);
}

.disabled\\:border-purple-500\\/95:disabled{
  border-color: rgb(122 90 248 / 0.95);
}

.disabled\\:border-purple-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(105 56 239 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-600\\/0:disabled{
  border-color: rgb(105 56 239 / 0);
}

.disabled\\:border-purple-600\\/10:disabled{
  border-color: rgb(105 56 239 / 0.1);
}

.disabled\\:border-purple-600\\/100:disabled{
  border-color: rgb(105 56 239 / 1);
}

.disabled\\:border-purple-600\\/15:disabled{
  border-color: rgb(105 56 239 / 0.15);
}

.disabled\\:border-purple-600\\/20:disabled{
  border-color: rgb(105 56 239 / 0.2);
}

.disabled\\:border-purple-600\\/25:disabled{
  border-color: rgb(105 56 239 / 0.25);
}

.disabled\\:border-purple-600\\/30:disabled{
  border-color: rgb(105 56 239 / 0.3);
}

.disabled\\:border-purple-600\\/35:disabled{
  border-color: rgb(105 56 239 / 0.35);
}

.disabled\\:border-purple-600\\/40:disabled{
  border-color: rgb(105 56 239 / 0.4);
}

.disabled\\:border-purple-600\\/45:disabled{
  border-color: rgb(105 56 239 / 0.45);
}

.disabled\\:border-purple-600\\/5:disabled{
  border-color: rgb(105 56 239 / 0.05);
}

.disabled\\:border-purple-600\\/50:disabled{
  border-color: rgb(105 56 239 / 0.5);
}

.disabled\\:border-purple-600\\/55:disabled{
  border-color: rgb(105 56 239 / 0.55);
}

.disabled\\:border-purple-600\\/60:disabled{
  border-color: rgb(105 56 239 / 0.6);
}

.disabled\\:border-purple-600\\/65:disabled{
  border-color: rgb(105 56 239 / 0.65);
}

.disabled\\:border-purple-600\\/70:disabled{
  border-color: rgb(105 56 239 / 0.7);
}

.disabled\\:border-purple-600\\/75:disabled{
  border-color: rgb(105 56 239 / 0.75);
}

.disabled\\:border-purple-600\\/80:disabled{
  border-color: rgb(105 56 239 / 0.8);
}

.disabled\\:border-purple-600\\/85:disabled{
  border-color: rgb(105 56 239 / 0.85);
}

.disabled\\:border-purple-600\\/90:disabled{
  border-color: rgb(105 56 239 / 0.9);
}

.disabled\\:border-purple-600\\/95:disabled{
  border-color: rgb(105 56 239 / 0.95);
}

.disabled\\:border-purple-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(89 37 220 / var(--tw-border-opacity, 1));
}

.disabled\\:border-purple-700\\/0:disabled{
  border-color: rgb(89 37 220 / 0);
}

.disabled\\:border-purple-700\\/10:disabled{
  border-color: rgb(89 37 220 / 0.1);
}

.disabled\\:border-purple-700\\/100:disabled{
  border-color: rgb(89 37 220 / 1);
}

.disabled\\:border-purple-700\\/15:disabled{
  border-color: rgb(89 37 220 / 0.15);
}

.disabled\\:border-purple-700\\/20:disabled{
  border-color: rgb(89 37 220 / 0.2);
}

.disabled\\:border-purple-700\\/25:disabled{
  border-color: rgb(89 37 220 / 0.25);
}

.disabled\\:border-purple-700\\/30:disabled{
  border-color: rgb(89 37 220 / 0.3);
}

.disabled\\:border-purple-700\\/35:disabled{
  border-color: rgb(89 37 220 / 0.35);
}

.disabled\\:border-purple-700\\/40:disabled{
  border-color: rgb(89 37 220 / 0.4);
}

.disabled\\:border-purple-700\\/45:disabled{
  border-color: rgb(89 37 220 / 0.45);
}

.disabled\\:border-purple-700\\/5:disabled{
  border-color: rgb(89 37 220 / 0.05);
}

.disabled\\:border-purple-700\\/50:disabled{
  border-color: rgb(89 37 220 / 0.5);
}

.disabled\\:border-purple-700\\/55:disabled{
  border-color: rgb(89 37 220 / 0.55);
}

.disabled\\:border-purple-700\\/60:disabled{
  border-color: rgb(89 37 220 / 0.6);
}

.disabled\\:border-purple-700\\/65:disabled{
  border-color: rgb(89 37 220 / 0.65);
}

.disabled\\:border-purple-700\\/70:disabled{
  border-color: rgb(89 37 220 / 0.7);
}

.disabled\\:border-purple-700\\/75:disabled{
  border-color: rgb(89 37 220 / 0.75);
}

.disabled\\:border-purple-700\\/80:disabled{
  border-color: rgb(89 37 220 / 0.8);
}

.disabled\\:border-purple-700\\/85:disabled{
  border-color: rgb(89 37 220 / 0.85);
}

.disabled\\:border-purple-700\\/90:disabled{
  border-color: rgb(89 37 220 / 0.9);
}

.disabled\\:border-purple-700\\/95:disabled{
  border-color: rgb(89 37 220 / 0.95);
}

.disabled\\:border-success-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(211 248 223 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-100\\/0:disabled{
  border-color: rgb(211 248 223 / 0);
}

.disabled\\:border-success-100\\/10:disabled{
  border-color: rgb(211 248 223 / 0.1);
}

.disabled\\:border-success-100\\/100:disabled{
  border-color: rgb(211 248 223 / 1);
}

.disabled\\:border-success-100\\/15:disabled{
  border-color: rgb(211 248 223 / 0.15);
}

.disabled\\:border-success-100\\/20:disabled{
  border-color: rgb(211 248 223 / 0.2);
}

.disabled\\:border-success-100\\/25:disabled{
  border-color: rgb(211 248 223 / 0.25);
}

.disabled\\:border-success-100\\/30:disabled{
  border-color: rgb(211 248 223 / 0.3);
}

.disabled\\:border-success-100\\/35:disabled{
  border-color: rgb(211 248 223 / 0.35);
}

.disabled\\:border-success-100\\/40:disabled{
  border-color: rgb(211 248 223 / 0.4);
}

.disabled\\:border-success-100\\/45:disabled{
  border-color: rgb(211 248 223 / 0.45);
}

.disabled\\:border-success-100\\/5:disabled{
  border-color: rgb(211 248 223 / 0.05);
}

.disabled\\:border-success-100\\/50:disabled{
  border-color: rgb(211 248 223 / 0.5);
}

.disabled\\:border-success-100\\/55:disabled{
  border-color: rgb(211 248 223 / 0.55);
}

.disabled\\:border-success-100\\/60:disabled{
  border-color: rgb(211 248 223 / 0.6);
}

.disabled\\:border-success-100\\/65:disabled{
  border-color: rgb(211 248 223 / 0.65);
}

.disabled\\:border-success-100\\/70:disabled{
  border-color: rgb(211 248 223 / 0.7);
}

.disabled\\:border-success-100\\/75:disabled{
  border-color: rgb(211 248 223 / 0.75);
}

.disabled\\:border-success-100\\/80:disabled{
  border-color: rgb(211 248 223 / 0.8);
}

.disabled\\:border-success-100\\/85:disabled{
  border-color: rgb(211 248 223 / 0.85);
}

.disabled\\:border-success-100\\/90:disabled{
  border-color: rgb(211 248 223 / 0.9);
}

.disabled\\:border-success-100\\/95:disabled{
  border-color: rgb(211 248 223 / 0.95);
}

.disabled\\:border-success-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(170 240 196 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-200\\/0:disabled{
  border-color: rgb(170 240 196 / 0);
}

.disabled\\:border-success-200\\/10:disabled{
  border-color: rgb(170 240 196 / 0.1);
}

.disabled\\:border-success-200\\/100:disabled{
  border-color: rgb(170 240 196 / 1);
}

.disabled\\:border-success-200\\/15:disabled{
  border-color: rgb(170 240 196 / 0.15);
}

.disabled\\:border-success-200\\/20:disabled{
  border-color: rgb(170 240 196 / 0.2);
}

.disabled\\:border-success-200\\/25:disabled{
  border-color: rgb(170 240 196 / 0.25);
}

.disabled\\:border-success-200\\/30:disabled{
  border-color: rgb(170 240 196 / 0.3);
}

.disabled\\:border-success-200\\/35:disabled{
  border-color: rgb(170 240 196 / 0.35);
}

.disabled\\:border-success-200\\/40:disabled{
  border-color: rgb(170 240 196 / 0.4);
}

.disabled\\:border-success-200\\/45:disabled{
  border-color: rgb(170 240 196 / 0.45);
}

.disabled\\:border-success-200\\/5:disabled{
  border-color: rgb(170 240 196 / 0.05);
}

.disabled\\:border-success-200\\/50:disabled{
  border-color: rgb(170 240 196 / 0.5);
}

.disabled\\:border-success-200\\/55:disabled{
  border-color: rgb(170 240 196 / 0.55);
}

.disabled\\:border-success-200\\/60:disabled{
  border-color: rgb(170 240 196 / 0.6);
}

.disabled\\:border-success-200\\/65:disabled{
  border-color: rgb(170 240 196 / 0.65);
}

.disabled\\:border-success-200\\/70:disabled{
  border-color: rgb(170 240 196 / 0.7);
}

.disabled\\:border-success-200\\/75:disabled{
  border-color: rgb(170 240 196 / 0.75);
}

.disabled\\:border-success-200\\/80:disabled{
  border-color: rgb(170 240 196 / 0.8);
}

.disabled\\:border-success-200\\/85:disabled{
  border-color: rgb(170 240 196 / 0.85);
}

.disabled\\:border-success-200\\/90:disabled{
  border-color: rgb(170 240 196 / 0.9);
}

.disabled\\:border-success-200\\/95:disabled{
  border-color: rgb(170 240 196 / 0.95);
}

.disabled\\:border-success-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(246 254 249 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-25\\/0:disabled{
  border-color: rgb(246 254 249 / 0);
}

.disabled\\:border-success-25\\/10:disabled{
  border-color: rgb(246 254 249 / 0.1);
}

.disabled\\:border-success-25\\/100:disabled{
  border-color: rgb(246 254 249 / 1);
}

.disabled\\:border-success-25\\/15:disabled{
  border-color: rgb(246 254 249 / 0.15);
}

.disabled\\:border-success-25\\/20:disabled{
  border-color: rgb(246 254 249 / 0.2);
}

.disabled\\:border-success-25\\/25:disabled{
  border-color: rgb(246 254 249 / 0.25);
}

.disabled\\:border-success-25\\/30:disabled{
  border-color: rgb(246 254 249 / 0.3);
}

.disabled\\:border-success-25\\/35:disabled{
  border-color: rgb(246 254 249 / 0.35);
}

.disabled\\:border-success-25\\/40:disabled{
  border-color: rgb(246 254 249 / 0.4);
}

.disabled\\:border-success-25\\/45:disabled{
  border-color: rgb(246 254 249 / 0.45);
}

.disabled\\:border-success-25\\/5:disabled{
  border-color: rgb(246 254 249 / 0.05);
}

.disabled\\:border-success-25\\/50:disabled{
  border-color: rgb(246 254 249 / 0.5);
}

.disabled\\:border-success-25\\/55:disabled{
  border-color: rgb(246 254 249 / 0.55);
}

.disabled\\:border-success-25\\/60:disabled{
  border-color: rgb(246 254 249 / 0.6);
}

.disabled\\:border-success-25\\/65:disabled{
  border-color: rgb(246 254 249 / 0.65);
}

.disabled\\:border-success-25\\/70:disabled{
  border-color: rgb(246 254 249 / 0.7);
}

.disabled\\:border-success-25\\/75:disabled{
  border-color: rgb(246 254 249 / 0.75);
}

.disabled\\:border-success-25\\/80:disabled{
  border-color: rgb(246 254 249 / 0.8);
}

.disabled\\:border-success-25\\/85:disabled{
  border-color: rgb(246 254 249 / 0.85);
}

.disabled\\:border-success-25\\/90:disabled{
  border-color: rgb(246 254 249 / 0.9);
}

.disabled\\:border-success-25\\/95:disabled{
  border-color: rgb(246 254 249 / 0.95);
}

.disabled\\:border-success-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(60 203 127 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-400\\/0:disabled{
  border-color: rgb(60 203 127 / 0);
}

.disabled\\:border-success-400\\/10:disabled{
  border-color: rgb(60 203 127 / 0.1);
}

.disabled\\:border-success-400\\/100:disabled{
  border-color: rgb(60 203 127 / 1);
}

.disabled\\:border-success-400\\/15:disabled{
  border-color: rgb(60 203 127 / 0.15);
}

.disabled\\:border-success-400\\/20:disabled{
  border-color: rgb(60 203 127 / 0.2);
}

.disabled\\:border-success-400\\/25:disabled{
  border-color: rgb(60 203 127 / 0.25);
}

.disabled\\:border-success-400\\/30:disabled{
  border-color: rgb(60 203 127 / 0.3);
}

.disabled\\:border-success-400\\/35:disabled{
  border-color: rgb(60 203 127 / 0.35);
}

.disabled\\:border-success-400\\/40:disabled{
  border-color: rgb(60 203 127 / 0.4);
}

.disabled\\:border-success-400\\/45:disabled{
  border-color: rgb(60 203 127 / 0.45);
}

.disabled\\:border-success-400\\/5:disabled{
  border-color: rgb(60 203 127 / 0.05);
}

.disabled\\:border-success-400\\/50:disabled{
  border-color: rgb(60 203 127 / 0.5);
}

.disabled\\:border-success-400\\/55:disabled{
  border-color: rgb(60 203 127 / 0.55);
}

.disabled\\:border-success-400\\/60:disabled{
  border-color: rgb(60 203 127 / 0.6);
}

.disabled\\:border-success-400\\/65:disabled{
  border-color: rgb(60 203 127 / 0.65);
}

.disabled\\:border-success-400\\/70:disabled{
  border-color: rgb(60 203 127 / 0.7);
}

.disabled\\:border-success-400\\/75:disabled{
  border-color: rgb(60 203 127 / 0.75);
}

.disabled\\:border-success-400\\/80:disabled{
  border-color: rgb(60 203 127 / 0.8);
}

.disabled\\:border-success-400\\/85:disabled{
  border-color: rgb(60 203 127 / 0.85);
}

.disabled\\:border-success-400\\/90:disabled{
  border-color: rgb(60 203 127 / 0.9);
}

.disabled\\:border-success-400\\/95:disabled{
  border-color: rgb(60 203 127 / 0.95);
}

.disabled\\:border-success-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(237 252 242 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-50\\/0:disabled{
  border-color: rgb(237 252 242 / 0);
}

.disabled\\:border-success-50\\/10:disabled{
  border-color: rgb(237 252 242 / 0.1);
}

.disabled\\:border-success-50\\/100:disabled{
  border-color: rgb(237 252 242 / 1);
}

.disabled\\:border-success-50\\/15:disabled{
  border-color: rgb(237 252 242 / 0.15);
}

.disabled\\:border-success-50\\/20:disabled{
  border-color: rgb(237 252 242 / 0.2);
}

.disabled\\:border-success-50\\/25:disabled{
  border-color: rgb(237 252 242 / 0.25);
}

.disabled\\:border-success-50\\/30:disabled{
  border-color: rgb(237 252 242 / 0.3);
}

.disabled\\:border-success-50\\/35:disabled{
  border-color: rgb(237 252 242 / 0.35);
}

.disabled\\:border-success-50\\/40:disabled{
  border-color: rgb(237 252 242 / 0.4);
}

.disabled\\:border-success-50\\/45:disabled{
  border-color: rgb(237 252 242 / 0.45);
}

.disabled\\:border-success-50\\/5:disabled{
  border-color: rgb(237 252 242 / 0.05);
}

.disabled\\:border-success-50\\/50:disabled{
  border-color: rgb(237 252 242 / 0.5);
}

.disabled\\:border-success-50\\/55:disabled{
  border-color: rgb(237 252 242 / 0.55);
}

.disabled\\:border-success-50\\/60:disabled{
  border-color: rgb(237 252 242 / 0.6);
}

.disabled\\:border-success-50\\/65:disabled{
  border-color: rgb(237 252 242 / 0.65);
}

.disabled\\:border-success-50\\/70:disabled{
  border-color: rgb(237 252 242 / 0.7);
}

.disabled\\:border-success-50\\/75:disabled{
  border-color: rgb(237 252 242 / 0.75);
}

.disabled\\:border-success-50\\/80:disabled{
  border-color: rgb(237 252 242 / 0.8);
}

.disabled\\:border-success-50\\/85:disabled{
  border-color: rgb(237 252 242 / 0.85);
}

.disabled\\:border-success-50\\/90:disabled{
  border-color: rgb(237 252 242 / 0.9);
}

.disabled\\:border-success-50\\/95:disabled{
  border-color: rgb(237 252 242 / 0.95);
}

.disabled\\:border-success-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(22 179 100 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-500\\/0:disabled{
  border-color: rgb(22 179 100 / 0);
}

.disabled\\:border-success-500\\/10:disabled{
  border-color: rgb(22 179 100 / 0.1);
}

.disabled\\:border-success-500\\/100:disabled{
  border-color: rgb(22 179 100 / 1);
}

.disabled\\:border-success-500\\/15:disabled{
  border-color: rgb(22 179 100 / 0.15);
}

.disabled\\:border-success-500\\/20:disabled{
  border-color: rgb(22 179 100 / 0.2);
}

.disabled\\:border-success-500\\/25:disabled{
  border-color: rgb(22 179 100 / 0.25);
}

.disabled\\:border-success-500\\/30:disabled{
  border-color: rgb(22 179 100 / 0.3);
}

.disabled\\:border-success-500\\/35:disabled{
  border-color: rgb(22 179 100 / 0.35);
}

.disabled\\:border-success-500\\/40:disabled{
  border-color: rgb(22 179 100 / 0.4);
}

.disabled\\:border-success-500\\/45:disabled{
  border-color: rgb(22 179 100 / 0.45);
}

.disabled\\:border-success-500\\/5:disabled{
  border-color: rgb(22 179 100 / 0.05);
}

.disabled\\:border-success-500\\/50:disabled{
  border-color: rgb(22 179 100 / 0.5);
}

.disabled\\:border-success-500\\/55:disabled{
  border-color: rgb(22 179 100 / 0.55);
}

.disabled\\:border-success-500\\/60:disabled{
  border-color: rgb(22 179 100 / 0.6);
}

.disabled\\:border-success-500\\/65:disabled{
  border-color: rgb(22 179 100 / 0.65);
}

.disabled\\:border-success-500\\/70:disabled{
  border-color: rgb(22 179 100 / 0.7);
}

.disabled\\:border-success-500\\/75:disabled{
  border-color: rgb(22 179 100 / 0.75);
}

.disabled\\:border-success-500\\/80:disabled{
  border-color: rgb(22 179 100 / 0.8);
}

.disabled\\:border-success-500\\/85:disabled{
  border-color: rgb(22 179 100 / 0.85);
}

.disabled\\:border-success-500\\/90:disabled{
  border-color: rgb(22 179 100 / 0.9);
}

.disabled\\:border-success-500\\/95:disabled{
  border-color: rgb(22 179 100 / 0.95);
}

.disabled\\:border-success-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(9 146 80 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-600\\/0:disabled{
  border-color: rgb(9 146 80 / 0);
}

.disabled\\:border-success-600\\/10:disabled{
  border-color: rgb(9 146 80 / 0.1);
}

.disabled\\:border-success-600\\/100:disabled{
  border-color: rgb(9 146 80 / 1);
}

.disabled\\:border-success-600\\/15:disabled{
  border-color: rgb(9 146 80 / 0.15);
}

.disabled\\:border-success-600\\/20:disabled{
  border-color: rgb(9 146 80 / 0.2);
}

.disabled\\:border-success-600\\/25:disabled{
  border-color: rgb(9 146 80 / 0.25);
}

.disabled\\:border-success-600\\/30:disabled{
  border-color: rgb(9 146 80 / 0.3);
}

.disabled\\:border-success-600\\/35:disabled{
  border-color: rgb(9 146 80 / 0.35);
}

.disabled\\:border-success-600\\/40:disabled{
  border-color: rgb(9 146 80 / 0.4);
}

.disabled\\:border-success-600\\/45:disabled{
  border-color: rgb(9 146 80 / 0.45);
}

.disabled\\:border-success-600\\/5:disabled{
  border-color: rgb(9 146 80 / 0.05);
}

.disabled\\:border-success-600\\/50:disabled{
  border-color: rgb(9 146 80 / 0.5);
}

.disabled\\:border-success-600\\/55:disabled{
  border-color: rgb(9 146 80 / 0.55);
}

.disabled\\:border-success-600\\/60:disabled{
  border-color: rgb(9 146 80 / 0.6);
}

.disabled\\:border-success-600\\/65:disabled{
  border-color: rgb(9 146 80 / 0.65);
}

.disabled\\:border-success-600\\/70:disabled{
  border-color: rgb(9 146 80 / 0.7);
}

.disabled\\:border-success-600\\/75:disabled{
  border-color: rgb(9 146 80 / 0.75);
}

.disabled\\:border-success-600\\/80:disabled{
  border-color: rgb(9 146 80 / 0.8);
}

.disabled\\:border-success-600\\/85:disabled{
  border-color: rgb(9 146 80 / 0.85);
}

.disabled\\:border-success-600\\/90:disabled{
  border-color: rgb(9 146 80 / 0.9);
}

.disabled\\:border-success-600\\/95:disabled{
  border-color: rgb(9 146 80 / 0.95);
}

.disabled\\:border-success-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(8 116 67 / var(--tw-border-opacity, 1));
}

.disabled\\:border-success-700\\/0:disabled{
  border-color: rgb(8 116 67 / 0);
}

.disabled\\:border-success-700\\/10:disabled{
  border-color: rgb(8 116 67 / 0.1);
}

.disabled\\:border-success-700\\/100:disabled{
  border-color: rgb(8 116 67 / 1);
}

.disabled\\:border-success-700\\/15:disabled{
  border-color: rgb(8 116 67 / 0.15);
}

.disabled\\:border-success-700\\/20:disabled{
  border-color: rgb(8 116 67 / 0.2);
}

.disabled\\:border-success-700\\/25:disabled{
  border-color: rgb(8 116 67 / 0.25);
}

.disabled\\:border-success-700\\/30:disabled{
  border-color: rgb(8 116 67 / 0.3);
}

.disabled\\:border-success-700\\/35:disabled{
  border-color: rgb(8 116 67 / 0.35);
}

.disabled\\:border-success-700\\/40:disabled{
  border-color: rgb(8 116 67 / 0.4);
}

.disabled\\:border-success-700\\/45:disabled{
  border-color: rgb(8 116 67 / 0.45);
}

.disabled\\:border-success-700\\/5:disabled{
  border-color: rgb(8 116 67 / 0.05);
}

.disabled\\:border-success-700\\/50:disabled{
  border-color: rgb(8 116 67 / 0.5);
}

.disabled\\:border-success-700\\/55:disabled{
  border-color: rgb(8 116 67 / 0.55);
}

.disabled\\:border-success-700\\/60:disabled{
  border-color: rgb(8 116 67 / 0.6);
}

.disabled\\:border-success-700\\/65:disabled{
  border-color: rgb(8 116 67 / 0.65);
}

.disabled\\:border-success-700\\/70:disabled{
  border-color: rgb(8 116 67 / 0.7);
}

.disabled\\:border-success-700\\/75:disabled{
  border-color: rgb(8 116 67 / 0.75);
}

.disabled\\:border-success-700\\/80:disabled{
  border-color: rgb(8 116 67 / 0.8);
}

.disabled\\:border-success-700\\/85:disabled{
  border-color: rgb(8 116 67 / 0.85);
}

.disabled\\:border-success-700\\/90:disabled{
  border-color: rgb(8 116 67 / 0.9);
}

.disabled\\:border-success-700\\/95:disabled{
  border-color: rgb(8 116 67 / 0.95);
}

.disabled\\:border-warning-100:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 199 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-100\\/0:disabled{
  border-color: rgb(254 240 199 / 0);
}

.disabled\\:border-warning-100\\/10:disabled{
  border-color: rgb(254 240 199 / 0.1);
}

.disabled\\:border-warning-100\\/100:disabled{
  border-color: rgb(254 240 199 / 1);
}

.disabled\\:border-warning-100\\/15:disabled{
  border-color: rgb(254 240 199 / 0.15);
}

.disabled\\:border-warning-100\\/20:disabled{
  border-color: rgb(254 240 199 / 0.2);
}

.disabled\\:border-warning-100\\/25:disabled{
  border-color: rgb(254 240 199 / 0.25);
}

.disabled\\:border-warning-100\\/30:disabled{
  border-color: rgb(254 240 199 / 0.3);
}

.disabled\\:border-warning-100\\/35:disabled{
  border-color: rgb(254 240 199 / 0.35);
}

.disabled\\:border-warning-100\\/40:disabled{
  border-color: rgb(254 240 199 / 0.4);
}

.disabled\\:border-warning-100\\/45:disabled{
  border-color: rgb(254 240 199 / 0.45);
}

.disabled\\:border-warning-100\\/5:disabled{
  border-color: rgb(254 240 199 / 0.05);
}

.disabled\\:border-warning-100\\/50:disabled{
  border-color: rgb(254 240 199 / 0.5);
}

.disabled\\:border-warning-100\\/55:disabled{
  border-color: rgb(254 240 199 / 0.55);
}

.disabled\\:border-warning-100\\/60:disabled{
  border-color: rgb(254 240 199 / 0.6);
}

.disabled\\:border-warning-100\\/65:disabled{
  border-color: rgb(254 240 199 / 0.65);
}

.disabled\\:border-warning-100\\/70:disabled{
  border-color: rgb(254 240 199 / 0.7);
}

.disabled\\:border-warning-100\\/75:disabled{
  border-color: rgb(254 240 199 / 0.75);
}

.disabled\\:border-warning-100\\/80:disabled{
  border-color: rgb(254 240 199 / 0.8);
}

.disabled\\:border-warning-100\\/85:disabled{
  border-color: rgb(254 240 199 / 0.85);
}

.disabled\\:border-warning-100\\/90:disabled{
  border-color: rgb(254 240 199 / 0.9);
}

.disabled\\:border-warning-100\\/95:disabled{
  border-color: rgb(254 240 199 / 0.95);
}

.disabled\\:border-warning-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(254 223 137 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-200\\/0:disabled{
  border-color: rgb(254 223 137 / 0);
}

.disabled\\:border-warning-200\\/10:disabled{
  border-color: rgb(254 223 137 / 0.1);
}

.disabled\\:border-warning-200\\/100:disabled{
  border-color: rgb(254 223 137 / 1);
}

.disabled\\:border-warning-200\\/15:disabled{
  border-color: rgb(254 223 137 / 0.15);
}

.disabled\\:border-warning-200\\/20:disabled{
  border-color: rgb(254 223 137 / 0.2);
}

.disabled\\:border-warning-200\\/25:disabled{
  border-color: rgb(254 223 137 / 0.25);
}

.disabled\\:border-warning-200\\/30:disabled{
  border-color: rgb(254 223 137 / 0.3);
}

.disabled\\:border-warning-200\\/35:disabled{
  border-color: rgb(254 223 137 / 0.35);
}

.disabled\\:border-warning-200\\/40:disabled{
  border-color: rgb(254 223 137 / 0.4);
}

.disabled\\:border-warning-200\\/45:disabled{
  border-color: rgb(254 223 137 / 0.45);
}

.disabled\\:border-warning-200\\/5:disabled{
  border-color: rgb(254 223 137 / 0.05);
}

.disabled\\:border-warning-200\\/50:disabled{
  border-color: rgb(254 223 137 / 0.5);
}

.disabled\\:border-warning-200\\/55:disabled{
  border-color: rgb(254 223 137 / 0.55);
}

.disabled\\:border-warning-200\\/60:disabled{
  border-color: rgb(254 223 137 / 0.6);
}

.disabled\\:border-warning-200\\/65:disabled{
  border-color: rgb(254 223 137 / 0.65);
}

.disabled\\:border-warning-200\\/70:disabled{
  border-color: rgb(254 223 137 / 0.7);
}

.disabled\\:border-warning-200\\/75:disabled{
  border-color: rgb(254 223 137 / 0.75);
}

.disabled\\:border-warning-200\\/80:disabled{
  border-color: rgb(254 223 137 / 0.8);
}

.disabled\\:border-warning-200\\/85:disabled{
  border-color: rgb(254 223 137 / 0.85);
}

.disabled\\:border-warning-200\\/90:disabled{
  border-color: rgb(254 223 137 / 0.9);
}

.disabled\\:border-warning-200\\/95:disabled{
  border-color: rgb(254 223 137 / 0.95);
}

.disabled\\:border-warning-25:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(255 252 245 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-25\\/0:disabled{
  border-color: rgb(255 252 245 / 0);
}

.disabled\\:border-warning-25\\/10:disabled{
  border-color: rgb(255 252 245 / 0.1);
}

.disabled\\:border-warning-25\\/100:disabled{
  border-color: rgb(255 252 245 / 1);
}

.disabled\\:border-warning-25\\/15:disabled{
  border-color: rgb(255 252 245 / 0.15);
}

.disabled\\:border-warning-25\\/20:disabled{
  border-color: rgb(255 252 245 / 0.2);
}

.disabled\\:border-warning-25\\/25:disabled{
  border-color: rgb(255 252 245 / 0.25);
}

.disabled\\:border-warning-25\\/30:disabled{
  border-color: rgb(255 252 245 / 0.3);
}

.disabled\\:border-warning-25\\/35:disabled{
  border-color: rgb(255 252 245 / 0.35);
}

.disabled\\:border-warning-25\\/40:disabled{
  border-color: rgb(255 252 245 / 0.4);
}

.disabled\\:border-warning-25\\/45:disabled{
  border-color: rgb(255 252 245 / 0.45);
}

.disabled\\:border-warning-25\\/5:disabled{
  border-color: rgb(255 252 245 / 0.05);
}

.disabled\\:border-warning-25\\/50:disabled{
  border-color: rgb(255 252 245 / 0.5);
}

.disabled\\:border-warning-25\\/55:disabled{
  border-color: rgb(255 252 245 / 0.55);
}

.disabled\\:border-warning-25\\/60:disabled{
  border-color: rgb(255 252 245 / 0.6);
}

.disabled\\:border-warning-25\\/65:disabled{
  border-color: rgb(255 252 245 / 0.65);
}

.disabled\\:border-warning-25\\/70:disabled{
  border-color: rgb(255 252 245 / 0.7);
}

.disabled\\:border-warning-25\\/75:disabled{
  border-color: rgb(255 252 245 / 0.75);
}

.disabled\\:border-warning-25\\/80:disabled{
  border-color: rgb(255 252 245 / 0.8);
}

.disabled\\:border-warning-25\\/85:disabled{
  border-color: rgb(255 252 245 / 0.85);
}

.disabled\\:border-warning-25\\/90:disabled{
  border-color: rgb(255 252 245 / 0.9);
}

.disabled\\:border-warning-25\\/95:disabled{
  border-color: rgb(255 252 245 / 0.95);
}

.disabled\\:border-warning-400:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(253 176 34 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-400\\/0:disabled{
  border-color: rgb(253 176 34 / 0);
}

.disabled\\:border-warning-400\\/10:disabled{
  border-color: rgb(253 176 34 / 0.1);
}

.disabled\\:border-warning-400\\/100:disabled{
  border-color: rgb(253 176 34 / 1);
}

.disabled\\:border-warning-400\\/15:disabled{
  border-color: rgb(253 176 34 / 0.15);
}

.disabled\\:border-warning-400\\/20:disabled{
  border-color: rgb(253 176 34 / 0.2);
}

.disabled\\:border-warning-400\\/25:disabled{
  border-color: rgb(253 176 34 / 0.25);
}

.disabled\\:border-warning-400\\/30:disabled{
  border-color: rgb(253 176 34 / 0.3);
}

.disabled\\:border-warning-400\\/35:disabled{
  border-color: rgb(253 176 34 / 0.35);
}

.disabled\\:border-warning-400\\/40:disabled{
  border-color: rgb(253 176 34 / 0.4);
}

.disabled\\:border-warning-400\\/45:disabled{
  border-color: rgb(253 176 34 / 0.45);
}

.disabled\\:border-warning-400\\/5:disabled{
  border-color: rgb(253 176 34 / 0.05);
}

.disabled\\:border-warning-400\\/50:disabled{
  border-color: rgb(253 176 34 / 0.5);
}

.disabled\\:border-warning-400\\/55:disabled{
  border-color: rgb(253 176 34 / 0.55);
}

.disabled\\:border-warning-400\\/60:disabled{
  border-color: rgb(253 176 34 / 0.6);
}

.disabled\\:border-warning-400\\/65:disabled{
  border-color: rgb(253 176 34 / 0.65);
}

.disabled\\:border-warning-400\\/70:disabled{
  border-color: rgb(253 176 34 / 0.7);
}

.disabled\\:border-warning-400\\/75:disabled{
  border-color: rgb(253 176 34 / 0.75);
}

.disabled\\:border-warning-400\\/80:disabled{
  border-color: rgb(253 176 34 / 0.8);
}

.disabled\\:border-warning-400\\/85:disabled{
  border-color: rgb(253 176 34 / 0.85);
}

.disabled\\:border-warning-400\\/90:disabled{
  border-color: rgb(253 176 34 / 0.9);
}

.disabled\\:border-warning-400\\/95:disabled{
  border-color: rgb(253 176 34 / 0.95);
}

.disabled\\:border-warning-50:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(255 250 235 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-50\\/0:disabled{
  border-color: rgb(255 250 235 / 0);
}

.disabled\\:border-warning-50\\/10:disabled{
  border-color: rgb(255 250 235 / 0.1);
}

.disabled\\:border-warning-50\\/100:disabled{
  border-color: rgb(255 250 235 / 1);
}

.disabled\\:border-warning-50\\/15:disabled{
  border-color: rgb(255 250 235 / 0.15);
}

.disabled\\:border-warning-50\\/20:disabled{
  border-color: rgb(255 250 235 / 0.2);
}

.disabled\\:border-warning-50\\/25:disabled{
  border-color: rgb(255 250 235 / 0.25);
}

.disabled\\:border-warning-50\\/30:disabled{
  border-color: rgb(255 250 235 / 0.3);
}

.disabled\\:border-warning-50\\/35:disabled{
  border-color: rgb(255 250 235 / 0.35);
}

.disabled\\:border-warning-50\\/40:disabled{
  border-color: rgb(255 250 235 / 0.4);
}

.disabled\\:border-warning-50\\/45:disabled{
  border-color: rgb(255 250 235 / 0.45);
}

.disabled\\:border-warning-50\\/5:disabled{
  border-color: rgb(255 250 235 / 0.05);
}

.disabled\\:border-warning-50\\/50:disabled{
  border-color: rgb(255 250 235 / 0.5);
}

.disabled\\:border-warning-50\\/55:disabled{
  border-color: rgb(255 250 235 / 0.55);
}

.disabled\\:border-warning-50\\/60:disabled{
  border-color: rgb(255 250 235 / 0.6);
}

.disabled\\:border-warning-50\\/65:disabled{
  border-color: rgb(255 250 235 / 0.65);
}

.disabled\\:border-warning-50\\/70:disabled{
  border-color: rgb(255 250 235 / 0.7);
}

.disabled\\:border-warning-50\\/75:disabled{
  border-color: rgb(255 250 235 / 0.75);
}

.disabled\\:border-warning-50\\/80:disabled{
  border-color: rgb(255 250 235 / 0.8);
}

.disabled\\:border-warning-50\\/85:disabled{
  border-color: rgb(255 250 235 / 0.85);
}

.disabled\\:border-warning-50\\/90:disabled{
  border-color: rgb(255 250 235 / 0.9);
}

.disabled\\:border-warning-50\\/95:disabled{
  border-color: rgb(255 250 235 / 0.95);
}

.disabled\\:border-warning-500:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(247 144 9 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-500\\/0:disabled{
  border-color: rgb(247 144 9 / 0);
}

.disabled\\:border-warning-500\\/10:disabled{
  border-color: rgb(247 144 9 / 0.1);
}

.disabled\\:border-warning-500\\/100:disabled{
  border-color: rgb(247 144 9 / 1);
}

.disabled\\:border-warning-500\\/15:disabled{
  border-color: rgb(247 144 9 / 0.15);
}

.disabled\\:border-warning-500\\/20:disabled{
  border-color: rgb(247 144 9 / 0.2);
}

.disabled\\:border-warning-500\\/25:disabled{
  border-color: rgb(247 144 9 / 0.25);
}

.disabled\\:border-warning-500\\/30:disabled{
  border-color: rgb(247 144 9 / 0.3);
}

.disabled\\:border-warning-500\\/35:disabled{
  border-color: rgb(247 144 9 / 0.35);
}

.disabled\\:border-warning-500\\/40:disabled{
  border-color: rgb(247 144 9 / 0.4);
}

.disabled\\:border-warning-500\\/45:disabled{
  border-color: rgb(247 144 9 / 0.45);
}

.disabled\\:border-warning-500\\/5:disabled{
  border-color: rgb(247 144 9 / 0.05);
}

.disabled\\:border-warning-500\\/50:disabled{
  border-color: rgb(247 144 9 / 0.5);
}

.disabled\\:border-warning-500\\/55:disabled{
  border-color: rgb(247 144 9 / 0.55);
}

.disabled\\:border-warning-500\\/60:disabled{
  border-color: rgb(247 144 9 / 0.6);
}

.disabled\\:border-warning-500\\/65:disabled{
  border-color: rgb(247 144 9 / 0.65);
}

.disabled\\:border-warning-500\\/70:disabled{
  border-color: rgb(247 144 9 / 0.7);
}

.disabled\\:border-warning-500\\/75:disabled{
  border-color: rgb(247 144 9 / 0.75);
}

.disabled\\:border-warning-500\\/80:disabled{
  border-color: rgb(247 144 9 / 0.8);
}

.disabled\\:border-warning-500\\/85:disabled{
  border-color: rgb(247 144 9 / 0.85);
}

.disabled\\:border-warning-500\\/90:disabled{
  border-color: rgb(247 144 9 / 0.9);
}

.disabled\\:border-warning-500\\/95:disabled{
  border-color: rgb(247 144 9 / 0.95);
}

.disabled\\:border-warning-600:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(220 104 3 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-600\\/0:disabled{
  border-color: rgb(220 104 3 / 0);
}

.disabled\\:border-warning-600\\/10:disabled{
  border-color: rgb(220 104 3 / 0.1);
}

.disabled\\:border-warning-600\\/100:disabled{
  border-color: rgb(220 104 3 / 1);
}

.disabled\\:border-warning-600\\/15:disabled{
  border-color: rgb(220 104 3 / 0.15);
}

.disabled\\:border-warning-600\\/20:disabled{
  border-color: rgb(220 104 3 / 0.2);
}

.disabled\\:border-warning-600\\/25:disabled{
  border-color: rgb(220 104 3 / 0.25);
}

.disabled\\:border-warning-600\\/30:disabled{
  border-color: rgb(220 104 3 / 0.3);
}

.disabled\\:border-warning-600\\/35:disabled{
  border-color: rgb(220 104 3 / 0.35);
}

.disabled\\:border-warning-600\\/40:disabled{
  border-color: rgb(220 104 3 / 0.4);
}

.disabled\\:border-warning-600\\/45:disabled{
  border-color: rgb(220 104 3 / 0.45);
}

.disabled\\:border-warning-600\\/5:disabled{
  border-color: rgb(220 104 3 / 0.05);
}

.disabled\\:border-warning-600\\/50:disabled{
  border-color: rgb(220 104 3 / 0.5);
}

.disabled\\:border-warning-600\\/55:disabled{
  border-color: rgb(220 104 3 / 0.55);
}

.disabled\\:border-warning-600\\/60:disabled{
  border-color: rgb(220 104 3 / 0.6);
}

.disabled\\:border-warning-600\\/65:disabled{
  border-color: rgb(220 104 3 / 0.65);
}

.disabled\\:border-warning-600\\/70:disabled{
  border-color: rgb(220 104 3 / 0.7);
}

.disabled\\:border-warning-600\\/75:disabled{
  border-color: rgb(220 104 3 / 0.75);
}

.disabled\\:border-warning-600\\/80:disabled{
  border-color: rgb(220 104 3 / 0.8);
}

.disabled\\:border-warning-600\\/85:disabled{
  border-color: rgb(220 104 3 / 0.85);
}

.disabled\\:border-warning-600\\/90:disabled{
  border-color: rgb(220 104 3 / 0.9);
}

.disabled\\:border-warning-600\\/95:disabled{
  border-color: rgb(220 104 3 / 0.95);
}

.disabled\\:border-warning-700:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(181 71 8 / var(--tw-border-opacity, 1));
}

.disabled\\:border-warning-700\\/0:disabled{
  border-color: rgb(181 71 8 / 0);
}

.disabled\\:border-warning-700\\/10:disabled{
  border-color: rgb(181 71 8 / 0.1);
}

.disabled\\:border-warning-700\\/100:disabled{
  border-color: rgb(181 71 8 / 1);
}

.disabled\\:border-warning-700\\/15:disabled{
  border-color: rgb(181 71 8 / 0.15);
}

.disabled\\:border-warning-700\\/20:disabled{
  border-color: rgb(181 71 8 / 0.2);
}

.disabled\\:border-warning-700\\/25:disabled{
  border-color: rgb(181 71 8 / 0.25);
}

.disabled\\:border-warning-700\\/30:disabled{
  border-color: rgb(181 71 8 / 0.3);
}

.disabled\\:border-warning-700\\/35:disabled{
  border-color: rgb(181 71 8 / 0.35);
}

.disabled\\:border-warning-700\\/40:disabled{
  border-color: rgb(181 71 8 / 0.4);
}

.disabled\\:border-warning-700\\/45:disabled{
  border-color: rgb(181 71 8 / 0.45);
}

.disabled\\:border-warning-700\\/5:disabled{
  border-color: rgb(181 71 8 / 0.05);
}

.disabled\\:border-warning-700\\/50:disabled{
  border-color: rgb(181 71 8 / 0.5);
}

.disabled\\:border-warning-700\\/55:disabled{
  border-color: rgb(181 71 8 / 0.55);
}

.disabled\\:border-warning-700\\/60:disabled{
  border-color: rgb(181 71 8 / 0.6);
}

.disabled\\:border-warning-700\\/65:disabled{
  border-color: rgb(181 71 8 / 0.65);
}

.disabled\\:border-warning-700\\/70:disabled{
  border-color: rgb(181 71 8 / 0.7);
}

.disabled\\:border-warning-700\\/75:disabled{
  border-color: rgb(181 71 8 / 0.75);
}

.disabled\\:border-warning-700\\/80:disabled{
  border-color: rgb(181 71 8 / 0.8);
}

.disabled\\:border-warning-700\\/85:disabled{
  border-color: rgb(181 71 8 / 0.85);
}

.disabled\\:border-warning-700\\/90:disabled{
  border-color: rgb(181 71 8 / 0.9);
}

.disabled\\:border-warning-700\\/95:disabled{
  border-color: rgb(181 71 8 / 0.95);
}

.disabled\\:\\!bg-primary-100:disabled{
  background-color: var(--color-primary-100, #E0F2FE) !important;
}

.disabled\\:\\!bg-primary-700:disabled{
  background-color: var(--color-primary-700, #026AA2) !important;
}

.disabled\\:bg-danger-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(254 228 226 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-100\\/0:disabled{
  background-color: rgb(254 228 226 / 0);
}

.disabled\\:bg-danger-100\\/10:disabled{
  background-color: rgb(254 228 226 / 0.1);
}

.disabled\\:bg-danger-100\\/100:disabled{
  background-color: rgb(254 228 226 / 1);
}

.disabled\\:bg-danger-100\\/15:disabled{
  background-color: rgb(254 228 226 / 0.15);
}

.disabled\\:bg-danger-100\\/20:disabled{
  background-color: rgb(254 228 226 / 0.2);
}

.disabled\\:bg-danger-100\\/25:disabled{
  background-color: rgb(254 228 226 / 0.25);
}

.disabled\\:bg-danger-100\\/30:disabled{
  background-color: rgb(254 228 226 / 0.3);
}

.disabled\\:bg-danger-100\\/35:disabled{
  background-color: rgb(254 228 226 / 0.35);
}

.disabled\\:bg-danger-100\\/40:disabled{
  background-color: rgb(254 228 226 / 0.4);
}

.disabled\\:bg-danger-100\\/45:disabled{
  background-color: rgb(254 228 226 / 0.45);
}

.disabled\\:bg-danger-100\\/5:disabled{
  background-color: rgb(254 228 226 / 0.05);
}

.disabled\\:bg-danger-100\\/50:disabled{
  background-color: rgb(254 228 226 / 0.5);
}

.disabled\\:bg-danger-100\\/55:disabled{
  background-color: rgb(254 228 226 / 0.55);
}

.disabled\\:bg-danger-100\\/60:disabled{
  background-color: rgb(254 228 226 / 0.6);
}

.disabled\\:bg-danger-100\\/65:disabled{
  background-color: rgb(254 228 226 / 0.65);
}

.disabled\\:bg-danger-100\\/70:disabled{
  background-color: rgb(254 228 226 / 0.7);
}

.disabled\\:bg-danger-100\\/75:disabled{
  background-color: rgb(254 228 226 / 0.75);
}

.disabled\\:bg-danger-100\\/80:disabled{
  background-color: rgb(254 228 226 / 0.8);
}

.disabled\\:bg-danger-100\\/85:disabled{
  background-color: rgb(254 228 226 / 0.85);
}

.disabled\\:bg-danger-100\\/90:disabled{
  background-color: rgb(254 228 226 / 0.9);
}

.disabled\\:bg-danger-100\\/95:disabled{
  background-color: rgb(254 228 226 / 0.95);
}

.disabled\\:bg-danger-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 202 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-200\\/0:disabled{
  background-color: rgb(254 205 202 / 0);
}

.disabled\\:bg-danger-200\\/10:disabled{
  background-color: rgb(254 205 202 / 0.1);
}

.disabled\\:bg-danger-200\\/100:disabled{
  background-color: rgb(254 205 202 / 1);
}

.disabled\\:bg-danger-200\\/15:disabled{
  background-color: rgb(254 205 202 / 0.15);
}

.disabled\\:bg-danger-200\\/20:disabled{
  background-color: rgb(254 205 202 / 0.2);
}

.disabled\\:bg-danger-200\\/25:disabled{
  background-color: rgb(254 205 202 / 0.25);
}

.disabled\\:bg-danger-200\\/30:disabled{
  background-color: rgb(254 205 202 / 0.3);
}

.disabled\\:bg-danger-200\\/35:disabled{
  background-color: rgb(254 205 202 / 0.35);
}

.disabled\\:bg-danger-200\\/40:disabled{
  background-color: rgb(254 205 202 / 0.4);
}

.disabled\\:bg-danger-200\\/45:disabled{
  background-color: rgb(254 205 202 / 0.45);
}

.disabled\\:bg-danger-200\\/5:disabled{
  background-color: rgb(254 205 202 / 0.05);
}

.disabled\\:bg-danger-200\\/50:disabled{
  background-color: rgb(254 205 202 / 0.5);
}

.disabled\\:bg-danger-200\\/55:disabled{
  background-color: rgb(254 205 202 / 0.55);
}

.disabled\\:bg-danger-200\\/60:disabled{
  background-color: rgb(254 205 202 / 0.6);
}

.disabled\\:bg-danger-200\\/65:disabled{
  background-color: rgb(254 205 202 / 0.65);
}

.disabled\\:bg-danger-200\\/70:disabled{
  background-color: rgb(254 205 202 / 0.7);
}

.disabled\\:bg-danger-200\\/75:disabled{
  background-color: rgb(254 205 202 / 0.75);
}

.disabled\\:bg-danger-200\\/80:disabled{
  background-color: rgb(254 205 202 / 0.8);
}

.disabled\\:bg-danger-200\\/85:disabled{
  background-color: rgb(254 205 202 / 0.85);
}

.disabled\\:bg-danger-200\\/90:disabled{
  background-color: rgb(254 205 202 / 0.9);
}

.disabled\\:bg-danger-200\\/95:disabled{
  background-color: rgb(254 205 202 / 0.95);
}

.disabled\\:bg-danger-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 250 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-25\\/0:disabled{
  background-color: rgb(255 251 250 / 0);
}

.disabled\\:bg-danger-25\\/10:disabled{
  background-color: rgb(255 251 250 / 0.1);
}

.disabled\\:bg-danger-25\\/100:disabled{
  background-color: rgb(255 251 250 / 1);
}

.disabled\\:bg-danger-25\\/15:disabled{
  background-color: rgb(255 251 250 / 0.15);
}

.disabled\\:bg-danger-25\\/20:disabled{
  background-color: rgb(255 251 250 / 0.2);
}

.disabled\\:bg-danger-25\\/25:disabled{
  background-color: rgb(255 251 250 / 0.25);
}

.disabled\\:bg-danger-25\\/30:disabled{
  background-color: rgb(255 251 250 / 0.3);
}

.disabled\\:bg-danger-25\\/35:disabled{
  background-color: rgb(255 251 250 / 0.35);
}

.disabled\\:bg-danger-25\\/40:disabled{
  background-color: rgb(255 251 250 / 0.4);
}

.disabled\\:bg-danger-25\\/45:disabled{
  background-color: rgb(255 251 250 / 0.45);
}

.disabled\\:bg-danger-25\\/5:disabled{
  background-color: rgb(255 251 250 / 0.05);
}

.disabled\\:bg-danger-25\\/50:disabled{
  background-color: rgb(255 251 250 / 0.5);
}

.disabled\\:bg-danger-25\\/55:disabled{
  background-color: rgb(255 251 250 / 0.55);
}

.disabled\\:bg-danger-25\\/60:disabled{
  background-color: rgb(255 251 250 / 0.6);
}

.disabled\\:bg-danger-25\\/65:disabled{
  background-color: rgb(255 251 250 / 0.65);
}

.disabled\\:bg-danger-25\\/70:disabled{
  background-color: rgb(255 251 250 / 0.7);
}

.disabled\\:bg-danger-25\\/75:disabled{
  background-color: rgb(255 251 250 / 0.75);
}

.disabled\\:bg-danger-25\\/80:disabled{
  background-color: rgb(255 251 250 / 0.8);
}

.disabled\\:bg-danger-25\\/85:disabled{
  background-color: rgb(255 251 250 / 0.85);
}

.disabled\\:bg-danger-25\\/90:disabled{
  background-color: rgb(255 251 250 / 0.9);
}

.disabled\\:bg-danger-25\\/95:disabled{
  background-color: rgb(255 251 250 / 0.95);
}

.disabled\\:bg-danger-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 112 102 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-400\\/0:disabled{
  background-color: rgb(249 112 102 / 0);
}

.disabled\\:bg-danger-400\\/10:disabled{
  background-color: rgb(249 112 102 / 0.1);
}

.disabled\\:bg-danger-400\\/100:disabled{
  background-color: rgb(249 112 102 / 1);
}

.disabled\\:bg-danger-400\\/15:disabled{
  background-color: rgb(249 112 102 / 0.15);
}

.disabled\\:bg-danger-400\\/20:disabled{
  background-color: rgb(249 112 102 / 0.2);
}

.disabled\\:bg-danger-400\\/25:disabled{
  background-color: rgb(249 112 102 / 0.25);
}

.disabled\\:bg-danger-400\\/30:disabled{
  background-color: rgb(249 112 102 / 0.3);
}

.disabled\\:bg-danger-400\\/35:disabled{
  background-color: rgb(249 112 102 / 0.35);
}

.disabled\\:bg-danger-400\\/40:disabled{
  background-color: rgb(249 112 102 / 0.4);
}

.disabled\\:bg-danger-400\\/45:disabled{
  background-color: rgb(249 112 102 / 0.45);
}

.disabled\\:bg-danger-400\\/5:disabled{
  background-color: rgb(249 112 102 / 0.05);
}

.disabled\\:bg-danger-400\\/50:disabled{
  background-color: rgb(249 112 102 / 0.5);
}

.disabled\\:bg-danger-400\\/55:disabled{
  background-color: rgb(249 112 102 / 0.55);
}

.disabled\\:bg-danger-400\\/60:disabled{
  background-color: rgb(249 112 102 / 0.6);
}

.disabled\\:bg-danger-400\\/65:disabled{
  background-color: rgb(249 112 102 / 0.65);
}

.disabled\\:bg-danger-400\\/70:disabled{
  background-color: rgb(249 112 102 / 0.7);
}

.disabled\\:bg-danger-400\\/75:disabled{
  background-color: rgb(249 112 102 / 0.75);
}

.disabled\\:bg-danger-400\\/80:disabled{
  background-color: rgb(249 112 102 / 0.8);
}

.disabled\\:bg-danger-400\\/85:disabled{
  background-color: rgb(249 112 102 / 0.85);
}

.disabled\\:bg-danger-400\\/90:disabled{
  background-color: rgb(249 112 102 / 0.9);
}

.disabled\\:bg-danger-400\\/95:disabled{
  background-color: rgb(249 112 102 / 0.95);
}

.disabled\\:bg-danger-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-50\\/0:disabled{
  background-color: rgb(254 243 242 / 0);
}

.disabled\\:bg-danger-50\\/10:disabled{
  background-color: rgb(254 243 242 / 0.1);
}

.disabled\\:bg-danger-50\\/100:disabled{
  background-color: rgb(254 243 242 / 1);
}

.disabled\\:bg-danger-50\\/15:disabled{
  background-color: rgb(254 243 242 / 0.15);
}

.disabled\\:bg-danger-50\\/20:disabled{
  background-color: rgb(254 243 242 / 0.2);
}

.disabled\\:bg-danger-50\\/25:disabled{
  background-color: rgb(254 243 242 / 0.25);
}

.disabled\\:bg-danger-50\\/30:disabled{
  background-color: rgb(254 243 242 / 0.3);
}

.disabled\\:bg-danger-50\\/35:disabled{
  background-color: rgb(254 243 242 / 0.35);
}

.disabled\\:bg-danger-50\\/40:disabled{
  background-color: rgb(254 243 242 / 0.4);
}

.disabled\\:bg-danger-50\\/45:disabled{
  background-color: rgb(254 243 242 / 0.45);
}

.disabled\\:bg-danger-50\\/5:disabled{
  background-color: rgb(254 243 242 / 0.05);
}

.disabled\\:bg-danger-50\\/50:disabled{
  background-color: rgb(254 243 242 / 0.5);
}

.disabled\\:bg-danger-50\\/55:disabled{
  background-color: rgb(254 243 242 / 0.55);
}

.disabled\\:bg-danger-50\\/60:disabled{
  background-color: rgb(254 243 242 / 0.6);
}

.disabled\\:bg-danger-50\\/65:disabled{
  background-color: rgb(254 243 242 / 0.65);
}

.disabled\\:bg-danger-50\\/70:disabled{
  background-color: rgb(254 243 242 / 0.7);
}

.disabled\\:bg-danger-50\\/75:disabled{
  background-color: rgb(254 243 242 / 0.75);
}

.disabled\\:bg-danger-50\\/80:disabled{
  background-color: rgb(254 243 242 / 0.8);
}

.disabled\\:bg-danger-50\\/85:disabled{
  background-color: rgb(254 243 242 / 0.85);
}

.disabled\\:bg-danger-50\\/90:disabled{
  background-color: rgb(254 243 242 / 0.9);
}

.disabled\\:bg-danger-50\\/95:disabled{
  background-color: rgb(254 243 242 / 0.95);
}

.disabled\\:bg-danger-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-500\\/0:disabled{
  background-color: rgb(240 68 56 / 0);
}

.disabled\\:bg-danger-500\\/10:disabled{
  background-color: rgb(240 68 56 / 0.1);
}

.disabled\\:bg-danger-500\\/100:disabled{
  background-color: rgb(240 68 56 / 1);
}

.disabled\\:bg-danger-500\\/15:disabled{
  background-color: rgb(240 68 56 / 0.15);
}

.disabled\\:bg-danger-500\\/20:disabled{
  background-color: rgb(240 68 56 / 0.2);
}

.disabled\\:bg-danger-500\\/25:disabled{
  background-color: rgb(240 68 56 / 0.25);
}

.disabled\\:bg-danger-500\\/30:disabled{
  background-color: rgb(240 68 56 / 0.3);
}

.disabled\\:bg-danger-500\\/35:disabled{
  background-color: rgb(240 68 56 / 0.35);
}

.disabled\\:bg-danger-500\\/40:disabled{
  background-color: rgb(240 68 56 / 0.4);
}

.disabled\\:bg-danger-500\\/45:disabled{
  background-color: rgb(240 68 56 / 0.45);
}

.disabled\\:bg-danger-500\\/5:disabled{
  background-color: rgb(240 68 56 / 0.05);
}

.disabled\\:bg-danger-500\\/50:disabled{
  background-color: rgb(240 68 56 / 0.5);
}

.disabled\\:bg-danger-500\\/55:disabled{
  background-color: rgb(240 68 56 / 0.55);
}

.disabled\\:bg-danger-500\\/60:disabled{
  background-color: rgb(240 68 56 / 0.6);
}

.disabled\\:bg-danger-500\\/65:disabled{
  background-color: rgb(240 68 56 / 0.65);
}

.disabled\\:bg-danger-500\\/70:disabled{
  background-color: rgb(240 68 56 / 0.7);
}

.disabled\\:bg-danger-500\\/75:disabled{
  background-color: rgb(240 68 56 / 0.75);
}

.disabled\\:bg-danger-500\\/80:disabled{
  background-color: rgb(240 68 56 / 0.8);
}

.disabled\\:bg-danger-500\\/85:disabled{
  background-color: rgb(240 68 56 / 0.85);
}

.disabled\\:bg-danger-500\\/90:disabled{
  background-color: rgb(240 68 56 / 0.9);
}

.disabled\\:bg-danger-500\\/95:disabled{
  background-color: rgb(240 68 56 / 0.95);
}

.disabled\\:bg-danger-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(217 45 32 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-600\\/0:disabled{
  background-color: rgb(217 45 32 / 0);
}

.disabled\\:bg-danger-600\\/10:disabled{
  background-color: rgb(217 45 32 / 0.1);
}

.disabled\\:bg-danger-600\\/100:disabled{
  background-color: rgb(217 45 32 / 1);
}

.disabled\\:bg-danger-600\\/15:disabled{
  background-color: rgb(217 45 32 / 0.15);
}

.disabled\\:bg-danger-600\\/20:disabled{
  background-color: rgb(217 45 32 / 0.2);
}

.disabled\\:bg-danger-600\\/25:disabled{
  background-color: rgb(217 45 32 / 0.25);
}

.disabled\\:bg-danger-600\\/30:disabled{
  background-color: rgb(217 45 32 / 0.3);
}

.disabled\\:bg-danger-600\\/35:disabled{
  background-color: rgb(217 45 32 / 0.35);
}

.disabled\\:bg-danger-600\\/40:disabled{
  background-color: rgb(217 45 32 / 0.4);
}

.disabled\\:bg-danger-600\\/45:disabled{
  background-color: rgb(217 45 32 / 0.45);
}

.disabled\\:bg-danger-600\\/5:disabled{
  background-color: rgb(217 45 32 / 0.05);
}

.disabled\\:bg-danger-600\\/50:disabled{
  background-color: rgb(217 45 32 / 0.5);
}

.disabled\\:bg-danger-600\\/55:disabled{
  background-color: rgb(217 45 32 / 0.55);
}

.disabled\\:bg-danger-600\\/60:disabled{
  background-color: rgb(217 45 32 / 0.6);
}

.disabled\\:bg-danger-600\\/65:disabled{
  background-color: rgb(217 45 32 / 0.65);
}

.disabled\\:bg-danger-600\\/70:disabled{
  background-color: rgb(217 45 32 / 0.7);
}

.disabled\\:bg-danger-600\\/75:disabled{
  background-color: rgb(217 45 32 / 0.75);
}

.disabled\\:bg-danger-600\\/80:disabled{
  background-color: rgb(217 45 32 / 0.8);
}

.disabled\\:bg-danger-600\\/85:disabled{
  background-color: rgb(217 45 32 / 0.85);
}

.disabled\\:bg-danger-600\\/90:disabled{
  background-color: rgb(217 45 32 / 0.9);
}

.disabled\\:bg-danger-600\\/95:disabled{
  background-color: rgb(217 45 32 / 0.95);
}

.disabled\\:bg-danger-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(180 35 24 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-danger-700\\/0:disabled{
  background-color: rgb(180 35 24 / 0);
}

.disabled\\:bg-danger-700\\/10:disabled{
  background-color: rgb(180 35 24 / 0.1);
}

.disabled\\:bg-danger-700\\/100:disabled{
  background-color: rgb(180 35 24 / 1);
}

.disabled\\:bg-danger-700\\/15:disabled{
  background-color: rgb(180 35 24 / 0.15);
}

.disabled\\:bg-danger-700\\/20:disabled{
  background-color: rgb(180 35 24 / 0.2);
}

.disabled\\:bg-danger-700\\/25:disabled{
  background-color: rgb(180 35 24 / 0.25);
}

.disabled\\:bg-danger-700\\/30:disabled{
  background-color: rgb(180 35 24 / 0.3);
}

.disabled\\:bg-danger-700\\/35:disabled{
  background-color: rgb(180 35 24 / 0.35);
}

.disabled\\:bg-danger-700\\/40:disabled{
  background-color: rgb(180 35 24 / 0.4);
}

.disabled\\:bg-danger-700\\/45:disabled{
  background-color: rgb(180 35 24 / 0.45);
}

.disabled\\:bg-danger-700\\/5:disabled{
  background-color: rgb(180 35 24 / 0.05);
}

.disabled\\:bg-danger-700\\/50:disabled{
  background-color: rgb(180 35 24 / 0.5);
}

.disabled\\:bg-danger-700\\/55:disabled{
  background-color: rgb(180 35 24 / 0.55);
}

.disabled\\:bg-danger-700\\/60:disabled{
  background-color: rgb(180 35 24 / 0.6);
}

.disabled\\:bg-danger-700\\/65:disabled{
  background-color: rgb(180 35 24 / 0.65);
}

.disabled\\:bg-danger-700\\/70:disabled{
  background-color: rgb(180 35 24 / 0.7);
}

.disabled\\:bg-danger-700\\/75:disabled{
  background-color: rgb(180 35 24 / 0.75);
}

.disabled\\:bg-danger-700\\/80:disabled{
  background-color: rgb(180 35 24 / 0.8);
}

.disabled\\:bg-danger-700\\/85:disabled{
  background-color: rgb(180 35 24 / 0.85);
}

.disabled\\:bg-danger-700\\/90:disabled{
  background-color: rgb(180 35 24 / 0.9);
}

.disabled\\:bg-danger-700\\/95:disabled{
  background-color: rgb(180 35 24 / 0.95);
}

.disabled\\:bg-moss-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(230 244 215 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-100\\/0:disabled{
  background-color: rgb(230 244 215 / 0);
}

.disabled\\:bg-moss-100\\/10:disabled{
  background-color: rgb(230 244 215 / 0.1);
}

.disabled\\:bg-moss-100\\/100:disabled{
  background-color: rgb(230 244 215 / 1);
}

.disabled\\:bg-moss-100\\/15:disabled{
  background-color: rgb(230 244 215 / 0.15);
}

.disabled\\:bg-moss-100\\/20:disabled{
  background-color: rgb(230 244 215 / 0.2);
}

.disabled\\:bg-moss-100\\/25:disabled{
  background-color: rgb(230 244 215 / 0.25);
}

.disabled\\:bg-moss-100\\/30:disabled{
  background-color: rgb(230 244 215 / 0.3);
}

.disabled\\:bg-moss-100\\/35:disabled{
  background-color: rgb(230 244 215 / 0.35);
}

.disabled\\:bg-moss-100\\/40:disabled{
  background-color: rgb(230 244 215 / 0.4);
}

.disabled\\:bg-moss-100\\/45:disabled{
  background-color: rgb(230 244 215 / 0.45);
}

.disabled\\:bg-moss-100\\/5:disabled{
  background-color: rgb(230 244 215 / 0.05);
}

.disabled\\:bg-moss-100\\/50:disabled{
  background-color: rgb(230 244 215 / 0.5);
}

.disabled\\:bg-moss-100\\/55:disabled{
  background-color: rgb(230 244 215 / 0.55);
}

.disabled\\:bg-moss-100\\/60:disabled{
  background-color: rgb(230 244 215 / 0.6);
}

.disabled\\:bg-moss-100\\/65:disabled{
  background-color: rgb(230 244 215 / 0.65);
}

.disabled\\:bg-moss-100\\/70:disabled{
  background-color: rgb(230 244 215 / 0.7);
}

.disabled\\:bg-moss-100\\/75:disabled{
  background-color: rgb(230 244 215 / 0.75);
}

.disabled\\:bg-moss-100\\/80:disabled{
  background-color: rgb(230 244 215 / 0.8);
}

.disabled\\:bg-moss-100\\/85:disabled{
  background-color: rgb(230 244 215 / 0.85);
}

.disabled\\:bg-moss-100\\/90:disabled{
  background-color: rgb(230 244 215 / 0.9);
}

.disabled\\:bg-moss-100\\/95:disabled{
  background-color: rgb(230 244 215 / 0.95);
}

.disabled\\:bg-moss-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(206 234 176 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-200\\/0:disabled{
  background-color: rgb(206 234 176 / 0);
}

.disabled\\:bg-moss-200\\/10:disabled{
  background-color: rgb(206 234 176 / 0.1);
}

.disabled\\:bg-moss-200\\/100:disabled{
  background-color: rgb(206 234 176 / 1);
}

.disabled\\:bg-moss-200\\/15:disabled{
  background-color: rgb(206 234 176 / 0.15);
}

.disabled\\:bg-moss-200\\/20:disabled{
  background-color: rgb(206 234 176 / 0.2);
}

.disabled\\:bg-moss-200\\/25:disabled{
  background-color: rgb(206 234 176 / 0.25);
}

.disabled\\:bg-moss-200\\/30:disabled{
  background-color: rgb(206 234 176 / 0.3);
}

.disabled\\:bg-moss-200\\/35:disabled{
  background-color: rgb(206 234 176 / 0.35);
}

.disabled\\:bg-moss-200\\/40:disabled{
  background-color: rgb(206 234 176 / 0.4);
}

.disabled\\:bg-moss-200\\/45:disabled{
  background-color: rgb(206 234 176 / 0.45);
}

.disabled\\:bg-moss-200\\/5:disabled{
  background-color: rgb(206 234 176 / 0.05);
}

.disabled\\:bg-moss-200\\/50:disabled{
  background-color: rgb(206 234 176 / 0.5);
}

.disabled\\:bg-moss-200\\/55:disabled{
  background-color: rgb(206 234 176 / 0.55);
}

.disabled\\:bg-moss-200\\/60:disabled{
  background-color: rgb(206 234 176 / 0.6);
}

.disabled\\:bg-moss-200\\/65:disabled{
  background-color: rgb(206 234 176 / 0.65);
}

.disabled\\:bg-moss-200\\/70:disabled{
  background-color: rgb(206 234 176 / 0.7);
}

.disabled\\:bg-moss-200\\/75:disabled{
  background-color: rgb(206 234 176 / 0.75);
}

.disabled\\:bg-moss-200\\/80:disabled{
  background-color: rgb(206 234 176 / 0.8);
}

.disabled\\:bg-moss-200\\/85:disabled{
  background-color: rgb(206 234 176 / 0.85);
}

.disabled\\:bg-moss-200\\/90:disabled{
  background-color: rgb(206 234 176 / 0.9);
}

.disabled\\:bg-moss-200\\/95:disabled{
  background-color: rgb(206 234 176 / 0.95);
}

.disabled\\:bg-moss-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(250 253 247 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-25\\/0:disabled{
  background-color: rgb(250 253 247 / 0);
}

.disabled\\:bg-moss-25\\/10:disabled{
  background-color: rgb(250 253 247 / 0.1);
}

.disabled\\:bg-moss-25\\/100:disabled{
  background-color: rgb(250 253 247 / 1);
}

.disabled\\:bg-moss-25\\/15:disabled{
  background-color: rgb(250 253 247 / 0.15);
}

.disabled\\:bg-moss-25\\/20:disabled{
  background-color: rgb(250 253 247 / 0.2);
}

.disabled\\:bg-moss-25\\/25:disabled{
  background-color: rgb(250 253 247 / 0.25);
}

.disabled\\:bg-moss-25\\/30:disabled{
  background-color: rgb(250 253 247 / 0.3);
}

.disabled\\:bg-moss-25\\/35:disabled{
  background-color: rgb(250 253 247 / 0.35);
}

.disabled\\:bg-moss-25\\/40:disabled{
  background-color: rgb(250 253 247 / 0.4);
}

.disabled\\:bg-moss-25\\/45:disabled{
  background-color: rgb(250 253 247 / 0.45);
}

.disabled\\:bg-moss-25\\/5:disabled{
  background-color: rgb(250 253 247 / 0.05);
}

.disabled\\:bg-moss-25\\/50:disabled{
  background-color: rgb(250 253 247 / 0.5);
}

.disabled\\:bg-moss-25\\/55:disabled{
  background-color: rgb(250 253 247 / 0.55);
}

.disabled\\:bg-moss-25\\/60:disabled{
  background-color: rgb(250 253 247 / 0.6);
}

.disabled\\:bg-moss-25\\/65:disabled{
  background-color: rgb(250 253 247 / 0.65);
}

.disabled\\:bg-moss-25\\/70:disabled{
  background-color: rgb(250 253 247 / 0.7);
}

.disabled\\:bg-moss-25\\/75:disabled{
  background-color: rgb(250 253 247 / 0.75);
}

.disabled\\:bg-moss-25\\/80:disabled{
  background-color: rgb(250 253 247 / 0.8);
}

.disabled\\:bg-moss-25\\/85:disabled{
  background-color: rgb(250 253 247 / 0.85);
}

.disabled\\:bg-moss-25\\/90:disabled{
  background-color: rgb(250 253 247 / 0.9);
}

.disabled\\:bg-moss-25\\/95:disabled{
  background-color: rgb(250 253 247 / 0.95);
}

.disabled\\:bg-moss-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(134 203 60 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-400\\/0:disabled{
  background-color: rgb(134 203 60 / 0);
}

.disabled\\:bg-moss-400\\/10:disabled{
  background-color: rgb(134 203 60 / 0.1);
}

.disabled\\:bg-moss-400\\/100:disabled{
  background-color: rgb(134 203 60 / 1);
}

.disabled\\:bg-moss-400\\/15:disabled{
  background-color: rgb(134 203 60 / 0.15);
}

.disabled\\:bg-moss-400\\/20:disabled{
  background-color: rgb(134 203 60 / 0.2);
}

.disabled\\:bg-moss-400\\/25:disabled{
  background-color: rgb(134 203 60 / 0.25);
}

.disabled\\:bg-moss-400\\/30:disabled{
  background-color: rgb(134 203 60 / 0.3);
}

.disabled\\:bg-moss-400\\/35:disabled{
  background-color: rgb(134 203 60 / 0.35);
}

.disabled\\:bg-moss-400\\/40:disabled{
  background-color: rgb(134 203 60 / 0.4);
}

.disabled\\:bg-moss-400\\/45:disabled{
  background-color: rgb(134 203 60 / 0.45);
}

.disabled\\:bg-moss-400\\/5:disabled{
  background-color: rgb(134 203 60 / 0.05);
}

.disabled\\:bg-moss-400\\/50:disabled{
  background-color: rgb(134 203 60 / 0.5);
}

.disabled\\:bg-moss-400\\/55:disabled{
  background-color: rgb(134 203 60 / 0.55);
}

.disabled\\:bg-moss-400\\/60:disabled{
  background-color: rgb(134 203 60 / 0.6);
}

.disabled\\:bg-moss-400\\/65:disabled{
  background-color: rgb(134 203 60 / 0.65);
}

.disabled\\:bg-moss-400\\/70:disabled{
  background-color: rgb(134 203 60 / 0.7);
}

.disabled\\:bg-moss-400\\/75:disabled{
  background-color: rgb(134 203 60 / 0.75);
}

.disabled\\:bg-moss-400\\/80:disabled{
  background-color: rgb(134 203 60 / 0.8);
}

.disabled\\:bg-moss-400\\/85:disabled{
  background-color: rgb(134 203 60 / 0.85);
}

.disabled\\:bg-moss-400\\/90:disabled{
  background-color: rgb(134 203 60 / 0.9);
}

.disabled\\:bg-moss-400\\/95:disabled{
  background-color: rgb(134 203 60 / 0.95);
}

.disabled\\:bg-moss-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(245 251 238 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-50\\/0:disabled{
  background-color: rgb(245 251 238 / 0);
}

.disabled\\:bg-moss-50\\/10:disabled{
  background-color: rgb(245 251 238 / 0.1);
}

.disabled\\:bg-moss-50\\/100:disabled{
  background-color: rgb(245 251 238 / 1);
}

.disabled\\:bg-moss-50\\/15:disabled{
  background-color: rgb(245 251 238 / 0.15);
}

.disabled\\:bg-moss-50\\/20:disabled{
  background-color: rgb(245 251 238 / 0.2);
}

.disabled\\:bg-moss-50\\/25:disabled{
  background-color: rgb(245 251 238 / 0.25);
}

.disabled\\:bg-moss-50\\/30:disabled{
  background-color: rgb(245 251 238 / 0.3);
}

.disabled\\:bg-moss-50\\/35:disabled{
  background-color: rgb(245 251 238 / 0.35);
}

.disabled\\:bg-moss-50\\/40:disabled{
  background-color: rgb(245 251 238 / 0.4);
}

.disabled\\:bg-moss-50\\/45:disabled{
  background-color: rgb(245 251 238 / 0.45);
}

.disabled\\:bg-moss-50\\/5:disabled{
  background-color: rgb(245 251 238 / 0.05);
}

.disabled\\:bg-moss-50\\/50:disabled{
  background-color: rgb(245 251 238 / 0.5);
}

.disabled\\:bg-moss-50\\/55:disabled{
  background-color: rgb(245 251 238 / 0.55);
}

.disabled\\:bg-moss-50\\/60:disabled{
  background-color: rgb(245 251 238 / 0.6);
}

.disabled\\:bg-moss-50\\/65:disabled{
  background-color: rgb(245 251 238 / 0.65);
}

.disabled\\:bg-moss-50\\/70:disabled{
  background-color: rgb(245 251 238 / 0.7);
}

.disabled\\:bg-moss-50\\/75:disabled{
  background-color: rgb(245 251 238 / 0.75);
}

.disabled\\:bg-moss-50\\/80:disabled{
  background-color: rgb(245 251 238 / 0.8);
}

.disabled\\:bg-moss-50\\/85:disabled{
  background-color: rgb(245 251 238 / 0.85);
}

.disabled\\:bg-moss-50\\/90:disabled{
  background-color: rgb(245 251 238 / 0.9);
}

.disabled\\:bg-moss-50\\/95:disabled{
  background-color: rgb(245 251 238 / 0.95);
}

.disabled\\:bg-moss-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(102 159 42 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-500\\/0:disabled{
  background-color: rgb(102 159 42 / 0);
}

.disabled\\:bg-moss-500\\/10:disabled{
  background-color: rgb(102 159 42 / 0.1);
}

.disabled\\:bg-moss-500\\/100:disabled{
  background-color: rgb(102 159 42 / 1);
}

.disabled\\:bg-moss-500\\/15:disabled{
  background-color: rgb(102 159 42 / 0.15);
}

.disabled\\:bg-moss-500\\/20:disabled{
  background-color: rgb(102 159 42 / 0.2);
}

.disabled\\:bg-moss-500\\/25:disabled{
  background-color: rgb(102 159 42 / 0.25);
}

.disabled\\:bg-moss-500\\/30:disabled{
  background-color: rgb(102 159 42 / 0.3);
}

.disabled\\:bg-moss-500\\/35:disabled{
  background-color: rgb(102 159 42 / 0.35);
}

.disabled\\:bg-moss-500\\/40:disabled{
  background-color: rgb(102 159 42 / 0.4);
}

.disabled\\:bg-moss-500\\/45:disabled{
  background-color: rgb(102 159 42 / 0.45);
}

.disabled\\:bg-moss-500\\/5:disabled{
  background-color: rgb(102 159 42 / 0.05);
}

.disabled\\:bg-moss-500\\/50:disabled{
  background-color: rgb(102 159 42 / 0.5);
}

.disabled\\:bg-moss-500\\/55:disabled{
  background-color: rgb(102 159 42 / 0.55);
}

.disabled\\:bg-moss-500\\/60:disabled{
  background-color: rgb(102 159 42 / 0.6);
}

.disabled\\:bg-moss-500\\/65:disabled{
  background-color: rgb(102 159 42 / 0.65);
}

.disabled\\:bg-moss-500\\/70:disabled{
  background-color: rgb(102 159 42 / 0.7);
}

.disabled\\:bg-moss-500\\/75:disabled{
  background-color: rgb(102 159 42 / 0.75);
}

.disabled\\:bg-moss-500\\/80:disabled{
  background-color: rgb(102 159 42 / 0.8);
}

.disabled\\:bg-moss-500\\/85:disabled{
  background-color: rgb(102 159 42 / 0.85);
}

.disabled\\:bg-moss-500\\/90:disabled{
  background-color: rgb(102 159 42 / 0.9);
}

.disabled\\:bg-moss-500\\/95:disabled{
  background-color: rgb(102 159 42 / 0.95);
}

.disabled\\:bg-moss-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(79 122 33 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-600\\/0:disabled{
  background-color: rgb(79 122 33 / 0);
}

.disabled\\:bg-moss-600\\/10:disabled{
  background-color: rgb(79 122 33 / 0.1);
}

.disabled\\:bg-moss-600\\/100:disabled{
  background-color: rgb(79 122 33 / 1);
}

.disabled\\:bg-moss-600\\/15:disabled{
  background-color: rgb(79 122 33 / 0.15);
}

.disabled\\:bg-moss-600\\/20:disabled{
  background-color: rgb(79 122 33 / 0.2);
}

.disabled\\:bg-moss-600\\/25:disabled{
  background-color: rgb(79 122 33 / 0.25);
}

.disabled\\:bg-moss-600\\/30:disabled{
  background-color: rgb(79 122 33 / 0.3);
}

.disabled\\:bg-moss-600\\/35:disabled{
  background-color: rgb(79 122 33 / 0.35);
}

.disabled\\:bg-moss-600\\/40:disabled{
  background-color: rgb(79 122 33 / 0.4);
}

.disabled\\:bg-moss-600\\/45:disabled{
  background-color: rgb(79 122 33 / 0.45);
}

.disabled\\:bg-moss-600\\/5:disabled{
  background-color: rgb(79 122 33 / 0.05);
}

.disabled\\:bg-moss-600\\/50:disabled{
  background-color: rgb(79 122 33 / 0.5);
}

.disabled\\:bg-moss-600\\/55:disabled{
  background-color: rgb(79 122 33 / 0.55);
}

.disabled\\:bg-moss-600\\/60:disabled{
  background-color: rgb(79 122 33 / 0.6);
}

.disabled\\:bg-moss-600\\/65:disabled{
  background-color: rgb(79 122 33 / 0.65);
}

.disabled\\:bg-moss-600\\/70:disabled{
  background-color: rgb(79 122 33 / 0.7);
}

.disabled\\:bg-moss-600\\/75:disabled{
  background-color: rgb(79 122 33 / 0.75);
}

.disabled\\:bg-moss-600\\/80:disabled{
  background-color: rgb(79 122 33 / 0.8);
}

.disabled\\:bg-moss-600\\/85:disabled{
  background-color: rgb(79 122 33 / 0.85);
}

.disabled\\:bg-moss-600\\/90:disabled{
  background-color: rgb(79 122 33 / 0.9);
}

.disabled\\:bg-moss-600\\/95:disabled{
  background-color: rgb(79 122 33 / 0.95);
}

.disabled\\:bg-moss-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 26 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-moss-700\\/0:disabled{
  background-color: rgb(63 98 26 / 0);
}

.disabled\\:bg-moss-700\\/10:disabled{
  background-color: rgb(63 98 26 / 0.1);
}

.disabled\\:bg-moss-700\\/100:disabled{
  background-color: rgb(63 98 26 / 1);
}

.disabled\\:bg-moss-700\\/15:disabled{
  background-color: rgb(63 98 26 / 0.15);
}

.disabled\\:bg-moss-700\\/20:disabled{
  background-color: rgb(63 98 26 / 0.2);
}

.disabled\\:bg-moss-700\\/25:disabled{
  background-color: rgb(63 98 26 / 0.25);
}

.disabled\\:bg-moss-700\\/30:disabled{
  background-color: rgb(63 98 26 / 0.3);
}

.disabled\\:bg-moss-700\\/35:disabled{
  background-color: rgb(63 98 26 / 0.35);
}

.disabled\\:bg-moss-700\\/40:disabled{
  background-color: rgb(63 98 26 / 0.4);
}

.disabled\\:bg-moss-700\\/45:disabled{
  background-color: rgb(63 98 26 / 0.45);
}

.disabled\\:bg-moss-700\\/5:disabled{
  background-color: rgb(63 98 26 / 0.05);
}

.disabled\\:bg-moss-700\\/50:disabled{
  background-color: rgb(63 98 26 / 0.5);
}

.disabled\\:bg-moss-700\\/55:disabled{
  background-color: rgb(63 98 26 / 0.55);
}

.disabled\\:bg-moss-700\\/60:disabled{
  background-color: rgb(63 98 26 / 0.6);
}

.disabled\\:bg-moss-700\\/65:disabled{
  background-color: rgb(63 98 26 / 0.65);
}

.disabled\\:bg-moss-700\\/70:disabled{
  background-color: rgb(63 98 26 / 0.7);
}

.disabled\\:bg-moss-700\\/75:disabled{
  background-color: rgb(63 98 26 / 0.75);
}

.disabled\\:bg-moss-700\\/80:disabled{
  background-color: rgb(63 98 26 / 0.8);
}

.disabled\\:bg-moss-700\\/85:disabled{
  background-color: rgb(63 98 26 / 0.85);
}

.disabled\\:bg-moss-700\\/90:disabled{
  background-color: rgb(63 98 26 / 0.9);
}

.disabled\\:bg-moss-700\\/95:disabled{
  background-color: rgb(63 98 26 / 0.95);
}

.disabled\\:bg-neutral-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-100\\/0:disabled{
  background-color: rgb(245 245 245 / 0);
}

.disabled\\:bg-neutral-100\\/10:disabled{
  background-color: rgb(245 245 245 / 0.1);
}

.disabled\\:bg-neutral-100\\/100:disabled{
  background-color: rgb(245 245 245 / 1);
}

.disabled\\:bg-neutral-100\\/15:disabled{
  background-color: rgb(245 245 245 / 0.15);
}

.disabled\\:bg-neutral-100\\/20:disabled{
  background-color: rgb(245 245 245 / 0.2);
}

.disabled\\:bg-neutral-100\\/25:disabled{
  background-color: rgb(245 245 245 / 0.25);
}

.disabled\\:bg-neutral-100\\/30:disabled{
  background-color: rgb(245 245 245 / 0.3);
}

.disabled\\:bg-neutral-100\\/35:disabled{
  background-color: rgb(245 245 245 / 0.35);
}

.disabled\\:bg-neutral-100\\/40:disabled{
  background-color: rgb(245 245 245 / 0.4);
}

.disabled\\:bg-neutral-100\\/45:disabled{
  background-color: rgb(245 245 245 / 0.45);
}

.disabled\\:bg-neutral-100\\/5:disabled{
  background-color: rgb(245 245 245 / 0.05);
}

.disabled\\:bg-neutral-100\\/50:disabled{
  background-color: rgb(245 245 245 / 0.5);
}

.disabled\\:bg-neutral-100\\/55:disabled{
  background-color: rgb(245 245 245 / 0.55);
}

.disabled\\:bg-neutral-100\\/60:disabled{
  background-color: rgb(245 245 245 / 0.6);
}

.disabled\\:bg-neutral-100\\/65:disabled{
  background-color: rgb(245 245 245 / 0.65);
}

.disabled\\:bg-neutral-100\\/70:disabled{
  background-color: rgb(245 245 245 / 0.7);
}

.disabled\\:bg-neutral-100\\/75:disabled{
  background-color: rgb(245 245 245 / 0.75);
}

.disabled\\:bg-neutral-100\\/80:disabled{
  background-color: rgb(245 245 245 / 0.8);
}

.disabled\\:bg-neutral-100\\/85:disabled{
  background-color: rgb(245 245 245 / 0.85);
}

.disabled\\:bg-neutral-100\\/90:disabled{
  background-color: rgb(245 245 245 / 0.9);
}

.disabled\\:bg-neutral-100\\/95:disabled{
  background-color: rgb(245 245 245 / 0.95);
}

.disabled\\:bg-neutral-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-200\\/0:disabled{
  background-color: rgb(233 234 235 / 0);
}

.disabled\\:bg-neutral-200\\/10:disabled{
  background-color: rgb(233 234 235 / 0.1);
}

.disabled\\:bg-neutral-200\\/100:disabled{
  background-color: rgb(233 234 235 / 1);
}

.disabled\\:bg-neutral-200\\/15:disabled{
  background-color: rgb(233 234 235 / 0.15);
}

.disabled\\:bg-neutral-200\\/20:disabled{
  background-color: rgb(233 234 235 / 0.2);
}

.disabled\\:bg-neutral-200\\/25:disabled{
  background-color: rgb(233 234 235 / 0.25);
}

.disabled\\:bg-neutral-200\\/30:disabled{
  background-color: rgb(233 234 235 / 0.3);
}

.disabled\\:bg-neutral-200\\/35:disabled{
  background-color: rgb(233 234 235 / 0.35);
}

.disabled\\:bg-neutral-200\\/40:disabled{
  background-color: rgb(233 234 235 / 0.4);
}

.disabled\\:bg-neutral-200\\/45:disabled{
  background-color: rgb(233 234 235 / 0.45);
}

.disabled\\:bg-neutral-200\\/5:disabled{
  background-color: rgb(233 234 235 / 0.05);
}

.disabled\\:bg-neutral-200\\/50:disabled{
  background-color: rgb(233 234 235 / 0.5);
}

.disabled\\:bg-neutral-200\\/55:disabled{
  background-color: rgb(233 234 235 / 0.55);
}

.disabled\\:bg-neutral-200\\/60:disabled{
  background-color: rgb(233 234 235 / 0.6);
}

.disabled\\:bg-neutral-200\\/65:disabled{
  background-color: rgb(233 234 235 / 0.65);
}

.disabled\\:bg-neutral-200\\/70:disabled{
  background-color: rgb(233 234 235 / 0.7);
}

.disabled\\:bg-neutral-200\\/75:disabled{
  background-color: rgb(233 234 235 / 0.75);
}

.disabled\\:bg-neutral-200\\/80:disabled{
  background-color: rgb(233 234 235 / 0.8);
}

.disabled\\:bg-neutral-200\\/85:disabled{
  background-color: rgb(233 234 235 / 0.85);
}

.disabled\\:bg-neutral-200\\/90:disabled{
  background-color: rgb(233 234 235 / 0.9);
}

.disabled\\:bg-neutral-200\\/95:disabled{
  background-color: rgb(233 234 235 / 0.95);
}

.disabled\\:bg-neutral-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-25\\/0:disabled{
  background-color: rgb(253 253 253 / 0);
}

.disabled\\:bg-neutral-25\\/10:disabled{
  background-color: rgb(253 253 253 / 0.1);
}

.disabled\\:bg-neutral-25\\/100:disabled{
  background-color: rgb(253 253 253 / 1);
}

.disabled\\:bg-neutral-25\\/15:disabled{
  background-color: rgb(253 253 253 / 0.15);
}

.disabled\\:bg-neutral-25\\/20:disabled{
  background-color: rgb(253 253 253 / 0.2);
}

.disabled\\:bg-neutral-25\\/25:disabled{
  background-color: rgb(253 253 253 / 0.25);
}

.disabled\\:bg-neutral-25\\/30:disabled{
  background-color: rgb(253 253 253 / 0.3);
}

.disabled\\:bg-neutral-25\\/35:disabled{
  background-color: rgb(253 253 253 / 0.35);
}

.disabled\\:bg-neutral-25\\/40:disabled{
  background-color: rgb(253 253 253 / 0.4);
}

.disabled\\:bg-neutral-25\\/45:disabled{
  background-color: rgb(253 253 253 / 0.45);
}

.disabled\\:bg-neutral-25\\/5:disabled{
  background-color: rgb(253 253 253 / 0.05);
}

.disabled\\:bg-neutral-25\\/50:disabled{
  background-color: rgb(253 253 253 / 0.5);
}

.disabled\\:bg-neutral-25\\/55:disabled{
  background-color: rgb(253 253 253 / 0.55);
}

.disabled\\:bg-neutral-25\\/60:disabled{
  background-color: rgb(253 253 253 / 0.6);
}

.disabled\\:bg-neutral-25\\/65:disabled{
  background-color: rgb(253 253 253 / 0.65);
}

.disabled\\:bg-neutral-25\\/70:disabled{
  background-color: rgb(253 253 253 / 0.7);
}

.disabled\\:bg-neutral-25\\/75:disabled{
  background-color: rgb(253 253 253 / 0.75);
}

.disabled\\:bg-neutral-25\\/80:disabled{
  background-color: rgb(253 253 253 / 0.8);
}

.disabled\\:bg-neutral-25\\/85:disabled{
  background-color: rgb(253 253 253 / 0.85);
}

.disabled\\:bg-neutral-25\\/90:disabled{
  background-color: rgb(253 253 253 / 0.9);
}

.disabled\\:bg-neutral-25\\/95:disabled{
  background-color: rgb(253 253 253 / 0.95);
}

.disabled\\:bg-neutral-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(164 167 174 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-400\\/0:disabled{
  background-color: rgb(164 167 174 / 0);
}

.disabled\\:bg-neutral-400\\/10:disabled{
  background-color: rgb(164 167 174 / 0.1);
}

.disabled\\:bg-neutral-400\\/100:disabled{
  background-color: rgb(164 167 174 / 1);
}

.disabled\\:bg-neutral-400\\/15:disabled{
  background-color: rgb(164 167 174 / 0.15);
}

.disabled\\:bg-neutral-400\\/20:disabled{
  background-color: rgb(164 167 174 / 0.2);
}

.disabled\\:bg-neutral-400\\/25:disabled{
  background-color: rgb(164 167 174 / 0.25);
}

.disabled\\:bg-neutral-400\\/30:disabled{
  background-color: rgb(164 167 174 / 0.3);
}

.disabled\\:bg-neutral-400\\/35:disabled{
  background-color: rgb(164 167 174 / 0.35);
}

.disabled\\:bg-neutral-400\\/40:disabled{
  background-color: rgb(164 167 174 / 0.4);
}

.disabled\\:bg-neutral-400\\/45:disabled{
  background-color: rgb(164 167 174 / 0.45);
}

.disabled\\:bg-neutral-400\\/5:disabled{
  background-color: rgb(164 167 174 / 0.05);
}

.disabled\\:bg-neutral-400\\/50:disabled{
  background-color: rgb(164 167 174 / 0.5);
}

.disabled\\:bg-neutral-400\\/55:disabled{
  background-color: rgb(164 167 174 / 0.55);
}

.disabled\\:bg-neutral-400\\/60:disabled{
  background-color: rgb(164 167 174 / 0.6);
}

.disabled\\:bg-neutral-400\\/65:disabled{
  background-color: rgb(164 167 174 / 0.65);
}

.disabled\\:bg-neutral-400\\/70:disabled{
  background-color: rgb(164 167 174 / 0.7);
}

.disabled\\:bg-neutral-400\\/75:disabled{
  background-color: rgb(164 167 174 / 0.75);
}

.disabled\\:bg-neutral-400\\/80:disabled{
  background-color: rgb(164 167 174 / 0.8);
}

.disabled\\:bg-neutral-400\\/85:disabled{
  background-color: rgb(164 167 174 / 0.85);
}

.disabled\\:bg-neutral-400\\/90:disabled{
  background-color: rgb(164 167 174 / 0.9);
}

.disabled\\:bg-neutral-400\\/95:disabled{
  background-color: rgb(164 167 174 / 0.95);
}

.disabled\\:bg-neutral-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-50\\/0:disabled{
  background-color: rgb(249 250 250 / 0);
}

.disabled\\:bg-neutral-50\\/10:disabled{
  background-color: rgb(249 250 250 / 0.1);
}

.disabled\\:bg-neutral-50\\/100:disabled{
  background-color: rgb(249 250 250 / 1);
}

.disabled\\:bg-neutral-50\\/15:disabled{
  background-color: rgb(249 250 250 / 0.15);
}

.disabled\\:bg-neutral-50\\/20:disabled{
  background-color: rgb(249 250 250 / 0.2);
}

.disabled\\:bg-neutral-50\\/25:disabled{
  background-color: rgb(249 250 250 / 0.25);
}

.disabled\\:bg-neutral-50\\/30:disabled{
  background-color: rgb(249 250 250 / 0.3);
}

.disabled\\:bg-neutral-50\\/35:disabled{
  background-color: rgb(249 250 250 / 0.35);
}

.disabled\\:bg-neutral-50\\/40:disabled{
  background-color: rgb(249 250 250 / 0.4);
}

.disabled\\:bg-neutral-50\\/45:disabled{
  background-color: rgb(249 250 250 / 0.45);
}

.disabled\\:bg-neutral-50\\/5:disabled{
  background-color: rgb(249 250 250 / 0.05);
}

.disabled\\:bg-neutral-50\\/50:disabled{
  background-color: rgb(249 250 250 / 0.5);
}

.disabled\\:bg-neutral-50\\/55:disabled{
  background-color: rgb(249 250 250 / 0.55);
}

.disabled\\:bg-neutral-50\\/60:disabled{
  background-color: rgb(249 250 250 / 0.6);
}

.disabled\\:bg-neutral-50\\/65:disabled{
  background-color: rgb(249 250 250 / 0.65);
}

.disabled\\:bg-neutral-50\\/70:disabled{
  background-color: rgb(249 250 250 / 0.7);
}

.disabled\\:bg-neutral-50\\/75:disabled{
  background-color: rgb(249 250 250 / 0.75);
}

.disabled\\:bg-neutral-50\\/80:disabled{
  background-color: rgb(249 250 250 / 0.8);
}

.disabled\\:bg-neutral-50\\/85:disabled{
  background-color: rgb(249 250 250 / 0.85);
}

.disabled\\:bg-neutral-50\\/90:disabled{
  background-color: rgb(249 250 250 / 0.9);
}

.disabled\\:bg-neutral-50\\/95:disabled{
  background-color: rgb(249 250 250 / 0.95);
}

.disabled\\:bg-neutral-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-500\\/0:disabled{
  background-color: rgb(113 118 128 / 0);
}

.disabled\\:bg-neutral-500\\/10:disabled{
  background-color: rgb(113 118 128 / 0.1);
}

.disabled\\:bg-neutral-500\\/100:disabled{
  background-color: rgb(113 118 128 / 1);
}

.disabled\\:bg-neutral-500\\/15:disabled{
  background-color: rgb(113 118 128 / 0.15);
}

.disabled\\:bg-neutral-500\\/20:disabled{
  background-color: rgb(113 118 128 / 0.2);
}

.disabled\\:bg-neutral-500\\/25:disabled{
  background-color: rgb(113 118 128 / 0.25);
}

.disabled\\:bg-neutral-500\\/30:disabled{
  background-color: rgb(113 118 128 / 0.3);
}

.disabled\\:bg-neutral-500\\/35:disabled{
  background-color: rgb(113 118 128 / 0.35);
}

.disabled\\:bg-neutral-500\\/40:disabled{
  background-color: rgb(113 118 128 / 0.4);
}

.disabled\\:bg-neutral-500\\/45:disabled{
  background-color: rgb(113 118 128 / 0.45);
}

.disabled\\:bg-neutral-500\\/5:disabled{
  background-color: rgb(113 118 128 / 0.05);
}

.disabled\\:bg-neutral-500\\/50:disabled{
  background-color: rgb(113 118 128 / 0.5);
}

.disabled\\:bg-neutral-500\\/55:disabled{
  background-color: rgb(113 118 128 / 0.55);
}

.disabled\\:bg-neutral-500\\/60:disabled{
  background-color: rgb(113 118 128 / 0.6);
}

.disabled\\:bg-neutral-500\\/65:disabled{
  background-color: rgb(113 118 128 / 0.65);
}

.disabled\\:bg-neutral-500\\/70:disabled{
  background-color: rgb(113 118 128 / 0.7);
}

.disabled\\:bg-neutral-500\\/75:disabled{
  background-color: rgb(113 118 128 / 0.75);
}

.disabled\\:bg-neutral-500\\/80:disabled{
  background-color: rgb(113 118 128 / 0.8);
}

.disabled\\:bg-neutral-500\\/85:disabled{
  background-color: rgb(113 118 128 / 0.85);
}

.disabled\\:bg-neutral-500\\/90:disabled{
  background-color: rgb(113 118 128 / 0.9);
}

.disabled\\:bg-neutral-500\\/95:disabled{
  background-color: rgb(113 118 128 / 0.95);
}

.disabled\\:bg-neutral-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(83 88 98 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-600\\/0:disabled{
  background-color: rgb(83 88 98 / 0);
}

.disabled\\:bg-neutral-600\\/10:disabled{
  background-color: rgb(83 88 98 / 0.1);
}

.disabled\\:bg-neutral-600\\/100:disabled{
  background-color: rgb(83 88 98 / 1);
}

.disabled\\:bg-neutral-600\\/15:disabled{
  background-color: rgb(83 88 98 / 0.15);
}

.disabled\\:bg-neutral-600\\/20:disabled{
  background-color: rgb(83 88 98 / 0.2);
}

.disabled\\:bg-neutral-600\\/25:disabled{
  background-color: rgb(83 88 98 / 0.25);
}

.disabled\\:bg-neutral-600\\/30:disabled{
  background-color: rgb(83 88 98 / 0.3);
}

.disabled\\:bg-neutral-600\\/35:disabled{
  background-color: rgb(83 88 98 / 0.35);
}

.disabled\\:bg-neutral-600\\/40:disabled{
  background-color: rgb(83 88 98 / 0.4);
}

.disabled\\:bg-neutral-600\\/45:disabled{
  background-color: rgb(83 88 98 / 0.45);
}

.disabled\\:bg-neutral-600\\/5:disabled{
  background-color: rgb(83 88 98 / 0.05);
}

.disabled\\:bg-neutral-600\\/50:disabled{
  background-color: rgb(83 88 98 / 0.5);
}

.disabled\\:bg-neutral-600\\/55:disabled{
  background-color: rgb(83 88 98 / 0.55);
}

.disabled\\:bg-neutral-600\\/60:disabled{
  background-color: rgb(83 88 98 / 0.6);
}

.disabled\\:bg-neutral-600\\/65:disabled{
  background-color: rgb(83 88 98 / 0.65);
}

.disabled\\:bg-neutral-600\\/70:disabled{
  background-color: rgb(83 88 98 / 0.7);
}

.disabled\\:bg-neutral-600\\/75:disabled{
  background-color: rgb(83 88 98 / 0.75);
}

.disabled\\:bg-neutral-600\\/80:disabled{
  background-color: rgb(83 88 98 / 0.8);
}

.disabled\\:bg-neutral-600\\/85:disabled{
  background-color: rgb(83 88 98 / 0.85);
}

.disabled\\:bg-neutral-600\\/90:disabled{
  background-color: rgb(83 88 98 / 0.9);
}

.disabled\\:bg-neutral-600\\/95:disabled{
  background-color: rgb(83 88 98 / 0.95);
}

.disabled\\:bg-neutral-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-700\\/0:disabled{
  background-color: rgb(65 70 81 / 0);
}

.disabled\\:bg-neutral-700\\/10:disabled{
  background-color: rgb(65 70 81 / 0.1);
}

.disabled\\:bg-neutral-700\\/100:disabled{
  background-color: rgb(65 70 81 / 1);
}

.disabled\\:bg-neutral-700\\/15:disabled{
  background-color: rgb(65 70 81 / 0.15);
}

.disabled\\:bg-neutral-700\\/20:disabled{
  background-color: rgb(65 70 81 / 0.2);
}

.disabled\\:bg-neutral-700\\/25:disabled{
  background-color: rgb(65 70 81 / 0.25);
}

.disabled\\:bg-neutral-700\\/30:disabled{
  background-color: rgb(65 70 81 / 0.3);
}

.disabled\\:bg-neutral-700\\/35:disabled{
  background-color: rgb(65 70 81 / 0.35);
}

.disabled\\:bg-neutral-700\\/40:disabled{
  background-color: rgb(65 70 81 / 0.4);
}

.disabled\\:bg-neutral-700\\/45:disabled{
  background-color: rgb(65 70 81 / 0.45);
}

.disabled\\:bg-neutral-700\\/5:disabled{
  background-color: rgb(65 70 81 / 0.05);
}

.disabled\\:bg-neutral-700\\/50:disabled{
  background-color: rgb(65 70 81 / 0.5);
}

.disabled\\:bg-neutral-700\\/55:disabled{
  background-color: rgb(65 70 81 / 0.55);
}

.disabled\\:bg-neutral-700\\/60:disabled{
  background-color: rgb(65 70 81 / 0.6);
}

.disabled\\:bg-neutral-700\\/65:disabled{
  background-color: rgb(65 70 81 / 0.65);
}

.disabled\\:bg-neutral-700\\/70:disabled{
  background-color: rgb(65 70 81 / 0.7);
}

.disabled\\:bg-neutral-700\\/75:disabled{
  background-color: rgb(65 70 81 / 0.75);
}

.disabled\\:bg-neutral-700\\/80:disabled{
  background-color: rgb(65 70 81 / 0.8);
}

.disabled\\:bg-neutral-700\\/85:disabled{
  background-color: rgb(65 70 81 / 0.85);
}

.disabled\\:bg-neutral-700\\/90:disabled{
  background-color: rgb(65 70 81 / 0.9);
}

.disabled\\:bg-neutral-700\\/95:disabled{
  background-color: rgb(65 70 81 / 0.95);
}

.disabled\\:bg-neutral-75:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-75\\/0:disabled{
  background-color: rgb(246 246 246 / 0);
}

.disabled\\:bg-neutral-75\\/10:disabled{
  background-color: rgb(246 246 246 / 0.1);
}

.disabled\\:bg-neutral-75\\/100:disabled{
  background-color: rgb(246 246 246 / 1);
}

.disabled\\:bg-neutral-75\\/15:disabled{
  background-color: rgb(246 246 246 / 0.15);
}

.disabled\\:bg-neutral-75\\/20:disabled{
  background-color: rgb(246 246 246 / 0.2);
}

.disabled\\:bg-neutral-75\\/25:disabled{
  background-color: rgb(246 246 246 / 0.25);
}

.disabled\\:bg-neutral-75\\/30:disabled{
  background-color: rgb(246 246 246 / 0.3);
}

.disabled\\:bg-neutral-75\\/35:disabled{
  background-color: rgb(246 246 246 / 0.35);
}

.disabled\\:bg-neutral-75\\/40:disabled{
  background-color: rgb(246 246 246 / 0.4);
}

.disabled\\:bg-neutral-75\\/45:disabled{
  background-color: rgb(246 246 246 / 0.45);
}

.disabled\\:bg-neutral-75\\/5:disabled{
  background-color: rgb(246 246 246 / 0.05);
}

.disabled\\:bg-neutral-75\\/50:disabled{
  background-color: rgb(246 246 246 / 0.5);
}

.disabled\\:bg-neutral-75\\/55:disabled{
  background-color: rgb(246 246 246 / 0.55);
}

.disabled\\:bg-neutral-75\\/60:disabled{
  background-color: rgb(246 246 246 / 0.6);
}

.disabled\\:bg-neutral-75\\/65:disabled{
  background-color: rgb(246 246 246 / 0.65);
}

.disabled\\:bg-neutral-75\\/70:disabled{
  background-color: rgb(246 246 246 / 0.7);
}

.disabled\\:bg-neutral-75\\/75:disabled{
  background-color: rgb(246 246 246 / 0.75);
}

.disabled\\:bg-neutral-75\\/80:disabled{
  background-color: rgb(246 246 246 / 0.8);
}

.disabled\\:bg-neutral-75\\/85:disabled{
  background-color: rgb(246 246 246 / 0.85);
}

.disabled\\:bg-neutral-75\\/90:disabled{
  background-color: rgb(246 246 246 / 0.9);
}

.disabled\\:bg-neutral-75\\/95:disabled{
  background-color: rgb(246 246 246 / 0.95);
}

.disabled\\:bg-primary-100:disabled{
  background-color: var(--color-primary-100, #E0F2FE);
}

.disabled\\:bg-primary-200:disabled{
  background-color: var(--color-primary-200, #B9E6FE);
}

.disabled\\:bg-primary-25:disabled{
  background-color: var(--color-primary-25, #F5FBFF);
}

.disabled\\:bg-primary-400:disabled{
  background-color: var(--color-primary-400, #36BFFA);
}

.disabled\\:bg-primary-50:disabled{
  background-color: var(--color-primary-50, #F0F9FF);
}

.disabled\\:bg-primary-500:disabled{
  background-color: var(--color-primary-500, #0BA5EC);
}

.disabled\\:bg-primary-600:disabled{
  background-color: var(--color-primary-600, #0086C9);
}

.disabled\\:bg-primary-700:disabled{
  background-color: var(--color-primary-700, #026AA2);
}

.disabled\\:bg-purple-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(235 233 254 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-100\\/0:disabled{
  background-color: rgb(235 233 254 / 0);
}

.disabled\\:bg-purple-100\\/10:disabled{
  background-color: rgb(235 233 254 / 0.1);
}

.disabled\\:bg-purple-100\\/100:disabled{
  background-color: rgb(235 233 254 / 1);
}

.disabled\\:bg-purple-100\\/15:disabled{
  background-color: rgb(235 233 254 / 0.15);
}

.disabled\\:bg-purple-100\\/20:disabled{
  background-color: rgb(235 233 254 / 0.2);
}

.disabled\\:bg-purple-100\\/25:disabled{
  background-color: rgb(235 233 254 / 0.25);
}

.disabled\\:bg-purple-100\\/30:disabled{
  background-color: rgb(235 233 254 / 0.3);
}

.disabled\\:bg-purple-100\\/35:disabled{
  background-color: rgb(235 233 254 / 0.35);
}

.disabled\\:bg-purple-100\\/40:disabled{
  background-color: rgb(235 233 254 / 0.4);
}

.disabled\\:bg-purple-100\\/45:disabled{
  background-color: rgb(235 233 254 / 0.45);
}

.disabled\\:bg-purple-100\\/5:disabled{
  background-color: rgb(235 233 254 / 0.05);
}

.disabled\\:bg-purple-100\\/50:disabled{
  background-color: rgb(235 233 254 / 0.5);
}

.disabled\\:bg-purple-100\\/55:disabled{
  background-color: rgb(235 233 254 / 0.55);
}

.disabled\\:bg-purple-100\\/60:disabled{
  background-color: rgb(235 233 254 / 0.6);
}

.disabled\\:bg-purple-100\\/65:disabled{
  background-color: rgb(235 233 254 / 0.65);
}

.disabled\\:bg-purple-100\\/70:disabled{
  background-color: rgb(235 233 254 / 0.7);
}

.disabled\\:bg-purple-100\\/75:disabled{
  background-color: rgb(235 233 254 / 0.75);
}

.disabled\\:bg-purple-100\\/80:disabled{
  background-color: rgb(235 233 254 / 0.8);
}

.disabled\\:bg-purple-100\\/85:disabled{
  background-color: rgb(235 233 254 / 0.85);
}

.disabled\\:bg-purple-100\\/90:disabled{
  background-color: rgb(235 233 254 / 0.9);
}

.disabled\\:bg-purple-100\\/95:disabled{
  background-color: rgb(235 233 254 / 0.95);
}

.disabled\\:bg-purple-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(217 214 254 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-200\\/0:disabled{
  background-color: rgb(217 214 254 / 0);
}

.disabled\\:bg-purple-200\\/10:disabled{
  background-color: rgb(217 214 254 / 0.1);
}

.disabled\\:bg-purple-200\\/100:disabled{
  background-color: rgb(217 214 254 / 1);
}

.disabled\\:bg-purple-200\\/15:disabled{
  background-color: rgb(217 214 254 / 0.15);
}

.disabled\\:bg-purple-200\\/20:disabled{
  background-color: rgb(217 214 254 / 0.2);
}

.disabled\\:bg-purple-200\\/25:disabled{
  background-color: rgb(217 214 254 / 0.25);
}

.disabled\\:bg-purple-200\\/30:disabled{
  background-color: rgb(217 214 254 / 0.3);
}

.disabled\\:bg-purple-200\\/35:disabled{
  background-color: rgb(217 214 254 / 0.35);
}

.disabled\\:bg-purple-200\\/40:disabled{
  background-color: rgb(217 214 254 / 0.4);
}

.disabled\\:bg-purple-200\\/45:disabled{
  background-color: rgb(217 214 254 / 0.45);
}

.disabled\\:bg-purple-200\\/5:disabled{
  background-color: rgb(217 214 254 / 0.05);
}

.disabled\\:bg-purple-200\\/50:disabled{
  background-color: rgb(217 214 254 / 0.5);
}

.disabled\\:bg-purple-200\\/55:disabled{
  background-color: rgb(217 214 254 / 0.55);
}

.disabled\\:bg-purple-200\\/60:disabled{
  background-color: rgb(217 214 254 / 0.6);
}

.disabled\\:bg-purple-200\\/65:disabled{
  background-color: rgb(217 214 254 / 0.65);
}

.disabled\\:bg-purple-200\\/70:disabled{
  background-color: rgb(217 214 254 / 0.7);
}

.disabled\\:bg-purple-200\\/75:disabled{
  background-color: rgb(217 214 254 / 0.75);
}

.disabled\\:bg-purple-200\\/80:disabled{
  background-color: rgb(217 214 254 / 0.8);
}

.disabled\\:bg-purple-200\\/85:disabled{
  background-color: rgb(217 214 254 / 0.85);
}

.disabled\\:bg-purple-200\\/90:disabled{
  background-color: rgb(217 214 254 / 0.9);
}

.disabled\\:bg-purple-200\\/95:disabled{
  background-color: rgb(217 214 254 / 0.95);
}

.disabled\\:bg-purple-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 255 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-25\\/0:disabled{
  background-color: rgb(250 250 255 / 0);
}

.disabled\\:bg-purple-25\\/10:disabled{
  background-color: rgb(250 250 255 / 0.1);
}

.disabled\\:bg-purple-25\\/100:disabled{
  background-color: rgb(250 250 255 / 1);
}

.disabled\\:bg-purple-25\\/15:disabled{
  background-color: rgb(250 250 255 / 0.15);
}

.disabled\\:bg-purple-25\\/20:disabled{
  background-color: rgb(250 250 255 / 0.2);
}

.disabled\\:bg-purple-25\\/25:disabled{
  background-color: rgb(250 250 255 / 0.25);
}

.disabled\\:bg-purple-25\\/30:disabled{
  background-color: rgb(250 250 255 / 0.3);
}

.disabled\\:bg-purple-25\\/35:disabled{
  background-color: rgb(250 250 255 / 0.35);
}

.disabled\\:bg-purple-25\\/40:disabled{
  background-color: rgb(250 250 255 / 0.4);
}

.disabled\\:bg-purple-25\\/45:disabled{
  background-color: rgb(250 250 255 / 0.45);
}

.disabled\\:bg-purple-25\\/5:disabled{
  background-color: rgb(250 250 255 / 0.05);
}

.disabled\\:bg-purple-25\\/50:disabled{
  background-color: rgb(250 250 255 / 0.5);
}

.disabled\\:bg-purple-25\\/55:disabled{
  background-color: rgb(250 250 255 / 0.55);
}

.disabled\\:bg-purple-25\\/60:disabled{
  background-color: rgb(250 250 255 / 0.6);
}

.disabled\\:bg-purple-25\\/65:disabled{
  background-color: rgb(250 250 255 / 0.65);
}

.disabled\\:bg-purple-25\\/70:disabled{
  background-color: rgb(250 250 255 / 0.7);
}

.disabled\\:bg-purple-25\\/75:disabled{
  background-color: rgb(250 250 255 / 0.75);
}

.disabled\\:bg-purple-25\\/80:disabled{
  background-color: rgb(250 250 255 / 0.8);
}

.disabled\\:bg-purple-25\\/85:disabled{
  background-color: rgb(250 250 255 / 0.85);
}

.disabled\\:bg-purple-25\\/90:disabled{
  background-color: rgb(250 250 255 / 0.9);
}

.disabled\\:bg-purple-25\\/95:disabled{
  background-color: rgb(250 250 255 / 0.95);
}

.disabled\\:bg-purple-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(155 138 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-400\\/0:disabled{
  background-color: rgb(155 138 251 / 0);
}

.disabled\\:bg-purple-400\\/10:disabled{
  background-color: rgb(155 138 251 / 0.1);
}

.disabled\\:bg-purple-400\\/100:disabled{
  background-color: rgb(155 138 251 / 1);
}

.disabled\\:bg-purple-400\\/15:disabled{
  background-color: rgb(155 138 251 / 0.15);
}

.disabled\\:bg-purple-400\\/20:disabled{
  background-color: rgb(155 138 251 / 0.2);
}

.disabled\\:bg-purple-400\\/25:disabled{
  background-color: rgb(155 138 251 / 0.25);
}

.disabled\\:bg-purple-400\\/30:disabled{
  background-color: rgb(155 138 251 / 0.3);
}

.disabled\\:bg-purple-400\\/35:disabled{
  background-color: rgb(155 138 251 / 0.35);
}

.disabled\\:bg-purple-400\\/40:disabled{
  background-color: rgb(155 138 251 / 0.4);
}

.disabled\\:bg-purple-400\\/45:disabled{
  background-color: rgb(155 138 251 / 0.45);
}

.disabled\\:bg-purple-400\\/5:disabled{
  background-color: rgb(155 138 251 / 0.05);
}

.disabled\\:bg-purple-400\\/50:disabled{
  background-color: rgb(155 138 251 / 0.5);
}

.disabled\\:bg-purple-400\\/55:disabled{
  background-color: rgb(155 138 251 / 0.55);
}

.disabled\\:bg-purple-400\\/60:disabled{
  background-color: rgb(155 138 251 / 0.6);
}

.disabled\\:bg-purple-400\\/65:disabled{
  background-color: rgb(155 138 251 / 0.65);
}

.disabled\\:bg-purple-400\\/70:disabled{
  background-color: rgb(155 138 251 / 0.7);
}

.disabled\\:bg-purple-400\\/75:disabled{
  background-color: rgb(155 138 251 / 0.75);
}

.disabled\\:bg-purple-400\\/80:disabled{
  background-color: rgb(155 138 251 / 0.8);
}

.disabled\\:bg-purple-400\\/85:disabled{
  background-color: rgb(155 138 251 / 0.85);
}

.disabled\\:bg-purple-400\\/90:disabled{
  background-color: rgb(155 138 251 / 0.9);
}

.disabled\\:bg-purple-400\\/95:disabled{
  background-color: rgb(155 138 251 / 0.95);
}

.disabled\\:bg-purple-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 255 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-50\\/0:disabled{
  background-color: rgb(244 243 255 / 0);
}

.disabled\\:bg-purple-50\\/10:disabled{
  background-color: rgb(244 243 255 / 0.1);
}

.disabled\\:bg-purple-50\\/100:disabled{
  background-color: rgb(244 243 255 / 1);
}

.disabled\\:bg-purple-50\\/15:disabled{
  background-color: rgb(244 243 255 / 0.15);
}

.disabled\\:bg-purple-50\\/20:disabled{
  background-color: rgb(244 243 255 / 0.2);
}

.disabled\\:bg-purple-50\\/25:disabled{
  background-color: rgb(244 243 255 / 0.25);
}

.disabled\\:bg-purple-50\\/30:disabled{
  background-color: rgb(244 243 255 / 0.3);
}

.disabled\\:bg-purple-50\\/35:disabled{
  background-color: rgb(244 243 255 / 0.35);
}

.disabled\\:bg-purple-50\\/40:disabled{
  background-color: rgb(244 243 255 / 0.4);
}

.disabled\\:bg-purple-50\\/45:disabled{
  background-color: rgb(244 243 255 / 0.45);
}

.disabled\\:bg-purple-50\\/5:disabled{
  background-color: rgb(244 243 255 / 0.05);
}

.disabled\\:bg-purple-50\\/50:disabled{
  background-color: rgb(244 243 255 / 0.5);
}

.disabled\\:bg-purple-50\\/55:disabled{
  background-color: rgb(244 243 255 / 0.55);
}

.disabled\\:bg-purple-50\\/60:disabled{
  background-color: rgb(244 243 255 / 0.6);
}

.disabled\\:bg-purple-50\\/65:disabled{
  background-color: rgb(244 243 255 / 0.65);
}

.disabled\\:bg-purple-50\\/70:disabled{
  background-color: rgb(244 243 255 / 0.7);
}

.disabled\\:bg-purple-50\\/75:disabled{
  background-color: rgb(244 243 255 / 0.75);
}

.disabled\\:bg-purple-50\\/80:disabled{
  background-color: rgb(244 243 255 / 0.8);
}

.disabled\\:bg-purple-50\\/85:disabled{
  background-color: rgb(244 243 255 / 0.85);
}

.disabled\\:bg-purple-50\\/90:disabled{
  background-color: rgb(244 243 255 / 0.9);
}

.disabled\\:bg-purple-50\\/95:disabled{
  background-color: rgb(244 243 255 / 0.95);
}

.disabled\\:bg-purple-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(122 90 248 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-500\\/0:disabled{
  background-color: rgb(122 90 248 / 0);
}

.disabled\\:bg-purple-500\\/10:disabled{
  background-color: rgb(122 90 248 / 0.1);
}

.disabled\\:bg-purple-500\\/100:disabled{
  background-color: rgb(122 90 248 / 1);
}

.disabled\\:bg-purple-500\\/15:disabled{
  background-color: rgb(122 90 248 / 0.15);
}

.disabled\\:bg-purple-500\\/20:disabled{
  background-color: rgb(122 90 248 / 0.2);
}

.disabled\\:bg-purple-500\\/25:disabled{
  background-color: rgb(122 90 248 / 0.25);
}

.disabled\\:bg-purple-500\\/30:disabled{
  background-color: rgb(122 90 248 / 0.3);
}

.disabled\\:bg-purple-500\\/35:disabled{
  background-color: rgb(122 90 248 / 0.35);
}

.disabled\\:bg-purple-500\\/40:disabled{
  background-color: rgb(122 90 248 / 0.4);
}

.disabled\\:bg-purple-500\\/45:disabled{
  background-color: rgb(122 90 248 / 0.45);
}

.disabled\\:bg-purple-500\\/5:disabled{
  background-color: rgb(122 90 248 / 0.05);
}

.disabled\\:bg-purple-500\\/50:disabled{
  background-color: rgb(122 90 248 / 0.5);
}

.disabled\\:bg-purple-500\\/55:disabled{
  background-color: rgb(122 90 248 / 0.55);
}

.disabled\\:bg-purple-500\\/60:disabled{
  background-color: rgb(122 90 248 / 0.6);
}

.disabled\\:bg-purple-500\\/65:disabled{
  background-color: rgb(122 90 248 / 0.65);
}

.disabled\\:bg-purple-500\\/70:disabled{
  background-color: rgb(122 90 248 / 0.7);
}

.disabled\\:bg-purple-500\\/75:disabled{
  background-color: rgb(122 90 248 / 0.75);
}

.disabled\\:bg-purple-500\\/80:disabled{
  background-color: rgb(122 90 248 / 0.8);
}

.disabled\\:bg-purple-500\\/85:disabled{
  background-color: rgb(122 90 248 / 0.85);
}

.disabled\\:bg-purple-500\\/90:disabled{
  background-color: rgb(122 90 248 / 0.9);
}

.disabled\\:bg-purple-500\\/95:disabled{
  background-color: rgb(122 90 248 / 0.95);
}

.disabled\\:bg-purple-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(105 56 239 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-600\\/0:disabled{
  background-color: rgb(105 56 239 / 0);
}

.disabled\\:bg-purple-600\\/10:disabled{
  background-color: rgb(105 56 239 / 0.1);
}

.disabled\\:bg-purple-600\\/100:disabled{
  background-color: rgb(105 56 239 / 1);
}

.disabled\\:bg-purple-600\\/15:disabled{
  background-color: rgb(105 56 239 / 0.15);
}

.disabled\\:bg-purple-600\\/20:disabled{
  background-color: rgb(105 56 239 / 0.2);
}

.disabled\\:bg-purple-600\\/25:disabled{
  background-color: rgb(105 56 239 / 0.25);
}

.disabled\\:bg-purple-600\\/30:disabled{
  background-color: rgb(105 56 239 / 0.3);
}

.disabled\\:bg-purple-600\\/35:disabled{
  background-color: rgb(105 56 239 / 0.35);
}

.disabled\\:bg-purple-600\\/40:disabled{
  background-color: rgb(105 56 239 / 0.4);
}

.disabled\\:bg-purple-600\\/45:disabled{
  background-color: rgb(105 56 239 / 0.45);
}

.disabled\\:bg-purple-600\\/5:disabled{
  background-color: rgb(105 56 239 / 0.05);
}

.disabled\\:bg-purple-600\\/50:disabled{
  background-color: rgb(105 56 239 / 0.5);
}

.disabled\\:bg-purple-600\\/55:disabled{
  background-color: rgb(105 56 239 / 0.55);
}

.disabled\\:bg-purple-600\\/60:disabled{
  background-color: rgb(105 56 239 / 0.6);
}

.disabled\\:bg-purple-600\\/65:disabled{
  background-color: rgb(105 56 239 / 0.65);
}

.disabled\\:bg-purple-600\\/70:disabled{
  background-color: rgb(105 56 239 / 0.7);
}

.disabled\\:bg-purple-600\\/75:disabled{
  background-color: rgb(105 56 239 / 0.75);
}

.disabled\\:bg-purple-600\\/80:disabled{
  background-color: rgb(105 56 239 / 0.8);
}

.disabled\\:bg-purple-600\\/85:disabled{
  background-color: rgb(105 56 239 / 0.85);
}

.disabled\\:bg-purple-600\\/90:disabled{
  background-color: rgb(105 56 239 / 0.9);
}

.disabled\\:bg-purple-600\\/95:disabled{
  background-color: rgb(105 56 239 / 0.95);
}

.disabled\\:bg-purple-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(89 37 220 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-purple-700\\/0:disabled{
  background-color: rgb(89 37 220 / 0);
}

.disabled\\:bg-purple-700\\/10:disabled{
  background-color: rgb(89 37 220 / 0.1);
}

.disabled\\:bg-purple-700\\/100:disabled{
  background-color: rgb(89 37 220 / 1);
}

.disabled\\:bg-purple-700\\/15:disabled{
  background-color: rgb(89 37 220 / 0.15);
}

.disabled\\:bg-purple-700\\/20:disabled{
  background-color: rgb(89 37 220 / 0.2);
}

.disabled\\:bg-purple-700\\/25:disabled{
  background-color: rgb(89 37 220 / 0.25);
}

.disabled\\:bg-purple-700\\/30:disabled{
  background-color: rgb(89 37 220 / 0.3);
}

.disabled\\:bg-purple-700\\/35:disabled{
  background-color: rgb(89 37 220 / 0.35);
}

.disabled\\:bg-purple-700\\/40:disabled{
  background-color: rgb(89 37 220 / 0.4);
}

.disabled\\:bg-purple-700\\/45:disabled{
  background-color: rgb(89 37 220 / 0.45);
}

.disabled\\:bg-purple-700\\/5:disabled{
  background-color: rgb(89 37 220 / 0.05);
}

.disabled\\:bg-purple-700\\/50:disabled{
  background-color: rgb(89 37 220 / 0.5);
}

.disabled\\:bg-purple-700\\/55:disabled{
  background-color: rgb(89 37 220 / 0.55);
}

.disabled\\:bg-purple-700\\/60:disabled{
  background-color: rgb(89 37 220 / 0.6);
}

.disabled\\:bg-purple-700\\/65:disabled{
  background-color: rgb(89 37 220 / 0.65);
}

.disabled\\:bg-purple-700\\/70:disabled{
  background-color: rgb(89 37 220 / 0.7);
}

.disabled\\:bg-purple-700\\/75:disabled{
  background-color: rgb(89 37 220 / 0.75);
}

.disabled\\:bg-purple-700\\/80:disabled{
  background-color: rgb(89 37 220 / 0.8);
}

.disabled\\:bg-purple-700\\/85:disabled{
  background-color: rgb(89 37 220 / 0.85);
}

.disabled\\:bg-purple-700\\/90:disabled{
  background-color: rgb(89 37 220 / 0.9);
}

.disabled\\:bg-purple-700\\/95:disabled{
  background-color: rgb(89 37 220 / 0.95);
}

.disabled\\:bg-success-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(211 248 223 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-100\\/0:disabled{
  background-color: rgb(211 248 223 / 0);
}

.disabled\\:bg-success-100\\/10:disabled{
  background-color: rgb(211 248 223 / 0.1);
}

.disabled\\:bg-success-100\\/100:disabled{
  background-color: rgb(211 248 223 / 1);
}

.disabled\\:bg-success-100\\/15:disabled{
  background-color: rgb(211 248 223 / 0.15);
}

.disabled\\:bg-success-100\\/20:disabled{
  background-color: rgb(211 248 223 / 0.2);
}

.disabled\\:bg-success-100\\/25:disabled{
  background-color: rgb(211 248 223 / 0.25);
}

.disabled\\:bg-success-100\\/30:disabled{
  background-color: rgb(211 248 223 / 0.3);
}

.disabled\\:bg-success-100\\/35:disabled{
  background-color: rgb(211 248 223 / 0.35);
}

.disabled\\:bg-success-100\\/40:disabled{
  background-color: rgb(211 248 223 / 0.4);
}

.disabled\\:bg-success-100\\/45:disabled{
  background-color: rgb(211 248 223 / 0.45);
}

.disabled\\:bg-success-100\\/5:disabled{
  background-color: rgb(211 248 223 / 0.05);
}

.disabled\\:bg-success-100\\/50:disabled{
  background-color: rgb(211 248 223 / 0.5);
}

.disabled\\:bg-success-100\\/55:disabled{
  background-color: rgb(211 248 223 / 0.55);
}

.disabled\\:bg-success-100\\/60:disabled{
  background-color: rgb(211 248 223 / 0.6);
}

.disabled\\:bg-success-100\\/65:disabled{
  background-color: rgb(211 248 223 / 0.65);
}

.disabled\\:bg-success-100\\/70:disabled{
  background-color: rgb(211 248 223 / 0.7);
}

.disabled\\:bg-success-100\\/75:disabled{
  background-color: rgb(211 248 223 / 0.75);
}

.disabled\\:bg-success-100\\/80:disabled{
  background-color: rgb(211 248 223 / 0.8);
}

.disabled\\:bg-success-100\\/85:disabled{
  background-color: rgb(211 248 223 / 0.85);
}

.disabled\\:bg-success-100\\/90:disabled{
  background-color: rgb(211 248 223 / 0.9);
}

.disabled\\:bg-success-100\\/95:disabled{
  background-color: rgb(211 248 223 / 0.95);
}

.disabled\\:bg-success-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(170 240 196 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-200\\/0:disabled{
  background-color: rgb(170 240 196 / 0);
}

.disabled\\:bg-success-200\\/10:disabled{
  background-color: rgb(170 240 196 / 0.1);
}

.disabled\\:bg-success-200\\/100:disabled{
  background-color: rgb(170 240 196 / 1);
}

.disabled\\:bg-success-200\\/15:disabled{
  background-color: rgb(170 240 196 / 0.15);
}

.disabled\\:bg-success-200\\/20:disabled{
  background-color: rgb(170 240 196 / 0.2);
}

.disabled\\:bg-success-200\\/25:disabled{
  background-color: rgb(170 240 196 / 0.25);
}

.disabled\\:bg-success-200\\/30:disabled{
  background-color: rgb(170 240 196 / 0.3);
}

.disabled\\:bg-success-200\\/35:disabled{
  background-color: rgb(170 240 196 / 0.35);
}

.disabled\\:bg-success-200\\/40:disabled{
  background-color: rgb(170 240 196 / 0.4);
}

.disabled\\:bg-success-200\\/45:disabled{
  background-color: rgb(170 240 196 / 0.45);
}

.disabled\\:bg-success-200\\/5:disabled{
  background-color: rgb(170 240 196 / 0.05);
}

.disabled\\:bg-success-200\\/50:disabled{
  background-color: rgb(170 240 196 / 0.5);
}

.disabled\\:bg-success-200\\/55:disabled{
  background-color: rgb(170 240 196 / 0.55);
}

.disabled\\:bg-success-200\\/60:disabled{
  background-color: rgb(170 240 196 / 0.6);
}

.disabled\\:bg-success-200\\/65:disabled{
  background-color: rgb(170 240 196 / 0.65);
}

.disabled\\:bg-success-200\\/70:disabled{
  background-color: rgb(170 240 196 / 0.7);
}

.disabled\\:bg-success-200\\/75:disabled{
  background-color: rgb(170 240 196 / 0.75);
}

.disabled\\:bg-success-200\\/80:disabled{
  background-color: rgb(170 240 196 / 0.8);
}

.disabled\\:bg-success-200\\/85:disabled{
  background-color: rgb(170 240 196 / 0.85);
}

.disabled\\:bg-success-200\\/90:disabled{
  background-color: rgb(170 240 196 / 0.9);
}

.disabled\\:bg-success-200\\/95:disabled{
  background-color: rgb(170 240 196 / 0.95);
}

.disabled\\:bg-success-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(246 254 249 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-25\\/0:disabled{
  background-color: rgb(246 254 249 / 0);
}

.disabled\\:bg-success-25\\/10:disabled{
  background-color: rgb(246 254 249 / 0.1);
}

.disabled\\:bg-success-25\\/100:disabled{
  background-color: rgb(246 254 249 / 1);
}

.disabled\\:bg-success-25\\/15:disabled{
  background-color: rgb(246 254 249 / 0.15);
}

.disabled\\:bg-success-25\\/20:disabled{
  background-color: rgb(246 254 249 / 0.2);
}

.disabled\\:bg-success-25\\/25:disabled{
  background-color: rgb(246 254 249 / 0.25);
}

.disabled\\:bg-success-25\\/30:disabled{
  background-color: rgb(246 254 249 / 0.3);
}

.disabled\\:bg-success-25\\/35:disabled{
  background-color: rgb(246 254 249 / 0.35);
}

.disabled\\:bg-success-25\\/40:disabled{
  background-color: rgb(246 254 249 / 0.4);
}

.disabled\\:bg-success-25\\/45:disabled{
  background-color: rgb(246 254 249 / 0.45);
}

.disabled\\:bg-success-25\\/5:disabled{
  background-color: rgb(246 254 249 / 0.05);
}

.disabled\\:bg-success-25\\/50:disabled{
  background-color: rgb(246 254 249 / 0.5);
}

.disabled\\:bg-success-25\\/55:disabled{
  background-color: rgb(246 254 249 / 0.55);
}

.disabled\\:bg-success-25\\/60:disabled{
  background-color: rgb(246 254 249 / 0.6);
}

.disabled\\:bg-success-25\\/65:disabled{
  background-color: rgb(246 254 249 / 0.65);
}

.disabled\\:bg-success-25\\/70:disabled{
  background-color: rgb(246 254 249 / 0.7);
}

.disabled\\:bg-success-25\\/75:disabled{
  background-color: rgb(246 254 249 / 0.75);
}

.disabled\\:bg-success-25\\/80:disabled{
  background-color: rgb(246 254 249 / 0.8);
}

.disabled\\:bg-success-25\\/85:disabled{
  background-color: rgb(246 254 249 / 0.85);
}

.disabled\\:bg-success-25\\/90:disabled{
  background-color: rgb(246 254 249 / 0.9);
}

.disabled\\:bg-success-25\\/95:disabled{
  background-color: rgb(246 254 249 / 0.95);
}

.disabled\\:bg-success-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(60 203 127 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-400\\/0:disabled{
  background-color: rgb(60 203 127 / 0);
}

.disabled\\:bg-success-400\\/10:disabled{
  background-color: rgb(60 203 127 / 0.1);
}

.disabled\\:bg-success-400\\/100:disabled{
  background-color: rgb(60 203 127 / 1);
}

.disabled\\:bg-success-400\\/15:disabled{
  background-color: rgb(60 203 127 / 0.15);
}

.disabled\\:bg-success-400\\/20:disabled{
  background-color: rgb(60 203 127 / 0.2);
}

.disabled\\:bg-success-400\\/25:disabled{
  background-color: rgb(60 203 127 / 0.25);
}

.disabled\\:bg-success-400\\/30:disabled{
  background-color: rgb(60 203 127 / 0.3);
}

.disabled\\:bg-success-400\\/35:disabled{
  background-color: rgb(60 203 127 / 0.35);
}

.disabled\\:bg-success-400\\/40:disabled{
  background-color: rgb(60 203 127 / 0.4);
}

.disabled\\:bg-success-400\\/45:disabled{
  background-color: rgb(60 203 127 / 0.45);
}

.disabled\\:bg-success-400\\/5:disabled{
  background-color: rgb(60 203 127 / 0.05);
}

.disabled\\:bg-success-400\\/50:disabled{
  background-color: rgb(60 203 127 / 0.5);
}

.disabled\\:bg-success-400\\/55:disabled{
  background-color: rgb(60 203 127 / 0.55);
}

.disabled\\:bg-success-400\\/60:disabled{
  background-color: rgb(60 203 127 / 0.6);
}

.disabled\\:bg-success-400\\/65:disabled{
  background-color: rgb(60 203 127 / 0.65);
}

.disabled\\:bg-success-400\\/70:disabled{
  background-color: rgb(60 203 127 / 0.7);
}

.disabled\\:bg-success-400\\/75:disabled{
  background-color: rgb(60 203 127 / 0.75);
}

.disabled\\:bg-success-400\\/80:disabled{
  background-color: rgb(60 203 127 / 0.8);
}

.disabled\\:bg-success-400\\/85:disabled{
  background-color: rgb(60 203 127 / 0.85);
}

.disabled\\:bg-success-400\\/90:disabled{
  background-color: rgb(60 203 127 / 0.9);
}

.disabled\\:bg-success-400\\/95:disabled{
  background-color: rgb(60 203 127 / 0.95);
}

.disabled\\:bg-success-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-50\\/0:disabled{
  background-color: rgb(237 252 242 / 0);
}

.disabled\\:bg-success-50\\/10:disabled{
  background-color: rgb(237 252 242 / 0.1);
}

.disabled\\:bg-success-50\\/100:disabled{
  background-color: rgb(237 252 242 / 1);
}

.disabled\\:bg-success-50\\/15:disabled{
  background-color: rgb(237 252 242 / 0.15);
}

.disabled\\:bg-success-50\\/20:disabled{
  background-color: rgb(237 252 242 / 0.2);
}

.disabled\\:bg-success-50\\/25:disabled{
  background-color: rgb(237 252 242 / 0.25);
}

.disabled\\:bg-success-50\\/30:disabled{
  background-color: rgb(237 252 242 / 0.3);
}

.disabled\\:bg-success-50\\/35:disabled{
  background-color: rgb(237 252 242 / 0.35);
}

.disabled\\:bg-success-50\\/40:disabled{
  background-color: rgb(237 252 242 / 0.4);
}

.disabled\\:bg-success-50\\/45:disabled{
  background-color: rgb(237 252 242 / 0.45);
}

.disabled\\:bg-success-50\\/5:disabled{
  background-color: rgb(237 252 242 / 0.05);
}

.disabled\\:bg-success-50\\/50:disabled{
  background-color: rgb(237 252 242 / 0.5);
}

.disabled\\:bg-success-50\\/55:disabled{
  background-color: rgb(237 252 242 / 0.55);
}

.disabled\\:bg-success-50\\/60:disabled{
  background-color: rgb(237 252 242 / 0.6);
}

.disabled\\:bg-success-50\\/65:disabled{
  background-color: rgb(237 252 242 / 0.65);
}

.disabled\\:bg-success-50\\/70:disabled{
  background-color: rgb(237 252 242 / 0.7);
}

.disabled\\:bg-success-50\\/75:disabled{
  background-color: rgb(237 252 242 / 0.75);
}

.disabled\\:bg-success-50\\/80:disabled{
  background-color: rgb(237 252 242 / 0.8);
}

.disabled\\:bg-success-50\\/85:disabled{
  background-color: rgb(237 252 242 / 0.85);
}

.disabled\\:bg-success-50\\/90:disabled{
  background-color: rgb(237 252 242 / 0.9);
}

.disabled\\:bg-success-50\\/95:disabled{
  background-color: rgb(237 252 242 / 0.95);
}

.disabled\\:bg-success-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(22 179 100 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-500\\/0:disabled{
  background-color: rgb(22 179 100 / 0);
}

.disabled\\:bg-success-500\\/10:disabled{
  background-color: rgb(22 179 100 / 0.1);
}

.disabled\\:bg-success-500\\/100:disabled{
  background-color: rgb(22 179 100 / 1);
}

.disabled\\:bg-success-500\\/15:disabled{
  background-color: rgb(22 179 100 / 0.15);
}

.disabled\\:bg-success-500\\/20:disabled{
  background-color: rgb(22 179 100 / 0.2);
}

.disabled\\:bg-success-500\\/25:disabled{
  background-color: rgb(22 179 100 / 0.25);
}

.disabled\\:bg-success-500\\/30:disabled{
  background-color: rgb(22 179 100 / 0.3);
}

.disabled\\:bg-success-500\\/35:disabled{
  background-color: rgb(22 179 100 / 0.35);
}

.disabled\\:bg-success-500\\/40:disabled{
  background-color: rgb(22 179 100 / 0.4);
}

.disabled\\:bg-success-500\\/45:disabled{
  background-color: rgb(22 179 100 / 0.45);
}

.disabled\\:bg-success-500\\/5:disabled{
  background-color: rgb(22 179 100 / 0.05);
}

.disabled\\:bg-success-500\\/50:disabled{
  background-color: rgb(22 179 100 / 0.5);
}

.disabled\\:bg-success-500\\/55:disabled{
  background-color: rgb(22 179 100 / 0.55);
}

.disabled\\:bg-success-500\\/60:disabled{
  background-color: rgb(22 179 100 / 0.6);
}

.disabled\\:bg-success-500\\/65:disabled{
  background-color: rgb(22 179 100 / 0.65);
}

.disabled\\:bg-success-500\\/70:disabled{
  background-color: rgb(22 179 100 / 0.7);
}

.disabled\\:bg-success-500\\/75:disabled{
  background-color: rgb(22 179 100 / 0.75);
}

.disabled\\:bg-success-500\\/80:disabled{
  background-color: rgb(22 179 100 / 0.8);
}

.disabled\\:bg-success-500\\/85:disabled{
  background-color: rgb(22 179 100 / 0.85);
}

.disabled\\:bg-success-500\\/90:disabled{
  background-color: rgb(22 179 100 / 0.9);
}

.disabled\\:bg-success-500\\/95:disabled{
  background-color: rgb(22 179 100 / 0.95);
}

.disabled\\:bg-success-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(9 146 80 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-600\\/0:disabled{
  background-color: rgb(9 146 80 / 0);
}

.disabled\\:bg-success-600\\/10:disabled{
  background-color: rgb(9 146 80 / 0.1);
}

.disabled\\:bg-success-600\\/100:disabled{
  background-color: rgb(9 146 80 / 1);
}

.disabled\\:bg-success-600\\/15:disabled{
  background-color: rgb(9 146 80 / 0.15);
}

.disabled\\:bg-success-600\\/20:disabled{
  background-color: rgb(9 146 80 / 0.2);
}

.disabled\\:bg-success-600\\/25:disabled{
  background-color: rgb(9 146 80 / 0.25);
}

.disabled\\:bg-success-600\\/30:disabled{
  background-color: rgb(9 146 80 / 0.3);
}

.disabled\\:bg-success-600\\/35:disabled{
  background-color: rgb(9 146 80 / 0.35);
}

.disabled\\:bg-success-600\\/40:disabled{
  background-color: rgb(9 146 80 / 0.4);
}

.disabled\\:bg-success-600\\/45:disabled{
  background-color: rgb(9 146 80 / 0.45);
}

.disabled\\:bg-success-600\\/5:disabled{
  background-color: rgb(9 146 80 / 0.05);
}

.disabled\\:bg-success-600\\/50:disabled{
  background-color: rgb(9 146 80 / 0.5);
}

.disabled\\:bg-success-600\\/55:disabled{
  background-color: rgb(9 146 80 / 0.55);
}

.disabled\\:bg-success-600\\/60:disabled{
  background-color: rgb(9 146 80 / 0.6);
}

.disabled\\:bg-success-600\\/65:disabled{
  background-color: rgb(9 146 80 / 0.65);
}

.disabled\\:bg-success-600\\/70:disabled{
  background-color: rgb(9 146 80 / 0.7);
}

.disabled\\:bg-success-600\\/75:disabled{
  background-color: rgb(9 146 80 / 0.75);
}

.disabled\\:bg-success-600\\/80:disabled{
  background-color: rgb(9 146 80 / 0.8);
}

.disabled\\:bg-success-600\\/85:disabled{
  background-color: rgb(9 146 80 / 0.85);
}

.disabled\\:bg-success-600\\/90:disabled{
  background-color: rgb(9 146 80 / 0.9);
}

.disabled\\:bg-success-600\\/95:disabled{
  background-color: rgb(9 146 80 / 0.95);
}

.disabled\\:bg-success-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(8 116 67 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-success-700\\/0:disabled{
  background-color: rgb(8 116 67 / 0);
}

.disabled\\:bg-success-700\\/10:disabled{
  background-color: rgb(8 116 67 / 0.1);
}

.disabled\\:bg-success-700\\/100:disabled{
  background-color: rgb(8 116 67 / 1);
}

.disabled\\:bg-success-700\\/15:disabled{
  background-color: rgb(8 116 67 / 0.15);
}

.disabled\\:bg-success-700\\/20:disabled{
  background-color: rgb(8 116 67 / 0.2);
}

.disabled\\:bg-success-700\\/25:disabled{
  background-color: rgb(8 116 67 / 0.25);
}

.disabled\\:bg-success-700\\/30:disabled{
  background-color: rgb(8 116 67 / 0.3);
}

.disabled\\:bg-success-700\\/35:disabled{
  background-color: rgb(8 116 67 / 0.35);
}

.disabled\\:bg-success-700\\/40:disabled{
  background-color: rgb(8 116 67 / 0.4);
}

.disabled\\:bg-success-700\\/45:disabled{
  background-color: rgb(8 116 67 / 0.45);
}

.disabled\\:bg-success-700\\/5:disabled{
  background-color: rgb(8 116 67 / 0.05);
}

.disabled\\:bg-success-700\\/50:disabled{
  background-color: rgb(8 116 67 / 0.5);
}

.disabled\\:bg-success-700\\/55:disabled{
  background-color: rgb(8 116 67 / 0.55);
}

.disabled\\:bg-success-700\\/60:disabled{
  background-color: rgb(8 116 67 / 0.6);
}

.disabled\\:bg-success-700\\/65:disabled{
  background-color: rgb(8 116 67 / 0.65);
}

.disabled\\:bg-success-700\\/70:disabled{
  background-color: rgb(8 116 67 / 0.7);
}

.disabled\\:bg-success-700\\/75:disabled{
  background-color: rgb(8 116 67 / 0.75);
}

.disabled\\:bg-success-700\\/80:disabled{
  background-color: rgb(8 116 67 / 0.8);
}

.disabled\\:bg-success-700\\/85:disabled{
  background-color: rgb(8 116 67 / 0.85);
}

.disabled\\:bg-success-700\\/90:disabled{
  background-color: rgb(8 116 67 / 0.9);
}

.disabled\\:bg-success-700\\/95:disabled{
  background-color: rgb(8 116 67 / 0.95);
}

.disabled\\:bg-warning-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 199 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-100\\/0:disabled{
  background-color: rgb(254 240 199 / 0);
}

.disabled\\:bg-warning-100\\/10:disabled{
  background-color: rgb(254 240 199 / 0.1);
}

.disabled\\:bg-warning-100\\/100:disabled{
  background-color: rgb(254 240 199 / 1);
}

.disabled\\:bg-warning-100\\/15:disabled{
  background-color: rgb(254 240 199 / 0.15);
}

.disabled\\:bg-warning-100\\/20:disabled{
  background-color: rgb(254 240 199 / 0.2);
}

.disabled\\:bg-warning-100\\/25:disabled{
  background-color: rgb(254 240 199 / 0.25);
}

.disabled\\:bg-warning-100\\/30:disabled{
  background-color: rgb(254 240 199 / 0.3);
}

.disabled\\:bg-warning-100\\/35:disabled{
  background-color: rgb(254 240 199 / 0.35);
}

.disabled\\:bg-warning-100\\/40:disabled{
  background-color: rgb(254 240 199 / 0.4);
}

.disabled\\:bg-warning-100\\/45:disabled{
  background-color: rgb(254 240 199 / 0.45);
}

.disabled\\:bg-warning-100\\/5:disabled{
  background-color: rgb(254 240 199 / 0.05);
}

.disabled\\:bg-warning-100\\/50:disabled{
  background-color: rgb(254 240 199 / 0.5);
}

.disabled\\:bg-warning-100\\/55:disabled{
  background-color: rgb(254 240 199 / 0.55);
}

.disabled\\:bg-warning-100\\/60:disabled{
  background-color: rgb(254 240 199 / 0.6);
}

.disabled\\:bg-warning-100\\/65:disabled{
  background-color: rgb(254 240 199 / 0.65);
}

.disabled\\:bg-warning-100\\/70:disabled{
  background-color: rgb(254 240 199 / 0.7);
}

.disabled\\:bg-warning-100\\/75:disabled{
  background-color: rgb(254 240 199 / 0.75);
}

.disabled\\:bg-warning-100\\/80:disabled{
  background-color: rgb(254 240 199 / 0.8);
}

.disabled\\:bg-warning-100\\/85:disabled{
  background-color: rgb(254 240 199 / 0.85);
}

.disabled\\:bg-warning-100\\/90:disabled{
  background-color: rgb(254 240 199 / 0.9);
}

.disabled\\:bg-warning-100\\/95:disabled{
  background-color: rgb(254 240 199 / 0.95);
}

.disabled\\:bg-warning-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(254 223 137 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-200\\/0:disabled{
  background-color: rgb(254 223 137 / 0);
}

.disabled\\:bg-warning-200\\/10:disabled{
  background-color: rgb(254 223 137 / 0.1);
}

.disabled\\:bg-warning-200\\/100:disabled{
  background-color: rgb(254 223 137 / 1);
}

.disabled\\:bg-warning-200\\/15:disabled{
  background-color: rgb(254 223 137 / 0.15);
}

.disabled\\:bg-warning-200\\/20:disabled{
  background-color: rgb(254 223 137 / 0.2);
}

.disabled\\:bg-warning-200\\/25:disabled{
  background-color: rgb(254 223 137 / 0.25);
}

.disabled\\:bg-warning-200\\/30:disabled{
  background-color: rgb(254 223 137 / 0.3);
}

.disabled\\:bg-warning-200\\/35:disabled{
  background-color: rgb(254 223 137 / 0.35);
}

.disabled\\:bg-warning-200\\/40:disabled{
  background-color: rgb(254 223 137 / 0.4);
}

.disabled\\:bg-warning-200\\/45:disabled{
  background-color: rgb(254 223 137 / 0.45);
}

.disabled\\:bg-warning-200\\/5:disabled{
  background-color: rgb(254 223 137 / 0.05);
}

.disabled\\:bg-warning-200\\/50:disabled{
  background-color: rgb(254 223 137 / 0.5);
}

.disabled\\:bg-warning-200\\/55:disabled{
  background-color: rgb(254 223 137 / 0.55);
}

.disabled\\:bg-warning-200\\/60:disabled{
  background-color: rgb(254 223 137 / 0.6);
}

.disabled\\:bg-warning-200\\/65:disabled{
  background-color: rgb(254 223 137 / 0.65);
}

.disabled\\:bg-warning-200\\/70:disabled{
  background-color: rgb(254 223 137 / 0.7);
}

.disabled\\:bg-warning-200\\/75:disabled{
  background-color: rgb(254 223 137 / 0.75);
}

.disabled\\:bg-warning-200\\/80:disabled{
  background-color: rgb(254 223 137 / 0.8);
}

.disabled\\:bg-warning-200\\/85:disabled{
  background-color: rgb(254 223 137 / 0.85);
}

.disabled\\:bg-warning-200\\/90:disabled{
  background-color: rgb(254 223 137 / 0.9);
}

.disabled\\:bg-warning-200\\/95:disabled{
  background-color: rgb(254 223 137 / 0.95);
}

.disabled\\:bg-warning-25:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 245 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-25\\/0:disabled{
  background-color: rgb(255 252 245 / 0);
}

.disabled\\:bg-warning-25\\/10:disabled{
  background-color: rgb(255 252 245 / 0.1);
}

.disabled\\:bg-warning-25\\/100:disabled{
  background-color: rgb(255 252 245 / 1);
}

.disabled\\:bg-warning-25\\/15:disabled{
  background-color: rgb(255 252 245 / 0.15);
}

.disabled\\:bg-warning-25\\/20:disabled{
  background-color: rgb(255 252 245 / 0.2);
}

.disabled\\:bg-warning-25\\/25:disabled{
  background-color: rgb(255 252 245 / 0.25);
}

.disabled\\:bg-warning-25\\/30:disabled{
  background-color: rgb(255 252 245 / 0.3);
}

.disabled\\:bg-warning-25\\/35:disabled{
  background-color: rgb(255 252 245 / 0.35);
}

.disabled\\:bg-warning-25\\/40:disabled{
  background-color: rgb(255 252 245 / 0.4);
}

.disabled\\:bg-warning-25\\/45:disabled{
  background-color: rgb(255 252 245 / 0.45);
}

.disabled\\:bg-warning-25\\/5:disabled{
  background-color: rgb(255 252 245 / 0.05);
}

.disabled\\:bg-warning-25\\/50:disabled{
  background-color: rgb(255 252 245 / 0.5);
}

.disabled\\:bg-warning-25\\/55:disabled{
  background-color: rgb(255 252 245 / 0.55);
}

.disabled\\:bg-warning-25\\/60:disabled{
  background-color: rgb(255 252 245 / 0.6);
}

.disabled\\:bg-warning-25\\/65:disabled{
  background-color: rgb(255 252 245 / 0.65);
}

.disabled\\:bg-warning-25\\/70:disabled{
  background-color: rgb(255 252 245 / 0.7);
}

.disabled\\:bg-warning-25\\/75:disabled{
  background-color: rgb(255 252 245 / 0.75);
}

.disabled\\:bg-warning-25\\/80:disabled{
  background-color: rgb(255 252 245 / 0.8);
}

.disabled\\:bg-warning-25\\/85:disabled{
  background-color: rgb(255 252 245 / 0.85);
}

.disabled\\:bg-warning-25\\/90:disabled{
  background-color: rgb(255 252 245 / 0.9);
}

.disabled\\:bg-warning-25\\/95:disabled{
  background-color: rgb(255 252 245 / 0.95);
}

.disabled\\:bg-warning-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(253 176 34 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-400\\/0:disabled{
  background-color: rgb(253 176 34 / 0);
}

.disabled\\:bg-warning-400\\/10:disabled{
  background-color: rgb(253 176 34 / 0.1);
}

.disabled\\:bg-warning-400\\/100:disabled{
  background-color: rgb(253 176 34 / 1);
}

.disabled\\:bg-warning-400\\/15:disabled{
  background-color: rgb(253 176 34 / 0.15);
}

.disabled\\:bg-warning-400\\/20:disabled{
  background-color: rgb(253 176 34 / 0.2);
}

.disabled\\:bg-warning-400\\/25:disabled{
  background-color: rgb(253 176 34 / 0.25);
}

.disabled\\:bg-warning-400\\/30:disabled{
  background-color: rgb(253 176 34 / 0.3);
}

.disabled\\:bg-warning-400\\/35:disabled{
  background-color: rgb(253 176 34 / 0.35);
}

.disabled\\:bg-warning-400\\/40:disabled{
  background-color: rgb(253 176 34 / 0.4);
}

.disabled\\:bg-warning-400\\/45:disabled{
  background-color: rgb(253 176 34 / 0.45);
}

.disabled\\:bg-warning-400\\/5:disabled{
  background-color: rgb(253 176 34 / 0.05);
}

.disabled\\:bg-warning-400\\/50:disabled{
  background-color: rgb(253 176 34 / 0.5);
}

.disabled\\:bg-warning-400\\/55:disabled{
  background-color: rgb(253 176 34 / 0.55);
}

.disabled\\:bg-warning-400\\/60:disabled{
  background-color: rgb(253 176 34 / 0.6);
}

.disabled\\:bg-warning-400\\/65:disabled{
  background-color: rgb(253 176 34 / 0.65);
}

.disabled\\:bg-warning-400\\/70:disabled{
  background-color: rgb(253 176 34 / 0.7);
}

.disabled\\:bg-warning-400\\/75:disabled{
  background-color: rgb(253 176 34 / 0.75);
}

.disabled\\:bg-warning-400\\/80:disabled{
  background-color: rgb(253 176 34 / 0.8);
}

.disabled\\:bg-warning-400\\/85:disabled{
  background-color: rgb(253 176 34 / 0.85);
}

.disabled\\:bg-warning-400\\/90:disabled{
  background-color: rgb(253 176 34 / 0.9);
}

.disabled\\:bg-warning-400\\/95:disabled{
  background-color: rgb(253 176 34 / 0.95);
}

.disabled\\:bg-warning-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-50\\/0:disabled{
  background-color: rgb(255 250 235 / 0);
}

.disabled\\:bg-warning-50\\/10:disabled{
  background-color: rgb(255 250 235 / 0.1);
}

.disabled\\:bg-warning-50\\/100:disabled{
  background-color: rgb(255 250 235 / 1);
}

.disabled\\:bg-warning-50\\/15:disabled{
  background-color: rgb(255 250 235 / 0.15);
}

.disabled\\:bg-warning-50\\/20:disabled{
  background-color: rgb(255 250 235 / 0.2);
}

.disabled\\:bg-warning-50\\/25:disabled{
  background-color: rgb(255 250 235 / 0.25);
}

.disabled\\:bg-warning-50\\/30:disabled{
  background-color: rgb(255 250 235 / 0.3);
}

.disabled\\:bg-warning-50\\/35:disabled{
  background-color: rgb(255 250 235 / 0.35);
}

.disabled\\:bg-warning-50\\/40:disabled{
  background-color: rgb(255 250 235 / 0.4);
}

.disabled\\:bg-warning-50\\/45:disabled{
  background-color: rgb(255 250 235 / 0.45);
}

.disabled\\:bg-warning-50\\/5:disabled{
  background-color: rgb(255 250 235 / 0.05);
}

.disabled\\:bg-warning-50\\/50:disabled{
  background-color: rgb(255 250 235 / 0.5);
}

.disabled\\:bg-warning-50\\/55:disabled{
  background-color: rgb(255 250 235 / 0.55);
}

.disabled\\:bg-warning-50\\/60:disabled{
  background-color: rgb(255 250 235 / 0.6);
}

.disabled\\:bg-warning-50\\/65:disabled{
  background-color: rgb(255 250 235 / 0.65);
}

.disabled\\:bg-warning-50\\/70:disabled{
  background-color: rgb(255 250 235 / 0.7);
}

.disabled\\:bg-warning-50\\/75:disabled{
  background-color: rgb(255 250 235 / 0.75);
}

.disabled\\:bg-warning-50\\/80:disabled{
  background-color: rgb(255 250 235 / 0.8);
}

.disabled\\:bg-warning-50\\/85:disabled{
  background-color: rgb(255 250 235 / 0.85);
}

.disabled\\:bg-warning-50\\/90:disabled{
  background-color: rgb(255 250 235 / 0.9);
}

.disabled\\:bg-warning-50\\/95:disabled{
  background-color: rgb(255 250 235 / 0.95);
}

.disabled\\:bg-warning-500:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-500\\/0:disabled{
  background-color: rgb(247 144 9 / 0);
}

.disabled\\:bg-warning-500\\/10:disabled{
  background-color: rgb(247 144 9 / 0.1);
}

.disabled\\:bg-warning-500\\/100:disabled{
  background-color: rgb(247 144 9 / 1);
}

.disabled\\:bg-warning-500\\/15:disabled{
  background-color: rgb(247 144 9 / 0.15);
}

.disabled\\:bg-warning-500\\/20:disabled{
  background-color: rgb(247 144 9 / 0.2);
}

.disabled\\:bg-warning-500\\/25:disabled{
  background-color: rgb(247 144 9 / 0.25);
}

.disabled\\:bg-warning-500\\/30:disabled{
  background-color: rgb(247 144 9 / 0.3);
}

.disabled\\:bg-warning-500\\/35:disabled{
  background-color: rgb(247 144 9 / 0.35);
}

.disabled\\:bg-warning-500\\/40:disabled{
  background-color: rgb(247 144 9 / 0.4);
}

.disabled\\:bg-warning-500\\/45:disabled{
  background-color: rgb(247 144 9 / 0.45);
}

.disabled\\:bg-warning-500\\/5:disabled{
  background-color: rgb(247 144 9 / 0.05);
}

.disabled\\:bg-warning-500\\/50:disabled{
  background-color: rgb(247 144 9 / 0.5);
}

.disabled\\:bg-warning-500\\/55:disabled{
  background-color: rgb(247 144 9 / 0.55);
}

.disabled\\:bg-warning-500\\/60:disabled{
  background-color: rgb(247 144 9 / 0.6);
}

.disabled\\:bg-warning-500\\/65:disabled{
  background-color: rgb(247 144 9 / 0.65);
}

.disabled\\:bg-warning-500\\/70:disabled{
  background-color: rgb(247 144 9 / 0.7);
}

.disabled\\:bg-warning-500\\/75:disabled{
  background-color: rgb(247 144 9 / 0.75);
}

.disabled\\:bg-warning-500\\/80:disabled{
  background-color: rgb(247 144 9 / 0.8);
}

.disabled\\:bg-warning-500\\/85:disabled{
  background-color: rgb(247 144 9 / 0.85);
}

.disabled\\:bg-warning-500\\/90:disabled{
  background-color: rgb(247 144 9 / 0.9);
}

.disabled\\:bg-warning-500\\/95:disabled{
  background-color: rgb(247 144 9 / 0.95);
}

.disabled\\:bg-warning-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(220 104 3 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-600\\/0:disabled{
  background-color: rgb(220 104 3 / 0);
}

.disabled\\:bg-warning-600\\/10:disabled{
  background-color: rgb(220 104 3 / 0.1);
}

.disabled\\:bg-warning-600\\/100:disabled{
  background-color: rgb(220 104 3 / 1);
}

.disabled\\:bg-warning-600\\/15:disabled{
  background-color: rgb(220 104 3 / 0.15);
}

.disabled\\:bg-warning-600\\/20:disabled{
  background-color: rgb(220 104 3 / 0.2);
}

.disabled\\:bg-warning-600\\/25:disabled{
  background-color: rgb(220 104 3 / 0.25);
}

.disabled\\:bg-warning-600\\/30:disabled{
  background-color: rgb(220 104 3 / 0.3);
}

.disabled\\:bg-warning-600\\/35:disabled{
  background-color: rgb(220 104 3 / 0.35);
}

.disabled\\:bg-warning-600\\/40:disabled{
  background-color: rgb(220 104 3 / 0.4);
}

.disabled\\:bg-warning-600\\/45:disabled{
  background-color: rgb(220 104 3 / 0.45);
}

.disabled\\:bg-warning-600\\/5:disabled{
  background-color: rgb(220 104 3 / 0.05);
}

.disabled\\:bg-warning-600\\/50:disabled{
  background-color: rgb(220 104 3 / 0.5);
}

.disabled\\:bg-warning-600\\/55:disabled{
  background-color: rgb(220 104 3 / 0.55);
}

.disabled\\:bg-warning-600\\/60:disabled{
  background-color: rgb(220 104 3 / 0.6);
}

.disabled\\:bg-warning-600\\/65:disabled{
  background-color: rgb(220 104 3 / 0.65);
}

.disabled\\:bg-warning-600\\/70:disabled{
  background-color: rgb(220 104 3 / 0.7);
}

.disabled\\:bg-warning-600\\/75:disabled{
  background-color: rgb(220 104 3 / 0.75);
}

.disabled\\:bg-warning-600\\/80:disabled{
  background-color: rgb(220 104 3 / 0.8);
}

.disabled\\:bg-warning-600\\/85:disabled{
  background-color: rgb(220 104 3 / 0.85);
}

.disabled\\:bg-warning-600\\/90:disabled{
  background-color: rgb(220 104 3 / 0.9);
}

.disabled\\:bg-warning-600\\/95:disabled{
  background-color: rgb(220 104 3 / 0.95);
}

.disabled\\:bg-warning-700:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(181 71 8 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-warning-700\\/0:disabled{
  background-color: rgb(181 71 8 / 0);
}

.disabled\\:bg-warning-700\\/10:disabled{
  background-color: rgb(181 71 8 / 0.1);
}

.disabled\\:bg-warning-700\\/100:disabled{
  background-color: rgb(181 71 8 / 1);
}

.disabled\\:bg-warning-700\\/15:disabled{
  background-color: rgb(181 71 8 / 0.15);
}

.disabled\\:bg-warning-700\\/20:disabled{
  background-color: rgb(181 71 8 / 0.2);
}

.disabled\\:bg-warning-700\\/25:disabled{
  background-color: rgb(181 71 8 / 0.25);
}

.disabled\\:bg-warning-700\\/30:disabled{
  background-color: rgb(181 71 8 / 0.3);
}

.disabled\\:bg-warning-700\\/35:disabled{
  background-color: rgb(181 71 8 / 0.35);
}

.disabled\\:bg-warning-700\\/40:disabled{
  background-color: rgb(181 71 8 / 0.4);
}

.disabled\\:bg-warning-700\\/45:disabled{
  background-color: rgb(181 71 8 / 0.45);
}

.disabled\\:bg-warning-700\\/5:disabled{
  background-color: rgb(181 71 8 / 0.05);
}

.disabled\\:bg-warning-700\\/50:disabled{
  background-color: rgb(181 71 8 / 0.5);
}

.disabled\\:bg-warning-700\\/55:disabled{
  background-color: rgb(181 71 8 / 0.55);
}

.disabled\\:bg-warning-700\\/60:disabled{
  background-color: rgb(181 71 8 / 0.6);
}

.disabled\\:bg-warning-700\\/65:disabled{
  background-color: rgb(181 71 8 / 0.65);
}

.disabled\\:bg-warning-700\\/70:disabled{
  background-color: rgb(181 71 8 / 0.7);
}

.disabled\\:bg-warning-700\\/75:disabled{
  background-color: rgb(181 71 8 / 0.75);
}

.disabled\\:bg-warning-700\\/80:disabled{
  background-color: rgb(181 71 8 / 0.8);
}

.disabled\\:bg-warning-700\\/85:disabled{
  background-color: rgb(181 71 8 / 0.85);
}

.disabled\\:bg-warning-700\\/90:disabled{
  background-color: rgb(181 71 8 / 0.9);
}

.disabled\\:bg-warning-700\\/95:disabled{
  background-color: rgb(181 71 8 / 0.95);
}

.disabled\\:\\!text-neutral-500:disabled{
  --tw-text-opacity: 1 !important;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1)) !important;
}

.disabled\\:text-\\[color\\:var\\(--color-on-primary\\2c \\#fff\\)\\]:disabled{
  color: var(--color-on-primary,#fff);
}

.disabled\\:text-danger-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(254 228 226 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-100\\/0:disabled{
  color: rgb(254 228 226 / 0);
}

.disabled\\:text-danger-100\\/10:disabled{
  color: rgb(254 228 226 / 0.1);
}

.disabled\\:text-danger-100\\/100:disabled{
  color: rgb(254 228 226 / 1);
}

.disabled\\:text-danger-100\\/15:disabled{
  color: rgb(254 228 226 / 0.15);
}

.disabled\\:text-danger-100\\/20:disabled{
  color: rgb(254 228 226 / 0.2);
}

.disabled\\:text-danger-100\\/25:disabled{
  color: rgb(254 228 226 / 0.25);
}

.disabled\\:text-danger-100\\/30:disabled{
  color: rgb(254 228 226 / 0.3);
}

.disabled\\:text-danger-100\\/35:disabled{
  color: rgb(254 228 226 / 0.35);
}

.disabled\\:text-danger-100\\/40:disabled{
  color: rgb(254 228 226 / 0.4);
}

.disabled\\:text-danger-100\\/45:disabled{
  color: rgb(254 228 226 / 0.45);
}

.disabled\\:text-danger-100\\/5:disabled{
  color: rgb(254 228 226 / 0.05);
}

.disabled\\:text-danger-100\\/50:disabled{
  color: rgb(254 228 226 / 0.5);
}

.disabled\\:text-danger-100\\/55:disabled{
  color: rgb(254 228 226 / 0.55);
}

.disabled\\:text-danger-100\\/60:disabled{
  color: rgb(254 228 226 / 0.6);
}

.disabled\\:text-danger-100\\/65:disabled{
  color: rgb(254 228 226 / 0.65);
}

.disabled\\:text-danger-100\\/70:disabled{
  color: rgb(254 228 226 / 0.7);
}

.disabled\\:text-danger-100\\/75:disabled{
  color: rgb(254 228 226 / 0.75);
}

.disabled\\:text-danger-100\\/80:disabled{
  color: rgb(254 228 226 / 0.8);
}

.disabled\\:text-danger-100\\/85:disabled{
  color: rgb(254 228 226 / 0.85);
}

.disabled\\:text-danger-100\\/90:disabled{
  color: rgb(254 228 226 / 0.9);
}

.disabled\\:text-danger-100\\/95:disabled{
  color: rgb(254 228 226 / 0.95);
}

.disabled\\:text-danger-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(254 205 202 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-200\\/0:disabled{
  color: rgb(254 205 202 / 0);
}

.disabled\\:text-danger-200\\/10:disabled{
  color: rgb(254 205 202 / 0.1);
}

.disabled\\:text-danger-200\\/100:disabled{
  color: rgb(254 205 202 / 1);
}

.disabled\\:text-danger-200\\/15:disabled{
  color: rgb(254 205 202 / 0.15);
}

.disabled\\:text-danger-200\\/20:disabled{
  color: rgb(254 205 202 / 0.2);
}

.disabled\\:text-danger-200\\/25:disabled{
  color: rgb(254 205 202 / 0.25);
}

.disabled\\:text-danger-200\\/30:disabled{
  color: rgb(254 205 202 / 0.3);
}

.disabled\\:text-danger-200\\/35:disabled{
  color: rgb(254 205 202 / 0.35);
}

.disabled\\:text-danger-200\\/40:disabled{
  color: rgb(254 205 202 / 0.4);
}

.disabled\\:text-danger-200\\/45:disabled{
  color: rgb(254 205 202 / 0.45);
}

.disabled\\:text-danger-200\\/5:disabled{
  color: rgb(254 205 202 / 0.05);
}

.disabled\\:text-danger-200\\/50:disabled{
  color: rgb(254 205 202 / 0.5);
}

.disabled\\:text-danger-200\\/55:disabled{
  color: rgb(254 205 202 / 0.55);
}

.disabled\\:text-danger-200\\/60:disabled{
  color: rgb(254 205 202 / 0.6);
}

.disabled\\:text-danger-200\\/65:disabled{
  color: rgb(254 205 202 / 0.65);
}

.disabled\\:text-danger-200\\/70:disabled{
  color: rgb(254 205 202 / 0.7);
}

.disabled\\:text-danger-200\\/75:disabled{
  color: rgb(254 205 202 / 0.75);
}

.disabled\\:text-danger-200\\/80:disabled{
  color: rgb(254 205 202 / 0.8);
}

.disabled\\:text-danger-200\\/85:disabled{
  color: rgb(254 205 202 / 0.85);
}

.disabled\\:text-danger-200\\/90:disabled{
  color: rgb(254 205 202 / 0.9);
}

.disabled\\:text-danger-200\\/95:disabled{
  color: rgb(254 205 202 / 0.95);
}

.disabled\\:text-danger-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(255 251 250 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-25\\/0:disabled{
  color: rgb(255 251 250 / 0);
}

.disabled\\:text-danger-25\\/10:disabled{
  color: rgb(255 251 250 / 0.1);
}

.disabled\\:text-danger-25\\/100:disabled{
  color: rgb(255 251 250 / 1);
}

.disabled\\:text-danger-25\\/15:disabled{
  color: rgb(255 251 250 / 0.15);
}

.disabled\\:text-danger-25\\/20:disabled{
  color: rgb(255 251 250 / 0.2);
}

.disabled\\:text-danger-25\\/25:disabled{
  color: rgb(255 251 250 / 0.25);
}

.disabled\\:text-danger-25\\/30:disabled{
  color: rgb(255 251 250 / 0.3);
}

.disabled\\:text-danger-25\\/35:disabled{
  color: rgb(255 251 250 / 0.35);
}

.disabled\\:text-danger-25\\/40:disabled{
  color: rgb(255 251 250 / 0.4);
}

.disabled\\:text-danger-25\\/45:disabled{
  color: rgb(255 251 250 / 0.45);
}

.disabled\\:text-danger-25\\/5:disabled{
  color: rgb(255 251 250 / 0.05);
}

.disabled\\:text-danger-25\\/50:disabled{
  color: rgb(255 251 250 / 0.5);
}

.disabled\\:text-danger-25\\/55:disabled{
  color: rgb(255 251 250 / 0.55);
}

.disabled\\:text-danger-25\\/60:disabled{
  color: rgb(255 251 250 / 0.6);
}

.disabled\\:text-danger-25\\/65:disabled{
  color: rgb(255 251 250 / 0.65);
}

.disabled\\:text-danger-25\\/70:disabled{
  color: rgb(255 251 250 / 0.7);
}

.disabled\\:text-danger-25\\/75:disabled{
  color: rgb(255 251 250 / 0.75);
}

.disabled\\:text-danger-25\\/80:disabled{
  color: rgb(255 251 250 / 0.8);
}

.disabled\\:text-danger-25\\/85:disabled{
  color: rgb(255 251 250 / 0.85);
}

.disabled\\:text-danger-25\\/90:disabled{
  color: rgb(255 251 250 / 0.9);
}

.disabled\\:text-danger-25\\/95:disabled{
  color: rgb(255 251 250 / 0.95);
}

.disabled\\:text-danger-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(249 112 102 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-400\\/0:disabled{
  color: rgb(249 112 102 / 0);
}

.disabled\\:text-danger-400\\/10:disabled{
  color: rgb(249 112 102 / 0.1);
}

.disabled\\:text-danger-400\\/100:disabled{
  color: rgb(249 112 102 / 1);
}

.disabled\\:text-danger-400\\/15:disabled{
  color: rgb(249 112 102 / 0.15);
}

.disabled\\:text-danger-400\\/20:disabled{
  color: rgb(249 112 102 / 0.2);
}

.disabled\\:text-danger-400\\/25:disabled{
  color: rgb(249 112 102 / 0.25);
}

.disabled\\:text-danger-400\\/30:disabled{
  color: rgb(249 112 102 / 0.3);
}

.disabled\\:text-danger-400\\/35:disabled{
  color: rgb(249 112 102 / 0.35);
}

.disabled\\:text-danger-400\\/40:disabled{
  color: rgb(249 112 102 / 0.4);
}

.disabled\\:text-danger-400\\/45:disabled{
  color: rgb(249 112 102 / 0.45);
}

.disabled\\:text-danger-400\\/5:disabled{
  color: rgb(249 112 102 / 0.05);
}

.disabled\\:text-danger-400\\/50:disabled{
  color: rgb(249 112 102 / 0.5);
}

.disabled\\:text-danger-400\\/55:disabled{
  color: rgb(249 112 102 / 0.55);
}

.disabled\\:text-danger-400\\/60:disabled{
  color: rgb(249 112 102 / 0.6);
}

.disabled\\:text-danger-400\\/65:disabled{
  color: rgb(249 112 102 / 0.65);
}

.disabled\\:text-danger-400\\/70:disabled{
  color: rgb(249 112 102 / 0.7);
}

.disabled\\:text-danger-400\\/75:disabled{
  color: rgb(249 112 102 / 0.75);
}

.disabled\\:text-danger-400\\/80:disabled{
  color: rgb(249 112 102 / 0.8);
}

.disabled\\:text-danger-400\\/85:disabled{
  color: rgb(249 112 102 / 0.85);
}

.disabled\\:text-danger-400\\/90:disabled{
  color: rgb(249 112 102 / 0.9);
}

.disabled\\:text-danger-400\\/95:disabled{
  color: rgb(249 112 102 / 0.95);
}

.disabled\\:text-danger-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(254 243 242 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-50\\/0:disabled{
  color: rgb(254 243 242 / 0);
}

.disabled\\:text-danger-50\\/10:disabled{
  color: rgb(254 243 242 / 0.1);
}

.disabled\\:text-danger-50\\/100:disabled{
  color: rgb(254 243 242 / 1);
}

.disabled\\:text-danger-50\\/15:disabled{
  color: rgb(254 243 242 / 0.15);
}

.disabled\\:text-danger-50\\/20:disabled{
  color: rgb(254 243 242 / 0.2);
}

.disabled\\:text-danger-50\\/25:disabled{
  color: rgb(254 243 242 / 0.25);
}

.disabled\\:text-danger-50\\/30:disabled{
  color: rgb(254 243 242 / 0.3);
}

.disabled\\:text-danger-50\\/35:disabled{
  color: rgb(254 243 242 / 0.35);
}

.disabled\\:text-danger-50\\/40:disabled{
  color: rgb(254 243 242 / 0.4);
}

.disabled\\:text-danger-50\\/45:disabled{
  color: rgb(254 243 242 / 0.45);
}

.disabled\\:text-danger-50\\/5:disabled{
  color: rgb(254 243 242 / 0.05);
}

.disabled\\:text-danger-50\\/50:disabled{
  color: rgb(254 243 242 / 0.5);
}

.disabled\\:text-danger-50\\/55:disabled{
  color: rgb(254 243 242 / 0.55);
}

.disabled\\:text-danger-50\\/60:disabled{
  color: rgb(254 243 242 / 0.6);
}

.disabled\\:text-danger-50\\/65:disabled{
  color: rgb(254 243 242 / 0.65);
}

.disabled\\:text-danger-50\\/70:disabled{
  color: rgb(254 243 242 / 0.7);
}

.disabled\\:text-danger-50\\/75:disabled{
  color: rgb(254 243 242 / 0.75);
}

.disabled\\:text-danger-50\\/80:disabled{
  color: rgb(254 243 242 / 0.8);
}

.disabled\\:text-danger-50\\/85:disabled{
  color: rgb(254 243 242 / 0.85);
}

.disabled\\:text-danger-50\\/90:disabled{
  color: rgb(254 243 242 / 0.9);
}

.disabled\\:text-danger-50\\/95:disabled{
  color: rgb(254 243 242 / 0.95);
}

.disabled\\:text-danger-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(240 68 56 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-500\\/0:disabled{
  color: rgb(240 68 56 / 0);
}

.disabled\\:text-danger-500\\/10:disabled{
  color: rgb(240 68 56 / 0.1);
}

.disabled\\:text-danger-500\\/100:disabled{
  color: rgb(240 68 56 / 1);
}

.disabled\\:text-danger-500\\/15:disabled{
  color: rgb(240 68 56 / 0.15);
}

.disabled\\:text-danger-500\\/20:disabled{
  color: rgb(240 68 56 / 0.2);
}

.disabled\\:text-danger-500\\/25:disabled{
  color: rgb(240 68 56 / 0.25);
}

.disabled\\:text-danger-500\\/30:disabled{
  color: rgb(240 68 56 / 0.3);
}

.disabled\\:text-danger-500\\/35:disabled{
  color: rgb(240 68 56 / 0.35);
}

.disabled\\:text-danger-500\\/40:disabled{
  color: rgb(240 68 56 / 0.4);
}

.disabled\\:text-danger-500\\/45:disabled{
  color: rgb(240 68 56 / 0.45);
}

.disabled\\:text-danger-500\\/5:disabled{
  color: rgb(240 68 56 / 0.05);
}

.disabled\\:text-danger-500\\/50:disabled{
  color: rgb(240 68 56 / 0.5);
}

.disabled\\:text-danger-500\\/55:disabled{
  color: rgb(240 68 56 / 0.55);
}

.disabled\\:text-danger-500\\/60:disabled{
  color: rgb(240 68 56 / 0.6);
}

.disabled\\:text-danger-500\\/65:disabled{
  color: rgb(240 68 56 / 0.65);
}

.disabled\\:text-danger-500\\/70:disabled{
  color: rgb(240 68 56 / 0.7);
}

.disabled\\:text-danger-500\\/75:disabled{
  color: rgb(240 68 56 / 0.75);
}

.disabled\\:text-danger-500\\/80:disabled{
  color: rgb(240 68 56 / 0.8);
}

.disabled\\:text-danger-500\\/85:disabled{
  color: rgb(240 68 56 / 0.85);
}

.disabled\\:text-danger-500\\/90:disabled{
  color: rgb(240 68 56 / 0.9);
}

.disabled\\:text-danger-500\\/95:disabled{
  color: rgb(240 68 56 / 0.95);
}

.disabled\\:text-danger-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-600\\/0:disabled{
  color: rgb(217 45 32 / 0);
}

.disabled\\:text-danger-600\\/10:disabled{
  color: rgb(217 45 32 / 0.1);
}

.disabled\\:text-danger-600\\/100:disabled{
  color: rgb(217 45 32 / 1);
}

.disabled\\:text-danger-600\\/15:disabled{
  color: rgb(217 45 32 / 0.15);
}

.disabled\\:text-danger-600\\/20:disabled{
  color: rgb(217 45 32 / 0.2);
}

.disabled\\:text-danger-600\\/25:disabled{
  color: rgb(217 45 32 / 0.25);
}

.disabled\\:text-danger-600\\/30:disabled{
  color: rgb(217 45 32 / 0.3);
}

.disabled\\:text-danger-600\\/35:disabled{
  color: rgb(217 45 32 / 0.35);
}

.disabled\\:text-danger-600\\/40:disabled{
  color: rgb(217 45 32 / 0.4);
}

.disabled\\:text-danger-600\\/45:disabled{
  color: rgb(217 45 32 / 0.45);
}

.disabled\\:text-danger-600\\/5:disabled{
  color: rgb(217 45 32 / 0.05);
}

.disabled\\:text-danger-600\\/50:disabled{
  color: rgb(217 45 32 / 0.5);
}

.disabled\\:text-danger-600\\/55:disabled{
  color: rgb(217 45 32 / 0.55);
}

.disabled\\:text-danger-600\\/60:disabled{
  color: rgb(217 45 32 / 0.6);
}

.disabled\\:text-danger-600\\/65:disabled{
  color: rgb(217 45 32 / 0.65);
}

.disabled\\:text-danger-600\\/70:disabled{
  color: rgb(217 45 32 / 0.7);
}

.disabled\\:text-danger-600\\/75:disabled{
  color: rgb(217 45 32 / 0.75);
}

.disabled\\:text-danger-600\\/80:disabled{
  color: rgb(217 45 32 / 0.8);
}

.disabled\\:text-danger-600\\/85:disabled{
  color: rgb(217 45 32 / 0.85);
}

.disabled\\:text-danger-600\\/90:disabled{
  color: rgb(217 45 32 / 0.9);
}

.disabled\\:text-danger-600\\/95:disabled{
  color: rgb(217 45 32 / 0.95);
}

.disabled\\:text-danger-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}

.disabled\\:text-danger-700\\/0:disabled{
  color: rgb(180 35 24 / 0);
}

.disabled\\:text-danger-700\\/10:disabled{
  color: rgb(180 35 24 / 0.1);
}

.disabled\\:text-danger-700\\/100:disabled{
  color: rgb(180 35 24 / 1);
}

.disabled\\:text-danger-700\\/15:disabled{
  color: rgb(180 35 24 / 0.15);
}

.disabled\\:text-danger-700\\/20:disabled{
  color: rgb(180 35 24 / 0.2);
}

.disabled\\:text-danger-700\\/25:disabled{
  color: rgb(180 35 24 / 0.25);
}

.disabled\\:text-danger-700\\/30:disabled{
  color: rgb(180 35 24 / 0.3);
}

.disabled\\:text-danger-700\\/35:disabled{
  color: rgb(180 35 24 / 0.35);
}

.disabled\\:text-danger-700\\/40:disabled{
  color: rgb(180 35 24 / 0.4);
}

.disabled\\:text-danger-700\\/45:disabled{
  color: rgb(180 35 24 / 0.45);
}

.disabled\\:text-danger-700\\/5:disabled{
  color: rgb(180 35 24 / 0.05);
}

.disabled\\:text-danger-700\\/50:disabled{
  color: rgb(180 35 24 / 0.5);
}

.disabled\\:text-danger-700\\/55:disabled{
  color: rgb(180 35 24 / 0.55);
}

.disabled\\:text-danger-700\\/60:disabled{
  color: rgb(180 35 24 / 0.6);
}

.disabled\\:text-danger-700\\/65:disabled{
  color: rgb(180 35 24 / 0.65);
}

.disabled\\:text-danger-700\\/70:disabled{
  color: rgb(180 35 24 / 0.7);
}

.disabled\\:text-danger-700\\/75:disabled{
  color: rgb(180 35 24 / 0.75);
}

.disabled\\:text-danger-700\\/80:disabled{
  color: rgb(180 35 24 / 0.8);
}

.disabled\\:text-danger-700\\/85:disabled{
  color: rgb(180 35 24 / 0.85);
}

.disabled\\:text-danger-700\\/90:disabled{
  color: rgb(180 35 24 / 0.9);
}

.disabled\\:text-danger-700\\/95:disabled{
  color: rgb(180 35 24 / 0.95);
}

.disabled\\:text-moss-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(230 244 215 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-100\\/0:disabled{
  color: rgb(230 244 215 / 0);
}

.disabled\\:text-moss-100\\/10:disabled{
  color: rgb(230 244 215 / 0.1);
}

.disabled\\:text-moss-100\\/100:disabled{
  color: rgb(230 244 215 / 1);
}

.disabled\\:text-moss-100\\/15:disabled{
  color: rgb(230 244 215 / 0.15);
}

.disabled\\:text-moss-100\\/20:disabled{
  color: rgb(230 244 215 / 0.2);
}

.disabled\\:text-moss-100\\/25:disabled{
  color: rgb(230 244 215 / 0.25);
}

.disabled\\:text-moss-100\\/30:disabled{
  color: rgb(230 244 215 / 0.3);
}

.disabled\\:text-moss-100\\/35:disabled{
  color: rgb(230 244 215 / 0.35);
}

.disabled\\:text-moss-100\\/40:disabled{
  color: rgb(230 244 215 / 0.4);
}

.disabled\\:text-moss-100\\/45:disabled{
  color: rgb(230 244 215 / 0.45);
}

.disabled\\:text-moss-100\\/5:disabled{
  color: rgb(230 244 215 / 0.05);
}

.disabled\\:text-moss-100\\/50:disabled{
  color: rgb(230 244 215 / 0.5);
}

.disabled\\:text-moss-100\\/55:disabled{
  color: rgb(230 244 215 / 0.55);
}

.disabled\\:text-moss-100\\/60:disabled{
  color: rgb(230 244 215 / 0.6);
}

.disabled\\:text-moss-100\\/65:disabled{
  color: rgb(230 244 215 / 0.65);
}

.disabled\\:text-moss-100\\/70:disabled{
  color: rgb(230 244 215 / 0.7);
}

.disabled\\:text-moss-100\\/75:disabled{
  color: rgb(230 244 215 / 0.75);
}

.disabled\\:text-moss-100\\/80:disabled{
  color: rgb(230 244 215 / 0.8);
}

.disabled\\:text-moss-100\\/85:disabled{
  color: rgb(230 244 215 / 0.85);
}

.disabled\\:text-moss-100\\/90:disabled{
  color: rgb(230 244 215 / 0.9);
}

.disabled\\:text-moss-100\\/95:disabled{
  color: rgb(230 244 215 / 0.95);
}

.disabled\\:text-moss-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(206 234 176 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-200\\/0:disabled{
  color: rgb(206 234 176 / 0);
}

.disabled\\:text-moss-200\\/10:disabled{
  color: rgb(206 234 176 / 0.1);
}

.disabled\\:text-moss-200\\/100:disabled{
  color: rgb(206 234 176 / 1);
}

.disabled\\:text-moss-200\\/15:disabled{
  color: rgb(206 234 176 / 0.15);
}

.disabled\\:text-moss-200\\/20:disabled{
  color: rgb(206 234 176 / 0.2);
}

.disabled\\:text-moss-200\\/25:disabled{
  color: rgb(206 234 176 / 0.25);
}

.disabled\\:text-moss-200\\/30:disabled{
  color: rgb(206 234 176 / 0.3);
}

.disabled\\:text-moss-200\\/35:disabled{
  color: rgb(206 234 176 / 0.35);
}

.disabled\\:text-moss-200\\/40:disabled{
  color: rgb(206 234 176 / 0.4);
}

.disabled\\:text-moss-200\\/45:disabled{
  color: rgb(206 234 176 / 0.45);
}

.disabled\\:text-moss-200\\/5:disabled{
  color: rgb(206 234 176 / 0.05);
}

.disabled\\:text-moss-200\\/50:disabled{
  color: rgb(206 234 176 / 0.5);
}

.disabled\\:text-moss-200\\/55:disabled{
  color: rgb(206 234 176 / 0.55);
}

.disabled\\:text-moss-200\\/60:disabled{
  color: rgb(206 234 176 / 0.6);
}

.disabled\\:text-moss-200\\/65:disabled{
  color: rgb(206 234 176 / 0.65);
}

.disabled\\:text-moss-200\\/70:disabled{
  color: rgb(206 234 176 / 0.7);
}

.disabled\\:text-moss-200\\/75:disabled{
  color: rgb(206 234 176 / 0.75);
}

.disabled\\:text-moss-200\\/80:disabled{
  color: rgb(206 234 176 / 0.8);
}

.disabled\\:text-moss-200\\/85:disabled{
  color: rgb(206 234 176 / 0.85);
}

.disabled\\:text-moss-200\\/90:disabled{
  color: rgb(206 234 176 / 0.9);
}

.disabled\\:text-moss-200\\/95:disabled{
  color: rgb(206 234 176 / 0.95);
}

.disabled\\:text-moss-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(250 253 247 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-25\\/0:disabled{
  color: rgb(250 253 247 / 0);
}

.disabled\\:text-moss-25\\/10:disabled{
  color: rgb(250 253 247 / 0.1);
}

.disabled\\:text-moss-25\\/100:disabled{
  color: rgb(250 253 247 / 1);
}

.disabled\\:text-moss-25\\/15:disabled{
  color: rgb(250 253 247 / 0.15);
}

.disabled\\:text-moss-25\\/20:disabled{
  color: rgb(250 253 247 / 0.2);
}

.disabled\\:text-moss-25\\/25:disabled{
  color: rgb(250 253 247 / 0.25);
}

.disabled\\:text-moss-25\\/30:disabled{
  color: rgb(250 253 247 / 0.3);
}

.disabled\\:text-moss-25\\/35:disabled{
  color: rgb(250 253 247 / 0.35);
}

.disabled\\:text-moss-25\\/40:disabled{
  color: rgb(250 253 247 / 0.4);
}

.disabled\\:text-moss-25\\/45:disabled{
  color: rgb(250 253 247 / 0.45);
}

.disabled\\:text-moss-25\\/5:disabled{
  color: rgb(250 253 247 / 0.05);
}

.disabled\\:text-moss-25\\/50:disabled{
  color: rgb(250 253 247 / 0.5);
}

.disabled\\:text-moss-25\\/55:disabled{
  color: rgb(250 253 247 / 0.55);
}

.disabled\\:text-moss-25\\/60:disabled{
  color: rgb(250 253 247 / 0.6);
}

.disabled\\:text-moss-25\\/65:disabled{
  color: rgb(250 253 247 / 0.65);
}

.disabled\\:text-moss-25\\/70:disabled{
  color: rgb(250 253 247 / 0.7);
}

.disabled\\:text-moss-25\\/75:disabled{
  color: rgb(250 253 247 / 0.75);
}

.disabled\\:text-moss-25\\/80:disabled{
  color: rgb(250 253 247 / 0.8);
}

.disabled\\:text-moss-25\\/85:disabled{
  color: rgb(250 253 247 / 0.85);
}

.disabled\\:text-moss-25\\/90:disabled{
  color: rgb(250 253 247 / 0.9);
}

.disabled\\:text-moss-25\\/95:disabled{
  color: rgb(250 253 247 / 0.95);
}

.disabled\\:text-moss-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(134 203 60 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-400\\/0:disabled{
  color: rgb(134 203 60 / 0);
}

.disabled\\:text-moss-400\\/10:disabled{
  color: rgb(134 203 60 / 0.1);
}

.disabled\\:text-moss-400\\/100:disabled{
  color: rgb(134 203 60 / 1);
}

.disabled\\:text-moss-400\\/15:disabled{
  color: rgb(134 203 60 / 0.15);
}

.disabled\\:text-moss-400\\/20:disabled{
  color: rgb(134 203 60 / 0.2);
}

.disabled\\:text-moss-400\\/25:disabled{
  color: rgb(134 203 60 / 0.25);
}

.disabled\\:text-moss-400\\/30:disabled{
  color: rgb(134 203 60 / 0.3);
}

.disabled\\:text-moss-400\\/35:disabled{
  color: rgb(134 203 60 / 0.35);
}

.disabled\\:text-moss-400\\/40:disabled{
  color: rgb(134 203 60 / 0.4);
}

.disabled\\:text-moss-400\\/45:disabled{
  color: rgb(134 203 60 / 0.45);
}

.disabled\\:text-moss-400\\/5:disabled{
  color: rgb(134 203 60 / 0.05);
}

.disabled\\:text-moss-400\\/50:disabled{
  color: rgb(134 203 60 / 0.5);
}

.disabled\\:text-moss-400\\/55:disabled{
  color: rgb(134 203 60 / 0.55);
}

.disabled\\:text-moss-400\\/60:disabled{
  color: rgb(134 203 60 / 0.6);
}

.disabled\\:text-moss-400\\/65:disabled{
  color: rgb(134 203 60 / 0.65);
}

.disabled\\:text-moss-400\\/70:disabled{
  color: rgb(134 203 60 / 0.7);
}

.disabled\\:text-moss-400\\/75:disabled{
  color: rgb(134 203 60 / 0.75);
}

.disabled\\:text-moss-400\\/80:disabled{
  color: rgb(134 203 60 / 0.8);
}

.disabled\\:text-moss-400\\/85:disabled{
  color: rgb(134 203 60 / 0.85);
}

.disabled\\:text-moss-400\\/90:disabled{
  color: rgb(134 203 60 / 0.9);
}

.disabled\\:text-moss-400\\/95:disabled{
  color: rgb(134 203 60 / 0.95);
}

.disabled\\:text-moss-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(245 251 238 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-50\\/0:disabled{
  color: rgb(245 251 238 / 0);
}

.disabled\\:text-moss-50\\/10:disabled{
  color: rgb(245 251 238 / 0.1);
}

.disabled\\:text-moss-50\\/100:disabled{
  color: rgb(245 251 238 / 1);
}

.disabled\\:text-moss-50\\/15:disabled{
  color: rgb(245 251 238 / 0.15);
}

.disabled\\:text-moss-50\\/20:disabled{
  color: rgb(245 251 238 / 0.2);
}

.disabled\\:text-moss-50\\/25:disabled{
  color: rgb(245 251 238 / 0.25);
}

.disabled\\:text-moss-50\\/30:disabled{
  color: rgb(245 251 238 / 0.3);
}

.disabled\\:text-moss-50\\/35:disabled{
  color: rgb(245 251 238 / 0.35);
}

.disabled\\:text-moss-50\\/40:disabled{
  color: rgb(245 251 238 / 0.4);
}

.disabled\\:text-moss-50\\/45:disabled{
  color: rgb(245 251 238 / 0.45);
}

.disabled\\:text-moss-50\\/5:disabled{
  color: rgb(245 251 238 / 0.05);
}

.disabled\\:text-moss-50\\/50:disabled{
  color: rgb(245 251 238 / 0.5);
}

.disabled\\:text-moss-50\\/55:disabled{
  color: rgb(245 251 238 / 0.55);
}

.disabled\\:text-moss-50\\/60:disabled{
  color: rgb(245 251 238 / 0.6);
}

.disabled\\:text-moss-50\\/65:disabled{
  color: rgb(245 251 238 / 0.65);
}

.disabled\\:text-moss-50\\/70:disabled{
  color: rgb(245 251 238 / 0.7);
}

.disabled\\:text-moss-50\\/75:disabled{
  color: rgb(245 251 238 / 0.75);
}

.disabled\\:text-moss-50\\/80:disabled{
  color: rgb(245 251 238 / 0.8);
}

.disabled\\:text-moss-50\\/85:disabled{
  color: rgb(245 251 238 / 0.85);
}

.disabled\\:text-moss-50\\/90:disabled{
  color: rgb(245 251 238 / 0.9);
}

.disabled\\:text-moss-50\\/95:disabled{
  color: rgb(245 251 238 / 0.95);
}

.disabled\\:text-moss-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(102 159 42 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-500\\/0:disabled{
  color: rgb(102 159 42 / 0);
}

.disabled\\:text-moss-500\\/10:disabled{
  color: rgb(102 159 42 / 0.1);
}

.disabled\\:text-moss-500\\/100:disabled{
  color: rgb(102 159 42 / 1);
}

.disabled\\:text-moss-500\\/15:disabled{
  color: rgb(102 159 42 / 0.15);
}

.disabled\\:text-moss-500\\/20:disabled{
  color: rgb(102 159 42 / 0.2);
}

.disabled\\:text-moss-500\\/25:disabled{
  color: rgb(102 159 42 / 0.25);
}

.disabled\\:text-moss-500\\/30:disabled{
  color: rgb(102 159 42 / 0.3);
}

.disabled\\:text-moss-500\\/35:disabled{
  color: rgb(102 159 42 / 0.35);
}

.disabled\\:text-moss-500\\/40:disabled{
  color: rgb(102 159 42 / 0.4);
}

.disabled\\:text-moss-500\\/45:disabled{
  color: rgb(102 159 42 / 0.45);
}

.disabled\\:text-moss-500\\/5:disabled{
  color: rgb(102 159 42 / 0.05);
}

.disabled\\:text-moss-500\\/50:disabled{
  color: rgb(102 159 42 / 0.5);
}

.disabled\\:text-moss-500\\/55:disabled{
  color: rgb(102 159 42 / 0.55);
}

.disabled\\:text-moss-500\\/60:disabled{
  color: rgb(102 159 42 / 0.6);
}

.disabled\\:text-moss-500\\/65:disabled{
  color: rgb(102 159 42 / 0.65);
}

.disabled\\:text-moss-500\\/70:disabled{
  color: rgb(102 159 42 / 0.7);
}

.disabled\\:text-moss-500\\/75:disabled{
  color: rgb(102 159 42 / 0.75);
}

.disabled\\:text-moss-500\\/80:disabled{
  color: rgb(102 159 42 / 0.8);
}

.disabled\\:text-moss-500\\/85:disabled{
  color: rgb(102 159 42 / 0.85);
}

.disabled\\:text-moss-500\\/90:disabled{
  color: rgb(102 159 42 / 0.9);
}

.disabled\\:text-moss-500\\/95:disabled{
  color: rgb(102 159 42 / 0.95);
}

.disabled\\:text-moss-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(79 122 33 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-600\\/0:disabled{
  color: rgb(79 122 33 / 0);
}

.disabled\\:text-moss-600\\/10:disabled{
  color: rgb(79 122 33 / 0.1);
}

.disabled\\:text-moss-600\\/100:disabled{
  color: rgb(79 122 33 / 1);
}

.disabled\\:text-moss-600\\/15:disabled{
  color: rgb(79 122 33 / 0.15);
}

.disabled\\:text-moss-600\\/20:disabled{
  color: rgb(79 122 33 / 0.2);
}

.disabled\\:text-moss-600\\/25:disabled{
  color: rgb(79 122 33 / 0.25);
}

.disabled\\:text-moss-600\\/30:disabled{
  color: rgb(79 122 33 / 0.3);
}

.disabled\\:text-moss-600\\/35:disabled{
  color: rgb(79 122 33 / 0.35);
}

.disabled\\:text-moss-600\\/40:disabled{
  color: rgb(79 122 33 / 0.4);
}

.disabled\\:text-moss-600\\/45:disabled{
  color: rgb(79 122 33 / 0.45);
}

.disabled\\:text-moss-600\\/5:disabled{
  color: rgb(79 122 33 / 0.05);
}

.disabled\\:text-moss-600\\/50:disabled{
  color: rgb(79 122 33 / 0.5);
}

.disabled\\:text-moss-600\\/55:disabled{
  color: rgb(79 122 33 / 0.55);
}

.disabled\\:text-moss-600\\/60:disabled{
  color: rgb(79 122 33 / 0.6);
}

.disabled\\:text-moss-600\\/65:disabled{
  color: rgb(79 122 33 / 0.65);
}

.disabled\\:text-moss-600\\/70:disabled{
  color: rgb(79 122 33 / 0.7);
}

.disabled\\:text-moss-600\\/75:disabled{
  color: rgb(79 122 33 / 0.75);
}

.disabled\\:text-moss-600\\/80:disabled{
  color: rgb(79 122 33 / 0.8);
}

.disabled\\:text-moss-600\\/85:disabled{
  color: rgb(79 122 33 / 0.85);
}

.disabled\\:text-moss-600\\/90:disabled{
  color: rgb(79 122 33 / 0.9);
}

.disabled\\:text-moss-600\\/95:disabled{
  color: rgb(79 122 33 / 0.95);
}

.disabled\\:text-moss-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(63 98 26 / var(--tw-text-opacity, 1));
}

.disabled\\:text-moss-700\\/0:disabled{
  color: rgb(63 98 26 / 0);
}

.disabled\\:text-moss-700\\/10:disabled{
  color: rgb(63 98 26 / 0.1);
}

.disabled\\:text-moss-700\\/100:disabled{
  color: rgb(63 98 26 / 1);
}

.disabled\\:text-moss-700\\/15:disabled{
  color: rgb(63 98 26 / 0.15);
}

.disabled\\:text-moss-700\\/20:disabled{
  color: rgb(63 98 26 / 0.2);
}

.disabled\\:text-moss-700\\/25:disabled{
  color: rgb(63 98 26 / 0.25);
}

.disabled\\:text-moss-700\\/30:disabled{
  color: rgb(63 98 26 / 0.3);
}

.disabled\\:text-moss-700\\/35:disabled{
  color: rgb(63 98 26 / 0.35);
}

.disabled\\:text-moss-700\\/40:disabled{
  color: rgb(63 98 26 / 0.4);
}

.disabled\\:text-moss-700\\/45:disabled{
  color: rgb(63 98 26 / 0.45);
}

.disabled\\:text-moss-700\\/5:disabled{
  color: rgb(63 98 26 / 0.05);
}

.disabled\\:text-moss-700\\/50:disabled{
  color: rgb(63 98 26 / 0.5);
}

.disabled\\:text-moss-700\\/55:disabled{
  color: rgb(63 98 26 / 0.55);
}

.disabled\\:text-moss-700\\/60:disabled{
  color: rgb(63 98 26 / 0.6);
}

.disabled\\:text-moss-700\\/65:disabled{
  color: rgb(63 98 26 / 0.65);
}

.disabled\\:text-moss-700\\/70:disabled{
  color: rgb(63 98 26 / 0.7);
}

.disabled\\:text-moss-700\\/75:disabled{
  color: rgb(63 98 26 / 0.75);
}

.disabled\\:text-moss-700\\/80:disabled{
  color: rgb(63 98 26 / 0.8);
}

.disabled\\:text-moss-700\\/85:disabled{
  color: rgb(63 98 26 / 0.85);
}

.disabled\\:text-moss-700\\/90:disabled{
  color: rgb(63 98 26 / 0.9);
}

.disabled\\:text-moss-700\\/95:disabled{
  color: rgb(63 98 26 / 0.95);
}

.disabled\\:text-neutral-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-100\\/0:disabled{
  color: rgb(245 245 245 / 0);
}

.disabled\\:text-neutral-100\\/10:disabled{
  color: rgb(245 245 245 / 0.1);
}

.disabled\\:text-neutral-100\\/100:disabled{
  color: rgb(245 245 245 / 1);
}

.disabled\\:text-neutral-100\\/15:disabled{
  color: rgb(245 245 245 / 0.15);
}

.disabled\\:text-neutral-100\\/20:disabled{
  color: rgb(245 245 245 / 0.2);
}

.disabled\\:text-neutral-100\\/25:disabled{
  color: rgb(245 245 245 / 0.25);
}

.disabled\\:text-neutral-100\\/30:disabled{
  color: rgb(245 245 245 / 0.3);
}

.disabled\\:text-neutral-100\\/35:disabled{
  color: rgb(245 245 245 / 0.35);
}

.disabled\\:text-neutral-100\\/40:disabled{
  color: rgb(245 245 245 / 0.4);
}

.disabled\\:text-neutral-100\\/45:disabled{
  color: rgb(245 245 245 / 0.45);
}

.disabled\\:text-neutral-100\\/5:disabled{
  color: rgb(245 245 245 / 0.05);
}

.disabled\\:text-neutral-100\\/50:disabled{
  color: rgb(245 245 245 / 0.5);
}

.disabled\\:text-neutral-100\\/55:disabled{
  color: rgb(245 245 245 / 0.55);
}

.disabled\\:text-neutral-100\\/60:disabled{
  color: rgb(245 245 245 / 0.6);
}

.disabled\\:text-neutral-100\\/65:disabled{
  color: rgb(245 245 245 / 0.65);
}

.disabled\\:text-neutral-100\\/70:disabled{
  color: rgb(245 245 245 / 0.7);
}

.disabled\\:text-neutral-100\\/75:disabled{
  color: rgb(245 245 245 / 0.75);
}

.disabled\\:text-neutral-100\\/80:disabled{
  color: rgb(245 245 245 / 0.8);
}

.disabled\\:text-neutral-100\\/85:disabled{
  color: rgb(245 245 245 / 0.85);
}

.disabled\\:text-neutral-100\\/90:disabled{
  color: rgb(245 245 245 / 0.9);
}

.disabled\\:text-neutral-100\\/95:disabled{
  color: rgb(245 245 245 / 0.95);
}

.disabled\\:text-neutral-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(233 234 235 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-200\\/0:disabled{
  color: rgb(233 234 235 / 0);
}

.disabled\\:text-neutral-200\\/10:disabled{
  color: rgb(233 234 235 / 0.1);
}

.disabled\\:text-neutral-200\\/100:disabled{
  color: rgb(233 234 235 / 1);
}

.disabled\\:text-neutral-200\\/15:disabled{
  color: rgb(233 234 235 / 0.15);
}

.disabled\\:text-neutral-200\\/20:disabled{
  color: rgb(233 234 235 / 0.2);
}

.disabled\\:text-neutral-200\\/25:disabled{
  color: rgb(233 234 235 / 0.25);
}

.disabled\\:text-neutral-200\\/30:disabled{
  color: rgb(233 234 235 / 0.3);
}

.disabled\\:text-neutral-200\\/35:disabled{
  color: rgb(233 234 235 / 0.35);
}

.disabled\\:text-neutral-200\\/40:disabled{
  color: rgb(233 234 235 / 0.4);
}

.disabled\\:text-neutral-200\\/45:disabled{
  color: rgb(233 234 235 / 0.45);
}

.disabled\\:text-neutral-200\\/5:disabled{
  color: rgb(233 234 235 / 0.05);
}

.disabled\\:text-neutral-200\\/50:disabled{
  color: rgb(233 234 235 / 0.5);
}

.disabled\\:text-neutral-200\\/55:disabled{
  color: rgb(233 234 235 / 0.55);
}

.disabled\\:text-neutral-200\\/60:disabled{
  color: rgb(233 234 235 / 0.6);
}

.disabled\\:text-neutral-200\\/65:disabled{
  color: rgb(233 234 235 / 0.65);
}

.disabled\\:text-neutral-200\\/70:disabled{
  color: rgb(233 234 235 / 0.7);
}

.disabled\\:text-neutral-200\\/75:disabled{
  color: rgb(233 234 235 / 0.75);
}

.disabled\\:text-neutral-200\\/80:disabled{
  color: rgb(233 234 235 / 0.8);
}

.disabled\\:text-neutral-200\\/85:disabled{
  color: rgb(233 234 235 / 0.85);
}

.disabled\\:text-neutral-200\\/90:disabled{
  color: rgb(233 234 235 / 0.9);
}

.disabled\\:text-neutral-200\\/95:disabled{
  color: rgb(233 234 235 / 0.95);
}

.disabled\\:text-neutral-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(253 253 253 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-25\\/0:disabled{
  color: rgb(253 253 253 / 0);
}

.disabled\\:text-neutral-25\\/10:disabled{
  color: rgb(253 253 253 / 0.1);
}

.disabled\\:text-neutral-25\\/100:disabled{
  color: rgb(253 253 253 / 1);
}

.disabled\\:text-neutral-25\\/15:disabled{
  color: rgb(253 253 253 / 0.15);
}

.disabled\\:text-neutral-25\\/20:disabled{
  color: rgb(253 253 253 / 0.2);
}

.disabled\\:text-neutral-25\\/25:disabled{
  color: rgb(253 253 253 / 0.25);
}

.disabled\\:text-neutral-25\\/30:disabled{
  color: rgb(253 253 253 / 0.3);
}

.disabled\\:text-neutral-25\\/35:disabled{
  color: rgb(253 253 253 / 0.35);
}

.disabled\\:text-neutral-25\\/40:disabled{
  color: rgb(253 253 253 / 0.4);
}

.disabled\\:text-neutral-25\\/45:disabled{
  color: rgb(253 253 253 / 0.45);
}

.disabled\\:text-neutral-25\\/5:disabled{
  color: rgb(253 253 253 / 0.05);
}

.disabled\\:text-neutral-25\\/50:disabled{
  color: rgb(253 253 253 / 0.5);
}

.disabled\\:text-neutral-25\\/55:disabled{
  color: rgb(253 253 253 / 0.55);
}

.disabled\\:text-neutral-25\\/60:disabled{
  color: rgb(253 253 253 / 0.6);
}

.disabled\\:text-neutral-25\\/65:disabled{
  color: rgb(253 253 253 / 0.65);
}

.disabled\\:text-neutral-25\\/70:disabled{
  color: rgb(253 253 253 / 0.7);
}

.disabled\\:text-neutral-25\\/75:disabled{
  color: rgb(253 253 253 / 0.75);
}

.disabled\\:text-neutral-25\\/80:disabled{
  color: rgb(253 253 253 / 0.8);
}

.disabled\\:text-neutral-25\\/85:disabled{
  color: rgb(253 253 253 / 0.85);
}

.disabled\\:text-neutral-25\\/90:disabled{
  color: rgb(253 253 253 / 0.9);
}

.disabled\\:text-neutral-25\\/95:disabled{
  color: rgb(253 253 253 / 0.95);
}

.disabled\\:text-neutral-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-400\\/0:disabled{
  color: rgb(164 167 174 / 0);
}

.disabled\\:text-neutral-400\\/10:disabled{
  color: rgb(164 167 174 / 0.1);
}

.disabled\\:text-neutral-400\\/100:disabled{
  color: rgb(164 167 174 / 1);
}

.disabled\\:text-neutral-400\\/15:disabled{
  color: rgb(164 167 174 / 0.15);
}

.disabled\\:text-neutral-400\\/20:disabled{
  color: rgb(164 167 174 / 0.2);
}

.disabled\\:text-neutral-400\\/25:disabled{
  color: rgb(164 167 174 / 0.25);
}

.disabled\\:text-neutral-400\\/30:disabled{
  color: rgb(164 167 174 / 0.3);
}

.disabled\\:text-neutral-400\\/35:disabled{
  color: rgb(164 167 174 / 0.35);
}

.disabled\\:text-neutral-400\\/40:disabled{
  color: rgb(164 167 174 / 0.4);
}

.disabled\\:text-neutral-400\\/45:disabled{
  color: rgb(164 167 174 / 0.45);
}

.disabled\\:text-neutral-400\\/5:disabled{
  color: rgb(164 167 174 / 0.05);
}

.disabled\\:text-neutral-400\\/50:disabled{
  color: rgb(164 167 174 / 0.5);
}

.disabled\\:text-neutral-400\\/55:disabled{
  color: rgb(164 167 174 / 0.55);
}

.disabled\\:text-neutral-400\\/60:disabled{
  color: rgb(164 167 174 / 0.6);
}

.disabled\\:text-neutral-400\\/65:disabled{
  color: rgb(164 167 174 / 0.65);
}

.disabled\\:text-neutral-400\\/70:disabled{
  color: rgb(164 167 174 / 0.7);
}

.disabled\\:text-neutral-400\\/75:disabled{
  color: rgb(164 167 174 / 0.75);
}

.disabled\\:text-neutral-400\\/80:disabled{
  color: rgb(164 167 174 / 0.8);
}

.disabled\\:text-neutral-400\\/85:disabled{
  color: rgb(164 167 174 / 0.85);
}

.disabled\\:text-neutral-400\\/90:disabled{
  color: rgb(164 167 174 / 0.9);
}

.disabled\\:text-neutral-400\\/95:disabled{
  color: rgb(164 167 174 / 0.95);
}

.disabled\\:text-neutral-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(249 250 250 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-50\\/0:disabled{
  color: rgb(249 250 250 / 0);
}

.disabled\\:text-neutral-50\\/10:disabled{
  color: rgb(249 250 250 / 0.1);
}

.disabled\\:text-neutral-50\\/100:disabled{
  color: rgb(249 250 250 / 1);
}

.disabled\\:text-neutral-50\\/15:disabled{
  color: rgb(249 250 250 / 0.15);
}

.disabled\\:text-neutral-50\\/20:disabled{
  color: rgb(249 250 250 / 0.2);
}

.disabled\\:text-neutral-50\\/25:disabled{
  color: rgb(249 250 250 / 0.25);
}

.disabled\\:text-neutral-50\\/30:disabled{
  color: rgb(249 250 250 / 0.3);
}

.disabled\\:text-neutral-50\\/35:disabled{
  color: rgb(249 250 250 / 0.35);
}

.disabled\\:text-neutral-50\\/40:disabled{
  color: rgb(249 250 250 / 0.4);
}

.disabled\\:text-neutral-50\\/45:disabled{
  color: rgb(249 250 250 / 0.45);
}

.disabled\\:text-neutral-50\\/5:disabled{
  color: rgb(249 250 250 / 0.05);
}

.disabled\\:text-neutral-50\\/50:disabled{
  color: rgb(249 250 250 / 0.5);
}

.disabled\\:text-neutral-50\\/55:disabled{
  color: rgb(249 250 250 / 0.55);
}

.disabled\\:text-neutral-50\\/60:disabled{
  color: rgb(249 250 250 / 0.6);
}

.disabled\\:text-neutral-50\\/65:disabled{
  color: rgb(249 250 250 / 0.65);
}

.disabled\\:text-neutral-50\\/70:disabled{
  color: rgb(249 250 250 / 0.7);
}

.disabled\\:text-neutral-50\\/75:disabled{
  color: rgb(249 250 250 / 0.75);
}

.disabled\\:text-neutral-50\\/80:disabled{
  color: rgb(249 250 250 / 0.8);
}

.disabled\\:text-neutral-50\\/85:disabled{
  color: rgb(249 250 250 / 0.85);
}

.disabled\\:text-neutral-50\\/90:disabled{
  color: rgb(249 250 250 / 0.9);
}

.disabled\\:text-neutral-50\\/95:disabled{
  color: rgb(249 250 250 / 0.95);
}

.disabled\\:text-neutral-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-500\\/0:disabled{
  color: rgb(113 118 128 / 0);
}

.disabled\\:text-neutral-500\\/10:disabled{
  color: rgb(113 118 128 / 0.1);
}

.disabled\\:text-neutral-500\\/100:disabled{
  color: rgb(113 118 128 / 1);
}

.disabled\\:text-neutral-500\\/15:disabled{
  color: rgb(113 118 128 / 0.15);
}

.disabled\\:text-neutral-500\\/20:disabled{
  color: rgb(113 118 128 / 0.2);
}

.disabled\\:text-neutral-500\\/25:disabled{
  color: rgb(113 118 128 / 0.25);
}

.disabled\\:text-neutral-500\\/30:disabled{
  color: rgb(113 118 128 / 0.3);
}

.disabled\\:text-neutral-500\\/35:disabled{
  color: rgb(113 118 128 / 0.35);
}

.disabled\\:text-neutral-500\\/40:disabled{
  color: rgb(113 118 128 / 0.4);
}

.disabled\\:text-neutral-500\\/45:disabled{
  color: rgb(113 118 128 / 0.45);
}

.disabled\\:text-neutral-500\\/5:disabled{
  color: rgb(113 118 128 / 0.05);
}

.disabled\\:text-neutral-500\\/50:disabled{
  color: rgb(113 118 128 / 0.5);
}

.disabled\\:text-neutral-500\\/55:disabled{
  color: rgb(113 118 128 / 0.55);
}

.disabled\\:text-neutral-500\\/60:disabled{
  color: rgb(113 118 128 / 0.6);
}

.disabled\\:text-neutral-500\\/65:disabled{
  color: rgb(113 118 128 / 0.65);
}

.disabled\\:text-neutral-500\\/70:disabled{
  color: rgb(113 118 128 / 0.7);
}

.disabled\\:text-neutral-500\\/75:disabled{
  color: rgb(113 118 128 / 0.75);
}

.disabled\\:text-neutral-500\\/80:disabled{
  color: rgb(113 118 128 / 0.8);
}

.disabled\\:text-neutral-500\\/85:disabled{
  color: rgb(113 118 128 / 0.85);
}

.disabled\\:text-neutral-500\\/90:disabled{
  color: rgb(113 118 128 / 0.9);
}

.disabled\\:text-neutral-500\\/95:disabled{
  color: rgb(113 118 128 / 0.95);
}

.disabled\\:text-neutral-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-600\\/0:disabled{
  color: rgb(83 88 98 / 0);
}

.disabled\\:text-neutral-600\\/10:disabled{
  color: rgb(83 88 98 / 0.1);
}

.disabled\\:text-neutral-600\\/100:disabled{
  color: rgb(83 88 98 / 1);
}

.disabled\\:text-neutral-600\\/15:disabled{
  color: rgb(83 88 98 / 0.15);
}

.disabled\\:text-neutral-600\\/20:disabled{
  color: rgb(83 88 98 / 0.2);
}

.disabled\\:text-neutral-600\\/25:disabled{
  color: rgb(83 88 98 / 0.25);
}

.disabled\\:text-neutral-600\\/30:disabled{
  color: rgb(83 88 98 / 0.3);
}

.disabled\\:text-neutral-600\\/35:disabled{
  color: rgb(83 88 98 / 0.35);
}

.disabled\\:text-neutral-600\\/40:disabled{
  color: rgb(83 88 98 / 0.4);
}

.disabled\\:text-neutral-600\\/45:disabled{
  color: rgb(83 88 98 / 0.45);
}

.disabled\\:text-neutral-600\\/5:disabled{
  color: rgb(83 88 98 / 0.05);
}

.disabled\\:text-neutral-600\\/50:disabled{
  color: rgb(83 88 98 / 0.5);
}

.disabled\\:text-neutral-600\\/55:disabled{
  color: rgb(83 88 98 / 0.55);
}

.disabled\\:text-neutral-600\\/60:disabled{
  color: rgb(83 88 98 / 0.6);
}

.disabled\\:text-neutral-600\\/65:disabled{
  color: rgb(83 88 98 / 0.65);
}

.disabled\\:text-neutral-600\\/70:disabled{
  color: rgb(83 88 98 / 0.7);
}

.disabled\\:text-neutral-600\\/75:disabled{
  color: rgb(83 88 98 / 0.75);
}

.disabled\\:text-neutral-600\\/80:disabled{
  color: rgb(83 88 98 / 0.8);
}

.disabled\\:text-neutral-600\\/85:disabled{
  color: rgb(83 88 98 / 0.85);
}

.disabled\\:text-neutral-600\\/90:disabled{
  color: rgb(83 88 98 / 0.9);
}

.disabled\\:text-neutral-600\\/95:disabled{
  color: rgb(83 88 98 / 0.95);
}

.disabled\\:text-neutral-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-700\\/0:disabled{
  color: rgb(65 70 81 / 0);
}

.disabled\\:text-neutral-700\\/10:disabled{
  color: rgb(65 70 81 / 0.1);
}

.disabled\\:text-neutral-700\\/100:disabled{
  color: rgb(65 70 81 / 1);
}

.disabled\\:text-neutral-700\\/15:disabled{
  color: rgb(65 70 81 / 0.15);
}

.disabled\\:text-neutral-700\\/20:disabled{
  color: rgb(65 70 81 / 0.2);
}

.disabled\\:text-neutral-700\\/25:disabled{
  color: rgb(65 70 81 / 0.25);
}

.disabled\\:text-neutral-700\\/30:disabled{
  color: rgb(65 70 81 / 0.3);
}

.disabled\\:text-neutral-700\\/35:disabled{
  color: rgb(65 70 81 / 0.35);
}

.disabled\\:text-neutral-700\\/40:disabled{
  color: rgb(65 70 81 / 0.4);
}

.disabled\\:text-neutral-700\\/45:disabled{
  color: rgb(65 70 81 / 0.45);
}

.disabled\\:text-neutral-700\\/5:disabled{
  color: rgb(65 70 81 / 0.05);
}

.disabled\\:text-neutral-700\\/50:disabled{
  color: rgb(65 70 81 / 0.5);
}

.disabled\\:text-neutral-700\\/55:disabled{
  color: rgb(65 70 81 / 0.55);
}

.disabled\\:text-neutral-700\\/60:disabled{
  color: rgb(65 70 81 / 0.6);
}

.disabled\\:text-neutral-700\\/65:disabled{
  color: rgb(65 70 81 / 0.65);
}

.disabled\\:text-neutral-700\\/70:disabled{
  color: rgb(65 70 81 / 0.7);
}

.disabled\\:text-neutral-700\\/75:disabled{
  color: rgb(65 70 81 / 0.75);
}

.disabled\\:text-neutral-700\\/80:disabled{
  color: rgb(65 70 81 / 0.8);
}

.disabled\\:text-neutral-700\\/85:disabled{
  color: rgb(65 70 81 / 0.85);
}

.disabled\\:text-neutral-700\\/90:disabled{
  color: rgb(65 70 81 / 0.9);
}

.disabled\\:text-neutral-700\\/95:disabled{
  color: rgb(65 70 81 / 0.95);
}

.disabled\\:text-neutral-75:disabled{
  --tw-text-opacity: 1;
  color: rgb(246 246 246 / var(--tw-text-opacity, 1));
}

.disabled\\:text-neutral-75\\/0:disabled{
  color: rgb(246 246 246 / 0);
}

.disabled\\:text-neutral-75\\/10:disabled{
  color: rgb(246 246 246 / 0.1);
}

.disabled\\:text-neutral-75\\/100:disabled{
  color: rgb(246 246 246 / 1);
}

.disabled\\:text-neutral-75\\/15:disabled{
  color: rgb(246 246 246 / 0.15);
}

.disabled\\:text-neutral-75\\/20:disabled{
  color: rgb(246 246 246 / 0.2);
}

.disabled\\:text-neutral-75\\/25:disabled{
  color: rgb(246 246 246 / 0.25);
}

.disabled\\:text-neutral-75\\/30:disabled{
  color: rgb(246 246 246 / 0.3);
}

.disabled\\:text-neutral-75\\/35:disabled{
  color: rgb(246 246 246 / 0.35);
}

.disabled\\:text-neutral-75\\/40:disabled{
  color: rgb(246 246 246 / 0.4);
}

.disabled\\:text-neutral-75\\/45:disabled{
  color: rgb(246 246 246 / 0.45);
}

.disabled\\:text-neutral-75\\/5:disabled{
  color: rgb(246 246 246 / 0.05);
}

.disabled\\:text-neutral-75\\/50:disabled{
  color: rgb(246 246 246 / 0.5);
}

.disabled\\:text-neutral-75\\/55:disabled{
  color: rgb(246 246 246 / 0.55);
}

.disabled\\:text-neutral-75\\/60:disabled{
  color: rgb(246 246 246 / 0.6);
}

.disabled\\:text-neutral-75\\/65:disabled{
  color: rgb(246 246 246 / 0.65);
}

.disabled\\:text-neutral-75\\/70:disabled{
  color: rgb(246 246 246 / 0.7);
}

.disabled\\:text-neutral-75\\/75:disabled{
  color: rgb(246 246 246 / 0.75);
}

.disabled\\:text-neutral-75\\/80:disabled{
  color: rgb(246 246 246 / 0.8);
}

.disabled\\:text-neutral-75\\/85:disabled{
  color: rgb(246 246 246 / 0.85);
}

.disabled\\:text-neutral-75\\/90:disabled{
  color: rgb(246 246 246 / 0.9);
}

.disabled\\:text-neutral-75\\/95:disabled{
  color: rgb(246 246 246 / 0.95);
}

.disabled\\:text-primary-100:disabled{
  color: var(--color-primary-100, #E0F2FE);
}

.disabled\\:text-primary-200:disabled{
  color: var(--color-primary-200, #B9E6FE);
}

.disabled\\:text-primary-25:disabled{
  color: var(--color-primary-25, #F5FBFF);
}

.disabled\\:text-primary-400:disabled{
  color: var(--color-primary-400, #36BFFA);
}

.disabled\\:text-primary-50:disabled{
  color: var(--color-primary-50, #F0F9FF);
}

.disabled\\:text-primary-500:disabled{
  color: var(--color-primary-500, #0BA5EC);
}

.disabled\\:text-primary-600:disabled{
  color: var(--color-primary-600, #0086C9);
}

.disabled\\:text-primary-700:disabled{
  color: var(--color-primary-700, #026AA2);
}

.disabled\\:text-purple-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(235 233 254 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-100\\/0:disabled{
  color: rgb(235 233 254 / 0);
}

.disabled\\:text-purple-100\\/10:disabled{
  color: rgb(235 233 254 / 0.1);
}

.disabled\\:text-purple-100\\/100:disabled{
  color: rgb(235 233 254 / 1);
}

.disabled\\:text-purple-100\\/15:disabled{
  color: rgb(235 233 254 / 0.15);
}

.disabled\\:text-purple-100\\/20:disabled{
  color: rgb(235 233 254 / 0.2);
}

.disabled\\:text-purple-100\\/25:disabled{
  color: rgb(235 233 254 / 0.25);
}

.disabled\\:text-purple-100\\/30:disabled{
  color: rgb(235 233 254 / 0.3);
}

.disabled\\:text-purple-100\\/35:disabled{
  color: rgb(235 233 254 / 0.35);
}

.disabled\\:text-purple-100\\/40:disabled{
  color: rgb(235 233 254 / 0.4);
}

.disabled\\:text-purple-100\\/45:disabled{
  color: rgb(235 233 254 / 0.45);
}

.disabled\\:text-purple-100\\/5:disabled{
  color: rgb(235 233 254 / 0.05);
}

.disabled\\:text-purple-100\\/50:disabled{
  color: rgb(235 233 254 / 0.5);
}

.disabled\\:text-purple-100\\/55:disabled{
  color: rgb(235 233 254 / 0.55);
}

.disabled\\:text-purple-100\\/60:disabled{
  color: rgb(235 233 254 / 0.6);
}

.disabled\\:text-purple-100\\/65:disabled{
  color: rgb(235 233 254 / 0.65);
}

.disabled\\:text-purple-100\\/70:disabled{
  color: rgb(235 233 254 / 0.7);
}

.disabled\\:text-purple-100\\/75:disabled{
  color: rgb(235 233 254 / 0.75);
}

.disabled\\:text-purple-100\\/80:disabled{
  color: rgb(235 233 254 / 0.8);
}

.disabled\\:text-purple-100\\/85:disabled{
  color: rgb(235 233 254 / 0.85);
}

.disabled\\:text-purple-100\\/90:disabled{
  color: rgb(235 233 254 / 0.9);
}

.disabled\\:text-purple-100\\/95:disabled{
  color: rgb(235 233 254 / 0.95);
}

.disabled\\:text-purple-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(217 214 254 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-200\\/0:disabled{
  color: rgb(217 214 254 / 0);
}

.disabled\\:text-purple-200\\/10:disabled{
  color: rgb(217 214 254 / 0.1);
}

.disabled\\:text-purple-200\\/100:disabled{
  color: rgb(217 214 254 / 1);
}

.disabled\\:text-purple-200\\/15:disabled{
  color: rgb(217 214 254 / 0.15);
}

.disabled\\:text-purple-200\\/20:disabled{
  color: rgb(217 214 254 / 0.2);
}

.disabled\\:text-purple-200\\/25:disabled{
  color: rgb(217 214 254 / 0.25);
}

.disabled\\:text-purple-200\\/30:disabled{
  color: rgb(217 214 254 / 0.3);
}

.disabled\\:text-purple-200\\/35:disabled{
  color: rgb(217 214 254 / 0.35);
}

.disabled\\:text-purple-200\\/40:disabled{
  color: rgb(217 214 254 / 0.4);
}

.disabled\\:text-purple-200\\/45:disabled{
  color: rgb(217 214 254 / 0.45);
}

.disabled\\:text-purple-200\\/5:disabled{
  color: rgb(217 214 254 / 0.05);
}

.disabled\\:text-purple-200\\/50:disabled{
  color: rgb(217 214 254 / 0.5);
}

.disabled\\:text-purple-200\\/55:disabled{
  color: rgb(217 214 254 / 0.55);
}

.disabled\\:text-purple-200\\/60:disabled{
  color: rgb(217 214 254 / 0.6);
}

.disabled\\:text-purple-200\\/65:disabled{
  color: rgb(217 214 254 / 0.65);
}

.disabled\\:text-purple-200\\/70:disabled{
  color: rgb(217 214 254 / 0.7);
}

.disabled\\:text-purple-200\\/75:disabled{
  color: rgb(217 214 254 / 0.75);
}

.disabled\\:text-purple-200\\/80:disabled{
  color: rgb(217 214 254 / 0.8);
}

.disabled\\:text-purple-200\\/85:disabled{
  color: rgb(217 214 254 / 0.85);
}

.disabled\\:text-purple-200\\/90:disabled{
  color: rgb(217 214 254 / 0.9);
}

.disabled\\:text-purple-200\\/95:disabled{
  color: rgb(217 214 254 / 0.95);
}

.disabled\\:text-purple-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(250 250 255 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-25\\/0:disabled{
  color: rgb(250 250 255 / 0);
}

.disabled\\:text-purple-25\\/10:disabled{
  color: rgb(250 250 255 / 0.1);
}

.disabled\\:text-purple-25\\/100:disabled{
  color: rgb(250 250 255 / 1);
}

.disabled\\:text-purple-25\\/15:disabled{
  color: rgb(250 250 255 / 0.15);
}

.disabled\\:text-purple-25\\/20:disabled{
  color: rgb(250 250 255 / 0.2);
}

.disabled\\:text-purple-25\\/25:disabled{
  color: rgb(250 250 255 / 0.25);
}

.disabled\\:text-purple-25\\/30:disabled{
  color: rgb(250 250 255 / 0.3);
}

.disabled\\:text-purple-25\\/35:disabled{
  color: rgb(250 250 255 / 0.35);
}

.disabled\\:text-purple-25\\/40:disabled{
  color: rgb(250 250 255 / 0.4);
}

.disabled\\:text-purple-25\\/45:disabled{
  color: rgb(250 250 255 / 0.45);
}

.disabled\\:text-purple-25\\/5:disabled{
  color: rgb(250 250 255 / 0.05);
}

.disabled\\:text-purple-25\\/50:disabled{
  color: rgb(250 250 255 / 0.5);
}

.disabled\\:text-purple-25\\/55:disabled{
  color: rgb(250 250 255 / 0.55);
}

.disabled\\:text-purple-25\\/60:disabled{
  color: rgb(250 250 255 / 0.6);
}

.disabled\\:text-purple-25\\/65:disabled{
  color: rgb(250 250 255 / 0.65);
}

.disabled\\:text-purple-25\\/70:disabled{
  color: rgb(250 250 255 / 0.7);
}

.disabled\\:text-purple-25\\/75:disabled{
  color: rgb(250 250 255 / 0.75);
}

.disabled\\:text-purple-25\\/80:disabled{
  color: rgb(250 250 255 / 0.8);
}

.disabled\\:text-purple-25\\/85:disabled{
  color: rgb(250 250 255 / 0.85);
}

.disabled\\:text-purple-25\\/90:disabled{
  color: rgb(250 250 255 / 0.9);
}

.disabled\\:text-purple-25\\/95:disabled{
  color: rgb(250 250 255 / 0.95);
}

.disabled\\:text-purple-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(155 138 251 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-400\\/0:disabled{
  color: rgb(155 138 251 / 0);
}

.disabled\\:text-purple-400\\/10:disabled{
  color: rgb(155 138 251 / 0.1);
}

.disabled\\:text-purple-400\\/100:disabled{
  color: rgb(155 138 251 / 1);
}

.disabled\\:text-purple-400\\/15:disabled{
  color: rgb(155 138 251 / 0.15);
}

.disabled\\:text-purple-400\\/20:disabled{
  color: rgb(155 138 251 / 0.2);
}

.disabled\\:text-purple-400\\/25:disabled{
  color: rgb(155 138 251 / 0.25);
}

.disabled\\:text-purple-400\\/30:disabled{
  color: rgb(155 138 251 / 0.3);
}

.disabled\\:text-purple-400\\/35:disabled{
  color: rgb(155 138 251 / 0.35);
}

.disabled\\:text-purple-400\\/40:disabled{
  color: rgb(155 138 251 / 0.4);
}

.disabled\\:text-purple-400\\/45:disabled{
  color: rgb(155 138 251 / 0.45);
}

.disabled\\:text-purple-400\\/5:disabled{
  color: rgb(155 138 251 / 0.05);
}

.disabled\\:text-purple-400\\/50:disabled{
  color: rgb(155 138 251 / 0.5);
}

.disabled\\:text-purple-400\\/55:disabled{
  color: rgb(155 138 251 / 0.55);
}

.disabled\\:text-purple-400\\/60:disabled{
  color: rgb(155 138 251 / 0.6);
}

.disabled\\:text-purple-400\\/65:disabled{
  color: rgb(155 138 251 / 0.65);
}

.disabled\\:text-purple-400\\/70:disabled{
  color: rgb(155 138 251 / 0.7);
}

.disabled\\:text-purple-400\\/75:disabled{
  color: rgb(155 138 251 / 0.75);
}

.disabled\\:text-purple-400\\/80:disabled{
  color: rgb(155 138 251 / 0.8);
}

.disabled\\:text-purple-400\\/85:disabled{
  color: rgb(155 138 251 / 0.85);
}

.disabled\\:text-purple-400\\/90:disabled{
  color: rgb(155 138 251 / 0.9);
}

.disabled\\:text-purple-400\\/95:disabled{
  color: rgb(155 138 251 / 0.95);
}

.disabled\\:text-purple-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(244 243 255 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-50\\/0:disabled{
  color: rgb(244 243 255 / 0);
}

.disabled\\:text-purple-50\\/10:disabled{
  color: rgb(244 243 255 / 0.1);
}

.disabled\\:text-purple-50\\/100:disabled{
  color: rgb(244 243 255 / 1);
}

.disabled\\:text-purple-50\\/15:disabled{
  color: rgb(244 243 255 / 0.15);
}

.disabled\\:text-purple-50\\/20:disabled{
  color: rgb(244 243 255 / 0.2);
}

.disabled\\:text-purple-50\\/25:disabled{
  color: rgb(244 243 255 / 0.25);
}

.disabled\\:text-purple-50\\/30:disabled{
  color: rgb(244 243 255 / 0.3);
}

.disabled\\:text-purple-50\\/35:disabled{
  color: rgb(244 243 255 / 0.35);
}

.disabled\\:text-purple-50\\/40:disabled{
  color: rgb(244 243 255 / 0.4);
}

.disabled\\:text-purple-50\\/45:disabled{
  color: rgb(244 243 255 / 0.45);
}

.disabled\\:text-purple-50\\/5:disabled{
  color: rgb(244 243 255 / 0.05);
}

.disabled\\:text-purple-50\\/50:disabled{
  color: rgb(244 243 255 / 0.5);
}

.disabled\\:text-purple-50\\/55:disabled{
  color: rgb(244 243 255 / 0.55);
}

.disabled\\:text-purple-50\\/60:disabled{
  color: rgb(244 243 255 / 0.6);
}

.disabled\\:text-purple-50\\/65:disabled{
  color: rgb(244 243 255 / 0.65);
}

.disabled\\:text-purple-50\\/70:disabled{
  color: rgb(244 243 255 / 0.7);
}

.disabled\\:text-purple-50\\/75:disabled{
  color: rgb(244 243 255 / 0.75);
}

.disabled\\:text-purple-50\\/80:disabled{
  color: rgb(244 243 255 / 0.8);
}

.disabled\\:text-purple-50\\/85:disabled{
  color: rgb(244 243 255 / 0.85);
}

.disabled\\:text-purple-50\\/90:disabled{
  color: rgb(244 243 255 / 0.9);
}

.disabled\\:text-purple-50\\/95:disabled{
  color: rgb(244 243 255 / 0.95);
}

.disabled\\:text-purple-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(122 90 248 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-500\\/0:disabled{
  color: rgb(122 90 248 / 0);
}

.disabled\\:text-purple-500\\/10:disabled{
  color: rgb(122 90 248 / 0.1);
}

.disabled\\:text-purple-500\\/100:disabled{
  color: rgb(122 90 248 / 1);
}

.disabled\\:text-purple-500\\/15:disabled{
  color: rgb(122 90 248 / 0.15);
}

.disabled\\:text-purple-500\\/20:disabled{
  color: rgb(122 90 248 / 0.2);
}

.disabled\\:text-purple-500\\/25:disabled{
  color: rgb(122 90 248 / 0.25);
}

.disabled\\:text-purple-500\\/30:disabled{
  color: rgb(122 90 248 / 0.3);
}

.disabled\\:text-purple-500\\/35:disabled{
  color: rgb(122 90 248 / 0.35);
}

.disabled\\:text-purple-500\\/40:disabled{
  color: rgb(122 90 248 / 0.4);
}

.disabled\\:text-purple-500\\/45:disabled{
  color: rgb(122 90 248 / 0.45);
}

.disabled\\:text-purple-500\\/5:disabled{
  color: rgb(122 90 248 / 0.05);
}

.disabled\\:text-purple-500\\/50:disabled{
  color: rgb(122 90 248 / 0.5);
}

.disabled\\:text-purple-500\\/55:disabled{
  color: rgb(122 90 248 / 0.55);
}

.disabled\\:text-purple-500\\/60:disabled{
  color: rgb(122 90 248 / 0.6);
}

.disabled\\:text-purple-500\\/65:disabled{
  color: rgb(122 90 248 / 0.65);
}

.disabled\\:text-purple-500\\/70:disabled{
  color: rgb(122 90 248 / 0.7);
}

.disabled\\:text-purple-500\\/75:disabled{
  color: rgb(122 90 248 / 0.75);
}

.disabled\\:text-purple-500\\/80:disabled{
  color: rgb(122 90 248 / 0.8);
}

.disabled\\:text-purple-500\\/85:disabled{
  color: rgb(122 90 248 / 0.85);
}

.disabled\\:text-purple-500\\/90:disabled{
  color: rgb(122 90 248 / 0.9);
}

.disabled\\:text-purple-500\\/95:disabled{
  color: rgb(122 90 248 / 0.95);
}

.disabled\\:text-purple-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(105 56 239 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-600\\/0:disabled{
  color: rgb(105 56 239 / 0);
}

.disabled\\:text-purple-600\\/10:disabled{
  color: rgb(105 56 239 / 0.1);
}

.disabled\\:text-purple-600\\/100:disabled{
  color: rgb(105 56 239 / 1);
}

.disabled\\:text-purple-600\\/15:disabled{
  color: rgb(105 56 239 / 0.15);
}

.disabled\\:text-purple-600\\/20:disabled{
  color: rgb(105 56 239 / 0.2);
}

.disabled\\:text-purple-600\\/25:disabled{
  color: rgb(105 56 239 / 0.25);
}

.disabled\\:text-purple-600\\/30:disabled{
  color: rgb(105 56 239 / 0.3);
}

.disabled\\:text-purple-600\\/35:disabled{
  color: rgb(105 56 239 / 0.35);
}

.disabled\\:text-purple-600\\/40:disabled{
  color: rgb(105 56 239 / 0.4);
}

.disabled\\:text-purple-600\\/45:disabled{
  color: rgb(105 56 239 / 0.45);
}

.disabled\\:text-purple-600\\/5:disabled{
  color: rgb(105 56 239 / 0.05);
}

.disabled\\:text-purple-600\\/50:disabled{
  color: rgb(105 56 239 / 0.5);
}

.disabled\\:text-purple-600\\/55:disabled{
  color: rgb(105 56 239 / 0.55);
}

.disabled\\:text-purple-600\\/60:disabled{
  color: rgb(105 56 239 / 0.6);
}

.disabled\\:text-purple-600\\/65:disabled{
  color: rgb(105 56 239 / 0.65);
}

.disabled\\:text-purple-600\\/70:disabled{
  color: rgb(105 56 239 / 0.7);
}

.disabled\\:text-purple-600\\/75:disabled{
  color: rgb(105 56 239 / 0.75);
}

.disabled\\:text-purple-600\\/80:disabled{
  color: rgb(105 56 239 / 0.8);
}

.disabled\\:text-purple-600\\/85:disabled{
  color: rgb(105 56 239 / 0.85);
}

.disabled\\:text-purple-600\\/90:disabled{
  color: rgb(105 56 239 / 0.9);
}

.disabled\\:text-purple-600\\/95:disabled{
  color: rgb(105 56 239 / 0.95);
}

.disabled\\:text-purple-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(89 37 220 / var(--tw-text-opacity, 1));
}

.disabled\\:text-purple-700\\/0:disabled{
  color: rgb(89 37 220 / 0);
}

.disabled\\:text-purple-700\\/10:disabled{
  color: rgb(89 37 220 / 0.1);
}

.disabled\\:text-purple-700\\/100:disabled{
  color: rgb(89 37 220 / 1);
}

.disabled\\:text-purple-700\\/15:disabled{
  color: rgb(89 37 220 / 0.15);
}

.disabled\\:text-purple-700\\/20:disabled{
  color: rgb(89 37 220 / 0.2);
}

.disabled\\:text-purple-700\\/25:disabled{
  color: rgb(89 37 220 / 0.25);
}

.disabled\\:text-purple-700\\/30:disabled{
  color: rgb(89 37 220 / 0.3);
}

.disabled\\:text-purple-700\\/35:disabled{
  color: rgb(89 37 220 / 0.35);
}

.disabled\\:text-purple-700\\/40:disabled{
  color: rgb(89 37 220 / 0.4);
}

.disabled\\:text-purple-700\\/45:disabled{
  color: rgb(89 37 220 / 0.45);
}

.disabled\\:text-purple-700\\/5:disabled{
  color: rgb(89 37 220 / 0.05);
}

.disabled\\:text-purple-700\\/50:disabled{
  color: rgb(89 37 220 / 0.5);
}

.disabled\\:text-purple-700\\/55:disabled{
  color: rgb(89 37 220 / 0.55);
}

.disabled\\:text-purple-700\\/60:disabled{
  color: rgb(89 37 220 / 0.6);
}

.disabled\\:text-purple-700\\/65:disabled{
  color: rgb(89 37 220 / 0.65);
}

.disabled\\:text-purple-700\\/70:disabled{
  color: rgb(89 37 220 / 0.7);
}

.disabled\\:text-purple-700\\/75:disabled{
  color: rgb(89 37 220 / 0.75);
}

.disabled\\:text-purple-700\\/80:disabled{
  color: rgb(89 37 220 / 0.8);
}

.disabled\\:text-purple-700\\/85:disabled{
  color: rgb(89 37 220 / 0.85);
}

.disabled\\:text-purple-700\\/90:disabled{
  color: rgb(89 37 220 / 0.9);
}

.disabled\\:text-purple-700\\/95:disabled{
  color: rgb(89 37 220 / 0.95);
}

.disabled\\:text-success-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(211 248 223 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-100\\/0:disabled{
  color: rgb(211 248 223 / 0);
}

.disabled\\:text-success-100\\/10:disabled{
  color: rgb(211 248 223 / 0.1);
}

.disabled\\:text-success-100\\/100:disabled{
  color: rgb(211 248 223 / 1);
}

.disabled\\:text-success-100\\/15:disabled{
  color: rgb(211 248 223 / 0.15);
}

.disabled\\:text-success-100\\/20:disabled{
  color: rgb(211 248 223 / 0.2);
}

.disabled\\:text-success-100\\/25:disabled{
  color: rgb(211 248 223 / 0.25);
}

.disabled\\:text-success-100\\/30:disabled{
  color: rgb(211 248 223 / 0.3);
}

.disabled\\:text-success-100\\/35:disabled{
  color: rgb(211 248 223 / 0.35);
}

.disabled\\:text-success-100\\/40:disabled{
  color: rgb(211 248 223 / 0.4);
}

.disabled\\:text-success-100\\/45:disabled{
  color: rgb(211 248 223 / 0.45);
}

.disabled\\:text-success-100\\/5:disabled{
  color: rgb(211 248 223 / 0.05);
}

.disabled\\:text-success-100\\/50:disabled{
  color: rgb(211 248 223 / 0.5);
}

.disabled\\:text-success-100\\/55:disabled{
  color: rgb(211 248 223 / 0.55);
}

.disabled\\:text-success-100\\/60:disabled{
  color: rgb(211 248 223 / 0.6);
}

.disabled\\:text-success-100\\/65:disabled{
  color: rgb(211 248 223 / 0.65);
}

.disabled\\:text-success-100\\/70:disabled{
  color: rgb(211 248 223 / 0.7);
}

.disabled\\:text-success-100\\/75:disabled{
  color: rgb(211 248 223 / 0.75);
}

.disabled\\:text-success-100\\/80:disabled{
  color: rgb(211 248 223 / 0.8);
}

.disabled\\:text-success-100\\/85:disabled{
  color: rgb(211 248 223 / 0.85);
}

.disabled\\:text-success-100\\/90:disabled{
  color: rgb(211 248 223 / 0.9);
}

.disabled\\:text-success-100\\/95:disabled{
  color: rgb(211 248 223 / 0.95);
}

.disabled\\:text-success-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(170 240 196 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-200\\/0:disabled{
  color: rgb(170 240 196 / 0);
}

.disabled\\:text-success-200\\/10:disabled{
  color: rgb(170 240 196 / 0.1);
}

.disabled\\:text-success-200\\/100:disabled{
  color: rgb(170 240 196 / 1);
}

.disabled\\:text-success-200\\/15:disabled{
  color: rgb(170 240 196 / 0.15);
}

.disabled\\:text-success-200\\/20:disabled{
  color: rgb(170 240 196 / 0.2);
}

.disabled\\:text-success-200\\/25:disabled{
  color: rgb(170 240 196 / 0.25);
}

.disabled\\:text-success-200\\/30:disabled{
  color: rgb(170 240 196 / 0.3);
}

.disabled\\:text-success-200\\/35:disabled{
  color: rgb(170 240 196 / 0.35);
}

.disabled\\:text-success-200\\/40:disabled{
  color: rgb(170 240 196 / 0.4);
}

.disabled\\:text-success-200\\/45:disabled{
  color: rgb(170 240 196 / 0.45);
}

.disabled\\:text-success-200\\/5:disabled{
  color: rgb(170 240 196 / 0.05);
}

.disabled\\:text-success-200\\/50:disabled{
  color: rgb(170 240 196 / 0.5);
}

.disabled\\:text-success-200\\/55:disabled{
  color: rgb(170 240 196 / 0.55);
}

.disabled\\:text-success-200\\/60:disabled{
  color: rgb(170 240 196 / 0.6);
}

.disabled\\:text-success-200\\/65:disabled{
  color: rgb(170 240 196 / 0.65);
}

.disabled\\:text-success-200\\/70:disabled{
  color: rgb(170 240 196 / 0.7);
}

.disabled\\:text-success-200\\/75:disabled{
  color: rgb(170 240 196 / 0.75);
}

.disabled\\:text-success-200\\/80:disabled{
  color: rgb(170 240 196 / 0.8);
}

.disabled\\:text-success-200\\/85:disabled{
  color: rgb(170 240 196 / 0.85);
}

.disabled\\:text-success-200\\/90:disabled{
  color: rgb(170 240 196 / 0.9);
}

.disabled\\:text-success-200\\/95:disabled{
  color: rgb(170 240 196 / 0.95);
}

.disabled\\:text-success-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(246 254 249 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-25\\/0:disabled{
  color: rgb(246 254 249 / 0);
}

.disabled\\:text-success-25\\/10:disabled{
  color: rgb(246 254 249 / 0.1);
}

.disabled\\:text-success-25\\/100:disabled{
  color: rgb(246 254 249 / 1);
}

.disabled\\:text-success-25\\/15:disabled{
  color: rgb(246 254 249 / 0.15);
}

.disabled\\:text-success-25\\/20:disabled{
  color: rgb(246 254 249 / 0.2);
}

.disabled\\:text-success-25\\/25:disabled{
  color: rgb(246 254 249 / 0.25);
}

.disabled\\:text-success-25\\/30:disabled{
  color: rgb(246 254 249 / 0.3);
}

.disabled\\:text-success-25\\/35:disabled{
  color: rgb(246 254 249 / 0.35);
}

.disabled\\:text-success-25\\/40:disabled{
  color: rgb(246 254 249 / 0.4);
}

.disabled\\:text-success-25\\/45:disabled{
  color: rgb(246 254 249 / 0.45);
}

.disabled\\:text-success-25\\/5:disabled{
  color: rgb(246 254 249 / 0.05);
}

.disabled\\:text-success-25\\/50:disabled{
  color: rgb(246 254 249 / 0.5);
}

.disabled\\:text-success-25\\/55:disabled{
  color: rgb(246 254 249 / 0.55);
}

.disabled\\:text-success-25\\/60:disabled{
  color: rgb(246 254 249 / 0.6);
}

.disabled\\:text-success-25\\/65:disabled{
  color: rgb(246 254 249 / 0.65);
}

.disabled\\:text-success-25\\/70:disabled{
  color: rgb(246 254 249 / 0.7);
}

.disabled\\:text-success-25\\/75:disabled{
  color: rgb(246 254 249 / 0.75);
}

.disabled\\:text-success-25\\/80:disabled{
  color: rgb(246 254 249 / 0.8);
}

.disabled\\:text-success-25\\/85:disabled{
  color: rgb(246 254 249 / 0.85);
}

.disabled\\:text-success-25\\/90:disabled{
  color: rgb(246 254 249 / 0.9);
}

.disabled\\:text-success-25\\/95:disabled{
  color: rgb(246 254 249 / 0.95);
}

.disabled\\:text-success-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(60 203 127 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-400\\/0:disabled{
  color: rgb(60 203 127 / 0);
}

.disabled\\:text-success-400\\/10:disabled{
  color: rgb(60 203 127 / 0.1);
}

.disabled\\:text-success-400\\/100:disabled{
  color: rgb(60 203 127 / 1);
}

.disabled\\:text-success-400\\/15:disabled{
  color: rgb(60 203 127 / 0.15);
}

.disabled\\:text-success-400\\/20:disabled{
  color: rgb(60 203 127 / 0.2);
}

.disabled\\:text-success-400\\/25:disabled{
  color: rgb(60 203 127 / 0.25);
}

.disabled\\:text-success-400\\/30:disabled{
  color: rgb(60 203 127 / 0.3);
}

.disabled\\:text-success-400\\/35:disabled{
  color: rgb(60 203 127 / 0.35);
}

.disabled\\:text-success-400\\/40:disabled{
  color: rgb(60 203 127 / 0.4);
}

.disabled\\:text-success-400\\/45:disabled{
  color: rgb(60 203 127 / 0.45);
}

.disabled\\:text-success-400\\/5:disabled{
  color: rgb(60 203 127 / 0.05);
}

.disabled\\:text-success-400\\/50:disabled{
  color: rgb(60 203 127 / 0.5);
}

.disabled\\:text-success-400\\/55:disabled{
  color: rgb(60 203 127 / 0.55);
}

.disabled\\:text-success-400\\/60:disabled{
  color: rgb(60 203 127 / 0.6);
}

.disabled\\:text-success-400\\/65:disabled{
  color: rgb(60 203 127 / 0.65);
}

.disabled\\:text-success-400\\/70:disabled{
  color: rgb(60 203 127 / 0.7);
}

.disabled\\:text-success-400\\/75:disabled{
  color: rgb(60 203 127 / 0.75);
}

.disabled\\:text-success-400\\/80:disabled{
  color: rgb(60 203 127 / 0.8);
}

.disabled\\:text-success-400\\/85:disabled{
  color: rgb(60 203 127 / 0.85);
}

.disabled\\:text-success-400\\/90:disabled{
  color: rgb(60 203 127 / 0.9);
}

.disabled\\:text-success-400\\/95:disabled{
  color: rgb(60 203 127 / 0.95);
}

.disabled\\:text-success-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(237 252 242 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-50\\/0:disabled{
  color: rgb(237 252 242 / 0);
}

.disabled\\:text-success-50\\/10:disabled{
  color: rgb(237 252 242 / 0.1);
}

.disabled\\:text-success-50\\/100:disabled{
  color: rgb(237 252 242 / 1);
}

.disabled\\:text-success-50\\/15:disabled{
  color: rgb(237 252 242 / 0.15);
}

.disabled\\:text-success-50\\/20:disabled{
  color: rgb(237 252 242 / 0.2);
}

.disabled\\:text-success-50\\/25:disabled{
  color: rgb(237 252 242 / 0.25);
}

.disabled\\:text-success-50\\/30:disabled{
  color: rgb(237 252 242 / 0.3);
}

.disabled\\:text-success-50\\/35:disabled{
  color: rgb(237 252 242 / 0.35);
}

.disabled\\:text-success-50\\/40:disabled{
  color: rgb(237 252 242 / 0.4);
}

.disabled\\:text-success-50\\/45:disabled{
  color: rgb(237 252 242 / 0.45);
}

.disabled\\:text-success-50\\/5:disabled{
  color: rgb(237 252 242 / 0.05);
}

.disabled\\:text-success-50\\/50:disabled{
  color: rgb(237 252 242 / 0.5);
}

.disabled\\:text-success-50\\/55:disabled{
  color: rgb(237 252 242 / 0.55);
}

.disabled\\:text-success-50\\/60:disabled{
  color: rgb(237 252 242 / 0.6);
}

.disabled\\:text-success-50\\/65:disabled{
  color: rgb(237 252 242 / 0.65);
}

.disabled\\:text-success-50\\/70:disabled{
  color: rgb(237 252 242 / 0.7);
}

.disabled\\:text-success-50\\/75:disabled{
  color: rgb(237 252 242 / 0.75);
}

.disabled\\:text-success-50\\/80:disabled{
  color: rgb(237 252 242 / 0.8);
}

.disabled\\:text-success-50\\/85:disabled{
  color: rgb(237 252 242 / 0.85);
}

.disabled\\:text-success-50\\/90:disabled{
  color: rgb(237 252 242 / 0.9);
}

.disabled\\:text-success-50\\/95:disabled{
  color: rgb(237 252 242 / 0.95);
}

.disabled\\:text-success-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(22 179 100 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-500\\/0:disabled{
  color: rgb(22 179 100 / 0);
}

.disabled\\:text-success-500\\/10:disabled{
  color: rgb(22 179 100 / 0.1);
}

.disabled\\:text-success-500\\/100:disabled{
  color: rgb(22 179 100 / 1);
}

.disabled\\:text-success-500\\/15:disabled{
  color: rgb(22 179 100 / 0.15);
}

.disabled\\:text-success-500\\/20:disabled{
  color: rgb(22 179 100 / 0.2);
}

.disabled\\:text-success-500\\/25:disabled{
  color: rgb(22 179 100 / 0.25);
}

.disabled\\:text-success-500\\/30:disabled{
  color: rgb(22 179 100 / 0.3);
}

.disabled\\:text-success-500\\/35:disabled{
  color: rgb(22 179 100 / 0.35);
}

.disabled\\:text-success-500\\/40:disabled{
  color: rgb(22 179 100 / 0.4);
}

.disabled\\:text-success-500\\/45:disabled{
  color: rgb(22 179 100 / 0.45);
}

.disabled\\:text-success-500\\/5:disabled{
  color: rgb(22 179 100 / 0.05);
}

.disabled\\:text-success-500\\/50:disabled{
  color: rgb(22 179 100 / 0.5);
}

.disabled\\:text-success-500\\/55:disabled{
  color: rgb(22 179 100 / 0.55);
}

.disabled\\:text-success-500\\/60:disabled{
  color: rgb(22 179 100 / 0.6);
}

.disabled\\:text-success-500\\/65:disabled{
  color: rgb(22 179 100 / 0.65);
}

.disabled\\:text-success-500\\/70:disabled{
  color: rgb(22 179 100 / 0.7);
}

.disabled\\:text-success-500\\/75:disabled{
  color: rgb(22 179 100 / 0.75);
}

.disabled\\:text-success-500\\/80:disabled{
  color: rgb(22 179 100 / 0.8);
}

.disabled\\:text-success-500\\/85:disabled{
  color: rgb(22 179 100 / 0.85);
}

.disabled\\:text-success-500\\/90:disabled{
  color: rgb(22 179 100 / 0.9);
}

.disabled\\:text-success-500\\/95:disabled{
  color: rgb(22 179 100 / 0.95);
}

.disabled\\:text-success-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(9 146 80 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-600\\/0:disabled{
  color: rgb(9 146 80 / 0);
}

.disabled\\:text-success-600\\/10:disabled{
  color: rgb(9 146 80 / 0.1);
}

.disabled\\:text-success-600\\/100:disabled{
  color: rgb(9 146 80 / 1);
}

.disabled\\:text-success-600\\/15:disabled{
  color: rgb(9 146 80 / 0.15);
}

.disabled\\:text-success-600\\/20:disabled{
  color: rgb(9 146 80 / 0.2);
}

.disabled\\:text-success-600\\/25:disabled{
  color: rgb(9 146 80 / 0.25);
}

.disabled\\:text-success-600\\/30:disabled{
  color: rgb(9 146 80 / 0.3);
}

.disabled\\:text-success-600\\/35:disabled{
  color: rgb(9 146 80 / 0.35);
}

.disabled\\:text-success-600\\/40:disabled{
  color: rgb(9 146 80 / 0.4);
}

.disabled\\:text-success-600\\/45:disabled{
  color: rgb(9 146 80 / 0.45);
}

.disabled\\:text-success-600\\/5:disabled{
  color: rgb(9 146 80 / 0.05);
}

.disabled\\:text-success-600\\/50:disabled{
  color: rgb(9 146 80 / 0.5);
}

.disabled\\:text-success-600\\/55:disabled{
  color: rgb(9 146 80 / 0.55);
}

.disabled\\:text-success-600\\/60:disabled{
  color: rgb(9 146 80 / 0.6);
}

.disabled\\:text-success-600\\/65:disabled{
  color: rgb(9 146 80 / 0.65);
}

.disabled\\:text-success-600\\/70:disabled{
  color: rgb(9 146 80 / 0.7);
}

.disabled\\:text-success-600\\/75:disabled{
  color: rgb(9 146 80 / 0.75);
}

.disabled\\:text-success-600\\/80:disabled{
  color: rgb(9 146 80 / 0.8);
}

.disabled\\:text-success-600\\/85:disabled{
  color: rgb(9 146 80 / 0.85);
}

.disabled\\:text-success-600\\/90:disabled{
  color: rgb(9 146 80 / 0.9);
}

.disabled\\:text-success-600\\/95:disabled{
  color: rgb(9 146 80 / 0.95);
}

.disabled\\:text-success-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(8 116 67 / var(--tw-text-opacity, 1));
}

.disabled\\:text-success-700\\/0:disabled{
  color: rgb(8 116 67 / 0);
}

.disabled\\:text-success-700\\/10:disabled{
  color: rgb(8 116 67 / 0.1);
}

.disabled\\:text-success-700\\/100:disabled{
  color: rgb(8 116 67 / 1);
}

.disabled\\:text-success-700\\/15:disabled{
  color: rgb(8 116 67 / 0.15);
}

.disabled\\:text-success-700\\/20:disabled{
  color: rgb(8 116 67 / 0.2);
}

.disabled\\:text-success-700\\/25:disabled{
  color: rgb(8 116 67 / 0.25);
}

.disabled\\:text-success-700\\/30:disabled{
  color: rgb(8 116 67 / 0.3);
}

.disabled\\:text-success-700\\/35:disabled{
  color: rgb(8 116 67 / 0.35);
}

.disabled\\:text-success-700\\/40:disabled{
  color: rgb(8 116 67 / 0.4);
}

.disabled\\:text-success-700\\/45:disabled{
  color: rgb(8 116 67 / 0.45);
}

.disabled\\:text-success-700\\/5:disabled{
  color: rgb(8 116 67 / 0.05);
}

.disabled\\:text-success-700\\/50:disabled{
  color: rgb(8 116 67 / 0.5);
}

.disabled\\:text-success-700\\/55:disabled{
  color: rgb(8 116 67 / 0.55);
}

.disabled\\:text-success-700\\/60:disabled{
  color: rgb(8 116 67 / 0.6);
}

.disabled\\:text-success-700\\/65:disabled{
  color: rgb(8 116 67 / 0.65);
}

.disabled\\:text-success-700\\/70:disabled{
  color: rgb(8 116 67 / 0.7);
}

.disabled\\:text-success-700\\/75:disabled{
  color: rgb(8 116 67 / 0.75);
}

.disabled\\:text-success-700\\/80:disabled{
  color: rgb(8 116 67 / 0.8);
}

.disabled\\:text-success-700\\/85:disabled{
  color: rgb(8 116 67 / 0.85);
}

.disabled\\:text-success-700\\/90:disabled{
  color: rgb(8 116 67 / 0.9);
}

.disabled\\:text-success-700\\/95:disabled{
  color: rgb(8 116 67 / 0.95);
}

.disabled\\:text-warning-100:disabled{
  --tw-text-opacity: 1;
  color: rgb(254 240 199 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-100\\/0:disabled{
  color: rgb(254 240 199 / 0);
}

.disabled\\:text-warning-100\\/10:disabled{
  color: rgb(254 240 199 / 0.1);
}

.disabled\\:text-warning-100\\/100:disabled{
  color: rgb(254 240 199 / 1);
}

.disabled\\:text-warning-100\\/15:disabled{
  color: rgb(254 240 199 / 0.15);
}

.disabled\\:text-warning-100\\/20:disabled{
  color: rgb(254 240 199 / 0.2);
}

.disabled\\:text-warning-100\\/25:disabled{
  color: rgb(254 240 199 / 0.25);
}

.disabled\\:text-warning-100\\/30:disabled{
  color: rgb(254 240 199 / 0.3);
}

.disabled\\:text-warning-100\\/35:disabled{
  color: rgb(254 240 199 / 0.35);
}

.disabled\\:text-warning-100\\/40:disabled{
  color: rgb(254 240 199 / 0.4);
}

.disabled\\:text-warning-100\\/45:disabled{
  color: rgb(254 240 199 / 0.45);
}

.disabled\\:text-warning-100\\/5:disabled{
  color: rgb(254 240 199 / 0.05);
}

.disabled\\:text-warning-100\\/50:disabled{
  color: rgb(254 240 199 / 0.5);
}

.disabled\\:text-warning-100\\/55:disabled{
  color: rgb(254 240 199 / 0.55);
}

.disabled\\:text-warning-100\\/60:disabled{
  color: rgb(254 240 199 / 0.6);
}

.disabled\\:text-warning-100\\/65:disabled{
  color: rgb(254 240 199 / 0.65);
}

.disabled\\:text-warning-100\\/70:disabled{
  color: rgb(254 240 199 / 0.7);
}

.disabled\\:text-warning-100\\/75:disabled{
  color: rgb(254 240 199 / 0.75);
}

.disabled\\:text-warning-100\\/80:disabled{
  color: rgb(254 240 199 / 0.8);
}

.disabled\\:text-warning-100\\/85:disabled{
  color: rgb(254 240 199 / 0.85);
}

.disabled\\:text-warning-100\\/90:disabled{
  color: rgb(254 240 199 / 0.9);
}

.disabled\\:text-warning-100\\/95:disabled{
  color: rgb(254 240 199 / 0.95);
}

.disabled\\:text-warning-200:disabled{
  --tw-text-opacity: 1;
  color: rgb(254 223 137 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-200\\/0:disabled{
  color: rgb(254 223 137 / 0);
}

.disabled\\:text-warning-200\\/10:disabled{
  color: rgb(254 223 137 / 0.1);
}

.disabled\\:text-warning-200\\/100:disabled{
  color: rgb(254 223 137 / 1);
}

.disabled\\:text-warning-200\\/15:disabled{
  color: rgb(254 223 137 / 0.15);
}

.disabled\\:text-warning-200\\/20:disabled{
  color: rgb(254 223 137 / 0.2);
}

.disabled\\:text-warning-200\\/25:disabled{
  color: rgb(254 223 137 / 0.25);
}

.disabled\\:text-warning-200\\/30:disabled{
  color: rgb(254 223 137 / 0.3);
}

.disabled\\:text-warning-200\\/35:disabled{
  color: rgb(254 223 137 / 0.35);
}

.disabled\\:text-warning-200\\/40:disabled{
  color: rgb(254 223 137 / 0.4);
}

.disabled\\:text-warning-200\\/45:disabled{
  color: rgb(254 223 137 / 0.45);
}

.disabled\\:text-warning-200\\/5:disabled{
  color: rgb(254 223 137 / 0.05);
}

.disabled\\:text-warning-200\\/50:disabled{
  color: rgb(254 223 137 / 0.5);
}

.disabled\\:text-warning-200\\/55:disabled{
  color: rgb(254 223 137 / 0.55);
}

.disabled\\:text-warning-200\\/60:disabled{
  color: rgb(254 223 137 / 0.6);
}

.disabled\\:text-warning-200\\/65:disabled{
  color: rgb(254 223 137 / 0.65);
}

.disabled\\:text-warning-200\\/70:disabled{
  color: rgb(254 223 137 / 0.7);
}

.disabled\\:text-warning-200\\/75:disabled{
  color: rgb(254 223 137 / 0.75);
}

.disabled\\:text-warning-200\\/80:disabled{
  color: rgb(254 223 137 / 0.8);
}

.disabled\\:text-warning-200\\/85:disabled{
  color: rgb(254 223 137 / 0.85);
}

.disabled\\:text-warning-200\\/90:disabled{
  color: rgb(254 223 137 / 0.9);
}

.disabled\\:text-warning-200\\/95:disabled{
  color: rgb(254 223 137 / 0.95);
}

.disabled\\:text-warning-25:disabled{
  --tw-text-opacity: 1;
  color: rgb(255 252 245 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-25\\/0:disabled{
  color: rgb(255 252 245 / 0);
}

.disabled\\:text-warning-25\\/10:disabled{
  color: rgb(255 252 245 / 0.1);
}

.disabled\\:text-warning-25\\/100:disabled{
  color: rgb(255 252 245 / 1);
}

.disabled\\:text-warning-25\\/15:disabled{
  color: rgb(255 252 245 / 0.15);
}

.disabled\\:text-warning-25\\/20:disabled{
  color: rgb(255 252 245 / 0.2);
}

.disabled\\:text-warning-25\\/25:disabled{
  color: rgb(255 252 245 / 0.25);
}

.disabled\\:text-warning-25\\/30:disabled{
  color: rgb(255 252 245 / 0.3);
}

.disabled\\:text-warning-25\\/35:disabled{
  color: rgb(255 252 245 / 0.35);
}

.disabled\\:text-warning-25\\/40:disabled{
  color: rgb(255 252 245 / 0.4);
}

.disabled\\:text-warning-25\\/45:disabled{
  color: rgb(255 252 245 / 0.45);
}

.disabled\\:text-warning-25\\/5:disabled{
  color: rgb(255 252 245 / 0.05);
}

.disabled\\:text-warning-25\\/50:disabled{
  color: rgb(255 252 245 / 0.5);
}

.disabled\\:text-warning-25\\/55:disabled{
  color: rgb(255 252 245 / 0.55);
}

.disabled\\:text-warning-25\\/60:disabled{
  color: rgb(255 252 245 / 0.6);
}

.disabled\\:text-warning-25\\/65:disabled{
  color: rgb(255 252 245 / 0.65);
}

.disabled\\:text-warning-25\\/70:disabled{
  color: rgb(255 252 245 / 0.7);
}

.disabled\\:text-warning-25\\/75:disabled{
  color: rgb(255 252 245 / 0.75);
}

.disabled\\:text-warning-25\\/80:disabled{
  color: rgb(255 252 245 / 0.8);
}

.disabled\\:text-warning-25\\/85:disabled{
  color: rgb(255 252 245 / 0.85);
}

.disabled\\:text-warning-25\\/90:disabled{
  color: rgb(255 252 245 / 0.9);
}

.disabled\\:text-warning-25\\/95:disabled{
  color: rgb(255 252 245 / 0.95);
}

.disabled\\:text-warning-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(253 176 34 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-400\\/0:disabled{
  color: rgb(253 176 34 / 0);
}

.disabled\\:text-warning-400\\/10:disabled{
  color: rgb(253 176 34 / 0.1);
}

.disabled\\:text-warning-400\\/100:disabled{
  color: rgb(253 176 34 / 1);
}

.disabled\\:text-warning-400\\/15:disabled{
  color: rgb(253 176 34 / 0.15);
}

.disabled\\:text-warning-400\\/20:disabled{
  color: rgb(253 176 34 / 0.2);
}

.disabled\\:text-warning-400\\/25:disabled{
  color: rgb(253 176 34 / 0.25);
}

.disabled\\:text-warning-400\\/30:disabled{
  color: rgb(253 176 34 / 0.3);
}

.disabled\\:text-warning-400\\/35:disabled{
  color: rgb(253 176 34 / 0.35);
}

.disabled\\:text-warning-400\\/40:disabled{
  color: rgb(253 176 34 / 0.4);
}

.disabled\\:text-warning-400\\/45:disabled{
  color: rgb(253 176 34 / 0.45);
}

.disabled\\:text-warning-400\\/5:disabled{
  color: rgb(253 176 34 / 0.05);
}

.disabled\\:text-warning-400\\/50:disabled{
  color: rgb(253 176 34 / 0.5);
}

.disabled\\:text-warning-400\\/55:disabled{
  color: rgb(253 176 34 / 0.55);
}

.disabled\\:text-warning-400\\/60:disabled{
  color: rgb(253 176 34 / 0.6);
}

.disabled\\:text-warning-400\\/65:disabled{
  color: rgb(253 176 34 / 0.65);
}

.disabled\\:text-warning-400\\/70:disabled{
  color: rgb(253 176 34 / 0.7);
}

.disabled\\:text-warning-400\\/75:disabled{
  color: rgb(253 176 34 / 0.75);
}

.disabled\\:text-warning-400\\/80:disabled{
  color: rgb(253 176 34 / 0.8);
}

.disabled\\:text-warning-400\\/85:disabled{
  color: rgb(253 176 34 / 0.85);
}

.disabled\\:text-warning-400\\/90:disabled{
  color: rgb(253 176 34 / 0.9);
}

.disabled\\:text-warning-400\\/95:disabled{
  color: rgb(253 176 34 / 0.95);
}

.disabled\\:text-warning-50:disabled{
  --tw-text-opacity: 1;
  color: rgb(255 250 235 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-50\\/0:disabled{
  color: rgb(255 250 235 / 0);
}

.disabled\\:text-warning-50\\/10:disabled{
  color: rgb(255 250 235 / 0.1);
}

.disabled\\:text-warning-50\\/100:disabled{
  color: rgb(255 250 235 / 1);
}

.disabled\\:text-warning-50\\/15:disabled{
  color: rgb(255 250 235 / 0.15);
}

.disabled\\:text-warning-50\\/20:disabled{
  color: rgb(255 250 235 / 0.2);
}

.disabled\\:text-warning-50\\/25:disabled{
  color: rgb(255 250 235 / 0.25);
}

.disabled\\:text-warning-50\\/30:disabled{
  color: rgb(255 250 235 / 0.3);
}

.disabled\\:text-warning-50\\/35:disabled{
  color: rgb(255 250 235 / 0.35);
}

.disabled\\:text-warning-50\\/40:disabled{
  color: rgb(255 250 235 / 0.4);
}

.disabled\\:text-warning-50\\/45:disabled{
  color: rgb(255 250 235 / 0.45);
}

.disabled\\:text-warning-50\\/5:disabled{
  color: rgb(255 250 235 / 0.05);
}

.disabled\\:text-warning-50\\/50:disabled{
  color: rgb(255 250 235 / 0.5);
}

.disabled\\:text-warning-50\\/55:disabled{
  color: rgb(255 250 235 / 0.55);
}

.disabled\\:text-warning-50\\/60:disabled{
  color: rgb(255 250 235 / 0.6);
}

.disabled\\:text-warning-50\\/65:disabled{
  color: rgb(255 250 235 / 0.65);
}

.disabled\\:text-warning-50\\/70:disabled{
  color: rgb(255 250 235 / 0.7);
}

.disabled\\:text-warning-50\\/75:disabled{
  color: rgb(255 250 235 / 0.75);
}

.disabled\\:text-warning-50\\/80:disabled{
  color: rgb(255 250 235 / 0.8);
}

.disabled\\:text-warning-50\\/85:disabled{
  color: rgb(255 250 235 / 0.85);
}

.disabled\\:text-warning-50\\/90:disabled{
  color: rgb(255 250 235 / 0.9);
}

.disabled\\:text-warning-50\\/95:disabled{
  color: rgb(255 250 235 / 0.95);
}

.disabled\\:text-warning-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(247 144 9 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-500\\/0:disabled{
  color: rgb(247 144 9 / 0);
}

.disabled\\:text-warning-500\\/10:disabled{
  color: rgb(247 144 9 / 0.1);
}

.disabled\\:text-warning-500\\/100:disabled{
  color: rgb(247 144 9 / 1);
}

.disabled\\:text-warning-500\\/15:disabled{
  color: rgb(247 144 9 / 0.15);
}

.disabled\\:text-warning-500\\/20:disabled{
  color: rgb(247 144 9 / 0.2);
}

.disabled\\:text-warning-500\\/25:disabled{
  color: rgb(247 144 9 / 0.25);
}

.disabled\\:text-warning-500\\/30:disabled{
  color: rgb(247 144 9 / 0.3);
}

.disabled\\:text-warning-500\\/35:disabled{
  color: rgb(247 144 9 / 0.35);
}

.disabled\\:text-warning-500\\/40:disabled{
  color: rgb(247 144 9 / 0.4);
}

.disabled\\:text-warning-500\\/45:disabled{
  color: rgb(247 144 9 / 0.45);
}

.disabled\\:text-warning-500\\/5:disabled{
  color: rgb(247 144 9 / 0.05);
}

.disabled\\:text-warning-500\\/50:disabled{
  color: rgb(247 144 9 / 0.5);
}

.disabled\\:text-warning-500\\/55:disabled{
  color: rgb(247 144 9 / 0.55);
}

.disabled\\:text-warning-500\\/60:disabled{
  color: rgb(247 144 9 / 0.6);
}

.disabled\\:text-warning-500\\/65:disabled{
  color: rgb(247 144 9 / 0.65);
}

.disabled\\:text-warning-500\\/70:disabled{
  color: rgb(247 144 9 / 0.7);
}

.disabled\\:text-warning-500\\/75:disabled{
  color: rgb(247 144 9 / 0.75);
}

.disabled\\:text-warning-500\\/80:disabled{
  color: rgb(247 144 9 / 0.8);
}

.disabled\\:text-warning-500\\/85:disabled{
  color: rgb(247 144 9 / 0.85);
}

.disabled\\:text-warning-500\\/90:disabled{
  color: rgb(247 144 9 / 0.9);
}

.disabled\\:text-warning-500\\/95:disabled{
  color: rgb(247 144 9 / 0.95);
}

.disabled\\:text-warning-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(220 104 3 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-600\\/0:disabled{
  color: rgb(220 104 3 / 0);
}

.disabled\\:text-warning-600\\/10:disabled{
  color: rgb(220 104 3 / 0.1);
}

.disabled\\:text-warning-600\\/100:disabled{
  color: rgb(220 104 3 / 1);
}

.disabled\\:text-warning-600\\/15:disabled{
  color: rgb(220 104 3 / 0.15);
}

.disabled\\:text-warning-600\\/20:disabled{
  color: rgb(220 104 3 / 0.2);
}

.disabled\\:text-warning-600\\/25:disabled{
  color: rgb(220 104 3 / 0.25);
}

.disabled\\:text-warning-600\\/30:disabled{
  color: rgb(220 104 3 / 0.3);
}

.disabled\\:text-warning-600\\/35:disabled{
  color: rgb(220 104 3 / 0.35);
}

.disabled\\:text-warning-600\\/40:disabled{
  color: rgb(220 104 3 / 0.4);
}

.disabled\\:text-warning-600\\/45:disabled{
  color: rgb(220 104 3 / 0.45);
}

.disabled\\:text-warning-600\\/5:disabled{
  color: rgb(220 104 3 / 0.05);
}

.disabled\\:text-warning-600\\/50:disabled{
  color: rgb(220 104 3 / 0.5);
}

.disabled\\:text-warning-600\\/55:disabled{
  color: rgb(220 104 3 / 0.55);
}

.disabled\\:text-warning-600\\/60:disabled{
  color: rgb(220 104 3 / 0.6);
}

.disabled\\:text-warning-600\\/65:disabled{
  color: rgb(220 104 3 / 0.65);
}

.disabled\\:text-warning-600\\/70:disabled{
  color: rgb(220 104 3 / 0.7);
}

.disabled\\:text-warning-600\\/75:disabled{
  color: rgb(220 104 3 / 0.75);
}

.disabled\\:text-warning-600\\/80:disabled{
  color: rgb(220 104 3 / 0.8);
}

.disabled\\:text-warning-600\\/85:disabled{
  color: rgb(220 104 3 / 0.85);
}

.disabled\\:text-warning-600\\/90:disabled{
  color: rgb(220 104 3 / 0.9);
}

.disabled\\:text-warning-600\\/95:disabled{
  color: rgb(220 104 3 / 0.95);
}

.disabled\\:text-warning-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}

.disabled\\:text-warning-700\\/0:disabled{
  color: rgb(181 71 8 / 0);
}

.disabled\\:text-warning-700\\/10:disabled{
  color: rgb(181 71 8 / 0.1);
}

.disabled\\:text-warning-700\\/100:disabled{
  color: rgb(181 71 8 / 1);
}

.disabled\\:text-warning-700\\/15:disabled{
  color: rgb(181 71 8 / 0.15);
}

.disabled\\:text-warning-700\\/20:disabled{
  color: rgb(181 71 8 / 0.2);
}

.disabled\\:text-warning-700\\/25:disabled{
  color: rgb(181 71 8 / 0.25);
}

.disabled\\:text-warning-700\\/30:disabled{
  color: rgb(181 71 8 / 0.3);
}

.disabled\\:text-warning-700\\/35:disabled{
  color: rgb(181 71 8 / 0.35);
}

.disabled\\:text-warning-700\\/40:disabled{
  color: rgb(181 71 8 / 0.4);
}

.disabled\\:text-warning-700\\/45:disabled{
  color: rgb(181 71 8 / 0.45);
}

.disabled\\:text-warning-700\\/5:disabled{
  color: rgb(181 71 8 / 0.05);
}

.disabled\\:text-warning-700\\/50:disabled{
  color: rgb(181 71 8 / 0.5);
}

.disabled\\:text-warning-700\\/55:disabled{
  color: rgb(181 71 8 / 0.55);
}

.disabled\\:text-warning-700\\/60:disabled{
  color: rgb(181 71 8 / 0.6);
}

.disabled\\:text-warning-700\\/65:disabled{
  color: rgb(181 71 8 / 0.65);
}

.disabled\\:text-warning-700\\/70:disabled{
  color: rgb(181 71 8 / 0.7);
}

.disabled\\:text-warning-700\\/75:disabled{
  color: rgb(181 71 8 / 0.75);
}

.disabled\\:text-warning-700\\/80:disabled{
  color: rgb(181 71 8 / 0.8);
}

.disabled\\:text-warning-700\\/85:disabled{
  color: rgb(181 71 8 / 0.85);
}

.disabled\\:text-warning-700\\/90:disabled{
  color: rgb(181 71 8 / 0.9);
}

.disabled\\:text-warning-700\\/95:disabled{
  color: rgb(181 71 8 / 0.95);
}

.disabled\\:\\!opacity-100:disabled{
  opacity: 1 !important;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.disabled\\:hover\\:bg-transparent:hover:disabled{
  background-color: transparent;
}

.disabled\\:hover\\:bg-white:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.disabled\\:active\\:bg-white:active:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group:focus-within .group-focus-within\\:pr-\\[32px\\]{
  padding-right: 32px;
}

.group\\/copy:focus-within .group-focus-within\\/copy\\:opacity-100{
  opacity: 1;
}

.group:focus-within .group-focus-within\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:visible{
  visibility: visible;
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:flex{
  display: flex;
}

.group\\/viewall:hover .group-hover\\/viewall\\:translate-x-\\[2px\\]{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-125{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/action:hover .group-hover\\/action\\:\\!border-primary-500{
  border-color: var(--color-primary-500, #0BA5EC) !important;
}

.group\\/action:hover .group-hover\\/action\\:\\!border-primary-600{
  border-color: var(--color-primary-600, #0086C9) !important;
}

.group\\/action:hover .group-hover\\/action\\:\\!bg-primary-500{
  background-color: var(--color-primary-500, #0BA5EC) !important;
}

.group\\/action:hover .group-hover\\/action\\:\\!bg-primary-600{
  background-color: var(--color-primary-600, #0086C9) !important;
}

.group\\/row:hover .group-hover\\/row\\:bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.group:hover .group-hover\\:bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-neutral-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-neutral-500{
  --tw-bg-opacity: 1;
  background-color: rgb(113 118 128 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-neutral-700{
  --tw-bg-opacity: 1;
  background-color: rgb(65 70 81 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-primary-300{
  background-color: var(--color-primary-300, #7CD4FD);
}

.group:hover .group-hover\\:pr-\\[32px\\]{
  padding-right: 32px;
}

.group\\/action:hover .group-hover\\/action\\:\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.group\\/copy:hover .group-hover\\/copy\\:text-primary-700{
  color: var(--color-primary-700, #026AA2);
}

.group:hover .group-hover\\:\\!text-neutral-800{
  --tw-text-opacity: 1 !important;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:\\!text-warning-700{
  --tw-text-opacity: 1 !important;
  color: rgb(181 71 8 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:text-primary-500{
  color: var(--color-primary-500, #0BA5EC);
}

.group:hover .group-hover\\:text-primary-700{
  color: var(--color-primary-700, #026AA2);
}

.group\\/copy:hover .group-hover\\/copy\\:opacity-100{
  opacity: 1;
}

.group\\/row:hover .group-hover\\/row\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-60{
  opacity: 0.6;
}

.group:hover .group-hover\\:delay-150{
  transition-delay: 150ms;
}

.group:focus .group-focus\\:bg-danger-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}

.group:focus .group-focus\\:bg-neutral-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.group:focus .group-focus\\:bg-success-50{
  --tw-bg-opacity: 1;
  background-color: rgb(237 252 242 / var(--tw-bg-opacity, 1));
}

.group:focus .group-focus\\:bg-warning-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}

.group:focus-visible .group-focus-visible\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group:focus-visible .group-focus-visible\\:ring-primary-300{
  --tw-ring-color: var(--color-primary-300, #7CD4FD);
}

.group:active .group-active\\:bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.group:active .group-active\\:bg-neutral-200{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.has-\\[\\:focus-visible\\]\\:border-neutral-200:has(:focus-visible){
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.has-\\[\\:focus-visible\\]\\:bg-neutral-50:has(:focus-visible){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.group:has(:focus-visible) .group-has-\\[\\:focus-visible\\]\\:visible{
  visibility: visible;
}

.group:has(:focus-visible) .group-has-\\[\\:focus-visible\\]\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/row:has(:focus-visible) .group-has-\\[\\:focus-visible\\]\\/row\\:opacity-100{
  opacity: 1;
}

.group:has(:focus-visible) .group-has-\\[\\:focus-visible\\]\\:opacity-100{
  opacity: 1;
}

.data-\\[open\\]\\:border-primary-500[data-open]{
  border-color: var(--color-primary-500, #0BA5EC);
}

.data-\\[focus\\]\\:bg-neutral-100[data-focus]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.data-\\[focus\\]\\:bg-neutral-75[data-focus]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.data-\\[focus\\]\\:bg-primary-100[data-focus]{
  background-color: var(--color-primary-100, #E0F2FE);
}

.data-\\[focus\\]\\:bg-white[data-focus]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.data-\\[hover\\]\\:bg-white\\/5[data-hover]{
  background-color: rgb(255 255 255 / 0.05);
}

.data-\\[open\\]\\:bg-neutral-200[data-open]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 234 235 / var(--tw-bg-opacity, 1));
}

.data-\\[open\\]\\:bg-neutral-75[data-open]{
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}

.data-\\[open\\]\\:bg-white[data-open]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group[data-open] .group-data-\\[open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (prefers-reduced-motion: no-preference){
  @keyframes pulse{
    50%{
      opacity: .5;
    }
  }
  .motion-safe\\:animate-\\[pulse_1\\.2s_ease-in-out_infinite\\]{
    animation: pulse 1.2s ease-in-out infinite;
  }
  @keyframes enter-up{
    0%{
      opacity: 0;
      transform: translateY(16px);
    }
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }
  .motion-safe\\:animate-enter-up{
    animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) backwards;
  }
  @keyframes enter-up{
    0%{
      opacity: 0;
      transform: translateY(16px);
    }
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }
  .motion-safe\\:animate-enter-up-1{
    animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards;
  }
  @keyframes enter-up{
    0%{
      opacity: 0;
      transform: translateY(16px);
    }
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }
  .motion-safe\\:animate-enter-up-2{
    animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.22s backwards;
  }
  @keyframes enter-up{
    0%{
      opacity: 0;
      transform: translateY(16px);
    }
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }
  .motion-safe\\:animate-enter-up-3{
    animation: enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.34s backwards;
  }
}

@media (prefers-reduced-motion: reduce){
  .motion-reduce\\:animate-none{
    animation: none;
  }
  .motion-reduce\\:transition-none{
    transition-property: none;
  }
  .motion-reduce\\:duration-\\[80ms\\]{
    transition-duration: 80ms;
  }
  .motion-reduce\\:hover\\:translate-y-0:hover{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .motion-reduce\\:active\\:scale-100:active{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .group\\/viewall:hover .motion-reduce\\:group-hover\\/viewall\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 1920px){
  .xxl\\:inline{
    display: inline;
  }
  .xxl\\:max-w-\\[1408px\\]{
    max-width: 1408px;
  }
  .xxl\\:max-w-\\[1920px\\]{
    max-width: 1920px;
  }
  .xxl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xxl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 1919px){
  .xl\\:inline{
    display: inline;
  }
  .xl\\:w-\\[284px\\]{
    width: 284px;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 1439px){
  .lg\\:static{
    position: static;
  }
  .lg\\:left-1{
    left: 0.25rem;
  }
  .lg\\:left-2{
    left: 0.5rem;
  }
  .lg\\:right-1{
    right: 0.25rem;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:inline{
    display: inline;
  }
  .lg\\:grid{
    display: grid;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-full{
    height: 100%;
  }
  .lg\\:max-h-\\[300px\\]{
    max-height: 300px;
  }
  .lg\\:min-h-\\[var\\(--app-height\\2c 100vh\\)\\]{
    min-height: var(--app-height,100vh);
  }
  .lg\\:\\!w-\\[340px\\]{
    width: 340px !important;
  }
  .lg\\:\\!w-\\[460px\\]{
    width: 460px !important;
  }
  .lg\\:w-1\\/2{
    width: 50%;
  }
  .lg\\:w-2\\/3{
    width: 66.666667%;
  }
  .lg\\:w-\\[86\\%\\]{
    width: 86%;
  }
  .lg\\:w-\\[96\\%\\]{
    width: 96%;
  }
  .lg\\:w-full{
    width: 100%;
  }
  .lg\\:max-w-none{
    max-width: none;
  }
  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(140px\\2c 1fr\\)\\)\\]{
    grid-template-columns: repeat(auto-fill,minmax(140px,1fr));
  }
  .lg\\:flex-col{
    flex-direction: column;
  }
  .lg\\:items-end{
    align-items: flex-end;
  }
  .lg\\:gap-4{
    gap: 1rem;
  }
  .lg\\:gap-x-4{
    column-gap: 1rem;
  }
  .lg\\:whitespace-nowrap{
    white-space: nowrap;
  }
  .lg\\:rounded-none{
    border-radius: 0px;
  }
  .lg\\:p-0{
    padding: 0px;
  }
  .lg\\:p-3{
    padding: 0.75rem;
  }
  .lg\\:p-6{
    padding: 1.5rem;
  }
  .lg\\:\\!px-12{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
  .lg\\:\\!px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .lg\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (max-width: 1279px){
  .md\\:bottom-10{
    bottom: 2.5rem;
  }
  .md\\:left-2{
    left: 0.5rem;
  }
  .md\\:order-3{
    order: 3;
  }
  .md\\:\\!col-span-1{
    grid-column: span 1 / span 1 !important;
  }
  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-full{
    grid-column: 1 / -1;
  }
  .md\\:mb-5{
    margin-bottom: 1.25rem;
  }
  .md\\:ml-auto{
    margin-left: auto;
  }
  .md\\:mt-0\\.5{
    margin-top: 0.125rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:inline{
    display: inline;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-\\[calc\\(100vh-194px\\)\\]{
    height: calc(100vh - 194px);
  }
  .md\\:max-h-\\[400px\\]{
    max-height: 400px;
  }
  .md\\:\\!w-\\[300px\\]{
    width: 300px !important;
  }
  .md\\:\\!w-\\[400px\\]{
    width: 400px !important;
  }
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:w-2\\/5{
    width: 40%;
  }
  .md\\:w-\\[200px\\]{
    width: 200px;
  }
  .md\\:w-\\[60\\%\\]{
    width: 60%;
  }
  .md\\:w-\\[86\\%\\]{
    width: 86%;
  }
  .md\\:w-\\[96\\%\\]{
    width: 96%;
  }
  .md\\:w-full{
    width: 100%;
  }
  .md\\:w-screen{
    width: 100vw;
  }
  .md\\:min-w-0{
    min-width: 0px;
  }
  .md\\:min-w-\\[350px\\]{
    min-width: 350px;
  }
  .md\\:min-w-\\[480px\\]{
    min-width: 480px;
  }
  .md\\:min-w-fit{
    min-width: fit-content;
  }
  .md\\:max-w-\\[400px\\]{
    max-width: 400px;
  }
  .md\\:max-w-\\[450px\\]{
    max-width: 450px;
  }
  .md\\:\\!grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:items-end{
    align-items: flex-end;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:gap-1{
    gap: 0.25rem;
  }
  .md\\:gap-5{
    gap: 1.25rem;
  }
  .md\\:gap-6{
    gap: 1.5rem;
  }
  .md\\:divide-y > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  }
  .md\\:whitespace-nowrap{
    white-space: nowrap;
  }
  .md\\:rounded-none{
    border-radius: 0px;
  }
  .md\\:border-l-0{
    border-left-width: 0px;
  }
  .md\\:border-t{
    border-top-width: 1px;
  }
  .md\\:p-0{
    padding: 0px;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:\\!px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .md\\:\\!px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .md\\:\\!px-\\[26px\\]{
    padding-left: 26px !important;
    padding-right: 26px !important;
  }
  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-\\[60px\\]{
    padding-left: 60px;
    padding-right: 60px;
  }
  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .md\\:\\!pt-0{
    padding-top: 0px !important;
  }
  .md\\:pl-3{
    padding-left: 0.75rem;
  }
  .md\\:pl-4{
    padding-left: 1rem;
  }
  .md\\:pr-3{
    padding-right: 0.75rem;
  }
  .md\\:pr-6{
    padding-right: 1.5rem;
  }
  .md\\:pt-0{
    padding-top: 0px;
  }
  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (max-width: 1023px){
  .sm\\:fixed{
    position: fixed;
  }
  .sm\\:absolute{
    position: absolute;
  }
  .sm\\:inset-0{
    inset: 0px;
  }
  .sm\\:inset-x-0{
    left: 0px;
    right: 0px;
  }
  .sm\\:bottom-0{
    bottom: 0px;
  }
  .sm\\:left-0{
    left: 0px;
  }
  .sm\\:left-2{
    left: 0.5rem;
  }
  .sm\\:right-0{
    right: 0px;
  }
  .sm\\:right-1{
    right: 0.25rem;
  }
  .sm\\:right-14{
    right: 3.5rem;
  }
  .sm\\:top-0{
    top: 0px;
  }
  .sm\\:top-2{
    top: 0.5rem;
  }
  .sm\\:z-10{
    z-index: 10;
  }
  .sm\\:z-20{
    z-index: 20;
  }
  .sm\\:z-50{
    z-index: 50;
  }
  .sm\\:order-1{
    order: 1;
  }
  .sm\\:order-2{
    order: 2;
  }
  .sm\\:order-3{
    order: 3;
  }
  .sm\\:order-last{
    order: 9999;
  }
  .sm\\:\\!col-span-1{
    grid-column: span 1 / span 1 !important;
  }
  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .sm\\:col-span-5{
    grid-column: span 5 / span 5;
  }
  .sm\\:col-span-full{
    grid-column: 1 / -1;
  }
  .sm\\:col-start-1{
    grid-column-start: 1;
  }
  .sm\\:row-start-3{
    grid-row-start: 3;
  }
  .sm\\:\\!m-0{
    margin: 0px !important;
  }
  .sm\\:m-4{
    margin: 1rem;
  }
  .sm\\:\\!mx-0{
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .sm\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .sm\\:my-\\[0\\.5rem\\]{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .sm\\:my-\\[1\\.5rem\\]{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .sm\\:mb-0{
    margin-bottom: 0px;
  }
  .sm\\:ml-auto{
    margin-left: auto;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-0\\.5{
    margin-top: 0.125rem;
  }
  .sm\\:mt-4{
    margin-top: 1rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:\\!flex{
    display: flex !important;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:grid{
    display: grid;
  }
  .sm\\:\\!hidden{
    display: none !important;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:aspect-\\[5\\/3\\]{
    aspect-ratio: 5/3;
  }
  .sm\\:aspect-auto{
    aspect-ratio: auto;
  }
  .sm\\:\\!h-12{
    height: 3rem !important;
  }
  .sm\\:\\!h-6{
    height: 1.5rem !important;
  }
  .sm\\:\\!h-7{
    height: 1.75rem !important;
  }
  .sm\\:\\!h-\\[40px\\]{
    height: 40px !important;
  }
  .sm\\:\\!h-full{
    height: 100% !important;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-4{
    height: 1rem;
  }
  .sm\\:h-8{
    height: 2rem;
  }
  .sm\\:h-9{
    height: 2.25rem;
  }
  .sm\\:h-\\[1px\\]{
    height: 1px;
  }
  .sm\\:h-auto{
    height: auto;
  }
  .sm\\:h-full{
    height: 100%;
  }
  .sm\\:\\!max-h-full{
    max-height: 100% !important;
  }
  .sm\\:max-h-\\[248px\\]{
    max-height: 248px;
  }
  .sm\\:max-h-\\[45vh\\]{
    max-height: 45vh;
  }
  .sm\\:max-h-\\[calc\\(100vh-32px\\)\\]{
    max-height: calc(100vh - 32px);
  }
  .sm\\:max-h-\\[calc\\(50vh-32px\\)\\]{
    max-height: calc(50vh - 32px);
  }
  .sm\\:\\!min-h-12{
    min-height: 3rem !important;
  }
  .sm\\:min-h-dvh{
    min-height: 100dvh;
  }
  .sm\\:\\!w-0{
    width: 0px !important;
  }
  .sm\\:\\!w-4{
    width: 1rem !important;
  }
  .sm\\:\\!w-\\[280px\\]{
    width: 280px !important;
  }
  .sm\\:\\!w-\\[350px\\]{
    width: 350px !important;
  }
  .sm\\:\\!w-full{
    width: 100% !important;
  }
  .sm\\:w-12{
    width: 3rem;
  }
  .sm\\:w-2\\/5{
    width: 40%;
  }
  .sm\\:w-20{
    width: 5rem;
  }
  .sm\\:w-28{
    width: 7rem;
  }
  .sm\\:w-3\\/4{
    width: 75%;
  }
  .sm\\:w-96{
    width: 24rem;
  }
  .sm\\:w-\\[100\\%\\]{
    width: 100%;
  }
  .sm\\:w-\\[250px\\]{
    width: 250px;
  }
  .sm\\:w-\\[400px\\]{
    width: 400px;
  }
  .sm\\:w-\\[85\\%\\]{
    width: 85%;
  }
  .sm\\:w-\\[86\\%\\]{
    width: 86%;
  }
  .sm\\:w-\\[96\\%\\]{
    width: 96%;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:w-screen{
    width: 100vw;
  }
  .sm\\:\\!min-w-\\[16px\\]{
    min-width: 16px !important;
  }
  .sm\\:min-w-0{
    min-width: 0px;
  }
  .sm\\:min-w-\\[190px\\]{
    min-width: 190px;
  }
  .sm\\:min-w-\\[300px\\]{
    min-width: 300px;
  }
  .sm\\:min-w-\\[90\\%\\]{
    min-width: 90%;
  }
  .sm\\:min-w-fit{
    min-width: fit-content;
  }
  .sm\\:min-w-max{
    min-width: max-content;
  }
  .sm\\:max-w-\\[320px\\]{
    max-width: 320px;
  }
  .sm\\:max-w-\\[90\\%\\]{
    max-width: 90%;
  }
  .sm\\:max-w-full{
    max-width: 100%;
  }
  .sm\\:flex-1{
    flex: 1 1 0%;
  }
  .sm\\:flex-none{
    flex: none;
  }
  .sm\\:shrink-0{
    flex-shrink: 0;
  }
  .sm\\:basis-auto{
    flex-basis: auto;
  }
  .sm\\:-translate-x-full{
    --tw-translate-x: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:\\!grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sm\\:grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(130px\\2c 1fr\\)\\)\\]{
    grid-template-columns: repeat(auto-fit,minmax(130px,1fr));
  }
  .sm\\:grid-rows-\\[0fr\\]{
    grid-template-rows: 0fr;
  }
  .sm\\:grid-rows-\\[1fr\\]{
    grid-template-rows: 1fr;
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:\\!items-start{
    align-items: flex-start !important;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:items-stretch{
    align-items: stretch;
  }
  .sm\\:justify-start{
    justify-content: flex-start;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:justify-between{
    justify-content: space-between;
  }
  .sm\\:\\!gap-1\\.5{
    gap: 0.375rem !important;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:gap-1{
    gap: 0.25rem;
  }
  .sm\\:gap-1\\.5{
    gap: 0.375rem;
  }
  .sm\\:gap-2{
    gap: 0.5rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-6{
    gap: 1.5rem;
  }
  .sm\\:gap-\\[10px\\]{
    gap: 10px;
  }
  .sm\\:gap-\\[2px\\]{
    gap: 2px;
  }
  .sm\\:\\!gap-y-4{
    row-gap: 1rem !important;
  }
  .sm\\:gap-x-2\\.5{
    column-gap: 0.625rem;
  }
  .sm\\:gap-y-3{
    row-gap: 0.75rem;
  }
  .sm\\:gap-y-6{
    row-gap: 1.5rem;
  }
  .sm\\:divide-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(0px * var(--tw-divide-x-reverse));
    border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)));
  }
  .sm\\:divide-y > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  }
  .sm\\:self-auto{
    align-self: auto;
  }
  .sm\\:overflow-visible{
    overflow: visible;
  }
  .sm\\:overflow-y-auto{
    overflow-y: auto;
  }
  .sm\\:overflow-y-visible{
    overflow-y: visible;
  }
  .sm\\:whitespace-normal{
    white-space: normal;
  }
  .sm\\:whitespace-nowrap{
    white-space: nowrap;
  }
  .sm\\:\\!rounded-none{
    border-radius: 0px !important;
  }
  .sm\\:rounded-none{
    border-radius: 0px;
  }
  .sm\\:rounded-xl{
    border-radius: 0.75rem;
  }
  .sm\\:border{
    border-width: 1px;
  }
  .sm\\:border-0{
    border-width: 0px;
  }
  .sm\\:\\!border-t-\\[2px\\]{
    border-top-width: 2px !important;
  }
  .sm\\:border-b{
    border-bottom-width: 1px;
  }
  .sm\\:border-b-0{
    border-bottom-width: 0px;
  }
  .sm\\:border-b-\\[1px\\]{
    border-bottom-width: 1px;
  }
  .sm\\:border-l-0{
    border-left-width: 0px;
  }
  .sm\\:border-r-0{
    border-right-width: 0px;
  }
  .sm\\:border-t{
    border-top-width: 1px;
  }
  .sm\\:\\!border-solid{
    border-style: solid !important;
  }
  .sm\\:border-solid{
    border-style: solid;
  }
  .sm\\:\\!border-none{
    border-style: none !important;
  }
  .sm\\:\\!border-neutral-100{
    --tw-border-opacity: 1 !important;
    border-color: rgb(245 245 245 / var(--tw-border-opacity, 1)) !important;
  }
  .sm\\:border-neutral-200{
    --tw-border-opacity: 1;
    border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  }
  .sm\\:border-b-neutral-100{
    --tw-border-opacity: 1;
    border-bottom-color: rgb(245 245 245 / var(--tw-border-opacity, 1));
  }
  .sm\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .sm\\:\\!p-0{
    padding: 0px !important;
  }
  .sm\\:\\!p-4{
    padding: 1rem !important;
  }
  .sm\\:p-0{
    padding: 0px;
  }
  .sm\\:p-10{
    padding: 2.5rem;
  }
  .sm\\:p-2{
    padding: 0.5rem;
  }
  .sm\\:p-3{
    padding: 0.75rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:\\!px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .sm\\:\\!px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .sm\\:\\!px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
  .sm\\:\\!px-\\[16px\\]{
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .sm\\:\\!py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .sm\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .sm\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:\\!pt-2{
    padding-top: 0.5rem !important;
  }
  .sm\\:\\!pt-3{
    padding-top: 0.75rem !important;
  }
  .sm\\:pb-4{
    padding-bottom: 1rem;
  }
  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .sm\\:pb-8{
    padding-bottom: 2rem;
  }
  .sm\\:pb-\\[136px\\]{
    padding-bottom: 136px;
  }
  .sm\\:pl-0{
    padding-left: 0px;
  }
  .sm\\:pl-2{
    padding-left: 0.5rem;
  }
  .sm\\:pl-5{
    padding-left: 1.25rem;
  }
  .sm\\:pr-4{
    padding-right: 1rem;
  }
  .sm\\:pt-2{
    padding-top: 0.5rem;
  }
  .sm\\:pt-3{
    padding-top: 0.75rem;
  }
  .sm\\:pt-4{
    padding-top: 1rem;
  }
  .sm\\:pt-6{
    padding-top: 1.5rem;
  }
  .sm\\:pt-8{
    padding-top: 2rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:\\!text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
  .sm\\:\\!text-base{
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-\\[12px\\]{
    font-size: 12px;
  }
  .sm\\:text-\\[28px\\]{
    font-size: 28px;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .sm\\:leading-9{
    line-height: 2.25rem;
  }
  .sm\\:leading-\\[14px\\]{
    line-height: 14px;
  }
  .sm\\:leading-\\[20px\\]{
    line-height: 20px;
  }
  .sm\\:opacity-0{
    opacity: 0;
  }
  .sm\\:opacity-100{
    opacity: 1;
  }
  .sm\\:\\!shadow-none{
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }
  .sm\\:shadow-\\[0_-4px_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
    --tw-shadow: 0 -4px 12px rgba(0,0,0,0.06);
    --tw-shadow-colored: 0 -4px 12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .sm\\:shadow-xl{
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .sm\\:outline{
    outline-style: solid;
  }
  .sm\\:outline-1{
    outline-width: 1px;
  }
  .sm\\:outline-neutral-200{
    outline-color: #E9EAEB;
  }
  .sm\\:\\!transition-none{
    transition-property: none !important;
  }
  .sm\\:transition-\\[gap\\]{
    transition-property: gap;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .sm\\:transition-all{
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .sm\\:transition-transform{
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .sm\\:\\!delay-0{
    transition-delay: 0s !important;
  }
  .sm\\:duration-300{
    transition-duration: 300ms;
  }
  .sm\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
}

@media (max-width: 599px){
  .xs\\:static{
    position: static;
  }
  .xs\\:order-last{
    order: 9999;
  }
  .xs\\:\\!col-span-1{
    grid-column: span 1 / span 1 !important;
  }
  .xs\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .xs\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
  .xs\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .xs\\:mb-3{
    margin-bottom: 0.75rem;
  }
  .xs\\:mb-4{
    margin-bottom: 1rem;
  }
  .xs\\:mt-1{
    margin-top: 0.25rem;
  }
  .xs\\:mt-auto{
    margin-top: auto;
  }
  .xs\\:block{
    display: block;
  }
  .xs\\:inline{
    display: inline;
  }
  .xs\\:flex{
    display: flex;
  }
  .xs\\:grid{
    display: grid;
  }
  .xs\\:hidden{
    display: none;
  }
  .xs\\:\\!h-\\[48px\\]{
    height: 48px !important;
  }
  .xs\\:h-12{
    height: 3rem;
  }
  .xs\\:h-14{
    height: 3.5rem;
  }
  .xs\\:h-16{
    height: 4rem;
  }
  .xs\\:h-\\[72px\\]{
    height: 72px;
  }
  .xs\\:h-auto{
    height: auto;
  }
  .xs\\:h-full{
    height: 100%;
  }
  .xs\\:max-h-\\[240px\\]{
    max-height: 240px;
  }
  .xs\\:min-h-0{
    min-height: 0px;
  }
  .xs\\:min-h-10{
    min-height: 2.5rem;
  }
  .xs\\:min-h-6{
    min-height: 1.5rem;
  }
  .xs\\:min-h-7{
    min-height: 1.75rem;
  }
  .xs\\:min-h-8{
    min-height: 2rem;
  }
  .xs\\:\\!w-full{
    width: 100% !important;
  }
  .xs\\:w-12{
    width: 3rem;
  }
  .xs\\:w-16{
    width: 4rem;
  }
  .xs\\:w-\\[72px\\]{
    width: 72px;
  }
  .xs\\:w-\\[calc\\(100vw-32px\\)\\]{
    width: calc(100vw - 32px);
  }
  .xs\\:w-auto{
    width: auto;
  }
  .xs\\:w-full{
    width: 100%;
  }
  .xs\\:w-max{
    width: max-content;
  }
  .xs\\:min-w-0{
    min-width: 0px;
  }
  .xs\\:min-w-\\[50px\\]{
    min-width: 50px;
  }
  .xs\\:\\!max-w-full{
    max-width: 100% !important;
  }
  .xs\\:max-w-\\[170px\\]{
    max-width: 170px;
  }
  .xs\\:max-w-none{
    max-width: none;
  }
  .xs\\:flex-1{
    flex: 1 1 0%;
  }
  .xs\\:flex-auto{
    flex: 1 1 auto;
  }
  .xs\\:flex-none{
    flex: none;
  }
  .xs\\:shrink-0{
    flex-shrink: 0;
  }
  .xs\\:\\!grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .xs\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xs\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xs\\:flex-row{
    flex-direction: row;
  }
  .xs\\:flex-col{
    flex-direction: column;
  }
  .xs\\:flex-col-reverse{
    flex-direction: column-reverse;
  }
  .xs\\:flex-wrap{
    flex-wrap: wrap;
  }
  .xs\\:items-start{
    align-items: flex-start;
  }
  .xs\\:items-stretch{
    align-items: stretch;
  }
  .xs\\:justify-start{
    justify-content: flex-start;
  }
  .xs\\:justify-end{
    justify-content: flex-end;
  }
  .xs\\:justify-between{
    justify-content: space-between;
  }
  .xs\\:gap-0\\.5{
    gap: 0.125rem;
  }
  .xs\\:gap-1{
    gap: 0.25rem;
  }
  .xs\\:gap-2{
    gap: 0.5rem;
  }
  .xs\\:gap-3{
    gap: 0.75rem;
  }
  .xs\\:gap-4{
    gap: 1rem;
  }
  .xs\\:gap-5{
    gap: 1.25rem;
  }
  .xs\\:gap-6{
    gap: 1.5rem;
  }
  .xs\\:gap-x-2{
    column-gap: 0.5rem;
  }
  .xs\\:gap-x-3{
    column-gap: 0.75rem;
  }
  .xs\\:gap-y-2\\.5{
    row-gap: 0.625rem;
  }
  .xs\\:gap-y-3{
    row-gap: 0.75rem;
  }
  .xs\\:gap-y-5{
    row-gap: 1.25rem;
  }
  .xs\\:gap-y-9{
    row-gap: 2.25rem;
  }
  .xs\\:overflow-visible{
    overflow: visible;
  }
  .xs\\:whitespace-normal{
    white-space: normal;
  }
  .xs\\:\\!rounded-none{
    border-radius: 0px !important;
  }
  .xs\\:rounded-none{
    border-radius: 0px;
  }
  .xs\\:border-0{
    border-width: 0px;
  }
  .xs\\:border-b{
    border-bottom-width: 1px;
  }
  .xs\\:border-r-0{
    border-right-width: 0px;
  }
  .xs\\:\\!p-0{
    padding: 0px !important;
  }
  .xs\\:\\!p-4{
    padding: 1rem !important;
  }
  .xs\\:\\!p-5{
    padding: 1.25rem !important;
  }
  .xs\\:p-0{
    padding: 0px;
  }
  .xs\\:p-3{
    padding: 0.75rem;
  }
  .xs\\:p-4{
    padding: 1rem;
  }
  .xs\\:p-5{
    padding: 1.25rem;
  }
  .xs\\:p-6{
    padding: 1.5rem;
  }
  .xs\\:\\!px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .xs\\:\\!px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
  .xs\\:\\!px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .xs\\:\\!px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
  .xs\\:\\!py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .xs\\:\\!py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .xs\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .xs\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .xs\\:px-1\\.5{
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }
  .xs\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .xs\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .xs\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .xs\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .xs\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .xs\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .xs\\:\\!pb-3{
    padding-bottom: 0.75rem !important;
  }
  .xs\\:\\!pb-4{
    padding-bottom: 1rem !important;
  }
  .xs\\:\\!pt-2{
    padding-top: 0.5rem !important;
  }
  .xs\\:\\!pt-7{
    padding-top: 1.75rem !important;
  }
  .xs\\:pb-3{
    padding-bottom: 0.75rem;
  }
  .xs\\:pb-4{
    padding-bottom: 1rem;
  }
  .xs\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .xs\\:pl-4{
    padding-left: 1rem;
  }
  .xs\\:pr-0{
    padding-right: 0px;
  }
  .xs\\:pr-5{
    padding-right: 1.25rem;
  }
  .xs\\:pt-4{
    padding-top: 1rem;
  }
  .xs\\:pt-5{
    padding-top: 1.25rem;
  }
  .xs\\:text-left{
    text-align: left;
  }
  .xs\\:text-center{
    text-align: center;
  }
  .xs\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .xs\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .xs\\:text-\\[12px\\]{
    font-size: 12px;
  }
  .xs\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .xs\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .xs\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .xs\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .xs\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .xs\\:font-600{
    font-weight: 600;
  }
  .xs\\:leading-\\[16px\\]{
    line-height: 16px;
  }
  .xs\\:leading-tight{
    line-height: 1.25;
  }
  .xs\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (max-width: 389px){
  .xxs\\:\\!min-h-\\[24px\\]{
    min-height: 24px !important;
  }
  .xxs\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xxs\\:\\!py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .xxs\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .xxs\\:pb-14{
    padding-bottom: 3.5rem;
  }
  .xxs\\:pb-\\[95px\\]{
    padding-bottom: 95px;
  }
  .xxs\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media print{
  .print\\:relative{
    position: relative;
  }
  .print\\:left-0{
    left: 0px;
  }
  .print\\:\\!mb-0{
    margin-bottom: 0px !important;
  }
  .print\\:ml-5{
    margin-left: 1.25rem;
  }
  .print\\:mr-5{
    margin-right: 1.25rem;
  }
  .print\\:\\!block{
    display: block !important;
  }
  .print\\:block{
    display: block;
  }
  .print\\:hidden{
    display: none;
  }
  .print\\:\\!h-auto{
    height: auto !important;
  }
  .print\\:\\!w-auto{
    width: auto !important;
  }
  .print\\:w-full{
    width: 100%;
  }
  .print\\:\\!min-w-0{
    min-width: 0px !important;
  }
  .print\\:min-w-0{
    min-width: 0px;
  }
  .print\\:max-w-full{
    max-width: 100%;
  }
  .print\\:table-auto{
    table-layout: auto;
  }
  .print\\:break-inside-auto{
    break-inside: auto;
  }
  .print\\:break-after-page{
    break-after: page;
  }
  .print\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .print\\:gap-0{
    gap: 0px;
  }
  .print\\:gap-x-6{
    column-gap: 1.5rem;
  }
  .print\\:overflow-visible{
    overflow: visible;
  }
  .print\\:\\!bg-\\[\\#fff\\]{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  }
  .print\\:\\!bg-white{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  }
  .print\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .print\\:\\!p-0{
    padding: 0px !important;
  }
  .print\\:p-4{
    padding: 1rem;
  }
  .print\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .print\\:\\!pt-10{
    padding-top: 2.5rem !important;
  }
  .print\\:pr-5{
    padding-right: 1.25rem;
  }
  .print\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .print\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .print\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .print\\:\\!text-white{
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
  }
  .print\\:\\!\\[transform\\:none\\]{
    transform: none !important;
  }
  .print\\:last\\:break-after-auto:last-child{
    break-after: auto;
  }
}

.group\\/action:hover .group-hover\\/action\\:\\[\\&\\.Icon\\.change-fill-color_svg_path\\]\\:\\!fill-white.Icon.change-fill-color svg path{
  fill: #FFFFFF !important;
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button{
  appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button{
  appearance: none;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb{
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-neutral-300::-webkit-scrollbar-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(213 215 218 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track{
  background-color: transparent;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-1\\.5::-webkit-scrollbar{
  height: 0.375rem;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-1\\.5::-webkit-scrollbar{
  width: 0.375rem;
}

.\\[\\&\\:hover\\:not\\(\\:has\\(\\[data-headlessui-state\\=open\\]\\)\\)\\]\\:bg-neutral-50:hover:not(:has([data-headlessui-state=open])){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1));
}

.\\[\\&\\:hover_span\\]\\:\\!text-primary-600:hover span{
  color: var(--color-primary-600, #0086C9) !important;
}

.\\[\\&\\:hover_svg_path\\]\\:\\!fill-primary-600:hover svg path{
  fill: var(--color-primary-600, #0086C9) !important;
}

.\\[\\&\\>\\*\\+\\*\\]\\:border-0>*+*{
  border-width: 0px;
}

.\\[\\&\\>\\*\\+\\*\\]\\:border-t>*+*{
  border-top-width: 1px;
}

.\\[\\&\\>\\*\\+\\*\\]\\:border-solid>*+*{
  border-style: solid;
}

.\\[\\&\\>\\*\\+\\*\\]\\:border-neutral-200>*+*{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.\\[\\&\\>\\*\\+\\*\\]\\:pt-6>*+*{
  padding-top: 1.5rem;
}

.\\[\\&\\>\\*\\:first-child\\]\\:\\!\\[border-top-width\\:0\\]>*:first-child{
  border-top-width: 0 !important;
}

.\\[\\&\\>\\*\\:not\\(\\:last-child\\)\\]\\:\\[border-bottom\\:1px_solid_theme\\(colors\\.neutral\\.100\\)\\]>*:not(:last-child){
  border-bottom: 1px solid #F5F5F5;
}

.\\[\\&\\>\\*\\]\\:pointer-events-none>*{
  pointer-events: none;
}

.\\[\\&\\>\\*\\]\\:min-w-0>*{
  min-width: 0px;
}

.\\[\\&\\>\\*\\]\\:select-none>*{
  user-select: none;
}

.\\[\\&\\>\\*\\]\\:justify-between>*{
  justify-content: space-between;
}

.\\[\\&\\>\\*\\]\\:truncate>*{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.\\[\\&\\>\\*\\]\\:px-6>*{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.\\[\\&\\>\\*\\]\\:pb-6>*{
  padding-bottom: 1.5rem;
}

@media (max-width: 1023px){
  .sm\\:\\[\\&\\>\\*\\]\\:px-4>*{
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.\\[\\&\\>\\.ag-cell-wrapper\\]\\:w-full>.ag-cell-wrapper{
  width: 100%;
}

.\\[\\&\\>\\.ag-cell-wrapper\\]\\:min-w-0>.ag-cell-wrapper{
  min-width: 0px;
}

.\\[\\&\\>\\.quill-wrapper\\>\\.relative\\]\\:h-full>.quill-wrapper>.relative{
  height: 100%;
}

.\\[\\&\\>\\.quill-wrapper\\]\\:min-h-0>.quill-wrapper{
  min-height: 0px;
}

.\\[\\&\\>\\.quill-wrapper\\]\\:flex-1>.quill-wrapper{
  flex: 1 1 0%;
}

@media (max-width: 1279px){
  .md\\:\\[\\&\\>div\\:first-child\\>button\\]\\:\\!ml-0>div:first-child>button{
    margin-left: 0px !important;
  }
  .md\\:\\[\\&\\>div\\:first-child\\>button\\]\\:\\!w-full>div:first-child>button{
    width: 100% !important;
  }
  .md\\:\\[\\&\\>div\\:first-child\\>button\\]\\:\\!basis-full>div:first-child>button{
    flex-basis: 100% !important;
  }
}

.\\[\\&\\>div\\:first-child\\]\\:justify-between>div:first-child{
  justify-content: space-between;
}

@media (max-width: 1279px){
  .md\\:\\[\\&\\>div\\:first-child\\]\\:\\!flex-wrap>div:first-child{
    flex-wrap: wrap !important;
  }
  .md\\:\\[\\&\\>div\\:first-child\\]\\:\\!items-center>div:first-child{
    align-items: center !important;
  }
  .md\\:\\[\\&\\>div\\:first-child\\]\\:\\!justify-start>div:first-child{
    justify-content: flex-start !important;
  }
}

.\\[\\&\\>div\\]\\:absolute>div{
  position: absolute;
}

.\\[\\&\\>div\\]\\:inset-0>div{
  inset: 0px;
}

.\\[\\&\\>div\\]\\:h-full>div{
  height: 100%;
}

.\\[\\&\\>div\\]\\:w-full>div{
  width: 100%;
}

.\\[\\&\\>div\\]\\:justify-center>div{
  justify-content: center;
}

.\\[\\&\\>div\\]\\:\\!bg-neutral-800>div{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 43 55 / var(--tw-bg-opacity, 1)) !important;
}

.\\[\\&\\>li\\]\\:mb-2>li{
  margin-bottom: 0.5rem;
}

.\\[\\&\\>li\\]\\:list-disc>li{
  list-style-type: disc;
}

.\\[\\&\\>span\\]\\:\\!text-base>span{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}

.\\[\\&\\>span\\]\\:normal-case>span{
  text-transform: none;
}

.\\[\\&\\>td\\]\\:p-3>td{
  padding: 0.75rem;
}

.\\[\\&\\>th\\]\\:px-3>th{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.\\[\\&\\>th\\]\\:py-2>th{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.\\[\\&\\>th\\]\\:text-left>th{
  text-align: left;
}

.\\[\\&\\>th\\]\\:text-sm>th{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.\\[\\&\\>th\\]\\:font-500>th{
  font-weight: 500;
}

.\\[\\&\\>th\\]\\:text-neutral-800>th{
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}

.\\[\\&\\>tr\\]\\:border-t>tr{
  border-top-width: 1px;
}

.\\[\\&\\>tr\\]\\:border-neutral-200>tr{
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}

.\\[\\&\\[data-dragging\\=false\\]\\:has\\(textarea\\:focus\\)\\]\\:\\!border-primary-300[data-dragging=false]:has(textarea:focus){
  border-color: var(--color-primary-300, #7CD4FD) !important;
}

.\\[\\&\\[data-dragging\\=false\\]\\:has\\(textarea\\:focus\\)\\]\\:\\!shadow-\\[0_0_0_2px_\\#CBF0FD\\][data-dragging=false]:has(textarea:focus){
  --tw-shadow: 0 0 0 2px #CBF0FD !important;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.\\[\\&_\\*\\]\\:\\!text-neutral-600 *{
  --tw-text-opacity: 1 !important;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&_\\.absolute\\.bg-white\\]\\:shadow-md .absolute.bg-white{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.\\[\\&_\\.absolute\\.bg-white\\]\\:outline-1 .absolute.bg-white{
  outline-width: 1px;
}

.\\[\\&_\\.absolute\\.bg-white\\]\\:-outline-offset-1 .absolute.bg-white{
  outline-offset: -1px;
}

.\\[\\&_\\.absolute\\.bg-white\\]\\:outline-neutral-200 .absolute.bg-white{
  outline-color: #E9EAEB;
}

.\\[\\&_\\.absolute\\.bg-white\\]\\:\\[outline-style\\:solid\\] .absolute.bg-white{
  outline-style: solid;
}

.\\[\\&_\\.ag-body-viewport\\]\\:\\!overflow-y-auto .ag-body-viewport{
  overflow-y: auto !important;
}

.\\[\\&_\\.ag-cell-focus\\]\\:\\!border-transparent .ag-cell-focus{
  border-color: transparent !important;
}

.\\[\\&_\\.ag-cell-focus\\]\\:\\!outline-transparent .ag-cell-focus{
  outline-color: transparent !important;
}

.\\[\\&_\\.ag-cell-value\\]\\:min-w-0 .ag-cell-value{
  min-width: 0px;
}

.\\[\\&_\\.ag-cell-value\\]\\:flex-1 .ag-cell-value{
  flex: 1 1 0%;
}

.\\[\\&_\\.ag-center-cols-container\\]\\:\\!min-h-0 .ag-center-cols-container{
  min-height: 0px !important;
}

.\\[\\&_\\.ag-center-cols-viewport\\]\\:\\!min-h-0 .ag-center-cols-viewport{
  min-height: 0px !important;
}

.\\[\\&_\\.ag-details-row\\]\\:\\!bg-transparent .ag-details-row{
  background-color: transparent !important;
}

.\\[\\&_\\.ag-details-row\\]\\:\\!p-0 .ag-details-row{
  padding: 0px !important;
}

.\\[\\&_\\.ag-header-cell-comp-wrapper\\>div\\]\\:justify-end .ag-header-cell-comp-wrapper>div{
  justify-content: flex-end;
}

.\\[\\&_\\.ag-overlay-no-rows-wrapper\\]\\:\\!py-8 .ag-overlay-no-rows-wrapper{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:\\!h-full .ag-root-wrapper{
  height: 100% !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:\\!rounded-lg .ag-root-wrapper{
  border-radius: 0.5rem !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:\\!rounded-none .ag-root-wrapper{
  border-radius: 0px !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:\\!rounded-t-none .ag-root-wrapper{
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:\\!border-0 .ag-root-wrapper{
  border-width: 0px !important;
}

.\\[\\&_\\.ag-root-wrapper\\]\\:border-0 .ag-root-wrapper{
  border-width: 0px;
}

.\\[\\&_\\.ag-row-group\\]\\:\\!bg-white .ag-row-group{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.\\[\\&_\\.ag-row-last\\]\\:\\!border-b-0 .ag-row-last{
  border-bottom-width: 0px !important;
}

.\\[\\&_\\.ag-row\\.ag-row-group-expanded\\]\\:\\!bg-\\[\\#F0F9FF\\] .ag-row.ag-row-group-expanded{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1)) !important;
}

.\\[\\&_\\.ag-row\\]\\:bg-white .ag-row{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.\\[\\&_\\.bg-neutral-100\\]\\:\\!rounded-none .bg-neutral-100{
  border-radius: 0px !important;
}

.\\[\\&_\\.bg-neutral-100\\]\\:\\!bg-transparent .bg-neutral-100{
  background-color: transparent !important;
}

.\\[\\&_\\.border-l\\:hover\\]\\:\\!bg-neutral-50 .border-l:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 250 / var(--tw-bg-opacity, 1)) !important;
}

.\\[\\&_\\.border-l\\]\\:\\!min-w-0 .border-l{
  min-width: 0px !important;
}

.\\[\\&_\\.border-l\\]\\:\\!bg-white .border-l{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.\\[\\&_\\.border-l\\]\\:\\!px-2 .border-l{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.\\[\\&_\\.border-l\\]\\:\\!py-0 .border-l{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.\\[\\&_\\.card-submit\\]\\:\\!h-10 .card-submit{
  height: 2.5rem !important;
}

.\\[\\&_\\.card-submit\\]\\:\\!w-full .card-submit{
  width: 100% !important;
}

.\\[\\&_\\.react-form-builder-form\\]\\:invisible .react-form-builder-form{
  visibility: hidden;
}

.\\[\\&_\\.react-form-builder-form\\]\\:h-0 .react-form-builder-form{
  height: 0px;
}

.\\[\\&_\\.react-form-builder-form\\]\\:overflow-hidden .react-form-builder-form{
  overflow: hidden;
}

.\\[\\&_\\.react-grid-item\\.cssTransforms\\]\\:\\[transition-property\\:transform\\] .react-grid-item.cssTransforms{
  transition-property: transform;
}

.\\[\\&_\\.right-0\\]\\:\\!-right-5 .right-0{
  right: -1.25rem !important;
}

.\\[\\&_\\.rounded-full\\>span\\]\\:whitespace-nowrap .rounded-full>span{
  white-space: nowrap;
}

.\\[\\&_b\\]\\:font-700 b{
  font-weight: 700;
}

.\\[\\&_canvas\\]\\:\\!h-auto canvas{
  height: auto !important;
}

.\\[\\&_canvas\\]\\:\\!w-full canvas{
  width: 100% !important;
}

.\\[\\&_h1\\]\\:mb-2 h1{
  margin-bottom: 0.5rem;
}

.\\[\\&_h1\\]\\:mt-3 h1{
  margin-top: 0.75rem;
}

.\\[\\&_h1\\]\\:text-xl h1{
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.\\[\\&_h1\\]\\:font-600 h1{
  font-weight: 600;
}

.\\[\\&_h2\\]\\:mb-2 h2{
  margin-bottom: 0.5rem;
}

.\\[\\&_h2\\]\\:mt-3 h2{
  margin-top: 0.75rem;
}

.\\[\\&_h2\\]\\:text-lg h2{
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.\\[\\&_h2\\]\\:font-600 h2{
  font-weight: 600;
}

.\\[\\&_h3\\]\\:mb-1 h3{
  margin-bottom: 0.25rem;
}

.\\[\\&_h3\\]\\:mt-2 h3{
  margin-top: 0.5rem;
}

.\\[\\&_h3\\]\\:text-base h3{
  font-size: 1rem;
  line-height: 1.5rem;
}

.\\[\\&_h3\\]\\:font-600 h3{
  font-weight: 600;
}

.\\[\\&_iframe\\]\\:\\!h-10 iframe{
  height: 2.5rem !important;
}

.\\[\\&_iframe\\]\\:h-full iframe{
  height: 100%;
}

.\\[\\&_iframe\\]\\:\\!w-full iframe{
  width: 100% !important;
}

.\\[\\&_li\\]\\:mb-1 li{
  margin-bottom: 0.25rem;
}

.\\[\\&_li\\]\\:flex li{
  display: flex;
}

.\\[\\&_li\\]\\:items-center li{
  align-items: center;
}

.\\[\\&_li\\]\\:gap-2 li{
  gap: 0.5rem;
}

.\\[\\&_li\\]\\:text-sm li{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.\\[\\&_li\\]\\:text-neutral-600 li{
  --tw-text-opacity: 1;
  color: rgb(83 88 98 / var(--tw-text-opacity, 1));
}

.\\[\\&_li\\]\\:before\\:h-\\[6px\\] li::before{
  content: var(--tw-content);
  height: 6px;
}

.\\[\\&_li\\]\\:before\\:w-\\[6px\\] li::before{
  content: var(--tw-content);
  width: 6px;
}

.\\[\\&_li\\]\\:before\\:shrink-0 li::before{
  content: var(--tw-content);
  flex-shrink: 0;
}

.\\[\\&_li\\]\\:before\\:rounded-full li::before{
  content: var(--tw-content);
  border-radius: 9999px;
}

.\\[\\&_li\\]\\:before\\:bg-primary-400 li::before{
  content: var(--tw-content);
  background-color: var(--color-primary-400, #36BFFA);
}

.\\[\\&_li\\]\\:before\\:content-\\[\\'\\'\\] li::before{
  --tw-content: '';
  content: var(--tw-content);
}

.\\[\\&_ol\\]\\:mb-2 ol{
  margin-bottom: 0.5rem;
}

.\\[\\&_ol\\]\\:list-decimal ol{
  list-style-type: decimal;
}

.\\[\\&_ol\\]\\:pl-4 ol{
  padding-left: 1rem;
}

.\\[\\&_ol\\]\\:pl-5 ol{
  padding-left: 1.25rem;
}

.\\[\\&_p\\]\\:m-0 p{
  margin: 0px;
}

.\\[\\&_p\\]\\:mb-2 p{
  margin-bottom: 0.5rem;
}

.\\[\\&_p\\]\\:mb-3 p{
  margin-bottom: 0.75rem;
}

.\\[\\&_p\\]\\:inline p{
  display: inline;
}

.\\[\\&_p\\]\\:text-\\[14px\\] p{
  font-size: 14px;
}

.\\[\\&_p\\]\\:text-sm p{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.\\[\\&_p\\]\\:\\!font-normal p{
  font-weight: 400 !important;
}

.\\[\\&_p\\]\\:font-500 p{
  font-weight: 500;
}

.\\[\\&_p\\]\\:font-medium p{
  font-weight: 500;
}

.\\[\\&_p\\]\\:text-neutral-700 p{
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}

.\\[\\&_p\\]\\:text-neutral-800 p{
  --tw-text-opacity: 1;
  color: rgb(37 43 55 / var(--tw-text-opacity, 1));
}

.\\[\\&_span\\]\\:normal-case span{
  text-transform: none;
}

.\\[\\&_span\\]\\:\\!text-neutral-400 span{
  --tw-text-opacity: 1 !important;
  color: rgb(164 167 174 / var(--tw-text-opacity, 1)) !important;
}

.\\[\\&_strong\\]\\:font-700 strong{
  font-weight: 700;
}

.\\[\\&_svg\\]\\:\\!size-\\[14px\\] svg{
  width: 14px !important;
  height: 14px !important;
}

.\\[\\&_svg\\]\\:size-7 svg{
  width: 1.75rem;
  height: 1.75rem;
}

.\\[\\&_svg_path\\]\\:\\!fill-neutral-700 svg path{
  fill: #414651 !important;
}

.\\[\\&_svg_path\\]\\:\\!fill-neutral-800 svg path{
  fill: #252B37 !important;
}

.\\[\\&_svg_path\\]\\:\\!fill-primary-600 svg path{
  fill: var(--color-primary-600, #0086C9) !important;
}

.\\[\\&_ul\\]\\:mb-2 ul{
  margin-bottom: 0.5rem;
}

.\\[\\&_ul\\]\\:mt-1 ul{
  margin-top: 0.25rem;
}

.\\[\\&_ul\\]\\:list-disc ul{
  list-style-type: disc;
}

.\\[\\&_ul\\]\\:space-y-2 ul > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.\\[\\&_ul\\]\\:pl-4 ul{
  padding-left: 1rem;
}

.\\[\\&_ul\\]\\:pl-5 ul{
  padding-left: 1.25rem;
}

.ag-row-focus .\\[\\.ag-row-focus_\\&\\]\\:opacity-100{
  opacity: 1;
}

.ag-row-hover .\\[\\.ag-row-hover_\\&\\]\\:opacity-100{
  opacity: 1;
}

@container (min-width:144px){
  .\\[\\@container_\\(min-width\\:144px\\)\\]\\:inline-flex{
    display: inline-flex;
  }
}

@container (min-width:200px){
  .\\[\\@container_\\(min-width\\:200px\\)\\]\\:block{
    display: block;
  }
}

@container (min-width:30rem){
  .\\[\\@container_\\(min-width\\:30rem\\)\\]\\:flex{
    display: flex;
  }
}

@container (min-width:320px){
  .\\[\\@container_\\(min-width\\:320px\\)\\]\\:inline{
    display: inline;
  }
}

@container (min-width:44rem){
  .\\[\\@container_\\(min-width\\:44rem\\)\\]\\:pl-\\[92px\\]{
    padding-left: 92px;
  }
}

@container (min-width:56rem){
  .\\[\\@container_\\(min-width\\:56rem\\)\\]\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.35fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1.35fr);
  }
  .\\[\\@container_\\(min-width\\:56rem\\)\\]\\:gap-6{
    gap: 1.5rem;
  }
}

@media(hover:hover){
  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:border-primary-300:hover{
    border-color: var(--color-primary-300, #7CD4FD);
  }
  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:shadow-card-selected:hover{
    --tw-shadow: 0px 0px 0px 2px rgba(203, 240, 253, 1);
    --tw-shadow-colored: 0px 0px 0px 2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:ring-2:hover{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }
  .\\[\\@media\\(hover\\:hover\\)\\]\\:hover\\:ring-primary-200:hover{
    --tw-ring-color: var(--color-primary-200, #B9E6FE);
  }
}

@media(hover:none){
  .\\[\\@media\\(hover\\:none\\)\\]\\:hidden{
    display: none;
  }
  .\\[\\@media\\(hover\\:none\\)\\]\\:opacity-100{
    opacity: 1;
  }
}

@media(hover:none) and (pointer:coarse){
  .\\[\\@media\\(hover\\:none\\)_and_\\(pointer\\:coarse\\)\\]\\:hidden{
    display: none;
  }
}

@media(max-height:620px){
  .\\[\\@media\\(max-height\\:620px\\)\\]\\:\\!left-1\\/2{
    left: 50% !important;
  }
  .\\[\\@media\\(max-height\\:620px\\)\\]\\:\\!top-1\\/2{
    top: 50% !important;
  }
  .\\[\\@media\\(max-height\\:620px\\)\\]\\:-translate-x-1\\/2{
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .\\[\\@media\\(max-height\\:620px\\)\\]\\:-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media(max-height:700px){
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:\\!left-1\\/2{
    left: 50% !important;
  }
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:\\!top-1\\/2{
    top: 50% !important;
  }
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:-translate-x-1\\/2{
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:gap-3{
    gap: 0.75rem;
  }
  .\\[\\@media\\(max-height\\:700px\\)\\]\\:p-4{
    padding: 1rem;
  }
}

@media(max-height:900px){
  .\\[\\@media\\(max-height\\:900px\\)\\]\\:pt-6{
    padding-top: 1.5rem;
  }
}

@media(min-width:1200px){
  .\\[\\@media\\(min-width\\:1200px\\)\\]\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width:1024px) and (max-width:1439px){
  .\\[\\@media_\\(min-width\\:1024px\\)_and_\\(max-width\\:1439px\\)\\]\\:max-w-\\[856px\\]{
    max-width: 856px;
  }
}

@media (min-width:1280px) and (max-width:1919px){
  .\\[\\@media_\\(min-width\\:1280px\\)_and_\\(max-width\\:1919px\\)\\]\\:max-w-\\[1360px\\]{
    max-width: 1360px;
  }
}

@media (min-width:1440px) and (max-width:1919px){
  .\\[\\@media_\\(min-width\\:1440px\\)_and_\\(max-width\\:1919px\\)\\]\\:max-w-\\[1056px\\]{
    max-width: 1056px;
  }
}

@media (min-width:1920px){
  .\\[\\@media_\\(min-width\\:1920px\\)\\]\\:max-w-\\[1200px\\]{
    max-width: 1200px;
  }
  .\\[\\@media_\\(min-width\\:1920px\\)\\]\\:max-w-\\[1440px\\]{
    max-width: 1440px;
  }
}

@media (min-width:600px) and (max-width:1023px){
  .\\[\\@media_\\(min-width\\:600px\\)_and_\\(max-width\\:1023px\\)\\]\\:max-w-\\[768px\\]{
    max-width: 768px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_reset.scss","webpack://./src/styles/_lib.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_kiosk-touch.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACIhB;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ADEF;;ACGE;EACE,iBAAA;ADAJ;ACGI;EACE,qBAAA;ADDN;ACMM;EACE,2BAAA;ADJR;ACQM;EACE,aAAA;ADNR;ACOQ;EACE,MAAA;EACA,6BAAA;ADLV;ACWQ;EACE,UAAA;EACA,iBAAA;ADTV;ACcM;EACE,OAAA;ADZR;ACaQ;EACE,UAAA;ADXV;ACgBM;EACE,UAAA;ADdR;ACeQ;EACE,YAAA;EACA,OAAA;EACA,6BAAA;ADbV;ACoBQ;EACE,QAAA;EACA,2BAAA;ADlBV;;ACyBA;EACE,yBAAA;EACA,sDAAA;ECaA,mBAViB;EDDjB,kBAAA;ADtBF;ACwBE;EACE,2BAAA;ADtBJ;;AC2BE;EACE,cAAA;ADxBJ;ACyBI;EACE,qBAAA;ADvBN;;AC6BE;EACE,YAAA;EACA,yBE0LG;EFzLH,kBAAA;AD1BJ;AC6BE;EACE,oCAAA;AD3BJ;AC8BE;EACE,uCAAA;AD5BJ;AC+BE;EACE,qCAAA;AD7BJ;ACgCE;EACE,sCAAA;AD9BJ;ACgCE;EACE,uBAAA;AD9BJ;;ACkCE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AD/BJ;ACkCE;EACE,oCAAA;ADhCJ;ACmCE;EACE,uCAAA;ADjCJ;ACoCE;EACE,qCAAA;ADlCJ;ACqCE;EACE,sCAAA;ADnCJ;ACqCE;EACE,uBAAA;ADnCJ;;ACuCA;EACE,2BAAA;EACA,yBAAA;ADpCF;ACsCE;EACE,cAAA;EACA,2BAAA;ADpCJ;ACuCE;EACE,oCAAA;EACA,sBAAA;EACA,wBAAA;ADrCJ;ACwCE;EACE,uCAAA;EACA,sBAAA;EACA,wBAAA;ADtCJ;ACyCE;EACE,qCAAA;EACA,sBAAA;EACA,wBAAA;ADvCJ;AC0CE;EACE,sCAAA;EACA,sBAAA;EACA,wBAAA;ADxCJ;AC2CE;EACE,uBAAA;ADzCJ;;AC6CA;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AD1CF;AC2CE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;ADzCJ;AC2CM;EACE,cAAA;ADzCR;AC6CM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mDE+EE;EF9EF,UAAA;AD3CR;AC8CQ;EACE,wCE0EA;AHtHV;AC+CM;EACE,wCEsEE;AHnHV;ACiDM;EACE,cAAA;AD/CR;ACkDI;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;ADhDN;;ACqDA;;;;;;;;;;;;EAYE,SAAA;EACA,UAAA;ADlDF;;ACqDA;EACE,qBAAA;EACA,wCEoCQ;AHtFV;ACmDE;EACE,wCEkCM;AHnFV;;ACqDA;EACE,wBAAA;ADlDF;;ACsDA;;;;EAIE,qDAAA;ADnDF;;ACsDA;EACE,4BAAA;EACA,oCAAA;ADnDF;;ACqDA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;ADlDF;ACmDE;EACE,cEQI;EFPJ,gBAAA;EACA,kBAAA;EACA,oBAAA;ADjDJ;;ACoDA;EACE,gBAAA;EACA,SAAA;ADjDF;ACkDE;EACE,UAAA;EACA,SAAA;ECtMF,eAViB;AFiKnB;ACiDI;EACE,yBECI;AHhDV;ACiDI;EACE,yBAAA;AD/CN;ACiDI;EACE,6BAAA;EACA,6BAAA;EACA,cAAA;AD/CN;ACgDM;EACE,yBAAA;AD9CR;;ACuDE;EACE,2BAAA;ADpDJ;ACkDA;EAKE,yBAAA;ADpDF;ACsDE;EACE,wBAAA;ADpDJ;ACuDE;EACE,wBAAA;ADrDJ;;ACyDA;EAKE,gBAAA;EACA,cAAA;AD1DF;AC4DE;EARF;IASI,eAAA;EDzDF;AACF;AC2DE;EACE,WAAA;EACA,eAAA;EACA,SAAA;ADzDJ;AC4DE;EACE;IACE,iBAAA;IACA,kBAAA;ED1DJ;AACF;AC6DE;EACE,wBAAA;EACA,QAAA;AD3DJ;AC8DE;EACE,wBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AD5DJ;AC+DE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AD7DJ;ACgEE;EAEE,iBAAA;EACA,gBAAA;AD/DJ;ACwEE;EACE,eAAA;ADtEJ;ACyEE;EACE,kBAAA;ADvEJ;AC0EE;EACE,eAAA;EACA,cAAA;EACA,6BAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;ADxEJ;AC2EE;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;EAEA,4BAAA;EACA,wBAAA,EAAA,qBAAA;EACA,2BAAA,EAAA,qBAAA;AD1EJ;AC6EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AD3EJ;AC8EE;EACE,gBAAA;AD5EJ;AC+EE;EACE,eAAA;AD7EJ;ACgFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AD9EJ;ACiFE;EACE,sBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AD/EJ;;ACyFE;EACE,mBAAA;ADtFJ;ACwFE;EACE,kBAAA;ADtFJ;ACwFE;EACE,0BAAA;EACA,oBAAA;ADtFJ;ACwFE;;EAEE,YAAA;ADtFJ;ACwFE;EACE,aAAA;ADtFJ;;AC0FA;EACE,uBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ADvFF;AC0FA;;EAEE,uBAAA;EACA,mBAAA;ADxFF;;AC6FE;EACE,6BAAA;AD1FJ;;AC8FA;EACE,UAAA;AD3FF;;AC+FA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AD5FF;;AC+FA;;;;EAIE,kCAAA;AD5FF;;AC+FA;;;;EAIE,aAAA;AD5FF;;AC+FA;EACE,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AD5FF;;ACgGE;EACE,2BAAA;AD7FJ;;AIxbA;;;;EAIE,0BAAA;AJ2bF;;AIlbE;;;;EAEE,0BAAA;AJubJ;AInbE;;;;EAEE,kBAAA;AJubJ;AInbE;;;;;;;;EAIE,0BAAA;AJybJ;AItbE;;;;EAEE,0BAAA;AJ0bJ;AIvbE;;EACE,uBAAA;EACA,2BAAA;AJ0bJ;AItbI;;;;;;;;EAIE,uBAAA;EACA,2BAAA;EACA,0BAAA;AJ4bN;AI1bM;;;;;;;;EACE,WAAA;EACA,gBAAA;AJmcR;AIhcM;;;;;;;;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AJycR;AItcM;;;;;;;;EACE,eAAA;EACA,gBAAA;AJ+cR;AI1cE;;EACE,eAAA;AJ6cJ;AI3cI;;EACE,2BAAA;EACA,0BAAA;AJ8cN;AI3cI;;;;EAEE,uBAAA;AJ+cN;AI5cI;;EACE,uBAAA;EACA,2BAAA;AJ+cN;AI5cI;;;;EAEE,0BAAA;EACA,6BAAA;AJgdN;AI7cI;;EACE,uBAAA;AJgdN;AI7cI;;EACE,2BAAA;EACA,wBAAA;AJgdN;AI7cI;;EACE,uBAAA;AJgdN;AI7cI;;;;EAEE,8BAAA;AJidN;AI9cI;;EACE,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,0BAAA;EACA,4BAAA;AJidN;AI9cI;;;;EAEE,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AJkdN;AI/cI;;EACE,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oCAAA;AJkdN;AI/cI;;EACE,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;AJkdN;AI/cI;;;;EAEE,gDAAA;AJmdN;AIhdI;;EACE,2BAAA;AJmdN;AIhdI;;EACE,kBAAA;AJmdN;AIhdI;;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AJmdN;AIjdM;;EACE,gBAAA;AJodR;AI9cI;;EACE,uBAAA;EACA,0BAAA;AJidN;AI5cI;;EACE,0BAAA;EACA,4BAAA;AJ+cN;AI3cE;;;;EAEE,uBAAA;EACA,6BAAA;EACA,8BAAA;AJ+cJ;AI5cE;;;;;;EAGE,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;AJidJ;AI9cE;;EACE,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;EACA,2BAAA;EACA,qBAAA;EACA,0BAAA;AJidJ;AI9cE;;EACE,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;AJidJ;;AAhrBA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,6BAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;AAaA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,aAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,aAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,YAAA;EAAA;AAAA;AAAA;EAAA,aAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,cAAA;EAAA;AAAA;AAAA;EAAA,YAAA;EAAA;AAAA;AAAA;EAAA,YAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA,UAAA;EAAA;AAAA;AAAA;EAAA,UAAA;EAAA;AAAA;AAAA;EAAA,UAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,2BAAA;IAAA;EAAA;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,2BAAA;IAAA;EAAA;EAAA;IAAA,eAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,YAAA;IAAA;EAAA;EAAA;IAAA,aAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA,QAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,aAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8DAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,iEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,wEAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,qFAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sFAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,qFAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,gEAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wDAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,wDAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,uEAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wEAAA;EAAA,6FAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,iGAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,kGAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,gGAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,wEAAA;EAAA,sGAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kGAAA;EAAA;AAAA;AAAA;EAAA,2DAAA;EAAA;AAAA;AAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,0RAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA,+QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,6CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAUA;EACE,sBAAA;EACA,gCGjBU;AH2rBZ;;AAvqBA;;EAEE,gBAAA;AA0qBF;;AAvqBA;;EAEE,gBAAA;EACA,UAAA;EAGA,8BAAA;EACA,sBAAA;EEyCA,eAViB;EF7BjB,oBAAA;EAAA,gDAAA;AAwqBF;AErsBE;EFoBF;;IEgDE,mBAViB;EFgpBjB;AACF;;AAxqBA;EACE,gCGzCU;EH0CV,sBAAA;AA2qBF;;AAxqBA;EACE,gBAAA;AA2qBF;;AArqBI;;;;EAEE,aAAA;EACA,mBAAA;AA0qBN;AAvqBI;;EACE,gBAAA;AA0qBN;AAvqBI;;EACE,kBAAA;AA0qBN;AAvqBI;;EACE,kBAAA;AA0qBN;AAvqBI;;EACE,mBAAA;AA0qBN;AAvqBI;;EACE,uBAAA;AA0qBN;AAvqBI;;EACE,uBAAA;AA0qBN;;AE5nBE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AF+nBJ;AE5nBE;EACE,mBAVc;EAWd,mBAAA;EACA,6BAAA;EACA,4BAAA;AF8nBJ;AE3nBE;EACE,iBAAA;AF6nBJ;;AA/qBE;EACE,UAAA;EACA,mBAAA;AAkrBJ;AEhpBE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AFkpBJ;AE/oBE;EACE,mBAVc;EAWd,mBAAA;EACA,6BAAA;EACA,4BAAA;AFipBJ;AE9oBE;EACE,iBAAA;AFgpBJ;;AAxrBA;EAEE,wBAAA;EACA,wCAAA;AA0rBF;AAxrBE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AA0rBJ;AAvrBE;EACE,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;AAyrBJ;AAtrBE;EAEE,oCAAA;AAurBJ;AArrBI;EACE,mBAAA;AAurBN;AAprBI;EACE,iBAAA;AAsrBN;;AAjrBA;EACE,mBAAA;AAorBF;;AAjrBA;EACE,8uIAAA;AAorBF;;AAxUA;EACE,gCAAA;AA2UF;;AAxUA;EE/aE,mBAViB;AFqwBnB;AA1UE;EACE,0BAAA;AA4UJ;;AEl0BE;EF4fE;IExbF,mBAViB;EF6wBjB;AACF;;AAtUE;EACE,qBAAA;EACA,oBAAA;AAyUJ;AApUI;;;;EAEE,4BAAA;AAwUN;;AAjUI;EACE,sBAAA;AAoUN;;AA/TA;EACE,kBAAA;AAkUF;AAjUE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AAmUJ;;AA/TA;EACE;IACE,uBAAA;EAkUF;EAhUA;IACE,yBAAA;EAkUF;AACF;AA/TA;;EAEE,6BAAA;EACA,wBAAA;EACA,yBAAA;AAiUF;;AA9TA;EEpfE,iBAViB;EFggBjB,iBAAA;EACA,gBAAA;AAiUF;;AA/TA;EEzfE,kBAViB;EFqgBjB,iBAAA;EACA,gBAAA;AAkUF;;AAhUA;EE9fE,eAViB;EF0gBjB,iBAAA;EACA,gBAAA;AAmUF;;AAjUA;EEngBE,kBAViB;EF+gBjB,iBAAA;EACA,gBAAA;AAoUF;;AAlUA;EExgBE,iBAViB;EFohBjB,iBAAA;EACA,gBAAA;AAqUF;;AAnUA;EE7gBE,kBAViB;EFyhBjB,iBAAA;EACA,gBAAA;AAsUF;;AA3TA;EACE,WAAA;EACA,gBAAA;EACA,iDAAA;EACA,cAAA;EACA,iBAAA;AA8TF;AA5TE;EACE,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,UAAA;AA8TJ;AA7TI;EACE,YAAA;EACA,kBAAA;EACA,iDAAA;AA+TN;AA7TM;EACE,cAAA;EACA,2BAAA;EE9iBN,mBAViB;EF0jBX,oBAAA;EACA,sBAAA;EACA,cAAA;AA+TR;AAzTI;EACE,YAAA;AA2TN;AA1TM;EACE,yBAAA;AA4TR;AA1TM;EACE,sBAAA;AA4TR;AAzTM;EACE,cAAA;EACA,oBAAA;EEnkBN,mBAViB;EF+kBX,oBAAA;EACA,sBAAA;AA2TR;AAxTM;EACE,cAAA;EE1kBN,mBAViB;EFslBX,oBAAA;EACA,cAAA;AA0TR;AApTI;EACE,oCAAA;AAsTN;AApTM;EACE,gBAAA;EACA,gBAAA;AAsTR;AAnTM;EACE,gBAAA;AAqTR;AAhTM;EACE,oCAAA;AAkTR;AA7SM;EACE,oCAAA;AA+SR;AA1SE;EACE,sBAAA;AA4SJ;AA3SI;EACE,kBAAA;AA6SN;AA3SQ;EACE,yBAAA;EACA,qBAAA;AA6SV;AA1SM;EACE,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;AA4SR;AA3SQ;EACE,wBAAA;AA6SV;AA3SQ;EACE,yBAAA;AA6SV;AAvSE;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AAySJ;AAxSI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA0SN;AAzSM;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA2SR;AAxSI;EACE,cAAA;EACA,mBAAA;EACA,WAAA;AA0SN;AAvSE;EACE,kBAAA;EACA,OAAA;EEpqBF,mBAViB;EFgrBf,cAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAySJ;;AArSA;EACE,8BAAA;AAwSF;;AAtSA;EACE,4CAAA;AAySF;;AAvSA;EACE,+BAAA;AA0SF;;AAxSA;EACE,gCAAA;AA2SF;;AAxSA;EACE,sCAAA;AA2SF;;AAvSA;EACE,yBAAA;EACA,iCAAA;AA0SF;;AAvSA;EACE,yBAAA;EACA,cAAA;AA0SF;;AAvSA;EACE,mBAAA;AA0SF;;AAvSA;EACE,yBAAA;AA0SF;;AAvSA;EACE,yBAAA;EACA,iDAAA;AA0SF;;AArSE;;EACE,eAAA;AAySJ;;AArSA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAwSF;;AArSA;EACE,yBAAA;EACA,mBAAA;AAwSF;;AArSA;EACE;IACE,YAAA;EAwSF;EAtSA;IACE,aAAA;EAwSF;EAtSA;IACE,cAAA;EAwSF;EAtSA;IACE,YAAA;EAwSF;AACF;AArSA;EACE,YAAA;EACA,wCAAA;AAuSF;;AApSA,iBAAA;AACA;EACE;IAGE,UAAA;EAqSF;EAnSA;IAEE,UAAA;EAoSF;AACF;AAjSA;EACE,mCAAA;AAmSF;;AAhSA;EAEE,kBAAA;EACA,uBAAA;AAkSF;AAhSE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WARM;EASN,wBAAA;EACA,uBAAA;EACA,2KAAA;EAOA,qCAAA;AA4RJ;;AAxRA;EACE;IACE,WAAA;IACA,UAAA;EA2RF;EAzRA;IACE,SAAA;IACA,YAAA;EA2RF;EAzRA;IACE,uBAAA;IACA,UAAA;EA2RF;AACF;AAxRA;EACE;IACE,2BAAA;EA0RF;EAxRA;IACE,4BAAA;EA0RF;AACF;AAvRA;EACE;;;IAGE,wCAAA;IACA,cGloBI;EH25BN;EAvRA;;;;;;;;;;;IAWE,yBAAA;EAyRF;EAvRA;;IAEE,gCAAA;EAyRF;EAvRA;IACE,qBAAA;EAyRF;EAxRE;IACE,aGxpBE;EHk7BN;EAvRA;IACE,mBAAA;EAyRF;EAvRA;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,SAAA;EAyRF;EAxRE;IACE,mBAAA;IACA,sBAAA;EA0RJ;EAxRE;IACE,aAAA;IACA,gBAAA;IACA,UAAA;EA0RJ;EAxRE;IACE,aAAA;IACA,gBAAA;IACA,UAAA;EA0RJ;AACF;AAtRA;EACE,yBAAA;EACA,8BAAA;EACA,qDAAA;EACA,gDAAA;EACA,yCAAA;EACA,iDAAA;EACA,yIACE;EAGF,2CAAA;EACA,0BAAA;EACA,yBAAA;EACA,kCAAA;EACA,gBAAA;AAqRF;;AAlRA;EACE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;AAqRF;;AAlRA;EACE,cAAA;EACA,gBAAA;EACA,gCAAA;AAqRF;;AAnwCA;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,eAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,gCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,gCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,gCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+CAmwCC;EAnwCD,0DAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,yCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,2BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,yBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iBAmwCC;EAnwCD,iBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,8BAmwCC;EAnwCD,qDAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6CAmwCC;EAnwCD,wDAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6EAmwCC;EAnwCD,iGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0CAmwCC;EAnwCD,uDAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oDAmwCC;EAnwCD,4DAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD,yCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,yCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,8BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sHAmwCC;EAnwCD,oHAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,2GAmwCC;EAnwCD,yGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,2GAmwCC;EAnwCD,yGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,8BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,2GAmwCC;EAnwCD,yGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iBAmwCC;EAnwCD,iBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iCAmwCC;EAnwCD,yCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,iBAmwCC;EAnwCD,iBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,2GAmwCC;EAnwCD,yGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;IAAA;MAAA;IAmwCC;EAAA;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;MAAA,UAmwCC;MAnwCD;IAmwCC;IAnwCD;MAAA,UAmwCC;MAnwCD;IAmwCC;EAAA;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;MAAA,UAmwCC;MAnwCD;IAmwCC;IAnwCD;MAAA,UAmwCC;MAnwCD;IAmwCC;EAAA;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;MAAA,UAmwCC;MAnwCD;IAmwCC;IAnwCD;MAAA,UAmwCC;MAnwCD;IAmwCC;EAAA;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;MAAA,UAmwCC;MAnwCD;IAmwCC;IAnwCD;MAAA,UAmwCC;MAnwCD;IAmwCC;EAAA;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,eAmwCC;IAnwCD,eAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,wBAmwCC;IAnwCD,kEAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,+BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,eAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,SAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,2BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,uBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,wBAmwCC;IAnwCD,0DAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,wBAmwCC;IAnwCD,kEAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,iCAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,4BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,gCAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,4BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,gBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,4BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,0BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,iCAmwCC;IAnwCD,yCAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,yCAmwCC;IAnwCD,uDAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,gFAmwCC;IAnwCD,oGAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,wBAmwCC;IAnwCD,wDAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,wBAmwCC;IAnwCD,wDAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,8BAmwCC;IAnwCD,wDAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,4BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,gCAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,gCAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,+BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,8BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,qBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,iBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,eAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD,8BAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,8BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,oBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,6BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,gBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,eAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,mBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,kBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,+BAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD,uBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;IAAA,kBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,qBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,yCAmwCC;EAnwCD,gEAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,6EAmwCC;EAnwCD,iGAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,4BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sCAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,6BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,2BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,kBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,eAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,0BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,gBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,mBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,oBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,+BAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,sBAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA,cAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA,uBAmwCC;EAnwCD,8DAmwCC;EAnwCD;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;AAmwCC;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA,mDAmwCC;IAnwCD,2DAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,2GAmwCC;IAnwCD,yGAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA,sBAmwCC;IAnwCD;EAmwCC;EAnwCD;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;EAnwCD;IAAA;EAmwCC;AAAA;;AAnwCD;EAAA;IAAA;EAmwCC;AAAA","sourcesContent":["@use 'lib' as lib;\n@use 'reset';\n@use 'variables' as var;\n@use 'kiosk-touch';\n//====================== IMPORTANT NOTE: Do not change import order! =====================//\n\n// Tailwindcss\n@tailwind base;\n@layer base {\n  button {\n    @apply bg-transparent;\n    @apply border-0;\n  }\n  ul {\n    @apply list-disc;\n  }\n  ol {\n    @apply list-decimal;\n  }\n}\n@tailwind components;\n@tailwind utilities;\n\n//Tippy js\n@import 'tippy.js/dist/tippy.css';\n@import 'tippy.js/animations/perspective.css';\n@import 'tippy.js/themes/light.css';\n\n// React Form Builder\n@import 'react-form-builder2/dist/app.css';\n\n* {\n  box-sizing: border-box;\n  font-family: var.$main-font;\n}\n\nhtml.portal,\nhtml.admin {\n  overflow: hidden;\n}\n\nhtml,\nbody {\n  font-weight: 400;\n  padding: 0;\n  // Preflight is disabled, so nothing else resets this; without it iOS Safari\n  // inflates text in landscape, making pages look zoomed in.\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  @include lib.rem(font-size, 16px);\n  @apply text-neutral-800;\n  @include lib.sm {\n    @include lib.rem(font-size, 14px);\n  }\n}\n\np {\n  font-family: var.$main-font;\n  word-break: break-word;\n}\n\nli {\n  list-style: none;\n}\n\n.rfb-item {\n  .static,\n  label > span {\n    ul,\n    ol {\n      margin: 4px 0;\n      padding-left: 1.5em;\n    }\n\n    ul > li {\n      list-style: disc;\n    }\n\n    ul ul > li {\n      list-style: circle;\n    }\n\n    ul ul ul > li {\n      list-style: square;\n    }\n\n    ol > li {\n      list-style: decimal;\n    }\n\n    ol ol > li {\n      list-style: lower-alpha;\n    }\n\n    ol ol ol > li {\n      list-style: lower-roman;\n    }\n  }\n}\n\nbody :not(.ag-theme-quartz) * {\n  @include lib.app-scrollbar;\n}\n\n.ag-visible-x-scroll {\n  .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .ag-body-horizontal-scroll-viewport {\n    @include lib.app-scrollbar;\n  }\n}\n\n.dynamic-scrollbar {\n  // Reserve gutter to avoid layout shift while keeping the thumb hidden when idle.\n  scrollbar-gutter: stable;\n  scrollbar-color: transparent transparent;\n\n  &::-webkit-scrollbar {\n    width: 12px;\n    height: 12px;\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: transparent;\n    border-radius: 24px;\n    border: 2px solid transparent;\n    background-clip: content-box;\n  }\n\n  &:hover,\n  &:focus-within {\n    scrollbar-color: lib.$scrollbar-color transparent;\n\n    &::-webkit-scrollbar-thumb {\n      background: lib.$scrollbar-color;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      border-width: 0px;\n    }\n  }\n}\n\n::selection {\n  background: #b0eaff;\n}\n\n.rounded-smooth {\n  clip-path: polygon(\n    100% 50%,\n    100% 56.6%,\n    100% 59.3%,\n    100% 61.4%,\n    99.9% 63.2%,\n    99.9% 64.8%,\n    99.9% 66.2%,\n    99.8% 67.5%,\n    99.8% 68.7%,\n    99.7% 69.8%,\n    99.6% 70.8%,\n    99.5% 71.8%,\n    99.5% 72.8%,\n    99.4% 73.7%,\n    99.3% 74.6%,\n    99.1% 75.4%,\n    99% 76.3%,\n    98.9% 77%,\n    98.8% 77.8%,\n    98.6% 78.5%,\n    98.5% 79.2%,\n    98.3% 79.9%,\n    98.1% 80.6%,\n    98% 81.3%,\n    97.8% 81.9%,\n    97.6% 82.5%,\n    97.4% 83.1%,\n    97.2% 83.7%,\n    97% 84.3%,\n    96.8% 84.8%,\n    96.5% 85.4%,\n    96.3% 85.9%,\n    96% 86.4%,\n    95.8% 86.9%,\n    95.5% 87.4%,\n    95.3% 87.9%,\n    95% 88.3%,\n    94.7% 88.8%,\n    94.4% 89.2%,\n    94.1% 89.7%,\n    93.8% 90.1%,\n    93.4% 90.5%,\n    93.1% 90.9%,\n    92.8% 91.3%,\n    92.4% 91.7%,\n    92% 92%,\n    91.7% 92.4%,\n    91.3% 92.8%,\n    90.9% 93.1%,\n    90.5% 93.4%,\n    90.1% 93.8%,\n    89.7% 94.1%,\n    89.2% 94.4%,\n    88.8% 94.7%,\n    88.3% 95%,\n    87.9% 95.3%,\n    87.4% 95.5%,\n    86.9% 95.8%,\n    86.4% 96%,\n    85.9% 96.3%,\n    85.4% 96.5%,\n    84.8% 96.8%,\n    84.3% 97%,\n    83.7% 97.2%,\n    83.1% 97.4%,\n    82.5% 97.6%,\n    81.9% 97.8%,\n    81.3% 98%,\n    80.6% 98.1%,\n    79.9% 98.3%,\n    79.2% 98.5%,\n    78.5% 98.6%,\n    77.8% 98.8%,\n    77% 98.9%,\n    76.3% 99%,\n    75.4% 99.1%,\n    74.6% 99.3%,\n    73.7% 99.4%,\n    72.8% 99.5%,\n    71.8% 99.5%,\n    70.8% 99.6%,\n    69.8% 99.7%,\n    68.7% 99.8%,\n    67.5% 99.8%,\n    66.2% 99.9%,\n    64.8% 99.9%,\n    63.2% 99.9%,\n    61.4% 100%,\n    59.3% 100%,\n    56.6% 100%,\n    50% 100%,\n    43.4% 100%,\n    40.7% 100%,\n    38.6% 100%,\n    36.8% 99.9%,\n    35.2% 99.9%,\n    33.8% 99.9%,\n    32.5% 99.8%,\n    31.3% 99.8%,\n    30.2% 99.7%,\n    29.2% 99.6%,\n    28.2% 99.5%,\n    27.2% 99.5%,\n    26.3% 99.4%,\n    25.4% 99.3%,\n    24.6% 99.1%,\n    23.7% 99%,\n    23% 98.9%,\n    22.2% 98.8%,\n    21.5% 98.6%,\n    20.8% 98.5%,\n    20.1% 98.3%,\n    19.4% 98.1%,\n    18.7% 98%,\n    18.1% 97.8%,\n    17.5% 97.6%,\n    16.9% 97.4%,\n    16.3% 97.2%,\n    15.7% 97%,\n    15.2% 96.8%,\n    14.6% 96.5%,\n    14.1% 96.3%,\n    13.6% 96%,\n    13.1% 95.8%,\n    12.6% 95.5%,\n    12.1% 95.3%,\n    11.7% 95%,\n    11.2% 94.7%,\n    10.8% 94.4%,\n    10.3% 94.1%,\n    9.9% 93.8%,\n    9.5% 93.4%,\n    9.1% 93.1%,\n    8.7% 92.8%,\n    8.3% 92.4%,\n    8% 92%,\n    7.6% 91.7%,\n    7.2% 91.3%,\n    6.9% 90.9%,\n    6.6% 90.5%,\n    6.2% 90.1%,\n    5.9% 89.7%,\n    5.6% 89.2%,\n    5.3% 88.8%,\n    5% 88.3%,\n    4.7% 87.9%,\n    4.5% 87.4%,\n    4.2% 86.9%,\n    4% 86.4%,\n    3.7% 85.9%,\n    3.5% 85.4%,\n    3.2% 84.8%,\n    3% 84.3%,\n    2.8% 83.7%,\n    2.6% 83.1%,\n    2.4% 82.5%,\n    2.2% 81.9%,\n    2% 81.3%,\n    1.9% 80.6%,\n    1.7% 79.9%,\n    1.5% 79.2%,\n    1.4% 78.5%,\n    1.2% 77.8%,\n    1.1% 77%,\n    1% 76.3%,\n    0.9% 75.4%,\n    0.7% 74.6%,\n    0.6% 73.7%,\n    0.5% 72.8%,\n    0.5% 71.8%,\n    0.4% 70.8%,\n    0.3% 69.8%,\n    0.2% 68.7%,\n    0.2% 67.5%,\n    0.1% 66.2%,\n    0.1% 64.8%,\n    0.1% 63.2%,\n    0% 61.4%,\n    0% 59.3%,\n    0% 56.6%,\n    0% 50%,\n    0% 43.4%,\n    0% 40.7%,\n    0% 38.6%,\n    0.1% 36.8%,\n    0.1% 35.2%,\n    0.1% 33.8%,\n    0.2% 32.5%,\n    0.2% 31.3%,\n    0.3% 30.2%,\n    0.4% 29.2%,\n    0.5% 28.2%,\n    0.5% 27.2%,\n    0.6% 26.3%,\n    0.7% 25.4%,\n    0.9% 24.6%,\n    1% 23.7%,\n    1.1% 23%,\n    1.2% 22.2%,\n    1.4% 21.5%,\n    1.5% 20.8%,\n    1.7% 20.1%,\n    1.9% 19.4%,\n    2% 18.7%,\n    2.2% 18.1%,\n    2.4% 17.5%,\n    2.6% 16.9%,\n    2.8% 16.3%,\n    3% 15.7%,\n    3.2% 15.2%,\n    3.5% 14.6%,\n    3.7% 14.1%,\n    4% 13.6%,\n    4.2% 13.1%,\n    4.5% 12.6%,\n    4.7% 12.1%,\n    5% 11.7%,\n    5.3% 11.2%,\n    5.6% 10.8%,\n    5.9% 10.3%,\n    6.2% 9.9%,\n    6.6% 9.5%,\n    6.9% 9.1%,\n    7.2% 8.7%,\n    7.6% 8.3%,\n    8% 8%,\n    8.3% 7.6%,\n    8.7% 7.2%,\n    9.1% 6.9%,\n    9.5% 6.6%,\n    9.9% 6.2%,\n    10.3% 5.9%,\n    10.8% 5.6%,\n    11.2% 5.3%,\n    11.7% 5%,\n    12.1% 4.7%,\n    12.6% 4.5%,\n    13.1% 4.2%,\n    13.6% 4%,\n    14.1% 3.7%,\n    14.6% 3.5%,\n    15.2% 3.2%,\n    15.7% 3%,\n    16.3% 2.8%,\n    16.9% 2.6%,\n    17.5% 2.4%,\n    18.1% 2.2%,\n    18.7% 2%,\n    19.4% 1.9%,\n    20.1% 1.7%,\n    20.8% 1.5%,\n    21.5% 1.4%,\n    22.2% 1.2%,\n    23% 1.1%,\n    23.7% 1%,\n    24.6% 0.9%,\n    25.4% 0.7%,\n    26.3% 0.6%,\n    27.2% 0.5%,\n    28.2% 0.5%,\n    29.2% 0.4%,\n    30.2% 0.3%,\n    31.3% 0.2%,\n    32.5% 0.2%,\n    33.8% 0.1%,\n    35.2% 0.1%,\n    36.8% 0.1%,\n    38.6% 0%,\n    40.7% 0%,\n    43.4% 0%,\n    50% 0%,\n    56.6% 0%,\n    59.3% 0%,\n    61.4% 0%,\n    63.2% 0.1%,\n    64.8% 0.1%,\n    66.2% 0.1%,\n    67.5% 0.2%,\n    68.7% 0.2%,\n    69.8% 0.3%,\n    70.8% 0.4%,\n    71.8% 0.5%,\n    72.8% 0.5%,\n    73.7% 0.6%,\n    74.6% 0.7%,\n    75.4% 0.9%,\n    76.3% 1%,\n    77% 1.1%,\n    77.8% 1.2%,\n    78.5% 1.4%,\n    79.2% 1.5%,\n    79.9% 1.7%,\n    80.6% 1.9%,\n    81.3% 2%,\n    81.9% 2.2%,\n    82.5% 2.4%,\n    83.1% 2.6%,\n    83.7% 2.8%,\n    84.3% 3%,\n    84.8% 3.2%,\n    85.4% 3.5%,\n    85.9% 3.7%,\n    86.4% 4%,\n    86.9% 4.2%,\n    87.4% 4.5%,\n    87.9% 4.7%,\n    88.3% 5%,\n    88.8% 5.3%,\n    89.2% 5.6%,\n    89.7% 5.9%,\n    90.1% 6.2%,\n    90.5% 6.6%,\n    90.9% 6.9%,\n    91.3% 7.2%,\n    91.7% 7.6%,\n    92% 8%,\n    92.4% 8.3%,\n    92.8% 8.7%,\n    93.1% 9.1%,\n    93.4% 9.5%,\n    93.8% 9.9%,\n    94.1% 10.3%,\n    94.4% 10.8%,\n    94.7% 11.2%,\n    95% 11.7%,\n    95.3% 12.1%,\n    95.5% 12.6%,\n    95.8% 13.1%,\n    96% 13.6%,\n    96.3% 14.1%,\n    96.5% 14.6%,\n    96.8% 15.2%,\n    97% 15.7%,\n    97.2% 16.3%,\n    97.4% 16.9%,\n    97.6% 17.5%,\n    97.8% 18.1%,\n    98% 18.7%,\n    98.1% 19.4%,\n    98.3% 20.1%,\n    98.5% 20.8%,\n    98.6% 21.5%,\n    98.8% 22.2%,\n    98.9% 23%,\n    99% 23.7%,\n    99.1% 24.6%,\n    99.3% 25.4%,\n    99.4% 26.3%,\n    99.5% 27.2%,\n    99.5% 28.2%,\n    99.6% 29.2%,\n    99.7% 30.2%,\n    99.8% 31.3%,\n    99.8% 32.5%,\n    99.9% 33.8%,\n    99.9% 35.2%,\n    99.9% 36.8%,\n    100% 38.6%,\n    100% 40.7%,\n    100% 43.4%\n  );\n}\n\na {\n  text-decoration: none !important;\n}\n\nlabel {\n  @include lib.rem(font-size, 14px);\n  &:first-letter {\n    text-transform: capitalize;\n  }\n}\n\ninput {\n  @include lib.sm {\n    &::placeholder {\n      @include lib.rem(font-size, 14px);\n    }\n  }\n}\n.invoice-table-container {\n  .ag-details-row {\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  .ag-layout-auto-height,\n  .ag-layout-print {\n    .ag-center-cols-container,\n    .ag-center-cols-viewport {\n      min-height: unset !important;\n    }\n  }\n}\n\n.era-table-container {\n  .ag-row {\n    .ag-cell-value {\n      flex-direction: column;\n    }\n  }\n}\n\n.disabled-wrapper {\n  position: relative;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    z-index: 2;\n    opacity: 0.3;\n    cursor: not-allowed;\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.eye-left,\n.eye-right {\n  animation: rotate 1s infinite;\n  transform-origin: center;\n  transform-box: border-box;\n}\n\nh1 {\n  @include lib.rem(font-size, 40px);\n  line-height: 50px;\n  font-weight: 500;\n}\nh2 {\n  @include lib.rem(font-size, 36px);\n  line-height: 45px;\n  font-weight: 500;\n}\nh3 {\n  @include lib.rem(font-size, 32px);\n  line-height: 40px;\n  font-weight: 500;\n}\nh4 {\n  @include lib.rem(font-size, 28px);\n  line-height: 36px;\n  font-weight: 500;\n}\nh5 {\n  @include lib.rem(font-size, 24px);\n  line-height: 32px;\n  font-weight: 500;\n}\nh6 {\n  @include lib.rem(font-size, 20px);\n  line-height: 28px;\n  font-weight: 500;\n}\n\n// label {\n//   line-height: 18px;\n// }\n// label.text-sm {\n//   line-height: 16px;\n// }\n\n// Primary table\n.primary-table {\n  width: 100%;\n  text-align: left;\n  box-shadow: 0 4px 16px 0px rgba(10, 18, 57, 0.03);\n  overflow: auto;\n  min-height: 104px;\n\n  thead {\n    position: sticky;\n    top: 0px;\n    background-color: #fff;\n    z-index: 1;\n    tr {\n      height: 52px;\n      position: relative;\n      box-shadow: 0 4px 16px 0px rgba(10, 18, 57, 0.03);\n\n      th {\n        color: #004f6b;\n        font-weight: 400 !important;\n        @include lib.rem(font-size, 14px);\n        line-height: 1.25rem;\n        vertical-align: middle;\n        padding: 0 8px;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      height: 52px;\n      &:nth-child(odd) {\n        background-color: #f8fdff;\n      }\n      &:nth-child(even) {\n        background-color: #fff;\n      }\n\n      th {\n        color: #004f6b;\n        font-weight: inherit;\n        @include lib.rem(font-size, 14px);\n        line-height: 1.25rem;\n        vertical-align: middle;\n      }\n\n      td {\n        color: #004f6b;\n        @include lib.rem(font-size, 14px);\n        line-height: 1.25rem;\n        padding: 0 8px;\n      }\n    }\n  }\n\n  .has-subtable {\n    tr {\n      background-color: #e6f8ff !important;\n\n      th {\n        font-weight: 600;\n        text-align: left;\n      }\n\n      td {\n        text-align: left;\n      }\n    }\n\n    &.danger {\n      tr {\n        background-color: #fef2f2 !important;\n      }\n    }\n\n    &.success {\n      tr {\n        background-color: #f0fdf4 !important;\n      }\n    }\n  }\n\n  &.selectable-children {\n    border-collapse: unset;\n    tr {\n      border-radius: 8px;\n      &.selected {\n        td {\n          background-color: #e6f8ff;\n          border-color: #13b9ff;\n        }\n      }\n      td {\n        border-width: 1px;\n        border-top-style: solid;\n        border-bottom-style: solid;\n        border-color: transparent;\n        &:first-child {\n          border-left-style: solid;\n        }\n        &:last-child {\n          border-right-style: solid;\n        }\n      }\n    }\n  }\n\n  &.responsive-table {\n    position: relative;\n    overflow: auto;\n    display: block;\n    table-layout: fixed;\n    width: 100%;\n    tbody {\n      position: relative;\n      z-index: 2;\n      display: block;\n      overflow: auto;\n      margin-right: 6px;\n      margin-left: 6px;\n      margin-top: 6px;\n      margin-bottom: 10px;\n      tr {\n        display: table;\n        table-layout: fixed;\n        width: 100%;\n        margin-top: 2px;\n      }\n    }\n    thead {\n      display: table;\n      table-layout: fixed;\n      width: 100%;\n    }\n  }\n  .empty {\n    position: absolute;\n    left: 0;\n    @include lib.rem(font-size, 14px);\n    color: #004f6b;\n    width: 100%;\n    background: white;\n    height: 52px;\n    top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.dashed-top {\n  border-top: 1px dashed #8ae0ff;\n}\n.dashed-bottom {\n  border-bottom: 1px dashed #8ae0ff !important;\n}\n.dashed-left {\n  border-left: 1px dashed #8ae0ff;\n}\n.dashed-right {\n  border-right: 1px dashed #8ae0ff;\n}\n\n.ag-row-error {\n  background-color: rgba(255, 0, 0, 0.2);\n}\n\n// An inset shadow rather than a border: AG Grid positions cells inside the row's padding box.\n.ag-row-command-highlight {\n  background-color: #f5fbff;\n  box-shadow: inset 2px 0 0 #0ba5ec;\n}\n\n::highlight(command-bar-match) {\n  background-color: #fedf89;\n  color: inherit;\n}\n\n.ag-cell-wrapper.ag-row-group {\n  align-items: center;\n}\n\n.selected-group-row {\n  background-color: #e6f8ff;\n}\n\n.ag-hover-group-row {\n  background-color: #d3edfe;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n}\n\nbutton,\n.select {\n  .Icon {\n    cursor: pointer;\n  }\n}\n\n.ag-status-bar {\n  padding: 16px 18px;\n  height: 48px;\n  min-height: 35px;\n}\n\n.debug {\n  border: 1px solid #f56565;\n  border-style: solid;\n}\n\n@keyframes ellipsis {\n  0% {\n    content: '.';\n  }\n  33% {\n    content: '..';\n  }\n  66% {\n    content: '...';\n  }\n  100% {\n    content: '.';\n  }\n}\n\n.animate-ellipsis::after {\n  content: '.';\n  animation: ellipsis 1s infinite steps(1);\n}\n\n/* Blink effect */\n@keyframes blink {\n  0%,\n  50%,\n  100% {\n    opacity: 1;\n  }\n  25%,\n  75% {\n    opacity: 0;\n  }\n}\n\n.blink {\n  animation: blink 2s linear infinite;\n}\n\n.animate-shine {\n  $width: 30px;\n  position: relative;\n  border: none !important;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -4px;\n    width: $width;\n    height: calc(100% + 8px);\n    transform: rotate(0deg);\n    background: linear-gradient(\n      109.17deg,\n      rgba(255, 255, 255, 0) 27.03%,\n      rgba(255, 255, 255, 0.3) 43.82%,\n      rgba(255, 255, 255, 0.254412) 58.83%,\n      rgba(255, 255, 255, 0) 77.63%\n    );\n    animation: shine 1.5s linear infinite;\n  }\n}\n\n@keyframes shine {\n  0% {\n    left: -30px;\n    opacity: 1;\n  }\n  70% {\n    left: 70%;\n    opacity: 0.5;\n  }\n  100% {\n    left: calc(100% - 16px);\n    opacity: 0;\n  }\n}\n\n@keyframes pulse-bg {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n@media print {\n  input,\n  textarea,\n  select {\n    background-color: transparent !important;\n    color: var.$black;\n  }\n  p,\n  span,\n  strong,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  label,\n  input {\n    color: var.$black !important;\n  }\n  input,\n  select {\n    border-color: var.$gray !important;\n  }\n  svg {\n    transform: scale(0.8);\n    path {\n      fill: var.$black;\n    }\n  }\n  .SortableItem {\n    break-inside: avoid;\n  }\n  .row {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin: 0;\n    .SortableItem {\n      break-inside: unset;\n      flex: unset !important;\n    }\n    .col-md-3 {\n      flex: 1 1 20%;\n      max-width: unset;\n      padding: 0;\n    }\n    .col-md-4 {\n      flex: 1 1 30%;\n      max-width: unset;\n      padding: 0;\n    }\n  }\n}\n\n.ag-chart-tooltip {\n  z-index: 99999 !important;\n  border-radius: 12px !important;\n  border: 1px solid rgba(233, 234, 235, 0.9) !important;\n  background: rgba(255, 255, 255, 0.94) !important;\n  backdrop-filter: saturate(180%) blur(8px);\n  -webkit-backdrop-filter: saturate(180%) blur(8px);\n  box-shadow:\n    0 1px 2px rgba(16, 24, 40, 0.04),\n    0 8px 16px -6px rgba(16, 24, 40, 0.12),\n    0 20px 32px -12px rgba(10, 18, 57, 0.18) !important;\n  font-family: var.$main-font !important;\n  font-size: 12px !important;\n  color: #181d27 !important;\n  font-variant-numeric: tabular-nums;\n  overflow: hidden;\n}\n\n.ag-chart-tooltip-title {\n  background: transparent !important;\n  color: #717680 !important;\n  font-weight: 600;\n  font-size: 10.5px;\n  letter-spacing: 0.02em;\n  padding: 8px 12px 2px !important;\n}\n\n.ag-chart-tooltip-content {\n  color: #181d27;\n  font-weight: 600;\n  padding: 2px 12px 9px !important;\n}\n","@use './variables' as var;\n@use './lib' as lib;\n\n// general style\n.Spinner-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n}\n\n// Tippy\n.tippy-box {\n  &.tippy-content {\n    padding: 6px 12px;\n  }\n  &.custom-tooltip {\n    .tippy-content {\n      padding: 0 !important;\n    }\n  }\n  &.arrow-small {\n    .tippy-arrow {\n      &:before {\n        border-width: 5px 5px 5px 0;\n      }\n    }\n    &[data-placement^='top'] {\n      .tippy-arrow {\n        bottom: unset;\n        &:before {\n          top: 0;\n          border-width: 5px 5px 0px 5px;\n        }\n      }\n    }\n    &[data-placement^='bottom'] {\n      .tippy-arrow {\n        &:before {\n          top: -10px;\n          border-width: 5px;\n        }\n      }\n    }\n    &[data-placement^='right'] {\n      .tippy-arrow {\n        left: 0;\n        &:before {\n          left: -4px;\n        }\n      }\n    }\n    &[data-placement^='left'] {\n      .tippy-arrow {\n        left: 100%;\n        &:before {\n          right: unset;\n          left: 0;\n          border-width: 5px 0px 5px 5px;\n        }\n      }\n    }\n    &[data-placement^='right'],\n    &[data-placement^='left'] {\n      .tippy-arrow {\n        &:before {\n          top: 50%;\n          transform: translateY(-50%);\n        }\n      }\n    }\n  }\n}\n\ndiv[data-tippy-root] > div {\n  color: #004f6b !important;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16) !important;\n  @include lib.rem(font-size, 14px);\n  border-radius: 4px;\n\n  &.tippy-border {\n    box-shadow: none !important;\n  }\n}\n\n.tippy-arrow-primary-dark {\n  .tippy-arrow {\n    color: #004f6b;\n    &:before {\n      left: -5px !important;\n    }\n  }\n}\n\n.tippy-dark {\n  div:first-child {\n    color: white;\n    background-color: var.$dark;\n    border-radius: 4px;\n  }\n\n  &[data-placement^='top'] > .tippy-arrow:before {\n    border-top-color: var.$dark !important;\n  }\n\n  &[data-placement^='bottom'] > .tippy-arrow:before {\n    border-bottom-color: var.$dark !important;\n  }\n\n  &[data-placement^='left'] > .tippy-arrow:before {\n    border-left-color: var.$dark !important;\n  }\n\n  &[data-placement^='right'] > .tippy-arrow:before {\n    border-right-color: var.$dark !important;\n  }\n  &.no-arrow .tippy-arrow:before {\n    border: none !important;\n  }\n}\n.tippy-black {\n  div:first-child {\n    color: white;\n    background: #374145;\n    border-radius: 3px;\n  }\n\n  &[data-placement^='top'] > .tippy-arrow:before {\n    border-top-color: #374145 !important;\n  }\n\n  &[data-placement^='bottom'] > .tippy-arrow:before {\n    border-bottom-color: #374145 !important;\n  }\n\n  &[data-placement^='left'] > .tippy-arrow:before {\n    border-left-color: #374145 !important;\n  }\n\n  &[data-placement^='right'] > .tippy-arrow:before {\n    border-right-color: #374145 !important;\n  }\n  &.no-arrow .tippy-arrow:before {\n    border: none !important;\n  }\n}\n\n.tippy-border {\n  box-shadow: none !important;\n  border: 1px solid #d5d7da;\n\n  div:first-child {\n    color: #181d27;\n    box-shadow: none !important;\n  }\n\n  &[data-placement^='top'] > .tippy-arrow:before {\n    border-top-color: #d5d7da !important;\n    transform: scale(0.65);\n    transform-origin: center;\n  }\n\n  &[data-placement^='bottom'] > .tippy-arrow:before {\n    border-bottom-color: #d5d7da !important;\n    transform: scale(0.65);\n    transform-origin: center;\n  }\n\n  &[data-placement^='left'] > .tippy-arrow:before {\n    border-left-color: #d5d7da !important;\n    transform: scale(0.65);\n    transform-origin: center;\n  }\n\n  &[data-placement^='right'] > .tippy-arrow:before {\n    border-right-color: #d5d7da !important;\n    transform: scale(0.65);\n    transform-origin: center;\n  }\n\n  &.no-arrow .tippy-arrow:before {\n    border: none !important;\n  }\n}\n\n.Tabnav {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #dcdcdc;\n  &__item {\n    margin-left: 30px;\n    padding: 22px 0;\n    position: relative;\n    cursor: pointer;\n    &:hover {\n      span {\n        color: #737373;\n      }\n    }\n    &.active {\n      &:before {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        width: 100%;\n        height: 3px;\n        background-color: var.$primary;\n        z-index: 2;\n      }\n      &:hover {\n        span {\n          color: var.$primary;\n        }\n      }\n      span {\n        color: var.$primary;\n      }\n    }\n    &:hover {\n      span {\n        color: #737373;\n      }\n    }\n    span {\n      color: #8e8d8e;\n      font-weight: 600;\n      transition: 0.2s;\n    }\n  }\n}\n\nbody,\np,\nul,\nli,\na,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nform {\n  margin: 0;\n  padding: 0;\n}\n\na {\n  text-decoration: none;\n  color: var.$primary;\n  &:hover {\n    color: var.$primary;\n  }\n}\n\nbutton {\n  outline: none !important;\n}\n\n// remove input background if user has autofill\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n.react-confirm-alert-overlay {\n  transition: 0.3s ease-in-out;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.react-confirm-alert-body {\n  min-width: 430px;\n  line-height: 1.3;\n  color: #afafaf;\n  & > h1 {\n    color: var.$black;\n    font-weight: 600;\n    font-size: 1.25rem;\n    padding-bottom: 20px;\n  }\n}\n.react-confirm-alert-button-group {\n  margin-top: 30px;\n  gap: 14px;\n  & > .Button {\n    width: 50%;\n    margin: 0;\n    @include lib.rem(font-size, 16px);\n    &--success {\n      background-color: var.$success;\n    }\n    &--danger {\n      background-color: var.$danger;\n    }\n    &--transparent {\n      background-color: transparent;\n      border: 1px solid transparent;\n      color: #aaaaaa;\n      &:hover {\n        background-color: #efefef;\n      }\n    }\n  }\n}\n\n// ReactFormBuilder\n\n.print-only {\n  .rfb-item:not(:has(.CustomForms)) {\n    max-width: 700px !important;\n  }\n\n  background-color: #ffffff;\n\n  .Icon--trash {\n    display: none !important;\n  }\n\n  div:has(> .Icon--trash:first-child) {\n    display: none !important;\n  }\n}\n\n.new-forms .react-form-builder-form {\n  // Centered, readable content width that still gives multi-column question\n  // grids room to breathe — in line with the native form. The package handles\n  // responsive column collapse (4->2 at <=1024, 3->1 at <=768), so we no longer\n  // force single-column stacking or a narrow 500px cap here.\n  max-width: 900px;\n  margin: 0 auto;\n\n  @media screen and (max-width: 1024px) {\n    max-width: 100%;\n  }\n\n  .rfb-item:not(:has(.CustomForms)) {\n    width: auto;\n    max-width: none;\n    margin: 0;\n  }\n\n  @media screen and (max-width: 599px) {\n    .rfb-item.SortableItem > :not(:first-child) {\n      padding-left: 8px;\n      padding-right: 8px;\n    }\n  }\n\n  .rfb-item .form-label {\n    display: flex !important;\n    gap: 2px;\n  }\n\n  .rfb-item label:not(.static) {\n    display: flex !important;\n    gap: 2px;\n    color: #374145;\n    font-weight: 400;\n  }\n\n  .rfb-item label.static {\n    display: block !important;\n    color: #374145;\n    font-weight: 400;\n  }\n\n  p {\n    // color: #374145;\n    line-height: 150%;\n    font-weight: 400;\n  }\n\n  // Control skins (checkboxes, radios, focus rings, dropdown chevron,\n  // required asterisk, rating, slider, inputs) now ship with the package\n  // (react-form-builder#v0-14-8) and follow per-practice branding. The old\n  // gray-pill label padding is gone — it made option controls float above\n  // their labels now that the package draws compact controls.\n\n  .static {\n    font-size: 1rem;\n  }\n\n  .rfb-item img {\n    border-radius: 8px;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    color: #6d828b;\n    background-color: transparent;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    height: 16px;\n    width: 22px;\n    padding-bottom: 8px;\n    font-size: 20px;\n    display: table-cell;\n    content: '\\00d7';\n  }\n\n  .react-datepicker__input-container:not(:has(button))::after {\n    content: '';\n    right: 12px;\n    display: block;\n    position: absolute;\n    bottom: 10px;\n    height: 20px;\n    width: 20px;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.5607 2.67V1.5C12.5607 1.1925 12.3057 0.9375 11.9982 0.9375C11.6907 0.9375 11.4357 1.1925 11.4357 1.5V2.625H6.56072V1.5C6.56072 1.1925 6.30572 0.9375 5.99822 0.9375C5.69072 0.9375 5.43572 1.1925 5.43572 1.5V2.67C3.41072 2.8575 2.42822 4.065 2.27822 5.8575C2.26322 6.075 2.44322 6.255 2.65322 6.255H15.3432C15.5607 6.255 15.7407 6.0675 15.7182 5.8575C15.5682 4.065 14.5857 2.8575 12.5607 2.67Z' fill='%23C1CACE'/%3E%3Cpath opacity='0.32' d='M15 7.37988C15.4125 7.37988 15.75 7.71738 15.75 8.12988V12.7499C15.75 14.9999 14.625 16.4999 12 16.4999H6C3.375 16.4999 2.25 14.9999 2.25 12.7499V8.12988C2.25 7.71738 2.5875 7.37988 3 7.37988H15Z' fill='%23C1CACE'/%3E%3Cpath d='M6.375 11.2501C6.18 11.2501 5.985 11.1676 5.8425 11.0326C5.7075 10.8901 5.625 10.6951 5.625 10.5001C5.625 10.3051 5.7075 10.1102 5.8425 9.96766C6.0525 9.75766 6.3825 9.69014 6.66 9.81014C6.7575 9.84764 6.84 9.90016 6.9075 9.96766C7.0425 10.1102 7.125 10.3051 7.125 10.5001C7.125 10.6951 7.0425 10.8901 6.9075 11.0326C6.765 11.1676 6.57 11.2501 6.375 11.2501Z' fill='%23C1CACE'/%3E%3Cpath d='M9 11.2501C8.805 11.2501 8.61 11.1676 8.4675 11.0326C8.3325 10.8901 8.25 10.6951 8.25 10.5001C8.25 10.3051 8.3325 10.1102 8.4675 9.96766C8.535 9.90016 8.6175 9.84764 8.715 9.81014C8.9925 9.69014 9.3225 9.75766 9.5325 9.96766C9.6675 10.1102 9.75 10.3051 9.75 10.5001C9.75 10.6951 9.6675 10.8901 9.5325 11.0326C9.495 11.0626 9.4575 11.0926 9.42 11.1226C9.375 11.1526 9.33 11.1752 9.285 11.1902C9.24 11.2127 9.195 11.2277 9.15 11.2352C9.0975 11.2427 9.0525 11.2501 9 11.2501Z' fill='%23C1CACE'/%3E%3Cpath d='M11.625 11.25C11.43 11.25 11.235 11.1675 11.0925 11.0325C10.9575 10.89 10.875 10.695 10.875 10.5C10.875 10.305 10.9575 10.11 11.0925 9.96752C11.1675 9.90002 11.2425 9.8475 11.34 9.81C11.475 9.75 11.625 9.735 11.775 9.765C11.82 9.7725 11.865 9.7875 11.91 9.81C11.955 9.825 12 9.84752 12.045 9.87752C12.0825 9.90752 12.12 9.93752 12.1575 9.96752C12.2925 10.11 12.375 10.305 12.375 10.5C12.375 10.695 12.2925 10.89 12.1575 11.0325C12.12 11.0625 12.0825 11.0925 12.045 11.1225C12 11.1525 11.955 11.175 11.91 11.19C11.865 11.2125 11.82 11.2275 11.775 11.235C11.7225 11.2425 11.67 11.25 11.625 11.25Z' fill='%23C1CACE'/%3E%3Cpath d='M6.375 13.875C6.2775 13.875 6.18 13.8525 6.09 13.815C5.9925 13.7775 5.9175 13.725 5.8425 13.6575C5.7075 13.515 5.625 13.32 5.625 13.125C5.625 12.93 5.7075 12.735 5.8425 12.5925C5.9175 12.525 5.9925 12.4725 6.09 12.435C6.225 12.375 6.375 12.36 6.525 12.39C6.57 12.3975 6.615 12.4125 6.66 12.435C6.705 12.45 6.75 12.4725 6.795 12.5025C6.8325 12.5325 6.87 12.5625 6.9075 12.5925C7.0425 12.735 7.125 12.93 7.125 13.125C7.125 13.32 7.0425 13.515 6.9075 13.6575C6.87 13.6875 6.8325 13.725 6.795 13.7475C6.75 13.7775 6.705 13.8 6.66 13.815C6.615 13.8375 6.57 13.8525 6.525 13.86C6.4725 13.8675 6.4275 13.875 6.375 13.875Z' fill='%23C1CACE'/%3E%3Cpath d='M9 13.8754C8.805 13.8754 8.61 13.7929 8.4675 13.6579C8.3325 13.5154 8.25 13.3204 8.25 13.1254C8.25 12.9304 8.3325 12.7354 8.4675 12.5929C8.745 12.3154 9.255 12.3154 9.5325 12.5929C9.6675 12.7354 9.75 12.9304 9.75 13.1254C9.75 13.3204 9.6675 13.5154 9.5325 13.6579C9.39 13.7929 9.195 13.8754 9 13.8754Z' fill='%23C1CACE'/%3E%3Cpath d='M11.625 13.8754C11.43 13.8754 11.235 13.7929 11.0925 13.6579C10.9575 13.5154 10.875 13.3204 10.875 13.1254C10.875 12.9304 10.9575 12.7354 11.0925 12.5929C11.37 12.3154 11.88 12.3154 12.1575 12.5929C12.2925 12.7354 12.375 12.9304 12.375 13.1254C12.375 13.3204 12.2925 13.5154 12.1575 13.6579C12.015 13.7929 11.82 13.8754 11.625 13.8754Z' fill='%23C1CACE'/%3E%3C/svg%3E\");\n\n    background-repeat: no-repeat;\n    background-size: contain; /* Adjust as needed */\n    background-position: center; /* Adjust as needed */\n  }\n\n  .react-datepicker__input-container input {\n    height: auto;\n    font-size: 14px;\n    padding: 9px 12px;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .range {\n    margin-top: 12px;\n  }\n\n  .slider {\n    margin-top: 5px;\n  }\n\n  .clear-signature {\n    position: absolute;\n    right: 12px;\n    bottom: 38px;\n  }\n\n  .form-group canvas {\n    width: 100% !important;\n    max-width: 500px !important;\n    aspect-ratio: 2 !important;\n    margin-top: 4px;\n    height: auto !important;\n    touch-action: none;\n  }\n\n}\n\n// Legacy overrides for the bare (non-.new-forms) form skin were removed:\n// the package (react-form-builder#v0-14-8) now ships a modern default skin\n// driven by the practice branding CSS variables. Only rules that change\n// behavior rather than looks are kept below.\n.react-form-builder-form {\n  button span {\n    white-space: nowrap;\n  }\n  canvas {\n    touch-action: none;\n  }\n  .signature-missing canvas {\n    outline: 2px solid var.$danger;\n    outline-offset: -1px;\n  }\n  input,\n  textarea {\n    resize: none;\n  }\n  hr {\n    display: none;\n  }\n}\n\n@font-face {\n  font-family: 'StarFont';\n  src: url('~assets/fonts/StarFont.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n.rating-container:before,\n.rating-container .rating-stars:before {\n  font-family: 'StarFont';\n  letter-spacing: 3px;\n}\n\n// react date picker\n.react-datepicker__year-read-view--down-arrow {\n  &:before {\n    border-top-color: transparent;\n  }\n}\n\n.react-tooltip {\n  z-index: 2;\n}\n\n// general style\n.Spinner-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n}\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  background-image: white !important;\n}\n\ninput[type='date'],\ninput[type='datetime-local'],\ninput[type='month'],\ninput[type='time'] {\n  display: flex;\n}\n\n#__filestack-picker {\n  overflow: hidden;\n  position: fixed !important;\n  z-index: 9999999 !important;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n}\n\n.intercom-app {\n  & [class*='intercom-with-namespace-'] {\n    background: none !important;\n  }\n}\n","@use './variables' as var;\n@use 'sass:math';\n@use 'sass:list';\n@use 'sass:meta';\n\n//Mixin for including styles under 390px\n@mixin xxs {\n  @media (max-width: var.$xxs) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 480px\n@mixin xs {\n  @media (max-width: var.$xs) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 768px\n@mixin sm {\n  @media (max-width: var.$sm) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 1024x\n@mixin md {\n  @media (max-width: var.$md) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 1512px\n@mixin lg {\n  @media (max-width: var.$lg) {\n    @content;\n  }\n}\n\n//Mixin for including styles above 1513px\n@mixin xl {\n  @media (min-width: var.$xl) {\n    @content;\n  }\n}\n\n// Mixin for including styles above 2001px\n@mixin xxl {\n  @media (min-width: var.$xxl) {\n    @content;\n  }\n}\n\n// Mixin for converting 'px' to 'rem'\n@mixin rem($property, $values) {\n  // Create a couple of empty lists as output buffers.\n  $base-font-size: 16px; // should be consistent with your html/body font-size\n  $px-values: ();\n  $rem-values: ();\n\n  // Loop through the $values list\n  @each $value in $values {\n    // For each property value, if it's in rem or px, derive both rem and\n    // px values for it and add those to the end of the appropriate buffer.\n    // Ensure all pixel values are rounded to the nearest pixel.\n    @if $value==0 or $value==0px {\n      // 0 -- use it without a unit\n      $px-values: list.join($px-values, 0);\n      $rem-values: list.join($rem-values, 0);\n    } @else if\n      meta.type-of($value)\n      ==number and not\n      math.is-unitless($value) and\n      (math.unit($value) ==px)\n    {\n      // px value given - calculate rem value from base-font-size\n      $new-rem-value: calc($value / $base-font-size);\n      $px-values: list.join($px-values, math.round($value));\n      $rem-values: list.join($rem-values, #{$new-rem-value}rem);\n    } @else {\n      // unitless value - use those directly as rem and calculate the px-fallback\n      $px-values: list.join($px-values, math.round($value * $base-font-size));\n      $rem-values: list.join($rem-values, #{$value}rem);\n    }\n  }\n\n  // output the converted rules\n  // #{$property}: $px-values;\n  #{$property}: $rem-values;\n}\n\n@mixin scrollbar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    background: #eceff0;\n    border-radius: 5px;\n    display: block;\n  }\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px white;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #cdd5d8;\n    border-radius: 5px;\n  }\n\n  &-sm-light {\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #e3eaed !important;\n    }\n  }\n}\n\n@mixin scrollbar-horizontal {\n  &::-webkit-scrollbar {\n    background: #eceff0;\n    border-radius: 5px;\n    display: block;\n    height: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px white;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #cdd5d8;\n    border-radius: 5px;\n  }\n}\n\n$scrollbar-color: #8fa0a7;\n\n@mixin app-scrollbar {\n  &::-webkit-scrollbar {\n    width: 12px;\n    height: 12px;\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $scrollbar-color;\n    border-radius: 24px;\n    border: 2px solid transparent;\n    background-clip: content-box;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    border-width: 0px;\n  }\n}\n","@use 'sass:map';\n\n$font-family-sans-serif:\n  'Geist',\n  -apple-system,\n  BlinkMacSystemFont,\n  'Segoe UI',\n  Roboto,\n  'Helvetica Neue',\n  Arial,\n  'Noto Sans',\n  sans-serif,\n  'Apple Color Emoji',\n  'Segoe UI Emoji',\n  'Segoe UI Symbol',\n  'Noto Color Emoji' !default;\n$main-font: 'Geist', sans-serif;\n\n// colors — kept in sync with tailwind.config.js\n$colors: (\n  'neutral': (\n    25: #fdfdfd,\n    50: #f9fafa,\n    75: #f6f6f6,\n    100: #f5f5f5,\n    200: #e9eaeb,\n    300: #d5d7da,\n    400: #a4a7ae,\n    500: #717680,\n    600: #535862,\n    700: #414651,\n    800: #252b37,\n    900: #181d27,\n    950: #0a0d12\n  ),\n  'neutral-dark': (\n    25: #fafafa,\n    50: #f7f7f7,\n    100: #f0f0f1,\n    200: #ececed,\n    300: #cecfd2,\n    400: #94979c,\n    500: #85888e,\n    600: #61656c,\n    700: #373a41,\n    800: #22262f,\n    900: #13161b,\n    950: #0c0e12\n  ),\n  'primary': (\n    10: #fafdff,\n    25: #f5fbff,\n    50: #f0f9ff,\n    100: #e0f2fe,\n    200: #b9e6fe,\n    300: #7cd4fd,\n    400: #36bffa,\n    500: #0ba5ec,\n    600: #0086c9,\n    700: #026aa2,\n    800: #065986,\n    900: #0b4a6f,\n    950: #062c41\n  ),\n  'danger': (\n    25: #fffbfa,\n    50: #fef3f2,\n    100: #fee4e2,\n    200: #fecdca,\n    300: #fda29b,\n    400: #f97066,\n    500: #f04438,\n    600: #d92d20,\n    700: #b42318,\n    800: #912018,\n    900: #7a271a,\n    950: #55160c\n  ),\n  'warning': (\n    25: #fffcf5,\n    50: #fffaeb,\n    100: #fef0c7,\n    200: #fedf89,\n    300: #fec84b,\n    400: #fdb022,\n    500: #f79009,\n    600: #dc6803,\n    700: #b54708,\n    800: #93370d,\n    900: #7a2e0e,\n    950: #4e1d09\n  ),\n  'success': (\n    25: #f6fef9,\n    50: #edfcf2,\n    100: #d3f8df,\n    200: #aaf0c4,\n    300: #73e2a3,\n    400: #3ccb7f,\n    500: #16b364,\n    600: #099250,\n    700: #087443,\n    800: #095c37,\n    900: #084c2e,\n    950: #052e1c\n  ),\n  'moss': (\n    25: #fafdf7,\n    50: #f5fbee,\n    100: #e6f4d7,\n    200: #ceeab0,\n    300: #acdc79,\n    400: #86cb3c,\n    500: #669f2a,\n    600: #4f7a21,\n    700: #3f621a,\n    800: #335015,\n    900: #2b4212,\n    950: #1a280b\n  ),\n  'green-light': (\n    25: #fafef5,\n    50: #f3fee7,\n    100: #e4fbcc,\n    200: #d0f8ab,\n    300: #a6ef67,\n    400: #85e13a,\n    500: #66c61c,\n    600: #4ca30d,\n    700: #3b7c0f,\n    800: #326212,\n    900: #2b5314,\n    950: #15290a\n  ),\n  'teal': (\n    25: #f6fefc,\n    50: #f0fdf9,\n    100: #ccfbef,\n    200: #99f6e0,\n    300: #5fe9d0,\n    400: #2ed3b7,\n    500: #15b79e,\n    600: #0e9384,\n    700: #107569,\n    800: #125d56,\n    900: #134e48,\n    950: #0a2926\n  ),\n  'cyan': (\n    25: #f5feff,\n    50: #ecfdff,\n    100: #cff9fe,\n    200: #a5f0fc,\n    300: #67e3f9,\n    400: #22ccee,\n    500: #06aed4,\n    600: #088ab2,\n    700: #0e7090,\n    800: #155b75,\n    900: #164c63,\n    950: #0d2d3a\n  ),\n  'blue-dark': (\n    25: #f5f8ff,\n    50: #eff4ff,\n    100: #d1e0ff,\n    200: #b2ccff,\n    300: #84adff,\n    400: #528bff,\n    500: #2970ff,\n    600: #155eef,\n    700: #004eeb,\n    800: #0040c1,\n    900: #00359e,\n    950: #002266\n  ),\n  'violet': (\n    25: #fbfaff,\n    50: #f5f3ff,\n    100: #ece9fe,\n    200: #ddd6fe,\n    300: #c3b5fd,\n    400: #a48afb,\n    500: #875bf7,\n    600: #7839ee,\n    700: #6927da,\n    800: #5720b7,\n    900: #491c96,\n    950: #2e125e\n  ),\n  'purple': (\n    25: #fafaff,\n    50: #f4f3ff,\n    100: #ebe9fe,\n    200: #d9d6fe,\n    300: #bdb4fe,\n    400: #9b8afb,\n    500: #7a5af8,\n    600: #6938ef,\n    700: #5925dc,\n    800: #4a1fb8,\n    900: #3e1c96,\n    950: #27115f\n  ),\n  'fuchsia': (\n    25: #fefaff,\n    50: #fdf4ff,\n    100: #fbe8ff,\n    200: #f6d0fe,\n    300: #eeaafd,\n    400: #e478fa,\n    500: #d444f1,\n    600: #ba24d5,\n    700: #9f1ab1,\n    800: #821890,\n    900: #6f1877,\n    950: #47104c\n  ),\n  'pink': (\n    25: #fef6fb,\n    50: #fdf2fa,\n    100: #fce7f6,\n    200: #fcceee,\n    300: #faa7e0,\n    400: #f670c7,\n    500: #ee46bc,\n    600: #dd2590,\n    700: #c11574,\n    800: #9e165f,\n    900: #851651,\n    950: #4e0d30\n  ),\n  'rose': (\n    25: #fff5f6,\n    50: #fff1f3,\n    100: #ffe4e8,\n    200: #fecdd6,\n    300: #fea3b4,\n    400: #fd6f8e,\n    500: #f63d68,\n    600: #e31b54,\n    700: #c01048,\n    800: #a11043,\n    900: #89123e,\n    950: #510b24\n  ),\n  'orange-dark': (\n    25: #fff9f5,\n    50: #fff4ed,\n    100: #ffe6d5,\n    200: #ffd6ae,\n    300: #ff9c66,\n    400: #ff692d,\n    500: #ff4405,\n    600: #e62e05,\n    700: #bc1b06,\n    800: #97180c,\n    900: #771a0d,\n    950: #57130a\n  ),\n  'yellow': (\n    25: #fefdf0,\n    50: #fefbe8,\n    100: #fef7c3,\n    200: #feee95,\n    300: #fde272,\n    400: #fac515,\n    500: #eaaa08,\n    600: #ca8504,\n    700: #a15c07,\n    800: #854a0e,\n    900: #713b12,\n    950: #542c0d\n  ),\n  'white': (\n    500: #ffffff\n  ),\n  'black': (\n    500: #000000\n  )\n);\n\n//colors\n$dark: map.get(map.get($colors, 'neutral'), 900);\n$black: map.get(map.get($colors, 'neutral'), 800);\n$primary: var(--color-primary-500, #{map.get(map.get($colors, 'primary'), 500)});\n$primary-dark: map.get(map.get($colors, 'primary'), 900);\n$secondary: var(--color-secondary-500, #b0d5e2);\n$gray: map.get(map.get($colors, 'neutral'), 400);\n$gray-dark: map.get(map.get($colors, 'neutral'), 800);\n$gray-light: map.get(map.get($colors, 'neutral'), 50);\n$success: map.get(map.get($colors, 'success'), 500);\n$warning: map.get(map.get($colors, 'warning'), 500);\n$danger: map.get(map.get($colors, 'danger'), 500);\n$blue-light: #f8fdff;\n$blue: #4876ff;\n\n//card theme colors\n$yellow: #ffc700;\n$purple: #aa56ff;\n$green: #00bf93;\n$greenLight: #10ca00;\n\n//media queries\n$xxs: 390px;\n$xs: 480px;\n$sm: 768px;\n$md: 1024px;\n$lg: 1512px;\n$xl: 1513px;\n$xxl: 2001px;\n","html.kiosk-touch,\nhtml.kiosk-touch body,\nhtml.touch-ux,\nhtml.touch-ux body {\n  font-size: 16px !important;\n}\n\nhtml.kiosk-touch,\nhtml.touch-ux {\n  // These modes drop maximum-scale so patients can pinch-zoom, which also\n  // re-enables iOS double-tap zoom — an accidental double-tap zooms the page\n  // and SPA navigation never resets it. `manipulation` keeps pan + pinch but\n  // removes double-tap zoom.\n  &,\n  * {\n    touch-action: manipulation;\n  }\n\n  // Signature pads need raw strokes (mirrors the base rules in _reset.scss).\n  .form-group canvas,\n  .react-form-builder-form canvas {\n    touch-action: none;\n  }\n\n  // 16px floor on every text-entry surface, or iOS auto-zooms on focus.\n  input,\n  select,\n  textarea,\n  [contenteditable='true'] {\n    font-size: 16px !important;\n  }\n\n  input::placeholder,\n  textarea::placeholder {\n    font-size: 16px !important;\n  }\n\n  label:has(> div > input) {\n    height: auto !important;\n    min-height: 48px !important;\n  }\n\n  .custom-picker {\n    .react-date-picker,\n    .react-datetime-picker,\n    .react-daterange-picker,\n    .react-datetimerange-picker {\n      height: auto !important;\n      min-height: 48px !important;\n      font-size: 16px !important;\n\n      &__wrapper {\n        width: 100%;\n        min-height: 48px;\n      }\n\n      &__button {\n        padding: 0 4px !important;\n        min-width: 44px;\n        min-height: 44px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &__clear-button {\n        min-width: 44px;\n        min-height: 44px;\n      }\n    }\n  }\n\n  .react-form-builder-form {\n    font-size: 16px;\n\n    .form-control.form-control {\n      min-height: 48px !important;\n      font-size: 16px !important;\n    }\n\n    input.form-control.form-control,\n    select.form-control.form-control {\n      height: 48px !important;\n    }\n\n    textarea.form-control.form-control {\n      height: auto !important;\n      min-height: 96px !important;\n    }\n\n    .rfb-item .form-group > label,\n    .rfb-item .form-group > .form-label {\n      font-size: 16px !important;\n      margin-bottom: 8px !important;\n    }\n\n    .rfb-item .form-group input[type='date'] {\n      height: 48px !important;\n    }\n\n    .react-datepicker__input-container input {\n      min-height: 48px !important;\n      padding: 12px !important;\n    }\n\n    .react-datepicker__input-container:not(:has(button))::after {\n      bottom: 14px !important;\n    }\n\n    .custom-control.custom-checkbox,\n    .custom-control.custom-radio {\n      margin-bottom: 12px !important;\n    }\n\n    .custom-control .custom-control-label {\n      display: flex !important;\n      align-items: center !important;\n      min-height: 40px !important;\n      padding: 8px 0 8px 36px !important;\n      font-size: 16px !important;\n      line-height: 24px !important;\n    }\n\n    .custom-control .custom-control-label::before,\n    .custom-control .custom-control-label::after {\n      top: 8px !important;\n      left: 0 !important;\n      width: 24px !important;\n      height: 24px !important;\n    }\n\n    .custom-control.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n      top: 12px !important;\n      left: 8px !important;\n      width: 8px !important;\n      height: 13px !important;\n      border-width: 0 3px 3px 0 !important;\n    }\n\n    .custom-control.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n      top: 13px !important;\n      left: 5px !important;\n      width: 13px !important;\n      height: 13px !important;\n    }\n\n    .three-column,\n    .four-column {\n      grid-template-columns: repeat(2, 1fr) !important;\n    }\n\n    .m-signature-pad--footer {\n      position: static !important;\n    }\n\n    .rfb-item .form-group:has(.clear-signature) {\n      position: relative;\n    }\n\n    .clear-signature {\n      top: auto !important;\n      right: 8px !important;\n      bottom: 8px !important;\n      left: auto !important;\n      display: inline-flex !important;\n      align-items: center;\n      gap: 6px;\n      width: auto !important;\n      height: 40px !important;\n      padding: 0 14px;\n      border: 1px solid #d5d7da;\n      border-radius: 8px;\n      background: #fff;\n      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);\n      font-size: 14px;\n      font-weight: 600;\n      color: #374145;\n\n      &::after {\n        content: 'Clear';\n      }\n    }\n  }\n\n  .ReviewSystems {\n    &__block__row .Input {\n      height: 44px !important;\n      font-size: 16px !important;\n    }\n  }\n\n  .HipaaForm__notice {\n    .text-sm {\n      font-size: 16px !important;\n      line-height: 26px !important;\n    }\n  }\n\n  [data-qa='hipaa-read-notice'],\n  [data-qa='hipaa-add-contact'] {\n    height: 44px !important;\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__day-name,\n  .react-datepicker__time-name {\n    width: 40px !important;\n    line-height: 40px !important;\n    margin: 2px !important;\n    font-size: 16px !important;\n  }\n\n  .validation-error {\n    top: auto !important;\n    bottom: 24px !important;\n    left: 50% !important;\n    right: auto !important;\n    transform: translateX(-50%) !important;\n    width: calc(100% - 48px) !important;\n    max-width: 640px !important;\n    padding: 0 !important;\n    font-size: 16px !important;\n  }\n\n  .validation-error .btn {\n    min-height: 44px !important;\n    padding: 12px 24px !important;\n    font-size: 16px !important;\n    line-height: 20px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
